
/**
 * @license almond 0.2.9 Copyright (c) 2011-2014, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/almond for details
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*jslint sloppy: true */
/*global setTimeout: false */

var requirejs, require, define;
(function (undef) {
    var main, req, makeMap, handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
            foundI, foundStarMap, starI, i, j, part,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = (map && map['*']) || {};

        //Adjust any relative paths.
        if (name && name.charAt(0) === ".") {
            //If have a base name, try to normalize against it,
            //otherwise, assume it is a top-level require that will
            //be relative to baseUrl in the end.
            if (baseName) {
                //Convert baseName to array, and lop off the last part,
                //so that . matches that "directory" and not name of the baseName's
                //module. For instance, baseName of "one/two/three", maps to
                //"one/two/three.js", but we want the directory, "one/two" for
                //this normalization.
                baseParts = baseParts.slice(0, baseParts.length - 1);
                name = name.split('/');
                lastIndex = name.length - 1;

                // Node .js allowance:
                if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
                }

                name = baseParts.concat(name);

                //start trimDots
                for (i = 0; i < name.length; i += 1) {
                    part = name[i];
                    if (part === ".") {
                        name.splice(i, 1);
                        i -= 1;
                    } else if (part === "..") {
                        if (i === 1 && (name[2] === '..' || name[0] === '..')) {
                            //End of the line. Keep at least one non-dot
                            //path segment at the front so it can be mapped
                            //correctly to disk. Otherwise, there is likely
                            //no path mapping for a path starting with '..'.
                            //This can still fail, but catches the most reasonable
                            //uses of ..
                            break;
                        } else if (i > 0) {
                            name.splice(i - 1, 2);
                            i -= 2;
                        }
                    }
                }
                //end trimDots

                name = name.join("/");
            } else if (name.indexOf('./') === 0) {
                // No baseName, so this is ID is resolved relative
                // to baseUrl, pull off the leading dot.
                name = name.substring(2);
            }
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            return req.apply(undef, aps.call(arguments, 0).concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relName) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relName));
            } else {
                name = normalize(name, relName);
            }
        } else {
            name = normalize(name, relName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return (config && config.config && config.config[name]) || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return (defined[name] = {});
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i,
            args = [],
            callbackType = typeof callback,
            usingExports;

        //Use name if no relName
        relName = relName || name;

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relName);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) ||
                           hasProp(waiting, depName) ||
                           hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef &&
                        cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, callback).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
}());
define("libs/almond.js", function(){});

/*!
 * routie - a tiny hash router
 * v0.3.2
 * http://projects.jga.me/routie
 * copyright Greg Allen 2013
 * MIT License
*/
(function(n){var e=[],t={},r="routie",o=n[r],i=function(n,e){this.name=e,this.path=n,this.keys=[],this.fns=[],this.params={},this.regex=a(this.path,this.keys,!1,!1)};i.prototype.addHandler=function(n){this.fns.push(n)},i.prototype.removeHandler=function(n){for(var e=0,t=this.fns.length;t>e;e++){var r=this.fns[e];if(n==r)return this.fns.splice(e,1),void 0}},i.prototype.run=function(n){for(var e=0,t=this.fns.length;t>e;e++)this.fns[e].apply(this,n)},i.prototype.match=function(n,e){var t=this.regex.exec(n);if(!t)return!1;for(var r=1,o=t.length;o>r;++r){var i=this.keys[r-1],a="string"==typeof t[r]?decodeURIComponent(t[r]):t[r];i&&(this.params[i.name]=a),e.push(a)}return!0},i.prototype.toURL=function(n){var e=this.path;for(var t in n)e=e.replace("/:"+t,"/"+n[t]);if(e=e.replace(/\/:.*\?/g,"/").replace(/\?/g,""),-1!=e.indexOf(":"))throw Error("missing parameters for url: "+e);return e};var a=function(n,e,t,r){return n instanceof RegExp?n:(n instanceof Array&&(n="("+n.join("|")+")"),n=n.concat(r?"":"/?").replace(/\/\(/g,"(?:/").replace(/\+/g,"__plus__").replace(/(\/)?(\.)?:(\w+)(?:(\(.*?\)))?(\?)?/g,function(n,t,r,o,i,a){return e.push({name:o,optional:!!a}),t=t||"",""+(a?"":t)+"(?:"+(a?t:"")+(r||"")+(i||r&&"([^/.]+?)"||"([^/]+?)")+")"+(a||"")}).replace(/([\/.])/g,"\\$1").replace(/__plus__/g,"(.+)").replace(/\*/g,"(.*)"),RegExp("^"+n+"$",t?"":"i"))},s=function(n,r){var o=n.split(" "),a=2==o.length?o[0]:null;n=2==o.length?o[1]:o[0],t[n]||(t[n]=new i(n,a),e.push(t[n])),t[n].addHandler(r)},h=function(n,e){if("function"==typeof e)s(n,e),h.reload();else if("object"==typeof n){for(var t in n)s(t,n[t]);h.reload()}else e===void 0&&h.navigate(n)};h.lookup=function(n,t){for(var r=0,o=e.length;o>r;r++){var i=e[r];if(i.name==n)return i.toURL(t)}},h.remove=function(n,e){var r=t[n];r&&r.removeHandler(e)},h.removeAll=function(){t={},e=[]},h.navigate=function(n,e){e=e||{};var t=e.silent||!1;t&&l(),setTimeout(function(){window.location.hash=n,t&&setTimeout(function(){p()},1)},1)},h.noConflict=function(){return n[r]=o,h};var f=function(){return window.location.hash.substring(1)},c=function(n,e){var t=[];return e.match(n,t)?(e.run(t),!0):!1},u=h.reload=function(){for(var n=f(),t=0,r=e.length;r>t;t++){var o=e[t];if(c(n,o))return}},p=function(){n.addEventListener?n.addEventListener("hashchange",u,!1):n.attachEvent("onhashchange",u)},l=function(){n.removeEventListener?n.removeEventListener("hashchange",u):n.detachEvent("onhashchange",u)};p(),n[r]=h})(window);
define("libs/routie", function(){});

define('libs/core',[
	"libs/routie"
], function () {

	function show(path, config) {
		if (config == -1)
			return render_sub_stack(this, path);
		if (this._subs[path])
			return render_sub_stack(this._subs[path], config);


		var scope = get_app_scope(this);
		var index = this.index;

		if (typeof path == "string") {
			var index = index;

			//child page
			if (path.indexOf("./") === 0) {
				index++;
				path = path.substr(2);
			}

			//route to page
			var parsed = parse_parts(path);
			scope.path = scope.path.slice(0, index).concat(parsed);
		} else {
			//set parameters
			webix.extend(scope.path[index].params, path, true);
		}

		scope.show(url_string(scope.path), -1);
	}

	function get_app_scope(scope) {
		while (scope) {
			if (scope.app)
				return scope;
			scope = scope.parent;
		}
		return app;
	}

	function url_string(stack) {
		var url = [];
		var start = app.config.layout ? 1 : 0;

		for (; start < stack.length; start++) {
			url.push("/" + stack[start].page);
			var params = params_string(stack[start].params);
			if (params)
				url.push(":" + params);
		}

		return url.join("");
	}
	function params_string(obj) {
		var str = [];
		for (var key in obj) {
			if (str.length)
				str.push(":");
			str.push(key + "=" + obj[key]);
		}

		return str.join("");
	}


	function subui(ui, name, stack) {
		if (run_plugins(url_plugins, ui, name, stack, this) === false) return;

		if (name.page != this.name) {
			this.name = name.page;
			this.ui = create_temp_ui;
			this.on = create_temp_event;
			this.show = show;
			this.module = ui;

			destroy.call(this);

			//collect init and destory handlers
			//set subview container
			this._init = [];
			this._destroy = [];
			this._subs = {};
			this.$layout = false;

			var subview = copy(ui, null, this);
			subview.$scope = this;

			create.call(this, subview);

			//prepare layout for view loading
			if (this.$layout) {
				this.$layout = {
					root: (this._ui.$$ || webix.$$)(this.name + ":subview"),
					sub: subui,
					parent: this,
					index: this.index + 1
				};
			}
		}

		run_plugins(ui_plugins, ui, name, stack, this);

		if (!ui.$onurlchange || ui.$onurlchange.call(ui, name.params, stack, this) !== false)
			return this.$layout;
	}

	function parse_parts(url) {
		//split url by "/"
		var chunks = url.split("/");

		//use optional default layout page
		if (!chunks[0]) {
			if (app.config.layout)
				chunks[0] = app.config.layout;
			else
				chunks.shift();
		}

		//for each page in url
		for (var i = 0; i < chunks.length; i++) {
			var test = chunks[i];
			var result = [];

			//detect params
			var pos = test.indexOf(":");
			if (pos !== -1) {
				var params = test.substr(pos + 1).split(":");
				//detect named params
				var objmode = params[0].indexOf("=") !== -1;

				//create hash of named params
				if (objmode) {
					result = {};
					for (var j = 0; j < params.length; j++) {
						var dchunk = params[j].split("=");
						result[dchunk[0]] = dchunk[1];
					}
				} else {
					result = params;
				}
			}

			//store parsed values
			chunks[i] = { page: (pos > -1 ? test.substr(0, pos) : test), params: result };
		}

		//return array of page objects
		return chunks;
	}

	function copy(obj, target, config) {
		if (obj.$oninit)
			config._init.push(obj.$oninit);
		if (obj.$ondestroy)
			config._destroy.push(obj.$ondestroy);
		if (obj.$subview) {
			if (typeof obj.$subview == "string") {
				var tname = (config.name + ":subview:" + obj.$subview);
				var tobj = config._subs[obj.$subview] = {
					parent: this,
					root: tname,
					sub: subui,
					index: 0,
					app: true
				};

				obj.id = tname;
			} else {
				obj = { id: (config.name + ":subview") };
				config.$layout = true;
			}
		}
		if (obj.$ui)
			obj = obj.$ui;
		if (obj.$init) {
			return obj;
		}

		target = target || (webix.isArray(obj) ? [] : {});
		for (var method in obj) {
			if (obj[method] && typeof obj[method] == "object" && !webix.isDate(obj[method])) {
				target[method] = copy(obj[method], (webix.isArray(obj[method]) ? [] : {}), config);
			} else {
				target[method] = obj[method];
			}
		}

		return target;
	}

	function render_sub_stack(scope, path) {
		if (scope.root)
			scope.root = webix.$$(scope.root);

		var parts = parse_parts(path);
		scope.path = [].concat(parts);
		render_stack(scope, parts);
	}

	function render_stack(layout, stack) {
		var line = stack[0];
		if (line && (!stack[1] || stack[1].page != 'signbienban')) {
			var url = line.page;
			var issubpage = url.indexOf(".") === 0;

			if (issubpage)
				url = (layout.fullname || "") + url;
			url = url.replace(/\./g, "/");

			if (run_plugins(require_plugins, url, line, stack, layout) === false) return;

			require(["views/" + url], function (ui) {
				stack.shift();

				var next = layout.sub(ui, line, stack);
				if (next) {
					next.fullname = (issubpage ? (layout.fullname || "") : "") + line.page;
					render_stack(next, stack);
				} else {
					webix.ui.$freeze = false;
					webix.ui.resize();
				}
			});

			require(["app", "models/user"], function (app, user) {
				debugger
				var token = user.getAccessToken();

				if (token == null) {
					return;
				}

				var dvcs = user.getDvcsID();

				var bear = token + ";" + dvcs;

				webix.ajax()
					.headers({
						"Authorization": "Bear " + bear
					})
					.get(app.config.host + "/System/GetAllMenuCode",
						function (text) {

							var code = location.hash.includes("=") ? location.hash.split("=").pop() : location.hash.split("/").pop();
							var data = JSON.parse(text);

							if (data.indexOf(code) === -1) {
								if (code !== "dashboard") {
									window.location.hash = "#!/app/dashboard";
									location.reload();

									webix.message({
										type: "error",
										text: "Bạn không có quyền truy cập chức năng này!"
									});
								}
								return;
							}
							if (callback) callback(result);
						});
			});

		} else {
			webix.ui.$freeze = false;
			webix.ui.resize();
		}

	}

	var ui_plugins = [];
	var url_plugins = [];
	var require_plugins = [];
	function run_plugins(plugins, ui, name, stack, scope) {
		for (var i = 0; i < plugins.length; i++)
			if (plugins[i](ui, name, stack, scope) === false) return false;
		return true;
	}

	var app = {
		create: function (config) {
			//init config
			app.config = webix.extend({
				name: "App",
				version: "1.0",
				container: document.body,
				start: "/home"
			}, config, true);

			//init self
			app.debug = config.debug;
			app.$layout = {
				sub: subui,
				root: app.config.container,
				index: 0,
				add: true
			};
			webix.extend(app, webix.EventSystem);

			//show start page
			setTimeout(function () {
				webix.ready(function () {
					app.start();
				});
			}, 1);



			var node = app.config.container;
			webix.html.addCss(node, "webixappstart");
			setTimeout(function () {
				webix.html.removeCss(node, "webixappstart");
				webix.html.addCss(node, "webixapp");
			}, 10);

			return app;
		},

		ui: create_temp_ui,


		//navigation
		router: function (name) {
			var parts = parse_parts(name);
			app.path = [].concat(parts);

			//webix.ui.$freeze = true;
			render_stack(app.$layout, parts);
		},
		show: function (name, options) {
			routie.navigate("!" + name, options);
		},
		start: function (name) {
			//init routing
			routie("!*", app.router);

			if (!window.location.hash)
				app.show(app.config.start);
			else {
				webix.ui.$freeze = false;
				webix.ui.resize();
			}
		},


		//plugins
		use: function (handler, config) {
			if (handler.$oninit)
				handler.$oninit(this, (config || {}));

			if (handler.$onurlchange)
				url_plugins.push(handler.$onurlchange);
			if (handler.$onurl)
				require_plugins.push(handler.$onurl);
			if (handler.$onui)
				ui_plugins.push(handler.$onui);
		},


		//event helpers
		trigger: function (name) {
			app.apply(name, [].splice.call(arguments, 1));
		},
		apply: function (name, data) {
			app.callEvent(name, data);
		},
		action: function (name) {
			return function () {
				app.apply(name, arguments);
			};
		},
		on: function (name, handler) {
			this.attachEvent(name, handler);
		},

		_uis: [],
		_handlers: []
	};

	function create_temp_event(obj, name, code) {
		var id = obj.attachEvent(name, code);
		this._handlers.push({ obj: obj, id: id });
		return id;
	}

	function create_temp_ui(module, container) {
		var view;
		var temp = { _init: [], _destroy: [] };
		var ui = copy(module, null, temp);
		ui.$scope = this;

		if (ui.id)
			view = $$(ui.id);

		if (!view) {
			view = webix.ui(ui, container);
			this._uis.push(view);
			run_handlers(temp._init, view, this);
		}

		return view;
	}

	function run_handlers(arr, view, scope) {
		if (arr)
			for (var i = 0; i < arr.length; i++)
				arr[i](view, scope);
	}

	function destroy() {
		if (!this._ui) return;

		if (this.$layout)
			destroy.call(this.$layout);

		var handlers = this._handlers;
		for (var i = handlers.length - 1; i >= 0; i--)
			handlers[i].obj.detachEvent(handlers[i].id);
		this._handlers = [];

		var uis = this._uis;
		for (var i = uis.length - 1; i >= 0; i--)
			if (uis[i] && uis[i].destructor) uis[i].destructor();
		this._uis = [];

		run_handlers(this._destroy, this._ui, this);

		if (!this.parent && this._ui)
			this._ui.destructor();
	}


	function delete_ids(view) {
		delete webix.ui.views[view.config.id];
		view.config.id = "";
		var childs = view.getChildViews();
		for (var i = childs.length - 1; i >= 0; i--)
			delete_ids(childs[i]);
	}
	function create(subview) {
		this._uis = [];
		this._handlers = [];

		//naive solution for id dupplication
		if (this.root && this.root.config)
			delete_ids(this.root);

		this._ui = webix.ui(subview, this.root);
		if (this.parent)
			this.root = this._ui;

		run_handlers(this._init, this._ui, this);
	}

	function invalid_url(err) {
		if (app.debug)
			console.log(err.stack);

		if (!err.requireModules) throw (err);
		if (app.debug)
			webix.message({ type: "error", expire: 5000, text: "Can't load " + err.requireModules.join(", ") });

		app.show(app.config.start);
	}

	requirejs.onError = invalid_url;
	return app;
});
define('helpers/menu',[], function () {
    function select_menu(menu_id, id) {
        var menu = $$(menu_id);
        if (menu.setValue) menu.setValue(id);
        else if (menu.select && menu.exists(id)) menu.select(id);
    }

    function get_menu(scope) {
        if (scope.parent) return scope.parent.module.$menu || get_menu(scope.parent);
    }

    return {
        $onurlchange: function (ui, name, url, scope) {
            if ($$("head-title") !== undefined) $$("head-title").reconstruct();
            if ($$("title") !== undefined) $$("title").parse({ title: "", details: "" });
            //menu handling
            if (ui.$menuid) {
                var id = ui.$menuid.call ? ui.$menuid.call(ui, ui, name, url) : ui.$menuid;
                var menu = get_menu(scope);
                if (menu && id) select_menu(menu, id);
            }
        },

        $onui: function (ui, name, url, scope) {
            //menu handling
            if (ui.$menu && url.length) select_menu(ui.$menu, url[0].page);
        },
    };
});

//     (c) 2012 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//

!function(root) {
  

  // ### Polyglot class constructor
  function Polyglot(options) {
    options = options || {};
    this.phrases = {};
    this.extend(options.phrases || {});
    this.currentLocale = options.locale || 'en';
    this.allowMissing = !!options.allowMissing;
    this.warn = options.warn || warn;
  }

  // ### Version
  Polyglot.VERSION = '0.4.1';

  // ### polyglot.locale([locale])
  //
  // Get or set locale. Internally, Polyglot only uses locale for pluralization.
  Polyglot.prototype.locale = function(newLocale) {
    if (newLocale) this.currentLocale = newLocale;
    return this.currentLocale;
  };

  // ### polyglot.extend(phrases)
  //
  // Use `extend` to tell Polyglot how to translate a given key.
  //
  //     polyglot.extend({
  //       "hello": "Hello",
  //       "hello_name": "Hello, %{name}"
  //     });
  //
  // The key can be any string.  Feel free to call `extend` multiple times;
  // it will override any phrases with the same key, but leave existing phrases
  // untouched.
  //
  // It is also possible to pass nested phrase objects, which get flattened
  // into an object with the nested keys concatenated using dot notation.
  //
  //     polyglot.extend({
  //       "nav": {
  //         "hello": "Hello",
  //         "hello_name": "Hello, %{name}",
  //         "sidebar": {
  //           "welcome": "Welcome"
  //         }
  //       }
  //     });
  //
  //     console.log(polyglot.phrases);
  //     // {
  //     //   'nav.hello': 'Hello',
  //     //   'nav.hello_name': 'Hello, %{name}',
  //     //   'nav.sidebar.welcome': 'Welcome'
  //     // }
  //
  // `extend` accepts an optional second argument, `prefix`, which can be used
  // to prefix every key in the phrases object with some string, using dot
  // notation.
  //
  //     polyglot.extend({
  //       "hello": "Hello",
  //       "hello_name": "Hello, %{name}"
  //     }, "nav");
  //
  //     console.log(polyglot.phrases);
  //     // {
  //     //   'nav.hello': 'Hello',
  //     //   'nav.hello_name': 'Hello, %{name}'
  //     // }
  //
  // This feature is used internally to support nested phrase objects.
  Polyglot.prototype.extend = function(morePhrases, prefix) {
    var phrase;

    for (var key in morePhrases) {
      if (morePhrases.hasOwnProperty(key)) {
        phrase = morePhrases[key];
        if (prefix) key = prefix + '.' + key;
        if (typeof phrase === 'object') {
          this.extend(phrase, key);
        } else {
          this.phrases[key] = phrase;
        }
      }
    }
  };

  // ### polyglot.clear()
  //
  // Clears all phrases. Useful for special cases, such as freeing
  // up memory if you have lots of phrases but no longer need to
  // perform any translation. Also used internally by `replace`.
  Polyglot.prototype.clear = function() {
    this.phrases = {};
  };

  // ### polyglot.replace(phrases)
  //
  // Completely replace the existing phrases with a new set of phrases.
  // Normally, just use `extend` to add more phrases, but under certain
  // circumstances, you may want to make sure no old phrases are lying around.
  Polyglot.prototype.replace = function(newPhrases) {
    this.clear();
    this.extend(newPhrases);
  };


  // ### polyglot.t(key, options)
  //
  // The most-used method. Provide a key, and `t` will return the
  // phrase.
  //
  //     polyglot.t("hello");
  //     => "Hello"
  //
  // The phrase value is provided first by a call to `polyglot.extend()` or
  // `polyglot.replace()`.
  //
  // Pass in an object as the second argument to perform interpolation.
  //
  //     polyglot.t("hello_name", {name: "Spike"});
  //     => "Hello, Spike"
  //
  // If you like, you can provide a default value in case the phrase is missing.
  // Use the special option key "_" to specify a default.
  //
  //     polyglot.t("i_like_to_write_in_language", {
  //       _: "I like to write in %{language}.",
  //       language: "JavaScript"
  //     });
  //     => "I like to write in JavaScript."
  //
  Polyglot.prototype.t = function(key, options) {
    var result;
    options = options == null ? {} : options;
    // allow number as a pluralization shortcut
    if (typeof options === 'number') {
      options = {smart_count: options};
    }
    var phrase = this.phrases[key] || options._ || (this.allowMissing ? key : '');
    if (phrase === '') {
      this.warn('Missing translation for key: "'+key+'"');
      result = key;
    } else {
      options = clone(options);
      result = choosePluralForm(phrase, this.currentLocale, options.smart_count);
      result = interpolate(result, options);
    }
    return result;
  };


  // #### Pluralization methods
  // The string that separates the different phrase possibilities.
  var delimeter = '||||';

  // Mapping from pluralization group plural logic.
  var pluralTypes = {
    chinese:   function(n) { return 0; },
    german:    function(n) { return n !== 1 ? 1 : 0; },
    french:    function(n) { return n > 1 ? 1 : 0; },
    russian:   function(n) { return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2; },
    czech:     function(n) { return (n === 1) ? 0 : (n >= 2 && n <= 4) ? 1 : 2; },
    polish:    function(n) { return (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2); },
    icelandic: function(n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; }
  };

  // Mapping from pluralization group to individual locales.
  var pluralTypeToLanguages = {
    chinese:   ['fa', 'id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
    german:    ['da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
    french:    ['fr', 'tl', 'pt-br'],
    russian:   ['hr', 'ru', 'be'],
    czech:     ['cs'],
    polish:    ['pl'],
    icelandic: ['is']
  };

  function langToTypeMap(mapping) {
    var type, langs, l, ret = {};
    for (type in mapping) {
      if (mapping.hasOwnProperty(type)) {
        langs = mapping[type];
        for (l in langs) {
          ret[langs[l]] = type;
        }
      }
    }
    return ret;
  }

  // Trim a string.
  function trim(str){
    var trimRe = /^\s+|\s+$/g;
    return str.replace(trimRe, '');
  }

  // Based on a phrase text that contains `n` plural forms separated
  // by `delimeter`, a `locale`, and a `count`, choose the correct
  // plural form, or none if `count` is `null`.
  function choosePluralForm(text, locale, count){
    var ret, texts, chosenText;
    if (count != null && text) {
      texts = text.split(delimeter);
      chosenText = texts[pluralTypeIndex(locale, count)] || texts[0];
      ret = trim(chosenText);
    } else {
      ret = text;
    }
    return ret;
  }

  function pluralTypeName(locale) {
    var langToPluralType = langToTypeMap(pluralTypeToLanguages);
    return langToPluralType[locale] || langToPluralType.en;
  }

  function pluralTypeIndex(locale, count) {
    return pluralTypes[pluralTypeName(locale)](count);
  }

  // ### interpolate
  //
  // Does the dirty work. Creates a `RegExp` object for each
  // interpolation placeholder.
  function interpolate(phrase, options) {
    for (var arg in options) {
      if (arg !== '_' && options.hasOwnProperty(arg)) {
        // We create a new `RegExp` each time instead of using a more-efficient
        // string replace so that the same argument can be replaced multiple times
        // in the same phrase.
        phrase = phrase.replace(new RegExp('%\\{'+arg+'\\}', 'g'), options[arg]);
      }
    }
    return phrase;
  }

  // ### warn
  //
  // Provides a warning in the console if a phrase key is missing.
  function warn(message) {
    root.console && root.console.warn && root.console.warn('WARNING: ' + message);
  }

  // ### clone
  //
  // Clone an object.
  function clone(source) {
    var ret = {};
    for (var prop in source) {
      ret[prop] = source[prop];
    }
    return ret;
  }


  // Export for Node, attach to `window` for browser.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Polyglot;
  } else {
    root.Polyglot = Polyglot;
  }

}(this);

define("libs/polyglot", function(){});

define('models/user',[], function () {
    var user = null,
        credentials = {},
        oauthUrl = "";
    var host = "";
    var start = "";
    var COOKIE_OPTIONS = { path: "/" };

    require(["app"], function (app) {
        host = app.config.host;
        start = app.config.start;
    });

    credentials = Cookies.getJSON("appCookie") || {};

    function saveSetting(key, value, reload) {
        if (current_user) {
            var id = current_user.id,
                settings = current_user.settings;

            if (!settings[key] || value != settings[key]) {
                if (reload) document.location.reload();
            }
        }
    }

    return {
        saveSetting: saveSetting,
        getDvcsID: function () {
            var cookie = this.getAppCookie();

            if (cookie == null) {
                return null;
            }

            return cookie.ma_dvcs;
        },
        getCurrentUser: function () {
            var cookie = this.getAppCookie();

            if (cookie == null) {
                return null;
            }

            return cookie.username;
        },
        getLanguage: function () {
            var cookie = this.getAppCookie();

            if (cookie == null) {
                return null;
            }

            return cookie.language;
        },
        getAccessToken: function () {
            var cookie = this.getAppCookie();

            if (cookie === null || cookie === undefined) {
                return null;
            }

            if (cookie.access_token === undefined) {
                return null;
            }

            if (cookie.expires_in + cookie.timestamp < Date.now() / 1000) {
                return null;
            }

            return cookie.access_token;
        },
        getRefreshToken: function () {
            var cookie = this.getAppCookie();

            if (cookie === null || cookie === undefined) {
                return;
            }

            if (cookie.refresh_token === undefined) {
                return;
            }

            if (5400 + cookie.timestamp < Date.now() / 1000) {
                webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .post(
                    host + "/Account/GetTokenByRefreshToken",
                    {
                        refresh_token: cookie.wb_user_id,
                        wb_user_id: cookie.wb_user_id
                    },
                    function (text, data) {
                        var result = JSON.parse(text);
                        
                        if (result.error != null) {
                            //webix.message(result.error, "error");
                            return;
                        }
                        var credentials = getCredentials();

                        credentials.timestamp = (Date.now() / 1000) | 0;

                        credentials.access_token = result.token;

                        var baseUrl = document.location.href;

                        if (baseUrl.startsWith("file")) {
                            webix.storage.local.put("appCookie", credentials);
                        } else {
                            Cookies.set("appCookie", credentials, COOKIE_OPTIONS);
                        }
                    }
                );
            }
        },
        getCredentials: function () {
            return credentials;
        },
        getAppCookie: function () {
            var baseUrl = document.location.href;

            if (baseUrl.startsWith("file")) {
                var cookie = webix.storage.local.get("appCookie");
                return cookie;
            } else {
                var cookie = Cookies.getJSON("appCookie");
                return cookie;
            }
        },
        setCurrentUser: function (userId) {
            user = userId;
            return true;
        },
        login: function (username, password, ma_dvcs, language, component) {
            webix.extend(component, webix.ProgressBar);
            component.disable();
            component.showProgress();

            webix
                .ajax()
                .post(
                    host + "/Account/Login",
                    {
                        username: username,
                        password: password,
                        ma_dvcs: ma_dvcs,
                        is_sso_login: "0"
                    },
                    function (text, data) {
                        var result = JSON.parse(text);

                        if (result.error != null) {
                            webix.message(result.error, "error");
                            component.enable();
                            component.hideProgress();
                            return;
                        }

                        var action = document.querySelector(".showLogin");
                        action.classList.remove("inactive");

                        webix.storage.local.remove("APP_CACHE");
                        webix.storage.local.put("APP_CACHE", {});

                        credentials = {
                            access_token: result.token,
                            refresh_token: result.refresh_token,
                            expires_in: 86400,
                            token_type: "Bearer",
                            scope: null,
                            username: username,
                            language: language,
                            ma_dvcs: ma_dvcs,
                            wb_user_id: result.wb_user_id,
                            noti_sso: result.noti_sso,
                            notes_sso: result.notes_sso,
                            notify: result.notify,
                            is_link_sso: result.is_link_sso,
                            is_weak_pass: result.isWeakPass
                        };

                        if (result.ma_dvcs != null) {
                            credentials.ma_dvcs = result.ma_dvcs;
                        }

                        credentials.timestamp = (Date.now() / 1000) | 0;

                        var baseUrl = document.location.href;

                        if (baseUrl.startsWith("file")) {
                            webix.storage.local.put("appCookie", credentials);
                        } else {
                            Cookies.set("appCookie", credentials, COOKIE_OPTIONS);
                        }

                        component.$scope.show("./" + start);
                    }
                )
                .then(null, function () {
                    component.enable();
                    component.hideProgress();
                });
        },
        loginsso: function (sso_code, redirect_uri, ma_dvcs, language) {
            webix
                .ajax()
                .post(
                    host + "/Account/LoginSSO",
                    {
                        sso_code: sso_code,
                        redirect_uri: redirect_uri
                    },
                    function (text, data) {
                        var result = JSON.parse(text);

                        if (result.error != null) {
                            webix.message(result.error, "error");
                            window.location.href = "/#!" + start;
                            return;
                        }

                        var action = document.querySelector(".showLogin");
                        action.classList.remove("inactive");

                        webix.storage.local.remove("APP_CACHE");
                        webix.storage.local.put("APP_CACHE", {});

                        credentials = {
                            access_token: result.token,
                            refresh_token: result.refresh_token,
                            expires_in: 86400,
                            token_type: "Bearer",
                            scope: null,
                            username: result.username,
                            language: language,
                            ma_dvcs: ma_dvcs,
                            wb_user_id: result.wb_user_id,
                            id_token: result.id_token,
                            notify: result.notify,
                            sid: result.sid
                        };

                        if (result.ma_dvcs != null) {
                            credentials.ma_dvcs = result.ma_dvcs;
                        }

                        credentials.timestamp = (Date.now() / 1000) | 0;

                        var baseUrl = document.location.href;

                        if (baseUrl.startsWith("file")) {
                            webix.storage.local.put("appCookie", credentials);
                        } else {
                            Cookies.set("appCookie", credentials, COOKIE_OPTIONS);
                        }
                        window.location.href = "/#!" + start;
                    }
                )
                .then(null, function () {
                    window.location.href = "/#!" + start;
                });
        },

        logout: function () {
            credentials = {};
            var cookie = this.getAppCookie();
            debugger
            if (cookie != null) {
                var id_token = cookie.to;
                var refresh_token = cookie.refresh_token;
                var expires_in = cookie.expires_in;
                var access_token = cookie.access_token;
                webix
                    .ajax()
                    .post(
                        host + "/Account/Logout",
                        {
                            id_token: id_token,
                            refresh_token : refresh_token,
                            expires_in : expires_in,
                            access_token: access_token
                        },
                        function (text, data) {
                            var result = JSON.parse(text);
                            
                            if (result.error != null) {
                                webix.message(result.error, "error");
                                return;
                            }
                            var baseUrl = document.location.href;
                            if (baseUrl.startsWith("file")) {
                                webix.storage.local.remove("appCookie");
                            } else {
                                Cookies.remove("appCookie", COOKIE_OPTIONS);
                            }
                            document.location.reload();
                        }
                    );
            } else {
                debugger;
                var baseUrl = document.location.href;
                if (baseUrl.startsWith("file")) {
                    webix.storage.local.remove("appCookie");
                } else {
                    Cookies.remove("appCookie", COOKIE_OPTIONS);
                }
                document.location.reload();
            }

        },
        getBranchAddressInfo: function (callback) {
            var branch_code = this.getDvcsID();
            if (branch_code != null) {
                webix
                    .ajax()
                    .get(
                        host + "/System/GetBranchAddressInfo",
                        {
                            branch_code: branch_code
                        },
                        function (text, data) {
                            var result = JSON.parse(text);

                            if (result.error != null) {
                                webix.message(result.error, "error");
                                return;
                            }

                            if (callback) callback(result);
                        }
                    );
            }

        },
        UpdateBranchAddressInfo: function (address, callback) {
            var branch_code = this.getDvcsID();
            if (branch_code != null) {
                webix
                    .ajax()
                    .post(
                        host + "/System/UpdateBranchAddressInfo",
                        {
                            address: address,
                            branch_code: branch_code
                        },
                        function (text, data) {
                            var result = JSON.parse(text);

                            if (result.error != null) {
                                webix.message(result.error, "error");
                                return;
                            }

                            if (callback) callback(result);
                        }
                    );
            }

        },
        session: {
            status: function () {
                return new Promise(function (resolve, reject) {
                    console.log("Getting user-status");
                    resolve(true);
                });
            },
        },
    };
});

define('helpers/locale',[
	"libs/polyglot",
	"models/user"	
], function(polyglot, users){

	var defaultlang = "vi";
	var key = "--:app:lang";
	var current_lang = "";

	function _get_lang(){
		return webix.storage.local.get(key) || defaultlang;
	}

	function _set_lang(lang, init){
		webix.storage.local.put(key, lang);
		document.location.reload();
	}

	function create_locale(lang,host){
		current_lang = lang;
		define("locale", [
			"locales/"+lang
		], function(data){
			var poly = new Polyglot({ phrases:data });
				poly.locale(lang);

			var t = webix.bind(poly.t, poly);
			t.template = function(a){
				return a.replace(/%([a-zA-Z0-9.]+)%/g, function(_, match){
					return poly.t(match);
				});
			};
			return t;
		});	
				
		
	}

	return {
		$oninit:function(app, config){
			key = (app.config.id || "")+key;

			var lang = _get_lang();
			create_locale(lang,app.config.host);
		},
		setLang: _set_lang,
		getLang: _get_lang,
		isNow:function(val){ return val == current_lang; }
	};
});
define('helpers/theme',[
	"models/user"
], function(users){

	var key = "--:app:theme";
	var current_theme = webix.storage.local.get(key) || "siberia:webix";

	function _get_theme(){
		if(users.getCurrentUser())
			return users.getCurrentUser().settings.theme;

		return current_theme;
	}

	function _set_theme(theme){
		webix.storage.local.put(key, theme);
		if(users.getCurrentUser())
			users.saveSetting("theme", theme, theme != current_theme);
		else
			document.location.reload();

		current_theme = theme;
	}

	return {
		setTheme: _set_theme,
		getTheme: _get_theme,
		isNow:function(val){ return val == current_theme; }
	};
});
define('helpers/uiVariant',[], function () {
    var key = "--:app:ui-variant";

    function _get_variant() {
        return webix.storage.local.get(key) || window.__UI_VARIANT__ || "old";
    }

    function _is_available() {
        return !!(window.__UI_SWITCH_TARGET__);
    }

    function _get_label() {
        return _get_variant() === "new" ? "Giao diện cũ" : "Giao diện mới";
    }

    function _get_options() {
        return [
            { id: "new", value: "Giao diện mới" },
            { id: "old", value: "Giao diện cũ" },
        ];
    }

    function _switch_to(next) {
        if (!_is_available()) return;
        if (next !== "new" && next !== "old") return;
        if (next === _get_variant()) return;

        webix.storage.local.put(key, next);

        var folder = window.__UI_SWITCH_TARGET__ || (next === "old" ? "../" : "./ui-new/");
        location.replace(folder + "index.html" + (location.hash || ""));
    }

    function _switch() {
        _switch_to(_get_variant() === "new" ? "old" : "new");
    }

    function _build_login_combo() {
        if (!_is_available()) return { width: 0 };
        return {
            id: "cbSwitchUI",
            view: "combo",
            width: 140,
            css: "cbSwitchUI",
            height: 36,
            options: _get_options(),
            value: _get_variant(),
            on: {
                onChange: function (newv) {
                    _switch_to(newv);
                },
            },
        };
    }

    return {
        $oninit: function (app) {
            key = (app.config.id || "") + key;
        },
        getVariant: _get_variant,
        isSwitchAvailable: _is_available,
        getSwitchLabel: _get_label,
        getSwitchOptions: _get_options,
        switchVariant: _switch,
        switchTo: _switch_to,
        buildLoginSwitchCombo: _build_login_combo,
    };
});

define('libs/rollbar',['require','exports','module'],function(require,exports,module){function _isUndefined(a){return"undefined"==typeof a}function computeStackTraceWrapper(a){function b(a){if(!t)return"";try{var b=function(){try{return new window.XMLHttpRequest}catch(a){return new window.ActiveXObject("Microsoft.XMLHTTP")}},c=b();return c.open("GET",a,!1),c.send(""),c.responseText}catch(d){return""}}function c(a){if(!s.hasOwnProperty(a)){var c="";-1!==a.indexOf(document.domain)&&(c=b(a)),s[a]=c?c.split("\n"):[]}return s[a]}function d(a,b){var d,e=/function ([^(]*)\(([^)]*)\)/,f=/['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,g="",h=10,i=c(a);if(!i.length)return UNKNOWN_FUNCTION;for(var j=0;h>j;++j)if(g=i[b-j]+g,!_isUndefined(g)){if(d=f.exec(g))return d[1];if(d=e.exec(g))return d[1]}return UNKNOWN_FUNCTION}function e(a,b){var d=c(a);if(!d.length)return null;var e=[],f=Math.floor(u/2),g=f+u%2,h=Math.max(0,b-f-1),i=Math.min(d.length,b+g-1);b-=1;for(var j=h;i>j;++j)_isUndefined(d[j])||e.push(d[j]);return e.length>0?e:null}function f(a){return a.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g,"\\$&")}function g(a){return f(a).replace("<","(?:<|&lt;)").replace(">","(?:>|&gt;)").replace("&","(?:&|&amp;)").replace('"','(?:"|&quot;)').replace(/\s+/g,"\\s+")}function h(a,b){for(var d,e,f=0,g=b.length;g>f;++f)if((d=c(b[f])).length&&(d=d.join("\n"),e=a.exec(d)))return{url:b[f],line:d.substring(0,e.index).split("\n").length,column:e.index-d.lastIndexOf("\n",e.index)-1};return null}function i(a,b,d){var e,g=c(b),h=new RegExp("\\b"+f(a)+"\\b");return d-=1,g&&g.length>d&&(e=h.exec(g[d]))?e.index:null}function j(a){for(var b,c,d,e,i=[window.location.href],j=document.getElementsByTagName("script"),k=""+a,l=/^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,m=/^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,n=0;n<j.length;++n){var o=j[n];o.src&&i.push(o.src)}if(d=l.exec(k)){var p=d[1]?"\\s+"+d[1]:"",q=d[2].split(",").join("\\s*,\\s*");b=f(d[3]).replace(/;$/,";?"),c=new RegExp("function"+p+"\\s*\\(\\s*"+q+"\\s*\\)\\s*{\\s*"+b+"\\s*}")}else c=new RegExp(f(k).replace(/\s+/g,"\\s+"));if(e=h(c,i))return e;if(d=m.exec(k)){var r=d[1];if(b=g(d[2]),c=new RegExp("on"+r+"=[\\'\"]\\s*"+b+"\\s*[\\'\"]","i"),e=h(c,i[0]))return e;if(c=new RegExp(b),e=h(c,i))return e}return null}function k(a){if(!a.stack)return null;for(var b,c,f=/^\s*at (?:((?:\[object object\])?\S+(?: \[as \S+\])?) )?\(?((?:file|http|https):.*?):(\d+)(?::(\d+))?\)?\s*$/i,g=/^\s*(\S*)(?:\((.*?)\))?@((?:file|http|https).*?):(\d+)(?::(\d+))?\s*$/i,h=a.stack.split("\n"),j=[],k=/^(.*) is undefined$/.exec(a.message),l=0,m=h.length;m>l;++l){if(b=g.exec(h[l]))c={url:b[3],func:b[1]||UNKNOWN_FUNCTION,args:b[2]?b[2].split(","):"",line:+b[4],column:b[5]?+b[5]:null};else{if(!(b=f.exec(h[l])))continue;c={url:b[2],func:b[1]||UNKNOWN_FUNCTION,line:+b[3],column:b[4]?+b[4]:null}}!c.func&&c.line&&(c.func=d(c.url,c.line)),c.line&&(c.context=e(c.url,c.line)),j.push(c)}return j[0]&&j[0].line&&!j[0].column&&k&&(j[0].column=i(k[1],j[0].url,j[0].line)),j.length?{mode:"stack",name:a.name,message:a.message,url:document.location.href,stack:j,useragent:navigator.userAgent}:null}function l(a){for(var b,c=a.stacktrace,f=/ line (\d+), column (\d+) in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\) in (.*):\s*$/i,g=c.split("\n"),h=[],i=0,j=g.length;j>i;i+=2)if(b=f.exec(g[i])){var k={line:+b[1],column:+b[2],func:b[3]||b[4],args:b[5]?b[5].split(","):[],url:b[6]};if(!k.func&&k.line&&(k.func=d(k.url,k.line)),k.line)try{k.context=e(k.url,k.line)}catch(l){}k.context||(k.context=[g[i+1]]),h.push(k)}return h.length?{mode:"stacktrace",name:a.name,message:a.message,url:document.location.href,stack:h,useragent:navigator.userAgent}:null}function m(a){var b=a.message.split("\n");if(b.length<4)return null;var f,i,j,k,l=/^\s*Line (\d+) of linked script ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,m=/^\s*Line (\d+) of inline#(\d+) script in ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,n=/^\s*Line (\d+) of function script\s*$/i,o=[],p=document.getElementsByTagName("script"),q=[];for(i in p)p.hasOwnProperty(i)&&!p[i].src&&q.push(p[i]);for(i=2,j=b.length;j>i;i+=2){var r=null;if(f=l.exec(b[i]))r={url:f[2],func:f[3],line:+f[1]};else if(f=m.exec(b[i])){r={url:f[3],func:f[4]};var s=+f[1],t=q[f[2]-1];if(t&&(k=c(r.url))){k=k.join("\n");var u=k.indexOf(t.innerText);u>=0&&(r.line=s+k.substring(0,u).split("\n").length)}}else if(f=n.exec(b[i])){var v=window.location.href.replace(/#.*$/,""),w=f[1],x=new RegExp(g(b[i+1]));k=h(x,[v]),r={url:v,line:k?k.line:w,func:""}}if(r){r.func||(r.func=d(r.url,r.line));var y=e(r.url,r.line),z=y?y[Math.floor(y.length/2)]:null;r.context=y&&z.replace(/^\s*/,"")===b[i+1].replace(/^\s*/,"")?y:[b[i+1]],o.push(r)}}return o.length?{mode:"multiline",name:a.name,message:b[0],url:document.location.href,stack:o,useragent:navigator.userAgent}:null}function n(a,b,c,f){var g={url:b,line:c};if(g.url&&g.line){a.incomplete=!1,g.func||(g.func=d(g.url,g.line)),g.context||(g.context=e(g.url,g.line));var h=/ '([^']+)' /.exec(f);if(h&&(g.column=i(h[1],g.url,g.line)),a.stack.length>0&&a.stack[0].url===g.url){if(a.stack[0].line===g.line)return!1;if(!a.stack[0].line&&a.stack[0].func===g.func)return a.stack[0].line=g.line,a.stack[0].context=g.context,!1}return a.stack.unshift(g),a.partial=!0,!0}return a.incomplete=!0,!1}function o(a,b){for(var c,e,f,g=/function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,h=[],k={},l=!1,m=o.caller;m&&!l;m=m.caller)if(m!==p&&m!==v){if(e={url:null,func:UNKNOWN_FUNCTION,line:null,column:null},m.name?e.func=m.name:(c=g.exec(m.toString()))&&(e.func=c[1]),f=j(m)){e.url=f.url,e.line=f.line,e.func===UNKNOWN_FUNCTION&&(e.func=d(e.url,e.line));var q=/ '([^']+)' /.exec(a.message||a.description);q&&(e.column=i(q[1],f.url,f.line))}k[""+m]?l=!0:k[""+m]=!0,h.push(e)}b&&h.splice(0,b);var r={mode:"callers",name:a.name,message:a.message,url:document.location.href,stack:h,useragent:navigator.userAgent};return n(r,a.sourceURL||a.fileName,a.line||a.lineNumber,a.message||a.description),r}function p(a,b){var c=null;b=null==b?0:+b;try{if(c=l(a))return c}catch(d){if(r)throw d}try{if(c=k(a))return c}catch(d){if(r)throw d}try{if(c=m(a))return c}catch(d){if(r)throw d}try{if(c=o(a,b+1))return c}catch(d){if(r)throw d}return{mode:"failed"}}function q(a){a=(null==a?0:+a)+1;try{throw new Error}catch(b){return p(b,a+1)}}var r=!1,s={},t=a.remoteFetching,u=a.linesOfContext,v=a.tracekitReport;return p.augmentStackTraceWithInitialElement=n,p.guessFunctionName=d,p.gatherContext=e,p.ofCaller=q,p}function Notifier(a){_topLevelNotifier=_topLevelNotifier||this;var b=window.location.protocol;0!==b.indexOf("http")&&(b="https:");var c=b+"//"+Notifier.DEFAULT_ENDPOINT;this.options={enabled:!0,endpoint:c,environment:"production",scrubFields:Util.copy(Notifier.DEFAULT_SCRUB_FIELDS),checkIgnore:null,logLevel:Notifier.DEFAULT_LOG_LEVEL,reportLevel:Notifier.DEFAULT_REPORT_LEVEL,uncaughtErrorLevel:Notifier.DEFAULT_UNCAUGHT_ERROR_LEVEL,payload:{}},this.lastError=null,this.plugins={},this.parentNotifier=a,this.logger=function(){if(window.console&&"function"==typeof window.console.log){var a=["Rollbar:"].concat(Array.prototype.slice.call(arguments,0));window.console.log(a)}},a&&(a.hasOwnProperty("shimId")?a.notifier=this:(this.logger=a.logger,this.configure(a.options)))}function _wrapNotifierFn(a,b){return function(){var c=b||this;try{return a.apply(c,arguments)}catch(d){c&&c.logger(d)}}}function _guessErrorClass(a){if(!a)return["Unknown error. There was no error message to display.",""];var b=a.match(ERR_CLASS_REGEXP),c="(unknown)";return b&&(c=b[b.length-1],a=a.replace((b[b.length-2]||"")+c+":",""),a=a.replace(/(^[\s]+|[\s]+$)/g,"")),[c,a]}function _payloadProcessorTimer(a){for(var b;b=window._rollbarPayloadQueue.shift();)_processPayload(b.endpointUrl,b.accessToken,b.payload,b.callback);a||(payloadProcessorTimeout=setTimeout(_payloadProcessorTimer,1e3))}function _processPayload(a,b,c,d){d=d||function(){};var e=(new Date).getTime();e-rateLimitStartTime>=6e4&&(rateLimitStartTime=e,rateLimitPerMinCounter=0);var f=window._globalRollbarOptions.maxItems,g=window._globalRollbarOptions.itemsPerMinute,h=function(){return!c.ignoreRateLimit&&f>=1&&rateLimitCounter>=f},i=function(){return!c.ignoreRateLimit&&g>=1&&rateLimitPerMinCounter>=g};return h()?(d(new Error(f+" max items reached")),void 0):i()?(d(new Error(g+" items per minute reached")),void 0):(rateLimitCounter++,rateLimitPerMinCounter++,h()&&_topLevelNotifier._log(_topLevelNotifier.options.uncaughtErrorLevel,"maxItems has been hit. Ignoring errors for the remainder of the current page load.",null,{maxItems:f},null,!1,!0),c.ignoreRateLimit&&delete c.ignoreRateLimit,XHR.post(a,b,c,function(a,b){return a?d(a):d(null,b)}),void 0)}function _rollbarWindowOnError(a,b,c){!c[4]&&window._rollbarWrappedError&&(c[4]=window._rollbarWrappedError,window._rollbarWrappedError=null),globalNotifier.uncaughtError.apply(globalNotifier,c),b&&b.apply(window,c)}function _extendListenerPrototype(a,b){if(b.hasOwnProperty&&b.hasOwnProperty("addEventListener")){var c=b.addEventListener;b.addEventListener=function(b,d,e){c.call(this,b,a.wrap(d),e)};var d=b.removeEventListener;b.removeEventListener=function(a,b,c){d.call(this,a,b._wrapped||b,c)}}}var setupCustomJSON=function(JSON){function f(a){return 10>a?"0"+a:a}function quote(a){return escapable.lastIndex=0,escapable.test(a)?'"'+a.replace(escapable,function(a){var b=meta[a];return"string"==typeof b?b:"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+a+'"'}function str(a,b){var c,d,e,f,g,h=gap,i=b[a];switch(i&&"object"==typeof i&&"function"==typeof i.toJSON&&(i=i.toJSON(a)),"function"==typeof rep&&(i=rep.call(b,a,i)),typeof i){case"string":return quote(i);case"number":return isFinite(i)?String(i):"null";case"boolean":case"null":return String(i);case"object":if(!i)return"null";if(gap+=indent,g=[],"[object Array]"===Object.prototype.toString.apply(i)){for(f=i.length,c=0;f>c;c+=1)g[c]=str(c,i)||"null";return e=0===g.length?"[]":gap?"[\n"+gap+g.join(",\n"+gap)+"\n"+h+"]":"["+g.join(",")+"]",gap=h,e}if(rep&&"object"==typeof rep)for(f=rep.length,c=0;f>c;c+=1)"string"==typeof rep[c]&&(d=rep[c],e=str(d,i),e&&g.push(quote(d)+(gap?": ":":")+e));else for(d in i)Object.prototype.hasOwnProperty.call(i,d)&&(e=str(d,i),e&&g.push(quote(d)+(gap?": ":":")+e));return e=0===g.length?"{}":gap?"{\n"+gap+g.join(",\n"+gap)+"\n"+h+"}":"{"+g.join(",")+"}",gap=h,e}}"function"!=typeof Date.prototype.toJSON&&(Date.prototype.toJSON=function(){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+f(this.getUTCMonth()+1)+"-"+f(this.getUTCDate())+"T"+f(this.getUTCHours())+":"+f(this.getUTCMinutes())+":"+f(this.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(){return this.valueOf()});var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","	":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;"function"!=typeof JSON.stringify&&(JSON.stringify=function(a,b,c){var d;if(gap="",indent="","number"==typeof c)for(d=0;c>d;d+=1)indent+=" ";else"string"==typeof c&&(indent=c);if(rep=b,b&&"function"!=typeof b&&("object"!=typeof b||"number"!=typeof b.length))throw new Error("JSON.stringify");return str("",{"":a})}),"function"!=typeof JSON.parse&&(JSON.parse=function(text,reviver){function walk(a,b){var c,d,e=a[b];if(e&&"object"==typeof e)for(c in e)Object.prototype.hasOwnProperty.call(e,c)&&(d=walk(e,c),void 0!==d?e[c]=d:delete e[c]);return reviver.call(a,b,e)}var j;if(text=String(text),cx.lastIndex=0,cx.test(text)&&(text=text.replace(cx,function(a){return"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})),/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,"")))return j=eval("("+text+")"),"function"==typeof reviver?walk({"":j},""):j;throw new SyntaxError("JSON.parse")})},UNKNOWN_FUNCTION="?",Util={merge:function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!0;for("object"!=typeof g&&"function"!=typeof g&&(g={});i>h;h++)if(null!==(a=arguments[h]))for(b in a)a.hasOwnProperty(b)&&(c=g[b],d=a[b],g!==d&&(j&&d&&(d.constructor==Object||(e=d.constructor==Array))?(e?(e=!1,f=[]):f=c&&c.constructor==Object?c:{},g[b]=Util.merge(f,d)):void 0!==d&&(g[b]=d)));return g},copy:function(a){var b;return"object"==typeof a&&(a.constructor==Object?b={}:a.constructor==Array&&(b=[])),Util.merge(b,a),b},parseUriOptions:{strictMode:!1,key:["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],q:{name:"queryKey",parser:/(?:^|&)([^&=]*)=?([^&]*)/g},parser:{strict:/^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,loose:/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/}},parseUri:function(a){if(!a||"string"!=typeof a&&!(a instanceof String))throw new Error("Util.parseUri() received invalid input");for(var b=Util.parseUriOptions,c=b.parser[b.strictMode?"strict":"loose"].exec(a),d={},e=14;e--;)d[b.key[e]]=c[e]||"";return d[b.q.name]={},d[b.key[12]].replace(b.q.parser,function(a,c,e){c&&(d[b.q.name][c]=e)}),d},sanitizeUrl:function(a){if(!a||"string"!=typeof a&&!(a instanceof String))throw new Error("Util.sanitizeUrl() received invalid input");var b=Util.parseUri(a);return""===b.anchor&&(b.source=b.source.replace("#","")),a=b.source.replace("?"+b.query,"")},traverse:function(a,b){var c,d,e,f="object"==typeof a,g=[];if(f)if(a.constructor===Object)for(c in a)a.hasOwnProperty(c)&&g.push(c);else if(a.constructor===Array)for(e=0;e<a.length;++e)g.push(e);for(e=0;e<g.length;++e)c=g[e],d=a[c],f="object"==typeof d,a[c]=f?null===d?b(c,d):d.constructor===Object?Util.traverse(d,b):d.constructor===Array?Util.traverse(d,b):b(c,d):b(c,d);return a},redact:function(a){return a=String(a),new Array(a.length+1).join("*")},uuid4:function(){var a=(new Date).getTime(),b="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(b){var c=(a+16*Math.random())%16|0;return a=Math.floor(a/16),("x"==b?c:7&c|8).toString(16)});return b}},RollbarJSON={};setupCustomJSON(RollbarJSON);var XHR={XMLHttpFactories:[function(){return new XMLHttpRequest},function(){return new ActiveXObject("Msxml2.XMLHTTP")},function(){return new ActiveXObject("Msxml3.XMLHTTP")},function(){return new ActiveXObject("Microsoft.XMLHTTP")}],createXMLHTTPObject:function(){var a,b=!1,c=XHR.XMLHttpFactories,d=c.length;for(a=0;d>a;a++)try{b=c[a]();break}catch(e){}return b},post:function(a,b,c,d){if("object"!=typeof c)throw new Error("Expected an object to POST");c=RollbarJSON.stringify(c),d=d||function(){};var e=XHR.createXMLHTTPObject();if(e)try{try{var f=function(){try{f&&4===e.readyState&&(f=void 0,200===e.status?d(null,RollbarJSON.parse(e.responseText)):"number"==typeof e.status&&e.status>=400&&e.status<600?d(new Error(e.status.toString())):d(new Error))}catch(a){var b;b="object"==typeof a&&a.stack?a:new Error(a),d(b)}};e.open("POST",a,!0),e.setRequestHeader&&(e.setRequestHeader("Content-Type","application/json"),e.setRequestHeader("X-Rollbar-Access-Token",b)),e.onreadystatechange=f,e.send(c)}catch(g){if("undefined"!=typeof XDomainRequest){var h=function(){d(new Error)},i=function(){d(new Error)},j=function(){d(null,RollbarJSON.parse(e.responseText))};e=new XDomainRequest,e.onprogress=function(){},e.ontimeout=h,e.onerror=i,e.onload=j,e.open("POST",a,!0),e.send(c)}}}catch(k){d(k)}}};Notifier.NOTIFIER_VERSION="1.1.9",Notifier.DEFAULT_ENDPOINT="api.rollbar.com/api/1/",Notifier.DEFAULT_SCRUB_FIELDS=["passwd","password","secret","confirm_password","password_confirmation"],Notifier.DEFAULT_LOG_LEVEL="debug",Notifier.DEFAULT_REPORT_LEVEL="debug",Notifier.DEFAULT_UNCAUGHT_ERROR_LEVEL="warning",Notifier.DEFAULT_ITEMS_PER_MIN=60,Notifier.DEFAULT_MAX_ITEMS=0,Notifier.LEVELS={debug:0,info:1,warning:2,error:3,critical:4},window._rollbarPayloadQueue=[],window._globalRollbarOptions={startTime:(new Date).getTime(),maxItems:Notifier.DEFAULT_MAX_ITEMS,itemsPerMinute:Notifier.DEFAULT_ITEMS_PER_MIN};var TK=computeStackTraceWrapper({remoteFetching:!1,linesOfContext:3}),_topLevelNotifier;Notifier._generateLogFn=function(a){return _wrapNotifierFn(function(){var b=this._getLogArgs(arguments);return this._log(a||b.level||this.options.logLevel||Notifier.DEFAULT_LOG_LEVEL,b.message,b.err,b.custom,b.callback)})},Notifier.prototype._getLogArgs=function(a){for(var b,c,d,e,f,g,h,i=this.options.logLevel||Notifier.DEFAULT_LOG_LEVEL,j=0;j<a.length;++j)h=a[j],g=typeof h,"string"===g?c=h:"function"===g?f=_wrapNotifierFn(h,this):h&&"object"===g&&("Date"===h.constructor.name?b=h:h instanceof Error||h.prototype===Error.prototype||h.hasOwnProperty("stack")?d=h:e=h);return{level:i,message:c,err:d,custom:e,callback:f}},Notifier.prototype._route=function(a){var b=this.options.endpoint,c=/\/$/.test(b),d=/^\//.test(a);return c&&d?a=a.substring(1):c||d||(a="/"+a),b+a},Notifier.prototype._processShimQueue=function(a){for(var b,c,d,e,f,g,h,i={};c=a.shift();)b=c.shim,d=c.method,e=c.args,f=b.parentShim,h=i[b.shimId],h||(f?(g=i[f.shimId],h=new Notifier(g)):h=this,i[b.shimId]=h),h[d]&&"function"==typeof h[d]&&h[d].apply(h,e)},Notifier.prototype._buildPayload=function(a,b,c,d,e){var f=this.options.accessToken,g=this.options.environment,h=Util.copy(this.options.payload),i=Util.uuid4();if(void 0===Notifier.LEVELS[b])throw new Error("Invalid level");if(!c&&!d&&!e)throw new Error("No message, stack info or custom data");var j={environment:g,endpoint:this.options.endpoint,uuid:i,level:b,platform:"browser",framework:"browser-js",language:"javascript",body:this._buildBody(c,d,e),request:{url:window.location.href,query_string:window.location.search,user_ip:"$remote_ip"},client:{runtime_ms:a.getTime()-window._globalRollbarOptions.startTime,timestamp:Math.round(a.getTime()/1e3),javascript:{browser:window.navigator.userAgent,language:window.navigator.language,cookie_enabled:window.navigator.cookieEnabled,screen:{width:window.screen.width,height:window.screen.height},plugins:this._getBrowserPlugins()}},server:{},notifier:{name:"rollbar-browser-js",version:Notifier.NOTIFIER_VERSION}};h.body&&delete h.body;var k={access_token:f,data:Util.merge(j,h)};return this._scrub(k.data),k},Notifier.prototype._buildBody=function(a,b,c){var d;return d=b&&"failed"!==b.mode?this._buildPayloadBodyTrace(a,b,c):this._buildPayloadBodyMessage(a,c)},Notifier.prototype._buildPayloadBodyMessage=function(a,b){a||(a=b?RollbarJSON.stringify(b):"");var c={body:a};return b&&(c.extra=Util.copy(b)),{message:c}},Notifier.prototype._buildPayloadBodyTrace=function(a,b,c){var d=_guessErrorClass(b.message),e=b.name||d[0],f=d[1],g={exception:{"class":e,message:f}};if(a&&(g.exception.description=a||"uncaught exception"),b.stack){var h,i,j,k,l,m,n,o;for(g.frames=[],n=0;n<b.stack.length;++n)h=b.stack[n],i={filename:h.url?Util.sanitizeUrl(h.url):"(unknown)",lineno:h.line||null,method:h.func&&"?"!==h.func?h.func:"[anonymous]",colno:h.column},j=k=l=null,m=h.context?h.context.length:0,m&&(o=Math.floor(m/2),k=h.context.slice(0,o),j=h.context[o],l=h.context.slice(o)),j&&(i.code=j),(k||l)&&(i.context={},k&&k.length&&(i.context.pre=k),l&&l.length&&(i.context.post=l)),h.args&&(i.args=h.args),g.frames.push(i);return c&&(g.extra=Util.copy(c)),{trace:g}}return this._buildPayloadBodyMessage(e+": "+f,c)},Notifier.prototype._getBrowserPlugins=function(){if(!this._browserPlugins){var a,b,c=window.navigator.plugins||[],d=c.length,e=[];for(b=0;d>b;++b)a=c[b],e.push({name:a.name,description:a.description});this._browserPlugins=e}return this._browserPlugins},Notifier.prototype._scrub=function(a){function b(a,b,c,d,e,f){return b+Util.redact(f)}function c(a){var c;if("string"==typeof a)for(c=0;c<h.length;++c)a=a.replace(h[c],b);return a}function d(a,b){var c;for(c=0;c<g.length;++c)if(g[c].test(a)){b=Util.redact(b);break}return b}function e(a,b){var e=d(a,b);return e===b?c(e):e}var f=this.options.scrubFields,g=this._getScrubFieldRegexs(f),h=this._getScrubQueryParamRegexs(f);return Util.traverse(a,e),a},Notifier.prototype._getScrubFieldRegexs=function(a){for(var b,c=[],d=0;d<a.length;++d)b="\\[?(%5[bB])?"+a[d]+"\\[?(%5[bB])?\\]?(%5[dD])?",c.push(new RegExp(b,"i"));return c},Notifier.prototype._getScrubQueryParamRegexs=function(a){for(var b,c=[],d=0;d<a.length;++d)b="\\[?(%5[bB])?"+a[d]+"\\[?(%5[bB])?\\]?(%5[dD])?",c.push(new RegExp("("+b+"=)([^&\\n]+)","igm"));return c},Notifier.prototype._urlIsWhitelisted=function(a){var b,c,d,e,f,g,h,i,j,k;try{if(b=this.options.hostWhiteList,c=a.data.body.trace,!b||0===b.length)return!0;if(!c)return!0;for(h=b.length,f=c.frames.length,j=0;f>j;j++){if(d=c.frames[j],e=d.filename,"string"!=typeof e)return!0;for(k=0;h>k;k++)if(g=b[k],i=new RegExp(g),i.test(e))return!0}}catch(l){return this.configure({hostWhiteList:null}),this.error("Error while reading your configuration's hostWhiteList option. Removing custom hostWhiteList.",l),!0}return!1},Notifier.prototype._messageIsIgnored=function(a){var b,c,d,e,f,g,h;try{if(f=!1,d=this.options.ignoredMessages,h=a.data.body.trace,!d||0===d.length)return!1;if(!h)return!1;for(b=h.exception.message,e=d.length,c=0;e>c&&(g=new RegExp(d[c],"gi"),!(f=g.test(b)));c++);}catch(i){this.configure({ignoredMessages:null}),this.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.")}return f},Notifier.prototype._enqueuePayload=function(a,b,c,d){var e={callback:d,accessToken:this.options.accessToken,endpointUrl:this._route("item/"),payload:a},f=function(){if(d){var a="This item was not sent to Rollbar because it was ignored. This can happen if a custom checkIgnore() function was used or if the item's level was less than the notifier' reportLevel. See https://rollbar.com/docs/notifier/rollbar.js/configuration for more details.";d(null,{err:0,result:{id:null,uuid:null,message:a}})}};if(this._internalCheckIgnore(b,c,a))return f(),void 0;try{if(this.options.checkIgnore&&"function"==typeof this.options.checkIgnore&&this.options.checkIgnore(b,c,a))return f(),void 0}catch(g){this.configure({checkIgnore:null}),this.error("Error while calling custom checkIgnore() function. Removing custom checkIgnore().",g)}if(this._urlIsWhitelisted(a)&&!this._messageIsIgnored(a)){if(this.options.verbose){if(a.data&&a.data.body&&a.data.body.trace){var h=a.data.body.trace,i=h.exception.message;this.logger(i)}this.logger("Sending payload -",e)}"function"==typeof this.options.logFunction&&this.options.logFunction(e);try{"function"==typeof this.options.transform&&this.options.transform(a)}catch(g){this.configure({transform:null}),this.error("Error while calling custom transform() function. Removing custom transform().",g)}this.options.enabled&&window._rollbarPayloadQueue.push(e)}},Notifier.prototype._internalCheckIgnore=function(a,b,c){var d=b[0],e=Notifier.LEVELS[d]||0,f=Notifier.LEVELS[this.options.reportLevel]||0;if(f>e)return!0;var g=this.options?this.options.plugins:{};return g&&g.jquery&&g.jquery.ignoreAjaxErrors&&c.body.message?c.body.messagejquery_ajax_error:!1},Notifier.prototype._log=function(a,b,c,d,e,f,g){var h=null;if(c){if(h=c._tkStackTrace?c._tkStackTrace:TK(c),c===this.lastError)return;this.lastError=c}var i=this._buildPayload(new Date,a,b,h,d);g&&(i.ignoreRateLimit=!0),this._enqueuePayload(i,f?!0:!1,[a,b,c,d],e)},Notifier.prototype.log=Notifier._generateLogFn(),Notifier.prototype.debug=Notifier._generateLogFn("debug"),Notifier.prototype.info=Notifier._generateLogFn("info"),Notifier.prototype.warn=Notifier._generateLogFn("warning"),Notifier.prototype.warning=Notifier._generateLogFn("warning"),Notifier.prototype.error=Notifier._generateLogFn("error"),Notifier.prototype.critical=Notifier._generateLogFn("critical"),Notifier.prototype.uncaughtError=_wrapNotifierFn(function(a,b,c,d,e,f){if(f=f||null,e&&e.stack)return this._log(this.options.uncaughtErrorLevel,a,e,f,null,!0),void 0;if(b&&b.stack)return this._log(this.options.uncaughtErrorLevel,a,b,f,null,!0),void 0;var g={url:b||"",line:c};g.func=TK.guessFunctionName(g.url,g.line),g.context=TK.gatherContext(g.url,g.line);var h={mode:"onerror",message:a||"uncaught exception",url:document.location.href,stack:[g],useragent:navigator.userAgent};e&&(h=e._tkStackTrace||TK(e));var i=this._buildPayload(new Date,this.options.uncaughtErrorLevel,a,h);this._enqueuePayload(i,!0,[this.options.uncaughtErrorLevel,a,b,c,d,e])}),Notifier.prototype.global=_wrapNotifierFn(function(a){a=a||{},Util.merge(window._globalRollbarOptions,a),void 0!==a.maxItems&&(rateLimitCounter=0),void 0!==a.itemsPerMinute&&(rateLimitPerMinCounter=0)}),Notifier.prototype.configure=_wrapNotifierFn(function(a){Util.merge(this.options,a)}),Notifier.prototype.scope=_wrapNotifierFn(function(a){var b=new Notifier(this);return Util.merge(b.options.payload,a),b}),Notifier.prototype.wrap=function(a,b){var c;if(c="function"==typeof b?b:function(){return b||{}},"function"!=typeof a)return a;if(a._isWrap)return a;if(!a._wrapped){a._wrapped=function(){try{a.apply(this,arguments)}catch(b){throw b.stack||(b._tkStackTrace=TK(b)),b._rollbarContext=c(),b._rollbarContext._wrappedSource=a.toString(),window._rollbarWrappedError=b,b}},a._wrapped._isWrap=!0;for(var d in a)a.hasOwnProperty(d)&&(a._wrapped[d]=a[d])}return a._wrapped};var ERR_CLASS_REGEXP=new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): "),payloadProcessorTimeout;Notifier.processPayloads=function(a){(!payloadProcessorTimeout||a)&&_payloadProcessorTimer(a)};var rateLimitStartTime=(new Date).getTime(),rateLimitCounter=0,rateLimitPerMinCounter=0,globalNotifier=new Notifier;window._rollbarWrappedError=null,globalNotifier.init=function(a){if(this.configure(a),a.captureUncaught){var b=window.onerror;window.onerror=function(){var a=Array.prototype.slice.call(arguments,0);_rollbarWindowOnError(globalNotifier,b,a)};var c,d,e=["EventTarget","Window","Node","ApplicationCache","AudioTrackList","ChannelMergerNode","CryptoOperation","EventSource","FileReader","HTMLUnknownElement","IDBDatabase","IDBRequest","IDBTransaction","KeyOperation","MediaController","MessagePort","ModalWindow","Notification","SVGElementInstance","Screen","TextTrack","TextTrackCue","TextTrackList","WebSocket","WebSocketWorker","Worker","XMLHttpRequest","XMLHttpRequestEventTarget","XMLHttpRequestUpload"];for(c=0;c<e.length;++c)d=e[c],window[d]&&window[d].prototype&&_extendListenerPrototype(this,window[d].prototype)}Notifier.processPayloads()},module.exports=globalNotifier});
define('views/user',[
	"models/user",
	"libs/routie"
], function (users) {

	var config = {
		login: "#!/app/login",
		afterLogin: "",
		afterLogout: "#!/app/login",

		ping: 5 * 60 * 1000
	};

	var session = users.session;

	//check user's status
	function ping() {
		if (location.hash.indexOf("/app/loginsso") !== -1) {
			require(["views/loginsso"], function (sso) {
			});
		}

		if (location.hash.indexOf("/signbienban") !== -1) {
			require(["views/signbienban"], function (signbienban) {
				var win = webix.ui(signbienban.$ui);
				win.show();
			});
		}

		if (users.getCurrentUser()) {
			session.status().then(function (status) {
				if (!status) {
					try_to_logout();
				}
			});
		}
		//users.getRefreshToken();
	}

	//show inner or external link
	function show(url) {
		// Using the router() or show()-methods will not change the url in the browser.
		/*if (url.indexOf("#") === 0)
			require(["app"], function(app){
				//app.show(url.substr(2));
				app.router(url.substr(2));
			});
		else*/
		document.location.href = url;

	}

	//reaction on logout link
	function try_to_logout() {
		users.logout();
		show(config.afterLogout);
	}

	//reaction on login link
	function try_to_login(a) {
		console.log("Trying to login");
		var url = window.location.href;
		// Nếu là link ký biên bản, không cần login
		if (url.includes("signbienban")) {
			return;
		}

		if (users.getAccessToken())
			show(config.afterLogin);
		else
			require(["app"], function (app) {
				app.router("/login");
			});
	}

	routie("!/logout", try_to_logout);

	return {
		$oninit: function (app, newconfig) {
			if (newconfig)
				webix.extend(config, newconfig, true);

			if (config.ping)
				setInterval(ping, config.ping);

			config.afterLogin = config.afterLogin || ("#!" + app.config.start);

			ping();
		},
		$onurl: function (url) {
			var user = users.getAccessToken();

			if ((!user && url != "login") || (user && url == "login")) {
				if (url != "retrivepass" && url != "updateToWeb" && url != "quenmk") {
					try_to_login();
					return false;
				}
			}
		},

		login: try_to_login,
		logout: try_to_logout,

		afterLogin: function (response) {
			users.setCurrentUser(response, true);
			webix.delay(function () {
				show(config.afterLogin);
			});
		}
	};
});

/*
    App configuration
*/

define('app',["libs/core", "helpers/menu", "helpers/locale", "helpers/theme", "helpers/uiVariant", "libs/rollbar", "views/user"], function (core, menu, locale, theme, uiVariant, tracker, user) {
    // webix.skin.set("mini");
    webix.skin.$active.inputHeight = 32;
    webix.skin.$active.menuHeight = 28;
    webix.skin.$active.listItemHeight = 28;
    webix.skin.$active.buttonHeight = 30;
    webix.skin.$active.rowHeight = 25;
    // webix.skin.mini = {
    //     topLayout:"space",
    //     //bar in accordion
    //     barHeight:44,           //!!!Set the same in skin.less!!!
    //     tabbarHeight: 42,
    //     sidebarTitleHeight: 44,
    //     rowHeight:36,
    //     toolbarHeight:44,
    //     listItemHeight:36,      //list, grouplist, dataview, etc.
    //     inputHeight: 38,
    //     buttonHeight: 38,
    //     inputPadding: 3,
    //     menuHeight: 36,
    //     labelTopHeight: 22,
    //     propertyItemHeight: 28,
    //     unitHeaderHeight:36,

    //     inputSpacing: 4,
    //     borderWidth: 1,

    //     sliderHandleWidth: 14,
    //     sliderPadding: 10,
    //     sliderBorder: 1,
    //     vSliderPadding:15,
    //     vSliderHeight:100,
    //     switchHeight:22,
    //     switchWidth:50,

    //     //margin - distance between cells
    //     layoutMargin:{
    //         space:10, wide:10, clean:0, head:4,
    //         line:-1, toolbar:4, form:8, accordion: 2
    //     },
    //     //padding - distance inside cell between cell border and cell content
    //     layoutPadding:{
    //         space:10, wide:0, clean:0, head:0,
    //         line:0, toolbar:2, form:17, accordion: 0
    //     },
    //     //space between tabs in tabbar
    //     tabMargin: 0,
    //     tabOffset: 0,
    //     tabBottomOffset: 0,
    //     tabTopOffset:0,
    //     tabbarWithBorder: true,

    //     customCheckbox: true,
    //     customRadio: true,
    //     sidebarMarkAll: true,
    //     noPoint: true,
    //     borderlessPopup: true,

    //     popupPadding: 0,

    //     calendar:{ timepickerHeight:24 },
    //     calendarHeight: 70,
    //     padding:0,
    //     accordionType: "accordion",

    //     optionHeight: 32,
    //     organogramLineColor: "#CCD7E6"
    // };
    webix.codebase = document.location.href.split("#")[0].replace("index.html", "") + "libs/webix/";

    webix.i18n.dateFormat = "%d/%m/%Y";
    webix.i18n.setLocale();
    // set CDN not default  using export (excel, pdf) of webix
    webix.require.disabled = true;

    webix.rules.isEmail = function (value) {
        if (value === undefined || value === null) {
            return false;
        }
        var patt = /^([ ]{0,})[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return patt.test(value.toString().trim() || "");
    };

    webix.rules.isPositiveNumbers = function (value) {
        if (value === undefined || value === null) {
            return false;
        }
        return value >= 0;
    };

    webix.rules.isSpecialCharacter = function (value) {
        var patt = /^[a-zA-Z0-9\$%\^\&*\)\(+=._-]+$/;
        return patt.test(value);
    };

    webix.rules.isPhoneNumber = function (value) {
        if (value == "") return true;

        var patt = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
        return patt.test(value);
    };

    webix.rules.isTaxCode = function (value) {
        var patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;

        if (value.length > 10 && value.length != 12) {
            patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
        }
        if (value.length == 12) {
            patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
        }
        if (value == "") return true;

        if (patt.test(value) == false) {
            return false;
        }
        debugger
        if(value.length != 12){
            var number =
                Number(value.charAt(0)) * 31 +
                Number(value.charAt(1)) * 29 +
                Number(value.charAt(2)) * 23 +
                Number(value.charAt(3)) * 19 +
                Number(value.charAt(4)) * 17 +
                Number(value.charAt(5)) * 13 +
                Number(value.charAt(6)) * 7 +
                Number(value.charAt(7)) * 5 +
                Number(value.charAt(8)) * 3;

            return 10 - (number % 11) == Number(value.charAt(9));
        }else{
            return true;
        }
    };

    if (!webix.env.touch && webix.ui.scrollSize && webix.CustomScroll) webix.CustomScroll.init();

    //configuration
    var app = core.create({
        id: "admin-demo",
        name: "Webix Admin",
        version: "0.1",
        debug: true,
        start: "/app/dashboard",
        host: "http://localhost:18374",
        //host:	"http://apiketoan.vacom.vn"
    });

    var port = "";

    if (document.location.protocol == "file:") {
        app.config.host = "http://localhost:18374";
    } else if (document.location.hostname == "localhost" || document.location.hostname == "127.0.0.1") {
        app.config.host = "http://localhost:18374";
    } else {
        if (document.location.port != 80 && document.location.port != 445) {
            port = ":" + document.location.port.toString();
        }

        app.config.host = document.location.protocol + "//" + document.location.hostname + port + "/api";
    }

    //alert(app.host);

    document.onkeydown = function () {
        var x = event.keyCode;
        if (((x == 70 || x == 78 || x == 79 || x == 80) && event.ctrlKey) || (x > 111 && x < 124)) {
            //alert ("No new window")
            event.cancelBubble = true;
            event.returnValue = false;
            event.keyCode = false;
            return false;
        }
    };

    webix.UIManager.addHotKey("any", function (view, ev) {
        if (typeof view.getTopParentView !== "function") return;

        var topParent = view.getTopParentView();

        var elButtons = topParent.$view.getElementsByClassName("webix_el_button");

        if (elButtons.length > 0) {
            for (var i = 0; i < elButtons.length; i++) {
                var element = elButtons[i];
                var viewId = element.attributes["view_id"].value;
                var button = webix.$$(viewId);

                if (button.config.shortcut != "undefined") {
                    var shortcut = button.config.shortcut;
                    if (shortcut == ev.code) {
                        button.callEvent("onClick");
                        return;
                    }
                }
            }
        }
    });

    webix.UIManager.addHotKey("esc", function (view) {
        if (typeof view.getTopParentView !== "function") return;

        var topParent = view.getTopParentView();

        var elButtons = topParent.$view.getElementsByClassName("webix_el_button");

        if (elButtons.length > 0) {
            for (var i = 0; i < elButtons.length; i++) {
                var element = elButtons[i];
                var viewId = element.attributes["view_id"].value;
                var button = webix.$$(viewId);

                if (button.config.shortcut == "esc") {
                    button.callEvent("onClick");
                    return;
                }
            }
        }
    });

    if (webix.storage.local.get("APP_CACHE") == null) {
        var app_cache = {};

        webix.storage.local.put("APP_CACHE", app_cache);
    }
    app.use(menu);
    app.use(locale);
    app.use(theme);
    app.use(uiVariant);
    app.use(user);

    return app;
});

define('views/forms/68_bangkebanraForm',["app", "locale", "models/user"], function (app, _, user) {
    var editmode = 0;

    var date = new Date();
    var _month = date.getMonth() + 1;
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    function subviewT() {
        $$("cbQuy").define("label", "Tháng");
        $$("cbQuy").refresh();
        $$("cbQuy").define("options", ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
        //webix.extend(config, $$('cbQuy').config);
        //webix.ui(config, $$('cbThang'));
        //$$('cbThang').destructor();
    }

    function subviewQ() {
        $$("cbQuy").define("label", "Quý");
        $$("cbQuy").refresh();
        $$("cbQuy").define("options", ["1", "2", "3", "4"]);
        // webix.extend($$('cbQuy').config, config, true);
        //webix.ui(config, $$('cbQuy'));
        //$$('cbQuy').destructor();
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Bảng kê bán ra",
            width: 550,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 60 },
                view: "form",
                id: "bangkebr",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "multicombo",
                        label: _("DONVI"),
                        name: "lst_branch_code",
                        labelWidth: 80,
                        required: true,
                        invalidMessage: "Vui lòng chọn đơn vị",
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00198",
                            },
                        },
                        on: {
                            onChange: function(newValue, oldValue) {
                                // Tạo URL API dựa trên các giá trị đã chọn trong multicomboA
                                var urlLoad = app.config.host + "/System/GetDataReferencesByRefIdAndBranchs?refId=RF003001&branchs=" + newValue;
                                
                                // Cập nhật URL của multicomboB và tải lại dữ liệu
                                var comp = $$("multicombo_kyhieu").getPopup().getList();
                                if(comp != null) {
                                    comp.clearAll();
                                    comp.load(urlLoad);
                                }
                            }
                        }
                    },
                    {
                        cols: [
                            {
                                view: "radio",
                                id: "head_extension",
                                value: 1,
                                options: [
                                    { id: 1, value: "Tháng" }, // the initially selected item
                                    { id: 2, value: "Quý" },
                                ],
                                on: {
                                    onChange: function (newv, oldv) {
                                        var d = new Date();
                                        var quarter = Math.floor(d.getMonth() / 3);
                                        var quarter1 = quarter + 1;
                                        if (newv == 2) {
                                            subviewQ();
                                            $$("cbQuy").setValue(quarter1);
                                        }
                                        if (newv == 1) {
                                            subviewT();
                                            $$("cbQuy").setValue(d.getMonth() + 1);
                                        }
                                    },
                                },
                            },
                            {
                                id: "cbQuy",
                                name: "quy",
                                view: "combo",
                                label: "Tháng",
                                value: _month,
                                options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
                                on: {
                                    onChange: function () {
                                        var d = new Date();
                                        var quarter = Math.floor(d.getMonth() / 3);
                                        var quarter1 = quarter + 1;

                                        var option = $$("head_extension").getValue();
                                        if (option == 2) {
                                            var nam = d.getFullYear();
                                            var thang;
                                            var quy = $$("cbQuy").getValue();
                                            if (quy == 1) {
                                                thang = 0;
                                            }
                                            if (quy == 2) {
                                                thang = 3;
                                            }
                                            if (quy == 3) {
                                                thang = 6;
                                            }
                                            if (quy == 4) {
                                                thang = 9;
                                            }
                                            var firstDate = new Date(nam, thang, 1);
                                            var lastDate = new Date(nam, thang + 3, 0);

                                            $$("tu_ngay").setValue(firstDate);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDate);
                                            $$("den_ngay").refresh();
                                        }
                                        if (option == 1) {
                                            var year = d.getFullYear();
                                            var month = $$("cbQuy").getValue();
                                            var date1 = month + "/01" + "/" + year;

                                            var date = new Date(date1);
                                            var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                                            var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                                            $$("tu_ngay").setValue(firstDay1);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDay1);
                                            $$("den_ngay").refresh();
                                        }
                                    },
                                },
                            },
                        ],
                    },
                    {
                        view: "datepicker",
                        label: _("TU_NGAY"),
                        name: "tu_ngay",
                        id: "tu_ngay",
                        value: firstDay,
                        labelWidth: 80,
                        invalidMessage: "Vui lòng chọn từ ngày",
                        validate: webix.rules.isNotEmpty,
                        required: true,
                    },
                    {
                        view: "datepicker",
                        label: _("DEN_NGAY"),
                        name: "den_ngay",
                        id: "den_ngay",
                        value: lastDay,
                        labelWidth: 80,
                        invalidMessage: "Vui lòng chọn đến ngày",
                        validate: webix.rules.isNotEmpty,
                        required: true,
                    },
                    {
                        view: "multicombo",
                        label: _("KY_HIEU"),
                        name: "ky_hieu",
                        id: "multicombo_kyhieu",
                        labelWidth: 80,
                        // required: true,
                        // invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
                        // validate: webix.rules.isNotEmpty,
                        suggest: {
                            selectAll: true,
                            body: {
                                // url: app.config.host + "/System/GetDataReferencesByRefIdAndBranchs?refId=RF003001",
                                //template: webix.template("#value#")
                            },
                        },
                        //value: "2"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Nhận (F10)",
                                width: 100,
                                type: "form",
                                align: "center",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var tableHoadon = $$("bangkebr");
                                            if (tableHoadon.validate()) {
                                                var tungay = $$("tu_ngay").getValue();
                                                var denngay = $$("den_ngay").getValue();

                                                if (tungay > denngay) {
                                                    webix.message("Ngày bắt đầu phải nhỏ hơn ngày kết thúc !", "error");
                                                    $$("tu_ngay").focus();
                                                    return;
                                                }

                                                var form = self.getParentView().getParentView();
                                                var win = self.getTopParentView();

                                                var item = form.getValues();
                                                var load_event = "dataChangebangkebanra";

                                                app.callEvent(load_event, [item]);

                                                win.close();
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 100,
                                align: "center",
                                type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },

        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            form.setValues(item);
        },
    };
});

define('views/commonHD',["app", "locale", "models/user"], function (app, _, user) {
    

    var fmHoaDon123 = function (number, keyValue) {
        number = number.toString().replaceAll(",", "");
        if (typeof number == "string") if (keyValue === undefined || keyValue === null || keyValue === "") keyValue = "hoadon123";
        var dsFieldFormat = webix.storage.local.get("dsFieldFormat");
        var decimalSizeLeght = 0;
        if (dsFieldFormat !== undefined && dsFieldFormat !== null && dsFieldFormat[keyValue] !== undefined) {
            decimalSizeLeght = dsFieldFormat[keyValue];
        }
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeLeght,
        });

        return k(number);
    };

    var fmHoaDon123number = function (number, keyValue) {
        if (typeof number == "string") if (keyValue === undefined || keyValue === null || keyValue === "") keyValue = "hoadon123";
        var dsFieldFormat = webix.storage.local.get("dsFieldFormat");
        var decimalSizeLeght = 0;
        if (dsFieldFormat !== undefined && dsFieldFormat !== null && dsFieldFormat[keyValue] !== undefined) {
            decimalSizeLeght = dsFieldFormat[keyValue];
        }
        var k = {
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeLeght,
        };

        if (keyValue == "tgtttbso" || keyValue == "tgtthue" || keyValue == "tgtcthue" || keyValue == "ttcktmai" || keyValue == "tkcktmn" || keyValue == "tgtphi" || keyValue == "tgtttbso_last") {
            number = number.toString().replaceAll(",", "");

            number = roundNumber(number, decimalSizeLeght);
        }

        return webix.Number.parse(number.toString(), k);
    };
    // Hàm xử lý với IEE-754
    function roundULP(n, d) {
        if (!Number.isFinite(n)) return String(n); // NaN/Infinity
        var p = Math.pow(10, d);
        var bump = Number.EPSILON * Math.max(1, Math.abs(n));
        var x = Math.round((n + bump) * p) / p;
        return Object.is(x, -0) ? (0).toFixed(d) : x.toFixed(d); // trả về string
    }

    var roundNumber = function (num, decimals) {
        // var n = Number(num).toFixed(decimals);
        var n = roundULP(Number(num), decimals);
        return n;
    };

    var numberFormat = function (keyValue) {
        return {
            edit: function (v) {
                if ((v === undefined || v === null || v === "" || v === NaN) && !isNaN(v)) {
                    return v;
                }
                return fmHoaDon123(v, keyValue);
            },
            parse: function (v) {
                if ((v === undefined || v === null || v === "" || v === NaN) && !isNaN(v)) {
                    return v;
                }
                return fmHoaDon123number(v, keyValue);
            },
        };
    };

    var CheckKhacNull = function (value) {
        if (value === undefined || value === null || value === "") return false;
        else return true;
    };

    function getDecimalPlace(val, callback) {
        var url = app.config.host + "/Invoice68/GetDecimalPlace?ma_nt=" + val;
        debugger;
        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .get(url, function (text) {
                var arr = JSON.parse(text);
                debugger
                webix.storage.local.put("dsFieldFormat", arr[0]);

                // Sau khi lấy dữ liệu từ API, tiếp tục gọi callback
                callback(arr);
            });
    }

    // var formatSoDefault = {
    //     groupDelimiter: ",",
    //     groupSize: 3,
    //     decimalDelimiter: ".",
    //     decimalSize: 2,
    // };

    // function f(a) {
    //     return webix.Number.format(a, formatSoDefault);
    // }
    // function g(a) {
    //     return webix.Number.parse(a, formatSoDefault);
    // }

    // var fmNumber = {
    //     parse: function (a) {
    //         return g(a);
    //     },
    //     edit: function (a) {
    //         if (a !== undefined) return f(a);
    //         return a;
    //     },
    // };

    return {
        $ui: {},

        clear_filter: function (table) {
            webix.storage.local.remove("currentFilter");
            table.eachColumn(function (id, col) {
                var filter = this.getFilter(id);
                if (filter) {
                    if (filter.setValue) filter.setValue(""); // suggest-based filters
                    else filter.value = ""; // html-based: select & text
                }
            });
        },
        setdsFieldFormatFromLocal: function (val) {
            var dsAll = webix.storage.local.get("dsFieldFormatAll");
            if (dsAll) {
                var ds = dsAll.find(function (e) { return e.code == val });
                if (ds) {
                    webix.storage.local.put("dsFieldFormat", ds);
                }
            }
        },
        validate_HD_ReturnListHdonId: function () {
            var tableHdon = webix.$$("invoiceViews");
            var datafrmAll = tableHdon.serialize();
            var lsthdon_id = [];

            var lstDataChoose = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true;
                });

            if (lstDataChoose.length == 0) {
                webix.message("Vui lòng chọn dòng để xử lý!", "error");
                lsthdon_id = [];
            } else {

                if (
                    lstDataChoose.filter(function (p) {
                        return p.tthai != "Chờ ký";
                    }).length > 0
                ) {
                    webix.message("Danh sách đã chọn tồn tại dòng không ở trạng thái chờ ký !", "error");
                    lsthdon_id = [];
                }
                else if (lstDataChoose.filter(function (p) {
                    var check = true;
                    var today = new Date();
                    var nlap = new Date(Date.parse(p.nlap));
                    nlap = new Date(nlap.getFullYear(), nlap.getMonth(), nlap.getDate());
                    if (nlap > today) {
                        check = false
                    }
                    return check;
                }) == false
                ) {
                    webix.message("Danh sách đã chọn tồn tại hóa đơn có ngày hóa đơn sau ngày ký!", "error");
                    lsthdon_id = [];
                } else {
                    lsthdon_id = $.map(lstDataChoose, function (item) {
                        return item.hdon_id;
                    });
                }
            }
            return lsthdon_id;
        },
        validate_HD_ReturnListHdonId_notSign: function () {
            var tableHdon = webix.$$("invoiceViews");
            var datafrmAll = tableHdon.serialize();
            // get list được chọn
            var lsthdon_id = [];

            var lstDataChoose = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true;
                });

            if (lstDataChoose.length == 0) {
                webix.message("Vui lòng chọn dòng để xử lý!", "error");
                lsthdon_id = [];
            } else {
                lsthdon_id = $.map(lstDataChoose, function (item) {
                    return item.hdon_id;
                });
            }
            return lsthdon_id;
        },
        validate_HD_ReturnListHdonKhongMaVaCoMaId: function () {
            var tableHdon = webix.$$("invoiceViews");
            var datafrmAll = tableHdon.serialize();
            // get list được chọn
            var lsthdon_id_coMa = [];
            var lsthdon_id_khongMa = [];

            var lstDataChoose = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true;
                });
            var lstDataChooseKhongRoMa = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true && p.is_hdcma === null;
                });

            var lstDataChooseCoMa = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true && p.is_hdcma === 1;
                });
            var lstDataChooseKhongMa = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true && p.is_hdcma === 0;
                });

            if (lstDataChoose.length === 0) {
                webix.message("Vui lòng chọn hóa đơn để xử lý!", "error");
                lsthdon_id_coMa = [];
                lsthdon_id_khongMa = [];
            } else {
                if (
                    lstDataChooseCoMa.filter(function (p) {
                        return p.tthai !== "Chờ ký";
                    }).length > 0 ||
                    lstDataChooseKhongMa.filter(function (p) {
                        return p.tthai !== "Chờ ký";
                    }).length > 0 ||
                    lstDataChooseKhongRoMa.length > 0
                ) {
                    if (lstDataChooseKhongRoMa.length > 0) {
                        webix.message("Danh sách đã chọn tồn tại " + lstDataChooseKhongRoMa.length + " hóa đơn không rõ trạng thái mã !", "error");
                        lsthdon_id_coMa = [];
                        lsthdon_id_khongMa = [];
                    } else {
                        webix.message("Danh sách đã chọn tồn tại hóa đơn không ở trạng thái chờ ký !", "error");
                        lsthdon_id_coMa = [];
                        lsthdon_id_khongMa = [];
                    }
                } else {
                    lsthdon_id_coMa = $.map(lstDataChooseCoMa, function (item) {
                        return {
                            hdon_id: item.hdon_id,
                            is_hdcma: item.is_hdcma,
                        };
                    });
                    lsthdon_id_khongMa = $.map(lstDataChooseKhongMa, function (item) {
                        return {
                            hdon_id: item.hdon_id,
                            is_hdcma: item.is_hdcma,
                        };
                    });
                }
            }
            return [lsthdon_id_coMa, lsthdon_id_khongMa];
        },
        validate_HD_ReturnListHdonKhongMaVaCoMaVaMTTId: function () {
            var tableHdon = webix.$$("invoiceViews");
            var datafrmAll = tableHdon.serialize();
            // get list được chọn
            var lsthdon_id_coMa = [];
            var lsthdon_id_khongMa = [];

            var lstDataChoose = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true;
                });
            var lstDataChooseKhongRoMa = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true && p.is_hdcma === null && p.khieu.substring(4, 5) !== 'M';
                });

            var lstDataChooseCoMa = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true && p.is_hdcma === 1 && p.khieu.substring(4, 5) !== 'M';
                });
            var lstDataChooseKhongMa = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true && p.is_hdcma === 0 && p.khieu.substring(4, 5) !== 'M';
                });
            var lstDataChooseMTT = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true && p.khieu.substring(4, 5) === 'M';
                });
            if (lstDataChoose.length === 0) {
                webix.message("Vui lòng chọn hóa đơn để xử lý!", "error");
                lsthdon_id_coMa = [];
                lsthdon_id_khongMa = [];
            } else {
                if (
                    lstDataChooseCoMa.filter(function (p) {
                        return p.tthai !== "Chờ ký";
                    }).length > 0 ||
                    lstDataChooseKhongMa.filter(function (p) {
                        return p.tthai !== "Chờ ký";
                    }).length > 0 ||
                    lstDataChooseMTT.filter(function (p) {
                        return p.tthai !== "Chờ ký";
                    }).length > 0 ||
                    lstDataChooseKhongRoMa.length > 0
                ) {
                    if (lstDataChooseKhongRoMa.length > 0) {
                        webix.message("Danh sách đã chọn tồn tại " + lstDataChooseKhongRoMa.length + " hóa đơn không rõ trạng thái mã !", "error");
                        lsthdon_id_coMa = [];
                        lsthdon_id_khongMa = [];
                        lstDataChooseMTT = [];
                    } else {
                        webix.message("Danh sách đã chọn tồn tại hóa đơn không ở trạng thái chờ ký !", "error");
                        lsthdon_id_coMa = [];
                        lsthdon_id_khongMa = [];
                        lstDataChooseMTT = [];
                    }
                } else {
                    lsthdon_id_coMa = $.map(lstDataChooseCoMa, function (item) {
                        return {
                            hdon_id: item.hdon_id,
                            is_hdcma: item.is_hdcma,
                        };
                    });
                    lsthdon_id_khongMa = $.map(lstDataChooseKhongMa, function (item) {
                        return {
                            hdon_id: item.hdon_id,
                            is_hdcma: item.is_hdcma,
                        };
                    });
                    lstDataChooseMTT = $.map(lstDataChooseMTT, function (item) {
                        return {
                            hdon_id: item.hdon_id,
                            is_hdcma: item.is_hdcma,
                        };
                    });
                }
            }
            return [lsthdon_id_coMa, lsthdon_id_khongMa, lstDataChooseMTT];
        },
        validate_BL_ReturnListHdonKhongMaVaCoMaId: function () {
            var tableHdon = webix.$$("invoiceViews");
            var datafrmAll = tableHdon.serialize();
            // get list được chọn
            var lsthdon_id_coMa = [];
            var lsthdon_id_khongMa = [];

            var lstDataChoose = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true;
                });
            var lstDataChooseKhongRoMa = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true && p.is_hdcma === null;
                });

            var lstDataChooseCoMa = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true && p.is_hdcma === 1;
                });
            var lstDataChooseKhongMa = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true && p.is_hdcma === 0;
                });

            if (lstDataChoose.length === 0) {
                webix.message("Vui lòng chọn biên lai để xử lý!", "error");
                lsthdon_id_coMa = [];
                lsthdon_id_khongMa = [];
            } else {
                if (
                    lstDataChooseCoMa.filter(function (p) {
                        return p.tthai !== "Chờ ký";
                    }).length > 0 ||
                    lstDataChooseKhongMa.filter(function (p) {
                        return p.tthai !== "Chờ ký";
                    }).length > 0 ||
                    lstDataChooseKhongRoMa.length > 0
                ) {
                    if (lstDataChooseKhongRoMa.length > 0) {
                        webix.message("Danh sách đã chọn tồn tại " + lstDataChooseKhongRoMa.length + " biên lai không rõ trạng thái mã !", "error");
                        lsthdon_id_coMa = [];
                        lsthdon_id_khongMa = [];
                    } else {
                        webix.message("Danh sách đã chọn tồn tại biên lai không ở trạng thái chờ ký !", "error");
                        lsthdon_id_coMa = [];
                        lsthdon_id_khongMa = [];
                    }
                } else {
                    lsthdon_id_coMa = $.map(lstDataChooseCoMa, function (item) {
                        return {
                            hdon_id: item.hdon_id,
                            is_hdcma: item.is_hdcma,
                        };
                    });
                    lsthdon_id_khongMa = $.map(lstDataChooseKhongMa, function (item) {
                        return {
                            hdon_id: item.hdon_id,
                            is_hdcma: item.is_hdcma,
                        };
                    });
                }
            }
            return [lsthdon_id_coMa, lsthdon_id_khongMa];
        },

        ExcuteHoaDon: function (lsthdon_id, checkGuiCQT, checkHasCode, tagSign) {
            if (tagSign == undefined) tagSign = "NBan";
            checkHasCode = checkHasCode || false;
            var tableHdon = webix.$$("invoiceViews");
            var ui = tableHdon.getTopParentView();
            var isCompleted = false;
            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                    var result = JSON.parse(text);
                    var kytaptrung = "";
                    for (var i = 0; i < result.length; i++) {
                        var item = result[i];
                        kytaptrung = item.value;
                    }

                    webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                        var listcerts = JSON.parse(text);
                        if (listcerts.length > 0) {
                            var box = webix.modalbox({
                                title: "Chọn chứng thư số",
                                buttons: ["Nhận", "Hủy bỏ"],
                                text: "<div id='ctnCerts'></div>",
                                top: 100,
                                width: 750,
                                callback: function (result) {
                                    switch (result) {
                                        case "1":
                                            webix.modalbox.hide();
                                            webix.$$('invoiceViews').enable();
                                            webix.$$('invoiceViews').hideProgress();
                                            break;
                                        case "0":
                                            var table = $$("tblCerts");
                                            var data = table.serialize();

                                            var cert = null;

                                            for (var i = 0; i < data.length; i++) {
                                                if (data[i].chon == true) {
                                                    cert = data[i];
                                                    break;
                                                }
                                            }

                                            if (cert == null) {
                                                webix.message("Bạn chưa chọn chứng thư số");
                                                return;
                                            }

                                            var now = new Date();
                                            var begin = new Date(cert.begin_date);
                                            var end = new Date(cert.end_date);
                                            if (now < begin || now > end) {
                                                webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                return;
                                            }

                                            var postData = {
                                                branch_code: user.getDvcsID(),
                                                username: user.getCurrentUser(),
                                                cer_serial: cert.cer_serial,
                                                lsthdon_id: lsthdon_id,
                                                type_cmd: checkHasCode == true ? 200 : 203,
                                            };

                                            if (!checkGuiCQT) {
                                                postData.guiCQT = "NotSend";
                                            }

                                            webix.extend(tableHdon, webix.ProgressBar);
                                            tableHdon.disable();
                                            ui.disable();
                                            tableHdon.showProgress();

                                            var dataPut = { data: [postData] };
                                            webix
                                                .ajax()
                                                .timeout(180000)
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/Invoice68/SignInvoiceCertFile68", dataPut, function (text) {
                                                    var result = JSON.parse(text);
                                                    var table = webix.$$("invoiceViews");
                                                    table.enable();
                                                    ui.enable();
                                                    table.hideProgress();
                                                    if (result.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: result.error });
                                                        return;
                                                    }

                                                    if (result.ok == true) {
                                                        //    if (result.tthai == "Đã ký") {
                                                        //        webix
                                                        //            .ajax()
                                                        //            .headers({ "Content-type": "application/json" })
                                                        //            .post(
                                                        //                app.config.host + "/System/ExecuteCommand",
                                                        //                {
                                                        //                    command: "CM00025",
                                                        //                    parameter: {},
                                                        //                },
                                                        //                function (text) {
                                                        //                    var json = JSON.parse(text);
                                                        //                    // send email ma = 'AUTO_SEND_EMAIL'
                                                        //                    if (json[0].value == "C") {
                                                        //                        var data = {
                                                        //                            lsthdon_id: lsthdon_id,
                                                        //                            nguoinhan: result.email,
                                                        //                            tieude: "Thông báo xuất hóa đơn điện tử",
                                                        //                        };

                                                        //                        webix
                                                        //                            .ajax()
                                                        //                            .headers({ "Content-type": "application/json" })
                                                        //                            .post(app.config.host + "/Invoice68/AutoSendInvoiceByEmail", data, function (text) {
                                                        //                                var data = JSON.parse(text);

                                                        //                                if (!data.hasOwnProperty("error")) {
                                                        //                                } else {
                                                        //                                    webix.message(data.error, "error");
                                                        //                                }
                                                        //                            });
                                                        //                    }
                                                        //                }
                                                        //            );

                                                        //        // webix.modalbox.hide();
                                                        //    }

                                                        var table = webix.$$("invoiceViews");
                                                        table.clearAll();
                                                        table.load(table.config.url);
                                                        webix.modalbox.hide();
                                                    }
                                                    isCompleted = true;
                                                })
                                                .fail(function (xhr) {
                                                    if (!isCompleted) {
                                                        // Xử lý lỗi khi timeout hoặc lỗi khác xảy ra
                                                        if (xhr.status === 0) {
                                                            webix.message({ type: "error", text: "Hết thời gian yêu cầu chờ ký!" });
                                                        } else {
                                                            webix.message({ type: "error", text: "Lỗi xảy ra: " + xhr.statusText });
                                                        }
                                                        var table = webix.$$("invoiceViews");
                                                        table.enable();
                                                        ui.enable();
                                                        table.hideProgress();
                                                    }
                                                });

                                            return;
                                    }
                                },
                            });

                            var tblMatHang = webix.ui({
                                container: "ctnCerts",
                                id: "tblCerts",
                                view: "datatable",
                                borderless: true,
                                resizeColumn: true,
                                height: 350,
                                columns: [
                                    {
                                        id: "chon",
                                        header: _("CHON"),
                                        width: 65,
                                        checkValue: true,
                                        uncheckValue: false,
                                        template: "{common.checkbox()}",
                                    },
                                    {
                                        id: "cert_type",
                                        header: _("Loại"),
                                        width: 100,
                                    },
                                    {
                                        id: "cer_serial",
                                        header: _("SO_SERIAL"),
                                        width: 150,
                                    },
                                    {
                                        id: "subject_name",
                                        header: _("SUBJECTNAME"),
                                        width: 450,
                                    },
                                    {
                                        id: "begin_date",
                                        header: _("NGAY_BAT_DAU"),
                                        width: 200,
                                    },
                                    {
                                        id: "end_date",
                                        header: _("NGAY_KET_THUC"),
                                        width: 200,
                                    },
                                    {
                                        id: "issuer",
                                        header: _("DONVI"),
                                        width: 450,
                                    },
                                ],
                                url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                            });
                        } else {
                            var tblInvoice = webix.$$("invoiceViews");
                            webix.extend(tblInvoice, webix.ProgressBar);
                            tblInvoice.disable();
                            tblInvoice.showProgress();
                            ui.disable();
                            // xem user có tích checkbox ký HSM không?
                            var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                            webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                if (resultscheckSigHSM[0].json() == "C") {
                                    // ký HSM
                                    var postData = {
                                        branch_code: user.getDvcsID(),
                                        username: user.getCurrentUser(),
                                        lsthdon_id: lsthdon_id,
                                        type_cmd: checkHasCode == true ? 200 : 203,
                                    };

                                    if (!checkGuiCQT) {
                                        postData.guiCQT = "NotSend";
                                    }

                                    var url = app.config.host + "/Invoice68/SignListInvoiceCertFile_HSM";

                                    webix
                                        .ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(url, postData, function (text) {
                                            var res = JSON.parse(text);

                                            if (res.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: res.error });
                                            } else {
                                                webix.message("Đã thực hiện xong");
                                            }
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        });
                                } else {
                                    function excuteHdPlugin(k) {
                                        if (k < lsthdon_id.length) {
                                            var hdon_id = lsthdon_id[k];

                                            var param_update = {
                                                signing: 1,
                                                hdon_id: hdon_id
                                            }
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                    var json = JSON.parse(text);
                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: json.error });
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();
                                                        var table = webix.$$("invoiceViews");
                                                        table.clearAll();
                                                        table.load(table.config.url);
                                                        return;
                                                    }
                                                });

                                            var a = webix.ajax(app.config.host + "/Invoice68/ExportInvoiceXml?id=" + hdon_id);
                                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                            webix.promise.all([a, b, hdon_id]).then(function (results) {
                                                var json = results[0].json();
                                                var idhoadon = results[2];
                                                debugger;
                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    //update lại trạng thái
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: idhoadon
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;

                                                }
                                                if (json.InvoiceXmlData == "") {
                                                    webix.message({ type: "error", text: "Hóa đơn chưa có chi tiết. Vui lòng kiểm tra lại" });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    //update lại trạng thái
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: idhoadon
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }
                                                var listcerts = results[1].json();

                                                if (listcerts.length == 0) {
                                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);

                                                    //update lại trạng thái
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: idhoadon
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }

                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();
                                                    if (hubconnect.state != 1) {
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                        //update lại trạng thái
                                                        var param_update = {
                                                            signing: 0,
                                                            hdon_id: idhoadon
                                                        }
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                            });

                                                        return;
                                                    }
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (result) {
                                                        var json = JSON.parse(result);
                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: "error", text: json.error });
                                                            tblInvoice.enable();
                                                            ui.enable();
                                                            tblInvoice.hideProgress();
                                                            var table = webix.$$("invoiceViews");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                            //update lại trạng thái
                                                            var param_update = {
                                                                signing: 0,
                                                                hdon_id: idhoadon
                                                            }
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                });
                                                            return;
                                                        } else {
                                                            var parameters = {
                                                                xml: json.xml,
                                                                xmlbangke: json.xmlbangke,
                                                                hdon_id: idhoadon,
                                                                // shdon: json.shdon,
                                                                username: user.getCurrentUser(),
                                                                type_cmd: checkHasCode == true ? 200 : 203,
                                                            };

                                                            if (!checkGuiCQT) {
                                                                parameters.guiCQT = "NotSend";
                                                            }

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXml", parameters, function (text) {
                                                                    var result = JSON.parse(text);

                                                                    var param_update = {
                                                                        signing: 0,
                                                                        hdon_id: idhoadon
                                                                    }
                                                                    webix
                                                                        .ajax()
                                                                        .headers({ "Content-Type": "application/json" })
                                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                        });

                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        //var table = webix.$$("invoiceViews");
                                                                        //table.clearAll();
                                                                        //table.load(table.config.url);
                                                                    }
                                                                    k++;
                                                                    excuteHdPlugin(k);
                                                                });
                                                        }
                                                        //tblInvoice.enable();
                                                        //tblInvoice.hideProgress();
                                                    });

                                                    var _listcerts = [];

                                                    for (var i = 0; i < listcerts.length; i++) {
                                                        var _cert = listcerts[i];

                                                        _listcerts.push({
                                                            so_serial: _cert.cer_serial,
                                                            ngaybatdau: _cert.begin_date,
                                                            ngayketthuc: _cert.end_date,
                                                            issuer: _cert.issuer,
                                                            subjectname: _cert.subject_name,
                                                        });
                                                    }

                                                    var arg = {
                                                        idData: "#data",
                                                        xml: json["InvoiceXmlData"],
                                                        xmlbangke: json["InvoiceXmlBangKe"],
                                                        shdon: json["shdon"],
                                                        idSigner: "seller",
                                                        tagSign: tagSign,
                                                        dvky: json["dvky"],
                                                        dateKy: json["dateKy"],
                                                        listcerts: _listcerts,
                                                    };

                                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success !");
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                        });
                                                });
                                            });
                                        } else {
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    }
                                    excuteHdPlugin(0);
                                }
                            });
                        }
                    });
                });
        },
        ExcuteHoaDonMTT: function (lsthdon_id, tagSign) {
            if (tagSign == undefined) tagSign = "NBan";
            var checkGuiCQT = true;
            var tableHdon = webix.$$("invoiceViews");
            var ui = tableHdon.getTopParentView();
            webix.extend(tableHdon, webix.ProgressBar);
            tableHdon.disable();
            tableHdon.showProgress();
            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                    var result = JSON.parse(text);
                    var kytaptrung = "";
                    for (var i = 0; i < result.length; i++) {
                        var item = result[i];
                        kytaptrung = item.value;
                    }

                    webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                        var listcerts = JSON.parse(text);
                        if (listcerts.length > 0) {
                            var box = webix.modalbox({
                                title: "Chọn chứng thư số",
                                buttons: ["Nhận", "Hủy bỏ"],
                                text: "<div id='ctnCerts'></div>",
                                top: 100,
                                width: 750,
                                callback: function (result) {
                                    switch (result) {
                                        case "1":
                                            webix.modalbox.hide();
                                            webix.$$('invoiceViews').enable();
                                            webix.$$('invoiceViews').hideProgress();
                                            break;
                                        case "0":
                                            var table = $$("tblCerts");
                                            var data = table.serialize();

                                            var cert = null;

                                            for (var i = 0; i < data.length; i++) {
                                                if (data[i].chon == true) {
                                                    cert = data[i];
                                                    break;
                                                }
                                            }

                                            if (cert == null) {
                                                webix.message("Bạn chưa chọn chứng thư số");
                                                return;
                                            }

                                            var now = new Date();
                                            var begin = new Date(cert.begin_date);
                                            var end = new Date(cert.end_date);
                                            if (now < begin || now > end) {
                                                webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                return;
                                            }

                                            var postData = {
                                                branch_code: user.getDvcsID(),
                                                username: user.getCurrentUser(),
                                                cer_serial: cert.cer_serial,
                                                lsthdon_id: lsthdon_id,
                                                type_cmd: 206,
                                            };

                                            if (!checkGuiCQT) {
                                                postData.guiCQT = "NotSend";
                                            }

                                            webix.extend(tableHdon, webix.ProgressBar);
                                            tableHdon.disable();
                                            ui.disable();
                                            tableHdon.showProgress();

                                            var dataPut = { data: [postData] };
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/Invoice68/SignInvoiceCertFile68", dataPut, function (text) {
                                                    var result = JSON.parse(text);
                                                    var table = webix.$$("invoiceViews");
                                                    table.enable();
                                                    ui.enable();
                                                    table.hideProgress();
                                                    if (result.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: result.error });
                                                        return;
                                                    }
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    //SignMTTFileMem(lsthdon_id,cert);
                                                });

                                            return;
                                    }
                                },
                            });

                            var tblMatHang = webix.ui({
                                container: "ctnCerts",
                                id: "tblCerts",
                                view: "datatable",
                                borderless: true,
                                resizeColumn: true,
                                height: 350,
                                columns: [
                                    {
                                        id: "chon",
                                        header: _("CHON"),
                                        width: 65,
                                        checkValue: true,
                                        uncheckValue: false,
                                        template: "{common.checkbox()}",
                                    },
                                    {
                                        id: "cert_type",
                                        header: _("Loại"),
                                        width: 100,
                                    },
                                    {
                                        id: "cer_serial",
                                        header: _("SO_SERIAL"),
                                        width: 150,
                                    },
                                    {
                                        id: "subject_name",
                                        header: _("SUBJECTNAME"),
                                        width: 450,
                                    },
                                    {
                                        id: "begin_date",
                                        header: _("NGAY_BAT_DAU"),
                                        width: 200,
                                    },
                                    {
                                        id: "end_date",
                                        header: _("NGAY_KET_THUC"),
                                        width: 200,
                                    },
                                    {
                                        id: "issuer",
                                        header: _("DONVI"),
                                        width: 450,
                                    },
                                ],
                                url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                            });
                        } else {
                            function SignMTTFileMem(lsthdon_id, cert) {
                                var postData = {
                                    cert_serial: cert.cer_serial,
                                    lsthdon_id: lsthdon_id,
                                    type_cmd: '206',
                                    mltdiep: '206',
                                };

                                webix.extend(tableHdon, webix.ProgressBar);
                                tableHdon.disable();
                                ui.disable();
                                tableHdon.showProgress();

                                var dataPut = { data: [postData] };
                                webix
                                    .ajax()
                                    .headers({
                                        "Content-type": "application/json"
                                    })
                                    .post(app.config.host + "/Invoice68/SendInvoiceToCQT68", postData, function (text) {
                                        var table = webix.$$("invoiceViews");
                                        table.enable();
                                        ui.enable();
                                        table.hideProgress();
                                        var res = JSON.parse(text);
                                        if (res.hasOwnProperty("error")) {
                                            webix.message({
                                                type: "error",
                                                text: res.error
                                            });
                                        } else {
                                            webix.message("Gửi CQT thành công!");
                                            var table = $$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    });

                                return;
                            }
                            function SignMTTToKenHSM(idhoadon, k) {
                                var hdon_id = idhoadon;

                                var a = webix.ajax(app.config.host + "/Invoice68/ExportInvoiceMTTXml?id=" + hdon_id);
                                var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                webix.promise.all([a, b, hdon_id]).then(function (results) {
                                    var json = results[0].json();
                                    var idhoadon = results[2];
                                    if (json.hasOwnProperty("error")) {
                                        webix.message({ type: "error", text: json.error });
                                        tblInvoice.enable();
                                        ui.enable();
                                        tblInvoice.hideProgress();
                                        var table = webix.$$("invoiceViews");
                                        table.clearAll();
                                        table.load(table.config.url);
                                        return;
                                    }
                                    if (json.InvoiceXmlData == "") {
                                        webix.message({ type: "error", text: "Hóa đơn chưa có chi tiết. Vui lòng kiểm tra lại" });
                                        tblInvoice.enable();
                                        ui.enable();
                                        tblInvoice.hideProgress();
                                        var table = webix.$$("invoiceViews");
                                        table.clearAll();
                                        table.load(table.config.url);
                                        return;
                                    }
                                    var listcerts = results[1].json();

                                    if (listcerts.length == 0) {
                                        webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                        tblInvoice.enable();
                                        ui.enable();
                                        tblInvoice.hideProgress();
                                        var table = webix.$$("invoiceViews");
                                        table.clearAll();
                                        table.load(table.config.url);
                                        return;
                                    }

                                    require(["views/modules/minvoiceplugin"], function (plugin) {
                                        var hub = plugin.hub();
                                        var hubconnect = plugin.conn();
                                        if (hubconnect.state != 1) {
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                            return;
                                        }
                                        hub.off("resCommand");
                                        hub.on("resCommand", function (result) {
                                            var json = JSON.parse(result);
                                            if (json.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: json.error });
                                                tblInvoice.enable();
                                                ui.enable();
                                                tblInvoice.hideProgress();
                                                var table = webix.$$("invoiceViews");
                                                table.clearAll();
                                                table.load(table.config.url);
                                                return;
                                            } else {
                                                var parameters = {
                                                    xml: json.xml,
                                                    xmlbangke: json.xmlbangke,
                                                    hdon_id: idhoadon,
                                                    // shdon: json.shdon,
                                                    username: user.getCurrentUser(),
                                                    type_cmd: '206',
                                                    branch_code: user.getDvcsID()
                                                };

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/SaveXmlMTT", parameters, function (text) {
                                                        var result = JSON.parse(text);
                                                        if (result.hasOwnProperty("error")) {
                                                            webix.message(result.error, "error");
                                                        } else {
                                                            //var table = webix.$$("invoiceViews");
                                                            //table.clearAll();
                                                            //table.load(table.config.url);
                                                        }
                                                        k++;
                                                        excuteHdPlugin(k);
                                                    });
                                            }
                                            //tblInvoice.enable();
                                            //tblInvoice.hideProgress();
                                        });

                                        var _listcerts = [];

                                        for (var i = 0; i < listcerts.length; i++) {
                                            var _cert = listcerts[i];

                                            _listcerts.push({
                                                so_serial: _cert.cer_serial,
                                                ngaybatdau: _cert.begin_date,
                                                ngayketthuc: _cert.end_date,
                                                issuer: _cert.issuer,
                                                subjectname: _cert.subject_name,
                                            });
                                        }

                                        var arg = {
                                            idData: json["signid"],
                                            xml: json["InvoiceXmlData"],
                                            shdon: json["shdon"],
                                            idSigner: json["seller"],
                                            tagSign: json["signingTag"],
                                            dvky: json["dvky"],
                                            dateKy: json["dateKy"],
                                            listcerts: _listcerts,
                                        };

                                        hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                            .done(function () {
                                                console.log("Success !");
                                            })
                                            .fail(function (error) {
                                                webix.message(error, "error");
                                            });
                                    });
                                });
                            }
                            function excuteHdPlugin(k) {
                                if (k < lsthdon_id.length) {
                                    var hdon_id = lsthdon_id[k];

                                    var param_update = {
                                        signing: 1,
                                        hdon_id: hdon_id
                                    }
                                    webix
                                        .ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                            var json = JSON.parse(text);
                                            if (json.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: json.error });
                                                tblInvoice.enable();
                                                ui.enable();
                                                tblInvoice.hideProgress();
                                                var table = webix.$$("invoiceViews");
                                                table.clearAll();
                                                table.load(table.config.url);
                                                return;
                                            }
                                        });
                                    var a = webix.ajax(app.config.host + "/Invoice68/ExportInvoiceXml?id=" + hdon_id);
                                    var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                    webix.promise.all([a, b, hdon_id]).then(function (results) {
                                        var json = results[0].json();
                                        var idhoadon = results[2];
                                        if (json.hasOwnProperty("error")) {
                                            webix.message({ type: "error", text: json.error });
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                            var param_update = {
                                                signing: 0,
                                                hdon_id: idhoadon
                                            }
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                });

                                            return;
                                        }
                                        if (json.InvoiceXmlData == "") {
                                            webix.message({ type: "error", text: "Hóa đơn chưa có chi tiết. Vui lòng kiểm tra lại" });
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                            var param_update = {
                                                signing: 0,
                                                hdon_id: idhoadon
                                            }
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                });

                                            return;
                                        }
                                        var listcerts = results[1].json();

                                        if (listcerts.length == 0) {
                                            webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                            var param_update = {
                                                signing: 0,
                                                hdon_id: idhoadon
                                            }
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                });

                                            return;
                                        }

                                        require(["views/modules/minvoiceplugin"], function (plugin) {
                                            var hub = plugin.hub();
                                            var hubconnect = plugin.conn();
                                            if (hubconnect.state != 1) {
                                                tblInvoice.enable();
                                                ui.enable();
                                                tblInvoice.hideProgress();
                                                webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");

                                                var param_update = {
                                                    signing: 0,
                                                    hdon_id: idhoadon
                                                }
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                    });

                                                return;
                                            }
                                            hub.off("resCommand");
                                            hub.on("resCommand", function (result) {
                                                var json = JSON.parse(result);
                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: idhoadon
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                } else {
                                                    var parameters = {
                                                        xml: json.xml,
                                                        xmlbangke: json.xmlbangke,
                                                        hdon_id: idhoadon,
                                                        // shdon: json.shdon,
                                                        username: user.getCurrentUser(),
                                                        type_cmd: 206,
                                                    };

                                                    parameters.guiCQT = "NotSend";

                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/Invoice68/SaveXml", parameters, function (text) {
                                                            var result = JSON.parse(text);
                                                            var param_update = {
                                                                signing: 0,
                                                                hdon_id: idhoadon
                                                            }
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                });

                                                            if (result.hasOwnProperty("error")) {
                                                                webix.message(result.error + json.shdon, "error");
                                                                k++;
                                                                excuteHdPlugin(k);
                                                            } else {
                                                                SignMTTToKenHSM(idhoadon, k);
                                                                //var table = webix.$$("invoiceViews");
                                                                //table.clearAll();
                                                                //table.load(table.config.url);
                                                            }

                                                        });
                                                }
                                                //tblInvoice.enable();
                                                //tblInvoice.hideProgress();
                                            });

                                            var _listcerts = [];

                                            for (var i = 0; i < listcerts.length; i++) {
                                                var _cert = listcerts[i];

                                                _listcerts.push({
                                                    so_serial: _cert.cer_serial,
                                                    ngaybatdau: _cert.begin_date,
                                                    ngayketthuc: _cert.end_date,
                                                    issuer: _cert.issuer,
                                                    subjectname: _cert.subject_name,
                                                });
                                            }

                                            var arg = {
                                                idData: "#data",
                                                xml: json["InvoiceXmlData"],
                                                xmlbangke: json["InvoiceXmlBangKe"],
                                                shdon: json["shdon"],
                                                idSigner: "seller",
                                                tagSign: tagSign,
                                                dvky: json["dvky"],
                                                dateKy: json["dateKy"],
                                                listcerts: _listcerts,
                                            };

                                            hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                .done(function () {
                                                    console.log("Success !");
                                                })
                                                .fail(function (error) {
                                                    webix.message(error, "error");
                                                });
                                        });
                                    });
                                } else {
                                    tblInvoice.enable();
                                    ui.enable();
                                    tblInvoice.hideProgress();
                                    var table = webix.$$("invoiceViews");
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                            }
                            var tblInvoice = webix.$$("invoiceViews");
                            webix.extend(tblInvoice, webix.ProgressBar);
                            tblInvoice.disable();
                            tblInvoice.showProgress();
                            ui.disable();
                            // xem user có tích checkbox ký HSM không?
                            var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                            webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                if (resultscheckSigHSM[0].json() == "C") {
                                    // ký HSM
                                    var postData = {
                                        branch_code: user.getDvcsID(),
                                        username: user.getCurrentUser(),
                                        lsthdon_id: lsthdon_id,
                                        type_cmd: 206,
                                    };

                                    if (!checkGuiCQT) {
                                        postData.guiCQT = "NotSend";
                                    }

                                    var url = app.config.host + "/Invoice68/SignListInvoiceCertFile_MTT_HSM";

                                    webix
                                        .ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(url, postData, function (text) {
                                            var res = JSON.parse(text);

                                            if (res.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: res.error });
                                            } else {
                                                webix.message("Đã thực hiện xong");

                                                tblInvoice.enable();
                                                ui.enable();
                                                tblInvoice.hideProgress();
                                                var table = webix.$$("invoiceViews");
                                                table.clearAll();
                                                table.load(table.config.url);
                                                return;
                                            }
                                            //SignMTTToKenHSM(lsthdon_id,true,false);
                                        });
                                } else {
                                    excuteHdPlugin(0);
                                }
                            });
                        }
                    });
                });
            tableHdon.enable();
            ui.enable();
            tableHdon.hideProgress()
        },
        ExcuteChungTu: function (lsthdon_id, checkGuiCQT, tagSign) {
            if (tagSign == undefined) tagSign = "TCTTNhap";
            var tableHdon = webix.$$("invoiceViews");
            var ui = tableHdon.getTopParentView();
            var isCompleted = false;
            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                    var result = JSON.parse(text);
                    var kytaptrung = "";
                    for (var i = 0; i < result.length; i++) {
                        var item = result[i];
                        kytaptrung = item.value;
                    }

                    webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                        var listcerts = JSON.parse(text);
                        if (listcerts.length > 0) {
                            var box = webix.modalbox({
                                title: "Chọn chứng thư số",
                                buttons: ["Nhận", "Hủy bỏ"],
                                text: "<div id='ctnCerts'></div>",
                                top: 100,
                                width: 750,
                                callback: function (result) {
                                    switch (result) {
                                        case "1":
                                            webix.modalbox.hide();
                                            webix.$$('invoiceViews').enable();
                                            webix.$$('invoiceViews').hideProgress();
                                            break;
                                        case "0":
                                            var table = $$("tblCerts");
                                            var data = table.serialize();

                                            var cert = null;

                                            for (var i = 0; i < data.length; i++) {
                                                if (data[i].chon == true) {
                                                    cert = data[i];
                                                    break;
                                                }
                                            }

                                            if (cert == null) {
                                                webix.message("Bạn chưa chọn chứng thư số");
                                                return;
                                            }

                                            var now = new Date();
                                            var begin = new Date(cert.begin_date);
                                            var end = new Date(cert.end_date);
                                            if (now < begin || now > end) {
                                                webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                return;
                                            }
                                            var postData = {
                                                branch_code: user.getDvcsID(),
                                                username: user.getCurrentUser(),
                                                cer_serial: cert.cer_serial,
                                                lsthdon_id: lsthdon_id,
                                                type_cmd: 211,
                                            };

                                            if (!checkGuiCQT) {
                                                postData.guiCQT = "NotSend";
                                            }

                                            webix.extend(tableHdon, webix.ProgressBar);
                                            tableHdon.disable();
                                            ui.disable();
                                            tableHdon.showProgress();

                                            var dataPut = { data: [postData] };
                                            webix
                                                .ajax()
                                                .timeout(180000)
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/Invoice68/SignInvoiceCertFile68", dataPut, function (text) {
                                                    var result = JSON.parse(text);
                                                    var table = webix.$$("invoiceViews");
                                                    table.enable();
                                                    ui.enable();
                                                    table.hideProgress();
                                                    if (result.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: result.error });
                                                        return;
                                                    }

                                                    if (result.ok == true) {
                                                        //    if (result.tthai == "Đã ký") {
                                                        //        webix
                                                        //            .ajax()
                                                        //            .headers({ "Content-type": "application/json" })
                                                        //            .post(
                                                        //                app.config.host + "/System/ExecuteCommand",
                                                        //                {
                                                        //                    command: "CM00025",
                                                        //                    parameter: {},
                                                        //                },
                                                        //                function (text) {
                                                        //                    var json = JSON.parse(text);
                                                        //                    // send email ma = 'AUTO_SEND_EMAIL'
                                                        //                    if (json[0].value == "C") {
                                                        //                        var data = {
                                                        //                            lsthdon_id: lsthdon_id,
                                                        //                            nguoinhan: result.email,
                                                        //                            tieude: "Thông báo xuất hóa đơn điện tử",
                                                        //                        };

                                                        //                        webix
                                                        //                            .ajax()
                                                        //                            .headers({ "Content-type": "application/json" })
                                                        //                            .post(app.config.host + "/Invoice68/AutoSendInvoiceByEmail", data, function (text) {
                                                        //                                var data = JSON.parse(text);

                                                        //                                if (!data.hasOwnProperty("error")) {
                                                        //                                } else {
                                                        //                                    webix.message(data.error, "error");
                                                        //                                }
                                                        //                            });
                                                        //                    }
                                                        //                }
                                                        //            );

                                                        //        // webix.modalbox.hide();
                                                        //    }

                                                        var table = webix.$$("invoiceViews");
                                                        table.clearAll();
                                                        table.load(table.config.url);
                                                        webix.modalbox.hide();
                                                    }
                                                    isCompleted = true;
                                                })
                                                .fail(function (xhr) {
                                                    if (!isCompleted) {
                                                        // Xử lý lỗi khi timeout hoặc lỗi khác xảy ra
                                                        if (xhr.status === 0) {
                                                            webix.message({ type: "error", text: "Hết thời gian yêu cầu chờ ký!" });
                                                        } else {
                                                            webix.message({ type: "error", text: "Lỗi xảy ra: " + xhr.statusText });
                                                        }
                                                        var table = webix.$$("invoiceViews");
                                                        table.enable();
                                                        ui.enable();
                                                        table.hideProgress();
                                                    }
                                                });

                                            return;
                                    }
                                },
                            });

                            var tblMatHang = webix.ui({
                                container: "ctnCerts",
                                id: "tblCerts",
                                view: "datatable",
                                borderless: true,
                                resizeColumn: true,
                                height: 350,
                                columns: [
                                    {
                                        id: "chon",
                                        header: _("CHON"),
                                        width: 65,
                                        checkValue: true,
                                        uncheckValue: false,
                                        template: "{common.checkbox()}",
                                    },
                                    {
                                        id: "cert_type",
                                        header: _("Loại"),
                                        width: 100,
                                    },
                                    {
                                        id: "cer_serial",
                                        header: _("SO_SERIAL"),
                                        width: 150,
                                    },
                                    {
                                        id: "subject_name",
                                        header: _("SUBJECTNAME"),
                                        width: 450,
                                    },
                                    {
                                        id: "begin_date",
                                        header: _("NGAY_BAT_DAU"),
                                        width: 200,
                                    },
                                    {
                                        id: "end_date",
                                        header: _("NGAY_KET_THUC"),
                                        width: 200,
                                    },
                                    {
                                        id: "issuer",
                                        header: _("DONVI"),
                                        width: 450,
                                    },
                                ],
                                url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                            });
                        } else {
                            var tblInvoice = webix.$$("invoiceViews");
                            webix.extend(tblInvoice, webix.ProgressBar);
                            tblInvoice.disable();
                            tblInvoice.showProgress();
                            ui.disable();
                            // xem user có tích checkbox ký HSM không?
                            var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                            webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                if (resultscheckSigHSM[0].json() == "C") {
                                    // ký HSM
                                    var postData = {
                                        branch_code: user.getDvcsID(),
                                        username: user.getCurrentUser(),
                                        lsthdon_id: lsthdon_id,
                                        type_cmd: 211,
                                    };

                                    if (!checkGuiCQT) {
                                        postData.guiCQT = "NotSend";
                                    }

                                    var url = app.config.host + "/Invoice68/SignListInvoiceCertFile_HSM";

                                    webix
                                        .ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(url, postData, function (text) {
                                            var res = JSON.parse(text);

                                            if (res.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: res.error });
                                            } else {
                                                webix.message("Đã thực hiện xong");
                                            }
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        });
                                } else {
                                    function excuteHdPlugin(k) {
                                        if (k < lsthdon_id.length) {
                                            var hdon_id = lsthdon_id[k];
                                            var param_update = {
                                                signing: 1,
                                                hdon_id: hdon_id
                                            }
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                    var json = JSON.parse(text);
                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: json.error });
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();
                                                        var table = webix.$$("invoiceViews");
                                                        table.clearAll();
                                                        table.load(table.config.url);
                                                        return;
                                                    }
                                                });
                                            var a = webix.ajax(app.config.host + "/Invoice68/ExportInvoiceXml?id=" + hdon_id);
                                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                            webix.promise.all([a, b, hdon_id]).then(function (results) {
                                                var json = results[0].json();
                                                var idhoadon = results[2];
                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: idhoadon
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }
                                                if (json.InvoiceXmlData == "") {
                                                    webix.message({ type: "error", text: "Hóa đơn chưa có chi tiết. Vui lòng kiểm tra lại" });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: idhoadon
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }
                                                var listcerts = results[1].json();

                                                if (listcerts.length == 0) {
                                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: idhoadon
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }

                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();
                                                    if (hubconnect.state != 1) {
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                        var param_update = {
                                                            signing: 0,
                                                            hdon_id: idhoadon
                                                        }
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                            });

                                                        return;
                                                    }
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (result) {
                                                        var json = JSON.parse(result);
                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: "error", text: json.error });
                                                            tblInvoice.enable();
                                                            ui.enable();
                                                            tblInvoice.hideProgress();
                                                            var table = webix.$$("invoiceViews");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                            var param_update = {
                                                                signing: 0,
                                                                hdon_id: idhoadon
                                                            }
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                });

                                                            return;
                                                        } else {
                                                            var parameters = {
                                                                xml: json.xml,
                                                                xmlbangke: json.xmlbangke,
                                                                hdon_id: idhoadon,
                                                                // shdon: json.shdon,
                                                                username: user.getCurrentUser(),
                                                                type_cmd: 211,
                                                            };

                                                            if (!checkGuiCQT) {
                                                                parameters.guiCQT = "NotSend";
                                                            }

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXml", parameters, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    var param_update = {
                                                                        signing: 0,
                                                                        hdon_id: idhoadon
                                                                    }
                                                                    webix
                                                                        .ajax()
                                                                        .headers({ "Content-Type": "application/json" })
                                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                        });

                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        //var table = webix.$$("invoiceViews");
                                                                        //table.clearAll();
                                                                        //table.load(table.config.url);
                                                                    }
                                                                    k++;
                                                                    excuteHdPlugin(k);
                                                                });
                                                        }
                                                        //tblInvoice.enable();
                                                        //tblInvoice.hideProgress();
                                                    });

                                                    var _listcerts = [];

                                                    for (var i = 0; i < listcerts.length; i++) {
                                                        var _cert = listcerts[i];

                                                        _listcerts.push({
                                                            so_serial: _cert.cer_serial,
                                                            ngaybatdau: _cert.begin_date,
                                                            ngayketthuc: _cert.end_date,
                                                            issuer: _cert.issuer,
                                                            subjectname: _cert.subject_name,
                                                        });
                                                    }

                                                    var arg = {
                                                        idData: "#data",
                                                        xml: json["InvoiceXmlData"],
                                                        xmlbangke: json["InvoiceXmlBangKe"],
                                                        shdon: json["shdon"],
                                                        idSigner: "seller",
                                                        tagSign: tagSign,
                                                        dvky: json["dvky"],
                                                        dateKy: json["dateKy"],
                                                        listcerts: _listcerts,
                                                    };

                                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success !");
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                        });
                                                });
                                            });
                                        } else {
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    }
                                    excuteHdPlugin(0);
                                }
                            });
                        }
                    });
                });
        },
        TongHopHoaDonMTT: function (lsthdon_id, tagSign) {
            var checkGuiCQT = true;
            var tableHdon = webix.$$("invoiceViews");
            var ui = tableHdon.getTopParentView();
            webix.extend(tableHdon, webix.ProgressBar);
            tableHdon.disable();
            tableHdon.showProgress();
            var postData = {
                editmode: 1,
                data: [
                    {
                        details: $.map(lsthdon_id, function (item) {
                            return { hdon_id: item };
                        })
                    }
                ]
            }
            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .post(app.config.host + "/Invoice68/SaveTongHopMTT", postData, {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(text + XmlHttpRequest, "error");
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var json = JSON.parse(text);
                        if (!json.hasOwnProperty("error")) {
                            var id = json["id"];

                            webix
                                .ajax()
                                .headers({ "Content-Type": "application/json" })
                                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                    var result = JSON.parse(text);
                                    var kytaptrung = "";
                                    for (var i = 0; i < result.length; i++) {
                                        var item = result[i];
                                        kytaptrung = item.value;
                                    }

                                    webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                        var listcerts = JSON.parse(text);
                                        if (listcerts.length > 0) {
                                            var box = webix.modalbox({
                                                title: "Chọn chứng thư số",
                                                buttons: ["Nhận", "Hủy bỏ"],
                                                text: "<div id='ctnCerts'></div>",
                                                top: 100,
                                                width: 750,
                                                callback: function (result) {
                                                    switch (result) {
                                                        case "1":
                                                            webix.modalbox.hide();
                                                            webix.$$('invoiceViews').enable();
                                                            webix.$$('invoiceViews').hideProgress();
                                                            break;
                                                        case "0":
                                                            var table = $$("tblCerts");
                                                            var data = table.serialize();

                                                            var cert = null;

                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i].chon == true) {
                                                                    cert = data[i];
                                                                    break;
                                                                }
                                                            }

                                                            if (cert == null) {
                                                                webix.message("Bạn chưa chọn chứng thư số");
                                                                return;
                                                            }

                                                            var now = new Date();
                                                            var begin = new Date(cert.begin_date);
                                                            var end = new Date(cert.end_date);
                                                            if (now < begin || now > end) {
                                                                webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                return;
                                                            }

                                                            var postDataMTT = {
                                                                branch_code: user.getDvcsID(),
                                                                username: user.getCurrentUser(),
                                                                cer_serial: cert.cer_serial,
                                                                id: id,
                                                            };

                                                            webix.extend(tableHdon, webix.ProgressBar);
                                                            tableHdon.disable();
                                                            ui.disable();
                                                            tableHdon.showProgress();

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SignTongHopMTT", postDataMTT, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    var table = webix.$$("invoiceViews");
                                                                    table.enable();
                                                                    ui.enable();
                                                                    table.hideProgress();
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message({ type: "error", text: result.error });
                                                                        return;
                                                                    }
                                                                });
                                                            return;
                                                    }
                                                },
                                            });

                                            var tblMatHang = webix.ui({
                                                container: "ctnCerts",
                                                id: "tblCerts",
                                                view: "datatable",
                                                borderless: true,
                                                resizeColumn: true,
                                                height: 350,
                                                columns: [
                                                    {
                                                        id: "chon",
                                                        header: _("CHON"),
                                                        width: 65,
                                                        checkValue: true,
                                                        uncheckValue: false,
                                                        template: "{common.checkbox()}",
                                                    },
                                                    {
                                                        id: "cert_type",
                                                        header: _("Loại"),
                                                        width: 100,
                                                    },
                                                    {
                                                        id: "cer_serial",
                                                        header: _("SO_SERIAL"),
                                                        width: 150,
                                                    },
                                                    {
                                                        id: "subject_name",
                                                        header: _("SUBJECTNAME"),
                                                        width: 450,
                                                    },
                                                    {
                                                        id: "begin_date",
                                                        header: _("NGAY_BAT_DAU"),
                                                        width: 200,
                                                    },
                                                    {
                                                        id: "end_date",
                                                        header: _("NGAY_KET_THUC"),
                                                        width: 200,
                                                    },
                                                    {
                                                        id: "issuer",
                                                        header: _("DONVI"),
                                                        width: 450,
                                                    },
                                                ],
                                                url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                            });
                                        } else {
                                            var tblInvoice = webix.$$("invoiceViews");
                                            webix.extend(tblInvoice, webix.ProgressBar);
                                            tblInvoice.disable();
                                            tblInvoice.showProgress();
                                            ui.disable();
                                            // xem user có tích checkbox ký HSM không?
                                            var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                            webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                                if (resultscheckSigHSM[0].json() == "C") {
                                                    // ký HSM
                                                    var postData = {
                                                        branch_code: user.getDvcsID(),
                                                        username: user.getCurrentUser(),
                                                        id: id,
                                                        type_cmd: 206,
                                                        CheckHSM: resultscheckSigHSM[0].json()
                                                    };

                                                    if (!checkGuiCQT) {
                                                        postData.guiCQT = "NotSend";
                                                    }

                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/Invoice68/SignTongHopMTT_HSM", postData, function (text) {
                                                            var res = JSON.parse(text);

                                                            if (res.hasOwnProperty("error")) {
                                                                webix.message({ type: "error", text: res.error });
                                                            } else {
                                                                webix.message("Đã thực hiện xong");

                                                                tblInvoice.enable();
                                                                ui.enable();
                                                                tblInvoice.hideProgress();
                                                                tblInvoice.clearAll();
                                                                tblInvoice.load(tblInvoice.config.url);
                                                                return;
                                                            }
                                                        });

                                                } else {
                                                    var a = webix.ajax(app.config.host + "/Invoice68/XmlTongHopMTT?id=" + id);
                                                    var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                    webix.promise.all([a, b]).then(function (results) {
                                                        var json = results[0].json();
                                                        var idhoadon = results[2];
                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: "error", text: json.error });
                                                            tblInvoice.enable();
                                                            ui.enable();
                                                            tblInvoice.hideProgress();
                                                            var table = webix.$$("invoiceViews");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                            return;
                                                        }
                                                        if (json.InvoiceXmlData == "") {
                                                            webix.message({
                                                                type: "error",
                                                                text: "Hóa đơn chưa có chi tiết. Vui lòng kiểm tra lại"
                                                            });
                                                            tblInvoice.enable();
                                                            ui.enable();
                                                            tblInvoice.hideProgress();
                                                            var table = webix.$$("invoiceViews");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                            return;
                                                        }
                                                        var listcerts = results[1].json();

                                                        if (listcerts.length == 0) {
                                                            webix.message({
                                                                type: "error",
                                                                text: "Bạn chưa được phân quyền chứng thư số"
                                                            });
                                                            tblInvoice.enable();
                                                            ui.enable();
                                                            tblInvoice.hideProgress();
                                                            var table = webix.$$("invoiceViews");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                            return;
                                                        }

                                                        require(["views/modules/minvoiceplugin"], function (plugin) {
                                                            var hub = plugin.hub();
                                                            var hubconnect = plugin.conn();
                                                            if (hubconnect.state != 1) {
                                                                tblInvoice.enable();
                                                                ui.enable();
                                                                tblInvoice.hideProgress();
                                                                webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                return;
                                                            }
                                                            hub.off("resCommand");
                                                            hub.on("resCommand", function (result) {
                                                                var json = JSON.parse(result);
                                                                if (json.hasOwnProperty("error")) {
                                                                    webix.message({
                                                                        type: "error",
                                                                        text: json.error
                                                                    });
                                                                    tblInvoice.enable();
                                                                    ui.enable();
                                                                    tblInvoice.hideProgress();
                                                                    var table = webix.$$("invoiceViews");
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                    return;
                                                                } else {
                                                                    var parameters = {
                                                                        xml: json.xml,
                                                                        id: id
                                                                        // shdon: json.shdon,
                                                                    };

                                                                    webix
                                                                        .ajax()
                                                                        .headers({ "Content-Type": "application/json" })
                                                                        .post(app.config.host + "/Invoice68/SaveXmlTongHopMTT", parameters, function (text) {
                                                                            var result = JSON.parse(text);
                                                                            if (result.hasOwnProperty("error")) {
                                                                                webix.message(result.error, "error");
                                                                            } else {
                                                                                //var table = webix.$$("invoiceViews");
                                                                                //table.clearAll();
                                                                                //table.load(table.config.url);
                                                                            }
                                                                            var table = webix.$$("invoiceViews");
                                                                            table.enable();
                                                                            ui.enable();
                                                                            table.hideProgress();
                                                                            table.clearAll();
                                                                            table.load(table.config.url);
                                                                        });
                                                                }
                                                                //tblInvoice.enable();
                                                                //tblInvoice.hideProgress();
                                                            });

                                                            var _listcerts = [];

                                                            for (var i = 0; i < listcerts.length; i++) {
                                                                var _cert = listcerts[i];

                                                                _listcerts.push({
                                                                    so_serial: _cert.cer_serial,
                                                                    ngaybatdau: _cert.begin_date,
                                                                    ngayketthuc: _cert.end_date,
                                                                    issuer: _cert.issuer,
                                                                    subjectname: _cert.subject_name,
                                                                });
                                                            }

                                                            var arg = {
                                                                idData: json["signid"],
                                                                xml: json["InvoiceXmlData"],
                                                                idSigner: json["seller"],
                                                                tagSign: json["signingTag"],
                                                                dvky: json["dvky"],
                                                                dateKy: json["dateKy"],
                                                                shdon: 0,
                                                                listcerts: _listcerts,
                                                            };

                                                            hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                .done(function () {
                                                                    console.log("Success !");
                                                                })
                                                                .fail(function (error) {
                                                                    webix.message(error, "error");
                                                                });
                                                        });
                                                    });
                                                }
                                            });
                                        }
                                    });
                                });
                        } else {
                            webix.message(json.error, "error");
                            tableHdon.enable();
                            ui.enable();
                            tableHdon.hideProgress();
                            tableHdon.clearAll();
                            tableHdon.load(tableHdon.config.url);
                        }
                    },

                });

            tableHdon.enable();
            ui.enable();
            tableHdon.hideProgress();
        },
        KyTongHopXml: function (ids) {
            var checkGuiCQT = true;
            var tblInvoice = webix.$$("bangtonghop");
            var ui = tblInvoice.getTopParentView();
            // webix.extend(tblInvoice, webix.ProgressBar);
            // tblInvoice.disable();
            // tblInvoice.showProgress();
            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                    var result = JSON.parse(text);
                    var kytaptrung = "";
                    for (var i = 0; i < result.length; i++) {
                        var item = result[i];
                        kytaptrung = item.value;
                    }

                    webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                        var listcerts = JSON.parse(text);
                        if (listcerts.length > 0) {
                            var box = webix.modalbox({
                                title: "Chọn chứng thư số",
                                buttons: ["Nhận", "Hủy bỏ"],
                                text: "<div id='ctnCerts'></div>",
                                top: 100,
                                width: 750,
                                callback: function (result) {
                                    switch (result) {
                                        case "1":
                                            webix.modalbox.hide();
                                            webix.$$('bangtonghop').enable();
                                            webix.$$('bangtonghop').hideProgress();
                                            break;
                                        case "0":
                                            var table = $$("tblCerts");
                                            var data = table.serialize();

                                            var cert = null;

                                            for (var i = 0; i < data.length; i++) {
                                                if (data[i].chon == true) {
                                                    cert = data[i];
                                                    break;
                                                }
                                            }

                                            if (cert == null) {
                                                webix.message("Bạn chưa chọn chứng thư số");
                                                return;
                                            }

                                            var now = new Date();
                                            var begin = new Date(cert.begin_date);
                                            var end = new Date(cert.end_date);
                                            if (now < begin || now > end) {
                                                webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                return;
                                            }

                                            ids.forEach(function (id) {
                                                var postDataMTT = {
                                                    branch_code: user.getDvcsID(),
                                                    username: user.getCurrentUser(),
                                                    cer_serial: cert.cer_serial,
                                                    id: id,
                                                };

                                                webix.extend(tblInvoice, webix.ProgressBar);
                                                tblInvoice.disable();
                                                ui.disable();
                                                tblInvoice.showProgress();

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/SignTongHopMTT", postDataMTT, function (text) {
                                                        var result = JSON.parse(text);
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();

                                                        var table = webix.$$("bangtonghop");
                                                        table.clearAll();
                                                        table.load(table.config.url);
                                                        if (result.hasOwnProperty("error")) {
                                                            webix.message({ type: "error", text: result.error });
                                                            return;
                                                        }
                                                    });
                                            })
                                            return;
                                    }
                                },
                            });

                            var tblMatHang = webix.ui({
                                container: "ctnCerts",
                                id: "tblCerts",
                                view: "datatable",
                                borderless: true,
                                resizeColumn: true,
                                height: 350,
                                columns: [
                                    {
                                        id: "chon",
                                        header: _("CHON"),
                                        width: 65,
                                        checkValue: true,
                                        uncheckValue: false,
                                        template: "{common.checkbox()}",
                                    },
                                    {
                                        id: "cert_type",
                                        header: _("Loại"),
                                        width: 100,
                                    },
                                    {
                                        id: "cer_serial",
                                        header: _("SO_SERIAL"),
                                        width: 150,
                                    },
                                    {
                                        id: "subject_name",
                                        header: _("SUBJECTNAME"),
                                        width: 450,
                                    },
                                    {
                                        id: "begin_date",
                                        header: _("NGAY_BAT_DAU"),
                                        width: 200,
                                    },
                                    {
                                        id: "end_date",
                                        header: _("NGAY_KET_THUC"),
                                        width: 200,
                                    },
                                    {
                                        id: "issuer",
                                        header: _("DONVI"),
                                        width: 450,
                                    },
                                ],
                                url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                            });
                        } else {
                            webix.extend(tblInvoice, webix.ProgressBar);
                            tblInvoice.disable();
                            ui.disable();
                            tblInvoice.showProgress();

                            // xem user có tích checkbox ký HSM không?
                            var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                            webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                if (resultscheckSigHSM[0].json() == "C") {
                                    // ký HSM
                                    ids.forEach(function (id) {
                                        var postData = {
                                            branch_code: user.getDvcsID(),
                                            username: user.getCurrentUser(),
                                            id: id,
                                            type_cmd: 206,
                                            CheckHSM: resultscheckSigHSM[0].json()
                                        };

                                        if (!checkGuiCQT) postData.guiCQT = "NotSend";

                                        webix
                                            .ajax()
                                            .headers({ "Content-Type": "application/json" })
                                            .post(app.config.host + "/Invoice68/SignTongHopMTT_HSM", postData, function (text) {
                                                var res = JSON.parse(text);

                                                if (res.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: res.error });
                                                } else {
                                                    webix.message("Đã thực hiện xong");
                                                }
                                                tblInvoice.enable();
                                                ui.enable();
                                                tblInvoice.hideProgress();

                                                var table = webix.$$("bangtonghop");
                                                table.clearAll();
                                                table.load(table.config.url);
                                            });
                                    })

                                } else {
                                    function excuteHdPluginMTT(k) {
                                        if (k < ids.length) {
                                            var id = ids[k];
                                            var param_update = {
                                                signing: 1,
                                                hdon_id: id
                                            }
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                    var json = JSON.parse(text);
                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: json.error });
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();
                                                        var table = webix.$$("bangtonghop");
                                                        table.clearAll();
                                                        table.load(table.config.url);
                                                        return;
                                                    }
                                                });
                                            var a = webix.ajax(app.config.host + "/Invoice68/XmlTongHopMTT?id=" + id);
                                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                            webix.promise.all([a, b, id]).then(function (results) {
                                                var json = results[0].json();
                                                var idhoadon = results[2];
                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();

                                                    var table = webix.$$("bangtonghop");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: id
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }
                                                if (json.InvoiceXmlData == "") {
                                                    webix.message({
                                                        type: "error",
                                                        text: "Hóa đơn chưa có chi tiết. Vui lòng kiểm tra lại"
                                                    });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();

                                                    var table = webix.$$("bangtonghop");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: id
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }
                                                var listcerts = results[1].json();

                                                if (listcerts.length == 0) {
                                                    webix.message({
                                                        type: "error",
                                                        text: "Bạn chưa được phân quyền chứng thư số"
                                                    });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();

                                                    var table = webix.$$("bangtonghop");
                                                    table.clearAll();
                                                    table.load(tblInvoice.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: id
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }

                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();
                                                    if (hubconnect.state != 1) {
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                        var param_update = {
                                                            signing: 0,
                                                            hdon_id: id
                                                        }
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                            });

                                                        return;
                                                    }
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (result) {
                                                        var json = JSON.parse(result);
                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({
                                                                type: "error",
                                                                text: json.error
                                                            });
                                                            tblInvoice.enable();
                                                            ui.enable();
                                                            tblInvoice.hideProgress();

                                                            var table = webix.$$("bangtonghop");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                            var param_update = {
                                                                signing: 0,
                                                                hdon_id: id
                                                            }
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                });

                                                            return;
                                                        } else {
                                                            var parameters = {
                                                                xml: json.xml,
                                                                id: id
                                                                // shdon: json.shdon,
                                                            };

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlTongHopMTT", parameters, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    var param_update = {
                                                                        signing: 0,
                                                                        hdon_id: id
                                                                    }
                                                                    webix
                                                                        .ajax()
                                                                        .headers({ "Content-Type": "application/json" })
                                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                        });

                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        //var table = webix.$$("invoiceViews");
                                                                        //table.clearAll();
                                                                        //table.load(table.config.url);
                                                                    }
                                                                    k++;
                                                                    excuteHdPluginMTT(k);
                                                                });
                                                        }
                                                        //tblInvoice.enable();
                                                        //tblInvoice.hideProgress();
                                                    });

                                                    var _listcerts = [];

                                                    for (var i = 0; i < listcerts.length; i++) {
                                                        var _cert = listcerts[i];

                                                        _listcerts.push({
                                                            so_serial: _cert.cer_serial,
                                                            ngaybatdau: _cert.begin_date,
                                                            ngayketthuc: _cert.end_date,
                                                            issuer: _cert.issuer,
                                                            subjectname: _cert.subject_name,
                                                        });
                                                    }

                                                    var arg = {
                                                        idData: json["signid"],
                                                        xml: json["InvoiceXmlData"],
                                                        idSigner: json["seller"],
                                                        tagSign: json["signingTag"],
                                                        dvky: json["dvky"],
                                                        dateKy: json["dateKy"],
                                                        shdon: 0,
                                                        listcerts: _listcerts,
                                                    };

                                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success !");
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                            tblInvoice.enable();
                                                            ui.enable();
                                                            tblInvoice.hideProgress();

                                                            var table = webix.$$("bangtonghop");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                        });
                                                });
                                            });
                                        } else {
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("bangtonghop");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    }
                                    excuteHdPluginMTT(0);
                                }
                            });
                        }
                    });
                });

            // tblInvoice.enable();
            // ui.enable();
            // tblInvoice.hideProgress();    
        },
        KyBienBanThoaThuan: function (ids) {
            var checkGuiCQT = true;
            var tblInvoice = webix.$$("bienbanthoathuan");
            var ui = tblInvoice.getTopParentView();
            // webix.extend(tblInvoice, webix.ProgressBar);
            // tblInvoice.disable();
            // tblInvoice.showProgress();
            debugger
            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                    var result = JSON.parse(text);
                    var kytaptrung = "";
                    for (var i = 0; i < result.length; i++) {
                        var item = result[i];
                        kytaptrung = item.value;
                    }

                    webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                        var listcerts = JSON.parse(text);
                        if (listcerts.length > 0) {
                            var box = webix.modalbox({
                                title: "Chọn chứng thư số",
                                buttons: ["Nhận", "Hủy bỏ"],
                                text: "<div id='ctnCerts'></div>",
                                top: 100,
                                width: 750,
                                callback: function (result) {
                                    switch (result) {
                                        case "1":
                                            webix.modalbox.hide();
                                            webix.$$('bienbanthoathuan').enable();
                                            webix.$$('bienbanthoathuan').hideProgress();
                                            break;
                                        case "0":
                                            var table = $$("tblCerts");
                                            var data = table.serialize();

                                            var cert = null;

                                            for (var i = 0; i < data.length; i++) {
                                                if (data[i].chon == true) {
                                                    cert = data[i];
                                                    break;
                                                }
                                            }

                                            if (cert == null) {
                                                webix.message("Bạn chưa chọn chứng thư số");
                                                return;
                                            }

                                            var now = new Date();
                                            var begin = new Date(cert.begin_date);
                                            var end = new Date(cert.end_date);
                                            if (now < begin || now > end) {
                                                webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                return;
                                            }

                                            var postDataMTT = {
                                                branch_code: user.getDvcsID(),
                                                username: user.getCurrentUser(),
                                                cer_serial: cert.cer_serial,
                                                ids: ids,
                                            };

                                            webix.extend(tblInvoice, webix.ProgressBar);
                                            tblInvoice.disable();
                                            ui.disable();
                                            tblInvoice.showProgress();

                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/Invoice68/SignBienBanThoaThuan", postDataMTT, function (text) {
                                                    var result = JSON.parse(text);
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();

                                                    var table = webix.$$("bienbanthoathuan");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    if (result.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: result.error });
                                                        return;
                                                    }
                                                });
                                            return;
                                    }
                                },
                            });

                            var tblMatHang = webix.ui({
                                container: "ctnCerts",
                                id: "tblCerts",
                                view: "datatable",
                                borderless: true,
                                resizeColumn: true,
                                height: 350,
                                columns: [
                                    {
                                        id: "chon",
                                        header: _("CHON"),
                                        width: 65,
                                        checkValue: true,
                                        uncheckValue: false,
                                        template: "{common.checkbox()}",
                                    },
                                    {
                                        id: "cert_type",
                                        header: _("Loại"),
                                        width: 100,
                                    },
                                    {
                                        id: "cer_serial",
                                        header: _("SO_SERIAL"),
                                        width: 150,
                                    },
                                    {
                                        id: "subject_name",
                                        header: _("SUBJECTNAME"),
                                        width: 450,
                                    },
                                    {
                                        id: "begin_date",
                                        header: _("NGAY_BAT_DAU"),
                                        width: 200,
                                    },
                                    {
                                        id: "end_date",
                                        header: _("NGAY_KET_THUC"),
                                        width: 200,
                                    },
                                    {
                                        id: "issuer",
                                        header: _("DONVI"),
                                        width: 450,
                                    },
                                ],
                                url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                            });
                        } else {
                            webix.extend(tblInvoice, webix.ProgressBar);
                            tblInvoice.disable();
                            ui.disable();
                            tblInvoice.showProgress();

                            // xem user có tích checkbox ký HSM không?
                            var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                            webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                if (resultscheckSigHSM[0].json() == "C") {
                                    // ký HSM
                                    var postData = {
                                        branch_code: user.getDvcsID(),
                                        username: user.getCurrentUser(),
                                        ids: ids,
                                        check_HSM: resultscheckSigHSM[0].json()
                                    };

                                    if (!checkGuiCQT) postData.guiCQT = "NotSend";

                                    webix
                                        .ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(app.config.host + "/Invoice68/SignBienBanThoaThuan", postData, function (text) {
                                            var res = JSON.parse(text);

                                            if (res.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: res.error });
                                            } else {
                                                webix.message("Đã thực hiện xong");
                                            }
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();

                                            var table = webix.$$("bienbanthoathuan");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        });

                                } else {
                                    function excuteHdPluginBienBan(k) {
                                        if (k < ids.length) {
                                            var id = ids[k];
                                            var param_update = {
                                                signing: 1,
                                                hdon_id: id
                                            }
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                    var json = JSON.parse(text);
                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: json.error });
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();
                                                        var table = webix.$$("bienbanthoathuan");
                                                        table.clearAll();
                                                        table.load(table.config.url);
                                                        return;
                                                    }
                                                });
                                            var a = webix.ajax(app.config.host + "/Invoice68/XmlBienBanThoaThuan?id=" + id);
                                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                            webix.promise.all([a, b, id]).then(function (results) {
                                                var json = results[0].json();
                                                var idhoadon = results[2];
                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();

                                                    var table = webix.$$("bienbanthoathuan");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: id
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }
                                                if (json.InvoiceXmlData == "") {
                                                    webix.message({
                                                        type: "error",
                                                        text: "Hóa đơn chưa có chi tiết. Vui lòng kiểm tra lại"
                                                    });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();

                                                    var table = webix.$$("bienbanthoathuan");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: id
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }
                                                var listcerts = results[1].json();

                                                if (listcerts.length == 0) {
                                                    webix.message({
                                                        type: "error",
                                                        text: "Bạn chưa được phân quyền chứng thư số"
                                                    });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();

                                                    var table = webix.$$("bienbanthoathuan");
                                                    table.clearAll();
                                                    table.load(tblInvoice.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: id
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }

                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();
                                                    if (hubconnect.state != 1) {
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                        var param_update = {
                                                            signing: 0,
                                                            hdon_id: id
                                                        }
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                            });

                                                        return;
                                                    }
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (result) {
                                                        var json = JSON.parse(result);
                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({
                                                                type: "error",
                                                                text: json.error
                                                            });
                                                            tblInvoice.enable();
                                                            ui.enable();
                                                            tblInvoice.hideProgress();

                                                            var table = webix.$$("bienbanthoathuan");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                            var param_update = {
                                                                signing: 0,
                                                                hdon_id: id
                                                            }
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                });

                                                            return;
                                                        } else {
                                                            var parameters = {
                                                                xml: json.xml,
                                                                id: id,
                                                                trang_thai: 1,
                                                                username: user.getCurrentUser(),
                                                                // shdon: json.shdon,
                                                            };

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlBienBan", parameters, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    var param_update = {
                                                                        signing: 0,
                                                                        hdon_id: id
                                                                    }
                                                                    webix
                                                                        .ajax()
                                                                        .headers({ "Content-Type": "application/json" })
                                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                        });

                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                        webix.message("Ký file thành công!");
                                                                    } else {
                                                                        //var table = webix.$$("invoiceViews");
                                                                        //table.clearAll();
                                                                        //table.load(table.config.url);
                                                                    }
                                                                    k++;
                                                                    excuteHdPluginBienBan(k);
                                                                });
                                                        }
                                                        //tblInvoice.enable();
                                                        //tblInvoice.hideProgress();
                                                    });

                                                    var _listcerts = [];

                                                    for (var i = 0; i < listcerts.length; i++) {
                                                        var _cert = listcerts[i];

                                                        _listcerts.push({
                                                            so_serial: _cert.cer_serial,
                                                            ngaybatdau: _cert.begin_date,
                                                            ngayketthuc: _cert.end_date,
                                                            issuer: _cert.issuer,
                                                            subjectname: _cert.subject_name,
                                                        });
                                                    }

                                                    var arg = {
                                                        idData: "#data",
                                                        xml: json["xml"],
                                                        idSigner: "seller",
                                                        tagSign: "NBan",
                                                        dvky: user.getDvcsID(),
                                                        dateKy: json["dateKy"],
                                                        shdon: 0,
                                                        listcerts: _listcerts,
                                                    };

                                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success !");
                                                            //
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                            tblInvoice.enable();
                                                            ui.enable();
                                                            tblInvoice.hideProgress();

                                                            var table = webix.$$("bienbanthoathuan");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                        });
                                                });
                                            });
                                        } else {
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("bienbanthoathuan");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    }
                                    excuteHdPluginBienBan(0);
                                }
                            });
                        }
                    });
                });

            // tblInvoice.enable();
            // ui.enable();
            // tblInvoice.hideProgress();    
        },
        KyBienBanThoaThuan_BenMua: function (id, otp) {
            debugger
            var tblInvoice = webix.$$("signbienban");
            var ui = tblInvoice.getTopParentView();
            webix.extend(tblInvoice, webix.ProgressBar);
            tblInvoice.disable();
            tblInvoice.showProgress();
            var postData = {
                otp: otp,
                id: id,
            };
            var a = webix.ajax().headers({ "Content-Type": "application/json" })
                .post(app.config.host + "/BienBan/XmlBienBanThoaThuan", postData);

            webix.promise.all([a, id]).then(function (results) {
                var json = results[0].json();
                if (json.hasOwnProperty("error")) {
                    webix.message({ type: "error", text: json.error });
                    tblInvoice.enable();
                    ui.enable();
                    tblInvoice.hideProgress();

                    /*var table = webix.$$("signbienban");
                    table.clearAll();
                    table.load(table.config.url);*/
                    return;
                }

                if (json.InvoiceXmlData == "") {
                    webix.message({
                        type: "error",
                        text: "Hóa đơn chưa có chi tiết. Vui lòng kiểm tra lại"
                    });
                    tblInvoice.enable();
                    ui.enable();
                    tblInvoice.hideProgress();

                    /*var table = webix.$$("signbienban");
                    table.clearAll();
                    table.load(table.config.url);*/
                    return;
                }

                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString(json.xml, "application/xml");
                var DSCKS = xmlDoc.getElementsByTagName("DSCKS")[0];
                var nmua = DSCKS.getElementsByTagName("NMua")[0];

                var sigCount = nmua.getElementsByTagName("Signature").length;

                if (sigCount > 0) {
                    webix.message("Biên bản đã được ký!", "error");
                    return;
                }

                require(["views/modules/minvoiceplugin"], function (plugin) {
                    var hub = plugin.hub();
                    var hubconnect = plugin.conn();

                    setTimeout(function () {
                        if (!hubconnect || hubconnect.state !== 1) {
                            tblInvoice.enable();
                            ui.enable();
                            tblInvoice.hideProgress();
                            webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin chưa được bật!", "error");
                            return;
                        }

                        hub.off("resCommand");
                        hub.on("resCommand", function (result) {
                            var json = JSON.parse(result);
                            if (json.hasOwnProperty("error")) {
                                webix.message({
                                    type: "error",
                                    text: json.error
                                });
                                tblInvoice.enable();
                                ui.enable();
                                tblInvoice.hideProgress();

                                /*var table = webix.$$("signbienban");
                                table.clearAll();
                                table.load(table.config.url);*/
                                return;
                            } else {
                                var parameters = {
                                    xml: json.xml,
                                    id: id,
                                    otp: otp,
                                    trang_thai: 2
                                };

                                webix
                                    .ajax()
                                    .headers({ "Content-Type": "application/json" })
                                    .post(app.config.host + "/BienBan/SaveXmlBienBan", parameters, function (text) {
                                        var result = JSON.parse(text);
                                        if (result.hasOwnProperty("error")) {
                                            webix.message(result.error, "error");
                                        } else {
                                            webix.message("Ký file thành công!");
                                            //var table = webix.$$("invoiceViews");
                                            //table.clearAll();
                                            //table.load(table.config.url);
                                        }
                                    });
                            }
                            //tblInvoice.enable();
                            //tblInvoice.hideProgress();
                        });

                        var arg = {
                            idData: "#data",
                            xml: json["xml"],
                            idSigner: "buyer",
                            tagSign: "NMua",
                            dvky: "",
                            dateKy: json["dateKy"],
                            shdon: 0,
                            //listcerts: _listcerts,
                        };

                        hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                            .done(function () {
                                console.log("Success !");
                            })
                            .fail(function (error) {
                                webix.message(error, "error");
                                tblInvoice.enable();
                                ui.enable();
                                tblInvoice.hideProgress();

                                /*var table = webix.$$("signbienban");
                                table.clearAll();
                                table.load(table.config.url);*/
                            });
                    }, 100);
                });
            });

            tblInvoice.enable();
            ui.enable();
            tblInvoice.hideProgress();
        },
        ExcuteHoaDonMTT_NotSign: function (lsthdon_id, havesign, checkGuiCQT, checkHasCode, tagSign) {
            if (tagSign == undefined) tagSign = "NBan";
            checkHasCode = checkHasCode || false;
            var tableHdon = webix.$$("invoiceViews");
            var ui = tableHdon.getTopParentView();
            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                    var result = JSON.parse(text);
                    var kytaptrung = "";
                    for (var i = 0; i < result.length; i++) {
                        var item = result[i];
                        kytaptrung = item.value;
                    }

                    webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                        var listcerts = JSON.parse(text);
                        if (listcerts.length > 0) {
                            var box = webix.modalbox({
                                title: "Chọn chứng thư số",
                                buttons: ["Nhận", "Hủy bỏ"],
                                text: "<div id='ctnCerts'></div>",
                                top: 100,
                                width: 750,
                                callback: function (result) {
                                    switch (result) {
                                        case "1":
                                            webix.modalbox.hide();
                                            webix.$$('invoiceViews').enable();
                                            webix.$$('invoiceViews').hideProgress();
                                            break;
                                        case "0":
                                            var table = $$("tblCerts");
                                            var data = table.serialize();

                                            var cert = null;

                                            for (var i = 0; i < data.length; i++) {
                                                if (data[i].chon == true) {
                                                    cert = data[i];
                                                    break;
                                                }
                                            }

                                            if (cert == null) {
                                                webix.message("Bạn chưa chọn chứng thư số");
                                                return;
                                            }

                                            var now = new Date();
                                            var begin = new Date(cert.begin_date);
                                            var end = new Date(cert.end_date);
                                            if (now < begin || now > end) {
                                                webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                return;
                                            }

                                            var postData = {
                                                cert_serial: cert.cer_serial,
                                                lsthdon_id: lsthdon_id,
                                                type_cmd: '206',
                                                mltdiep: '206',
                                            };

                                            webix.extend(tableHdon, webix.ProgressBar);
                                            tableHdon.disable();
                                            ui.disable();
                                            tableHdon.showProgress();

                                            var dataPut = { data: [postData] };
                                            webix
                                                .ajax()
                                                .headers({
                                                    "Content-type": "application/json"
                                                })
                                                .post(app.config.host + "/Invoice68/SendInvoiceToCQT68", postData, function (text) {
                                                    var table = webix.$$("invoiceViews");
                                                    table.enable();
                                                    ui.enable();
                                                    table.hideProgress();
                                                    var res = JSON.parse(text);
                                                    if (res.hasOwnProperty("error")) {
                                                        webix.message({
                                                            type: "error",
                                                            text: res.error
                                                        });
                                                    } else {
                                                        webix.message("Gửi CQT thành công!");
                                                        var table = $$("invoiceViews");
                                                        table.clearAll();
                                                        table.load(table.config.url);
                                                    }
                                                });

                                            return;
                                    }
                                },
                            });

                            var tblMatHang = webix.ui({
                                container: "ctnCerts",
                                id: "tblCerts",
                                view: "datatable",
                                borderless: true,
                                resizeColumn: true,
                                height: 350,
                                columns: [
                                    {
                                        id: "chon",
                                        header: _("CHON"),
                                        width: 65,
                                        checkValue: true,
                                        uncheckValue: false,
                                        template: "{common.checkbox()}",
                                    },
                                    {
                                        id: "cert_type",
                                        header: _("Loại"),
                                        width: 100,
                                    },
                                    {
                                        id: "cer_serial",
                                        header: _("SO_SERIAL"),
                                        width: 150,
                                    },
                                    {
                                        id: "subject_name",
                                        header: _("SUBJECTNAME"),
                                        width: 450,
                                    },
                                    {
                                        id: "begin_date",
                                        header: _("NGAY_BAT_DAU"),
                                        width: 200,
                                    },
                                    {
                                        id: "end_date",
                                        header: _("NGAY_KET_THUC"),
                                        width: 200,
                                    },
                                    {
                                        id: "issuer",
                                        header: _("DONVI"),
                                        width: 450,
                                    },
                                ],
                                url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                            });
                        } else {
                            var tblInvoice = webix.$$("invoiceViews");
                            webix.extend(tblInvoice, webix.ProgressBar);
                            tblInvoice.disable();
                            tblInvoice.showProgress();
                            ui.disable();
                            // xem user có tích checkbox ký HSM không?
                            var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                            webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                if (resultscheckSigHSM[0].json() == "C") {
                                    // ký HSM
                                    var postData = {
                                        lsthdon_id: lsthdon_id,
                                        type_cmd: '206',
                                        mltdiep: '206',
                                    };

                                    var url = app.config.host + "/Invoice68/SendInvoiceToCQT68";

                                    webix
                                        .ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(url, postData, function (text) {
                                            var res = JSON.parse(text);

                                            if (res.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: res.error });
                                            } else {
                                                webix.message("Đã thực hiện xong");
                                            }
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        });
                                } else {
                                    function excuteHdPluginMTT(k) {
                                        if (k < lsthdon_id.length) {
                                            var hdon_id = lsthdon_id[k];
                                            var param_update = {
                                                signing: 1,
                                                hdon_id: hdon_id
                                            }
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                    var json = JSON.parse(text);
                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: json.error });
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();
                                                        var table = webix.$$("invoiceViews");
                                                        table.clearAll();
                                                        table.load(table.config.url);
                                                        return;
                                                    }
                                                });
                                            var a = webix.ajax(app.config.host + "/Invoice68/ExportInvoiceMTTXml?id=" + hdon_id);
                                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                            webix.promise.all([a, b, hdon_id]).then(function (results) {
                                                var json = results[0].json();
                                                var idhoadon = results[2];
                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: idhoadon
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }
                                                if (json.InvoiceXmlData == "") {
                                                    webix.message({ type: "error", text: "Hóa đơn chưa có chi tiết. Vui lòng kiểm tra lại" });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: idhoadon
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }
                                                var listcerts = results[1].json();

                                                if (listcerts.length == 0) {
                                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: idhoadon
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }

                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();
                                                    if (hubconnect.state != 1) {
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                        var param_update = {
                                                            signing: 0,
                                                            hdon_id: idhoadon
                                                        }
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                var json = JSON.parse(text);
                                                                if (json.hasOwnProperty("error")) {
                                                                    webix.message({ type: "error", text: json.error });
                                                                    tblInvoice.enable();
                                                                    ui.enable();
                                                                    tblInvoice.hideProgress();
                                                                    var table = webix.$$("invoiceViews");
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                    return;
                                                                }
                                                            });

                                                        return;
                                                    }
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (result) {
                                                        var json = JSON.parse(result);
                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: "error", text: json.error });
                                                            tblInvoice.enable();
                                                            ui.enable();
                                                            tblInvoice.hideProgress();
                                                            var table = webix.$$("invoiceViews");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                            var param_update = {
                                                                signing: 0,
                                                                hdon_id: idhoadon
                                                            }
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                });

                                                            return;
                                                        } else {
                                                            var parameters = {
                                                                xml: json.xml,
                                                                xmlbangke: json.xmlbangke,
                                                                hdon_id: idhoadon,
                                                                // shdon: json.shdon,
                                                                username: user.getCurrentUser(),
                                                                type_cmd: '206',
                                                                branch_code: user.getDvcsID()
                                                            };

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlMTT", parameters, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    var param_update = {
                                                                        signing: 0,
                                                                        hdon_id: idhoadon
                                                                    }
                                                                    webix
                                                                        .ajax()
                                                                        .headers({ "Content-Type": "application/json" })
                                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                        });

                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        //var table = webix.$$("invoiceViews");
                                                                        //table.clearAll();
                                                                        //table.load(table.config.url);
                                                                    }
                                                                    k++;
                                                                    excuteHdPluginMTT(k);
                                                                });
                                                        }
                                                        //tblInvoice.enable();
                                                        //tblInvoice.hideProgress();
                                                    });

                                                    var _listcerts = [];

                                                    for (var i = 0; i < listcerts.length; i++) {
                                                        var _cert = listcerts[i];

                                                        _listcerts.push({
                                                            so_serial: _cert.cer_serial,
                                                            ngaybatdau: _cert.begin_date,
                                                            ngayketthuc: _cert.end_date,
                                                            issuer: _cert.issuer,
                                                            subjectname: _cert.subject_name,
                                                        });
                                                    }

                                                    var arg = {
                                                        idData: json["signid"],
                                                        xml: json["InvoiceXmlData"],
                                                        shdon: json["shdon"],
                                                        idSigner: json["seller"],
                                                        tagSign: json["signingTag"],
                                                        dvky: json["dvky"],
                                                        dateKy: json["dateKy"],
                                                        listcerts: _listcerts,
                                                    };

                                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success !");
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                        });
                                                });
                                            });
                                        } else {
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    }
                                    excuteHdPluginMTT(0);
                                }
                            });
                        }
                    });
                });
        },
        ExcuteHoaDonForHasCodeAndNotHaveAnyCode: function (lsthdon_id, checkGuiCQT, checkHasCode, tagSign) {
            if (tagSign == undefined) tagSign = "NBan";
            checkHasCode = checkHasCode || false;
            var tableHdon = webix.$$("invoiceViews");
            var ui = tableHdon.getTopParentView();
            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                    var result = JSON.parse(text);
                    var kytaptrung = "";
                    for (var i = 0; i < result.length; i++) {
                        var item = result[i];
                        kytaptrung = item.value;
                    }

                    webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                        var listcerts = JSON.parse(text);
                        if (listcerts.length > 0) {
                            var box = webix.modalbox({
                                title: "Chọn chứng thư số",
                                buttons: ["Nhận", "Hủy bỏ"],
                                text: "<div id='ctnCerts'></div>",
                                top: 100,
                                width: 750,
                                callback: function (result) {
                                    switch (result) {
                                        case "1":
                                            webix.modalbox.hide();
                                            webix.$$('invoiceViews').enable();
                                            webix.$$('invoiceViews').hideProgress();
                                            break;
                                        case "0":
                                            var table = $$("tblCerts");
                                            var data = table.serialize();

                                            var cert = null;

                                            for (var i = 0; i < data.length; i++) {
                                                if (data[i].chon == true) {
                                                    cert = data[i];
                                                    break;
                                                }
                                            }

                                            if (cert == null) {
                                                webix.message("Bạn chưa chọn chứng thư số");
                                                return;
                                            }


                                            var now = new Date();
                                            var begin = new Date(cert.begin_date);
                                            var end = new Date(cert.end_date);
                                            if (now < begin || now > end) {
                                                webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                return;
                                            }

                                            var now = new Date();
                                            var begin = new Date(cert.begin_date);
                                            var end = new Date(cert.end_date);
                                            if (now < begin || now > end) {
                                                webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                return;
                                            }

                                            var lsCoMa = lsthdon_id[0];
                                            var lsKhongMa = lsthdon_id[1];
                                            var dsHoaDon = lsCoMa.concat(lsKhongMa);
                                            var postData = {
                                                branch_code: user.getDvcsID(),
                                                username: user.getCurrentUser(),
                                                cer_serial: cert.cer_serial,
                                                lsthdon_id: dsHoaDon,
                                            };

                                            if (!checkGuiCQT) {
                                                postData.guiCQT = "NotSend";
                                            }

                                            webix.extend(tableHdon, webix.ProgressBar);
                                            tableHdon.disable();
                                            ui.disable();
                                            tableHdon.showProgress();
                                            var urlApi = "";
                                            urlApi = "/Invoice68/SignInvoiceCertFile68ForHasCodeAndNotHaveAnyCode";
                                            var dataPut = { data: [postData] };
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + urlApi, dataPut, function (text) {
                                                    var result = JSON.parse(text);
                                                    var table = webix.$$("invoiceViews");
                                                    table.enable();
                                                    ui.enable();
                                                    table.hideProgress();
                                                    if (result.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: result.error });
                                                        return;
                                                    }

                                                    if (result.ok == true) {
                                                        webix.message("Đã thực hiện xong");
                                                        var table = webix.$$("invoiceViews");
                                                        table.clearAll();
                                                        table.load(table.config.url);
                                                        webix.modalbox.hide();
                                                    }
                                                });

                                            return;
                                    }
                                },
                            });

                            var tblMatHang = webix.ui({
                                container: "ctnCerts",
                                id: "tblCerts",
                                view: "datatable",
                                borderless: true,
                                resizeColumn: true,
                                height: 350,
                                columns: [
                                    {
                                        id: "chon",
                                        header: _("CHON"),
                                        width: 65,
                                        checkValue: true,
                                        uncheckValue: false,
                                        template: "{common.checkbox()}",
                                    },
                                    {
                                        id: "cert_type",
                                        header: _("Loại"),
                                        width: 100,
                                    },
                                    {
                                        id: "cer_serial",
                                        header: _("SO_SERIAL"),
                                        width: 150,
                                    },
                                    {
                                        id: "subject_name",
                                        header: _("SUBJECTNAME"),
                                        width: 450,
                                    },
                                    {
                                        id: "begin_date",
                                        header: _("NGAY_BAT_DAU"),
                                        width: 200,
                                    },
                                    {
                                        id: "end_date",
                                        header: _("NGAY_KET_THUC"),
                                        width: 200,
                                    },
                                    {
                                        id: "issuer",
                                        header: _("DONVI"),
                                        width: 450,
                                    },
                                ],
                                url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                            });
                        } else {
                            var tblInvoice = webix.$$("invoiceViews");
                            webix.extend(tblInvoice, webix.ProgressBar);
                            tblInvoice.disable();
                            ui.disable();
                            tblInvoice.showProgress();

                            // xem user có tích checkbox ký HSM không?
                            var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                            webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                if (resultscheckSigHSM[0].json() == "C") {
                                    var lsCoMa = lsthdon_id[0];
                                    var lsKhongMa = lsthdon_id[1];
                                    var dsHoaDon = lsCoMa.concat(lsKhongMa);

                                    // ký HSM
                                    var postData = {
                                        branch_code: user.getDvcsID(),
                                        username: user.getCurrentUser(),
                                        lsthdon_id: dsHoaDon,
                                        AllHoaDon: "All",
                                    };

                                    if (!checkGuiCQT) {
                                        postData.guiCQT = "NotSend";
                                    }

                                    var url = app.config.host + "/Invoice68/SignListInvoiceCertFile_HSM";

                                    webix
                                        .ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(url, postData, function (text) {
                                            var res = JSON.parse(text);

                                            if (res.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: res.error });
                                            } else {
                                                webix.message("Đã thực hiện xong");
                                            }
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        });
                                } else {
                                    var lsCoMa = lsthdon_id[0];
                                    var lsKhongMa = lsthdon_id[1];
                                    var dsHoaDonXL = lsCoMa.concat(lsKhongMa);
                                    function excuteHdPlugin(k, dsHoaDon) {
                                        if (k < dsHoaDon.length) {
                                            // debugger;
                                            var hoadon = dsHoaDon[k];
                                            var param_update = {
                                                signing: 1,
                                                hdon_id: hoadon.hdon_id
                                            }
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                    var json = JSON.parse(text);
                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: json.error });
                                                        tblInvoice.enable();
                                                        ui.enable();
                                                        tblInvoice.hideProgress();
                                                        var table = webix.$$("invoiceViews");
                                                        table.clearAll();
                                                        table.load(table.config.url);
                                                        return;
                                                    }
                                                });
                                            var a = webix.ajax(app.config.host + "/Invoice68/ExportInvoiceXml?id=" + hoadon.hdon_id);
                                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                            webix.promise.all([a, b, hoadon]).then(function (results) {
                                                var json = results[0].json();
                                                var item = results[2];

                                                if (item.is_hdcma !== 0 && item.is_hdcma !== 1) {
                                                    webix.message({ type: "error", text: "Kiểm tra lại loại hóa đơn" });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: item.hdon_id
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });

                                                    return;
                                                }

                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: item.hdon_id
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });
                                                    return;
                                                }
                                                if (json.InvoiceXmlData == "") {
                                                    webix.message({ type: "error", text: "Hóa đơn chưa có chi tiết. Vui lòng kiểm tra lại" });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: item.hdon_id
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });
                                                    return;
                                                }
                                                var listcerts = results[1].json();

                                                if (listcerts.length == 0) {
                                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                    tblInvoice.enable();
                                                    ui.enable();
                                                    tblInvoice.hideProgress();
                                                    var table = webix.$$("invoiceViews");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    var param_update = {
                                                        signing: 0,
                                                        hdon_id: item.hdon_id
                                                    }
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                        });
                                                    return;
                                                }

                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();
                                                    if (hubconnect.state != 1) {
                                                        tblInvoice.enable();
                                                        tblInvoice.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                        var param_update = {
                                                            signing: 0,
                                                            hdon_id: item.hdon_id
                                                        }
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                            });
                                                        return;
                                                    }
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (result) {
                                                        var json = JSON.parse(result);
                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: "error", text: json.error });
                                                            tblInvoice.enable();
                                                            ui.enable();
                                                            tblInvoice.hideProgress();
                                                            var table = webix.$$("invoiceViews");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                            return;
                                                        } else {
                                                            var parameters = {
                                                                xml: json.xml,
                                                                xmlbangke: json.xmlbangke,
                                                                hdon_id: item.hdon_id,
                                                                // shdon: json.shdon,
                                                                username: user.getCurrentUser(),
                                                                type_cmd: item.is_hdcma === 1 ? 200 : 203,
                                                            };

                                                            if (!checkGuiCQT) {
                                                                parameters.guiCQT = "NotSend";
                                                            }

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXml", parameters, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    var param_update = {
                                                                        signing: 0,
                                                                        hdon_id: item.hdon_id
                                                                    }
                                                                    webix
                                                                        .ajax()
                                                                        .headers({ "Content-Type": "application/json" })
                                                                        .post(app.config.host + "/System/UpdateSigning", param_update, function (text) {
                                                                        });
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        //var table = webix.$$("invoiceViews");
                                                                        //table.clearAll();
                                                                        //table.load(table.config.url);
                                                                    }
                                                                    k++;
                                                                    excuteHdPlugin(k, dsHoaDon);
                                                                });
                                                        }
                                                        //tblInvoice.enable();
                                                        //tblInvoice.hideProgress();
                                                    });

                                                    var _listcerts = [];

                                                    for (var i = 0; i < listcerts.length; i++) {
                                                        var _cert = listcerts[i];

                                                        _listcerts.push({
                                                            so_serial: _cert.cer_serial,
                                                            ngaybatdau: _cert.begin_date,
                                                            ngayketthuc: _cert.end_date,
                                                            issuer: _cert.issuer,
                                                            subjectname: _cert.subject_name,
                                                        });
                                                    }

                                                    var arg = {
                                                        idData: "#data",
                                                        xml: json["InvoiceXmlData"],
                                                        xmlbangke: json["InvoiceXmlBangKe"],
                                                        shdon: json["shdon"],
                                                        idSigner: "seller",
                                                        tagSign: tagSign,
                                                        dvky: json["dvky"],
                                                        dateKy: json["dateKy"],
                                                        listcerts: _listcerts,
                                                    };

                                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success !");
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                        });
                                                });
                                            });
                                        } else {
                                            tblInvoice.enable();
                                            ui.enable();
                                            tblInvoice.hideProgress();
                                            var table = webix.$$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    }
                                    excuteHdPlugin(0, dsHoaDonXL);
                                }
                            });
                        }
                    });
                });
        },
        CommonOnclickTaskOfHD: function (self) {
            if ($$("kyhieu_id") != undefined) {
                if ($$("kyhieu_id").getPopup().getList().serialize().length > 0 ? true : false) self.callEvent("onClick");
                else webix.message("Không tồn tại ký hiệu!", "error");
            } else {
                webix.message("Không tồn tại ký hiệu!", "error");
            }
        },
        CommonOnclickTaskOfHDTT32: function (self) {
            self.callEvent("onClick");
        },

        CreatItemFromData: function (field, tab) {
            var format = field.format;
            var isFmNumber = false;

            var formatNumberDetails = field.format;
            if (formatNumberDetails !== undefined && formatNumberDetails !== "" && formatNumberDetails !== null) {
                var formatNumberArray = formatNumberDetails.split(":");
                if (formatNumberArray[0] === "fmNumber") isFmNumber = true;
            }

            // field.format = isFmNumber === true ? null : format;

            var subCol = {
                id: field.column_name,
                header: field.caption != null ? _(field.caption) : _(field.column_name),
                editor: field.type_editor,
                hidden: field.hidden,
                value_change: field.value_change,
                isFmNumber: isFmNumber,
                formatOriginal: field.format,
            };

            if (field.read_only == "C" || field.type_editor == "checkbox") {
                delete subCol.editor;
            }

            if (field.type_editor == "checkbox") {
                subCol.template = "{common.checkbox()}";
                subCol.checkValue = true;
                subCol.uncheckValue = false;
            }

            if (field.column_type == "date" || field.column_type == "datetime") {
                subCol.format = function (text) {
                    if (text != null && text != undefined) {
                        var format = webix.Date.dateToStr("%d/%m/%Y %H:%i");
                        text = removeTimeZoneT(text);
                        return format(text);
                    }
                };
            }

            if (field.column_type == "numeric") {
                subCol.css = { "text-align": "right" };
                subCol.format = webix.Number.numToStr({
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: field.data_decimal,
                });

                if (field.type_editor == "autonumeric") {
                    if (field.data_decimal >= 0) {
                        var decimal = Array(field.data_decimal + 1).join("9");

                        subCol.numericConfig = {
                            //maximumValue: Number("999999999999." + decimal),
                            //minValue: Number("-999999999999." + decimal),
                            decimalPlaces: field.data_decimal,
                        };
                    }
                }
                // if (field.data_decimal === "fmNumber") subCol.format = fmNumber;
            }

            if (field.column_width == null) {
                subCol.fillspace = true;
            } else {
                subCol.width = field.column_width;
            }

            if (field.type_editor == "combo" || field.type_editor == "multiselect") {
                if (field.ref_id !== undefined && field.ref_id !== null && field.ref_id !== "") {
                    subCol.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                    subCol.optionslist = true;
                } else {
                    subCol.options = JSON.parse(field.list_column);
                    subCol.value = "1";
                }
            }
            webix.editors.$popup = {
                date: {
                    view: "popup",
                    body: { view: "calendar", timepicker: true, icons: true },
                },
            };

            if (field.type_editor == "datepicker") {
                subCol.editor = "date";
                subCol.format = function (text) {
                    if (text != null && text != undefined) {
                        var format = webix.Date.dateToStr("%d/%m/%Y %H:%i");
                        text = removeTimeZoneT(text);
                        return format(text);
                    }
                };
            }

            if (field.type_editor == "treesuggest") {
                var listColumns = JSON.parse(field.list_column);

                for (var v = 0; v < listColumns.length; v++) {
                    listColumns[v].header = _(listColumns[v].id);
                }

                var popup = webix.ui({
                    view: "treesuggest",
                    body: {
                        columns: listColumns,
                        refid: field.ref_id,
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

                                webix.ajax(url, function (text) {
                                    var json = JSON.parse(text);
                                    var data = listToTree(json);
                                    view.parse(data, "json");
                                });
                            },
                        },
                        filterMode: {
                            level: false,
                            showSubItems: false,
                        },
                    },
                });

                subCol.popup = popup;
                subCol.editor = "combo";
            }

            if (field.type_editor == "gridcombo") {
                var listColumns = JSON.parse(field.list_column);

                for (var v = 0; v < listColumns.length; v++) {
                    listColumns[v].header = _(listColumns[v].id);
                }

                var popup = webix.ui({
                    view: "gridsuggest",
                    textValue: field.display_field,
                    body: {
                        columns: listColumns,
                        refid: field.ref_id,
                        textValue: field.display_field,
                        tableId: "edit_" + tab.table_name,
                        url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
                    },
                });

                subCol.popup = popup;
                subCol.editor = "combo";
            }
            if (field.type_editor == "search") {
                subCol.onSearchIconClick = function (e) {
                    var form = $$(this.getFormView());

                    var field_express = this.config.fieldExpression;
                    var text = this.getValue();
                    var datapost = { masothue: text };
                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .post(app.config.host + "/System/GetInfoByMST", datapost, function (text) {
                            var json = JSON.parse(text);

                            if (!json.hasOwnProperty("error")) {
                                //console.log(JSON.stringify(json));
                                form.setValues(json);
                            } else {
                                // nếu không tồn tại mã số thuế phải xóa địa chỉ + tên cty ở đây
                                webix.message(json.error, "error", 2000);
                            }
                        });
                };
            }
            if (field.type_editor == "gridsuggest") {
                var listColumns = JSON.parse(field.list_column);

                for (var v = 0; v < listColumns.length; v++) {
                    listColumns[v].header = _(listColumns[v].id.toUpperCase());
                }

                subCol.editor = "textsearch";
                subCol.tableId = "edit_" + tab.table_name;
                subCol.onIconButtonClick = function (e) {
                    var tableId = this.getAttribute("tableId");
                    var table = $$(tableId);
                    tableShowEditWindow(table, 1);
                };

                subCol.suggest = {
                    view: "gridsuggest",
                    value_suggest: field.value_suggest,
                    fieldExpression: field.field_expression,
                    displayField: field.display_field,
                    tableId: "edit_" + tab.table_name,
                    columnName: field.column_name,
                    body: {
                        columns: listColumns,
                        refid: field.ref_id,
                        scroll: true,
                        autoheight: false,
                        datatype: "json",
                        dataFeed: function (filtervalue, filter) {
                            if (filtervalue.length < 1 && field.column_name != "tlkthu") return;

                            var refid = this.config.refid;
                            var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                        },
                    },
                    on: {
                        onValueSuggest: function (obj) {
                            if (this.config.fieldExpression != null) {
                                var table = $$("hoadon68_chitiet");
                                var selectedItem = table.getSelectedItem();

                                var fields = this.config.fieldExpression.split(";");

                                for (var i = 0; i < fields.length; i++) {
                                    var field = fields[i].replace("{", "").replace("}", "");
                                    var array = field.split(":");

                                    selectedItem[array[1]] = obj[array[0]];
                                }

                                table.updateItem(selectedItem.id, selectedItem);
                            }

                            if (this.config.value_suggest != null) {
                                var fn = Function("obj", "id", this.config.value_suggest);
                                fn(obj, this.config.id);
                            }
                        },
                    },
                };
            }
            return subCol;
        },

        //FormMater Tạo item form trên trang từ data
        CreatItemMaterFromData: function (field, windowno) {
            var timeStamp = Date.now();
            var item = {
                view: field.type_editor,
                resizeColumn: true,
                //keepViews: true,
                name: field.column_name,
                label: _(field.caption),
                id: field.column_name,
                width: field.width,
                labelPosition: field.label_position,
                labelWidth: field.label_width,
                format: field.format,
                value_change: field.value_change,
                fieldExpression: field.field_expression,
                data_width: field.data_width,
                column_type: field.column_type,
                css: field.css,
                attributes: {},
                on: {},
                hidden: field.hidden,
                placeholder: field.placeholder,
            };

            var formatNumberMaster = item.format;
            var formatdvtt = false;
            if (formatNumberMaster !== undefined && formatNumberMaster !== "" && formatNumberMaster !== null) {
                var formatNumberArray = formatNumberMaster.split(":");
                if (formatNumberArray[0] === "fmNumber") {
                    item.format = numberFormat(field.column_name);
                    formatdvtt = true;
                }
            }
            if ((field.column_type == "numeric" && formatdvtt == false) || field.column_name == "tgtkhac" || field.column_name == "tgtkcthue") {
                var decimal = "";
                if (field.data_decimal >= 0) {
                    for (var i = 0; i < parseInt(field.data_decimal); i++) {
                        decimal += "0";
                    }
                }
                item.format = "1,111." + decimal;
                item.attributes.onClick = "this.select();";
            }

            if (field.type_editor == "password") {
                item.view = "text";
                item.type = "password";
            }

            if (item.data_width != null) {
                if (item.data_width != 0) {
                    item.attributes.maxlength = item.data_width;
                    //style: "text-transform: uppercase;"
                }
            }

            if (field.styleinput != null && field.styleinput != "") {
                item.attributes.style = field.styleinput;
            }

            if (field.height != null) {
                if (field.height != 0) {
                    item.height = field.height;
                }
            }

            if (field.caption != null) {
                item.label = _(field.caption);
            }

            if (field.readonly == "C") {
                item.readonly = true;
            }
            if (field.read_only == "C") {
                item.readonly = true;
            }
            if (item.view == "combo") {
                item.suggest = {
                    body: {
                        url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
                    },
                };
                //item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
            }

            if (item.view == "select") {
                item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
            }
            if (item.view == "checkbox") {
                if (field.label_position == "right") {
                    item.labelRight = _(field.column_name);
                    item.label = "";
                }

                if (field.column_type == "char") {
                    item.checkValue = "C";
                    item.uncheckValue = "K";
                }

                if (field.column_type == "tinyint") {
                    item.checkValue = "1";
                    item.uncheckValue = "0";
                }

                if (field.column_type == "bit") {
                    item.checkValue = true;
                    item.uncheckValue = false;
                }
            }

            if (item.view == "autonumeric" || field.column_type == "numeric") {
                if (windowno != undefined && (windowno == "WIN00791" || windowno == "WIN00792" || windowno == "WIN00793")) {
                    item.inputAlign = "left";
                } else {
                    item.inputAlign = "right";
                }
                item.decimalPlaces = field.data_decimal;
            }

            if (field.valid_rule != null) {
                var rule = field.valid_rule;

                if (rule == "isNotEmpty") {
                    item.required = true;
                    item.invalidMessage = item.label + " không được bỏ trống";
                    item.validate = webix.rules.isNotEmpty;
                } else if (rule == "isSpecialCharacter") {
                    item.required = true;
                    item.invalidMessage = "Không bỏ trống hoặc ký tự không hợp lệ (a-z,A-Z,0-9)";
                    item.validate = webix.rules.isSpecialCharacter;
                } else if (rule == "isEmail") {
                    item.invalidMessage = item.label + " không hợp lệ";
                    item.validate = webix.rules.isEmail;
                } else if (rule == "isTaxCode") {
                    item.invalidMessage = item.label + " không hợp lệ";
                    item.validate = webix.rules.isTaxCode;
                } else if (rule == "isPositiveNumbers") {
                    item.invalidMessage = item.label + " không hợp lệ";
                    item.validate = webix.rules.isPositiveNumbers;
                } else {
                    if (rule.trim() !== "") {
                        item.validate = Function("value", field.valid_rule);
                        item.invalidMessage = item.label + " không hợp lệ";
                    }
                    if (item.id === "stknmua" || item.id === "stknban") {
                        item.invalidMessage = item.label + " không được vượt quá 30 ký tự";
                    }
                    if (item.id === "sdtnmua") {
                        item.invalidMessage = item.label + " không được vượt quá 20 ký tự";
                    }
                    if (item.id === "email") {
                        item.invalidMessage = item.label + " không đúng định dạng hoăc vượt quá 50 ký tự";
                    }
                    if (item.id === "dchi") {
                        item.invalidMessage = item.label + " không hợp lệ hoặc vượt quá 400 ký tự";
                    }
                }
            }

            if (item.view == "treesuggest") {
                //item.REF_ID = field.REF_ID.toString();
                var listColumns = JSON.parse(field.list_column);

                for (var v = 0; v < listColumns.length; v++) {
                    listColumns[v].header = _(listColumns[v].id);
                }

                item.view = "combo";
                item.options = {
                    view: "treesuggest",
                    textValue: field.display_field,
                    url: {
                        $proxy: true,
                        load: function (view, callback, params) {
                            var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

                            webix.ajax(url, function (text) {
                                var json = JSON.parse(text);
                                var data = listToTree(json);
                                view.parse(data, "json");
                            });
                        },
                    },
                    body: {
                        columns: listColumns,
                        refid: field.ref_id,
                        filterMode: {
                            level: false,
                            showSubItems: false,
                        },
                    },
                };

                item.on.onKeyPress = function (code, e) {
                    if (e.code == "F4") {
                        alert("Moi");
                    }
                };
            }

            if (item.view == "gridcombo") {
                var listColumns = JSON.parse(field.list_column);

                for (var v = 0; v < listColumns.length; v++) {
                    listColumns[v].header = _(listColumns[v].id);
                }

                item.view = "combo";
                item.options = {
                    view: "gridsuggest",
                    template: field.display_field,
                    url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
                    body: {
                        columns: listColumns,
                        refid: field.REF_ID,
                        textValue: field.display_field,
                    },
                    on: {
                        onValueSuggest: function (obj) {
                            var master = $$(this.config.master);
                            if (master.config.fieldExpression != null) {
                                var win = master.getTopParentView();
                                var form = win.getChildViews()[1];
                                //console.log(form);
                                var parentItem = form.getValues();
                                //console.log(parentItem);
                                var fields = master.config.fieldExpression.split(";");

                                for (var i = 0; i < fields.length; i++) {
                                    var field = fields[i].replace("{", "").replace("}", "");
                                    var array = field.split(":");
                                    //console.log(array);
                                    parentItem[array[1]] = obj[array[0]];
                                }

                                form.setValues(parentItem);
                            }

                            if (this.config.value_suggest != null) {
                                var fn = Function("obj", "id", this.config.value_suggest);
                                fn(obj, this.config.id);
                            }
                        },
                    },
                };

                item.on.onKeyPress = function (code, e) {
                    if (e.code == "F4") {
                        alert("Moi");
                    }
                };
            }
            if (item.view == "search") {
                item.on.onSearchIconClick = function (e) {
                    var form = $$(this.getFormView());

                    //get value của form hiện tại để đổi giá trị
                    var mst = this.getValue();
                    // window.location.href = "http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst;
                    window.open("http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst);
                };
            }

            if (item.view == "gridsuggest") {
                var listColumns = JSON.parse(field.list_column);

                for (var v = 0; v < listColumns.length; v++) {
                    listColumns[v].header = _(listColumns[v].id);
                }

                item.view = "search";
                item.icon = "mdi mdi-plus";
                item.on.onSearchIconClick = function (e) {
                    showEditWindow(this, 1);
                };
                item.suggest = {
                    view: "gridsuggest",
                    autoheight: false,
                    value_suggest: field.value_suggest,
                    textValue: field.display_field,
                    body: {
                        columns: listColumns,
                        refid: field.ref_id,
                        scroll: true,
                        autoheight: false,
                        datatype: "json",
                        textValue: field.display_field,
                        dataFeed: function (filtervalue, filter) {
                            if (filtervalue.length < 1 && field.column_name != "tlkthu") return;

                            var refid = this.config.refid;
                            var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                        },
                    },
                    on: {
                        onValueSuggest: function (obj) {
                            //console.log(obj);
                            var master = $$(this.config.master);
                            if (master.config.fieldExpression != null) {
                                var win = master.getTopParentView();
                                var form = win.getChildViews()[1];
                                //console.log(form);
                                var parentItem = form.getValues();
                                //console.log(parentItem);
                                var fields = master.config.fieldExpression.split(";");

                                for (var i = 0; i < fields.length; i++) {
                                    var field = fields[i].replace("{", "").replace("}", "");
                                    var array = field.split(":");
                                    //console.log(array);
                                    parentItem[array[1]] = obj[array[0]];
                                }

                                form.setValues(parentItem);
                            }

                            if (this.config.value_suggest != null) {
                                var fn = Function("obj", "id", this.config.value_suggest);
                                fn(obj, this.config.id);
                            }
                        },
                    },
                };

                item.on.onKeyPress = function (code, e) {
                    if (e.code == "F2") {
                        var suggest = $$(this.config.suggest);
                        var refid = suggest.config.body.refid;

                        suggest.hide();
                        var sql = {
                            command: "SYS004",
                            parameter: {
                                refid: refid,
                            },
                        };
                        //var sql = "SELECT a.*,b.window_id as WINDOWNO FROM #SCHEMA_NAME#.wb_references a INNER JOIN #SCHEMA_NAME#.wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='" + refid + "'";
                        //var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;
                        var url = app.config.host + "/System/ExecuteCommand";

                        var win = this.getTopParentView();
                        var form = win.getChildViews()[1];

                        var editorId = this.config.id;
                        var formId = form.config.id;

                        var a = webix.ajax().post(url, sql);
                        var b = this.config.suggest;
                        var c = this.config.id;
                        var d = this.config.fieldExpression;
                        var e = editorId;
                        var f = formId;

                        webix.promise.all([a, b, c, d, e, f]).then(function (results) {
                            var res_a = results[0].json();

                            var suggest = $$(results[1]);

                            suggest.hide();

                            var url = app.config.host + "/System/GetConfigWinByNo?id=" + res_a[0]["windowno"];

                            var ajax = webix.ajax();
                            ajax.master = {
                                searchId: results[2],
                                fieldExpression: d,
                                valueField: res_a[0]["value_field"],
                                formId: f,
                                editorId: e,
                            };

                            ajax.get(url, function (text) {
                                var windowconfig = JSON.parse(text);
                                var txtSearch = $$(this.searchId);

                                var win = txtSearch.$scope.ui(selectwindow.$ui);

                                win.config.valueField = this.valueField;
                                win.config.fieldExpression = this.fieldExpression;
                                win.config.formId = this.formId;
                                win.config.editorId = this.editorId;

                                selectwindow.initUI(windowconfig);

                                win.getHead().setHTML(windowconfig.data[0].name);
                                win.show();
                            });
                        });

                        var win = this.$scope.ui(selectwindow.$ui);
                        win.show();
                    }
                };
            }

            if (item.value_change != null || item.css != null || item.validate != null) {
                item.on.onChange = function (newv, oldv) {
                    // if (this.config.validate != null) {
                    //     this.validate();
                    // }

                    if (this.config.css != null) {
                        if (this.config.css == "mcls_uppercase" && newv !== undefined && oldv !== undefined) {
                            if (newv.toUpperCase() != oldv.toUpperCase()) {
                                webix.$$(this.config.id).setValue(newv.toUpperCase());
                            }
                        }
                    }
                    if (this.config.value_change != null) {
                        var fn = Function("newv", "oldv", "id", "timeStamp", this.config.value_change);
                        fn(newv, oldv, this.config.id, timeStamp);
                    }
                };
            }
            if (item.css === "txtTongtien") item.label = "";
            return item;
        },

        ExeCuteCheckReadCurencyTV: function (checkReadTV) {
            if (checkReadTV != 0) {
                // if ($$("docngoaitetv") != null) $$("docngoaitetv").setValue(1);
            }

            var total_amount = $$("tgtttbso_last").getValue();
            var type_curency = "VND";
            var table = webix.$$("invoiceViews");
            var item = table.getSelectedItem();

            if ($$("dvtte") != null) {
                var type_curency = $$("dvtte").getValue();
            }
            if (
                total_amount !== undefined &&
                total_amount !== null &&
                total_amount.toString() !== " " &&
                total_amount.toString() !== "" &&
                total_amount.toString() !== "0" &&
                CheckKhacNull(checkReadTV) &&
                checkReadTV.toString() !== "true"
            ) {
                var url = "";
                if (type_curency == "VND") {
                    url = app.config.host + "/Invoice68/Amount_ToWord?number=" + total_amount + "&type_amount=" + type_curency;
                } else if (type_curency == "JPY") {
                    url = app.config.host + "/Invoice68/Amount_ToWord_JPY?number=" + total_amount + "&checkReadTV=" + checkReadTV;
                } else {
                    url = app.config.host + "/Invoice68/Amount_ToWord_New?number=" + total_amount + "&checkReadTV=" + checkReadTV;
                }

                var xhr = webix.ajax().sync().get(url);

                var c_result = JSON.parse(xhr.responseText);
                if (type_curency == "GBP") {
                    c_result.data = c_result.data.replace('đô la Mỹ', 'bảng Anh').replace('dollars', 'pounds');
                } else if (type_curency == "SGD") {
                    c_result.data = c_result.data.replace('Mỹ', 'Singapore').replace('dollars', 'Singapore dollars');
                } else if (type_curency == "JPY") {
                    c_result.data = c_result.data.replace('đô la Mỹ', 'yên Nhật');
                }
                if (item != undefined) {
                    if (item.tthdon == 21) {
                        c_result.data = c_result.data.replace('Âm', 'Điều chỉnh giảm');
                    }
                }

                if (c_result.error == undefined || c_result.error == null) {
                    if (c_result.data != undefined && c_result.data != null) {
                        $$("tgtttbchu").setValue(c_result.data);
                    }
                }
            } else {
                if (type_curency === "USD") {
                    if (Number(total_amount) == 0) {
                        if (checkReadTV == 0) {
                            $$("tgtttbchu").setValue("Zero dollars.");
                        } else {
                            $$("tgtttbchu").setValue("Không đô la Mỹ.");
                        }
                    } else {
                        checkReadTV = "" || " " || undefined || null ? 0 : checkReadTV;
                        url = app.config.host + "/Invoice68/Amount_ToWord_New?number=" + total_amount + "&checkReadTV=" + checkReadTV;
                        var xhr = webix.ajax().sync().get(url);

                        var c_result = JSON.parse(xhr.responseText);

                        if (c_result.error == undefined || c_result.error == null) {
                            if (c_result.data != undefined && c_result.data != null) {
                                $$("tgtttbchu").setValue(c_result.data);
                            }
                        }
                    }
                } else if (type_curency === "GBP") {
                    if (Number(total_amount) == 0) {
                        if (checkReadTV == 0) {
                            $$("tgtttbchu").setValue("Zero pounds.");
                        } else {
                            $$("tgtttbchu").setValue("Không bảng Anh.");
                        }
                    } else {
                        checkReadTV = "" || " " || undefined || null ? 0 : checkReadTV;
                        url = app.config.host + "/Invoice68/Amount_ToWord_New?number=" + total_amount + "&checkReadTV=" + checkReadTV;
                        var xhr = webix.ajax().sync().get(url);

                        var c_result = JSON.parse(xhr.responseText);

                        c_result.data = c_result.data.replace('đô la Mỹ', 'bảng Anh').replace('dollars', 'pounds');

                        if (c_result.error == undefined || c_result.error == null) {
                            if (c_result.data != undefined && c_result.data != null) {
                                $$("tgtttbchu").setValue(c_result.data);
                            }
                        }
                    }
                } else if (type_curency === "JPY") {
                    if (Number(total_amount) == 0) {
                        if (checkReadTV == 0) {
                            $$("tgtttbchu").setValue("平和がない");
                        } else {
                            $$("tgtttbchu").setValue("Không yên Nhật.");
                        }
                    } else {
                        checkReadTV = "" || " " || undefined || null ? 0 : checkReadTV;
                        url = app.config.host + "/Invoice68/Amount_ToWord_JPY?number=" + total_amount + "&checkReadTV=" + checkReadTV;
                        var xhr = webix.ajax().sync().get(url);

                        var c_result = JSON.parse(xhr.responseText);

                        c_result.data = c_result.data.replace('đô la Mỹ', 'yên Nhật');

                        if (c_result.error == undefined || c_result.error == null) {
                            if (c_result.data != undefined && c_result.data != null) {
                                $$("tgtttbchu").setValue(c_result.data);
                            }
                        }
                    }
                } else if (type_curency === "SGD") {
                    if (Number(total_amount) == 0) {
                        if (checkReadTV == 0) {
                            $$("tgtttbchu").setValue("Zero Singapore dollar.");
                        } else {
                            $$("tgtttbchu").setValue("Không đô la Singapore.");
                        }
                    } else {
                        checkReadTV = "" || " " || undefined || null ? 0 : checkReadTV;
                        url = app.config.host + "/Invoice68/Amount_ToWord_New?number=" + total_amount + "&checkReadTV=" + checkReadTV;
                        var xhr = webix.ajax().sync().get(url);

                        var c_result = JSON.parse(xhr.responseText);

                        c_result.data = c_result.data.replace('Mỹ', 'Singapore').replace('dollars', 'Singapore dollars');

                        if (c_result.error == undefined || c_result.error == null) {
                            if (c_result.data != undefined && c_result.data != null) {
                                $$("tgtttbchu").setValue(c_result.data);
                            }
                        }
                    }
                } else {
                    if (Number(total_amount) == 0) {
                        $$("tgtttbchu").setValue("Không đồng.");
                    } else {
                        url = app.config.host + "/Invoice68/Amount_ToWord?number=" + total_amount + "&type_amount=" + type_curency;
                        var xhr = webix.ajax().sync().get(url);

                        var c_result = JSON.parse(xhr.responseText);

                        if (c_result.error == undefined || c_result.error == null) {
                            if (c_result.data != undefined && c_result.data != null) {
                                $$("tgtttbchu").setValue(c_result.data);
                            }
                        }
                    }
                }
            }
        },
        CanhBaoTinhTien: function () {
            var tong_tien_all = 0;
            var tong_tien = 0;
            var canh_bao = "";
            var khieu = "";
            var tthdon = "";
            var lech = 0;
            var lech2 = 0;
            var table = $$("hoadon68_chitiet");
            var table_t = webix.$$("invoiceViews");
            var item = table_t.getSelectedItem();
            if (item != undefined) {
                khieu = item.khieu;
                tthdon = item.tthdon;
            }
            if ($$("tudongtinhtien") !== undefined && $$("tudongtinhtien").isVisible()) {
                if ($$("tudongtinhtien").getValue() == true) {
                    $$("lblCanhbao").hide();
                    return;
                }
            }
            if (table !== undefined) {
                var data = table.serialize();
                data.forEach(function (entry) {
                    if (entry.kmai && (entry.kmai.toString() === "1" || entry.kmai.toString() === "5" || entry.kmai.toString() === "3")) {
                        if (entry.kmai.toString() === "1" || entry.kmai.toString() === "5") {
                            tong_tien_all += entry["tgtien"] == null ? 0 : entry["tgtien"];
                        } else {
                            tong_tien_all -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                        }
                    }
                });

                if ($$("tgtttbso") !== undefined && $$("tgtttbso").isVisible()) {
                    var tgtttbso = Number($$("tgtttbso").getValue());
                    var decimalDigits = 0;
                    if (tgtttbso.toString().includes(".")) {
                        var parts = tgtttbso.toString().split(".");
                        decimalDigits = parts[1].length;
                    }
                    if (tgtttbso !== tong_tien_all) {
                        lech = Math.abs(tgtttbso - tong_tien_all.toFixed(decimalDigits));
                    }
                }
            }
            debugger
            var tong_tien = 0;
            if ($$("tgtttbso") !== undefined && $$("tgtttbso").isVisible()) {
                if ($$("tgtttbso").getValue() != null) tong_tien += Number($$("tgtttbso").getValue());
            } else {
                tong_tien += tong_tien_all;
            }
            if ($$("tgtphi") !== undefined) {
                if ($$("tgtphi").getValue() != null) tong_tien += Number($$("tgtphi").getValue());
            }
            if ($$("tgtkhac") !== undefined) {
                if ($$("tgtkhac").getValue() != null) tong_tien -= Number($$("tgtkhac").getValue());
            }
            if ($$("tgtkcthue") !== undefined) {
                if ($$("tgtkcthue").getValue() != null) tong_tien -= Number($$("tgtkcthue").getValue());
            }
            if ($$("tgtttbso_last") !== undefined && $$("tgtttbso_last").isVisible()) {
                var tgtttbso_last = Number($$("tgtttbso_last").getValue());
                var decimalDigits = 0;
                if (tgtttbso_last.toString().includes(".")) {
                    var parts = tgtttbso_last.toString().split(".");
                    decimalDigits = parts[1].length;
                }
                if (tgtttbso_last !== tong_tien) {
                    lech2 = Math.abs(tgtttbso_last - tong_tien.toFixed(decimalDigits));
                }
            }
            if (lech <= 0 && lech2 <= 0) {
                //$$("lblCanhbao").type = 0;
                $$("lblCanhbao").hide();
                return;
            } else {
                /*if (lech > 100 || lech2 > 100) {
                    $$("lblCanhbao").type = 1;
                } else {
                    $$("lblCanhbao").type = 0;
                }*/
                if (lech > 0 && lech2 > 0) {
                    canh_bao = "Cảnh báo: Trường tổng tiền sau thuế tính lệch " + lech + " và trường thành tiền tính lệch " + lech2 + " " + $$("dvtte").getValue();
                    $$("lblCanhbao").setValue(canh_bao);
                } else if (lech > 0) {
                    canh_bao = "Cảnh báo: Trường tổng tiền sau thuế tính lệch " + lech + " " + $$("dvtte").getValue();
                    $$("lblCanhbao").setValue(canh_bao);
                }
                else if (lech2 > 0) {
                    canh_bao = "Cảnh báo: Trường thành tiền tính lệch " + lech2 + " " + $$("dvtte").getValue();
                    $$("lblCanhbao").setValue(canh_bao);
                }
                $$("lblCanhbao").show();
                return
            }
        },
        GetBienLaiChon: function () {
            var tableHdon = webix.$$("invoiceViews");
            var datafrmAll = tableHdon.serialize();
            // get list được chọn
            var lsthdon_id = [];

            var lstDataChoose = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true;
                });

            if (lstDataChoose.length == 0) {
                webix.message("Vui lòng chọn biên lai để xử lý!", "error");
            }
            return lstDataChoose;
        },
        GetHoaDonChon: function () {
            var tableHdon = webix.$$("invoiceViews");
            var datafrmAll = tableHdon.serialize();
            // get list được chọn
            var lsthdon_id = [];

            var lstDataChoose = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true;
                });

            if (lstDataChoose.length == 0) {
                webix.message("Vui lòng chọn hóa đơn để xử lý!", "error");
            }
            return lstDataChoose;
        },
        GetHoaDonChonOfTableId: function (params) {
            var tableHdon = webix.$$(params.id);
            var datafrmAll = tableHdon.serialize();
            // get list được chọn
            var lsthdon_id = [];

            var lstDataChoose = datafrmAll
                .filter(function (p) {
                    return p != undefined;
                })
                .filter(function (p) {
                    return p.chon == true;
                });

            if (lstDataChoose.length == 0) {
                webix.message("Vui lòng chọn hóa đơn để xử lý!", "error");
            }
            return lstDataChoose;
        },
        ExcuteShowPopupNotifyErrorInvoice: function () {
            require(["views/forms/68_huyhoadon", "app"], function (huyhoadon, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();
                if (item.tthdon == 11 || item.tthdon == 17) {
                    webix.message("Hóa đơn đã điều chỉnh không thể thực hiện chức năng này", "error");
                    return;
                }

                var datafrm = table.serialize();
                var data = [];

                if (datafrm.length > 0) {
                    for (var i = 0; i < datafrm.length; i++) {
                        if (datafrm[i] != undefined) {
                            if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                data.push(datafrm[i]);
                            }
                        }
                    }
                }

                if (data.length > 0) {
                    var cungshd = true;
                    for (var k = 1; k <= data.length - 1; k++) {
                        if (data[k]["stbao"] !== data[0]["stbao"]) {
                            cungshd = false;
                            break;
                        }
                    }
                    if (cungshd === true) {
                        var loai = 1;
                        if (data[0]["stbao"] !== null) loai = 2;
                        for (var i = 0; i < data.length; i++) {
                            if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký" || data[i].tthai == "Đã ký") {
                                webix.message("Hóa đơn chưa gửi không thể thông báo sai sót", "error");
                                app.callEvent("dataChangedInvoie68", [1, null]);
                                return;
                            }
                            if (data[i].ladhddt == undefined) {
                                data[i].ladhddt = "1";
                            }
                            if (data[i].tctbao == undefined) {
                                data[i].tctbao = "1";
                            }
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();
                        var tongquat = {
                            so: data[0].stbao,
                            ntbccqt: data[0].ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);
                        data.forEach(function (item) {
                            var put = {
                                mcqtcap: item.mccqthue,
                                khieu: item.khieu_temp,
                                shdon: item.shdon_temp,
                                ngay: item.nlap_temp,
                                ladhddt: item.ladhddt,
                                tctbao: item.tctbao,
                                hdon_id: item.hdon_id_old,
                            };
                            huyhoadon.setValues(put, null, null);
                            //this.hide();
                            win.show();
                        });
                    } else {
                        webix.message("Các hóa đơn chọn phải có số thông báo giống nhau", "error");
                    }
                } else {
                    var loai = 1;
                    if (item["stbao"] !== null) loai = 2;

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }

                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                        webix.message("Hóa đơn chưa gửi không thể thông báo sai sót", "error");
                        app.callEvent("dataChangedInvoie68", [1, null]);
                        return;
                    }

                    if (item.ladhddt == undefined) {
                        item["ladhddt"] = "1";
                    }
                    if (item.tctbao == undefined) {
                        item["tctbao"] = "1";
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnHuyhoadon").destructor();

                    var tongquat = {
                        so: item.stbao,
                        ntbccqt: item.ntbao,
                        loai: loai,
                    };
                    huyhoadon.setValuesTongQuat(tongquat, null, null);

                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon_temp,
                        ngay: item.nlap_temp,
                        ladhddt: item.ladhddt,
                        tctbao: item.tctbao,
                        hdon_id: item.hdon_id_old,
                    };
                    huyhoadon.setValues(put, null, null);

                    //this.hide();
                    win.show();
                }
            });
        },
        ExcuteReplaceInvoice: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78", "views/forms/formhoadoncode78", "views/forms/formhoadoncode78_mtt", "app"], function (invoiceForms, invoiceFormsCode, invoiceFormsCodeMTT, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                    "tgtkcthue",
                    "tgtkhac"
                ];
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();

                if (item == null || item == undefined) {
                    webix.message("Bạn chưa chọn hóa đơn !", "error");
                    return;
                }

                if (
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        (item.tthdon == 0 || item.tthdon == 1)) ||
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        item.tthdon == 2) ||
                    (item.tthai == "Chờ phản hồi" && item.tthdon == 3)
                ) {
                    var check = true;
                } else {
                    webix.message("Không thể thực hiện chức năng này", "error");
                    return;
                }

                var box = webix.modalbox({
                    title: "Chọn mặt hàng cần thay thế",
                    buttons: ["Nhận", "Hủy bỏ"],
                    text: "<div id='ctnMatHang'></div>",
                    top: 100,
                    width: 750,
                    callback: function (result) {
                        switch (result) {
                            case "0":
                                var tblMatHang = $$("tblMatHang");
                                var array = tblMatHang.serialize();

                                var chons = [];

                                for (var i = 0; i < array.length; i++) {
                                    var chon = array[i];
                                    if (chon.hasOwnProperty("chon")) {
                                        if (chon.chon == true) {
                                            chons.push(chon);
                                        }
                                    }
                                }
                                tblMatHang.destructor();

                                // var btn = $$("btnPlus");
                                // btn.callEvent("onClick");
                                //var detailForm = $$("invoiceForms");
                                var detailForm;
                                var khieu = item.khieu;
                                var windowno = app.path[1].params[0];
                                var app_cache = webix.storage.local.get("APP_CACHE");
                                var windowconfig = app_cache[windowno];
                                var ngay_hoa_don = item.nlap;
                                item.cctbao_id_temp = item.cctbao_id;
                                item.cctbao_id = kyHieuHoaDon.cctbao_id;
                                item.khieu_temp = item.khieu;
                                item.khieu = kyHieuHoaDon.khieu;
                                item.nlap_temp = item.nlap;
                                item.nlap = null;
                                item.shdon_temp = item.shdon;
                                item.shdon = "";
                                item.hdon_id_old = item.hdon_id;
                                item.tthdon_old = item.tthdon;
                                item.tthdon = 2;
                                item.tthdon_original = 2;
                                item.tthai_old = item.tthai;
                                item.nky = "";
                                item.hdon_id = "";
                                item.loaihdlq = kyHieuHoaDon.loaihdlq;
                                item.tgia = 1;
                                item.sdhang = "";
                                item.tienthuegtgtgiam = 0;
                                item.tiletienthuegtgtgiam = "";
                                item.giamthuebanhang20 = false;
                                for (var i = 0; i < arrayString.length; i++) {
                                    item[arrayString[i]] = 0;
                                }
                                item["tgtttbchu"] = "";

                                if (khieu.charAt(1) == "C") {
                                    if (khieu.charAt(4) == "M") {
                                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCodeMTT.$ui);
                                        invoiceFormsCodeMTT.initUI(windowconfig);
                                        invoiceFormsCodeMTT.initUINew(kyHieuHoaDon.cctbao_id);
                                        invoiceFormsCodeMTT.setEditMode(1);
                                        invoiceForms.setValues(item, null);
                                    } else {
                                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCode.$ui);
                                        invoiceFormsCode.initUI(windowconfig);
                                        invoiceFormsCode.initUINew(kyHieuHoaDon.cctbao_id);
                                        invoiceFormsCode.setEditMode(1);
                                        invoiceFormsCode.setValues(item, null);
                                    }
                                } else {
                                    detailForm = $$("invoiceViews").$scope.ui(invoiceForms.$ui);
                                    invoiceForms.initUI(windowconfig);
                                    invoiceForms.initUINew(kyHieuHoaDon.cctbao_id);
                                    invoiceForms.setEditMode(1);
                                    invoiceForms.setValues(item, null);
                                }

                                //var tableDetail_phi = webix.$$("hoadon68_phi");
                                //tableDetail_phi.clearAll();
                                //tableDetail_phi.refreshColumns();

                                var tableDetail = webix.$$("hoadon68_chitiet");

                                tableDetail.clearAll();

                                for (var i = 0; i < chons.length; i++) {
                                    var chon = chons[i];
                                    chon.hdon_id = null;
                                    chon.cthdon_id = null;
                                    chon.id = webix.uid();
                                    tableDetail.add(chon);
                                }

                                var tablePhi = webix.$$("hoadon68_phi");
                                tablePhi.clearAll()
                                var dataPhi;
                                var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                                webix
                                    .ajax()
                                    .headers({
                                        "Content-type": "application/json",
                                    })
                                    .get(urlPhi, function (text) {
                                        dataPhi = JSON.parse(text);
                                        //tablePhi.parse(data);
                                        if (dataPhi !== undefined) {
                                            for (var i = 0; i < dataPhi.length; i++) {
                                                var dtaPhi = dataPhi[i];
                                                tablePhi.add(dtaPhi);
                                            }
                                        }
                                    });

                                console.log(item.khieu);
                                console.log(item.khieu_temp);
                                detailForm.show();
                                break;
                            case "1":
                                webix.modalbox.hide();
                                break;
                        }
                    },
                });
                var tblMatHang = webix.ui({
                    container: "ctnMatHang",
                    id: "tblMatHang",
                    view: "datatable",
                    borderless: true,
                    height: 350,
                    columns: [
                        {
                            id: "chon",
                            header: [
                                {
                                    text: "",
                                    content: "masterCheckbox",
                                },
                            ],
                            width: 65,
                            checkValue: true,
                            uncheckValue: false,
                            template: "{common.checkbox()}",
                        },
                        {
                            id: "stt",
                            header: "",
                            width: 30,
                        },
                        {
                            id: "ma",
                            header: _("Mã hàng hóa"),
                            editor: "text",
                            width: 100,
                            editable: true,
                        },
                        {
                            id: "ten",
                            header: _("Tên hàng hóa"),
                            editor: "text",
                            width: 350,
                            editable: true,
                        },
                        {
                            id: "mdvtinh",
                            header: _("ĐVT"),
                            editor: "text",
                            width: 80,
                            editable: true,
                        },
                        {
                            id: "sluong",
                            header: _("Số lương"),
                            editor: "autonumeric",
                            width: 100,
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "dgia",
                            header: _("Đơn giá"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                            // value_change: field.value_change
                        },
                        {
                            id: "thtien",
                            header: _("Tiền trước thuế"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                            // value_change: field.value_change
                        },
                        {
                            id: "tlckhau",
                            header: _("% CK"),
                            width: 80,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "stckhau",
                            header: _("Tiền CK"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "tsuat",
                            header: _("Thuế suất"),
                            width: 100,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "tthue",
                            header: _("Tiền thuế"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "tgtien",
                            header: _("Tiền sau thuế"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                    ],
                });
                var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                webix
                    .ajax()
                    .headers({
                        "Content-type": "application/json",
                    })
                    .get(url, function (text) {
                        var data = JSON.parse(text);

                        var tblMatHang = $$("tblMatHang");
                        tblMatHang.parse(data);
                    });
            });
        },
        ExcuteChonInvoice: function (kyHieuHoaDon, mode) {
            mode = (typeof mode !== 'undefined') ? mode : null;
            require(["views/forms/formhoadon78", "views/forms/formhoadoncode78", "views/forms/formhoadoncode78_mtt", "app"], function (invoiceForms, invoiceFormsCode, invoiceFormsCodeMTT, app) {

                var table = webix.$$("invoiceViews");
                var itemSL = table.getSelectedItem();

                if (itemSL == null || itemSL == undefined) {
                    webix.message("Bạn chưa chọn hóa đơn !", "error");
                    return;
                }

                // var btn = $$("btnPlus");
                // btn.callEvent("onClick");
                //var detailForm = $$("invoiceForms");

                var item = Object.assign({}, itemSL);
                item.shdon = null;
                item.sbmat = null;
                item.cctbao_id = kyHieuHoaDon.cctbao_id;
                var detailForm;
                var khieu = item.khieu;
                var windowno = app.path[1].params[0];
                var app_cache = webix.storage.local.get("APP_CACHE");
                var windowconfig = app_cache[windowno];

                if (khieu.charAt(1) == "C") {
                    if (khieu.charAt(4) == "M") {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCodeMTT.$ui);
                        invoiceFormsCodeMTT.initUI(windowconfig);
                        invoiceFormsCodeMTT.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCodeMTT.setEditMode(1);
                        invoiceFormsCodeMTT.setModeChangeView(mode);
                        invoiceFormsCodeMTT.copyValues(item);
                    } else {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCode.$ui);
                        invoiceFormsCode.initUI(windowconfig);
                        invoiceFormsCode.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCode.setEditMode(1);
                        invoiceFormsCode.setModeChangeView(mode);
                        invoiceFormsCode.copyValues(item);
                    }
                } else {
                    detailForm = $$("invoiceViews").$scope.ui(invoiceForms.$ui);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.initUINew(kyHieuHoaDon.cctbao_id);
                    invoiceForms.setEditMode(1);
                    invoiceForms.setModeChangeView(mode);
                    invoiceForms.copyValues(item);
                }

                detailForm.show();
            });
        },
        ExcuteReplaceInvoice_32: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78", "views/forms/formhoadoncode78", "views/forms/formhoadoncode78_mtt", "app"], function (invoiceForms, invoiceFormsCode, invoiceFormsCodeMTT, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];
                var detailForm;
                for (var i = 0; i < arrayString.length; i++) {
                    kyHieuHoaDon[arrayString[i]] = 0;
                }
                kyHieuHoaDon["tgtttbchu"] = "";
                var windowno = app.path[1].params[0];
                var app_cache = webix.storage.local.get("APP_CACHE");
                var windowconfig = app_cache[windowno];
                if (kyHieuHoaDon.khieu.charAt(1) == "C") {
                    if (kyHieuHoaDon.khieu.charAt(4) == "M") {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCodeMTT.$ui);
                        invoiceFormsCodeMTT.initUI(windowconfig);
                        invoiceFormsCodeMTT.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCodeMTT.setEditMode(1);
                        invoiceFormsCodeMTT.setValues(kyHieuHoaDon, null);
                    } else {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCode.$ui);
                        invoiceFormsCode.initUI(windowconfig);
                        invoiceFormsCode.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCode.setEditMode(1);
                        invoiceFormsCode.setValues(kyHieuHoaDon, null);
                    }
                } else {
                    detailForm = $$("invoiceViews").$scope.ui(invoiceForms.$ui);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.initUINew(kyHieuHoaDon.cctbao_id);
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(kyHieuHoaDon, null);
                }

                var tableDetail = webix.$$("hoadon68_chitiet");

                tableDetail.clearAll();
                tableDetail.refresh();

                detailForm.show();
            });
        },
        ExcuteIncreaseChangeInvoice_32: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78", "views/forms/formhoadoncode78", "views/forms/formhoadoncode78_mtt", "app"], function (invoiceForms, invoiceFormsCode, invoiceFormsCodeMTT, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];
                var table = webix.$$("invoiceViews");
                // var item = table.getSelectedItem();
                var btn = $$("btnPlus");
                // btn.callEvent("onClick");
                //var detailForm = $$("invoiceForms");
                var detailForm;
                for (var i = 0; i < arrayString.length; i++) {
                    kyHieuHoaDon[arrayString[i]] = 0;
                }
                kyHieuHoaDon["tgtttbchu"] = "";
                var windowno = app.path[1].params[0];
                var app_cache = webix.storage.local.get("APP_CACHE");
                var windowconfig = app_cache[windowno];

                if (kyHieuHoaDon.khieu.charAt(1) == "C") {
                    if (kyHieuHoaDon.khieu.charAt(4) == "M") {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCodeMTT.$ui);
                        invoiceFormsCodeMTT.initUI(windowconfig);
                        invoiceFormsCodeMTT.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCodeMTT.setEditMode(1);
                        invoiceFormsCodeMTT.setValues(kyHieuHoaDon, null);
                    } else {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCode.$ui);
                        invoiceFormsCode.initUI(windowconfig);
                        invoiceFormsCode.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCode.setEditMode(1);
                        invoiceFormsCode.setValues(kyHieuHoaDon, null);
                    }
                } else {
                    detailForm = $$("invoiceViews").$scope.ui(invoiceForms.$ui);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.initUINew(kyHieuHoaDon.cctbao_id);
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(kyHieuHoaDon, null);
                }

                var tableDetail = webix.$$("hoadon68_chitiet");

                tableDetail.clearAll();
                tableDetail.refresh();

                detailForm.show();
            });
        },
        ExcuteReduceChangeInvoice_32: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78", "views/forms/formhoadoncode78", "views/forms/formhoadoncode78_mtt", "app"], function (invoiceForms, invoiceFormsCode, invoiceFormsCodeMTT, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];
                var table = webix.$$("invoiceViews");
                // var item = table.getSelectedItem();
                var btn = $$("btnPlus");
                // btn.callEvent("onClick");
                //var detailForm = $$("invoiceForms");
                for (var i = 0; i < arrayString.length; i++) {
                    kyHieuHoaDon[arrayString[i]] = 0;
                }
                kyHieuHoaDon["tgtttbchu"] = "";
                var detailForm;
                var windowno = app.path[1].params[0];
                var app_cache = webix.storage.local.get("APP_CACHE");
                var windowconfig = app_cache[windowno];
                if (kyHieuHoaDon.khieu.charAt(1) == "C") {
                    if (kyHieuHoaDon.khieu.charAt(4) == "M") {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCodeMTT.$ui);
                        invoiceFormsCodeMTT.initUI(windowconfig);
                        invoiceFormsCodeMTT.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCodeMTT.setEditMode(1);
                        invoiceFormsCodeMTT.setValues(kyHieuHoaDon, null);
                    } else {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCode.$ui);
                        invoiceFormsCode.initUI(windowconfig);
                        invoiceFormsCode.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCode.setEditMode(1);
                        invoiceFormsCode.setValues(kyHieuHoaDon, null);
                    }
                } else {
                    detailForm = $$("invoiceViews").$scope.ui(invoiceForms.$ui);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.initUINew(kyHieuHoaDon.cctbao_id);
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(kyHieuHoaDon, null);
                }

                var ghichu = webix.$$("textGhiChu");
                ghichu.setValue("Lưu ý: Hóa đơn điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                ghichu.show();

                var tableDetail = webix.$$("hoadon68_chitiet");

                tableDetail.clearAll();
                tableDetail.refresh();

                detailForm.show();
            });
        },
        ExcuteInfoChangeInvoice_32: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78", "views/forms/formhoadoncode78", "views/forms/formhoadoncode78_mtt", "app"], function (invoiceForms, invoiceFormsCode, invoiceFormsCodeMTT, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];
                var table = webix.$$("invoiceViews");
                // var item = table.getSelectedItem();
                var btn = $$("btnPlus");
                // btn.callEvent("onClick");
                //var detailForm = $$("invoiceForms");
                for (var i = 0; i < arrayString.length; i++) {
                    kyHieuHoaDon[arrayString[i]] = 0;
                }
                kyHieuHoaDon["tgtttbchu"] = "";
                var detailForm;
                var windowno = app.path[1].params[0];
                var app_cache = webix.storage.local.get("APP_CACHE");
                var windowconfig = app_cache[windowno];
                if (kyHieuHoaDon.khieu.charAt(1) == "C") {
                    if (kyHieuHoaDon.khieu.charAt(4) == "M") {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCodeMTT.$ui);
                        invoiceFormsCodeMTT.initUI(windowconfig);
                        invoiceFormsCodeMTT.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCodeMTT.setEditMode(1);
                        invoiceFormsCodeMTT.setValues(kyHieuHoaDon, null);
                    } else {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCode.$ui);
                        invoiceFormsCode.initUI(windowconfig);
                        invoiceFormsCode.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCode.setEditMode(1);
                        invoiceFormsCode.setValues(kyHieuHoaDon, null);
                    }
                } else {
                    detailForm = $$("invoiceViews").$scope.ui(invoiceForms.$ui);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.initUINew(kyHieuHoaDon.cctbao_id);
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(kyHieuHoaDon, null);
                }

                var obj_detail = {
                    id: webix.uid(),
                    kmai: "4",
                    ten: "Hóa đơn điều chỉnh cho hóa đơn số " + kyHieuHoaDon.shdclquan + " ngày " + moment(kyHieuHoaDon.nlhdclquan).format("DD/MM/YYYY") + " ký hiệu " + kyHieuHoaDon.khhdclquan,
                };
                var tableDetail = webix.$$("hoadon68_chitiet");
                tableDetail.clearAll();
                tableDetail.add(obj_detail);
                var columns = tableDetail.config.columns;
                for (var i = 0; i < columns.length; i++) {
                    var column = columns[i];
                }
                tableDetail.refreshColumns();
                tableDetail.refresh();

                detailForm.show();
            });
        },

        ExcuteIncreaseChangeInvoice: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78", "views/forms/formhoadoncode78", "views/forms/formhoadoncode78_mtt", "app"], function (invoiceForms, invoiceFormsCode, invoiceFormsCodeMTT, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();
                if (item == null || item == undefined) {
                    webix.message("Bạn chưa chọn hóa đơn !", "error");
                    return;
                }

                if (
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        (item.tthdon == 0 || item.tthdon == 1)) ||
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        item.tthdon == 11)
                ) {
                    var check = true;
                } else {
                    webix.message("Không thể thực hiện chức năng này", "error");
                    return;
                }

                var box = webix.modalbox({
                    title: "Chọn mặt hàng cần điều chỉnh",
                    buttons: ["Nhận", "Hủy bỏ"],
                    text: "<div id='ctnMatHang'></div>",
                    top: 100,
                    width: 750,
                    callback: function (result) {
                        switch (result) {
                            case "0":
                                var tblMatHang = $$("tblMatHang");
                                var array = tblMatHang.serialize();

                                var chons = [];

                                for (var i = 0; i < array.length; i++) {
                                    var chon = array[i];
                                    if (chon.hasOwnProperty("chon")) {
                                        if (chon.chon == true) {
                                            chons.push(chon);
                                        }
                                    }
                                }

                                tblMatHang.destructor();

                                webix.modalbox.hide();
                                // var btnPlus = $$("btnPlus");
                                // btnPlus.callEvent("onClick");
                                var detailForm;
                                var khieu = item.khieu;
                                var windowno = app.path[1].params[0];
                                var app_cache = webix.storage.local.get("APP_CACHE");
                                var windowconfig = app_cache[windowno];
                                var ngay_hoa_don = item.nlap;
                                item.cctbao_id_temp = item.cctbao_id;
                                item.cctbao_id = kyHieuHoaDon.cctbao_id;
                                item.khieu_temp = item.khieu;
                                item.khieu = kyHieuHoaDon.khieu;
                                item.nlap_temp = item.nlap;
                                item.nlap = null;
                                item.shdon_temp = item.shdon;
                                item.shdon = "";
                                item.hdon_id_old = item.hdon_id;
                                item.tthdon_old = item.tthdon;
                                item.tthdon = 19;
                                item.tthdon_original = 19;
                                item.tthai_old = item.tthai;
                                item.nky = "";
                                item.hdon_id = "";

                                // for (var i = 0; i < arrayString.length; i++) {
                                //     item[arrayString[i]] = 0;
                                // }
                                // item["tgtttbchu"] = "";

                                if (khieu.charAt(1) == "C") {
                                    if (khieu.charAt(4) == "M") {
                                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCodeMTT.$ui);
                                        invoiceFormsCodeMTT.initUI(windowconfig);
                                        invoiceFormsCodeMTT.initUINew(kyHieuHoaDon.cctbao_id);
                                        invoiceFormsCodeMTT.setEditMode(1);
                                        invoiceFormsCodeMTT.setValues(item, null);
                                    } else {
                                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCode.$ui);
                                        invoiceFormsCode.initUI(windowconfig);
                                        invoiceFormsCode.initUINew(kyHieuHoaDon.cctbao_id);
                                        invoiceFormsCode.setEditMode(1);
                                        invoiceFormsCode.setValues(item, null);
                                    }
                                } else {
                                    detailForm = $$("invoiceViews").$scope.ui(invoiceForms.$ui);
                                    invoiceForms.initUI(windowconfig);
                                    invoiceForms.initUINew(kyHieuHoaDon.cctbao_id);
                                    invoiceForms.setEditMode(1);
                                    invoiceForms.setValues(item, null);
                                }

                                // var tableDetail_phi = webix.$$("hoadon68_phi");
                                // tableDetail_phi.clearAll();
                                // tableDetail_phi.refreshColumns();

                                var tableDetail = webix.$$("hoadon68_chitiet");
                                tableDetail.clearAll();
                                for (var i = 0; i < chons.length; i++) {
                                    var chon = chons[i];
                                    chon.hdon_id = null;
                                    chon.cthdon_id = null;
                                    chon.id = webix.uid();
                                    tableDetail.add(chon);
                                }
                                tableDetail.refreshColumns();

                                var tablePhi = webix.$$("hoadon68_phi");
                                tablePhi.clearAll()
                                var dataPhi;
                                var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                                webix
                                    .ajax()
                                    .headers({
                                        "Content-type": "application/json",
                                    })
                                    .get(urlPhi, function (text) {
                                        dataPhi = JSON.parse(text);
                                        //tablePhi.parse(data);
                                        if (dataPhi !== undefined) {
                                            for (var i = 0; i < dataPhi.length; i++) {
                                                var dtaPhi = dataPhi[i];
                                                tablePhi.add(dtaPhi);
                                            }
                                        }
                                    });
                                detailForm.show();
                                break;
                            case "1":
                                webix.modalbox.hide();
                                break;
                        }
                    },
                });
                var tblMatHang = webix.ui({
                    container: "ctnMatHang",
                    id: "tblMatHang",
                    view: "datatable",
                    borderless: true,
                    height: 350,
                    columns: [
                        {
                            id: "chon",
                            header: [
                                {
                                    text: "",
                                    content: "masterCheckbox",
                                },
                            ],
                            width: 65,
                            checkValue: true,
                            uncheckValue: false,
                            template: "{common.checkbox()}",
                        },
                        {
                            id: "stt",
                            header: "",
                            width: 30,
                        },
                        {
                            id: "ma",
                            header: _("Mã hàng hóa"),
                            editor: "text",
                            width: 100,
                            editable: true,
                        },
                        {
                            id: "ten",
                            header: _("Tên hàng hóa"),
                            editor: "text",
                            width: 350,
                            editable: true,
                        },
                        {
                            id: "mdvtinh",
                            header: _("ĐVT"),
                            editor: "text",
                            width: 80,
                            editable: true,
                        },
                        {
                            id: "sluong",
                            header: _("Số lương"),
                            editor: "autonumeric",
                            width: 100,
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "dgia",
                            header: _("Đơn giá"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                            // value_change: field.value_change
                        },
                        {
                            id: "thtien",
                            header: _("Tiền trước thuế"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                            // value_change: field.value_change
                        },
                        {
                            id: "tlckhau",
                            header: _("% CK"),
                            width: 80,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "stckhau",
                            header: _("Tiền CK"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "tsuat",
                            header: _("Thuế suất"),
                            width: 100,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "tthue",
                            header: _("Tiền thuế"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "tgtien",
                            header: _("Tiền sau thuế"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                    ],
                });
                var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                webix
                    .ajax()
                    .headers({
                        "Content-type": "application/json",
                    })
                    .get(url, function (text) {
                        var data = JSON.parse(text);

                        var tblMatHang = $$("tblMatHang");
                        tblMatHang.parse(data);
                    });
            });
        },
        ExcuteReduceChangeInvoice: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78", "views/forms/formhoadoncode78", "views/forms/formhoadoncode78_mtt", "app"], function (invoiceForms, invoiceFormsCode, invoiceFormsCodeMTT, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];
                var table = webix.$$("invoiceViews");

                var item = table.getSelectedItem();
                if (item == null || item == undefined) {
                    webix.message("Bạn chưa chọn hóa đơn !", "error");
                    return;
                }

                if (
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        (item.tthdon == 0 || item.tthdon == 1)) ||
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        item.tthdon == 11)
                ) {
                    var check = true;
                } else {
                    webix.message("Không thể thực hiện chức năng này", "error");
                    return;
                }

                var box = webix.modalbox({
                    title: "Chọn mặt hàng cần điều chỉnh",
                    buttons: ["Nhận", "Hủy bỏ"],
                    text: "<div id='ctnMatHang'></div>",
                    top: 100,
                    width: 750,
                    callback: function (result) {
                        switch (result) {
                            case "0":
                                var tblMatHang = $$("tblMatHang");
                                var array = tblMatHang.serialize();

                                var chons = [];

                                for (var i = 0; i < array.length; i++) {
                                    var chon = array[i];
                                    if (chon.hasOwnProperty("chon")) {
                                        if (chon.chon == true) {
                                            chons.push(chon);
                                        }
                                    }
                                }
                                tblMatHang.destructor();

                                webix.modalbox.hide();
                                // var btnPlus = $$("btnPlus");
                                // btnPlus.callEvent("onClick");
                                var detailForm;
                                var khieu = item.khieu;
                                var windowno = app.path[1].params[0];
                                var app_cache = webix.storage.local.get("APP_CACHE");
                                var windowconfig = app_cache[windowno];
                                item.cctbao_id_temp = item.cctbao_id;
                                item.cctbao_id = kyHieuHoaDon.cctbao_id;
                                item.khieu_temp = item.khieu;
                                item.khieu = kyHieuHoaDon.khieu;
                                item.nlap_temp = item.nlap;
                                item.nlap = null;
                                item.shdon_temp = item.shdon;
                                item.shdon = "";
                                item.hdon_id_old = item.hdon_id;
                                item.tthdon_old = item.tthdon;
                                item.tthdon = 21;
                                item.tthdon_original = 21;
                                item.tthai_old = item.tthai;
                                item.nky = "";
                                item.hdon_id = "";
                                item.note = "reduce_change_invoice";

                                // for (var i = 0; i < arrayString.length; i++) {
                                //     item[arrayString[i]] = 0;
                                // }
                                // item["tgtttbchu"] = "";

                                if (khieu.charAt(1) == "C") {
                                    if (khieu.charAt(4) == "M") {
                                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCodeMTT.$ui);
                                        invoiceFormsCodeMTT.initUI(windowconfig);
                                        invoiceFormsCodeMTT.initUINew(kyHieuHoaDon.cctbao_id);
                                        invoiceFormsCodeMTT.setEditMode(1);
                                        invoiceFormsCodeMTT.setValues(item, null);
                                    } else {
                                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCode.$ui);
                                        invoiceFormsCode.initUI(windowconfig);
                                        invoiceFormsCode.initUINew(kyHieuHoaDon.cctbao_id);
                                        invoiceFormsCode.setEditMode(1);
                                        invoiceFormsCode.setValues(item, null);
                                    }
                                } else {
                                    detailForm = $$("invoiceViews").$scope.ui(invoiceForms.$ui);
                                    invoiceForms.initUI(windowconfig);
                                    invoiceForms.initUINew(kyHieuHoaDon.cctbao_id);
                                    invoiceForms.setEditMode(1);
                                    invoiceForms.setValues(item, null);
                                }

                                var ghichu = webix.$$("textGhiChu");
                                ghichu.setValue("Lưu ý: Hóa đơn điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                                ghichu.show();

                                // var tableDetail_phi = webix.$$("hoadon68_phi");
                                // tableDetail_phi.clearAll();
                                // tableDetail_phi.refreshColumns();

                                var tableDetail = webix.$$("hoadon68_chitiet");
                                tableDetail.clearAll();
                                for (var i = 0; i < chons.length; i++) {
                                    var chon = chons[i];
                                    chon.hdon_id = null;
                                    chon.cthdon_id = null;
                                    chon.id = webix.uid();
                                    tableDetail.add(chon);
                                }
                                tableDetail.refreshColumns();

                                var tablePhi = webix.$$("hoadon68_phi");
                                tablePhi.clearAll()
                                var dataPhi;
                                var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                                webix
                                    .ajax()
                                    .headers({
                                        "Content-type": "application/json",
                                    })
                                    .get(urlPhi, function (text) {
                                        dataPhi = JSON.parse(text);
                                        //tablePhi.parse(data);
                                        if (dataPhi !== undefined) {
                                            for (var i = 0; i < dataPhi.length; i++) {
                                                var dtaPhi = dataPhi[i];
                                                tablePhi.add(dtaPhi);
                                            }
                                        }
                                    });
                                console.log(item.khieu);
                                console.log(item.khieu_temp);
                                detailForm.show();
                                break;
                            case "1":
                                webix.modalbox.hide();
                                break;
                        }
                    },
                });
                var tblMatHang = webix.ui({
                    container: "ctnMatHang",
                    id: "tblMatHang",
                    view: "datatable",
                    borderless: true,
                    height: 350,
                    columns: [
                        {
                            id: "chon",
                            header: [
                                {
                                    text: "",
                                    content: "masterCheckbox",
                                },
                            ],
                            width: 65,
                            checkValue: true,
                            uncheckValue: false,
                            template: "{common.checkbox()}",
                        },
                        {
                            id: "stt",
                            header: "",
                            width: 30,
                        },
                        {
                            id: "ma",
                            header: _("Mã hàng hóa"),
                            editor: "text",
                            width: 100,
                            editable: true,
                        },
                        {
                            id: "ten",
                            header: _("Tên hàng hóa"),
                            editor: "text",
                            width: 350,
                            editable: true,
                        },
                        {
                            id: "mdvtinh",
                            header: _("ĐVT"),
                            editor: "text",
                            width: 80,
                            editable: true,
                        },
                        {
                            id: "sluong",
                            header: _("Số lương"),
                            editor: "autonumeric",
                            width: 100,
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "dgia",
                            header: _("Đơn giá"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                            // value_change: field.value_change
                        },
                        {
                            id: "thtien",
                            header: _("Tiền trước thuế"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                            // value_change: field.value_change
                        },
                        {
                            id: "tlckhau",
                            header: _("% CK"),
                            width: 80,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "stckhau",
                            header: _("Tiền CK"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "tsuat",
                            header: _("Thuế suất"),
                            width: 100,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "tthue",
                            header: _("Tiền thuế"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                        {
                            id: "tgtien",
                            header: _("Tiền sau thuế"),
                            width: 150,
                            editor: "autonumeric",
                            editable: true,
                            css: {
                                "text-align": "right",
                            },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 2,
                            }),
                        },
                    ],
                });
                var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                webix
                    .ajax()
                    .headers({
                        "Content-type": "application/json",
                    })
                    .get(url, function (text) {
                        var data = JSON.parse(text);

                        var tblMatHang = $$("tblMatHang");
                        tblMatHang.parse(data);
                    });
            });
        },
        ExcuteInfoChangeInvoice: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78", "views/forms/formhoadoncode78", "views/forms/formhoadoncode78_mtt", "app"], function (invoiceForms, invoiceFormsCode, invoiceFormsCodeMTT, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                    "tgtkcthue",
                    "tgtkhac"
                ];
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();
                if (item == null || item == undefined) {
                    webix.message("Bạn chưa chọn hóa đơn !", "error");
                    return;
                }

                if (
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        (item.tthdon == 0 || item.tthdon == 1)) ||
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        item.tthdon == 11)
                ) {
                    var check = true;
                } else {
                    webix.message("Không thể thực hiện chức năng này", "error");
                    return;
                }

                // var btnPlus = $$("btnPlus");
                // btnPlus.callEvent("onClick");
                // var detailForm = $$("invoiceForms");
                var detailForm;
                var khieu = item.khieu;
                var windowno = app.path[1].params[0];
                var app_cache = webix.storage.local.get("APP_CACHE");
                var windowconfig = app_cache[windowno];
                var ngay_hoa_don = item.nlap;
                item.cctbao_id_temp = item.cctbao_id;
                item.cctbao_id = kyHieuHoaDon.cctbao_id;
                item.khieu_temp = item.khieu;
                item.khieu = kyHieuHoaDon.khieu;
                item.nlap_temp = item.nlap;
                item.nlap = null;
                item.hdon_id_old = item.hdon_id;
                item.tthdon_old = item.tthdon;
                item.tthdon = 23;
                item.tthdon_original = 23;
                item.tthai_old = item.tthai;
                item.shdon_temp = item.shdon;
                item.shdon = "";
                item.nky = "";
                item.hdon_id = "";
                item.mccqthue = "";
                item.tgia = 1;
                item.sdhang = "";
                item.tienthuegtgtgiam = 0;
                item.tiletienthuegtgtgiam = "";
                item.giamthuebanhang20 = false;
                for (var i = 0; i < arrayString.length; i++) {
                    item[arrayString[i]] = 0;
                }
                item["tgtttbchu"] = "";

                if (khieu.charAt(1) == "C") {
                    if (khieu.charAt(4) == "M") {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCodeMTT.$ui);
                        invoiceFormsCodeMTT.initUI(windowconfig);
                        invoiceFormsCodeMTT.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCodeMTT.setEditMode(1);
                        invoiceFormsCodeMTT.setValues(item, null);
                    } else {
                        detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCode.$ui);
                        invoiceFormsCode.initUI(windowconfig);
                        invoiceFormsCode.initUINew(kyHieuHoaDon.cctbao_id);
                        invoiceFormsCode.setEditMode(1);
                        invoiceFormsCode.setValues(item, null);
                    }
                } else {
                    detailForm = $$("invoiceViews").$scope.ui(invoiceForms.$ui);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.initUINew(kyHieuHoaDon.cctbao_id);
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);
                }

                var obj_detail = {
                    id: webix.uid(),
                    kmai: "4",
                    ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu_temp,
                };

                var tableDetail_phi = webix.$$("hoadon68_phi");
                tableDetail_phi.clearAll();
                tableDetail_phi.refreshColumns();

                var tableDetail = webix.$$("hoadon68_chitiet");
                tableDetail.clearAll();
                tableDetail.add(obj_detail);
                var columns = tableDetail.config.columns;
                for (var i = 0; i < columns.length; i++) {
                    var column = columns[i];
                    //column.editor = null;
                }
                // tableDetail.getColumnConfig("sluong").editor = null;
                // tableDetail.getColumnConfig("thtien").editor = null;
                // tableDetail.getColumnConfig("tsuat").editor = null;
                // tableDetail.getColumnConfig("tgtien").editor = null;
                // tableDetail.getColumnConfig("tthue").editor = null;
                tableDetail.refreshColumns();
                tableDetail.refresh();

                detailForm.show();
                while (!detailForm.isVisible()) { }
                $$("hoadon68_phi").clearAll();
            });
        },
        ExcuteCancellingInvoice: function () {
            var table = webix.$$("invoiceViews");

            var datafrm = table.serialize();
            var data = [];

            if (datafrm.length > 0) {
                for (var i = 0; i < datafrm.length; i++) {
                    if (datafrm[i] != undefined) {
                        if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                            data.push(datafrm[i]);
                            var item = datafrm[i];
                            if (item == null || item == undefined) {
                                webix.message("Không tìm thấy thông tin hóa đơn!", "error");
                            }

                            if (
                                ((item.tthai == "Đã ký" ||
                                    item.tthai == "CQT đã nhận" ||
                                    item.tthai == "CQT không tiếp nhận HĐ" ||
                                    item.tthai == "Chờ phản hồi" ||
                                    item.tthai == "Đã cấp mã" ||
                                    item.tthai == "CQT không cấp mã") &&
                                    (item.tthdon == 0 || item.tthdon == 1)) ||
                                (item.tthai == "CQT không tiếp nhận HĐ" && (item.tthdon == 19 || item.tthdon == 21 || item.tthdon == 23)) ||
                                (item.tthai == "CQT không tiếp nhận HĐ" && item.tthdon == 2)
                            ) {
                                var check = true;
                            } else {
                                webix.message("Tồn tại hóa đơn không thể thực hiện chức năng này", "error");
                                return;
                            }
                        }
                    }
                }
            }

            if (data.length > 0) {
                var totalHuy = data.length;

                var strHoaDonSelect = " ";
                for (var i = 0; i < data.length; i++) {
                    if (i < data.length - 1) {
                        strHoaDonSelect += data[i].shdon + ",";
                    } else {
                        strHoaDonSelect += data[i].shdon;
                    }
                }

                webix.confirm({
                    text: "<span style='color: red;'>Xác nhận hủy hóa đơn số " + strHoaDonSelect + " trên MobiFone Invoice.</span><br /> <b><span>Lưu ý</span></b>: Cần làm thông báo 04/SS-HĐĐT để Hủy hóa đơn với CQT",
                    ok: "Có",
                    width: "500px",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            var hoaDonHuy = data.length;
                            for (var i = 0; i < hoaDonHuy; i++) {
                                var idHoaDon = data[i].id;
                                webix
                                    .ajax()
                                    .headers({
                                        "Content-Type": "application/json",
                                    })
                                    .get(app.config.host + "/Invoice68/uploadCanceledInv?id=" + idHoaDon, function (text) {
                                        var response = JSON.parse(text);
                                        if (response.hasOwnProperty("error")) {
                                            webix.message({
                                                type: "error",
                                                text: response.error,
                                            });

                                            table.clearAll();
                                            table.load(table.config.url);

                                            return;
                                        }

                                        totalHuy = totalHuy - 1;

                                        if (totalHuy == 0) {
                                            webix.message("Hóa đơn hủy thành công");

                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    });
                            }
                        }
                    },
                });
            } else {
                webix.message("Chưa tích chọn hóa đơn hủy!", "error");
            }
        },
        ExcuteCancellingInvoicetncn: function () {
            var table = webix.$$("invoiceViews");

            var datafrm = table.serialize();
            var data = [];

            if (datafrm.length > 0) {
                for (var i = 0; i < datafrm.length; i++) {
                    if (datafrm[i] != undefined) {
                        if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                            data.push(datafrm[i]);
                            var item = datafrm[i];
                            if (item == null || item == undefined) {
                                webix.message("Không tìm thấy thông tin chứng từ!", "error");
                            }

                            if (
                                ((item.tthai == "Đã ký" ||
                                    item.tthai == "CQT đã nhận" ||
                                    item.tthai == "CQT không tiếp nhận HĐ" ||
                                    item.tthai == "Chờ phản hồi" ||
                                    item.tthai == "Đã cấp mã" ||
                                    item.tthai == "CQT không cấp mã") &&
                                    (item.tthdon == 0 || item.tthdon == 1)) ||
                                (item.tthai == "CQT không tiếp nhận HĐ" && (item.tthdon == 19 || item.tthdon == 21 || item.tthdon == 23)) ||
                                (item.tthai == "CQT không tiếp nhận HĐ" && item.tthdon == 2)
                            ) {
                                var check = true;
                            } else {
                                webix.message("Tồn tại chứng từ không thể thực hiện chức năng này", "error");
                                return;
                            }
                        }
                    }
                }
            }

            if (data.length > 0) {
                var totalHuy = data.length;
                webix.confirm({
                    text: "Hủy chứng từ trên MobiFone Invoice",
                    ok: "Có",
                    width: "500px",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            var hoaDonHuy = data.length;
                            for (var i = 0; i < hoaDonHuy; i++) {
                                var idHoaDon = data[i].id;
                                webix
                                    .ajax()
                                    .headers({
                                        "Content-Type": "application/json",
                                    })
                                    .get(app.config.host + "/Invoice68/uploadCanceledInv?id=" + idHoaDon, function (text) {
                                        var response = JSON.parse(text);
                                        if (response.hasOwnProperty("error")) {
                                            webix.message({
                                                type: "error",
                                                text: response.error,
                                            });

                                            table.clearAll();
                                            table.load(table.config.url);

                                            return;
                                        }

                                        totalHuy = totalHuy - 1;

                                        if (totalHuy == 0) {
                                            webix.message("Chứng từ hủy thành công");

                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    });
                            }
                        }
                    },
                });
            } else {
                webix.message("Chưa tích chọn chứng từ hủy!", "error");
            }
        },
        ExcuteHUyInvoicebienlai: function () {
            var table = webix.$$("invoiceViews");

            var datafrm = table.serialize();
            var data = [];

            if (datafrm.length > 0) {
                for (var i = 0; i < datafrm.length; i++) {
                    if (datafrm[i] != undefined) {
                        if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                            data.push(datafrm[i]);
                            var item = datafrm[i];
                            if (item == null || item == undefined) {
                                webix.message("Không tìm thấy thông tin biên lai!", "error");
                            }

                            if (
                                ((item.tthai == "Đã ký" ||
                                    item.tthai == "CQT đã nhận" ||
                                    item.tthai == "CQT không tiếp nhận HĐ" ||
                                    item.tthai == "Chờ phản hồi" ||
                                    item.tthai == "Đã cấp mã" ||
                                    item.tthai == "CQT không cấp mã") &&
                                    (item.tthdon == 0 || item.tthdon == 1)) ||
                                (item.tthai == "CQT không tiếp nhận HĐ" && (item.tthdon == 19 || item.tthdon == 21 || item.tthdon == 23)) ||
                                (item.tthai == "CQT không tiếp nhận HĐ" && item.tthdon == 2)
                            ) {
                                var check = true;
                            } else {
                                webix.message("Tồn tại biên lai không thể thực hiện chức năng này", "error");
                                return;
                            }
                        }
                    }
                }
            }

            if (data.length > 0) {
                var totalHuy = data.length;
                webix.confirm({
                    text: "Hủy biên lai trên MobiFone Invoice",
                    ok: "Có",
                    width: "500px",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            var hoaDonHuy = data.length;
                            for (var i = 0; i < hoaDonHuy; i++) {
                                var idHoaDon = data[i].id;
                                webix
                                    .ajax()
                                    .headers({
                                        "Content-Type": "application/json",
                                    })
                                    .get(app.config.host + "/Invoice68/uploadCanceledInv?id=" + idHoaDon, function (text) {
                                        var response = JSON.parse(text);
                                        if (response.hasOwnProperty("error")) {
                                            webix.message({
                                                type: "error",
                                                text: response.error,
                                            });

                                            table.clearAll();
                                            table.load(table.config.url);

                                            return;
                                        }

                                        totalHuy = totalHuy - 1;

                                        if (totalHuy == 0) {
                                            webix.message("Biên lai hủy thành công");

                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    });
                            }
                        }
                    },
                });
            } else {
                webix.message("Chưa tích chọn biên lai hủy!", "error");
            }
        },
        ExcuteCancellingInvoicebienlai: function () {
            require(["views/forms/68_huyhoadon_bienlai", "app"], function (huyhoadon, app) {
                var table = webix.$$("invoiceViews");

                var datafrm = table.serialize();
                var data = [];
                if (datafrm.length > 0) {
                    for (var i = 0; i < datafrm.length; i++) {
                        if (datafrm[i] != undefined) {
                            if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                data.push(datafrm[i]);
                                var item = datafrm[i];
                                if (item == null || item == undefined) {
                                    webix.message("Không tìm thấy thông tin biên lai!", "error");
                                }

                                if (item.tthai == "Đã ký" && item.tthdon != 3 && item.tthdon != 27) {
                                    var check = true;
                                } else {
                                    webix.message("Tồn tại biên lai không thể thực hiện chức năng này", "error");
                                    return;
                                }
                            }
                        }
                    }
                }

                if (data.length > 0) {
                    var cungshd = true;
                    for (var k = 1; k <= data.length - 1; k++) {
                        if (data[k]["stbao"] !== data[0]["stbao"]) {
                            cungshd = false;
                            break;
                        }
                    }
                    if (cungshd === true) {
                        var loai = 1;
                        if (data[0]["stbao"] !== null) {
                            loai = 2;
                        }

                        for (var i = 0; i < data.length; i++) {
                            if (data[i].ladhddt == undefined || data[i].tctbao == undefined) {
                                data[i].ladhddt = "1";
                            }
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();
                        var tongquat = {
                            so: data[0].stbao,
                            ntbccqt: data[0].ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);
                        data.forEach(function (item) {
                            var put = {
                                mcqtcap: item.mccqthue,
                                khieu: item.khieu,
                                shdon: item.shdon,
                                ngay: item.nlap,
                                ladhddt: item.ladhddt,
                                tctbao: 1,
                                hdon_id: item.id,
                            };
                            huyhoadon.setValues(put, null, null);
                            //this.hide();
                            win.show();
                        });
                    } else {
                        webix.message("Các biên lai chọn phải có số thông báo giống nhau", "error");
                    }
                } else {
                    webix.message("Chưa tích chọn biên lai !", "error");
                }
            });
        },
        CheckKhacNull: function (value) {
            if (value === undefined || value === null || value === "") return false;
            else return true;
        },
        DuyetHoaDon: function (lsthdon_id, status) {
            var tableHdon = webix.$$("invoiceViews");
            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                    var result = JSON.parse(text);
                    var kytaptrung = "";
                    for (var i = 0; i < result.length; i++) {
                        var item = result[i];
                        kytaptrung = item.value;
                    }
                    var postData = {
                        lsthdon_id: lsthdon_id,
                    };

                    webix.extend(tableHdon, webix.ProgressBar);
                    tableHdon.disable();
                    tableHdon.showProgress();

                    var dataPut = { data: [postData], status: status };
                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice68/DuyetHoaDon", dataPut, function (text) {
                            var result = JSON.parse(text);
                            var table = webix.$$("invoiceViews");
                            table.enable();
                            table.hideProgress();
                            if (result.hasOwnProperty("error")) {
                                webix.message({ type: "error", text: result.error });
                                return;
                            }

                            if (result.ok == true) {
                                var table = webix.$$("invoiceViews");
                                table.clearAll();
                                table.load(table.config.url);
                                webix.modalbox.hide();
                            }
                        });
                });
        },

        renderFormat: function (val, changeValue, data) {
            if (typeof val == "undefined" || val == null || val == "" || val == 0) val = "VND";
            var table_chitiet = webix.$$("hoadon68_chitiet");

            var table_phi = webix.$$("hoadon68_phi");
            getDecimalPlace(val, function (arr) {
                var arrayString_chitiet = ["sluong", "dgia", "thtien", "stckhau", "tthue", "tgtien", "tienphi", "tlckhau"];

                for (var i = 0; i < arrayString_chitiet.length; i++) {
                    var field_name = "";
                    switch (arrayString_chitiet[i]) {
                        case "sluong":
                            field_name = "quantity_decimal";
                            break;
                        case "dgia":
                            field_name = "price_decimal";
                            break;
                        case "thtien":
                            field_name = "amount_without_vat_decimal";
                            break;
                        case "stckhau":
                            field_name = "price_discount";
                            break;
                        case "tthue":
                            field_name = "tax_price";
                            break;
                        case "tgtien":
                            field_name = "total_amount_decimal";
                            break;
                        case "tienphi":
                            field_name = "fee_price";
                            break;
                        case "tlckhau":
                            field_name = "tlckhau";
                            break;
                        case "tienthuegtgtgiam":
                            field_name = "tienthuegtgtgiam";
                            break;
                    }

                    //var decimal_place = Array(Number(arr[0][field_name]) + 1).join("9");
                    var decimal_format = Number(arr[0][field_name]);
                    var format_numeric = {
                        //maximumValue: Number("999999999999." + decimal_place),
                        //minValue: Number("-999999999999." + decimal_place),
                        decimalPlaces: Number(decimal_format),
                    };
                    var formatSoDefault = {
                        groupDelimiter: ",",
                        groupSize: 3,
                        decimalDelimiter: ".",
                        decimalSize: decimal_format,
                    };

                    var formatSo = webix.Number.numToStr(formatSoDefault);
                    if (field_name == "fee_price") {
                        var format_config = table_phi.getColumnConfig("tienphi");
                        if (format_config.isFmNumber === true) {
                            format_config.format = formatSo;
                            format_config.numericConfig = format_numeric;
                        }
                    } else {
                        var format_config = table_chitiet.getColumnConfig(arrayString_chitiet[i]);
                        if (format_config.isFmNumber === true) {
                            format_config.format = formatSo;
                            format_config.numericConfig = format_numeric;
                        }
                    }
                }

                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",

                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];

                table_chitiet.refreshColumns();
                table_phi.refreshColumns();
                for (var i = 0; i < arrayString.length; i++) {
                    $$(arrayString[i]).refresh();
                }

                if (changeValue == true) {
                    var item = {
                        id: webix.uid(),
                    };

                    table_chitiet.add(item);

                    table_chitiet.select(item.id, "ma", false);
                    table_chitiet.edit({
                        row: item.id,
                        column: "ma",
                    });

                    table_chitiet.editStop();

                    table_chitiet.remove(item.id);
                    table_chitiet.clearSelection();
                }
                var row = table_chitiet.serialize();
                var arrayString_chitiet = ["sluong", "dgia", "thtien", "stckhau", "tthue", "tgtien", "tienphi", "tlckhau"];
                var selectedItem;
                for (var j = 0; j < row.length; j++) {
                    for (var i = 0; i < arrayString_chitiet.length; i++) {
                        selectedItem = row[j];
                        if (arrayString_chitiet[i] == "tienphi") {
                            format_config = table_phi.getColumnConfig(arrayString_chitiet[i]);
                            if (format_config !== undefined && format_config.format !== undefined && webix.rules.isNumber(selectedItem[arrayString_chitiet[i]])) {
                                selectedItem[arrayString_chitiet[i]] = Number(format_config.format(selectedItem[arrayString_chitiet[i]]).replaceAll(",", ""));
                            }
                            table_chitiet.updateItem(selectedItem["id"], selectedItem);
                            table_chitiet.refresh();
                        } else {
                            format_config = table_chitiet.getColumnConfig(arrayString_chitiet[i]);
                            if (format_config !== undefined && format_config.format !== undefined && webix.rules.isNumber(selectedItem[arrayString_chitiet[i]])) {
                                selectedItem[arrayString_chitiet[i]] = Number(format_config.format(selectedItem[arrayString_chitiet[i]]).replaceAll(",", ""));
                            }
                            table_chitiet.updateItem(selectedItem["id"], selectedItem);
                            table_chitiet.refresh();
                        }
                    }
                }
            });
        },

        ExcuteReplaceChungTuTncn: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78tncn", "app"], function (invoiceFormsCode, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();

                if (item == null || item == undefined) {
                    webix.message("Bạn chưa chọn chứng từ !", "error");
                    return;
                }

                if (
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        (item.tthdon == 0 || item.tthdon == 1)) ||
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        item.tthdon == 2) ||
                    (item.tthai == "Chờ phản hồi" && item.tthdon == 3)
                ) {
                    var check = true;
                } else {
                    webix.message("Không thể thực hiện chức năng này", "error");
                    return;
                }

                // var btn = $$("btnPlus");
                // btn.callEvent("onClick");
                //var detailForm = $$("invoiceForms");
                var detailForm;
                var khieu = item.khieu;
                var windowno = app.path[1].params[0];
                var app_cache = webix.storage.local.get("APP_CACHE");
                var windowconfig = app_cache[windowno];
                var ngay_hoa_don = item.nlap;
                item.cctbao_id_temp = item.cctbao_id;
                item.cctbao_id = kyHieuHoaDon.cctbao_id;
                item.khieu_temp = item.khieu;
                item.khieu = kyHieuHoaDon.khieu;
                item.nlap_temp = item.nlap;
                item.nlap = null;
                item.shdon_temp = item.shdon;
                item.shdon = "";
                item.hdon_id_old = item.hdon_id;
                item.tthdon_old = item.tthdon;
                item.tthdon = 2;
                item.tthdon_original = 2;
                item.tthai_old = item.tthai;
                item.nky = "";
                item.hdon_id = "";
                item.loaihdlq = kyHieuHoaDon.loaihdlq;

                for (var i = 0; i < arrayString.length; i++) {
                    item[arrayString[i]] = 0;
                }
                item["tgtttbchu"] = "";


                detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCode.$ui);
                invoiceFormsCode.initUI(windowconfig);
                invoiceFormsCode.initUINew(kyHieuHoaDon.cctbao_id);
                invoiceFormsCode.setEditMode(1);
                invoiceFormsCode.setValues(item, null);

                var tableDetail = webix.$$("hoadon68_chitiet");

                tableDetail.clearAll();
                tableDetail.refresh();

                detailForm.show();
            });
        },

        ExcuteInfoChangeChungTuTncn: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78tncn", "app"], function (invoiceFormsCode, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();
                if (item == null || item == undefined) {
                    webix.message("Bạn chưa chọn chứng từ !", "error");
                    return;
                }
                debugger
                if (
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        (item.tthdon == 0 || item.tthdon == 1)) ||
                    ((item.tthai == "Đã ký" ||
                        item.tthai == "Đã cấp mã" ||
                        item.tthai == "CQT đã nhận" ||
                        item.tthai == "Chấp nhận TBSS" ||
                        item.tthai == "Không chấp nhận TBSS" ||
                        item.tthai == "TBSS sai định dạng" ||
                        item.tthai == "Chờ phản hồi") &&
                        item.tthdon == 11)
                ) {
                    var check = true;
                } else {
                    webix.message("Không thể thực hiện chức năng này", "error");
                    return;
                }

                // var btnPlus = $$("btnPlus");
                // btnPlus.callEvent("onClick");
                // var detailForm = $$("invoiceForms");
                var detailForm;
                var khieu = item.khieu;
                var windowno = app.path[1].params[0];
                var app_cache = webix.storage.local.get("APP_CACHE");
                var windowconfig = app_cache[windowno];
                var ngay_hoa_don = item.nlap;
                item.cctbao_id_temp = item.cctbao_id;
                item.cctbao_id = kyHieuHoaDon.cctbao_id;
                item.khieu_temp = item.khieu;
                item.khieu = kyHieuHoaDon.khieu;
                item.nlap_temp = item.nlap;
                item.nlap = null;
                item.hdon_id_old = item.hdon_id;
                item.tthdon_old = item.tthdon;
                item.tthdon = 5;
                item.tthdon_original = 5;
                item.tthai_old = item.tthai;
                item.shdon_temp = item.shdon;
                item.shdon = "";
                item.nky = "";
                item.hdon_id = "";
                item.mccqthue = "";
                for (var i = 0; i < arrayString.length; i++) {
                    item[arrayString[i]] = 0;
                }
                item["tgtttbchu"] = "";


                detailForm = $$("invoiceViews").$scope.ui(invoiceFormsCode.$ui);
                invoiceFormsCode.initUI(windowconfig);
                invoiceFormsCode.initUINew(kyHieuHoaDon.cctbao_id);
                invoiceFormsCode.setEditMode(1);
                invoiceFormsCode.setValues(item, null);


                var obj_detail = {
                    id: webix.uid(),
                    kmai: "4",
                    ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                };
                var tableDetail = webix.$$("hoadon68_chitiet");
                tableDetail.clearAll();
                tableDetail.add(obj_detail);
                var columns = tableDetail.config.columns;
                for (var i = 0; i < columns.length; i++) {
                    var column = columns[i];
                    //column.editor = null;
                }
                // tableDetail.getColumnConfig("sluong").editor = null;
                // tableDetail.getColumnConfig("thtien").editor = null;
                // tableDetail.getColumnConfig("tsuat").editor = null;
                // tableDetail.getColumnConfig("tgtien").editor = null;
                // tableDetail.getColumnConfig("tthue").editor = null;
                tableDetail.refreshColumns();
                tableDetail.refresh();

                detailForm.show();
            });
        },

        CheckExistKeySession: function (key, check) {
            return true;
            var form = webix.$$("invoiceForms");
            var newInvoice = form.config.newInvoice;
            var valueSession = sessionStorage.getItem(key);
            if (check != undefined) {
                return true;
            } else {
                if (valueSession == undefined || valueSession === null || valueSession === "") {
                    valueSession = 0;
                    valueSession++;
                    sessionStorage.setItem(key, valueSession);
                    if (newInvoice) {
                        return true;
                    }
                    return true;
                }
                valueSession++;
                sessionStorage.setItem(key, valueSession);
                return true;
            }
        },

        roundNumber: function (num, decimals) {
            var n = Number(num).toFixed(decimals);
            return n;
        },

        getAllHD_ValidateHD: function () {
            var returnData = [];
            webix.ajax().sync().get(app.config.host + "/Invoice68/GetListIDDataInvoiceDanhSachChoKy?start=0&count=1000&continue=null&filter=null&tlbparam=null&tthai=Chờ ký", function (text) {
                var data = JSON.parse(text);
                returnData.push(data[0]);
                returnData.push(data[1]);
            });
            return returnData;
        },


        ExcuteReplaceInvoice_KMG: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78bienlai", "app"], function (invoiceForms, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                    "tgtkcthue",
                    "tgtkhac"
                ];
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();

                if (item == null || item == undefined) {
                    webix.message("Bạn chưa chọn biên lai !", "error");
                    return;
                }

                if (((item.tthai == "Đã ký" || item.tthai == "Đã cấp mã" || item.tthai == "CQT đã nhận" || item.tthai == "Chấp nhận TBSS" || item.tthai == "Không chấp nhận TBSS" || item.tthai == "TBSS sai định dạng" || item.tthai == "Chờ phản hồi" || item.tthai == "CQT chấp nhận BC" || item.tthai == "Gửi báo cáo lỗi")
                    && (item.tthdon == 0 || item.tthdon == 1 || item.tthdon == 2))
                    || ((item.tthai == "Chờ phản hồi") && item.tthdon == 3)) {
                    var check = true;
                }
                else {
                    webix.message("Không thể thực hiện chức năng này", "error");
                    return;
                }

                if (item.tthai == "CQT chấp nhận BC" || item.tthai == "Gửi báo cáo lỗi") {
                    webix.confirm({
                        title: "Xác nhận",
                        ok: "Nhận (F10)",
                        cancel: "Hủy bỏ (ESC)",
                        text: "Biên lai đã được gửi báo cáo<br/>Bạn chắc chắn muốn thực hiện thay thế?",
                        type: "confirm-warning",
                        callback: function (result) {
                            if (result) {
                                openInvoiceEditForm(item, arrayString, invoiceForms);
                            }
                        }
                    });
                } else {
                    openInvoiceEditForm(item, arrayString, invoiceForms);
                }

            });
            function openInvoiceEditForm(item, arrayString, invoiceForms) {

                var btnPlus = $$("btnPlus");
                btnPlus.callEvent("onClick");
                var detailForm = $$("invoiceForms");

                var ngay_hoa_don = item.nlap;
                item.cctbao_id_temp = item.cctbao_id;
                item.cctbao_id = kyHieuHoaDon.cctbao_id;
                item.khieu_temp = item.khieu;
                item.khieu = kyHieuHoaDon.khieu;
                item.nlap_temp = item.nlap;
                item.nlap = null;
                item.shdon_temp = item.shdon;
                item.shdon = "";
                item.hdon_id_old = item.hdon_id;
                item.tthdon_old = item.tthdon;
                item.tthdon = 2;
                item.tthdon_original = 2;
                item.tthai_old = item.tthai;
                item.nky = "";
                item.hdon_id = "";
                item.tgia = 1;
                item.sdhang = "";
                item.tienthuegtgtgiam = 0;
                item.tiletienthuegtgtgiam = "";
                item.giamthuebanhang20 = false;

                for (var i = 0; i < arrayString.length; i++) {
                    item[arrayString[i]] = 0;
                }
                item["tgtttbchu"] = "";
                invoiceForms.initUINew(kyHieuHoaDon.cctbao_id);
                invoiceForms.setEditMode(1);
                invoiceForms.setValues(item, null);

                var tableDetail = webix.$$("hoadon68_chitiet");

                tableDetail.clearAll();
                tableDetail.refresh();

                detailForm.show();
                while (!detailForm.isVisible()) { }
                $$("hoadon68_phi").clearAll();
            }
        },

        ExcuteInfoChangeInvoice_BienLai: function (kyHieuHoaDon) {
            require(["views/forms/formhoadon78bienlai", "app"], function (invoiceForms, app) {
                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtkcthue",
                    "tgtkhac"
                ];
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();

                if (item == null || item == undefined) {
                    webix.message("Bạn chưa chọn biên lai !", "error");
                    return;
                }

                if (((item.tthai == "Đã ký" || item.tthai == "Đã cấp mã" || item.tthai == "CQT đã nhận" || item.tthai == "Chấp nhận TBSS" || item.tthai == "Không chấp nhận TBSS" || item.tthai == "TBSS sai định dạng" || item.tthai == "Chờ phản hồi" || item.tthai == "CQT chấp nhận BC" || item.tthai == "Gửi báo cáo lỗi")
                    && (item.tthdon == 0 || item.tthdon == 1 || item.tthdon == 2))
                    || ((item.tthai == "Chờ phản hồi") && item.tthdon == 3)) {
                    var check = true;
                }
                else {
                    webix.message("Không thể thực hiện chức năng này", "error");
                    return;
                }


                if (item.tthai == "CQT chấp nhận BC" || item.tthai == "Gửi báo cáo lỗi") {
                    webix.confirm({
                        title: "Xác nhận",
                        ok: "Nhận (F10)",
                        cancel: "Hủy bỏ (ESC)",
                        text: "Biên lai đã được gửi báo cáo<br/>Bạn chắc chắn muốn thực hiện điều chỉnh?",
                        type: "confirm-warning",
                        callback: function (result) {
                            if (result) {
                                openInvoiceEditForm(item, arrayString, invoiceForms);
                            }
                        }
                    });
                } else {
                    openInvoiceEditForm(item, arrayString, invoiceForms);
                }

            });

            function openInvoiceEditForm(item, arrayString, invoiceForms) {
                var btnPlus = $$("btnPlus");
                btnPlus.callEvent("onClick");

                var ngay_hoa_don = item.nlap;
                item.cctbao_id_temp = item.cctbao_id;
                item.cctbao_id = kyHieuHoaDon.cctbao_id;
                item.khieu_temp = item.khieu;
                item.khieu = kyHieuHoaDon.khieu;
                item.nlap_temp = item.nlap;
                item.nlap = null;
                item.shdon_temp = item.shdon;
                item.shdon = "";
                item.hdon_id_old = item.hdon_id;
                item.tthdon_old = item.tthdon;
                item.tthdon = 5;
                item.tthdon_original = 5;
                item.tthai_old = item.tthai;
                item.nky = "";
                item.hdon_id = "";
                item.tgia = 1;
                item.sdhang = "";
                item.tienthuegtgtgiam = 0;
                item.giamthuebanhang20 = false;

                for (var i = 0; i < arrayString.length; i++) {
                    item[arrayString[i]] = 0;
                }

                invoiceForms.initUINew(kyHieuHoaDon.cctbao_id);
                invoiceForms.setEditMode(1);
                invoiceForms.setValues(item, null);

                var tableDetail = webix.$$("hoadon68_chitiet");
                tableDetail.clearAll();

                $$("hoadon68_phi").clearAll();

                var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                webix
                    .ajax()
                    .headers({
                        "Content-type": "application/json"
                    })
                    .get(url, function (text) {
                        var data = JSON.parse(text);
                        data.forEach(function (item) {
                            item.cthdon_id = null;
                        });
                        var tblMatHang = $$("hoadon68_chitiet");
                        tblMatHang.parse(data);
                    });
            }
        }




    };
});



define('views/forms/68_invoiceForms',["app", "locale", "models/user", "views/commonHD"], function (app, _, user, commonHD) {
    var editmode = 0;
    var mau04 = {};

    var formatSoDefault = {
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0,
    };
    function f(a) {
        return webix.Number.format(a, formatSoDefault);
    }
    function g(a) {
        return webix.Number.parse(a, formatSoDefault);
    }
    /*function fmNumber(a){
        if(a !== undefined)
            return f(a);
        return a;
    };*/
    var fmNumber = {
        parse: function (a) {
            return g(a);
        },
        edit: function (a) {
            if (a !== undefined) return f(a);
            return a;
        },
    };
    var mess = "Tổng tiền chiết khấu lớn hơn tổng tiền hàng hóa thông thương trên hóa đơn. Vui lòng lập riêng hóa đơn chiết khấu mới.";

    function renderFormat(val) {
        if (val === undefined) val = "VND";
        var url = app.config.host + "/Invoice68/GetDecimalPlace?ma_nt=" + val;
        var table_chitiet = webix.$$("hoadon68_chitiet");
        var table_phi = webix.$$("hoadon68_phi");
        var table = $$("invoiceForms");

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .get(url, function (text) {
                var arr = JSON.parse(text);
                var decimal_place = Array(Number(arr[0]["hoadon123"]) + 1).join("9");
                var decimal_format = Number(arr[0]["hoadon123"]);
                var format_numeric = {
                    //maximumValue: Number("999999999999." + decimal_place),
                    //minValue: Number("-999999999999." + decimal_place),
                    decimalPlaces: Number(decimal_format),
                };
                formatSoDefault = {
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: decimal_format,
                };

                var formatSo = webix.Number.numToStr(formatSoDefault);

                var arrayString_chitiet = ["sluong", "dgia", "thtien", "stckhau", "tthue", "tgtien"];
                for (var i = 0; i < arrayString_chitiet.length; i++) {
                    var format_config = table_chitiet.getColumnConfig(arrayString_chitiet[i]);

                    format_config.format = formatSo;

                    format_config.numericConfig = format_numeric;
                }

                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];

                var format_config_phi = table_phi.getColumnConfig("tienphi");
                format_config_phi.format = formatSo;
                format_config_phi.numericConfig = format_numeric;

                table_chitiet.refreshColumns();
                table_phi.refreshColumns();

                for (var i = 0; i < arrayString.length; i++) {
                    $$(arrayString[i]).refresh();
                }
            });
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-iconInvoice",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formInvoice",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Hóa đơn 01GTGT<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_InvoiceForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "invoice68",
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () { },
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "invoiceForms",
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {
                    // }
                },
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: "fieldset",
                                            label: "Thông tin hóa đơn",
                                            body: {
                                                rows: [
                                                    {
                                                        cols: [
                                                            { view: "text", label: "cctbao_id", id: "cctbao_id", name: "cctbao_id", hidden: true },
                                                            {
                                                                view: "datepicker",
                                                                name: "nlap",
                                                                label: "Ngày hóa đơn",
                                                                //labelPosition: "top",
                                                                id: "nlap",
                                                                required: true,
                                                            },
                                                            {
                                                                view: "text",
                                                                name: "shdon",
                                                                id: "shdon",
                                                                label: "Số HĐ",
                                                                css: "mcls_readonly_text",
                                                                readonly: true,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: "text",
                                                                label: _("Ký hiệu"),
                                                                name: "khieu",
                                                                css: "mcls_readonly_text",
                                                                readonly: true,
                                                                id: "khieu",
                                                                // type:"number",
                                                                attributes: { maxlength: 7 },
                                                            },
                                                            {
                                                                view: "text",
                                                                label: _("Số đơn hàng"),
                                                                name: "sdhang",
                                                                id: "sdhang",
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: "combo",
                                                                name: "dvtte",
                                                                label: "Mã tiền tệ",
                                                                //labelPosition: "top",
                                                                id: "dvtte",
                                                                required: true,
                                                                value: "VND",
                                                                invalidMessage: "Trạng thái hóa đơn không thể bỏ trống !",
                                                                options: {
                                                                    view: "gridsuggest",
                                                                    value: "VND",
                                                                    template: "#value#",
                                                                    url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00188",
                                                                    body: {
                                                                        columns: [{ id: "value", header: _("Mã tiền tệ"), width: 120 }],
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) {
                                                                                this.load(this.config.url);
                                                                                return;
                                                                            }

                                                                            var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00188";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        },
                                                                    },
                                                                },
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        commonHD.renderFormat(newv);
                                                                        var type_curency = $$("dvtte").getValue();

                                                                        if (type_curency != "VND") {
                                                                            $$("docngoaitetv").show();
                                                                            //$$("docngoaitetv").setValue(1);
                                                                        } else {
                                                                            $$("docngoaitetv").hide();
                                                                        }

                                                                        commonHD.ExeCuteCheckReadCurencyTV($$("docngoaitetv").getValue());
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "checkbox",
                                                                id: "docngoaitetv",
                                                                name: "docngoaitetv",
                                                                value: 0,
                                                                labelRight: _("Đọc ngoại tệ Tiếng Việt"),
                                                                labelWidth: 2,
                                                                width: 180,
                                                                hidden: true,
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        commonHD.ExeCuteCheckReadCurencyTV(newv);
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "text",
                                                                label: "Tỷ giá",
                                                                type: "number",
                                                                value: 1,
                                                                name: "tgia",
                                                                id: "tgia",
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        if (newv == undefined) return;
                                                                        if (newv == "") return;
                                                                        if (!webix.rules.isNumber(newv)) {
                                                                            webix.message("Tỷ giá phải nhập số", "error");
                                                                            this.focus();
                                                                            return;
                                                                        }
                                                                    },
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: "combo",
                                                        name: "htttoan",
                                                        label: "HT thanh toán",
                                                        //labelPosition: "top",
                                                        value: "đồng",
                                                        id: "htttoan",
                                                        value: "Tiền mặt/Chuyển khoản",
                                                        options: {
                                                            view: "gridsuggest",
                                                            template: "#name#",
                                                            value: "Tiền mặt/Chuyển khoản",
                                                            body: {
                                                                scroll: true,
                                                                autoheight: false,
                                                                columns: [
                                                                    // { id: "id", header: _("MS_THUE"), width: 150 },
                                                                    { id: "code", header: _("Mã ngoại tệ"), width: 150 },
                                                                    { id: "name", header: _("Tên ngoại tệ"), width: 550 },
                                                                ],
                                                                dataFeed: function (filtervalue, filter) {
                                                                    if (filtervalue.length < 1) return;

                                                                    var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00252";
                                                                    var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                    this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                },
                                                            },
                                                            url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00252",
                                                        },
                                                        on: {},
                                                    },
                                                    {
                                                        cols: [
                                                            { view: "text", label: _("STK người bán"), name: "stknban", id: "stknban" },
                                                            { view: "text", label: _("Ngân hàng"), name: "tnhban", id: "tnhban" },
                                                        ],
                                                    },
                                                    {},
                                                ],
                                            },
                                        },
                                        {
                                            view: "fieldset",
                                            label: "Thông tin khách hàng",
                                            body: {
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                view: "text",
                                                                editor: "textsearch",
                                                                label: "Mã khách hàng",
                                                                id: "mnmua",
                                                                name: "mnmua",
                                                                suggest: {
                                                                    view: "gridsuggest",
                                                                    columnName: "code",
                                                                    body: {
                                                                        columns: [
                                                                            { id: "id", hidden: true, header: "id" },
                                                                            { id: "code", width: 120, header: "code" },
                                                                            { id: "name", width: 350, header: "name" },
                                                                        ],
                                                                        scroll: true,
                                                                        autoheight: false,
                                                                        datatype: "json",
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) return;

                                                                            var refid = this.config.refid;
                                                                            var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00002";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        },
                                                                    },
                                                                    on: {
                                                                        onValueSuggest: function (obj) {
                                                                            var table = $$("invoiceForms");
                                                                            var selectedItem = $$("invoiceForms").getValues();

                                                                            selectedItem["mnmua"] = obj["code"];
                                                                            selectedItem["tnmua"] = obj["buyer_name"];
                                                                            selectedItem["ten"] = obj["name"];
                                                                            selectedItem["dchi"] = obj["address"];
                                                                            selectedItem["mst"] = obj["tax_code"];
                                                                            selectedItem["email"] = obj["email"];
                                                                            selectedItem["stknmua"] = obj["bank_account"];
                                                                            table.setValues(selectedItem);
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                id: "mst",
                                                                name: "mst",
                                                                view: "search",
                                                                label: "Mã số thuế",
                                                                //align: "center",
                                                                validate: webix.rules.isTaxCode,
                                                                invalidMessage: "Mã số thuế không hợp lệ",
                                                                placeholder: _("SEARCH") + "...",
                                                                // width: 300,
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        if (newv == undefined) return;
                                                                        if (newv == "") return;
                                                                        if (!webix.rules.isTaxCode(newv)) {
                                                                            webix.message("Mã số thuế không hợp lệ", "error");
                                                                            this.focus();
                                                                            return;
                                                                        }
                                                                        // if (newv.length != 11) {
                                                                        //     webix.message({ type: "error", text: "Độ dài mẫu số phải là 11 ký tự" });
                                                                        //     this.focus();
                                                                        //     return;
                                                                        // }
                                                                    },
                                                                    onTimedKeyPress: function () {
                                                                        // var table = $$("tblSearch");
                                                                        // table.clearAll();
                                                                        // table.load(table.config.url);
                                                                    },
                                                                    onSearchIconClick: function (e) {
                                                                        //get value của form hiện tại để đổi giá trị
                                                                        var mst = this.getValue();
                                                                        // window.location.href = "http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst;
                                                                        window.open("http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst);
                                                                    },
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        cols: [
                                                            { view: "text", label: _("Tên người mua"), name: "tnmua", id: "tnmua" },
                                                            {
                                                                view: "text",
                                                                label: _("Email"),
                                                                name: "email",
                                                                id: "email",
                                                                validate: function (value) {
                                                                    if (value) {
                                                                        var re = /\S+@\S+\.\S+/;
                                                                        return re.test(value);
                                                                    }
                                                                    return true;
                                                                },
                                                                invalidMessage: "Bạn nhập không đúng email",
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: "text",
                                                        label: _("Tên đơn vị"),
                                                        name: "ten",
                                                        id: "ten",
                                                        validate: function (value) {
                                                            var item = $$("invoiceForms").getValues();
                                                            if (item["mst"] && item["mst"] !== null && (!value || value === null)) {
                                                                return false;
                                                            }
                                                            return true;
                                                        },
                                                        invalidMessage: "Bắt buộc khi có mã số thuế",
                                                    },
                                                    { view: "text", label: _("Địa chỉ"), name: "dchi", id: "dchi" },
                                                    {
                                                        cols: [
                                                            { view: "text", label: _("STK người mua"), name: "stknmua", id: "stknmua" },
                                                            { view: "text", label: _("Ngân hàng"), name: "tnhmua", id: "tnhmua" },
                                                        ],
                                                    },
                                                    {
                                                        view: "text",
                                                        label: _("Số điện thoại"),
                                                        name: "sdtnmua",
                                                        id: "sdtnmua",
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 300,
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết hóa đơn",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    {
                                                        id: "mainInvoiceManage",
                                                        css: {
                                                            "padding-bottom": "5px !important",
                                                        },
                                                        cols: [
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                                id: "addrow",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_chitiet");
                                                                        var item = {
                                                                            id: webix.uid(),
                                                                        };
                                                                        table.add(item);
                                                                        table.select(item.id, "ma", false);
                                                                        table.edit({
                                                                            row: item.id,
                                                                            column: "ma",
                                                                        });
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                                id: "removerow",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_chitiet");

                                                                        table.editStop();

                                                                        var item = table.getSelectedItem();

                                                                        if (!webix.isUndefined(item)) {
                                                                            table.remove(item.id);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }

                                                                        var editor = table.getEditState();

                                                                        if (!webix.isUndefined(editor)) {
                                                                            table.remove(editor.row);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                                view: "button",
                                                                id: "copyrow",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_chitiet");

                                                                        table.editStop();

                                                                        var item = table.getSelectedItem();
                                                                        if (item == null || item == undefined) {
                                                                            webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                            return;
                                                                        }
                                                                        var copy = webix.copy(item);
                                                                        copy.id = webix.uid();

                                                                        table.add(copy);
                                                                        table.unselect(item.id);
                                                                        table.select(copy.id, "ma", false);
                                                                        table.edit({
                                                                            row: copy.id,
                                                                            column: "ma",
                                                                        });
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "checkbox",
                                                                id: "check_chietkhau",
                                                                value: 0,
                                                                labelRight: _("Chiết khấu"),
                                                                labelWidth: 2,
                                                                tooltip: "Tích vào đây nếu hóa đơn có chiết khấu",
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        if (newv == 1) {
                                                                            $$("hoadon68_chitiet").showColumn("stckhau");
                                                                            $$("hoadon68_chitiet").showColumn("tlckhau");
                                                                        } else {
                                                                            $$("hoadon68_chitiet").hideColumn("stckhau");
                                                                            $$("hoadon68_chitiet").hideColumn("tlckhau");
                                                                        }
                                                                    },
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: "hoadon68_chitiet",
                                                        editable: true,
                                                        select: "cell",
                                                        drag: true,
                                                        scroll: true,
                                                        columns: [
                                                            {
                                                                id: "stt",
                                                                header: "",
                                                                width: 30,
                                                            },
                                                            {
                                                                id: "ma",
                                                                header: _("Mã hàng hóa"),
                                                                editor: "textsearch",
                                                                width: 100,
                                                                editable: true,
                                                                suggest: {
                                                                    view: "gridsuggest",
                                                                    columnName: "ma_hanghoa",
                                                                    body: {
                                                                        columns: [
                                                                            { id: "id", hidden: true, header: "id" },
                                                                            { id: "code", width: 120, header: "code" },
                                                                            { id: "name", width: 350, header: "name" },
                                                                        ],
                                                                        scroll: true,
                                                                        autoheight: false,
                                                                        datatype: "json",
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) return;

                                                                            var refid = this.config.refid;
                                                                            var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00005";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        },
                                                                    },
                                                                    on: {
                                                                        onValueSuggest: function (obj) {
                                                                            var table = $$("hoadon68_chitiet");
                                                                            var selectedItem = table.getSelectedItem();
                                                                            selectedItem["ma"] = obj["code"];
                                                                            selectedItem["ten"] = obj["name"];
                                                                            selectedItem["mdvtinh"] = obj["unit_code"];
                                                                            selectedItem["dgia"] = obj["unit_price"];
                                                                            selectedItem["tsuat"] = obj["vat_type"];
                                                                            selectedItem["tsuatstr"] = obj["vat_name"];
                                                                            table.updateItem(selectedItem.id, selectedItem);
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                id: "ten",
                                                                header: _("Tên hàng hóa"),
                                                                editor: "text",
                                                                width: 350,
                                                                editable: true,
                                                            },
                                                            {
                                                                id: "mdvtinh",
                                                                header: _("ĐVT"),
                                                                editor: "text",
                                                                width: 80,
                                                                editable: true,
                                                                suggest: {
                                                                    view: "gridsuggest",
                                                                    columnName: "name",
                                                                    body: {
                                                                        columns: [
                                                                            { id: "id", hidden: true, header: "id" },
                                                                            { id: "name", width: 120, header: "name" },
                                                                        ],
                                                                        scroll: true,
                                                                        autoheight: false,
                                                                        datatype: "json",
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) return;

                                                                            var refid = this.config.refid;
                                                                            var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00035";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        },
                                                                    },
                                                                    on: {
                                                                        onValueSuggest: function (obj) {
                                                                            var table = $$("hoadon68_chitiet");
                                                                            var selectedItem = table.getSelectedItem();
                                                                            selectedItem["mdvtinh"] = obj["code"];

                                                                            table.updateItem(selectedItem.id, selectedItem);
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                id: "sluong",
                                                                header: _("Số lượng"),
                                                                editor: "autonumeric",
                                                                width: 100,
                                                                editable: true,
                                                                css: {
                                                                    "text-align": "right",
                                                                },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "dgia",
                                                                header: _("Đơn giá"),
                                                                width: 150,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                css: {
                                                                    "text-align": "right",
                                                                },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "thtien",
                                                                header: _("Tiền trước thuế"),
                                                                width: 150,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                css: {
                                                                    "text-align": "right",
                                                                },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "tlckhau",
                                                                header: _("% CK"),
                                                                width: 80,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                hidden: true,
                                                                css: {
                                                                    "text-align": "right",
                                                                },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "stckhau",
                                                                header: _("Tiền CK"),
                                                                width: 150,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                css: {
                                                                    "text-align": "right",
                                                                },
                                                                hidden: true,
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "tsuat",
                                                                header: _("Thuế suất"),
                                                                width: 100,
                                                                editor: "combo",
                                                                //editor: "autonumeric",
                                                                editable: true,
                                                                css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        var table = $$("hoadon68_chitiet");
                                                                        var selectedItem = table.getSelectedItem();
                                                                        if (newv == -1) selectedItem["tsuatstr"] = "KCT";
                                                                        if (newv == -2) selectedItem["tsuatstr"] = "KKKNT";
                                                                        table.updateItem(selectedItem.id, selectedItem);
                                                                    },
                                                                },
                                                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00019",
                                                                optionslist: true,
                                                            },
                                                            {
                                                                id: "tthue",
                                                                header: _("Tiền thuế"),
                                                                width: 150,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "tgtien",
                                                                header: _("Tiền sau thuế"),
                                                                width: 150,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "kmai",
                                                                name: "kmai",
                                                                header: _("Tính chất"),
                                                                width: 200,
                                                                editor: "combo",
                                                                editable: true,
                                                                value: "1",
                                                                options: [
                                                                    { id: "1", value: "Hàng hóa dịch vụ" },
                                                                    { id: "2", value: "Khuyến mại" },
                                                                    { id: "3", value: "Chiếu khấu thương mại" },
                                                                    { id: "4", value: "Ghi chú" },
                                                                ],
                                                            },
                                                        ],
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                });
                                                            },
                                                            onAfterLoad: function () {
                                                                var table = this;
                                                                var data = table.serialize();

                                                                data.forEach(function (entry) {
                                                                    if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                        if (entry["stckhau"] != 0 || entry["tlckhau"] != 0) {
                                                                            var ck = $$("check_chietkhau");
                                                                            if (ck != undefined) {
                                                                                ck.setValue(1);
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                            },
                                                            onCheck: function (row, column, state) {
                                                                var table = this;
                                                                if (column == "khuyen_mai") {
                                                                    if (state == true) {
                                                                    }
                                                                }
                                                            },
                                                            onAfterAdd: function (id, index) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();

                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0;
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0;
                                                                data.forEach(function (entry) {
                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];
                                                                });
                                                            },
                                                            onAfterDelete: function (id) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();
                                                                var tien_tt_all = 0;
                                                                var tien_thue_all = 0;
                                                                var tien_ck_all = 0;
                                                                var tong_tien_all = 0;

                                                                var tien_tt_10 = 0;
                                                                var tien_thue_10 = 0;
                                                                var tien_ck_10 = 0;
                                                                var tong_tien_10 = 0;

                                                                var tien_tt_5 = 0;
                                                                var tien_thue_5 = 0;
                                                                var tien_ck_5 = 0;
                                                                var tong_tien_5 = 0;

                                                                var tien_tt_0 = 0;
                                                                var tien_thue_0 = 0;
                                                                var tien_ck_0 = 0;
                                                                var tong_tien_0 = 0;

                                                                var tien_tt_k = 0;
                                                                var tien_thue_k = 0;
                                                                var tien_ck_k = 0;
                                                                var tong_tien_k = 0;

                                                                var tien_tt_kct = 0;
                                                                var tien_thue_kct = 0;
                                                                var tien_ck_kct = 0;
                                                                var tong_tien_kct = 0;

                                                                var tien_tt_kkk = 0;
                                                                var tien_thue_kkk = 0;
                                                                var tien_ck_kkk = 0;
                                                                var tong_tien_kkk = 0;

                                                                data.forEach(function (entry) {
                                                                    if (entry.kmai && (entry.kmai.toString() === "1" || entry.kmai.toString() === "3")) {
                                                                        if (entry.kmai.toString() === "1") {
                                                                            tien_tt_all += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                            tien_thue_all += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                            tien_ck_all += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                            tong_tien_all += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            if (entry["tsuat"] == 10) {
                                                                                tien_tt_10 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_10 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_10 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_10 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 5) {
                                                                                tien_tt_5 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_5 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_5 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_5 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 0) {
                                                                                tien_tt_0 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_0 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_0 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_0 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -1) {
                                                                                tien_tt_kct += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kct += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kct += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kct += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -2) {
                                                                                tien_tt_kkk += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kkk += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kkk += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kkk += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else {
                                                                                tien_tt_k += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_k += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_k += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_k += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            }
                                                                        } else {
                                                                            tien_tt_all -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                            tien_thue_all -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                            tien_ck_all -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                            tong_tien_all -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            if (entry["tsuat"] == 10) {
                                                                                tien_tt_10 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_10 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_10 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_10 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 5) {
                                                                                tien_tt_5 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_5 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_5 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_5 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 0) {
                                                                                tien_tt_0 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_0 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_0 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_0 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -1) {
                                                                                tien_tt_kct -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kct -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kct -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kct -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -2) {
                                                                                tien_tt_kkk -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kkk -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kkk -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kkk -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else {
                                                                                tien_tt_k -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_k -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_k -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_k -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            }
                                                                        }
                                                                    }
                                                                });

                                                                $$("tgtcthue").setValue(tien_tt_all);
                                                                $$("tgtcthue10").setValue(tien_tt_10);
                                                                $$("tgtcthue5").setValue(tien_tt_5);
                                                                $$("tgtcthue0").setValue(tien_tt_0);
                                                                $$("tgtcthuek").setValue(tien_tt_k);
                                                                $$("tgtcthuekct").setValue(tien_tt_kct);
                                                                $$("tgtcthuekkk").setValue(tien_tt_kkk);

                                                                $$("ttcktmai").setValue(tien_ck_all);
                                                                $$("ttcktmai10").setValue(tien_ck_10);
                                                                $$("ttcktmai5").setValue(tien_ck_5);
                                                                $$("ttcktmai0").setValue(tien_ck_0);
                                                                $$("ttcktmaik").setValue(tien_ck_k);
                                                                $$("ttcktmaikct").setValue(tien_ck_kct);
                                                                $$("ttcktmaikkk").setValue(tien_ck_kkk);

                                                                $$("tgtthue").setValue(tien_thue_all);
                                                                $$("tgtthue10").setValue(tien_thue_10);
                                                                $$("tgtthue5").setValue(tien_thue_5);
                                                                $$("tgtthue0").setValue(tien_thue_0);
                                                                $$("tgtthuek").setValue(tien_thue_k);
                                                                $$("tgtthuekct").setValue(tien_thue_kct);
                                                                $$("tgtthuekkk").setValue(tien_thue_kkk);

                                                                $$("tgtttbso").setValue(tong_tien_all);
                                                                $$("tgtttbso10").setValue(tong_tien_10);
                                                                $$("tgtttbso5").setValue(tong_tien_5);
                                                                $$("tgtttbso0").setValue(tong_tien_0);
                                                                $$("tgtttbsok").setValue(tong_tien_k);
                                                                $$("tgtttbsokct").setValue(tong_tien_kct);
                                                                $$("tgtttbsokkk").setValue(tong_tien_kkk);

                                                                //if ($$("tkcktmn").getValue() != null && $$("tkcktmn").getValue() != "") tong_tien_all -= Number($$("tkcktmn").getValue());
                                                                if ($$("tgtphi").getValue() != null && $$("tgtphi").getValue() != "") tong_tien_all += Number($$("tgtphi").getValue());

                                                                $$("tgtttbso_last").setValue(tong_tien_all);
                                                                var tien_chietkhauthuongmai = 0;
                                                                data.forEach(function (entry) {
                                                                    if (entry["kmai"] && entry["kmai"].toString() == "3") {
                                                                        tien_chietkhauthuongmai += entry["tgtien"] == null ? 0 : Number(entry["tgtien"]);
                                                                    }
                                                                });
                                                                $$("tkcktmn").setValue(tien_chietkhauthuongmai);
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                var table_inv_views = webix.$$("invoiceViews");
                                                                var item_inv = table_inv_views.getSelectedItem();
                                                                var item_note = "";
                                                                if (item_inv != undefined && item_inv.hasOwnProperty("note") == true) {
                                                                    item_note = item_inv.note ? item_inv.note : "";
                                                                }
                                                                var table = $$(this.config.id);
                                                                1;
                                                                var selectedItem = table.getItem(editor.row);
                                                                var columnId = editor.config.id;
                                                                if (!selectedItem.kmai) selectedItem.kmai = "1";
                                                                var so_luong = webix.rules.isNumber(selectedItem.sluong) ? selectedItem.sluong : 0;
                                                                var don_gia = webix.rules.isNumber(selectedItem.dgia) ? selectedItem.dgia : 0;
                                                                var tien_tt = webix.rules.isNumber(selectedItem.thtien) ? selectedItem.thtien : 0;
                                                                var pt_ck = webix.rules.isNumber(selectedItem.tlckhau) ? selectedItem.tlckhau : 0;
                                                                var tien_ck = webix.rules.isNumber(selectedItem.stckhau) ? selectedItem.stckhau : 0;
                                                                var pt_thue = webix.rules.isNumber(selectedItem.tsuat) ? selectedItem.tsuat : 0;
                                                                var tien_thue = webix.rules.isNumber(selectedItem.tthue) ? selectedItem.tthue : 0;
                                                                var tong_tien = webix.rules.isNumber(selectedItem.tgtien) ? selectedItem.tgtien : 0;
                                                                if (
                                                                    columnId == "tsuat" ||
                                                                    columnId == "sluong" ||
                                                                    columnId == "dgia" ||
                                                                    columnId == "tlckhau" ||
                                                                    columnId == "tsuatstr" ||
                                                                    columnId == "kmai" ||
                                                                    columnId == "ma"
                                                                ) {
                                                                    tien_tt += tien_ck;
                                                                    if (item_note != "reduce_change_invoice") {
                                                                        if (don_gia < 0) {
                                                                            don_gia = 0;
                                                                        }
                                                                    }

                                                                    if (so_luong < 0) {
                                                                        so_luong = 0;
                                                                    }

                                                                    if (!(item_note == "reduce_change_invoice") && don_gia > 0) {
                                                                        tien_tt = so_luong * don_gia;
                                                                    } else tien_tt = so_luong * don_gia;

                                                                    if (pt_ck < 0) {
                                                                        pt_ck = 0;
                                                                    }
                                                                    if (pt_ck > 100) {
                                                                        pt_ck = 0;
                                                                    }
                                                                    tien_ck = (tien_tt * pt_ck) / 100;
                                                                    if (!(item_note == "reduce_change_invoice") && tien_ck - tien_tt > 0) {
                                                                        tien_ck = 0;
                                                                    }
                                                                    if (selectedItem.kmai != 1) tien_ck = 0;
                                                                    tien_thue = ((tien_tt - tien_ck) * (pt_thue < 0 ? 0 : pt_thue)) / 100;
                                                                    tong_tien = tien_tt - tien_ck + parseFloat(tien_thue);

                                                                    if (item_note == "reduce_change_invoice") {
                                                                        if (don_gia > 0) {
                                                                            don_gia = don_gia * -1;
                                                                            tien_tt = so_luong * don_gia;
                                                                            tien_ck = tien_ck * -1;
                                                                            tien_thue = tien_thue * -1;
                                                                            tong_tien = tong_tien * -1;
                                                                        }
                                                                    }
                                                                    tien_tt -= tien_ck;
                                                                    selectedItem.sluong = so_luong;
                                                                    selectedItem.dgia = don_gia;
                                                                    //selectedItem.tsuat = pt_thue;
                                                                    selectedItem.thtien = tien_tt;
                                                                    selectedItem.tlckhau = pt_ck;
                                                                    selectedItem.stckhau = tien_ck;
                                                                    selectedItem.tthue = tien_thue;
                                                                    /*if(selectedItem.kmai.toString() !== "3"){
                                                                    }*/
                                                                    selectedItem.tgtien = tong_tien;
                                                                }

                                                                table.updateItem(selectedItem.id, selectedItem);
                                                                if (selectedItem.kmai.toString() === "2") {
                                                                    //selectedItem.sluong = null;
                                                                    //selectedItem.dgia = null;
                                                                    //selectedItem.tsuat = null;
                                                                    //selectedItem.tsuatstr = null;
                                                                    selectedItem.thtien = 0;
                                                                    //selectedItem.tlckhau = null;
                                                                    //selectedItem.stckhau = null;
                                                                    selectedItem.tthue = 0;
                                                                    selectedItem.tgtien = 0;
                                                                    if (columnId == "kmai") {
                                                                        selectedItem.sluong = null;
                                                                        selectedItem.dgia = null;
                                                                        selectedItem.tsuat = null;
                                                                        selectedItem.tsuatstr = null;
                                                                        selectedItem.tlckhau = null;
                                                                        selectedItem.stckhau = null;
                                                                    }
                                                                    table.updateItem(selectedItem.id, selectedItem);
                                                                } else if (selectedItem.kmai.toString() === "3") {
                                                                    //selectedItem.tsuat = "0";
                                                                    //selectedItem.tsuatstr = "0%";
                                                                    selectedItem.tlckhau = null;
                                                                    selectedItem.stckhau = null;
                                                                    //selectedItem.tthue = 0;
                                                                    /*if(columnId !== "tgtien"){
                                                                         selectedItem.tgtien = selectedItem.thtien
                                                                     }*/
                                                                } else if (selectedItem.kmai.toString() === "4") {
                                                                    selectedItem.sluong = null;
                                                                    selectedItem.dgia = null;
                                                                    selectedItem.tsuat = null;
                                                                    selectedItem.tsuatstr = null;
                                                                    selectedItem.thtien = null;
                                                                    selectedItem.tlckhau = null;
                                                                    selectedItem.stckhau = null;
                                                                    selectedItem.tthue = null;
                                                                    selectedItem.tgtien = null;
                                                                    table.updateItem(selectedItem.id, selectedItem);
                                                                }
                                                                var data = table.serialize();

                                                                var tien_tt_all = 0;
                                                                var tien_thue_all = 0;
                                                                var tien_ck_all = 0;
                                                                var tong_tien_all = 0;

                                                                var tien_tt_10 = 0;
                                                                var tien_thue_10 = 0;
                                                                var tien_ck_10 = 0;
                                                                var tong_tien_10 = 0;

                                                                var tien_tt_5 = 0;
                                                                var tien_thue_5 = 0;
                                                                var tien_ck_5 = 0;
                                                                var tong_tien_5 = 0;

                                                                var tien_tt_0 = 0;
                                                                var tien_thue_0 = 0;
                                                                var tien_ck_0 = 0;
                                                                var tong_tien_0 = 0;

                                                                var tien_tt_k = 0;
                                                                var tien_thue_k = 0;
                                                                var tien_ck_k = 0;
                                                                var tong_tien_k = 0;

                                                                var tien_tt_kct = 0;
                                                                var tien_thue_kct = 0;
                                                                var tien_ck_kct = 0;
                                                                var tong_tien_kct = 0;

                                                                var tien_tt_kkk = 0;
                                                                var tien_thue_kkk = 0;
                                                                var tien_ck_kkk = 0;
                                                                var tong_tien_kkk = 0;

                                                                data.forEach(function (entry) {
                                                                    if (entry.kmai && (entry.kmai.toString() === "1" || entry.kmai.toString() === "3")) {
                                                                        if (entry.kmai.toString() === "1") {
                                                                            tien_tt_all += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                            tien_thue_all += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                            tien_ck_all += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                            tong_tien_all += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            if (entry["tsuat"] == 10) {
                                                                                tien_tt_10 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_10 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_10 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_10 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 5) {
                                                                                tien_tt_5 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_5 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_5 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_5 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 0) {
                                                                                tien_tt_0 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_0 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_0 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_0 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -1) {
                                                                                tien_tt_kct += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kct += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kct += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kct += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -2) {
                                                                                tien_tt_kkk += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kkk += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kkk += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kkk += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else {
                                                                                tien_tt_k += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_k += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_k += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_k += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            }
                                                                        } else {
                                                                            tien_tt_all -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                            tien_thue_all -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                            tien_ck_all -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                            tong_tien_all -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            if (entry["tsuat"] == 10) {
                                                                                tien_tt_10 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_10 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_10 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_10 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 5) {
                                                                                tien_tt_5 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_5 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_5 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_5 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 0) {
                                                                                tien_tt_0 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_0 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_0 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_0 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -1) {
                                                                                tien_tt_kct -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kct -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kct -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kct -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -2) {
                                                                                tien_tt_kkk -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kkk -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kkk -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kkk -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else {
                                                                                tien_tt_k -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_k -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_k -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_k -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            }
                                                                        }
                                                                    }
                                                                });

                                                                $$("tgtcthue").setValue(tien_tt_all);
                                                                $$("tgtcthue10").setValue(tien_tt_10);
                                                                $$("tgtcthue5").setValue(tien_tt_5);
                                                                $$("tgtcthue0").setValue(tien_tt_0);
                                                                $$("tgtcthuek").setValue(tien_tt_k);
                                                                $$("tgtcthuekct").setValue(tien_tt_kct);
                                                                $$("tgtcthuekkk").setValue(tien_tt_kkk);

                                                                $$("ttcktmai").setValue(tien_ck_all);
                                                                $$("ttcktmai10").setValue(tien_ck_10);
                                                                $$("ttcktmai5").setValue(tien_ck_5);
                                                                $$("ttcktmai0").setValue(tien_ck_0);
                                                                $$("ttcktmaik").setValue(tien_ck_k);
                                                                $$("ttcktmaikct").setValue(tien_ck_kct);
                                                                $$("ttcktmaikkk").setValue(tien_ck_kkk);

                                                                $$("tgtthue").setValue(tien_thue_all);
                                                                $$("tgtthue10").setValue(tien_thue_10);
                                                                $$("tgtthue5").setValue(tien_thue_5);
                                                                $$("tgtthue0").setValue(tien_thue_0);
                                                                $$("tgtthuek").setValue(tien_thue_k);
                                                                $$("tgtthuekct").setValue(tien_thue_kct);
                                                                $$("tgtthuekkk").setValue(tien_thue_kkk);

                                                                $$("tgtttbso").setValue(tong_tien_all);
                                                                $$("tgtttbso10").setValue(tong_tien_10);
                                                                $$("tgtttbso5").setValue(tong_tien_5);
                                                                $$("tgtttbso0").setValue(tong_tien_0);
                                                                $$("tgtttbsok").setValue(tong_tien_k);
                                                                $$("tgtttbsokct").setValue(tong_tien_kct);
                                                                $$("tgtttbsokkk").setValue(tong_tien_kkk);

                                                                //if ($$("tkcktmn").getValue() != null && $$("tkcktmn").getValue() != "") tong_tien_all -= Number($$("tkcktmn").getValue());
                                                                if ($$("tgtphi").getValue() != null && $$("tgtphi").getValue() != "") tong_tien_all += Number($$("tgtphi").getValue());

                                                                $$("tgtttbso_last").setValue(tong_tien_all);
                                                                var tien_chietkhauthuongmai = 0;
                                                                data.forEach(function (entry) {
                                                                    if (entry["kmai"] && entry["kmai"].toString() == "3") {
                                                                        tien_chietkhauthuongmai += entry["tgtien"] == null ? 0 : Number(entry["tgtien"]);
                                                                    }
                                                                });
                                                                $$("tkcktmn").setValue(tien_chietkhauthuongmai);
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            header: "Tiền phí/lệ phí",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    {
                                                        id: "mainInvoiceManage",
                                                        css: {
                                                            "padding-bottom": "5px !important",
                                                        },
                                                        cols: [
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                                id: "addrow2",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_phi");
                                                                        var item = {
                                                                            id: webix.uid(),
                                                                            tienphi: 0,
                                                                        };
                                                                        table.add(item);
                                                                        table.select(item.id);
                                                                        table.edit({
                                                                            row: item.id,
                                                                            column: "tnphi",
                                                                        });
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                                id: "removerow2",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_phi");
                                                                        table.editStop();
                                                                        var item = table.getSelectedItem();
                                                                        if (!webix.isUndefined(item)) {
                                                                            table.remove(item.id);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }

                                                                        var editor = table.getEditState();

                                                                        if (!webix.isUndefined(editor)) {
                                                                            table.remove(editor.row);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                                view: "button",
                                                                id: "copyrow2",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_phi");

                                                                        table.editStop();

                                                                        var item = table.getSelectedItem();
                                                                        if (item == null || item == undefined) {
                                                                            webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                            return;
                                                                        }
                                                                        var copy = webix.copy(item);
                                                                        copy.id = webix.uid();

                                                                        table.add(copy);
                                                                        table.unselect(item.id);
                                                                        table.select(copy.id);
                                                                        table.edit({
                                                                            row: copy.id,
                                                                            column: "tnphi",
                                                                        });
                                                                    },
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: "hoadon68_phi",
                                                        editable: true,
                                                        select: "cell",
                                                        drag: true,
                                                        columns: [
                                                            {
                                                                id: "tnphi",
                                                                name: "tnphi",
                                                                header: _("Tên phí"),
                                                                editor: "text",
                                                                width: 350,

                                                                editable: true,
                                                            },
                                                            {
                                                                id: "tienphi",
                                                                name: "tienphi",
                                                                header: _("Tiền phí"),
                                                                editor: "text",
                                                                width: 350,
                                                                editable: true,
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                        ],
                                                        on: {
                                                            onAfterDelete: function (id) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();
                                                                var tien_phi_moi = 0;
                                                                data.forEach(function (entry) {
                                                                    tien_phi_moi += entry["tienphi"] == null ? 0 : Number(entry["tienphi"]);
                                                                });
                                                                $$("tgtphi").setValue(tien_phi_moi);
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();
                                                                var tien_phi_moi = 0;
                                                                data.forEach(function (entry) {
                                                                    tien_phi_moi += entry["tienphi"] == null ? 0 : Number(entry["tienphi"]);
                                                                });
                                                                $$("tgtphi").setValue(tien_phi_moi);
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            rows: [
                                                { view: "label", label: "Loại thuế", css: "lblTongtien" },
                                                {
                                                    view: "label",
                                                    label: " + Tổng cộng hàng hóa, dịch vụ",
                                                    height: 22,
                                                    css: { "padding-left": "5px", "font-weight": "bold", "background-color": "#86b2cf" },
                                                },
                                                { view: "label", label: "Thuế suất 10%", css: "lblSubTongtien", height: 22 },
                                                { view: "label", label: "Thuế suất 5%", css: "lblSubTongtien", height: 22 },
                                                { view: "label", label: "Thuế suất 0%", css: "lblSubTongtien", height: 22 },
                                                { view: "label", label: "Thuế suất khác", css: "lblSubTongtien", height: 22 },
                                                { view: "label", label: "Không chịu thuế GTGT", css: "lblSubTongtien", height: 22 },
                                                { view: "label", label: "Không kê khai, tính nộp thuế GTGT", css: "lblSubTongtien", height: 22 },
                                                {},
                                                {},
                                                {},
                                                // { view: "label", label: "Tổng cộng phí lệ phí", css: { "font-weight": "bold", "background-color": "#86b2cf" } , height: 22 },
                                                // { view: "label", label: "Tổng cộng thanh toán", css: { "font-weight": "bold", "background-color": "#86b2cf" } , height: 22 },
                                            ],
                                        },
                                        {
                                            rows: [
                                                {
                                                    view: "label",
                                                    label: "Thành tiền trước thuế",
                                                    css: "lblTongtien",
                                                    validate: function (value) {
                                                        if (Number(value) > 0 || Number(value) === 0) {
                                                            return true;
                                                        }
                                                        webix.message(mess, "error");
                                                        return false;
                                                    },
                                                    invalidMessage: mess,
                                                },
                                                { view: "text", id: "tgtcthue", name: "tgtcthue", css: "txtTongtien", readonly: true, height: 22, format: fmNumber },
                                                { view: "text", format: fmNumber, id: "tgtcthue10", name: "tgtcthue10", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtcthue5", name: "tgtcthue5", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtcthue0", name: "tgtcthue0", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtcthuek", name: "tgtcthuek", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtcthuekct", name: "tgtcthuekct", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtcthuekkk", name: "tgtcthuekkk", css: "txtTongtien", readonly: true, height: 22 },
                                                {},
                                                {},
                                                {},
                                                // { view: "text", id: "2", name: "2", css: "txtTongtien", readonly: true, height: 22 }
                                            ],
                                        },

                                        {
                                            rows: [
                                                { view: "label", label: "Tiền chiết khấu", css: "lblTongtien" },
                                                { view: "text", format: fmNumber, id: "ttcktmai", name: "ttcktmai", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmai10", name: "ttcktmai10", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmai5", name: "ttcktmai5", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmai0", name: "ttcktmai0", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmaik", name: "ttcktmaik", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmaikct", name: "ttcktmaikct", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmaikkk", name: "ttcktmaikkk", css: "txtTongtien", readonly: true, height: 22 },
                                                {},
                                                {},
                                                {},
                                            ],
                                        },
                                        {
                                            rows: [
                                                {
                                                    view: "label",
                                                    label: "Tiền thuế",
                                                    css: "lblTongtien",
                                                    validate: function (value) {
                                                        if (Number(value) > 0 || Number(value) === 0) {
                                                            return true;
                                                        }
                                                        webix.message(mess, "error");
                                                        return false;
                                                    },
                                                    invalidMessage: mess,
                                                    format: fmNumber,
                                                },
                                                { view: "text", format: fmNumber, id: "tgtthue", name: "tgtthue", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthue10", name: "tgtthue10", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthue5", name: "tgtthue5", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthue0", name: "tgtthue0", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthuek", name: "tgtthuek", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthuekct", name: "tgtthuekct", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthuekkk", name: "tgtthuekkk", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "label", label: "Chiết khấu thương mại", labelAlign: "right", labelPosition: "top" },
                                                { view: "label", label: "Tổng tiền phí/lệ phí", labelAlign: "right", labelPosition: "top" },
                                                { view: "label", label: "Thành tiền", labelAlign: "right", labelPosition: "top" },
                                            ],
                                        },
                                        {
                                            rows: [
                                                { view: "label", label: "Tổng tiền sau thuế", css: "lblTongtien" },
                                                {
                                                    view: "text",
                                                    id: "tgtttbso",
                                                    name: "tgtttbso",
                                                    css: "txtTongtien",
                                                    readonly: true,
                                                    height: 22,
                                                    format: fmNumber,
                                                },
                                                { view: "text", format: fmNumber, id: "tgtttbso10", name: "tgtttbso10", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtttbso5", name: "tgtttbso5", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtttbso0", name: "tgtttbso0", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtttbsok", name: "tgtttbsok", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtttbsokct", name: "tgtttbsokct", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtttbsokkk", name: "tgtttbsokkk", css: "txtTongtien", readonly: true, height: 22 },
                                                {
                                                    id: "tkcktmn",
                                                    view: "text",
                                                    editor: "numeric",
                                                    labelWidth: 200,
                                                    width: 600,
                                                    format: fmNumber,
                                                    name: "tkcktmn",
                                                    /*on: {
                                                        onChange: function (newValue, oldValue, config) {
                                                            var tong_tien_cu = 0;
                                                            if ($$("tgtttbso_last").getValue() != null && $$("tgtttbso").getValue() != "") tong_tien_cu = Number($$("tgtttbso_last").getValue());
                                                            if (oldValue != null && oldValue != "") tong_tien_cu += Number(oldValue);
                                                            if (tong_tien_cu > $$("tkcktmn").getValue()) {
                                                                $$("tgtttbso_last").setValue(tong_tien_cu - newValue);
                                                                $$("tkcktmn").setValue(newValue);
                                                            } else {
                                                                $$("tgtttbso_last").setValue(tong_tien_cu);
                                                            }
                                                        },
                                                    },*/
                                                },
                                                {
                                                    view: "text",
                                                    format: fmNumber,
                                                    id: "tgtphi",
                                                    name: "tgtphi",
                                                    readonly: true,
                                                    value: 0,
                                                    on: {
                                                        onChange: function (newValue, oldValue, config) {
                                                            var tong_tien_cu = 0;
                                                            if ($$("tgtttbso_last").getValue() != null && $$("tgtttbso").getValue() != "") tong_tien_cu = Number($$("tgtttbso_last").getValue());
                                                            if (oldValue != null && oldValue != "") tong_tien_cu -= Number(oldValue);
                                                            tong_tien_cu += Number(newValue);
                                                            $$("tgtttbso_last").setValue(tong_tien_cu);
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "text",
                                                    id: "tgtttbso_last",
                                                    name: "tgtttbso_last",
                                                    readonly: true,
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            commonHD.ExeCuteCheckReadCurencyTV($$("docngoaitetv").getValue());
                                                        },
                                                    },
                                                    validate: function (value) {
                                                        var table_inv_views = webix.$$("invoiceViews");
                                                        var item_inv = table_inv_views.getSelectedItem();
                                                        var item_note = "";
                                                        if (item_inv != undefined && item_inv.hasOwnProperty("note") == true) {
                                                            item_note = item_inv.note ? item_inv.note : "";
                                                        }
                                                        if (item_note == "reduce_change_invoice") return true;
                                                        if (Number(value) > 0 || Number(value) === 0) {
                                                            return true;
                                                        }
                                                        webix.message(mess, "error");
                                                        return false;
                                                    },
                                                    invalidMessage: mess,
                                                    format: fmNumber,
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: "label",
                                            width: 140,
                                            label: "Đọc tiền bằng chữ:",
                                            css: { "font-weight": "bold", "padding-left": "5px" },
                                            height: 22,
                                        },
                                        { view: "text", id: "tgtttbchu", name: "tgtttbchu", readonly: true, height: 22 },
                                    ],
                                },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        {
                                            view: "button",
                                            id: "btnHoadonSaveMau04",
                                            hidden: true,
                                            label: "Ký và gửi CQT",
                                            align: "center",
                                            type: "form",
                                            width: 120,
                                            click: function () {
                                                var item = $$("invoiceForms").getValues();
                                                var tableHoadon = $$("invoiceForms");

                                                if (tableHoadon.validate()) {
                                                    var record = $$("hoadon68_chitiet").serialize();
                                                    if (record.length == 0) {
                                                        webix.message("Bạn chưa nhập chi tiết hóa đơn", "error");
                                                        return;
                                                    } else {
                                                        for (var i = 0; i < record.length; i++) {
                                                            var it = record[i];
                                                            if (it["ten"] == null || it["ten"] == "") {
                                                                webix.message("Bạn chưa nhập tên hàng");
                                                                return;
                                                            }
                                                            if (it.kmai.toString() === "1") {
                                                                var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                                                if (!bool) {
                                                                    webix.message("Tiền trước thuế + tiền thuế != tiền sau thuế");
                                                                    return;
                                                                }
                                                                if (it["tsuat"] == null || it["tsuat"] == "") {
                                                                    webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                                    return;
                                                                }
                                                            }
                                                        }
                                                        var t = webix.$$("invoiceViews");
                                                        var k = t.getSelectedItem();
                                                        var details = [];
                                                        details.push({ data: $$("hoadon68_chitiet").serialize() });
                                                        item["details"] = details;
                                                        item["tthdon"] = 2;
                                                        item["hdon68_id_lk"] = k.id;
                                                        var phi = [];
                                                        phi.push({
                                                            data: $$("hoadon68_phi").serialize(),
                                                        });
                                                        item["hoadon68_phi"] = phi;
                                                        // hóa đơn không mã
                                                        item.is_hdcma = 0;
                                                        var item1 = [];
                                                        item1.push(item);
                                                        var data_post = { editmode: editmode, data: item1 };
                                                        data_post.mau04 = mau04;

                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                                var result = JSON.parse(text);
                                                                var kytaptrung = "";
                                                                for (var i = 0; i < result.length; i++) {
                                                                    var item = result[i];
                                                                    kytaptrung = item.value;
                                                                }

                                                                webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                                    var listcerts = JSON.parse(text);
                                                                    if (listcerts.length > 0) {
                                                                        var box = webix.modalbox({
                                                                            title: "Chọn chứng thư số",
                                                                            buttons: ["Nhận", "Hủy bỏ"],
                                                                            text: "<div id='ctnCerts'></div>",
                                                                            top: 100,
                                                                            width: 750,
                                                                            callback: function (result) {
                                                                                switch (result) {
                                                                                    case "1":
                                                                                        webix.modalbox.hide();
                                                                                        break;
                                                                                    case "0":
                                                                                        var table = $$("tblCerts");
                                                                                        var data = table.serialize();

                                                                                        var cert = null;

                                                                                        for (var i = 0; i < data.length; i++) {
                                                                                            if (data[i].chon == true) {
                                                                                                cert = data[i];
                                                                                                break;
                                                                                            }
                                                                                        }

                                                                                        if (cert == null) {
                                                                                            webix.message("Bạn chưa chọn chứng thư số");
                                                                                            return;
                                                                                        }

                                                                                        var now = new Date();
                                                                                        var begin = new Date(cert.begin_date);
                                                                                        var end = new Date(cert.end_date);
                                                                                        if (now < begin || now > end) {
                                                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                            return;
                                                                                        }

                                                                                        var postData = {
                                                                                            branch_code: user.getDvcsID(),
                                                                                            username: user.getCurrentUser(),
                                                                                            cer_serial: cert.cer_serial,
                                                                                        };
                                                                                        data_post.sign = postData;

                                                                                        // console.log(data_post);
                                                                                        webix.extend(tableHoadon, webix.ProgressBar);
                                                                                        tableHoadon.disable();
                                                                                        tableHoadon.showProgress();
                                                                                        webix
                                                                                            .ajax()
                                                                                            .headers({ "Content-type": "application/json" })
                                                                                            .post(app.config.host + "/Invoice68/huyHoadonTaomoi", data_post, {
                                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                                    tableHoadon.enable();
                                                                                                    tableHoadon.hideProgress();
                                                                                                    // var json = JSON.parse(text);
                                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                                },
                                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                                    var json = JSON.parse(text);
                                                                                                    tableHoadon.enable();
                                                                                                    tableHoadon.hideProgress();

                                                                                                    if (!json.hasOwnProperty("error")) {
                                                                                                        //gửi mail tới khách hàng sau khi Ký
                                                                                                        if (json.tthai == "Đã ký") {
                                                                                                            webix
                                                                                                                .ajax()
                                                                                                                .headers({ "Content-type": "application/json" })
                                                                                                                .post(
                                                                                                                    app.config.host + "/System/ExecuteCommand",
                                                                                                                    {
                                                                                                                        command: "CM00025",
                                                                                                                        parameter: {},
                                                                                                                    },
                                                                                                                    function (text) {
                                                                                                                        var json = JSON.parse(text);
                                                                                                                        // send email ma = 'AUTO_SEND_EMAIL'
                                                                                                                        if (json[0].value == "C") {
                                                                                                                            var data = {
                                                                                                                                id: result.hdon_id,
                                                                                                                                nguoinhan: result.email,
                                                                                                                                tieude: "Thông báo xuất hóa đơn điện tử",
                                                                                                                            };

                                                                                                                            webix
                                                                                                                                .ajax()
                                                                                                                                .headers({ "Content-type": "application/json" })
                                                                                                                                .post(
                                                                                                                                    app.config.host + "/Invoice68/AutoSendInvoiceByEmail",
                                                                                                                                    data,
                                                                                                                                    function (text) {
                                                                                                                                        var data = JSON.parse(text);

                                                                                                                                        if (!data.hasOwnProperty("error")) {
                                                                                                                                        } else {
                                                                                                                                            webix.message(data.error, "error");
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                );
                                                                                                                        }
                                                                                                                    }
                                                                                                                );

                                                                                                            webix.modalbox.hide();
                                                                                                            //webix.message("Ký hóa đơn thành công !", "debug");
                                                                                                        }

                                                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                                                        $$("invoice68").close();
                                                                                                        $$("huyhoadonForms").close();

                                                                                                        app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                                    } else {
                                                                                                        webix.message(json.error, "error");
                                                                                                    }
                                                                                                },
                                                                                            });

                                                                                        return;
                                                                                }
                                                                            },
                                                                        });

                                                                        var tblMatHang = webix.ui({
                                                                            container: "ctnCerts",
                                                                            id: "tblCerts",
                                                                            view: "datatable",
                                                                            borderless: true,
                                                                            resizeColumn: true,
                                                                            height: 350,
                                                                            columns: [
                                                                                {
                                                                                    id: "chon",
                                                                                    header: _("CHON"),
                                                                                    width: 65,
                                                                                    checkValue: true,
                                                                                    uncheckValue: false,
                                                                                    template: "{common.checkbox()}",
                                                                                },
                                                                                {
                                                                                    id: "cer_serial",
                                                                                    header: _("SO_SERIAL"),
                                                                                    width: 150,
                                                                                },
                                                                                {
                                                                                    id: "subject_name",
                                                                                    header: _("SUBJECTNAME"),
                                                                                    width: 450,
                                                                                },
                                                                                {
                                                                                    id: "begin_date",
                                                                                    header: _("NGAY_BAT_DAU"),
                                                                                    width: 200,
                                                                                },
                                                                                {
                                                                                    id: "end_date",
                                                                                    header: _("NGAY_KET_THUC"),
                                                                                    width: 200,
                                                                                },
                                                                                {
                                                                                    id: "issuer",
                                                                                    header: _("DONVI"),
                                                                                    width: 450,
                                                                                },
                                                                            ],
                                                                            url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                        });
                                                                    } else {
                                                                        webix.extend(tableHoadon, webix.ProgressBar);
                                                                        tableHoadon.disable();
                                                                        tableHoadon.showProgress();
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/huyHoadonTaomoiUSB", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    tableHoadon.enable();
                                                                                    tableHoadon.hideProgress();
                                                                                    // var json = JSON.parse(text);
                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);
                                                                                    tableHoadon.enable();
                                                                                    tableHoadon.hideProgress();
                                                                                    if (!json.hasOwnProperty("error")) {
                                                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlMau0405?id=" + json.idMau04);
                                                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                                                        webix.promise.all([a, b, json]).then(function (results) {
                                                                                            // webix.extend(tblInvoice, webix.ProgressBar);
                                                                                            // tblInvoice.disable();
                                                                                            // tblInvoice.showProgress();
                                                                                            var json = results[0].json();

                                                                                            if (json.hasOwnProperty("error")) {
                                                                                                webix.message({ type: "error", text: json.error });
                                                                                            }

                                                                                            var listcerts = results[1].json();
                                                                                            var item = results[2];

                                                                                            if (listcerts.length == 0) {
                                                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                                                return;
                                                                                            }

                                                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                                                var hub = plugin.hub();
                                                                                                var hubconnect = plugin.conn();
                                                                                                if (hubconnect.state != 1) {
                                                                                                    // tblInvoice.enable();
                                                                                                    // tblInvoice.hideProgress();
                                                                                                    webix.message(
                                                                                                        "Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !",
                                                                                                        "error"
                                                                                                    );
                                                                                                    return;
                                                                                                }
                                                                                                hub.off("resCommand");
                                                                                                hub.on("resCommand", function (result) {
                                                                                                    var json = JSON.parse(result);

                                                                                                    if (json.hasOwnProperty("error")) {
                                                                                                        webix.message({ type: "error", text: json.error });
                                                                                                    } else {
                                                                                                        var parameters = {
                                                                                                            xml: json.xml,
                                                                                                            id: item.idMau04,
                                                                                                            tthdon: 3,
                                                                                                        };

                                                                                                        webix
                                                                                                            .ajax()
                                                                                                            .headers({ "Content-Type": "application/json" })
                                                                                                            .post(app.config.host + "/Invoice68/SaveXmlMau0405", parameters, function (text) {
                                                                                                                var result = JSON.parse(text);
                                                                                                                if (result.hasOwnProperty("error")) {
                                                                                                                    webix.message(result.error, "error");
                                                                                                                } else {
                                                                                                                    webix.message("Gửi thành công đến CQT !", "success");
                                                                                                                    $$("invoice68").close();
                                                                                                                    $$("huyhoadonForms").close();

                                                                                                                    app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                                                }
                                                                                                            });
                                                                                                    }
                                                                                                    tableHoadon.enable();
                                                                                                    tableHoadon.hideProgress();
                                                                                                });

                                                                                                var _listcerts = [];

                                                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                                                    var _cert = listcerts[i];

                                                                                                    _listcerts.push({
                                                                                                        so_serial: _cert.cer_serial,
                                                                                                        ngaybatdau: _cert.begin_date,
                                                                                                        ngayketthuc: _cert.end_date,
                                                                                                        issuer: _cert.issuer,
                                                                                                        subjectname: _cert.subject_name,
                                                                                                    });
                                                                                                }

                                                                                                var arg = {
                                                                                                    idData: "#data",
                                                                                                    xml: json["xml"],
                                                                                                    shdon: "",
                                                                                                    idSigner: "seller",
                                                                                                    tagSign: "NNT",
                                                                                                    dvky: json["dvky"],
                                                                                                    dateKy: json["dateKy"],
                                                                                                    listcerts: _listcerts,
                                                                                                };

                                                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                                                    .done(function () {
                                                                                                        console.log("Success !");
                                                                                                    })
                                                                                                    .fail(function (error) {
                                                                                                        webix.message(error, "error");
                                                                                                    });
                                                                                            });
                                                                                        });
                                                                                        // webix.message("Gửi thành công đến CQT !", "success");
                                                                                        // $$("invoice68").close();
                                                                                        // $$("huyhoadonForms").close();

                                                                                        // app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                    } else {
                                                                                        webix.message(json.error, "error");
                                                                                    }
                                                                                },
                                                                            });
                                                                    }
                                                                });
                                                            });
                                                    }
                                                }
                                            },
                                        },
                                        {
                                            shortcut: "F10",
                                            view: "button",
                                            id: "btnHoadonSave",
                                            label: "Lưu tạm (F10)",
                                            type: "form",
                                            align: "center",
                                            width: 120,
                                            on: {
                                                onClick: function () {
                                                    var item = $$("invoiceForms").getValues();
                                                    var table = $$("invoiceForms");
                                                    var record = $$("hoadon68_chitiet").serialize();
                                                    for (var i = 0; i < record.length; i++) {
                                                        var it = record[i];
                                                        if (it["ten"] == null || it["ten"] == "") {
                                                            webix.message("Bạn chưa nhập tên hàng");
                                                            return;
                                                        }
                                                        if (it.kmai.toString() === "1") {
                                                            var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                                            if (!bool) {
                                                                webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                                                return;
                                                            }
                                                            if (it["tsuat"] == null || it["tsuat"] == "") {
                                                                webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                                return;
                                                            }
                                                        }
                                                    }
                                                    if (table.validate()) {
                                                        // var fn = Function(check);
                                                        // var result = fn();
                                                        // console.log(result);
                                                        webix.extend(table, webix.ProgressBar);
                                                        table.disable();
                                                        table.showProgress();

                                                        var details = [];
                                                        details.push({ data: record });
                                                        item["details"] = details;
                                                        var phi = [];
                                                        phi.push({
                                                            data: $$("hoadon68_phi").serialize(),
                                                        });
                                                        item["hoadon68_phi"] = phi;
                                                        // hóa đơn không mã
                                                        item.is_hdcma = 0;
                                                        var item1 = [];
                                                        item1.push(item);
                                                        var data_post = { editmode: editmode, data: item1 };

                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/hoadonSaveChange", data_post, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    if (!json.hasOwnProperty("error")) {
                                                                        webix.$$("invoice68").close();
                                                                        app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                                    } else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                },
                                                            });
                                                    }
                                                },
                                            },
                                            click: function () {
                                                this.callEvent("onClick");
                                            },
                                        },
                                        {
                                            shortcut: "F11",
                                            view: "button",
                                            id: "btnHoadonCQT",
                                            label: "Ký và gửi CQT (F11)",
                                            type: "form",
                                            align: "center",
                                            width: 150,
                                            on: {
                                                onClick: function () {
                                                    var item = $$("invoiceForms").getValues();
                                                    var table = $$("invoiceForms");
                                                    var record = $$("hoadon68_chitiet").serialize();
                                                    for (var i = 0; i < record.length; i++) {
                                                        var it = record[i];
                                                        if (it["ten"] == null || it["ten"] == "") {
                                                            webix.message("Bạn chưa nhập tên hàng");
                                                            return;
                                                        }
                                                        if (it.kmai.toString() === "1") {
                                                            var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                                            if (!bool) {
                                                                webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                                                return;
                                                            }
                                                            if (it["tsuat"] == null || it["tsuat"] == "") {
                                                                webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                                return;
                                                            }
                                                        }
                                                    }
                                                    if (table.validate()) {
                                                        // var fn = Function(check);
                                                        // var result = fn();
                                                        // console.log(result);
                                                        webix.extend(table, webix.ProgressBar);
                                                        table.disable();
                                                        table.showProgress();

                                                        var details = [];
                                                        details.push({ data: $$("hoadon68_chitiet").serialize() });
                                                        item["details"] = details;
                                                        var phi = [];
                                                        phi.push({
                                                            data: $$("hoadon68_phi").serialize(),
                                                        });
                                                        item["hoadon68_phi"] = phi;
                                                        // hóa đơn không mã
                                                        item.is_hdcma = 0;
                                                        var item1 = [];
                                                        item1.push(item);
                                                        var data_post = { editmode: editmode, data: item1 };

                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/hoadonSaveChange", data_post, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");

                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var _res = JSON.parse(text);
                                                                    var json = JSON.parse(text);
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    if (!_res.hasOwnProperty("error")) {
                                                                        webix.$$("invoice68").close();
                                                                        app.callEvent("dataChangedInvoie68", [editmode, _res.data]);

                                                                        var lsthdon_id = [];
                                                                        lsthdon_id.push(_res.data.hdon_id);
                                                                        commonHD.ExcuteHoaDon(lsthdon_id, true, false);
                                                                    } else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                },
                                                            });
                                                    }
                                                },
                                            },
                                            click: function () {
                                                this.callEvent("onClick");
                                            },
                                        },
                                        {
                                            view: "button",
                                            hotkey: "esc",
                                            label: "Hủy bỏ (ESC)",
                                            align: "center",
                                            type: "danger",
                                            width: 120,
                                            click: function () {
                                                this.getTopParentView().close();
                                                app.callEvent("dataChangedInvoie68", [editmode, null]);
                                            },
                                        },
                                        {},
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            if (item != null) {
                item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                form.setValues(item);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
                var tablePhi = webix.$$("hoadon68_phi");
                var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                tablePhi.clearAll();
                tablePhi.load(urlPhi);
            }

            if (editmode == 2) {
            }
            // nếu có mẫu 04 (hóa đơn hủy)
            if (winconfig != null) {
                mau04 = winconfig;
                $$("btnHoadonSaveMau04").show();
                $$("btnHoadonCQT").destructor();
                $$("btnHoadonSave").destructor();
            }
            this.getFormat(item["dvtte"]);
        },
        setEditMode: function (mode) {
            editmode = mode;
            //var form = webix.$$("invoiceForms");
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            } else {
                if (editmode == 2) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
        },
        copyValues: function (item) {
            var form = webix.$$("invoiceForms");

            var tableDetail = webix.$$("hoadon68_chitiet");
            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(url, function (text) {
                    var data = JSON.parse(text);

                    for (var i = 0; i < data.length; i++) {
                        data[i]["cthdon_id"] = null;
                        data[i]["hdon_id"] = null;
                    }

                    tableDetail.clearAll();
                    tableDetail.parse(data);
                });
            var tablePhi = webix.$$("hoadon68_phi");
            var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(urlPhi, function (text) {
                    var data = JSON.parse(text);

                    for (var i = 0; i < data.length; i++) {
                        data[i]["phi_id"] = null;
                        data[i]["hdon_id"] = null;
                    }

                    tablePhi.clearAll();
                    tablePhi.parse(data);
                });
            // tableDetail.clearAll();
            // tableDetail.load(url);
            item["tthdon"] = 0;
            item["hdon_id"] = null;
            item["nky"] = null;
            item["id"] = webix.uid();
            form.setValues(item);
            this.getFormat();
        },
        initUINew: function (cctbao_id) {
            $$("cctbao_id").setValue(cctbao_id);
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(app.config.host + "/Invoice68/getKyhieu?cctbao_id=" + cctbao_id, function (text) {
                    var data = JSON.parse(text);

                    if (data.length > 0) {
                        var form = $$("invoiceForms");
                        var values = form.getValues();

                        values["khieu"] = data[0]["khhdon"];
                        values["mcqtcap"] = data[0]["mccqthue"];

                        form.setValues(values);
                    }
                });
            this.getFormat();
        },
        getFormat: function (val) {
            commonHD.renderFormat(val);
        },
    };
});

define('views/forms/68_bangmotaloiCQT',["app", "locale", "models/user", "views/forms/68_invoiceForms"], function (app, _, user, invoiceForms) {
    

    var editmode = 0;
    var hdon_id = "";

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Danh sách lỗi phản hồi từ CQT<div/>";
                        },
                    },
                ],
            },
            id: "responseMessageForms1",
            resize: true,
            width: 800,
            height: 400,
            move: true,
            on: {
                onBeforeShow: function () {},
            },
            body: {
                view: "form",
                id: "message",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        // id: "header",
                        template: "<center><b><span style='font-size:17px;'>DANH SÁCH LỖI PHẢN HỒI TỪ CQT</b></center>",
                        borderless: true,
                        height: 40,
                    },
                    // {
                    //     paddingX: 30,
                    //     rows: [
                    //         {
                    //             view: "text",
                    //             label: "Ký hiệu",
                    //             id: "khieu",
                    //             name: "khieu",
                    //         },
                    //         {
                    //             view: "text",
                    //             label: "Số hóa đơn",
                    //             labelWidth: 150,
                    //             id: "shdon",
                    //             name: "shdon",
                    //         },
                    //     ],
                    // },
                    { height: 3 },
                    {
                        rows: [
                            {
                                view: "datatable",
                                id: "danhsach_message",
                                // height: 250,
                                //name: "danhsach_message",
                                // select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                select: "cell",
                                scheme: {
                                    $init: function (obj) {},
                                },
                                url: {
                                    $proxy: true,
                                    load: function (view, callback, params) {
                                        // var hdon_id = "87de11a4-0b4e-42d4-a86c-45ba10b80337";
                                        if (hdon_id != "") {
                                            var url = app.config.host + "/Invoice68/GetResponseMessage?id=" + hdon_id;
                                            webix.ajax(url, callback, view);
                                        }
                                    },
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                },
                                columns: [
                                    { editor: "text", id: "hdon_id", name: "hdon_id", hidden: true },
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                    },
                                    {
                                        id: "maloi",
                                        name: "maloi",
                                        header: "Mã lỗi",
                                        width: 150,
                                        editor: "text",
                                    },
                                    {
                                        id: "motaloi",
                                        name: "motaloi",
                                        header: "Mô tả lỗi",
                                        width: 300,
                                        editor: "text",
                                    },
                                    {
                                        id: "huongdanxuly",
                                        name: "huongdanxuly",
                                        header: "Hướng dẫn xử lý",
                                        width: 300,
                                        editor: "text",
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    hdon_id = "";
                                    webix.$$("responseMessageForms1").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (id) {
            hdon_id = id;
            var table = $$("danhsach_message");
            table.load(table.config.url);
        },
        setValues: function (item, winconfig, params) {
            var table = $$("danhsach_message");
            table.setValues(item);
        },
    };
});

define('views/forms/68_hoadon_history',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_bangmotaloiCQT"], function (app, _, user, invoiceForms, bangmotaloiCQT) {
    

    var editmode = 0;
    var hdon_id = "";

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Lịch sử xử lý<div/>";
                        },
                    },
                ],
            },

            id: "responseMessageForms",
            resize: true,
            width: 1000,
            height: 500,
            move: true,
            on: {
                onBeforeShow: function () {},
            },
            body: {
                view: "form",
                id: "message",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        // id: "header",
                        template: "<center><b><span style='font-size:17px;'>LỊCH SỬ XỬ LÝ</b></center>",
                        borderless: true,
                        height: 40,
                    },
                    { height: 3 },
                    {
                        rows: [
                            {
                                view: "datatable",
                                id: "danhsach_history",
                                // height: 250,
                                //name: "danhsach_history",
                                // select: true,
                                editable: true,
                                rowLineHeight: 25,
                                rowHeight: 25,
                                resizeColumn: true,
                                fullScreen: true,
                                fixedRowHeight: false,
                                select: "row",
                                scheme: {
                                    $init: function (obj) {},
                                },
                                url: {
                                    $proxy: true,
                                    load: function (view, callback, params) {
                                        // var hdon_id = "87de11a4-0b4e-42d4-a86c-45ba10b80337";
                                        if (hdon_id != "") {
                                            var url = app.config.host + "/Invoice68/GetHistoryInvoice?id=" + hdon_id;
                                            webix.ajax(url, callback, view);
                                        }
                                    },
                                },
                                onClick: {
                                    ShowResponseMessage: function (event, cell, target) {
                                        //var win = table.$scope.ui(bangmotaloiCQT.$ui);
                                        webix.ui(bangmotaloiCQT.$ui);
                                        var ref_id = cell.row;

                                        bangmotaloiCQT.setEditMode(ref_id);
                                        // // var win = table.$scope.ui(hoadonHistory.$ui);
                                        // // hoadonHistory.setEditMode(hdon_id);
                                        // $$("danhsach_history").show();
                                        webix.ui(bangmotaloiCQT.$ui).show();
                                    },
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                },
                                columns: [
                                    {
                                        editor: "text",
                                        id: "ref_id",
                                        name: "ref_id",
                                        hidden: true,
                                    },
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                        css: "rank",
                                    },
                                    {
                                        id: "tgian_gui",
                                        name: "tgian_gui",
                                        header: "Thời gian",
                                        width: 200,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s.%S");
                                            var time = new Date(text);
                                            text = removeTimeZoneT(time);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "nguoi_gui",
                                        name: "nguoi_gui",
                                        header: "Nơi gửi",
                                        width: 150,
                                    },
                                    {
                                        id: "mltdiep_gui",
                                        name: "mltdiep_gui",
                                        header: "Loại Thông điệp",
                                        width: 150,
                                        template: function (obj) {
                                            if ((obj.mltdiep_gui == "203" || obj.mltdiep_gui == "200") && obj.note == "app") {
                                                return "Gửi HDDT lên CQT";
                                            } else if (obj.mltdiep_gui == "400" && obj.note == "app") {
                                                return "Gửi BTHDL lên CQT";
                                            } else if ((obj.mltdiep_gui == "100" || obj.mltdiep_gui == "101") && obj.note == "app") {
                                                return "Gửi Tờ khai lên CQT";
                                            }
                                            // else if(obj.mltdiep_gui == "200" && obj.note == "app"){
                                            //     return "Gửi HDDT có mã lên CQT";
                                            // }
                                            else if ((obj.mltdiep_gui == "300" || obj.mltdiep_gui == "301") && obj.note == "app") {
                                                return "Thông báo hóa đơn sai sót";
                                            } else if (obj.mltdiep_gui == "301" && obj.note == "saisot") {
                                                return "Kết quả tiếp nhận và xử lý hóa đơn sai sót";
                                            } else if (obj.mltdiep_gui == "202" && obj.note == "capma") {
                                                return "Cơ quan thuế cấp mã hóa đơn";
                                            } else if (obj.note == "phkt") {
                                                return "Phản hồi kĩ thuật";
                                            } else if (obj.note == "ktdl") {
                                                return "Kiểm tra dữ liệu";
                                            } else if (obj.note == "rasoat") {
                                                return "Thông báo HDDT cần rà soát";
                                            } else {
                                                return "Gửi HDDT lên CQT";
                                            }
                                        },
                                    },
                                    {
                                        id: "history",
                                        name: "history",
                                        header: "Nội dung",
                                        width: 430,
                                    },
                                    // {
                                    //     id: "btnResponseMessage",
                                    //     name: "View",
                                    //     header: "Xem chi tiết",
                                    //     width: 100,
                                    //     //editor: "text",
                                    //     template: function (obj) {
                                    //         if (obj.note == "phkt" || obj.note == "ktdl" || obj.note == "rasoat") {
                                    //             return "<span class='ShowResponseMessage' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                                    //         } else {
                                    //             return "";
                                    //         }
                                    //     },
                                    // },
                                ],

                                ready: function () {
                                    this.adjustRowHeight("history", true);

                                    var row_id = this.getFirstId();
                                    this.select(row_id, false);
                                    this.unselect(row_id, false);
                                },
                            },
                        ],
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    hdon_id = "";
                                    webix.$$("responseMessageForms").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (id) {
            hdon_id = id;
            var table = $$("danhsach_history");
            table.load(table.config.url);
        },
    };
});

define('views/68_bangkebanra',["app", "locale", "models/user", "views/forms/68_bangkebanraForm", "views/forms/68_hoadon_history"], function (app, _, user, bangkebanraForm, hoadonHistory) {
    

    webix.$$("title").parse({
        title: "Tờ khai chứng từ bán ra",
        details: "Tờ khai chứng từ bán ra",
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(bangkebanraForm.$ui);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
        //    id: "btnPlus",
        //    shortcut: "F4",
        //    on: {
        //        onClick: function () {
        //            var detailForm = this.$scope.ui(bangkebanraForm.$ui);
        //            bangkebanraForm.setEditMode(1);
        //            detailForm.show();

        //            var url = app.config.host + "/Invoice68/GetInfoCompany";

        //            webix.ajax(url, function (text) {
        //                var json = JSON.parse(text);
        //                webix.$$("tnnt").setValue(json.name);
        //                webix.$$("mst").setValue(json.tax_code);
        //                webix.$$("ddanh").setValue(json.address);
        //            });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
        //    id: "btnEdit",
        //    shortcut: "F3",
        //    on: {
        //        onClick: function () {
        //            var table = webix.$$("bangkebanra");
        //            var selectedItem = table.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn dòng nào ! ", "error");
        //                return;
        //            }

        //            var detailForm = this.$scope.ui(bangkebanraForm.$ui);
        //            bangkebanraForm.setEditMode(2);
        //            bangkebanraForm.setValues(selectedItem);
        //            if (selectedItem.trang_thai == 1) {
        //                var form = $$("bangkebanra-form").elements;
        //                for (var key in form) {
        //                    var $el = form[key];
        //                    $el.define("readonly", "true");
        //                    $el.define("css", "mcls_readonly_text");
        //                    $el.refresh();
        //                }

        //                webix.$$("btnBTHSave").destructor();
        //                webix.$$("btnTaiDanhSachBanRa").destructor();
        //            }
        //            detailForm.show();
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
        //    id: "btnDelete",
        //    shortcut: "F8",
        //    on: {
        //        onClick: function () {
        //            var table = webix.$$("bangkebanra");
        //            var selectedItem = table.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                return;
        //            }
        //            if (selectedItem.trang_thai == 1) {
        //                webix.message("Bảng tổng hợp đã gửi CQT không thể xóa ! ", "error");
        //                return;
        //            }

        //            var khData = {};

        //            khData.editmode = 3;
        //            khData.data = [];
        //            khData.data.push(selectedItem);

        //            webix.confirm({
        //                text: "Bạn có muốn xóa bản ghi",
        //                ok: "Có",
        //                cancel: "Không",
        //                callback: function (choose) {
        //                    if (choose) {
        //                        webix
        //                            .ajax()
        //                            .headers({ "Content-type": "application/json" })
        //                            .post(app.config.host + "/Invoice68/SaveBangKeBanRa", khData, function (text) {
        //                                var response = JSON.parse(text);

        //                                if (response.hasOwnProperty("error")) {
        //                                    webix.message({ type: "error", text: response.error });
        //                                    return;
        //                                }

        //                                // table.remove(item.id);
        //                                var btnRefresh = $$("btnRefresh");
        //                                btnRefresh.callEvent("onClick");
        //                            });
        //                    }
        //                },
        //            });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fas fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "In PDF" + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;

                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }

                    var datafrmAll = table.serialize();

                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để in !", "error");
                        return;
                    }

                    rpParameter.type = "PDF";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(
                                app.config.host + "/Invoice68/PrintPDFBangKeBanRa",
                                rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/pdf" });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.open(fileURL, "_blank");
                                    },
                                }
                                // function (text, data) {
                                //     var file = new Blob([data], { type: 'application/pdf' });
                                //     var fileURL = URL.createObjectURL(file);
                                //     webix.modalbox.hide(box);
                                //     window.open(fileURL, '_blank');
                                // }
                            );
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        /*{
            view: "button",
            type: "htmlbutton",
            width: 150,
            hide: true,
            label: '<i class="fa fa-file fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("EXPORT_EXCEL") + "</span>",
            id: "btnExportExcel",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";

                    var datafrmAll = table.serialize();

                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để xuất !", "error");
                        return;
                    }

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(app.config.host + "/Invoice68/PrintPDFBangKeBanRa", rpParameter, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                    //var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    //window.location.href = fileURL;
                                    webix.html.download(file, "BangKeBanRa.xlsx");
                                },
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },*/
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-file fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("EXPORT_EXCEL") + "</span>",
            id: "btnExportExcelF",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";

                    var datafrmAll = table.serialize();

                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để xuất !", "error");
                        return;
                    }

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(app.config.host + "/Invoice68/PrintExcelBangKeBanRa_New", rpParameter, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                    //var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    //window.location.href = fileURL;
                                    webix.html.download(file, "BangKeBanRa.xlsx");
                                },
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 100,
        //     label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Gửi email") + "</span>",
        //     id: "btnSendEmail",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("hoadon");
        //             var selectedItem = table.getSelectedItem();
        //             if (selectedItem == null) {
        //                 webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                 return;
        //             }
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký gửi CQT") + "</span>",
        //    id: "btnSign",
        //    on: {
        //        onClick: function () {
        //            var tableDK = webix.$$("bangkebanra");
        //            var selectedItem = tableDK.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn dòng ! ", "error");
        //                return;
        //            }
        //            if (selectedItem.trang_thai == 1) {
        //                webix.message("Mẫu đã ký và gửi CQT bạn không thể ký lại! ", "error");
        //                return;
        //            }

        //            webix
        //                .ajax()
        //                .headers({ "Content-Type": "application/json" })
        //                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
        //                    var result = JSON.parse(text);
        //                    var kytaptrung = "";
        //                    for (var i = 0; i < result.length; i++) {
        //                        var item = result[i];
        //                        kytaptrung = item.value;
        //                    }

        //                    webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
        //                        var listcerts = JSON.parse(text);
        //                        if (listcerts.length > 0) {
        //                            var box = webix.modalbox({
        //                                title: "Chọn chứng thư số",
        //                                buttons: ["Nhận", "Hủy bỏ"],
        //                                text: "<div id='ctnCerts'></div>",
        //                                top: 100,
        //                                width: 750,
        //                                callback: function (result) {
        //                                    switch (result) {
        //                                        case "1":
        //                                            webix.modalbox.hide();
        //                                            break;
        //                                        case "0":
        //                                            var table = $$("tblCerts");
        //                                            var data = table.serialize();
        //                                            var cert = null;

        //                                            for (var i = 0; i < data.length; i++) {
        //                                                if (data[i].chon == true) {
        //                                                    cert = data[i];
        //                                                    break;
        //                                                }
        //                                            }

        //                                            if (cert == null) {
        //                                                webix.message("Bạn chưa chọn chứng thư số");
        //                                                return;
        //                                            }
        //                                            var postData = {
        //                                                branch_code: user.getDvcsID(),
        //                                                username: user.getCurrentUser(),
        //                                                cer_serial: cert.cer_serial,
        //                                                id: selectedItem.id,
        //                                            };

        //                                            webix.extend(tableDK, webix.ProgressBar);
        //                                            tableDK.disable();
        //                                            tableDK.showProgress();
        //                                            webix
        //                                                .ajax()
        //                                                .headers({ "Content-type": "application/json" })
        //                                                .post(app.config.host + "/Invoice68/SignBangKeBanRa", postData, {
        //                                                    error: function (text, data, XmlHttpRequest) {
        //                                                        tableDK.enable();
        //                                                        tableDK.hideProgress();
        //                                                        // var json = JSON.parse(text);
        //                                                        // webix.message(json.ExceptionMessage, "error");
        //                                                        webix.message(text + XmlHttpRequest, "error");
        //                                                    },
        //                                                    success: function (text, data, XmlHttpRequest) {
        //                                                        var json = JSON.parse(text);
        //                                                        tableDK.enable();
        //                                                        tableDK.hideProgress();
        //                                                        if (!json.hasOwnProperty("error")) {
        //                                                            webix.message("Gửi thành công đến CQT !", "success");
        //                                                            // $$("huyhoadonForms").close();
        //                                                            app.callEvent("dataChangebangkebanra", [1, null]);
        //                                                        } else {
        //                                                            webix.message(json.error, "error");
        //                                                        }
        //                                                    },
        //                                                });
        //                                            return;
        //                                    }
        //                                },
        //                            });
        //                            var tblMatHang = webix.ui({
        //                                container: "ctnCerts",
        //                                id: "tblCerts",
        //                                view: "datatable",
        //                                borderless: true,
        //                                resizeColumn: true,
        //                                height: 350,
        //                                columns: [
        //                                    {
        //                                        id: "chon",
        //                                        header: _("CHON"),
        //                                        width: 65,
        //                                        checkValue: true,
        //                                        uncheckValue: false,
        //                                        template: "{common.checkbox()}",
        //                                    },
        //                                    {
        //                                        id: "cer_serial",
        //                                        header: _("SO_SERIAL"),
        //                                        width: 150,
        //                                    },
        //                                    {
        //                                        id: "subject_name",
        //                                        header: _("SUBJECTNAME"),
        //                                        width: 450,
        //                                    },
        //                                    {
        //                                        id: "begin_date",
        //                                        header: _("NGAY_BAT_DAU"),
        //                                        width: 200,
        //                                    },
        //                                    {
        //                                        id: "end_date",
        //                                        header: _("NGAY_KET_THUC"),
        //                                        width: 200,
        //                                    },
        //                                    {
        //                                        id: "issuer",
        //                                        header: _("DONVI"),
        //                                        width: 450,
        //                                    },
        //                                ],
        //                                url: app.config.host + "/Invoice68/GetListCertificatesFile68",
        //                            });
        //                        } else {
        //                            var table = $$("bangkebanra");
        //                            webix.extend(table, webix.ProgressBar);
        //                            table.disable();
        //                            table.showProgress();

        //                            var a = webix.ajax(app.config.host + "/Invoice68/XmlBangKeBanRa?id=" + selectedItem.id);
        //                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

        //                            webix.promise.all([a, b, selectedItem]).then(function (results) {
        //                                // webix.extend(tblInvoice, webix.ProgressBar);
        //                                // tblInvoice.disable();
        //                                // tblInvoice.showProgress();
        //                                var json = results[0].json();

        //                                if (json.hasOwnProperty("error")) {
        //                                    webix.message({ type: "error", text: json.error });
        //                                }

        //                                var listcerts = results[1].json();
        //                                var item = results[2];

        //                                if (listcerts.length == 0) {
        //                                    table.enable();
        //                                    table.hideProgress();
        //                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
        //                                    return;
        //                                }

        //                                require(["views/modules/minvoiceplugin"], function (plugin) {
        //                                    var hub = plugin.hub();
        //                                    var hubconnect = plugin.conn();
        //                                    if (hubconnect.state != 1) {
        //                                        table.enable();
        //                                        table.hideProgress();
        //                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
        //                                        return;
        //                                    }
        //                                    hub.off("resCommand");
        //                                    hub.on("resCommand", function (result) {
        //                                        var json = JSON.parse(result);

        //                                        if (json.hasOwnProperty("error")) {
        //                                            webix.message({ type: "error", text: json.error });
        //                                        } else {
        //                                            var parameters = {
        //                                                xml: json.xml,
        //                                                id: selectedItem.id,
        //                                                shdon: json.shdon,
        //                                            };

        //                                            webix
        //                                                .ajax()
        //                                                .headers({ "Content-Type": "application/json" })
        //                                                .post(app.config.host + "/Invoice68/SaveXmlBangKeBanRa", parameters, function (text) {
        //                                                    var result = JSON.parse(text);
        //                                                    if (result.hasOwnProperty("error")) {
        //                                                        webix.message(result.error, "error");
        //                                                    } else {
        //                                                        webix.message("Gửi thành công đến CQT !", "success");
        //                                                        // $$("huyhoadonForms").close();
        //                                                        app.callEvent("dataChangebangkebanra", [1, null]);
        //                                                    }
        //                                                });
        //                                        }
        //                                        table.enable();
        //                                        table.hideProgress();
        //                                    });

        //                                    var _listcerts = [];

        //                                    for (var i = 0; i < listcerts.length; i++) {
        //                                        var _cert = listcerts[i];

        //                                        _listcerts.push({
        //                                            so_serial: _cert.cer_serial,
        //                                            ngaybatdau: _cert.begin_date,
        //                                            ngayketthuc: _cert.end_date,
        //                                            issuer: _cert.issuer,
        //                                            subjectname: _cert.subject_name,
        //                                        });
        //                                    }

        //                                    var arg = {
        //                                        idData: "#data",
        //                                        xml: json["xml"],
        //                                        shdon: json.shdon,
        //                                        idSigner: "seller",
        //                                        tagSign: "NNT",
        //                                        listcerts: _listcerts,
        //                                    };

        //                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
        //                                        .done(function () {
        //                                            console.log("Success !");
        //                                        })
        //                                        .fail(function (error) {
        //                                            webix.message(error, "error");
        //                                        });
        //                                });
        //                            });
        //                        }
        //                    });
        //                });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 120,
        //    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Lập bổ sung" + "</span>",
        //    id: "btnCreatePlus",
        //    shortcut: "F4",
        //    on: {
        //        onClick: function () {
        //            var detailForm = this.$scope.ui(bangkebanraForm.$ui);
        //            bangkebanraForm.setEditMode(1);
        //            detailForm.show();

        //            webix.$$("ldau").setValue(0);

        //            var url = app.config.host + "/Invoice68/GetInfoCompany";

        //            webix.ajax(url, function (text) {
        //                var json = JSON.parse(text);
        //                webix.$$("tnnt").setValue(json.name);
        //                webix.$$("mst").setValue(json.tax_code);
        //                webix.$$("ddanh").setValue(json.address);
        //            });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 120,
        //     label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Lập bổ sung") + "</span>",
        //     id: "btnUp",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("hoadon");
        //             var selectedItem = table.getSelectedItem();
        //             if (selectedItem == null) {
        //                 webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                 return;
        //             }
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải XML") + "</span>",
        //    id: "btnDownloadXml",
        //    on: {
        //        onClick: function () {
        //            var table = webix.$$("bangkebanra");
        //            var selectedItem = table.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                return;
        //            }
        //            if (selectedItem.trang_thai != 1) {
        //                webix.message("Bảng tổng hợp chưa gửi CQT không tồn tại xml ! ", "error");
        //                return;
        //            }

        //            webix.extend(table, webix.ProgressBar);
        //            table.disable();
        //            table.showProgress();

        //            var url = app.config.host + "/Invoice68/ExportXMLBangKeBanRa?id=" + selectedItem.id;
        //            webix
        //                .ajax()
        //                .response("arraybuffer")
        //                .get(url, function (text, data) {
        //                    table.enable();
        //                    table.hideProgress();

        //                    var file = new Blob([data], { type: "application/xml" });
        //                    webix.html.download(file, "BangKeBanRa.xml");
        //                    // var fileURL = URL.createObjectURL(file);
        //                    // window.open(fileURL, "_blank");
        //                });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                container: "testA",
                view: "treetable",
                id: "bangkebanra",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                fixedRowHeight: false,
                rowLineHeight: 25,
                rowHeight: 25,
                columns: [
                    {
                        id: "stt",
                        header: "<center>STT</center>",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "ky_hieu",
                        header:"<center>Ký hiệu</center>",
                        width: 500,
                        template: function (obj, common) {
                            if (obj.$level == 1) return common.treetable(obj, common) + "<span style='color:blue;'>" + obj.value + " ( " + obj.$count + " )" + "</span>";
                            return obj.ky_hieu;
                        },
                    },
                    {
                        id: "so_hd",
                        header: [{ text: "<center>Hóa đơn chứng từ bán</center>", colspan: 2 }, { text: "<center>Số hóa đơn</center>" }],
                        width: 500,
                        template: function (obj, common) {
                            if (obj.$level == 1) return common.treetable(obj, common) + "<span style='color:blue;'>" + obj.value + " ( " + obj.$count + " )" + "</span>";
                            return obj.so_hd;
                        },
                    },
                    {
                        id: "ngay_hd",
                        header: [null, { text: "<center>Ngày hóa đơn</center>" }],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    { id: "ten_kh_hd", header: "<center>Tên người mua</center>", width: 300 },
                    { id: "ms_thue", header: "<center>Mã số thuế</center>", width: 150 },
                    // DDKD — bat khi can hien dia diem kinh doanh (API goi rp_bc_bangkebanra_68_ddkd)
                    // { id: "mddkdoanh", header: "<center>Mã địa điểm kinh doanh</center>", width: 150 },
                    // { id: "tddkdoanh", header: "<center>Địa điểm kinh doanh</center>", width: 200 },
                    { id: "mchang", header: "<center>Mã cửa hàng</center>", width: 150 },
                    { id: "tchang", header: "<center>Tên cửa hàng</center>", width: 200 },
                    {
                        id: "tien_tt0",
                        header: "<center>Doanh thu chưa có thuế GTGT</center>",
                        width: 200,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    {
                        id: "tien",
                        header: "<center>Thuế GTGT</center>",
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    { id: "ghi_chu", header: "<center>Ghi chú</center>", width: 200 },
                ],
                pager: "pagerA",
                scheme: {
                    $group: {
                        by: "nhom",
                        //,css:{ "text-align": "right" }
                        // map:{
                        // 	nguoi_lien_he:["nguoi_lien_he", "count"]
                        // }
                    },
                    //$sort: { by: "stt", dir: "asc" }
                },
                ready: function () {
                    //this.open(this.getFirstId());
                    //this.sort({ by: "stt", dir: "asc" });
                    this.openAll();
                    this.adjustRowHeight("ghi_chu", true);
                    this.refresh();
                },
                //url: app.config.host + "/System/ExecuteQuery?sql=" + sql
                //autoheight: true,
                //autowidth:true,
                //data: big_film_set
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChangebangkebanra", function (item) {
                var table = $$("bangkebanra");
                // webix.extend(table, webix.OverlayBox);
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();

                table.config.rpParameter = item;

                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .post(app.config.host + "/Invoice68/GetDSHoaDonBangKeBanRa", item, {
                        error: function (text, data, XmlHttpRequest) {
                            table.enable();
                            table.hideProgress();
                            alert(text);
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var json = JSON.parse(text);
                            if (!json.hasOwnProperty("error")) {
                                //console.log(json);
                                $$("bangkebanra").clearAll();
                                $$("bangkebanra").parse(json);
                                $$("bangkebanra").refresh();
                            } else {
                                webix.message(json.error, "error");
                            }
                            table.enable();
                            table.hideProgress();
                        },
                    });
            });
        },
    };
});

define('views/modules/download_file_handle',["app", "locale"], function (app, _) {
    // config thông tin window ui
    var statusProcess = {
        loading: 'fas fa-spinner fa-spin icon-loading',
        error: 'fas fa-exclamation-circle custom-color-red',
        success: 'fas fa-check-circle custom-color-green'
    }

    var actionProcess = {
        sync: "fas fa-sync",
        cancel: "fas fa-times-circle",
        download: "fas fa-download"
    }

    // Danh sách các file đnag trong quá trình xử lý
    var listFileProcess = new webix.DataCollection({
        data: [],
    });

    //Hàm support xử lý
    function convertTypeToFileFormat(type) {
        var fileFormat = "application/pdf";
        switch (type) {
            case "PDF":
            case "pdf":
                fileFormat = "application/pdf";
                break;
            case "xlsx":
            case "XLSX":
                fileFormat = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                break;
        }
        return fileFormat;
    }

    function handleProcessFileInfo(processFileInfo) {
        var request = null;
        // Add item
        var id = Math.floor(Math.random() * 1000000);
        var fileInfo = {
            id: id,
            name: processFileInfo.fileName,
            loadingIcon: statusProcess.loading,
            actionIcon: actionProcess.cancel,
            process: null,
            type: processFileInfo.fileType,
            data: null,
            clickAction: null,
            xhr: null
        }

        // gán event
        var sucessEvent = function (text, data, XmlHttpRequest) {
            fileInfo.loadingIcon = statusProcess.success;
            fileInfo.actionIcon = actionProcess.download;
            if(data != null) {
                fileInfo.data = new Blob([data], { type: convertTypeToFileFormat(fileInfo.fileType) });
            }

            listFileProcess.updateItem(fileInfo.id, fileInfo);
            if(processFileInfo.onSuccess != null) {
                processFileInfo.onSuccess(text, data, XmlHttpRequest);
            }
        }

        var errorEvent = function (text, data, XmlHttpRequest) {
            fileInfo.loadingIcon = statusProcess.error;
            fileInfo.actionIcon = actionProcess.sync;
            listFileProcess.updateItem(fileInfo.id, fileInfo);
            if(processFileInfo.onError != null) {
                processFileInfo.onError(text, data, XmlHttpRequest);
            }
        }

        // gán request ajax
        var paramRequest = JSON.parse(JSON.stringify(processFileInfo.param ? processFileInfo.param : {}));
        request = webix.ajax()
            .response(processFileInfo.response)
            .headers(processFileInfo.header); 

        switch(processFileInfo.method) {
            case "post":
            case "POST":
                fileInfo.process = request.post.bind(request);
                fileInfo.process(
                    processFileInfo.url,
                    paramRequest,
                    {
                        error: errorEvent,
                        success: sucessEvent,
                    }
                );
                break;
            case "get":
            case "GET":
                fileInfo.process = request.get.bind(request);
                fileInfo.process(
                    processFileInfo.url,
                    {
                        error: errorEvent,
                        success: sucessEvent,
                    }
                );
                break;
        }
        
        // Xử lý action
        fileInfo.clickAction = function () {
            var me = this;
            switch(this.actionIcon) {
                case actionProcess.sync:
                    if(me.process) {
                        me.actionIcon = actionProcess.cancel;
                        me.loadingIcon = statusProcess.loading;
                        switch(processFileInfo.method) {
                            case "post":
                            case "POST":
                                fileInfo.process = request.post.bind(request);
                                fileInfo.process(
                                    processFileInfo.url,
                                    paramRequest,
                                    {
                                        error: errorEvent,
                                        success: sucessEvent,
                                    }
                                );
                            case "get":
                            case "GET":
                                fileInfo.process = request.get.bind(request);
                                fileInfo.process(
                                    processFileInfo.url,
                                    {
                                        error: errorEvent,
                                        success: sucessEvent,
                                    }
                                );
                                break;
                        };
                        listFileProcess.updateItem(me.id, me);
                    }
                    break;
                case actionProcess.cancel:
                    if(me.process) {
                        
                    }
                    webix.confirm({
                        text: "Bảng kê đang được kết xuất, bạn có muốn huỷ bỏ tiến trình?",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                removeItem(me.id);
                            }
                        }
                    })
                    break;
                case actionProcess.download:
                    if(processFileInfo.onDownLoad) {
                        processFileInfo.onDownLoad(me.data);
                    }
                    break;
            }
        }

        // Gán vào list process
        listFileProcess.add(fileInfo, 0);
    }

    function checkFileProcess() {
        var rs = false;
        var count = 0;
        for(var i = 0; i < listFileProcess.count(); i++) {
            var itemId = listFileProcess.getIdByIndex(i);
            var item = listFileProcess.getItem(itemId);
            if(item.loadingIcon == statusProcess.loading) {
                count++;
            }
        }
        rs = count < 3;
        return rs;
    }

    function checkItemLoading() {
        var isLoading = false;
        for(var i = 0; i < listFileProcess.count(); i++) {
            var itemId = listFileProcess.getIdByIndex(i);
            var item = listFileProcess.getItem(itemId);
            if(item.loadingIcon == statusProcess.loading) {
                isLoading = true;
                break;
            }
        }
        return isLoading;
    }

    function removeItem(id) {
        if(id) {
            listFileProcess.remove(id);
            if(listFileProcess.count() == 0) {
                closeWindow();
            }
        }
    }

    function closeWindow() {
        listFileProcess.clearAll();
        $$("download_window").close();
    }

    // Vẽ header
    function genHeader(title) {
        title = title ? title : "Kết xuất bảng kê"; 
        var headerComp = {
            view: "toolbar",
            css: "manager-file-header",
            elements: [
                {
                    template:
                        "<div class='manager-file-title'>" + title + "</div>",
                    borderless: true,
                },
                {
                    view: "template",
                    template:
                        "<div class='manager-file-down manager-file-icon manager-file-action'><i class='fas fa-chevron-down'></i></div><div class='manager-file-close-button manager-file-icon manager-file-action'><i class='fas fa-times'></i></div>",
                    borderless: true,
                    css: "manager-file-header-button",
                    onClick: {
                        "manager-file-down": function () {
                            var window = $$("download_window"); 
                            var className = "hide-custom-class";
    
                            var htmlElement = window.$view; 
                            if (htmlElement.classList.contains(className)) {
                                htmlElement.classList.remove(className); 
                            } else {
                                htmlElement.classList.add(className); 
                            }
                        },
                        "manager-file-close-button": function () {
                            if(checkItemLoading()) {
                                webix.confirm({
                                    text: "Bảng kê đang được kết xuất, bạn có muốn huỷ bỏ tiến trình?",
                                    ok: "Có",
                                    cancel: "Không",
                                    callback: function (choose) {
                                        if (choose) {
                                            closeWindow();
                                        }
                                    }
                                })
                            } else {
                                closeWindow();
                            }
                        },
                    },
                },
            ],
        };

        return headerComp;
    }

    // Vẽ body
    var getIconFile = function (type) {
        var icon = "far fa-file";
        switch (type) {
            case "PDF":
            case "pdf":
                icon = "far fa-file-pdf custom-color-red";
                break;
            case "xlsx":
            case "XLSX":
                icon = "far fa-file-excel custom-color-green";
                break;
        }
        return icon;
    };

    var bodyComp = {
        view: "list",
        css: "manager-file-custom_list",
        id: "manager-file-custom_list",
        template: function (obj) {
            var type = getIconFile(obj.type);
            var temp =
                '<div class="manager-file-list_item">' +
                '<div class="manager-file-item_icon"><i class="' +
                type +
                '"></i></div>' +
                '<div class="manager-file-item_name">' +
                obj.name +
                "</div>" +
                '<div class="manager-file-item_loading_icon"><i class="' +
                obj.loadingIcon +
                '"></i></div>' +
                '<div class="manager-file-item_action_icon" id="download-action-' + obj.id + '"><i class="' +
                obj.actionIcon +
                '"></i></div></div>';
            return temp;
        },
        ready: function () {
            $$("manager-file-custom_list").attachEvent("onItemClick", function (id, e, node) {
                var item = this.getItem(id);
                var elementId = "download-action-" + item.id;
    
                // Kiểm tra xem có phải là phần tử action_icon được click hay không
                if (e.target && e.target.closest("#" + elementId) && item) {
                    item.clickAction();
                }
            });
        },
        data: listFileProcess,
    };

    return {
        handleFileDownLoad: function (fileProcessInfor) {

            var isCheckAdd = checkFileProcess();
            if(!isCheckAdd) {
                webix.message("Số file đang kết xuất đã đạt tối đa (3 file)", "error");
                return;
            }

            var window = webix.$$("download_window");
            if(fileProcessInfor == null) {
                return;
            } 

            // Xử lý fileProcessInfor
            handleProcessFileInfo(fileProcessInfor);
            
            // Show window
            var headerTitle = fileProcessInfor["headerTitle"];
            if(window == null || window == undefined) {
                webix.ui({
                    view: "window",
                    id: "download_window",
                    css: "manager-file",
                    head: genHeader(headerTitle),
                    body: bodyComp,
                    autohide: false,
                    hidden: true,
                })
                .show();
            }
            
        },
    };
});

define('views/forms/68_bangkebanraFormChiTiet',["app", "locale", "models/user"], function (app, _, user) {
    var editmode = 0;

    var date = new Date();
    var _month = date.getMonth() + 1;
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    function subviewT() {
        $$("cbQuy").define("label", "Tháng");
        $$("cbQuy").refresh();
        $$("cbQuy").define("options", ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
        //webix.extend(config, $$('cbQuy').config);
        //webix.ui(config, $$('cbThang'));
        //$$('cbThang').destructor();
    }

    function subviewQ() {
        $$("cbQuy").define("label", "Quý");
        $$("cbQuy").refresh();
        $$("cbQuy").define("options", ["1", "2", "3", "4"]);
        // webix.extend($$('cbQuy').config, config, true);
        //webix.ui(config, $$('cbQuy'));
        //$$('cbQuy').destructor();
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Bảng kê bán ra chi tiết",
            width: 550,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 60 },
                view: "form",
                id: "bangkebr",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "multicombo",
                        label: _("DONVI"),
                        name: "lst_branch_code",
                        labelWidth: 80,
                        required: true,
                        invalidMessage: "Vui lòng chọn đơn vị",
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00198",
                            },
                        },
                        on: {
                            onChange: function (newValue, oldValue) {
                                // Tạo URL API dựa trên các giá trị đã chọn trong multicomboA
                                var urlLoad = app.config.host + "/System/GetDataReferencesByRefIdAndBranchs?refId=RF003001&branchs=" + newValue;

                                // Cập nhật URL của multicomboB và tải lại dữ liệu
                                var comp = $$("multicombo_kyhieu").getPopup().getList();
                                if (comp != null) {
                                    comp.clearAll();
                                    comp.load(urlLoad);
                                }
                            }
                        }
                    },
                    {
                        cols: [
                            {
                                view: "radio",
                                id: "head_extension",
                                value: 1,
                                options: [
                                    { id: 1, value: "Tháng" }, // the initially selected item
                                    { id: 2, value: "Quý" },
                                ],
                                on: {
                                    onChange: function (newv, oldv) {
                                        var d = new Date();
                                        var quarter = Math.floor(d.getMonth() / 3);
                                        var quarter1 = quarter + 1;
                                        if (newv == 2) {
                                            subviewQ();
                                            $$("cbQuy").setValue(quarter1);
                                        }
                                        if (newv == 1) {
                                            subviewT();
                                            $$("cbQuy").setValue(d.getMonth() + 1);
                                        }
                                    },
                                },
                            },
                            {
                                id: "cbQuy",
                                name: "quy",
                                view: "combo",
                                label: "Tháng",
                                value: _month,
                                options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
                                on: {
                                    onChange: function () {
                                        var d = new Date();
                                        var quarter = Math.floor(d.getMonth() / 3);
                                        var quarter1 = quarter + 1;

                                        var option = $$("head_extension").getValue();
                                        if (option == 2) {
                                            var nam = d.getFullYear();
                                            var thang;
                                            var quy = $$("cbQuy").getValue();
                                            if (quy == 1) {
                                                thang = 0;
                                            }
                                            if (quy == 2) {
                                                thang = 3;
                                            }
                                            if (quy == 3) {
                                                thang = 6;
                                            }
                                            if (quy == 4) {
                                                thang = 9;
                                            }
                                            var firstDate = new Date(nam, thang, 1);
                                            var lastDate = new Date(nam, thang + 3, 0);

                                            $$("tu_ngay").setValue(firstDate);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDate);
                                            $$("den_ngay").refresh();
                                        }
                                        if (option == 1) {
                                            var year = d.getFullYear();
                                            var month = $$("cbQuy").getValue();
                                            var date1 = month + "/01" + "/" + year;

                                            var date = new Date(date1);
                                            var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                                            var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                                            $$("tu_ngay").setValue(firstDay1);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDay1);
                                            $$("den_ngay").refresh();
                                        }
                                    },
                                },
                            },
                        ],
                    },
                    {
                        view: "datepicker",
                        label: _("TU_NGAY"),
                        name: "tu_ngay",
                        id: "tu_ngay",
                        value: firstDay,
                        labelWidth: 80,
                        invalidMessage: "Vui lòng chọn từ ngày",
                        validate: webix.rules.isNotEmpty,
                        required: true,
                    },
                    {
                        view: "datepicker",
                        label: _("DEN_NGAY"),
                        name: "den_ngay",
                        id: "den_ngay",
                        value: lastDay,
                        labelWidth: 80,
                        invalidMessage: "Vui lòng chọn đến ngày",
                        validate: webix.rules.isNotEmpty,
                        required: true,
                    },
                    {
                        view: "multicombo",
                        label: _("KY_HIEU"),
                        name: "ky_hieu",
                        id: "multicombo_kyhieu",
                        labelWidth: 80,
                        // required: true,
                        // invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
                        // validate: webix.rules.isNotEmpty,
                        suggest: {
                            selectAll: true,
                            body: {
                                // url: app.config.host + "/System/GetDataReferencesByRefIdAndBranchs?refId=RF003001",
                                //template: webix.template("#value#")
                            },
                        },
                        //value: "2"
                    },
                    {
                        view: "checkbox",
                        id: "ishhdt",
                        name: "ishhdt",
                        label: "Thông tin hàng hóa đặc trưng",
                        labelWidth: 200
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Nhận (F10)",
                                width: 100,
                                type: "form",
                                align: "center",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var tableHoadon = $$("bangkebr");
                                            if (tableHoadon.validate()) {
                                                var tungay = $$("tu_ngay").getValue();
                                                var denngay = $$("den_ngay").getValue();

                                                if (tungay > denngay) {
                                                    webix.message("Ngày bắt đầu phải nhỏ hơn ngày kết thúc !", "error");
                                                    $$("tu_ngay").focus();
                                                    return;
                                                }

                                                var form = self.getParentView().getParentView();
                                                var win = self.getTopParentView();

                                                var item = form.getValues();
                                                var load_event = "dataChangebangkebanrachitiet";

                                                app.callEvent(load_event, [item]);

                                                win.close();
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 100,
                                align: "center",
                                type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },

        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            form.setValues(item);
        },
    };
});

define('views/68_bangkebanrachitiet',["app", "locale", "models/user", "views/modules/download_file_handle", "views/forms/68_bangkebanraFormChiTiet", "views/forms/68_hoadon_history"], function (app, _, user, handleFile, bangkebanraForm, hoadonHistory) {
    

    webix.$$("title").parse({
        title: "Tờ khai chứng từ bán ra",
        details: "Tờ khai chứng từ bán ra",
    });


    function formatDate() {
        var date = new Date();

        var dd = String(date.getDate()).padStart(2, '0');
        var MM = String(date.getMonth() + 1).padStart(2, '0'); // Tháng bắt đầu từ 0
        var YYYY = date.getFullYear();
        var hh = String(date.getHours()).padStart(2, '0');
        var mm = String(date.getMinutes()).padStart(2, '0');
        var ss = String(date.getSeconds()).padStart(2, '0');

        var formattedDate = dd + "_" + MM + "_" + YYYY + "_" + hh + "_" + mm + "_" + ss;
        return formattedDate;
    }

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(bangkebanraForm.$ui);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
        //    id: "btnPlus",
        //    shortcut: "F4",
        //    on: {
        //        onClick: function () {
        //            var detailForm = this.$scope.ui(bangkebanraForm.$ui);
        //            bangkebanraForm.setEditMode(1);
        //            detailForm.show();

        //            var url = app.config.host + "/Invoice68/GetInfoCompany";

        //            webix.ajax(url, function (text) {
        //                var json = JSON.parse(text);
        //                webix.$$("tnnt").setValue(json.name);
        //                webix.$$("mst").setValue(json.tax_code);
        //                webix.$$("ddanh").setValue(json.address);
        //            });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
        //    id: "btnEdit",
        //    shortcut: "F3",
        //    on: {
        //        onClick: function () {
        //            var table = webix.$$("bangkebanra");
        //            var selectedItem = table.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn dòng nào ! ", "error");
        //                return;
        //            }

        //            var detailForm = this.$scope.ui(bangkebanraForm.$ui);
        //            bangkebanraForm.setEditMode(2);
        //            bangkebanraForm.setValues(selectedItem);
        //            if (selectedItem.trang_thai == 1) {
        //                var form = $$("bangkebanra-form").elements;
        //                for (var key in form) {
        //                    var $el = form[key];
        //                    $el.define("readonly", "true");
        //                    $el.define("css", "mcls_readonly_text");
        //                    $el.refresh();
        //                }

        //                webix.$$("btnBTHSave").destructor();
        //                webix.$$("btnTaiDanhSachBanRa").destructor();
        //            }
        //            detailForm.show();
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
        //    id: "btnDelete",
        //    shortcut: "F8",
        //    on: {
        //        onClick: function () {
        //            var table = webix.$$("bangkebanra");
        //            var selectedItem = table.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                return;
        //            }
        //            if (selectedItem.trang_thai == 1) {
        //                webix.message("Bảng tổng hợp đã gửi CQT không thể xóa ! ", "error");
        //                return;
        //            }

        //            var khData = {};

        //            khData.editmode = 3;
        //            khData.data = [];
        //            khData.data.push(selectedItem);

        //            webix.confirm({
        //                text: "Bạn có muốn xóa bản ghi",
        //                ok: "Có",
        //                cancel: "Không",
        //                callback: function (choose) {
        //                    if (choose) {
        //                        webix
        //                            .ajax()
        //                            .headers({ "Content-type": "application/json" })
        //                            .post(app.config.host + "/Invoice68/SaveBangKeBanRa", khData, function (text) {
        //                                var response = JSON.parse(text);

        //                                if (response.hasOwnProperty("error")) {
        //                                    webix.message({ type: "error", text: response.error });
        //                                    return;
        //                                }

        //                                // table.remove(item.id);
        //                                var btnRefresh = $$("btnRefresh");
        //                                btnRefresh.callEvent("onClick");
        //                            });
        //                    }
        //                },
        //            });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fas fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "In PDF" + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;

                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }

                    var datafrmAll = table.serialize();

                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để in !", "error");
                        return;
                    }

                    rpParameter.type = "PDF";

                    var fileName = 'BangKeBanRa_' + formatDate();
                    if (rpParameter != null) {
                        var fileProcessInfor = {
                            method: "POST",
                            response: "arraybuffer",
                            header: { "Content-type": "application/json" },
                            url: app.config.host + "/Invoice68/PrintPDFBangKeBanRaChiTiet",
                            param: rpParameter,
                            onError: function (data, XmlHttpRequest) {
                                var textErr = "Đã có lỗi xảy ra";
                                if (XmlHttpRequest && XmlHttpRequest.statusText) {
                                    textErr = XmlHttpRequest.statusText;
                                }
                                webix.message(textErr, "error");
                            },
                            onDownLoad: function (data) {
                                var fileURL = URL.createObjectURL(data);
                                window.open(fileURL, "_blank");

                                if (newWindow) {
                                    setTimeout(function () {
                                        URL.revokeObjectURL(fileURL);
                                    }, 100);
                                }
                            },
                            fileName: fileName,
                            fileType: rpParameter.type
                        };

                        handleFile.handleFileDownLoad(fileProcessInfor);
                        return;
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-file fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("EXPORT_EXCEL") + "</span>",
            id: "btnExportExcel",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";

                    var datafrmAll = table.serialize();

                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để xuất !", "error");
                        return;
                    }

                    if (rpParameter != null) {
                        var fileName = 'BangKeBanRa_' + formatDate();
                        var fileProcessInfor = {
                            method: "POST",
                            response: "arraybuffer",
                            header: { "Content-type": "application/json" },
                            url: app.config.host + "/Invoice68/PrintPDFBangKeBanRaChiTiet",
                            param: rpParameter,
                            onError: function (text, data, XmlHttpRequest) {
                                var textErr = "Đã có lỗi xảy ra";
                                if (XmlHttpRequest && XmlHttpRequest.statusText) {
                                    textErr = XmlHttpRequest.statusText;
                                }
                                webix.message(textErr, "error");
                            },
                            onDownLoad: function (data) {
                                webix.html.download(data, fileName + ".xlsx");
                            },
                            fileName: fileName,
                            fileType: rpParameter.type
                        };

                        handleFile.handleFileDownLoad(fileProcessInfor);
                        return;
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 100,
        //     label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Gửi email") + "</span>",
        //     id: "btnSendEmail",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("hoadon");
        //             var selectedItem = table.getSelectedItem();
        //             if (selectedItem == null) {
        //                 webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                 return;
        //             }
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký gửi CQT") + "</span>",
        //    id: "btnSign",
        //    on: {
        //        onClick: function () {
        //            var tableDK = webix.$$("bangkebanra");
        //            var selectedItem = tableDK.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn dòng ! ", "error");
        //                return;
        //            }
        //            if (selectedItem.trang_thai == 1) {
        //                webix.message("Mẫu đã ký và gửi CQT bạn không thể ký lại! ", "error");
        //                return;
        //            }

        //            webix
        //                .ajax()
        //                .headers({ "Content-Type": "application/json" })
        //                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
        //                    var result = JSON.parse(text);
        //                    var kytaptrung = "";
        //                    for (var i = 0; i < result.length; i++) {
        //                        var item = result[i];
        //                        kytaptrung = item.value;
        //                    }

        //                    webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
        //                        var listcerts = JSON.parse(text);
        //                        if (listcerts.length > 0) {
        //                            var box = webix.modalbox({
        //                                title: "Chọn chứng thư số",
        //                                buttons: ["Nhận", "Hủy bỏ"],
        //                                text: "<div id='ctnCerts'></div>",
        //                                top: 100,
        //                                width: 750,
        //                                callback: function (result) {
        //                                    switch (result) {
        //                                        case "1":
        //                                            webix.modalbox.hide();
        //                                            break;
        //                                        case "0":
        //                                            var table = $$("tblCerts");
        //                                            var data = table.serialize();
        //                                            var cert = null;

        //                                            for (var i = 0; i < data.length; i++) {
        //                                                if (data[i].chon == true) {
        //                                                    cert = data[i];
        //                                                    break;
        //                                                }
        //                                            }

        //                                            if (cert == null) {
        //                                                webix.message("Bạn chưa chọn chứng thư số");
        //                                                return;
        //                                            }
        //                                            var postData = {
        //                                                branch_code: user.getDvcsID(),
        //                                                username: user.getCurrentUser(),
        //                                                cer_serial: cert.cer_serial,
        //                                                id: selectedItem.id,
        //                                            };

        //                                            webix.extend(tableDK, webix.ProgressBar);
        //                                            tableDK.disable();
        //                                            tableDK.showProgress();
        //                                            webix
        //                                                .ajax()
        //                                                .headers({ "Content-type": "application/json" })
        //                                                .post(app.config.host + "/Invoice68/SignBangKeBanRa", postData, {
        //                                                    error: function (text, data, XmlHttpRequest) {
        //                                                        tableDK.enable();
        //                                                        tableDK.hideProgress();
        //                                                        // var json = JSON.parse(text);
        //                                                        // webix.message(json.ExceptionMessage, "error");
        //                                                        webix.message(text + XmlHttpRequest, "error");
        //                                                    },
        //                                                    success: function (text, data, XmlHttpRequest) {
        //                                                        var json = JSON.parse(text);
        //                                                        tableDK.enable();
        //                                                        tableDK.hideProgress();
        //                                                        if (!json.hasOwnProperty("error")) {
        //                                                            webix.message("Gửi thành công đến CQT !", "success");
        //                                                            // $$("huyhoadonForms").close();
        //                                                            app.callEvent("dataChangebangkebanra", [1, null]);
        //                                                        } else {
        //                                                            webix.message(json.error, "error");
        //                                                        }
        //                                                    },
        //                                                });
        //                                            return;
        //                                    }
        //                                },
        //                            });
        //                            var tblMatHang = webix.ui({
        //                                container: "ctnCerts",
        //                                id: "tblCerts",
        //                                view: "datatable",
        //                                borderless: true,
        //                                resizeColumn: true,
        //                                height: 350,
        //                                columns: [
        //                                    {
        //                                        id: "chon",
        //                                        header: _("CHON"),
        //                                        width: 65,
        //                                        checkValue: true,
        //                                        uncheckValue: false,
        //                                        template: "{common.checkbox()}",
        //                                    },
        //                                    {
        //                                        id: "cer_serial",
        //                                        header: _("SO_SERIAL"),
        //                                        width: 150,
        //                                    },
        //                                    {
        //                                        id: "subject_name",
        //                                        header: _("SUBJECTNAME"),
        //                                        width: 450,
        //                                    },
        //                                    {
        //                                        id: "begin_date",
        //                                        header: _("NGAY_BAT_DAU"),
        //                                        width: 200,
        //                                    },
        //                                    {
        //                                        id: "end_date",
        //                                        header: _("NGAY_KET_THUC"),
        //                                        width: 200,
        //                                    },
        //                                    {
        //                                        id: "issuer",
        //                                        header: _("DONVI"),
        //                                        width: 450,
        //                                    },
        //                                ],
        //                                url: app.config.host + "/Invoice68/GetListCertificatesFile68",
        //                            });
        //                        } else {
        //                            var table = $$("bangkebanra");
        //                            webix.extend(table, webix.ProgressBar);
        //                            table.disable();
        //                            table.showProgress();

        //                            var a = webix.ajax(app.config.host + "/Invoice68/XmlBangKeBanRa?id=" + selectedItem.id);
        //                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

        //                            webix.promise.all([a, b, selectedItem]).then(function (results) {
        //                                // webix.extend(tblInvoice, webix.ProgressBar);
        //                                // tblInvoice.disable();
        //                                // tblInvoice.showProgress();
        //                                var json = results[0].json();

        //                                if (json.hasOwnProperty("error")) {
        //                                    webix.message({ type: "error", text: json.error });
        //                                }

        //                                var listcerts = results[1].json();
        //                                var item = results[2];

        //                                if (listcerts.length == 0) {
        //                                    table.enable();
        //                                    table.hideProgress();
        //                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
        //                                    return;
        //                                }

        //                                require(["views/modules/minvoiceplugin"], function (plugin) {
        //                                    var hub = plugin.hub();
        //                                    var hubconnect = plugin.conn();
        //                                    if (hubconnect.state != 1) {
        //                                        table.enable();
        //                                        table.hideProgress();
        //                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
        //                                        return;
        //                                    }
        //                                    hub.off("resCommand");
        //                                    hub.on("resCommand", function (result) {
        //                                        var json = JSON.parse(result);

        //                                        if (json.hasOwnProperty("error")) {
        //                                            webix.message({ type: "error", text: json.error });
        //                                        } else {
        //                                            var parameters = {
        //                                                xml: json.xml,
        //                                                id: selectedItem.id,
        //                                                shdon: json.shdon,
        //                                            };

        //                                            webix
        //                                                .ajax()
        //                                                .headers({ "Content-Type": "application/json" })
        //                                                .post(app.config.host + "/Invoice68/SaveXmlBangKeBanRa", parameters, function (text) {
        //                                                    var result = JSON.parse(text);
        //                                                    if (result.hasOwnProperty("error")) {
        //                                                        webix.message(result.error, "error");
        //                                                    } else {
        //                                                        webix.message("Gửi thành công đến CQT !", "success");
        //                                                        // $$("huyhoadonForms").close();
        //                                                        app.callEvent("dataChangebangkebanra", [1, null]);
        //                                                    }
        //                                                });
        //                                        }
        //                                        table.enable();
        //                                        table.hideProgress();
        //                                    });

        //                                    var _listcerts = [];

        //                                    for (var i = 0; i < listcerts.length; i++) {
        //                                        var _cert = listcerts[i];

        //                                        _listcerts.push({
        //                                            so_serial: _cert.cer_serial,
        //                                            ngaybatdau: _cert.begin_date,
        //                                            ngayketthuc: _cert.end_date,
        //                                            issuer: _cert.issuer,
        //                                            subjectname: _cert.subject_name,
        //                                        });
        //                                    }

        //                                    var arg = {
        //                                        idData: "#data",
        //                                        xml: json["xml"],
        //                                        shdon: json.shdon,
        //                                        idSigner: "seller",
        //                                        tagSign: "NNT",
        //                                        listcerts: _listcerts,
        //                                    };

        //                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
        //                                        .done(function () {
        //                                            console.log("Success !");
        //                                        })
        //                                        .fail(function (error) {
        //                                            webix.message(error, "error");
        //                                        });
        //                                });
        //                            });
        //                        }
        //                    });
        //                });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 120,
        //    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Lập bổ sung" + "</span>",
        //    id: "btnCreatePlus",
        //    shortcut: "F4",
        //    on: {
        //        onClick: function () {
        //            var detailForm = this.$scope.ui(bangkebanraForm.$ui);
        //            bangkebanraForm.setEditMode(1);
        //            detailForm.show();

        //            webix.$$("ldau").setValue(0);

        //            var url = app.config.host + "/Invoice68/GetInfoCompany";

        //            webix.ajax(url, function (text) {
        //                var json = JSON.parse(text);
        //                webix.$$("tnnt").setValue(json.name);
        //                webix.$$("mst").setValue(json.tax_code);
        //                webix.$$("ddanh").setValue(json.address);
        //            });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 120,
        //     label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Lập bổ sung") + "</span>",
        //     id: "btnUp",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("hoadon");
        //             var selectedItem = table.getSelectedItem();
        //             if (selectedItem == null) {
        //                 webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                 return;
        //             }
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải XML") + "</span>",
        //    id: "btnDownloadXml",
        //    on: {
        //        onClick: function () {
        //            var table = webix.$$("bangkebanra");
        //            var selectedItem = table.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                return;
        //            }
        //            if (selectedItem.trang_thai != 1) {
        //                webix.message("Bảng tổng hợp chưa gửi CQT không tồn tại xml ! ", "error");
        //                return;
        //            }

        //            webix.extend(table, webix.ProgressBar);
        //            table.disable();
        //            table.showProgress();

        //            var url = app.config.host + "/Invoice68/ExportXMLBangKeBanRa?id=" + selectedItem.id;
        //            webix
        //                .ajax()
        //                .response("arraybuffer")
        //                .get(url, function (text, data) {
        //                    table.enable();
        //                    table.hideProgress();

        //                    var file = new Blob([data], { type: "application/xml" });
        //                    webix.html.download(file, "BangKeBanRa.xml");
        //                    // var fileURL = URL.createObjectURL(file);
        //                    // window.open(fileURL, "_blank");
        //                });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                container: "testA",
                view: "treetable",
                id: "bangkebanra",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                fixedRowHeight: false,
                rowLineHeight: 25,
                rowHeight: 25,
                columns: [
                    {
                        id: "stt",
                        header: "<center>STT</center>",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "ky_hieu",
                        header: "<center>Ký hiệu</center>",
                        width: 150
                    },
                    {
                        id: "so_hd",
                        header: [{ text: "<center>Hóa đơn chứng từ bán</center>", colspan: 2 }, { text: "<center>Số hóa đơn</center>" }],
                        width: 500,
                        template: function (obj, common) {
                            if (obj.$level == 1) return common.treetable(obj, common) + "<span style='color:blue;'>" + obj.value + " ( " + obj.$count + " )" + "</span>";
                            return obj.so_hd;
                        },
                    },

                    {
                        id: "ngay_hd",
                        header: [null, { text: "<center>Ngày hóa đơn</center>" }],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    { id: "makh", header: "<center>Mã khách hàng</center>", width: 150 },
                    { id: "ten_ng_mua", header: "<center>Tên người mua</center>", width: 200 },
                    { id: "ten_kh_hd", header: "<center>Tên đơn vị</center>", width: 200 },
                    { id: "dia_chi", header: "<center>Địa chỉ</center>", width: 300 },
                    { id: "cccd", header: "<center>CCCD</center>", width: 150, hidden: true },
                    { id: "ms_thue", header: "<center>Mã số thuế</center>", width: 150 },
                    {
                        id: "tien_tt0",
                        header: "<center>Doanh thu chưa có thuế GTGT</center>",
                        width: 200,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    { id: "mat_hang", header: "<center>Mặt hàng</center>", width: 150 },
                    { id: "lhhdthu", header: "<center>Loại hàng hóa đặc trưng </center>", width: 100 },
                    { id: "skhung", header: "<center>Số khung</center>", width: 100 },
                    { id: "smay", header: "<center>Số máy</center>", width: 100 },
                    { id: "bksptvchuyen", header: "<center>Biển kiểm soát</center>", width: 100 },
                    { id: "tnghang", header: "<center>Tên người gửi hàng</center>", width: 100 },
                    { id: "dcnghang", header: "<center>Địa chỉ người gửi hàng</center>", width: 100 },
                    { id: "mstnghang", header: "<center>MST người gửi hàng</center>", width: 100 },
                    { id: "mddnghang", header: "<center>Số định danh người gửi hàng</center>", width: 100 },
                    { id: "mdvtinh", header: "<center>Mã đơn vị tính</center>", width: 150 },
                    { id: "sluong", header: "<center>Số lượng</center>", width: 150 },
                    {
                        id: "dgia",
                        header: "<center>Đơn giá</center>",
                        width: 150,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    {
                        id: "tien",
                        header: "<center>Thuế GTGT</center>",
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    { id: "don_vi_lap", header: "<center>Đơn vị lập hóa đơn</center>", width: 200 },
                    { id: "ma_tra_cuu", header: "<center>Mã tra cứu hóa đơn</center>", width: 200 },
                    { id: "ghi_chu", header: "<center>Ghi chú</center>", width: 200 },
                ],
                pager: "pagerA",
                scheme: {
                    $group: {
                        by: "nhom",
                        //,css:{ "text-align": "right" }
                        // map:{
                        // 	nguoi_lien_he:["nguoi_lien_he", "count"]
                        // }
                    },
                    //$sort: { by: "stt", dir: "asc" }
                },
                ready: function () {
                    //this.open(this.getFirstId());
                    //this.sort({ by: "stt", dir: "asc" });
                    this.openAll();
                    this.adjustRowHeight("ghi_chu", true);
                    this.refresh();
                },
                //url: app.config.host + "/System/ExecuteQuery?sql=" + sql
                //autoheight: true,
                //autowidth:true,
                //data: big_film_set
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChangebangkebanrachitiet", function (item) {
                var table = $$("bangkebanra");
                // webix.extend(table, webix.OverlayBox);
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();

                table.config.rpParameter = item;

                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .post(app.config.host + "/Invoice68/GetDSHoaDonBangKeBanRaChiTiet", item, {
                        error: function (text, data, XmlHttpRequest) {
                            table.enable();
                            table.hideProgress();
                            alert(text);
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var json = JSON.parse(text);
                            if (!json.hasOwnProperty("error")) {
                                //console.log(json);
                                $$("bangkebanra").clearAll();
                                $$("bangkebanra").parse(json);
                                var dataList = json.data || json;
                                var hasCccd = Array.isArray(dataList) && dataList.length > 0 && dataList[0].hasOwnProperty("cccd");
                                if (hasCccd) {
                                    $$("bangkebanra").showColumn("cccd");
                                } else {
                                    $$("bangkebanra").hideColumn("cccd");
                                }
                                if (item.ishhdt != "1") {
                                    $$("bangkebanra").hideColumn("lhhdthu");
                                    $$("bangkebanra").hideColumn("skhung");
                                    $$("bangkebanra").hideColumn("smay");
                                    $$("bangkebanra").hideColumn("bksptvchuyen");
                                    $$("bangkebanra").hideColumn("tnghang");
                                    $$("bangkebanra").hideColumn("dcnghang");
                                    $$("bangkebanra").hideColumn("mstnghang");
                                    $$("bangkebanra").hideColumn("mddnghang");
                                } else {
                                    $$("bangkebanra").showColumn("lhhdthu");
                                    $$("bangkebanra").showColumn("skhung");
                                    $$("bangkebanra").showColumn("smay");
                                    $$("bangkebanra").showColumn("bksptvchuyen");
                                    $$("bangkebanra").showColumn("tnghang");
                                    $$("bangkebanra").showColumn("dcnghang");
                                    $$("bangkebanra").showColumn("mstnghang");
                                    $$("bangkebanra").showColumn("mddnghang");
                                }
                                $$("bangkebanra").refresh();
                            } else {
                                webix.message(json.error, "error");
                            }
                            table.enable();
                            table.hideProgress();
                        },
                    });
            });
        },
    };
});

define('views/forms/68_danhsachgiamtru',["app", "locale", "models/user"], function (app, _, user) {
    var editmode = 0;

    var date = new Date();
    var _month = date.getMonth() + 1;
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    var startYear = 2010;
    var endYear = date.getFullYear();
    var years = [];
    for (var year = startYear; year <= endYear; year++) {
        years.push(year.toString());
    }

    function subviewT() {
        $$("cbQuy").define("label", "Tháng");
        $$("cbQuy").refresh();
        $$("cbQuy").define("options", ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
        //webix.extend(config, $$('cbQuy').config);
        //webix.ui(config, $$('cbThang'));
        //$$('cbThang').destructor();
    }

    function subviewQ() {
        $$("cbQuy").define("label", "Quý");
        $$("cbQuy").refresh();
        $$("cbQuy").define("options", ["1", "2", "3", "4"]);
        // webix.extend($$('cbQuy').config, config, true);
        //webix.ui(config, $$('cbQuy'));
        //$$('cbQuy').destructor();
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Bảng kê bán ra",
            width: 550,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 60 },
                view: "form",
                id: "bangkebr",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "multicombo",
                        label: _("DONVI"),
                        name: "lst_branch_code",
                        labelWidth: 80,
                        required: true,
                        invalidMessage: "Vui lòng chọn đơn vị",
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00198",
                            },
                        },
                    },
                    {
                        cols: [
                            {
                                view: "radio",
                                id: "head_extension",
                                name: "head_extension",
                                value: 1,
                                options: [
                                    { id: 1, value: "Tháng" }, // the initially selected item
                                    { id: 2, value: "Quý" },
                                ],
                                on: {
                                    onChange: function (newv, oldv) {
                                        var d = new Date();
                                        var quarter = Math.floor(d.getMonth() / 3);
                                        var quarter1 = quarter + 1;
                                        if (newv == 2) {
                                            subviewQ();
                                            $$("cbQuy").setValue(quarter1);
                                        }
                                        if (newv == 1) {
                                            subviewT();
                                            $$("cbQuy").setValue(d.getMonth() + 1);
                                        }
                                    },
                                },
                            },
                            {
                                id: "cbQuy",
                                name: "quy",
                                view: "combo",
                                label: "Tháng",
                                value: _month,
                                options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
                                on: {
                                    onChange: function () {
                                        var d = new Date();
                                        var quarter = Math.floor(d.getMonth() / 3);
                                        var quarter1 = quarter + 1;

                                        var option = $$("head_extension").getValue();
                                        if (option == 2) {
                                            var nam = $$("cbNam").getValue();
                                            var thang;
                                            var quy = $$("cbQuy").getValue();
                                            if (quy == 1) {
                                                thang = 0;
                                            }
                                            if (quy == 2) {
                                                thang = 3;
                                            }
                                            if (quy == 3) {
                                                thang = 6;
                                            }
                                            if (quy == 4) {
                                                thang = 9;
                                            }
                                            firstDay = new Date(nam, thang, 1);
                                            lastDay = new Date(nam, thang + 3, 0);

                                            $$("tu_ngay").setValue(firstDay);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDay);
                                            $$("den_ngay").refresh();
                                        }
                                        if (option == 1) {
                                            var year = d.getFullYear();
                                            var month = $$("cbQuy").getValue();
                                            var date1 = month + "/01" + "/" + year;

                                            var date = new Date(date1);
                                            firstDay = new Date($$("cbNam").getValue(), date.getMonth(), 1);

                                            lastDay = new Date($$("cbNam").getValue(), date.getMonth() + 1, 0);
                                            $$("tu_ngay").setValue(firstDay);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDay);
                                            $$("den_ngay").refresh();
                                        }
                                    },
                                },
                            },
                            {
                                id: "cbNam",
                                name: "nam",
                                view: "combo",
                                label: "Năm",
                                value: new Date().getFullYear(),
                                options: years,
                                on: {
                                    onChange: function (newYear) {
                                        // Get the current date from the datetext controls
                                        var currentFromDate = $$("tu_ngay").getValue();
                                        var currentToDate = $$("den_ngay").getValue();

                                        firstDay = new Date(currentFromDate);
                                        firstDay.setFullYear(newYear);
                                        // Set the updated Date object back to tu_ngay
                                        $$("tu_ngay").setValue(firstDay);

                                        lastDay = new Date(currentToDate);
                                        lastDay.setFullYear(newYear);
                                        // Set the updated Date object back to tu_ngay
                                        $$("den_ngay").setValue(lastDay);
                                    }
                                },
                            },
                        ],
                    },
                    {
                        view: "datepicker",
                        label: _("TU_NGAY"),
                        name: "tu_ngay",
                        id: "tu_ngay",
                        value: firstDay,
                        labelWidth: 80,
                        invalidMessage: "Vui lòng chọn từ ngày",
                        validate: webix.rules.isNotEmpty,
                        required: true,
                    },
                    {
                        view: "datepicker",
                        label: _("DEN_NGAY"),
                        name: "den_ngay",
                        id: "den_ngay",
                        value: lastDay,
                        labelWidth: 80,
                        invalidMessage: "Vui lòng chọn đến ngày",
                        validate: webix.rules.isNotEmpty,
                        required: true,
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Nhận (F10)",
                                width: 100,
                                type: "form",
                                align: "center",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var tableHoadon = $$("bangkebr");
                                            if (tableHoadon.validate()) {
                                                var tungay = $$("tu_ngay").getValue();
                                                var denngay = $$("den_ngay").getValue();

                                                if (tungay > denngay) {
                                                    webix.message("Ngày bắt đầu phải nhỏ hơn ngày kết thúc !", "error");
                                                    $$("tu_ngay").focus();
                                                    return;
                                                }

                                                var form = self.getParentView().getParentView();
                                                var win = self.getTopParentView();
                                                var item = form.getValues();
                                                if(firstDay != $$("tu_ngay").getValue() || lastDay != $$("den_ngay").getValue() ){
                                                    item.isquy = 0;
                                                }else {
                                                    item.isquy = 1;
                                                }
                                                var load_event = "dataChangebangkehanghoagiamtruthue";

                                                app.callEvent(load_event, [item]);

                                                win.close();
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 100,
                                align: "center",
                                type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },

        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            form.setValues(item);
        },
    };
});

define('views/68_bangkehanghoagiamtruthue',["app", "locale", "models/user", "views/forms/68_danhsachgiamtru", "views/forms/68_hoadon_history"], function (app, _, user, danhsachgiamtru, hoadonHistory) {
    

    webix.$$("title").parse({
        title: "Tờ khai chứng từ hàng hóa giảm trừ thuế",
        details: "Tờ khai chứng từ hàng hóa giảm trừ thuế",
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(danhsachgiamtru.$ui);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fas fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "In PDF" + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangkehanghoagiamtruthue");

                    var rpParameter = table.config.rpParameter;

                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }

                    var datafrmAll = table.serialize();

                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để in !", "error");
                        return;
                    }

                    rpParameter.type = "PDF";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(
                                app.config.host + "/Invoice68/PrintPDFBangKeHangHoaGiamTruThue",
                                rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/pdf" });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.open(fileURL, "_blank");
                                    },
                                }
                            );
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-file fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("EXPORT_EXCEL") + "</span>",
            id: "btnExportExcel",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangkehanghoagiamtruthue");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";

                    var datafrmAll = table.serialize();

                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để xuất !", "error");
                        return;
                    }

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(app.config.host + "/Invoice68/PrintPDFbangkehanghoagiamtruthue", rpParameter, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                    //var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    //window.location.href = fileURL;
                                    webix.html.download(file, "bangkehanghoagiamtruthue.xlsx");
                                },
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                container: "testA",
                view: "treetable",
                id: "bangkehanghoagiamtruthue",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                fixedRowHeight: false,
                rowLineHeight: 25,
                rowHeight: 25,
                columns: [
                    {
                        id: "stt",
                        header: "<center>STT</center>",
                        sort: "int",
                        width: 40,
                    },
                    { id: "ten", header: "<center>Tên hàng hóa</center>", width: 300 },
                    {
                        id: "tien_tt0",
                        header: "<center>Doanh thu chưa có thuế GTGT</center>",
                        width: 200,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    { id: "tsuat", header: "<center>Tỷ lệ thuế </center>", width: 300 },
                    { id: "giam", header: "<center>Tỷ lệ thuế sau giảm</center>", width: 300 },
                    {
                        id: "thuegiam",
                        header: "<center>Tiền thuế được giảm</center>",
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    }
                ],
                pager: "pagerA",
                scheme: {
                    //$group: {
                        //by: "nhom",
                        //,css:{ "text-align": "right" }
                        // map:{
                        // 	nguoi_lien_he:["nguoi_lien_he", "count"]
                        // }
                    //},
                    //$sort: { by: "stt", dir: "asc" }
                },
                ready: function () {
                    //this.open(this.getFirstId());
                    //this.sort({ by: "stt", dir: "asc" });
                    this.openAll();
                    this.refresh();
                },
                //url: app.config.host + "/System/ExecuteQuery?sql=" + sql
                //autoheight: true,
                //autowidth:true,
                //data: big_film_set
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChangebangkehanghoagiamtruthue", function (item) {
                var table = $$("bangkehanghoagiamtruthue");
                // webix.extend(table, webix.OverlayBox);
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();

                table.config.rpParameter = item;

                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .post(app.config.host + "/Invoice68/GetDSHoaDonBangKeHangHoaGiamTruThue", item, {
                        error: function (text, data, XmlHttpRequest) {
                            table.enable();
                            table.hideProgress();
                            alert(text);
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var json = JSON.parse(text);
                            if (!json.hasOwnProperty("error")) {
                                //console.log(json);
                                $$("bangkehanghoagiamtruthue").clearAll();
                                $$("bangkehanghoagiamtruthue").parse(json);
                                $$("bangkehanghoagiamtruthue").refresh();
                            } else {
                                webix.message(json.error, "error");
                            }
                            table.enable();
                            table.hideProgress();
                        },
                    });
            });
        },
    };
});

define('views/forms/68_bangdanhsachhoadon',["app", "models/user", "views/forms/68_bangtonghopform"], function (app, user, bangtonghopform) {
    var editmode = 0;
    var loaihanghoa = "2";
    var params;
    var checkBTHChitiet;
    var checkghichu;

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var table = webix.$$("danhsach_hoadonFrm");
                    webix.extend(table, webix.ProgressBar);

                    var ui = webix.$$("danhsachhoadon-win");
                    ui.disable();
                    table.showProgress();
                    var data = table.serialize();
                    var lstTemp = [];
                    var putData = "";
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        if (item.chon != undefined) {
                            if (item.chon == "C") {
                                //item.mstnmua = item["mst"];
                                lstTemp.push(item);
                                putData += "'" + item.hdon_id + "',";
                            }
                        }
                    }

                    putData = putData.substring(0, putData.length - 1);

                    if (lstTemp.length == 0) {
                        ui.enable();
                        table.enable();
                        table.hideProgress();
                        webix.message({ type: "error", text: "Bạn chưa chọn hóa đơn" });

                        return;
                    }

                    var params = {};
                    params["data"] = putData;
                    var lhhoa = $$("bangtonghop-form").getValues().lhhoa;

                    if (lhhoa === "1") {
                        webix
                            .ajax()
                            .headers({ "Content-type": "application/json" })
                            .post(app.config.host + "/Invoice68/GetDetailHoaDonXangDauChoXuLy", params, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message(text + XmlHttpRequest, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var json = JSON.parse(text);

                                    if (!json.hasOwnProperty("error")) {
                                        if (json[0].shdon != null) {
                                            var errorMessenger = "";
                                            for (var index = 0; index < json.length; index++) {
                                                if (index == json.length - 1) {
                                                    errorMessenger += json[index].shdon;
                                                } else {
                                                    errorMessenger += json[index].shdon + ", ";
                                                }
                                            }
                                            webix.message("Các số hoá đơn sau chưa nhập đơn vị tính của hàng hoá: " + errorMessenger, "error");
                                            return;
                                        }
                                        var frm = webix.$$("danhsach_hoadon");
                                        frm.clearAll();
                                        frm.parse(json);

                                        var tien_tt = 0;
                                        var tien_thue = 0;
                                        var tong_tien = 0;

                                        for (var i = 0; i < json.length; i++) {
                                            var item = json[i];
                                            tien_tt += item["ttcthue"] == null ? 0 : item["ttcthue"];
                                            tien_thue += item["tgtthue"] == null ? 0 : item["tgtthue"];
                                            tong_tien += item["tgtttoan"] == null ? 0 : item["tgtttoan"];
                                        }

                                        $$("tgtcthue").setValue(fm(tien_tt));
                                        $$("tgtthue").setValue(fm(tien_thue));
                                        $$("tgtttoan").setValue(fm(tong_tien));

                                        $$("danhsachhoadon-win").close();
                                    } else {
                                        webix.message(json.error, "error");
                                    }
                                },
                            });
                    } else {
                        debugger
                        if (checkBTHChitiet === 1) {
                            var pathApi = "GetDetailHoadonChoXuLyChitiet";
                            if(checkghichu === 1){
                                pathApi = "GetDetailHoadonChoXuLyChitiet_NotGhiChu"
                            }
                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .post(app.config.host + "/Invoice68/" + pathApi, params, {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(text + XmlHttpRequest, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text);

                                        if (!json.hasOwnProperty("error")) {
                                            var frm = webix.$$("danhsach_hoadon");
                                            frm.clearAll();
                                            frm.parse(json);

                                            var tien_tt = 0;
                                            var tien_thue = 0;
                                            var tong_tien = 0;
                                            var tong_gt = 0;
                                            var tong_phi = 0;
                                            var hoaDonLoi = [];
                                            for (var i = 0; i < json.length; i++) {
                                                var item = json[i];
                                                if ((item["tgtkhac"] || 0) > 0 || (item["tgtphi"] || 0) > 0 || (item["tgtkcthue"] || 0) > 0) {
                                                    var hd = item["khieu"] + "-" + item["shdon"];
                                                    if (hoaDonLoi.indexOf(hd) === -1) {
                                                        hoaDonLoi.push(hd);
                                                    }
                                                }
                                                tien_tt += item["ttcthue"] == null ? 0 : item["ttcthue"];
                                                tien_thue += item["tgtthue"] == null ? 0 : item["tgtthue"];
                                                tong_tien += item["tgtttoan"] == null ? 0 : item["tgtttoan"];
                                                tong_gt += item["tgtkhac"] == null ? 0 : item["tgtkhac"];
                                                tong_phi += item["tgtphi"] == null ? 0 : item["tgtphi"];
                                            }
                                            if (hoaDonLoi.length > 0) {
                                                frm.clearAll();
                                                $$("danhsachhoadon-win").close();
                                                webix.message("Hóa đơn " + hoaDonLoi.join(", ") +
                                                    " có trường giảm trừ khác hoặc giảm trừ không chịu thuế, không thể tổng hợp chi tiết hóa đơn", "error");
                                                return;
                                            }
                                            $$("tgtcthue").setValue(fm(tien_tt));
                                            $$("tgtthue").setValue(fm(tien_thue));
                                            $$("tgtttoan").setValue(fm(tong_tien));

                                            $$("tgtkhac").setValue(fm(tong_gt));
                                            $$("tgtphi").setValue(fm(tong_phi));

                                            $$("danhsachhoadon-win").close();
                                            frm.refresh();
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    },
                                });
                        }
                        else {
                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .post(app.config.host + "/Invoice68/GetDetailHoadonChoXuLy", params, {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(text + XmlHttpRequest, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text);

                                        if (!json.hasOwnProperty("error")) {
                                            var frm = webix.$$("danhsach_hoadon");
                                            frm.clearAll();
                                            frm.parse(json);

                                            var tien_tt = 0;
                                            var tien_thue = 0;
                                            var tong_tien = 0;
                                            var tong_gt = 0;
                                            var tong_phi = 0;

                                            for (var i = 0; i < json.length; i++) {
                                                var item = json[i];
                                                tien_tt += item["ttcthue"] == null ? 0 : item["ttcthue"];
                                                tien_thue += item["tgtthue"] == null ? 0 : item["tgtthue"];
                                                tong_tien += item["tgtttoan"] == null ? 0 : item["tgtttoan"];
                                                tong_gt += item["tgtkhac"] == null ? 0 : item["tgtkhac"];
                                                tong_phi += item["tgtphi"] == null ? 0 : item["tgtphi"];
                                            }

                                            $$("tgtcthue").setValue(fm(tien_tt));
                                            $$("tgtthue").setValue(fm(tien_thue));
                                            $$("tgtttoan").setValue(fm(tong_tien));

                                            $$("tgtkhac").setValue(fm(tong_gt));
                                            $$("tgtphi").setValue(fm(tong_phi));

                                            $$("danhsachhoadon-win").close();
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    },
                                });
                        }

                    }

                    // var frm = webix.$$("danhsach_hoadon");
                    // frm.clearAll();
                    // frm.parse(lstTemp);
                    // $$("tgtcthue").setValue(fm(tien_tt));
                    // $$("tgtthue").setValue(fm(tien_thue));
                    // $$("tgtttoan").setValue(fm(tong_tien));
                    // $$("danhsachhoadon-win").close();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("danhsachhoadon-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "danhsachhoadon-win",
        position: "center",
        head: "Chọn hóa đơn vào bảng tổng hợp dữ liệu điện tử",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            minWidth: 900,
            id: "danhsachhoadon-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    view: "datatable",
                    id: "danhsach_hoadonFrm",
                    name: "danhsach_hoadonFrm",
                    select: true,
                    resizeColumn: true,
                    footer: false,
                    editable: false,
                    tooltip: true,
                    minHeight: 400,
                    scheme: {
                        $init: function (obj) { },
                    },
                    on: {},
                    columns: [
                        {
                            id: "chon",
                            header: [{ text: "", content: "masterCheckbox" }],
                            width: 55,
                            checkValue: "C",
                            uncheckValue: "K",
                            template: "{common.checkbox()}",
                        },
                        {
                            id: "nky",
                            name: "nky",
                            header: ["Ngày giờ ký", { content: "datepickerFilter" }],
                            width: 120,
                            format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            },
                        },
                        {
                            id: "khieu",
                            name: "khieu",
                            header: [
                                "Ký hiệu",
                                {
                                    content: "textFilter",
                                },
                            ],
                            width: 120,
                        },
                        {
                            id: "shdon",
                            name: "shdon",
                            header: ["Số hóa đơn", { content: "textFilter" }],
                            width: 120,
                        },
                        {
                            id: "mst",
                            name: "mst",
                            header: ["Mã số thuế", { content: "textFilter" }],
                            width: 150,
                        },
                        {
                            id: "ten",
                            name: "ten",
                            header: [
                                "Tên đơn vị/Tên người mua",
                                {
                                    content: "textFilter",
                                },
                            ],
                            width: 350,
                        },

                        {
                            id: "tgtttbso",
                            name: "tgtttbso",
                            header: ["Thành tiền sau thuế", { content: "textFilter" }],
                            width: 150,
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0,
                            }),
                            css: {
                                "text-align": "right",
                            },
                        },
                        {
                            id: "tdlap",
                            name: "tdlap",
                            header: ["Thời điểm lập", { content: "datepickerFilter" }],
                            width: 120,
                            format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            },
                        },
                        {
                            id: "nglap",
                            name: "nglap",
                            header: "Người lập",
                            header: ["Người lập", { content: "textFilter" }],
                            width: 150,
                        },
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setParams: function (value) {
            params = value;
            checkBTHChitiet = value.bthchitiet
            checkghichu = value.bthghichu
            var table = $$("danhsach_hoadonFrm");
            webix.extend(table, webix.ProgressBar);
            table.disable();
            table.showProgress();
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .post(app.config.host + "/Invoice68/GetHoadonChoXuLy", params, {
                    error: function (text, data, XmlHttpRequest) {
                        table.enable();
                        table.hideProgress();
                        webix.message(text, "error");
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var json = JSON.parse(text);
                        if (!json.hasOwnProperty("error")) {
                            //console.log(json);
                            $$("danhsach_hoadonFrm").clearAll();
                            $$("danhsach_hoadonFrm").parse(json);

                            if (json["data"].length > 0) {
                                $$("tgtcthue").setValue(fm(json["data"][0]["tong_dt"]));
                                $$("tgtthue").setValue(fm(json["data"][0]["tong_tienthue"]));
                            }

                            $$("danhsach_hoadonFrm").refresh();
                        } else {
                            webix.message(json.error, "error");
                        }
                        table.enable();
                        table.hideProgress();
                    },
                });
        },
        setValues: function (item) { },
    };
});

define('views/forms/68_bangtonghopform',["app", "models/user", "views/forms/68_bangdanhsachhoadon"], function (app, user, bangdanhsachhoadon) {
    var editmode = 0;

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var getNgay = function () {
        var option = $$("lkdlieu").getValue();
        if (option == "Q") {
            var nam = $$("nam").getValue();
            var thang;
            var quy = $$("thang").getValue();
            if (quy == "1") {
                thang = 0;
            } else if (quy == "2") {
                thang = 3;
            } else if (quy == "3") {
                thang = 6;
            } else if (quy == "4") {
                thang = 9;
            }
            var firstDate = new Date(nam, thang, 1);
            var lastDate = new Date(nam, thang + 3, 0);

            $$("tu_ngay").setValue(firstDate);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(lastDate);
            $$("den_ngay").refresh();
        } else if (option == "T") {
            var year = $$("nam").getValue();
            var month = $$("thang").getValue();
            var date1 = month + "/01" + "/" + year;

            var date = new Date(date1);
            var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

            var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            $$("tu_ngay").setValue(firstDay1);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(lastDay1);
            $$("den_ngay").refresh();
        } else if (option == "N") {
            var year = $$("nam").getValue();
            var month = $$("thang").getValue();
            var day = $$("ngay").getValue();
            var date1 = month + "/" + day + "/" + year;

            var date = new Date(date1);

            $$("tu_ngay").setValue(date);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(date);
            $$("den_ngay").refresh();
        }

        var tableDetail = webix.$$("danhsach_hoadon");
        tableDetail.clearAll();
    };

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Lưu tạm (F10)",
            id: "btnBTHSave",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var tableHoadon = $$("bangtonghop-form");
                    if (tableHoadon.validate()) {
                        var ds_hdon = $$("danhsach_hoadon").serialize();
                        if (ds_hdon.length == 0) {
                            webix.message("Bạn chưa nhập chi tiết hóa đơn", "error");
                            return;
                        } else {
                            webix.extend(tableHoadon, webix.ProgressBar);
                            tableHoadon.disable();
                            tableHoadon.showProgress();
                            var params = $$("bangtonghop-form").getValues();
                            if (params.bthchitiet !== 1) {
                                // console.log(data_post);
                                var limit = 1000;
                                var m = parseInt(ds_hdon.length / limit);
                                if (ds_hdon.length > m * limit) m = m + 1;
                                var apiIndex = 0;
                                var item = $$("bangtonghop-form").getValues();
                                for (var k = 0; k < m; k++) {
                                    if (k < m - 1) {
                                        item["details"] = ds_hdon.slice(k * limit, (k + 1) * limit);
                                    } else {
                                        item["details"] = ds_hdon.slice(k * limit, ds_hdon.length);
                                    }
                                    var tgtcthue = 0;
                                    var tgtthue = 0;
                                    var tgtttoan = 0;
                                    var tgtkhac = 0;
                                    var tgtphi = 0;
                                    item["details"].forEach(function (it) {
                                        tgtcthue += it["ttcthue"];
                                        tgtthue += it["tgtthue"];
                                        tgtttoan += it["tgtttoan"];
                                        tgtkhac += it["tgtkhac"];
                                        tgtphi += it["tgtphi"];
                                    });
                                    item["tgtcthue"] = tgtcthue;
                                    item["tgtthue"] = tgtthue;
                                    item["tgtttoan"] = tgtttoan;
                                    item["tgtkhac"] = tgtkhac;
                                    item["tgtphi"] = tgtphi;
                                    var item1 = [];
                                    item1.push(item);
                                    var data_post = { editmode: editmode, data: item1 };
                                    if (item.lhhoa === "1") {
                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/Invoice68/SaveBangTHDLXangDau", data_post, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    apiIndex++;
                                                    if (apiIndex == m) {
                                                        tableHoadon.enable();
                                                        tableHoadon.hideProgress();
                                                        // var json = JSON.parse(text);
                                                        // webix.message(json.ExceptionMessage, "error");
                                                    }
                                                    webix.message(text + XmlHttpRequest, "error");
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    apiIndex++;
                                                    if (apiIndex == m) {
                                                        var json = JSON.parse(text);
                                                        tableHoadon.enable();
                                                        tableHoadon.hideProgress();
                                                        if (!json.hasOwnProperty("error")) {
                                                            webix.$$("bangtonghop-win").close();
                                                            app.callEvent("dataChangeBangtonghop", [1, null]);
                                                        } else {
                                                            webix.message(json.error, "error");
                                                        }
                                                    }
                                                },
                                            });
                                    } else {
                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/Invoice68/SaveBangTHDL", data_post, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    apiIndex++;
                                                    if (apiIndex == m) {
                                                        tableHoadon.enable();
                                                        tableHoadon.hideProgress();
                                                        // var json = JSON.parse(text);
                                                        // webix.message(json.ExceptionMessage, "error");
                                                    }
                                                    webix.message(text + XmlHttpRequest, "error");
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    apiIndex++;
                                                    if (apiIndex == m) {
                                                        var json = JSON.parse(text);
                                                        tableHoadon.enable();
                                                        tableHoadon.hideProgress();
                                                        if (!json.hasOwnProperty("error")) {
                                                            webix.$$("bangtonghop-win").close();
                                                            app.callEvent("dataChangeBangtonghop", [1, null]);
                                                        } else {
                                                            webix.message(json.error, "error");
                                                        }
                                                    }
                                                },
                                            });
                                    }
                                }
                            }
                            else {
                                var limit = 1000;
                                var apiIndex = 0;
                                var item = $$("bangtonghop-form").getValues();

                                var batches = [];
                                var currentBatch = [];
                                var currentCount = 0;

                                // Giả sử mỗi phần tử ds_hdon có field invoice_id
                                var grouped = {};
                                ds_hdon.forEach(function (item) {
                                    if (!grouped[item.hdon_id]) grouped[item.hdon_id] = [];
                                    grouped[item.hdon_id].push(item);
                                });

                                // Lấy danh sách hóa đơn theo thứ tự ban đầu
                                var invoiceIds = Object.keys(grouped);

                                invoiceIds.forEach(function (id) {
                                    var invoiceDetails = grouped[id];
                                    var detailsCount = invoiceDetails.length;

                                    if (currentCount + detailsCount > limit && currentCount > 0) {
                                        // Lưu lô hiện tại và bắt đầu lô mới
                                        batches.push(currentBatch);
                                        currentBatch = [];
                                        currentCount = 0;
                                    }

                                    currentBatch = currentBatch.concat(invoiceDetails);
                                    currentCount += detailsCount;
                                });

                                // Lưu lô cuối nếu có
                                if (currentBatch.length > 0) {
                                    batches.push(currentBatch);
                                }

                                for (var k = 0; k < batches.length; k++) {
                                    item["details"] = batches[k];
                                    var tgtcthue = 0;
                                    var tgtthue = 0;
                                    var tgtttoan = 0;
                                    var tgtkhac = 0;
                                    var tgtphi = 0;
                                    item["details"].forEach(function (it) {
                                        tgtcthue += it["ttcthue"];
                                        tgtthue += it["tgtthue"];
                                        tgtttoan += it["tgtttoan"];
                                        tgtkhac += it["tgtkhac"];
                                        tgtphi += it["tgtphi"];
                                    });
                                    item["tgtcthue"] = tgtcthue;
                                    item["tgtthue"] = tgtthue;
                                    item["tgtttoan"] = tgtttoan;
                                    item["tgtkhac"] = tgtkhac;
                                    item["tgtphi"] = tgtphi;
                                    var item1 = [];
                                    item1.push(item);
                                    var data_post = { editmode: editmode, data: item1 };
                                    if (item.lhhoa === "1") {
                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/Invoice68/SaveBangTHDLXangDau", data_post, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    apiIndex++;
                                                    if (apiIndex == batches.length) {
                                                        tableHoadon.enable();
                                                        tableHoadon.hideProgress();
                                                        // var json = JSON.parse(text);
                                                        // webix.message(json.ExceptionMessage, "error");
                                                    }
                                                    webix.message(text + XmlHttpRequest, "error");
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    apiIndex++;
                                                    if (apiIndex == batches.length) {
                                                        var json = JSON.parse(text);
                                                        tableHoadon.enable();
                                                        tableHoadon.hideProgress();
                                                        if (!json.hasOwnProperty("error")) {
                                                            webix.$$("bangtonghop-win").close();
                                                            app.callEvent("dataChangeBangtonghop", [1, null]);
                                                        } else {
                                                            webix.message(json.error, "error");
                                                        }
                                                    }
                                                },
                                            });
                                    } else {
                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/Invoice68/SaveBangTHDL", data_post, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    apiIndex++;
                                                    if (apiIndex == batches.length) {
                                                        tableHoadon.enable();
                                                        tableHoadon.hideProgress();
                                                        // var json = JSON.parse(text);
                                                        // webix.message(json.ExceptionMessage, "error");
                                                    }
                                                    webix.message(text + XmlHttpRequest, "error");
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    apiIndex++;
                                                    debugger
                                                    if (apiIndex == batches.length) {
                                                        var json = JSON.parse(text);
                                                        tableHoadon.enable();
                                                        tableHoadon.hideProgress();
                                                        if (!json.hasOwnProperty("error")) {
                                                            webix.$$("bangtonghop-win").close();
                                                            app.callEvent("dataChangeBangtonghop", [1, null]);
                                                        } else {
                                                            webix.message(json.error, "error");
                                                        }
                                                    }
                                                },
                                            });
                                    }
                                }
                            }
                        }
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     shortcut: "F11",
        //     view: "button",
        //     label: "Xuất tờ khai XML (F11)",
        //     type: "form",
        //     align: "center",
        //     width: 180,
        //     on: {
        //         onClick: function () {
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        // {
        //     shortcut: "F12",
        //     id: "btnBTHSend",
        //     view: "button",
        //     label: "Ký và gửi CQT (F12)",
        //     type: "form",
        //     align: "center",
        //     width: 150,
        //     on: {
        //         onClick: function () {
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            view: "button",
            hotkey: "esc",
            label: "Quay lại (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("bangtonghop-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        fullscreen: true,
        id: "bangtonghop-win",
        position: "center",
        head: "BẢNG TỔNG HỢP DỮ LIỆU HÓA ĐƠN ĐIỆN TỬ",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 1500,
            id: "bangtonghop-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    rows: [
                        {
                            cols: [
                                {},
                                {
                                    view: "label",
                                    label: "[01] Kỳ dữ liệu",
                                    width: 170,
                                },
                                {
                                    id: "lkdlieu",
                                    name: "lkdlieu",
                                    view: "combo",
                                    width: 120,
                                    value: "T",
                                    options: [
                                        { id: "T", value: "Tháng" },
                                        { id: "Q", value: "Quý" },
                                        { id: "N", value: "Ngày" },
                                    ],
                                    on: {
                                        onChange: function (newv, oldv) {
                                            if (newv == "N") {
                                                var k = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 60);
                                                $$("thang").refresh();
                                                $$("ngay").show();
                                                $$("ngay").refresh();
                                            }
                                            if (newv == "T") {
                                                var k = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 120);
                                                $$("thang").refresh();
                                                $$("ngay").hide();
                                                $$("ngay").refresh();
                                            }
                                            if (newv == "Q") {
                                                var k = ["1", "2", "3", "4"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 120);
                                                $$("thang").setValue("1");
                                                $$("thang").refresh();
                                                $$("ngay").hide();
                                                $$("ngay").refresh();
                                            }

                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "ngay",
                                    name: "ngay",
                                    view: "combo",
                                    width: 60,
                                    value: "1",
                                    hidden: true,
                                    options: [
                                        "1",
                                        "2",
                                        "3",
                                        "4",
                                        "5",
                                        "6",
                                        "7",
                                        "8",
                                        "9",
                                        "10",
                                        "11",
                                        "12",
                                        "13",
                                        "14",
                                        "15",
                                        "16",
                                        "17",
                                        "18",
                                        "19",
                                        "20",
                                        "21",
                                        "22",
                                        "23",
                                        "24",
                                        "25",
                                        "26",
                                        "27",
                                        "28",
                                        "29",
                                        "30",
                                        "31",
                                    ],
                                    required: true,
                                    invalidMessage: "Tháng/Quý không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "thang",
                                    name: "thang",
                                    view: "combo",
                                    width: 120,
                                    value: "1",
                                    options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
                                    required: true,
                                    invalidMessage: "Tháng/Quý không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "nam",
                                    name: "nam",
                                    view: "text",
                                    label: "Năm",
                                    labelWidth: 50,
                                    width: 120,
                                    required: true,
                                    invalidMessage: "Năm không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                { id: "tu_ngay", name: "tu_ngay", view: "datepicker", label: "Từ ngày", hidden: true, width: 200, labelWidth: 100 },
                                { id: "den_ngay", name: "den_ngay", view: "datepicker", label: "Đến ngày:", hidden: true, labelWidth: 100, width: 260 },
                                {
                                    id: "ldau",
                                    name: "ldau",
                                    view: "checkbox",
                                    label: "[02] Lần đầu",
                                    value: 1,
                                    width: 150,
                                    on: {
                                        onChange: function () {
                                            var lanDau = $$("ldau").getValue();
                                            if (lanDau == 0) {
                                                $$("bslthu").define("required", true);
                                                $$("bslthu").define("invalidMessage", "Không được để trống trường này!");
                                                $$("bslthu").enable();
                                                $$("bslthu").refresh();
                                            } else {
                                                $$("bslthu").define("required", false);
                                                $$("bslthu").define("invalidMessage", "");
                                                $$("bslthu").setValue("");
                                                $$("bslthu").disable();
                                                $$("bslthu").refresh();
                                            }
                                        },
                                    },
                                },
                                { id: "bslthu", name: "bslthu", view: "text", label: "[03] Bổ sung lần thứ: ", labelWidth: 140, width: 250, disabled: true },
                                { id: "sdlthu", name: "sdlthu", view: "text", label: "[04] Sửa đổi lần thứ: ", labelWidth: 130, width: 250 },
                                {},
                            ],
                        },
                        {
                            cols: [
                                {},
                                {
                                    id: "tnnt",
                                    name: "tnnt",
                                    view: "text",
                                    label: "[05] Tên người nộp thuế:",
                                    labelWidth: 170,
                                    width: 410,
                                    required: true,
                                    invalidMessage: "Tên người nộp thuế không được để trống !",
                                    readonly: true,
                                },
                                {
                                    id: "mst",
                                    name: "mst",
                                    view: "text",
                                    label: "[06] Mã số thuế:",
                                    labelWidth: 130,
                                    width: 380,
                                    readonly: true,
                                    required: true,
                                    invalidMessage: "Mã số thuế không được để trống !",
                                },
                                { id: "nlap", name: "nlap", view: "datepicker", label: "Ngày lập", width: 190, labelWidth: 70, value: new Date() },
                                { id: "sbthdlieu", name: "sbthdlieu", view: "text", label: "Số:", labelWidth: 50, width: 200, readonly: true },
                                {},
                            ],
                        },
                        {
                            cols: [
                                {},
                                {
                                    id: "hddin",
                                    name: "hddin",
                                    label: "Hóa đơn đặt in:",
                                    labelWidth: 170,
                                    width: 410,
                                    view: "combo",
                                    value: "0",
                                    options: [
                                        { id: "0", value: "Hóa đơn điện tử" },
                                        { id: "1", value: "Hóa đơn đặt in" },
                                    ],
                                },
                                {
                                    id: "lhhoa",
                                    name: "lhhoa",
                                    view: "text",
                                    label: "Loại hàng hóa:",
                                    labelWidth: 130,
                                    width: 380,
                                    view: "combo",
                                    value: "9",
                                    options: [
                                        { id: "2", value: "Vận tải hàng không" },
                                        { id: "9", value: "Khác" },
                                    ],
                                    on: {
                                        onChange: function () {
                                            var loaiHangHoa = $$("lhhoa").getValue();
                                            if (loaiHangHoa === "1") {
                                                $$("lkdlieu").setValue("N");
                                                $$("lkdlieu").disable();
                                                $$("danhsach_hoadon").clearAll();
                                                $$("tgtcthue").setValue("");
                                                $$("tgtthue").setValue("");
                                                $$("tgtttoan").setValue("");
                                            } else {
                                                $$("lkdlieu").setValue("T");
                                                $$("lkdlieu").enable();
                                                $$("danhsach_hoadon").clearAll();
                                                $$("tgtcthue").setValue("");
                                                $$("tgtthue").setValue("");
                                                $$("tgtttoan").setValue("");
                                            }
                                        },
                                    },
                                },
                                {
                                    id: "dvtt",
                                    name: "dvtt",
                                    view: "text",
                                    label: "Đơn vị tiền tệ:",
                                    labelWidth: 130,
                                    width: 380,
                                    view: "combo",
                                    required: true,
                                    invalidMessage: "Đơn vị tiền tệ không được để trống !",
                                    options: app.config.host + "/Invoice68/GetListDVTT",

                                    // attributes: {
                                    //     readonly: editmode == 1 ? false : true
                                    // }
                                },
                                {},
                            ],
                        },
                        {
                            paddingX: -110,
                            cols: [
                                {},
                                {
                                    view: "checkbox",
                                    id: "bthchitiet",
                                    name: "bthchitiet",
                                    label: "Tổng hợp theo chi tiết hóa đơn",
                                    labelWidth: 200,
                                    width: 400,
                                    value: 0,
                                    on: {
                                        onChange: function (newv) {
                                            if (newv == 1) {
                                                $$("bthghichu").getNode().style.visibility = "visible";
                                            } else {
                                                $$("bthghichu").setValue(0);
                                                $$("bthghichu").getNode().style.visibility = "hidden";
                                            }
                                        }
                                    }

                                },
                                {
                                    view: "checkbox",
                                    id: "bthghichu",
                                    name: "bthghichu",
                                    label: "Không tổng hợp dòng Ghi chú",
                                    labelWidth: 200,
                                    width: 300,
                                    css: { "margin-left": "10px !important" },
                                    on: {
                                        onAfterRender: function () {

                                            if (this.getValue() !== 1) {
                                                this.getNode().style.visibility = "hidden";
                                            } else {
                                                this.getNode().style.visibility = "visible";
                                            }
                                        }
                                    }

                                },
                                {},
                                {},
                            ],

                        },
                    ],
                },
                {
                    rows: [
                        {
                            cols: [
                                {
                                    view: "button",
                                    label: "Chọn hóa đơn",
                                    id: "btnTaiHoaDon",
                                    width: 150,
                                    on: {
                                        onItemClick: function (id, e) {
                                            var item = $$("bangtonghop-form").getValues();
                                            var tableHoadon = $$("bangtonghop-form");
                                            if (tableHoadon.validate()) {
                                                var loaiHangHoa = $$("lhhoa").getValue();
                                                if (loaiHangHoa !== "1") {
                                                    var detailForm = this.getTopParentView().$scope.ui(bangdanhsachhoadon.$ui);
                                                    bangdanhsachhoadon.setEditMode(1);
                                                    bangdanhsachhoadon.setParams(item);
                                                    detailForm.show();
                                                } else {
                                                    var detailForm = this.getTopParentView().$scope.ui(bangdanhsachhoadon.$ui);
                                                    bangdanhsachhoadon.setEditMode(1);
                                                    bangdanhsachhoadon.setParams(item);
                                                    detailForm.show();
                                                }
                                            }
                                        },
                                    },
                                },
                                {
                                    view: "button",
                                    label: "Chọn toàn bộ",
                                    id: "btnAllHoaDon",
                                    width: 150,
                                    on: {
                                        onItemClick: function (id, e) {
                                            var tableHoadon = $$("bangtonghop-form");
                                            if (tableHoadon.validate()) {
                                                webix.confirm({
                                                    text: "Tự động chọn tất cả hóa đơn trong kì",
                                                    ok: "Có",
                                                    cancel: "Không",
                                                    callback: function (res) {
                                                        if (res) {
                                                            var params = $$("bangtonghop-form").getValues();
                                                            var tableHoadon = webix.$$("danhsach_hoadon");
                                                            if (tableHoadon.validate()) {
                                                                if (params.bthchitiet === 1) {
                                                                    var pathApi = "GetHoadonChoXuLyallChitiet";
                                                                    if (params.bthghichu === 1) {
                                                                        pathApi = "GetHoadonChoXuLyallChitiet_NotGhiChu"
                                                                    }
                                                                    webix.extend($$("bangtonghop-form"), webix.ProgressBar);
                                                                    $$("bangtonghop-form").disable();
                                                                    $$("bangtonghop-form").showProgress();
                                                                    webix
                                                                        .ajax()
                                                                        .headers({ "Content-type": "application/json" })
                                                                        .post(app.config.host + "/Invoice68/" + pathApi, params, {
                                                                            error: function (text, data, XmlHttpRequest) {
                                                                                $$("bangtonghop-form").enable();
                                                                                $$("bangtonghop-form").hideProgress();
                                                                                webix.message(text, "error");
                                                                            },
                                                                            success: function (text, data, XmlHttpRequest) {
                                                                                var json = JSON.parse(text);
                                                                                if (!json.hasOwnProperty("error")) {
                                                                                    //console.log(json);
                                                                                    tableHoadon.clearAll();
                                                                                    tableHoadon.parse(json);
                                                                                    var tien_tt = 0;
                                                                                    var tien_thue = 0;
                                                                                    var tong_tien = 0;
                                                                                    var tong_gt = 0;
                                                                                    var tong_phi = 0;
                                                                                    var hoaDonLoi = [];
                                                                                    for (var i = 0; i < json.data.length; i++) {
                                                                                        var item = json.data[i];
                                                                                        if ((item["tgtkhac"] || 0) > 0 || (item["tgtphi"] || 0) > 0 || (item["tgtkcthue"] || 0) > 0) {
                                                                                            var hd = item["khieu"] + "-" + item["shdon"];
                                                                                            if (hoaDonLoi.indexOf(hd) === -1) {
                                                                                                hoaDonLoi.push(hd);
                                                                                            }
                                                                                        }
                                                                                        tien_tt += item["ttcthue"] == null ? 0 : item["ttcthue"];
                                                                                        tien_thue += item["tgtthue"] == null ? 0 : item["tgtthue"];
                                                                                        tong_tien += item["tgtttoan"] == null ? 0 : item["tgtttoan"];
                                                                                        tong_gt += item["tgtkhac"] == null ? 0 : item["tgtkhac"];
                                                                                        tong_phi += item["tgtphi"] == null ? 0 : item["tgtphi"];
                                                                                    }
                                                                                    if (hoaDonLoi.length > 0) {
                                                                                        tableHoadon.clearAll();
                                                                                        $$("bangtonghop-form").enable();
                                                                                        $$("bangtonghop-form").hideProgress();
                                                                                        webix.message("Hóa đơn " + hoaDonLoi.join(", ") +
                                                                                            " có trường giảm trừ khác hoặc giảm trừ không chịu thuế, không thể tổng hợp chi tiết hóa đơn", "error");
                                                                                        return;
                                                                                    }
                                                                                    $$("tgtcthue").setValue(fm(tien_tt));
                                                                                    $$("tgtthue").setValue(fm(tien_thue));
                                                                                    $$("tgtttoan").setValue(fm(tong_tien));

                                                                                    $$("tgtkhac").setValue(fm(tong_gt));
                                                                                    $$("tgtphi").setValue(fm(tong_phi));
                                                                                    tableHoadon.refresh();
                                                                                } else {
                                                                                    webix.message(json.error, "error");
                                                                                }
                                                                                $$("bangtonghop-form").enable();
                                                                                $$("bangtonghop-form").hideProgress();
                                                                            },
                                                                        });
                                                                } else {
                                                                    webix.extend($$("bangtonghop-form"), webix.ProgressBar);
                                                                    $$("bangtonghop-form").disable();
                                                                    $$("bangtonghop-form").showProgress();
                                                                    webix
                                                                        .ajax()
                                                                        .headers({ "Content-type": "application/json" })
                                                                        .post(app.config.host + "/Invoice68/GetHoadonChoXuLyall", params, {
                                                                            error: function (text, data, XmlHttpRequest) {
                                                                                $$("bangtonghop-form").enable();
                                                                                $$("bangtonghop-form").hideProgress();
                                                                                webix.message(text, "error");
                                                                            },
                                                                            success: function (text, data, XmlHttpRequest) {
                                                                                var json = JSON.parse(text);
                                                                                if (!json.hasOwnProperty("error")) {
                                                                                    //console.log(json);
                                                                                    tableHoadon.clearAll();
                                                                                    tableHoadon.parse(json);
                                                                                    var tien_tt = 0;
                                                                                    var tien_thue = 0;
                                                                                    var tong_tien = 0;
                                                                                    var tong_gt = 0;
                                                                                    var tong_phi = 0;

                                                                                    for (var i = 0; i < json.data.length; i++) {
                                                                                        var item = json.data[i];
                                                                                        tien_tt += item["ttcthue"] == null ? 0 : item["ttcthue"];
                                                                                        tien_thue += item["tgtthue"] == null ? 0 : item["tgtthue"];
                                                                                        tong_tien += item["tgtttoan"] == null ? 0 : item["tgtttoan"];
                                                                                        tong_gt += item["tgtkhac"] == null ? 0 : item["tgtkhac"];
                                                                                        tong_phi += item["tgtphi"] == null ? 0 : item["tgtphi"];
                                                                                    }

                                                                                    $$("tgtcthue").setValue(fm(tien_tt));
                                                                                    $$("tgtthue").setValue(fm(tien_thue));
                                                                                    $$("tgtttoan").setValue(fm(tong_tien));

                                                                                    $$("tgtkhac").setValue(fm(tong_gt));
                                                                                    $$("tgtphi").setValue(fm(tong_phi));

                                                                                    tableHoadon.refresh();
                                                                                } else {
                                                                                    webix.message(json.error, "error");
                                                                                }
                                                                                $$("bangtonghop-form").enable();
                                                                                $$("bangtonghop-form").hideProgress();
                                                                            },
                                                                        });
                                                                }

                                                            }
                                                        }
                                                    },
                                                });
                                            }
                                        },
                                    },
                                },
                                {
                                    view: "button",
                                    label: "Xóa",
                                    id: "btnXoaHoaDon",
                                    width: 120,
                                    on: {
                                        onItemClick: function (id, e) {
                                            var table = webix.$$("danhsach_hoadon");
                                            table.editStop();
                                            var item = table.getSelectedItem();
                                            if (!webix.isUndefined(item)) {
                                                var rows = table.find(function (obj) {
                                                    return obj.hdon_id === item.hdon_id;
                                                });

                                                rows.forEach(function (row) {
                                                    table.remove(row.id);
                                                });
                                                table.clearSelection();

                                                var table = webix.$$("danhsach_hoadon");
                                                var data = table.serialize();

                                                var tien_tt = 0;
                                                var tien_thue = 0;
                                                var tong_tien = 0;
                                                var tong_gt = 0;
                                                var tong_phi = 0;

                                                for (var i = 0; i < data.length; i++) {
                                                    var item = data[i];
                                                    tien_tt += item["ttcthue"] == null ? 0 : item["ttcthue"];
                                                    tien_thue += item["tgtthue"] == null ? 0 : item["tgtthue"];
                                                    tong_tien += item["tgtttoan"] == null ? 0 : item["tgtttoan"];
                                                    tong_gt += item["tgtkhac"] == null ? 0 : item["tgtkhac"];
                                                    tong_phi += item["tgtphi"] == null ? 0 : item["tgtphi"];
                                                }

                                                $$("tgtcthue").setValue(fm(tien_tt));
                                                $$("tgtthue").setValue(fm(tien_thue));
                                                $$("tgtttoan").setValue(fm(tong_tien));
                                                $$("tgtkhac").setValue(fm(tong_gt));
                                                $$("tgtphi").setValue(fm(tong_phi));

                                                return;
                                            }
                                            var editor = table.getEditState();
                                            if (!webix.isUndefined(editor)) {
                                                var current = table.getItem(editor.row);
                                                var rows = table.find(function (obj) {
                                                    return obj.hdon_id === current.hdon_id;
                                                });
                                                rows.forEach(function (row) {
                                                    table.remove(row.id);
                                                });
                                                table.clearSelection();

                                                var table = webix.$$("danhsach_hoadon");
                                                var data = table.serialize();

                                                var tien_tt = 0;
                                                var tien_thue = 0;
                                                var tong_tien = 0;
                                                var tong_gt = 0;
                                                var tong_phi = 0;

                                                for (var i = 0; i < data.length; i++) {
                                                    var item = data[i];
                                                    tien_tt += item["ttcthue"] == null ? 0 : item["ttcthue"];
                                                    tien_thue += item["tgtthue"] == null ? 0 : item["tgtthue"];
                                                    tong_tien += item["tgtttoan"] == null ? 0 : item["tgtttoan"];
                                                    tong_gt += item["tgtkhac"] == null ? 0 : item["tgtkhac"];
                                                    tong_phi += item["tgtphi"] == null ? 0 : item["tgtphi"];
                                                }

                                                $$("tgtcthue").setValue(fm(tien_tt));
                                                $$("tgtthue").setValue(fm(tien_thue));
                                                $$("tgtttoan").setValue(fm(tong_tien));
                                                $$("tgtkhac").setValue(fm(tong_gt));
                                                $$("tgtphi").setValue(fm(tong_phi));

                                                return;
                                            }
                                        },
                                    },
                                },

                            ],
                        },
                        {
                            view: "datatable",
                            id: "danhsach_hoadon",
                            minHeight: 350,
                            name: "danhsach_hoadon",
                            select: true,
                            scroll: true,
                            resizeColumn: true,
                            // footer: true,
                            editable: false,
                            tooltip: true,
                            scheme: {
                                $init: function (obj) { },
                            },
                            on: {
                                "data->onStoreUpdated": function () {
                                    this.data.each(function (obj, i) {
                                        obj.stt = i + 1;
                                    });
                                },
                            },
                            columns: [
                                {
                                    id: "stt",
                                    name: "stt",
                                    header: "STT",
                                    width: 40,
                                },
                                {
                                    id: "khieu",
                                    name: "khieu",
                                    header: "Ký hiệu",
                                    width: 120,
                                    // footer: "Tổng cộng"
                                },
                                { id: "shdon", name: "shdon", header: "Số hóa đơn", width: 120 },
                                {
                                    id: "nlap",
                                    name: "nlap",
                                    header: "Ngày hóa đơn",
                                    width: 120,
                                    format: function (text) {
                                        var format = webix.Date.dateToStr("%d/%m/%Y");
                                        text = removeTimeZoneT(text);
                                        return format(text);
                                    },
                                },
                                { id: "tnmua", name: "tnmua", header: "Tên người mua", width: 350 },
                                { id: "mstnmua", name: "mstnmua", header: "Mã số thuế người mua/mã khách hàng", width: 150 },
                                { id: "thhdvu", name: "thhdvu", header: "Mặt hàng", width: 150 },
                                {
                                    id: "sluong",
                                    name: "sluong",
                                    header: "Số lượng hàng hóa",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 6,
                                        decimalOptional: true
                                    }),
                                    css: { "text-align": "right" },
                                },
                                {
                                    id: "ttcthue",
                                    name: "ttcthue",
                                    header: "Tiền trước thuế",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 6,
                                        decimalOptional: true
                                    }),
                                    css: { "text-align": "right" },
                                    // footer: {
                                    //     content: "summColumn"
                                    // }
                                },
                                {
                                    id: "tsuat",
                                    name: "tsuat",
                                    header: "Thuế suất",
                                    width: 150,
                                    css: { "text-align": "right" },
                                },
                                {
                                    id: "tgtthue",
                                    name: "tgtthue",
                                    header: "Tiền thuế",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 6,
                                        decimalOptional: true
                                    }),
                                    css: { "text-align": "right" },
                                    // footer: {
                                    //     content: "summColumn"
                                    // }
                                },
                                { id: "tgtkhac", name: "tgtkhac", header: "Giảm trừ khác", width: 150 },
                                { id: "tgia", name: "tgia", header: "Tỷ giá", width: 100 },
                                { id: "tgtphi", name: "tgtphi", header: "Tổng tiền phí", width: 150 },
                                {
                                    id: "tgtttoan",
                                    name: "tgtttoan",
                                    header: "Tiền thanh toán",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 6,
                                        decimalOptional: true
                                    }),
                                    css: { "text-align": "right" },
                                    // footer: {
                                    //     content: "summColumn"
                                    // }
                                },
                                {
                                    id: "tthai",
                                    name: "tthai",
                                    header: "Trạng thái",
                                    width: 150,
                                    format: function (text) {
                                        var result = "";
                                        if (text == 0) {
                                            result = "Mới";
                                        } else if (text == 1) {
                                            result = "Hủy";
                                        } else if (text == 2) {
                                            result = "Điều chỉnh";
                                        } else if (text == 3) {
                                            result = "Thay thế";
                                        } else if (text == 4) {
                                            result = "Giải trình";
                                        } else if (text == 5) {
                                            result = "Sai sót do tổng hợp";
                                        }
                                        return result;
                                    },
                                },
                                { id: "tthdlquan", name: "tthdlquan", header: "Thông tin hóa đơn liên quan", width: 250 },
                                { id: "gchu", name: "gchu", header: "Ghi chú", width: 150 }
                            ],
                        },
                        {
                            cols: [
                                {
                                    id: "tgtcthue",
                                    name: "tgtcthue",
                                    view: "text",
                                    label: "Tiền trước thuế",
                                    readonly: true,
                                    labelWidth: 100,
                                    css: "mcls_readonly_text",
                                    // format: webix.Number.numToStr({
                                    //     groupDelimiter: ",",
                                    //     groupSize: 3,
                                    //     decimalDelimiter: ".",
                                    //     decimalSize: 0,
                                    // })
                                },
                                {
                                    id: "tgtthue",
                                    name: "tgtthue",
                                    view: "text",
                                    label: "Tiền thuế",
                                    readonly: true,
                                    labelWidth: 100,
                                    css: "mcls_readonly_text",
                                    // format: webix.Number.numToStr({
                                    //     groupDelimiter: ",",
                                    //     groupSize: 3,
                                    //     decimalDelimiter: ".",
                                    //     decimalSize: 0,
                                    // })
                                },
                                {
                                    id: "tgtkhac",
                                    name: "tgtkhac",
                                    view: "text",
                                    readonly: true,
                                    labelWidth: 100,
                                    css: "mcls_readonly_text",
                                    label: "Tổng giảm trừ",
                                    // format: webix.Number.numToStr({
                                    //     groupDelimiter: ",",
                                    //     groupSize: 3,
                                    //     decimalDelimiter: ".",
                                    //     decimalSize: 0,
                                    // })
                                },
                                {
                                    id: "tgtphi",
                                    name: "tgtphi",
                                    view: "text",
                                    readonly: true,
                                    labelWidth: 100,
                                    css: "mcls_readonly_text",
                                    label: "Tổng tiền phí",
                                    // format: webix.Number.numToStr({
                                    //     groupDelimiter: ",",
                                    //     groupSize: 3,
                                    //     decimalDelimiter: ".",
                                    //     decimalSize: 0,
                                    // })
                                },
                                {
                                    id: "tgtttoan",
                                    name: "tgtttoan",
                                    view: "text",
                                    readonly: true,
                                    labelWidth: 100,
                                    css: "mcls_readonly_text",
                                    label: "Tiền thanh toán",
                                    // format: webix.Number.numToStr({
                                    //     groupDelimiter: ",",
                                    //     groupSize: 3,
                                    //     decimalDelimiter: ".",
                                    //     decimalSize: 0,
                                    // })
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            item["nlap"] = removeTimeZoneT(item["nlap"]);
            if (editmode == 2)
                $$("dvtt").define("readonly", true);
            form.setValues(item);

            $$("tgtcthue").setValue(fm(item.tgtcthue));
            $$("tgtthue").setValue(fm(item.tgtthue));
            $$("tgtttoan").setValue(fm(item.tgtttoan));
            $$("tgtkhac").setValue(fm(item.tgtkhac));
            $$("tgtphi").setValue(fm(item.tgtphi));
            console.log(editmode);
            getNgay();

            var tableDetail = webix.$$("danhsach_hoadon");
            if (item.lhhoa === 1) {
                var url = app.config.host + "/Invoice68/GetDataBangTHDLXangDauDetail?id=" + item.id;
            } else {
                var url = app.config.host + "/Invoice68/GetDataBangTHDLDetail?id=" + item.id;
            }
            tableDetail.clearAll();
            tableDetail.load(url);
        },
    };
});

define('views/68_bangtonghop',[
    "app", 
    "locale", 
    "models/user", 
    "views/forms/68_bangtonghopform", 
    "views/forms/68_bangdanhsachhoadon", 
    "views/forms/68_hoadon_history",
    "views/modules/download_file_handle"], function (
    app,
    _,
    user,
    bangtonghopform,
    bangdanhsachhoadon,
    hoadonHistory,
    handleFile
) {
    

    webix.$$("title").parse({
        title: "Bảng tổng hợp hóa đơn",
        details: "Bảng tổng hợp hóa đơn",
    });

    var initUI = function () {
        var table = webix.$$("bangtonghop");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetBangTHDL";
                var par = "";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    par = "start=" + params.start;
                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                                filterType: column.header[1].content,
                            };


                            if (item.value != null && item.value != "") {
                                array.push(item);
                            }
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var urlTemp = url;
                if(par) {
                    urlTemp = url.replace("&count=" + view.config.datafetch, "").replace(par, "start=0");
                } else {
                    urlTemp = url.replace("&count=" + view.config.datafetch, "");
                }

                table.define('urlget',urlTemp);
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    function formatDate() {
        var date = new Date();
    
        var dd = String(date.getDate()).padStart(2, '0');
        var MM = String(date.getMonth() + 1).padStart(2, '0'); // Tháng bắt đầu từ 0
        var YYYY = date.getFullYear();
        var hh = String(date.getHours()).padStart(2, '0');
        var mm = String(date.getMinutes()).padStart(2, '0');
        var ss = String(date.getSeconds()).padStart(2, '0');
    
        var formattedDate = dd + "_" + MM + "_" + YYYY + "_" + hh + "_" + mm + "_" + ss;
        return formattedDate;
    }

    function exportExcelMulti(selectedItems) {

        // kiểm tra lại bảng tổng hợp
        var idItems = [];
        var loaiHd = selectedItems[0].lhhoa;
        for(var i = 0; i < selectedItems.length; i++) {
            idItems.push(selectedItems[i].id);
        }

        var fileName = "bthdl_" + formatDate();
        var fileProcessInfor = {
            method: "POST",
            response: "arraybuffer",
            header: { "Content-type": "application/json" },
            url: app.config.host + "/Invoice68/excelBTHDLieuMulti",
            param: JSON.stringify(idItems),
            onError: function (text, data, XmlHttpRequest) {
                webix.message(XmlHttpRequest.statusText, "error");
            },
            onSuccess: null,
            onDownLoad: function (data) {
                var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                webix.html.download(file, fileName + ".xlsx");
            },
            fileName: fileName,
            fileType: 'xlsx',
            headerTitle: "Kết xuất BTHDL"
        };

        handleFile.handleFileDownLoad(fileProcessInfor);
    }

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(bangtonghopform.$ui);
                    bangtonghopform.setEditMode(1);
                    detailForm.show();

                    var url = app.config.host + "/Invoice68/GetInfoCompany";

                    webix.ajax(url, function (text) {
                        var json = JSON.parse(text);
                        webix.$$("tnnt").setValue(json.name);
                        webix.$$("mst").setValue(json.tax_code);
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng nào ! ", "error");
                        return;
                    }

                    var detailForm = this.$scope.ui(bangtonghopform.$ui);
                    bangtonghopform.setEditMode(2);
                    bangtonghopform.setValues(selectedItem);
                    if (selectedItem.trang_thai == 1) {
                        var form = $$("bangtonghop-form").elements;
                        for (var key in form) {
                            var $el = form[key];
                            $el.define("readonly", "true");
                            $el.define("css", "mcls_readonly_text");
                            $el.refresh();
                        }

                        $$("btnBTHSave").destructor();
                        $$("btnTaiHoaDon").destructor();
                        $$("btnXoaHoaDon").destructor();
                    }
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");


                    var databth = table.serialize();
                    var datachon = [];

                    for (var i = 0; i < databth.length; i++) {
                        if (databth[i]!= undefined && databth[i].chon === true && databth[i].trang_thai === "0") {
                            datachon.push(databth[i]);
                        }
                    }
                    if (datachon.length == 0) {
                        webix.message("Bạn chưa chọn dòng nào ở trạng thái chờ ký ! ", "error");
                        return;
                    }
                    /*if (selectedItem.trang_thai == 1) {
                        webix.message("Bảng tổng hợp đã gửi CQT không thể xóa ! ", "error");
                        return;
                    }*/

                    var khData = {};

                    khData.editmode = 3;
                    khData.data = datachon;

                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/SaveBangTHDL", khData, function (text) {
                                        var response = JSON.parse(text);

                                        if (response.hasOwnProperty("error")) {
                                            webix.message({ type: "error", text: response.error });
                                            return;
                                        }

                                        // table.remove(item.id);
                                        var btnRefresh = $$("btnRefresh");
                                        btnRefresh.callEvent("onClick");
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-eye fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "In (F7)" + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng in ! ", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);
                    if (selectedItem.lhhoa == 1) {
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLieuXangDau?id=" + selectedItem.id, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    } else {
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLieu?id=" + selectedItem.id, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-excel fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Export Excel" + "</span>",
            //id: "btnPreview",
            //shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");

                    var dataTable = table.serialize();
                    var selectedRecords = [];
                    for (var i = 0; i < dataTable.length; i++) {
                        if (dataTable[i]!= undefined && dataTable[i].chon === true) {
                            selectedRecords.push(dataTable[i]);
                        }
                    }

                    if (selectedRecords == null || selectedRecords.length <= 0) {
                        webix.message("Bạn chưa chọn dòng xuất dữ liệu! ", "error");
                        return;
                    }

                    /*if (selectedRecords.length == 1) {
                        var selectedItem = selectedRecords[0];
                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });
    
                        if (selectedItem.lhhoa == 1) {
                            webix
                                .ajax()
                                .response("arraybuffer")
                                .headers({ "Content-type": "application/json" })
                                .get(app.config.host + "/Invoice68/excelBTHDLieuXangDau?id=" + selectedItem.id, {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                        webix.modalbox.hide(box);
                                        webix.html.download(file, "bthdl.xlsx");
                                    },
                                });
                        } else {
                            webix
                                .ajax()
                                .response("arraybuffer")
                                .headers({ "Content-type": "application/json" })
                                .get(app.config.host + "/Invoice68/excelBTHDLieu?id=" + selectedItem.id, {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                        webix.modalbox.hide(box);
                                        webix.html.download(file, "bthdl.xlsx");
                                    },
                                });
                        }
                    } else {
                        exportExcelMulti(selectedRecords);
                    }*/
                    exportExcelMulti(selectedRecords);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 180,
            label: '<i class="fa fa-excel fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Kết xuất toàn bộ BTHDL" + "</span>",
            //id: "btnPreview",
            //shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangtonghop");

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();
                    webix.ui({
                        view:"datatable",
                        id:"excel",
                        columns: [
                            {
                                id: "trang_thai",
                                header: "Trạng thái",
                                exportType: "string",
                                template: function (obj) {
                                    return obj.trang_thai == "1" ? "Đã gửi CQT" : "Chưa gửi CQT";
                                },
                            },
                            {
                                id: "ldau",
                                header: "Trạng thái gửi",
                                exportType: "string",
                                template: function (obj) {
                                    return obj.ldau == "1" ? "Lần đầu" : "Bổ sung";
                                },
                            },
                            {
                                id: "kdlieu",
                                header: "Kỳ dữ liệu",
                                exportType: "string",
                            },

                            {
                                id: "ngay_ky",
                                header: "Ngày ký",
                                exportType: "string",
                            },
                            {
                                id: "sbthdlieu",
                                header: "Số thứ tự bảng",
                                exportType: "string",
                            },
                            {
                                id: "tgtcthue",
                                header: "Tổng tiền trước thuế",
                                exportType: "string",
                            },
                            {
                                id: "tgtthue",
                                header: "Tổng tiền thuế",
                                exportType: "string",
                            },
                            {
                                id: "tgtttoan",
                                header: "Tổng tiền thanh toán",
                                exportType: "string",
                            },
                            {
                                id: "nlap",
                                header: "Ngày lập",
                                exportType: "string",
                            },
                            {
                                id: "nglap",
                                header: "Người lập",
                                exportType: "string",
                            },
                            {
                                id: "ngky",
                                header: "Người gửi",
                                exportType: "string",
                            },
                            {
                                id: "ket_qua",
                                header: "Kết quả",
                                exportType: "string",
                                template: function (obj) {
                                    if (obj.ket_qua == 1) {
                                        return "Dữ liệu hợp lệ";
                                    } else {
                                        if (obj.ket_qua == 2) {
                                            return "Dữ liệu không hợp lệ";
                                        } else {
                                            return "Chờ phản hồi";
                                        }
                                    }
                                },
                            },
                        ]
                    });


                    var tableexcel = $$("excel");
                    var urlget = table.config.urlget;
                    urlget = urlget+"&count=" + table.data.count();

                    tableexcel.load(urlget,
                        function() {
                            webix.toExcel($$("excel"), {
                                rawValues: true,
                                columns: [
                                    {
                                        id: "trang_thai",
                                        header: "Trạng thái",
                                        exportType: "string",
                                        template: function (obj) {
                                            return obj.trang_thai == "1" ? "Đã gửi CQT" : "Chưa gửi CQT";
                                        },
                                    },
                                    {
                                        id: "ldau",
                                        header: "Trạng thái gửi",
                                        exportType: "string",
                                        template: function (obj) {
                                            return obj.ldau == "1" ? "Lần đầu" : "Bổ sung";
                                        },
                                    },
                                    {
                                        id: "kdlieu",
                                        header: "Kỳ dữ liệu",
                                        exportType: "string",
                                    },

                                    {
                                        id: "ngay_ky",
                                        header: "Ngày ký",
                                        exportType: "string",
                                    },
                                    {
                                        id: "sbthdlieu",
                                        header: "Số thứ tự bảng",
                                        exportType: "string",
                                    },
                                    {
                                        id: "tgtcthue",
                                        header: "Tổng tiền trước thuế",
                                        exportType: "string",
                                    },
                                    {
                                        id: "tgtthue",
                                        header: "Tổng tiền thuế",
                                        exportType: "string",
                                    },
                                    {
                                        id: "tgtttoan",
                                        header: "Tổng tiền thanh toán",
                                        exportType: "string",
                                    },
                                    {
                                        id: "nlap",
                                        header: "Ngày lập",
                                        exportType: "string",
                                    },
                                    {
                                        id: "nglap",
                                        header: "Người lập",
                                        exportType: "string",
                                    },
                                    {
                                        id: "ngky",
                                        header: "Người gửi",
                                        exportType: "string",
                                    },
                                    {
                                        id: "ket_qua",
                                        header: "Kết quả",
                                        exportType: "string",
                                        template: function (obj) {
                                            if (obj.ket_qua == 1) {
                                                return "Dữ liệu hợp lệ";
                                            } else {
                                                if (obj.ket_qua == 2) {
                                                    return "Dữ liệu không hợp lệ";
                                                } else {
                                                    return "Chờ phản hồi";
                                                }
                                            }
                                        },
                                    },
                                ],
                                filename: "DanhSachBTHDL",
                            });
                            table.enable();
                            table.hideProgress();
                        });

                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký gửi CQT") + "</span>",
            id: "btnSign",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("bangtonghop");
                    var layoutDK = webix.$$("layout");
                    /*var selectedItem = tableDK.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã ký và gửi CQT bạn không thể ký lại! ", "error");
                        return;
                    }*/
                    var datafrm = tableDK.serialize();

                    var data_id = [];
                    var data_id_xd = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true && datafrm[i].trang_thai != 1 && datafrm[i].lhhoa != 1) {
                                    data_id.push(datafrm[i].id);
                                }
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true && datafrm[i].trang_thai != 1 && datafrm[i].lhhoa == 1) {
                                    data_id_xd.push(datafrm[i].id);
                                }
                            }
                        }
                    }
                    if (data_id.length > 0 && data_id_xd.length > 0) {
                        webix.message("Chỉ được chọn các bảng THDL cùng loại hàng hoá để ký!");
                        return;
                    }
                    if (data_id.length > 0 && data_id_xd.length == 0) {
                        webix
                            .ajax()
                            .headers({ "Content-Type": "application/json" })
                            .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                var result = JSON.parse(text);
                                var kytaptrung = "";
                                for (var i = 0; i < result.length; i++) {
                                    var item = result[i];
                                    kytaptrung = item.value;
                                }

                                webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                    var listcerts = JSON.parse(text);
                                    if (listcerts.length > 0) {
                                        var box = webix.modalbox({
                                            title: "Chọn chứng thư số",
                                            buttons: ["Nhận", "Hủy bỏ"],
                                            text: "<div id='ctnCerts'></div>",
                                            top: 100,
                                            width: 750,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "1":
                                                        webix.modalbox.hide();
                                                        break;
                                                    case "0":
                                                        var table = $$("tblCerts");
                                                        var data = table.serialize();
                                                        var cert = null;

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i].chon == true) {
                                                                cert = data[i];
                                                                break;
                                                            }
                                                        }

                                                        if (cert == null) {
                                                            webix.message("Bạn chưa chọn chứng thư số");
                                                            return;
                                                        }

                                                        var now = new Date();
                                                        var begin = new Date(cert.begin_date);
                                                        var end = new Date(cert.end_date);
                                                        if (now < begin || now > end) {
                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                            return;
                                                        }


                                                        var postData = {
                                                            branch_code: user.getDvcsID(),
                                                            username: user.getCurrentUser(),
                                                            cer_serial: cert.cer_serial,
                                                            CheckHSM: "",
                                                            id: data_id,
                                                        };

                                                        webix.extend(layoutDK, webix.ProgressBar);
                                                        layoutDK.disable();
                                                        layoutDK.showProgress();
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/SignBTHDL", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    layoutDK.enable();
                                                                    layoutDK.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    layoutDK.enable();
                                                                    layoutDK.hideProgress();
                                                                    if (!json.hasOwnProperty("error")) {
                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                        // $$("huyhoadonForms").close();
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    } else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                },
                                                            });
                                                        return;
                                                }
                                            },
                                        });
                                        var tblMatHang = webix.ui({
                                            container: "ctnCerts",
                                            id: "tblCerts",
                                            view: "datatable",
                                            borderless: true,
                                            resizeColumn: true,
                                            height: 350,
                                            columns: [
                                                {
                                                    id: "chon",
                                                    header: _("CHON"),
                                                    width: 65,
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    template: "{common.checkbox()}",
                                                },
                                                {
                                                    id: "cert_type",
                                                    header: _("Loại"),
                                                    width: 100,
                                                },
                                                {
                                                    id: "cer_serial",
                                                    header: _("SO_SERIAL"),
                                                    width: 150,
                                                },
                                                {
                                                    id: "subject_name",
                                                    header: _("SUBJECTNAME"),
                                                    width: 450,
                                                },
                                                {
                                                    id: "begin_date",
                                                    header: _("NGAY_BAT_DAU"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "end_date",
                                                    header: _("NGAY_KET_THUC"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "issuer",
                                                    header: _("DONVI"),
                                                    width: 450,
                                                },
                                            ],
                                            url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                        });
                                    } else {
                                        var table = $$("bangtonghop");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        // xem user có tích checkbox ký HSM không?
                                        var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                        webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                            if (resultscheckSigHSM[0].json() == "C") {
                                                var postData = {
                                                    branch_code: user.getDvcsID(),
                                                    username: user.getCurrentUser(),
                                                    id: data_id,
                                                    CheckHSM: "1",
                                                };

                                                webix.extend(layoutDK, webix.ProgressBar);
                                                layoutDK.disable();
                                                layoutDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/SignBTHDL", postData, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            layoutDK.enable();
                                                            layoutDK.hideProgress();
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            layoutDK.enable();
                                                            layoutDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                app.callEvent("dataChangeBangtonghop", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                                table.enable();
                                                table.hideProgress();
                                            } else {
                                                var parameters_list = [];

                                                var k = 0; //khai báo biến k để chạy lần lượt từng hoá đơn theo id
                                                function excuteHdPlugin() {
                                                    if (k < data_id.length) {
                                                        var hdon_id = data_id[k];
                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlBTHDL?id=" + hdon_id);
                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                        webix.promise.all([a, b, hdon_id]).then(function (results) {
                                                            var json = results[0].json();

                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message({ type: "error", text: json.error });
                                                            }

                                                            var listcerts = results[1].json();
                                                            var item = results[2];

                                                            if (listcerts.length == 0) {
                                                                table.enable();
                                                                table.hideProgress();
                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                return;
                                                            }

                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                var hub = plugin.hub();
                                                                var hubconnect = plugin.conn();
                                                                if (hubconnect.state != 1) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                    return;
                                                                }
                                                                hub.off("resCommand");
                                                                hub.on("resCommand", function (result) {
                                                                    var json = JSON.parse(result);

                                                                    if (json.hasOwnProperty("error")) {
                                                                        webix.message({ type: "error", text: json.error });
                                                                    } else {
                                                                        var parameters = {
                                                                            xml: json.xml,
                                                                            id: item,
                                                                            shdon: json.shdon,
                                                                        };
                                                                        parameters_list.push(parameters);
                                                                    }
                                                                    k++;
                                                                    excuteHdPlugin();
                                                                });

                                                                var _listcerts = [];

                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                    var _cert = listcerts[i];

                                                                    _listcerts.push({
                                                                        so_serial: _cert.cer_serial,
                                                                        ngaybatdau: _cert.begin_date,
                                                                        ngayketthuc: _cert.end_date,
                                                                        issuer: _cert.issuer,
                                                                        subjectname: _cert.subject_name,
                                                                    });
                                                                }

                                                                var arg = {
                                                                    idData: "#data",
                                                                    xml: json["xml"],
                                                                    shdon: json.shdon,
                                                                    idSigner: "seller",
                                                                    tagSign: "NNT",
                                                                    dateKy: json["dateKy"],
                                                                    listcerts: _listcerts,
                                                                };

                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                    .done(function () {
                                                                        console.log("Success !");
                                                                    })
                                                                    .fail(function (error) {
                                                                        webix.message(error, "error");
                                                                    });
                                                            });
                                                        });
                                                    } else {
                                                        if (parameters_list.length > 0) {
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlBTHDL", JSON.stringify(parameters_list), function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    }
                                                }

                                                excuteHdPlugin();
                                            }
                                        });
                                    }
                                });
                            });
                    } else if (data_id_xd.length > 0 && data_id == 0) {
                        webix
                            .ajax()
                            .headers({ "Content-Type": "application/json" })
                            .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                var result = JSON.parse(text);
                                var kytaptrung = "";
                                for (var i = 0; i < result.length; i++) {
                                    var item = result[i];
                                    kytaptrung = item.value;
                                }

                                webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                    var listcerts = JSON.parse(text);
                                    if (listcerts.length > 0) {
                                        var box = webix.modalbox({
                                            title: "Chọn chứng thư số",
                                            buttons: ["Nhận", "Hủy bỏ"],
                                            text: "<div id='ctnCerts'></div>",
                                            top: 100,
                                            width: 750,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "1":
                                                        webix.modalbox.hide();
                                                        break;
                                                    case "0":
                                                        var table = $$("tblCerts");
                                                        var data = table.serialize();
                                                        var cert = null;

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i].chon == true) {
                                                                cert = data[i];
                                                                break;
                                                            }
                                                        }

                                                        if (cert == null) {
                                                            webix.message("Bạn chưa chọn chứng thư số");
                                                            return;
                                                        }

                                                        var now = new Date();
                                                        var begin = new Date(cert.begin_date);
                                                        var end = new Date(cert.end_date);
                                                        if (now < begin || now > end) {
                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                            return;
                                                        }            

                                                        var postData = {
                                                            branch_code: user.getDvcsID(),
                                                            username: user.getCurrentUser(),
                                                            cer_serial: cert.cer_serial,
                                                            /*id: selectedItem.id,*/
                                                            id: data_id_xd,
                                                        };

                                                        webix.extend(layoutDK, webix.ProgressBar);
                                                        layoutDK.disable();
                                                        layoutDK.showProgress();
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/SignBTHDLXangDau", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    layoutDK.enable();
                                                                    layoutDK.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    layoutDK.enable();
                                                                    layoutDK.hideProgress();
                                                                    if (!json.hasOwnProperty("error")) {
                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                        // $$("huyhoadonForms").close();
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    } else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                },
                                                            });
                                                        return;
                                                }
                                            },
                                        });
                                        var tblMatHang = webix.ui({
                                            container: "ctnCerts",
                                            id: "tblCerts",
                                            view: "datatable",
                                            borderless: true,
                                            resizeColumn: true,
                                            height: 350,
                                            columns: [
                                                {
                                                    id: "chon",
                                                    header: _("CHON"),
                                                    width: 65,
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    template: "{common.checkbox()}",
                                                },
                                                {
                                                    id: "cer_serial",
                                                    header: _("SO_SERIAL"),
                                                    width: 150,
                                                },
                                                {
                                                    id: "subject_name",
                                                    header: _("SUBJECTNAME"),
                                                    width: 450,
                                                },
                                                {
                                                    id: "begin_date",
                                                    header: _("NGAY_BAT_DAU"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "end_date",
                                                    header: _("NGAY_KET_THUC"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "issuer",
                                                    header: _("DONVI"),
                                                    width: 450,
                                                },
                                            ],
                                            url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                        });
                                    } else {
                                        var table = $$("bangtonghop");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        // xem user có tích checkbox ký HSM không?
                                        var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                        webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                            if (resultscheckSigHSM[0].json() == "C") {
                                                var postData = {
                                                    branch_code: user.getDvcsID(),
                                                    username: user.getCurrentUser(),
                                                    id: data_id_xd,
                                                    CheckHSM: "1",
                                                };

                                                webix.extend(layoutDK, webix.ProgressBar);
                                                layoutDK.disable();
                                                layoutDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/SignBTHDLXangDau", postData, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            layoutDK.enable();
                                                            layoutDK.hideProgress();
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            layoutDK.enable();
                                                            layoutDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                app.callEvent("dataChangeBangtonghop", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                                table.enable();
                                                table.hideProgress();   
                                            } else {
                                                var parameters_list = [];

                                                function excuteHdPlugin(k) {
                                                    if (k < data_id_xd.length) {
                                                        var hdon_id = data_id_xd[k];
                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlBTHDLXangDau?id=" + hdon_id);
                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                        webix.promise.all([a, b, hdon_id]).then(function (results) {
                                                            var json = results[0].json();

                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message({ type: "error", text: json.error });
                                                            }

                                                            var listcerts = results[1].json();
                                                            var item = results[2];

                                                            if (listcerts.length == 0) {
                                                                table.enable();
                                                                table.hideProgress();
                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                return;
                                                            }

                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                var hub = plugin.hub();
                                                                var hubconnect = plugin.conn();
                                                                if (hubconnect.state != 1) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                    return;
                                                                }
                                                                hub.off("resCommand");
                                                                hub.on("resCommand", function (result) {
                                                                    var json = JSON.parse(result);

                                                                    if (json.hasOwnProperty("error")) {
                                                                        webix.message({ type: "error", text: json.error });
                                                                    } else {
                                                                        var parameters = {
                                                                            xml: json.xml,
                                                                            id: item,
                                                                            shdon: json.shdon,
                                                                        };
                                                                        parameters_list.push(parameters);
                                                                    }
                                                                    k++;
                                                                    excuteHdPlugin(k);
                                                                });

                                                                var _listcerts = [];

                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                    var _cert = listcerts[i];

                                                                    _listcerts.push({
                                                                        so_serial: _cert.cer_serial,
                                                                        ngaybatdau: _cert.begin_date,
                                                                        ngayketthuc: _cert.end_date,
                                                                        issuer: _cert.issuer,
                                                                        subjectname: _cert.subject_name,
                                                                    });
                                                                }

                                                                var arg = {
                                                                    idData: "#data",
                                                                    xml: json["xml"],
                                                                    shdon: json.shdon,
                                                                    idSigner: "seller",
                                                                    tagSign: "NNT",
                                                                    dateKy: json["dateKy"],
                                                                    listcerts: _listcerts,
                                                                };

                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                    .done(function () {
                                                                        console.log("Success !");
                                                                    })
                                                                    .fail(function (error) {
                                                                        webix.message(error, "error");
                                                                    });
                                                            });
                                                        });
                                                    } else {
                                                        if (parameters_list.length > 0) {
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlBTHDLXangDau", JSON.stringify(parameters_list), function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    }
                                                }

                                                excuteHdPlugin(0);
                                            }
                                        });
                                    }
                                });
                            });
                    } else {
                        webix.message("Chưa tích chọn bảng hoặc bảng đã gửi CQT!");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Lập bổ sung") + "</span>",
            id: "btnUp",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(bangtonghopform.$ui);
                    bangtonghopform.setEditMode(1);
                    detailForm.show();

                    webix.$$("ldau").setValue(0);

                    var url = app.config.host + "/Invoice68/GetInfoCompany";

                    webix.ajax(url, function (text) {
                        var json = JSON.parse(text);
                        webix.$$("tnnt").setValue(json.name);
                        webix.$$("mst").setValue(json.tax_code);
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải XML") + "</span>",
            id: "btnDownloadXml",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn khách hàng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai != 1) {
                        webix.message("Bảng tổng hợp chưa gửi CQT không tồn tại xml ! ", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLBangTHDL?id=" + selectedItem.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "BangTHDL.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "bangtonghop",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                urlget:"",
                scheme: {
                    $init: function (obj) {},
                },
                onClick: {
                    DowloadBTHLDRep: function (event, cell, target) {
                        var win = webix.$$("bangtonghop");
                        var record = win.getItem(cell.row);

                        if (record.trang_thai != 1) {
                            webix.message("Mẫu chưa được ký không thể tải !", "error");
                            return;
                        }

                        if (record.ket_qua == null || record.ket_qua == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = "KetQuaKiemTraBTHDL.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLBTHDLRep?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();
                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                            });

                        return false;
                    },
                    InBTHDLRep: function (event, cell, target) {
                        var table = webix.$$("bangtonghop");
                        var item = table.getItem(cell.row);

                        if (item.ket_qua == null || item.ket_qua == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLRep?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },

                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("bangtonghop");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {},
                    onItemClick: function (id) {
                        var table = webix.$$("bangtonghop");
                        var item = table.getSelectedItem();
                        item.chon = !item.chon;
                        table.updateItem(id.row, item);
                    },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "index",
                        header: "STT",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "trang_thai",
                        header: [
                            "Trạng thái",
                            {
                                content: "serverSelectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "0", value: "Chưa gửi CQT" },
                                    { id: "1", value: "Đã gửi CQT" },
                                ],
                            },
                        ],
                        width: 150,
                        template: function (obj) {
                            if (obj.loai_tbao == "5") {
                                return "";
                            } else {
                                return obj.trang_thai == 1
                                    ? "<span style='color: #00b300'><i class='fas fa-check'></i></span> Đã gửi CQT"
                                    : "<span style='color: red'><i class='fas fa-times'></i></span> Chưa gửi CQT";
                            }
                        },
                    },
                    {
                        id: "ldau",
                        header: [
                            "Lần nộp",
                            {
                                content: "serverSelectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "1", value: "Lần đầu" },
                                    { id: "0", value: "Bổ sung" },
                                ],
                            },
                        ],
                        width: 150,
                        template: function (obj) {
                            return obj.ldau == "1"
                                ? "<span style='color: #00b300'><i class='fas fa-check'></i></span> Lần đầu"
                                : "<span style='color: red'><i class='fas fa-times'></i></span> Bổ sung";
                        },
                    },

                    {
                        id: "btnMessagetn",
                        header: ["", "Lịch sử xử lý"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                        },
                        width: 180,
                    },
                    {
                        id: "mtdiep_gui",
                        header: [
                            "Mã thông điệp gửi",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 350,
                    },
                    {
                        id: "kdlieu",
                        header: [
                            "Kỳ dữ liệu",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ngay_ky",
                        header: [
                            "Ngày giờ ký",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },

                    {
                        id: "sbthdlieu",
                        header: [
                            "Số thứ tự bảng",
                            {
                                content: "serverFilter",
                            },
                        ],
                        columnType: "numeric",
                        width: 120,
                    },
                    {
                        id: "tgtcthue",
                        header: [
                            "Tổng tiền trước thuế",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 150,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                        columnType: "numeric",
                        css: {
                            "text-align": "right",
                        },
                    },
                    {
                        id: "tgtthue",
                        header: [
                            "Tổng tiền thuế",
                            {
                                content: "serverFilter",
                            },
                        ],
                        columnType: "numeric",
                        width: 150,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                        css: {
                            "text-align": "right",
                        },
                    },
                    {
                        id: "tgtttoan",
                        header: [
                            "Tổng tiền thanh toán",
                            {
                                content: "serverFilter",
                            },
                        ],
                        columnType: "numeric",
                        width: 150,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                        css: {
                            "text-align": "right",
                        },
                    },
                    {
                        id: "nlap",
                        header: [
                            "Ngày lập",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },
                    {
                        id: "nglap",
                        header: [
                            "Người lập",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                    },
                    // {
                    //     id: "mtdiep_gui",
                    //     header: [
                    //         "Mã thông điệp",
                    //         {
                    //             content: "textFilter",
                    //         },
                    //     ],
                    //     width: 150,
                    // },
                    {
                        id: "ngky",
                        header: [
                            "Người gửi",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "ket_qua",
                        header: [
                            "Kết quả",
                            {
                                content: "serverSelectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "0", value: "Chờ phản hổi" },
                                    { id: "1", value: "Dữ liệu hợp lệ" },
                                    { id: "2", value: "Dữ liệu không hợp lệ" },
                                ],
                            },
                        ],
                        css: { "text-align": "center" },
                        width: 150,
                        template: function (obj) {
                            if (obj.ket_qua == 1) {
                                return "<span style='color: #00b300'>Dữ liệu hợp lệ</span> ";
                            } else {
                                if (obj.ket_qua == 2) {
                                    return "<span style='color: #e83717'>Dữ liệu không hợp lệ</span> ";
                                } else {
                                    return "<span>Chờ phản hồi</span>";
                                }
                            }
                        },
                    },
                    {
                        id: "bthDowloadBTHLDRep",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ket_qua != null && obj.ket_qua != "") {
                                return "<span class='DowloadBTHLDRep' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='DowloadBTHLDRep' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "btnInBTHDLRep",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ket_qua != null && obj.ket_qua != "") {
                                return "<span class='InBTHDLRep' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InBTHDLRep' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 120,
                    },
                    // {
                    //     id: "mtdiepcqt",
                    //     header: ["", "Mã thông điệp CQT"],
                    //     width: 250,
                    // },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        id: "layout",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("bangtonghop");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("bangtonghop");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangeBangtonghop", function (mode, item) {
                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },

        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_bangtonghopbienlaiform',["app", "models/user"], function (app, user) {
    var editmode = 0;

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var getNgay = function () {
        var option = $$("lkdlieu").getValue();
        if (option == "Q") {
            var nam = $$("nam").getValue();
            var thang;
            var quy = $$("thang").getValue();
            if (quy == "1") {
                thang = 0;
            } else if (quy == "2") {
                thang = 3;
            } else if (quy == "3") {
                thang = 6;
            } else if (quy == "4") {
                thang = 9;
            }
            var firstDate = new Date(nam, thang, 1);
            var lastDate = new Date(nam, thang + 3, 0);

            $$("tu_ngay").setValue(firstDate);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(lastDate);
            $$("den_ngay").refresh();
        } else if (option == "T") {
            var year = $$("nam").getValue();
            var month = $$("thang").getValue();
            var date1 = month + "/01" + "/" + year;

            var date = new Date(date1);
            var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

            var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            $$("tu_ngay").setValue(firstDay1);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(lastDay1);
            $$("den_ngay").refresh();
        } else if (option == "N") {
            var year = $$("nam").getValue();
            var month = $$("thang").getValue();
            var day = $$("ngay").getValue();
            var date1 = month + "/" + day + "/" + year;

            var date = new Date(date1);

            $$("tu_ngay").setValue(date);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(date);
            $$("den_ngay").refresh();
        }

        var tableDetail = webix.$$("danhsach_hoadon");
        tableDetail.clearAll();
    };

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Lưu tạm (F10)",
            id: "btnBTHSave",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var tableHoadon = $$("bangtonghop-form");
                    if (tableHoadon.validate()) {
                        var ds_hdon = $$("danhsach_hoadon").serialize();
                        if (ds_hdon.length == 0) {
                            webix.message("Bạn chưa nhập chi tiết biên lai", "error");
                            return;
                        } else {
                            webix.extend(tableHoadon, webix.ProgressBar);
                            tableHoadon.disable();
                            tableHoadon.showProgress();
                            // console.log(data_post);
                            var limit = 1000;
                            var m = parseInt(ds_hdon.length / limit);
                            if (ds_hdon.length > m * limit) m = m + 1;
                            var apiIndex = 0;
                            var item = $$("bangtonghop-form").getValues();
                            item["loaibth"] = 2;
                            for (var k = 0; k < m; k++) {
                                if (k < m - 1) {
                                    item["details"] = ds_hdon.slice(k * limit, (k + 1) * limit);
                                } else {
                                    item["details"] = ds_hdon.slice(k * limit, ds_hdon.length);
                                }
                                var tgtcthue = 0;
                                var tgtthue = 0;
                                var tgtttoan = 0;
                                item["details"].forEach(function (it) {
                                    tgtcthue += it["ttcthue"];
                                    tgtthue += it["tgtthue"];
                                    tgtttoan += it["tgtttoan"];
                                });
                                item["tgtcthue"] = tgtcthue;
                                item["tgtthue"] = tgtthue;
                                item["tgtttoan"] = tgtttoan;
                                var item1 = [];
                                item1.push(item);
                                var data_post = { editmode: editmode, data: item1 };
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/SaveBangTHDL", data_post, {
                                        error: function (text, data, XmlHttpRequest) {
                                            tableHoadon.enable();
                                            tableHoadon.hideProgress();
                                            // var json = JSON.parse(text);
                                            // webix.message(json.ExceptionMessage, "error");
                                            webix.message(text + XmlHttpRequest, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var json = JSON.parse(text);
                                            tableHoadon.enable();
                                            tableHoadon.hideProgress();
                                            if (!json.hasOwnProperty("error")) {
                                                webix.$$("bangtonghop-win").close();
                                                app.callEvent("dataChangeBangtonghop", [1, null]);
                                            } else {
                                                webix.message(json.error, "error");
                                            }
                                        },
                                    });
                            }
                        }
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     shortcut: "F11",
        //     view: "button",
        //     label: "Xuất tờ khai XML (F11)",
        //     type: "form",
        //     align: "center",
        //     width: 180,
        //     on: {
        //         onClick: function () {
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        // {
        //     shortcut: "F12",
        //     id: "btnBTHSend",
        //     view: "button",
        //     label: "Ký và gửi CQT (F12)",
        //     type: "form",
        //     align: "center",
        //     width: 150,
        //     on: {
        //         onClick: function () {
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            view: "button",
            hotkey: "esc",
            label: "Quay lại (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("bangtonghop-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        fullscreen: true,
        id: "bangtonghop-win",
        position: "center",
        head: "BÁO CÁO TÌNH HÌNH SỬ DỤNG DỮ LIỆU BIÊN LAI ĐIỆN TỬ",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 1500,
            id: "bangtonghop-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    rows: [
                        {
                            cols: [
                                { width: 200 },
                                {
                                    view: "label",
                                    label: "[01] Kỳ dữ liệu",
                                    width: 170,
                                },
                                {
                                    id: "lkdlieu",
                                    name: "lkdlieu",
                                    view: "combo",
                                    width: 120,
                                    value: "Q",
                                    options: [   
                                        { id: "T", value: "Tháng" },
                                        { id: "Q", value: "Quý" },
                                        { id: "N", value: "Ngày" },
                                    ],
                                    on: {
                                        onChange: function (newv, oldv) {
                                            if (newv == "N") {
                                                var k = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 60);
                                                $$("thang").refresh();
                                                $$("ngay").show();
                                                $$("ngay").refresh();
                                            }
                                            if (newv == "T") {
                                                var k = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 120);
                                                $$("thang").refresh();
                                                $$("ngay").hide();
                                                $$("ngay").refresh();
                                            }
                                            if (newv == "Q") {
                                                var k = ["1", "2", "3", "4"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 120);
                                                $$("thang").refresh();
                                                $$("ngay").hide();
                                                $$("ngay").refresh();
                                            }

                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "ngay",
                                    name: "ngay",
                                    view: "combo",
                                    width: 60,
                                    value: "1",
                                    hidden: true,
                                    options: [
                                        "1",
                                        "2",
                                        "3",
                                        "4",
                                        "5",
                                        "6",
                                        "7",
                                        "8",
                                        "9",
                                        "10",
                                        "11",
                                        "12",
                                        "13",
                                        "14",
                                        "15",
                                        "16",
                                        "17",
                                        "18",
                                        "19",
                                        "20",
                                        "21",
                                        "22",
                                        "23",
                                        "24",
                                        "25",
                                        "26",
                                        "27",
                                        "28",
                                        "29",
                                        "30",
                                        "31",
                                    ],
                                    required: true,
                                    invalidMessage: "Tháng/Quý không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "thang",
                                    name: "thang",
                                    view: "combo",
                                    width: 120,
                                    value: "1",
                                    options: ["1", "2", "3", "4"],
                                    required: true,
                                    invalidMessage: "Tháng/Quý không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "nam",
                                    name: "nam",
                                    view: "text",
                                    label: "Năm",
                                    labelWidth: 50,
                                    width: 120,
                                    required: true,
                                    invalidMessage: "Năm không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                { id: "tu_ngay", name: "tu_ngay", view: "datepicker", label: "Từ ngày", hidden: true, width: 200, labelWidth: 100 },
                                { id: "den_ngay", name: "den_ngay", view: "datepicker", label: "Đến ngày:", hidden: true, labelWidth: 100, width: 260 },
                                {},
                            ],
                        },
                        {
                            cols: [
                                { width: 200 },
                                {
                                    id: "tnnt",
                                    name: "tnnt",
                                    view: "text",
                                    label: "[02] Tên người nộp thuế:",
                                    labelWidth: 170,
                                    width: 410,
                                    required: true,
                                    invalidMessage: "Tên người nộp thuế không được để trống !",
                                    readonly: true,
                                },
                                {
                                    id: "mst",
                                    name: "mst",
                                    view: "text",
                                    label: "[03] Mã số thuế:",
                                    labelWidth: 130,
                                    width: 380,
                                    readonly: true,
                                    required: true,
                                    invalidMessage: "Mã số thuế không được để trống !",
                                },
                                { id: "nlap", name: "nlap", view: "datepicker", label: "Ngày lập", width: 190, labelWidth: 70, value: new Date() },
                                { id: "sbthdlieu", name: "sbthdlieu", view: "text", label: "Số:", labelWidth: 50, width: 200, readonly: true },
                                {},
                            ],
                        },
                        {
                            cols: [
                                { width: 200 },
                                {
                                    id: "dchi",
                                    name: "dchi",
                                    view: "text",
                                    label: "[04] Địa chỉ:",
                                    labelWidth: 130,
                                    width: 900,
                                    invalidMessage: "Mã số thuế không được để trống !",
                                },
                                {
                                    id: "ddanh",
                                    name: "ddanh",
                                    view: "text",
                                    label: "[05] Tỉnh/Thành phố:",
                                    labelWidth: 130,
                                    width: 300,
                                    invalidMessage: "Mã số thuế không được để trống !",
                                },
                            ],
                        },

                        /*{
                            id: "lhhoa",
                            name: "lhhoa",
                            view: "text",
                            label: "Loại mẫu:",
                            labelWidth: 130,
                            width: 380,
                            view: "combo",
                            value: "10",
                            options: [
                                { id: "10", value: "Mẫu BC26BLĐT" },
                                { id: "11", value: "Mẫu  BC26BLG" },
                            ],
                            on: {
                                onChange: function () {
                                    var loaiHangHoa = $$("lhhoa").getValue();
                                    if (loaiHangHoa === "1") {
                                        $$("lkdlieu").setValue("N");
                                        $$("lkdlieu").disable();
                                        $$("danhsach_hoadon").clearAll();
                                        $$("tgtcthue").setValue("");
                                        $$("tgtthue").setValue("");
                                        $$("tgtttoan").setValue("");
                                    } else {
                                        $$("lkdlieu").setValue("T");
                                        $$("lkdlieu").enable();
                                        $$("danhsach_hoadon").clearAll();
                                        $$("tgtcthue").setValue("");
                                        $$("tgtthue").setValue("");
                                        $$("tgtttoan").setValue("");
                                    }
                                },
                            },
                        },*/
                    ],
                },
                {
                    rows: [
                        {
                            cols: [
                                {
                                    view: "button",
                                    label: "Lấy thông tin biên lai",
                                    id: "btnAllHoaDon",
                                    width: 150,
                                    on: {
                                        onItemClick: function (id, e) {
                                            var tableHoadon = $$("bangtonghop-form");
                                            if (tableHoadon.validate()) {
                                                webix.confirm({
                                                    text: "Tự động lập bản báo cáo theo kì",
                                                    ok: "Có",
                                                    cancel: "Không",
                                                    callback: function (res) {
                                                        if (res) {
                                                            var params = $$("bangtonghop-form").getValues();
                                                            params["loaibth"] = 2;
                                                            var tableHoadon = webix.$$("danhsach_hoadon");
                                                            if (tableHoadon.validate()) {
                                                                webix.extend($$("bangtonghop-form"), webix.ProgressBar);
                                                                $$("bangtonghop-form").disable();
                                                                $$("bangtonghop-form").showProgress();
                                                                webix
                                                                    .ajax()
                                                                    .headers({ "Content-type": "application/json" })
                                                                    .post(app.config.host + "/Invoice68/GetHoadonChoXuLyall", params, {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            $$("bangtonghop-form").enable();
                                                                            $$("bangtonghop-form").hideProgress();
                                                                            webix.message(text, "error");
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var json = JSON.parse(text);
                                                                            if (!json.hasOwnProperty("error")) {
                                                                                //console.log(json);
                                                                                tableHoadon.clearAll();
                                                                                tableHoadon.parse(json);

                                                                                tableHoadon.refresh();
                                                                            } else {
                                                                                webix.message(json.error, "error");
                                                                            }
                                                                            $$("bangtonghop-form").enable();
                                                                            $$("bangtonghop-form").hideProgress();
                                                                        },
                                                                    });
                                                            }
                                                        }
                                                    },
                                                });
                                            }
                                        },
                                    },
                                },
                                {
                                    view: "button",
                                    label: "Xóa",
                                    id: "btnXoaHoaDon",
                                    width: 120,
                                    on: {
                                        onItemClick: function (id, e) {
                                            var table = webix.$$("danhsach_hoadon");
                                            table.editStop();
                                            var item = table.getSelectedItem();
                                            if (!webix.isUndefined(item)) {
                                                table.remove(item.id);
                                                table.clearSelection();

                                                var table = webix.$$("danhsach_hoadon");
                                                var data = table.serialize();

                                                var tien_tt = 0;
                                                var tien_thue = 0;
                                                var tong_tien = 0;

                                                for (var i = 0; i < data.length; i++) {
                                                    var item = data[i];
                                                    tien_tt += item["ttcthue"] == null ? 0 : item["ttcthue"];
                                                    tien_thue += item["tgtthue"] == null ? 0 : item["tgtthue"];
                                                    tong_tien += item["tgtttoan"] == null ? 0 : item["tgtttoan"];
                                                }

                                                $$("tgtcthue").setValue(fm(tien_tt));
                                                $$("tgtthue").setValue(fm(tien_thue));
                                                $$("tgtttoan").setValue(fm(tong_tien));

                                                return;
                                            }
                                            var editor = table.getEditState();
                                            if (!webix.isUndefined(editor)) {
                                                table.remove(editor.row);
                                                table.clearSelection();

                                                var table = webix.$$("danhsach_hoadon");
                                                var data = table.serialize();

                                                var tien_tt = 0;
                                                var tien_thue = 0;
                                                var tong_tien = 0;

                                                for (var i = 0; i < data.length; i++) {
                                                    var item = data[i];
                                                    tien_tt += item["ttcthue"] == null ? 0 : item["ttcthue"];
                                                    tien_thue += item["tgtthue"] == null ? 0 : item["tgtthue"];
                                                    tong_tien += item["tgtttoan"] == null ? 0 : item["tgtttoan"];
                                                }

                                                $$("tgtcthue").setValue(fm(tien_tt));
                                                $$("tgtthue").setValue(fm(tien_thue));
                                                $$("tgtttoan").setValue(fm(tong_tien));

                                                return;
                                            }
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            view: "datatable",
                            id: "danhsach_hoadon",
                            minHeight: 350,
                            name: "danhsach_hoadon",
                            select: true,
                            scroll: true,
                            resizeColumn: true,
                            // footer: true,
                            editable: false,
                            tooltip: true,
                            css: "webix_header_border webix_data_border",
                            scheme: {
                                $init: function (obj) {},
                            },
                            on: {
                                "data->onStoreUpdated": function () {
                                    this.data.each(function (obj, i) {
                                        obj.stt = i + 1;
                                    });
                                },
                            },
                            columns: [
                                {
                                    id: "stt",
                                    name: "stt",
                                    header: "STT",
                                    width: 40,
                                    position: "center",
                                },
                                {
                                    id: "thdon",
                                    name: "thdon",
                                    header: "Tên biên lai",
                                    width: 300,
                                    position: "center",
                                    // footer: "Tổng cộng"
                                },
                                {
                                    id: "khms",
                                    name: "khms",
                                    header: "Ký hiệu mẫu số biên lai",
                                    width: 120,
                                    position: "center",
                                    // footer: "Tổng cộng"
                                },
                                {
                                    id: "khieu",
                                    name: "khieu",
                                    header: "Ký hiệu biên lai",
                                    width: 120,
                                    position: "center",
                                    // footer: "Tổng cộng"
                                },
                                {
                                    id: "tongso",
                                    name: "tongso",
                                    header: "Tổng số",
                                    width: 120,
                                    position: "center",
                                    css : { "text-align": "center" }
                                    // footer: "Tổng cộng"
                                },

                                {
                                    id: "sdky_tso",
                                    name: "sdky_tso",
                                    header: [
                                        {
                                            content: "columnGroup",
                                            closed: false,
                                            batch: "gr1",
                                            groupText: "Số tồn đầu kỳ",
                                            colspan: 2,
                                            position: "center",
                                        },
                                        "Từ số",
                                    ],
                                    width: 140,
                                    position: "center",
                                    css : { "text-align": "center" }
                                },
                                { id: "sdky_dso", name: "sdky_dso", batch: "gr1", header: [null, "Đến số"], position: "center" ,css : { "text-align": "center" }},
                                {
                                    id: "sph_tso",
                                    name: "sph_tso",
                                    header: [
                                        {
                                            content: "columnGroup",
                                            closed: false,
                                            batch: "gr0",
                                            groupText: "Mua phát sinh trong kì",
                                            colspan: 2,
                                            position: "center",
                                        },
                                        "Từ số",
                                    ],
                                    width: 140,
                                    position: "center",
                                    css : { "text-align": "center" }
                                },
                                { id: "sph_dso", name: "sph_dso", batch: "gr0", header: [null, "Đến số"], position: "center",css : { "text-align": "center" } },
                                { id: "ssdung", name: "ssdung", header: "Tổng số sử dụng, hủy", width: 140, position: "center",css : { "text-align": "center" } },
                                {
                                    id: "ssdung_tso",
                                    name: "ssdung_tso",
                                    header: [
                                        {
                                            content: "columnGroup",
                                            closed: false,
                                            batch: "gr2",
                                            groupText: "Số sử dụng",
                                            colspan: 2,
                                            position: "center",
                                        },
                                        "Từ số",
                                    ],
                                    width: 140,
                                    position: "center",
                                    css : { "text-align": "center" }
                                },
                                { id: "ssdung_dso", name: "ssdung_dso", batch: "gr2", header: [null, "Đến số"], width: 140, position: "center",css : { "text-align": "center" } },
                                { id: "ssdung_dsd", name: "ssdung_dsd", header: "Số đã dùng", width: 140, position: "center" ,css : { "text-align": "center" }},
                                {
                                    id: "shuy_sluong",
                                    name: "shuy_sluong",
                                    header: [
                                        {
                                            content: "columnGroup",
                                            closed: false,
                                            batch: "gr3",
                                            groupText: "Hủy",
                                            colspan: 2,
                                            position: "center",
                                        },
                                        "Số lượng",
                                    ],
                                    width: 140,
                                    position: "center",
                                    css : { "text-align": "center" }
                                },
                                { id: "shuy", name: "shuy", batch: "gr3", header: [null, "Số"], width: 140, position: "center",css : { "text-align": "center" } },
                                // { id: "sxoabo_sluong", name: "sxoabo_sluong",  header: [
                                //         {
                                //             content: "columnGroup", closed: false, batch: "gr4",
                                //             groupText: "Xóa bỏ", colspan: 2,position: "center"
                                //         },
                                //         "Số lượng"], width: 140 ,position: "center"},
                                // { id: "sxoabo", name: "sxoabo", batch: "gr4", header: [null, "Số"], width: 140, position: "center" },
                                {
                                    id: "scky_tso",
                                    name: "scky_tso",
                                    header: [
                                        {
                                            content: "columnGroup",
                                            closed: false,
                                            batch: "gr5",
                                            groupText: "Số tồn cuối kì kỳ",
                                            colspan: 3,
                                            position: "center",
                                        },
                                        "Từ số",
                                    ],
                                    width: 140,
                                    position: "center",
                                    css : { "text-align": "center" }
                                },
                                { id: "scky_dso", name: "scky_dso", batch: "gr5", header: [null, "Đến Số"], width: 140, position: "center",css : { "text-align": "center" } },
                                { id: "sltck", name: "sltck", batch: "gr5", header: [null, "Số lượng"], width: 140, position: "center",css : { "text-align": "center" } },
                            ],
                        },
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
            getNgay();
        },
        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            item["nlap"] = removeTimeZoneT(item["nlap"]);
            form.setValues(item);

            //$$("tgtcthue").setValue(fm(item.tgtcthue));
            //$$("tgtthue").setValue(fm(item.tgtthue));
            //$$("tgtttoan").setValue(fm(item.tgtttoan));

            var tableDetail = webix.$$("danhsach_hoadon");

            var url = app.config.host + "/Invoice68/GetDataBangTHDLDetail_bienlai?id=" + item.id;
            tableDetail.clearAll();
            tableDetail.load(url);
        },
    };
});

define('views/68_bangtonghopbienlai',["app", "locale", "models/user", "views/forms/68_bangtonghopbienlaiform", "views/forms/68_bangdanhsachhoadon", "views/forms/68_hoadon_history"], function (
    app,
    _,
    user,
    bangtonghopform,
    bangdanhsachhoadon,
    hoadonHistory
) {
    

    var initUI = function () {
        var table = webix.$$("bangtonghop");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetBangTHDL";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                                filterType: column.header[1].content,
                            };


                            if (item.value != null && item.value != "") {
                                array.push(item);
                            }
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                url = url + "&loaibth=2";
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(bangtonghopform.$ui);
                    bangtonghopform.setEditMode(1);
                    detailForm.show();

                    var url = app.config.host + "/Invoice68/GetInfoCompany";

                    webix.ajax(url, function (text) {
                        var json = JSON.parse(text);
                        webix.$$("tnnt").setValue(json.name);
                        webix.$$("mst").setValue(json.tax_code);
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng nào ! ", "error");
                        return;
                    }

                    var detailForm = this.$scope.ui(bangtonghopform.$ui);
                    bangtonghopform.setEditMode(2);
                    bangtonghopform.setValues(selectedItem);
                    if (selectedItem.trang_thai == 1) {
                        var form = $$("bangtonghop-form").elements;
                        for (var key in form) {
                            var $el = form[key];
                            $el.define("readonly", "true");
                            $el.define("css", "mcls_readonly_text");
                            $el.refresh();
                        }

                        $$("btnBTHSave").destructor();
                        //$$("btnTaiHoaDon").destructor();
                        $$("btnXoaHoaDon").destructor();
                    }
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var databth = table.serialize();
                    var datachon = [];

                    for (var i = 0; i < databth.length; i++) {
                        if (databth[i]!= undefined && databth[i].chon === true && databth[i].trang_thai === "0") {
                            datachon.push(databth[i]);
                        }
                    }
                    if (datachon.length == 0) {
                        webix.message("Bạn chưa chọn dòng nào ở trạng thái chờ ký ! ", "error");
                        return;
                    }
                    /*if (selectedItem.trang_thai == 1) {
                        webix.message("Bảng tổng hợp đã gửi CQT không thể xóa ! ", "error");
                        return;
                    }*/

                    var khData = {};

                    khData.editmode = 3;
                    khData.data = datachon;

                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/SaveBangTHDL", khData, function (text) {
                                        var response = JSON.parse(text);

                                        if (response.hasOwnProperty("error")) {
                                            webix.message({ type: "error", text: response.error });
                                            return;
                                        }

                                        // table.remove(item.id);
                                        var btnRefresh = $$("btnRefresh");
                                        btnRefresh.callEvent("onClick");
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-eye fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "In (F7)" + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng in ! ", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang in Biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);
                    if (selectedItem.lhhoa == 1) {
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLieuXangDau?id=" + selectedItem.id, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    } else {
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLieu_all?id=" + selectedItem.id, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 100,
        //     label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Gửi email") + "</span>",
        //     id: "btnSendEmail",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("bangtonghop");
        //             var selectedItem = table.getSelectedItem();
        //             if (selectedItem == null) {
        //                 webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                 return;
        //             }
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký") + "</span>",
            id: "btnSign",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("bangtonghop");
                    /*var selectedItem = tableDK.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã ký và gửi CQT bạn không thể ký lại! ", "error");
                        return;
                    }*/
                    var datafrm = tableDK.serialize();

                    var data_id = [];
                    var data_id_xd = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true && datafrm[i].trang_thai != 1 && datafrm[i].lhhoa != 1) {
                                    data_id.push(datafrm[i].id);
                                }
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true && datafrm[i].trang_thai != 1 && datafrm[i].lhhoa == 1) {
                                    data_id_xd.push(datafrm[i].id);
                                }
                            }
                        }
                    }
                    if (data_id.length > 0 && data_id_xd.length > 0) {
                        webix.message("Chỉ được chọn các bảng THDL cùng loại hàng hoá để ký!");
                        return;
                    }
                    if (data_id.length > 0 && data_id_xd.length == 0) {
                        webix
                            .ajax()
                            .headers({ "Content-Type": "application/json" })
                            .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                var result = JSON.parse(text);
                                var kytaptrung = "";
                                for (var i = 0; i < result.length; i++) {
                                    var item = result[i];
                                    kytaptrung = item.value;
                                }

                                webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                    var listcerts = JSON.parse(text);
                                    if (listcerts.length > 0) {
                                        var box = webix.modalbox({
                                            title: "Chọn chứng thư số",
                                            buttons: ["Nhận", "Hủy bỏ"],
                                            text: "<div id='ctnCerts'></div>",
                                            top: 100,
                                            width: 750,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "1":
                                                        webix.modalbox.hide();
                                                        break;
                                                    case "0":
                                                        var table = $$("tblCerts");
                                                        var data = table.serialize();
                                                        var cert = null;

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i].chon == true) {
                                                                cert = data[i];
                                                                break;
                                                            }
                                                        }

                                                        if (cert == null) {
                                                            webix.message("Bạn chưa chọn chứng thư số");
                                                            return;
                                                        }

                                                        var now = new Date();
                                                        var begin = new Date(cert.begin_date);
                                                        var end = new Date(cert.end_date);
                                                        if (now < begin || now > end) {
                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                            return;
                                                        }            

                                                        var postData = {
                                                            branch_code: user.getDvcsID(),
                                                            username: user.getCurrentUser(),
                                                            cer_serial: cert.cer_serial,
                                                            CheckHSM: "",
                                                            id: data_id,
                                                            loaibth: 2,
                                                        };

                                                        webix.extend(tableDK, webix.ProgressBar);
                                                        tableDK.disable();
                                                        tableDK.showProgress();
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/SignBTHDL", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    if (!json.hasOwnProperty("error")) {
                                                                        webix.message("Ký thành công thông báo phát hành!", "success");
                                                                        // $$("huyhoadonForms").close();
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    } else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                },
                                                            });
                                                        return;
                                                }
                                            },
                                        });
                                        var tblMatHang = webix.ui({
                                            container: "ctnCerts",
                                            id: "tblCerts",
                                            view: "datatable",
                                            borderless: true,
                                            resizeColumn: true,
                                            height: 350,
                                            columns: [
                                                {
                                                    id: "chon",
                                                    header: _("CHON"),
                                                    width: 65,
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    template: "{common.checkbox()}",
                                                },
                                                {
                                                    id: "cert_type",
                                                    header: _("Loại"),
                                                    width: 100,
                                                },
                                                {
                                                    id: "cer_serial",
                                                    header: _("SO_SERIAL"),
                                                    width: 150,
                                                },
                                                {
                                                    id: "subject_name",
                                                    header: _("SUBJECTNAME"),
                                                    width: 450,
                                                },
                                                {
                                                    id: "begin_date",
                                                    header: _("NGAY_BAT_DAU"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "end_date",
                                                    header: _("NGAY_KET_THUC"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "issuer",
                                                    header: _("DONVI"),
                                                    width: 450,
                                                },
                                            ],
                                            url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                        });
                                    } else {
                                        var table = $$("bangtonghop");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        // xem user có tích checkbox ký HSM không?
                                        var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                        webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                            if (resultscheckSigHSM[0].json() == "C") {
                                                var postData = {
                                                    branch_code: user.getDvcsID(),
                                                    username: user.getCurrentUser(),
                                                    id: data_id,
                                                    CheckHSM: "1",
                                                    loaibth: 2,
                                                };

                                                webix.extend(tableDK, webix.ProgressBar);
                                                tableDK.disable();
                                                tableDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/SignBTHDL", postData, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                app.callEvent("dataChangeBangtonghop", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                            } else {
                                                var parameters_list = [];

                                                function excuteHdPlugin(k) {
                                                    if (k < data_id.length) {
                                                        var hdon_id = data_id[k];
                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlBTHDL?id=" + hdon_id);
                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                        webix.promise.all([a, b, hdon_id]).then(function (results) {
                                                            var json = results[0].json();

                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message({ type: "error", text: json.error });
                                                            }

                                                            var listcerts = results[1].json();
                                                            var item = results[2];

                                                            if (listcerts.length == 0) {
                                                                table.enable();
                                                                table.hideProgress();
                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                return;
                                                            }

                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                var hub = plugin.hub();
                                                                var hubconnect = plugin.conn();
                                                                if (hubconnect.state != 1) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    webix.message("Quý khách hàng chưa cài Plugin ký Biên lai hoặc Plugin ký Biên lai chưa được bật !", "error");
                                                                    return;
                                                                }
                                                                hub.off("resCommand");
                                                                hub.on("resCommand", function (result) {
                                                                    var json = JSON.parse(result);

                                                                    if (json.hasOwnProperty("error")) {
                                                                        webix.message({ type: "error", text: json.error });
                                                                    } else {
                                                                        var parameters = {
                                                                            xml: json.xml,
                                                                            id: item,
                                                                            shdon: json.shdon,
                                                                        };
                                                                        parameters_list.push(parameters);
                                                                    }
                                                                    k++;
                                                                    excuteHdPlugin(k);
                                                                });

                                                                var _listcerts = [];

                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                    var _cert = listcerts[i];

                                                                    _listcerts.push({
                                                                        so_serial: _cert.cer_serial,
                                                                        ngaybatdau: _cert.begin_date,
                                                                        ngayketthuc: _cert.end_date,
                                                                        issuer: _cert.issuer,
                                                                        subjectname: _cert.subject_name,
                                                                    });
                                                                }

                                                                var arg = {
                                                                    idData: "#data",
                                                                    xml: json["xml"],
                                                                    shdon: json.shdon,
                                                                    idSigner: "seller",
                                                                    tagSign: "TCTPLPhi",
                                                                    dateKy: json["dateKy"],
                                                                    listcerts: _listcerts,
                                                                };

                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                    .done(function () {
                                                                        console.log("Success !");
                                                                    })
                                                                    .fail(function (error) {
                                                                        webix.message(error, "error");
                                                                    });
                                                            });
                                                        });
                                                    } else {
                                                        if (parameters_list.length > 0) {
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlBTHDL", JSON.stringify(parameters_list), function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    }
                                                }

                                                excuteHdPlugin(0);
                                            }
                                        });
                                    }
                                });
                            });
                    } else if (data_id_xd.length > 0 && data_id == 0) {
                        webix
                            .ajax()
                            .headers({ "Content-Type": "application/json" })
                            .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                var result = JSON.parse(text);
                                var kytaptrung = "";
                                for (var i = 0; i < result.length; i++) {
                                    var item = result[i];
                                    kytaptrung = item.value;
                                }

                                webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                    var listcerts = JSON.parse(text);
                                    if (listcerts.length > 0) {
                                        var box = webix.modalbox({
                                            title: "Chọn chứng thư số",
                                            buttons: ["Nhận", "Hủy bỏ"],
                                            text: "<div id='ctnCerts'></div>",
                                            top: 100,
                                            width: 750,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "1":
                                                        webix.modalbox.hide();
                                                        break;
                                                    case "0":
                                                        var table = $$("tblCerts");
                                                        var data = table.serialize();
                                                        var cert = null;

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i].chon == true) {
                                                                cert = data[i];
                                                                break;
                                                            }
                                                        }

                                                        if (cert == null) {
                                                            webix.message("Bạn chưa chọn chứng thư số");
                                                            return;
                                                        }

                                                        var now = new Date();
                                                        var begin = new Date(cert.begin_date);
                                                        var end = new Date(cert.end_date);
                                                        if (now < begin || now > end) {
                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                            return;
                                                        }

                                                        var postData = {
                                                            branch_code: user.getDvcsID(),
                                                            username: user.getCurrentUser(),
                                                            cer_serial: cert.cer_serial,
                                                            /*id: selectedItem.id,*/
                                                            id: data_id_xd,
                                                        };

                                                        webix.extend(tableDK, webix.ProgressBar);
                                                        tableDK.disable();
                                                        tableDK.showProgress();
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/SignBTHDLXangDau", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    if (!json.hasOwnProperty("error")) {
                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                        // $$("huyhoadonForms").close();
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    } else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                },
                                                            });
                                                        return;
                                                }
                                            },
                                        });
                                        var tblMatHang = webix.ui({
                                            container: "ctnCerts",
                                            id: "tblCerts",
                                            view: "datatable",
                                            borderless: true,
                                            resizeColumn: true,
                                            height: 350,
                                            columns: [
                                                {
                                                    id: "chon",
                                                    header: _("CHON"),
                                                    width: 65,
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    template: "{common.checkbox()}",
                                                },
                                                {
                                                    id: "cer_serial",
                                                    header: _("SO_SERIAL"),
                                                    width: 150,
                                                },
                                                {
                                                    id: "subject_name",
                                                    header: _("SUBJECTNAME"),
                                                    width: 450,
                                                },
                                                {
                                                    id: "begin_date",
                                                    header: _("NGAY_BAT_DAU"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "end_date",
                                                    header: _("NGAY_KET_THUC"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "issuer",
                                                    header: _("DONVI"),
                                                    width: 450,
                                                },
                                            ],
                                            url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                        });
                                    } else {
                                        var table = $$("bangtonghop");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        // xem user có tích checkbox ký HSM không?
                                        var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                        webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                            if (resultscheckSigHSM[0].json() == "C") {
                                                var postData = {
                                                    branch_code: user.getDvcsID(),
                                                    username: user.getCurrentUser(),
                                                    id: data_id_xd,
                                                    CheckHSM: "1",
                                                };

                                                webix.extend(tableDK, webix.ProgressBar);
                                                tableDK.disable();
                                                tableDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/SignBTHDLXangDau", postData, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                app.callEvent("dataChangeBangtonghop", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                            } else {
                                                var parameters_list = [];

                                                var k = 0; //khai báo biến k để chạy lần lượt từng hoá đơn theo id
                                                function excuteHdPlugin() {
                                                    if (k < data_id_xd.length) {
                                                        var hdon_id = data_id_xd[k];
                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlBTHDLXangDau?id=" + hdon_id);
                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                        webix.promise.all([a, b, hdon_id]).then(function (results) {
                                                            var json = results[0].json();

                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message({ type: "error", text: json.error });
                                                            }

                                                            var listcerts = results[1].json();
                                                            var item = results[2];

                                                            if (listcerts.length == 0) {
                                                                table.enable();
                                                                table.hideProgress();
                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                return;
                                                            }

                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                var hub = plugin.hub();
                                                                var hubconnect = plugin.conn();
                                                                if (hubconnect.state != 1) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    webix.message("Quý khách hàng chưa cài Plugin ký Biên lai hoặc Plugin ký Biên lai chưa được bật !", "error");
                                                                    return;
                                                                }
                                                                hub.off("resCommand");
                                                                hub.on("resCommand", function (result) {
                                                                    var json = JSON.parse(result);

                                                                    if (json.hasOwnProperty("error")) {
                                                                        webix.message({ type: "error", text: json.error });
                                                                    } else {
                                                                        var parameters = {
                                                                            xml: json.xml,
                                                                            id: item,
                                                                            shdon: json.shdon,
                                                                        };
                                                                        parameters_list.push(parameters);
                                                                    }
                                                                    k++;
                                                                    excuteHdPlugin();
                                                                });

                                                                var _listcerts = [];

                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                    var _cert = listcerts[i];

                                                                    _listcerts.push({
                                                                        so_serial: _cert.cer_serial,
                                                                        ngaybatdau: _cert.begin_date,
                                                                        ngayketthuc: _cert.end_date,
                                                                        issuer: _cert.issuer,
                                                                        subjectname: _cert.subject_name,
                                                                    });
                                                                }

                                                                var arg = {
                                                                    idData: "#data",
                                                                    xml: json["xml"],
                                                                    shdon: json.shdon,
                                                                    idSigner: "seller",
                                                                    tagSign: "NNT",
                                                                    dateKy: json["dateKy"],
                                                                    listcerts: _listcerts,
                                                                };

                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                    .done(function () {
                                                                        console.log("Success !");
                                                                    })
                                                                    .fail(function (error) {
                                                                        webix.message(error, "error");
                                                                    });
                                                            });
                                                        });
                                                    } else {
                                                        if (parameters_list.length > 0) {
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlBTHDLXangDau", JSON.stringify(parameters_list), function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    }
                                                }

                                                excuteHdPlugin();
                                            }
                                        });
                                    }
                                });
                            });
                    } else {
                        webix.message("Chưa tích chọn bảng hoặc bảng đã ký!");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 120,
        //     label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Lập bổ sung") + "</span>",
        //     id: "btnUp",
        //     on: {
        //         onClick: function () {
        //             var detailForm = this.$scope.ui(bangtonghopform.$ui);
        //             bangtonghopform.setEditMode(1);
        //             detailForm.show();

        //             webix.$$("ldau").setValue(0);

        //             var url = app.config.host + "/Invoice68/GetInfoCompany";

        //             webix.ajax(url, function (text) {
        //                 var json = JSON.parse(text);
        //                 webix.$$("tnnt").setValue(json.name);
        //                 webix.$$("mst").setValue(json.tax_code);
        //             });
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải XML") + "</span>",
            id: "btnDownloadXml",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai != 1) {
                        webix.message("Bảng tổng hợp chưa gửi CQT không tồn tại xml ! ", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLBangTHDL?id=" + selectedItem.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "BangTHDL.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "bangtonghop",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {},
                },
                onClick: {
                    DowloadBTHLDRep: function (event, cell, target) {
                        var win = webix.$$("bangtonghop");
                        var record = win.getItem(cell.row);

                        if (record.trang_thai != 1) {
                            webix.message("Mẫu chưa được ký không thể tải !", "error");
                            return;
                        }

                        if (record.xml_nhan == null || record.xml_nhan == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = "KetQuaKiemTraBTHDL.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLBTHDLRep?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();
                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                            });

                        return false;
                    },
                    InBTHDLRep: function (event, cell, target) {
                        var table = webix.$$("bangtonghop");
                        var item = table.getItem(cell.row);

                        if (item.xml_nhan == null || item.xml_nhan == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        var box = webix.modalbox({
                            title: "Đang in Biên lai ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLRep?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },

                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("bangtonghop");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {},
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "index",
                        header: "STT",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "trang_thai",

                        header: [
                            "Trạng thái",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 150,
                        template: function (obj) {
                            return obj.trang_thai == 1
                                ? "<span style='color: #00b300'><i class='fas fa-check'></i></span> Đã Ký"
                                : "<span style='color: red'><i class='fas fa-times'></i></span> Chưa Ký";
                        },
                    },
                    /*{
                        id: "ldau",
                        header: [
                            "Lần nộp",
                            {
                                content: "selectFilter",
                            },
                        ],
                        width: 120,
                        template: function (obj) {
                            if (obj.ldau == 1) {
                                return "<span style='color: #00b300'>Lần đầu</span> ";
                            } else {
                                return "<span style='color: #e83717'>Bổ sung</span> ";
                            }
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "numeric",
                    },
                    // {
                    //     id: "btnMessagetn",
                    //     header: ["", "Lịch sử xử lý"],
                    //     css: { "text-align": "center" },
                    //     template: function (obj) {
                    //         return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                    //     },
                    //     width: 180,
                    // },*/
                    {
                        id: "kdlieu",
                        header: [
                            "Kỳ dữ liệu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ngay_ky",
                        header: [
                            "Ngày giờ ký",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },

                    {
                        id: "sbthdlieu",
                        header: [
                            "Số thứ tự bảng",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "nlap",
                        header: [
                            "Ngày lập",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },
                    {
                        id: "nglap",
                        header: [
                            "Người lập",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "ngky",
                        header: [
                            "Người ký",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("bangtonghop");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({
                title: "Tình hình sử dụng biên lai",
                details: "Tình hình sử dụng biên lai",
            });
            var table = webix.$$("bangtonghop");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangeBangtonghop", function (mode, item) {
                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },

        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_bangtonghopMTTform',["app", "models/user","views/forms/68_hoadon_history"], function (app, user,hoadonHistory) {
    var editmode = 0;
    var id = '';


    var ui = {
        view: "window",
        modal: true,
        move: true,
        fullscreen: true,
        id: "bangtonghop-win",
        position: "center",
        head: "Tổng hợp hóa đơn MTT gửi CQT",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 1500,
            id: "bangtonghop-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    rows: [
                        {
                            view: "datatable",
                            id: "danhsach_hoadon",
                            minHeight: 350,
                            name: "danhsach_hoadon",
                            select: true,
                            scroll: true,
                            resizeColumn: true,
                            // footer: true,
                            editable: false,
                            tooltip: true,
                            css: "webix_header_border webix_data_border",
                            scheme: {
                                $init: function (obj) {},
                            },
                            onClick: {
                                ShowHistory: function (event, cell, target) {
                                    var table = webix.$$("invoiceViews");
                                    var win = table.$scope.ui(hoadonHistory.$ui);
                                    var hdon_id = cell.row;
                                    hoadonHistory.setEditMode(hdon_id);
                                    win.show();
                                },
                            },
                            on: {
                                "data->onStoreUpdated": function () {
                                    this.data.each(function (obj, i) {
                                        obj.stt = i + 1;
                                    });
                                },
                            },
                            url: {
                                $proxy: true,
                                load: function (view, callback, params) {
                                    // var hdon_id = "87de11a4-0b4e-42d4-a86c-45ba10b80337";
                                        var url = app.config.host + "/Invoice68/GetTongHopHoaDonTheoBTHID?id="+id;
                                        webix.ajax(url, callback, view);
                                },
                            },
                            columns: [
                                {
                                    id: "stt",
                                    name: "stt",
                                    header: "STT",
                                    width: 40,
                                },
                                {
                                    id: "khieu",
                                    name: "khieu",
                                    header:"Ký hiệu" ,
                                    width: 120,
                                    // footer: "Tổng cộng"
                                },
                                { id: "shdon", name: "shdon", header: "Số hóa đơn", width: 120 },
                                { id: "tttthai", name: "tttthai", header: "Trạng thái hóa đơn", width: 120 },
                                { id: "tthoadon", name: "tthoadon", header: "Trạng thái gửi", width: 120 },
                                {
                                    id: "btnMessagetn",
                                    header: ["<center>Lịch sử xử lý</center>"],
                                    css: { "text-align": "center" },
                                    template: function (obj) {
                                        return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                                    },
                                    width: 180,
                                },
                                {
                                    id: "nlap",
                                    name: "nlap",
                                    header:"Ngày hóa đơn",
                                    width: 120,
                                    format: function (text) {
                                        var format = webix.Date.dateToStr("%d/%m/%Y");
                                        text = removeTimeZoneT(text);
                                        return format(text);
                                    },
                                },
                                { id: "tnmua", name: "tnmua",header:"Tên người mua" , width: 350 },
                                { id: "mstnmua", name: "mstnmua", header: "Mã số thuế người mua/mã khách hàng", width: 150 },
                                { id: "thhdvu", name: "thhdvu", header: "Mặt hàng", width: 150 },
                                {
                                    id: "sluong",
                                    name: "sluong",
                                    header: "Số lượng hàng hóa",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 6,
                                        decimalOptional: true
                                    }),
                                    css: { "text-align": "right" },
                                },
                                {
                                    id: "tgtttoan",
                                    name: "tgtttoan",
                                    header: "Tiền thanh toán",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 6,
                                        decimalOptional: true
                                    }),
                                    css: { "text-align": "right" },
                                    // footer: {
                                    //     content: "summColumn"
                                    // }
                                },
                                { id: "tthdlquan", name: "tthdlquan", header: "Thông tin hóa đơn liên quan", width: 250 },
                                { id: "gchu", name: "gchu", header: "Ghi chú", width: 150 },
                            ],
                        },
                        {
                            id: "btnHuyHDDT",
                            cols: [
                                {},
                                {
                                    view: "button",
                                    hotkey: "esc",
                                    label: "Hủy bỏ (ESC)",
                                    width: 120,
                                    type: "danger",
                                    align: "center",
                                    click: function () {
                                        hdon_id = "";
                                        webix.$$("bangtonghop-win").close();
                                    },
                                },
                                {},
                            ],
                        },
                    ],
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setId: function (bangtonghop_id) {
            var table = $$("danhsach_hoadon");
            id = bangtonghop_id;
            table.clearAll();
            table.load(table.config.url);
        },
    };
});

define('views/68_bangtonghopMTT',["app", "locale", "models/user", "views/forms/68_bangtonghopMTTform", "views/forms/68_hoadon_history","views/commonHD"], function (
    app,
    _,
    user,
    bangtonghopform,
    hoadonHistory,
    commonHD
) {
    

    var initUI = function () {
        var table = webix.$$("bangtonghop");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {

                var url = app.config.host + "/Invoice68/GetBangTHDL";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                                filterType: column.header[1].content,
                            };


                            if (item.value != null && item.value != "") {
                                array.push(item);
                            }
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                url = url + "&loaibth=4";
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Xem chi tiết" + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng nào ! ", "error");
                        return;
                    }

                    var detailForm = this.$scope.ui(bangtonghopform.$ui);
                    bangtonghopform.setId(selectedItem.bangtonghopdl_68_id);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Đã ký, không thể xóa ! ", "error");
                        return;
                    }

                    var khData = {};

                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(selectedItem);

                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/SaveBangTHDL", khData, function (text) {
                                        var response = JSON.parse(text);

                                        if (response.hasOwnProperty("error")) {
                                            webix.message({ type: "error", text: response.error });
                                            return;
                                        }

                                        // table.remove(item.id);
                                        var btnRefresh = $$("btnRefresh");
                                        btnRefresh.callEvent("onClick");
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký") + "</span>",
            id: "btnSign",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("bangtonghop");
                    var datafrm = tableDK.serialize();

                    var data_id = [];
                    var data_id_xd = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true && datafrm[i].trang_thai != 1) {
                                    data_id.push(datafrm[i].id);
                                }
                            }
                        }
                    }
                    if (data_id.length > 0) {
                        commonHD.KyTongHopXml(data_id);
                    } else {
                        webix.message("Chưa tích chọn bảng hoặc bảng đã ký!");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 120,
        //     label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Lập bổ sung") + "</span>",
        //     id: "btnUp",
        //     on: {
        //         onClick: function () {
        //             var detailForm = this.$scope.ui(bangtonghopform.$ui);
        //             bangtonghopform.setEditMode(1);
        //             detailForm.show();

        //             webix.$$("ldau").setValue(0);

        //             var url = app.config.host + "/Invoice68/GetInfoCompany";

        //             webix.ajax(url, function (text) {
        //                 var json = JSON.parse(text);
        //                 webix.$$("tnnt").setValue(json.name);
        //                 webix.$$("mst").setValue(json.tax_code);
        //             });
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải XML") + "</span>",
            id: "btnDownloadXml",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai != 1) {
                        webix.message("Bảng tổng hợp chưa gửi CQT không tồn tại xml ! ", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLBangTHDL?id=" + selectedItem.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "BangTHDL.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "bangtonghop",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {},
                },
                onClick: {
                    DowloadBTHLDRep: function (event, cell, target) {
                        var win = webix.$$("bangtonghop");
                        var record = win.getItem(cell.row);

                        if (record.trang_thai != 1) {
                            webix.message("Mẫu chưa được ký không thể tải !", "error");
                            return;
                        }

                        if (record.xml_nhan == null || record.xml_nhan == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = "KetQuaKiemTraBTHDL.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLBTHDLRep?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();
                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                            });

                        return false;
                    },
                    InBTHDLRep: function (event, cell, target) {
                        var table = webix.$$("bangtonghop");
                        var item = table.getItem(cell.row);

                        if (item.xml_nhan == null || item.xml_nhan == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        var box = webix.modalbox({
                            title: "Đang in Biên lai ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLRep?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },

                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("bangtonghop");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {},
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "index",
                        header: "STT",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "trang_thai",

                        header: [
                            "Trạng thái",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 150,
                        template: function (obj) {
                            return obj.trang_thai == 1
                                ? "<span style='color: #00b300'><i class='fas fa-check'></i></span> Đã Ký"
                                : "<span style='color: red'><i class='fas fa-times'></i></span> Chưa Ký";
                        },
                    },
                    {
                        id: "btnMessagetn",
                        header: ["", "Lịch sử xử lý"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                        },
                        width: 180,
                    },
                    {
                        id: "kdlieu",
                        header: [
                            "Kỳ dữ liệu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ngay_ky",
                        header: [
                            "Ngày giờ ký",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },

                    {
                        id: "sbthdlieu",
                        header: [
                            "Số thứ tự bảng",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "nlap",
                        header: [
                            "Ngày lập",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },
                    {
                        id: "nglap",
                        header: [
                            "Người lập",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "ngky",
                        header: [
                            "Người ký",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "ket_qua",
                        header: ["", "Kết quả"],
                        css: { "text-align": "center" },
                        width: 150,
                        template: function (obj) {
                            if (obj.ket_qua == 1) {
                                return "<span style='color: #00b300'>Dữ liệu hợp lệ</span> ";
                            } else {
                                if (obj.ket_qua == 2) {
                                    return "<span style='color: #e83717'>Dữ liệu không hợp lệ</span> ";
                                } else {
                                    return "<span>Chờ phản hồi</span>";
                                }
                            }
                        },
                    },
                    {
                        id: "bthDowloadBTHLDRep",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ket_qua != null && obj.ket_qua != "") {
                                return "<span class='DowloadBTHLDRep' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='DowloadBTHLDRep' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 120,
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("bangtonghop");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({
                title: "Bảng tổng hợp hóa đơn máy tính tiền",
                details: "Bảng tổng hợp hóa đơn máy tính tiền",
            });
            var table = webix.$$("bangtonghop");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangeBangtonghop", function (mode, item) {
                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },

        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_bangdanhsachtncn',["app", "models/user", "views/forms/68_bangtonghopform"], function (app, user, bangtonghopform) {
    var editmode = 0;
    var params;

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var table = webix.$$("danhsach_hoadonFrm");
                    var data = table.serialize();
                    var lstTemp = [];
                    var putData = "";
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        if (item.chon != undefined) {
                            if (item.chon == "C") {
                                //item.mstnmua = item["mst"];
                                lstTemp.push(item);
                                putData += "'" + item.hdon_id + "',";
                            }
                        }
                    }

                    putData = putData.substring(0, putData.length - 1);

                    if (lstTemp.length == 0) {
                        webix.message({ type: "error", text: "Bạn chưa chọn chứng từ" });
                        return;
                    }

                    var params = {};
                    params["data"] = putData;
                    var lhhoa = $$("bangtonghop-form").getValues().lhhoa;
                    params["loaibth"] = 3;
                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .post(app.config.host + "/Invoice68/GetDetailHoadonChoXuLy", params, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(text + XmlHttpRequest, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var json = JSON.parse(text);

                                if (!json.hasOwnProperty("error")) {
                                    var frm = webix.$$("danhsach_hoadon");
                                    frm.clearAll();
                                    frm.parse(json);

                                    $$("danhsachhoadon-win").close();
                                } else {
                                    webix.message(json.error, "error");
                                }
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("danhsachhoadon-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "danhsachhoadon-win",
        position: "center",
        head: "Chọn chứng từ vào bảng tổng hợp dữ liệu điện tử",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            minWidth: 900,
            id: "danhsachhoadon-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    view: "datatable",
                    id: "danhsach_hoadonFrm",
                    name: "danhsach_hoadonFrm",
                    select: true,
                    resizeColumn: true,
                    footer: false,
                    editable: false,
                    tooltip: true,
                    minHeight: 400,
                    scheme: {
                        $init: function (obj) {},
                    },
                    on: {},
                    columns: [
                        {
                            id: "chon",
                            header: [{ text: "", content: "masterCheckbox" }],
                            width: 55,
                            checkValue: "C",
                            uncheckValue: "K",
                            template: "{common.checkbox()}",
                        },
                        {
                            id: "nky",
                            name: "nky",
                            header: ["Ngày giờ ký", { content: "datepickerFilter" }],
                            width: 120,
                            format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            },
                        },
                        {
                            id: "khieu",
                            name: "khieu",
                            header: [
                                "Ký hiệu",
                                {
                                    content: "textFilter",
                                },
                            ],
                            width: 120,
                            // footer: "Tổng cộng"
                        },
                        { id: "shdon", name: "shdon", header: ["Số chứng từ", { content: "textFilter" }], width: 120 },
                        {
                            id: "nlap",
                            name: "nlap",
                            header: ["Ngày chứng từ", { content: "datepickerFilter" }],
                            width: 120,
                            format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            },
                        },
                        { id: "tnmua", name: "tnmua", header: ["Tên người bị khâu trừ", { content: "textFilter" }], width: 350 },
                        { id: "mstnmua", name: "mstnmua", header: ["Mã số thuế", { content: "textFilter" }], width: 150 },
                        { id: "cmnd", name: "cmnd", header: ["CMND/CCCD", { content: "textFilter" }], width: 150 },
                        /*{
                            id: "ktnhap",
                            name: "ktnhap",
                            header: "Khoản thu nhập",
                            width: 150,
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0,
                            }),
                            css: { "text-align": "right" },
                            // footer: {
                            //     content: "summColumn"
                            // }
                        },
                        {
                            id: "kdbhbbuoc",
                            name: "kdbhbbuoc",
                            header: "Khoản đóng bảo hiểm bắt buộc",
                            width: 150,
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0,
                            }),
                            css: { "text-align": "right" },
                            // footer: {
                            //     content: "summColumn"
                            // }
                        },
                        {
                            id: "tgtthue",
                            name: "tgtthue",
                            header: "Tổng thu nhập khấu trừ",
                            width: 150,
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0,
                            }),
                            css: { "text-align": "right" },
                            // footer: {
                            //     content: "summColumn"
                            // }
                        },
                        {
                            id: "ttcthue",
                            name: "ttcthue",
                            header: "Tổng thu nhập chịu thuế",
                            width: 150,
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0,
                            }),
                            css: { "text-align": "right" },
                            // footer: {
                            //     content: "summColumn"
                            // }
                        },
                        {
                            id: "ttntthue",
                            name: "ttntthue",
                            header: "Tổng thu nhập tính thuế",
                            width: 150,
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0,
                            }),
                            css: { "text-align": "right" },
                            // footer: {
                            //     content: "summColumn"
                            // }
                        }*/ {
                            id: "tgtttoan",
                            name: "tgtttoan",
                            header: "Số tiền thuế",
                            width: 150,
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0,
                            }),
                            css: { "text-align": "right" },
                            // footer: {
                            //     content: "summColumn"
                            // }
                        },
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setParams: function (value) {
            params = value;
            params["loaibth"] = 3;
            var table = $$("danhsach_hoadonFrm");
            webix.extend(table, webix.ProgressBar);
            table.disable();
            table.showProgress();
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .post(app.config.host + "/Invoice68/GetHoadonChoXuLy", params, {
                    error: function (text, data, XmlHttpRequest) {
                        table.enable();
                        table.hideProgress();
                        webix.message(text, "error");
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var json = JSON.parse(text);
                        if (!json.hasOwnProperty("error")) {
                            //console.log(json);
                            $$("danhsach_hoadonFrm").clearAll();
                            $$("danhsach_hoadonFrm").parse(json);

                            if (json["data"].length > 0) {
                                $$("tgtcthue").setValue(fm(json["data"][0]["tong_dt"]));
                                $$("tgtthue").setValue(fm(json["data"][0]["tong_tienthue"]));
                            }

                            $$("danhsach_hoadonFrm").refresh();
                        } else {
                            webix.message(json.error, "error");
                        }
                        table.enable();
                        table.hideProgress();
                    },
                });
        },
        setValues: function (item) {},
    };
});

define('views/forms/68_bangtonghoothunhapcanhanform',["app", "models/user", "views/forms/68_bangdanhsachtncn"], function (app, user, bangdanhsachhoadon) {
    var editmode = 0;

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var getNgay = function () {
        var option = $$("lkdlieu").getValue();
        if (option == "Q") {
            var nam = $$("nam").getValue();
            var thang;
            var quy = $$("thang").getValue();
            if (quy == "1") {
                thang = 0;
            } else if (quy == "2") {
                thang = 3;
            } else if (quy == "3") {
                thang = 6;
            } else if (quy == "4") {
                thang = 9;
            }
            var firstDate = new Date(nam, thang, 1);
            var lastDate = new Date(nam, thang + 3, 0);

            $$("tu_ngay").setValue(firstDate);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(lastDate);
            $$("den_ngay").refresh();
        } else if (option == "T") {
            var year = $$("nam").getValue();
            var month = $$("thang").getValue();
            var date1 = month + "/01" + "/" + year;

            var date = new Date(date1);
            var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

            var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            $$("tu_ngay").setValue(firstDay1);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(lastDay1);
            $$("den_ngay").refresh();
        } else if (option == "N") {
            var year = $$("nam").getValue();
            var month = $$("thang").getValue();
            var day = $$("ngay").getValue();
            var date1 = month + "/" + day + "/" + year;

            var date = new Date(date1);

            $$("tu_ngay").setValue(date);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(date);
            $$("den_ngay").refresh();
        }

        var tableDetail = webix.$$("danhsach_hoadon");
        tableDetail.clearAll();
    };

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Lưu tạm (F10)",
            id: "btnBTHSave",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var tableHoadon = $$("bangtonghop-form");
                    if (tableHoadon.validate()) {
                        var ds_hdon = $$("danhsach_hoadon").serialize();
                        if (ds_hdon.length == 0) {
                            webix.message("Bạn chưa nhập chi tiết bảng kê", "error");
                            return;
                        } else {
                            webix.extend(tableHoadon, webix.ProgressBar);
                            tableHoadon.disable();
                            tableHoadon.showProgress();
                            // console.log(data_post);
                            var limit = 1000;
                            var m = parseInt(ds_hdon.length / limit);
                            if (ds_hdon.length > m * limit) m = m + 1;
                            var apiIndex = 0;
                            var item = $$("bangtonghop-form").getValues();
                            item["loaibth"] = 3;
                            for (var k = 0; k < m; k++) {
                                if (k < m - 1) {
                                    item["details"] = ds_hdon.slice(k * limit, (k + 1) * limit);
                                } else {
                                    item["details"] = ds_hdon.slice(k * limit, ds_hdon.length);
                                }
                                var tgtcthue = 0;
                                var tgtthue = 0;
                                var tgtttoan = 0;
                                item["details"].forEach(function (it) {
                                    tgtcthue += it["ttcthue"];
                                    tgtthue += it["tgtthue"];
                                    tgtttoan += it["tgtttoan"];
                                });
                                item["tgtcthue"] = tgtcthue;
                                item["tgtthue"] = tgtthue;
                                item["tgtttoan"] = tgtttoan;
                                var item1 = [];
                                item1.push(item);
                                var data_post = { editmode: editmode, data: item1 };
                                if (item.lhhoa === "1") {
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Invoice68/SaveBangTHDLXangDau", data_post, {
                                            error: function (text, data, XmlHttpRequest) {
                                                tableHoadon.enable();
                                                tableHoadon.hideProgress();
                                                // var json = JSON.parse(text);
                                                // webix.message(json.ExceptionMessage, "error");
                                                webix.message(text + XmlHttpRequest, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var json = JSON.parse(text);
                                                tableHoadon.enable();
                                                tableHoadon.hideProgress();
                                                if (!json.hasOwnProperty("error")) {
                                                    webix.$$("bangtonghop-win").close();
                                                    app.callEvent("dataChangeBangtonghop", [1, null]);
                                                } else {
                                                    webix.message(json.error, "error");
                                                }
                                            },
                                        });
                                } else {
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Invoice68/SaveBangTHDL", data_post, {
                                            error: function (text, data, XmlHttpRequest) {
                                                tableHoadon.enable();
                                                tableHoadon.hideProgress();
                                                // var json = JSON.parse(text);
                                                // webix.message(json.ExceptionMessage, "error");
                                                webix.message(text + XmlHttpRequest, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var json = JSON.parse(text);
                                                tableHoadon.enable();
                                                tableHoadon.hideProgress();
                                                if (!json.hasOwnProperty("error")) {
                                                    webix.$$("bangtonghop-win").close();
                                                    app.callEvent("dataChangeBangtonghop", [1, null]);
                                                } else {
                                                    webix.message(json.error, "error");
                                                }
                                            },
                                        });
                                }
                            }
                        }
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     shortcut: "F11",
        //     view: "button",
        //     label: "Xuất tờ khai XML (F11)",
        //     type: "form",
        //     align: "center",
        //     width: 180,
        //     on: {
        //         onClick: function () {
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        // {
        //     shortcut: "F12",
        //     id: "btnBTHSend",
        //     view: "button",
        //     label: "Ký và gửi CQT (F12)",
        //     type: "form",
        //     align: "center",
        //     width: 150,
        //     on: {
        //         onClick: function () {
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            view: "button",
            hotkey: "esc",
            label: "Quay lại (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("bangtonghop-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        fullscreen: true,
        id: "bangtonghop-win",
        position: "center",
        head: "BẢNG KÊ CHỨNG TỪ THUẾ THU NHẬP CÁ NHÂN",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 1500,
            id: "bangtonghop-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    rows: [
                        {
                            cols: [
                                {},
                                {
                                    view: "label",
                                    label: "[01] Kỳ dữ liệu",
                                    width: 170,
                                },
                                {
                                    id: "lkdlieu",
                                    name: "lkdlieu",
                                    view: "combo",
                                    width: 150,
                                    value: "T",
                                    options: [
                                        { id: "T", value: "Tháng" },
                                        { id: "Q", value: "Quý" },
                                    ],
                                    on: {
                                        onChange: function (newv, oldv) {
                                            if (newv == "N") {
                                                var k = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 60);
                                                $$("thang").refresh();
                                                $$("ngay").show();
                                                $$("ngay").refresh();
                                            }
                                            if (newv == "T") {
                                                var k = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 120);
                                                $$("thang").refresh();
                                                $$("ngay").hide();
                                                $$("ngay").refresh();
                                            }
                                            if (newv == "Q") {
                                                var k = ["1", "2", "3", "4"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 120);
                                                $$("thang").setValue("1");
                                                $$("thang").refresh();
                                                $$("ngay").hide();
                                                $$("ngay").refresh();
                                            }

                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "ngay",
                                    name: "ngay",
                                    view: "combo",
                                    width: 60,
                                    value: "1",
                                    hidden: true,
                                    options: [
                                        "1",
                                        "2",
                                        "3",
                                        "4",
                                        "5",
                                        "6",
                                        "7",
                                        "8",
                                        "9",
                                        "10",
                                        "11",
                                        "12",
                                        "13",
                                        "14",
                                        "15",
                                        "16",
                                        "17",
                                        "18",
                                        "19",
                                        "20",
                                        "21",
                                        "22",
                                        "23",
                                        "24",
                                        "25",
                                        "26",
                                        "27",
                                        "28",
                                        "29",
                                        "30",
                                        "31",
                                    ],
                                    required: true,
                                    invalidMessage: "Tháng/Quý không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "thang",
                                    name: "thang",
                                    view: "combo",
                                    width: 150,
                                    value: "1",
                                    options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
                                    required: true,
                                    invalidMessage: "Tháng/Quý không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "nam",
                                    name: "nam",
                                    view: "text",
                                    label: "Năm",
                                    labelWidth: 50,
                                    width: 150,
                                    required: true,
                                    invalidMessage: "Năm không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "mst",
                                    name: "mst",
                                    view: "text",
                                    label: "[02] Mã số thuế:",
                                    labelWidth: 130,
                                    width: 400,
                                    readonly: true,
                                    required: true,
                                    invalidMessage: "Mã số thuế không được để trống !",
                                },
                                { id: "tu_ngay", name: "tu_ngay", view: "datepicker", label: "Từ ngày", hidden: true, width: 200, labelWidth: 100 },
                                { id: "den_ngay", name: "den_ngay", view: "datepicker", label: "Đến ngày:", hidden: true, labelWidth: 100, width: 260 },
                                {},
                            ],
                        },
                        {
                            cols: [
                                {},
                                {
                                    id: "tnnt",
                                    name: "tnnt",
                                    view: "text",
                                    label: "[03] Tên người nộp thuế:",
                                    labelWidth: 170,
                                    width: 620,
                                    required: true,
                                    invalidMessage: "Tên người nộp thuế không được để trống !",
                                    readonly: true,
                                },
                                {
                                    id: "dchi",
                                    name: "dchi",
                                    view: "text",
                                    label: "[04] Địa chỉ:",
                                    labelWidth: 130,
                                    width: 400,
                                    invalidMessage: "Không được để trống !",
                                },
                                {},
                            ],
                        },
                        {
                            cols: [
                                {},
                                {
                                    id: "dthoai",
                                    name: "dthoai",
                                    view: "text",
                                    label: "[05] Điện thoại:",
                                    labelWidth: 170,
                                    width: 380,
                                    invalidMessage: "Mã số thuế không được để trống !",
                                },
                                { id: "nlap", name: "nlap", view: "datepicker", label: "Ngày lập", width: 240, labelWidth: 100, value: new Date() },
                                { id: "sbthdlieu", name: "sbthdlieu", view: "text", label: "Số:", labelWidth: 130, width: 400, readonly: true },
                                {},
                            ],
                        },
                    ],
                },
                {
                    rows: [
                        {
                            cols: [
                                {
                                    view: "button",
                                    label: "Chọn chứng từ",
                                    id: "btnTaiHoaDon",
                                    width: 150,
                                    on: {
                                        onItemClick: function (id, e) {
                                            var item = $$("bangtonghop-form").getValues();
                                            var tableHoadon = $$("bangtonghop-form");
                                            if (tableHoadon.validate()) {
                                                var detailForm = this.getTopParentView().$scope.ui(bangdanhsachhoadon.$ui);
                                                bangdanhsachhoadon.setEditMode(1);
                                                bangdanhsachhoadon.setParams(item);
                                                detailForm.show();
                                            }
                                        },
                                    },
                                },
                                {
                                    view: "button",
                                    label: "Chọn toàn bộ",
                                    id: "btnAllHoaDon",
                                    width: 150,
                                    on: {
                                        onItemClick: function (id, e) {
                                            webix.confirm({
                                                text: "Tự động chọn tất cả chứng từ trong kì",
                                                ok: "Có",
                                                cancel: "Không",
                                                callback: function (res) {
                                                    if (res) {
                                                        var params = $$("bangtonghop-form").getValues();
                                                        params["loaibth"] = 3;
                                                        var tableHoadon = webix.$$("danhsach_hoadon");
                                                        if (tableHoadon.validate()) {
                                                            webix.extend($$("bangtonghop-form"), webix.ProgressBar);
                                                            $$("bangtonghop-form").disable();
                                                            $$("bangtonghop-form").showProgress();
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/GetHoadonChoXuLyall", params, {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        $$("bangtonghop-form").enable();
                                                                        $$("bangtonghop-form").hideProgress();
                                                                        webix.message(text, "error");
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var json = JSON.parse(text);
                                                                        if (!json.hasOwnProperty("error")) {
                                                                            //console.log(json);
                                                                            tableHoadon.clearAll();
                                                                            tableHoadon.parse(json);

                                                                            tableHoadon.refresh();
                                                                        } else {
                                                                            webix.message(json.error, "error");
                                                                        }
                                                                        $$("bangtonghop-form").enable();
                                                                        $$("bangtonghop-form").hideProgress();
                                                                    },
                                                                });
                                                        }
                                                    }
                                                },
                                            });
                                        },
                                    },
                                },
                                {
                                    view: "button",
                                    label: "Xóa",
                                    id: "btnXoaHoaDon",
                                    width: 120,
                                    on: {
                                        onItemClick: function (id, e) {
                                            var table = webix.$$("danhsach_hoadon");
                                            table.editStop();
                                            var item = table.getSelectedItem();
                                            if (!webix.isUndefined(item)) {
                                                table.remove(item.id);
                                                table.clearSelection();

                                                var table = webix.$$("danhsach_hoadon");
                                                var data = table.serialize();

                                                var tien_tt = 0;
                                                var tien_thue = 0;
                                                var tong_tien = 0;

                                                for (var i = 0; i < data.length; i++) {
                                                    var item = data[i];
                                                    tien_tt += item["ttcthue"] == null ? 0 : item["ttcthue"];
                                                    tien_thue += item["tgtthue"] == null ? 0 : item["tgtthue"];
                                                    tong_tien += item["tgtttoan"] == null ? 0 : item["tgtttoan"];
                                                }

                                                $$("tgtcthue").setValue(fm(tien_tt));
                                                $$("tgtthue").setValue(fm(tien_thue));
                                                $$("tgtttoan").setValue(fm(tong_tien));

                                                return;
                                            }
                                            var editor = table.getEditState();
                                            if (!webix.isUndefined(editor)) {
                                                table.remove(editor.row);
                                                table.clearSelection();

                                                var table = webix.$$("danhsach_hoadon");
                                                var data = table.serialize();

                                                var tien_tt = 0;
                                                var tien_thue = 0;
                                                var tong_tien = 0;

                                                for (var i = 0; i < data.length; i++) {
                                                    var item = data[i];
                                                    tien_tt += item["ttcthue"] == null ? 0 : item["ttcthue"];
                                                    tien_thue += item["tgtthue"] == null ? 0 : item["tgtthue"];
                                                    tong_tien += item["tgtttoan"] == null ? 0 : item["tgtttoan"];
                                                }

                                                $$("tgtcthue").setValue(fm(tien_tt));
                                                $$("tgtthue").setValue(fm(tien_thue));
                                                $$("tgtttoan").setValue(fm(tong_tien));

                                                return;
                                            }
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            view: "datatable",
                            id: "danhsach_hoadon",
                            minHeight: 350,
                            name: "danhsach_hoadon",
                            select: true,
                            scroll: true,
                            resizeColumn: true,
                            // footer: true,
                            editable: false,
                            tooltip: true,
                            scheme: {
                                $init: function (obj) {},
                            },
                            on: {
                                "data->onStoreUpdated": function () {
                                    this.data.each(function (obj, i) {
                                        obj.stt = i + 1;
                                    });
                                },
                            },
                            columns: [
                                {
                                    id: "stt",
                                    name: "stt",
                                    header: "STT",
                                    width: 40,
                                },
                                {
                                    id: "khieu",
                                    name: "khieu",
                                    header: "Ký hiệu",
                                    width: 120,
                                    // footer: "Tổng cộng"
                                },
                                { id: "shdon", name: "shdon", header: "Số chứng từ", width: 120 },
                                {
                                    id: "nlap",
                                    name: "nlap",
                                    header: "Ngày chứng từ",
                                    width: 120,
                                    format: function (text) {
                                        var format = webix.Date.dateToStr("%d/%m/%Y");
                                        text = removeTimeZoneT(text);
                                        return format(text);
                                    },
                                },
                                { id: "tnmua", name: "tnmua", header: "Tên người bị khâu trừ", width: 350 },
                                { id: "mstnmua", name: "mstnmua", header: "Mã số thuế", width: 150 },
                                { id: "cmnd", name: "cmnd", header: "Chứng minh nhân dân", width: 150 },
                                {
                                    id: "tgtttoan",
                                    name: "tgtttoan",
                                    header: "Số tiền thuế",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: { "text-align": "right" },
                                    // footer: {
                                    //     content: "summColumn"
                                    // }
                                },
                                {
                                    id: "tthai",
                                    name: "tthai",
                                    header: "Trạng thái",
                                    width: 150,
                                    format: function (text) {
                                        var result = "";
                                        if (text == 0) {
                                            result = "Mới";
                                        } else if (text == 1) {
                                            result = "Hủy";
                                        } else if (text == 2) {
                                            result = "Điều chỉnh";
                                        } else if (text == 3) {
                                            result = "Thay thế";
                                        } else if (text == 4) {
                                            result = "Giải trình";
                                        } else if (text == 5) {
                                            result = "Sai sót do tổng hợp";
                                        }
                                        return result;
                                    },
                                },
                                { id: "tthdlquan", name: "tthdlquan", header: "Thông tin chứng từ liên quan", width: 250 },

                                /*{
                                    id: "ktnhap",
                                    name: "ktnhap",
                                    header: "Khoản thu nhập",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: { "text-align": "right" },
                                    // footer: {
                                    //     content: "summColumn"
                                    // }
                                },
                                {
                                    id: "kdbhbbuoc",
                                    name: "kdbhbbuoc",
                                    header: "Khoản đóng bảo hiểm bắt buộc",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: { "text-align": "right" },
                                    // footer: {
                                    //     content: "summColumn"
                                    // }
                                },
                                {
                                    id: "tgtthue",
                                    name: "tgtthue",
                                    header: "Tổng thu nhập khấu trừ",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: { "text-align": "right" },
                                    // footer: {
                                    //     content: "summColumn"
                                    // }
                                },
                                {
                                    id: "ttcthue",
                                    name: "ttcthue",
                                    header: "Tổng thu nhập chịu thuế",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: { "text-align": "right" },
                                    // footer: {
                                    //     content: "summColumn"
                                    // }
                                },
                                {
                                    id: "ttntthue",
                                    name: "ttntthue",
                                    header: "Tổng thu nhập tính thuế",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: { "text-align": "right" },
                                    // footer: {
                                    //     content: "summColumn"
                                    // }
                                }*/
                                {
                                    id: "tthai",
                                    name: "tthai",
                                    header: "Ghi chú",
                                    width: 150,
                                    format: function (text) {
                                        var result = "";
                                        if (text == 1) {
                                            result = "Chứng từ đã hủy.";
                                        }
                                        return result;
                                    },
                                },
                            ],
                        },
                        {
                            hidden: true,
                            cols: [
                                {
                                    id: "tgtcthue",
                                    name: "tgtcthue",
                                    view: "text",
                                    label: "Tiền trước thuế",
                                    readonly: true,
                                    labelWidth: 100,
                                    css: "mcls_readonly_text",
                                    // format: webix.Number.numToStr({
                                    //     groupDelimiter: ",",
                                    //     groupSize: 3,
                                    //     decimalDelimiter: ".",
                                    //     decimalSize: 0,
                                    // })
                                },
                                {
                                    id: "tgtthue",
                                    name: "tgtthue",
                                    view: "text",
                                    label: "Tiền thuế",
                                    readonly: true,
                                    labelWidth: 100,
                                    css: "mcls_readonly_text",
                                    // format: webix.Number.numToStr({
                                    //     groupDelimiter: ",",
                                    //     groupSize: 3,
                                    //     decimalDelimiter: ".",
                                    //     decimalSize: 0,
                                    // })
                                },
                                {
                                    id: "tgtttoan",
                                    name: "tgtttoan",
                                    view: "text",
                                    readonly: true,
                                    labelWidth: 100,
                                    css: "mcls_readonly_text",
                                    label: "Tiền thanh toán",
                                    // format: webix.Number.numToStr({
                                    //     groupDelimiter: ",",
                                    //     groupSize: 3,
                                    //     decimalDelimiter: ".",
                                    //     decimalSize: 0,
                                    // })
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
            var now = new Date();
            var getDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            $$("thang").setValue((now.getMonth() + 1).toString());
            $$("thang").refresh();
            $$("nam").setValue(now.getFullYear().toString());
            $$("nam").refresh();
        },
        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            item["nlap"] = removeTimeZoneT(item["nlap"]);
            form.setValues(item);

            $$("tgtcthue").setValue(fm(item.tgtcthue));
            $$("tgtthue").setValue(fm(item.tgtthue));
            $$("tgtttoan").setValue(fm(item.tgtttoan));

            getNgay();

            var tableDetail = webix.$$("danhsach_hoadon");
            if (item.lhhoa === 1) {
                var url = app.config.host + "/Invoice68/GetDataBangTHDLXangDauDetail?id=" + item.id;
            } else {
                var url = app.config.host + "/Invoice68/GetDataBangTHDLDetail?id=" + item.id;
            }
            tableDetail.clearAll();
            tableDetail.load(url);
        },
    };
});

define('views/68_bangtonghopthuetncn',["app", "locale", "models/user", "views/forms/68_bangtonghoothunhapcanhanform", "views/forms/68_hoadon_history"], function (app, _, user, bangtonghopform, hoadonHistory) {
    

    var initUI = function () {
        var table = webix.$$("bangtonghop");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetBangTHDL";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                                filterType: column.header[1].content,
                            };


                            if (item.value != null && item.value != "") {
                                array.push(item);
                            }
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                url = url + "&loaibth=3";
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
        webix.$$("title").parse({
            title: "Bảng kê chứng từ thuế thu nhập cá nhân",
            details: "Bảng kê chứng từ thuế thu nhập cá nhân",
        });
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(bangtonghopform.$ui);
                    bangtonghopform.setEditMode(1);
                    detailForm.show();

                    var url = app.config.host + "/Invoice68/GetInfoCompany";

                    webix.ajax(url, function (text) {
                        var json = JSON.parse(text);
                        webix.$$("tnnt").setValue(json.name);
                        webix.$$("mst").setValue(json.tax_code);
                        webix.$$("dthoai").setValue(json.tel);
                        webix.$$("dchi").setValue(json.address);
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng nào ! ", "error");
                        return;
                    }

                    var detailForm = this.$scope.ui(bangtonghopform.$ui);
                    bangtonghopform.setEditMode(2);
                    bangtonghopform.setValues(selectedItem);
                    if (selectedItem.trang_thai == 1) {
                        var form = $$("bangtonghop-form").elements;
                        for (var key in form) {
                            var $el = form[key];
                            $el.define("readonly", "true");
                            $el.define("css", "mcls_readonly_text");
                            $el.refresh();
                        }

                        $$("btnBTHSave").destructor();
                        $$("btnTaiHoaDon").destructor();
                        $$("btnAllHoaDon").destructor();
                        $$("btnXoaHoaDon").destructor();
                    }
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var databth = table.serialize();
                    var datachon = [];

                    for (var i = 0; i < databth.length; i++) {
                        if (databth[i]!= undefined && databth[i].chon === true && databth[i].trang_thai === "0") {
                            datachon.push(databth[i]);
                        }
                    }
                    if (datachon.length == 0) {
                        webix.message("Bạn chưa chọn dòng nào ở trạng thái chờ ký ! ", "error");
                        return;
                    }
                    /*if (selectedItem.trang_thai == 1) {
                        webix.message("Bảng tổng hợp đã gửi CQT không thể xóa ! ", "error");
                        return;
                    }*/

                    var khData = {};

                    khData.editmode = 3;
                    khData.data = datachon;

                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/SaveBangTHDL", khData, function (text) {
                                        var response = JSON.parse(text);

                                        if (response.hasOwnProperty("error")) {
                                            webix.message({ type: "error", text: response.error });
                                            return;
                                        }

                                        // table.remove(item.id);
                                        var btnRefresh = $$("btnRefresh");
                                        btnRefresh.callEvent("onClick");
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-eye fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "In (F7)" + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng in ! ", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);
                    if (selectedItem.lhhoa == 1) {
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLieuXangDau?id=" + selectedItem.id, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    } else {
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLieu_all?id=" + selectedItem.id, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 100,
        //     label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Gửi email") + "</span>",
        //     id: "btnSendEmail",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("bangtonghop");
        //             var selectedItem = table.getSelectedItem();
        //             if (selectedItem == null) {
        //                 webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                 return;
        //             }
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký") + "</span>",
            id: "btnSign",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("bangtonghop");
                    /*var selectedItem = tableDK.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã ký và gửi CQT bạn không thể ký lại! ", "error");
                        return;
                    }*/
                    var datafrm = tableDK.serialize();

                    var data_id = [];
                    var data_id_xd = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true && datafrm[i].trang_thai != 1 && datafrm[i].lhhoa != 1) {
                                    data_id.push(datafrm[i].id);
                                }
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true && datafrm[i].trang_thai != 1 && datafrm[i].lhhoa == 1) {
                                    data_id_xd.push(datafrm[i].id);
                                }
                            }
                        }
                    }
                    if (data_id.length > 0 && data_id_xd.length > 0) {
                        webix.message("Chỉ được chọn các bảng THDL cùng loại hàng hoá để ký!");
                        return;
                    }
                    if (data_id.length > 0 && data_id_xd.length == 0) {
                        webix
                            .ajax()
                            .headers({ "Content-Type": "application/json" })
                            .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                var result = JSON.parse(text);
                                var kytaptrung = "";
                                for (var i = 0; i < result.length; i++) {
                                    var item = result[i];
                                    kytaptrung = item.value;
                                }

                                webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                    var listcerts = JSON.parse(text);
                                    if (listcerts.length > 0) {
                                        var box = webix.modalbox({
                                            title: "Chọn chứng thư số",
                                            buttons: ["Nhận", "Hủy bỏ"],
                                            text: "<div id='ctnCerts'></div>",
                                            top: 100,
                                            width: 750,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "1":
                                                        webix.modalbox.hide();
                                                        break;
                                                    case "0":
                                                        var table = $$("tblCerts");
                                                        var data = table.serialize();
                                                        var cert = null;

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i].chon == true) {
                                                                cert = data[i];
                                                                break;
                                                            }
                                                        }

                                                        if (cert == null) {
                                                            webix.message("Bạn chưa chọn chứng thư số");
                                                            return;
                                                        }

                                                        var now = new Date();
                                                        var begin = new Date(cert.begin_date);
                                                        var end = new Date(cert.end_date);
                                                        if (now < begin || now > end) {
                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                            return;
                                                        }

                                                        var postData = {
                                                            branch_code: user.getDvcsID(),
                                                            username: user.getCurrentUser(),
                                                            cer_serial: cert.cer_serial,
                                                            CheckHSM: "",
                                                            id: data_id,
                                                            loaibth: 3,
                                                        };

                                                        webix.extend(tableDK, webix.ProgressBar);
                                                        tableDK.disable();
                                                        tableDK.showProgress();
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/SignBTHDL", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    if (!json.hasOwnProperty("error")) {
                                                                        webix.message("Ký thành công !", "success");
                                                                        // $$("huyhoadonForms").close();
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    } else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                },
                                                            });
                                                        return;
                                                }
                                            },
                                        });
                                        var tblMatHang = webix.ui({
                                            container: "ctnCerts",
                                            id: "tblCerts",
                                            view: "datatable",
                                            borderless: true,
                                            resizeColumn: true,
                                            height: 350,
                                            columns: [
                                                {
                                                    id: "chon",
                                                    header: _("CHON"),
                                                    width: 65,
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    template: "{common.checkbox()}",
                                                },
                                                {
                                                    id: "cert_type",
                                                    header: _("Loại"),
                                                    width: 100,
                                                },
                                                {
                                                    id: "cer_serial",
                                                    header: _("SO_SERIAL"),
                                                    width: 150,
                                                },
                                                {
                                                    id: "subject_name",
                                                    header: _("SUBJECTNAME"),
                                                    width: 450,
                                                },
                                                {
                                                    id: "begin_date",
                                                    header: _("NGAY_BAT_DAU"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "end_date",
                                                    header: _("NGAY_KET_THUC"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "issuer",
                                                    header: _("DONVI"),
                                                    width: 450,
                                                },
                                            ],
                                            url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                        });
                                    } else {
                                        var table = $$("bangtonghop");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        // xem user có tích checkbox ký HSM không?
                                        var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                        webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                            if (resultscheckSigHSM[0].json() == "C") {
                                                var postData = {
                                                    branch_code: user.getDvcsID(),
                                                    username: user.getCurrentUser(),
                                                    id: data_id,
                                                    CheckHSM: "1",
                                                };

                                                webix.extend(tableDK, webix.ProgressBar);
                                                tableDK.disable();
                                                tableDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/SignBTHDL", postData, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Ký thành công !", "success");
                                                                app.callEvent("dataChangeBangtonghop", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                            } else {
                                                var parameters_list = [];

                                                function excuteHdPlugin(k) {
                                                    if (k < data_id.length) {
                                                        var hdon_id = data_id[k];
                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlBTHDL?id=" + hdon_id);
                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                        webix.promise.all([a, b, hdon_id]).then(function (results) {
                                                            var json = results[0].json();

                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message({ type: "error", text: json.error });
                                                            }

                                                            var listcerts = results[1].json();
                                                            var item = results[2];

                                                            if (listcerts.length == 0) {
                                                                table.enable();
                                                                table.hideProgress();
                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                return;
                                                            }

                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                var hub = plugin.hub();
                                                                var hubconnect = plugin.conn();
                                                                if (hubconnect.state != 1) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                    return;
                                                                }
                                                                hub.off("resCommand");
                                                                hub.on("resCommand", function (result) {
                                                                    var json = JSON.parse(result);

                                                                    if (json.hasOwnProperty("error")) {
                                                                        webix.message({ type: "error", text: json.error });
                                                                    } else {
                                                                        var parameters = {
                                                                            xml: json.xml,
                                                                            id: item,
                                                                            shdon: json.shdon,
                                                                            loaibth: 3,
                                                                        };
                                                                        parameters_list.push(parameters);
                                                                    }
                                                                    k++;
                                                                    excuteHdPlugin(k);
                                                                });

                                                                var _listcerts = [];

                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                    var _cert = listcerts[i];

                                                                    _listcerts.push({
                                                                        so_serial: _cert.cer_serial,
                                                                        ngaybatdau: _cert.begin_date,
                                                                        ngayketthuc: _cert.end_date,
                                                                        issuer: _cert.issuer,
                                                                        subjectname: _cert.subject_name,
                                                                    });
                                                                }

                                                                var arg = {
                                                                    idData: "#data",
                                                                    xml: json["xml"],
                                                                    shdon: json.shdon,
                                                                    idSigner: "seller",
                                                                    tagSign: "TChuc",
                                                                    dateKy: json["dateKy"],
                                                                    listcerts: _listcerts,
                                                                };

                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                    .done(function () {
                                                                        console.log("Success !");
                                                                    })
                                                                    .fail(function (error) {
                                                                        webix.message(error, "error");
                                                                    });
                                                            });
                                                        });
                                                    } else {
                                                        if (parameters_list.length > 0) {
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlBTHDL", JSON.stringify(parameters_list), function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        webix.message("Ký thành công !", "success");
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    }
                                                }

                                                excuteHdPlugin(0);
                                            }
                                        });
                                    }
                                });
                            });
                    } else if (data_id_xd.length > 0 && data_id == 0) {
                        webix
                            .ajax()
                            .headers({ "Content-Type": "application/json" })
                            .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                var result = JSON.parse(text);
                                var kytaptrung = "";
                                for (var i = 0; i < result.length; i++) {
                                    var item = result[i];
                                    kytaptrung = item.value;
                                }

                                webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                    var listcerts = JSON.parse(text);
                                    if (listcerts.length > 0) {
                                        var box = webix.modalbox({
                                            title: "Chọn chứng thư số",
                                            buttons: ["Nhận", "Hủy bỏ"],
                                            text: "<div id='ctnCerts'></div>",
                                            top: 100,
                                            width: 750,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "1":
                                                        webix.modalbox.hide();
                                                        break;
                                                    case "0":
                                                        var table = $$("tblCerts");
                                                        var data = table.serialize();
                                                        var cert = null;

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i].chon == true) {
                                                                cert = data[i];
                                                                break;
                                                            }
                                                        }

                                                        if (cert == null) {
                                                            webix.message("Bạn chưa chọn chứng thư số");
                                                            return;
                                                        }

                                                        var now = new Date();
                                                        var begin = new Date(cert.begin_date);
                                                        var end = new Date(cert.end_date);
                                                        if (now < begin || now > end) {
                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                            return;
                                                        }

                                                        var postData = {
                                                            branch_code: user.getDvcsID(),
                                                            username: user.getCurrentUser(),
                                                            cer_serial: cert.cer_serial,
                                                            /*id: selectedItem.id,*/
                                                            id: data_id_xd,
                                                        };

                                                        webix.extend(tableDK, webix.ProgressBar);
                                                        tableDK.disable();
                                                        tableDK.showProgress();
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/SignBTHDLXangDau", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    if (!json.hasOwnProperty("error")) {
                                                                        webix.message("Ký thành công !", "success");
                                                                        // $$("huyhoadonForms").close();
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    } else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                },
                                                            });
                                                        return;
                                                }
                                            },
                                        });
                                        var tblMatHang = webix.ui({
                                            container: "ctnCerts",
                                            id: "tblCerts",
                                            view: "datatable",
                                            borderless: true,
                                            resizeColumn: true,
                                            height: 350,
                                            columns: [
                                                {
                                                    id: "chon",
                                                    header: _("CHON"),
                                                    width: 65,
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    template: "{common.checkbox()}",
                                                },
                                                {
                                                    id: "cer_serial",
                                                    header: _("SO_SERIAL"),
                                                    width: 150,
                                                },
                                                {
                                                    id: "subject_name",
                                                    header: _("SUBJECTNAME"),
                                                    width: 450,
                                                },
                                                {
                                                    id: "begin_date",
                                                    header: _("NGAY_BAT_DAU"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "end_date",
                                                    header: _("NGAY_KET_THUC"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "issuer",
                                                    header: _("DONVI"),
                                                    width: 450,
                                                },
                                            ],
                                            url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                        });
                                    } else {
                                        var table = $$("bangtonghop");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        // xem user có tích checkbox ký HSM không?
                                        var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                        webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                            if (resultscheckSigHSM[0].json() == "C") {
                                                var postData = {
                                                    branch_code: user.getDvcsID(),
                                                    username: user.getCurrentUser(),
                                                    id: data_id_xd,
                                                    CheckHSM: "1",
                                                };

                                                webix.extend(tableDK, webix.ProgressBar);
                                                tableDK.disable();
                                                tableDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/SignBTHDLXangDau", postData, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Ký thành công !", "success");
                                                                app.callEvent("dataChangeBangtonghop", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                            } else {
                                                var parameters_list = [];

                                                var k = 0; //khai báo biến k để chạy lần lượt từng hoá đơn theo id
                                                function excuteHdPlugin() {
                                                    if (k < data_id_xd.length) {
                                                        var hdon_id = data_id_xd[k];
                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlBTHDLXangDau?id=" + hdon_id);
                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                        webix.promise.all([a, b, hdon_id]).then(function (results) {
                                                            var json = results[0].json();

                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message({ type: "error", text: json.error });
                                                            }

                                                            var listcerts = results[1].json();
                                                            var item = results[2];

                                                            if (listcerts.length == 0) {
                                                                table.enable();
                                                                table.hideProgress();
                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                return;
                                                            }

                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                var hub = plugin.hub();
                                                                var hubconnect = plugin.conn();
                                                                if (hubconnect.state != 1) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                    return;
                                                                }
                                                                hub.off("resCommand");
                                                                hub.on("resCommand", function (result) {
                                                                    var json = JSON.parse(result);

                                                                    if (json.hasOwnProperty("error")) {
                                                                        webix.message({ type: "error", text: json.error });
                                                                    } else {
                                                                        var parameters = {
                                                                            xml: json.xml,
                                                                            id: item,
                                                                            shdon: json.shdon,
                                                                        };
                                                                        parameters_list.push(parameters);
                                                                    }
                                                                    k++;
                                                                    excuteHdPlugin();
                                                                });

                                                                var _listcerts = [];

                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                    var _cert = listcerts[i];

                                                                    _listcerts.push({
                                                                        so_serial: _cert.cer_serial,
                                                                        ngaybatdau: _cert.begin_date,
                                                                        ngayketthuc: _cert.end_date,
                                                                        issuer: _cert.issuer,
                                                                        subjectname: _cert.subject_name,
                                                                    });
                                                                }

                                                                var arg = {
                                                                    idData: "#data",
                                                                    xml: json["xml"],
                                                                    shdon: json.shdon,
                                                                    idSigner: "seller",
                                                                    tagSign: "TChuc",
                                                                    dateKy: json["dateKy"],
                                                                    listcerts: _listcerts,
                                                                };

                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                    .done(function () {
                                                                        console.log("Success !");
                                                                    })
                                                                    .fail(function (error) {
                                                                        webix.message(error, "error");
                                                                    });
                                                            });
                                                        });
                                                    } else {
                                                        if (parameters_list.length > 0) {
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlBTHDLXangDau", JSON.stringify(parameters_list), function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        webix.message("Ký thành công !", "success");
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    }
                                                }

                                                excuteHdPlugin();
                                            }
                                        });
                                    }
                                });
                            });
                    } else {
                        webix.message("Chưa tích chọn bảng hoặc bảng đã ký!");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        /*{
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Lập bổ sung") + "</span>",
            id: "btnUp",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(bangtonghopform.$ui);
                    bangtonghopform.setEditMode(1);
                    detailForm.show();

                    webix.$$("ldau").setValue(0);

                    var url = app.config.host + "/Invoice68/GetInfoCompany";

                    webix.ajax(url, function (text) {
                        var json = JSON.parse(text);
                        webix.$$("tnnt").setValue(json.name);
                        webix.$$("mst").setValue(json.tax_code);
                        webix.$$("dthoai").setValue(json.tel);
                        webix.$$("dchi").setValue(json.address);
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },*/
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải XML") + "</span>",
            id: "btnDownloadXml",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn khách hàng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai != 1) {
                        webix.message("Bảng kê chưa ký không tồn tại xml ! ", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLBangTHDL?id=" + selectedItem.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "BangTHDL.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Export Excel" + "</span>",
            id: "btnExel",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa dòng export ! ", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang export exel ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    if (selectedItem.lhhoa == 1) {
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLieuXangDau?id=" + selectedItem.id + "&type=Excel", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                    webix.modalbox.hide(box);
                                    webix.html.download(file, "bangke.xlsx");
                                },
                            });
                    } else {
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLieu_all?id=" + selectedItem.id + "&type=Excel", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                    webix.modalbox.hide(box);
                                    webix.html.download(file, "bangke.xlsx");
                                },
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "bangtonghop",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {},
                },
                onClick: {
                    DowloadBTHLDRep: function (event, cell, target) {
                        var win = webix.$$("bangtonghop");
                        var record = win.getItem(cell.row);

                        if (record.trang_thai != 1) {
                            webix.message("Mẫu chưa được ký không thể tải !", "error");
                            return;
                        }

                        if (record.xml_nhan == null || record.xml_nhan == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = "KetQuaKiemTraBTHDL.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLBTHDLRep?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();
                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                            });

                        return false;
                    },
                    InBTHDLRep: function (event, cell, target) {
                        var table = webix.$$("bangtonghop");
                        var item = table.getItem(cell.row);

                        if (item.xml_nhan == null || item.xml_nhan == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLRep?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },

                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("bangtonghop");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {},
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "index",
                        header: "STT",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "trang_thai",

                        header: ["Trạng thái"],
                        width: 150,
                        template: function (obj) {
                            return obj.trang_thai == 1
                                ? "<span style='color: #00b300'><i class='fas fa-check'></i></span> Đã ký"
                                : "<span style='color: red'><i class='fas fa-times'></i></span> Chưa ký";
                        },
                    },
                    /*{
                        id: "btnMessagetn",
                        header: ["", "Lịch sử xử lý"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                        },
                        width: 180,
                    },*/
                    {
                        id: "kdlieu",
                        header: [
                            "Kỳ dữ liệu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ngay_ky",
                        header: [
                            "Ngày giờ ký",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },

                    {
                        id: "sbthdlieu",
                        header: [
                            "Số thứ tự bảng",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "nlap",
                        header: [
                            "Ngày lập",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },
                    {
                        id: "nglap",
                        header: [
                            "Người lập",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    // {
                    //     id: "mtdiep_gui",
                    //     header: [
                    //         "Mã thông điệp",
                    //         {
                    //             content: "textFilter",
                    //         },
                    //     ],
                    //     width: 150,
                    // },
                    {
                        id: "ngky",
                        header: [
                            "Người ký",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    /* {
                        id: "ket_qua",
                        header: ["", "Kết quả"],
                        css: { "text-align": "center" },
                        width: 150,
                        template: function (obj) {
                            if (obj.ket_qua == 1) {
                                return "<span style='color: #00b300'>Dữ liệu hợp lệ</span> ";
                            } else {
                                if (obj.ket_qua == 2) {
                                    return "<span style='color: #e83717'>Dữ liệu không hợp lệ</span> ";
                                } else {
                                    return "<span>Chờ phản hồi</span>";
                                }
                            }
                        },
                    },*/
                    /*{
                        id: "bthDowloadBTHLDRep",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.xml_nhan != null && obj.xml_nhan != "") {
                                return "<span class='DowloadBTHLDRep' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='DowloadBTHLDRep' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "btnInBTHDLRep",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.xml_nhan != null && obj.xml_nhan != "") {
                                return "<span class='InBTHDLRep' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InBTHDLRep' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 120,
                    },*/
                    // {
                    //     id: "mtdiepcqt",
                    //     header: ["", "Mã thông điệp CQT"],
                    //     width: 250,
                    // },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("bangtonghop");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("bangtonghop");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangeBangtonghop", function (mode, item) {
                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },

        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_baocao_tinhhinhbienlaiForm',["app", "models/user"], function (app, user) {
    var editmode = 0;

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var getNgay = function () {
        var option = $$("lkdlieu").getValue();
        if (option == "Q") {
            var nam = $$("nam").getValue();
            var thang;
            var quy = $$("thang").getValue();
            if (quy == "1") {
                thang = 0;
            } else if (quy == "2") {
                thang = 3;
            } else if (quy == "3") {
                thang = 6;
            } else if (quy == "4") {
                thang = 9;
            }
            var firstDate = new Date(nam, thang, 1);
            var lastDate = new Date(nam, thang + 3, 0);

            $$("tu_ngay").setValue(firstDate);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(lastDate);
            $$("den_ngay").refresh();
        } else if (option == "T") {
            var year = $$("nam").getValue();
            var month = $$("thang").getValue();
            var date1 = month + "/01" + "/" + year;

            var date = new Date(date1);
            var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

            var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            $$("tu_ngay").setValue(firstDay1);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(lastDay1);
            $$("den_ngay").refresh();
        } else if (option == "N") {
            var year = $$("nam").getValue();
            var month = $$("thang").getValue();
            var day = $$("ngay").getValue();
            var date1 = month + "/" + day + "/" + year;

            var date = new Date(date1);

            $$("tu_ngay").setValue(date);
            $$("tu_ngay").refresh();
            $$("den_ngay").setValue(date);
            $$("den_ngay").refresh();
        }

        var tableDetail = webix.$$("danhsach_hoadon");
        tableDetail.clearAll();
    };

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Lưu tạm (F10)",
            id: "btnBTHSave",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var tableHoadon = $$("bangtonghop-form");

                    if (tableHoadon.validate()) {
                        var ds_hdon = $$("danhsach_hoadon").serialize();

                        if (ds_hdon.length == 0) {
                            webix.message("Bạn chưa nhập chi tiết biên lai", "error");
                            return;
                        } else {
                            webix.extend(tableHoadon, webix.ProgressBar);
                            tableHoadon.disable();
                            tableHoadon.showProgress();
                            // console.log(data_post);
                            var limit = 1000;
                            var m = parseInt(ds_hdon.length / limit);
                            if (ds_hdon.length > m * limit) m = m + 1;
                            var apiIndex = 0;
                            var item = $$("bangtonghop-form").getValues();
                            item["loaibth"] = 2;
                            for (var k = 0; k < m; k++) {
                                if (k < m - 1) {
                                    item["details"] = ds_hdon.slice(k * limit, (k + 1) * limit);
                                } else {
                                    item["details"] = ds_hdon.slice(k * limit, ds_hdon.length);
                                }
                                var item1 = [];
                                item1.push(item);
                                var data_post = { editmode: editmode, data: item1 };
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/SaveBaoCaoTHBienLai", data_post, {
                                        error: function (text, data, XmlHttpRequest) {
                                            tableHoadon.enable();
                                            tableHoadon.hideProgress();
                                            // var json = JSON.parse(text);
                                            // webix.message(json.ExceptionMessage, "error");
                                            webix.message(text + XmlHttpRequest, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var json = JSON.parse(text);
                                            tableHoadon.enable();
                                            tableHoadon.hideProgress();
                                            if (!json.hasOwnProperty("error")) {
                                                webix.$$("bangtonghop-win").close();
                                                app.callEvent("dataChangeBangtonghop", [1, null]);
                                            } else {
                                                webix.message(json.error, "error");
                                            }
                                        },
                                    });
                            }
                        }
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            shortcut: "F11",
            id: "btnBTHSend",
            view: "button",
            label: "Ký gửi CQT",
            type: "form",
            align: "center",
            width: 150,
            on: {
                onClick: function () {
                    var tableHoadon = $$("bangtonghop-form");

                    if (!tableHoadon.validate()) {
                        webix.message("Dữ liệu biểu mẫu không hợp lệ", "error");
                        return;
                    }

                    var ds_hdon = $$("danhsach_hoadon").serialize();

                    if (ds_hdon.length === 0) {
                        webix.message("Bạn chưa chọn biên lai nào", "error");
                        return;
                    }

                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .get(app.config.host + "/Invoice68/GetSignType", function (text, data, XmlHttpRequest) {
                            try {
                                var result = JSON.parse(text);
                                var kytaptrung = result.length > 0 ? result[0].value : "";

                                webix
                                    .ajax()
                                    .get(app.config.host + "/Invoice68/GetListCertificatesFile68")
                                    .then(function (response) {
                                        var listcerts = response.json();

                                        if (!listcerts || listcerts.length === 0) {
                                            //webix.message("Không tìm thấy chứng thư số nào", "error");
                                            proceedWithHSMOrPlugin();
                                            return;
                                        }

                                        // Modal box for certificate selection
                                        var box = webix.modalbox({
                                            title: "Chọn chứng thư số",
                                            buttons: ["Nhận", "Hủy bỏ"],
                                            text: "<div id='ctnCerts' style='width:100%;height:350px;'></div>",
                                            top: 100,
                                            width: 750,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "1":
                                                        webix.modalbox.hide();
                                                        break;
                                                    case "0":
                                                        var table = $$("tblCerts");
                                                        var data = table.serialize();
                                                        var cert = null;

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i].chon === true) {
                                                                cert = data[i];
                                                                break;
                                                            }
                                                        }

                                                        if (!cert) {
                                                            webix.message("Bạn chưa chọn chứng thư số", "error");
                                                            return;
                                                        }

                                                        var now = new Date();
                                                        var begin = new Date(cert.begin_date);
                                                        var end = new Date(cert.end_date);
                                                        if (now < begin || now > end) {
                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                            return;
                                                        }

                                                        luuTamBaoCao(function (mauId) {
                                                            if (!mauId) {
                                                                webix.message("Lưu tạm báo cáo thất bại", "error");
                                                                return;
                                                            }

                                                            var postData = {
                                                                branch_code: user.getDvcsID(),
                                                                username: user.getCurrentUser(),
                                                                cer_serial: cert.cer_serial,
                                                                CheckHSM: "",
                                                                id: mauId,
                                                                loaibth: 2,
                                                            };

                                                            webix.extend(tableHoadon, webix.ProgressBar);
                                                            tableHoadon.disable();
                                                            tableHoadon.showProgress();
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SignBaoCaoTHBienlai", postData, {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        tableHoadon.enable();
                                                                        tableHoadon.hideProgress();
                                                                        webix.message("Lỗi khi ký báo cáo: " + text, "error");
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var json = JSON.parse(text);
                                                                        if (!json.hasOwnProperty("error")) {
                                                                            //webix.$$("bangtonghop-win").close();
                                                                            webix.message("Ký và gửi thành công!", "success");

                                                                            app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                        } else {
                                                                            webix.message(json.error, "error");
                                                                        }
                                                                        tableHoadon.enable();
                                                                        tableHoadon.hideProgress();
                                                                    },
                                                                });
                                                        });
                                                        return;
                                                }
                                            },
                                        });

                                        // Certificate table mimicking danhsach_hoadon behavior
                                        webix.ui({
                                            container: "ctnCerts",
                                            id: "tblCerts",
                                            view: "datatable",
                                            borderless: true,
                                            resizeColumn: true,
                                            height: 350,
                                            columns: [
                                                {
                                                    id: "chon",
                                                    header: { content: "masterCheckbox", contentId: "chkMasterCerts" },
                                                    template: "{common.checkbox()}",
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    width: 65,
                                                    css: { "text-align": "center" },
                                                },
                                                {
                                                    id: "cert_type",
                                                    header: "Loại",
                                                    width: 100,
                                                    css: { "text-align": "center" },
                                                },
                                                {
                                                    id: "cer_serial",
                                                    header: "Số serial",
                                                    width: 150,
                                                    css: { "text-align": "center" },
                                                },
                                                {
                                                    id: "subject_name",
                                                    header: "Tên chủ thể",
                                                    width: 450,
                                                    css: { "text-align": "center" },
                                                },
                                                {
                                                    id: "begin_date",
                                                    header: "Ngày bắt đầu",
                                                    width: 200,
                                                    css: { "text-align": "center" },
                                                },
                                                {
                                                    id: "end_date",
                                                    header: "Ngày kết thúc",
                                                    width: 200,
                                                    css: { "text-align": "center" },
                                                },
                                                {
                                                    id: "issuer",
                                                    header: "Đơn vị cấp",
                                                    width: 450,
                                                    css: { "text-align": "center" },
                                                },
                                            ],
                                            data: listcerts, // Load data directly
                                            scheme: {
                                                $init: function (obj) {
                                                    obj.chon = false;
                                                },
                                            },
                                            on: {
                                                onStoreUpdated: function () {
                                                    this.data.each(function (obj, i) {
                                                        obj.stt = i + 1;
                                                    });
                                                },
                                                onAfterLoad: function () {
                                                    this.adjust();
                                                    this.refresh();
                                                },
                                            },
                                        });
                                    })
                                    .fail(function (err) {
                                        //webix.message("Lỗi khi lấy danh sách chứng thư số: " + err.message, "error");
                                        proceedWithHSMOrPlugin();
                                    });
                            } catch (e) {
                                //webix.message("Lỗi khi lấy loại ký: " + e.message, "error");
                                proceedWithHSMOrPlugin();
                            }
                        });

                    // Original HSM/plugin signing logic
                    function proceedWithHSMOrPlugin() {
                        var table = $$("bangtonghop-win");
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();

                        luuTamBaoCao(function (mauId) {
                            if (!mauId) {
                                table.enable();
                                table.hideProgress();
                                webix.message("Lưu tạm báo cáo thất bại", "error");
                                return;
                            }

                            webix.ajax().get(app.config.host + "/Account/GetInfoUserLogin").then(function (response) {
                                if (response.json() === "C") {
                                    var postData = {
                                        branch_code: user.getDvcsID(),
                                        username: user.getCurrentUser(),
                                        id: mauId,
                                        CheckHSM: "1",
                                        loaibth: 2,
                                    };

                                    var tableDK = $$("bangtonghop-win");
                                    webix.extend(tableDK, webix.ProgressBar);
                                    tableDK.disable();
                                    tableDK.showProgress();
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Invoice68/SignBaoCaoTHBienlai", postData, {
                                            error: function (text, data, XmlHttpRequest) {
                                                tableDK.enable();
                                                tableDK.hideProgress();
                                                webix.message("Lỗi khi ký HSM: " + text, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var json = JSON.parse(text);
                                                tableDK.enable();
                                                tableDK.hideProgress();
                                                if (!json.hasOwnProperty("error")) {
                                                    webix.message("Gửi thành công đến CQT!", "success");
                                                    app.callEvent("dataChangeBangtonghop", [1, null]);
                                                } else {
                                                    webix.message(json.error, "error");
                                                }
                                            },
                                        });
                                } else {
                                    var parameters_list = [];

                                    function excuteHdPlugin() {

                                        var hdon_id = mauId;
                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlTHSDBienLai?id=" + hdon_id);
                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                        webix.promise.all([a, b, hdon_id]).then(function (results) {
                                            var json = results[0].json();

                                            if (json.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: json.error });
                                                table.enable();
                                                table.hideProgress();
                                                return;
                                            }

                                            var listcerts = results[1].json();
                                            var item = results[2];

                                            if (listcerts.length === 0) {
                                                table.enable();
                                                table.hideProgress();
                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                return;
                                            }

                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                var hub = plugin.hub();
                                                var hubconnect = plugin.conn();
                                                if (hubconnect.state !== 1) {
                                                    table.enable();
                                                    table.hideProgress();
                                                    webix.message("Quý khách hàng chưa cài Plugin ký Biên lai hoặc Plugin ký Biên lai chưa được bật!", "error");
                                                    return;
                                                }
                                                hub.off("resCommand");
                                                hub.on("resCommand", function (result) {
                                                    var json = JSON.parse(result);

                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: json.error });
                                                    } else {
                                                        var parameters = {
                                                            xml: json.xml,
                                                            id: item,
                                                            shdon: json.shdon,
                                                        };
                                                        
                                                        parameters_list.push(parameters);
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/SaveXmlTHSDBienLai", JSON.stringify(parameters_list), function (text) {
                                                                var result = JSON.parse(text);
                                                                if (result.hasOwnProperty("error")) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    webix.message(result.error, "error");
                                                                } else {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    webix.message("Gửi thành công đến CQT!", "success");
                                                                    app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                }
                                                            });
                                                    }
                                                });

                                                var _listcerts = [];
                                                for (var i = 0; i < listcerts.length; i++) {
                                                    var _cert = listcerts[i];
                                                    _listcerts.push({
                                                        so_serial: _cert.cer_serial,
                                                        ngaybatdau: _cert.begin_date,
                                                        ngayketthuc: _cert.end_date,
                                                        issuer: _cert.issuer,
                                                        subjectname: _cert.subject_name,
                                                    });
                                                }

                                                var arg = {
                                                    idData: "#data",
                                                    xml: json["xml"],
                                                    shdon: json.shdon,
                                                    idSigner: "seller",
                                                    tagSign: "TCTTPLPhi",
                                                    dateKy: json["dateKy"],
                                                    listcerts: _listcerts,
                                                };

                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                    .done(function () {
                                                        console.log("Success!");
                                                    })
                                                    .fail(function (error) {
                                                        webix.message(error, "error");
                                                    });
                                            });
                                        });



                                    }

                                    excuteHdPlugin();
                                }
                            }).fail(function (err) {
                                table.enable();
                                table.hideProgress();
                                webix.message("Lỗi khi kiểm tra thông tin người dùng: " + err, "error");
                            });
                        });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Quay lại (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("bangtonghop-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        fullscreen: true,
        id: "bangtonghop-win",
        position: "center",
        head: "BÁO CÁO TÌNH HÌNH SỬ DỤNG DỮ LIỆU BIÊN LAI ĐIỆN TỬ",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 1500,
            id: "bangtonghop-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    rows: [
                        {
                            cols: [
                                { width: 200 },
                                {
                                    view: "label",
                                    label: "[01] Kỳ dữ liệu",
                                    width: 170,
                                },
                                {
                                    id: "lkdlieu",
                                    name: "lkdlieu",
                                    view: "combo",
                                    width: 120,
                                    value: "Q",
                                    options: [
                                        { id: "T", value: "Tháng" },
                                        { id: "Q", value: "Quý" }
                                    ],
                                    on: {
                                        onChange: function (newv, oldv) {
                                            if (newv == "N") {
                                                var k = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 60);
                                                $$("thang").refresh();
                                                $$("ngay").show();
                                                $$("ngay").refresh();
                                            }
                                            if (newv == "T") {
                                                var k = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 120);
                                                $$("thang").refresh();
                                                $$("ngay").hide();
                                                $$("ngay").refresh();
                                            }
                                            if (newv == "Q") {
                                                var k = ["1", "2", "3", "4"];
                                                $$("thang").define("options", k);
                                                $$("thang").define("width", 120);
                                                $$("thang").refresh();
                                                $$("ngay").hide();
                                                $$("ngay").refresh();
                                            }

                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "ngay",
                                    name: "ngay",
                                    view: "combo",
                                    width: 60,
                                    value: "1",
                                    hidden: true,
                                    options: [
                                        "1",
                                        "2",
                                        "3",
                                        "4",
                                        "5",
                                        "6",
                                        "7",
                                        "8",
                                        "9",
                                        "10",
                                        "11",
                                        "12",
                                        "13",
                                        "14",
                                        "15",
                                        "16",
                                        "17",
                                        "18",
                                        "19",
                                        "20",
                                        "21",
                                        "22",
                                        "23",
                                        "24",
                                        "25",
                                        "26",
                                        "27",
                                        "28",
                                        "29",
                                        "30",
                                        "31",
                                    ],
                                    required: true,
                                    invalidMessage: "Tháng/Quý không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "thang",
                                    name: "thang",
                                    view: "combo",
                                    width: 120,
                                    value: "1",
                                    options: ["1", "2", "3", "4"],
                                    required: true,
                                    invalidMessage: "Tháng/Quý không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                {
                                    id: "nam",
                                    name: "nam",
                                    view: "text",
                                    label: "Năm",
                                    labelWidth: 50,
                                    width: 120,
                                    value: new Date().getFullYear(),
                                    required: true,
                                    invalidMessage: "Năm không được để trống !",
                                    on: {
                                        onChange: function () {
                                            getNgay();
                                        },
                                    },
                                },
                                { id: "tu_ngay", name: "tu_ngay", view: "datepicker", label: "Từ ngày", hidden: true, width: 200, labelWidth: 100 },
                                { id: "den_ngay", name: "den_ngay", view: "datepicker", label: "Đến ngày:", hidden: true, labelWidth: 100, width: 260 },
                                {},
                            ],
                        },
                        {
                            cols: [
                                { width: 200 },
                                {
                                    id: "tnnt",
                                    name: "tnnt",
                                    view: "text",
                                    label: "[02] Tên người nộp thuế:",
                                    labelWidth: 170,
                                    width: 410,
                                    required: true,
                                    invalidMessage: "Tên người nộp thuế không được để trống !",
                                    readonly: true,
                                },
                                {
                                    id: "mst",
                                    name: "mst",
                                    view: "text",
                                    label: "[03] Mã số thuế:",
                                    labelWidth: 130,
                                    width: 380,
                                    readonly: true,
                                    required: true,
                                    invalidMessage: "Mã số thuế không được để trống !",
                                },
                                { id: "nlap", name: "nlap", view: "datepicker", label: "Ngày lập", width: 190, labelWidth: 70, value: new Date() },
                                { id: "sbthdlieu", name: "sbthdlieu", view: "text", label: "Số:", labelWidth: 50, width: 200, readonly: true },
                                {},
                            ],
                        },
                        {
                            cols: [
                                { width: 200 },
                                {
                                    id: "dchi",
                                    name: "dchi",
                                    view: "text",
                                    label: "[04] Địa chỉ:",
                                    labelWidth: 130,
                                    width: 900,
                                    invalidMessage: "Mã số thuế không được để trống !",
                                }
                            ],
                        },

                        /*{
                            id: "lhhoa",
                            name: "lhhoa",
                            view: "text",
                            label: "Loại mẫu:",
                            labelWidth: 130,
                            width: 380,
                            view: "combo",
                            value: "10",
                            options: [
                                { id: "10", value: "Mẫu BC26BLĐT" },
                                { id: "11", value: "Mẫu  BC26BLG" },
                            ],
                            on: {
                                onChange: function () {
                                    var loaiHangHoa = $$("lhhoa").getValue();
                                    if (loaiHangHoa === "1") {
                                        $$("lkdlieu").setValue("N");
                                        $$("lkdlieu").disable();
                                        $$("danhsach_hoadon").clearAll();
                                        $$("tgtcthue").setValue("");
                                        $$("tgtthue").setValue("");
                                        $$("tgtttoan").setValue("");
                                    } else {
                                        $$("lkdlieu").setValue("T");
                                        $$("lkdlieu").enable();
                                        $$("danhsach_hoadon").clearAll();
                                        $$("tgtcthue").setValue("");
                                        $$("tgtthue").setValue("");
                                        $$("tgtttoan").setValue("");
                                    }
                                },
                            },
                        },*/
                    ],
                },
                {
                    rows: [
                        {
                            cols: [
                                {
                                    view: "button",
                                    label: "Lấy thông tin biên lai",
                                    id: "btnAllHoaDon",
                                    width: 150,
                                    on: {
                                        onItemClick: function (id, e) {
                                            var tableHoadon = $$("bangtonghop-form");
                                            if (tableHoadon.validate()) {
                                                webix.confirm({
                                                    text: "Tự động lập bản báo cáo theo kì",
                                                    ok: "Có",
                                                    cancel: "Không",
                                                    callback: function (res) {
                                                        if (res) {
                                                            var params = $$("bangtonghop-form").getValues();
                                                            params["loaibth"] = 2;
                                                            var tableHoadon = webix.$$("danhsach_hoadon");
                                                            if (tableHoadon.validate()) {
                                                                webix.extend($$("bangtonghop-form"), webix.ProgressBar);
                                                                $$("bangtonghop-form").disable();
                                                                $$("bangtonghop-form").showProgress();
                                                                webix
                                                                    .ajax()
                                                                    .headers({ "Content-type": "application/json" })
                                                                    .post(app.config.host + "/Invoice68/GetThongTinBienLai", params, {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            $$("bangtonghop-form").enable();
                                                                            $$("bangtonghop-form").hideProgress();
                                                                            webix.message(text, "error");
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var json = JSON.parse(text);
                                                                            if (!json.hasOwnProperty("error")) {
                                                                                //console.log(json);
                                                                                tableHoadon.clearAll();
                                                                                tableHoadon.parse(json);

                                                                                tableHoadon.refresh();
                                                                            } else {
                                                                                webix.message(json.error, "error");
                                                                            }
                                                                            $$("bangtonghop-form").enable();
                                                                            $$("bangtonghop-form").hideProgress();
                                                                        },
                                                                    });
                                                            }
                                                        }
                                                    },
                                                });
                                            }
                                        },
                                    },
                                },
                                {
                                    view: "button",
                                    label: "Xóa",
                                    id: "btnXoaHoaDon",
                                    width: 120,
                                    on: {
                                        onItemClick: function () {
                                            var table = $$("danhsach_hoadon");
                                            table.editStop();
                                            var item = table.getSelectedItem();
                                            table.remove(item.id);
                                            table.refresh();
                                            return;

                                            if (checkedItems.length > 0) {
                                                checkedItems.forEach(function (item) {
                                                    if (table.exists(item.id)) {
                                                        table.remove(item.id);
                                                    }
                                                });
                                            } else {
                                                var selected = table.getSelectedItem();
                                                if (!selected) {
                                                    webix.message("Vui lòng chọn ít nhất một dòng để xoá", "error");
                                                    return;
                                                }
                                                table.remove(selected.id);
                                            }
                                        }

                                    }

                                },
                            ],
                        },
                        {
                            view: "datatable",
                            id: "danhsach_hoadon",
                            name: "danhsach_hoadon",
                            select: true,
                            scroll: true,
                            resizeColumn: true,
                            editable: false,
                            tooltip: true,
                            css: "webix_header_border webix_data_border",
                            scheme: {
                                $init: function (obj) { },
                            },
                            on: {
                                onStoreUpdated: function () {
                                    this.data.each(function (obj, i) {
                                        obj.stt = i + 1;
                                    });
                                },
                            },
                            columns: [
                                {
                                    id: "stt",
                                    name: "stt",
                                    header: "STT",
                                    width: 80,
                                    position: "center",
                                },
                                {
                                    id: "thdon",
                                    name: "thdon",
                                    header: "Tên loại biên lai",
                                    width: 300,
                                    position: "center",
                                },
                                {
                                    id: "khms",
                                    name: "khms",
                                    header: "Ký hiệu mẫu số biên lai",
                                    width: 300,
                                    position: "center",
                                },
                                {
                                    id: "khieu",
                                    name: "khieu",
                                    header: "Ký hiệu biên lai",
                                    width: 300,
                                    position: "center",
                                },
                                {
                                    id: "sluong",
                                    name: "sluong",
                                    header: "Số biên lai sử dụng trong kỳ",
                                    width: 300,
                                    position: "center",
                                    css: { "text-align": "center" }
                                },
                                {
                                    id: "tgtien",
                                    name: "tgtien",
                                    header: "Tổng tiền thuê, phí, lệ phí trong kỳ",
                                    width: 300,
                                    position: "center",
                                    css: { "text-align": "center" }
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };




    function luuTamBaoCao(callback) {
        var tableHoadon = $$("bangtonghop-form");

        if (tableHoadon.validate()) {
            var ds_hdon = $$("danhsach_hoadon").serialize();

            if (ds_hdon.length == 0) {
                webix.message("Bạn chưa nhập chi tiết biên lai", "error");
                return;
            }

            webix.extend(tableHoadon, webix.ProgressBar);
            tableHoadon.disable();
            tableHoadon.showProgress();

            var limit = 1000;
            var m = parseInt(ds_hdon.length / limit);
            if (ds_hdon.length > m * limit) m = m + 1;

            var item = $$("bangtonghop-form").getValues();
            item["loaibth"] = 2;

            var data_post;
            var lastId = null;

            for (var k = 0; k < m; k++) {
                item["details"] = ds_hdon.slice(k * limit, (k + 1) * limit);
                data_post = { editmode: editmode, data: [item] };

                webix.ajax()
                    .headers({ "Content-type": "application/json" })
                    .post(app.config.host + "/Invoice68/SaveBaoCaoTHBienLai", data_post)
                    .then(function (response) {
                        tableHoadon.enable();
                        tableHoadon.hideProgress();
                        var json = response.json();
                        if (!json.hasOwnProperty("error")) {
                            if (typeof callback === "function") callback(json.id); // <<== trả id ở đây
                            webix.$$("bangtonghop-win").close();
                        } else {
                            webix.message(json.error, "error");
                        }
                    })
                    .fail(function (err) {
                        tableHoadon.enable();
                        tableHoadon.hideProgress();
                        webix.message(err, "error");
                    });

                break; // chỉ chạy 1 lần vì bạn muốn lấy 1 id
            }
        }
    }




    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
            getNgay();
        },
        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            item["nlap"] = removeTimeZoneT(item["nlap"]);
            form.setValues(item);
            getNgay();
            //$$("tgtcthue").setValue(fm(item.tgtcthue));
            //$$("tgtthue").setValue(fm(item.tgtthue));
            //$$("tgtttoan").setValue(fm(item.tgtttoan));

            var tableDetail = webix.$$("danhsach_hoadon");

            var url = app.config.host + "/Invoice68/GetDataTHSuDungBienLaiLDetail_bienlai?id=" + item.id;
            tableDetail.clearAll();
            tableDetail.load(url).then(function () {
                tableDetail.data.each(function (item) {
                    item.checked = false;
                });
                tableDetail.refresh();
            });

        },
    };
});

define('views/68_baocao_tinhhinhbienlai',["app", "locale", "models/user", "views/forms/68_baocao_tinhhinhbienlaiForm", "views/forms/68_bangdanhsachhoadon", "views/forms/68_hoadon_history"], function (
    app,
    _,
    user,
    bangtonghopform,
    bangdanhsachhoadon,
    hoadonHistory
) {
    

    var initUI = function () {
        var table = webix.$$("bangtonghop");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetBangTHDL";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                                filterType: column.header[1].content,
                            };


                            if (item.value != null && item.value != "") {
                                array.push(item);
                            }
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                url = url + "&loaibth=2";
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(bangtonghopform.$ui);
                    bangtonghopform.setEditMode(1);
                    detailForm.show();

                    var url = app.config.host + "/Invoice68/GetInfoCompany";

                    webix.ajax(url, function (text) {
                        var json = JSON.parse(text);
                        webix.$$("tnnt").setValue(json.name);
                        webix.$$("mst").setValue(json.tax_code);
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng nào ! ", "error");
                        return;
                    }

                    var detailForm = this.$scope.ui(bangtonghopform.$ui);
                    bangtonghopform.setEditMode(2);
                    bangtonghopform.setValues(selectedItem);
                    if (selectedItem.trang_thai == 1) {
                        var form = $$("bangtonghop-form").elements;
                        for (var key in form) {
                            var $el = form[key];
                            $el.define("readonly", "true");
                            $el.define("css", "mcls_readonly_text");
                            $el.refresh();
                        }

                        $$("btnBTHSave").destructor();
                        //$$("btnTaiHoaDon").destructor();
                        $$("btnXoaHoaDon").destructor();
                        $$("btnBTHSend").destructor();

                    }
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var databth = table.serialize();
                    var datachon = [];

                    for (var i = 0; i < databth.length; i++) {
                        if (databth[i] != undefined && databth[i].chon === true && databth[i].trang_thai === "0") {
                            datachon.push(databth[i]);
                        }
                    }
                    if (datachon.length == 0) {
                        webix.message("Bạn chưa chọn dòng nào ở trạng thái chờ ký ! ", "error");
                        return;
                    }
                    /*if (selectedItem.trang_thai == 1) {
                        webix.message("Bảng tổng hợp đã gửi CQT không thể xóa ! ", "error");
                        return;
                    }*/

                    var khData = {};

                    khData.editmode = 3;
                    khData.data = datachon;

                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/SaveBangTHDL", khData, function (text) {
                                        var response = JSON.parse(text);

                                        if (response.hasOwnProperty("error")) {
                                            webix.message({ type: "error", text: response.error });
                                            return;
                                        }

                                        // table.remove(item.id);
                                        var btnRefresh = $$("btnRefresh");
                                        btnRefresh.callEvent("onClick");
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-eye fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "In (F7)" + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng in ! ", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang in Biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);
                    if (selectedItem.lhhoa == 1) {
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLieuXangDau?id=" + selectedItem.id, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    } else {
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLieu_bc26?id=" + selectedItem.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký gửi CQT") + "</span>",
            id: "btnSign",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("bangtonghop");
                    /*var selectedItem = tableDK.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã ký và gửi CQT bạn không thể ký lại! ", "error");
                        return;
                    }*/
                    var datafrm = tableDK.serialize();

                    var data_id = [];
                    var data_id_xd = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true && datafrm[i].trang_thai != 1 && datafrm[i].lhhoa != 1) {
                                    data_id.push(datafrm[i].id);
                                }
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true && datafrm[i].trang_thai != 1 && datafrm[i].lhhoa == 1) {
                                    data_id_xd.push(datafrm[i].id);
                                }
                            }
                        }
                    }
                    if (data_id.length > 0 && data_id_xd.length > 0) {
                        webix.message("Chỉ được chọn các bảng THDL cùng loại hàng hoá để ký!");
                        return;
                    }
                    if (data_id.length > 0 && data_id_xd.length == 0) {
                        webix
                            .ajax()
                            .headers({ "Content-Type": "application/json" })
                            .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                var result = JSON.parse(text);
                                var kytaptrung = "";
                                for (var i = 0; i < result.length; i++) {
                                    var item = result[i];
                                    kytaptrung = item.value;
                                }

                                webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                    var listcerts = JSON.parse(text);
                                    if (listcerts.length > 0) {
                                        var box = webix.modalbox({
                                            title: "Chọn chứng thư số",
                                            buttons: ["Nhận", "Hủy bỏ"],
                                            text: "<div id='ctnCerts'></div>",
                                            top: 100,
                                            width: 750,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "1":
                                                        webix.modalbox.hide();
                                                        break;
                                                    case "0":
                                                        var table = $$("tblCerts");
                                                        var data = table.serialize();
                                                        var cert = null;

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i].chon == true) {
                                                                cert = data[i];
                                                                break;
                                                            }
                                                        }

                                                        if (cert == null) {
                                                            webix.message("Bạn chưa chọn chứng thư số");
                                                            return;
                                                        }

                                                        var now = new Date();
                                                        var begin = new Date(cert.begin_date);
                                                        var end = new Date(cert.end_date);
                                                        if (now < begin || now > end) {
                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                            return;
                                                        }

                                                        var postData = {
                                                            branch_code: user.getDvcsID(),
                                                            username: user.getCurrentUser(),
                                                            cer_serial: cert.cer_serial,
                                                            CheckHSM: "",
                                                            id: data_id,
                                                            loaibth: 2,
                                                        };

                                                        webix.extend(tableDK, webix.ProgressBar);
                                                        tableDK.disable();
                                                        tableDK.showProgress();
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/SignBaoCaoTHBienlai", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    if (!json.hasOwnProperty("error")) {
                                                                        webix.message("Ký thành công thông báo phát hành!", "success");
                                                                        // $$("huyhoadonForms").close();
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    } else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                },
                                                            });
                                                        return;
                                                }
                                            },
                                        });
                                        var tblMatHang = webix.ui({
                                            container: "ctnCerts",
                                            id: "tblCerts",
                                            view: "datatable",
                                            borderless: true,
                                            resizeColumn: true,
                                            height: 350,
                                            columns: [
                                                {
                                                    id: "chon",
                                                    header: _("CHON"),
                                                    width: 65,
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    template: "{common.checkbox()}",
                                                },
                                                {
                                                    id: "cert_type",
                                                    header: _("Loại"),
                                                    width: 100,
                                                },
                                                {
                                                    id: "cer_serial",
                                                    header: _("SO_SERIAL"),
                                                    width: 150,
                                                },
                                                {
                                                    id: "subject_name",
                                                    header: _("SUBJECTNAME"),
                                                    width: 450,
                                                },
                                                {
                                                    id: "begin_date",
                                                    header: _("NGAY_BAT_DAU"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "end_date",
                                                    header: _("NGAY_KET_THUC"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "issuer",
                                                    header: _("DONVI"),
                                                    width: 450,
                                                },
                                            ],
                                            url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                        });
                                    } else {
                                        var table = $$("bangtonghop");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        // xem user có tích checkbox ký HSM không?
                                        var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                        webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                            if (resultscheckSigHSM[0].json() == "C") {
                                                var postData = {
                                                    branch_code: user.getDvcsID(),
                                                    username: user.getCurrentUser(),
                                                    id: data_id,
                                                    CheckHSM: "1",
                                                    loaibth: 2,
                                                };

                                                webix.extend(tableDK, webix.ProgressBar);
                                                tableDK.disable();
                                                tableDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/SignBaoCaoTHBienlai", postData, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                app.callEvent("dataChangeBangtonghop", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                            } else {
                                                var parameters_list = [];

                                                function excuteHdPlugin(k) {
                                                    if (k < data_id.length) {
                                                        var hdon_id = data_id[k];
                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlTHSDBienLai?id=" + hdon_id);
                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                        webix.promise.all([a, b, hdon_id]).then(function (results) {
                                                            var json = results[0].json();

                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message({ type: "error", text: json.error });
                                                            }

                                                            var listcerts = results[1].json();
                                                            var item = results[2];

                                                            if (listcerts.length == 0) {
                                                                table.enable();
                                                                table.hideProgress();
                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                return;
                                                            }

                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                var hub = plugin.hub();
                                                                var hubconnect = plugin.conn();
                                                                if (hubconnect.state != 1) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    webix.message("Quý khách hàng chưa cài Plugin ký Biên lai hoặc Plugin ký Biên lai chưa được bật !", "error");
                                                                    return;
                                                                }
                                                                hub.off("resCommand");
                                                                hub.on("resCommand", function (result) {
                                                                    var json = JSON.parse(result);

                                                                    if (json.hasOwnProperty("error")) {
                                                                        webix.message({ type: "error", text: json.error });
                                                                    } else {
                                                                        var parameters = {
                                                                            xml: json.xml,
                                                                            id: item,
                                                                            shdon: json.shdon,
                                                                        };
                                                                        parameters_list.push(parameters);
                                                                    }
                                                                    k++;
                                                                    excuteHdPlugin(k);
                                                                });

                                                                var _listcerts = [];

                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                    var _cert = listcerts[i];

                                                                    _listcerts.push({
                                                                        so_serial: _cert.cer_serial,
                                                                        ngaybatdau: _cert.begin_date,
                                                                        ngayketthuc: _cert.end_date,
                                                                        issuer: _cert.issuer,
                                                                        subjectname: _cert.subject_name,
                                                                    });
                                                                }

                                                                var arg = {
                                                                    idData: "#data",
                                                                    xml: json["xml"],
                                                                    shdon: json.shdon,
                                                                    idSigner: "seller",
                                                                    tagSign: "TCTTPLPhi",
                                                                    dateKy: json["dateKy"],
                                                                    listcerts: _listcerts,
                                                                };

                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                    .done(function () {
                                                                        console.log("Success !");
                                                                    })
                                                                    .fail(function (error) {
                                                                        webix.message(error, "error");
                                                                    });
                                                            });
                                                        });
                                                    } else {
                                                        if (parameters_list.length > 0) {
                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlTHSDBienLai", JSON.stringify(parameters_list), function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                        app.callEvent("dataChangeBangtonghop", [1, null]);
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    }
                                                }

                                                excuteHdPlugin(0);
                                            }
                                        });
                                    }
                                });
                            });
                    } else {
                        webix.message("Chưa tích chọn bảng hoặc bảng đã ký!");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 120,
        //     label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Lập bổ sung") + "</span>",
        //     id: "btnUp",
        //     on: {
        //         onClick: function () {
        //             var detailForm = this.$scope.ui(bangtonghopform.$ui);
        //             bangtonghopform.setEditMode(1);
        //             detailForm.show();

        //             webix.$$("ldau").setValue(0);

        //             var url = app.config.host + "/Invoice68/GetInfoCompany";

        //             webix.ajax(url, function (text) {
        //                 var json = JSON.parse(text);
        //                 webix.$$("tnnt").setValue(json.name);
        //                 webix.$$("mst").setValue(json.tax_code);
        //             });
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải XML") + "</span>",
            id: "btnDownloadXml",
            on: {
                onClick: function () {
                    var table = webix.$$("bangtonghop");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai != 1) {
                        webix.message("Bảng tổng hợp chưa gửi CQT không tồn tại xml ! ", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLBangTHDL?id=" + selectedItem.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "BangTHDL.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "bangtonghop",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) { },
                },
                onClick: {
                    DowloadBTHDL: function (event, cell, target) {
                        var win = webix.$$("bangtonghop");
                        var record = win.getItem(cell.row);

                        if (record.trang_thai != 1) {
                            webix.message("Mẫu chưa được ký không thể tải !", "error");
                            return;
                        }

                        if (record.xml_send == null || record.xml_send == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = "KetQuaKiemTraBTHDL.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLBangTHDL?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();
                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                            });

                        return false;
                    },
                    InBTHDL: function (event, cell, target) {
                        var table = webix.$$("bangtonghop");
                        var item = table.getItem(cell.row);

                        if (item.xml_send == null || item.xml_send == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        var box = webix.modalbox({
                            title: "Đang in Biên lai ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLieu_bc26?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    DowloadBTHDLRep: function (event, cell, target) {
                        var win = webix.$$("bangtonghop");
                        var record = win.getItem(cell.row);

                        if (record.trang_thai != 1) {
                            webix.message("Mẫu chưa được ký không thể tải !", "error");
                            return;
                        }

                        if (record.xml_nhan == null || record.xml_nhan == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = "KetQuaKiemTraBTHDL.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLBTHDLRep?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();
                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                            });

                        return false;
                    },
                    InBTHDLRep: function (event, cell, target) {
                        var table = webix.$$("bangtonghop");
                        var item = table.getItem(cell.row);

                        if (item.xml_nhan == null || item.xml_nhan == "") {
                            webix.message("CQT chưa phản hồi !", "error");
                            return;
                        }

                        var box = webix.modalbox({
                            title: "Đang in Biên lai ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inBTHDLRep?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },

                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("bangtonghop");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () { },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "index",
                        header: "STT",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "trang_thai",

                        header: [
                            "Trạng thái",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 150,
                        template: function (obj) {
                            return obj.trang_thai == 1
                                ? "<span style='color: #00b300'><i class='fas fa-check'></i></span> Đã Ký"
                                : "<span style='color: red'><i class='fas fa-times'></i></span> Chưa Ký";
                        },
                    },
                    /*{
                        id: "ldau",
                        header: [
                            "Lần nộp",
                            {
                                content: "selectFilter",
                            },
                        ],
                        width: 120,
                        template: function (obj) {
                            if (obj.ldau == 1) {
                                return "<span style='color: #00b300'>Lần đầu</span> ";
                            } else {
                                return "<span style='color: #e83717'>Bổ sung</span> ";
                            }
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "numeric",
                    },
                    // {
                    //     id: "btnMessagetn",
                    //     header: ["", "Lịch sử xử lý"],
                    //     css: { "text-align": "center" },
                    //     template: function (obj) {
                    //         return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                    //     },
                    //     width: 180,
                    // },*/
                    {
                        id: "kdlieu",
                        header: [
                            "Kỳ dữ liệu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ngay_ky",
                        header: [
                            "Ngày giờ ký",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },

                    {
                        id: "sbthdlieu",
                        header: [
                            "Số thứ tự bảng",
                            {
                                content: "textFilter",
                            },
                        ],
                        columnType: "numeric",
                        width: 120,
                    },
                    {
                        id: "nlap",
                        header: [
                            "Ngày lập",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },
                    {
                        id: "nglap",
                        header: [
                            "Người lập",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "ngky",
                        header: [
                            "Người ký",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "bthDowloadBTHBL",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='DowloadBTHDL' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='DowloadBTHDL' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "btnInBTHBL",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='InBTHDL' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InBTHDL' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "ket_qua",
                        header: [
                            "Kết quả",
                            {
                                content: "serverSelectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "0", value: "Chờ phản hổi" },
                                    { id: "1", value: "Dữ liệu hợp lệ" },
                                    { id: "2", value: "Dữ liệu không hợp lệ" },
                                ],
                            },
                        ],
                        css: { "text-align": "center" },
                        width: 150,
                        template: function (obj) {
                            if (obj.ket_qua == 1) {
                                return "<span style='color: #00b300'>Dữ liệu hợp lệ</span> ";
                            } else {
                                if (obj.ket_qua == 2) {
                                    return "<span style='color: #e83717'>Dữ liệu không hợp lệ</span> ";
                                } else {
                                    return "<span>Chờ phản hồi</span>";
                                }
                            }
                        },
                    },
                    {
                        id: "bthDowloadBTHDLRep",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ket_qua != null && obj.ket_qua != "") {
                                return "<span class='DowloadBTHDLRep' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='DowloadBTHDLRep' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "btnInBTHDLRep",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ket_qua != null && obj.ket_qua != "") {
                                return "<span class='InBTHDLRep' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InBTHDLRep' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 120,
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("bangtonghop");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({
                title: "Tình hình sử dụng biên lai (BC26/BLĐT)",
                details: "Tình hình sử dụng biên lai (BC26/BLĐT)",
            });
            var table = webix.$$("bangtonghop");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangeBangtonghop", function (mode, item) {
                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },

        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_baocao_tinhhinhhoadonForm',["app", "locale", "models/user"], function (app, _, user) {
    var editmode = 0;

    var date = new Date();
    var _month = date.getMonth() + 1;
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    function subviewT() {
        $$("cbQuy").define("label", "Tháng");
        $$("cbQuy").refresh();
        $$("cbQuy").define("options", ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
        //webix.extend(config, $$('cbQuy').config);
        //webix.ui(config, $$('cbThang'));
        //$$('cbThang').destructor();
    }

    function subviewQ() {
        $$("cbQuy").define("label", "Quý");
        $$("cbQuy").refresh();
        $$("cbQuy").define("options", ["1", "2", "3", "4"]);
        // webix.extend($$('cbQuy').config, config, true);
        //webix.ui(config, $$('cbQuy'));
        //$$('cbQuy').destructor();
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Tình hình sử dụng hóa đơn",
            width: 550,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 60 },
                view: "form",
                id: "bangkebr",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "multicombo",
                        label: _("DONVI"),
                        name: "lst_branch_code",
                        labelWidth: 80,
                        required: true,
                        invalidMessage: "Vui lòng chọn đơn vị",
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00198",
                            },
                        },
                        on: {
                            onChange: function(newValue, oldValue) {
                                // Tạo URL API dựa trên các giá trị đã chọn trong multicomboA
                                var urlLoad = app.config.host + "/System/GetDataReferencesByRefIdAndBranchs?refId=RF003001&branchs=" + newValue;
                                
                                // Cập nhật URL của multicomboB và tải lại dữ liệu
                                var comp = $$("multicombo_kyhieu").getPopup().getList();
                                if(comp != null) {
                                    comp.clearAll();
                                    comp.load(urlLoad);
                                }
                            }
                        }
                    },
                    {
                        cols: [
                            {
                                view: "radio",
                                id: "head_extension",
                                value: 1,
                                options: [
                                    { id: 1, value: "Tháng" }, // the initially selected item
                                    { id: 2, value: "Quý" },
                                ],
                                on: {
                                    onChange: function (newv, oldv) {
                                        var d = new Date();
                                        var quarter = Math.floor(d.getMonth() / 3);
                                        var quarter1 = quarter + 1;
                                        if (newv == 2) {
                                            subviewQ();
                                            $$("cbQuy").setValue(quarter1);
                                        }
                                        if (newv == 1) {
                                            subviewT();
                                            $$("cbQuy").setValue(d.getMonth() + 1);
                                        }
                                    },
                                },
                            },
                            {
                                id: "cbQuy",
                                name: "quy",
                                view: "combo",
                                label: "Tháng",
                                value: _month,
                                options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
                                on: {
                                    onChange: function () {
                                        var d = new Date();
                                        var quarter = Math.floor(d.getMonth() / 3);
                                        var quarter1 = quarter + 1;

                                        var option = $$("head_extension").getValue();
                                        if (option == 2) {
                                            var nam = d.getFullYear();
                                            var thang;
                                            var quy = $$("cbQuy").getValue();
                                            if (quy == 1) {
                                                thang = 0;
                                            }
                                            if (quy == 2) {
                                                thang = 3;
                                            }
                                            if (quy == 3) {
                                                thang = 6;
                                            }
                                            if (quy == 4) {
                                                thang = 9;
                                            }
                                            var firstDate = new Date(nam, thang, 1);
                                            var lastDate = new Date(nam, thang + 3, 0);

                                            $$("tu_ngay").setValue(firstDate);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDate);
                                            $$("den_ngay").refresh();
                                        }
                                        if (option == 1) {
                                            var year = d.getFullYear();
                                            var month = $$("cbQuy").getValue();
                                            var date1 = month + "/01" + "/" + year;

                                            var date = new Date(date1);
                                            var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                                            var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                                            $$("tu_ngay").setValue(firstDay1);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDay1);
                                            $$("den_ngay").refresh();
                                        }
                                    },
                                },
                            },
                        ],
                    },
                    {
                        view: "datepicker",
                        label: _("TU_NGAY"),
                        name: "tu_ngay",
                        id: "tu_ngay",
                        value: firstDay,
                        labelWidth: 80,
                        invalidMessage: "Vui lòng chọn từ ngày",
                        validate: webix.rules.isNotEmpty,
                        required: true,
                    },
                    {
                        view: "datepicker",
                        label: _("DEN_NGAY"),
                        name: "den_ngay",
                        id: "den_ngay",
                        value: lastDay,
                        labelWidth: 80,
                        invalidMessage: "Vui lòng chọn đến ngày",
                        validate: webix.rules.isNotEmpty,
                        required: true,
                    },
                    {
                        view: "multicombo",
                        label: _("KY_HIEU"),
                        name: "ky_hieu",
                        labelWidth: 80,
                        id: "multicombo_kyhieu",
                        // required: true,
                        // invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
                        // validate: webix.rules.isNotEmpty,
                        suggest: {
                            selectAll: true,
                            body: {
                                // url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF003001",
                                //template: webix.template("#value#")
                            },
                        },
                        //value: "2"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Nhận (F10)",
                                width: 100,
                                type: "form",
                                align: "center",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var tableHoadon = $$("bangkebr");
                                            if (tableHoadon.validate()) {
                                                var tungay = $$("tu_ngay").getValue();
                                                var denngay = $$("den_ngay").getValue();

                                                if (tungay > denngay) {
                                                    webix.message("Ngày bắt đầu phải nhỏ hơn ngày kết thúc !", "error");
                                                    $$("tu_ngay").focus();
                                                    return;
                                                }

                                                var form = self.getParentView().getParentView();
                                                var win = self.getTopParentView();

                                                var item = form.getValues();
                                                var load_event = "dataChangebangkebanra";

                                                app.callEvent(load_event, [item]);

                                                win.close();
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 100,
                                align: "center",
                                type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },

        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            form.setValues(item);
        },
    };
});

define('views/68_baocao_tinhhinhhoadon',["app", "locale", "models/user", "views/forms/68_baocao_tinhhinhhoadonForm", "views/forms/68_hoadon_history"], function (app, _, user, bangkebanraForm, hoadonHistory) {
    

    webix.$$("title").parse({
        title: "Tờ khai chứng từ bán ra",
        details: "Tờ khai chứng từ bán ra",
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(bangkebanraForm.$ui);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
        //    id: "btnPlus",
        //    shortcut: "F4",
        //    on: {
        //        onClick: function () {
        //            var detailForm = this.$scope.ui(bangkebanraForm.$ui);
        //            bangkebanraForm.setEditMode(1);
        //            detailForm.show();

        //            var url = app.config.host + "/Invoice68/GetInfoCompany";

        //            webix.ajax(url, function (text) {
        //                var json = JSON.parse(text);
        //                webix.$$("tnnt").setValue(json.name);
        //                webix.$$("mst").setValue(json.tax_code);
        //                webix.$$("ddanh").setValue(json.address);
        //            });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
        //    id: "btnEdit",
        //    shortcut: "F3",
        //    on: {
        //        onClick: function () {
        //            var table = webix.$$("bangkebanra");
        //            var selectedItem = table.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn dòng nào ! ", "error");
        //                return;
        //            }

        //            var detailForm = this.$scope.ui(bangkebanraForm.$ui);
        //            bangkebanraForm.setEditMode(2);
        //            bangkebanraForm.setValues(selectedItem);
        //            if (selectedItem.trang_thai == 1) {
        //                var form = $$("bangkebanra-form").elements;
        //                for (var key in form) {
        //                    var $el = form[key];
        //                    $el.define("readonly", "true");
        //                    $el.define("css", "mcls_readonly_text");
        //                    $el.refresh();
        //                }

        //                webix.$$("btnBTHSave").destructor();
        //                webix.$$("btnTaiDanhSachBanRa").destructor();
        //            }
        //            detailForm.show();
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
        //    id: "btnDelete",
        //    shortcut: "F8",
        //    on: {
        //        onClick: function () {
        //            var table = webix.$$("bangkebanra");
        //            var selectedItem = table.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                return;
        //            }
        //            if (selectedItem.trang_thai == 1) {
        //                webix.message("Bảng tổng hợp đã gửi CQT không thể xóa ! ", "error");
        //                return;
        //            }

        //            var khData = {};

        //            khData.editmode = 3;
        //            khData.data = [];
        //            khData.data.push(selectedItem);

        //            webix.confirm({
        //                text: "Bạn có muốn xóa bản ghi",
        //                ok: "Có",
        //                cancel: "Không",
        //                callback: function (choose) {
        //                    if (choose) {
        //                        webix
        //                            .ajax()
        //                            .headers({ "Content-type": "application/json" })
        //                            .post(app.config.host + "/Invoice68/SaveBangKeBanRa", khData, function (text) {
        //                                var response = JSON.parse(text);

        //                                if (response.hasOwnProperty("error")) {
        //                                    webix.message({ type: "error", text: response.error });
        //                                    return;
        //                                }

        //                                // table.remove(item.id);
        //                                var btnRefresh = $$("btnRefresh");
        //                                btnRefresh.callEvent("onClick");
        //                            });
        //                    }
        //                },
        //            });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fas fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "In PDF" + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;

                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }

                    var datafrmAll = table.serialize();

                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để in !", "error");
                        return;
                    }

                    rpParameter.type = "PDF";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(
                                app.config.host + "/Invoice68/PrintPDFTinhHinhSuDungHoaDon",
                                rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/pdf" });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.open(fileURL, "_blank");
                                    },
                                }
                                // function (text, data) {
                                //     var file = new Blob([data], { type: 'application/pdf' });
                                //     var fileURL = URL.createObjectURL(file);
                                //     webix.modalbox.hide(box);
                                //     window.open(fileURL, '_blank');
                                // }
                            );
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-file fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("EXPORT_EXCEL") + "</span>",
            id: "btnExportExcel",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";

                    var datafrmAll = table.serialize();

                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để xuất !", "error");
                        return;
                    }

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(app.config.host + "/Invoice68/PrintPDFTinhHinhSuDungHoaDon", rpParameter, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                    //var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    //window.location.href = fileURL;
                                    webix.html.download(file, "TinhHinhSuDungHoaDon.xlsx");
                                },
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 100,
        //     label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Gửi email") + "</span>",
        //     id: "btnSendEmail",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("hoadon");
        //             var selectedItem = table.getSelectedItem();
        //             if (selectedItem == null) {
        //                 webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                 return;
        //             }
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký gửi CQT") + "</span>",
        //    id: "btnSign",
        //    on: {
        //        onClick: function () {
        //            var tableDK = webix.$$("bangkebanra");
        //            var selectedItem = tableDK.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn dòng ! ", "error");
        //                return;
        //            }
        //            if (selectedItem.trang_thai == 1) {
        //                webix.message("Mẫu đã ký và gửi CQT bạn không thể ký lại! ", "error");
        //                return;
        //            }

        //            webix
        //                .ajax()
        //                .headers({ "Content-Type": "application/json" })
        //                .get(app.config.host + "/Invoice68/GetSignType", function (text) {
        //                    var result = JSON.parse(text);
        //                    var kytaptrung = "";
        //                    for (var i = 0; i < result.length; i++) {
        //                        var item = result[i];
        //                        kytaptrung = item.value;
        //                    }

        //                    webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
        //                        var listcerts = JSON.parse(text);
        //                        if (listcerts.length > 0) {
        //                            var box = webix.modalbox({
        //                                title: "Chọn chứng thư số",
        //                                buttons: ["Nhận", "Hủy bỏ"],
        //                                text: "<div id='ctnCerts'></div>",
        //                                top: 100,
        //                                width: 750,
        //                                callback: function (result) {
        //                                    switch (result) {
        //                                        case "1":
        //                                            webix.modalbox.hide();
        //                                            break;
        //                                        case "0":
        //                                            var table = $$("tblCerts");
        //                                            var data = table.serialize();
        //                                            var cert = null;

        //                                            for (var i = 0; i < data.length; i++) {
        //                                                if (data[i].chon == true) {
        //                                                    cert = data[i];
        //                                                    break;
        //                                                }
        //                                            }

        //                                            if (cert == null) {
        //                                                webix.message("Bạn chưa chọn chứng thư số");
        //                                                return;
        //                                            }
        //                                            var postData = {
        //                                                branch_code: user.getDvcsID(),
        //                                                username: user.getCurrentUser(),
        //                                                cer_serial: cert.cer_serial,
        //                                                id: selectedItem.id,
        //                                            };

        //                                            webix.extend(tableDK, webix.ProgressBar);
        //                                            tableDK.disable();
        //                                            tableDK.showProgress();
        //                                            webix
        //                                                .ajax()
        //                                                .headers({ "Content-type": "application/json" })
        //                                                .post(app.config.host + "/Invoice68/SignBangKeBanRa", postData, {
        //                                                    error: function (text, data, XmlHttpRequest) {
        //                                                        tableDK.enable();
        //                                                        tableDK.hideProgress();
        //                                                        // var json = JSON.parse(text);
        //                                                        // webix.message(json.ExceptionMessage, "error");
        //                                                        webix.message(text + XmlHttpRequest, "error");
        //                                                    },
        //                                                    success: function (text, data, XmlHttpRequest) {
        //                                                        var json = JSON.parse(text);
        //                                                        tableDK.enable();
        //                                                        tableDK.hideProgress();
        //                                                        if (!json.hasOwnProperty("error")) {
        //                                                            webix.message("Gửi thành công đến CQT !", "success");
        //                                                            // $$("huyhoadonForms").close();
        //                                                            app.callEvent("dataChangebangkebanra", [1, null]);
        //                                                        } else {
        //                                                            webix.message(json.error, "error");
        //                                                        }
        //                                                    },
        //                                                });
        //                                            return;
        //                                    }
        //                                },
        //                            });
        //                            var tblMatHang = webix.ui({
        //                                container: "ctnCerts",
        //                                id: "tblCerts",
        //                                view: "datatable",
        //                                borderless: true,
        //                                resizeColumn: true,
        //                                height: 350,
        //                                columns: [
        //                                    {
        //                                        id: "chon",
        //                                        header: _("CHON"),
        //                                        width: 65,
        //                                        checkValue: true,
        //                                        uncheckValue: false,
        //                                        template: "{common.checkbox()}",
        //                                    },
        //                                    {
        //                                        id: "cer_serial",
        //                                        header: _("SO_SERIAL"),
        //                                        width: 150,
        //                                    },
        //                                    {
        //                                        id: "subject_name",
        //                                        header: _("SUBJECTNAME"),
        //                                        width: 450,
        //                                    },
        //                                    {
        //                                        id: "begin_date",
        //                                        header: _("NGAY_BAT_DAU"),
        //                                        width: 200,
        //                                    },
        //                                    {
        //                                        id: "end_date",
        //                                        header: _("NGAY_KET_THUC"),
        //                                        width: 200,
        //                                    },
        //                                    {
        //                                        id: "issuer",
        //                                        header: _("DONVI"),
        //                                        width: 450,
        //                                    },
        //                                ],
        //                                url: app.config.host + "/Invoice68/GetListCertificatesFile68",
        //                            });
        //                        } else {
        //                            var table = $$("bangkebanra");
        //                            webix.extend(table, webix.ProgressBar);
        //                            table.disable();
        //                            table.showProgress();

        //                            var a = webix.ajax(app.config.host + "/Invoice68/XmlBangKeBanRa?id=" + selectedItem.id);
        //                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

        //                            webix.promise.all([a, b, selectedItem]).then(function (results) {
        //                                // webix.extend(tblInvoice, webix.ProgressBar);
        //                                // tblInvoice.disable();
        //                                // tblInvoice.showProgress();
        //                                var json = results[0].json();

        //                                if (json.hasOwnProperty("error")) {
        //                                    webix.message({ type: "error", text: json.error });
        //                                }

        //                                var listcerts = results[1].json();
        //                                var item = results[2];

        //                                if (listcerts.length == 0) {
        //                                    table.enable();
        //                                    table.hideProgress();
        //                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
        //                                    return;
        //                                }

        //                                require(["views/modules/minvoiceplugin"], function (plugin) {
        //                                    var hub = plugin.hub();
        //                                    var hubconnect = plugin.conn();
        //                                    if (hubconnect.state != 1) {
        //                                        table.enable();
        //                                        table.hideProgress();
        //                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
        //                                        return;
        //                                    }
        //                                    hub.off("resCommand");
        //                                    hub.on("resCommand", function (result) {
        //                                        var json = JSON.parse(result);

        //                                        if (json.hasOwnProperty("error")) {
        //                                            webix.message({ type: "error", text: json.error });
        //                                        } else {
        //                                            var parameters = {
        //                                                xml: json.xml,
        //                                                id: selectedItem.id,
        //                                                shdon: json.shdon,
        //                                            };

        //                                            webix
        //                                                .ajax()
        //                                                .headers({ "Content-Type": "application/json" })
        //                                                .post(app.config.host + "/Invoice68/SaveXmlBangKeBanRa", parameters, function (text) {
        //                                                    var result = JSON.parse(text);
        //                                                    if (result.hasOwnProperty("error")) {
        //                                                        webix.message(result.error, "error");
        //                                                    } else {
        //                                                        webix.message("Gửi thành công đến CQT !", "success");
        //                                                        // $$("huyhoadonForms").close();
        //                                                        app.callEvent("dataChangebangkebanra", [1, null]);
        //                                                    }
        //                                                });
        //                                        }
        //                                        table.enable();
        //                                        table.hideProgress();
        //                                    });

        //                                    var _listcerts = [];

        //                                    for (var i = 0; i < listcerts.length; i++) {
        //                                        var _cert = listcerts[i];

        //                                        _listcerts.push({
        //                                            so_serial: _cert.cer_serial,
        //                                            ngaybatdau: _cert.begin_date,
        //                                            ngayketthuc: _cert.end_date,
        //                                            issuer: _cert.issuer,
        //                                            subjectname: _cert.subject_name,
        //                                        });
        //                                    }

        //                                    var arg = {
        //                                        idData: "#data",
        //                                        xml: json["xml"],
        //                                        shdon: json.shdon,
        //                                        idSigner: "seller",
        //                                        tagSign: "NNT",
        //                                        listcerts: _listcerts,
        //                                    };

        //                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
        //                                        .done(function () {
        //                                            console.log("Success !");
        //                                        })
        //                                        .fail(function (error) {
        //                                            webix.message(error, "error");
        //                                        });
        //                                });
        //                            });
        //                        }
        //                    });
        //                });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 120,
        //    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Lập bổ sung" + "</span>",
        //    id: "btnCreatePlus",
        //    shortcut: "F4",
        //    on: {
        //        onClick: function () {
        //            var detailForm = this.$scope.ui(bangkebanraForm.$ui);
        //            bangkebanraForm.setEditMode(1);
        //            detailForm.show();

        //            webix.$$("ldau").setValue(0);

        //            var url = app.config.host + "/Invoice68/GetInfoCompany";

        //            webix.ajax(url, function (text) {
        //                var json = JSON.parse(text);
        //                webix.$$("tnnt").setValue(json.name);
        //                webix.$$("mst").setValue(json.tax_code);
        //                webix.$$("ddanh").setValue(json.address);
        //            });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 120,
        //     label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Lập bổ sung") + "</span>",
        //     id: "btnUp",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("hoadon");
        //             var selectedItem = table.getSelectedItem();
        //             if (selectedItem == null) {
        //                 webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                 return;
        //             }
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        //{
        //    view: "button",
        //    type: "htmlbutton",
        //    width: 100,
        //    label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải XML") + "</span>",
        //    id: "btnDownloadXml",
        //    on: {
        //        onClick: function () {
        //            var table = webix.$$("bangkebanra");
        //            var selectedItem = table.getSelectedItem();
        //            if (selectedItem == null) {
        //                webix.message("Bạn chưa chọn khách hàng ! ", "error");
        //                return;
        //            }
        //            if (selectedItem.trang_thai != 1) {
        //                webix.message("Bảng tổng hợp chưa gửi CQT không tồn tại xml ! ", "error");
        //                return;
        //            }

        //            webix.extend(table, webix.ProgressBar);
        //            table.disable();
        //            table.showProgress();

        //            var url = app.config.host + "/Invoice68/ExportXMLBangKeBanRa?id=" + selectedItem.id;
        //            webix
        //                .ajax()
        //                .response("arraybuffer")
        //                .get(url, function (text, data) {
        //                    table.enable();
        //                    table.hideProgress();

        //                    var file = new Blob([data], { type: "application/xml" });
        //                    webix.html.download(file, "BangKeBanRa.xml");
        //                    // var fileURL = URL.createObjectURL(file);
        //                    // window.open(fileURL, "_blank");
        //                });
        //        },
        //    },
        //    click: function () {
        //        this.callEvent("onClick");
        //    },
        //},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                container: "testA",
                view: "treetable",
                id: "bangkebanra",
                select: true,
                tooltip:true,
                resizeColumn: true,
                fullScreen: true,
                fixedRowHeight: false,
                rowLineHeight: 25,
                rowHeight: 25,
                columns: [
                    {
                        id: "stt",
                        header: "<center>STT</center>",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "khmhdon",
                        header:"<center>Ký hiệu mẫu hóa đơn</center>",
                        width: 150,
                        // template: function (obj) {
                        //     debugger;
                        //     if (obj != null) 
                        //     return obj.khieu.substr(0,1);
                        // },
                    },
                    {
                        id: "khieu",
                        header:"<center>Ký hiệu hóa đơn</center>",
                        width: 150,
                        // template: function (obj) {

                        //     debugger;
                        //     if (obj != null) 
                        //     return obj.khieu.substr(1,obj.khieu.length - 1);
                        // },
                    },
                    {
                        id: "tsss_tuso",
                        header: [{ text: "<center>Tổng số sử dụng, thay thế, điều chỉnh, hủy</center>", colspan: 3 }, { text: "<center>Từ số</center>" }],
                        width: 100,
                        // format: webix.Number.numToStr({
                        //             groupDelimiter: ",",
                        //             groupSize: 3,
                        //             decimalDelimiter: ".",
                        //             decimalSize: 0,
                        //         }),
                    },
                    {
                        id: "tsss_denso",
                        header: [null, { text: "<center>Đến số</center>" }],
                        width: 100,
                        // format: function (text) {
                        //     var format = webix.Date.dateToStr("%d/%m/%Y");
                        //     text = removeTimeZoneT(text);
                        //     return format(text);
                        // },
                    },
                    {
                        id: "tsss_tong",
                        header: [null, { text: "<center>Tổng</center>" }],
                        width: 100,
                        format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 6,
                                decimalOptional: true
                            }),
                    },
                    { 
                        id: "doanhthu", 
                        header: "<center>Doanh thu</center>", 
                        width: 100, 
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    {
                        id: "goc_sl",
                        header: [{ text: "<center>Gốc</center>", colspan: 2 }, { text: "<center>Số lượng</center>" }],
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    {
                        id: "goc_ttien",
                        header: [null, { text: "<center>Tổng tiền</center>" }],
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    {
                        id: "huy_sl",
                        header: [{ text: "<center>Hủy/Bị thay thế</center>", colspan: 3 }, { text: "<center>Số lượng</center>" }],
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    {
                        id: "huy_soseri",
                        header: [null, { text: "<center>Số seri hóa đơn</center>" }],
                        width: 150,
                        // format: function (text) {
                        //     var format = webix.Date.dateToStr("%d/%m/%Y");
                        //     text = removeTimeZoneT(text);
                        //     return format(text);
                        // },
                    },
                    {
                        id: "huy_ttien",
                        header: [null, { text: "<center>Tổng tiền</center>" }],
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    {
                        id: "loi_sl",
                        header: [{ text: "<center>Lỗi</center>", colspan: 3 }, { text: "<center>Số lượng</center>" }],
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    {
                        id: "loi_soseri",
                        header: [null, { text: "<center>Số seri hóa đơn</center>" }],
                        width: 150,
                        // format: function (text) {
                        //     var format = webix.Date.dateToStr("%d/%m/%Y");
                        //     text = removeTimeZoneT(text);
                        //     return format(text);
                        // },
                    },
                    {
                        id: "loi_ttien",
                        header: [null, { text: "<center>Tổng tiền</center>" }],
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    {
                        id: "bidieuchinh_sl",
                        header: [{ text: "<center>Bị điều chỉnh</center>", colspan: 3 }, { text: "<center>Số lượng</center>" }],
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                    },
                    {
                        id: "bidieuchinh_soseri",
                        header: [null, { text: "<center>Số seri hóa đơn</center>" }],
                        width: 150,
                        // format: function (text) {
                        //     var format = webix.Date.dateToStr("%d/%m/%Y");
                        //     text = removeTimeZoneT(text);
                        //     return format(text);
                        // },
                    },
                    {
                        id: "bidieuchinh_ttien",
                        header: [null, { text: "<center>Tổng tiền</center>" }],
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    
                    {
                        id: "dieuchinh_sl",
                        header: [{ text: "<center>Điều chỉnh/Thay thế</center>", colspan: 3 }, { text: "<center>Số lượng</center>" }],
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    {
                        id: "dieuchinh_soseri",
                        header: [null, { text: "<center>Số seri hóa đơn</center>" }],
                        width: 150,
                        // format: function (text) {
                        //     var format = webix.Date.dateToStr("%d/%m/%Y");
                        //     text = removeTimeZoneT(text);
                        //     return format(text);
                        // },
                    },
                    {
                        id: "dieuchinh_ttien",
                        header: [null, { text: "<center>Tổng tiền</center>" }],
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        }),
                    },
                    
                    
                    
                    // { id: "ms_thue", header: "<center>Mã số thuế</center>", width: 150 },
                    // {
                    //     id: "tien_tt0",
                    //     header: "<center>Doanh thu chưa có thuế GTGT</center>",
                    //     width: 200,
                    //     format: webix.Number.numToStr({
                    //         groupDelimiter: ",",
                    //         groupSize: 3,
                    //         decimalDelimiter: ".",
                    //         decimalSize: 0,
                    //     }),
                    // },
                    // {
                    //     id: "tien",
                    //     header: "<center>Thuế GTGT</center>",
                    //     width: 100,
                    //     format: webix.Number.numToStr({
                    //         groupDelimiter: ",",
                    //         groupSize: 3,
                    //         decimalDelimiter: ".",
                    //         decimalSize: 0,
                    //     }),
                    // },
                    // { id: "ghi_chu", header: "<center>Ghi chú</center>", width: 200 },
                ],
                pager: "pagerA",
                scheme: {
                    //$group: {
                        //by: "nhom",
                        //,css:{ "text-align": "right" }
                        // map:{
                        // 	nguoi_lien_he:["nguoi_lien_he", "count"]
                        // }
                    //},
                    //$sort: { by: "stt", dir: "asc" }
                },
                ready: function () {
                    //this.open(this.getFirstId());
                    //this.sort({ by: "stt", dir: "asc" });
                    this.openAll();
                    this.adjustRowHeight("ghi_chu", true);
                    this.refresh();
                },
                //url: app.config.host + "/System/ExecuteQuery?sql=" + sql
                //autoheight: true,
                //autowidth:true,
                //data: big_film_set
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChangebangkebanra", function (item) {
                var table = $$("bangkebanra");
                // webix.extend(table, webix.OverlayBox);
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();

                table.config.rpParameter = item;

                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .post(app.config.host + "/Invoice68/GetTinhHinhSuDungHoaDon", item, {
                        error: function (text, data, XmlHttpRequest) {
                            table.enable();
                            table.hideProgress();
                            alert(text);
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var json = JSON.parse(text);
                            if (!json.hasOwnProperty("error")) {
                                //console.log(json);
                                $$("bangkebanra").clearAll();
                                $$("bangkebanra").parse(json);
                                $$("bangkebanra").refresh();
                            } else {
                                webix.message(json.error, "error");
                            }
                            table.enable();
                            table.hideProgress();
                        },
                    });
            });
        },
    };
});

define('views/forms/68_baocao_tinhhinhhoadonBC26Form',["app", "locale", "models/user"], function (app, _, user) {
    var editmode = 0;

    var date = new Date();
    var _month = date.getMonth() + 1;
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    function subviewT() {
        $$("cbQuy").define("label", "Tháng");
        $$("cbQuy").refresh();
        $$("cbQuy").define("options", ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
        //webix.extend(config, $$('cbQuy').config);
        //webix.ui(config, $$('cbThang'));
        //$$('cbThang').destructor();
    }

    function subviewQ() {
        $$("cbQuy").define("label", "Quý");
        $$("cbQuy").refresh();
        $$("cbQuy").define("options", ["1", "2", "3", "4"]);
        // webix.extend($$('cbQuy').config, config, true);
        //webix.ui(config, $$('cbQuy'));
        //$$('cbQuy').destructor();
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Tình hình sử dụng hóa đơn",
            width: 550,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 60 },
                view: "form",
                id: "bangkebr",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "multicombo",
                        label: _("DONVI"),
                        name: "lst_branch_code",
                        labelWidth: 80,
                        required: true,
                        invalidMessage: "Vui lòng chọn đơn vị",
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00198",
                            },
                        },
                        on: {
                            onChange: function(newValue, oldValue) {
                                // Tạo URL API dựa trên các giá trị đã chọn trong multicomboA
                                var urlLoad = app.config.host + "/System/GetDataReferencesByRefIdAndBranchs?refId=RF003001&branchs=" + newValue;
                                
                                // Cập nhật URL của multicomboB và tải lại dữ liệu
                                var comp = $$("multicombo_kyhieu").getPopup().getList();
                                if(comp != null) {
                                    comp.clearAll();
                                    comp.load(urlLoad);
                                }
                            }
                        }
                    },
                    {
                        cols: [
                            {
                                view: "radio",
                                id: "head_extension",
                                value: 1,
                                options: [
                                    { id: 1, value: "Tháng" }, // the initially selected item
                                    { id: 2, value: "Quý" },
                                ],
                                on: {
                                    onChange: function (newv, oldv) {
                                        var d = new Date();
                                        var quarter = Math.floor(d.getMonth() / 3);
                                        var quarter1 = quarter + 1;
                                        if (newv == 2) {
                                            subviewQ();
                                            $$("cbQuy").setValue(quarter1);
                                        }
                                        if (newv == 1) {
                                            subviewT();
                                            $$("cbQuy").setValue(d.getMonth() + 1);
                                        }
                                    },
                                },
                            },
                            {
                                id: "cbQuy",
                                name: "quy",
                                view: "combo",
                                label: "Tháng",
                                value: _month,
                                options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
                                on: {
                                    onChange: function () {
                                        var d = new Date();
                                        var quarter = Math.floor(d.getMonth() / 3);
                                        var quarter1 = quarter + 1;

                                        var option = $$("head_extension").getValue();
                                        if (option == 2) {
                                            var nam = d.getFullYear();
                                            var thang;
                                            var quy = $$("cbQuy").getValue();
                                            if (quy == 1) {
                                                thang = 0;
                                            }
                                            if (quy == 2) {
                                                thang = 3;
                                            }
                                            if (quy == 3) {
                                                thang = 6;
                                            }
                                            if (quy == 4) {
                                                thang = 9;
                                            }
                                            var firstDate = new Date(nam, thang, 1);
                                            var lastDate = new Date(nam, thang + 3, 0);

                                            $$("tu_ngay").setValue(firstDate);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDate);
                                            $$("den_ngay").refresh();
                                        }
                                        if (option == 1) {
                                            var year = d.getFullYear();
                                            var month = $$("cbQuy").getValue();
                                            var date1 = month + "/01" + "/" + year;

                                            var date = new Date(date1);
                                            var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                                            var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                                            $$("tu_ngay").setValue(firstDay1);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDay1);
                                            $$("den_ngay").refresh();
                                        }
                                    },
                                },
                            },
                        ],
                    },
                    {
                        view: "datepicker",
                        label: _("TU_NGAY"),
                        name: "tu_ngay",
                        id: "tu_ngay",
                        value: firstDay,
                        labelWidth: 80,
                        invalidMessage: "Vui lòng chọn từ ngày",
                        validate: webix.rules.isNotEmpty,
                        required: true,
                    },
                    {
                        view: "datepicker",
                        label: _("DEN_NGAY"),
                        name: "den_ngay",
                        id: "den_ngay",
                        value: lastDay,
                        labelWidth: 80,
                        invalidMessage: "Vui lòng chọn đến ngày",
                        validate: webix.rules.isNotEmpty,
                        required: true,
                    },
                    {
                        view: "multicombo",
                        label: _("KY_HIEU"),
                        name: "ky_hieu",
                        labelWidth: 80,
                        id: "multicombo_kyhieu",
                        // required: true,
                        // invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
                        // validate: webix.rules.isNotEmpty,
                        suggest: {
                            selectAll: true,
                            body: {
                                // url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF003001",
                                //template: webix.template("#value#")
                            },
                        },
                        //value: "2"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Nhận (F10)",
                                width: 100,
                                type: "form",
                                align: "center",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var tableHoadon = $$("bangkebr");
                                            if (tableHoadon.validate()) {
                                                var tungay = $$("tu_ngay").getValue();
                                                var denngay = $$("den_ngay").getValue();

                                                if (tungay > denngay) {
                                                    webix.message("Ngày bắt đầu phải nhỏ hơn ngày kết thúc !", "error");
                                                    $$("tu_ngay").focus();
                                                    return;
                                                }

                                                var form = self.getParentView().getParentView();
                                                var win = self.getTopParentView();

                                                var item = form.getValues();
                                                var load_event = "dataChangebangkebanra";

                                                app.callEvent(load_event, [item]);

                                                win.close();
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 100,
                                align: "center",
                                type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },

        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            form.setValues(item);
        },
    };
});

define('views/68_baocao_tinhhinhhoadonBC26',["app", "locale", "models/user", "views/forms/68_baocao_tinhhinhhoadonBC26Form", "views/forms/68_hoadon_history"], function (app, _, user, bangkebanraForm, hoadonHistory) {
    

    webix.$$("title").parse({
        title: "Tờ khai chứng từ bán ra",
        details: "Tờ khai chứng từ bán ra",
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(bangkebanraForm.$ui);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fas fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "In PDF" + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");
                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    var datafrmAll = table.serialize();
                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để in !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(
                                app.config.host + "/Invoice68/PrintPDFTinhHinhSuDungHoaDon26",
                                rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/pdf" });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.open(fileURL, "_blank");
                                    },
                                }
                            );
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-file fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("EXPORT_EXCEL") + "</span>",
            id: "btnExportExcel",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");
                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";
                    var datafrmAll = table.serialize();
                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để xuất !", "error");
                        return;
                    }
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(app.config.host + "/Invoice68/PrintPDFTinhHinhSuDungHoaDon26", rpParameter, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                    webix.modalbox.hide(box);
                                    webix.html.download(file, "TinhHinhSuDungHoaDonBC26.xlsx");
                                },
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [{
            container: "testA",
            view: "treetable",
            id: "bangkebanra",
            css: "custom-bordered-table", // Áp dụng CSS tùy chỉnh cho viền
            select: true,
            tooltip: true,
            resizeColumn: true,
            scroll: "x", // <-- ĐÃ THÊM THANH CUỘN NGANG
            fixedRowHeight: false,
            rowLineHeight: 25,
            rowHeight: 25,
            columns: [
                // Cột đơn giản
                { id: "stt", header: { text: "STT", rowspan: 4, css: { "vertical-align": "middle", "text-align": "center" } }, sort: "int", width: 50, css: { "text-align": "center" } },
                { id: "ten_loai_hdon", header: { text: "Tên loại hóa đơn", rowspan: 4, css: { "vertical-align": "middle", "text-align": "center" } }, width: 250 }, // <-- Đã thay đổi
                { id: "khieu_mau_hdon", header: { text: "Ký hiệu mẫu hóa đơn", rowspan: 4, css: { "vertical-align": "middle", "text-align": "center" } }, width: 150 }, // <-- Đã thay đổi
                { id: "khieu_hdon", header: { text: "Ký hiệu hóa đơn", rowspan: 4, css: { "vertical-align": "middle", "text-align": "center" } }, width: 150 }, // <-- Đã thay đổi

                // Nhóm 1: Số tồn đầu kỳ, mua/phát hành trong kỳ (5 cột)
                { id: "tong_so", header: [{ text: "Số tồn đầu kỳ, mua/phát hành trong kỳ", colspan: 5, css: { "text-align": "center" } }, { text: "Tổng số", rowspan: 3, css: { "text-align": "center" } }], width: 100, css: { "text-align": "right" } },
                { id: "ton_dk_tu_so", header: [null, { text: "Số tồn đầu kỳ", colspan: 2, css: { "text-align": "center" } }, { text: "Từ số", rowspan: 2, css: { "text-align": "center" } }], width: 100, css: { "text-align": "right" } },
                { id: "ton_dk_den_so", header: [null, null, { text: "Đến số", rowspan: 2, css: { "text-align": "center" } }], width: 100, css: { "text-align": "right" } },
                { id: "mua_tk_tu_so", header: [null, { text: "Số mua/phát hành trong kỳ", colspan: 2, css: { "text-align": "center" } }, { text: "Từ số", rowspan: 2, css: { "text-align": "center" } }], width: 100, css: { "text-align": "right" } },
                { id: "mua_tk_den_so", header: [null, null, { text: "Đến số", rowspan: 2, css: { "text-align": "center" } }], width: 100, css: { "text-align": "right" } },

                // Nhóm 2: Sử dụng, xóa bỏ, mất, hủy trong kỳ (10 cột)
                { id: "tong_sd_tu_so", header: [{ text: "Sử dụng, xóa bỏ, mất, hủy trong kỳ", colspan: 10, css: { "text-align": "center" } }, { text: "Tổng số sử dụng, xóa bỏ, mất, hủy", colspan: 3, css: { "text-align": "center" } }, { text: "Từ số", rowspan: 2, css: { "text-align": "center" } }], width: 100, css: { "text-align": "right" } },
                { id: "tong_sd_den_so", header: [null, null, { text: "Đến số", rowspan: 2, css: { "text-align": "center" } }], width: 100, css: { "text-align": "right" } },
                { id: "tong_sd_cong", header: [null, null, { text: "Cộng", rowspan: 2, css: { "text-align": "center" } }], width: 100, format: webix.Number.numToStr({ groupDelimiter: ",", groupSize: 3 }), css: { "text-align": "right" } },
                { id: "sl_da_su_dung", header: [null, { text: "Trong đó", colspan: 7, css: { "text-align": "center" } }, { text: "Số lượng đã sử dụng", rowspan: 2, css: { "text-align": "center" } }], width: 150, format: webix.Number.numToStr({ groupDelimiter: ",", groupSize: 3 }), css: { "text-align": "right" } },
                { id: "xoa_bo_sl", header: [null, null, { text: "Xóa bỏ", colspan: 2, css: { "text-align": "center" } }, { text: "Số lượng", css: { "text-align": "center" } }], width: 100, format: webix.Number.numToStr({ groupDelimiter: ",", groupSize: 3 }), css: { "text-align": "right" } },
                { id: "xoa_bo_so", header: [null, null, null, { text: "Số", css: { "text-align": "center" } }], width: 120 }, 
                { id: "mat_sl", header: [null, null, { text: "Mất", colspan: 2, css: { "text-align": "center" } }, { text: "Số lượng", css: { "text-align": "center" } }], width: 100, format: webix.Number.numToStr({ groupDelimiter: ",", groupSize: 3 }), css: { "text-align": "right" } },
                { id: "mat_so", header: [null, null, null, { text: "Số", css: { "text-align": "center" } }], width: 120 }, 
                { id: "huy_sl", header: [null, null, { text: "Hủy", colspan: 2, css: { "text-align": "center" } }, { text: "Số lượng", css: { "text-align": "center" } }], width: 100, format: webix.Number.numToStr({ groupDelimiter: ",", groupSize: 3 }), css: { "text-align": "right" } },
                { id: "huy_so", header: [null, null, null, { text: "Số", css: { "text-align": "center" } }], width: 120, css: { "text-align": "right" } }, 

                // Nhóm 3: Tồn cuối kỳ (3 cột)
                { id: "ton_ck_tu_so", header: [{ text: "Tồn cuối kỳ", colspan: 3, css: { "text-align": "center" } }, { text: "Từ số", rowspan: 3, css: { "text-align": "center" } }], width: 100, css: { "text-align": "right" } },
                { id: "ton_ck_den_so", header: [null, { text: "Đến số", rowspan: 3, css: { "text-align": "center" } }], width: 100, css: { "text-align": "right" } },
                { id: "ton_ck_sl", header: [null, { text: "Số lượng", rowspan: 3, css: { "text-align": "center" } }], width: 100, format: webix.Number.numToStr({ groupDelimiter: ",", groupSize: 3 }), css: { "text-align": "right" } }
            ],
            pager: "pagerA",
            scheme: {},
            ready: function () {
                this.openAll();
                this.adjustRowHeight("ghi_chu", true);
                this.refresh();
            },
        }, {
            id: "pagerA",
            view: "pager",
            size: 50,
            group: 5,
            template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
        },],
    };

    var layout = {
        rows: [{
            height: 39,
            css: "btnControl",
            margin: 0,
            borderless: true,
            type: "toolbar",
            cols: controls,
        }, {
            rows: [table],
        },],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            var customCss =
                ".custom-bordered-table .webix_hcell {" +
                "border-bottom: 1px solid #d7d7d7 !important;" +
                "border-right: 1px solid #d7d7d7 !important;" +
                "}" +
                ".custom-bordered-table .webix_cell {" +
                "border-right: 1px solid #d7d7d7 !important;" +
                "}" +
                ".custom-bordered-table .webix_last_column .webix_hcell," +
                ".custom-bordered-table .webix_last_column .webix_cell {" +
                "border-right: none !important;" +
                "}";

            webix.html.addStyle(customCss);
            // **KẾT THÚC: CSS TÍCH HỢP TRỰC TIẾP**

            $scope.on(app, "dataChangebangkebanra", function (item) {
                var table = $$("bangkebanra");
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();

                table.config.rpParameter = item;

                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .post(app.config.host + "/Invoice68/GetTinhHinhSuDungHoaDonBC26", item, {
                        error: function (text, data, XmlHttpRequest) {
                            table.enable();
                            table.hideProgress();
                            alert(text);
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var json = JSON.parse(text);
                            if (!json.hasOwnProperty("error")) {
                                $$("bangkebanra").clearAll();
                                $$("bangkebanra").parse(json);
                                $$("bangkebanra").refresh();
                            } else {
                                webix.message(json.error, "error");
                            }
                            table.enable();
                            table.hideProgress();
                        },
                    });
            });
        },
    };
});
define('views/forms/68_bienbanthoathuanform',["app", "models/user"], function (app, user, hoadonHistory) {
    var editmode = 0;
    var id = '';
    function validateRequiredInputs(containerId, requiredIds) {
        var container = $$(containerId).getNode();
        var valid = true;

        requiredIds.forEach(function (id) {
            var el = container.querySelector("#" + id);
            if (el && !el.value.trim()) {
                el.classList.add("bienban-input-error");
                valid = false;
            } else if (el) {
                el.classList.remove("bienban-input-error");
            }
        });

        return valid;
    }
    var ui = {
        view: "window",
        modal: true,
        position: "center",
        css: "headformchil",
        head: {
            height: 35,
            cols: [
                {
                    id: "head-icondksd",
                    view: "template",
                    css: "headform",
                    width: 35,
                    template: "",
                },
                {
                    id: "head-formdksd",
                    view: "template",
                    css: "headform",
                    template: function (obj) {
                        return "<div>Biên bản thỏa thuận hóa đơn điện tử<div/>";
                    },
                }
            ],
        },
        id: "bienbanForm",
        resize: true,
        width: 1100,
        height: 900,
        move: true,
        body: {
            rows: [
                {
                    view: "scrollview",
                    scroll: "y",
                    id: "bienbanDetail",
                    height: 700,
                    move: true,
                    body: {
                        scroll: true,
                        template:
                            '<div style="padding: 20px; padding-top: 10px; font-size: 17px; line-height: 1.6; width: 100%; font-family: times new roman !important"; > ' +
                            '<div class="bienban-text-center header"><strong>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</strong></div>' +
                            '<div class="bienban-text-center header">Độc lập - Tự do - Hạnh phúc</div>' +
                            '<div class="bienban-text-center header"><strong>---oOo---</strong></div>' +
                            '<div class="bienban-text-center header" style="font-size: 20px; padding-top: 20px;" id="title"><strong></strong></div>' +
                            '<div class="bienban-text-center header title-number">' +
                            '<strong>Số' +
                            '<input type="text" id="svban" name="DocNo" class="required input-dotted" style="width: 20%; text-align: center;" value=""></strong>' +
                            '</div>' +
                            '<div class="based-on">' +
                            '<div class="bienban-text-content">Căn cứ Luật Quản lý thuế ngày 10 tháng 12 năm 2025;</div>' +
                            '<div class="bienban-text-content">Căn cứ Nghị định 254/2026/NĐ-CP quy định chi tiết một số điều và biện pháp để tổ chức, hướng dẫn thi hành Luật Quản lý thuế số 108/2025/QH15 về hóa đơn điện tử, chứng từ điện tử;</div>' +
                            '<div class="bienban-text-content">Căn cứ Thông tư 91/2026/TT-BTC Quy định một số điều của Luật Quản lý thuế và Nghị định số 254/2026/NĐ-CP của Chính phủ quy định chi tiết một số điều và biện pháp để tổ chức, hướng dẫn thi hành Luật Quản lý thuế số 108/2025/QH15 về hóa đơn điện tử, chứng từ điện tử.</div>' +

                            '</div>' +
                            '<div class="based-on bienban-title-name">' +
                            'Hôm nay, ngày <input type="date" id="nvban" name="DocTime" class="bienban-title-name input-dotted" value="" placeholder="__/__/____">, đại diện hai bên gồm có:' +
                            '</div>' +

                            '<!-- Bên A -->' +
                            '<div class="bienban-title-name">BÊN A (Bên bán):' +
                            '<input type="text" id="seller_name" class="input-dotted bienban-benban" name="SellerCom" value="">' +
                            '</div>' +
                            '<div class="bienban-normal-indent">' +
                            '<div>Mã số thuế:' +
                            '<input type="text" id="seller_tax" class="input-dotted bienban-input" name="BuyerAdr" style="width: 89%" value="" readonly>' +
                            '</div>' +
                            '<div>Địa chỉ:' +
                            '<input type="text" id="seller_address" class="input-dotted bienban-input" name="SellerAdr" style="width: 91%" value="">' +
                            '</div>' +
                            '<div class="bienban-around">' +
                            '<div style="width: 50%">' +
                            'Đại diện: Ông/bà <input type="text" id="seller_represent" class="input-dotted bienban-input" style="width: 65%; margin-right: 12px" value="">' +
                            '</div>' +
                            '<div style="width: 50%">' +
                            'Chức vụ: <input type="text" id="seller_pos" class="input-dotted bienban-input" style="width: 67%" value="">' +
                            '</div>' +
                            '</div>' +
                            '<div class="bienban-around">' +
                            '<div style="width: 50%">' +
                            'Email: <input type="text" id="seller_email" class="input-dotted bienban-input" style="width:82%" value="">' +
                            '</div>' +
                            '<div style="width: 50%">' +
                            'Số điện thoại: <input type="text" id="seller_phone"  class="input-dotted bienban-input" style="width: 60%" value="">' +
                            '</div>' +
                            '</div>' +
                            '</div>' +

                            '<!-- Bên B -->' +
                            '<div class="bienban-title-name">BÊN B (Bên mua):' +
                            '<input type="text" id="ten" class="input-dotted bienban-benmua" name="BuyerCom" value="">' +
                            '</div>' +
                            '<div class="bienban-normal-indent">' +
                            '<div>Mã số thuế:' +
                            '<input type="text" id="mst" class="input-dotted bienban-input" name="BuyerAdr" style="width: 89%" value="">' +
                            '</div>' +
                            '<div>Địa chỉ:' +
                            '<input type="text" id="dchi" class="input-dotted bienban-input" name="BuyerAdr" style="width: 91%" value="">' +
                            '</div>' +
                            '<div class="bienban-around">' +
                            '<div style="width: 50%">' +
                            'Đại diện: Ông/bà <input type="text" id="tnmua" class="input-dotted bienban-input" style="width: 65%; margin-right: 12px" value="">' +
                            '</div>' +
                            '<div style="width: 50%">' +
                            'Chức vụ: <input type="text" id="position" class="input-dotted bienban-input" style="width: 67%" value="">' +
                            '</div>' +
                            '</div>' +
                            '<div class="bienban-around">' +
                            '<div style="width: 50%">' +
                            'Email: <input type="text" id="email" class="input-dotted bienban-input" style="width:82%" value="">' +
                            '</div>' +
                            '<div style="width: 50%">' +
                            'Số điện thoại: <input type="text" id="sdtnmua" class="input-dotted bienban-input" style="width: 60%" value="">' +
                            '</div>' +
                            '</div>' +
                            '<div class="normal" id="hoadontext"></div>' +
                            '</div>' +

                            '<div class="bienban-title-name">Lý do điều chỉnh:</div>' +
                            '<textarea id="lydo" class="input-dotted bienban-input" style="width: 97%" value=""></textarea>' +
                            /*'<div class="bienban-title-name">NỘI DUNG TRƯỚC KHI ĐIỀU CHỈNH:</div>' +
                            '<textarea rows="3" id="txtContentBefAdjust" class="bienban-textarea-line" style="width: 100%"></textarea>' +
                            '<div class="bienban-title-name">HAI BÊN THỐNG NHẤT ĐIỀU CHỈNH LẠI NHƯ SAU:</div>' +
                            '<textarea rows="3" id="txtContentAdjust" class="bienban-textarea-line" style="width: 100%"></textarea>' +*/

                            '<div class="bienban-input" >Chúng tôi cam kết và hoàn toàn chịu trách nhiệm về việc hóa đơn này.</div>' +
                            '<div class="bienban-input" >Biên bản được lập thành 02 (hai) bản, mỗi bên giữ 01 (một) bản, có giá trị pháp lý như nhau.</div>' +
                            /*'<div class="bienban-represent">' +
                            '<span class="buyer-bienban-represent">ĐẠI DIỆN BÊN A</span>' +
                            '<span class="seller-bienban-represent">ĐẠI DIỆN BÊN B</span>' +
                            '</div>' +*/
                            '<input type="hidden" id="bienban_kemtheo_id"/>' +
                            '<input type="hidden" id="nlap"/>' +
                            '<input type="hidden" id="hdon_id"/>' +
                            '<input type="hidden" id="cctbao_id"/>' +
                            '</div>'
                    }
                },
                {
                    margin: 10,
                    cols: [
                        {},
                        {
                            shortcut: "F10", id: "btnBienBanEdit", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
                            click: function () {
                                var win = this.getTopParentView();
                                var htmltag = $$("bienbanDetail").getNode();
                                var values = {};
                                webix.extend(win, webix.ProgressBar);
                                win.disable();
                                win.showProgress();
                                htmltag.querySelectorAll("input, textarea, select").forEach(function (el) {
                                    var key = el.id;
                                    if (key) {
                                        values[key] = el.value || "";
                                    }
                                });

                                var requiredFields = ["svban", "nvban", "seller_name", "seller_tax",
                                    "seller_address", "email", "lydo"];
                                if (!validateRequiredInputs("bienbanDetail", requiredFields)) {
                                    webix.message("Vui lòng nhập đầy đủ các trường bắt buộc", "error");
                                    win.enable();
                                    win.hideProgress();
                                    return;
                                }

                                if (!webix.rules.isEmail(values.email)) {
                                    webix.message("Email không đúng định dạng!", "error");
                                    win.enable();
                                    win.hideProgress();
                                    return;
                                }

                                var data_post = {
                                    editmode: editmode,
                                    data: values
                                };

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/SaveBienBan", data_post, {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(text + XmlHttpRequest, "error");
                                            win.enable();
                                            win.hideProgress();
                                            var table = webix.$$("bienbanthoathuan");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var json = JSON.parse(text);
                                            if (json.hasOwnProperty("error")) {
                                                webix.message(json.error, "error");
                                            } else {
                                                webix.message(editmode == 2 ? "Sửa biên bản thành công !" : "Tạo biên bản thành công !", "success");

                                                win.close();
                                            }
                                            win.enable();
                                            win.hideProgress();
                                            var table = webix.$$("bienbanthoathuan");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        },

                                    });
                            }
                        },
                        {
                            view: "button", id: "btnBienBanDelete", hotkey: "delete", hidden: true, label: "Xóa (Delete)", align: "center", type: "danger", width: 100,
                            click: function () {
                                var win = this.getTopParentView();
                                webix.confirm({
                                    text: "Bạn có muốn xóa bản ghi",
                                    ok: "Có",
                                    cancel: "Không",
                                    callback: function (result) {
                                        if (result) {
                                            var hdonElement = document.getElementById("bienban_kemtheo_id");
                                            var bienban_kemtheo_id = hdonElement ? hdonElement.value : "";
                                            editmode = 3;

                                            if (bienban_kemtheo_id.length == 0) {
                                                webix.message("Không tồn tại biên bản!", "error");
                                                return;
                                            }

                                            var data_post = {
                                                editmode: editmode,
                                                data: {
                                                    bienban_kemtheo_id: bienban_kemtheo_id
                                                }
                                            }

                                            webix
                                                .ajax()
                                                .headers({ "Content-type": "application/json" })
                                                .post(app.config.host + "/Invoice68/SaveBienBan", data_post, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(text + XmlHttpRequest, "error");
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text);
                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message(json.error, "error");
                                                            var table = webix.$$("bienbanthoathuan");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                        } else {
                                                            webix.message("Xóa biên bản thành công !", "success");
                                                            win.close();
                                                            var table = webix.$$("bienbanthoathuan");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                        }
                                                    },
                                                });
                                        }
                                    }
                                });
                            }
                        },
                        {
                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", type: "danger", width: 120,
                            click: function () {
                                var win = this.getTopParentView();
                                win.close();
                                var table = webix.$$("bienbanthoathuan");
                                table.clearAll();
                                table.load(table.config.url);
                            }
                        },
                        {}
                    ]
                }

            ]
        }
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix
                    .ajax()
                    .sync()
                    .get(app.config.host + "/System/GetDmDvcsByUser");
                var json = JSON.parse(result.response);
                webix.delay(function () {
                    var data = json[0];
                    var map = {
                        seller_name: "name",
                        seller_tax: "tax_code",
                        seller_represent: "manager",
                        seller_address: "address",
                        seller_email: "email",
                        seller_phone: "tel"
                    };

                    Object.keys(map).forEach(function (id) {
                        var el = document.getElementById(id);
                        if (el) el.value = data[map[id]] || "";
                    });

                });
            } else {
                if (editmode == 2) {
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    $$('btnBienBanDelete').show();
                }
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }
            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
        setValues: function (item, winconfig, params) {
            webix.delay(function () {
                var htmltag = $$("bienbanDetail").getNode();
                var inputs = htmltag.querySelectorAll("input, textarea, select");
                var khieu = item.khieu ? "ký hiệu " + item.khieu : "";
                var shdon = item.shdon ? " số " + item.shdon : "";
                var ttthdon = (!item.ttthdon || item.ttthdon == "Gốc") ? "" : item.ttthdon;
                var nlap = moment(item.nlap).format("DD/MM/YYYY") ? " ngày " + moment(item.nlap).format("DD/MM/YYYY") : "";
                inputs.forEach(function (el) {
                    var key = el.id || el.name; // Ưu tiên id, fallback về name
                    if (key && item.hasOwnProperty(key)) {
                        var value = item[key] || "";

                        // Nếu là input type date → format lại yyyy-MM-dd
                        if (el.type === "date" && value) {
                            var date = new Date(value);
                            if (!isNaN(date.getTime())) {
                                value = moment(value).format("YYYY-MM-DD");
                            }
                        }

                        el.value = value;
                    }

                    if (el.id === "svban" && !value) {
                        value = "BB-" + (item.khieu || "") + (item.shdon || "");
                        el.value = value;
                    }
                });

                if (item.trang_thai != "0" && item.trang_thai) {
                    $$('btnBienBanDelete').hide();
                    $$('btnBienBanEdit').hide();
                }

                // Gán ngày hiện tại nếu không có
                var dateInput = document.getElementById("nvban");
                if (dateInput && !dateInput.value) {
                    var today = moment(new Date()).format("YYYY-MM-DD");
                    dateInput.value = today;
                }
                var hoadontext = 'Hai bên thống nhất lập biên bản ' + ttthdon + ' hóa đơn ' + khieu + shdon + nlap + ' theo quy định.';
                document.getElementById("hoadontext").innerText = hoadontext;
                var title = '<strong>BIÊN BẢN THỎA THUẬN LẬP HÓA ĐƠN ĐIỆN TỬ ' + ttthdon.toUpperCase(); + '</strong>';
                document.getElementById("title").innerHTML = title;
            });
        }
    };
});

define('views/68_bienbanthoathuan',["app", "locale", "models/user", "views/forms/68_bienbanthoathuanform", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    bienbanthoathuanform,
    hoadonHistory,
    commonHD
) {
    

    var initUI = function () {
        var table = webix.$$("bienbanthoathuan");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {

                var url = app.config.host + "/Invoice68/GetBienBanThoaThuan";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                                filterType: column.header[1].content,
                            };


                            if (item.value != null && item.value != "") {
                                array.push(item);
                            }
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                //url = url + "&loaibth=4";
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("bienbanthoathuan");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Sửa" + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("bienbanthoathuan");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng nào ! ", "error");
                        return;
                    }

                    var detailForm = this.$scope.ui(bienbanthoathuanform.$ui);
                    bienbanthoathuanform.setEditMode(2);
                    bienbanthoathuanform.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("bienbanthoathuan");
                    var datafrm = table.serialize();
                    debugger
                    var data_id = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    if (datafrm[i].trang_thai != 0) {
                                        webix.message("Biên bản đã ký, không thể xóa ! ", "error");
                                        return;
                                    }
                                    data_id.push(datafrm[i].bienban_kemtheo_id);
                                }
                            }
                        }
                    }

                    if (data_id.length <= 0) {
                        webix.message("Chưa tích chọn bản ghi hoặc bản ghi đã ký!");
                        return;
                    }

                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                data_id.forEach(function (bienban_kemtheo_id) {
                                    var data_post = {
                                        editmode: 3,
                                        data: {
                                            bienban_kemtheo_id: bienban_kemtheo_id
                                        }
                                    }
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Invoice68/SaveBienBan", data_post, function (text) {
                                            var response = JSON.parse(text);

                                            if (response.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: response.error });
                                                return;
                                            }
                                            // table.remove(item.id);
                                            var btnRefresh = $$("btnRefresh");
                                            btnRefresh.callEvent("onClick");

                                        });
                                })

                            }
                        },
                    });

                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký biên bản") + "</span>",
            id: "btnSign",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("bienbanthoathuan");
                    var datafrm = tableDK.serialize();

                    var data_id = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    if (datafrm[i].trang_thai != 0) {
                                        webix.message("Biên bản không tồn tại trạng thái chờ ký! ", "error");
                                        return;
                                    }
                                    data_id.push(datafrm[i].bienban_kemtheo_id);
                                }
                            }
                        }
                    }
                    if (data_id.length > 0) {
                        commonHD.KyBienBanThoaThuan(data_id);
                    } else {
                        webix.message("Chưa tích chọn bản ghi hoặc bản ghi đã ký!");
                    }
                    var btnRefresh = $$("btnRefresh");
                    btnRefresh.callEvent("onClick");
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-envelope fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Gửi người mua ký") + "</span>",
            id: "btnEmail",
            on: {
                onClick: function () {
                    var table = webix.$$("bienbanthoathuan");
                    var item = table.getSelectedItem();

                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên bản cần email!", "error");
                        return;
                    }
                    if (item.trang_thai == "0") {
                        webix.message("Biên bản chưa ký không thể gửi email !", "error");
                        return;
                    }
                    require(["views/forms/sendemailbienban", "app"], function (sendemail, app) {
                        var url = "/Invoice68/GetEmailTemplateBienBan?type=Gửi biên bản thỏa thuận&id=" + item.bienban_kemtheo_id;
                        webix.ajax(app.config.host + url, function (text) {
                            var json = JSON.parse(text);
                            var win = webix.$$("bienbanthoathuan").$scope.ui(sendemail.$ui);
                            var hoadon = {
                                nguoi_gui: json.sender,
                                tieude: json.subject,
                                noidung: json.body,
                                mat_khau: json.pass,
                                inv_invoiceauth_id: item.bienban_kemtheo_id,
                                id: item.bienban_kemtheo_id,
                                type: "Gửi biên bản thỏa thuận",
                                nguoinhan: item.email,
                                his_email: json.his_email,
                                lst_email: json.lst_email,
                                otp: json.otp,
                                hdon68: 1,
                                alias: json.alias,
                            };

                            //console.log(JSON.stringify(json.lst_email));
                            sendemail.setValues(hoadon);
                            win.show();
                        });
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "uploader",
            view: "uploader",
            type: "htmlbutton",
            label:
                '<i class="fas fa-folder-open" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Upload biên bản có xác nhận người mua") + "</span>",
            name: "uploader",
            width: 150,
            accept: "application/pdf",
            //link: "mylist",
            autosend: true,
            multiple: false,
            upload: app.config.host + "/Invoice68/UploadBienBanThoaThuan",
            on: {
                onBeforeFileAdd: function (file) {
                    var selected = $$("bienbanthoathuan").getSelectedItem();
                    if (!selected) {
                        webix.message("Bạn chưa chọn dòng!", "error");
                        return false;
                    }

                    if (selected.trang_thai == "0") {
                        webix.message("Biên bản thỏa thuận chưa được ký! ", "error");
                        return;
                    }

                    if (!file.name.endsWith(".pdf")) {
                        webix.alert("Vui lòng chọn đúng định dạng PDF!");
                        return false;
                    }

                    this.bienban_kemtheo_id = selected.bienban_kemtheo_id;

                    return true;
                },
                onAfterFileAdd: function (file) {
                    var uploader = this;
                    var item = uploader.files.getItem(file.id);
                    var formData = new FormData();

                    formData.append("file", item.file);
                    formData.append("bienban_kemtheo_id", uploader.bienban_kemtheo_id);

                    webix.ajax()
                        .post(app.config.host + "/Invoice68/UploadBienBanThoaThuan", formData)
                        .then(function (res) {
                            debugger
                            if (res.hasOwnProperty("error")) {
                                webix.message({ type: "error", text: res.error });
                                return;
                            }
                            else { webix.message("Upload file thành công!"); }
                        })
                        .catch(function (err) {
                            webix.message("Upload file lỗi!", "error");
                        });

                    uploader.files.remove(file.id);

                    return false;
                },
                onUploadComplete: function (response) {
                    if (!response) return;
                    if (response.error) {
                        webix.message({ type: "error", text: response.error });
                    } else {
                        webix.message("Upload file thành công!");
                        // Optional: reload bảng nếu cần
                        // $$("bienbanthoathuan").reload();
                    }
                },
                onFileUploadError: function (file, response) {
                    webix.message("Tải file thất bại!", "error");
                },
            },
            apiOnly: true,
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải XML") + "</span>",
            id: "btnDownloadXml",
            on: {
                onClick: function () {
                    var table = webix.$$("bienbanthoathuan");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.dlxml == null || selectedItem.dlxml == "") {
                        webix.message("Bảng tổng hợp chưa gửi CQT không tồn tại xml ! ", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLBienBan?id=" + selectedItem.bienban_kemtheo_id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "BienBan.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("In") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("bienbanthoathuan");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng in ! ", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang in biên bản ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });
                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inMauBienBan?id=" + selectedItem.bienban_kemtheo_id, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });

                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải biên bản có xác nhận người mua") + "</span>",
            id: "btnDownload",
            // view: "button",
            // id: "btnDownload",
            // type: "icon",
            // icon: "download",
            // label: "Tải (F8)",
            // width: 100,
            on: {
                onClick: function () {
                    var table = webix.$$("bienbanthoathuan");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn biên bản cần tải! ", "error");
                        return;
                    }

                    if (selectedItem.trang_thai != 2) {
                        webix.message("Biên bản chưa được người mua xác nhận! ", "error");
                        return;
                    }

                    var url = app.config.host + "/Invoice68/DowloadBienBanKy?id=" + selectedItem.bienban_kemtheo_id;

                    if (selectedItem.dlbienban == null) {
                        url = app.config.host + "/Invoice68/inMauBienBan?id=" + selectedItem.bienban_kemtheo_id;
                    }

                    var box = webix.modalbox({
                        title: "Đang tải biên bản thỏa thuận(PDF) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: "application/pdf" });
                            webix.html.download(file, "BienBan.pdf");
                            var fileURL = URL.createObjectURL(file);
                            //console.log(fileURL);
                            webix.modalbox.hide(box);
                            window.open(fileURL, '_blank');
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "bienbanthoathuan",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) { },
                },
                onClick: {
                    TaiXMLBienBan: function (event, cell, target) {
                        var table = webix.$$("bienbanthoathuan");
                        var record = table.getItem(cell.row);

                        if (record.dlxml == null || record.dlxml == "") {
                            webix.message("Biên bản chưa được ký!", "error");
                            return;
                        }

                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();

                        var url = app.config.host + "/Invoice68/ExportXMLBienBan?id=" + record.bienban_kemtheo_id;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                table.enable();
                                table.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, "BienBan.xml");
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });

                        return false;
                    },
                    InBienBan: function (event, cell, target) {
                        var table = webix.$$("bienbanthoathuan");
                        var item = table.getItem(cell.row);

                        if (item.dlxml == null || item.dlxml == "") {
                            webix.message("Biên bản chưa được ký!", "error");
                            return;
                        }

                        var box = webix.modalbox({
                            title: "Đang in biên bản ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });
                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMauBienBan?id=" + item.bienban_kemtheo_id, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },

                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("bienbanthoathuan");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () { },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "index",
                        header: "STT",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "svban",
                        header: [
                            "Số biên bản",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 150,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "khieu",
                        header: [
                            "Ký hiệu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 100,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "shdon",
                        header: [
                            "Số hóa đơn",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 100,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ttthdon",
                        header: [
                            "Trạng thái hóa đơn",
                            {
                                content: "serverMultiSelectFilter",
                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00502",
                            },
                        ],

                        template: function (obj, common) {
                            return "<span class='mcls_status" + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        },
                        width: 150,
                    },
                    {
                        id: "trang_thai",
                        header: ["Trạng thái gửi", { content: "serverMultiSelectFilter", options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00574" }],
                        collection: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00574",
                        width: 120,
                    },
                    {
                        id: "issendmail",
                        header: [
                            "Gửi mail",
                            {
                                content: "serverSelectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "0", value: "Chưa gửi" },
                                    { id: "1", value: "Đã gửi" },
                                ],
                            },
                        ],
                        disable: true,
                        css: {
                            "text-align": "center",
                        },
                        template: function (obj) {
                            return "<input type='checkbox' disabled " + (obj.issendmail ? "checked" : "") + ">";
                        },
                        width: 80,
                    },
                    {
                        id: "btnMessagetn",
                        header: ["", "Lịch sử"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                        },
                        width: 100,
                    },
                    {
                        id: "lydo",
                        header: [
                            "Lý do",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "nvban",
                        header: [
                            "Ngày tạo",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },
                    {
                        id: "nky",
                        header: [
                            "Ngày ký",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: {
                            "text-align": "center",
                        },
                        columnType: "datetime",
                    },
                    {
                        id: "email",
                        header: [
                            "Email",
                            {
                                content: "textFilter",
                            },
                        ],
                        css: {
                            "text-align": "center",
                        },
                        width: 120,
                    },
                    {
                        id: "ngtao",
                        header: [
                            "Người tạo",
                            {
                                content: "textFilter",
                            },
                        ],
                        css: {
                            "text-align": "center",
                        },
                        width: 120,
                    },
                    {
                        id: "bthTaiXMLBienBan",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.dlxml != null && obj.dlxml != "") {
                                return "<span class='TaiXMLBienBan' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='TaiXMLBienBan' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "btnInBienBan",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.dlxml != null && obj.dlxml != "") {
                                return "<span class='InBienBan' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InBienBan' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 120,
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("bienbanthoathuan");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({
                title: "Danh sách biên bản",
                details: "Danh sách biên bản",
            });
            var table = webix.$$("bienbanthoathuan");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangebienbanthoathuan", function (mode, item) {
                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },

        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});


define('views/modules/minvoiceplugin',["app", "models/user"], function (app, user) {

    var isConnected = false;
    var isWindowXP = function () {
        return navigator.userAgent.indexOf("Windows NT 5.1") != -1;
    }
    var isLocked = false;
    if (!isWindowXP()) {
        var urls = ["http://localhost:17997/signalr", "http://localhost:19898/signalr"];
        var connection = null;
        var hub = null;

        function connectToSignalR(urlIndex) {
            if (urlIndex >= urls.length) {
                console.log('All connection attempts failed.');
                return;
            }

            var url = urls[urlIndex];
            var conn = $.hubConnection(url, {
                useDefaultPath: false
            });

            hub = conn.createHubProxy('invoiceHub');

            // Xử lý khi nhận sự kiện từ hub
            hub.on('resCommand', function (result) {

            });

            // Xử lý khi kết nối bị ngắt
            conn.disconnected(function () {
                console.log('Connection disconnected');
                isConnected = false;
                isLocked = false;
            });

            // Bắt đầu kết nối
            conn.start().done(function () {
                console.log("Connected to Plugin Id: " + hub.connection.id + " at " + urls[urlIndex]);
                isConnected = true;
                isLocked = false;
            }).fail(function () {
                console.log('Failed to connect to ' + urls[urlIndex]);
                // Nếu kết nối thất bại, thử kết nối URL tiếp theo
                if (urlIndex == urls.length - 1) {
                    isConnected = false;
                    var userApp = user.getAppCookie();
                    var url = app.config.host + "/System/ExecuteCommand";
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .post(url,
                            {
                                command: "CM00005",
                                parameter: {
                                    wb_user_id: userApp.wb_user_id
                                }
                            }
                            , function (text) {
                                var json = JSON.parse(text);
                                if (json.length > 0 && json.filter(function (x) { return x.chon1 == 'C' }).length > 0)
                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn (Tiện ích > Plugin ký hóa đơn) hoặc Plugin ký hóa đơn chưa được bật !", "debug");
                            });
                }
                else {
                    connectToSignalR(urlIndex + 1);
                }
            });
            connection = conn;

        }

        // Bắt đầu kết nối ngay lập tức khi module được nạp
        connectToSignalR(0);

        return {
            hub: function () {
                return hub;
            },
            conn: function () {
                if (connection.state != 1) {
                    connection.start();
                }
                return connection;
            },
            isConnected: isConnected,
            setLocked: function (locked) {
                isLocked = locked;
            },
            getLocked: function () {
                return isLocked;
            }
        };

    } else {
        var url = "ws://localhost:19898/service";
        var hub = {};
        window.fn = undefined;
        window.state = undefined;
        hub.ws = undefined;

        hub.conn = function () {
            window.state = 1;
            hub.ws = new WebSocket(url);
            // hub.ws.onopen = hub.onOpen;
            hub.ws.onclose = hub.onClose;
            //  hub.ws.onmessage = hub.on;
            hub.ws.onerror = hub.onError;
        }
        var conn = function () {
            return { state: window.state };
        }
        hub.off = function (_) {

        }
        hub.invoke = function (_, str2, json) {
            if (hub.ws != undefined) {
                hub.ws.onopen = function () {
                    var obj = {
                        execCommand: str2,
                        arg: JSON.parse(json)
                    }
                    if (hub.ws.readyState == WebSocket.OPEN) {
                        hub.ws.send(JSON.stringify(obj));
                    }
                }

            } else {
                console.log('Websocket is not initialized');
            }
            return hub;
        };
        hub.onError = function (arg) {
            window.state = -1;
            if (hub.ws != undefined) {
                isConnected = false;
                var userApp = user.getAppCookie();
                var url = app.config.host + "/System/ExecuteCommand";
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .post(url,
                        {
                            command: "CM00005",
                            parameter: {
                                wb_user_id: userApp.wb_user_id
                            }
                        }
                        , function (text) {
                            console.log(1);
                            var json = JSON.parse(text);
                            if (json.length > 0 && json.filter(function (x) { return x.chon1 == 'C' }).length > 0)
                                webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn (Tiện ích > Plugin ký hóa đơn) hoặc Plugin ký hóa đơn chưa được bật !", "debug");
                        });
            } else {
                console.log('Websocket is not initialized');
            }
        }
        hub.on = function (str, fn_in) {
            if (hub.ws != undefined) {
                window.fn = fn_in;
                hub.ws.onmessage = func;
            } else {
                console.log('Websocket is not initialized');
            }
        }
        var func = function (result) {
            return window.fn(result.data);
        }
        hub.onClose = function (arg) {
            if (hub.ws != undefined) {
                console.log('DISCONNECTED');
                isConnected = false;
                isLocked = false;
            } else {
                console.log('Websocket is not initialized');
            }
        };

        hub.onOpen = function (arg) {
            if (hub.ws != undefined) {
                isConnected = true;
                isLocked = false;
                window.state = hub.ws.readyState;
            } else {
                isConnected = false;
                isLocked = true;
                console.log('Websocket is not initialized');
            }
        };
        hub.done = function (fn) {
            fn();
            return hub;
        }
        hub.fail = function (fn) {
            return hub;
        }

        return {
            hub: function () {
                hub.conn();

                return hub;
            },
            conn: function () {
                return conn();
            },
            isConnected: isConnected,
            setLocked: function (locked) {
                isLocked = locked;
            },
            getLocked: function () {
                return isLocked;
            }
        };
    }
});
define('views/forms/68_dangkysudung_bienlai',["app", "locale", "models/user", "views/modules/minvoiceplugin"], function (app, _, user, plugin) {
    

    webix.$$("title").parse({ title: "Đăng ký sử dụng", details: "Đăng ký sử dụng" });
    var editmode = 0;

    function listToTreeCustomize(json) {
        return json.map(function(item) {
            return {
                id: item.code,
                name: item.name != null ? item.name.toString() : "",
                code: item.code
            };
        });
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Đăng ký/thay đổi thông tin sử dụng chứng từ điện tử<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_dksdForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "dangkysudungForms",
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () { },
            },
            body: {
                view: "form",
                id: "dangkysudung",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        cols: [
                            {
                                view: "radio",
                                id: "loai",
                                name: "loai",
                                width: 200,
                                value: 1,
                                options: [
                                    { id: 1, value: "Đăng ký" }, // the initially selected item
                                    { id: 2, value: "Thay đổi" },
                                ],
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("header").define(
                                                "template",
                                                "<center><b><span style='font-size:17px;'>TỜ KHAI</span> </br> THAY ĐỔI THÔNG TIN SỬ DỤNG CHỨNG TỪ ĐIỆN TỬ</b></center>"
                                            );
                                            $$("header").refresh();
                                        } else {
                                            $$("header").define(
                                                "template",
                                                "<center><b><span style='font-size:17px;'>TỜ KHAI</span> </br> ĐĂNG KÝ THÔNG TIN SỬ DỤNG CHỨNG TỪ ĐIỆN TỬ</b></center>"
                                            );
                                            $$("header").refresh();
                                        }
                                    },
                                },
                            },
                            {
                                id: "header",
                                template: "<center><b><span style='font-size:17px;'>TỜ KHAI</span> </br>ĐĂNG KÝ THÔNG TIN SỬ DỤNG CHỨNG TỪ ĐIỆN TỬ</b></center>",
                                borderless: true,
                                height: 40,
                            },
                        ],
                    },
                    {
                        paddingX: 40,
                        rows: [
                            {
                                view: "text",
                                label: "Tên người nộp thuế: ",
                                labelWidth: 150,
                                name: "tnnt",
                                id: "tnnt",
                                required: true,
                                invalidMessage: "Tên người nộp thuế không được để trống !",
                                css: "mcls_uppercase",
                            },
                            {
                                view: "search",
                                label: "Mã số thuế",
                                id: "mst",
                                name: "mst",
                                labelWidth: 150,
                                required: true,
                                invalidMessage: "Mã số thuế không được để trống !",
                                on: {
                                    onSearchIconClick: function () {
                                        var mst = this.getValue();
                                        window.open("http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst);
                                    },
                                },
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        id: "cqtqly_hidden",
                                        name: "cqtqly",
                                        hidden: true
                                    },
                                    {
                                        id: "cqtqly",
                                        view: "combo",
                                        valueField: "name", // Chỉ định rõ ràng rằng combo sẽ lấy giá trị từ trường name   
                                        label: "Cơ quan thuế quản lý: ",
                                        labelWidth: 150,
                                        options: {
                                            view: "gridsuggest",
                                            columnName: "name",
                                            url: {
                                                $proxy: true,
                                                load: function (view, callback, params) {
                                                    var url = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00251";
                                                    webix.ajax(url, function (text) {
                                                        var json = JSON.parse(text);
                                                        var data = listToTreeCustomize(json);
                                                        view.parse(data, "json");
                                                    });
                                                },
                                            },
                                            body: {
                                                columns: [ { id: "name", width: 225, header: "Tên" }, { id: "code", width: 100, header: "Mã" }],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    $$("cqtqly_hidden").setValue(obj["name"]); // Lưu item.name vào trường ẩn
                                                    $$("cqtqly_hidden").refresh();

                                                    $$("mcqtqly").setValue(obj["code"]);
                                                    $$("mcqtqly").refresh();
                                                },
                                            },
                                        },
                                        required: true,
                                        invalidMessage: "Cơ quan thuế quản lý không được để trống !",
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "text",
                                                label: "Mã CQT quản lý: ",
                                                labelWidth: 150,
                                                name: "mcqtqly",
                                                id: "mcqtqly",
                                                required: true,
                                                invalidMessage: "Mã cơ quan thuế quản lý không được để trống !",
                                                attributes: { maxlength: 5 },
                                                readonly: true,
                                            },
                                            {
                                                view: "text",
                                                label: "Địa danh: ",
                                                labelWidth: 80,
                                                name: "ddanh",
                                                id: "ddanh",
                                                required: true,
                                                invalidMessage: "Địa danh không được để trống !",
                                                attributes: { maxlength: 50 },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Người liên hệ: ",
                                        labelWidth: 150,
                                        name: "nlhe",
                                        id: "nlhe",
                                        required: true,
                                        invalidMessage: "Người liên hệ không được để trống !",
                                        attributes: { maxlength: 50 },
                                    },
                                    {
                                        view: "text",
                                        label: "Điện thoại liên hệ: ",
                                        labelWidth: 150,
                                        name: "dtlhe",
                                        id: "dtlhe",
                                        required: true,
                                        invalidMessage: "Điện thoại liên hệ không được để trống !",
                                        attributes: { maxlength: 20 },
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Địa chỉ liên hệ: ",
                                        labelWidth: 150,
                                        name: "dclhe",
                                        id: "dclhe",
                                        required: true,
                                        invalidMessage: "Địa chỉ liên hệ không được để trống !",
                                        attributes: { maxlength: 400 },
                                    },
                                    {
                                        view: "text",
                                        label: "Thư điện tử: ",
                                        labelWidth: 150,
                                        name: "dctdtu",
                                        id: "dctdtu",
                                        validate: webix.rules.isEmail,
                                        required: true,
                                        invalidMessage: "Thư điện tử không hợp lệ !",
                                        attributes: { maxlength: 50 },
                                    },
                                ],
                            },
                            // {
                            //     cols: [
                            //         {
                            //             view: "text",
                            //             label: "Căn cứ: ",
                            //             labelWidth: 100,
                            //             name: "ccu",
                            //             id: "ccu",
                            //             required: true,
                            //             invalidMessage: "Căn cứ không được để trống !",
                            //             attributes: {
                            //                 maxlength: 500,
                            //             },
                            //         },
                            //         {
                            //             view: "text",
                            //             label: "Thư điện tử: ",
                            //             labelWidth: 150,
                            //             name: "dctdtu",
                            //             id: "dctdtu",
                            //             validate: webix.rules.isEmail,
                            //             required: true,
                            //             invalidMessage: "Thư điện tử không hợp lệ !",
                            //         },
                            //     ],
                            // },
                            { height: 5 },
                        ],
                    },
                    {
                        paddingX: 40,
                        rows: [
                            { view: "label", label: "Theo Nghị định số 70/2025/NĐ-CP ngày 20 tháng 3 năm 2025 của Chính phủ, chúng tôi/tôi thuộc đối tượng sử dụng chứng từ điện tử. Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng chứng từ điện tử như sau:" }
                        ]
                    },
                    {
                        rows: [
                            { view: "label", label: "<b>1. Đối tượng phát hành:</b>" },
                            {
                                view: "checkbox",
                                id: "tccnphanh",
                                name: "tccnphanh",
                                labelRight: "Tổ chức, cá nhân phát hành",
                                value: 1,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            //$$("dcqtphanh").setValue(1);
                                            $$("dcqtphanh").setValue(0);
                                        }
                                    },
                                },
                            },
                            {
                                view: "checkbox",
                                id: "dcqtphanh",
                                name: "dcqtphanh",
                                labelRight: "Cơ quan thuế phát hành",
                                //value: 1,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            //$$("tccnphanh").setValue(1);
                                            $$("tccnphanh").setValue(0);
                                        }
                                    },
                                },
                            },
                            { view: "label", label: "<b>2. Loại hình sử dụng:</b>" },
                            {
                                view: "checkbox",
                                id: "cttncnhan",
                                name: "cttncnhan",
                                labelRight: "Chứng từ điện tử khấu trừ thuế thu nhập cá nhân",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             //$$("cttncnhan").setValue(0);
                                //             $$("ctktttmdtu").setValue(0);
                                //             $$("bltplpkin").setValue(0);
                                //             $$("bltplpin").setValue(0);
                                //             $$("blttplphi").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "ctktttmdtu",
                                name: "ctktttmdtu",
                                labelRight: "Chứng từ điện tử khấu trừ thuế đối với hoạt động kinh doanh trên nền tảng thương mại điện tử, nền tảng số",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cttncnhan").setValue(0);
                                //             //$$("ctktttmdtu").setValue(0);
                                //             $$("bltplpkin").setValue(0);
                                //             $$("bltplpin").setValue(0);
                                //             $$("blttplphi").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "bltplpkin",
                                name: "bltplpkin",
                                value: 1,
                                labelRight: "Biên lai thu thuế, phí, lệ phí không in sẵn mệnh giá",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cttncnhan").setValue(0);
                                //             $$("ctktttmdtu").setValue(0);
                                //             //$$("bltplpkin").setValue(0);
                                //             $$("bltplpin").setValue(0);
                                //             $$("blttplphi").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "bltplpin",
                                name: "bltplpin",
                                value: 1,
                                labelRight: "Biên lai thu thuế, phí, lệ phí in sẵn mệnh giá",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cttncnhan").setValue(0);
                                //             $$("ctktttmdtu").setValue(0);
                                //             $$("bltplpkin").setValue(0);
                                //             //$$("bltplpin").setValue(0);
                                //             $$("blttplphi").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "blttplphi",
                                name: "blttplphi",
                                labelRight: "Biên lai thu thuế, phí, lệ phí (CTT50)",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cttncnhan").setValue(0);
                                //             $$("ctktttmdtu").setValue(0);
                                //             $$("bltplpkin").setValue(0);
                                //             $$("bltplpin").setValue(0);
                                //             //$$("blttplphi").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            { view: "label", label: "<b>3. Hình thức gửi dữ liệu chứng từ điện tử:</b>" },
                            {
                                view: "checkbox",
                                id: "cdlqccqt",
                                name: "cdlqccqt",
                                labelRight: "Trên Cổng thông tin điện tử của cơ quan thuế",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             //$$("cdlqccqt").setValue(0);
                                //             $$("cdlqtctn").setValue(0);
                                //             $$("cdlqtctnut").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "cdlqtctn",
                                name: "cdlqtctn",
                                value: 1,
                                labelRight: "Thông qua tổ chức cung cấp dịch vụ hóa đơn điện tử",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cdlqccqt").setValue(0);
                                //             //$$("cdlqtctn").setValue(0);
                                //             $$("cdlqtctnut").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "cdlqtctnut",
                                name: "cdlqtctnut",
                                labelRight: "Thông qua tổ chức cung cấp dịch vụ hóa đơn điện tử được Tổng cục Thuế ủy thác",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cdlqccqt").setValue(0);
                                //             $$("cdlqtctn").setValue(0);
                                //             //$$("cdlqtctnut").setValue(0);
                                //         }
                                //     },
                                // },
                            }
                        ],
                    },
                    {
                        rows: [
                            {
                                view: "label",
                                label: "<b>4. Danh sách chứng thư số sử dụng:</b>",
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " Thêm",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = "";
                                                        for (var i = 0; i < result.length; i++) {
                                                            var item = result[i];
                                                            kytaptrung = item.value;
                                                        }
                                                        webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                            var listcerts = JSON.parse(text);
                                                            if (listcerts.length > 0) {
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();

                                                                                var cert = null;

                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }

                                                                                var now = new Date();
                                                                                var begin = new Date(cert.begin_date);
                                                                                var end = new Date(cert.end_date);
                                                                                if (now < begin || now > end) {
                                                                                    webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                    return;
                                                                                }

                                                                                var item = {
                                                                                    stt: $$("danhsach_chukyso").count() + 1,
                                                                                    ttchuc: cert.subject_name,
                                                                                    seri: cert.cer_serial,
                                                                                    tngay: cert.begin_date,
                                                                                    dngay: cert.end_date,
                                                                                    hthuc: "1",
                                                                                };

                                                                                // $$("danhsach_chukyso").clearAll();
                                                                                $$("danhsach_chukyso").add(item);
                                                                                return;
                                                                        }
                                                                    },
                                                                });

                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,

                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}",
                                                                        },
                                                                        {
                                                                            id: "cert_type",
                                                                            header: _("Loại"),
                                                                            width: 100,
                                                                        },
                                                                        {
                                                                            id: "cer_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 150,
                                                                        },
                                                                        {
                                                                            id: "subject_name",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "begin_date",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "end_date",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "issuer",
                                                                            header: _("DONVI"),
                                                                            width: 450,
                                                                        },
                                                                    ],
                                                                    url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                });
                                                            } else {
                                                                // xem user có tích checkbox ký HSM không?
                                                                var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                                                webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                                                    if (resultscheckSigHSM[0].json() == "C") {
                                                                        webix.ajax().get(app.config.host + "/Invoice68/GetCTS_HSM_ToKhai", function (result) {
                                                                            var ctsHSM = JSON.parse(result);

                                                                            if (ctsHSM.hasOwnProperty("error")) {
                                                                                webix.message({ type: "error", text: ctsHSM.error });
                                                                            } else {
                                                                                var item = {
                                                                                    stt: $$("danhsach_chukyso").count() + 1,
                                                                                    ttchuc: ctsHSM.subjectname,
                                                                                    seri: ctsHSM.so_serial,
                                                                                    tngay: ctsHSM.ngaybatdau,
                                                                                    dngay: ctsHSM.ngayketthuc,
                                                                                    hthuc: "1",
                                                                                };

                                                                                // $$("danhsach_chukyso").clearAll();
                                                                                $$("danhsach_chukyso").add(item);
                                                                            }
                                                                        });
                                                                    } else {
                                                                        var hub = plugin.hub();

                                                                        hub.off("resCommand");
                                                                        hub.on("resCommand", function (result) {
                                                                            var json = JSON.parse(result);

                                                                            if (json.hasOwnProperty("error")) {
                                                                                webix.message({ type: "error", text: json.error });
                                                                            } else {
                                                                                var callback = json.callback;

                                                                                if (callback == "RegisterCert") {
                                                                                    var item = {
                                                                                        stt: $$("danhsach_chukyso").count() + 1,
                                                                                        ttchuc: json.data.subjectname,
                                                                                        seri: json.data.so_serial,
                                                                                        tngay: json.data.ngaybatdau,
                                                                                        dngay: json.data.ngayketthuc,
                                                                                        hthuc: "1",
                                                                                    };

                                                                                    // $$("danhsach_chukyso").clearAll();
                                                                                    $$("danhsach_chukyso").add(item);
                                                                                }
                                                                            }
                                                                        });

                                                                        var arg = {
                                                                            callback: "RegisterCert",
                                                                        };

                                                                        hub.invoke("execCommand", arg.callback, JSON.stringify(arg));
                                                                    }
                                                                });
                                                            }
                                                        });
                                                    });
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " Xóa",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_chukyso");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {},
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_chukyso",
                                height: 250,
                                name: "danhsach_chukyso",
                                select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scroll: true,
                                fullscreen: true,
                                scheme: {
                                    $init: function (obj) { },
                                },
                                on: {},
                                columns: [
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                    },
                                    {
                                        id: "ttchuc",
                                        name: "ttchuc",
                                        header: "Tên tổ chức cơ quan chứng thực/cấp/công nhận chữ ký số, chữ ký điện tử",
                                        width: 450,
                                    },
                                    {
                                        id: "seri",
                                        name: "seri",
                                        header: "Số sê-ri chứng thư số",
                                        width: 300,
                                    },
                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                text: "Thời hạn sử dụng chứng thư số",
                                                colspan: 2,
                                            },
                                            {
                                                text: "Từ ngày",
                                            },
                                        ],
                                        width: 200,
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                text: "Đến ngày",
                                            },
                                        ],
                                        width: 200,
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "hthuc",
                                        name: "hthuc",
                                        header: "Hình thức đăng ký ( Thêm mới, Gia hạn, ngừng sử dụng)",
                                        fillspace: true,
                                        editor: "combo",
                                        options: [
                                            { id: "1", value: "Thêm mới" },
                                            { id: "2", value: "Gia hạn" },
                                            { id: "3", value: "Ngừng sử dụng" },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                    { height: 10 },
                    {
                        view: "combo",
                        label: "Loại đăng ký ủy nhiệm",
                        id: "ldkunhiem",
                        name: "ldkunhiem",
                        labelWidth: 150,
                        options: [
                            { id: 1, value: "Ủy nhiệm" },
                            { id: 2, value: "Nhận ủy nhiệm" },
                        ],
                        width: 400,
                    },
                    { height: 10 },
                    {
                        rows: [
                            {
                                view: "label",
                                label: "<b>5. Đăng ký ủy nhiệm lập biên lai:</b>",
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " Thêm",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var item = {
                                                    stt: $$("danhsach_uynhiem").count() + 1,
                                                    tlhdunhiem: "",
                                                    khmhdon: "",
                                                    khhdunhiem: "",
                                                    mstunhiem: "",
                                                    ttcdunhiem: "",
                                                    mdunhiem: "",
                                                    thunhiem: "",
                                                    tngay: new Date(),
                                                    dngay: new Date(),
                                                    pttthdunhiem: 1,
                                                    //ket_qua: 0,
                                                };
                                                // $$("danhsach_uynhiem").clearAll();
                                                $$("danhsach_uynhiem").add(item);

                                                $$("ldkunhiem").define("required", true);
                                                $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                                $$("ldkunhiem").refresh();

                                                return;
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " Xóa",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_uynhiem");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();

                                                    if (table.count() == 0) {
                                                        $$("ldkunhiem").define("required", false);
                                                        $$("ldkunhiem").refresh();
                                                    } else {
                                                        $$("ldkunhiem").define("required", true);
                                                        $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                                        $$("ldkunhiem").refresh();
                                                    }

                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();

                                                    if (table.count() == 0) {
                                                        $$("ldkunhiem").define("required", false);
                                                        $$("ldkunhiem").refresh();
                                                    } else {
                                                        $$("ldkunhiem").define("required", true);
                                                        $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                                        $$("ldkunhiem").refresh();
                                                    }

                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {},
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_uynhiem",
                                height: 250,
                                name: "danhsach_uynhiem",
                                select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scroll: true,
                                fullscreen: true,
                                scheme: {
                                    $init: function (obj) { },
                                },
                                on: {},
                                columns: [
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                    },
                                    {
                                        id: "tlhdunhiem",
                                        name: "tlhdunhiem",
                                        header: "Tên loại biên lai ủy nhiệm",
                                        width: 200,
                                        editor: "text",
                                        attributes: { maxlength: 100 },
                                    },
                                    {
                                        id: "khmhdon",
                                        name: "khmhdon",
                                        header: "Ký hiệu mẫu biên lai",
                                        width: 150,
                                        editor: "text",
                                    },
                                    {
                                        id: "khhdunhiem",
                                        name: "khhdunhiem",
                                        header: "Ký hiệu biên lai ủy nhiệm",
                                        width: 150,
                                        editor: "text",
                                    },
                                    {
                                        id: "mstunhiem",
                                        name: "mstunhiem",
                                        header: "Mã số thuế",
                                        width: 150,
                                        editor: "text",
                                    },
                                    {
                                        id: "ttcdunhiem",
                                        name: "ttcdunhiem",
                                        header: "Tên tổ chức được ủy nhiệm",
                                        width: 300,
                                        editor: "text",
                                    },
                                    {
                                        id: "mdunhiem",
                                        name: "mdunhiem",
                                        header: "Mục đích ủy nhiệm",
                                        width: 300,
                                        editor: "text",
                                    },
                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                text: "Thời hạn sử dụng chứng thư số",
                                                colspan: 2,
                                            },
                                            {
                                                text: "Từ ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                text: "Đến ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "pttthdunhiem",
                                        name: "pttthdunhiem",
                                        header: "PTTT biên lai ủy nhiệm",
                                        fillspace: true,
                                        editor: "text",
                                        //editor: "combo",
                                        // options: [
                                        //     { id: 1, value: "Tiền mặt" },
                                        //     { id: 2, value: "Chuyển khoản" },
                                        //     { id: 3, value: "Tiền mặt/Chuyển khoản" },
                                        //     { id: 4, value: "Đối trừ công nợ" },
                                        //     { id: 5, value: "Không thu tiền" },
                                        //     { id: 9, value: "Khác" },
                                        // ],
                                        width: 150,
                                    },
                                    // {
                                    //     id: "ket_qua",
                                    //     name: "ket_qua",
                                    //     header: "Kết quả",
                                    //     fillspace: true,
                                    //     format: function (text) {
                                    //         var result = "";
                                    //         if (text == 0) {
                                    //             result = "Chờ phản hồi";
                                    //         } else if (text == 1) {
                                    //             result = "Chấp nhận";
                                    //         } else if (text == 2) {
                                    //             result = "Không chấp nhận";
                                    //         }
                                    //         return result;
                                    //     },
                                    //     width: 150,
                                    // },
                                ],
                                rules: {
                                    tlhdunhiem: webix.rules.isNotEmpty,
                                    khmhdon: webix.rules.isNotEmpty,
                                    khhdunhiem: webix.rules.isNotEmpty,
                                    mstunhiem: webix.rules.isNotEmpty,
                                    ttcdunhiem: webix.rules.isNotEmpty,
                                    mdunhiem: webix.rules.isNotEmpty,
                                    tngay: webix.rules.isNotEmpty,
                                    dngay: webix.rules.isNotEmpty,
                                    pttthdunhiem: webix.rules.isNotEmpty,
                                },
                                ready: function () {
                                    var tableUyNhiem = webix.$$("danhsach_uynhiem");
                                    if (tableUyNhiem.count() == 0) {
                                        $$("ldkunhiem").define("required", false);
                                        $$("ldkunhiem").refresh();
                                    } else {
                                        $$("ldkunhiem").define("required", true);
                                        $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                        $$("ldkunhiem").refresh();
                                    }
                                },
                            },
                        ],
                    },
                    { height: 5 },
                    {
                        css: "fixbottom",
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Ghi (F10)",
                                id: "btnDKSDSave1",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("dangkysudung").getValues();
                                            item.ltkhai = 2;
                                            var table = $$("dangkysudung");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_chukyso").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa đăng ký chữ ký số cho thông báo phát hành !", "error");
                                                    return;
                                                }
                                                if (!$$("danhsach_uynhiem").validate()) {
                                                    webix.message("Bạn chưa nhập đầy đủ thông tin ủy nhiệm hóa đơn !", "error");
                                                    return;
                                                }

                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();

                                                var details = [];
                                                details.push({ data: $$("danhsach_chukyso").serialize() });
                                                item["details"] = details;

                                                var uynhiems = [];
                                                uynhiems.push({ data: $$("danhsach_uynhiem").serialize() });
                                                item["uynhiems"] = uynhiems;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/dangkysudungSave", data_post, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            table.enable();
                                                            table.hideProgress();
                                                            // var json = JSON.parse(text);
                                                            // webix.message(json.ExceptionMessage, "error");
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            table.enable();
                                                            table.hideProgress();
                                                            var json = JSON.parse(text);
                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message(json.error, "error");
                                                            } else {
                                                                app.callEvent("dataChangeDangkysudung68", [editmode, null]);

                                                                webix.message("Thành công !", "success");
                                                                webix.$$("dangkysudungForms").close();
                                                            }
                                                        },
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },

                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    webix.$$("dangkysudungForms").close();
                                },
                            },
                            {},
                        ],
                    },
                    { height: 5 },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix
                    .ajax()
                    .sync()
                    .get(app.config.host + "/System/GetDmDvcsByUser");
                var json = JSON.parse(result.response);

                $$("dclhe").setValue(json[0].address);
                $$("tnnt").setValue(json[0].name);
                $$("mst").setValue(json[0].tax_code);
                $$("dtlhe").setValue(json[0].tel);
                $$("dctdtu").setValue(json[0].email);
                $$("nlhe").setValue(json[0].manage);
            } else {
                if (editmode == 2) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            // item["tdlap"] = removeTimeZoneT(item["tdlap"]);
            form.setValues(item);
            
            $$("cqtqly").setValue(item.mcqtqly);

            // if (editmode == 2) {

            // }

            var tableDetail = webix.$$("danhsach_chukyso");
            var url = app.config.host + "/Invoice68/GetDataDangkysudungDetail?id=" + item.id;
            tableDetail.clearAll();
            tableDetail.load(url);

            var tableUyNhiem = webix.$$("danhsach_uynhiem");
            var urlUyNhiem = app.config.host + "/Invoice68/GetDataDangkysudungUyNhiem?id=" + item.id;
            tableUyNhiem.clearAll();
            tableUyNhiem.load(urlUyNhiem);
        },
        // $oninit: function (view, $scope) {
        //     var url = app.config.host + "/Invoice68/getDangkysudung";

        //     webix.ajax(url, function (text) {
        //         var json = JSON.parse(text);

        //         $$("dangkysudung").setValues(json);
        //         $$("danhsach_chukyso").parse(json["data"]);
        //     });
        // }
    };
});

define('views/68_dangkysudung_bienlai',["app", "locale", "models/user", "views/forms/68_dangkysudung_bienlai", "views/forms/68_hoadon_history"], function (app, _, user, dangkysudung, hoadonHistory) {
    

    webix.$$("title").parse({
        title: "Đăng ký/ Thay đổi thông tin SD Biên lai",
        details: "Đăng ký/ Thay đổi thông tin SD Biên lai",
    });

    var initUI = function () {
        //var windowno = app.path[1].params[0];
        //var windowno = app.path[1].params[0];
        var table = webix.$$("dangkysudung01Views");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetDataDkysdung01";
                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }
                        url = url + "&filter=" + JSON.stringify(array);
                        //console.log(JSON.stringify(array));
                    }
                }
                url = url + "&ltkhai=2";
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dangkysudung.$ui);
                    dangkysudung.setEditMode(1);

                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký cần sửa ! ", "error");
                        return;
                    }
                    // if (selectedItem.trang_thai == 1) {
                    //     webix.message("Đã gửi CQT không thể sửa", "error");
                    //     return;
                    // }
                    var detailForm = this.$scope.ui(dangkysudung.$ui);

                    dangkysudung.setEditMode(2);
                    dangkysudung.setValues(selectedItem);

                    if (selectedItem.trang_thai == 1) {
                        var form = $$("dangkysudung").elements;
                        for (var key in form) {
                            var $el = form[key];
                            $el.define("readonly", "true");
                            $el.define("css", "mcls_readonly_text");
                            $el.refresh();
                        }

                        // $$("btnDKSDSave").destructor();
                        $$("btnDKSDSave1").destructor();
                    }

                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký ! ", "error");
                        return;
                    }

                    if (selectedItem.trang_thai == 1) {
                        webix.message("Thông báo đã được ký. Bạn không thể thực hiện chức năng này ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/deleteMau01", selectedItem, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            table.remove(selectedItem.id);
                                            table.enable();
                                            table.hideProgress();
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-eye fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký và gửi CQT (F7)") + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("dangkysudung01Views");
                    var selectedItem = tableDK.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã được ký, bạn không thể ký lại ! ", "error");
                        return;
                    }
                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                            var result = JSON.parse(text);
                            var kytaptrung = "";
                            for (var i = 0; i < result.length; i++) {
                                var item = result[i];
                                kytaptrung = item.value;
                            }

                            webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                var listcerts = JSON.parse(text);
                                if (listcerts.length > 0) {
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();

                                                    var cert = null;

                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }

                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                        return;
                                                    }


                                                    var now = new Date();
                                                    var begin = new Date(cert.begin_date);
                                                    var end = new Date(cert.end_date);
                                                    if (now < begin || now > end) {
                                                        webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                        return;
                                                    }

                                                    var postData = {
                                                        branch_code: user.getDvcsID(),
                                                        username: user.getCurrentUser(),
                                                        cer_serial: cert.cer_serial,
                                                        mau01_id: selectedItem.id,
                                                    };

                                                    if (postData.mau01_id == undefined || postData.mau01_id == "") {
                                                        webix.message("Bạn chưa ghi dữ liệu, không thể ký !", "error");
                                                        return;
                                                    } else {
                                                        webix.extend(tableDK, webix.ProgressBar);
                                                        tableDK.disable();
                                                        tableDK.showProgress();
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/SignDangkysudung", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    if (json.hasOwnProperty("error")) {
                                                                        webix.message(json.error, "error");
                                                                        tableDK.enable();
                                                                        tableDK.hideProgress();
                                                                    } else {
                                                                        tableDK.enable();
                                                                        tableDK.hideProgress();
                                                                        app.callEvent("dataChangeDangkysudung68", [1, null]);

                                                                        webix.message("Ký thành công!", "success");
                                                                    }
                                                                },
                                                            });

                                                        // return;
                                                    }
                                            }
                                        },
                                    });

                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon",
                                                header: _("CHON"),
                                                width: 65,
                                                checkValue: true,
                                                uncheckValue: false,
                                                template: "{common.checkbox()}",
                                            },
                                            {
                                                id: "cert_type",
                                                header: _("Loại"),
                                                width: 100,
                                            },
                                            {
                                                id: "cer_serial",
                                                header: _("SO_SERIAL"),
                                                width: 150,
                                            },
                                            {
                                                id: "subject_name",
                                                header: _("SUBJECTNAME"),
                                                width: 450,
                                            },
                                            {
                                                id: "begin_date",
                                                header: _("NGAY_BAT_DAU"),
                                                width: 200,
                                            },
                                            {
                                                id: "end_date",
                                                header: _("NGAY_KET_THUC"),
                                                width: 200,
                                            },
                                            {
                                                id: "issuer",
                                                header: _("DONVI"),
                                                width: 450,
                                            },
                                        ],
                                        url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                    });
                                } else {
                                    var table = $$("dangkysudung01Views");
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();
                                    // xem user có tích checkbox ký HSM không?
                                    var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                    webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                        if (resultscheckSigHSM[0].json() == "C") {
                                            // ký HSM
                                            var postData = {
                                                branch_code: user.getDvcsID(),
                                                username: user.getCurrentUser(),
                                                mau01_id: selectedItem.id,
                                            };

                                            var url = app.config.host + "/Invoice68/SignDangkysudung_HSM";

                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(url, postData, function (text) {
                                                    var res = JSON.parse(text);

                                                    if (res.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: res.error });
                                                    } else {
                                                        webix.message("Đã thực hiện xong");
                                                    }
                                                    table.enable();
                                                    table.hideProgress();
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                });
                                        } else {
                                            var a = webix.ajax(app.config.host + "/Invoice68/XmlMau01?id=" + selectedItem.id);
                                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                            webix.promise.all([a, b, selectedItem]).then(function (results) {
                                                // webix.extend(tblInvoice, webix.ProgressBar);
                                                // tblInvoice.disable();
                                                // tblInvoice.showProgress();
                                                var json = results[0].json();

                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                }

                                                var listcerts = results[1].json();
                                                var item = results[2];

                                                if (listcerts.length == 0) {
                                                    table.enable();
                                                    table.hideProgress();
                                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                    return;
                                                }

                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();
                                                    if (hubconnect.state != 1) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký biên lai hoặc Plugin ký biên lai chưa được bật !", "error");
                                                        return;
                                                    }
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (result) {
                                                        var json = JSON.parse(result);

                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: "error", text: json.error });
                                                        } else {
                                                            var parameters = {
                                                                xml: json.xml,
                                                                id: item.id,
                                                            };

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlMau01", parameters, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        app.callEvent("dataChangeDangkysudung68", [1, null]);

                                                                        webix.message("Ký thành công !", "success");
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    });

                                                    var _listcerts = [];

                                                    for (var i = 0; i < listcerts.length; i++) {
                                                        var _cert = listcerts[i];

                                                        _listcerts.push({
                                                            so_serial: _cert.cer_serial,
                                                            ngaybatdau: _cert.begin_date,
                                                            ngayketthuc: _cert.end_date,
                                                            issuer: _cert.issuer,
                                                            subjectname: _cert.subject_name,
                                                        });
                                                    }

                                                    var arg = {
                                                        idData: "#data",
                                                        xml: json["xml"],
                                                        shdon: "",
                                                        idSigner: "seller",
                                                        tagSign: "NNT",
                                                        dateKy: json["dateKy"],
                                                        listcerts: _listcerts,
                                                    };

                                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success !");
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                        });
                                                });
                                            });
                                        }
                                    });
                                }
                            });
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "dangkysudung01Views",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.date_new) {
                        //     obj.date_new = new Date(obj.date_new);
                        // }
                    },
                },
                onClick: {
                    dowloadXmlDKSD: function (event, cell, target) {
                        var win = webix.$$("dangkysudung01Views");
                        var record = win.getItem(cell.row);
                        if (record.trang_thai != 1) {
                            webix.message("Mẫu chưa được ký không thể tải !", "error");
                            return;
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();

                        var url = app.config.host + "/Invoice68/ExportXMLMau01?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, "Mau01.xml");
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        // return false; // here it blocks the default behavior
                    },
                    btndowloadXMLRep: function (event, cell, target) {
                        var win = webix.$$("dangkysudung01Views");
                        var record = win.getItem(cell.row);
                        if (record.ket_qua == null || record.ket_qua == "") {
                            webix.message("Mẫu chưa được CQT trả về không thể tải !", "error");
                            return;
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();

                        var url = app.config.host + "/Invoice68/ExportXMLMau02?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, "Mau02.xml");
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        // return false; // here it blocks the default behavior
                    },
                    btndowloadXMLRepTiepNhan: function (event, cell, target) {
                        var win = webix.$$("dangkysudung01Views");
                        var record = win.getItem(cell.row);
                        if (record.ketqua_tiepnhan == null || record.ketqua_tiepnhan == "") {
                            webix.message("Mẫu chưa được CQT trả về không thể tải !", "error");
                            return;
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();

                        var url = app.config.host + "/Invoice68/ExportXMLMau03?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, "Mau03.xml");
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        // return false; // here it blocks the default behavior
                    },
                    InMau01: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var item = table.getItem(cell.row);

                        //webix.message("Chưa có mẫu in ...", "error");
                        // var rpParameter = null;
                        var box = webix.modalbox({
                            title: "Đang in biên lai ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau01?id=" + item.id + "&type=PDF&loaitk=2", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    InMau02: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var item = table.getItem(cell.row);

                        if (item.ket_qua == 3) {
                            webix.message("Chưa có mẫu in ...", "error");
                            return;
                        }

                        var box = webix.modalbox({
                            title: "Đang in biên lai ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau02?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    InMau03: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var item = table.getItem(cell.row);

                        //webix.message("Chưa có mẫu in ...", "error");
                        // var rpParameter = null;
                        var box = webix.modalbox({
                            title: "Đang in biên lai ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau03?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "stt",
                        header: [{ text: "Tờ khai Đăng ký/thay đổi thông tin sử dụng biên lai điện tử", colspan: "6" }, "STT"],
                        width: 40,
                    },
                    // {
                    //     id: "mtdiep_gui",
                    //     header: ["", "Mã thông điệp"],
                    //     width: 350,
                    // },
                    {
                        id: "ngay_gui",
                        header: ["", "Ngày ký"],
                        width: 200,
                        css: { "text-align": "center" },
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    {
                        id: "nlap",
                        header: ["", "Ngày lập"],
                        width: 200,
                        css: { "text-align": "center" },
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    {
                        id: "noi_dung",
                        header: ["", "Nội dung"],
                        width: 250,
                    },
                    /*{
                        id: "btnMessagetn",
                        header: ["", "Lịch sử xử lý"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                        },
                        width: 180,
                    },*/
                    {
                        id: "btndowload",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='dowloadXmlDKSD' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='dowloadXmlDKSD' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "btnInMau01",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='InMau01' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau01' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "nguoi_gui",
                        header: ["", "Người gửi"],
                        width: 200,
                    },
                    {
                        id: "ketqua_tiepnhan",
                        header: [{ text: "Mẫu 01/TB-TNĐT - Thông tin tiếp nhận tờ khai của Cơ quan Thuế", colspan: "4" }, "Kết quả"],
                        width: 300,
                        template: function (obj) {
                            if (obj.ketqua_tiepnhan == 1) {
                                return "<span style='color: #00b300'>Tiếp nhận tờ khai đăng ký</span> ";
                            } else {
                                if (obj.ketqua_tiepnhan == 2) {
                                    return "<span style='color: #e83717'>Không tiếp nhận tờ khai đăng ký</span> ";
                                } else {
                                    if (obj.ketqua_tiepnhan == 3) {
                                        return "<span style='color: #00b300'>Tiếp nhận tờ khai đăng ký thay đổi</span> ";
                                    } else {
                                        if (obj.ketqua_tiepnhan == 4) {
                                            return "<span style='color: #00b300'>Không tiếp nhận tờ khai đăng ký thay đổi</span> ";
                                        } else {
                                            if (obj.ketqua_tiepnhan == 0) {
                                                return "<span style='color: #00b300'>Không tiếp nhận tờ khai đăng ký thay đổi</span> ";
                                            } else {
                                                return "<span></span>";
                                            }
                                        }
                                    }
                                }
                            }
                        },
                    },
                    // {
                    //     id: "xac_thuc",
                    //     header: ["", "Thông tin xác thực của người đại diện"],
                    //     template: function (obj) {
                    //         if (obj.mhso != null && obj.lttxthuc != null && obj.thxthuc != null && obj.mhso != null && obj.lttxthuc != "" && obj.thxthuc != "") {
                    //             var format = webix.Date.dateToStr("%d/%m/%Y");
                    //             var thxthuc = format(removeTimeZoneT(obj.thxthuc));


                    //             return "<span style='color: #00b300'>Hồ sơ " + obj.mhso  + " phải thực hiện " + obj.lttxthuc + " trước " + thxthuc + "</span>";
                    //         } else return "";
                    //     },
                    //     width: 500,
                    // },
                    {
                        id: "lydo_tiepnhan",
                        header: ["", "Lý do"],
                        width: 300,
                    },
                    {
                        id: "ngay_tbao_tiepnhan",
                        header: ["", "Ngày thông báo"],
                        width: 200,
                        css: { "text-align": "center" },
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    {
                        id: "btndowloadXMLRepTiepNhan",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ketqua_tiepnhan != null && obj.ketqua_tiepnhan != "") {
                                return "<span class='btndowloadXMLRepTiepNhan' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='btndowloadXMLRepTiepNhan' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "btnInMau03",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ketqua_tiepnhan != null && obj.ketqua_tiepnhan != "") {
                                return "<span class='InMau03' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau03' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 60,
                    },
                    // {
                    //     id: "mtdiep_tiepnhan_cqt",
                    //     header: ["", "Mã thông điệp CQT"],
                    //     width: 350,
                    // },
                    {
                        id: "ket_qua",
                        header: [{ text: "Mẫu 01/TB-ĐKĐT - Thông tin chấp nhận Tờ khai của Cơ quan Thuế", colspan: "5" }, "Kết quả"],
                        width: 200,
                        template: function (obj) {
                            if (obj.ket_qua == 1) {
                                return "<span style='color: #00b300'>Chấp thuận</span> ";
                            } else {
                                if (obj.ket_qua == 2) {
                                    return "<span style='color: #e83717'>Không chấp thuận</span> ";
                                } else {
                                    if (obj.ket_qua == 3) {
                                        return "<span style='color: #00b300'>Đã phản hồi kết quả</span> ";
                                    } else {
                                        return "<span>Chờ phản hồi</span>";
                                    }
                                }
                            }
                        },
                    },
                    {
                        id: "ly_do",
                        header: ["", "Lý do"],
                        width: 300,
                    },
                    {
                        id: "ngay_tbao",
                        header: ["", "Ngày thông báo"],
                        width: 200,
                        css: { "text-align": "center" },
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    {
                        id: "btndowloadXMLRep",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ket_qua != null && obj.ket_qua != "") {
                                return "<span class='btndowloadXMLRep' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='btndowloadXMLRep' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "btnInMau02",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ket_qua != null && obj.ket_qua != "") {
                                return "<span class='InMau02' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau02' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 60,
                    },
                    // {
                    //     id: "mtdiep_cqt",
                    //     header: ["", "Mã thông điệp CQT"],
                    //     width: 350,
                    // },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",

                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("dangkysudung01Views");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("dangkysudung01Views");
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChangeDangkysudung68", function (mode, item) {
                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_dangkysudung_thue_TNCN',["app", "locale", "models/user", "views/modules/minvoiceplugin"], function (app, _, user, plugin) {
    

    webix.$$("title").parse({ title: "Đăng ký sử dụng", details: "Đăng ký sử dụng" });
    var editmode = 0;

    function listToTreeCustomize(json) {
        return json.map(function(item) {
            return {
                id: item.code,
                name: item.name != null ? item.name.toString() : "",
                code: item.code
            };
        });
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Đăng ký/thay đổi thông tin sử dụng khấu trừ thuế thu nhập cá nhân<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_dksdForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "dangkysudungForms",
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {},
            },
            body: {
                view: "form",
                id: "dangkysudung",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        cols: [
                            {
                                view: "radio",
                                id: "loai",
                                name: "loai",
                                width: 200,
                                value: 1,
                                options: [
                                    { id: 1, value: "Đăng ký" }, // the initially selected item
                                    { id: 2, value: "Thay đổi" },
                                ],
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("header").define(
                                                "template",
                                                "<center><b><span style='font-size:17px;'>TỜ KHAI</span> </br> THAY ĐỔI THÔNG TIN SỬ DỤNG CHỨNG TỪ THUẾ THU NHẬP CÁ NHÂN</b></center>"
                                            );
                                            $$("header").refresh();
                                        } else {
                                            $$("header").define(
                                                "template",
                                                "<center><b><span style='font-size:17px;'>TỜ KHAI</span> </br> ĐĂNG KÝ THÔNG TIN SỬ DỤNG CHỨNG TỪ THUẾ THU NHẬP CÁ NHÂN</b></center>"
                                            );
                                            $$("header").refresh();
                                        }
                                    },
                                },
                            },
                            {
                                id: "header",
                                template: "<center><b><span style='font-size:17px;'>TỜ KHAI</span> </br>ĐĂNG KÝ THÔNG TIN SỬ DỤNG CHỨNG TỪ THUẾ THU NHẬP CÁ NHÂN</b></center>",
                                borderless: true,
                                height: 40,
                            },
                        ],
                    },
                    {
                        paddingX: 40,
                        rows: [
                            {
                                view: "text",
                                label: "Tên người nộp thuế: ",
                                labelWidth: 150,
                                name: "tnnt",
                                id: "tnnt",
                                required: true,
                                invalidMessage: "Tên người nộp thuế không được để trống !",
                                css: "mcls_uppercase",
                            },
                            {
                                view: "search",
                                label: "Mã số thuế",
                                id: "mst",
                                name: "mst",
                                labelWidth: 150,
                                required: true,
                                invalidMessage: "Mã số thuế không được để trống !",
                                on: {
                                    onSearchIconClick: function () {
                                        var mst = this.getValue();
                                        window.open("http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst);
                                    },
                                },
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        id: "cqtqly_hidden",
                                        name: "cqtqly",
                                        hidden: true
                                    },
                                    {
                                        id: "cqtqly",
                                        view: "combo",
                                        label: "Cơ quan thuế quản lý: ",
                                        valueField: "name", // Chỉ định rõ ràng rằng combo sẽ lấy giá trị từ trường name   
                                        labelWidth: 150,
                                        options: {
                                            view: "gridsuggest",
                                            columnName: "name",
                                            url: {
                                                $proxy: true,
                                                load: function (view, callback, params) {
                                                    var url = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00251";
                                                    webix.ajax(url, function (text) {
                                                        var json = JSON.parse(text);
                                                        var data = listToTreeCustomize(json);
                                                        view.parse(data, "json");
                                                    });
                                                },
                                            },
                                            body: {
                                                columns: [ { id: "name", width: 225, header: "Tên" }, { id: "code", width: 100, header: "Mã" }],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    $$("cqtqly_hidden").setValue(obj["name"]); // Lưu item.name vào trường ẩn
                                                    $$("cqtqly_hidden").refresh();

                                                    $$("mcqtqly").setValue(obj["code"]);
                                                    $$("mcqtqly").refresh();
                                                },
                                            },
                                        },
                                        required: true,
                                        invalidMessage: "Cơ quan thuế quản lý không được để trống !",
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "text",
                                                label: "Mã CQT quản lý: ",
                                                labelWidth: 150,
                                                name: "mcqtqly",
                                                id: "mcqtqly",
                                                required: true,
                                                invalidMessage: "Mã cơ quan thuế quản lý không được để trống !",
                                                attributes: { maxlength: 5 },
                                                readonly: true,
                                            },
                                            {
                                                view: "text",
                                                label: "Địa danh: ",
                                                labelWidth: 80,
                                                name: "ddanh",
                                                id: "ddanh",
                                                required: true,
                                                invalidMessage: "Địa danh không được để trống !",
                                                attributes: { maxlength: 50 },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Người liên hệ: ",
                                        labelWidth: 150,
                                        name: "nlhe",
                                        id: "nlhe",
                                        required: true,
                                        invalidMessage: "Người liên hệ không được để trống !",
                                        attributes: { maxlength: 50 },
                                    },
                                    {
                                        view: "text",
                                        label: "Điện thoại liên hệ: ",
                                        labelWidth: 150,
                                        name: "dtlhe",
                                        id: "dtlhe",
                                        required: true,
                                        invalidMessage: "Điện thoại liên hệ không được để trống !",
                                        attributes: { maxlength: 20 },
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Địa chỉ liên hệ: ",
                                        labelWidth: 150,
                                        name: "dclhe",
                                        id: "dclhe",
                                        required: true,
                                        invalidMessage: "Địa chỉ liên hệ không được để trống !",
                                        attributes: { maxlength: 400 },
                                    },
                                    {
                                        view: "text",
                                        label: "Thư điện tử: ",
                                        labelWidth: 150,
                                        name: "dctdtu",
                                        id: "dctdtu",
                                        validate: webix.rules.isEmail,
                                        required: true,
                                        invalidMessage: "Thư điện tử không hợp lệ !",
                                        attributes: { maxlength: 50 },
                                    },
                                ],
                            },
                            // {
                            //     cols: [
                            //         {
                            //             view: "text",
                            //             label: "Căn cứ: ",
                            //             labelWidth: 100,
                            //             name: "ccu",
                            //             id: "ccu",
                            //             required: true,
                            //             invalidMessage: "Căn cứ không được để trống !",
                            //             attributes: {
                            //                 maxlength: 500,
                            //             },
                            //         },
                            //         {
                            //             view: "text",
                            //             label: "Thư điện tử: ",
                            //             labelWidth: 150,
                            //             name: "dctdtu",
                            //             id: "dctdtu",
                            //             validate: webix.rules.isEmail,
                            //             required: true,
                            //             invalidMessage: "Thư điện tử không hợp lệ !",
                            //         },
                            //     ],
                            // },
                            { height: 5 },
                        ],
                    },
                    {
                        paddingX: 40,
                        rows: [
                            { view: "label", label: "Theo Nghị định số 70/2025/NĐ-CP ngày 20 tháng 3 năm 2025 của Chính phủ, chúng tôi/tôi thuộc đối tượng sử dụng chứng từ điện tử. Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng chứng từ điện tử như sau:" }
                        ]
                    },
                    {
                        rows: [
                            { view: "label", label: "<b>1. Đối tượng phát hành:</b>" },
                            {
                                view: "checkbox",
                                id: "tccnphanh",
                                name: "tccnphanh",
                                labelRight: "Tổ chức, cá nhân phát hành",
                                value: 1,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            //$$("dcqtphanh").setValue(1);
                                            $$("dcqtphanh").setValue(0);
                                        }
                                    },
                                },
                            },
                              {
                                view: "checkbox",
                                id: "dcqtphanh",
                                name: "dcqtphanh",
                                labelRight: "Cơ quan thuế phát hành",
                                //value: 1,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                             //$$("tccnphanh").setValue(1);
                                             $$("tccnphanh").setValue(0);
                                         }
                                    },
                                },
                            },
                            { view: "label", label: "<b>2. Loại hình sử dụng:</b>" },
                            {
                                view: "checkbox",
                                id: "cttncnhan",
                                name: "cttncnhan",
                                value: 1,
                                labelRight: "Chứng từ điện tử khấu trừ thuế thu nhập cá nhân",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             //$$("cttncnhan").setValue(0);
                                //             $$("ctktttmdtu").setValue(0);
                                //             $$("bltplpkin").setValue(0);
                                //             $$("bltplpin").setValue(0);
                                //             $$("blttplphi").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "ctktttmdtu",
                                name: "ctktttmdtu",
                                labelRight: "Chứng từ điện tử khấu trừ thuế đối với hoạt động kinh doanh trên nền tảng thương mại điện tử, nền tảng số",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cttncnhan").setValue(0);
                                //             //$$("ctktttmdtu").setValue(0);
                                //             $$("bltplpkin").setValue(0);
                                //             $$("bltplpin").setValue(0);
                                //             $$("blttplphi").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "bltplpkin",
                                name: "bltplpkin",
                                value: 1,
                                labelRight: "Biên lai thu thuế, phí, lệ phí không in sẵn mệnh giá",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cttncnhan").setValue(0);
                                //             $$("ctktttmdtu").setValue(0);
                                //             //$$("bltplpkin").setValue(0);
                                //             $$("bltplpin").setValue(0);
                                //             $$("blttplphi").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "bltplpin",
                                name: "bltplpin",
                                value: 1,
                                labelRight: "Biên lai thu thuế, phí, lệ phí in sẵn mệnh giá",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cttncnhan").setValue(0);
                                //             $$("ctktttmdtu").setValue(0);
                                //             $$("bltplpkin").setValue(0);
                                //             //$$("bltplpin").setValue(0);
                                //             $$("blttplphi").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "blttplphi",
                                name: "blttplphi",
                                labelRight: "Biên lai thu thuế, phí, lệ phí (CTT50)",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cttncnhan").setValue(0);
                                //             $$("ctktttmdtu").setValue(0);
                                //             $$("bltplpkin").setValue(0);
                                //             $$("bltplpin").setValue(0);
                                //             //$$("blttplphi").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            { view: "label", label: "<b>3. Hình thức gửi dữ liệu chứng từ điện tử:</b>" },
                            {
                                view: "checkbox",
                                id: "cdlqccqt",
                                name: "cdlqccqt",
                                labelRight: "Trên Cổng thông tin điện tử của cơ quan thuế",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             //$$("cdlqccqt").setValue(0);
                                //             $$("cdlqtctn").setValue(0);
                                //             $$("cdlqtctnut").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "cdlqtctn",
                                name: "cdlqtctn",
                                value: 1,
                                labelRight: "Thông qua tổ chức cung cấp dịch vụ hóa đơn điện tử",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cdlqccqt").setValue(0);
                                //             //$$("cdlqtctn").setValue(0);
                                //             $$("cdlqtctnut").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "cdlqtctnut",
                                name: "cdlqtctnut",
                                labelRight: "Thông qua tổ chức cung cấp dịch vụ hóa đơn điện tử được Tổng cục Thuế ủy thác",
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("cdlqccqt").setValue(0);
                                //             $$("cdlqtctn").setValue(0);
                                //             //$$("cdlqtctnut").setValue(0);
                                //         }
                                //     },
                                // },
                            }
                        ],
                    },
                    {
                        rows: [
                            {
                                view: "label",
                                label: "<b>4. Danh sách chứng thư số sử dụng:</b>",
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " Thêm",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = "";
                                                        for (var i = 0; i < result.length; i++) {
                                                            var item = result[i];
                                                            kytaptrung = item.value;
                                                        }
                                                        webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                            var listcerts = JSON.parse(text);
                                                            if (listcerts.length > 0) {
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();

                                                                                var cert = null;

                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }

                                                                                var now = new Date();
                                                                                var begin = new Date(cert.begin_date);
                                                                                var end = new Date(cert.end_date);
                                                                                if (now < begin || now > end) {
                                                                                    webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                    return;
                                                                                }

                                                                                var item = {
                                                                                    stt: $$("danhsach_chukyso").count() + 1,
                                                                                    ttchuc: cert.subject_name,
                                                                                    seri: cert.cer_serial,
                                                                                    tngay: cert.begin_date,
                                                                                    dngay: cert.end_date,
                                                                                    hthuc: "1",
                                                                                };

                                                                                // $$("danhsach_chukyso").clearAll();
                                                                                $$("danhsach_chukyso").add(item);
                                                                                return;
                                                                        }
                                                                    },
                                                                });

                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,

                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}",
                                                                        },
                                                                        {
                                                                            id: "cert_type",
                                                                            header: _("Loại"),
                                                                            width: 100,
                                                                        },
                                                                        {
                                                                            id: "cer_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 150,
                                                                        },
                                                                        {
                                                                            id: "subject_name",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "begin_date",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "end_date",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "issuer",
                                                                            header: _("DONVI"),
                                                                            width: 450,
                                                                        },
                                                                    ],
                                                                    url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                });
                                                            } else {
                                                                // xem user có tích checkbox ký HSM không?
                                                                var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                                                webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                                                    if (resultscheckSigHSM[0].json() == "C") {
                                                                        webix.ajax().get(app.config.host + "/Invoice68/GetCTS_HSM_ToKhai", function (result) {
                                                                            var ctsHSM = JSON.parse(result);

                                                                            if (ctsHSM.hasOwnProperty("error")) {
                                                                                webix.message({ type: "error", text: ctsHSM.error });
                                                                            } else {
                                                                                var item = {
                                                                                    stt: $$("danhsach_chukyso").count() + 1,
                                                                                    ttchuc: ctsHSM.subjectname,
                                                                                    seri: ctsHSM.so_serial,
                                                                                    tngay: ctsHSM.ngaybatdau,
                                                                                    dngay: ctsHSM.ngayketthuc,
                                                                                    hthuc: "1",
                                                                                };

                                                                                // $$("danhsach_chukyso").clearAll();
                                                                                $$("danhsach_chukyso").add(item);
                                                                            }
                                                                        });
                                                                    } else {
                                                                        var hub = plugin.hub();

                                                                        hub.off("resCommand");
                                                                        hub.on("resCommand", function (result) {
                                                                            var json = JSON.parse(result);

                                                                            if (json.hasOwnProperty("error")) {
                                                                                webix.message({ type: "error", text: json.error });
                                                                            } else {
                                                                                var callback = json.callback;

                                                                                if (callback == "RegisterCert") {
                                                                                    var item = {
                                                                                        stt: $$("danhsach_chukyso").count() + 1,
                                                                                        ttchuc: json.data.subjectname,
                                                                                        seri: json.data.so_serial,
                                                                                        tngay: json.data.ngaybatdau,
                                                                                        dngay: json.data.ngayketthuc,
                                                                                        hthuc: "1",
                                                                                    };

                                                                                    // $$("danhsach_chukyso").clearAll();
                                                                                    $$("danhsach_chukyso").add(item);
                                                                                }
                                                                            }
                                                                        });

                                                                        var arg = {
                                                                            callback: "RegisterCert",
                                                                        };

                                                                        hub.invoke("execCommand", arg.callback, JSON.stringify(arg));
                                                                    }
                                                                });
                                                            }
                                                        });
                                                    });
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " Xóa",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_chukyso");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {},
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_chukyso",
                                height: 250,
                                name: "danhsach_chukyso",
                                select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scroll: true,
                                fullscreen: true,
                                scheme: {
                                    $init: function (obj) {},
                                },
                                on: {},
                                columns: [
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                    },
                                    {
                                        id: "ttchuc",
                                        name: "ttchuc",
                                        header: "Tên tổ chức cơ quan chứng thực/cấp/công nhận chữ ký số, chữ ký điện tử",
                                        width: 450,
                                    },
                                    {
                                        id: "seri",
                                        name: "seri",
                                        header: "Số sê-ri chứng thư số",
                                        width: 300,
                                    },
                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                text: "Thời hạn sử dụng chứng thư số",
                                                colspan: 2,
                                            },
                                            {
                                                text: "Từ ngày",
                                            },
                                        ],
                                        width: 200,
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                text: "Đến ngày",
                                            },
                                        ],
                                        width: 200,
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "hthuc",
                                        name: "hthuc",
                                        header: "Hình thức đăng ký ( Thêm mới, Gia hạn, ngừng sử dụng)",
                                        fillspace: true,
                                        editor: "combo",
                                        options: [
                                            { id: "1", value: "Thêm mới" },
                                            { id: "2", value: "Gia hạn" },
                                            { id: "3", value: "Ngừng sử dụng" },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                    { height: 10 },
                    {
                        view: "combo",
                        label: "Loại đăng ký ủy nhiệm",
                        id: "ldkunhiem",
                        name: "ldkunhiem",
                        labelWidth: 150,
                        options: [
                            { id: 1, value: "Ủy nhiệm" },
                            { id: 2, value: "Nhận ủy nhiệm" },
                        ],
                        width: 400,
                    },
                    { height: 10 },
                    {
                        rows: [
                            {
                                view: "label",
                                label: "<b>5. Đăng ký ủy nhiệm lập biên lai:</b>",
                            },
                              {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " Thêm",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                 var item = {
                                                    stt: $$("danhsach_uynhiem").count() + 1,
                                                    tlhdunhiem: "",
                                                    khmhdon: "",
                                                    khhdunhiem: "",
                                                    mstunhiem: "",
                                                    ttcdunhiem: "",
                                                    mdunhiem: "",
                                                    thunhiem: "",
                                                    tngay: new Date(),
                                                    dngay: new Date(),
                                                    pttthdunhiem: 1,
                                                    //ket_qua: 0,
                                                };
                                                // $$("danhsach_uynhiem").clearAll();
                                                $$("danhsach_uynhiem").add(item);

                                                $$("ldkunhiem").define("required", true);
                                                $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                                $$("ldkunhiem").refresh();

                                                return;
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " Xóa",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_uynhiem");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();

                                                    if (table.count() == 0) {
                                                        $$("ldkunhiem").define("required", false);
                                                        $$("ldkunhiem").refresh();
                                                    } else {
                                                        $$("ldkunhiem").define("required", true);
                                                        $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                                        $$("ldkunhiem").refresh();
                                                    }

                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();

                                                    if (table.count() == 0) {
                                                        $$("ldkunhiem").define("required", false);
                                                        $$("ldkunhiem").refresh();
                                                    } else {
                                                        $$("ldkunhiem").define("required", true);
                                                        $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                                        $$("ldkunhiem").refresh();
                                                    }

                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {},
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_uynhiem",
                                height: 250,
                                name: "danhsach_uynhiem",
                                select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scroll: true,
                                fullscreen: true,
                                scheme: {
                                    $init: function (obj) {},
                                },
                                on: {},
                                columns: [
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                    },
                                    {
                                        id: "tlhdunhiem",
                                        name: "tlhdunhiem",
                                        header: "Tên loại biên lai ủy nhiệm",
                                        width: 200,
                                        editor: "text",
                                        attributes: {maxlength: 100},
                                    },
                                    {
                                        id: "khmhdon",
                                        name: "khmhdon",
                                        header: "Ký hiệu mẫu biên lai",
                                        width: 150,
                                        editor: "text",
                                    },
                                    {
                                        id: "khhdunhiem",
                                        name: "khhdunhiem",
                                        header: "Ký hiệu biên lai ủy nhiệm",
                                        width: 150,
                                        editor: "text",
                                    },
                                    {
                                        id: "mstunhiem",
                                        name: "mstunhiem",
                                        header: "Mã số thuế",
                                        width: 150,
                                        editor: "text",
                                    },
                                    {
                                        id: "ttcdunhiem",
                                        name: "ttcdunhiem",
                                        header: "Tên tổ chức được ủy nhiệm",
                                        width: 300,
                                        editor: "text",
                                    },
                                    {
                                        id: "mdunhiem",
                                        name: "mdunhiem",
                                        header: "Mục đích ủy nhiệm",
                                        width: 300,
                                        editor: "text",
                                    },
                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                text: "Thời hạn sử dụng chứng thư số",
                                                colspan: 2,
                                            },
                                            {
                                                text: "Từ ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                text: "Đến ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "pttthdunhiem",
                                        name: "pttthdunhiem",
                                        header: "PTTT biên lai ủy nhiệm",
                                        fillspace: true,
                                        editor: "text",
                                        //editor: "combo",
                                        // options: [
                                        //     { id: 1, value: "Tiền mặt" },
                                        //     { id: 2, value: "Chuyển khoản" },
                                        //     { id: 3, value: "Tiền mặt/Chuyển khoản" },
                                        //     { id: 4, value: "Đối trừ công nợ" },
                                        //     { id: 5, value: "Không thu tiền" },
                                        //     { id: 9, value: "Khác" },
                                        // ],
                                        width: 150,
                                    },
                                    // {
                                    //     id: "ket_qua",
                                    //     name: "ket_qua",
                                    //     header: "Kết quả",
                                    //     fillspace: true,
                                    //     format: function (text) {
                                    //         var result = "";
                                    //         if (text == 0) {
                                    //             result = "Chờ phản hồi";
                                    //         } else if (text == 1) {
                                    //             result = "Chấp nhận";
                                    //         } else if (text == 2) {
                                    //             result = "Không chấp nhận";
                                    //         }
                                    //         return result;
                                    //     },
                                    //     width: 150,
                                    // },
                                ],
                                rules: {
                                    tlhdunhiem: webix.rules.isNotEmpty,
                                    khmhdon: webix.rules.isNotEmpty,
                                    khhdunhiem: webix.rules.isNotEmpty,
                                    mstunhiem: webix.rules.isNotEmpty,
                                    ttcdunhiem: webix.rules.isNotEmpty,
                                    mdunhiem: webix.rules.isNotEmpty,
                                    tngay: webix.rules.isNotEmpty,
                                    dngay: webix.rules.isNotEmpty,
                                    pttthdunhiem: webix.rules.isNotEmpty,
                                },
                                 ready: function () {
                                    var tableUyNhiem = webix.$$("danhsach_uynhiem");
                                    if (tableUyNhiem.count() == 0) {
                                        $$("ldkunhiem").define("required", false);
                                        $$("ldkunhiem").refresh();
                                    } else {
                                        $$("ldkunhiem").define("required", true);
                                        $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                        $$("ldkunhiem").refresh();
                                    }
                                },
                            },
                        ],
                    },
                    { height: 5 },
                    {
                        css: "fixbottom",
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Ghi (F10)",
                                id: "btnDKSDSave1",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("dangkysudung").getValues();
                                            item.ltkhai = 3;
                                            var table = $$("dangkysudung");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_chukyso").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa đăng ký chữ ký số cho thông báo phát hành !", "error");
                                                    return;
                                                }
                                                if (!$$("danhsach_uynhiem").validate()) {
                                                    webix.message("Bạn chưa nhập đầy đủ thông tin ủy nhiệm hóa đơn !", "error");
                                                    return;
                                                }

                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();

                                                var details = [];
                                                details.push({ data: $$("danhsach_chukyso").serialize() });
                                                item["details"] = details;

                                                var uynhiems = [];
                                                uynhiems.push({ data: $$("danhsach_uynhiem").serialize() });
                                                item["uynhiems"] = uynhiems;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/dangkysudungSave", data_post, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            table.enable();
                                                            table.hideProgress();
                                                            // var json = JSON.parse(text);
                                                            // webix.message(json.ExceptionMessage, "error");
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            table.enable();
                                                            table.hideProgress();
                                                            var json = JSON.parse(text);
                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message(json.error, "error");
                                                            } else {
                                                                app.callEvent("dataChangeDangkysudung68", [editmode, null]);

                                                                webix.message("Thành công !", "success");
                                                                webix.$$("dangkysudungForms").close();
                                                            }
                                                        },
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },

                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    webix.$$("dangkysudungForms").close();
                                },
                            },
                            {},
                        ],
                    },
                    { height: 5 },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix
                    .ajax()
                    .sync()
                    .get(app.config.host + "/System/GetDmDvcsByUser");
                var json = JSON.parse(result.response);

                $$("dclhe").setValue(json[0].address);
                $$("tnnt").setValue(json[0].name);
                $$("mst").setValue(json[0].tax_code);
                $$("dtlhe").setValue(json[0].tel);
                $$("dctdtu").setValue(json[0].email);
                $$("nlhe").setValue(json[0].manage);
            } else {
                if (editmode == 2) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            // item["tdlap"] = removeTimeZoneT(item["tdlap"]);
            form.setValues(item);

            $$("cqtqly").setValue(item.mcqtqly);

            // if (editmode == 2) {

            // }

            var tableDetail = webix.$$("danhsach_chukyso");
            var url = app.config.host + "/Invoice68/GetDataDangkysudungDetail?id=" + item.id;
            tableDetail.clearAll();
            tableDetail.load(url);

            var tableUyNhiem = webix.$$("danhsach_uynhiem");
            var urlUyNhiem = app.config.host + "/Invoice68/GetDataDangkysudungUyNhiem?id=" + item.id;
            tableUyNhiem.clearAll();
            tableUyNhiem.load(urlUyNhiem);
        },
        // $oninit: function (view, $scope) {
        //     var url = app.config.host + "/Invoice68/getDangkysudung";

        //     webix.ajax(url, function (text) {
        //         var json = JSON.parse(text);

        //         $$("dangkysudung").setValues(json);
        //         $$("danhsach_chukyso").parse(json["data"]);
        //     });
        // }
    };
});

define('views/68_dangkysudung_cthue_THCN',["app", "locale", "models/user", "views/forms/68_dangkysudung_thue_TNCN", "views/forms/68_hoadon_history"], function (app, _, user, dangkysudung, hoadonHistory) {
    

    webix.$$("title").parse({
        title: "Đăng ký/ Thay đổi thông tin SD CTTNCN",
        details: "Đăng ký/ Thay đổi thông tin SD CTTNCN",
    });

    var initUI = function () {
        //var windowno = app.path[1].params[0];
        //var windowno = app.path[1].params[0];
        var table = webix.$$("dangkysudung01Views");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetDataDkysdung01";
                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }
                        url = url + "&filter=" + JSON.stringify(array);
                        //console.log(JSON.stringify(array));
                    }
                }
                url = url + "&ltkhai=3";
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dangkysudung.$ui);
                    dangkysudung.setEditMode(1);

                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký cần sửa ! ", "error");
                        return;
                    }
                    // if (selectedItem.trang_thai == 1) {
                    //     webix.message("Đã gửi CQT không thể sửa", "error");
                    //     return;
                    // }
                    var detailForm = this.$scope.ui(dangkysudung.$ui);

                    dangkysudung.setEditMode(2);
                    dangkysudung.setValues(selectedItem);

                    if (selectedItem.trang_thai == 1) {
                        var form = $$("dangkysudung").elements;
                        for (var key in form) {
                            var $el = form[key];
                            $el.define("readonly", "true");
                            $el.define("css", "mcls_readonly_text");
                            $el.refresh();
                        }

                        // $$("btnDKSDSave").destructor();
                        $$("btnDKSDSave1").destructor();
                    }

                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký ! ", "error");
                        return;
                    }

                    if (selectedItem.trang_thai == 1) {
                        webix.message("Thông báo đã được ký. Bạn không thể thực hiện chức năng này ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/deleteMau01", selectedItem, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            table.remove(selectedItem.id);
                                            table.enable();
                                            table.hideProgress();
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-eye fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký và gửi CQT (F7)") + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("dangkysudung01Views");
                    var selectedItem = tableDK.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã được ký, bạn không thể ký lại ! ", "error");
                        return;
                    }
                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                            var result = JSON.parse(text);
                            var kytaptrung = "";
                            for (var i = 0; i < result.length; i++) {
                                var item = result[i];
                                kytaptrung = item.value;
                            }

                            webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                var listcerts = JSON.parse(text);
                                if (listcerts.length > 0) {
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();

                                                    var cert = null;

                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }

                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                        return;
                                                    }

                                                    var now = new Date();
                                                    var begin = new Date(cert.begin_date);
                                                    var end = new Date(cert.end_date);
                                                    if (now < begin || now > end) {
                                                        webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                        return;
                                                    }


                                                    var postData = {
                                                        branch_code: user.getDvcsID(),
                                                        username: user.getCurrentUser(),
                                                        cer_serial: cert.cer_serial,
                                                        mau01_id: selectedItem.id,
                                                    };

                                                    if (postData.mau01_id == undefined || postData.mau01_id == "") {
                                                        webix.message("Bạn chưa ghi dữ liệu, không thể ký !", "error");
                                                        return;
                                                    } else {
                                                        webix.extend(tableDK, webix.ProgressBar);
                                                        tableDK.disable();
                                                        tableDK.showProgress();
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/SignDangkysudung", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    if (json.hasOwnProperty("error")) {
                                                                        webix.message(json.error, "error");
                                                                        tableDK.enable();
                                                                        tableDK.hideProgress();
                                                                    } else {
                                                                        tableDK.enable();
                                                                        tableDK.hideProgress();
                                                                        app.callEvent("dataChangeDangkysudung68", [1, null]);

                                                                        webix.message("Ký thành công!", "success");
                                                                    }
                                                                },
                                                            });

                                                        // return;
                                                    }
                                            }
                                        },
                                    });

                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon",
                                                header: _("CHON"),
                                                width: 65,
                                                checkValue: true,
                                                uncheckValue: false,
                                                template: "{common.checkbox()}",
                                            },
                                            {
                                                id: "cert_type",
                                                header: _("Loại"),
                                                width: 100,
                                            },
                                            {
                                                id: "cer_serial",
                                                header: _("SO_SERIAL"),
                                                width: 150,
                                            },
                                            {
                                                id: "subject_name",
                                                header: _("SUBJECTNAME"),
                                                width: 450,
                                            },
                                            {
                                                id: "begin_date",
                                                header: _("NGAY_BAT_DAU"),
                                                width: 200,
                                            },
                                            {
                                                id: "end_date",
                                                header: _("NGAY_KET_THUC"),
                                                width: 200,
                                            },
                                            {
                                                id: "issuer",
                                                header: _("DONVI"),
                                                width: 450,
                                            },
                                        ],
                                        url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                    });
                                } else {
                                    var table = $$("dangkysudung01Views");
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();
                                    // xem user có tích checkbox ký HSM không?
                                    var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                    webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                        if (resultscheckSigHSM[0].json() == "C") {
                                            // ký HSM
                                            var postData = {
                                                branch_code: user.getDvcsID(),
                                                username: user.getCurrentUser(),
                                                mau01_id: selectedItem.id,
                                            };

                                            var url = app.config.host + "/Invoice68/SignDangkysudung_HSM";

                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(url, postData, function (text) {
                                                    var res = JSON.parse(text);

                                                    if (res.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: res.error });
                                                    } else {
                                                        webix.message("Đã thực hiện xong");
                                                    }
                                                    table.enable();
                                                    table.hideProgress();
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                });
                                        } else {
                                            var a = webix.ajax(app.config.host + "/Invoice68/XmlMau01?id=" + selectedItem.id);
                                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                            webix.promise.all([a, b, selectedItem]).then(function (results) {
                                                // webix.extend(tblInvoice, webix.ProgressBar);
                                                // tblInvoice.disable();
                                                // tblInvoice.showProgress();
                                                var json = results[0].json();

                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                }

                                                var listcerts = results[1].json();
                                                var item = results[2];

                                                if (listcerts.length == 0) {
                                                    table.enable();
                                                    table.hideProgress();
                                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                    return;
                                                }

                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();
                                                    if (hubconnect.state != 1) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                        return;
                                                    }
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (result) {
                                                        var json = JSON.parse(result);

                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: "error", text: json.error });
                                                        } else {
                                                            var parameters = {
                                                                xml: json.xml,
                                                                id: item.id,
                                                            };

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlMau01", parameters, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        app.callEvent("dataChangeDangkysudung68", [1, null]);

                                                                        webix.message("Ký thành công !", "success");
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    });

                                                    var _listcerts = [];

                                                    for (var i = 0; i < listcerts.length; i++) {
                                                        var _cert = listcerts[i];

                                                        _listcerts.push({
                                                            so_serial: _cert.cer_serial,
                                                            ngaybatdau: _cert.begin_date,
                                                            ngayketthuc: _cert.end_date,
                                                            issuer: _cert.issuer,
                                                            subjectname: _cert.subject_name,
                                                        });
                                                    }

                                                    var arg = {
                                                        idData: "#data",
                                                        xml: json["xml"],
                                                        shdon: "",
                                                        idSigner: "seller",
                                                        tagSign: "NNT",
                                                        dateKy: json["dateKy"],
                                                        listcerts: _listcerts,
                                                    };

                                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success !");
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                        });
                                                });
                                            });
                                        }
                                    });
                                }
                            });
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "dangkysudung01Views",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.date_new) {
                        //     obj.date_new = new Date(obj.date_new);
                        // }
                    },
                },
                onClick: {
                    dowloadXmlDKSD: function (event, cell, target) {
                        var win = webix.$$("dangkysudung01Views");
                        var record = win.getItem(cell.row);
                        if (record.trang_thai != 1) {
                            webix.message("Mẫu chưa được ký không thể tải !", "error");
                            return;
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();

                        var url = app.config.host + "/Invoice68/ExportXMLMau01?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, "Mau01.xml");
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        // return false; // here it blocks the default behavior
                    },
                    btndowloadXMLRep: function (event, cell, target) {
                        var win = webix.$$("dangkysudung01Views");
                        var record = win.getItem(cell.row);
                        if (record.ket_qua == null || record.ket_qua == "") {
                            webix.message("Mẫu chưa được CQT trả về không thể tải !", "error");
                            return;
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();

                        var url = app.config.host + "/Invoice68/ExportXMLMau02?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, "Mau02.xml");
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        // return false; // here it blocks the default behavior
                    },
                    btndowloadXMLRepTiepNhan: function (event, cell, target) {
                        var win = webix.$$("dangkysudung01Views");
                        var record = win.getItem(cell.row);
                        if (record.ketqua_tiepnhan == null || record.ketqua_tiepnhan == "") {
                            webix.message("Mẫu chưa được CQT trả về không thể tải !", "error");
                            return;
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();

                        var url = app.config.host + "/Invoice68/ExportXMLMau03?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, "Mau03.xml");
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        // return false; // here it blocks the default behavior
                    },
                    InMau01: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var item = table.getItem(cell.row);

                        //webix.message("Chưa có mẫu in ...", "error");
                        // var rpParameter = null;
                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau01?id=" + item.id + "&type=PDF&loaitk=3", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    InMau02: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var item = table.getItem(cell.row);

                        if (item.ket_qua == 3) {
                            webix.message("Chưa có mẫu in ...", "error");
                            return;
                        }

                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau02?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    InMau03: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var item = table.getItem(cell.row);

                        //webix.message("Chưa có mẫu in ...", "error");
                        // var rpParameter = null;
                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau03?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "stt",
                        header: [{ text: "Tờ khai Đăng ký/thay đổi thông tin sử dụng chứng từ khấu trừ thuế thu nhập cá nhân", colspan: "6" }, "STT"],
                        width: 40,
                    },
                    // {
                    //     id: "mtdiep_gui",
                    //     header: ["", "Mã thông điệp"],
                    //     width: 350,
                    // },
                    {
                        id: "ngay_gui",
                        header: ["", "Ngày ký"],
                        width: 200,
                        css: { "text-align": "center" },
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    {
                        id: "nlap",
                        header: ["", "Ngày lập"],
                        width: 200,
                        css: { "text-align": "center" },
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    {
                        id: "noi_dung",
                        header: ["", "Nội dung"],
                        width: 250,
                    },
                    /*{
                        id: "btnMessagetn",
                        header: ["", "Lịch sử xử lý"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                        },
                        width: 180,
                    },*/
                    {
                        id: "btndowload",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='dowloadXmlDKSD' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='dowloadXmlDKSD' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "btnInMau01",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='InMau01' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau01' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "nguoi_gui",
                        header: ["", "Người gửi"],
                        width: 200,
                    },
                    {
                        id: "ketqua_tiepnhan",
                        header: [{ text: "Mẫu 01/TB-TNĐT - Thông tin tiếp nhận tờ khai của Cơ quan Thuế", colspan: "4" }, "Kết quả"],
                        width: 300,
                        template: function (obj) {
                            if (obj.ketqua_tiepnhan == 1) {
                                return "<span style='color: #00b300'>Tiếp nhận tờ khai đăng ký</span> ";
                            } else {
                                if (obj.ketqua_tiepnhan == 2) {
                                    return "<span style='color: #e83717'>Không tiếp nhận tờ khai đăng ký</span> ";
                                } else {
                                    if (obj.ketqua_tiepnhan == 3) {
                                        return "<span style='color: #00b300'>Tiếp nhận tờ khai đăng ký thay đổi</span> ";
                                    } else {
                                        if (obj.ketqua_tiepnhan == 4) {
                                            return "<span style='color: #00b300'>Không tiếp nhận tờ khai đăng ký thay đổi</span> ";
                                        } else {
                                            if (obj.ketqua_tiepnhan == 0) {
                                                return "<span style='color: #00b300'>Không tiếp nhận tờ khai đăng ký thay đổi</span> ";
                                            } else {
                                                return "<span></span>";
                                            }
                                        }
                                    }
                                }
                            }
                        },
                    },
                    // {
                    //     id: "xac_thuc",
                    //     header: ["", "Thông tin xác thực của người đại diện"],
                    //     template: function (obj) {
                    //         if (obj.mhso != null && obj.lttxthuc != null && obj.thxthuc != null && obj.mhso != null && obj.lttxthuc != "" && obj.thxthuc != "") {
                    //             var format = webix.Date.dateToStr("%d/%m/%Y");
                    //             var thxthuc = format(removeTimeZoneT(obj.thxthuc));


                    //             return "<span style='color: #00b300'>Hồ sơ " + obj.mhso  + " phải thực hiện " + obj.lttxthuc + " trước " + thxthuc + "</span>";
                    //         } else return "";
                    //     },
                    //     width: 500,
                    // },
                    {
                        id: "lydo_tiepnhan",
                        header: ["", "Lý do"],
                        width: 300,
                    },
                    {
                        id: "ngay_tbao_tiepnhan",
                        header: ["", "Ngày thông báo"],
                        width: 200,
                        css: { "text-align": "center" },
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },       
                    {
                        id: "btndowloadXMLRepTiepNhan",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ketqua_tiepnhan != null && obj.ketqua_tiepnhan != "") {
                                return "<span class='btndowloadXMLRepTiepNhan' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='btndowloadXMLRepTiepNhan' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "btnInMau03",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ketqua_tiepnhan != null && obj.ketqua_tiepnhan != "") {
                                return "<span class='InMau03' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau03' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 60,
                    },
                    // {
                    //     id: "mtdiep_tiepnhan_cqt",
                    //     header: ["", "Mã thông điệp CQT"],
                    //     width: 350,
                    // },
                    {
                        id: "ket_qua",
                        header: [{ text: "Mẫu 01/TB-ĐKĐT - Thông tin chấp nhận Tờ khai của Cơ quan Thuế", colspan: "5" }, "Kết quả"],
                        width: 200,
                        template: function (obj) {
                            if (obj.ket_qua == 1) {
                                return "<span style='color: #00b300'>Chấp thuận</span> ";
                            } else {
                                if (obj.ket_qua == 2) {
                                    return "<span style='color: #e83717'>Không chấp thuận</span> ";
                                } else {
                                    if (obj.ket_qua == 3) {
                                        return "<span style='color: #00b300'>Đã phản hồi kết quả</span> ";
                                    } else {
                                        return "<span>Chờ phản hồi</span>";
                                    }
                                }
                            }
                        },
                    },
                    {
                        id: "ly_do",
                        header: ["", "Lý do"],
                        width: 300,
                    },
                    {
                        id: "ngay_tbao",
                        header: ["", "Ngày thông báo"],
                        width: 200,
                        css: { "text-align": "center" },
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    {
                        id: "btndowloadXMLRep",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ket_qua != null && obj.ket_qua != "") {
                                return "<span class='btndowloadXMLRep' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='btndowloadXMLRep' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "btnInMau02",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ket_qua != null && obj.ket_qua != "") {
                                return "<span class='InMau02' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau02' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 60,
                    },
                    // {
                    //     id: "mtdiep_cqt",
                    //     header: ["", "Mã thông điệp CQT"],
                    //     width: 350,
                    // },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",

                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("dangkysudung01Views");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("dangkysudung01Views");
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChangeDangkysudung68", function (mode, item) {
                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_dangkysudung',["app", "locale", "models/user", "views/modules/minvoiceplugin"], function (app, _, user, plugin) {
    

    webix.$$("title").parse({ title: "Đăng ký sử dụng", details: "Đăng ký sử dụng" });
    var editmode = 0;

    //đánh lại số thứ tự cho các table
    function reindex(table) {
        table.data.each(function (obj, index) {
            obj.stt = index + 1;
            table.updateItem(obj.id, obj);
        });
    }

    function listToTreeCustomize(json) {
        return json.map(function (item) {
            return {
                id: item.code,
                name: item.name != null ? item.name.toString() : "",
                code: item.code
            };
        });
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Đăng ký/thay đổi thông tin sử dụng hóa đơn điện tử<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_dksdForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "dangkysudungForms",
            resize: true,
            fullscreen: true,
            move: true,

            body: {
                view: "form",
                id: "dangkysudung",
                // width: 1500,
                position: "center",
                autowidth: true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                elements: [
                    {
                        cols: [
                            {
                                view: "radio",
                                id: "loai",
                                name: "loai",
                                width: 200,
                                value: 1,
                                options: [
                                    { id: 1, value: "Đăng ký" }, // the initially selected item
                                    { id: 2, value: "Thay đổi" },
                                ],
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("header").define("template", "<center><b><span style='font-size:17px;'>TỜ KHAI</span> </br> ĐĂNG KÝ THÔNG TIN SỬ DỤNG HÓA ĐƠN ĐIỆN TỬ</b></center>");
                                            $$("header").refresh();
                                        } else {
                                            $$("header").define("template", "<center><b><span style='font-size:17px;'>TỜ KHAI</span> </br> THAY ĐỔI THÔNG TIN SỬ DỤNG HÓA ĐƠN ĐIỆN TỬ</b></center>");
                                            $$("header").refresh();
                                        }
                                    },
                                },
                            },
                            {
                                id: "header",
                                template: "<center><b><span style='font-size:17px;'>TỜ KHAI</span> </br>ĐĂNG KÝ THÔNG TIN SỬ DỤNG HÓA ĐƠN ĐIỆN TỬ</b></center>",
                                borderless: true,
                                height: 40,
                            },
                        ],
                    },

                    {
                        paddingX: 40,
                        rows: [
                            {
                                view: "text",
                                label: "Tên người nộp thuế: ",
                                labelWidth: 215,
                                name: "tnnt",
                                id: "tnnt",
                                required: true,
                                invalidMessage: "Tên người nộp thuế không được để trống !",
                                bottomPadding: 12,
                            },
                            {
                                view: "search",
                                label: "Mã số thuế",
                                id: "mst",
                                name: "mst",
                                labelWidth: 215,
                                required: true,
                                invalidMessage: "Mã số thuế không được để trống !",
                                bottomPadding: 12,
                                on: {
                                    onSearchIconClick: function () {
                                        var mst = this.getValue();
                                        window.open("http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst);
                                    },
                                },
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        id: "cqtqly_hidden",
                                        name: "cqtqly",
                                        hidden: true
                                    },
                                    {
                                        id: "cqtqly",
                                        view: "combo",
                                        label: "Cơ quan thuế quản lý: ",
                                        valueField: "name", // Chỉ định rõ ràng rằng combo sẽ lấy giá trị từ trường name   
                                        labelWidth: 215,
                                        options: {
                                            view: "gridsuggest",
                                            columnName: "name",
                                            url: {
                                                $proxy: true,
                                                load: function (view, callback, params) {
                                                    var url = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00251";
                                                    webix.ajax(url, function (text) {
                                                        var json = JSON.parse(text);
                                                        var data = listToTreeCustomize(json);
                                                        view.parse(data, "json");
                                                    });
                                                },
                                            },
                                            body: {
                                                columns: [{ id: "name", width: 225, header: "Tên" }, { id: "code", width: 100, header: "Mã" }],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    $$("cqtqly_hidden").setValue(obj["name"]); // Lưu item.name vào trường ẩn
                                                    $$("cqtqly_hidden").refresh();

                                                    $$("mcqtqly").setValue(obj["code"]);
                                                    $$("mcqtqly").refresh();
                                                },
                                            },
                                        },
                                        required: true,
                                        invalidMessage: "Cơ quan thuế quản lý không được để trống !",
                                        bottomPadding: 12
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "text",
                                                label: "Mã CQT quản lý: ",
                                                labelWidth: 185,
                                                name: "mcqtqly",
                                                id: "mcqtqly",
                                                required: true,
                                                invalidMessage: "Mã cơ quan thuế quản lý không được để trống !",
                                                attributes: { maxlength: 5 },
                                                readonly: true,
                                                bottomPadding: 12
                                            },
                                            {
                                                view: "text",
                                                label: "Địa danh: ",
                                                labelWidth: 100,
                                                name: "ddanh",
                                                id: "ddanh",
                                                required: true,
                                                invalidMessage: "Địa danh không được để trống !",
                                                attributes: { maxlength: 20 },
                                                bottomPadding: 12
                                            },
                                        ],
                                    },
                                ],

                            },

                            {
                                cols: [

                                    {
                                        view: "text",
                                        label: "Tên người đại diện theo pháp luật: ",
                                        labelWidth: 215,
                                        name: "tnddpluat",
                                        id: "tnddpluat",
                                        required: true,
                                        invalidMessage: "Đại diện pháp luật không được để trống !",
                                        attributes: { maxlength: 50 },
                                        bottomPadding: 12
                                    },


                                    {
                                        cols: [
                                            {
                                                view: "datepicker",
                                                label: "Ngày tháng năm sinh: ",
                                                labelWidth: 185,
                                                name: "nsddpluat",
                                                id: "nsddpluat",
                                                required: true,
                                                invalidMessage: "Ngày sinh người đại diện không được để trống !",
                                                editable: true,
                                                bottomPadding: 12,
                                                on: {


                                                    onTimedKeyPress: function () {
                                                        var input = this.getInputNode();
                                                        var raw = input.value;

                                                        var cleaned = raw.replace(/[^0-9\/]/g, '');

                                                        cleaned = cleaned.replace(/-/g, '/');

                                                        var slashCount = 0;
                                                        var finalValue = '';
                                                        for (var i = 0; i < cleaned.length; i++) {
                                                            var ch = cleaned[i];
                                                            if (ch === '/') {
                                                                slashCount++;
                                                                if (slashCount > 2) continue;
                                                            }
                                                            finalValue += ch;
                                                        }

                                                        cleaned = finalValue;

                                                        var parts = cleaned.split('/');

                                                        if (parts[0]) parts[0] = parts[0].slice(0, 2);
                                                        if (parts[1]) parts[1] = parts[1].slice(0, 2);
                                                        if (parts[2]) parts[2] = parts[2].slice(0, 4);

                                                        cleaned = parts.join('/');

                                                        if (cleaned !== raw) {
                                                            input.value = cleaned;
                                                        }

                                                        var dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;

                                                        if (cleaned && !dateRegex.test(cleaned)) {
                                                            webix.message({
                                                                type: "error",
                                                                text: "Ngày sinh phải đúng định dạng dd/mm/yyyy!"
                                                            });
                                                        }
                                                    },
                                                }
                                            },

                                            {
                                                view: "combo",
                                                label: "Quốc tịch: ",
                                                labelWidth: 100,
                                                name: "qtich",
                                                id: "qtich",
                                                required: true,
                                                invalidMessage: "Quốc tịch không được để trống!",
                                                bottomPadding: 12,
                                                options: {
                                                    view: "gridsuggest",
                                                    url: {
                                                        $proxy: true,
                                                        load: function (view, callback, params) {
                                                            var url = app.config.host + "/Invoice68/LayTatCaQuocTich";
                                                            webix.ajax(url, function (text) {
                                                                var json = JSON.parse(text);

                                                                var data = json.map(function (x) {
                                                                    return {
                                                                        id: x.MaQuocTich,
                                                                        MaQuocTich: x.MaQuocTich,
                                                                        TenVn: x.TenVn
                                                                    };
                                                                });

                                                                view.parse(data, "json");

                                                                webix.delay(function () {
                                                                    var combo = $$("qtich");
                                                                    // Kiểm tra nếu chưa có giá trị thì mới set VNM
                                                                    if (!combo.getValue()) {
                                                                        combo.setValue("VNM");
                                                                    }

                                                                    var suggest = combo.getPopup().getList();
                                                                    var selected = suggest.getItem(combo.getValue());

                                                                    var passportField = $$("shchieu");
                                                                    var cccdField = $$("cccdan");

                                                                    if (!selected) {
                                                                        // Không có quốc tịch được chọn → không trường nào required
                                                                        passportField.define("required", false);
                                                                        passportField.define("invalidMessage", "");
                                                                        passportField.refresh();

                                                                        cccdField.define("required", false);
                                                                        cccdField.define("invalidMessage", "");
                                                                        cccdField.refresh();
                                                                    }
                                                                    else if (selected && selected.MaQuocTich === "VNM") {
                                                                        passportField.define("required", false);
                                                                        passportField.define("invalidMessage", "");
                                                                        passportField.refresh();

                                                                        cccdField.define("required", true);
                                                                        cccdField.define("invalidMessage", "Số CC/CCCD/Số định danh không được để trống!");
                                                                        cccdField.refresh();
                                                                    } else {
                                                                        passportField.define("required", true);
                                                                        passportField.define("invalidMessage", "Số hộ chiếu bắt buộc với người nước ngoài!");
                                                                        passportField.refresh();

                                                                        cccdField.define("required", false);
                                                                        cccdField.define("invalidMessage", "");
                                                                        cccdField.refresh();
                                                                    }
                                                                }, null, null, 100);
                                                            });
                                                        },
                                                    },
                                                    body: {
                                                        columns: [
                                                            { id: "TenVn", width: 225, header: "Tên" },
                                                            { id: "MaQuocTich", width: 100, header: "Mã" }
                                                        ],
                                                        scroll: true,
                                                        autoheight: false,
                                                        datatype: "json",
                                                    },

                                                },
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        var suggest = this.getPopup().getList();
                                                        var selected = suggest.getItem(newv);


                                                        var passportField = $$("shchieu");
                                                        var cccdField = $$("cccdan");

                                                        if (!selected) {
                                                            // Không có quốc tịch được chọn → không trường nào required
                                                            passportField.define("required", false);
                                                            passportField.define("invalidMessage", "");
                                                            passportField.refresh();

                                                            cccdField.define("required", false);
                                                            cccdField.define("invalidMessage", "");
                                                            cccdField.refresh();
                                                        }
                                                        else if (selected && selected.MaQuocTich === "VNM") {
                                                            // Là người Việt Nam → yêu cầu CCCD
                                                            passportField.define("required", false);
                                                            passportField.define("invalidMessage", "");
                                                            passportField.refresh();

                                                            cccdField.define("required", true);
                                                            cccdField.define("invalidMessage", "Số CCCD không được để trống!");
                                                            cccdField.refresh();
                                                        } else {
                                                            // Người nước ngoài → yêu cầu hộ chiếu
                                                            passportField.define("required", true);
                                                            passportField.define("invalidMessage", "Số hộ chiếu bắt buộc với người nước ngoài!");
                                                            passportField.refresh();

                                                            cccdField.define("required", false);
                                                            cccdField.define("invalidMessage", "");
                                                            cccdField.refresh();
                                                        }
                                                    }
                                                },
                                            },
                                        ],

                                    }

                                ],

                            },

                            {
                                cols: [

                                    {
                                        view: "radio",
                                        label: "Giới tính: ",
                                        labelWidth: 215,
                                        name: "gtinh",
                                        id: "gtinh",
                                        required: true,
                                        value: 1,
                                        invalidMessage: "Giới tính không được để trống !",
                                        options: [
                                            { id: 1, value: "Nam" },
                                            { id: 0, value: "Nữ" }
                                        ],
                                    },
                                ]
                            },

                            {
                                cols: [
                                    {

                                        view: "text",
                                        label: "Điện thoại người đại diện: ",
                                        labelWidth: 215,
                                        name: "dtddpluat",
                                        id: "dtddpluat",
                                        required: true,
                                        attributes: { maxlength: 20 },
                                        bottomPadding: 12,
                                        invalidMessage: "Số điện thoại bắt đầu bằng 0 hoặc +84 và chỉ chứa số.",
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();

                                                input.addEventListener("input", function (e) {
                                                    var value = input.value;
                                                    if (value.startsWith("+")) {
                                                        if (!value.startsWith("+84")) value = "+84";
                                                        var after = value.slice(3).replace(/\D/g, "");
                                                        value = "+84" + after;
                                                    } else if (value.startsWith("0")) {
                                                        value = value.replace(/[^0-9]/g, "");
                                                    } else {
                                                        value = "";
                                                    }
                                                    input.value = value;
                                                });
                                            }
                                        },
                                        validate: function (value) {
                                            if (!value) {
                                                this.define("invalidMessage", "Số điện thoại người đại diện không được để trống!");
                                                return false;
                                            }
                                            var regex = /^(0\d{9,10}|\+84\d{9,10})$/;
                                            var isValid = regex.test(value);
                                            if (!isValid) {
                                                this.define("invalidMessage", "Số điện thoại không hợp lệ! Phải bắt đầu bằng 0 hoặc +84 và chỉ chứa số.");
                                            }
                                            return isValid;
                                        }

                                    },

                                    {
                                        cols: [{

                                            view: "text",
                                            label: "Số CC/CCCD/Số định danh: ",
                                            labelWidth: 185,
                                            name: "cccdan",
                                            id: "cccdan",
                                            attributes: { maxlength: 12 },
                                            editable: true,
                                            bottomPadding: 12,
                                            on: {
                                                onAfterRender: function () {
                                                    var input = this.getInputNode();
                                                    input.addEventListener("input", function () {
                                                        input.value = input.value.replace(/[^0-9]/g, "");
                                                    });
                                                }
                                            }

                                        },

                                        {
                                            view: "text",
                                            label: "Số hộ chiếu: ",
                                            labelWidth: 100,
                                            name: "shchieu",
                                            id: "shchieu",
                                            required: false,
                                            attributes: { maxlength: 20 },
                                            bottomPadding: 12,
                                            //regex
                                            on: {
                                                onAfterRender: function () {
                                                    var input = this.getInputNode();

                                                    input.addEventListener("input", function () {

                                                        input.value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                                    });
                                                }
                                            },
                                        },
                                        ],

                                    }




                                ],

                            },

                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Địa chỉ liên hệ của NNT: ",
                                        labelWidth: 215,
                                        name: "dclhe",
                                        id: "dclhe",
                                        required: true,
                                        invalidMessage: "Địa chỉ không được để trống !",
                                        bottomPadding: 12
                                    },
                                    {
                                        view: "text",
                                        label: "Thư điện tử của NNT: ",
                                        labelWidth: 185,
                                        name: "dctdtu",
                                        id: "dctdtu",
                                        validate: webix.rules.isEmail,
                                        required: true,
                                        invalidMessage: "Thư điện tử không hợp lệ !",
                                        bottomPadding: 12
                                    },
                                ],
                            },

                            {
                                cols: [


                                    {
                                        view: "text",
                                        label: "Người liên hệ: ",
                                        labelWidth: 215,
                                        name: "nlhe",
                                        id: "nlhe"

                                    },
                                    {
                                        view: "text",
                                        label: "Điện thoại liên hệ: ",
                                        labelWidth: 185,
                                        name: "dtlhe",
                                        id: "dtlhe"
                                    },
                                ],
                            },




                            { height: 8 },
                        ],
                    },


                    {
                        rows: [
                            {
                                cols: [
                                    {
                                        view: "label",
                                        label: "Theo Nghị định số 70/2025/NĐ-CP ngày 20 tháng 3 năm 2025 của Chính phủ, chúng tôi/tôi thuộc đối tượng sử dụng hóa đơn điện tử. Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng hóa đơn điện tử như sau:",
                                    },
                                ],
                            },
                            { view: "label", label: "<b>1. Hình thức hoá đơn:</b>" },
                            {
                                view: "checkbox",
                                id: "adhdcma",
                                name: "adhdcma",
                                labelRight: "Có mã của cơ quan thuế",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("htgdlhddtcma").enable();
                                            $$("htgdlhddtcmkkhan").enable();
                                            $$("htgdlhddtcmkcncao").enable();
                                            $$("htgdlhddtcqxltscong").enable();

                                            $$("htgdlhddtkma").enable();
                                            $$("htgdlhddtkmttiep").enable();
                                            $$("htgdlhddtkmtchuc").enable();
                                            $$("hdbtscong").enable();
                                            $$("hdbhdtqgia").enable();
                                            $$("qlnhdon").enable();
                                        }
                                        if (newv == 0) {
                                            if ($$("adhdmttcma").getValue() != 1) {
                                                $$("htgdlhddtcma").enable();
                                                $$("htgdlhddtcmkkhan").enable();
                                                $$("htgdlhddtcmkcncao").enable();
                                                $$("htgdlhddtcqxltscong").enable();

                                                $$("htgdlhddtkma").enable();
                                                $$("htgdlhddtkmttiep").enable();
                                                $$("htgdlhddtkmtchuc").enable();
                                            }

                                            if ($$("adhdmttcma").getValue() == 1 && $$("adhdkma").getValue() != 1) {
                                                $$("hdbtscong").disable();
                                                $$("hdbtscong").setValue(0);
                                                $$("hdbhdtqgia").disable();
                                                $$("hdbhdtqgia").setValue(0);
                                                $$("qlnhdon").disable();
                                                $$("qlnhdon").setValue(0);
                                            }
                                        }

                                        if (newv == 1 && $$("adhdkma").getValue() == 1) {
                                            $$("htgdlhddtcma").enable();
                                            $$("htgdlhddtcmkkhan").enable();
                                            $$("htgdlhddtcmkcncao").enable();

                                            $$("htgdlhddtkma").enable();
                                            $$("htgdlhddtkmttiep").enable();
                                            $$("htgdlhddtkmtchuc").enable();
                                        }

                                        if (newv == 0 && $$("adhdkma").getValue() == 1 && $$("adhdmttcma").getValue() != 1) {
                                            $$("htgdlhddtcma").disable();
                                            $$("htgdlhddtcma").setValue(0);
                                            $$("htgdlhddtcmkkhan").disable();
                                            $$("htgdlhddtcmkkhan").setValue(0);
                                            $$("htgdlhddtcmkcncao").disable();
                                            $$("htgdlhddtcmkcncao").setValue(0);
                                            $$("htgdlhddtcqxltscong").disable();
                                            $$("htgdlhddtcqxltscong").setValue(0);
                                        }
                                    },
                                },
                            },
                            {
                                view: "checkbox",
                                id: "adhdkma",
                                name: "adhdkma",
                                value: 1,
                                labelRight: "Không có mã của cơ quan thuế",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("htgdlhddtcma").disable();
                                            $$("htgdlhddtcma").setValue(0);
                                            $$("htgdlhddtcmkkhan").disable();
                                            $$("htgdlhddtcmkkhan").setValue(0);
                                            $$("htgdlhddtcmkcncao").disable();
                                            $$("htgdlhddtcmkcncao").setValue(0);
                                            $$("htgdlhddtcqxltscong").disable();
                                            $$("htgdlhddtcqxltscong").setValue(0);

                                            $$("hdbtscong").enable();
                                            $$("hdbhdtqgia").enable();
                                            $$("qlnhdon").enable();
                                        }

                                        if (newv == 0) {
                                            $$("htgdlhddtcma").enable();
                                            $$("htgdlhddtcmkkhan").enable();
                                            $$("htgdlhddtcmkcncao").enable();
                                            $$("htgdlhddtcqxltscong").enable();
                                            if ($$("adhdmttcma").getValue() == 1 && $$("adhdcma").getValue() != 1) {
                                                $$("hdbtscong").disable();
                                                $$("hdbtscong").setValue(0);
                                                $$("hdbhdtqgia").disable();
                                                $$("hdbhdtqgia").setValue(0);
                                                $$("qlnhdon").disable();
                                                $$("qlnhdon").setValue(0);
                                            }
                                        }

                                        if (newv == 1 && ($$("adhdcma").getValue() == 1 || $$("adhdmttcma").getValue() == 1)) {
                                            $$("htgdlhddtcma").enable();
                                            $$("htgdlhddtcmkkhan").enable();
                                            $$("htgdlhddtcmkcncao").enable();
                                            $$("htgdlhddtcqxltscong").enable();

                                            $$("htgdlhddtkma").enable();
                                            $$("htgdlhddtkmttiep").enable();
                                            $$("htgdlhddtkmtchuc").enable();
                                        }

                                        // if (newv == 0 && $$("adhdcma").getValue() == 1) {
                                        //     $$("htgdlhddtcma").disable();
                                        //     $$("htgdlhddtcma").setValue(0);
                                        //     $$("htgdlhddtcmkkhan").disable();
                                        //     $$("htgdlhddtcmkkhan").setValue(0);
                                        //     $$("htgdlhddtcmkcncao").disable();
                                        //     $$("htgdlhddtcmkcncao").setValue(0);
                                        //     $$("htgdlhddtcqxltscong").disable();
                                        //     $$("htgdlhddtcqxltscong").setValue(0);


                                        //     $$("htgdlhddtkma").disable();
                                        //     $$("htgdlhddtkma").setValue(0);
                                        //     $$("htgdlhddtkmttiep").disable();
                                        //     $$("htgdlhddtkmttiep").setValue(0);
                                        //     $$("htgdlhddtkmtchuc").disable();
                                        //     $$("htgdlhddtkmtchuc").setValue(0);
                                        // }

                                        // if (newv == 0 && $$("adhdmttcma").getValue() == 1) {
                                        //     $$("htgdlhddtcma").disable();
                                        //     $$("htgdlhddtcma").setValue(0);
                                        //     $$("htgdlhddtcmkkhan").disable();
                                        //     $$("htgdlhddtcmkkhan").setValue(0);
                                        //     $$("htgdlhddtcmkcncao").disable();
                                        //     $$("htgdlhddtcmkcncao").setValue(0);
                                        //     $$("htgdlhddtcqxltscong").disable();
                                        //     $$("htgdlhddtcqxltscong").setValue(0);


                                        //     $$("htgdlhddtkma").disable();
                                        //     $$("htgdlhddtkma").setValue(0);
                                        //     $$("htgdlhddtkmttiep").disable();
                                        //     $$("htgdlhddtkmttiep").setValue(0);
                                        //     $$("htgdlhddtkmtchuc").disable();
                                        //     $$("htgdlhddtkmtchuc").setValue(0);
                                        // }
                                    },
                                },
                            },
                            {
                                view: "checkbox",
                                id: "adhdmttcma",
                                name: "adhdmttcma",
                                value: 1,
                                labelRight: "Có mã khởi tạo từ máy tính tiền",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            if ($$("adhdkma").getValue() != 1) {
                                                $$("htgdlhddtcma").enable();
                                                $$("htgdlhddtcmkkhan").enable();
                                                $$("htgdlhddtcmkcncao").enable();
                                                $$("htgdlhddtcqxltscong").enable();

                                                $$("htgdlhddtkma").enable();
                                                $$("htgdlhddtkmttiep").enable();
                                                $$("htgdlhddtkmtchuc").enable();

                                            }

                                            if ($$("adhdcma").getValue() != 1 && $$("adhdkma").getValue() != 1) {
                                                $$("hdbtscong").disable();
                                                $$("hdbtscong").setValue(0);
                                                $$("hdbhdtqgia").disable();
                                                $$("hdbhdtqgia").setValue(0);
                                                $$("qlnhdon").disable();
                                                $$("qlnhdon").setValue(0);
                                            }
                                        }
                                        if (newv == 0 && $$("adhdkma").getValue() == 1) {
                                            $$("htgdlhddtcma").enable();
                                            $$("htgdlhddtcmkkhan").enable();
                                            $$("htgdlhddtcmkcncao").enable();
                                            $$("htgdlhddtcqxltscong").enable();

                                            $$("htgdlhddtkma").enable();
                                            $$("htgdlhddtkmttiep").enable();
                                            $$("htgdlhddtkmtchuc").enable();

                                            $$("hdbtscong").enable();
                                            $$("hdbhdtqgia").enable();
                                            $$("qlnhdon").enable();
                                        }

                                        if (newv == 1 && $$("adhdkma").getValue() == 1) {
                                            $$("htgdlhddtcma").enable();
                                            $$("htgdlhddtcmkkhan").enable();
                                            $$("htgdlhddtcmkcncao").enable();
                                            $$("htgdlhddtcqxltscong").enable();

                                            $$("htgdlhddtkma").enable();
                                            $$("htgdlhddtkmttiep").enable();
                                            $$("htgdlhddtkmtchuc").enable();
                                        }

                                        if (newv == 0 && $$("adhdkma").getValue() == 1 && $$("adhdcma").getValue() != 1) {
                                            $$("htgdlhddtcma").disable();
                                            $$("htgdlhddtcma").setValue(0);
                                            $$("htgdlhddtcmkkhan").disable();
                                            $$("htgdlhddtcmkkhan").setValue(0);
                                            $$("htgdlhddtcmkcncao").disable();
                                            $$("htgdlhddtcmkcncao").setValue(0);
                                            $$("htgdlhddtcqxltscong").disable();
                                            $$("htgdlhddtcqxltscong").setValue(0);
                                        }

                                        if (newv == 0 && $$("adhdkma").getValue() == 0 && $$("adhdcma").getValue() == 0) {
                                            $$("htgdlhddtcma").enable();
                                            $$("htgdlhddtcmkkhan").enable();
                                            $$("htgdlhddtcmkcncao").enable();
                                            $$("htgdlhddtcqxltscong").enable();

                                            $$("htgdlhddtkma").enable();
                                            $$("htgdlhddtkmttiep").enable();
                                            $$("htgdlhddtkmtchuc").enable();

                                            $$("hdbtscong").enable();
                                            $$("hdbhdtqgia").enable();
                                            $$("qlnhdon").enable();
                                        }
                                    },
                                },
                            },
                            { view: "label", id: "label", label: "<b>2. Hình thức gửi dữ liệu hóa đơn điện tử:</b>" },
                            {
                                view: "checkbox",
                                id: "htgdlhddtcma",
                                name: "htgdlhddtcma",
                                labelRight: "Trường hợp sử dụng hóa đơn điện tử có mã trên Cổng thông tin điện tử của Tổng cục Thuế hoặc tổ chức cung cấp dịch vụ hóa đơn điện tử được Tổng cục Thuế ủy thác:",
                                label: "a. ",
                                labelWidth: 10,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("htgdlhddtkma").setValue(0);
                                            $$("htgdlhddtcma").setValue(1);
                                            $$("htgdlhddtcmkkhan").setValue(1);
                                            $$("htgdlhddtcmkcncao").setValue(0);
                                            $$("htgdlhddtkmttiep").setValue(0);
                                            $$("htgdlhddtkmtchuc").setValue(0);
                                        }
                                        if (newv == 0) {
                                            $$("htgdlhddtcmkkhan").setValue(0);
                                            $$("htgdlhddtcmkcncao").setValue(0);
                                            $$("htgdlhddtcqxltscong").setValue(0);
                                        }
                                    },
                                },
                            },
                            {
                                view: "checkbox",
                                id: "htgdlhddtcmkkhan",
                                name: "htgdlhddtcmkkhan",
                                labelRight:
                                    "Doanh nghiệp nhỏ và vừa, hợp tác xã, cá nhân kinh doanh tại địa bàn có điều kiện kinh tế xã hội khó khăn, địa bàn có điều kiện kinh tế xã hội đặc biệt khó khăn( điểm a khoản 1 Điều 14 của Nghị định).",
                                labelWidth: 50,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("htgdlhddtkma").setValue(0);
                                            $$("htgdlhddtcma").setValue(1);
                                            $$("htgdlhddtcmkcncao").setValue(0);
                                            $$("htgdlhddtcmkkhan").setValue(1);
                                            $$("htgdlhddtcqxltscong").setValue(0);
                                        }

                                    },
                                },
                            },
                            {
                                view: "checkbox",
                                id: "htgdlhddtcmkcncao",
                                name: "htgdlhddtcmkcncao",
                                labelRight:
                                    "Doanh nghiệp nhỏ và vừa khác theo đề nghị của Ủy ban nhân dân tỉnh, thành phố trực thuộc trung ương gửi Bộ Tài chính trừ doanh nghiệp hoạt động tại các khu vực kinh tế, khu công nghiệp, khu công nghệ cao(điểm b khoản 1 Điều 14 của Nghị định).",
                                labelWidth: 50,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("htgdlhddtkma").setValue(0);
                                            $$("htgdlhddtcma").setValue(1);
                                            $$("htgdlhddtcmkcncao").setValue(1);
                                            $$("htgdlhddtcmkkhan").setValue(0);
                                            $$("htgdlhddtcqxltscong").setValue(0);
                                        }
                                    },
                                },
                            },

                            //Khoản 11 điều 1 Nghị định 70
                            {
                                view: "checkbox",
                                id: "htgdlhddtcqxltscong",
                                name: "htgdlhddtcqxltscong",
                                labelRight:
                                    "Cơ quan thuế hoặc cơ quan được giao nhiệm vụ tổ chức, xử lý tài sản công theo quy định pháp luật về quản lý, sử dụng tài sản công(khoản 1 Điều 15 Nghị định).",
                                labelWidth: 50,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("htgdlhddtkma").setValue(0);
                                            $$("htgdlhddtcma").setValue(1);
                                            $$("htgdlhddtcmkcncao").setValue(0);
                                            $$("htgdlhddtcmkkhan").setValue(0);
                                            $$("htgdlhddtcqxltscong").setValue(1);
                                        }
                                    },
                                },
                            },


                            {
                                view: "checkbox",
                                id: "htgdlhddtkma",
                                name: "htgdlhddtkma",
                                labelRight:
                                    "Trường hợp sử dụng hóa đơn điện tử không có mã của cơ quan thuế:</B></i>",
                                label: "b. ",
                                labelWidth: 10,
                                value: 1,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("htgdlhddtkma").setValue(1);
                                            $$("htgdlhddtcma").setValue(0);
                                            $$("htgdlhddtcmkkhan").setValue(0);
                                            $$("htgdlhddtcmkcncao").setValue(0);
                                            $$("htgdlhddtcqxltscong").setValue(0);
                                            $$("htgdlhddtkmttiep").setValue(1);
                                            $$("htgdlhddtkmtchuc").setValue(0);
                                        }
                                        if (newv == 0) {
                                            $$("htgdlhddtkmttiep").setValue(0);
                                            $$("htgdlhddtkmtchuc").setValue(0);
                                        }
                                    },
                                },
                            },
                            {
                                view: "checkbox",
                                id: "htgdlhddtkmttiep",
                                name: "htgdlhddtkmttiep",
                                labelRight: "Gửi trực tiếp đến cơ quan thuế (điểm b1, khoản 3, Điều 22 của Nghị định).",
                                labelWidth: 50,
                                value: 1,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("htgdlhddtkma").setValue(1);
                                            $$("htgdlhddtcma").setValue(0);
                                            $$("htgdlhddtkmtchuc").setValue(0);
                                            $$("htgdlhddtkmttiep").setValue(1);

                                        }
                                    },
                                },
                            },
                            {
                                view: "checkbox",
                                id: "htgdlhddtkmtchuc",
                                name: "htgdlhddtkmtchuc",
                                labelRight: "Gửi đến cơ quan thuế thông qua tổ chức cung cấp dịch vụ hóa đơn điện tử (điểm b2, khoản 3, Điều 22 của Nghị định).",
                                labelWidth: 50,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("htgdlhddtkma").setValue(1);
                                            $$("htgdlhddtcma").setValue(0);
                                            $$("htgdlhddtkmtchuc").setValue(1);
                                            $$("htgdlhddtkmttiep").setValue(0);
                                        }
                                    },
                                },
                            },


                            { view: "label", label: "<b>3. Phương thức chuyển dữ liệu hóa đơn điện tử:</b>" },
                            {
                                view: "checkbox",
                                id: "ptcdlhdndthdon",
                                name: "ptcdlhdndthdon",
                                labelRight: "Chuyển đầy đủ nội dung từng hóa đơn",
                                value: 1,
                                labelWidth: 50,
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("ptcdlhdndthdon").setValue(1);
                                //             $$("ptcdlhdbthop").setValue(0);
                                //         }
                                //     },
                                // },
                            },
                            {
                                view: "checkbox",
                                id: "ptcdlhdbthop",
                                name: "ptcdlhdbthop",
                                labelRight: "Chuyển dữ liệu hóa đơn điện tử theo Bảng tổng hợp dữ liệu hóa đơn điện tử theo Mẫu số 01/TH-HĐĐT(điểm a1, khoản 3, Điều 22 của Nghị định)",
                                labelWidth: 50,
                                // on: {
                                //     onChange: function (newv, oldv) {
                                //         if (newv == 1) {
                                //             $$("ptcdlhdndthdon").setValue(0);
                                //             $$("ptcdlhdbthop").setValue(1);
                                //         }
                                //     },
                                // },
                            },

                            { view: "label", label: "<b>4. Loại hóa đơn sử dụng:</b>" },
                            {
                                view: "checkbox",
                                id: "hdgtgt",
                                name: "hdgtgt",
                                labelRight: "Hóa đơn GTGT",
                                value: 1,
                                labelWidth: 50,
                            },

                            {
                                view: "checkbox",
                                id: "hdgtgtthblai",
                                name: "hdgtgtthblai",
                                labelRight: "Hóa đơn GTGT tích hợp biên lai thu thuế, phí, lệ phí ",
                                labelWidth: 50,
                            },

                            {
                                view: "checkbox",
                                id: "hdbhang",
                                name: "hdbhang",
                                labelRight: "Hóa đơn bán hàng",
                                labelWidth: 50,
                            },

                            {
                                view: "checkbox",
                                id: "hdbhthblai",
                                name: "hdbhthblai",
                                labelRight: "Hóa đơn bán hàng tích hợp biên lai thu thuế, phí, lệ phí ",
                                labelWidth: 50,
                            },

                            {
                                view: "checkbox",
                                id: "hdtmai",
                                name: "hdtmai",
                                labelRight: "Hóa đơn thương mại ",
                                labelWidth: 50,
                            },

                            // {
                            //     view: "checkbox",
                            //     id: "hdnccnn",
                            //     name: "hdnccnn",
                            //     labelRight: "Hóa đơn nhà cung cấp ở nước ngoài không có cơ sở thường trú tại Việt Nam ",
                            //     labelWidth: 50,
                            // },

                            {
                                view: "checkbox",
                                id: "hdbtscong",
                                name: "hdbtscong",
                                labelRight: "Hóa đơn bán tài sản công",
                                labelWidth: 50,
                            },
                            {
                                view: "checkbox",
                                id: "hdbhdtqgia",
                                name: "hdbhdtqgia",
                                labelRight: "Hóa đơn bán hàng dự trữ quốc gia",
                                labelWidth: 50,
                            },
                            {
                                view: "checkbox",
                                id: "hdkhac",
                                name: "hdkhac",
                                labelRight: "Hóa đơn khác (Tem, vé, thẻ, phiếu....)",
                                labelWidth: 50,
                            },
                            {
                                view: "checkbox",
                                id: "qlnhdon",
                                name: "qlnhdon",
                                labelRight: "Các chứng từ được in, phát hành, sử dụng và quản lý như hóa đơn (<i>VD HĐ phiếu xuất kho,...</i>)",
                                labelWidth: 50,
                            },
                        ],
                    },

                    {
                        rows: [
                            {
                                view: "label",
                                label: "<b>5. Danh sách chứng thư số sử dụng:</b>",
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        label: " Thêm",
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = "";
                                                        for (var i = 0; i < result.length; i++) {
                                                            var item = result[i];
                                                            kytaptrung = item.value;
                                                        }
                                                        webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                            var listcerts = JSON.parse(text);
                                                            if (listcerts.length > 0) {
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();

                                                                                var cert = null;
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }

                                                                                var now = new Date();
                                                                                var begin = new Date(cert.begin_date);
                                                                                var end = new Date(cert.end_date);
                                                                                if (now < begin || now > end) {
                                                                                    webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                    return;
                                                                                }

                                                                                var item = {
                                                                                    stt: $$("danhsach_chukyso").count() + 1,
                                                                                    ttchuc: cert.issuer,
                                                                                    seri: cert.cer_serial,
                                                                                    tngay: new Date(cert.begin_date),
                                                                                    dngay: new Date(cert.end_date),
                                                                                    hthuc: "1",
                                                                                    allowEdit: false
                                                                                };
                                                                                $$("danhsach_chukyso").add(item);
                                                                                return;
                                                                        }
                                                                    },
                                                                });

                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        { id: "chon", header: _("CHON"), width: 65, checkValue: true, uncheckValue: false, template: "{common.checkbox()}" },
                                                                        { id: "cert_type", header: _("Loại"), width: 100 },
                                                                        { id: "cer_serial", header: _("SO_SERIAL"), width: 150 },
                                                                        { id: "subject_name", header: _("SUBJECTNAME"), width: 450 },
                                                                        { id: "begin_date", header: _("NGAY_BAT_DAU"), width: 200 },
                                                                        { id: "end_date", header: _("NGAY_KET_THUC"), width: 200 },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 },
                                                                    ],
                                                                    url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                });
                                                            } else {
                                                                // xem user có tích checkbox ký HSM không?
                                                                var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                                                webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                                                    if (resultscheckSigHSM[0].json() == "C") {
                                                                        webix.ajax().get(app.config.host + "/Invoice68/GetCTS_HSM_ToKhai", function (result) {
                                                                            var ctsHSM = JSON.parse(result);

                                                                            if (ctsHSM.hasOwnProperty("error")) {
                                                                                webix.message({ type: "error", text: ctsHSM.error });
                                                                            } else {
                                                                                var item = {
                                                                                    stt: $$("danhsach_chukyso").count() + 1,
                                                                                    ttchuc: ctsHSM.issuer,
                                                                                    seri: ctsHSM.so_serial,
                                                                                    tngay: ctsHSM.ngaybatdau,
                                                                                    dngay: ctsHSM.ngayketthuc,
                                                                                    hthuc: "1",
                                                                                };

                                                                                // $$("danhsach_chukyso").clearAll();
                                                                                $$("danhsach_chukyso").add(item);
                                                                            }
                                                                        });
                                                                    } else {
                                                                        var hub = plugin.hub();

                                                                        hub.off("resCommand");
                                                                        hub.on("resCommand", function (result) {
                                                                            var json = JSON.parse(result);

                                                                            if (json.hasOwnProperty("error")) {
                                                                                webix.message({ type: "error", text: json.error });
                                                                            } else {
                                                                                var callback = json.callback;

                                                                                if (callback == "RegisterCert") {
                                                                                    var item = {
                                                                                        stt: $$("danhsach_chukyso").count() + 1,
                                                                                        ttchuc: json.data.issuer,
                                                                                        seri: json.data.so_serial,
                                                                                        tngay: json.data.ngaybatdau,
                                                                                        dngay: json.data.ngayketthuc,
                                                                                        hthuc: "1",
                                                                                    };

                                                                                    // $$("danhsach_chukyso").clearAll();
                                                                                    $$("danhsach_chukyso").add(item);
                                                                                }
                                                                            }
                                                                        });

                                                                        var arg = {
                                                                            callback: "RegisterCert",
                                                                        };

                                                                        hub.invoke("execCommand", arg.callback, JSON.stringify(arg));
                                                                    }
                                                                });
                                                            }
                                                        });
                                                    });
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        autowidth: true,
                                        label: " Xóa",
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_chukyso");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        label: "Nhập thông tin",
                                        width: 180,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function () {
                                                var table = $$("danhsach_chukyso");
                                                var item = {
                                                    stt: table.count() + 1,
                                                    ttchuc: "",
                                                    seri: "",
                                                    tngay: new Date(),
                                                    dngay: new Date(),
                                                    hthuc: "1",
                                                    allowEdit: true
                                                };
                                                table.add(item);
                                                reindex(table);
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_chukyso",
                                name: "danhsach_chukyso",
                                autoheight: true,
                                select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scroll: true,
                                fullscreen: true,
                                on: {

                                    onBeforeEditStart: function (id) {
                                        var item = this.getItem(id.row);
                                        if (item && item.allowEdit === false) {
                                            return false;
                                        }

                                        if (id.column === "tngay" || id.column === "dngay") {
                                            var value = item[id.column];
                                            if (typeof value === 'string') {
                                                item[id.column] = new Date(value);
                                            }
                                        }
                                    },




                                },
                                columns: [
                                    { id: "stt", name: "stt", header: "STT", sort: "int", width: 40 },
                                    {
                                        id: "ttchuc",
                                        name: "ttchuc",
                                        header: "Tên tổ chức cơ quan chứng thực/cấp/công nhận chữ ký số, chữ ký điện tử",
                                        width: 450,
                                        editor: "text"
                                    },
                                    {
                                        id: "seri",
                                        name: "seri",
                                        header: "Số sê-ri chứng thư số",
                                        width: 300,
                                        editor: "text"
                                    },
                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [{ text: "Thời hạn sử dụng chứng thư số", colspan: 2 }, { text: "Từ ngày" }],
                                        width: 130,
                                        editor: "date",
                                        format: function (value) {
                                            if (!value) return "";
                                            var dateObject = (typeof value === "string") ? new Date(value) : value;
                                            if (isNaN(dateObject.getTime())) return "NaN/NaN/NaN";
                                            return webix.Date.dateToStr("%d/%m/%Y")(dateObject);
                                        }
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [null, { text: "Đến ngày" }],
                                        width: 130,
                                        editor: "date",
                                        format: function (value) {
                                            if (!value) return "";
                                            var dateObject = (typeof value === "string") ? new Date(value) : value;
                                            if (isNaN(dateObject.getTime())) return "NaN/NaN/NaN";
                                            return webix.Date.dateToStr("%d/%m/%Y")(dateObject);
                                        }
                                    },
                                    {
                                        id: "hthuc",
                                        name: "hthuc",
                                        header: "Hình thức đăng ký (Thêm mới, Gia hạn, Ngừng sử dụng)",
                                        fillspace: true,
                                        editor: "combo",
                                        options: [
                                            { id: "1", value: "Thêm mới" },
                                            { id: "2", value: "Gia hạn" },
                                            { id: "3", value: "Ngừng sử dụng" },
                                        ]
                                    }
                                ],

                                rules: {
                                    ttchuc: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({ type: "error", text: "Tên tổ chức không được để trống!" });
                                            return false;
                                        }
                                        if (value.length > 400) {
                                            webix.message({ type: "error", text: "Tên tổ chức tối đa 400 ký tự!" });
                                            return false;
                                        }
                                        return true;
                                    },
                                    seri: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({ type: "error", text: "Số sê-ri không được để trống!" });
                                            return false;
                                        }
                                        if (value.length > 40) {
                                            webix.message({ type: "error", text: "Số sê-ri tối đa 40 ký tự!" });
                                            return false;
                                        }
                                        return true;
                                    },
                                    hthuc: function (value) {
                                        if (!value) {
                                            webix.message({ type: "error", text: "Phải chọn hình thức đăng ký!" });
                                            return false;
                                        }
                                        return true;
                                    }
                                }

                            },
                        ],
                    },

                    { height: 5 },
                    {
                        view: "combo",
                        label: "Loại đăng ký ủy nhiệm",
                        id: "ldkunhiem",
                        name: "ldkunhiem",
                        labelWidth: 150,
                        options: [
                            { id: 1, value: "Ủy nhiệm" },
                            { id: 2, value: "Nhận ủy nhiệm" },
                        ],
                        width: 400,
                    },
                    { height: 5 },
                    {
                        rows: [
                            {
                                view: "label",
                                label: "<b>6. Đăng ký ủy nhiệm lập hóa đơn:</b>",
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " Thêm",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var item = {
                                                    stt: $$("danhsach_uynhiem").count() + 1,
                                                    tlhdunhiem: "",
                                                    khmhdon: "",
                                                    khhdunhiem: "",
                                                    mstunhiem: "",
                                                    ttcdunhiem: "",
                                                    mdunhiem: "",
                                                    thunhiem: "",
                                                    tngay: new Date(),
                                                    dngay: new Date(),
                                                    pttthdunhiem: 1,
                                                    ket_qua: 0,
                                                };
                                                // $$("danhsach_uynhiem").clearAll();
                                                $$("danhsach_uynhiem").add(item);

                                                $$("ldkunhiem").define("required", true);
                                                $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                                $$("ldkunhiem").refresh();

                                                return;
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " Xóa",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_uynhiem");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();

                                                    if (table.count() == 0) {
                                                        $$("ldkunhiem").define("required", false);
                                                        $$("ldkunhiem").refresh();
                                                    } else {
                                                        $$("ldkunhiem").define("required", true);
                                                        $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                                        $$("ldkunhiem").refresh();
                                                    }

                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();

                                                    if (table.count() == 0) {
                                                        $$("ldkunhiem").define("required", false);
                                                        $$("ldkunhiem").refresh();
                                                    } else {
                                                        $$("ldkunhiem").define("required", true);
                                                        $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                                        $$("ldkunhiem").refresh();
                                                    }

                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {},
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_uynhiem",
                                name: "danhsach_uynhiem",
                                select: true,
                                autoheight: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scroll: true,
                                fullscreen: true,
                                scheme: {
                                    $init: function (obj) {
                                        obj.tngay = new Date(obj.tngay);
                                        obj.dngay = new Date(obj.dngay);
                                    },
                                },
                                on: {},
                                columns: [
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                    },
                                    {
                                        id: "tlhdunhiem",
                                        name: "tlhdunhiem",
                                        header: "Tên loại hóa đơn ủy nhiệm",
                                        width: 200,
                                        editor: "text",
                                    },
                                    {
                                        id: "khmhdon",
                                        name: "khmhdon",
                                        header: "Ký hiệu mẫu hóa đơn",
                                        width: 150,
                                        editor: "text",
                                    },
                                    {
                                        id: "khhdunhiem",
                                        name: "khhdunhiem",
                                        header: "Ký hiệu hóa đơn ủy nhiệm",
                                        width: 150,
                                        editor: "text",
                                    },
                                    {
                                        id: "mstunhiem",
                                        name: "mstunhiem",
                                        header: "Mã số thuế",
                                        width: 150,
                                        editor: "text",
                                    },
                                    {
                                        id: "ttcdunhiem",
                                        name: "ttcdunhiem",
                                        header: "Tên tổ chức được ủy nhiệm",
                                        width: 300,
                                        editor: "text",
                                    },
                                    {
                                        id: "mdunhiem",
                                        name: "mdunhiem",
                                        header: "Mục đích ủy nhiệm",
                                        width: 300,
                                        editor: "text",
                                    },
                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                text: "Thời hạn sử dụng chứng thư số",
                                                colspan: 2,
                                            },
                                            {
                                                text: "Từ ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                text: "Đến ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "pttthdunhiem",
                                        name: "pttthdunhiem",
                                        header: "PTTT hóa đơn ủy nhiệm",
                                        fillspace: true,
                                        editor: "text",
                                        //editor: "combo",
                                        // options: [
                                        //     { id: 1, value: "Tiền mặt" },
                                        //     { id: 2, value: "Chuyển khoản" },
                                        //     { id: 3, value: "Tiền mặt/Chuyển khoản" },
                                        //     { id: 4, value: "Đối trừ công nợ" },
                                        //     { id: 5, value: "Không thu tiền" },
                                        //     { id: 9, value: "Khác" },
                                        // ],
                                        width: 150,
                                    },
                                    {
                                        id: "ket_qua",
                                        name: "ket_qua",
                                        header: "Kết quả",
                                        fillspace: true,
                                        format: function (text) {
                                            var result = "";
                                            if (text == 0) {
                                                result = "Chờ phản hồi";
                                            } else if (text == 1) {
                                                result = "Chấp nhận";
                                            } else if (text == 2) {
                                                result = "Không chấp nhận";
                                            }
                                            return result;
                                        },
                                        width: 150,
                                    },
                                ],
                                rules: {
                                    tlhdunhiem: webix.rules.isNotEmpty,
                                    khmhdon: webix.rules.isNotEmpty,
                                    khhdunhiem: webix.rules.isNotEmpty,
                                    mstunhiem: webix.rules.isNotEmpty,
                                    ttcdunhiem: webix.rules.isNotEmpty,
                                    mdunhiem: webix.rules.isNotEmpty,
                                    tngay: webix.rules.isNotEmpty,
                                    dngay: webix.rules.isNotEmpty,
                                    pttthdunhiem: webix.rules.isNotEmpty,
                                },
                                ready: function () {
                                    var tableUyNhiem = webix.$$("danhsach_uynhiem");
                                    if (tableUyNhiem.count() == 0) {
                                        $$("ldkunhiem").define("required", false);
                                        $$("ldkunhiem").refresh();
                                    } else {
                                        $$("ldkunhiem").define("required", true);
                                        $$("ldkunhiem").define("invalidMessage", "Loại đăng ký ủy nhiệm không được để trống !");
                                        $$("ldkunhiem").refresh();
                                    }
                                },
                            },
                        ],
                    },

                    // danh sách tổ chức cung cấp dịch vụ hóa đơn điện tử
                    { height: 5 },
                    {
                        rows: [
                            {
                                view: "label",
                                label: "<b>7. Danh sách tổ chức cung cấp dịch vụ hóa đơn điện tử:</b>",
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " Thêm",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function () {
                                                var table = $$("danhsach_nhacungcap");

                                                var contract_info = app.contractInfoCache;

                                                var item = {
                                                    stt: 0, // tạm gán, sẽ cập nhật sau
                                                    ttcgp: "Tổng công ty Viễn thông MobiFone",
                                                    msttcgp: "0100686209",
                                                    tngay: contract_info.start_date,
                                                    dngay: contract_info.end_date,
                                                    gchu: "",
                                                };

                                                table.add(item);

                                                // Cập nhật lại stt cho toàn bộ danh sách
                                                reindex(table);
                                            },

                                        },


                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " Xóa",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function () {
                                                var table = $$("danhsach_nhacungcap");
                                                table.editStop();

                                                var item = table.getSelectedItem();
                                                if (item) {
                                                    if (table.count() === 1) {
                                                        webix.message("Cần có ít nhất một tổ chức cung cấp!");
                                                        return;
                                                    }

                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    reindex(table);
                                                    return;
                                                }

                                                var editor = table.getEditState();
                                                if (editor) {
                                                    var editingItem = table.getItem(editor.row);
                                                    if (table.count() === 1) {
                                                        webix.message("Cần có ít nhất một tổ chức cung cấp!");
                                                        return;
                                                    }

                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    reindex(table);
                                                }

                                            }
                                        },
                                    },
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_nhacungcap",
                                name: "danhsach_nhacungcap",
                                select: true,
                                resizeColumn: true,
                                autoheight: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scroll: true,
                                fullscreen: true,
                                scheme: {
                                    $init: function (obj) {
                                        obj.tngay = new Date(obj.tngay);
                                        obj.dngay = "";
                                    },
                                },
                                on: {
                                    onAfterEditStop: function (state, editor) {
                                        var item = this.getItem(editor.row);

                                        if (editor.column === "tngay" || editor.column === "dngay") {
                                            var fromDate = new Date(item.tngay);
                                            var toDate = new Date(item.dngay);
                                            var now = new Date();

                                            if (item.tngay && fromDate > now) {
                                                webix.message({ type: "error", text: "'Từ ngày' không được lớn hơn ngày hiện tại!" });
                                                item.tngay = new Date();
                                                this.updateItem(editor.row, item);
                                                return;
                                            }

                                            if (item.tngay && item.dngay && toDate < fromDate) {
                                                webix.message({ type: "error", text: "'Đến ngày' không được nhỏ hơn 'Từ ngày'!" });
                                                item.dngay = "";
                                                this.updateItem(editor.row, item);
                                            }
                                        }
                                    }
                                },


                                columns: [
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        },
                                    },
                                    {
                                        id: "ttcgp",
                                        name: "ttcgp",
                                        header: "Tên tổ chức cung cấp giải pháp hóa đơn điện tử ",
                                        width: 400,
                                        editor: "text",
                                        attributes: { maxlength: 400 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.ttcgp);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 400) {
                                                        input.value = input.value.slice(0, 400);
                                                        webix.message({ type: "error", text: "Tên tổ chức cung cấp được nhập tối đa 400 ký tự!" });
                                                    }
                                                });
                                            }
                                        }



                                    },
                                    {
                                        id: "msttcgp",
                                        name: "msttcgp",
                                        header: "Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử ",
                                        width: 350,
                                        editor: "text",
                                        attributes: { maxlength: 14 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.msttcgp);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 14) {
                                                        input.value = input.value.slice(0, 14);
                                                        webix.message({ type: "error", text: "Mã số thuế tổ chức cung cấp giải pháp được nhập tối đa 14 ký tự!" });
                                                    }
                                                });
                                            }
                                        }

                                    },

                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                text: "Thời hạn sử dụng dịch vụ",
                                                colspan: 2,
                                            },
                                            {
                                                text: "Từ ngày",
                                            },
                                        ],
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        },
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                text: "Đến ngày",
                                            },
                                        ],
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        },
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },



                                    {
                                        id: "gchu",
                                        name: "gchu",
                                        header: "Ghi chú",
                                        fillspace: true,
                                        editor: "text",
                                        width: 150,
                                        attributes: { maxlength: 225 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.gchu);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 255) {
                                                        input.value = input.value.slice(0, 255);
                                                        webix.message({ type: "error", text: "Ghi chú được nhập tối đa 255 ký tự!" });
                                                    }
                                                });
                                            }
                                        }

                                    },

                                ],
                                rules: {
                                    ttcgp: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên tổ chức cung cấp giải pháp hóa đơn điện tử</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 400) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên tổ chức cung cấp giải pháp hóa đơn điện tử</b> vượt quá 400 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    msttcgp: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mã số thuế tổ chức cung cấp</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 14) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mã số thuế tổ chức cung cấp</b> vượt quá 14 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    gchu: function (value) {

                                        if (value && value.length > 255) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Ghi chú</b> vượt quá 255 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },


                                    tngay: function (value) {

                                        if (!value) {
                                            webix.message({
                                                type: "error",
                                                text: "Từ ngày không được để trống"
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                },
                                validateOnEdit: true,
                            },
                        ],
                    },

                    //chứa danh sách tổ chức truyền nhận

                    { height: 5 },
                    {
                        rows: [
                            {
                                view: "label",
                                label: "<b>8. Danh sách tổ chức truyền nhận:</b>",
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " Thêm",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",

                                        on: {
                                            onItemClick: function () {
                                                var table = $$("danhsach_truyennhan");

                                                var contract_info = app.contractInfoCache;

                                                var item = {
                                                    stt: 0, // tạm gán, sẽ cập nhật sau
                                                    ttctn: "Tổng công ty Viễn thông MobiFone",
                                                    msttctn: "0100686209",
                                                    tngay: contract_info.start_date,
                                                    dngay: contract_info.end_date,
                                                    gchu: "",
                                                };

                                                table.add(item);

                                                // Cập nhật lại stt cho toàn bộ danh sách
                                                reindex(table);
                                            },
                                        },
                                    },


                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " Xóa",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function () {
                                                var table = $$("danhsach_truyennhan");
                                                table.editStop();

                                                var item = table.getSelectedItem();
                                                if (item) {
                                                    // Nếu chỉ còn 1 dòng thì không cho xóa
                                                    if (table.count() === 1) {
                                                        webix.message({ type: "warning", text: "Cần có ít nhất một tổ chức truyền nhận!" });
                                                        return;
                                                    }

                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    reindex(table);
                                                    return;
                                                }

                                                var editor = table.getEditState();
                                                if (editor) {
                                                    var editingItem = table.getItem(editor.row);

                                                    // Nếu chỉ còn 1 dòng thì không cho xóa
                                                    if (table.count() === 1) {
                                                        webix.message({ type: "warning", text: "Cần có ít nhất một tổ chức truyền nhận!" });
                                                        return;
                                                    }

                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    reindex(table);
                                                }

                                            }
                                        }

                                    },

                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_truyennhan",
                                name: "danhsach_truyennhan",
                                select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scroll: true,
                                fullscreen: true,
                                autoheight: true,
                                validateOnEdit: true,
                                scheme: {
                                    $init: function (obj) {
                                        obj.tngay = new Date(obj.tngay);
                                        obj.dngay = "";
                                    },
                                },
                                on: {
                                    onAfterEditStop: function (state, editor) {
                                        var item = this.getItem(editor.row);

                                        if (editor.column === "tngay" || editor.column === "dngay") {
                                            var fromDate = new Date(item.tngay);
                                            var toDate = new Date(item.dngay);
                                            var now = new Date();

                                            if (item.tngay && fromDate > now) {
                                                webix.message({ type: "error", text: "'Từ ngày' không được lớn hơn ngày hiện tại!" });
                                                item.tngay = new Date();
                                                this.updateItem(editor.row, item);
                                                return;
                                            }

                                            if (item.tngay && item.dngay && toDate < fromDate) {
                                                webix.message({ type: "error", text: "'Đến ngày' không được nhỏ hơn 'Từ ngày'!" });
                                                item.dngay = "";
                                                this.updateItem(editor.row, item);
                                            }
                                        }
                                    }
                                },
                                columns: [
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        },
                                    },
                                    {
                                        id: "ttctn",
                                        name: "ttctn",
                                        header: "Tên tổ chức truyền nhận ",
                                        width: 400,
                                        editor: "text",
                                        attributes: { maxlength: 400 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.ttctn);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 400) {
                                                        input.value = input.value.slice(0, 400);
                                                        webix.message({ type: "error", text: "Tên tổ chức truyền nhận được nhập tối đa 400 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },
                                    {
                                        id: "msttctn",
                                        name: "msttctn",
                                        header: "Mã số thuế tổ chức truyền nhận ",
                                        width: 350,
                                        editor: "text",
                                        attributes: { maxlength: 14 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.msttctn);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 14) {
                                                        input.value = input.value.slice(0, 14);
                                                        webix.message({ type: "error", text: "Mã số thuế tổ chức được nhập tối đa 14 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },
                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                text: "Thời hạn sử dụng dịch vụ",
                                                colspan: 2,
                                            },
                                            {
                                                text: "Từ ngày",
                                            },
                                        ],
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        },
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                text: "Đến ngày",
                                            },
                                        ],
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        },
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "gchu",
                                        name: "gchu",
                                        header: "Ghi chú",
                                        fillspace: true,
                                        editor: "text",
                                        width: 150,
                                        attributes: { maxlength: 255 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.gchu);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 255) {
                                                        input.value = input.value.slice(0, 255);
                                                        webix.message({ type: "error", text: "Ghi chú được nhập tối đa 255 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },

                                ],
                                rules: {
                                    ttctn: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên tổ chức truyền nhận</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 400) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên tổ chức truyền nhận</b> vượt quá 400 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    msttctn: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mã số thuế tổ chức truyền nhận</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 14) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mã số thuế tổ chức truyền nhận</b> vượt quá 14 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    gchu: function (value) {

                                        if (value && value.length > 255) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Ghi chú</b> vượt quá 255 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    tngay: function (value) {

                                        if (!value) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Từ ngày</b> không được để trống"
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                },
                            },
                        ],
                    },

                    //danh sách đơn vị hạch toán phụ thuộc cần cấp quyền tra cứu hóa đơn

                    { height: 5 },
                    {
                        rows: [
                            {
                                view: "label",
                                label: "<b>9. Đơn vị hạch toán phụ thuộc cần cấp quyền tra cứu hóa đơn:</b>",
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " Thêm",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function () {
                                                var table = $$("danhsach_donvihachtoan");

                                                var item = {
                                                    stt: 0, // tạm gán, sẽ cập nhật sau
                                                    tdvhtpt: "",
                                                    mstdvhtpt: "",
                                                    tngay: new Date(),
                                                    dngay: new Date(),
                                                    gchu: "",
                                                };

                                                table.add(item);

                                                // Cập nhật lại stt cho toàn bộ danh sách
                                                reindex(table);
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " Xóa",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function () {
                                                var table = $$("danhsach_donvihachtoan");
                                                table.editStop();

                                                var item = table.getSelectedItem();
                                                if (item) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    reindex(table); // Cập nhật lại stt sau khi xóa
                                                    return;
                                                }

                                                var editor = table.getEditState();
                                                if (editor) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    reindex(table); // Cập nhật lại stt sau khi xóa
                                                }
                                            }
                                        },
                                    },

                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_donvihachtoan",
                                name: "danhsach_donvihachtoan",
                                select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scroll: true,
                                fullscreen: true,
                                autoheight: true,
                                validateOnEdit: true,
                                scheme: {
                                    $init: function (obj) {
                                        obj.tngay = new Date(obj.tngay);
                                        obj.dngay = "";
                                    },
                                },
                                on: {
                                    onAfterEditStop: function (state, editor) {
                                        var item = this.getItem(editor.row);

                                        if (editor.column === "tngay" || editor.column === "dngay") {
                                            var fromDate = new Date(item.tngay);
                                            var toDate = new Date(item.dngay);
                                            var now = new Date();

                                            if (item.tngay && fromDate > now) {
                                                webix.message({ type: "error", text: "'Từ ngày' không được lớn hơn ngày hiện tại!" });
                                                item.tngay = new Date();
                                                this.updateItem(editor.row, item);
                                                return;
                                            }

                                            if (item.tngay && item.dngay && toDate < fromDate) {
                                                webix.message({ type: "error", text: "'Đến ngày' không được nhỏ hơn 'Từ ngày'!" });
                                                item.dngay = "";
                                                this.updateItem(editor.row, item);
                                            }
                                        }
                                    }
                                },
                                columns: [
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        }
                                    },
                                    {
                                        id: "tdvhtpt",
                                        name: "tdvhtpt",
                                        header: "Tên đơn vị ",
                                        width: 400,
                                        editor: "text",
                                        attributes: { maxlength: 400 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.tdvhtpt);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 400) {
                                                        input.value = input.value.slice(0, 400);
                                                        webix.message({ type: "error", text: "Tên đơn vị được nhập tối đa 400 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },
                                    {
                                        id: "mstdvhtpt",
                                        name: "mstdvhtpt",
                                        header: "Mã số thuế đơn vị hạch toán ",
                                        width: 350,
                                        editor: "text",
                                        attributes: { maxlength: 14 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.mstdvhtpt);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 14) {
                                                        input.value = input.value.slice(0, 14);
                                                        webix.message({ type: "error", text: "Mã số thuế đơn vị hạch toán được nhập tối đa 14 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },
                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                text: "Thời hạn quyền tra cứu hoá đơn",
                                                colspan: 2,
                                            },
                                            {
                                                text: "Từ ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        }
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                text: "Đến ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        }
                                    },
                                    {
                                        id: "gchu",
                                        name: "gchu",
                                        header: "Ghi chú",
                                        fillspace: true,
                                        editor: "text",
                                        width: 150,
                                        attributes: { maxlength: 255 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.gchu);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 255) {
                                                        input.value = input.value.slice(0, 255);
                                                        webix.message({ type: "error", text: "Ghi chú được nhập tối đa 255 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },

                                ],
                                rules: {
                                    tdvhtpt: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên đơn vị hạch toán</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 400) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên đơn vị hạch toán</b> vượt quá 400 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    mstdvhtpt: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mã số thuế đơn vị hạch toán</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 14) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mã số thuế đơn vị hạch toán</b> vượt quá 14 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    gchu: function (value) {

                                        if (value && value.length > 255) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Ghi chú</b> vượt quá 255 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    tngay: function (value) {

                                        if (!value) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Từ ngày</b> không được để trống"
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                },
                            },
                        ],
                    },


                    //thông tin tạm ngừng sử dụng hóa đơn điện tử
                    { height: 8 },
                    {
                        rows: [
                            {
                                view: "label",
                                label: "<b>10. Đơn đề nghị tạm ngừng sử dụng hóa đơn điện tử gồm: </b> " +
                                    "<br/><b>Trong quá trình sử dụng hóa đơn điện tử, chúng tôi xin phép tạm ngừng sử dụng hóa đơn điện tử cụ thể như sau:</b>",
                                height: "38px",
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " Thêm",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",

                                        on: {
                                            onItemClick: function () {
                                                var table = $$("danhsach_tamngunghddt");

                                                var item = {
                                                    stt: 0, // tạm gán, sẽ cập nhật sau
                                                    tngay: new Date(),
                                                    dngay: new Date(),
                                                    ttcgp: "",
                                                    msttcgp: "",
                                                    seri: "",
                                                    mdich: "",
                                                    gchu: "",
                                                };

                                                table.add(item);

                                                // Cập nhật lại stt cho toàn bộ danh sách
                                                reindex(table);
                                            },
                                        },

                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " Xóa",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function () {
                                                var table = $$("danhsach_tamngunghddt");
                                                table.editStop();

                                                var item = table.getSelectedItem();
                                                if (item) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    reindex(table); // Cập nhật lại stt sau khi xóa
                                                    return;
                                                }

                                                var editor = table.getEditState();
                                                if (editor) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    reindex(table); // Cập nhật lại stt sau khi xóa
                                                }
                                            }
                                        },
                                    },

                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_tamngunghddt",
                                name: "danhsach_tamngunghddt",
                                select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scroll: true,
                                fullscreen: true,
                                autoheight: true,
                                validateOnEdit: true,
                                scheme: {
                                    $init: function (obj) {
                                        obj.tngay = new Date(obj.tngay);
                                        obj.dngay = new Date(obj.dngay);
                                    },
                                },
                                on: {
                                    onAfterEditStop: function (state, editor) {
                                        var item = this.getItem(editor.row);

                                        if (editor.column === "tngay" || editor.column === "dngay") {
                                            var fromDate = new Date(item.tngay);
                                            var toDate = new Date(item.dngay);
                                            var now = new Date();

                                            if (item.tngay && fromDate > now) {
                                                webix.message({ type: "error", text: "'Từ ngày' không được lớn hơn ngày hiện tại!" });
                                                item.tngay = new Date();
                                                this.updateItem(editor.row, item);
                                                return;
                                            }

                                            if (item.tngay && item.dngay && toDate < fromDate) {
                                                webix.message({ type: "error", text: "'Đến ngày' không được nhỏ hơn 'Từ ngày'!" });
                                                item.dngay = "";
                                                this.updateItem(editor.row, item);
                                            }
                                        }
                                    }
                                },
                                columns: [
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        }
                                    },

                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                text: "Thời gian ngừng sử dụng dịch vụ",
                                                colspan: 2,
                                            },
                                            {
                                                text: "Từ ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        }
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                text: "Đến ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        }
                                    },

                                    {
                                        id: "ttcgp",
                                        name: "ttcgp",
                                        header: "Tổ chức cung cấp dịch vụ ",
                                        width: 400,
                                        editor: "text",
                                        attributes: { maxlength: 400 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.ttcgp);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 400) {
                                                        input.value = input.value.slice(0, 400);
                                                        webix.message({ type: "error", text: "Tổ chức cung cấp được nhập tối đa 400 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },
                                    {
                                        id: "msttcgp",
                                        name: "msttcgp",
                                        header: "Mã số thuế tổ chức ",
                                        width: 350,
                                        editor: "text",
                                        attributes: { maxlength: 14 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.msttcgp);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 14) {
                                                        input.value = input.value.slice(0, 14);
                                                        webix.message({ type: "error", text: "Mã số thuế tổ chức được nhập tối đa 14 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },
                                    {
                                        id: "seri",
                                        name: "seri",
                                        header: "Số se-ri chứng thư ",
                                        width: 350,
                                        editor: "text",
                                        attributes: { maxlength: 40 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.seri);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 40) {
                                                        input.value = input.value.slice(0, 40);
                                                        webix.message({ type: "error", text: "Số seri chứng thư được nhập tối đa 40 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },


                                    {
                                        id: "gchu",
                                        name: "gchu",
                                        header: "Ghi chú",
                                        fillspace: true,
                                        editor: "text",
                                        width: 150,
                                        attributes: { maxlength: 255 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.gchu);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 255) {
                                                        input.value = input.value.slice(0, 255);
                                                        webix.message({ type: "error", text: "Ghi chú được nhập tối đa 255 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },

                                ],
                                rules: {
                                    tngay: function (value) {

                                        if (!value) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Từ ngày</b> không được để trống"
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    dngay: function (value) {

                                        if (!value) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Đến ngày</b> không được để trống"
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    ttcgp: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên tổ chức cung cấp giải pháp </b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 400) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên tổ chức cung cấp giải pháp</b> vượt quá 400 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    msttcgp: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mã số thuế tổ chức cung cấp</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 14) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mã số thuế tổ chức cung cấp</b> vượt quá 14 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },


                                    seri: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Số seri chứng thư</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 40) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Số seri chứng thư</b> vượt quá 40 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    gchu: function (value) {

                                        if (value && value.length > 255) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Ghi chú</b> vượt quá 255 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },


                                },
                            },
                        ],
                    },


                    //thông tin đăng ký tích hợp hóa đơn điện tử với chứng từ điện tử
                    { height: 5 },
                    {
                        rows: [
                            {
                                view: "label",
                                label: "<b>11. Đăng ký tích hợp hóa đơn điện tử với chứng từ điện tử :</b>",
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " Thêm",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",

                                        on: {
                                            onItemClick: function () {
                                                var table = $$("danhsach_tichhop");

                                                var item = {
                                                    stt: 0, // tạm gán, sẽ cập nhật sau
                                                    tlhdon: "",
                                                    khmshdon: "",
                                                    khhdon: "",
                                                    ten: "",
                                                    mst: "",
                                                    mdich: "",
                                                    tngay: new Date(),
                                                    dngay: new Date(),
                                                    gchu: "",
                                                };

                                                table.add(item);

                                                // Cập nhật lại stt cho toàn bộ danh sách
                                                reindex(table);
                                            },
                                        },

                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " Xóa",
                                        // width: 60,
                                        icon: "fas fa-minus",

                                        on: {
                                            onItemClick: function () {
                                                var table = $$("danhsach_tichhop");
                                                table.editStop();

                                                var item = table.getSelectedItem();
                                                if (item) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    reindex(table); // Cập nhật lại stt sau khi xóa
                                                    return;
                                                }

                                                var editor = table.getEditState();
                                                if (editor) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    reindex(table); // Cập nhật lại stt sau khi xóa
                                                }
                                            }
                                        },

                                    },
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_tichhop",
                                name: "danhsach_tichhop",
                                select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scroll: true,
                                fullscreen: true,
                                autoheight: true,
                                validateOnEdit: true,
                                scheme: {
                                    $init: function (obj) {
                                        obj.tngay = new Date(obj.tngay);
                                        obj.dngay = new Date(obj.dngay);
                                    },
                                },
                                on: {
                                    onAfterEditStop: function (state, editor) {
                                        var item = this.getItem(editor.row);

                                        if (editor.column === "tngay" || editor.column === "dngay") {
                                            var fromDate = new Date(item.tngay);
                                            var toDate = new Date(item.dngay);
                                            var now = new Date();

                                            if (item.tngay && fromDate > now) {
                                                webix.message({ type: "error", text: "'Từ ngày' không được lớn hơn ngày hiện tại!" });
                                                item.tngay = new Date();
                                                this.updateItem(editor.row, item);
                                                return;
                                            }

                                            if (item.tngay && item.dngay && toDate < fromDate) {
                                                webix.message({ type: "error", text: "'Đến ngày' không được nhỏ hơn 'Từ ngày'!" });
                                                item.dngay = "";
                                                this.updateItem(editor.row, item);
                                            }
                                        }
                                    }
                                },
                                columns: [
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        }
                                    },

                                    {
                                        id: "tlhdon",
                                        name: "tlhdon",
                                        header: "Tên loại hoá đơn tích hợp ",
                                        width: 200,
                                        editor: "text",
                                        attributes: { maxlength: 100 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.tlhdon);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 100) {
                                                        input.value = input.value.slice(0, 100);
                                                        webix.message({ type: "error", text: "Tên loại hoá đơn được nhập tối đa 40 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },
                                    {
                                        id: "khmshdon",
                                        name: "khmshdon",
                                        header: "Ký hiệu mẫu hoá đơn tích hợp ",
                                        width: 150,
                                        editor: "text",
                                        attributes: { maxlength: 1 },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 1) {
                                                        input.value = input.value.slice(0, 1);
                                                        webix.message({ type: "error", text: "Ký hiệu mẫu hoá đơn tích hợp được nhập tối đa 1 ký tự!" });
                                                    }
                                                });
                                            }
                                        }

                                    },
                                    {
                                        id: "khhdon",
                                        name: "khhdon",
                                        header: "Ký hiệu hoá đơn tích hợp ",
                                        width: 150,
                                        editor: "text",
                                        attributes: { maxlength: 50 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.khhdon);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 50) {
                                                        input.value = input.value.slice(0, 50);
                                                        webix.message({ type: "error", text: "Ký hiệu hoá đơn tích hợp được nhập tối đa 50 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },

                                    {
                                        id: "ten",
                                        name: "ten",
                                        header: "Tên tổ chức được hoặc nhận tích hợp hóa đơn ",
                                        width: 350,
                                        editor: "text",
                                        attributes: { maxlength: 400 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.ten);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 400) {
                                                        input.value = input.value.slice(0, 400);
                                                        webix.message({ type: "error", text: "Tên tổ chức được nhập tối đa 400 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },

                                    {
                                        id: "mst",
                                        name: "mst",
                                        header: "Mã số thuế ",
                                        width: 150,
                                        editor: "text",
                                        attributes: { maxlength: 14 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.mst);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 14) {
                                                        input.value = input.value.slice(0, 14);
                                                        webix.message({ type: "error", text: "Mã số thuế được nhập tối đa 14 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },

                                    {
                                        id: "mdich",
                                        name: "mdich",
                                        header: "Mục đích tích hợp ",
                                        width: 350,
                                        editor: "text",
                                        attributes: { maxlength: 255 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.mdich);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 255) {
                                                        input.value = input.value.slice(0, 255);
                                                        webix.message({ type: "error", text: "Mục đích tích hợp được nhập tối đa 255 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },


                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                text: "Thời hạn sử dụng dịch vụ",
                                                colspan: 2,
                                            },
                                            {
                                                text: "Từ ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        }
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                text: "Đến ngày",
                                            },
                                        ],
                                        width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                        cssFormat: function () {
                                            return { "text-align": "center" };
                                        }
                                    },

                                    {
                                        id: "gchu",
                                        name: "gchu",
                                        header: "Ghi chú",
                                        fillspace: true,
                                        editor: "text",
                                        width: 150,
                                        attributes: { maxlength: 255 },
                                        template: function (obj) {
                                            return webix.template.escape(obj.ttcgp);
                                        },
                                        on: {
                                            onAfterRender: function () {
                                                var input = this.getInputNode();
                                                input.addEventListener("input", function () {
                                                    if (input.value.length > 255) {
                                                        input.value = input.value.slice(0, 255);
                                                        webix.message({ type: "error", text: "Ghi chú được nhập tối đa 255 ký tự!" });
                                                    }
                                                });
                                            }
                                        }
                                    },

                                ],
                                rules: {
                                    tlhdon: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên loại hoá đơn tích hợp</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 400) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên loại hoá đơn tích hợp</b> vượt quá 400 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },

                                    khmshdon: function (value) {
                                        if (!value) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Ký hiệu mẫu hoá đơn tích hợp</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 1) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Ký hiệu mẫu hoá đơn tích hợp</b> vượt quá 1 ký tự."
                                            });
                                            return false;
                                        }
                                        const strValue = String(value);
                                        if (strValue !== "0" && strValue !== "1") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Ký hiệu mẫu hóa đơn tích hợp</b> chỉ được nhập giá trị 0 hoặc 1."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },

                                    khhdon: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Ký hiệu hoá đơn tích hợp</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value.length < 6 || value.length > 50) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Ký hiệu hoá đơn tích hợp</b> phải có độ dài từ 6 đến 50 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    ten: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên tổ chức</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && (value.length < 6 && value.length > 400)) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Tên tổ chức</b> từ 6 đến 50 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    mst: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mã số thuế</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 14) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mã số thuế</b> vượt 14 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    mdich: function (value) {
                                        if (!value || value.trim() === "") {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mục đích</b> không được để trống."
                                            });
                                            return false;
                                        }

                                        if (value && value.length > 255) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Mục đích</b> vượt quá 255 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    gchu: function (value) {

                                        if (value && value.length > 255) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Ghi chú</b> vượt quá 255 ký tự."
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    tngay: function (value) {

                                        if (!value) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Từ ngày</b> không được để trống"
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                    dngay: function (value) {

                                        if (!value) {
                                            webix.message({
                                                type: "error",
                                                text: "<b>Đến ngày</b> không được để trống"
                                            });
                                            return false;
                                        }
                                        return true;
                                    },
                                },
                            },
                        ],
                    },


                    { height: 10 }, {
                        rows: [
                            {

                                view: "label",
                                label: "",

                            },
                        ],
                    },



                    { height: 25 },
                    {
                        css: "fixbottom",
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Ghi (F10)",
                                id: "btnDKSDSave1",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("dangkysudung").getValues();
                                            var table = $$("dangkysudung");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_chukyso").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa đăng ký chữ ký số cho thông báo phát hành !", "error");
                                                    return;
                                                }
                                                if (!$$("danhsach_uynhiem").validate()) {
                                                    webix.message("Bạn chưa nhập đầy đủ thông tin ủy nhiệm hóa đơn !", "error");
                                                    return;
                                                }
                                                if (!$$("danhsach_chukyso").validate()) {
                                                    return;
                                                }
                                                // nghị định 70


                                                if ($$("danhsach_nhacungcap").count() === 0) {
                                                    webix.message("Danh sách nhà cung cấp dịch vụ đang trống!", "error");
                                                    return;
                                                }
                                                if ($$("danhsach_truyennhan").count() === 0) {
                                                    webix.message("Danh sách tổ chức truyền nhận đang trống!", "error");
                                                    return;
                                                }

                                                if (!$$("danhsach_nhacungcap").validate()) {
                                                    return;
                                                }

                                                if (!$$("danhsach_truyennhan").validate()) {
                                                    return;
                                                }

                                                if (!$$("danhsach_donvihachtoan").validate()) {
                                                    return;
                                                }

                                                if (!$$("danhsach_tamngunghddt").validate()) {
                                                    return;
                                                }
                                                var isHdbhthblai = $$("hdbhthblai").getValue();
                                                if (isHdbhthblai == 1 && $$("danhsach_tichhop").count() == 0) {
                                                    webix.message({ type: "error", text: "Danh sách tích hợp bắt buộc phải có ít nhất một dòng!" });
                                                    return;
                                                }
                                                if (!$$("danhsach_tichhop").validate()) {
                                                    return;
                                                }


                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();

                                                var details = [];
                                                details.push({ data: $$("danhsach_chukyso").serialize() });
                                                item["details"] = details;

                                                var uynhiems = [];
                                                uynhiems.push({ data: $$("danhsach_uynhiem").serialize() });
                                                item["uynhiems"] = uynhiems;

                                                // nghị định 70
                                                var nhacungcaps = [];
                                                nhacungcaps.push({ data: $$("danhsach_nhacungcap").serialize() });
                                                item["nhacungcaps"] = nhacungcaps;

                                                var truyennhans = [];
                                                truyennhans.push({ data: $$("danhsach_truyennhan").serialize() });
                                                item["truyennhans"] = truyennhans;

                                                var donvihachtoans = [];
                                                donvihachtoans.push({ data: $$("danhsach_donvihachtoan").serialize() });
                                                item["donvihachtoans"] = donvihachtoans;

                                                var tamngunghddts = [];
                                                tamngunghddts.push({ data: $$("danhsach_tamngunghddt").serialize() });
                                                item["tamngunghddts"] = tamngunghddts;

                                                var tichhops = [];
                                                tichhops.push({ data: $$("danhsach_tichhop").serialize() });
                                                item["tichhops"] = tichhops;


                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/dangkysudungSave", data_post, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            table.enable();
                                                            table.hideProgress();
                                                            // var json = JSON.parse(text);
                                                            // webix.message(json.ExceptionMessage, "error");
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            table.enable();
                                                            table.hideProgress();
                                                            var json = JSON.parse(text);
                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message(json.error, "error");
                                                            } else {
                                                                app.callEvent("dataChangeDangkysudung68", [editmode, null]);

                                                                webix.message("Thành công !", "success");
                                                                webix.$$("dangkysudungForms").close();
                                                            }
                                                        },
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },

                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    webix.$$("dangkysudungForms").close();
                                },
                            },
                            {},
                        ],
                    },
                    { height: 25 },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix
                    .ajax()
                    .sync()
                    .get(app.config.host + "/System/GetDmDvcsByUser");
                var json = JSON.parse(result.response);

                $$("dclhe").setValue(json[0].address);
                $$("tnnt").setValue(json[0].name);
                $$("mst").setValue(json[0].tax_code);
                $$("dtlhe").setValue(json[0].tel);
                $$("dctdtu").setValue(json[0].email);
                $$("nlhe").setValue(json[0].manage);
            } else {
                if (editmode == 2) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            // item["tdlap"] = removeTimeZoneT(item["tdlap"]);
            form.setValues(item);

            $$("cqtqly").setValue(item.mcqtqly);

            // if (editmode == 2) {

            // }

            var tableDetail = webix.$$("danhsach_chukyso");
            var url = app.config.host + "/Invoice68/GetDataDangkysudungDetail?id=" + item.id;
            tableDetail.clearAll();
            tableDetail.load(url);

            var tableUyNhiem = webix.$$("danhsach_uynhiem");
            var urlUyNhiem = app.config.host + "/Invoice68/GetDataDangkysudungUyNhiem?id=" + item.id;
            tableUyNhiem.clearAll();
            tableUyNhiem.load(urlUyNhiem);

            var tableNCC = webix.$$("danhsach_nhacungcap");
            var urlNCC = app.config.host + "/Invoice68/GetDataToChucCungCapDichVu?id=" + item.id;
            tableNCC.clearAll();
            tableNCC.load(urlNCC);

            var tableDonvi = webix.$$("danhsach_donvihachtoan");
            var urlDonvi = app.config.host + "/Invoice68/GetDataDonViHachToan?id=" + item.id;
            tableDonvi.clearAll();
            tableDonvi.load(urlDonvi);

            var tableTamNgung = webix.$$("danhsach_tamngunghddt");
            var urlTamNgung = app.config.host + "/Invoice68/GetDataTamNgungDichVu?id=" + item.id;
            tableTamNgung.clearAll();
            tableTamNgung.load(urlTamNgung);

            var tableTichHop = webix.$$("danhsach_tichhop");
            var urlTichHop = app.config.host + "/Invoice68/GetDataTichHop?id=" + item.id;
            tableTichHop.clearAll();
            tableTichHop.load(urlTichHop);

            var tableTruyenNhan = webix.$$("danhsach_truyennhan");
            var urlTruyenNhan = app.config.host + "/Invoice68/GetDataToChucTruyenNhan?id=" + item.id;
            tableTruyenNhan.clearAll();
            tableTruyenNhan.load(urlTruyenNhan);



        },
    };
});

define('views/68_dangkysudung',["app", "locale", "models/user", "views/forms/68_dangkysudung", "views/forms/68_hoadon_history"], function (app, _, user, dangkysudung, hoadonHistory) {
    

    webix.$$("title").parse({
        title: "Đăng ký/ Thay đổi thông tin SD HDDT",
        details: "Đăng ký/ Thay đổi thông tin SD HDDT",
    });

    var initUI = function () {
        var table = webix.$$("dangkysudung01Views");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetDataDkysdung01";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }

                webix.ajax(url, function (text) {
                    var json = JSON.parse(text);
                    var mainData = json.data;
                    var contract_info = json.contract_info;

                    // Sử dụng view.parse để tránh lỗi callback
                    view.parse(mainData);

                    if (contract_info) {
                        app.contractInfoCache = contract_info;
                    }
                }, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dangkysudung.$ui);
                    dangkysudung.setEditMode(1);


                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký cần sửa ! ", "error");
                        return;
                    }
                    // if (selectedItem.trang_thai == 1) {
                    //     webix.message("Đã gửi CQT không thể sửa", "error");
                    //     return;
                    // }
                    var detailForm = this.$scope.ui(dangkysudung.$ui);

                    dangkysudung.setEditMode(2);

                    if (selectedItem.nsddpluat)
                        selectedItem.nsddpluat = new Date(selectedItem.nsddpluat);

                    dangkysudung.setValues(selectedItem);

                    if (selectedItem.trang_thai == 1) {
                        var form = $$("dangkysudung").elements;
                        for (var key in form) {
                            var $el = form[key];
                            $el.define("readonly", "true");
                            $el.define("css", "mcls_readonly_text");
                            $el.refresh();
                        }

                        // $$("btnDKSDSave").destructor();
                        $$("btnDKSDSave1").destructor();
                    }

                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },

        {
            view: "button",
            type: "htmlbutton",
            width: 130,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + " (F5)" + "</span>",
            id: "btnCopy",
            shortcut: "F5",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký cần sửa ! ", "error");
                        return;
                    }
                    var detailForm = this.$scope.ui(dangkysudung.$ui);
                    dangkysudung.setEditMode(1);

                    if (selectedItem.nlap)
                        delete selectedItem.nlap;

                    if (selectedItem.nsddpluat)
                        selectedItem.nsddpluat = new Date(selectedItem.nsddpluat);

                    dangkysudung.setValues(selectedItem);


                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },



        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký ! ", "error");
                        return;
                    }

                    if (selectedItem.trang_thai == 1) {
                        webix.message("Thông báo đã được ký và gửi CQT. Bạn không thể thực hiện chức năng này ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/deleteMau01", selectedItem, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            table.remove(selectedItem.id);
                                            table.enable();
                                            table.hideProgress();
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-eye fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký và gửi CQT (F7)") + "</span>",
            id: "btnPreview",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("dangkysudung01Views");
                    var selectedItem = tableDK.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã được ký và gửi đi, bạn không thể ký lại ! ", "error");
                        return;
                    }
                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                            var result = JSON.parse(text);
                            var kytaptrung = "";
                            for (var i = 0; i < result.length; i++) {
                                var item = result[i];
                                kytaptrung = item.value;
                            }

                            webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                var listcerts = JSON.parse(text);
                                if (listcerts.length > 0) {
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();

                                                    var cert = null;

                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }

                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                        return;
                                                    }

                                                    var now = new Date();
                                                    var begin = new Date(cert.begin_date);
                                                    var end = new Date(cert.end_date);
                                                    if (now < begin || now > end) {
                                                        webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                        return;
                                                    }

                                                    var postData = {
                                                        branch_code: user.getDvcsID(),
                                                        username: user.getCurrentUser(),
                                                        cer_serial: cert.cer_serial,
                                                        mau01_id: selectedItem.id,
                                                    };

                                                    if (postData.mau01_id == undefined || postData.mau01_id == "") {
                                                        webix.message("Bạn chưa ghi dữ liệu, không thể ký và gửi đi !", "error");
                                                        return;
                                                    } else {
                                                        webix.extend(tableDK, webix.ProgressBar);
                                                        tableDK.disable();
                                                        tableDK.showProgress();
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/SignDangkysudung", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    if (json.hasOwnProperty("error")) {
                                                                        webix.message(json.error, "error");
                                                                        tableDK.enable();
                                                                        tableDK.hideProgress();
                                                                    } else {
                                                                        tableDK.enable();
                                                                        tableDK.hideProgress();
                                                                        app.callEvent("dataChangeDangkysudung68", [1, null]);

                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                    }
                                                                },
                                                            });

                                                        // return;
                                                    }
                                            }
                                        },
                                    });

                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon",
                                                header: _("CHON"),
                                                width: 65,
                                                checkValue: true,
                                                uncheckValue: false,
                                                template: "{common.checkbox()}",
                                            },
                                            {
                                                id: "cert_type",
                                                header: _("Loại"),
                                                width: 100,
                                            },
                                            {
                                                id: "cer_serial",
                                                header: _("SO_SERIAL"),
                                                width: 150,
                                            },
                                            {
                                                id: "subject_name",
                                                header: _("SUBJECTNAME"),
                                                width: 450,
                                            },
                                            {
                                                id: "begin_date",
                                                header: _("NGAY_BAT_DAU"),
                                                width: 200,
                                            },
                                            {
                                                id: "end_date",
                                                header: _("NGAY_KET_THUC"),
                                                width: 200,
                                            },
                                            {
                                                id: "issuer",
                                                header: _("DONVI"),
                                                width: 450,
                                            },
                                        ],
                                        url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                    });
                                } else {
                                    var table = $$("dangkysudung01Views");
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();
                                    // xem user có tích checkbox ký HSM không?
                                    var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                    webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                        if (resultscheckSigHSM[0].json() == "C") { // ký HSM
                                            var postData = {
                                                branch_code: user.getDvcsID(),
                                                username: user.getCurrentUser(),
                                                mau01_id: selectedItem.id
                                            };

                                            var url = app.config.host + "/Invoice68/SignDangkysudung_HSM";

                                            webix.ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(url, postData, function (text) {
                                                    var res = JSON.parse(text);

                                                    if (res.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: res.error });
                                                    }
                                                    else {
                                                        webix.message("Đã thực hiện xong");
                                                    }
                                                    table.enable();
                                                    table.hideProgress();
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                });
                                        }
                                        else {
                                            var a = webix.ajax(app.config.host + "/Invoice68/XmlMau01?id=" + selectedItem.id);
                                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                            webix.promise.all([a, b, selectedItem]).then(function (results) {
                                                // webix.extend(tblInvoice, webix.ProgressBar);
                                                // tblInvoice.disable();
                                                // tblInvoice.showProgress();
                                                var json = results[0].json();

                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                }

                                                var listcerts = results[1].json();
                                                var item = results[2];

                                                if (listcerts.length == 0) {
                                                    table.enable();
                                                    table.hideProgress();
                                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                    return;
                                                }

                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();
                                                    if (hubconnect.state != 1) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                        return;
                                                    }
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (result) {
                                                        var json = JSON.parse(result);

                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: "error", text: json.error });
                                                        } else {
                                                            var parameters = {
                                                                xml: json.xml,
                                                                id: item.id,
                                                            };

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlMau01", parameters, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        app.callEvent("dataChangeDangkysudung68", [1, null]);

                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    });

                                                    var _listcerts = [];

                                                    for (var i = 0; i < listcerts.length; i++) {
                                                        var _cert = listcerts[i];

                                                        _listcerts.push({
                                                            so_serial: _cert.cer_serial,
                                                            ngaybatdau: _cert.begin_date,
                                                            ngayketthuc: _cert.end_date,
                                                            issuer: _cert.issuer,
                                                            subjectname: _cert.subject_name,
                                                        });
                                                    }

                                                    var arg = {
                                                        idData: "#data",
                                                        xml: json["xml"],
                                                        shdon: "",
                                                        idSigner: "seller",
                                                        tagSign: "NNT",
                                                        dateKy: json["dateKy"],
                                                        listcerts: _listcerts,
                                                    };

                                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success !");
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                        });
                                                });
                                            });
                                        }
                                    });
                                }
                            });
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "dangkysudung01Views",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.date_new) {
                        //     obj.date_new = new Date(obj.date_new);
                        // }
                    },
                },
                onClick: {
                    dowloadXmlDKSD: function (event, cell, target) {
                        var win = webix.$$("dangkysudung01Views");
                        var record = win.getItem(cell.row);
                        if (record.trang_thai != 1) {
                            webix.message("Mẫu chưa được ký không thể tải !", "error");
                            return;
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();

                        var url = app.config.host + "/Invoice68/ExportXMLMau01?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, "Mau01.xml");
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        // return false; // here it blocks the default behavior
                    },
                    btndowloadXMLRep: function (event, cell, target) {
                        var win = webix.$$("dangkysudung01Views");
                        var record = win.getItem(cell.row);
                        if (record.ket_qua == null || record.ket_qua == "") {
                            webix.message("Mẫu chưa được CQT trả về không thể tải !", "error");
                            return;
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();

                        var url = app.config.host + "/Invoice68/ExportXMLMau02?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, "Mau02.xml");
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        // return false; // here it blocks the default behavior
                    },
                    btndowloadXMLRepTiepNhan: function (event, cell, target) {
                        var win = webix.$$("dangkysudung01Views");
                        var record = win.getItem(cell.row);
                        if (record.ketqua_tiepnhan == null || record.ketqua_tiepnhan == "") {
                            webix.message("Mẫu chưa được CQT trả về không thể tải !", "error");
                            return;
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();

                        var url = app.config.host + "/Invoice68/ExportXMLMau03?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, "Mau03.xml");
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        // return false; // here it blocks the default behavior
                    },
                    InMau01: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var item = table.getItem(cell.row);

                        //webix.message("Chưa có mẫu in ...", "error");
                        // var rpParameter = null;
                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau01?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    InMau02: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var item = table.getItem(cell.row);

                        if (item.ket_qua == 3) {
                            webix.message("Chưa có mẫu in ...", "error");
                            return;
                        }

                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau02?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    InMau03: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var item = table.getItem(cell.row);

                        //webix.message("Chưa có mẫu in ...", "error");
                        // var rpParameter = null;
                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau03?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("dangkysudung01Views");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },




                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },


                },
                columns: [
                    {
                        id: "stt",
                        header: [{ text: "Mẫu 01ĐKTK/HĐĐT - Tờ khai Đăng ký/thay đổi thông tin sử dụng HĐĐT", colspan: "6" }, "STT"],
                        width: 40,
                    },
                    // {
                    //     id: "mtdiep_gui",
                    //     header: ["", "Mã thông điệp"],
                    //     width: 350,
                    // },
                    {
                        id: "ngay_gui",
                        header: ["", "Ngày gửi"],
                        width: 200,
                        css: { "text-align": "center" },
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    {
                        id: "noi_dung",
                        header: ["", "Nội dung"],
                        width: 250,
                    },
                    {
                        id: "btnMessagetn",
                        header: ["", "Lịch sử xử lý"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                        },
                        width: 180,
                    },
                    {
                        id: "btndowload",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='dowloadXmlDKSD' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='dowloadXmlDKSD' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "btnInMau01",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='InMau01' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau01' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "nguoi_gui",
                        header: ["", "Người gửi"],
                        width: 200,
                    },
                    {
                        id: "ketqua_tiepnhan",
                        header: [{ text: "Mẫu 01/TB-TNĐT - Thông tin tiếp nhận tờ khai của Cơ quan Thuế", colspan: "5" }, "Kết quả"],
                        width: 300,
                        template: function (obj) {
                            if (obj.ketqua_tiepnhan == 1) {
                                return "<span style='color: #00b300'>Tiếp nhận tờ khai đăng ký</span> ";
                            } else {
                                if (obj.ketqua_tiepnhan == 2) {
                                    return "<span style='color: #e83717'>Không tiếp nhận tờ khai đăng ký</span> ";
                                } else {
                                    if (obj.ketqua_tiepnhan == 3) {
                                        return "<span style='color: #00b300'>Tiếp nhận tờ khai đăng ký thay đổi</span> ";
                                    } else {
                                        if (obj.ketqua_tiepnhan == 4) {
                                            return "<span style='color: #00b300'>Không tiếp nhận tờ khai đăng ký thay đổi</span> ";
                                        } else {
                                            if (obj.ketqua_tiepnhan == 0) {
                                                return "<span style='color: #00b300'>Không tiếp nhận tờ khai đăng ký thay đổi</span> ";
                                            } else {
                                                return "<span></span>";
                                            }
                                        }
                                    }
                                }
                            }
                        },
                    },
                    {
                        id: "lydo_tiepnhan",
                        header: ["", "Lý do"],
                        width: 300,
                    },
                    {
                        id: "xac_thuc",
                        header: ["", "Thông tin xác thực của người đại diện"],
                        template: function (obj) {
                            if (obj.mhso != null && obj.lttxthuc != null && obj.thxthuc != null && obj.mhso != null && obj.lttxthuc != "" && obj.thxthuc != "") {
                                var format = webix.Date.dateToStr("%d/%m/%Y %H:%i");
                                var thxthuc = format(removeTimeZoneT(obj.thxthuc));

                                var textXthuc = "";
                                if (obj.lttxthuc == "1") {
                                    textXthuc = "xác thực sinh trắc học";
                                } else if (obj.lttxthuc == "2") {
                                    textXthuc = "xác thực OTP";
                                } else {
                                    textXthuc = obj.lttxthuc;
                                }

                                return "<span style='color:rgb(0, 48, 179)'>Hồ sơ " + obj.mhso + " phải thực hiện " + textXthuc + " trước " + thxthuc + "</span>";
                            } else return ""; rgb(0, 12, 179)
                        },
                        width: 650,
                    },
                    {
                        id: "ngay_tbao_tiepnhan",
                        header: ["", "Ngày thông báo"],
                        width: 200,
                        css: { "text-align": "center" },
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    {
                        id: "btndowloadXMLRepTiepNhan",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ketqua_tiepnhan != null && obj.ketqua_tiepnhan != "") {
                                return "<span class='btndowloadXMLRepTiepNhan' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='btndowloadXMLRepTiepNhan' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "btnInMau03",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ketqua_tiepnhan != null && obj.ketqua_tiepnhan != "") {
                                return "<span class='InMau03' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau03' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 60,
                    },
                    // {
                    //     id: "mtdiep_tiepnhan_cqt",
                    //     header: ["", "Mã thông điệp CQT"],
                    //     width: 350,
                    // },
                    {
                        id: "ket_qua",
                        header: [{ text: "Mẫu 01/TB-ĐKĐT - Thông tin chấp nhận Tờ khai của Cơ quan Thuế", colspan: "5" }, "Kết quả"],
                        width: 200,
                        template: function (obj) {
                            if (obj.ket_qua == 1) {
                                return "<span style='color: #00b300'>Chấp thuận</span> ";
                            } else {
                                if (obj.ket_qua == 2) {
                                    return "<span style='color: #e83717'>Không chấp thuận</span> ";
                                } else {
                                    if (obj.ket_qua == 3) {
                                        return "<span style='color: #00b300'>Đã phản hồi kết quả</span> ";
                                    } else {
                                        return "<span>Chờ phản hồi</span>";
                                    }
                                }
                            }
                        },
                    },
                    {
                        id: "ly_do",
                        header: ["", "Lý do"],
                        width: 300,
                    },
                    {
                        id: "ngay_tbao",
                        header: ["", "Ngày thông báo"],
                        width: 200,
                        css: { "text-align": "center" },
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    {
                        id: "btndowloadXMLRep",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ket_qua != null && obj.ket_qua != "") {
                                return "<span class='btndowloadXMLRep' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='btndowloadXMLRep' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 60,
                    },
                    {
                        id: "btnInMau02",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.ket_qua != null && obj.ket_qua != "") {
                                return "<span class='InMau02' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau02' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 60,
                    },
                    // {
                    //     id: "mtdiep_cqt",
                    //     header: ["", "Mã thông điệp CQT"],
                    //     width: 350,
                    // },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",

                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("dangkysudung01Views");
        table.clearAll();
        table.load(table.config.url);
    }






    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("dangkysudung01Views");
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChangeDangkysudung68", function (mode, item) {
                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }

                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);

                }
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});


define('views/forms/68_lichsu_history',["app", "locale", "models/user"], function (app, _, user) {
    

    var hdon_id = "";

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Lịch sử xử lý<div/>";
                        },
                    },
                ],
            },
            id: "responseMessageForms",
            resize: true,
            width: 1000,
            height: 500,
            move: true,
            on: {
                onBeforeShow: function () {},
            },
            body: {
                view: "form",
                id: "message",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        // id: "header",
                        template: "<center><b><span style='font-size:17px;'>LỊCH SỬ XỬ LÝ</b></center>",
                        borderless: true,
                        height: 40,
                    },
                    { height: 3 },
                    {
                        rows: [
                            {
                                view: "datatable",
                                id: "danhsach_history",
                                // height: 250,
                                //name: "danhsach_history",
                                // select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                select: "cell",
                                scroll: true,
                                scheme: {
                                    $init: function (obj) {},
                                },
                                url:{
                                    $proxy: true,
                                    load: function (view, callback, params) {
                                        // var hdon_id = "87de11a4-0b4e-42d4-a86c-45ba10b80337";
                                        if(hdon_id != ""){
                                            var url = app.config.host + "/Invoice68/GetHistoryTruyenNhan_ChiTiet?id=" + hdon_id;
                                            webix.ajax(url, callback, view);
                                        }
                                    }
                                },
                                onClick: {
                                    dowloadXmlDKSD: function (event, cell, target) {
                                        var win = webix.$$("danhsach_history");
                                        var record = win.getItem(cell.row);
                                        var file = new Blob([record.xml_thongdiep], {type: "application/xml"});
                                        webix.html.download(file, "file.xml");
                                    }
                                },
                                columns: [
                                    {
                                        id: "tg_gui",
                                        header: ["<center>Thời gian gửi</center>"],
                                        // template: function (obj, common) {
                                        //     console.log(obj.tthdon);
                                        //     return "<span class='mcls_status " + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                                        // },
                                        width: 250,
                                        format: function (text) {
                                            var test = new Date(text);
                                            if(test !== null && test !== 'null') {
                                                var format = webix.Date.dateToStr("%d-%m-%Y %H:%i:%s");
                                                text = removeTimeZoneT(test);
                                                return format(text);
                                            }
                                            return '';
                                        },
                                        columnType: "datetime",
                                    },
                                    {
                                        id: "mngui_ft",
                                        header: ["<center>Mã nơi gửi</center>"],
                                        width: 120,
                                        columnType: "nvarchar",
                                    },
                                    {
                                        id: "mltdiep_gui",
                                        header: ["<center>Mã loại thông điệp</center>"],
                                        width: 120,
                                        columnType: "nvarchar",
                                    },
                                    {
                                        id: "mtdiep_gui",
                                        header: ["<center>Mã thông điệp</center>"],
                                        width: 300,
                                        columnType: "xml",
                                    },{

                                        id: "mtdiep_thamchieu",
                                        header: ["<center>Mã thông điệp tham chiếu</center>"],
                                        width: 300,
                                        columnType: "xml",
                                    },
                                    {
                                        id: "xml_thongdiep",
                                        header: ["<center>Xml thông điệp</center>"],
                                        css: { "text-align": "center" },
                                        template: function (obj) {
                                            return "<span class='dowloadXmlDKSD' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                                        },
                                        width: 120,
                                    },
                                    {
                                        id: "mnnhan",
                                        header: ["<center>Mã nơi nhận</center>"],
                                        width: 120,
                                        columnType: "nvarchar",
                                    },
                                    {
                                        id: "tg_nhan",
                                        header: ["<center>Thời gian nhận</center>"],
                                        width: 250,
                                        format: function (text) {
                                            var test = new Date(text);
                                            var format = webix.Date.dateToStr("%d-%m-%Y %H:%i:%s");
                                            text = removeTimeZoneT(test);
                                            return format(text);
                                        },
                                        columnType: "nvarchar",
                                    },
                                    {
                                        id: "vendor",
                                        header: ["<center>Tên giải pháp</center>"],
                                        width: 120,
                                        columnType: "nvarchar",
                                    },
                                    {
                                        id: "mngui",
                                        header: ["<center>Mã số thuế</center>"],
                                        width: 120,
                                        columnType: "nvarchar",
                                    }
                                ],
                            },
                        ],
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    hdon_id = "";
                                    webix.$$("responseMessageForms").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (id) {
            hdon_id = id;
            var table = $$("danhsach_history");
            table.load(table.config.url);
        },
    };
});

define('views/68_hoadon_history_view',["app", "locale", "models/user", "views/forms/68_lichsu_history"], function (app, _, user, hoadonHistory) {
    
    webix.$$("title").parse({ title: "Lịch sử truyền nhận", details: "Lịch sử truyền nhận" });
    var grid = {
        rows: [
            {
                view: "datatable",
                id: "truyenhanview",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                scroll: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var url = app.config.host + "/Invoice68/GetHistoryTruyenNhan";

                        var tlbParams = $$("param");
                        if (params == null) {
                            url = url + "?start=0&count=" + view.config.datafetch;
                        } else {
                            url = url + "?start=" + params.start + "&count=" + params.count;
                        }

                        var tlbParams = $$("param");

                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();

                            var parameters = [];
                            var format = webix.Date.dateToStr("%Y-%m-%d");
                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];
                                // console.log(child);
                                var id = child.config.id;
                                //var value_field = child.config.value_field;
                                switch (id) {
                                    case "filter":
                                        url = url + "&filter=" + $$(id).getValue();
                                        break;
                                    case "tggui_tu":
                                        url = url + "&tggui_tu=" + format($$(id).getValue());
                                        break;
                                    case "tggui_den":
                                        url = url + "&tggui_den=" + format($$(id).getValue());
                                        break;
                                    case "check_error":
                                        url = url + "&check_error=" + $$(id).getValue();
                                        break;
                                }
                            }
                        }
                        webix.ajax(url, callback, view);
                    },
                },
                onClick: {
                    dowloadXmlDKSD: function (event, cell, target) {
                        var win = webix.$$("truyenhanview");
                        var record = win.getItem(cell.row);
                        var file = new Blob([record.xml_thongdiep], { type: "application/xml" });
                        webix.html.download(file, "file.xml");
                    },
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("truyenhanview");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var record = table.getItem(cell.row);
                        var historyid = record.reg_id;
                        hoadonHistory.setEditMode(historyid);
                        win.show();
                    },
                    /*ShowHistory: function (event, cell, target) {
                        var table = webix.$$("truyenhanview");
                        var record = win.getItem(cell.row);
                        var historyid = record.reg_id;
                        hoadonHistory.setEditMode(historyid);
                        hoadonHistory.show();
                    },*/
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                },
                columns: [
                    { id: "stt", header: "STT", width: 50 },
                    {
                        id: "tg_gui",
                        header: ["<center>Thời gian gửi</center>"],
                        // template: function (obj, common) {
                        //     console.log(obj.tthdon);
                        //     return "<span class='mcls_status " + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        // },
                        width: 250,
                        format: function (text) {
                            var test = new Date(text);
                            if (test !== null && test !== "null") {
                                var format = webix.Date.dateToStr("%d-%m-%Y %H:%i:%s");
                                text = removeTimeZoneT(test);
                                return format(text);
                            }
                            return "";
                        },
                        columnType: "datetime",
                    },
                    {
                        id: "mngui_ft",
                        header: ["<center>Mã nơi gửi</center>"],
                        width: 120,
                        columnType: "nvarchar",
                    },
                    {
                        id: "btnMessagetn",
                        header: "Lịch sử",
                        template: function (obj) {
                            return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "mltdiep_gui",
                        header: ["<center>Mã loại thông điệp</center>"],
                        width: 120,
                        columnType: "nvarchar",
                    },
                    {
                        id: "mtdiep_gui",
                        header: ["<center>Mã thông điệp</center>"],
                        width: 300,
                        columnType: "xml",
                    },
                    {
                        id: "mtdiep_thamchieu",
                        header: ["<center>Mã thông điệp tham chiếu</center>"],
                        width: 300,
                        columnType: "xml",
                    },
                    {
                        id: "xml_thongdiep",
                        header: ["<center>Xml thông điệp</center>"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='dowloadXmlDKSD' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "mnnhan",
                        header: ["<center>Mã nơi nhận</center>"],
                        width: 120,
                        columnType: "nvarchar",
                    },
                    {
                        id: "tg_nhan",
                        header: ["<center>Thời gian nhận</center>"],
                        width: 250,
                        format: function (text) {
                            var test = new Date(text);
                            if (test !== null && test !== "null") {
                                var format = webix.Date.dateToStr("%d-%m-%Y %H:%i:%s");
                                text = removeTimeZoneT(test);
                                return format(text);
                            }
                            return "";
                        },
                        columnType: "nvarchar",
                    },
                    {
                        id: "vendor",
                        header: ["<center>Tên giải pháp</center>"],
                        width: 120,
                        columnType: "nvarchar",
                    },
                    {
                        id: "mngui",
                        header: ["<center>Mã số thuế</center>"],
                        width: 120,
                        columnType: "nvarchar",
                    },
                ],
                pager: "pagerA",
            },
            {
                // cols: [
                // {
                //     view: "icon",
                //     icon: "fas fa-question-circle",
                //     id: "help_form_main",
                //     tooltip: _("HELPER"),
                //     css: "helper",
                //     click: function () {
                //         webix.alert({
                //             title: "Thông báo !",
                //             text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                //             type: "alert-warning",
                //             callback: function (result) {},
                //         });
                //     },
                // },
                // {
                //     view: "combo",
                //     label: _("MENU_QUICK"),
                //     id: "QuickMenuMain",
                //     hide: true,
                //     options: {
                //         // view: "gridsuggest",
                //         // id: "grid_window",
                //         // template: "#name#",
                //         // body: {
                //         //     scroll: true,
                //         //     autoheight: false,
                //         //     columns: [
                //         //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                //         //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                //         //     ],
                //         //     url: app.config.host + "/System/GetQuickMenu"
                //         // },
                //         // on: {
                //         //     onValueSuggest: function (obj) {
                //         //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                //         //         window.location.hash = "!/app/" + start;
                //         //         $$("QuickMenu").setValue(null);
                //         //     }
                //         // }
                //     },
                //     on: {
                //         onChange: function (newv, oldv) {},
                //     },
                // },
                // {},
                // {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                // },
                // ],
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                id: "param",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    {
                        id: "filter",
                        view: "text",
                        label: "TK nhanh",
                        width: 350,
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                    },
                    {
                        id: "tggui_tu",
                        view: "datepicker",
                        label: "Gửi từ",
                        width: 200,
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                    },
                    {
                        id: "tggui_den",
                        view: "datepicker",
                        label: "đến",
                        width: 200,
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                    },
                    {
                        id: "check_error",
                        view: "checkbox",
                        label: "TĐ lỗi",
                        width: 120,
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                    },
                    {
                        view: "button",
                        type: "htmlbutton",
                        width: 100,
                        label: '<span class="text">' + _("Refresh") + "</span>",
                        id: "btnReload",
                        on: {
                            onClick: function () {
                                var table = $$("truyenhanview");
                                table.clearAll();
                                var tlbParams = $$("param");
                                if (tlbParams !== undefined) {
                                    var childViews = tlbParams.getChildViews();
                                    for (var i = 0; i < childViews.length; i++) {
                                        var child = childViews[i];
                                        // console.log(child);
                                        var id = child.config.id;
                                        if (id === "filter" || id === "tggui_tu" || id === "tggui_den" || id === "check_error") {
                                            $$(id).setValue(null);
                                        }
                                        //var value_field = child.config.value_field;
                                    }
                                }
                                table.load(table.config.url);
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                    {
                        view: "button",
                        type: "htmlbutton",
                        width: 100,
                        label: '<span class="text">' + _("Tìm kiếm") + "</span>",
                        id: "btnTimKiem",
                        on: {
                            onClick: function () {
                                var table = $$("truyenhanview");
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                ],
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
    };
});

define('views/forms/68_invoiceForms_code',["app", "locale", "models/user", "views/commonHD"], function (app, _, user, commonHD) {
    var editmode = 0;
    var mau04 = {};
    var formatSoDefault = {
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0,
    };
    function f(a) {
        return webix.Number.format(a, formatSoDefault);
    }
    function g(a) {
        return webix.Number.parse(a, formatSoDefault);
    }
    /*function fmNumber(a){
        if(a !== undefined)
            return f(a);
        return a;
    };*/
    var fmNumber = {
        parse: function (a) {
            return g(a);
        },
        edit: function (a) {
            if (a !== undefined) return f(a);
            return a;
        },
    };

    var mess = "Tổng tiền chiết khấu lớn hơn tổng tiền hàng hóa thông thương trên hóa đơn. Vui lòng lập riêng hóa đơn chiết khấu mới.";

    function renderFormat(val) {
        if (val === undefined) val = "VND";
        var url = app.config.host + "/Invoice68/GetDecimalPlace?ma_nt=" + val;
        var table_chitiet = webix.$$("hoadon68_chitiet");
        var table_phi = webix.$$("hoadon68_phi");
        var table = $$("invoiceForms");

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .get(url, function (text) {
                var arr = JSON.parse(text);
                var decimal_place = Array(Number(arr[0]["hoadon123"]) + 1).join("9");
                var decimal_format = Number(arr[0]["hoadon123"]);
                var format_numeric = {
                    maximumValue: Number("999999999999." + decimal_place),
                    minValue: Number("-999999999999." + decimal_place),
                    decimalPlaces: Number(decimal_format),
                };
                formatSoDefault = {
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: decimal_format,
                };

                var formatSo = webix.Number.numToStr(formatSoDefault);

                var arrayString_chitiet = ["sluong", "dgia", "thtien", "stckhau", "tthue", "tgtien"];
                for (var i = 0; i < arrayString_chitiet.length; i++) {
                    var format_config = table_chitiet.getColumnConfig(arrayString_chitiet[i]);

                    format_config.format = formatSo;

                    format_config.numericConfig = format_numeric;
                }

                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];

                var format_config_phi = table_phi.getColumnConfig("tienphi");
                format_config_phi.format = formatSo;
                format_config_phi.numericConfig = format_numeric;

                table_chitiet.refreshColumns();
                table_phi.refreshColumns();

                for (var i = 0; i < arrayString.length; i++) {
                    $$(arrayString[i]).refresh();
                }
            });
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-iconInvoice",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formInvoice",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Hóa đơn 01GTGT<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_InvoiceForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "invoice68",
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () { },
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "invoiceForms",
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {
                    // }
                },
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: "fieldset",
                                            label: "Thông tin hóa đơn",
                                            body: {
                                                rows: [
                                                    {
                                                        cols: [
                                                            { view: "text", label: "cctbao_id", id: "cctbao_id", name: "cctbao_id", hidden: true },
                                                            {
                                                                view: "datepicker",
                                                                name: "nlap",
                                                                label: "Ngày hóa đơn",
                                                                //labelPosition: "top",
                                                                id: "nlap",
                                                                required: true,
                                                                // css: "mcls_readonly_text",
                                                                // readonly: true,
                                                            },
                                                            {
                                                                view: "text",
                                                                name: "shdon",
                                                                id: "shdon",
                                                                label: "Số HĐ",
                                                                css: "mcls_readonly_text",
                                                                readonly: true,
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: "text",
                                                                label: _("Ký hiệu"),
                                                                name: "khieu",
                                                                css: "mcls_readonly_text",
                                                                readonly: true,
                                                                id: "khieu",
                                                                // type:"number",
                                                                attributes: { maxlength: 7 },
                                                            },
                                                            {
                                                                view: "text",
                                                                label: _("Số đơn hàng"),
                                                                name: "sdhang",
                                                                id: "sdhang",
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: "combo",
                                                                name: "dvtte",
                                                                label: "Mã tiền tệ",
                                                                //labelPosition: "top",
                                                                id: "dvtte",
                                                                required: true,
                                                                value: "VND",
                                                                invalidMessage: "Trạng thái hóa đơn không thể bỏ trống !",
                                                                options: {
                                                                    view: "gridsuggest",
                                                                    value: "VND",
                                                                    template: "#value#",
                                                                    url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00188",
                                                                    body: {
                                                                        columns: [{ id: "value", header: _("Mã tiền tệ"), width: 120 }],
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) {
                                                                                this.load(this.config.url);
                                                                                return;
                                                                            }

                                                                            var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00188";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        },
                                                                    },
                                                                },
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        commonHD.renderFormat(newv);
                                                                        var type_curency = $$("dvtte").getValue();

                                                                        if (type_curency != "VND") {
                                                                            $$("docngoaitetv").show();
                                                                            $$("docngoaitetv").setValue(1);
                                                                        } else {
                                                                            $$("docngoaitetv").hide();
                                                                        }

                                                                        commonHD.ExeCuteCheckReadCurencyTV($$("docngoaitetv").getValue());
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "checkbox",
                                                                id: "docngoaitetv",
                                                                name: "docngoaitetv",
                                                                value: 0,
                                                                labelRight: _("Đọc ngoại tệ Tiếng Việt"),
                                                                labelWidth: 2,
                                                                width: 180,
                                                                hidden: true,
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        commonHD.ExeCuteCheckReadCurencyTV(newv);
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "text",
                                                                label: "Tỷ giá",
                                                                type: "number",
                                                                value: 1,
                                                                name: "tgia",
                                                                id: "tgia",
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        if (newv == undefined) return;
                                                                        if (newv == "") return;
                                                                        if (!webix.rules.isNumber(newv)) {
                                                                            webix.message("Tỷ giá phải nhập số", "error");
                                                                            this.focus();
                                                                            return;
                                                                        }
                                                                    },
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: "combo",
                                                        name: "htttoan",
                                                        label: "HT thanh toán",
                                                        //labelPosition: "top",
                                                        value: "đồng",
                                                        id: "htttoan",
                                                        value: "Tiền mặt/Chuyển khoản",
                                                        options: {
                                                            view: "gridsuggest",
                                                            template: "#name#",
                                                            value: "Tiền mặt/Chuyển khoản",
                                                            body: {
                                                                scroll: true,
                                                                autoheight: false,
                                                                columns: [
                                                                    // { id: "id", header: _("MS_THUE"), width: 150 },
                                                                    { id: "code", header: _("Mã ngoại tệ"), width: 150 },
                                                                    { id: "name", header: _("Tên ngoại tệ"), width: 550 },
                                                                ],
                                                                dataFeed: function (filtervalue, filter) {
                                                                    if (filtervalue.length < 1) return;

                                                                    var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00252";
                                                                    var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                    this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                },
                                                            },
                                                            url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00252",
                                                        },
                                                        on: {},
                                                    },
                                                    {
                                                        cols: [
                                                            { view: "text", label: _("STK người bán"), name: "stknban", id: "stknban" },
                                                            { view: "text", label: _("Ngân hàng"), name: "tnhban", id: "tnhban" },
                                                        ],
                                                    },
                                                    {},
                                                ],
                                            },
                                        },
                                        {
                                            view: "fieldset",
                                            label: "Thông tin khách hàng",
                                            body: {
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                view: "text",
                                                                editor: "textsearch",
                                                                label: "Mã khách hàng",
                                                                id: "mnmua",
                                                                name: "mnmua",
                                                                suggest: {
                                                                    view: "gridsuggest",
                                                                    columnName: "code",
                                                                    body: {
                                                                        columns: [
                                                                            { id: "id", hidden: true, header: "id" },
                                                                            { id: "code", width: 120, header: "code" },
                                                                            { id: "name", width: 350, header: "name" },
                                                                        ],
                                                                        scroll: true,
                                                                        autoheight: false,
                                                                        datatype: "json",
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) return;

                                                                            var refid = this.config.refid;
                                                                            var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00002";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        },
                                                                    },
                                                                    on: {
                                                                        onValueSuggest: function (obj) {
                                                                            var table = $$("invoiceForms");
                                                                            var selectedItem = $$("invoiceForms").getValues();

                                                                            selectedItem["mnmua"] = obj["code"];
                                                                            selectedItem["tnmua"] = obj["buyer_name"];
                                                                            selectedItem["ten"] = obj["name"];
                                                                            selectedItem["dchi"] = obj["address"];
                                                                            selectedItem["mst"] = obj["tax_code"];
                                                                            selectedItem["email"] = obj["email"];
                                                                            selectedItem["stknmua"] = obj["bank_account"];
                                                                            table.setValues(selectedItem);
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                id: "mst",
                                                                name: "mst",
                                                                view: "search",
                                                                label: "Mã số thuế",
                                                                //align: "center",
                                                                validate: webix.rules.isTaxCode,
                                                                invalidMessage: "Mã số thuế không hợp lệ",
                                                                placeholder: _("SEARCH") + "...",
                                                                // width: 300,
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        if (newv == undefined) return;
                                                                        if (newv == "") return;
                                                                        if (!webix.rules.isTaxCode(newv)) {
                                                                            webix.message("Mã số thuế không hợp lệ", "error");
                                                                            this.focus();
                                                                            return;
                                                                        }
                                                                        // if (newv.length != 11) {
                                                                        //     webix.message({ type: "error", text: "Độ dài mẫu số phải là 11 ký tự" });
                                                                        //     this.focus();
                                                                        //     return;
                                                                        // }
                                                                    },
                                                                    onTimedKeyPress: function () {
                                                                        // var table = $$("tblSearch");
                                                                        // table.clearAll();
                                                                        // table.load(table.config.url);
                                                                    },
                                                                    onSearchIconClick: function (e) {
                                                                        // var text = this.getValue();
                                                                        // var datapost = { masothue: text };
                                                                        // var table = $$("invoiceForms");
                                                                        // webix.extend(table, webix.ProgressBar);
                                                                        // table.disable();
                                                                        // table.showProgress();
                                                                        // webix
                                                                        //     .ajax()
                                                                        //     .headers({ "Content-type": "application/json" })
                                                                        //     .post(app.config.host + "/System/GetInfoByMST", datapost, function (text) {
                                                                        //         var json = JSON.parse(text);
                                                                        //         table.enable();
                                                                        //         table.hideProgress();
                                                                        //         if (!json.hasOwnProperty("error")) {
                                                                        //             $$("inv_Invoice_sellerName").setValue(json.ten_cty);
                                                                        //             $$("inv_Invoice_sellerAdress").setValue(json.dia_chi);
                                                                        //         } else {
                                                                        //             // nếu không tồn tại mã số thuế phải xóa địa chỉ + tên cty ở đây
                                                                        //             webix.message(json.error, "error", 1500);
                                                                        //         }
                                                                        //     });

                                                                        var mst = this.getValue();
                                                                        // window.location.href = "http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst;
                                                                        window.open("http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst);
                                                                    },
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        cols: [
                                                            { view: "text", label: _("Tên người mua"), name: "tnmua", id: "tnmua" },
                                                            {
                                                                view: "text",
                                                                label: _("Email"),
                                                                name: "email",
                                                                id: "email",
                                                                validate: function (value) {
                                                                    if (value) {
                                                                        var re = /\S+@\S+\.\S+/;
                                                                        return re.test(value);
                                                                    }
                                                                    return true;
                                                                },
                                                                invalidMessage: "Bạn nhập không đúng email",
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: "text",
                                                        label: _("Tên đơn vị"),
                                                        name: "ten",
                                                        id: "ten",
                                                        validate: function (value) {
                                                            var item = $$("invoiceForms").getValues();
                                                            if (item["mst"] && item["mst"] !== null && (!value || value === null)) {
                                                                return false;
                                                            }
                                                            return true;
                                                        },
                                                        invalidMessage: "Bắt buộc khi có mã số thuế",
                                                    },
                                                    { view: "text", label: _("Địa chỉ"), name: "dchi", id: "dchi" },
                                                    {
                                                        cols: [
                                                            { view: "text", label: _("STK người mua"), name: "stknmua", id: "stknmua" },
                                                            { view: "text", label: _("Ngân hàng"), name: "tnhmua", id: "tnhmua" },
                                                        ],
                                                    },
                                                    {
                                                        view: "text",
                                                        label: _("Số điện thoại"),
                                                        name: "sdtnmua",
                                                        id: "sdtnmua",
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 300,
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết hóa đơn",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    {
                                                        id: "mainInvoiceManage",
                                                        css: {
                                                            "padding-bottom": "5px !important",
                                                        },
                                                        cols: [
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                                id: "addrow",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_chitiet");
                                                                        var item = {
                                                                            id: webix.uid(),
                                                                        };
                                                                        table.add(item);
                                                                        table.select(item.id, "ma", false);
                                                                        table.edit({
                                                                            row: item.id,
                                                                            column: "ma",
                                                                        });
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                                id: "removerow",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_chitiet");

                                                                        table.editStop();

                                                                        var item = table.getSelectedItem();

                                                                        if (!webix.isUndefined(item)) {
                                                                            table.remove(item.id);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }

                                                                        var editor = table.getEditState();

                                                                        if (!webix.isUndefined(editor)) {
                                                                            table.remove(editor.row);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                                view: "button",
                                                                id: "copyrow",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_chitiet");

                                                                        table.editStop();

                                                                        var item = table.getSelectedItem();
                                                                        if (item == null || item == undefined) {
                                                                            webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                            return;
                                                                        }
                                                                        var copy = webix.copy(item);
                                                                        copy.id = webix.uid();

                                                                        table.add(copy);
                                                                        table.unselect(item.id);
                                                                        table.select(copy.id, "ma", false);
                                                                        table.edit({
                                                                            row: copy.id,
                                                                            column: "ma",
                                                                        });
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "checkbox",
                                                                id: "check_chietkhau",
                                                                value: 0,
                                                                labelRight: _("Chiết khấu"),
                                                                labelWidth: 2,
                                                                tooltip: "Tích vào đây nếu hóa đơn có chiết khấu",
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        if (newv == 1) {
                                                                            $$("hoadon68_chitiet").showColumn("stckhau");
                                                                            $$("hoadon68_chitiet").showColumn("tlckhau");
                                                                        } else {
                                                                            $$("hoadon68_chitiet").hideColumn("stckhau");
                                                                            $$("hoadon68_chitiet").hideColumn("tlckhau");
                                                                        }
                                                                    },
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: "hoadon68_chitiet",
                                                        editable: true,
                                                        select: "cell",
                                                        drag: true,
                                                        scroll: true,
                                                        columns: [
                                                            {
                                                                id: "stt",
                                                                header: "",
                                                                width: 30,
                                                            },
                                                            {
                                                                id: "ma",
                                                                header: _("Mã hàng hóa"),
                                                                editor: "textsearch",
                                                                width: 100,
                                                                editable: true,
                                                                suggest: {
                                                                    view: "gridsuggest",
                                                                    columnName: "ma_hanghoa",
                                                                    body: {
                                                                        columns: [
                                                                            { id: "id", hidden: true, header: "id" },
                                                                            { id: "code", width: 120, header: "code" },
                                                                            { id: "name", width: 350, header: "name" },
                                                                        ],
                                                                        scroll: true,
                                                                        autoheight: false,
                                                                        datatype: "json",
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) return;

                                                                            var refid = this.config.refid;
                                                                            var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00005";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        },
                                                                    },
                                                                    on: {
                                                                        onValueSuggest: function (obj) {
                                                                            var table = $$("hoadon68_chitiet");
                                                                            var selectedItem = table.getSelectedItem();
                                                                            selectedItem["ma"] = obj["code"];
                                                                            selectedItem["ten"] = obj["name"];
                                                                            selectedItem["mdvtinh"] = obj["unit_code"];
                                                                            selectedItem["dgia"] = obj["unit_price"];
                                                                            selectedItem["tsuat"] = obj["vat_type"];
                                                                            selectedItem["tsuatstr"] = obj["vat_name"];
                                                                            table.updateItem(selectedItem.id, selectedItem);
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                id: "ten",
                                                                header: _("Tên hàng hóa"),
                                                                editor: "text",
                                                                width: 350,
                                                                editable: true,
                                                            },
                                                            {
                                                                id: "mdvtinh",
                                                                header: _("ĐVT"),
                                                                editor: "text",
                                                                width: 80,
                                                                editable: true,
                                                                suggest: {
                                                                    view: "gridsuggest",
                                                                    columnName: "name",
                                                                    body: {
                                                                        columns: [
                                                                            { id: "id", hidden: true, header: "id" },
                                                                            { id: "name", width: 120, header: "name" },
                                                                        ],
                                                                        scroll: true,
                                                                        autoheight: false,
                                                                        datatype: "json",
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) return;

                                                                            var refid = this.config.refid;
                                                                            var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00035";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        },
                                                                    },
                                                                    on: {
                                                                        onValueSuggest: function (obj) {
                                                                            var table = $$("hoadon68_chitiet");
                                                                            var selectedItem = table.getSelectedItem();
                                                                            selectedItem["mdvtinh"] = obj["code"];

                                                                            table.updateItem(selectedItem.id, selectedItem);
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                id: "sluong",
                                                                header: _("Số lượng"),
                                                                editor: "autonumeric",
                                                                width: 100,
                                                                editable: true,
                                                                css: {
                                                                    "text-align": "right",
                                                                },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "dgia",
                                                                header: _("Đơn giá"),
                                                                width: 150,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                css: {
                                                                    "text-align": "right",
                                                                },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "thtien",
                                                                header: _("Tiền trước thuế"),
                                                                width: 150,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                css: {
                                                                    "text-align": "right",
                                                                },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "tlckhau",
                                                                header: _("% CK"),
                                                                width: 80,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                hidden: true,
                                                                css: {
                                                                    "text-align": "right",
                                                                },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "stckhau",
                                                                header: _("Tiền CK"),
                                                                width: 150,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                css: {
                                                                    "text-align": "right",
                                                                },
                                                                hidden: true,
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "tsuat",
                                                                header: _("Thuế suất"),
                                                                width: 100,
                                                                editor: "combo",
                                                                //editor: "autonumeric",
                                                                editable: true,
                                                                css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00019",
                                                                optionslist: true,
                                                            },
                                                            {
                                                                id: "tthue",
                                                                header: _("Tiền thuế"),
                                                                width: 150,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "tgtien",
                                                                header: _("Tiền sau thuế"),
                                                                width: 150,
                                                                editor: "autonumeric",
                                                                editable: true,
                                                                css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                            {
                                                                id: "kmai",
                                                                name: "kmai",
                                                                header: _("Tính chất"),
                                                                width: 200,
                                                                editor: "combo",
                                                                editable: true,
                                                                value: "1",
                                                                options: [
                                                                    { id: "1", value: "Hàng hóa dịch vụ" },
                                                                    { id: "2", value: "Khuyến mại" },
                                                                    { id: "3", value: "Chiếu khấu thương mại" },
                                                                    { id: "4", value: "Ghi chú" },
                                                                ],
                                                            },
                                                        ],
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                });
                                                            },
                                                            onAfterLoad: function () {
                                                                var table = this;
                                                                var data = table.serialize();
                                                                data.forEach(function (entry) {
                                                                    if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                        if (entry["stckhau"] != 0 || entry["tlckhau"] != 0) {
                                                                            var ck = $$("check_chietkhau");
                                                                            if (ck != undefined) {
                                                                                ck.setValue(1);
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                            },
                                                            onCheck: function (row, column, state) {
                                                                var table = this;
                                                                if (column == "khuyen_mai") {
                                                                    if (state == true) {
                                                                    }
                                                                }
                                                            },
                                                            onAfterAdd: function (id, index) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();

                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0;
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0;
                                                                data.forEach(function (entry) {
                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];
                                                                });
                                                            },
                                                            onAfterDelete: function (id) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();
                                                                var tien_tt_all = 0;
                                                                var tien_thue_all = 0;
                                                                var tien_ck_all = 0;
                                                                var tong_tien_all = 0;

                                                                var tien_tt_10 = 0;
                                                                var tien_thue_10 = 0;
                                                                var tien_ck_10 = 0;
                                                                var tong_tien_10 = 0;

                                                                var tien_tt_5 = 0;
                                                                var tien_thue_5 = 0;
                                                                var tien_ck_5 = 0;
                                                                var tong_tien_5 = 0;

                                                                var tien_tt_0 = 0;
                                                                var tien_thue_0 = 0;
                                                                var tien_ck_0 = 0;
                                                                var tong_tien_0 = 0;

                                                                var tien_tt_k = 0;
                                                                var tien_thue_k = 0;
                                                                var tien_ck_k = 0;
                                                                var tong_tien_k = 0;

                                                                var tien_tt_kct = 0;
                                                                var tien_thue_kct = 0;
                                                                var tien_ck_kct = 0;
                                                                var tong_tien_kct = 0;

                                                                var tien_tt_kkk = 0;
                                                                var tien_thue_kkk = 0;
                                                                var tien_ck_kkk = 0;
                                                                var tong_tien_kkk = 0;

                                                                data.forEach(function (entry) {
                                                                    if (entry.kmai && (entry.kmai.toString() === "1" || entry.kmai.toString() === "5" || entry.kmai.toString() === "3")) {
                                                                        if (entry.kmai.toString() === "1" || entry.kmai.toString() === "5") {
                                                                            tien_tt_all += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                            tien_thue_all += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                            tien_ck_all += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                            tong_tien_all += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            if (entry["tsuat"] == 10) {
                                                                                tien_tt_10 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_10 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_10 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_10 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 5) {
                                                                                tien_tt_5 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_5 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_5 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_5 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 0) {
                                                                                tien_tt_0 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_0 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_0 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_0 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -1) {
                                                                                tien_tt_kct += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kct += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kct += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kct += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -2) {
                                                                                tien_tt_kkk += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kkk += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kkk += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kkk += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else {
                                                                                tien_tt_k += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_k += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_k += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_k += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            }
                                                                        } else {
                                                                            tien_tt_all -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                            tien_thue_all -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                            tien_ck_all -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                            tong_tien_all -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            if (entry["tsuat"] == 10) {
                                                                                tien_tt_10 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_10 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_10 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_10 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 5) {
                                                                                tien_tt_5 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_5 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_5 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_5 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 0) {
                                                                                tien_tt_0 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_0 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_0 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_0 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -1) {
                                                                                tien_tt_kct -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kct -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kct -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kct -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -2) {
                                                                                tien_tt_kkk -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kkk -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kkk -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kkk -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else {
                                                                                tien_tt_k -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_k -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_k -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_k -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            }
                                                                        }
                                                                    }
                                                                });

                                                                $$("tgtcthue").setValue(tien_tt_all);
                                                                $$("tgtcthue10").setValue(tien_tt_10);
                                                                $$("tgtcthue5").setValue(tien_tt_5);
                                                                $$("tgtcthue0").setValue(tien_tt_0);
                                                                $$("tgtcthuek").setValue(tien_tt_k);
                                                                $$("tgtcthuekct").setValue(tien_tt_kct);
                                                                $$("tgtcthuekkk").setValue(tien_tt_kkk);

                                                                $$("ttcktmai").setValue(tien_ck_all);
                                                                $$("ttcktmai10").setValue(tien_ck_10);
                                                                $$("ttcktmai5").setValue(tien_ck_5);
                                                                $$("ttcktmai0").setValue(tien_ck_0);
                                                                $$("ttcktmaik").setValue(tien_ck_k);
                                                                $$("ttcktmaikct").setValue(tien_ck_kct);
                                                                $$("ttcktmaikkk").setValue(tien_ck_kkk);

                                                                $$("tgtthue").setValue(tien_thue_all);
                                                                $$("tgtthue10").setValue(tien_thue_10);
                                                                $$("tgtthue5").setValue(tien_thue_5);
                                                                $$("tgtthue0").setValue(tien_thue_0);
                                                                $$("tgtthuek").setValue(tien_thue_k);
                                                                $$("tgtthuekct").setValue(tien_thue_kct);
                                                                $$("tgtthuekkk").setValue(tien_thue_kkk);

                                                                $$("tgtttbso").setValue(tong_tien_all);
                                                                $$("tgtttbso10").setValue(tong_tien_10);
                                                                $$("tgtttbso5").setValue(tong_tien_5);
                                                                $$("tgtttbso0").setValue(tong_tien_0);
                                                                $$("tgtttbsok").setValue(tong_tien_k);
                                                                $$("tgtttbsokct").setValue(tong_tien_kct);
                                                                $$("tgtttbsokkk").setValue(tong_tien_kkk);

                                                                //if ($$("tkcktmn").getValue() != null && $$("tkcktmn").getValue() != "") tong_tien_all -= Number($$("tkcktmn").getValue());
                                                                if ($$("tgtphi").getValue() != null && $$("tgtphi").getValue() != "") tong_tien_all += Number($$("tgtphi").getValue());

                                                                $$("tgtttbso_last").setValue(tong_tien_all);
                                                                var tien_chietkhauthuongmai = 0;
                                                                data.forEach(function (entry) {
                                                                    if (entry["kmai"] && entry["kmai"].toString() == "3") {
                                                                        tien_chietkhauthuongmai += entry["tgtien"] == null ? 0 : Number(entry["tgtien"]);
                                                                    }
                                                                });
                                                                $$("tkcktmn").setValue(tien_chietkhauthuongmai);
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                var table_inv_views = webix.$$("invoiceViews");
                                                                var item_inv = table_inv_views.getSelectedItem();
                                                                var item_note = "";
                                                                if (item_inv != undefined && item_inv.hasOwnProperty("note") == true) {
                                                                    item_note = item_inv.note ? item_inv.note : "";
                                                                }
                                                                var table = $$(this.config.id);
                                                                1;
                                                                var selectedItem = table.getItem(editor.row);
                                                                var columnId = editor.config.id;
                                                                if (!selectedItem.kmai) selectedItem.kmai = "1";
                                                                var so_luong = webix.rules.isNumber(selectedItem.sluong) ? selectedItem.sluong : 0;
                                                                var don_gia = webix.rules.isNumber(selectedItem.dgia) ? selectedItem.dgia : 0;
                                                                var tien_tt = webix.rules.isNumber(selectedItem.thtien) ? selectedItem.thtien : 0;
                                                                var pt_ck = webix.rules.isNumber(selectedItem.tlckhau) ? selectedItem.tlckhau : 0;
                                                                var tien_ck = webix.rules.isNumber(selectedItem.stckhau) ? selectedItem.stckhau : 0;
                                                                var pt_thue = webix.rules.isNumber(selectedItem.tsuat) ? selectedItem.tsuat : 0;
                                                                var tien_thue = webix.rules.isNumber(selectedItem.tthue) ? selectedItem.tthue : 0;
                                                                var tong_tien = webix.rules.isNumber(selectedItem.tgtien) ? selectedItem.tgtien : 0;
                                                                /*if (columnId == "tsuatstr") {
                                                                    var tien_thue_str = selectedItem.tsuatstr;
                                                                    var re = /^([0-9]{1,2})(\.[0-9]{1,2}){0,1}%$/;
                                                                    if (tien_thue_str === "KCT" || tien_thue_str === "KKKNT") pt_thue = 0;
                                                                    else if (tien_thue_str !== "KHAC") {
                                                                        var checkDD = re.test(tien_thue_str);
                                                                        if (!checkDD) {
                                                                            webix.message("Không đúng định dạng nhập phần trăm");
                                                                            selectedItem.tsuatstr = state.old;
                                                                            table.updateItem(selectedItem.id, selectedItem);
                                                                            return;
                                                                        } else {
                                                                            pt_thue = Number(tien_thue_str.replace("%", ""));
                                                                        }
                                                                    }
                                                                }*/
                                                                tien_tt += tien_ck;
                                                                if (
                                                                    columnId == "tsuat" ||
                                                                    columnId == "sluong" ||
                                                                    columnId == "dgia" ||
                                                                    columnId == "tlckhau" ||
                                                                    columnId == "tsuatstr" ||
                                                                    columnId == "kmai" ||
                                                                    columnId == "ma"
                                                                ) {
                                                                    if (item_note != "reduce_change_invoice") {
                                                                        if (don_gia < 0) {
                                                                            don_gia = 0;
                                                                        }
                                                                    }

                                                                    if (so_luong < 0) {
                                                                        so_luong = 0;
                                                                    }

                                                                    if (!(item_note == "reduce_change_invoice") && don_gia > 0) {
                                                                        tien_tt = so_luong * don_gia;
                                                                    } else tien_tt = so_luong * don_gia;

                                                                    if (pt_ck < 0) {
                                                                        pt_ck = 0;
                                                                    }
                                                                    if (pt_ck > 100) {
                                                                        pt_ck = 0;
                                                                    }
                                                                    tien_ck = (tien_tt * pt_ck) / 100;
                                                                    if (!(item_note == "reduce_change_invoice") && tien_ck - tien_tt > 0) {
                                                                        tien_ck = 0;
                                                                    }

                                                                    tien_thue = ((tien_tt - tien_ck) * (pt_thue < 0 ? 0 : pt_thue)) / 100;
                                                                    tong_tien = tien_tt - tien_ck + parseFloat(tien_thue);

                                                                    if (item_note == "reduce_change_invoice") {
                                                                        if (don_gia > 0) {
                                                                            don_gia = don_gia * -1;
                                                                            tien_tt = so_luong * don_gia;
                                                                            tien_ck = tien_ck * -1;
                                                                            tien_thue = tien_thue * -1;
                                                                            tong_tien = tong_tien * -1;
                                                                        }
                                                                    }
                                                                }
                                                                tien_tt -= tien_ck;
                                                                selectedItem.sluong = so_luong;
                                                                selectedItem.dgia = don_gia;
                                                                selectedItem.thtien = tien_tt;
                                                                selectedItem.tlckhau = pt_ck;
                                                                selectedItem.stckhau = tien_ck;
                                                                selectedItem.tthue = tien_thue;
                                                                /*if(selectedItem.kmai.toString() !== "3"){
                                                                }*/
                                                                selectedItem.tgtien = tong_tien;
                                                                table.updateItem(selectedItem.id, selectedItem);
                                                                if (selectedItem.kmai.toString() === "2") {
                                                                    //selectedItem.sluong = null;
                                                                    //selectedItem.dgia = null;
                                                                    //selectedItem.tsuat = null;
                                                                    //selectedItem.tsuatstr = null;
                                                                    selectedItem.thtien = 0;
                                                                    //selectedItem.tlckhau = null;
                                                                    //selectedItem.stckhau = null;
                                                                    selectedItem.tthue = 0;
                                                                    selectedItem.tgtien = 0;
                                                                    if (columnId == "kmai") {
                                                                        selectedItem.sluong = null;
                                                                        selectedItem.dgia = null;
                                                                        selectedItem.tsuat = null;
                                                                        selectedItem.tsuatstr = null;
                                                                        selectedItem.tlckhau = null;
                                                                        selectedItem.stckhau = null;
                                                                    }
                                                                    table.updateItem(selectedItem.id, selectedItem);
                                                                } else if (selectedItem.kmai.toString() === "3") {
                                                                    //selectedItem.tsuat = "0";
                                                                    //selectedItem.tsuatstr = "0%";
                                                                    selectedItem.tlckhau = null;
                                                                    selectedItem.stckhau = null;
                                                                    //selectedItem.tthue = 0;
                                                                    /*if(columnId !== "tgtien"){
                                                                        selectedItem.tgtien = selectedItem.thtien
                                                                    }*/
                                                                } else if (selectedItem.kmai.toString() === "4") {
                                                                    selectedItem.sluong = null;
                                                                    selectedItem.dgia = null;
                                                                    selectedItem.tsuat = null;
                                                                    selectedItem.tsuatstr = null;
                                                                    selectedItem.thtien = null;
                                                                    selectedItem.tlckhau = null;
                                                                    selectedItem.stckhau = null;
                                                                    selectedItem.tthue = null;
                                                                    selectedItem.tgtien = null;
                                                                    table.updateItem(selectedItem.id, selectedItem);
                                                                }
                                                                var data = table.serialize();

                                                                var tien_tt_all = 0;
                                                                var tien_thue_all = 0;
                                                                var tien_ck_all = 0;
                                                                var tong_tien_all = 0;

                                                                var tien_tt_10 = 0;
                                                                var tien_thue_10 = 0;
                                                                var tien_ck_10 = 0;
                                                                var tong_tien_10 = 0;

                                                                var tien_tt_5 = 0;
                                                                var tien_thue_5 = 0;
                                                                var tien_ck_5 = 0;
                                                                var tong_tien_5 = 0;

                                                                var tien_tt_0 = 0;
                                                                var tien_thue_0 = 0;
                                                                var tien_ck_0 = 0;
                                                                var tong_tien_0 = 0;

                                                                var tien_tt_k = 0;
                                                                var tien_thue_k = 0;
                                                                var tien_ck_k = 0;
                                                                var tong_tien_k = 0;

                                                                var tien_tt_kct = 0;
                                                                var tien_thue_kct = 0;
                                                                var tien_ck_kct = 0;
                                                                var tong_tien_kct = 0;

                                                                var tien_tt_kkk = 0;
                                                                var tien_thue_kkk = 0;
                                                                var tien_ck_kkk = 0;
                                                                var tong_tien_kkk = 0;

                                                                data.forEach(function (entry) {
                                                                    if (entry.kmai && (entry.kmai.toString() === "1" || entry.kmai.toString() === "5" || entry.kmai.toString() === "3")) {
                                                                        if (entry.kmai.toString() === "1" || entry.kmai.toString() === "5") {
                                                                            tien_tt_all += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                            tien_thue_all += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                            tien_ck_all += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                            tong_tien_all += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            if (entry["tsuat"] == 10) {
                                                                                tien_tt_10 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_10 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_10 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_10 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 5) {
                                                                                tien_tt_5 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_5 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_5 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_5 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 0) {
                                                                                tien_tt_0 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_0 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_0 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_0 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -1) {
                                                                                tien_tt_kct += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kct += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kct += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kct += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -2) {
                                                                                tien_tt_kkk += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kkk += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kkk += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kkk += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else {
                                                                                tien_tt_k += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_k += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_k += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_k += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            }
                                                                        } else {
                                                                            tien_tt_all -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                            tien_thue_all -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                            tien_ck_all -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                            tong_tien_all -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            if (entry["tsuat"] == 10) {
                                                                                tien_tt_10 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_10 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_10 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_10 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 5) {
                                                                                tien_tt_5 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_5 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_5 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_5 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == 0) {
                                                                                tien_tt_0 -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_0 -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_0 -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_0 -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -1) {
                                                                                tien_tt_kct -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kct -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kct -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kct -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else if (entry["tsuat"] == -2) {
                                                                                tien_tt_kkk -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_kkk -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_kkk -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_kkk -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            } else {
                                                                                tien_tt_k -= entry["thtien"] == null ? 0 : entry["thtien"];
                                                                                tien_thue_k -= entry["tthue"] == null ? 0 : entry["tthue"];
                                                                                tien_ck_k -= entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                                tong_tien_k -= entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                            }
                                                                        }
                                                                    }
                                                                });

                                                                $$("tgtcthue").setValue(tien_tt_all);
                                                                $$("tgtcthue10").setValue(tien_tt_10);
                                                                $$("tgtcthue5").setValue(tien_tt_5);
                                                                $$("tgtcthue0").setValue(tien_tt_0);
                                                                $$("tgtcthuek").setValue(tien_tt_k);
                                                                $$("tgtcthuekct").setValue(tien_tt_kct);
                                                                $$("tgtcthuekkk").setValue(tien_tt_kkk);

                                                                $$("ttcktmai").setValue(tien_ck_all);
                                                                $$("ttcktmai10").setValue(tien_ck_10);
                                                                $$("ttcktmai5").setValue(tien_ck_5);
                                                                $$("ttcktmai0").setValue(tien_ck_0);
                                                                $$("ttcktmaik").setValue(tien_ck_k);
                                                                $$("ttcktmaikct").setValue(tien_ck_kct);
                                                                $$("ttcktmaikkk").setValue(tien_ck_kkk);

                                                                $$("tgtthue").setValue(tien_thue_all);
                                                                $$("tgtthue10").setValue(tien_thue_10);
                                                                $$("tgtthue5").setValue(tien_thue_5);
                                                                $$("tgtthue0").setValue(tien_thue_0);
                                                                $$("tgtthuek").setValue(tien_thue_k);
                                                                $$("tgtthuekct").setValue(tien_thue_kct);
                                                                $$("tgtthuekkk").setValue(tien_thue_kkk);

                                                                $$("tgtttbso").setValue(tong_tien_all);
                                                                $$("tgtttbso10").setValue(tong_tien_10);
                                                                $$("tgtttbso5").setValue(tong_tien_5);
                                                                $$("tgtttbso0").setValue(tong_tien_0);
                                                                $$("tgtttbsok").setValue(tong_tien_k);
                                                                $$("tgtttbsokct").setValue(tong_tien_kct);
                                                                $$("tgtttbsokkk").setValue(tong_tien_kkk);

                                                                //if ($$("tkcktmn").getValue() != null && $$("tkcktmn").getValue() != "") tong_tien_all -= Number($$("tkcktmn").getValue());
                                                                if ($$("tgtphi").getValue() != null && $$("tgtphi").getValue() != "") tong_tien_all += Number($$("tgtphi").getValue());

                                                                $$("tgtttbso_last").setValue(tong_tien_all);
                                                                var tien_chietkhauthuongmai = 0;
                                                                data.forEach(function (entry) {
                                                                    if (entry["kmai"] && entry["kmai"].toString() == "3") {
                                                                        tien_chietkhauthuongmai += entry["tgtien"] == null ? 0 : Number(entry["tgtien"]);
                                                                    }
                                                                });
                                                                $$("tkcktmn").setValue(tien_chietkhauthuongmai);
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            header: "Tiền phí/lệ phí",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    {
                                                        id: "mainInvoiceManage",
                                                        css: {
                                                            "padding-bottom": "5px !important",
                                                        },
                                                        cols: [
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                                id: "addrow2",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_phi");
                                                                        var item = {
                                                                            id: webix.uid(),
                                                                            tienphi: 0,
                                                                        };
                                                                        table.add(item);
                                                                        table.select(item.id);
                                                                        table.edit({
                                                                            row: item.id,
                                                                            column: "tnphi",
                                                                        });
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                                id: "removerow2",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_phi");
                                                                        table.editStop();
                                                                        var item = table.getSelectedItem();
                                                                        if (!webix.isUndefined(item)) {
                                                                            table.remove(item.id);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }

                                                                        var editor = table.getEditState();

                                                                        if (!webix.isUndefined(editor)) {
                                                                            table.remove(editor.row);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                view: "button",
                                                                type: "htmlbutton",
                                                                width: 65,
                                                                label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                                view: "button",
                                                                id: "copyrow2",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("hoadon68_phi");

                                                                        table.editStop();

                                                                        var item = table.getSelectedItem();
                                                                        if (item == null || item == undefined) {
                                                                            webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                            return;
                                                                        }
                                                                        var copy = webix.copy(item);
                                                                        copy.id = webix.uid();

                                                                        table.add(copy);
                                                                        table.unselect(item.id);
                                                                        table.select(copy.id);
                                                                        table.edit({
                                                                            row: copy.id,
                                                                            column: "tnphi",
                                                                        });
                                                                    },
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: "hoadon68_phi",
                                                        editable: true,
                                                        select: "cell",
                                                        drag: true,
                                                        columns: [
                                                            {
                                                                id: "tnphi",
                                                                name: "tnphi",
                                                                header: _("Tên phí"),
                                                                editor: "text",
                                                                width: 350,

                                                                editable: true,
                                                            },
                                                            {
                                                                id: "tienphi",
                                                                name: "tienphi",
                                                                header: _("Tiền phí"),
                                                                editor: "text",
                                                                width: 350,
                                                                editable: true,
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2,
                                                                }),
                                                            },
                                                        ],
                                                        on: {
                                                            onAfterDelete: function (id) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();
                                                                var tien_phi_moi = 0;
                                                                data.forEach(function (entry) {
                                                                    tien_phi_moi += entry["tienphi"] == null ? 0 : Number(entry["tienphi"]);
                                                                });
                                                                $$("tgtphi").setValue(tien_phi_moi);
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();
                                                                var tien_phi_moi = 0;
                                                                data.forEach(function (entry) {
                                                                    tien_phi_moi += entry["tienphi"] == null ? 0 : Number(entry["tienphi"]);
                                                                });
                                                                $$("tgtphi").setValue(tien_phi_moi);
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            rows: [
                                                { view: "label", label: "Loại thuế", css: "lblTongtien" },
                                                {
                                                    view: "label",
                                                    label: " + Tổng cộng hàng hóa, dịch vụ",
                                                    height: 22,
                                                    css: { "padding-left": "5px", "font-weight": "bold", "background-color": "#86b2cf" },
                                                },
                                                { view: "label", label: "Thuế suất 10%", css: "lblSubTongtien", height: 22 },
                                                { view: "label", label: "Thuế suất 5%", css: "lblSubTongtien", height: 22 },
                                                { view: "label", label: "Thuế suất 0%", css: "lblSubTongtien", height: 22 },
                                                { view: "label", label: "Thuế suất khác", css: "lblSubTongtien", height: 22 },
                                                { view: "label", label: "Không chịu thuế GTGT", css: "lblSubTongtien", height: 22 },
                                                { view: "label", label: "Không kê khai, tính nộp thuế GTGT", css: "lblSubTongtien", height: 22 },
                                                {},
                                                {},
                                                {},
                                                // { view: "label", label: "Tổng cộng phí lệ phí", css: { "font-weight": "bold", "background-color": "#86b2cf" } , height: 22 },
                                                // { view: "label", label: "Tổng cộng thanh toán", css: { "font-weight": "bold", "background-color": "#86b2cf" } , height: 22 },
                                            ],
                                        },
                                        {
                                            rows: [
                                                {
                                                    view: "label",
                                                    label: "Thành tiền trước thuế",
                                                    css: "lblTongtien",
                                                    validate: function (value) {
                                                        if (Number(value) > 0 || Number(value) === 0) {
                                                            return true;
                                                        }
                                                        webix.message(mess, "error");
                                                        return false;
                                                    },
                                                    invalidMessage: mess,
                                                },
                                                { view: "text", format: fmNumber, id: "tgtcthue", name: "tgtcthue", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtcthue10", name: "tgtcthue10", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtcthue5", name: "tgtcthue5", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtcthue0", name: "tgtcthue0", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtcthuek", name: "tgtcthuek", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtcthuekct", name: "tgtcthuekct", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtcthuekkk", name: "tgtcthuekkk", css: "txtTongtien", readonly: true, height: 22 },
                                                {},
                                                {},
                                                {},
                                                // { view: "text", id: "2", name: "2", css: "txtTongtien", readonly: true, height: 22 }
                                            ],
                                        },

                                        {
                                            rows: [
                                                { view: "label", label: "Tiền chiết khấu", css: "lblTongtien" },
                                                { view: "text", format: fmNumber, id: "ttcktmai", name: "ttcktmai", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmai10", name: "ttcktmai10", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmai5", name: "ttcktmai5", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmai0", name: "ttcktmai0", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmaik", name: "ttcktmaik", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmaikct", name: "ttcktmaikct", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "ttcktmaikkk", name: "ttcktmaikkk", css: "txtTongtien", readonly: true, height: 22 },
                                                {},
                                                {},
                                                {},
                                            ],
                                        },
                                        {
                                            rows: [
                                                {
                                                    view: "label",
                                                    label: "Tiền thuế",
                                                    css: "lblTongtien",
                                                    validate: function (value) {
                                                        if (Number(value) > 0 || Number(value) === 0) {
                                                            return true;
                                                        }
                                                        webix.message(mess, "error");
                                                        return false;
                                                    },
                                                    invalidMessage: mess,
                                                },
                                                { view: "text", format: fmNumber, id: "tgtthue", name: "tgtthue", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthue10", name: "tgtthue10", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthue5", name: "tgtthue5", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthue0", name: "tgtthue0", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthuek", name: "tgtthuek", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthuekct", name: "tgtthuekct", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtthuekkk", name: "tgtthuekkk", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "label", label: "Chiết khấu thương mại", labelAlign: "right", labelPosition: "top" },
                                                { view: "label", label: "Tổng tiền phí/lệ phí", labelAlign: "right", labelPosition: "top" },
                                                { view: "label", label: "Thành tiền", labelAlign: "right", labelPosition: "top" },
                                            ],
                                        },
                                        {
                                            rows: [
                                                { view: "label", label: "Tổng tiền sau thuế", css: "lblTongtien" },
                                                {
                                                    view: "text",
                                                    id: "tgtttbso",
                                                    name: "tgtttbso",
                                                    css: "txtTongtien",
                                                    readonly: true,
                                                    height: 22,
                                                    format: fmNumber,
                                                },
                                                { view: "text", format: fmNumber, id: "tgtttbso10", name: "tgtttbso10", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtttbso5", name: "tgtttbso5", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtttbso0", name: "tgtttbso0", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtttbsok", name: "tgtttbsok", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtttbsokct", name: "tgtttbsokct", css: "txtTongtien", readonly: true, height: 22 },
                                                { view: "text", format: fmNumber, id: "tgtttbsokkk", name: "tgtttbsokkk", css: "txtTongtien", readonly: true, height: 22 },
                                                {
                                                    id: "tkcktmn",
                                                    view: "text",
                                                    editor: "numeric",
                                                    labelWidth: 200,
                                                    width: 600,
                                                    format: fmNumber,
                                                    name: "tkcktmn",
                                                    /*on: {
                                                        onChange: function (newValue, oldValue, config) {
                                                            var tong_tien_cu = 0;
                                                            if ($$("tgtttbso_last").getValue() != null && $$("tgtttbso").getValue() != "") tong_tien_cu = Number($$("tgtttbso_last").getValue());
                                                            if (oldValue != null && oldValue != "") tong_tien_cu += Number(oldValue);
                                                            if (tong_tien_cu > $$("tkcktmn").getValue()) {
                                                                $$("tgtttbso_last").setValue(tong_tien_cu - newValue);
                                                                $$("tkcktmn").setValue(newValue);
                                                            } else {
                                                                $$("tgtttbso_last").setValue(tong_tien_cu);
                                                            }
                                                        },
                                                    },*/
                                                },
                                                {
                                                    view: "text",
                                                    format: fmNumber,
                                                    id: "tgtphi",
                                                    name: "tgtphi",
                                                    readonly: true,
                                                    on: {
                                                        onChange: function (newValue, oldValue, config) {
                                                            var tong_tien_cu = 0;
                                                            if ($$("tgtttbso_last").getValue() != null && $$("tgtttbso").getValue() != "") tong_tien_cu = Number($$("tgtttbso_last").getValue());
                                                            if (oldValue != null && oldValue != "") tong_tien_cu -= Number(oldValue);
                                                            tong_tien_cu += Number(newValue);
                                                            $$("tgtttbso_last").setValue(tong_tien_cu);
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "text",
                                                    id: "tgtttbso_last",
                                                    name: "tgtttbso_last",
                                                    readonly: true,
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            commonHD.ExeCuteCheckReadCurencyTV($$("docngoaitetv").getValue());
                                                        },
                                                    },
                                                    validate: function (value) {
                                                        var table_inv_views = webix.$$("invoiceViews");
                                                        var item_inv = table_inv_views.getSelectedItem();
                                                        var item_note = "";
                                                        if (item_inv != undefined && item_inv.hasOwnProperty("note") == true) {
                                                            item_note = item_inv.note ? item_inv.note : "";
                                                        }
                                                        if (item_note == "reduce_change_invoice") return true;
                                                        if (Number(value) > 0 || Number(value) === 0) {
                                                            return true;
                                                        }
                                                        webix.message(mess, "error");
                                                        return false;
                                                    },
                                                    invalidMessage: mess,
                                                    format: fmNumber,
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: "label",
                                            width: 140,
                                            label: "Đọc tiền bằng chữ:",
                                            css: { "font-weight": "bold", "padding-left": "5px" },
                                            height: 22,
                                        },
                                        { view: "text", id: "tgtttbchu", name: "tgtttbchu", readonly: true, height: 22 },
                                    ],
                                },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        {
                                            view: "button",
                                            id: "btnHoadonSaveMau04",
                                            hidden: true,
                                            label: "Ký và gửi CQT",
                                            align: "center",
                                            type: "form",
                                            width: 120,
                                            click: function () {
                                                var item = $$("invoiceForms").getValues();
                                                var tableHoadon = $$("invoiceForms");

                                                if (tableHoadon.validate()) {
                                                    var record = $$("hoadon68_chitiet").serialize();
                                                    if (record.length == 0) {
                                                        webix.message("Bạn chưa nhập chi tiết hóa đơn", "error");
                                                        return;
                                                    } else {
                                                        for (var i = 0; i < record.length; i++) {
                                                            var it = record[i];
                                                            if (it.ten == null || it.ten == "") {
                                                                webix.message("Bạn chưa nhập tên hàng");
                                                                return;
                                                            }
                                                            if (it.kmai.toString() === "1" || it.kmai.toString() === "5") {
                                                                var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                                                if (!bool) {
                                                                    webix.message("Tiền trước thuế + tiền thuế != tiền sau thuế");
                                                                    return;
                                                                }
                                                                if (it["tsuat"] == null || it["tsuat"] == "") {
                                                                    webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                                    return;
                                                                }
                                                            }
                                                        }
                                                        var t = webix.$$("invoiceViews");
                                                        var k = t.getSelectedItem();
                                                        var details = [];
                                                        details.push({ data: $$("hoadon68_chitiet").serialize() });
                                                        item["details"] = details;
                                                        item["tthdon"] = 2;
                                                        item["hdon68_id_lk"] = k.id;
                                                        var phi = [];
                                                        phi.push({
                                                            data: $$("hoadon68_phi").serialize(),
                                                        });
                                                        item["hoadon68_phi"] = phi;
                                                        // hóa đơn không mã
                                                        item.is_hdcma = 1;
                                                        var item1 = [];
                                                        item1.push(item);
                                                        var data_post = { editmode: editmode, data: item1 };
                                                        data_post.mau04 = mau04;

                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                                var result = JSON.parse(text);
                                                                var kytaptrung = "";
                                                                for (var i = 0; i < result.length; i++) {
                                                                    var item = result[i];
                                                                    kytaptrung = item.value;
                                                                }

                                                                webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                                    var listcerts = JSON.parse(text);
                                                                    if (listcerts.length > 0) {
                                                                        var box = webix.modalbox({
                                                                            title: "Chọn chứng thư số",
                                                                            buttons: ["Nhận", "Hủy bỏ"],
                                                                            text: "<div id='ctnCerts'></div>",
                                                                            top: 100,
                                                                            width: 750,
                                                                            callback: function (result) {
                                                                                switch (result) {
                                                                                    case "1":
                                                                                        webix.modalbox.hide();
                                                                                        break;
                                                                                    case "0":
                                                                                        var table = $$("tblCerts");
                                                                                        var data = table.serialize();

                                                                                        var cert = null;

                                                                                        for (var i = 0; i < data.length; i++) {
                                                                                            if (data[i].chon == true) {
                                                                                                cert = data[i];
                                                                                                break;
                                                                                            }
                                                                                        }

                                                                                        if (cert == null) {
                                                                                            webix.message("Bạn chưa chọn chứng thư số");
                                                                                            return;
                                                                                        }

                                                                                        var now = new Date();
                                                                                        var begin = new Date(cert.begin_date);
                                                                                        var end = new Date(cert.end_date);
                                                                                        if (now < begin || now > end) {
                                                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                            return;
                                                                                        }

                                                                                        var postData = {
                                                                                            branch_code: user.getDvcsID(),
                                                                                            username: user.getCurrentUser(),
                                                                                            cer_serial: cert.cer_serial,
                                                                                        };
                                                                                        data_post.sign = postData;

                                                                                        // console.log(data_post);
                                                                                        webix.extend(tableHoadon, webix.ProgressBar);
                                                                                        tableHoadon.disable();
                                                                                        tableHoadon.showProgress();
                                                                                        webix
                                                                                            .ajax()
                                                                                            .headers({ "Content-type": "application/json" })
                                                                                            .post(app.config.host + "/Invoice68/huyHoadonTaomoi", data_post, {
                                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                                    tableHoadon.enable();
                                                                                                    tableHoadon.hideProgress();
                                                                                                    // var json = JSON.parse(text);
                                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                                },
                                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                                    var json = JSON.parse(text);
                                                                                                    tableHoadon.enable();
                                                                                                    tableHoadon.hideProgress();
                                                                                                    if (!json.hasOwnProperty("error")) {
                                                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                                                        $$("invoice68").close();
                                                                                                        $$("huyhoadonForms").close();

                                                                                                        app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                                    } else {
                                                                                                        webix.message(json.error, "error");
                                                                                                    }
                                                                                                },
                                                                                            });

                                                                                        return;
                                                                                }
                                                                            },
                                                                        });

                                                                        var tblMatHang = webix.ui({
                                                                            container: "ctnCerts",
                                                                            id: "tblCerts",
                                                                            view: "datatable",
                                                                            borderless: true,
                                                                            resizeColumn: true,
                                                                            height: 350,
                                                                            columns: [
                                                                                {
                                                                                    id: "chon",
                                                                                    header: _("CHON"),
                                                                                    width: 65,
                                                                                    checkValue: true,
                                                                                    uncheckValue: false,
                                                                                    template: "{common.checkbox()}",
                                                                                },
                                                                                {
                                                                                    id: "cer_serial",
                                                                                    header: _("SO_SERIAL"),
                                                                                    width: 150,
                                                                                },
                                                                                {
                                                                                    id: "subject_name",
                                                                                    header: _("SUBJECTNAME"),
                                                                                    width: 450,
                                                                                },
                                                                                {
                                                                                    id: "begin_date",
                                                                                    header: _("NGAY_BAT_DAU"),
                                                                                    width: 200,
                                                                                },
                                                                                {
                                                                                    id: "end_date",
                                                                                    header: _("NGAY_KET_THUC"),
                                                                                    width: 200,
                                                                                },
                                                                                {
                                                                                    id: "issuer",
                                                                                    header: _("DONVI"),
                                                                                    width: 450,
                                                                                },
                                                                            ],
                                                                            url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                        });
                                                                    } else {
                                                                        webix.extend(tableHoadon, webix.ProgressBar);
                                                                        tableHoadon.disable();
                                                                        tableHoadon.showProgress();
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/huyHoadonTaomoiUSB", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    tableHoadon.enable();
                                                                                    tableHoadon.hideProgress();
                                                                                    // var json = JSON.parse(text);
                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);
                                                                                    tableHoadon.enable();
                                                                                    tableHoadon.hideProgress();
                                                                                    if (!json.hasOwnProperty("error")) {
                                                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlMau0405?id=" + json.idMau04);
                                                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                                                        webix.promise.all([a, b, json]).then(function (results) {
                                                                                            // webix.extend(tblInvoice, webix.ProgressBar);
                                                                                            // tblInvoice.disable();
                                                                                            // tblInvoice.showProgress();
                                                                                            var json = results[0].json();

                                                                                            if (json.hasOwnProperty("error")) {
                                                                                                webix.message({ type: "error", text: json.error });
                                                                                            }

                                                                                            var listcerts = results[1].json();
                                                                                            var item = results[2];

                                                                                            if (listcerts.length == 0) {
                                                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                                                return;
                                                                                            }

                                                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                                                var hub = plugin.hub();
                                                                                                var hubconnect = plugin.conn();
                                                                                                if (hubconnect.state != 1) {
                                                                                                    // tblInvoice.enable();
                                                                                                    // tblInvoice.hideProgress();
                                                                                                    webix.message(
                                                                                                        "Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !",
                                                                                                        "error"
                                                                                                    );
                                                                                                    return;
                                                                                                }
                                                                                                hub.off("resCommand");
                                                                                                hub.on("resCommand", function (result) {
                                                                                                    var json = JSON.parse(result);

                                                                                                    if (json.hasOwnProperty("error")) {
                                                                                                        webix.message({ type: "error", text: json.error });
                                                                                                    } else {
                                                                                                        var parameters = {
                                                                                                            xml: json.xml,
                                                                                                            id: item.idMau04,
                                                                                                            tthdon: 3,
                                                                                                        };

                                                                                                        webix
                                                                                                            .ajax()
                                                                                                            .headers({ "Content-Type": "application/json" })
                                                                                                            .post(app.config.host + "/Invoice68/SaveXmlMau0405", parameters, function (text) {
                                                                                                                var result = JSON.parse(text);
                                                                                                                if (result.hasOwnProperty("error")) {
                                                                                                                    webix.message(result.error, "error");
                                                                                                                } else {
                                                                                                                    webix.message("Gửi thành công đến CQT !", "success");
                                                                                                                    $$("invoice68").close();
                                                                                                                    $$("huyhoadonForms").close();

                                                                                                                    app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                                                }
                                                                                                            });
                                                                                                    }
                                                                                                    tableHoadon.enable();
                                                                                                    tableHoadon.hideProgress();
                                                                                                });

                                                                                                var _listcerts = [];

                                                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                                                    var _cert = listcerts[i];

                                                                                                    _listcerts.push({
                                                                                                        so_serial: _cert.cer_serial,
                                                                                                        ngaybatdau: _cert.begin_date,
                                                                                                        ngayketthuc: _cert.end_date,
                                                                                                        issuer: _cert.issuer,
                                                                                                        subjectname: _cert.subject_name,
                                                                                                    });
                                                                                                }

                                                                                                var arg = {
                                                                                                    idData: "#data",
                                                                                                    xml: json["xml"],
                                                                                                    shdon: "",
                                                                                                    idSigner: "seller",
                                                                                                    tagSign: "NNT",
                                                                                                    dvky: json["dvky"],
                                                                                                    dateKy: json["dateKy"],
                                                                                                    listcerts: _listcerts,
                                                                                                };

                                                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                                                    .done(function () {
                                                                                                        console.log("Success !");
                                                                                                    })
                                                                                                    .fail(function (error) {
                                                                                                        webix.message(error, "error");
                                                                                                    });
                                                                                            });
                                                                                        });
                                                                                        // webix.message("Gửi thành công đến CQT !", "success");
                                                                                        // $$("invoice68").close();
                                                                                        // $$("huyhoadonForms").close();

                                                                                        // app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                    } else {
                                                                                        webix.message(json.error, "error");
                                                                                    }
                                                                                },
                                                                            });
                                                                    }
                                                                });
                                                            });
                                                    }
                                                }
                                            },
                                        },
                                        {
                                            shortcut: "F10",
                                            view: "button",
                                            id: "btnHoadonSave",
                                            label: "Lưu tạm (F10)",
                                            type: "form",
                                            align: "center",
                                            width: 120,
                                            on: {
                                                onClick: function () {
                                                    var item = $$("invoiceForms").getValues();
                                                    var table = $$("invoiceForms");
                                                    var record = $$("hoadon68_chitiet").serialize();
                                                    for (var i = 0; i < record.length; i++) {
                                                        var it = record[i];
                                                        if (it.ten == null || it.ten == "") {
                                                            webix.message("Bạn chưa nhập tên hàng");
                                                            return;
                                                        }
                                                        if (it.kmai.toString() === "1" || it.kmai.toString() === "5") {
                                                            var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                                            if (!bool) {
                                                                webix.message("Tiền trước thuế + tiền thuế != tiền sau thuế");
                                                                return;
                                                            }
                                                            if (it["tsuat"] == null || it["tsuat"] == "") {
                                                                webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                                return;
                                                            }
                                                        }
                                                    }
                                                    if (table.validate()) {
                                                        // var fn = Function(check);
                                                        // var result = fn();
                                                        // console.log(result);
                                                        webix.extend(table, webix.ProgressBar);
                                                        table.disable();
                                                        table.showProgress();

                                                        var details = [];
                                                        details.push({ data: $$("hoadon68_chitiet").serialize() });
                                                        item["details"] = details;
                                                        // hóa đơn có mã
                                                        var phi = [];
                                                        phi.push({
                                                            data: $$("hoadon68_phi").serialize(),
                                                        });
                                                        item["hoadon68_phi"] = phi;
                                                        // hóa đơn không mã
                                                        item.is_hdcma = 1;
                                                        var item1 = [];
                                                        item1.push(item);
                                                        var data_post = { editmode: editmode, data: item1 };

                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/hoadonSaveChange", data_post, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    if (!json.hasOwnProperty("error")) {
                                                                        webix.$$("invoice68").close();
                                                                        app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                                    } else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                },
                                                            });
                                                    }
                                                },
                                            },
                                            click: function () {
                                                this.callEvent("onClick");
                                            },
                                        },
                                        {
                                            shortcut: "F11",
                                            view: "button",
                                            id: "btnHoadonCQT",
                                            label: "Ký và gửi CQT (F11)",
                                            type: "form",
                                            align: "center",
                                            width: 150,
                                            on: {
                                                onClick: function () {
                                                    var item = $$("invoiceForms").getValues();
                                                    var table = $$("invoiceForms");
                                                    var record = $$("hoadon68_chitiet").serialize();
                                                    for (var i = 0; i < record.length; i++) {
                                                        var it = record[i];
                                                        if (it.ten == null || it.ten == "") {
                                                            webix.message("Bạn chưa nhập tên hàng");
                                                            return;
                                                        }
                                                        if (it.kmai.toString() === "1" || it.kmai.toString() === "1") {
                                                            var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                                            if (!bool) {
                                                                webix.message("Tiền trước thuế + tiền thuế != tiền sau thuế");
                                                                return;
                                                            }
                                                            if (it["tsuat"] == null || it["tsuat"] == "") {
                                                                webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                                return;
                                                            }
                                                        }
                                                    }
                                                    if (table.validate()) {
                                                        // var fn = Function(check);
                                                        // var result = fn();
                                                        // console.log(result);
                                                        webix.extend(table, webix.ProgressBar);
                                                        table.disable();
                                                        table.showProgress();

                                                        var details = [];
                                                        details.push({ data: $$("hoadon68_chitiet").serialize() });
                                                        item["details"] = details;
                                                        var phi = [];
                                                        phi.push({
                                                            data: $$("hoadon68_phi").serialize(),
                                                        });
                                                        item["hoadon68_phi"] = phi;
                                                        // hóa đơn không mã
                                                        item.is_hdcma = 1;
                                                        var item1 = [];
                                                        item1.push(item);
                                                        var data_post = { editmode: editmode, data: item1 };

                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/hoadonSaveChange", data_post, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var _res = JSON.parse(text);
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    if (!_res.hasOwnProperty("error")) {
                                                                        webix.$$("invoice68").close();
                                                                        app.callEvent("dataChangedInvoie68", [editmode, _res.data]);

                                                                        var lsthdon_id = [];
                                                                        lsthdon_id.push(_res.data.hdon_id);
                                                                        commonHD.ExcuteHoaDon(lsthdon_id, true, true);
                                                                    } else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                },
                                                            });
                                                    }
                                                },
                                            },
                                            click: function () {
                                                this.callEvent("onClick");
                                            },
                                        },
                                        {
                                            view: "button",
                                            hotkey: "esc",
                                            label: "Hủy bỏ (ESC)",
                                            align: "center",
                                            type: "danger",
                                            width: 120,
                                            click: function () {
                                                this.getTopParentView().close();
                                                app.callEvent("dataChangedInvoie68", [editmode, null]);
                                            },
                                        },
                                        {},
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            if (item != null) {
                item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                form.setValues(item);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);

                var tablePhi = webix.$$("hoadon68_phi");
                var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                tablePhi.clearAll();
                tablePhi.load(urlPhi);
            }

            if (editmode == 2) {
            }
            // nếu có mẫu 04 (hóa đơn hủy)
            if (winconfig != null) {
                mau04 = winconfig;
                $$("btnHoadonSaveMau04").show();
                $$("btnHoadonCQT").destructor();
                $$("btnHoadonSave").destructor();
            }
            this.getFormat();
        },
        setEditMode: function (mode) {
            editmode = mode;
            //var form = webix.$$("invoiceForms");
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            } else {
                if (editmode == 2) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
        },
        copyValues: function (item) {
            var form = webix.$$("invoiceForms");

            var tableDetail = webix.$$("hoadon68_chitiet");
            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(url, function (text) {
                    var data = JSON.parse(text);

                    for (var i = 0; i < data.length; i++) {
                        data[i]["cthdon_id"] = null;
                        data[i]["hdon_id"] = null;
                    }

                    tableDetail.clearAll();
                    tableDetail.parse(data);
                });
            var tablePhi = webix.$$("hoadon68_phi");
            var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(urlPhi, function (text) {
                    var data = JSON.parse(text);

                    for (var i = 0; i < data.length; i++) {
                        data[i]["phi_id"] = null;
                        data[i]["hdon_id"] = null;
                    }

                    tablePhi.clearAll();
                    tablePhi.parse(data);
                });
            // tableDetail.clearAll();
            // tableDetail.load(url);
            item["tthdon"] = 0;
            item["hdon_id"] = null;
            item["nky"] = null;
            item["id"] = webix.uid();
            form.setValues(item);
            this.getFormat();
        },
        initUINew: function (cctbao_id) {
            $$("cctbao_id").setValue(cctbao_id);
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(app.config.host + "/Invoice68/getKyhieu?cctbao_id=" + cctbao_id, function (text) {
                    var data = JSON.parse(text);

                    if (data.length > 0) {
                        var form = $$("invoiceForms");
                        var values = form.getValues();

                        values["khieu"] = data[0]["khhdon"];

                        form.setValues(values);
                    }
                });
            this.getFormat();
        },
        getFormat: function (val) {
            commonHD.renderFormat(val);
        },
    };
});

define('views/forms/68_huyhoadon',["app", "locale", "models/user", "views/forms/68_invoiceForms"], function (app, _, user, invoiceForms) {
    

    var editmode = 0;

    function listToTreeCustomize(json) {
        return json.map(function(item) {
            return {
                id: item.code,
                name: item.name != null ? item.name.toString() : "",
                code: item.code
            };
        });
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Thông báo hóa đơn điện tử đã lập sai<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_dksdForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "huyhoadonForms",
            resize: true,
            width: 1100,
            height: 600,
            // fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {},
            },
            body: {
                view: "form",
                id: "huyhoadon",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        // id: "header",
                        template: "<center><b><span style='font-size:17px;'>THÔNG BÁO HÓA ĐƠN ĐIỆN TỬ ĐÃ LẬP SAI</b></center>",
                        borderless: true,
                        height: 40,
                    },
                    {
                        paddingX: 30,
                        rows: [
                            {
                                cols: [
                                    {},
                                    {
                                        view: "text",
                                        id: "tcqt_hidden",
                                        name: "tcqt",
                                        hidden: true
                                    },
                                    {
                                        label: "Kính gửi: ",
                                        id: "tcqt",
                                        view: "combo",
                                        valueField: "name", // Chỉ định rõ ràng rằng combo sẽ lấy giá trị từ trường name                                        width: 300,
                                        labelWidth: 100,
                                        width: 300,
                                        options: {
                                            view: "gridsuggest",
                                            columnName: "name",
                                            url: {
                                                $proxy: true,
                                                load: function (view, callback, params) {
                                                    var url = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00251";
                                                    webix.ajax(url, function (text) {
                                                        var json = JSON.parse(text);
                                                        var data = listToTreeCustomize(json);

                                                        view.parse(data, "json");
                                                    });
                                                },
                                            },
                                            body: {
                                                columns: [ { id: "name", width: 225, header: "Tên" }, { id: "code", width: 100, header: "Mã" }],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    console.log(obj);

                                                    $$("tcqt_hidden").setValue(obj["name"]); // Lưu item.name vào trường ẩn
                                                    $$("tcqt_hidden").refresh();

                                                    $$("mcqt").setValue(obj["code"]);
                                                    $$("mcqt").refresh();
                                                },
                                            },
                                        },
                                        required: true,
                                        invalidMessage: "Kính gửi không được để trống !",
                                    },
                                    {},
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Mã số thuế",
                                        id: "mst",
                                        name: "mst",
                                        required: true,
                                        invalidMessage: "Tên người nộp thuế không được để trống !",
                                    }
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Tên người nộp thuế",
                                        labelWidth: 150,
                                        required: true,
                                        invalidMessage: "Tên người nộp thuế không được để trống !",
                                        id: "tnnt",
                                        name: "tnnt",
                                    },
                                    {
                                        id: "mcqt",
                                        name: "mcqt",
                                        label: "Mã cơ quan thuế",
                                        labelWidth: 150,
                                        required: true,
                                        invalidMessage: "Mã cơ quan thuế quản lý không được để trống !",
                                        view: "text",
                                        attributes: { maxlength: 5 },
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Địa danh",
                                        labelWidth: 150,
                                        id: "ddanh",
                                        name: "ddanh",
                                        required: true,
                                        invalidMessage: "Địa danh không được để trống !",
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Lý do",
                                        labelWidth: 150,
                                        id: "ldo_all",
                                        name: "ldo_all",
                                        on: {
                                            onblur: function () {
                                                var datatable = $$("danhsach_hoadonhuy");
                                                var items = datatable.serialize(); 
                                                if(items.length < 1){
                                                    return;
                                                }
                                                for (var i = 0; i < items.length; i++) {
                                                    datatable.updateItem(items[i].id, { ldo: this.getValue()}); 
                                                }
                
                                            }
                                        }
                                    },
                                ],
                            },
                        ],
                    },
                    { height: 3 },
                    {
                        template: "<b><span >Người nộp thuế thông báo về việc hóa đơn điện tử đã lập sai như sau:</b>",
                        borderless: true,
                        height: 40,
                    },
                    { height: 3 },
                    {
                        rows: [
                            {
                                id: "btnHuyhoadon",
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " (F9)",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_hoadonhuy");
                                                var item = { id: webix.uid() };
                                                table.add(item);
                                                table.select(item.id, "khieu", false);
                                                table.edit({ row: item.id, column: "khieu" });
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " (F8)",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_hoadonhuy");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {},
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_hoadonhuy",
                                // height: 250,
                                name: "danhsach_hoadonhuy",
                                // select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                select: "cell",
                                scheme: {
                                    $init: function (obj) {},
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                    onBeforeEditStart: function (id) {
                                        if (id.column == "stt") {
                                            // block editors in 'year' column
                                            return false;
                                        } else if (id.column == "khieu") {
                                            return false;
                                        } else if (id.column == "shdon") {
                                            return false;
                                        } else if (id.column == "ladhddt") {
                                            return false;
                                        } else if (id.column == "ngay") {
                                            return false;
                                        } else if (id.column == "huygiaitrinh") {
                                            return false;
                                        }
                                    },
                                },
                                columns: [
                                    { editor: "text", id: "hdon_id", name: "hdon_id", hidden: true },
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                    },
                                    {
                                        id: "mcqtcap",
                                        name: "mcatcap",
                                        header: "Mã cơ quan thuế cấp",
                                        width: 150,
                                        editor: "text",
                                    },
                                    {
                                        id: "khieu",
                                        header: _("Ký hiệu hóa đơn điện tử"),
                                        editor: "text",
                                        width: 250,
                                        editable: true,
                                        suggest: {
                                            view: "gridsuggest",
                                            // value_suggest: field.value_suggest,
                                            // fieldExpression: field.field_expression,
                                            // displayField: field.display_field,
                                            // tableId: "edit_inv_InvoiceDetail",
                                            columnName: "ky_hieu",
                                            body: {
                                                columns: [
                                                    { id: "id", hidden: true, header: "id" },
                                                    { id: _("khieu"), width: 120, header: "khieu" },
                                                    { id: _("shdon"), width: 350, header: "shdon" },
                                                ],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                                dataFeed: function (filtervalue, filter) {
                                                    if (filtervalue.length < 1) return;

                                                    var refid = this.config.refid;
                                                    var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=29f51d47-8bf6-4b32-a679-52e75b8cacc8";
                                                    var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                    this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                },
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    var table = $$("danhsach_hoadonhuy");
                                                    var selectedItem = table.getSelectedItem();
                                                    selectedItem["shdon"] = obj["shdon"];
                                                    selectedItem["ngay"] = obj["nlap"];
                                                    selectedItem["huygiaitrinh"] = 1;
                                                    selectedItem["hdon_id"] = obj["hdon_id"];
                                                    table.updateItem(selectedItem.id, selectedItem);
                                                },
                                            },
                                        },
                                    },
                                    {
                                        id: "shdon",
                                        name: "shdon",
                                        header: "Số hóa đơn điện tử",
                                        width: 200,
                                        editor: "text",
                                    },
                                    {
                                        id: "ngay",
                                        name: "ngay",
                                        header: "Ngày lập hóa đơn",
                                        width: 200,
                                        editor: "text",
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "ladhddt",
                                        name: "ladhddt",
                                        header: "Loại áp dụng hóa đơn điện tử",
                                        editable: true,
                                        width: 200,
                                        editor: "combo",
                                        options: [
                                            // { id: "1", value: "HĐĐT Nghị đinh số 119/2018" },
                                            { id: "1", value: "Hóa đơn điện tử theo Nghị định 123/2020/NĐ-CP, Nghị định 70/2025/NĐ-CP" },
                                            { id: "2", value: "Hóa đơn điện tử có mã xác thực của cơ quan thuế theo Quyết định số 1209/QĐ-BTC ngày 23 tháng 6 năm 2015 và Quyết định số 2660/QĐ-BTC ngày 14 tháng 12 năm 2016 của Bộ Tài chính (Hóa đơn có mã xác thực của CQT theo Nghị định số 51/2010/NĐ-CP và Nghị định số 04/2014/NĐ-CP)" },
                                            { id: "3", value: "Các loại hóa đơn theo Nghị định số 51/2010/NĐ-CP và Nghị định số 04/2014/NĐ-CP (Trừ hóa đơn điện tử có mã xác thực của cơ quan thuế theo Quyết định số 1209/QĐ-BTC và Quyết định số 2660/QĐ-BTC)" },
                                            { id: "4", value: "Hóa đơn đặt in theo Nghị định 123/2020/NĐ-CP" },
                                        ],
                                    },
                                    {
                                        id: "ldo",
                                        name: "ldo",
                                        header: "Lý do",
                                        editable: true,
                                        editor: "text",
                                        width: 300,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                view: "button",
                                id: "btnStep299",
                                label: "Lưu, chuyển sang bước tiếp theo",
                                type: "form",
                                hidden: true,
                                align: "center",
                                click: function () {
                                    // var btnEdit = $$("btnPlus");
                                    // btnEdit.callEvent("onClick");
                                    var self = this;
                                    setTimeout(function () {
                                        var item = $$("huyhoadon").getValues();
                                        var details = [];
                                        details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                        item["details"] = details;

                                        var item1 = [];
                                        item1.push(item);
                                        var data_post = { editmode: editmode, data: item1 };

                                        var detailForm = self.$scope.ui(invoiceForms.$ui);

                                        var cctbao_id = webix.$$("kyhieu_id").getValue();
                                        invoiceForms.initUINew(cctbao_id);
                                        invoiceForms.setEditMode(1);
                                        invoiceForms.setValues(null, data_post, null);
                                        detailForm.show();
                                    }, 100);

                                    // $$("huyhoadonForms").close();
                                },
                            },
                            {
                                shortcut: "F10",
                                view: "button",
                                id: "btnGhiHuyhoadon",
                                label: "Ghi (F10)",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin hóa đơn cần hủy !", "error");
                                                    return;
                                                }
                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();

                                                var details = [];
                                                details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                                item["details"] = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/huyhoadonSave", data_post, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            table.enable();
                                                            table.hideProgress();
                                                            // var json = JSON.parse(text);
                                                            // webix.message(json.ExceptionMessage, "error");
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);

                                                            table.enable();
                                                            table.hideProgress();
                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message(json.error, "error");
                                                            } else {
                                                                app.callEvent("dataChangedInvoie68", [editmode, null]);

                                                                webix.message("Thành công !", "success");
                                                                webix.$$("huyhoadonForms").close();
                                                            }
                                                        },
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                shortcut: "F4",
                                view: "button",
                                id: "btnGhiSignHuyHDDT",
                                label: "Ký và gửi CQT (F14)",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin hóa đơn cần hủy !", "error");
                                                    return;
                                                }
                                                var details = [];
                                                details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                                item["details"] = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                var tableDK = $$("huyhoadon");

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = "";
                                                        for (var i = 0; i < result.length; i++) {
                                                            var item = result[i];
                                                            kytaptrung = item.value;
                                                        }

                                                        webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                            var listcerts = JSON.parse(text);
                                                            if (listcerts.length > 0) {
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();

                                                                                var cert = null;

                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }

                                                                                var now = new Date();
                                                                                var begin = new Date(cert.begin_date);
                                                                                var end = new Date(cert.end_date);
                                                                                if (now < begin || now > end) {
                                                                                    webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                    return;
                                                                                }    

                                                                                var postData = {
                                                                                    branch_code: user.getDvcsID(),
                                                                                    username: user.getCurrentUser(),
                                                                                    cer_serial: cert.cer_serial,
                                                                                };
                                                                                data_post.sign = postData;

                                                                                webix.extend(tableDK, webix.ProgressBar);
                                                                                tableDK.disable();
                                                                                tableDK.showProgress();
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({ "Content-type": "application/json" })
                                                                                    .post(app.config.host + "/Invoice68/huyhoadonSaveSign", data_post, {
                                                                                        error: function (text, data, XmlHttpRequest) {
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            // var json = JSON.parse(text);
                                                                                            // webix.message(json.ExceptionMessage, "error");
                                                                                            webix.message(text + XmlHttpRequest, "error");
                                                                                        },
                                                                                        success: function (text, data, XmlHttpRequest) {
                                                                                            var json = JSON.parse(text);
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            if (!json.hasOwnProperty("error")) {
                                                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                                                $$("huyhoadonForms").close();
                                                                                                app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                            } else {
                                                                                                webix.message(json.error, "error");
                                                                                            }
                                                                                        },
                                                                                    });

                                                                            // return;
                                                                        }
                                                                    },
                                                                });

                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}",
                                                                        },
                                                                        {
                                                                            id: "cert_type",
                                                                            header: _("Loại"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "cer_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 150,
                                                                        },
                                                                        {
                                                                            id: "subject_name",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "begin_date",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "end_date",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "issuer",
                                                                            header: _("DONVI"),
                                                                            width: 450,
                                                                        },
                                                                    ],
                                                                    url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                });
                                                            } else {
                                                                var table = $$("huyhoadon");
                                                                webix.extend(table, webix.ProgressBar);
                                                                table.disable();
                                                                table.showProgress();

                                                                // xem user có tích checkbox ký HSM không?
                                                                var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                                                webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                                                    if (resultscheckSigHSM[0].json() == "C") {
                                                                        var postData = {
                                                                            branch_code: user.getDvcsID(),
                                                                            username: user.getCurrentUser(),
                                                                            check_HSM: "1",
                                                                        };
                                                                        data_post.sign = postData;

                                                                        webix.extend(tableDK, webix.ProgressBar);
                                                                        tableDK.disable();
                                                                        tableDK.showProgress();
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/huyhoadonSaveSign", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    tableDK.enable();
                                                                                    tableDK.hideProgress();
                                                                                    // var json = JSON.parse(text);
                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);
                                                                                    tableDK.enable();
                                                                                    tableDK.hideProgress();
                                                                                    if (!json.hasOwnProperty("error")) {
                                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                                        $$("huyhoadonForms").close();
                                                                                        app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                    } else {
                                                                                        webix.message(json.error, "error");
                                                                                    }
                                                                                },
                                                                            });
                                                                    } else {
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/huyhoadonSave", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    table.enable();
                                                                                    table.hideProgress();
                                                                                    // var json = JSON.parse(text);
                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);

                                                                                    if (json.hasOwnProperty("error")) {
                                                                                        webix.message(json.error, "error");
                                                                                    } else {
                                                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlMau0405?id=" + json.id);
                                                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                                                        webix.promise.all([a, b, json]).then(function (results) {
                                                                                            // webix.extend(tblInvoice, webix.ProgressBar);
                                                                                            // tblInvoice.disable();
                                                                                            // tblInvoice.showProgress();
                                                                                            var json = results[0].json();

                                                                                            if (json.hasOwnProperty("error")) {
                                                                                                webix.message({ type: "error", text: json.error });
                                                                                            }

                                                                                            var listcerts = results[1].json();
                                                                                            var item = results[2];

                                                                                            if (listcerts.length == 0) {
                                                                                                table.enable();
                                                                                                table.hideProgress();
                                                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                                                return;
                                                                                            }

                                                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                                                var hub = plugin.hub();
                                                                                                var hubconnect = plugin.conn();
                                                                                                if (hubconnect.state != 1) {
                                                                                                    table.enable();
                                                                                                    table.hideProgress();
                                                                                                    webix.message(
                                                                                                        "Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !",
                                                                                                        "error"
                                                                                                    );
                                                                                                    return;
                                                                                                }
                                                                                                hub.off("resCommand");
                                                                                                hub.on("resCommand", function (result) {
                                                                                                    var json = JSON.parse(result);

                                                                                                    if (json.hasOwnProperty("error")) {
                                                                                                        webix.message({ type: "error", text: json.error });
                                                                                                    } else {
                                                                                                        var parameters = {
                                                                                                            xml: json.xml,
                                                                                                            id: item.id,
                                                                                                            tthdon: 3,
                                                                                                        };

                                                                                                        webix
                                                                                                            .ajax()
                                                                                                            .headers({ "Content-Type": "application/json" })
                                                                                                            .post(app.config.host + "/Invoice68/SaveXmlMau0405", parameters, function (text) {
                                                                                                                var result = JSON.parse(text);
                                                                                                                if (result.hasOwnProperty("error")) {
                                                                                                                    webix.message(result.error, "error");
                                                                                                                } else {
                                                                                                                    app.callEvent("dataChangedInvoie68", [editmode, null]);

                                                                                                                    webix.message("Thành công !", "success");
                                                                                                                    webix.$$("huyhoadonForms").close();
                                                                                                                }
                                                                                                            });
                                                                                                    }
                                                                                                    table.enable();
                                                                                                    table.hideProgress();
                                                                                                });

                                                                                                var _listcerts = [];

                                                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                                                    var _cert = listcerts[i];

                                                                                                    _listcerts.push({
                                                                                                        so_serial: _cert.cer_serial,
                                                                                                        ngaybatdau: _cert.begin_date,
                                                                                                        ngayketthuc: _cert.end_date,
                                                                                                        issuer: _cert.issuer,
                                                                                                        subjectname: _cert.subject_name,
                                                                                                    });
                                                                                                }

                                                                                                var arg = {
                                                                                                    idData: "#data",
                                                                                                    xml: json["xml"],
                                                                                                    shdon: "",
                                                                                                    idSigner: "seller",
                                                                                                    tagSign: "NNT",
                                                                                                    dvky: json["dvky"],
                                                                                                    dateKy: json["dateKy"],
                                                                                                    listcerts: _listcerts,
                                                                                                };

                                                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                                                    .done(function () {
                                                                                                        console.log("Success !");
                                                                                                    })
                                                                                                    .fail(function (error) {
                                                                                                        webix.message(error, "error");
                                                                                                    });
                                                                                            });
                                                                                        });
                                                                                        // app.callEvent("dataChangedInvoie68", [editmode, null]);

                                                                                        // webix.message("Thành công !", "success");
                                                                                        // webix.$$("huyhoadonForms").close();
                                                                                    }
                                                                                },
                                                                            });
                                                                    }
                                                                });
                                                            }
                                                        });
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                shortcut: "F4",
                                view: "button",
                                id: "btnSaveSignGiaiTrinh",
                                label: "Ký và gửi CQT",
                                width: 150,
                                hidden: true,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin hóa đơn cần hủy !", "error");
                                                    return;
                                                }
                                                var details = [];
                                                details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                                item["details"] = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                var tableDK = $$("huyhoadon");
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = "";
                                                        for (var i = 0; i < result.length; i++) {
                                                            var item = result[i];
                                                            kytaptrung = item.value;
                                                        }

                                                        webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                            var listcerts = JSON.parse(text);
                                                            if (listcerts.length > 0) {
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();

                                                                                var cert = null;

                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }

                                                                                var now = new Date();
                                                                                var begin = new Date(cert.begin_date);
                                                                                var end = new Date(cert.end_date);
                                                                                if (now < begin || now > end) {
                                                                                    webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                    return;
                                                                                }
                                                                                
                                                                                var postData = {
                                                                                    branch_code: user.getDvcsID(),
                                                                                    username: user.getCurrentUser(),
                                                                                    cer_serial: cert.cer_serial,
                                                                                };
                                                                                data_post.sign = postData;

                                                                                webix.extend(tableDK, webix.ProgressBar);
                                                                                tableDK.disable();
                                                                                tableDK.showProgress();
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({ "Content-type": "application/json" })
                                                                                    .post(app.config.host + "/Invoice68/giaitrinhSaveSign", data_post, {
                                                                                        error: function (text, data, XmlHttpRequest) {
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            // var json = JSON.parse(text);
                                                                                            // webix.message(json.ExceptionMessage, "error");
                                                                                            webix.message(text + XmlHttpRequest, "error");
                                                                                        },
                                                                                        success: function (text, data, XmlHttpRequest) {
                                                                                            var json = JSON.parse(text);
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            if (!json.hasOwnProperty("error")) {
                                                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                                                $$("huyhoadonForms").close();
                                                                                                app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                            } else {
                                                                                                webix.message(json.error, "error");
                                                                                            }
                                                                                        },
                                                                                    });

                                                                            // return;
                                                                        }
                                                                    },
                                                                });

                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}",
                                                                        },
                                                                        {
                                                                            id: "cert_type",
                                                                            header: _("Loại"),
                                                                            width: 100,
                                                                        },
                                                                        {
                                                                            id: "cer_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 150,
                                                                        },
                                                                        {
                                                                            id: "subject_name",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "begin_date",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "end_date",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "issuer",
                                                                            header: _("DONVI"),
                                                                            width: 450,
                                                                        },
                                                                    ],
                                                                    url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                });
                                                            } else {
                                                                var table = $$("huyhoadon");
                                                                webix.extend(table, webix.ProgressBar);
                                                                table.disable();
                                                                table.showProgress();

                                                                webix
                                                                    .ajax()
                                                                    .headers({ "Content-type": "application/json" })
                                                                    .post(app.config.host + "/Invoice68/huyhoadonSave", data_post, {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            table.enable();
                                                                            table.hideProgress();
                                                                            // var json = JSON.parse(text);
                                                                            // webix.message(json.ExceptionMessage, "error");
                                                                            webix.message(text + XmlHttpRequest, "error");
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var json = JSON.parse(text);

                                                                            if (json.hasOwnProperty("error")) {
                                                                                webix.message(json.error, "error");
                                                                            } else {
                                                                                var a = webix.ajax(app.config.host + "/Invoice68/XmlMau0405?id=" + json.id);
                                                                                var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                                                webix.promise.all([a, b, json]).then(function (results) {
                                                                                    // webix.extend(tblInvoice, webix.ProgressBar);
                                                                                    // tblInvoice.disable();
                                                                                    // tblInvoice.showProgress();
                                                                                    var json = results[0].json();

                                                                                    if (json.hasOwnProperty("error")) {
                                                                                        webix.message({ type: "error", text: json.error });
                                                                                    }

                                                                                    var listcerts = results[1].json();
                                                                                    var item = results[2];

                                                                                    if (listcerts.length == 0) {
                                                                                        table.enable();
                                                                                        table.hideProgress();
                                                                                        webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                                        return;
                                                                                    }

                                                                                    require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                                        var hub = plugin.hub();
                                                                                        var hubconnect = plugin.conn();
                                                                                        if (hubconnect.state != 1) {
                                                                                            table.enable();
                                                                                            table.hideProgress();
                                                                                            webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                                            return;
                                                                                        }
                                                                                        hub.off("resCommand");
                                                                                        hub.on("resCommand", function (result) {
                                                                                            var json = JSON.parse(result);

                                                                                            if (json.hasOwnProperty("error")) {
                                                                                                webix.message({ type: "error", text: json.error });
                                                                                            } else {
                                                                                                var parameters = {
                                                                                                    xml: json.xml,
                                                                                                    id: item.id,
                                                                                                    tthdon: 1,
                                                                                                };

                                                                                                webix
                                                                                                    .ajax()
                                                                                                    .headers({ "Content-Type": "application/json" })
                                                                                                    .post(app.config.host + "/Invoice68/SaveXmlMau0405", parameters, function (text) {
                                                                                                        var result = JSON.parse(text);
                                                                                                        if (result.hasOwnProperty("error")) {
                                                                                                            webix.message(result.error, "error");
                                                                                                        } else {
                                                                                                            app.callEvent("dataChangedInvoie68", [editmode, null]);

                                                                                                            webix.message("Thành công !", "success");
                                                                                                            webix.$$("huyhoadonForms").close();
                                                                                                        }
                                                                                                    });
                                                                                            }
                                                                                            table.enable();
                                                                                            table.hideProgress();
                                                                                        });

                                                                                        var _listcerts = [];

                                                                                        for (var i = 0; i < listcerts.length; i++) {
                                                                                            var _cert = listcerts[i];

                                                                                            _listcerts.push({
                                                                                                so_serial: _cert.cer_serial,
                                                                                                ngaybatdau: _cert.begin_date,
                                                                                                ngayketthuc: _cert.end_date,
                                                                                                issuer: _cert.issuer,
                                                                                                subjectname: _cert.subject_name,
                                                                                            });
                                                                                        }

                                                                                        var arg = {
                                                                                            idData: "#data",
                                                                                            xml: json["xml"],
                                                                                            shdon: "",
                                                                                            idSigner: "seller",
                                                                                            tagSign: "NNT",
                                                                                            dvky: json["dvky"],
                                                                                            dateKy: json["dateKy"],
                                                                                            listcerts: _listcerts,
                                                                                        };

                                                                                        hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                                            .done(function () {
                                                                                                console.log("Success !");
                                                                                            })
                                                                                            .fail(function (error) {
                                                                                                webix.message(error, "error");
                                                                                            });
                                                                                    });
                                                                                });
                                                                                // app.callEvent("dataChangedInvoie68", [editmode, null]);

                                                                                // webix.message("Thành công !", "success");
                                                                                // webix.$$("huyhoadonForms").close();
                                                                            }
                                                                        },
                                                                    });
                                                            }
                                                        });
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    app.callEvent("dataChangedInvoie68", [1, null]);
                                    webix.$$("huyhoadonForms").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix
                    .ajax()
                    .sync()
                    .get(app.config.host + "/System/GetDmDvcsByUser");
                var json = JSON.parse(result.response);

                // $$("dclhe").setValue(json[0].address);
                $$("tnnt").setValue(json[0].name);
                $$("mst").setValue(json[0].tax_code);
                //$$("tcqt").setValue(json[0].cqt_ql);
                $$("ddanh").setValue(json[0].city);
                //$$("mcqt").setValue(json[0].manage_tax_authorities);

                $$("tcqt").setValue(json[0].code2);
                $$("mcqt").setValue(json[0].code2);
                $$("tcqt_hidden").setValue(json[0].name2);

                console.log(json);
                // $$("dctdtu").setValue(json[0].email);
                // $$("nlhe").setValue(json[0].manage);
            } else {
                if (editmode == 2) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
        setValues: function (item, winconfig, params) {
            $$("danhsach_hoadonhuy").parse(item);
        },
        setValuesTongQuat: function (item, winconfig, params) {
            var data = $$("huyhoadon").getValues();
            data.so = item.so;
            data.ntbccqt = item.ntbccqt;
            data.loai = item.loai;
            $$("huyhoadon").parse(data);
        },
    };
});

define('views/forms/68_huyhoadon_1/68_mau04form',["app", "models/user"], function (app, user) {
    var controls = {
        cols: [
            {
                view: "icon",
                icon: "plus",
                on: {
                    onItemClick: function (id, e) {
                        var table = webix.$$("danhsachhoadonhuy");
                        table.add({});
                    },
                },
            },
            {
                view: "icon",
                icon: "minus",
                on: {
                    onItemClick: function (id, e) {
                        var table = webix.$$("danhsachhoadonhuy");
                        table.editStop();
                        var item = table.getSelectedItem();
                        if (!webix.isUndefined(item)) {
                            table.remove(item.id);
                            table.clearSelection();
                            return;
                        }
                        var editor = table.getEditState();
                        if (!webix.isUndefined(editor)) {
                            table.remove(editor.row);
                            table.clearSelection();
                            return;
                        }
                    },
                },
            },
        ],
    };

    var controls2 = {
        cols: [
            {},
            {
                view: "button",
                type: "icon",
                type: "form",
                label: "Lưu và Chuyển bước 2 (F10)",
                shortcut: "F10",
                width: 200,
                align: "center",
                on: {
                    onClick: function () {
                        $$("tabbar").setValue("formView");
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {
                view: "button",
                type: "icon",
                type: "danger",
                label: "Thoát (ESC)",
                hotkey: "esc",
                width: 150,
                align: "center",
                on: {
                    onClick: function () {
                        webix.$$("huyhoadon-win").close();
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {},
        ],
    };

    var table = {
        id: "danhsachhoadonhuy",
        view: "datatable",
        select: true,
        resizeColumn: true,
        footer: false,
        editable: true,
        tooltip: true,
        height: 200,
        scheme: {},
        on: {
            "data->onStoreUpdated": function () {
                this.data.each(function (obj, i) {
                    obj.stt = i + 1;
                });
            },
        },
        columns: [
            {
                id: "stt",
                name: "stt",
                header: "STT",
                width: 40,
            },
            {
                id: "khieu",
                name: "khieu",
                header: "Ký hiệu mẫu hóa đơn và ký hiệu hóa đơn",
                width: 200,
            },
            {
                id: "shdon",
                name: "shdon",
                header: "Số hóa đơn điện tử",
                width: 120,
            },
            {
                id: "tdlap",
                name: "tdlap",
                header: "Ngày lập hóa đơn",
                width: 120,
                format: webix.i18n.dateFormatStr,
                editor: "date",
            },
            {
                id: "ladhddt",
                name: "ladhddt",
                header: "Loại áp dụng hóa đơn điện tử",
                template: function (obj) {
                    switch (obj.ladhddt) {
                        case 1:
                            return "<span>HĐĐT Nghị đinh số 123/2020/NĐ-CP</span> ";
                        case 2:
                            return "<span>HĐĐT có mã của cơ quan thu</span> ";
                        case 3:
                            return "<span>Các loại hóa đơn theo Nghị đinh 51/2010</span> ";
                        case 4:
                            return "<span>Hóa đơn đặt in theo Nghị định số 123/2020/NĐ-C</span> ";
                        default:
                            break;
                    }
                },
                width: 180,
            },
            {
                id: "tctbao",
                name: "tctbao",
                header: "Hủy/Giải trình",
                width: 180,
            },
            {
                id: "ldo",
                name: "ldo",
                header: "Lý do",
                width: 180,
            },
        ],
        pager: "pagerA",
    };

    var pagination = {
        id: "pagerA",
        view: "pager",
        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
        container: "paging_here",
        size: 50,
        group: 5,
    };

    var ui = {
        id: "infoView",
        margin: 0,
        rows: [
            controls,
            table,
            pagination,
            {
                height: 10,
            },
            controls2,
        ],
    };

    return {
        $ui: ui,
    };
});

define('views/forms/68_huyhoadon_1/68_huyhoadonchitietform',["app", "models/user"], function (app, user) {
    var editmode = 0;

    var table = {
        id: "hoadon",
        view: "datatable",
        select: true,
        resizeColumn: true,
        footer: false,
        editable: false,
        tooltip: true,
        scheme: {},
        on: {
            "data->onStoreUpdated": function () {
                this.data.each(function (obj, i) {
                    obj.stt = i + 1;
                });
            },
        },
        columns: [
            {
                id: "stt",
                name: "stt",
                header: "STT",
                width: 40,
            },
            {
                id: "khieu",
                name: "khieu",
                header: "Ký hiệu mẫu hóa đơn và ký hiệu hóa đơn",
                width: 200,
            },
            {
                id: "shdon",
                name: "shdon",
                header: "Số hóa đơn điện tử",
                width: 120,
            },
            {
                id: "tdlap",
                name: "tdlap",
                header: "Ngày lập hóa đơn",
                width: 120,
                format: webix.i18n.dateFormatStr,
                editor: "date",
            },
            {
                id: "ladhddt",
                name: "ladhddt",
                header: "Loại áp dụng hóa đơn điện tử",
                template: function (obj) {
                    switch (obj.ladhddt) {
                        case 1:
                            return "<span>HĐĐT Nghị đinh số 123/2020/NĐ-CP</span> ";
                        case 2:
                            return "<span>HĐĐT có mã của cơ quan thu</span> ";
                        case 3:
                            return "<span>Các loại hóa đơn theo Nghị đinh 51/2010</span> ";
                        case 4:
                            return "<span>Hóa đơn đặt in theo Nghị định số 123/2020/NĐ-C</span> ";
                        default:
                            break;
                    }
                },
                width: 180,
            },
            {
                id: "tctbao",
                name: "tctbao",
                header: "Hủy/Giải trình",
                width: 180,
            },
            {
                id: "ldo",
                name: "ldo",
                header: "Lý do",
                width: 180,
            },
        ],
        pager: "pagerA",
    };

    var buttons = {
        cols: [
            {},
            {
                shortcut: "F8",
                view: "button",
                type: "icon",
                icon: "save",
                label: "Lưu tạm (F8)",
                width: 120,
                align: "center",
                on: {
                    onClick: function () {},
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {
                shortcut: "F9",
                view: "button",
                type: "icon",
                icon: "signal",
                label: "Ký chờ xử lý (F9)",
                width: 150,
                align: "center",
                on: {
                    onClick: function () {},
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {
                shortcut: "F10",
                type: "icon",
                icon: "paper-plane",
                view: "button",
                label: "Ký và gửi CQT (F10)",
                width: 150,
                align: "center",
                on: {
                    onClick: function () {},
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {
                shortcut: "F11",
                view: "button",
                label: "Kết xuất mẫu 04 (F11)",
                type: "icon",
                icon: "file-export",
                width: 150,
                align: "center",
                on: {
                    onClick: function () {},
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {
                view: "button",
                hotkey: "esc",
                label: "Hủy bỏ (ESC)",
                width: 120,
                type: "icon",
                icon: "ban",
                align: "center",
                click: function () {
                    webix.$$("huyhoadon-win").close();
                },
            },
            {},
        ],
    };

    var ui = {
        id: "previewView",
        rows: [
            {
                cols: [
                    {
                        height: 600,
                        view: "template",
                        id: "pdfViewInfoOld",
                    },
                    {
                        height: 600,
                        view: "template",
                        id: "pdfViewInfoNew",
                    },
                ],
            },
            buttons,
        ],
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },

        setValues: function (item) {},
    };
});

define('views/forms/68_huyhoadon_1/68_hoadonform',["app", "models/user", "locale"], function (app, user, _) {
    var header = {
        view: "template",
        template: "Hóa đơn gia trị gia tăng (01GTKT)",
        type: "header",
    };

    var master = {
        cols: [
            {
                view: "fieldset",
                label: "Thông tin hóa đơn",
                body: {
                    rows: [
                        {
                            cols: [
                                {
                                    id: "tdlap",
                                    view: "datepicker",
                                    label: "Ngày hóa đơn",
                                    labelWidth: 100,
                                    name: "tdlap",
                                },
                                {
                                    id: "shdon",
                                    view: "text",
                                    label: "Số hóa đơn",
                                    labelWidth: 100,
                                    name: "shdon",
                                },
                            ],
                        },
                        {
                            cols: [
                                {
                                    id: "tmau",
                                    view: "text",
                                    label: "Mẫu hóa đơn",
                                    labelWidth: 100,
                                    name: "tmau",
                                },
                                {
                                    id: "khieu",
                                    view: "text",
                                    label: "Ký hiệu",
                                    labelWidth: 100,
                                    name: "khieu",
                                },
                            ],
                        },
                        {
                            cols: [
                                {
                                    id: "dvtte",
                                    view: "text",
                                    label: "Mã tiền tệ",
                                    labelWidth: 100,
                                    name: "dvtte",
                                },
                                {
                                    id: "tgia",
                                    view: "text",
                                    label: "Tỷ giá",
                                    labelWidth: 100,
                                    name: "tgia",
                                },
                            ],
                        },
                        {
                            cols: [
                                {
                                    id: "htttoan",
                                    view: "combo",
                                    label: "HT thanh toán",
                                    labelWidth: 100,
                                    name: "htttoan",
                                },
                                {
                                    id: "sdhang",
                                    view: "text",
                                    label: "Số đơn hàng",
                                    labelWidth: 100,
                                    name: "sdhang",
                                },
                            ],
                        },
                        {
                            id: "stknban",
                            view: "text",
                            label: "STK bên bán",
                            labelWidth: 100,
                            name: "stknban",
                        },
                    ],
                },
            },
            {
                width: 10,
            },
            {
                view: "fieldset",
                label: "Thông tin khách hàng",
                body: {
                    rows: [
                        {
                            cols: [
                                {
                                    id: "mst",
                                    view: "search",
                                    labelWidth: 110,
                                    label: "Mã số thuế",
                                    name: "mst",
                                },
                                {
                                    id: "mnmua",
                                    view: "gridsuggest",
                                    label: "Mã đối tượng",
                                    labelWidth: 110,
                                    width: 300,
                                    name: "mnmua",
                                },
                            ],
                        },
                        {
                            cols: [
                                {
                                    id: "tnmua",
                                    view: "text",
                                    name: "tnmua",
                                    label: "Tên người mua",
                                    labelWidth: 110,
                                },
                                {
                                    id: "email",
                                    view: "text",
                                    labelWidth: 110,
                                    label: "Email",
                                    name: "email",
                                },
                            ],
                        },
                        {
                            id: "ten",
                            view: "text",
                            name: "ten",
                            label: "Tên đơn vị",
                            labelWidth: 110,
                        },
                        {
                            id: "dchi",
                            view: "text",
                            labelWidth: 110,
                            label: "Địa chỉ",
                            name: "dchi",
                        },
                        {
                            id: "stknmua",
                            view: "text",
                            label: "STK người mua",
                            labelWidth: 110,
                            name: "stknmua",
                        },
                        {
                            id: "mccqthue",
                            view: "combo",
                            label: "Cơ quan thuế",
                            labelWidth: 110,
                            name: "mccqthue",
                        },
                    ],
                },
            },
        ],
    };

    var detail = {
        borderless: true,
        scrollX: true,
        tabbar: {
            width: 200,
        },
        view: "tabview",
        id: "tab_replace",
        cells: [
            {
                header: "Chi tiết hóa đơn (01GTKT)",
                body: {
                    rows: [
                        {
                            cols: [
                                {
                                    view: "icon",
                                    icon: "plus",
                                    on: {
                                        onItemClick: function (id, e) {
                                            var table = webix.$$("chitiethoadon");
                                            table.add({});
                                        },
                                    },
                                },
                                {
                                    view: "icon",
                                    icon: "minus",
                                    on: {
                                        onItemClick: function (id, e) {
                                            var table = webix.$$("chitiethoadon");
                                            table.editStop();
                                            var item = table.getSelectedItem();
                                            if (!webix.isUndefined(item)) {
                                                table.remove(item.id);
                                                table.clearSelection();
                                                return;
                                            }
                                            var editor = table.getEditState();
                                            if (!webix.isUndefined(editor)) {
                                                table.remove(editor.row);
                                                table.clearSelection();
                                                return;
                                            }
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            view: "datatable",
                            id: "chitiethoadon",
                            height: 220,
                            name: "chitiethoadon",
                            resizeColumn: true,
                            footer: false,
                            editable: true,
                            tooltip: true,
                            scheme: {
                                $init: function (obj) { },
                            },
                            on: {
                                "data->onStoreUpdated": function () {
                                    this.data.each(function (obj, i) {
                                        obj.stt = i + 1;
                                    });
                                },
                            },
                            columns: [
                                {
                                    id: "cthdon_id",
                                    name: "cthdon_id",
                                    hidden: true,
                                },
                                {
                                    id: "hdon_id",
                                    name: "hdon_id",
                                    hidden: true,
                                },
                                {
                                    width: 120,
                                    id: "choose",
                                    header: "Chọn",
                                    editor: "checkbox",
                                    width: 90,
                                    template: function () {
                                        return "<input disabled class='webix_table_checkbox' type='checkbox' >";
                                    },
                                },
                                {
                                    id: "stt",
                                    header: "STT",
                                    width: 40,
                                },
                                {
                                    id: "ma",
                                    name: "ma",
                                    header: "Mã hàng",
                                    width: 150,
                                    editor: "combo",
                                    suggest: {
                                        view: "gridsuggest",
                                        body: {
                                            url: null,
                                            columns: [
                                                {
                                                    id: "ma",
                                                    header: "Mã hàng hóa",
                                                    width: 120,
                                                },
                                                {
                                                    id: "ten",
                                                    header: "Tên hàng hóa",
                                                    width: 250,
                                                },
                                            ],
                                            dataFeed: function (filtervalue, filter) { },
                                        },
                                        on: {
                                            onValueSuggest: function (obj) { },
                                        },
                                    },
                                },
                                {
                                    id: "ten",
                                    name: "Tên hàng hóa",
                                    header: "Tên hàng hóa",
                                    width: 250,
                                    editor: "text",
                                },
                                {
                                    id: "mdvtinh",
                                    name: "mdvtinh",
                                    header: "ĐVT",
                                    width: 150,
                                    editor: "combo",
                                    suggest: {
                                        view: "gridsuggest",
                                        body: {
                                            url: null,
                                            columns: [
                                                {
                                                    id: "ten",
                                                    header: "Tên ĐVT",
                                                    width: 150,
                                                },
                                            ],
                                            dataFeed: function (filtervalue, filter) { },
                                        },
                                        on: {
                                            onValueSuggest: function (obj) { },
                                        },
                                    },
                                },
                                {
                                    id: "sluong",
                                    name: "sluong",
                                    header: "Số lượng",
                                    width: 120,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: {
                                        "text-align": "right",
                                    },
                                    editor: "autonumeric",
                                },
                                {
                                    id: "dgia",
                                    name: "dgia",
                                    header: "Đơn giá",
                                    width: 120,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: {
                                        "text-align": "right",
                                    },
                                    editor: "autonumeric",
                                },

                                {
                                    id: "thtien",
                                    name: "thtien",
                                    header: "Tiền trước thuế",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: {
                                        "text-align": "right",
                                    },
                                    editor: "autonumeric",
                                },

                                {
                                    id: "tlckhau",
                                    name: "tlckhau",
                                    header: "% CK",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: {
                                        "text-align": "right",
                                    },
                                    editor: "autonumeric",
                                },

                                {
                                    id: "stckhau",
                                    name: "stckhau",
                                    header: "Tiền CK",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: {
                                        "text-align": "right",
                                    },
                                    editor: "autonumeric",
                                },

                                {
                                    id: "tsuat",
                                    name: "tsuat",
                                    header: "Thuế suất",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: {
                                        "text-align": "right",
                                    },
                                    editor: "combo",
                                    options: null,
                                },

                                {
                                    id: "tthue",
                                    name: "tthue",
                                    header: "Tiền thuế",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: {
                                        "text-align": "right",
                                    },
                                    editor: "autonumeric",
                                },

                                {
                                    id: "tgtien",
                                    name: "tgtien",
                                    header: "Tiền sau thuế",
                                    width: 150,
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                    css: {
                                        "text-align": "right",
                                    },
                                    editor: "autonumeric",
                                },
                            ],
                        },
                    ],
                },
            },
        ],
    };

    var totalFooter = {
        rows: [
            {
                view: "treetable",
                autoheight: true,
                autowidth: true,
                columns: [
                    {
                        id: "value",
                        header: "Loại thuế",
                        width: 250,
                        template: "{common.icon()} #value#",
                    },
                    {
                        id: "ttthue_total",
                        header: "Thành tiền trước thuế",
                        width: 200,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                        css: {
                            "text-align": "right",
                        },
                    },
                    {
                        id: "tckhau_total",
                        header: "Tiền chiết khấu",
                        width: 200,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                        css: {
                            "text-align": "right",
                        },
                    },
                    {
                        id: "tthue_total",
                        header: "Tiền thuế",
                        width: 200,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                        css: {
                            "text-align": "right",
                        },
                    },
                    {
                        id: "ttsthue_total",
                        header: "Tiền thuế",
                        width: 200,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                        css: {
                            "text-align": "right",
                        },
                    },
                ],
                data: [
                    {
                        id: "1",
                        value: "Tổng cộng hàng hóa dịch vụ",
                        open: true,
                        ttthue_total: 3000000,
                        tckhau_total: 500000,
                        tthue_total: 100000,
                        ttsthue_total: 3100000,
                        data: [
                            {
                                id: "1.1",
                                value: "Thuế suất 0%",
                                ttthue_total: 1000000,
                                tckhau_total: 0,
                                tthue_total: 0,
                                ttsthue_total: 1000000,
                            },
                            {
                                id: "1.2",
                                value: "Thuế suất 5%",
                                ttthue_total: 1000000,
                                tckhau_total: 0,
                                tthue_total: 50000,
                                ttsthue_total: 1050000,
                            },
                            {
                                id: "1.3",
                                value: "Thuế suất 10%",
                                ttthue_total: 1000000,
                                tckhau_total: 500000,
                                tthue_total: 50000,
                                ttsthue_total: 1050000,
                            },
                            {
                                id: "1.4",
                                value: "Không chịu thuế GTGT",
                                ttthue_total: 1000000,
                                tckhau_total: 0,
                                tthue_total: 0,
                                ttsthue_total: 0,
                            },
                            {
                                id: "1.5",
                                value: "Không kê thai, tính nộp thuế GTGT",
                                ttthue_total: 0,
                                tckhau_total: 0,
                                tthue_total: 0,
                                ttsthue_total: 0,
                            },
                        ],
                    },
                    {
                        id: "2",
                        value: "Tổng cộng phí lệ phí",
                        open: true,
                        ttthue_total: 0,
                        tckhau_total: 0,
                        tthue_total: 0,
                        ttsthue_total: 0,
                    },
                    {
                        id: "3",
                        value: "Tổng cộng thanh toán",
                        open: true,
                        ttthue_total: 0,
                        tckhau_total: 0,
                        tthue_total: 0,
                        ttsthue_total: 0,
                    },
                    {
                        id: "4",
                        value: "Đọc tiền bằng chữ",
                        open: true,
                        ttthue_total: 0,
                        tckhau_total: 0,
                        tthue_total: 0,
                        ttsthue_total: 0,
                    },
                ],
            },
            {
                id: "amount_to_word_inv_invoiceauth",
                view: "text",
                label: "Đọc tiền bằng chữ",
                labelWidth: 150,
                name: "amount_to_word",
            },
        ],
    };

    var controls = {
        cols: [
            {
                view: "button",
                label: "Chuyển đến giai đoạn 3",
                width: 200,
                on: {
                    onClick: function () {
                        $$("tabbar").setValue("previewView");
                        var win = webix.$$("previewView");
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();

                        var url = "http://localhost:18374/hopdong/printhopdong?id=b9496ff0-360d-4852-8153-4b3c54fbe167&type=pdf";
                        webix.ajax().get(url, function (response) {
                            win.enable();
                            win.hideProgress();
                            var file = new Blob([response], {
                                type: "application/pdf",
                            });
                            var fileURL = URL.createObjectURL(file);

                            var builder = '<iframe class="responsive-iframe" src="' + fileURL + '" frameborder="0" height="700px" width="100%"></iframe>';

                            $$("pdfViewInfo").setHTML(builder);
                        });
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {
                view: "button",
                label: "Quay lại",
                width: 120,
                on: {
                    onClick: function () {
                        $$("tabbar").setValue("infoView");
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
        ],
    };

    var ui = {
        view: "form",
        scroll: true,
        id: "formView",
        elements: [header, master, detail, totalFooter, controls],
    };
    return {
        $ui: {
            // paddingY: 10,
            // paddingX: 10,
            // elementsConfig: { labelWidth: 100 },
            view: "form",
            id: "huyhoadon_add",
            // complexData: true,
            scroll: true,
            margin: 0,
            on: {
                // onViewShow: function () {
                // }
            },
            elements: [
                {
                    view: "scrollview",
                    scroll: "y",
                    body: {
                        paddingX: 18,
                        rows: [
                            {
                                cols: [
                                    {
                                        view: "fieldset",
                                        label: "Thông tin hóa đơn",
                                        body: {
                                            rows: [
                                                {
                                                    cols: [
                                                        { view: "text", label: "cctbao_id", id: "cctbao_id", name: "cctbao_id", hidden: true },
                                                        {
                                                            view: "datepicker",
                                                            name: "tdlap",
                                                            label: "Ngày lập",
                                                            //labelPosition: "top",
                                                            id: "tdlap",
                                                            css: "mcls_readonly_text",
                                                            readonly: true,
                                                        },
                                                        {
                                                            view: "text",
                                                            name: "shdon",
                                                            id: "shdon",
                                                            label: "Số HĐ",
                                                            css: "mcls_readonly_text",
                                                            readonly: true,
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: "text",
                                                            label: _("Ký hiệu"),
                                                            name: "khieu",
                                                            css: "mcls_readonly_text",
                                                            readonly: true,
                                                            id: "khieu",
                                                            // type:"number",
                                                            attributes: { maxlength: 7 },
                                                        },
                                                        {
                                                            view: "text",
                                                            label: _("Số đơn hàng"),
                                                            name: "sdhang",
                                                            id: "sdhang",
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: "combo",
                                                            name: "dvtte",
                                                            label: "Mã tiền tệ",
                                                            //labelPosition: "top",
                                                            id: "dvtte",
                                                            required: true,
                                                            value: "1",
                                                            invalidMessage: "Trạng thái hóa đơn không thể bỏ trống !",
                                                            options: {
                                                                view: "gridsuggest",
                                                                value: "1",
                                                                template: "#value#",
                                                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00188",
                                                                body: {
                                                                    columns: [{ id: "value", header: _("Mã tiền tệ"), width: 220 }],
                                                                    dataFeed: function (filtervalue, filter) {
                                                                        if (filtervalue.length < 1) {
                                                                            this.load(this.config.url);
                                                                            return;
                                                                        }

                                                                        var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00188";
                                                                        var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                        this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                    },
                                                                },
                                                            },
                                                        },
                                                        {
                                                            view: "text",
                                                            label: "Tỷ giá",
                                                            type: "number",
                                                            value: 1,
                                                            name: "tgia",
                                                            id: "tgia",
                                                            on: {
                                                                onChange: function (newv, oldv) {
                                                                    if (newv == undefined) return;
                                                                    if (newv == "") return;
                                                                    if (!webix.rules.isNumber(newv)) {
                                                                        webix.message("Tỷ giá phải nhập số", "error");
                                                                        this.focus();
                                                                        return;
                                                                    }
                                                                },
                                                            },
                                                        },
                                                    ],
                                                },
                                                {
                                                    view: "combo",
                                                    name: "htttoan",
                                                    label: "HT thanh toán",
                                                    //labelPosition: "top",
                                                    value: "đồng",
                                                    id: "htttoan",
                                                    options: {
                                                        view: "gridsuggest",
                                                        template: "#name#",
                                                        body: {
                                                            scroll: true,
                                                            autoheight: false,
                                                            columns: [
                                                                // { id: "id", header: _("MS_THUE"), width: 150 },
                                                                { id: "code", header: _("Mã ngoại tệ"), width: 150 },
                                                                { id: "name", header: _("Tên ngoại tệ"), width: 550 },
                                                            ],
                                                            dataFeed: function (filtervalue, filter) {
                                                                if (filtervalue.length < 1) return;

                                                                var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00252";
                                                                var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                            },
                                                        },
                                                        url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00252",
                                                    },
                                                    on: {},
                                                },
                                                {
                                                    view: "text",
                                                    label: _("STK người bán"),
                                                    id: "stknban",
                                                    name: "stknban",
                                                },
                                            ],
                                        },
                                    },
                                    {
                                        view: "fieldset",
                                        label: "Thông tin khách hàng",
                                        body: {
                                            rows: [
                                                {
                                                    cols: [
                                                        {
                                                            id: "mst",
                                                            name: "mst",
                                                            view: "search",
                                                            label: "Mã số thuế",
                                                            //align: "center",
                                                            validate: webix.rules.isTaxCode,
                                                            invalidMessage: "Mã số thuế không hợp lệ",
                                                            placeholder: _("SEARCH") + "...",
                                                            // width: 300,
                                                            on: {
                                                                onChange: function (newv, oldv) {
                                                                    if (newv == undefined) return;
                                                                    if (newv == "") return;
                                                                    if (!webix.rules.isTaxCode(newv)) {
                                                                        webix.message("Mã số thuế không hợp lệ", "error");
                                                                        this.focus();
                                                                        return;
                                                                    }
                                                                    // if (newv.length != 11) {
                                                                    //     webix.message({ type: "error", text: "Độ dài mẫu số phải là 11 ký tự" });
                                                                    //     this.focus();
                                                                    //     return;
                                                                    // }
                                                                },
                                                                onTimedKeyPress: function () {
                                                                    // var table = $$("tblSearch");
                                                                    // table.clearAll();
                                                                    // table.load(table.config.url);
                                                                },
                                                                onSearchIconClick: function (e) {
                                                                    var mst = this.getValue();
                                                                    // window.location.href = "http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst;
                                                                    window.open("http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst);
                                                                },
                                                            },
                                                        },
                                                        {
                                                            view: "text",
                                                            editor: "textsearch",
                                                            label: "Mã đối tượng",
                                                            id: "mnmua",
                                                            name: "mnmua",
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        { view: "text", label: _("Tên người mua"), name: "tnmua", id: "tnmua" },
                                                        { view: "text", label: _("Email"), name: "email", id: "email" },
                                                    ],
                                                },
                                                { view: "text", label: _("Tên đơn vị"), name: "ten", id: "ten" },
                                                { view: "text", label: _("Địa chỉ"), name: "dchi", id: "dchi" },
                                                { view: "text", label: _("STK người mua"), name: "stknmua", id: "stknmua" },
                                            ],
                                        },
                                    },
                                ],
                            },
                            {
                                borderless: true,
                                view: "tabview",
                                scrollX: true,
                                tabbar: {
                                    width: 200,
                                },
                                cells: [
                                    {
                                        header: "Chi tiết hóa đơn",
                                        select: "cell",
                                        body: {
                                            rows: [
                                                {
                                                    id: "mainInvoiceManage",
                                                    css: { "padding-bottom": "5px !important" },
                                                    // view: "toolbar",
                                                    // height: 18,
                                                    cols: [
                                                        {
                                                            view: "button",
                                                            type: "htmlbutton",
                                                            width: 65,
                                                            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                            // id: "btnPrint",
                                                            // view: "button", type: "icon",
                                                            // //view: "icon",
                                                            id: "addrow",
                                                            // label: " (F9)",
                                                            // width: 60,
                                                            // icon: "fas fa-plus",
                                                            css: "btnForm",
                                                            //css: { "font-size": "15px" },
                                                            on: {
                                                                onItemClick: function (id, e) {
                                                                    var table = webix.$$("hoadon68_chitiet");
                                                                    var item = { id: webix.uid() };
                                                                    table.add(item);
                                                                    table.select(item.id, "ma", false);
                                                                    table.edit({ row: item.id, column: "ma" });
                                                                },
                                                            },
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "htmlbutton",
                                                            width: 65,
                                                            label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                            // view: "button",
                                                            id: "removerow",
                                                            // type: "icon",
                                                            // //view: "icon",
                                                            // label: " (F8)",
                                                            // width: 60,
                                                            css: "btnForm",
                                                            // icon: "fas fa-minus",
                                                            on: {
                                                                onItemClick: function (id, e) {
                                                                    var table = webix.$$("hoadon68_chitiet");

                                                                    table.editStop();

                                                                    var item = table.getSelectedItem();

                                                                    if (!webix.isUndefined(item)) {
                                                                        table.remove(item.id);
                                                                        table.clearSelection();
                                                                        return;
                                                                    }

                                                                    var editor = table.getEditState();

                                                                    if (!webix.isUndefined(editor)) {
                                                                        table.remove(editor.row);
                                                                        table.clearSelection();
                                                                        return;
                                                                    }
                                                                },
                                                            },
                                                        },
                                                        {
                                                            view: "button",
                                                            type: "htmlbutton",
                                                            width: 65,
                                                            label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                            view: "button",
                                                            id: "copyrow",
                                                            // type: "icon",
                                                            //view: "icon",
                                                            // label: " (F7)",
                                                            // width: 60,
                                                            // icon: "fas fa-copy",
                                                            css: "btnForm",
                                                            on: {
                                                                onItemClick: function (id, e) {
                                                                    var table = webix.$$("hoadon68_chitiet");

                                                                    table.editStop();

                                                                    var item = table.getSelectedItem();
                                                                    if (item == null || item == undefined) {
                                                                        webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                        return;
                                                                    }
                                                                    //item.id = webix.uid();
                                                                    var copy = webix.copy(item);
                                                                    copy.id = webix.uid();
                                                                    //copy[tab.tab_table + "_id"] = null;

                                                                    table.add(copy);
                                                                    table.unselect(item.id);
                                                                    table.select(copy.id, "ma", false);
                                                                    table.edit({ row: copy.id, column: "ma" });
                                                                },
                                                            },
                                                        },
                                                        {
                                                            view: "checkbox",
                                                            id: "check_chietkhau",
                                                            value: 0,
                                                            labelRight: _("Chiết khấu"),
                                                            labelWidth: 2,
                                                            tooltip: "Tích vào đây nếu hóa đơn có chiết khấu",
                                                            on: {
                                                                onChange: function (newv, oldv) {
                                                                    if (newv == 1) {
                                                                        $$("hoadon68_chitiet").showColumn("stckhau");
                                                                        $$("hoadon68_chitiet").showColumn("tlckhau");
                                                                    } else {
                                                                        $$("hoadon68_chitiet").hideColumn("stckhau");
                                                                        $$("hoadon68_chitiet").hideColumn("tlckhau");
                                                                    }
                                                                },
                                                            },
                                                        },
                                                    ],
                                                },
                                                {
                                                    view: "datatable",
                                                    resizeColumn: true,
                                                    id: "hoadon68_chitiet",
                                                    // tab_table: tab.tab_table,
                                                    // tab_id: tab.tab_id,
                                                    editable: true,
                                                    select: "cell",
                                                    height: 260,
                                                    drag: true,
                                                    // select_change: tab.select_change,
                                                    // cell_editstop: tab.cell_editstop,
                                                    // after_addrow: tab.after_addrow,
                                                    // after_delrow: tab.after_delrow,
                                                    // oncheck: tab.oncheck,
                                                    columns: [
                                                        { id: "stt", header: "", width: 30 },
                                                        {
                                                            id: "ma",
                                                            header: _("Mã hàng hóa"),
                                                            editor: "textsearch",
                                                            width: 100,
                                                            editable: true,
                                                            suggest: {
                                                                view: "gridsuggest",
                                                                // value_suggest: field.value_suggest,
                                                                // fieldExpression: field.field_expression,
                                                                // displayField: field.display_field,
                                                                // tableId: "edit_inv_InvoiceDetail",
                                                                columnName: "ma_hanghoa",
                                                                body: {
                                                                    columns: [
                                                                        { id: "id", hidden: true, header: "id" },
                                                                        { id: "code", width: 120, header: "code" },
                                                                        { id: "name", width: 350, header: "name" },
                                                                    ],
                                                                    scroll: true,
                                                                    autoheight: false,
                                                                    datatype: "json",
                                                                    dataFeed: function (filtervalue, filter) {
                                                                        if (filtervalue.length < 1) return;

                                                                        var refid = this.config.refid;
                                                                        var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00005";
                                                                        var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                        this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                    },
                                                                },
                                                                on: {
                                                                    onValueSuggest: function (obj) {
                                                                        var table = $$("hoadon68_chitiet");
                                                                        var selectedItem = table.getSelectedItem();
                                                                        selectedItem["ma"] = obj["code"];
                                                                        selectedItem["ten"] = obj["name"];
                                                                        selectedItem["mdvtinh"] = obj["unit_code"];
                                                                        selectedItem["dgia"] = obj["unit_price"];
                                                                        selectedItem["tsuat"] = obj["vat_type"];
                                                                        table.updateItem(selectedItem.id, selectedItem);
                                                                    },
                                                                },
                                                            },
                                                        },
                                                        {
                                                            id: "ten",
                                                            header: _("Tên hàng hóa"),
                                                            editor: "text",
                                                            width: 350,
                                                            editable: true,
                                                        },
                                                        {
                                                            id: "mdvtinh",
                                                            header: _("ĐVT"),
                                                            editor: "text",
                                                            width: 80,
                                                            editable: true,
                                                            suggest: {
                                                                view: "gridsuggest",
                                                                columnName: "name",
                                                                body: {
                                                                    columns: [
                                                                        { id: "id", hidden: true, header: "id" },
                                                                        { id: "name", width: 120, header: "name" },
                                                                    ],
                                                                    scroll: true,
                                                                    autoheight: false,
                                                                    datatype: "json",
                                                                    dataFeed: function (filtervalue, filter) {
                                                                        if (filtervalue.length < 1) return;

                                                                        var refid = this.config.refid;
                                                                        var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?id=RF00035";
                                                                        var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                        this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                    },
                                                                },
                                                                on: {
                                                                    onValueSuggest: function (obj) {
                                                                        var table = $$("hoadon68_chitiet");
                                                                        var selectedItem = table.getSelectedItem();
                                                                        selectedItem["mdvtinh"] = obj["code"];

                                                                        table.updateItem(selectedItem.id, selectedItem);
                                                                    },
                                                                },
                                                            },
                                                        },
                                                        {
                                                            id: "sluong",
                                                            header: _("Số lượng"),
                                                            editor: "autonumeric",
                                                            width: 100,
                                                            editable: true,
                                                            css: { "text-align": "right" },
                                                            format: webix.Number.numToStr({
                                                                groupDelimiter: ".",
                                                                groupSize: 3,
                                                                decimalDelimiter: ",",
                                                                decimalSize: 2,
                                                            }),
                                                        },
                                                        {
                                                            id: "dgia",
                                                            header: _("Đơn giá"),
                                                            width: 150,
                                                            editor: "autonumeric",
                                                            editable: true,
                                                            css: { "text-align": "right" },
                                                            format: webix.Number.numToStr({
                                                                groupDelimiter: ".",
                                                                groupSize: 3,
                                                                decimalDelimiter: ",",
                                                                decimalSize: 2,
                                                            }),
                                                            // value_change: field.value_change
                                                        },
                                                        {
                                                            id: "thtien",
                                                            header: _("Tiền trước thuế"),
                                                            width: 150,
                                                            editor: "autonumeric",
                                                            editable: true,
                                                            css: { "text-align": "right" },
                                                            format: webix.Number.numToStr({
                                                                groupDelimiter: ".",
                                                                groupSize: 3,
                                                                decimalDelimiter: ",",
                                                                decimalSize: 2,
                                                            }),
                                                            // value_change: field.value_change
                                                        },
                                                        {
                                                            id: "tlckhau",
                                                            header: _("% CK"),
                                                            width: 80,
                                                            editor: "autonumeric",
                                                            editable: true,
                                                            hidden: true,
                                                            css: { "text-align": "right" },
                                                            format: webix.Number.numToStr({
                                                                groupDelimiter: ".",
                                                                groupSize: 3,
                                                                decimalDelimiter: ",",
                                                                decimalSize: 2,
                                                            }),
                                                        },
                                                        {
                                                            id: "stckhau",
                                                            header: _("Tiền CK"),
                                                            width: 150,
                                                            editor: "autonumeric",
                                                            editable: true,
                                                            css: { "text-align": "right" },
                                                            hidden: true,
                                                            format: webix.Number.numToStr({
                                                                groupDelimiter: ".",
                                                                groupSize: 3,
                                                                decimalDelimiter: ",",
                                                                decimalSize: 2,
                                                            }),
                                                        },
                                                        {
                                                            id: "tsuat",
                                                            header: _("Thuế suất"),
                                                            width: 100,
                                                            //  editor: "combo",
                                                            editor: "autonumeric",
                                                            editable: true,
                                                            css: { "text-align": "right" },
                                                            format: webix.Number.numToStr({
                                                                groupDelimiter: ".",
                                                                groupSize: 3,
                                                                decimalDelimiter: ",",
                                                                decimalSize: 2,
                                                            }),
                                                            // on: {
                                                            //     onChange: function (newv, oldv) {
                                                            //     }
                                                            // },
                                                            // options: app.config.host + "/System/GetDataByReferencesId?id=D6FAEAFC-4EF2-4ABD-AB45-F3DCB4805740",
                                                            // optionslist: true
                                                        },
                                                        {
                                                            id: "tthue",
                                                            header: _("Tiền thuế"),
                                                            width: 150,
                                                            editor: "autonumeric",
                                                            editable: true,
                                                            css: { "text-align": "right" },
                                                            format: webix.Number.numToStr({
                                                                groupDelimiter: ".",
                                                                groupSize: 3,
                                                                decimalDelimiter: ",",
                                                                decimalSize: 2,
                                                            }),
                                                        },
                                                        {
                                                            id: "tgtien",
                                                            header: _("Tiền sau thuế"),
                                                            width: 150,
                                                            editor: "autonumeric",
                                                            editable: true,
                                                            css: { "text-align": "right" },
                                                            format: webix.Number.numToStr({
                                                                groupDelimiter: ".",
                                                                groupSize: 3,
                                                                decimalDelimiter: ",",
                                                                decimalSize: 2,
                                                            }),
                                                        },
                                                        {
                                                            id: "kmai",
                                                            header: _("Khuyến mại"),
                                                            width: 100,
                                                            editor: "checkbox",
                                                            editable: true,
                                                            template: "{common.checkbox()}",
                                                            checkValue: true,
                                                            uncheckValue: false,
                                                        },
                                                    ],
                                                    on: {
                                                        "data->onStoreUpdated": function () {
                                                            this.data.each(function (obj, i) {
                                                                obj.stt = i + 1;
                                                            });
                                                        },
                                                        onAfterLoad: function () {
                                                            var table = this;
                                                            var data = table.serialize();
                                                            data.forEach(function (entry) {
                                                                if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                    if (entry["stckhau"] != 0 || entry["tlckhau"] != 0) {
                                                                        var ck = $$("check_chietkhau");
                                                                        if (ck != undefined) {
                                                                            ck.setValue(1);
                                                                            return false;
                                                                            // $$("edit_" + tab.tab_table).showColumn("inv_discountAmount");
                                                                            // $$("edit_" + tab.tab_table).showColumn("inv_discountPercentage");
                                                                        }
                                                                    }
                                                                }
                                                            });
                                                        },
                                                        onCheck: function (row, column, state) {
                                                            var table = this;
                                                            if (column == "khuyen_mai") {
                                                                if (state == true) {
                                                                    // var selectedItem = table.getItem(row);
                                                                    // selectedItem.don_gia = null;
                                                                    // selectedItem.tien_tt = null;
                                                                    // selectedItem.pt_ck = null;
                                                                    // selectedItem.tien_ck = null;
                                                                    // selectedItem.pt_thue = null;
                                                                    // selectedItem.tien_thue = null;
                                                                    // selectedItem.tong_tien = null;
                                                                    // table.updateItem(selectedItem.id, selectedItem);
                                                                    // table.callEvent("onAfterAdd");
                                                                }
                                                            }
                                                        },
                                                        onAfterAdd: function (id, index) {
                                                            var table = $$(this.config.id);
                                                            var data = table.serialize();

                                                            var tong_tien_tt_dp = 0;
                                                            var tong_tien_thue_dp = 0;
                                                            var tong_tien_ck_dp = 0;
                                                            var tong_tien_dp = 0;
                                                            data.forEach(function (entry) {
                                                                tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];

                                                                // $$("inv_Invoice_tien_tt").setValue(tong_tien_tt_dp);
                                                                // $$("inv_Invoice_tien_ck").setValue(tong_tien_ck_dp);
                                                                // $$("inv_Invoice_tien_thue").setValue(tong_tien_thue_dp);
                                                                // $$("inv_Invoice_tong_tien").setValue(tong_tien_dp);
                                                            });
                                                        },
                                                        onAfterEditStop: function (state, editor, ignore) {
                                                            var table = $$(this.config.id);
                                                            var selectedItem = table.getItem(editor.row);
                                                            var columnId = editor.config.id;

                                                            var so_luong = webix.rules.isNumber(selectedItem.sluong) ? selectedItem.sluong : 0;
                                                            var don_gia = webix.rules.isNumber(selectedItem.dgia) ? selectedItem.dgia : 0;
                                                            var tien_tt = webix.rules.isNumber(selectedItem.thtien) ? selectedItem.thtien : 0;
                                                            var pt_ck = webix.rules.isNumber(selectedItem.tlckhau) ? selectedItem.tlckhau : 0;
                                                            var tien_ck = webix.rules.isNumber(selectedItem.stckhau) ? selectedItem.stckhau : 0;
                                                            var pt_thue = webix.rules.isNumber(selectedItem.tsuat) ? selectedItem.tsuat : 0;
                                                            var tien_thue = webix.rules.isNumber(selectedItem.tthue) ? selectedItem.tthue : 0;
                                                            var tong_tien = webix.rules.isNumber(selectedItem.tgtien) ? selectedItem.tgtien : 0;
                                                            if (
                                                                columnId == "tsuat" ||
                                                                columnId == "sluong" ||
                                                                columnId == "dgia" ||
                                                                columnId == "thtien" ||
                                                                columnId == "tgtien" ||
                                                                columnId == "tlckhau" ||
                                                                columnId == "stckhau"
                                                            ) {
                                                                if (don_gia < 0) {
                                                                    don_gia = 0;
                                                                }
                                                                if (so_luong < 0) {
                                                                    so_luong = 0;
                                                                }

                                                                if (don_gia > 0) {
                                                                    tien_tt = so_luong * don_gia;
                                                                }

                                                                if (pt_ck < 0) {
                                                                    pt_ck = 0;
                                                                }
                                                                if (pt_ck > 100) {
                                                                    pt_ck = 0;
                                                                }

                                                                tien_ck = (tien_tt * pt_ck) / 100;
                                                                if (tien_ck - tien_tt > 0) {
                                                                    tien_ck = 0;
                                                                }
                                                                tien_thue = ((tien_tt - tien_ck) * pt_thue) / 100;

                                                                tong_tien = Math.round(tien_tt - tien_ck + parseFloat(tien_thue));
                                                            }
                                                            selectedItem.sluong = so_luong;
                                                            selectedItem.dgia = don_gia;
                                                            selectedItem.tsuat = pt_thue;
                                                            selectedItem.thtien = tien_tt;
                                                            selectedItem.tlckhau = pt_ck;
                                                            selectedItem.stckhau = tien_ck;
                                                            selectedItem.tthue = tien_thue;
                                                            selectedItem.tgtien = tong_tien;
                                                            table.updateItem(selectedItem.id, selectedItem);

                                                            var data = table.serialize();
                                                            var tien_tt_all = 0;
                                                            var tien_thue_all = 0;
                                                            var tien_ck_all = 0;
                                                            var tong_tien_all = 0;

                                                            var tien_tt_10 = 0;
                                                            var tien_thue_10 = 0;
                                                            var tien_ck_10 = 0;
                                                            var tong_tien_10 = 0;

                                                            var tien_tt_5 = 0;
                                                            var tien_thue_5 = 0;
                                                            var tien_ck_5 = 0;
                                                            var tong_tien_5 = 0;

                                                            var tien_tt_0 = 0;
                                                            var tien_thue_0 = 0;
                                                            var tien_ck_0 = 0;
                                                            var tong_tien_0 = 0;

                                                            var tien_tt_kct = 0;
                                                            var tien_thue_kct = 0;
                                                            var tien_ck_kct = 0;
                                                            var tong_tien_kct = 0;

                                                            var tien_tt_kkk = 0;
                                                            var tien_thue_kkk = 0;
                                                            var tien_ck_kkk = 0;
                                                            var tong_tien_kkk = 0;

                                                            data.forEach(function (entry) {
                                                                tien_tt_all += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                tien_thue_all += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                tien_ck_all += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                tong_tien_all += entry["tgtien"] == null ? 0 : entry["tgtien"];

                                                                if (entry["tsuat"] == 10) {
                                                                    tien_tt_10 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                    tien_thue_10 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                    tien_ck_10 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                    tong_tien_10 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                }
                                                                if (entry["tsuat"] == 5) {
                                                                    tien_tt_5 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                    tien_thue_5 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                    tien_ck_5 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                    tong_tien_5 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                }
                                                                if (entry["tsuat"] == 0) {
                                                                    tien_tt_0 += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                    tien_thue_0 += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                    tien_ck_0 += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                    tong_tien_0 += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                }
                                                                if (entry["tsuat"] == -1) {
                                                                    tien_tt_kct += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                    tien_thue_kct += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                    tien_ck_kct += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                    tong_tien_kct += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                }
                                                                if (entry["tsuat"] == -2) {
                                                                    tien_tt_kkk += entry["thtien"] == null ? 0 : entry["thtien"];
                                                                    tien_thue_kkk += entry["tthue"] == null ? 0 : entry["tthue"];
                                                                    tien_ck_kkk += entry["stckhau"] == null ? 0 : entry["stckhau"];
                                                                    tong_tien_kkk += entry["tgtien"] == null ? 0 : entry["tgtien"];
                                                                }
                                                            });

                                                            $$("tgtcthue").setValue(tien_tt_all);
                                                            $$("tgtcthue10").setValue(tien_tt_10);
                                                            $$("tgtcthue5").setValue(tien_tt_5);
                                                            $$("tgtcthue0").setValue(tien_tt_0);
                                                            $$("tgtcthuekct").setValue(tien_tt_kct);
                                                            $$("tgtcthuekkk").setValue(tien_tt_kkk);

                                                            $$("ttcktmai").setValue(tien_ck_all);
                                                            $$("ttcktmai10").setValue(tien_ck_10);
                                                            $$("ttcktmai5").setValue(tien_ck_5);
                                                            $$("ttcktmai0").setValue(tien_ck_0);
                                                            $$("ttcktmaikct").setValue(tien_ck_kct);
                                                            $$("ttcktmaikkk").setValue(tien_ck_kkk);

                                                            $$("tgtthue").setValue(tien_thue_all);
                                                            $$("tgtthue10").setValue(tien_thue_10);
                                                            $$("tgtthue5").setValue(tien_thue_5);
                                                            $$("tgtthue0").setValue(tien_thue_0);
                                                            $$("tgtthuekct").setValue(tien_thue_kct);
                                                            $$("tgtthuekkk").setValue(tien_thue_kkk);

                                                            $$("tgtttbso").setValue(tong_tien_all);
                                                            $$("tgtttbso10").setValue(tong_tien_10);
                                                            $$("tgtttbso5").setValue(tong_tien_5);
                                                            $$("tgtttbso0").setValue(tong_tien_0);
                                                            $$("tgtttbsokct").setValue(tong_tien_kct);
                                                            $$("tgtttbsokkk").setValue(tong_tien_kkk);
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        rows: [
                                            { view: "label", label: "Loại thuế", css: "lblTongtien" },
                                            {
                                                view: "label",
                                                label: " + Tổng cộng hàng hóa, dịch vụ",
                                                height: 22,
                                                css: { "padding-left": "5px", "font-weight": "bold", "background-color": "#86b2cf" },
                                            },
                                            { view: "label", label: "Thuế suất 10%", css: "lblSubTongtien", height: 22 },
                                            { view: "label", label: "Thuế suất 5%", css: "lblSubTongtien", height: 22 },
                                            { view: "label", label: "Thuế suất 0%", css: "lblSubTongtien", height: 22 },
                                            { view: "label", label: "Không chịu thuế GTGT", css: "lblSubTongtien", height: 22 },
                                            { view: "label", label: "Không kê khai, tính nộp thuế GTGT", css: "lblSubTongtien", height: 22 },
                                            // { view: "label", label: "Tổng cộng phí lệ phí", css: { "font-weight": "bold", "background-color": "#86b2cf" } , height: 22 },
                                            // { view: "label", label: "Tổng cộng thanh toán", css: { "font-weight": "bold", "background-color": "#86b2cf" } , height: 22 },
                                        ],
                                    },
                                    {
                                        rows: [
                                            { view: "label", label: "Thành tiền trước thuế", css: "lblTongtien" },
                                            { view: "text", format: "1.111,00", id: "tgtcthue", name: "tgtcthue", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtcthue10", name: "tgtcthue10", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtcthue5", name: "tgtcthue5", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtcthue0", name: "tgtcthue0", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtcthuekct", name: "tgtcthuekct", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtcthuekkk", name: "tgtcthuekkk", css: "txtTongtien", readonly: true, height: 22 },
                                            // { view: "text", id: "2", name: "2", css: "txtTongtien", readonly: true, height: 22 }
                                        ],
                                    },
                                    {
                                        rows: [
                                            { view: "label", label: "Tiền chiết khấu", css: "lblTongtien" },
                                            { view: "text", format: "1.111,00", id: "ttcktmai", name: "ttcktmai", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "ttcktmai10", name: "ttcktmai10", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "ttcktmai5", name: "ttcktmai5", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "ttcktmai0", name: "ttcktmai0", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "ttcktmaikct", name: "ttcktmaikct", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "ttcktmaikkk", name: "ttcktmaikkk", css: "txtTongtien", readonly: true, height: 22 },
                                        ],
                                    },
                                    {
                                        rows: [
                                            { view: "label", label: "Tiền thuế", css: "lblTongtien" },
                                            { view: "text", format: "1.111,00", id: "tgtthue", name: "tgtthue", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtthue10", name: "tgtthue10", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtthue5", name: "tgtthue5", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtthue0", name: "tgtthue0", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtthuekct", name: "tgtthuekct", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtthuekkk", name: "tgtthuekkk", css: "txtTongtien", readonly: true, height: 22 },
                                        ],
                                    },
                                    {
                                        rows: [
                                            { view: "label", label: "Tổng tiền sau thuế", css: "lblTongtien" },
                                            {
                                                view: "text",
                                                id: "tgtttbso",
                                                name: "tgtttbso",
                                                css: "txtTongtien",
                                                readonly: true,
                                                height: 22,
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        var total_amount = $$("tgtttbso").getValue();
                                                        var type_curency = $$("dvtte").getValue();
                                                        var url = app.config.host + "/Invoice68/Amount_ToWord?number=" + total_amount + "&type_amount=" + type_curency;
                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .get(url, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    //webix.modalbox.hide(box);
                                                                    webix.alert({
                                                                        title: "Lỗi !",
                                                                        text: err,
                                                                        type: "alert-error",
                                                                    });
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var c_result = JSON.parse(text);
                                                                    $$("tgtttbchu").setValue(c_result.data);
                                                                },
                                                            });
                                                    },
                                                },
                                                format: "1.111,00",
                                            },
                                            { view: "text", format: "1.111,00", id: "tgtttbso10", name: "tgtttbso10", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtttbso5", name: "tgtttbso5", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtttbso0", name: "tgtttbso0", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtttbsokct", name: "tgtttbsokct", css: "txtTongtien", readonly: true, height: 22 },
                                            { view: "text", format: "1.111,00", id: "tgtttbsokkk", name: "tgtttbsokkk", css: "txtTongtien", readonly: true, height: 22 },
                                        ],
                                    },
                                ],
                            },
                            {
                                cols: [
                                    { view: "label", width: 309, label: "Đọc tiền bằng chữ", css: { "font-weight": "bold", "background-color": "#86b2cf", "padding-left": "5px" }, height: 22 },
                                    { view: "text", id: "tgtttbchu", name: "tgtttbchu", css: "txtTongtien", readonly: true, height: 22 },
                                ],
                            },
                            {
                                margin: 10,
                                cols: [
                                    {},
                                    {
                                        shortcut: "F10",
                                        view: "button",
                                        label: "Lưu tạm (F10)",
                                        type: "form",
                                        align: "center",
                                        width: 120,
                                        on: {
                                            onClick: function () {
                                                var item = $$("huyhoadon_add").getValues();
                                                var table = $$("huyhoadon_add");

                                                if (table.validate()) {
                                                    // var fn = Function(check);
                                                    // var result = fn();
                                                    // console.log(result);
                                                    webix.extend(table, webix.ProgressBar);
                                                    table.disable();
                                                    table.showProgress();

                                                    var details = [];
                                                    details.push({ data: $$("hoadon68_chitiet").serialize() });
                                                    item["details"] = details;

                                                    var item1 = [];
                                                    item1.push(item);
                                                    var data_post = { editmode: editmode, data: item1 };

                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(app.config.host + "/Invoice68/hoadonSaveChange", data_post, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                table.enable();
                                                                table.hideProgress();
                                                                // var json = JSON.parse(text);
                                                                // webix.message(json.ExceptionMessage, "error");
                                                                webix.message(text + XmlHttpRequest, "error");
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(text);
                                                                table.enable();
                                                                table.hideProgress();
                                                                if (!json.hasOwnProperty("error")) {
                                                                    webix.$$("invoice68").close();
                                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                                } else {
                                                                    webix.message(json.error, "error");
                                                                }
                                                            },
                                                        });
                                                }
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                    {
                                        shortcut: "F11",
                                        view: "button",
                                        label: "Ký và gửi CQT (F11)",
                                        type: "form",
                                        align: "center",
                                        width: 150,
                                        on: {
                                            onClick: function () {
                                                var item = $$("huyhoadon_add").getValues();
                                                var table = $$("huyhoadon_add");

                                                if (table.validate()) {
                                                    // var fn = Function(check);
                                                    // var result = fn();
                                                    // console.log(result);
                                                    webix.extend(table, webix.ProgressBar);
                                                    table.disable();
                                                    table.showProgress();

                                                    var details = [];
                                                    details.push({ data: $$("hoadon68_chitiet").serialize() });
                                                    item["details"] = details;

                                                    var item1 = [];
                                                    item1.push(item);
                                                    var data_post = { editmode: editmode, data: item1 };

                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(app.config.host + "/Invoice68/hoadonSaveChange", data_post, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                table.enable();
                                                                table.hideProgress();
                                                                // var json = JSON.parse(text);
                                                                // webix.message(json.ExceptionMessage, "error");
                                                                webix.message(text + XmlHttpRequest, "error");
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(text);
                                                                table.enable();
                                                                table.hideProgress();
                                                                if (!json.hasOwnProperty("error")) {
                                                                    webix.$$("invoice68").close();
                                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);

                                                                    var box = webix.modalbox({
                                                                        title: "Chọn chứng thư số",
                                                                        buttons: ["Nhận", "Hủy bỏ"],
                                                                        text: "<div id='ctnCerts'></div>",
                                                                        top: 100,
                                                                        width: 750,
                                                                        callback: function (result) {
                                                                            switch (result) {
                                                                                case "1":
                                                                                    webix.modalbox.hide();
                                                                                    break;
                                                                                case "0":
                                                                                    var table = $$("tblCerts");
                                                                                    var data = table.serialize();

                                                                                    var cert = null;

                                                                                    for (var i = 0; i < data.length; i++) {
                                                                                        if (data[i].chon == true) {
                                                                                            cert = data[i];
                                                                                            break;
                                                                                        }
                                                                                    }

                                                                                    if (cert == null) {
                                                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                                                        return;
                                                                                    }

                                                                                    var item = json.data;

                                                                                    var postData = {
                                                                                        branch_code: user.getDvcsID(),
                                                                                        username: user.getCurrentUser(),
                                                                                        cer_serial: cert.cer_serial,
                                                                                        hdon_id: item.id,
                                                                                    };

                                                                                    webix
                                                                                        .ajax()
                                                                                        .headers({ "Content-Type": "application/json" })
                                                                                        .post(app.config.host + "/Invoice68/SignInvoiceCertFile68", postData, function (text) {
                                                                                            var result = JSON.parse(text);

                                                                                            if (result.hasOwnProperty("error")) {
                                                                                                webix.message({ type: "error", text: result.error });
                                                                                                return;
                                                                                            }

                                                                                            if (result.ok == true) {
                                                                                                var table = webix.$$("invoiceViews");
                                                                                                table.clearAll();
                                                                                                table.load(table.config.url);
                                                                                                // webix.ajax()
                                                                                                //     .headers({ 'Content-type': 'application/json' })
                                                                                                //     .post(app.config.host + "/System/ExecuteCommand",
                                                                                                //     {
                                                                                                //         command: "CM00025",
                                                                                                //         parameter: {

                                                                                                //         }
                                                                                                //     }
                                                                                                //     , function (text) {
                                                                                                //         var json = JSON.parse(text);
                                                                                                //         // auto send SMS
                                                                                                //         if (json[1].value == "C") {
                                                                                                //             var data = { id: item.inv_InvoiceAuth_id };

                                                                                                //             webix.ajax()
                                                                                                //                 .headers({ 'Content-type': 'application/json' })
                                                                                                //                 .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
                                                                                                //                     var data = JSON.parse(text);

                                                                                                //                     if (!data.hasOwnProperty("error")) {

                                                                                                //                     }
                                                                                                //                     else {
                                                                                                //                         webix.message(data.error, "error");
                                                                                                //                     }
                                                                                                //                 });
                                                                                                //         }

                                                                                                //     });

                                                                                                webix.modalbox.hide();
                                                                                            }
                                                                                        });

                                                                                    return;
                                                                            }
                                                                        },
                                                                    });

                                                                    var tblMatHang = webix.ui({
                                                                        container: "ctnCerts",
                                                                        id: "tblCerts",
                                                                        view: "datatable",
                                                                        borderless: true,
                                                                        resizeColumn: true,
                                                                        height: 350,
                                                                        columns: [
                                                                            {
                                                                                id: "chon",
                                                                                header: _("CHON"),
                                                                                width: 65,
                                                                                checkValue: true,
                                                                                uncheckValue: false,
                                                                                template: "{common.checkbox()}",
                                                                            },
                                                                            {
                                                                                id: "cer_serial",
                                                                                header: _("SO_SERIAL"),
                                                                                width: 150,
                                                                            },
                                                                            {
                                                                                id: "subject_name",
                                                                                header: _("SUBJECTNAME"),
                                                                                width: 450,
                                                                            },
                                                                            {
                                                                                id: "begin_date",
                                                                                header: _("NGAY_BAT_DAU"),
                                                                                width: 200,
                                                                            },
                                                                            {
                                                                                id: "end_date",
                                                                                header: _("NGAY_KET_THUC"),
                                                                                width: 200,
                                                                            },
                                                                            {
                                                                                id: "issuer",
                                                                                header: _("DONVI"),
                                                                                width: 450,
                                                                            },
                                                                        ],
                                                                        url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                    });
                                                                } else {
                                                                    webix.message(json.error, "error");
                                                                }
                                                            },
                                                        });
                                                }
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                    {
                                        view: "button",
                                        hotkey: "esc",
                                        label: "Hủy bỏ (ESC)",
                                        align: "center",
                                        type: "danger",
                                        width: 120,
                                        click: function () {
                                            this.getTopParentView().close();
                                        },
                                    },
                                    {},
                                ],
                            },
                        ],
                    },
                },
            ],
        },
    };
});

define('views/forms/68_huyhoadon_1',["app", "models/user", "views/forms/68_huyhoadon_1/68_mau04form", "views/forms/68_huyhoadon_1/68_huyhoadonchitietform", "views/forms/68_huyhoadon_1/68_hoadonform"], function (
    app,
    user,
    mau04form,
    huyhoadonchitietform,
    hoadonform
) {
    var editmode = 0;

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "huyhoadon-win",
        position: "center",
        head: {
            view: "toolbar",
            elements: [
                {
                    width: 50,
                },
                {
                    template: function () {
                        return '<h3 style="text-align: center; margin: 0">Hủy và tạo mới hóa đơn</h3>';
                    },
                },
                {
                    view: "icon",
                    icon: "times",
                    on: {
                        onClick: function () {
                            $$("huyhoadon-win").close();
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
            ],
        },
        body: {
            rows: [
                {
                    view: "tabbar",
                    id: "tabbar",
                    multiview: true,
                    height: 50,
                    width: 1500,
                    value: "infoView",
                    options: [
                        { value: "Bước 1: Lập mẫu 04", id: "infoView" },
                        { value: "Bước 2: Tạo hóa đơn mới", id: "formView" },
                        { value: "Bước 3: Ký và gửi", id: "previewView" },
                    ],
                    on: {
                        onBeforeTabClick: function (id, ev) {
                            if (id == "previewView") {
                                var win = webix.$$("previewView");
                                webix.extend(win, webix.ProgressBar);
                                win.disable();
                                win.showProgress();

                                var url = "http://localhost:18374/hopdong/printhopdong?id=b9496ff0-360d-4852-8153-4b3c54fbe167&type=pdf";
                                webix.ajax().get(url, function (response) {
                                    win.enable();
                                    win.hideProgress();
                                    var file = new Blob([response], {
                                        type: "application/pdf",
                                    });
                                    var fileURL = URL.createObjectURL(file);

                                    var builder = '<div><p>Mẫu hóa đơn</p><iframe class="responsive-iframe" src="' + fileURL + '" frameborder="0" height="700px" width="100%"></iframe></div>';

                                    $$("pdfViewInfoOld").setHTML(builder);
                                    $$("pdfViewInfoNew").setHTML(builder);
                                });
                            }

                            if (id == "formView") {
                                // Load data tab formView
                            }

                            if (id == "infoView") {
                                // Load data tab infoView
                            }
                        },
                        onAfterRender: function () {
                            // Load data tab 1
                        },
                    },
                },
                {
                    height: 650,
                    cells: [mau04form.$ui, hoadonform, huyhoadonchitietform],
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },

        setValues: function (item) {},
    };
});

define('views/68_invoiceViews_code',["app", "locale", "models/user", "views/forms/68_invoiceForms_code", "views/forms/68_huyhoadon", "views/forms/68_huyhoadon_1", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    invoiceForms,
    huyhoadon,
    huyhoadon_1,
    hoadonHistory,
    commonHD
) {
    

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];

    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            // {
            //     id: "huyhoadon",
            //     value: "Hủy hóa đơn",
            // },
            // {
            //     id: "huyhoadon2",
            //     value: "Hủy hóa đơn có tạo mới",
            // },
            // {
            //     id: "giaitrinh",
            //     value: "Giải trình",
            // },
            {
                id: "notifyErrorInvoice",
                value: "Thông báo HĐĐT có sai sót",
            },
            {
                id: "replace_invoice",
                value: "Thay thế",
            },
            {
                id: "increase_change_invoice",
                value: "Điều chỉnh tăng",
            },
            {
                id: "reduce_change_invoice",
                value: "Điều chỉnh giảm",
            },
            {
                id: "info_change",
                value: "Điều chỉnh thông tin",
            },
            {
                id: "dowloadXml",
                value: "Tải XML",
            },
            {
                id: "dowloadXmlMessageHD",
                value: "Tải XML thông điệp gửi HĐ",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                // console.log(record);
                if (record.id == "huyhoadon") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Hóa đơn đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: item.ladhddt,
                        tctbao: item.tctbao,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "huyhoadon2") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Hóa đơn đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnStep299").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    // webix.$$("btnStep299").define("hidden", false);
                    // webix.$$("btnStep2").show();
                    // webix.$$("btnStep299").hide();
                    // $$("btnHuyHDDT").addView({ view:"button",label: "Bước 2" }, 1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "dowloadXml") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlInvoice.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "dowloadXmlMessageHD") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Hóa đơn chưa được gửi tới CQT, không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLThongDiepHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlThongDiepHoaDon.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "giaitrinh") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon != "4" && item.tthdon != "0") {
                        webix.message("Hóa đơn không ở trạng thái rà soát không thể lập giải trình !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnSaveSignGiaiTrinh").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    // webix.$$("tctbao").setValue(2);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    this.hide();
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 2,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();

                    // var fn = Function("_", "user", item.on_click);
                    // fn(_, user);
                }
                if (record.id == "notifyErrorInvoice") {
                    var table = webix.$$("invoiceViews");
                    var datafrm = table.serialize();
                    var data = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i]);
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        var cungshd = true;
                        for (var k = 1; k <= data.length - 1; k++) {
                            if (data[k]["stbao"] !== data[0]["stbao"]) {
                                cungshd = false;
                                break;
                            }
                        }
                        if (cungshd === true) {
                            var loai = 1;
                            if (data[0]["stbao"] !== null) loai = 2;
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký") {
                                    webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                                    return;
                                }
                                if (data[i].ladhddt == undefined) {
                                    data[i].ladhddt = "1";
                                }
                                if (data[i].tctbao == undefined) {
                                    data[i].tctbao = "1";
                                }
                            }

                            var win = table.$scope.ui(huyhoadon.$ui);
                            huyhoadon.setEditMode(1);
                            webix.$$("btnHuyhoadon").destructor();
                            var tongquat = {
                                so: data[0].stbao,
                                ntbccqt: data[0].ntbao,
                                loai: loai,
                            };
                            huyhoadon.setValuesTongQuat(tongquat, null, null);
                            data.forEach(function (item) {
                                var put = {
                                    mcqtcap: item.mccqthue,
                                    khieu: item.khieu,
                                    shdon: item.shdon,
                                    ngay: item.nlap,
                                    ladhddt: item.ladhddt,
                                    tctbao: item.tctbao,
                                    hdon_id: item.id,
                                };
                                huyhoadon.setValues(put, null, null);
                                //this.hide();
                                win.show();
                            });
                        } else {
                            webix.message("Các hóa đơn chọn phải có số thông báo giống nhau", "error");
                        }
                    } else {
                        var item = table.getSelectedItem();

                        var loai = 1;
                        if (item["stbao"] !== null) loai = 2;

                        if (item == null) {
                            webix.message("Bạn chưa chọn hóa đơn", "error");
                            return;
                        }

                        if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                            webix.message("Hóa đơn chưa gửi không thể thông báo sai sót", "error");
                            return;
                        }

                        if (item.ladhddt == undefined) {
                            item["ladhddt"] = "1";
                        }
                        if (item.tctbao == undefined) {
                            item["tctbao"] = "1";
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();

                        var tongquat = {
                            so: item.stbao,
                            ntbccqt: item.ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);

                        var put = {
                            mcqtcap: item.mccqthue,
                            khieu: item.khieu,
                            shdon: item.shdon,
                            ngay: item.nlap,
                            ladhddt: item.ladhddt,
                            tctbao: item.tctbao,
                            hdon_id: item.id,
                        };
                        huyhoadon.setValues(put, null, null);

                        //this.hide();
                        win.show();
                    }

                    // var win = table.$scope.ui(huyhoadon.$ui);
                    // huyhoadon.setEditMode(1);
                    // webix.$$("btnHuyhoadon").destructor();

                    // webix.$$("btnSaveSignGiaiTrinh").show();
                    // webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("btnGhiHuyhoadon").destructor();
                    // webix.$$("btnGhiSignHuyHDDT").destructor();
                    // this.hide();
                    // win.show();
                }

                if (record.id == "replace_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 2;
                    item.tthdon_original = 2;
                    item.nky = "";
                    item.hdon_id = "";
                    item.mccqthue = "";
                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var tableDetail = webix.$$("hoadon68_chitiet");

                    tableDetail.clearAll();

                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "increase_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 19;
                    item.tthdon_original = 19;
                    item.nky = "";
                    item.hdon_id = "";
                    item.mccqthue = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "reduce_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 21;
                    item.tthdon_original = 21;
                    item.nky = "";
                    item.hdon_id = "";
                    item.note = "reduce_change_invoice";
                    item.mccqthue = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "info_change") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 23;
                    item.tthdon_original = 23;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.nky = "";
                    item.hdon_id = "";
                    item.mccqthue = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);

                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    /*tableDetail.getColumnConfig("sluong").editor = null;
                    tableDetail.getColumnConfig("thtien").editor = null;
                    tableDetail.getColumnConfig("tsuat").editor = null;
                    tableDetail.getColumnConfig("tgtien").editor = null;
                    tableDetail.getColumnConfig("tthue").editor = null;*/
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();
                }
            },
        },
    });

    webix.$$("title").parse({ title: "Lập hóa đơn -> Hóa đơn GTGT (Loại 1)", details: "Lập hóa đơn -> Hóa đơn GTGT (Loại 1)" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in chứng từ",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại hóa đơn gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Thêm (F4)") + "</span>",
            id: "btnPlus",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);

                    var cctbao_id = $$("kyhieu_id").getValue();
                    invoiceForms.initUINew(cctbao_id);
                    invoiceForms.setEditMode(1);
                    detailForm.show();
                    // if (vc_window.after_new != null) {
                    //     var fn = Function("app", vc_window.after_new);
                    //     fn(app);
                    // }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    //var detailForm = this.$scope.ui(webix.$$("main"));
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký") {
                        webix.message("Hóa đơn đã ký hoặc đã gửi lên cơ quan thuế, không thể sửa !", "error");
                        return;
                    }
                    // main.setEditMode(0);
                    // main.initUI(windowconfig);
                    item.nlap = new Date(item.nlap);
                    invoiceForms.setEditMode(2);
                    invoiceForms.setValues(item, null);

                    detailForm.show();
                    //main.focusFirstElement();
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Xóa (F8)") + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần xóa !", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký") {
                        webix.message("Không thể xóa hóa đơn đã ký,đã gửi !", "error");
                        return;
                    }

                    var khData = {};
                    // khData.windowid = windowconfig.data[0].window_id;
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);

                    webix.confirm({
                        title: "XÓA HÓA ĐƠN",
                        text: "Bạn có muốn xóa hóa đơn số: <span style='color: red'>" + item.shdon + "</span>",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/hoadonSaveChange", khData, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.ExceptionMessage, "error");
                                            app.callEvent("dataChangedInvoie68", [1, null]);
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            table.remove(item.id);
                                            table.enable();
                                            table.hideProgress();
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + "</span>",
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "far fa-files-o",
            // label: _("COPY"),
            // width: 85,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu");
                        return;
                    }
                    // var vc_window = windowconfig["data"][0];
                    // windowform.$ui.id = vc_window.code;
                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    item.mccqthue = "";
                    item.shdon = null;
                    invoiceForms.setEditMode(1);
                    invoiceForms.copyValues(item);
                    detailForm.show();
                    // windowform.focusFirstElement();
                    // if (vc_window.after_new != null) {
                    //     var fn = Function(vc_window.after_new);
                    //     fn();
                    // }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-evelop fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Email") + "</span>",
            id: "btnEmail",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể gửi email !", "error");
                        return;
                    }
                    if (item.mccqthue == "" || item.mccqthue == null) {
                        webix.message("Hóa đơn chưa có mã cơ quan thuế không thể gửi email !", "error");
                        return;
                    }

                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    // var box = webix.modalbox({
                    //     title: "Đang gửi email ....",
                    //     text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //     width: 350,
                    //     height: 200,
                    // });

                    // webix
                    //     .ajax()
                    //     .headers({ "Content-type": "application/json" })
                    //     .post(app.config.host + "/Invoice68/SendInvoiceByEmail", item, {
                    //         error: function (text, data, XmlHttpRequest) {
                    //             webix.modalbox.hide(box);
                    //             webix.message(XmlHttpRequest.statusText, "error");
                    //         },
                    //         success: function (text, data, XmlHttpRequest) {
                    //             webix.modalbox.hide(box);
                    //             var data = JSON.parse(text);

                    //             if (!data.hasOwnProperty("error")) {
                    //                 webix.message("Gửi Email thành công !", "debug");
                    //             } else {
                    //                 webix.message(data.error, "error");
                    //             }
                    //         },
                    //     });

                    require(["views/forms/sendemail", "app"], function (sendemail, app) {
                        var url = "/Invoice68/GetEmailTemplate?type=Gửi hóa đơn&id=" + item.hdon_id;
                        webix.ajax(app.config.host + url, function (text) {
                            var json = JSON.parse(text);
                            var win = webix.$$("invoiceViews").$scope.ui(sendemail.$ui);
                            var hoadon = {
                                nguoi_gui: json.sender,
                                tieude: json.subject,
                                noidung: json.body,
                                mat_khau: json.pass,
                                inv_invoiceauth_id: item.hdon_id,
                                id: item.hdon_id,
                                type: "Gửi hóa đơn",
                                nguoinhan: item.email,
                                his_email: json.his_email,
                                lst_email: json.lst_email,
                                hdon68: 1,
                                alias: json.alias,
                            };

                            //console.log(JSON.stringify(json.lst_email));
                            sendemail.setValues(hoadon);
                            win.show();
                        });
                    });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("Ký chờ xử lý") + "</span>",
            id: "btnKyCXL",
            click: function () {
                //check validate và return ra list hoadon_id
                var lsthdon_id = commonHD.validate_HD_ReturnListHdonId();
                if (lsthdon_id.length > 0) {
                    //call function excute hoa don
                    commonHD.ExcuteHoaDon(lsthdon_id, false, true);
                }
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("Ký và gửi CQT") + "</span>",
            id: "btnKyGuiCQT",
            click: function () {
                //check validate và return ra list hoadon_id
                var lsthdon_id = commonHD.validate_HD_ReturnListHdonId();
                if (lsthdon_id.length > 0) {
                    //call function excute hoa don
                    commonHD.ExcuteHoaDon(lsthdon_id, true, true);
                }
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Gửi CQT") + "</span>",
            id: "btnGuiCQT",
            click: function () {
                var tableHdon = webix.$$("invoiceViews");
                var datafrm = tableHdon.serialize();

                var data = [];
                if (datafrm.length > 0) {
                    for (var i = 0; i < datafrm.length; i++) {
                        if (datafrm[i] != undefined) {
                            if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                data.push(datafrm[i].hdon_id);
                            }
                        }
                    }
                }

                var postData = {
                    invs: data,
                    mltdiep: "200",
                };

                if (data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].tthai != null && data[i].tthai == "Đã gửi") {
                            webix.message("Hóa đơn đã gửi không thể gửi !", "error");
                            return;
                        }
                    }
                    webix.confirm({
                        text: "Bạn có muốn gửi hóa đơn tới CQT không?",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/SendInvoiceToCQT68", postData, function (text) {
                                        var res = JSON.parse(text);
                                        if (res.hasOwnProperty("error")) {
                                            webix.message({ type: "error", text: res.error });
                                        } else {
                                            webix.message("Gửi CQT thành công!");
                                            var table = $$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    });
                            }
                        },
                    });
                } else webix.message("Bạn chưa chọn hóa đơn!");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("Nghiệp vụ") + "</span>",
            id: "btnChucNang",
            // label: _("CHUC_NANG"),
            // view: "button",
            // type: "icon",
            // css: "webix_secondary",
            // icon: "fas fa-tasks",
            // width: 100,
            click: function () {
                subChucNang.show(webix.$$("btnChucNang").$view);
            },
        },
        // {
        //     view: "button", type: "htmlbutton", width: 115,
        //     label: '<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> ' +
        //     '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
        //     id: "btnExport",
        //     on: {
        //         onClick: function () {
        //             var box = webix.modalbox({
        //                 title: "Đang kết suất Excel ... ",
        //                 buttons: ["Hủy bỏ"],
        //                 text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        //                 width: 350,
        //                 height: 200,
        //                 callback: function (result) {
        //                     switch (result) {
        //                         case "0":
        //                             clearTimeout(interVal);
        //                             webix.modalbox.hide(box);
        //                             break;
        //                     }
        //                 }
        //             });
        //             var interVal = setTimeout(function () {
        //                 var table = $$("invoiceViews");
        //                 webix.toExcel(table, {
        //                     filename: "danh sach hoa don",
        //                     rawValues: true,
        //                     filterHTML: true
        //                 });
        //                 clearTimeout(interVal);
        //                 webix.modalbox.hide(box);
        //             }, 1500);

        //             // var rpParameter = table.config.rpParameter;
        //             // if (rpParameter == undefined || rpParameter == null) {
        //             //     webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
        //             //     return;
        //             // }
        //             // rpParameter.type = "xlsx";

        //             // if (rpParameter != null) {
        //             //     var box = webix.modalbox({
        //             //         title: "Đang kết xuất Excel ....",
        //             //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        //             //         width: 350,
        //             //         height: 200
        //             //     });

        //             //     webix.ajax()
        //             //         .response("arraybuffer")
        //             //         .headers({ 'Content-type': 'application/json' })
        //             //         .post(app.config.host + "/Bcthsd/PrintPDFBangKeBanRa", rpParameter,
        //             //         {
        //             //             error: function (text, data, XmlHttpRequest) {
        //             //                 webix.modalbox.hide(box);
        //             //                 webix.message(XmlHttpRequest.statusText, "error");
        //             //             },
        //             //             success: function (text, data, XmlHttpRequest) {
        //             //                 var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        //             //                 var fileURL = URL.createObjectURL(file);
        //             //                 webix.modalbox.hide(box);
        //             //                 window.location.href = fileURL;
        //             //             }
        //             //         }
        //             //         // function (text, data) {

        //             //         //     var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        //             //         //     var fileURL = URL.createObjectURL(file);

        //             //         //     window.location.href = fileURL;
        //             //         // }
        //             //         );
        //             // }
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }

        // },
        {},
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        //get count list combo ký hiệu
                        var countkyHieu = $$("kyhieu_id") != undefined ? $$("kyhieu_id").getPopup().getList().serialize().length : 0;
                        if (countkyHieu > 0) {
                            var url = app.config.host + "/Invoice68/GetDataInvoice";

                            if (params == null) {
                                url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                            } else {
                                url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                                if (params.filter != null) {
                                    var array = [];

                                    for (var property in params.filter) {
                                        var column = view.getColumnConfig(property);

                                        var item = {
                                            columnName: property,
                                            columnType: column.columnType,
                                            value: params.filter[property],
                                        };

                                        array.push(item);
                                    }

                                    //console.log(JSON.stringify(array));
                                    url = url + "&filter=" + JSON.stringify(array);
                                }
                            }
                            var tlbParams = $$("paramKH");

                            if (tlbParams !== undefined) {
                                var childViews = tlbParams.getChildViews();

                                var parameters = [];

                                for (var i = 0; i < childViews.length; i++) {
                                    var child = childViews[i];
                                    // console.log(child);
                                    var id = child.config.id;
                                    //var value_field = child.config.value_field;

                                    var item = {
                                        columnName: "cctbao_id",
                                        value: $$(id).getValue(),
                                    };
                                    if (item.value !== "") {
                                        parameters.push(item);
                                    } else {
                                        return;
                                    }
                                }
                                tlbparam_s = parameters;
                                url = url + "&tlbparam=" + JSON.stringify(parameters);
                            } else {
                                url = url + "&tlbparam=null";
                            }

                            var urlMiniDashBoard = url.replace("GetDataInvoice", "GetDataInvoiceThongTin");
                            webix.ajax().get(urlMiniDashBoard, function (text) {
                                var json = JSON.parse(text);
                                $$("choCapMa").setValue("<span style=' font-weight:bold'>Số hóa đơn chờ cấp mã: </span>" + json["chocapma"]);
                            });
                            webix.ajax().get(urlMiniDashBoard, function (text) {
                                var json = JSON.parse(text);
                                $$("choCapMaError").setValue("<span style=' font-weight:bold'>Số hóa đơn CQT không cấp mã: </span>" + json["chocapmaerror"]);
                            });
                            webix.ajax().get(urlMiniDashBoard, function (text) {
                                var json = JSON.parse(text);
                                $$("duocCapMa").setValue("<span style=' font-weight:bold'>Số hóa đơn được cấp mã: </span>" + json["duoccapma"]);
                            });
                            webix.ajax().get(urlMiniDashBoard, function (text) {
                                var json = JSON.parse(text);
                                $$("chuaGui").setValue("<span style=' font-weight:bold'>Số hóa đơn chưa ký gửi CQT: </span>" + json["chuagui"]);
                            });
                            webix.ajax().get(urlMiniDashBoard, function (text) {
                                var json = JSON.parse(text);
                                $$("doanhThu").setValue("<span style=' font-weight:bold'>Doanh thu xuất hóa đơn: </span>" + fm(json["doanhthu"]));
                            });
                            webix.ajax(url, callback, view);
                        }
                    },
                },
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    css: "subInvoice",
                    scrollX: true,
                    // tabbar: {
                    //     width: 200
                    // },
                    multiview: {
                        fitBiggest: true,
                    },
                    cells: [
                        {
                            header: "Chi tiết hóa đơn",
                            select: "cell",
                            body: {
                                view: "datatable",
                                resizeColumn: true,
                                margin: 10,
                                id: "hoadon68_chitiet_view",
                                height: 200,
                                columns: [
                                    { id: "stt", header: "", width: 30 },
                                    {
                                        id: "ma",
                                        header: _("Mã hàng hóa"),
                                        editor: "text",
                                        width: 100,
                                        editable: true,
                                    },
                                    {
                                        id: "ten",
                                        header: _("Tên hàng hóa"),
                                        editor: "text",
                                        width: 350,
                                        editable: true,
                                    },
                                    {
                                        id: "mdvtinh",
                                        header: _("ĐVT"),
                                        editor: "text",
                                        width: 80,
                                        editable: true,
                                    },
                                    {
                                        id: "sluong",
                                        header: _("Số lương"),
                                        editor: "autonumeric",
                                        width: 100,
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "dgia",
                                        header: _("Đơn giá"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "thtien",
                                        header: _("Tiền trước thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "tlckhau",
                                        header: _("% CK"),
                                        width: 80,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "stckhau",
                                        header: _("Tiền CK"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tsuat",
                                        header: _("Thuế suất"),
                                        width: 100,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tthue",
                                        header: _("Tiền thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tgtien",
                                        header: _("Tiền sau thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "khuyen_mai",
                                        header: _("Khuyến mại"),
                                        width: 100,
                                        editor: "checkbox",
                                        editable: true,
                                        template: "{common.checkbox()}",
                                        checkValue: true,
                                        uncheckValue: false,
                                    },
                                ],
                                on: {
                                    onBeforeLoad: function () {
                                        this.showOverlay(_("LOADING") + "...");
                                    },
                                    onAfterLoad: function () {
                                        this.hideOverlay();
                                    },
                                },
                            },
                        },
                    ],
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "stt",
                        header: ["<center>STT</center>"],
                        //header: "",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "ttthdon",
                        header: ["<center>Trạng thái</center>", { content: "textFilter" }],
                        template: "<span class='mcls_status#tthdon#'>#ttthdon#</span>",
                        // template: function (obj, common) {
                        //     console.log(obj.tthdon);
                        //     return "<span class='mcls_status " + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        // },
                        width: 150,
                        columnType: "nvarchar",
                    },
                    {
                        id: "tthai",
                        header: ["<center>Trạng thái gửi CQT</center>", { content: "textFilter" }],
                        width: 120,
                        columnType: "nvarchar",
                    },
                    {
                        id: "btnMessagetn",
                        header: ["<center>Lịch sử xử lý</center>"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                        },
                        width: 180,
                    },
                    {
                        id: "issendmail",
                        header: ["<center>Gửi Email</center>"],
                        css: { "text-align": "center" },
                        width: 120,
                        columnType: "nvarchar",
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.rcheckbox()}",
                    },
                    {
                        id: "error_status",
                        header: ["<center>Có lỗi/Không có lỗi</center>"],
                        css: { "text-align": "center" },
                        width: 120,
                        columnType: "nvarchar",
                        template: function (obj) {
                            if (obj.error_status == "1") {
                                return "<span style='color: #e83717'>Có lỗi</span> ";
                            } else {
                                return "";
                            }
                        },
                    },
                    {
                        id: "nlap",
                        header: ["<center>Ngày hóa đơn</center>", { content: "serverDateRangeFilter" }],
                        width: 120,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        // template: function (obj, common) {
                        //     if(obj.tthai!="Chờ ký"){
                        //         return obj.nlap="";
                        //     }
                        //     else{
                        //         var format = webix.Date.dateToStr("%d/%m/%Y");
                        //         var text = removeTimeZoneT(obj.nlap);
                        //         return format(text);
                        //     }
                        // },
                        columnType: "datetime",
                    },
                    {
                        id: "nky",
                        header: ["<center>Ngày ký</center>", { content: "serverDateRangeFilter" }],
                        width: 150,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        columnType: "datetime",
                    },
                    {
                        id: "khieu",
                        header: ["<center>Ký hiệu</center>", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        columnType: "nvarchar",
                    },
                    // {
                    //     id: "khieu", header: ["<center>Ký hiệu</center>", { content: "textFilter" }],
                    //     template: function (obj, common) {
                    //         return "<span class='mcls_status " + obj.className + "'>" + obj.ten_trang_thai + "</span>";
                    //     }, width: 100, columnType: "nvarchar"
                    // },
                    { id: "shdon", header: ["<center>Số hóa đơn</center>", { content: "textFilter" }], width: 100, columnType: "nvarchar", css: { "text-align": "center" } },

                    { id: "mst", header: ["<center>Mã số thuế</center>", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    { id: "mccqthue", header: ["<center>Mã CQT</center>", { content: "textFilter" }], width: 100, columnType: "nvarchar" },
                    // { id: "mtdiep_gui", header: ["<center>Mã thông điệp gửi đi</center>", { content: "textFilter" }], width: 350, columnType: "nvarchar" },
                    // { id: "mtdiep_cqt", header: ["<center>Mã thông điệp cơ quan thuế</center>", { content: "textFilter" }], width: 300, columnType: "nvarchar" },
                    { id: "ten", header: ["<center>Tên đơn vị/ Tên người mua</center>", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    {
                        id: "tgtttbso",
                        header: ["<center>Thành tiền sau thuế</center>", { content: "textFilter" }],
                        width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tgtttbso == null ? 0 : fm(obj.tgtttbso);
                        },
                        columnType: "decimal",
                    },
                    { id: "htttoan", header: ["<center>Hình thức TT</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar", css: { "text-align": "center" } },
                    // {
                    //     id: "tdlap",
                    //     header: ["<center>Thời điểm lập</center>", { content: "textFilter" }],
                    //     width: 200,
                    //     columnType: "nvarchar",
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    // },
                    {
                        id: "nglap",
                        header: ["<center>Người lập</center>", { content: "textFilter" }],
                        width: 200,
                        columnType: "nvarchar",
                    },
                    // { id: "ten_loai", header: ["<center>Tên loại HĐ</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                // cols: [
                // {
                //     view: "icon",
                //     icon: "fas fa-question-circle",
                //     id: "help_form_main",
                //     tooltip: _("HELPER"),
                //     css: "helper",
                //     hide: true,
                //     click: function () {
                //         webix.alert({
                //             title: "Thông báo !",
                //             text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                //             type: "alert-warning",
                //             callback: function (result) {},
                //         });
                //     },
                // },
                // {
                //     view: "combo",
                //     label: _("MENU_QUICK"),
                //     id: "QuickMenuMain",
                //     hide: true,
                //     options: {
                //         // view: "gridsuggest",
                //         // id: "grid_window",
                //         // template: "#name#",
                //         // body: {
                //         //     scroll: true,
                //         //     autoheight: false,
                //         //     columns: [
                //         //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                //         //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                //         //     ],
                //         //     url: app.config.host + "/System/GetQuickMenu"
                //         // },
                //         // on: {
                //         //     onValueSuggest: function (obj) {
                //         //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                //         //         window.location.hash = "!/app/" + start;
                //         //         $$("QuickMenu").setValue(null);
                //         //     }
                //         // }
                //     },
                //     on: {
                //         onChange: function (newv, oldv) {},
                //     },
                // },
                // {},
                // {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                //     },
                // ],
            },
        ],
    };

    var mini_dashboard = {
        type: "clean",
        borderless: true,
        cols: [
            {
                id: "choCapMa",
                name: "choCapMa",
                view: "label",
            },
            {
                id: "choCapMaError",
                name: "choCapMaError",
                view: "label",
            },
            {
                id: "duocCapMa",
                name: "duocCapMa",
                view: "label",
            },
            {
                id: "chuaGui",
                name: "chuaGui",
                view: "label",
            },
            {
                id: "doanhThu",
                name: "doanhThu",
                view: "label",
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    {
                        id: "kyhieu_id",
                        view: "combo",
                        width: 300,
                        label: _("Ký hiệu"),
                        options: {
                            body: {
                                //comboId: comp.id,
                                // isDefault: item.has_default,
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00058",
                                ready: function () {
                                    // if (this.config.isDefault == "C") {
                                    var count = this.count();

                                    if (count > 0) {
                                        var combo = webix.$$("kyhieu_id");
                                        combo.setValue(this.getFirstId());
                                    }
                                    // }
                                },
                            },
                        },
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                        on: {
                            onChange: function (newv, oldv) {
                                var table = $$("invoiceViews");
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                ],
            },
            {
                rows: [mini_dashboard],
            },
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");

                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
            // var table = $$("invoiceViews");
            // var url = {
            //     $proxy: true,
            //     load: function (view, callback, params) {
            //         console.log(view.config);
            //         console.log(callback);
            //         console.log(params);
            //         /*var windowno = app.path[1].params[0];
            //         var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

            //         if (params == null) {
            //             url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            //         }
            //         else {
            //             url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

            //             if (params.filter != null) {
            //                 var array = [];

            //                 for (var property in params.filter) {

            //                     var column = view.getColumnConfig(property);

            //                     if (column !== undefined) {
            //                         var item = {
            //                             columnName: property,
            //                             columnType: column.columnType,
            //                             value: params.filter[property]
            //                         };

            //                         array.push(item);
            //                     }
            //                 }

            //                 //console.log(JSON.stringify(array));
            //                 if (array.length > 0) {
            //                     url = url + "&filter=" + JSON.stringify(array);
            //                 }
            //                 else {
            //                     url = url + "&filter=null";
            //                 }

            //             }
            //             else {
            //                 url = url + "&filter=null";
            //             }
            //         }

            //         if (view.config.infoparam != null) {
            //             url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
            //         }
            //         else {
            //             url = url + "&infoparam=null";
            //         }

            //         var tlbParams = $$("tlbParams");

            //         if (tlbParams !== undefined) {
            //             var childViews = tlbParams.getChildViews();

            //             var parameters = [];

            //             for (var i = 0; i < childViews.length; i++) {
            //                 var child = childViews[i];

            //                 var id = child.config.id;
            //                 var value_field = child.config.value_field;

            //                 var item = {
            //                     columnName: value_field,
            //                     value: $$(id).getValue()
            //                 };

            //                 parameters.push(item);
            //             }

            //             url = url + "&tlbparam=" + JSON.stringify(parameters);

            //         }
            //         else {
            //             url = url + "&tlbparam=null";
            //         }*/

            //         //console.log(url);

            //         /* webix.ajax().bind(view)
            //             .get(url,function(text){
            //                 var json =JSON.parse(text);

            //                 this.clearAll();

            //                 if (!json.hasOwnProperty("error")){
            //                     this.parse(json.data,"json");
            //                 }
            //         }); */

            //         //webix.ajax(url, callback, view);

            //     }
            // };

            // table.define("url", url);
        },
    };
});

define('views/68_invoiceViews',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_huyhoadon", "views/forms/68_huyhoadon_1", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    invoiceForms,
    huyhoadon,
    huyhoadon_1,
    hoadonHistory,
    commonHD
) {
    

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            // {
            //     id: "huyhoadon",
            //     value: "Hủy hóa đơn",
            // },
            // {
            //     id: "huyhoadon2",
            //     value: "Hủy hóa đơn có tạo mới",
            // },
            // {
            //     id: "giaitrinh",
            //     value: "Giải trình",
            // },
            {
                id: "notifyErrorInvoice",
                value: "Thông báo HĐĐT có sai sót",
            },
            {
                id: "replace_invoice",
                value: "Thay thế",
            },
            {
                id: "increase_change_invoice",
                value: "Điều chỉnh tăng",
            },
            {
                id: "reduce_change_invoice",
                value: "Điều chỉnh giảm",
            },
            {
                id: "info_change",
                value: "Điều chỉnh thông tin",
            },
            {
                id: "dowloadXml",
                value: "Tải XML",
            },
            {
                id: "dowloadXmlMessageHD",
                value: "Tải XML thông điệp gửi HĐ",
            },
            {
                id: "nhanExcel",
                value: "Nhận Excel hàng loạt",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                if (record.id == "nhanExcel") {
                    var table = $$("invoiceViews");

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", { excel_id: "EX00010", filename: "Nhan hang loat hoa don 68 (GTGT).xlsx" });
                        webix.$$("uploader").hide();
                    });
                }
                // console.log(record);
                if (record.id == "huyhoadon") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Hóa đơn đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);

                    webix.$$("btnHuyhoadon").destructor();
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "huyhoadon2") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Hóa đơn đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnStep299").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    // webix.$$("btnStep299").define("hidden", false);
                    // webix.$$("btnStep2").show();
                    // webix.$$("btnStep299").hide();
                    // $$("btnHuyHDDT").addView({ view:"button",label: "Bước 2" }, 1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "dowloadXml") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlInvoice.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "dowloadXmlMessageHD") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Hóa đơn chưa được gửi tới CQT, không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLThongDiepHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlThongDiepHoaDon.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "giaitrinh") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon != "4" && item.tthdon != "0") {
                        webix.message("Hóa đơn không ở trạng thái rà soát không thể lập giải trình !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnSaveSignGiaiTrinh").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    // webix.$$("tctbao").setValue(2);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    this.hide();
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 2,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();

                    // var fn = Function("_", "user", item.on_click);
                    // fn(_, user);
                }
                if (record.id == "notifyErrorInvoice") {
                    var table = webix.$$("invoiceViews");
                    var datafrm = table.serialize();
                    var data = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i]);
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        var cungshd = true;
                        for (var k = 1; k <= data.length - 1; k++) {
                            if (data[k]["stbao"] !== data[0]["stbao"]) {
                                cungshd = false;
                                break;
                            }
                        }
                        if (cungshd === true) {
                            var loai = 1;
                            if (data[0]["stbao"] !== null) loai = 2;
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký" || data[i].tthai == "Đã ký") {
                                    webix.message("Hóa đơn chưa gửi không thể thông báo sai sót", "error");
                                    return;
                                }
                                if (data[i].ladhddt == undefined) {
                                    data[i].ladhddt = "1";
                                }
                                if (data[i].tctbao == undefined) {
                                    data[i].tctbao = "1";
                                }
                            }

                            var win = table.$scope.ui(huyhoadon.$ui);
                            huyhoadon.setEditMode(1);
                            webix.$$("btnHuyhoadon").destructor();
                            var tongquat = {
                                so: data[0].stbao,
                                ntbccqt: data[0].ntbao,
                                loai: loai,
                            };
                            huyhoadon.setValuesTongQuat(tongquat, null, null);
                            data.forEach(function (item) {
                                var put = {
                                    khieu: item.khieu,
                                    shdon: item.shdon,
                                    ngay: item.nlap,
                                    ladhddt: item.ladhddt,
                                    tctbao: item.tctbao,
                                    hdon_id: item.id,
                                };
                                huyhoadon.setValues(put, null, null);
                                //this.hide();
                                win.show();
                            });
                        } else {
                            webix.message("Các hóa đơn chọn phải có số thông báo giống nhau", "error");
                        }
                    } else {
                        var item = table.getSelectedItem();

                        var loai = 1;
                        if (item["stbao"] !== null) loai = 2;

                        if (item == null) {
                            webix.message("Bạn chưa chọn hóa đơn", "error");
                            return;
                        }

                        if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                            webix.message("Hóa đơn chưa gửi không thể thông báo sai sót", "error");
                            return;
                        }

                        if (item.ladhddt == undefined) {
                            item["ladhddt"] = "1";
                        }
                        if (item.tctbao == undefined) {
                            item["tctbao"] = "1";
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();

                        var tongquat = {
                            so: item.stbao,
                            ntbccqt: item.ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);

                        var put = {
                            khieu: item.khieu,
                            shdon: item.shdon,
                            ngay: item.nlap,
                            ladhddt: item.ladhddt,
                            tctbao: item.tctbao,
                            hdon_id: item.id,
                        };
                        huyhoadon.setValues(put, null, null);

                        //this.hide();
                        win.show();
                    }

                    // var win = table.$scope.ui(huyhoadon.$ui);
                    // huyhoadon.setEditMode(1);
                    // webix.$$("btnHuyhoadon").destructor();

                    // webix.$$("btnSaveSignGiaiTrinh").show();
                    // webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("btnGhiHuyhoadon").destructor();
                    // webix.$$("btnGhiSignHuyHDDT").destructor();
                    // this.hide();
                    // win.show();
                }
                if (record.id == "replace_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 2;
                    item.tthdon_original = 2;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var tableDetail = webix.$$("hoadon68_chitiet");

                    tableDetail.clearAll();
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "increase_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 19;
                    item.tthdon_original = 19;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    // var tableDetail = webix.$$("hoadon68_chitiet");
                    // tableDetail.clearAll();
                    // tableDetail.refresh();

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    /*tableDetail.getColumnConfig("sluong").editor = null;
                    tableDetail.getColumnConfig("thtien").editor = null;
                    tableDetail.getColumnConfig("tsuat").editor = null;
                    tableDetail.getColumnConfig("tgtien").editor = null;
                    tableDetail.getColumnConfig("tthue").editor = null;*/
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();

                    //detailForm.show();
                }
                if (record.id == "reduce_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 21;
                    item.tthdon_original = 21;
                    item.nky = "";
                    item.hdon_id = "";
                    item.note = "reduce_change_invoice";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);
                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "info_change") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 23;
                    item.tthdon_original = 23;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";

                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    // tableDetail.getColumnConfig("sluong").editor = null;
                    // tableDetail.getColumnConfig("thtien").editor = null;
                    // tableDetail.getColumnConfig("tsuat").editor = null;
                    // tableDetail.getColumnConfig("tgtien").editor = null;
                    // tableDetail.getColumnConfig("tthue").editor = null;
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();
                }
            },
        },
    });

    webix.$$("title").parse({ title: "Lập hóa đơn -> Hóa đơn giá trị gia tăng", details: "Lập hóa đơn -> Hóa đơn giá trị gia tăng" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in chứng từ",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại hóa đơn gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Thêm (F4)") + "</span>",
            id: "btnPlus",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);

                    var cctbao_id = $$("kyhieu_id").getValue();
                    invoiceForms.initUINew(cctbao_id);
                    invoiceForms.setEditMode(1);
                    detailForm.show();
                    // if (vc_window.after_new != null) {
                    //     var fn = Function("app", vc_window.after_new);
                    //     fn(app);
                    // }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    //var detailForm = this.$scope.ui(webix.$$("main"));
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký") {
                        webix.message("Hóa đơn đã ký hoặc đã gửi lên cơ quan thuế, không thể sửa !", "error");
                        return;
                    }
                    // main.setEditMode(0);
                    // main.initUI(windowconfig);

                    item.nlap = new Date(item.nlap);
                    invoiceForms.setEditMode(2);
                    invoiceForms.setValues(item, null);

                    detailForm.show();
                    //main.focusFirstElement();
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Xóa (F8)") + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần xóa !", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký") {
                        webix.message("Không thể xóa hóa đơn đã ký,đã gửi !", "error");
                        return;
                    }
                    var khData = {};
                    // khData.windowid = windowconfig.data[0].window_id;
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);

                    webix.confirm({
                        title: "XÓA HÓA ĐƠN",
                        text: "Bạn có muốn xóa hóa đơn số: <span style='color: red'>" + item.shdon + "</span>",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/hoadonSaveChange", khData, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.ExceptionMessage, "error");
                                            app.callEvent("dataChangedInvoie68", [1, null]);
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var result = JSON.parse(text);

                                            if (result.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: result.error });
                                                table.enable();
                                                table.hideProgress();
                                                return;
                                            } else {
                                                table.remove(item.id);
                                                table.enable();
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + "</span>",
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "far fa-files-o",
            // label: _("COPY"),
            // width: 85,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }
                    // var vc_window = windowconfig["data"][0];
                    // windowform.$ui.id = vc_window.code;
                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    item.shdon = null;
                    invoiceForms.setEditMode(1);
                    invoiceForms.copyValues(item);
                    detailForm.show();
                    // windowform.focusFirstElement();
                    // if (vc_window.after_new != null) {
                    //     var fn = Function(vc_window.after_new);
                    //     fn();
                    // }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("In chuyển đổi") + "</span>",
            id: "btnPrintConvert",
            hidden: true,
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-evelop fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Email") + "</span>",
            id: "btnEmail",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể gửi email !", "error");
                        return;
                    }
                    require(["views/forms/sendemail", "app"], function (sendemail, app) {
                        var url = "/Invoice68/GetEmailTemplate?type=Gửi hóa đơn&id=" + item.hdon_id;
                        webix.ajax(app.config.host + url, function (text) {
                            var json = JSON.parse(text);
                            var win = webix.$$("invoiceViews").$scope.ui(sendemail.$ui);
                            var hoadon = {
                                nguoi_gui: json.sender,
                                tieude: json.subject,
                                noidung: json.body,
                                mat_khau: json.pass,
                                inv_invoiceauth_id: item.hdon_id,
                                id: item.hdon_id,
                                type: "Gửi hóa đơn",
                                nguoinhan: item.email,
                                his_email: json.his_email,
                                lst_email: json.lst_email,
                                hdon68: 1,
                                alias: json.alias,
                            };

                            //console.log(JSON.stringify(json.lst_email));
                            sendemail.setValues(hoadon);
                            win.show();
                        });
                    });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký chờ xử lý") + "</span>",
            id: "btnKyCXL",
            click: function () {
                //check validate và return ra list hoadon_id
                var lsthdon_id = commonHD.validate_HD_ReturnListHdonId();
                if (lsthdon_id.length > 0) {
                    //call function excute hoa don
                    commonHD.ExcuteHoaDon(lsthdon_id, false);
                }
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký và gửi CQT") + "</span>",
            id: "btnKyGuiCQT",
            click: function () {
                //check validate và return ra list hoadon_id
                var lsthdon_id = commonHD.validate_HD_ReturnListHdonId();
                if (lsthdon_id.length > 0) {
                    //call function excute hoa don
                    commonHD.ExcuteHoaDon(lsthdon_id, true);
                }
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Gửi CQT") + "</span>",
            id: "btnGuiCQT",
            click: function () {
                var tableHdon = webix.$$("invoiceViews");
                var itemHdon = tableHdon.getSelectedItem();

                var datafrm = tableHdon.serialize();

                var data = [];

                if (datafrm.length > 0) {
                    for (var i = 0; i < datafrm.length; i++) {
                        if (datafrm[i] != undefined) {
                            if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                data.push(datafrm[i].hdon_id);
                            }
                        }
                    }
                }

                var postData = {
                    invs: data,
                    mltdiep: "203",
                };

                if (data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].tthai != null && data[i].tthai == "Đã gửi") {
                            webix.message("Hóa đơn đã gửi không thể gửi !", "error");
                            return;
                        }
                    }

                    webix.confirm({
                        text: "Bạn có muốn gửi hóa đơn tới CQT không?",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/SendInvoiceToCQT68", postData, function (text) {
                                        var res = JSON.parse(text);
                                        if (res.hasOwnProperty("error")) {
                                            webix.message({ type: "error", text: res.error });
                                        } else {
                                            webix.message("Gửi CQT thành công!");
                                            var table = $$("invoiceViews");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    });
                            }
                        },
                    });
                } else webix.message("Bạn chưa chọn hóa đơn!");
            },
        },

        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Nghiệp vụ") + "</span>",
            id: "btnChucNang",
            // label: _("CHUC_NANG"),
            // view: "button",
            // type: "icon",
            // css: "webix_secondary",
            // icon: "fas fa-tasks",
            // width: 100,
            click: function () {
                subChucNang.show(webix.$$("btnChucNang").$view);
            },
        },
        // {
        //     view: "button", type: "htmlbutton", width: 115,
        //     label: '<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> ' +
        //     '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
        //     id: "btnExport",
        //     on: {
        //         onClick: function () {
        //             var box = webix.modalbox({
        //                 title: "Đang kết suất Excel ... ",
        //                 buttons: ["Hủy bỏ"],
        //                 text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        //                 width: 350,
        //                 height: 200,
        //                 callback: function (result) {
        //                     switch (result) {
        //                         case "0":
        //                             clearTimeout(interVal);
        //                             webix.modalbox.hide(box);
        //                             break;
        //                     }
        //                 }
        //             });
        //             var interVal = setTimeout(function () {
        //                 var table = $$("invoiceViews");
        //                 webix.toExcel(table, {
        //                     filename: "danh sach hoa don",
        //                     rawValues: true,
        //                     filterHTML: true
        //                 });
        //                 clearTimeout(interVal);
        //                 webix.modalbox.hide(box);
        //             }, 1500);

        //             // var rpParameter = table.config.rpParameter;
        //             // if (rpParameter == undefined || rpParameter == null) {
        //             //     webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
        //             //     return;
        //             // }
        //             // rpParameter.type = "xlsx";

        //             // if (rpParameter != null) {
        //             //     var box = webix.modalbox({
        //             //         title: "Đang kết xuất Excel ....",
        //             //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        //             //         width: 350,
        //             //         height: 200
        //             //     });

        //             //     webix.ajax()
        //             //         .response("arraybuffer")
        //             //         .headers({ 'Content-type': 'application/json' })
        //             //         .post(app.config.host + "/Bcthsd/PrintPDFBangKeBanRa", rpParameter,
        //             //         {
        //             //             error: function (text, data, XmlHttpRequest) {
        //             //                 webix.modalbox.hide(box);
        //             //                 webix.message(XmlHttpRequest.statusText, "error");
        //             //             },
        //             //             success: function (text, data, XmlHttpRequest) {
        //             //                 var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        //             //                 var fileURL = URL.createObjectURL(file);
        //             //                 webix.modalbox.hide(box);
        //             //                 window.location.href = fileURL;
        //             //             }
        //             //         }
        //             //         // function (text, data) {

        //             //         //     var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        //             //         //     var fileURL = URL.createObjectURL(file);

        //             //         //     window.location.href = fileURL;
        //             //         // }
        //             //         );
        //             // }
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }

        // },
        {},
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        //get count list combo ký hiệu
                        var countkyHieu = $$("kyhieu_id") != undefined ? $$("kyhieu_id").getPopup().getList().serialize().length : 0;

                        if (countkyHieu > 0) {
                            var url = app.config.host + "/Invoice68/GetDataInvoice";

                            if (params == null) {
                                url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                            } else {
                                url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                                if (params.filter != null) {
                                    var array = [];

                                    for (var property in params.filter) {
                                        var column = view.getColumnConfig(property);
                                        var item = {
                                            columnName: property,
                                            columnType: column.columnType,
                                            value: params.filter[property],
                                        };

                                        array.push(item);
                                    }

                                    //console.log(JSON.stringify(array));
                                    url = url + "&filter=" + JSON.stringify(array);
                                }
                            }
                            var tlbParams = $$("paramKH");

                            if (tlbParams !== undefined) {
                                var childViews = tlbParams.getChildViews();

                                var parameters = [];

                                for (var i = 0; i < childViews.length; i++) {
                                    var child = childViews[i];
                                    // console.log(child);
                                    var id = child.config.id;
                                    //var value_field = child.config.value_field;
                                    var item = {
                                        columnName: "cctbao_id",
                                        value: $$(id).getValue(),
                                    };
                                    if (item.value !== "") {
                                        parameters.push(item);
                                    } else {
                                        return;
                                    }
                                    parameters.push(item);
                                }
                                tlbparam_s = parameters;
                                url = url + "&tlbparam=" + JSON.stringify(parameters);
                            } else {
                                url = url + "&tlbparam=null";
                            }

                            var urlMiniDashBoard = url.replace("GetDataInvoice", "GetDataInvoiceThongTin");

                            webix.ajax().get(urlMiniDashBoard, function (text) {
                                var json = JSON.parse(text);
                                $$("khongMa").setValue("<span style=' font-weight:bold'>Số hóa đơn đã gửi CQT: </span>" + json["khongma"]);
                            });
                            webix.ajax().get(urlMiniDashBoard, function (text) {
                                var json = JSON.parse(text);
                                $$("khongMaError").setValue("<span style=' font-weight:bold'>Số hóa đơn CQT thông báo lỗi: </span>" + json["khongmaerror"]);
                            });
                            webix.ajax().get(urlMiniDashBoard, function (text) {
                                var json = JSON.parse(text);
                                $$("doanhThuNoCode").setValue("<span style=' font-weight:bold'>Doanh thu xuất hóa đơn: </span>" + fm(json["doanhthunocode"]));
                            });

                            webix.ajax(url, callback, view);
                        }
                    },
                },
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    css: "subInvoice",
                    scrollX: true,
                    // tabbar: {
                    //     width: 200
                    // },
                    multiview: {
                        fitBiggest: true,
                    },
                    cells: [
                        {
                            header: "Chi tiết hóa đơn",
                            select: "cell",
                            body: {
                                view: "datatable",
                                resizeColumn: true,
                                margin: 10,
                                id: "hoadon68_chitiet_view",
                                height: 200,
                                columns: [
                                    { id: "stt", header: "", width: 30 },
                                    {
                                        id: "ma",
                                        header: _("Mã hàng hóa"),
                                        editor: "text",
                                        width: 100,
                                        editable: true,
                                    },
                                    {
                                        id: "ten",
                                        header: _("Tên hàng hóa"),
                                        editor: "text",
                                        width: 350,
                                        editable: true,
                                    },
                                    {
                                        id: "mdvtinh",
                                        header: _("ĐVT"),
                                        editor: "text",
                                        width: 80,
                                        editable: true,
                                    },
                                    {
                                        id: "sluong",
                                        header: _("Số lương"),
                                        editor: "autonumeric",
                                        width: 100,
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "dgia",
                                        header: _("Đơn giá"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "thtien",
                                        header: _("Tiền trước thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "tlckhau",
                                        header: _("% CK"),
                                        width: 80,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "stckhau",
                                        header: _("Tiền CK"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tsuat",
                                        header: _("Thuế suất"),
                                        width: 100,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tthue",
                                        header: _("Tiền thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tgtien",
                                        header: _("Tiền sau thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "khuyen_mai",
                                        header: _("Khuyến mại"),
                                        width: 100,
                                        editor: "checkbox",
                                        editable: true,
                                        template: "{common.checkbox()}",
                                        checkValue: true,
                                        uncheckValue: false,
                                    },
                                ],
                                on: {
                                    onBeforeLoad: function () {
                                        this.showOverlay(_("LOADING") + "...");
                                    },
                                    onAfterLoad: function () {
                                        this.hideOverlay();
                                    },
                                },
                            },
                        },
                    ],
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "stt",
                        header: ["<center>STT</center>"],
                        //header: "",
                        sort: "int",
                        width: 40,
                        columnType: "nvarchar",
                        //css: { "line-height": "20px !important", "height": "63px !important"}
                    },
                    {
                        id: "ttthdon",
                        header: ["<center>Trạng thái</center>", { content: "textFilter" }],
                        template: "<span class='mcls_status#tthdon#'>#ttthdon#</span>",
                        // template: function (obj, common) {
                        //     console.log(obj.tthdon);
                        //     return "<span class='mcls_status " + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        // },
                        width: 150,
                        columnType: "nvarchar",
                    },
                    {
                        id: "tthai",
                        header: ["<center>Trạng thái gửi CQT</center>", { content: "textFilter" }],
                        width: 120,
                        columnType: "nvarchar",
                    },

                    {
                        id: "btnMessagetn",
                        header: ["<center>Lịch sử xử lý</center>"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                        },
                        width: 180,
                    },
                    {
                        id: "issendmail",
                        header: ["<center>Gửi Email</center>"],
                        css: { "text-align": "center" },
                        width: 120,
                        columnType: "nvarchar",
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.rcheckbox()}",
                    },
                    {
                        id: "error_status",
                        header: ["<center>Có lỗi/Không có lỗi</center>"],
                        css: { "text-align": "center" },
                        width: 120,
                        columnType: "nvarchar",
                        template: function (obj) {
                            if (obj.error_status == "1") {
                                return "<span style='color: #e83717'>Có lỗi</span> ";
                            } else {
                                return "";
                            }
                        },
                    },
                    {
                        id: "nlap",
                        header: ["<center>Ngày hóa đơn</center>", { content: "serverDateRangeFilter" }],
                        width: 120,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        // template: function (obj, common) {
                        //     if(obj.tthai!="Chờ ký"){
                        //         return obj.nlap="";
                        //     }
                        //     else{
                        //         var format = webix.Date.dateToStr("%d/%m/%Y");
                        //         var text = removeTimeZoneT(obj.nlap);
                        //         return format(text);
                        //     }
                        // },
                        columnType: "datetime",
                    },
                    {
                        id: "nky",
                        header: ["<center>Ngày ký</center>", { content: "serverDateRangeFilter" }],
                        width: 150,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        columnType: "datetime",
                    },
                    {
                        id: "khieu",
                        header: ["<center>Ký hiệu</center>", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        columnType: "nvarchar",
                    },
                    // {
                    //     id: "khieu", header: ["<center>Ký hiệu</center>", { content: "textFilter" }],
                    //     template: function (obj, common) {
                    //         return "<span class='mcls_status " + obj.className + "'>" + obj.ten_trang_thai + "</span>";
                    //     }, width: 100, columnType: "nvarchar"
                    // },
                    { id: "shdon", header: ["<center>Số hóa đơn</center>", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },

                    { id: "mst", header: ["<center>Mã số thuế</center>", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    // { id: "mtdiep_gui", header: ["<center>Mã thông điệp gửi đi</center>", { content: "textFilter" }], width: 350, columnType: "nvarchar" },
                    // { id: "mtdiep_cqt", header: ["<center>Mã thông điệp cơ quan thuế</center>", { content: "textFilter" }], width: 300, columnType: "nvarchar" },
                    { id: "ten", header: ["<center>Tên đơn vị/ Tên người mua</center>", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    {
                        id: "tgtttbso",
                        header: ["<center>Thành tiền sau thuế</center>", { content: "textFilter" }],
                        width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tgtttbso == null ? 0 : fm(obj.tgtttbso);
                        },
                        columnType: "numeric",
                    },
                    { id: "htttoan", header: ["<center>Hình thức TT</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar", css: { "text-align": "center" } },
                    // {
                    //     id: "tdlap",
                    //     header: ["<center>Thời điểm lập</center>", { content: "textFilter" }],
                    //     width: 200,
                    //     columnType: "nvarchar",
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    // },
                    {
                        id: "nglap",
                        header: ["<center>Người lập</center>", { content: "textFilter" }],
                        width: 200,
                        columnType: "nvarchar",
                    },
                    // { id: "ten_loai", header: ["<center>Tên loại HĐ</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                // cols: [
                // {
                //     view: "icon",
                //     icon: "fas fa-question-circle",
                //     id: "help_form_main",
                //     tooltip: _("HELPER"),
                //     css: "helper",
                //     click: function () {
                //         webix.alert({
                //             title: "Thông báo !",
                //             text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                //             type: "alert-warning",
                //             callback: function (result) {},
                //         });
                //     },
                // },
                // {
                //     view: "combo",
                //     label: _("MENU_QUICK"),
                //     id: "QuickMenuMain",
                //     hide: true,
                //     options: {
                //         // view: "gridsuggest",
                //         // id: "grid_window",
                //         // template: "#name#",
                //         // body: {
                //         //     scroll: true,
                //         //     autoheight: false,
                //         //     columns: [
                //         //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                //         //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                //         //     ],
                //         //     url: app.config.host + "/System/GetQuickMenu"
                //         // },
                //         // on: {
                //         //     onValueSuggest: function (obj) {
                //         //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                //         //         window.location.hash = "!/app/" + start;
                //         //         $$("QuickMenu").setValue(null);
                //         //     }
                //         // }
                //     },
                //     on: {
                //         onChange: function (newv, oldv) {},
                //     },
                // },
                // {},
                // {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                // },
                // ],
            },
        ],
    };

    var mini_dashboard = {
        type: "clean",
        borderless: true,
        cols: [
            {
                id: "khongMa",
                name: "khongMa",
                view: "label",
            },
            {
                id: "khongMaError",
                name: "khongMaError",
                css: "",
                view: "label",
            },
            {
                id: "doanhThuNoCode",
                name: "doanhThuNoCode",
                view: "label",
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    {
                        id: "kyhieu_id",
                        view: "combo",
                        width: 300,
                        label: _("Ký hiệu"),
                        options: {
                            body: {
                                //comboId: comp.id,
                                // isDefault: item.has_default,
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00054",
                                ready: function () {
                                    // if (this.config.isDefault == "C") {
                                    var count = this.count();

                                    if (count > 0) {
                                        var combo = webix.$$("kyhieu_id");
                                        combo.setValue(this.getFirstId());
                                    }
                                    // }
                                },
                            },
                        },
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                        on: {
                            onChange: function (newv, oldv) {
                                var table = $$("invoiceViews");
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                ],
            },
            {
                rows: [mini_dashboard],
            },
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
            // var table = $$("invoiceViews");
            // var url = {
            //     $proxy: true,
            //     load: function (view, callback, params) {
            //         console.log(view.config);
            //         console.log(callback);
            //         console.log(params);
            //         /*var windowno = app.path[1].params[0];
            //         var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

            //         if (params == null) {
            //             url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            //         }
            //         else {
            //             url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

            //             if (params.filter != null) {
            //                 var array = [];

            //                 for (var property in params.filter) {

            //                     var column = view.getColumnConfig(property);

            //                     if (column !== undefined) {
            //                         var item = {
            //                             columnName: property,
            //                             columnType: column.columnType,
            //                             value: params.filter[property]
            //                         };

            //                         array.push(item);
            //                     }
            //                 }

            //                 //console.log(JSON.stringify(array));
            //                 if (array.length > 0) {
            //                     url = url + "&filter=" + JSON.stringify(array);
            //                 }
            //                 else {
            //                     url = url + "&filter=null";
            //                 }

            //             }
            //             else {
            //                 url = url + "&filter=null";
            //             }
            //         }

            //         if (view.config.infoparam != null) {
            //             url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
            //         }
            //         else {
            //             url = url + "&infoparam=null";
            //         }

            //         var tlbParams = $$("tlbParams");

            //         if (tlbParams !== undefined) {
            //             var childViews = tlbParams.getChildViews();

            //             var parameters = [];

            //             for (var i = 0; i < childViews.length; i++) {
            //                 var child = childViews[i];

            //                 var id = child.config.id;
            //                 var value_field = child.config.value_field;

            //                 var item = {
            //                     columnName: value_field,
            //                     value: $$(id).getValue()
            //                 };

            //                 parameters.push(item);
            //             }

            //             url = url + "&tlbparam=" + JSON.stringify(parameters);

            //         }
            //         else {
            //             url = url + "&tlbparam=null";
            //         }*/

            //         //console.log(url);

            //         /* webix.ajax().bind(view)
            //             .get(url,function(text){
            //                 var json =JSON.parse(text);

            //                 this.clearAll();

            //                 if (!json.hasOwnProperty("error")){
            //                     this.parse(json.data,"json");
            //                 }
            //         }); */

            //         //webix.ajax(url, callback, view);

            //     }
            // };

            // table.define("url", url);
        },
    };
});

define('views/forms/68_kyhieuForm_bienlai',["app", "models/user"], function (app, user) {
    var editmode = 0;
    var param;
    var dt = new Date();
    var yearlast = dt.getFullYear().toString().substring(2, 4);
    // 20 chữ cái được phép dùng cho 2 ký tự cuối ký hiệu biên lai
    var allowedLetters = "ABCDEGHKLMNPQRSTUVXY";

    function syncKhhdon() {
        var kh2 = $$("kh2") ? ($$("kh2").getValue() || "") : yearlast;
        kh2 = String(kh2).replace(/[^0-9]/g, "").substring(0, 2);
        var kh4 = $$("kh4") ? ($$("kh4").getValue() || "") : "";
        kh4 = String(kh4).toUpperCase().replace(/[^A-Z]/g, "").substring(0, 2);
        var res = kh2 + "T" + kh4;
        if ($$("khhdon")) {
            $$("khhdon").setValue(res);
            $$("khhdon").refresh();
        }
        return res;
    }

    function isValidKh4(val) {
        if (!val || String(val).length !== 2) {
            return false;
        }
        var v = String(val).toUpperCase();
        return allowedLetters.indexOf(v[0]) >= 0 && allowedLetters.indexOf(v[1]) >= 0;
    }

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        syncKhhdon();
                        var item = $$("kyhieu-form").getValues();
                        var table = $$("kyhieu-form");
                        var kh4 = $$("kh4").getValue();

                        if (table.validate() && isValidKh4(kh4)) {
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            item.editmode = editmode;
                            item.code = param.code;
                            item.loaikh = 2;
                            item.khhdon = syncKhhdon();
                            item.khmbl = $$("khmbl").getValue();
                            item.htbl = "T";

                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .post(app.config.host + "/Invoice68/quanlykyhieu68", item, {
                                    error: function (text, data, XmlHttpRequest) {
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        webix.message(text + XmlHttpRequest, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text);
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            $$("kyhieu-win").close();
                                            var table = $$("kyhieu");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    },
                                });
                        } else {
                            if (!isValidKh4(kh4)) {
                                webix.message(
                                    "2 ký tự cuối ký hiệu chỉ được dùng: A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y",
                                    "error"
                                );
                            } else {
                                webix.message("Dữ liệu nhập sai định dạng", "error");
                            }
                        }
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("kyhieu-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "kyhieu-win",
        position: "center",
        head: "Đăng ký ký hiệu biên lai",
        on: {
            onBeforeShow: function () {
                if (editmode == 1) {
                    yearlast = new Date().getFullYear().toString().substring(2, 4);
                    $$("loaibl").setValue("01");
                    $$("khmbl").setValue("EBL01");
                    $$("htbl").setValue("T");
                    $$("kh2").setValue(yearlast);
                    $$("kh3").setValue("T");
                    $$("kh4").setValue("AA");
                    syncKhhdon();
                }
            },
        },
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "kyhieu-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    view: "combo",
                    name: "loaibl",
                    label: "Loại biên lai",
                    id: "loaibl",
                    required: true,
                    labelWidth: 120,
                    value: "01",
                    invalidMessage: "Loại biên lai không được bỏ trống !",
                    options: [
                        { id: "01", value: "Biên lai thu phí, lệ phí không có mệnh giá" },
                        { id: "02", value: "Biên lai thu phí, lệ phí có mệnh giá" },
                    ],
                    on: {
                        onChange: function (newv, oldv) {
                            // Ký hiệu mẫu: EBL + 01/02
                            if (newv) {
                                $$("khmbl").setValue("EBL" + newv);
                                $$("khmbl").refresh();
                            }
                        },
                    },
                },
                {
                    view: "text",
                    label: "Ký hiệu mẫu",
                    name: "khmbl",
                    id: "khmbl",
                    labelWidth: 120,
                    required: true,
                    readonly: true,
                    css: "mcls_readonly_text",
                    value: "EBL01",
                    invalidMessage: "Không được bỏ trống",
                },
                {
                    view: "combo",
                    label: "Hình thức biên lai",
                    name: "htbl",
                    id: "htbl",
                    required: true,
                    invalidMessage: "Không được bỏ trống",
                    labelWidth: 120,
                    value: "T",
                    options: [{ id: "T", value: "Biên lai điện tử" }],
                    on: {
                        onChange: function (newv, oldv) {
                            $$("kh3").setValue(newv || "T");
                            $$("kh3").refresh();
                            syncKhhdon();
                        },
                    },
                },
                {
                    rows: [
                        {
                            cols: [
                                {
                                    view: "label",
                                    label: "Ký hiệu *",
                                    width: 120,
                                },
                                {
                                    // 2 số năm — cho phép nhập
                                    view: "text",
                                    id: "kh2",
                                    name: "kh2",
                                    width: 40,
                                    value: yearlast,
                                    attributes: { maxlength: 2, type: "number" },
                                    invalidMessage: "Năm phải gồm 2 chữ số",
                                    validate: function (val) {
                                        return /^\d{2}$/.test(val || "");
                                    },
                                    on: {
                                        onChange: function (newv, oldv) {
                                            if (newv == null || newv == undefined) {
                                                return;
                                            }
                                            var val = String(newv).replace(/[^0-9]/g, "").substring(0, 2);
                                            if (val !== newv) {
                                                this.blockEvent();
                                                this.setValue(val);
                                                this.unblockEvent();
                                            }
                                            syncKhhdon();
                                        },
                                    },
                                },
                                {
                                    // chữ T - biên lai điện tử (readonly)
                                    view: "text",
                                    id: "kh3",
                                    name: "kh3",
                                    width: 30,
                                    readonly: true,
                                    css: "mcls_readonly_text",
                                    value: "T",
                                    attributes: { maxlength: 1 },
                                },
                                {
                                    // 2 chữ cái ĐV tự đặt
                                    view: "text",
                                    id: "kh4",
                                    name: "kh4",
                                    width: 50,
                                    value: "AA",
                                    css: "mcls_uppercase",
                                    attributes: { maxlength: 2 },
                                    invalidMessage: "2 ký tự cuối không hợp lệ",
                                    validate: function (val) {
                                        return isValidKh4(val);
                                    },
                                    on: {
                                        onChange: function (newv, oldv) {
                                            if (newv == null || newv == undefined) {
                                                return;
                                            }
                                            var val = String(newv)
                                                .toUpperCase()
                                                .replace(/[^A-Z]/g, "")
                                                .substring(0, 2);
                                            // chỉ giữ chữ cái trong danh sách cho phép
                                            var filtered = "";
                                            for (var i = 0; i < val.length; i++) {
                                                if (allowedLetters.indexOf(val[i]) >= 0) {
                                                    filtered += val[i];
                                                }
                                            }
                                            if (filtered !== newv) {
                                                this.blockEvent();
                                                this.setValue(filtered);
                                                this.unblockEvent();
                                            }
                                            syncKhhdon();
                                        },
                                    },
                                },
                                {
                                    // giá trị đầy đủ: yyTxx (vd: 26TAA)
                                    view: "text",
                                    name: "khhdon",
                                    id: "khhdon",
                                    readonly: true,
                                    css: "mcls_readonly_text",
                                    width: 200,
                                    required: true,
                                    value: yearlast + "TAA",
                                    invalidMessage: "Ký hiệu không được bỏ trống",
                                    attributes: { maxlength: 5 },
                                    validate: function (val) {
                                        return new RegExp("^\\d{2}T[" + allowedLetters + "]{2}$").test(
                                            (val || "").toUpperCase()
                                        );
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    id: "sdmau",
                    name: "sdmau",
                    label: "Số dòng in mẫu",
                    labelWidth: 120,
                    view: "text",
                    value: 1,
                    validate: function (val) {
                        return !isNaN(val * 1) && val * 1 >= 0;
                    },
                    invalidMessage: "Phải nhập số dương",
                    attributes: { type: "number" },
                },
                {
                    view: "combo",
                    label: "Mẫu thiết kế",
                    name: "qlmtke_id",
                    id: "qlmtke_id",
                    labelWidth: 120,
                    required: true,
                    invalidMessage: "Mẫu không được bỏ trống",
                    options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF02005",
                    on: {
                        onChange: function (newv, oldv) {},
                    },
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {
            $$("kyhieu-form").setValues(item);

            var khm = $$("khmbl").getValue() || "";
            if (khm.length >= 5) {
                $$("loaibl").setValue(khm.substring(3, 5));
            }

            var khhd = ($$("khhdon").getValue() || "").toUpperCase();
            // Format mới: 26TAA (5 ký tự)
            if (khhd.length === 5) {
                yearlast = khhd.substring(0, 2);
                $$("kh2").setValue(khhd.substring(0, 2));
                $$("kh3").setValue(khhd.substring(2, 3));
                $$("kh4").setValue(khhd.substring(3, 5));
            } else if (khhd.length >= 3) {
                // tương thích dữ liệu cũ
                yearlast = khhd.substring(0, 2);
                $$("kh2").setValue(khhd.substring(0, 2));
                $$("kh3").setValue(khhd.substring(2, 3) || "T");
                $$("kh4").setValue(khhd.substring(3, 5) || "");
            }
            syncKhhdon();
        },
    };
});

define('views/68_kyhieu_bienlai',["app", "locale", "models/user", "views/forms/68_kyhieuForm_bienlai"], function (app, _, user, kyhieuForm) {
    

    var initUI = function () {
        // var windowno = app.path[1].params[0];
        var table = webix.$$("kyhieu");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var tlbparam_s = [];
                var url = app.config.host + "/Invoice68/GetDataquanlykyhieu68bienlai";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var tlbParams = $$("paramDonvi");

                if (tlbParams !== undefined) {
                    var childViews = tlbParams.getChildViews();
                    var parameters = [];

                    for (var i = 0; i < childViews.length; i++) {
                        var child = childViews[i];
                        // console.log(child);
                        var id = child.config.id;
                        //var value_field = child.config.value_field;

                        var item = {
                            columnName: "code",
                            value: $$(id).getValue(),
                        };
                        parameters.push(item);
                    }

                    tlbparam_s = parameters;
                    url = url + "&tlbparam=" + JSON.stringify(parameters);
                } else {
                    url = url + "&tlbparam=null";
                }
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var submenuChucNang = webix.ui({
        id: "submnchucnang",
        view: "submenu",
        width: 250,
        padding: 0,
        data: [
            {
                id: "UploadTemplate",
                value: "Tải mẫu lên",
            },
            {
                id: "SignTemplate",
                value: "Ký mẫu biên lai",
            },
            {
                id: "PreviewTemplate",
                value: "Xem mẫu biên lai (PDF)",
            },
            {
                id: "DownloadTemplate",
                value: "Tải mẫu thiết kế (.repx)",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                this.hide();
                var selectedItem = webix.$$("congvieckinhdoanh").getSelectedItem();
                if (selectedselectedItem == null) {
                    webix.message("Bạn chưa chọn khách hàng !", "error");
                    return;
                }
            },
        },
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);
                    kyhieuForm.setEditMode(1);
                    var params = null;

                    var tlbParams = $$("paramDonvi");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];
                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item[id] = $$(id).getValue();
                        }

                        params = item;
                    }
                    kyhieuForm.initUI(params);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn khách hàng ! ", "error");
                        return;
                    }
                    if (selectedItem.tt_sd > 0) {
                        webix.message("Ký hiệu đã sử dụng không thể sửa ! ", "error");
                        return;
                    }
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);

                    var params = null;

                    var tlbParams = $$("paramDonvi");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];
                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item[id] = $$(id).getValue();
                        }

                        params = item;
                    }
                    kyhieuForm.initUI(params);

                    kyhieuForm.setEditMode(2);
                    kyhieuForm.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn ký hiệu biên lai cần xóa ! ", "error");
                        return;
                    }
                    if (selectedItem.tt_sd > 0) {
                        webix.message("Ký hiệu đã sử dụng không thể xóa ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/deletequanlykyhieu68", selectedItem, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var res = JSON.parse(text);
                                            if (res.hasOwnProperty("error")) {
                                                webix.message(res.error, "error");
                                            } else {
                                                table.remove(selectedItem.id);
                                                table.enable();
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + " (F7)" + "</span>",
            id: "btnPrint",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inMauHoadon?id=" + item.id, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     id: "btnChucNang",
        //     view: "button",
        //     type: "icon",
        //     icon: "fa fa-cube",
        //     label: "Chức năng",
        //     width: 100,
        //     css: "button_raised",
        //     click: function () {
        //         submenuChucNang.show(webix.$$("btnChucNang").$view);
        //     },
        // },
        // {
        //     view: "button",
        //     id: "btnRegister",
        //     type: "icon",
        //     icon: "plus",
        //     label: "Đăng ký",
        //     width: 100,
        //     shortcut: "F1",
        //     on: {
        //         onClick: function () {
        //             var detailForm = this.$scope.ui(dangkyform.$ui);
        //             dangkyform.setEditMode(0);
        //             detailForm.show();
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "kyhieu",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.ngayLap) {
                        //     obj.ngayLap = new Date(obj.ngayLap);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "kyhieu_id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "index",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "tmau",
                        header: [
                            "Tên mẫu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "khmbl",
                        header: [
                            "Ký hiệu mẫu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "khhdon",
                        header: [
                            "Ký hiệu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    // {
                    //     id: "trangThai",
                    //     header: [
                    //         "Số dòng in mẫu",
                    //         {
                    //             content: "textFilter",
                    //         },
                    //     ],
                    //     width: 120,
                    //     template: function (obj) {
                    //         return (
                    //             "<span class='tt_kyhieu_status" +
                    //             obj.trangThai +
                    //             "'>" +
                    //             obj.trangThai +
                    //             "</span>"
                    //         );
                    //     }
                    // },
                    {
                        id: "nlap",
                        header: [
                            "Ngày lập",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        columnType: "datetime",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "nglap",
                        header: [
                            "Người lập",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "tt_sdung",
                        header: ["Sử dụng"],
                        editor: "checkbox",
                        width: 90,
                        template: function (obj) {
                            var checked = obj.tt_sd > 0 ? 'checked="true"' : "";
                            return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                        },
                        css: {
                            "text-align": "center",
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                id: "paramDonvi",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    {
                        id: "code",
                        view: "combo",
                        width: 500,
                        label: _("Đơn vị"),
                        options: {
                            body: {
                                //comboId: comp.id,
                                // isDefault: item.has_default,
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195",
                                ready: function () {
                                    // if (this.config.isDefault == "C") {
                                    var count = this.count();

                                    if (count > 0) {
                                        var combo = webix.$$("code");
                                        combo.setValue(this.getFirstId());
                                    }
                                    // }
                                },
                            },
                        },
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                        on: {
                            onChange: function (newv, oldv) {
                                var table = $$("kyhieu");
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                ],
            },
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("kyhieu");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({
                title: "Quản lý ký hiệu biên lai sử dụng",
                details: "Quản lý ký hiệu biên lai sử dụng",
            });
            var table = webix.$$("kyhieu");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangedKyhieu68", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_kyhieu_donvi',["app", "locale", "models/user"], function (app, _, user) {
    var editmode = 0;
    var param;
    var branh_code;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var item = $$("kyhieu-form").getValues();
                        var table = $$("kyhieu-form");

                        if (table.validate()) {
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();
                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .post(app.config.host + "/Invoice68/kihieudonvi68", item, {
                                    error: function (text, data, XmlHttpRequest) {
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        // var json = JSON.parse(text);
                                        // webix.message(json.ExceptionMessage, "error");
                                        webix.message(text + XmlHttpRequest, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text);
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            $$("kyhieu-win").close();
                                            var table = $$("kyhieu_hoadon");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    },
                                });
                        }
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("kyhieu-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "kyhieu-win",
        position: "center",
        head: "Đăng ký ký hiệu",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "kyhieu-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    view: "combo",
                    name: "phanhoadon_78_id",
                    label: "Ký hiệu",
                    //labelPosition: "top",
                    id: "phanhoadon_78_id",
                    required: true,
                    labelWidth: 120,
                    invalidMessage: "Ký hiệu không được bỏ trống",
                    css: "mcls_uppercase",
                    options: {
                        url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00230",
                    },on: {
                        onChange: function (newv, oldv) {
                            var test = newv;
                        },
                    },
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {
            $$("kyhieu-form").setValues(item);
        },
    };
});

define('views/68_kyhieu_donvi_bienlai',["app", "locale", "models/user", "views/forms/68_kyhieu_donvi"], function (app, _, user, kyhieuForm) {
    

    webix.$$("title").parse({
        title: "Phân ký kiệu hoá đơn cho đơn vị",
        details: "Phân ký kiệu hoá đơn cho đơn vị",
    });

    var initUI = function () {
        // var windowno = app.path[1].params[0];
        var table = webix.$$("kyhieu_hoadon");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var tlbparam_s = [];
                var url = app.config.host + "/Invoice68/GetKyHieuDonVi68";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var tlbParams = $$("paramDonvi");

                if (tlbParams !== undefined) {
                    var childViews = tlbParams.getChildViews();
                    var parameters = [];

                    for (var i = 0; i < childViews.length; i++) {
                        var child = childViews[i];
                        // console.log(child);
                        var id = child.config.id;
                        //var value_field = child.config.value_field;

                        var item = {
                            columnName: id,
                            value: $$(id).getValue(),
                        };
                        parameters.push(item);
                    }
                    tlbparam_s = parameters;
                    url = url + "&tlbparam=" + JSON.stringify(parameters);
                } else {
                    url = url + "&tlbparam=null";
                }
                webix.ajax(url+ "&loaikh=2", callback, view);
            },
        };
        table.define("url", url);
    };

    var submenuChucNang = webix.ui({
        id: "submnchucnang",
        view: "submenu",
        width: 250,
        padding: 0,
        data: [
            {
                id: "UploadTemplate",
                value: "Tải mẫu lên",
            },
            {
                id: "SignTemplate",
                value: "Ký mẫu hóa đơn",
            },
            {
                id: "PreviewTemplate",
                value: "Xem mẫu hóa đơn (PDF)",
            },
            {
                id: "DownloadTemplate",
                value: "Tải mẫu thiết kế (.repx)",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                this.hide();
                var selectedItem = webix.$$("congvieckinhdoanh").getSelectedItem();
                if (selectedselectedItem == null) {
                    webix.message("Bạn chưa chọn khách hàng !", "error");
                    return;
                }
            },
        },
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);
                    kyhieuForm.setEditMode(1);
                    var params = null;

                    var tlbParams = $$("paramDonvi");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];
                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item["branch_code"] = $$(id).getValue();
                        }

                        params = item;
                    }
                    kyhieuForm.setValues(params);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    var selectedItem = table.getSelectedItem();
                    if(selectedItem != null) {
                        webix.confirm({
                            text: "Bạn có muốn xóa bản ghi",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (choose) {
                                if (choose) {
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    webix
                                        .ajax()
                                        .headers({"Content-type": "application/json"})
                                        .post(app.config.host + "/Invoice68/deletekihieudonvi68", selectedItem, {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();
                                                var json = JSON.parse(text);
                                                webix.message(json.error, "error");
                                                //webix.message(XmlHttpRequest.statusText, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var res = JSON.parse(text);
                                                if (res.hasOwnProperty("error")) {
                                                    webix.message(res.error, "error");
                                                } else {
                                                    table.remove(selectedItem.id);
                                                    table.enable();
                                                    table.hideProgress();
                                                }
                                            },
                                        });
                                }
                            },
                        });
                    }
                    else {
                        webix.message("Chưa chọn dòng cần xóa", "info");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "kyhieu_hoadon",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.ngayLap) {
                        //     obj.ngayLap = new Date(obj.ngayLap);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                },
                columns: [
                    {
                        id: "phanhoadon_78_donvi_id",
                        header: "phanhoadon_78_donvi_id",
                        hidden: true,
                    },
                    {
                        id: "phanhoadon_78_id",
                        header: "phanhoadon_78_id",
                        hidden: true,
                    },
                    {
                        id: "kyhieu_id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "khhdon",
                        header: [
                            "Kí hiệu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 240,
                    },
                    {
                        id: "tongso",
                        header: [
                            "Tổng số",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                    },
                    {
                        id: "sosudung",
                        header: [
                            "Số sử dụng",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ngaybatdau",
                        format: function (text) {
                            var test = new Date(text);
                            if (test !== null && test !== "null") {
                                var format = webix.Date.dateToStr("%d-%m-%Y %H:%i:%s");
                                text = removeTimeZoneT(test);
                                return format(text);
                            }
                            return "";
                        },
                        width: 240,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "branch_code",
                        header: [
                            "Đơn vị tạo",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "donvisudung",
                        header: [
                            "Đơn vị sử dụng",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                id: "paramDonvi",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    {
                        id: "branch_code",
                        view: "combo",
                        width: 500,
                        label: _("Đơn vị"),
                        options: {
                            body: {
                                //comboId: comp.id,
                                // isDefault: item.has_default,
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195",
                                ready: function () {
                                    // if (this.config.isDefault == "C") {
                                    var count = this.count();

                                    if (count > 0) {
                                        var combo = webix.$$("branch_code");
                                        combo.setValue(this.getFirstId());
                                        var table = $$("kyhieu_hoadon");
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                    // }
                                },
                            },
                        },
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                        on: {
                            onChange: function (newv, oldv) {
                                var table = $$("kyhieu_hoadon");
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                ],
            },
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };
    return {
        $ui: layout,
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_kyhieu_donvi_tncn',["app", "locale", "models/user"], function (app, _, user) {
    var editmode = 0;
    var param;
    var branh_code;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var item = $$("kyhieu-form").getValues();
                        var table = $$("kyhieu-form");

                        if (table.validate()) {
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();
                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .post(app.config.host + "/Invoice68/kihieudonvi68", item, {
                                    error: function (text, data, XmlHttpRequest) {
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        // var json = JSON.parse(text);
                                        // webix.message(json.ExceptionMessage, "error");
                                        webix.message(text + XmlHttpRequest, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text);
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            $$("kyhieu-win").close();
                                            var table = $$("kyhieu_hoadon");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    },
                                });
                        }
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("kyhieu-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "kyhieu-win",
        position: "center",
        head: "Đăng ký ký hiệu",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "kyhieu-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "phanhoadon_78_id",
                    label: "Ký hiệu",
                    //labelPosition: "top",
                    id: "phanhoadon_78_id",
                    required: true,
                    labelWidth: 120,
                    invalidMessage: "Ký hiệu không được bỏ trống",
                    options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF02001",
                    on: {
                        onChange: function (newv, oldv) {
                            var test = newv;
                        },
                    },
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {
            $$("kyhieu-form").setValues(item);
        },
    };
});

define('views/68_kyhieu_donvi_tncn',["app", "locale", "models/user", "views/forms/68_kyhieu_donvi_tncn"], function (app, _, user, kyhieuForm) {
    

    webix.$$("title").parse({
        title: "Phân ký kiệu chứng từ cho đơn vị",
        details: "Phân ký kiệu chứng từ cho đơn vị",
    });

    var initUI = function () {
        // var windowno = app.path[1].params[0];
        var table = webix.$$("kyhieu_hoadon");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var tlbparam_s = [];
                var url = app.config.host + "/Invoice68/GetKyHieuDonVi68";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var tlbParams = $$("paramDonvi");

                if (tlbParams !== undefined) {
                    var childViews = tlbParams.getChildViews();
                    var parameters = [];

                    for (var i = 0; i < childViews.length; i++) {
                        var child = childViews[i];
                        // console.log(child);
                        var id = child.config.id;
                        //var value_field = child.config.value_field;

                        var item = {
                            columnName: id,
                            value: $$(id).getValue(),
                        };
                        parameters.push(item);
                    }
                    tlbparam_s = parameters;
                    url = url + "&tlbparam=" + JSON.stringify(parameters);
                } else {
                    url = url + "&tlbparam=null";
                }
                webix.ajax(url+ "&loaikh=3", callback, view);
            },
        };
        table.define("url", url);
    };

    var submenuChucNang = webix.ui({
        id: "submnchucnang",
        view: "submenu",
        width: 250,
        padding: 0,
        data: [
            {
                id: "UploadTemplate",
                value: "Tải mẫu lên",
            },
            {
                id: "SignTemplate",
                value: "Ký mẫu hóa đơn",
            },
            {
                id: "PreviewTemplate",
                value: "Xem mẫu hóa đơn (PDF)",
            },
            {
                id: "DownloadTemplate",
                value: "Tải mẫu thiết kế (.repx)",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                this.hide();
                var selectedItem = webix.$$("congvieckinhdoanh").getSelectedItem();
                if (selectedselectedItem == null) {
                    webix.message("Bạn chưa chọn khách hàng !", "error");
                    return;
                }
            },
        },
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);
                    kyhieuForm.setEditMode(1);
                    var params = null;

                    var tlbParams = $$("paramDonvi");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];
                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item["branch_code"] = $$(id).getValue();
                        }

                        params = item;
                    }
                    kyhieuForm.setValues(params);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    var selectedItem = table.getSelectedItem();
                    if(selectedItem != null) {
                        webix.confirm({
                            text: "Bạn có muốn xóa bản ghi",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (choose) {
                                if (choose) {
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    webix
                                        .ajax()
                                        .headers({"Content-type": "application/json"})
                                        .post(app.config.host + "/Invoice68/deletekihieudonvi68", selectedItem, {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();
                                                var json = JSON.parse(text);
                                                webix.message(json.error, "error");
                                                //webix.message(XmlHttpRequest.statusText, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var res = JSON.parse(text);
                                                if (res.hasOwnProperty("error")) {
                                                    webix.message(res.error, "error");
                                                } else {
                                                    table.remove(selectedItem.id);
                                                    table.enable();
                                                    table.hideProgress();
                                                }
                                            },
                                        });
                                }
                            },
                        });
                    }
                    else {
                        webix.message("Chưa chọn dòng cần xóa", "info");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "kyhieu_hoadon",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.ngayLap) {
                        //     obj.ngayLap = new Date(obj.ngayLap);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                },
                columns: [
                    {
                        id: "phanhoadon_78_donvi_id",
                        header: "phanhoadon_78_donvi_id",
                        hidden: true,
                    },
                    {
                        id: "phanhoadon_78_id",
                        header: "phanhoadon_78_id",
                        hidden: true,
                    },
                    {
                        id: "kyhieu_id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "khhdon",
                        header: [
                            "Ký hiệu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 240,
                    },
                    {
                        id: "tongso",
                        header: [
                            "Tổng số",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                    },
                    {
                        id: "sosudung",
                        header: [
                            "Số sử dụng",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ngaybatdau",
                        format: function (text) {
                            var test = new Date(text);
                            if (test !== null && test !== "null") {
                                var format = webix.Date.dateToStr("%d-%m-%Y %H:%i:%s");
                                text = removeTimeZoneT(test);
                                return format(text);
                            }
                            return "";
                        },
                        width: 240,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "branch_code",
                        header: [
                            "Đơn vị tạo",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "donvisudung",
                        header: [
                            "Đơn vị sử dụng",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                id: "paramDonvi",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    {
                        id: "branch_code",
                        view: "combo",
                        width: 500,
                        label: _("Đơn vị"),
                        options: {
                            body: {
                                //comboId: comp.id,
                                // isDefault: item.has_default,
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195",
                                ready: function () {
                                    // if (this.config.isDefault == "C") {
                                    var count = this.count();

                                    if (count > 0) {
                                        var combo = webix.$$("branch_code");
                                        combo.setValue(this.getFirstId());
                                        var table = $$("kyhieu_hoadon");
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                    // }
                                },
                            },
                        },
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                        on: {
                            onChange: function (newv, oldv) {
                                var table = $$("kyhieu_hoadon");
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                ],
            },
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };
    return {
        $ui: layout,
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/68_kyhieu_donvi',["views/commonHD", "app", "locale", "models/user", "views/forms/68_kyhieu_donvi"], function (commonHD, app, _, user, kyhieuForm) {
    
    var initUI = function () {
        // var windowno = app.path[1].params[0];
        var table = webix.$$("kyhieu_hoadon");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var tlbparam_s = [];
                var url = app.config.host + "/Invoice68/GetKyHieuDonVi68";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var tlbParams = $$("paramDonvi");

                if (tlbParams !== undefined) {
                    var childViews = tlbParams.getChildViews();
                    var parameters = [];

                    for (var i = 0; i < childViews.length; i++) {
                        var child = childViews[i];
                        // console.log(child);
                        var id = child.config.id;
                        //var value_field = child.config.value_field;

                        var item = {
                            columnName: id,
                            value: $$(id).getValue(),
                        };
                        parameters.push(item);
                    }
                    tlbparam_s = parameters;
                    url = url + "&tlbparam=" + JSON.stringify(parameters);
                } else {
                    url = url + "&tlbparam=null";
                }
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var submenuChucNang = webix.ui({
        id: "submnchucnang",
        view: "submenu",
        width: 250,
        padding: 0,
        data: [
            {
                id: "UploadTemplate",
                value: "Tải mẫu lên",
            },
            {
                id: "SignTemplate",
                value: "Ký mẫu hóa đơn",
            },
            {
                id: "PreviewTemplate",
                value: "Xem mẫu hóa đơn (PDF)",
            },
            {
                id: "DownloadTemplate",
                value: "Tải mẫu thiết kế (.repx)",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                this.hide();
                var selectedItem = webix.$$("congvieckinhdoanh").getSelectedItem();
                if (selectedselectedItem == null) {
                    webix.message("Bạn chưa chọn khách hàng !", "error");
                    return;
                }
            },
        },
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    commonHD.clear_filter(table);
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);
                    kyhieuForm.setEditMode(1);
                    var params = null;

                    var tlbParams = $$("paramDonvi");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];
                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item["branch_code"] = $$(id).getValue();
                        }

                        params = item;
                    }
                    kyhieuForm.setValues(params);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem != null) {
                        webix.confirm({
                            text: "Bạn có muốn xóa bản ghi",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (choose) {
                                if (choose) {
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Invoice68/deletekihieudonvi68", selectedItem, {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();
                                                var json = JSON.parse(text);
                                                webix.message(json.error, "error");
                                                //webix.message(XmlHttpRequest.statusText, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var res = JSON.parse(text);
                                                if (res.hasOwnProperty("error")) {
                                                    webix.message(res.error, "error");
                                                } else {
                                                    table.remove(selectedItem.id);
                                                    table.enable();
                                                    table.hideProgress();
                                                }
                                            },
                                        });
                                }
                            },
                        });
                    }
                    else {
                        webix.message("Chưa chọn dòng cần xóa", "info");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "kyhieu_hoadon",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.ngayLap) {
                        //     obj.ngayLap = new Date(obj.ngayLap);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                },
                columns: [
                    {
                        id: "phanhoadon_78_donvi_id",
                        header: "phanhoadon_78_donvi_id",
                        hidden: true,
                    },
                    {
                        id: "phanhoadon_78_id",
                        header: "phanhoadon_78_id",
                        hidden: true,
                    },
                    {
                        id: "kyhieu_id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "khhdon",
                        header: [
                            "Ký hiệu",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 240,
                    },
                    {
                        id: "tongso",
                        header: [
                            "Tổng số",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                    },
                    {
                        id: "sosudung",
                        header: [
                            "Số sử dụng",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ngaybatdau",
                        header: "Ngày bắt đầu",
                        format: function (text) {
                            var test = new Date(text);
                            if (test !== null && test !== "null") {
                                var format = webix.Date.dateToStr("%d-%m-%Y %H:%i:%s");
                                text = removeTimeZoneT(test);
                                return format(text);
                            }
                            return "";
                        },
                        width: 240,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "branch_code",
                        header: [
                            "Đơn vị tạo",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "donvisudung",
                        header: [
                            "Đơn vị sử dụng",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                id: "paramDonvi",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    {
                        id: "branch_code",
                        view: "combo",
                        width: 800,
                        label: _("Đơn vị"),
                        options: {
                            body: {
                                //comboId: comp.id,
                                // isDefault: item.has_default,
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195",
                                ready: function () {
                                    // if (this.config.isDefault == "C") {
                                    var count = this.count();

                                    if (count > 0) {
                                        var combo = webix.$$("branch_code");
                                        combo.setValue(this.getFirstId());
                                        var table = $$("kyhieu_hoadon");
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                    // }
                                },
                            },
                        },
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                        on: {
                            onChange: function (newv, oldv) {
                                var table = $$("kyhieu_hoadon");
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                ],
            },
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };
    return {
        $ui: layout,
        $onurlchange: function (ui, name, url, scope) {
            initUI();
            if (webix.$$("head-title") != null) {
                webix.$$("head-title").show()
            }
            webix.$$("title").parse({
                title: "Phân ký kiệu hoá đơn cho đơn vị",
                details: "Phân ký kiệu hoá đơn cho đơn vị",
            });
        },
    };
});

define('views/forms/68_kyhieuForm_tncn',["app", "models/user"], function (app, user) {
    var editmode = 0;
    var param;
    var yearDefault = new Date().getFullYear().toString().slice(-2);

    function syncKhhdon() {
        var year = $$("kh_year") ? String($$("kh_year").getValue() || "").replace(/[^0-9]/g, "").substring(0, 2) : yearDefault;
        var suffix = $$("kh_suffix") ? String($$("kh_suffix").getValue() || "").toUpperCase().replace(/[^A-Z]/g, "").substring(0, 2) : "";
        var res = "CT" + year + suffix;
        if ($$("khhdon")) {
            $$("khhdon").setValue(res);
            $$("khhdon").refresh();
        }
        return res;
    }

    function isValidKhhdon(val) {
        return /^CT\d{2}[A-Z]{2}$/.test((val || "").toUpperCase());
    }

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        syncKhhdon();
                        var item = $$("kyhieu-form").getValues();
                        var table = $$("kyhieu-form");

                        item.khhdon = syncKhhdon();
                        if (item.khmbl) {
                            item.khmbl = String(item.khmbl).toUpperCase();
                        }

                        if (table.validate() && isValidKhhdon(item.khhdon)) {
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            item.editmode = editmode;
                            item.code = param.code;
                            item.loaikh = 3;
                            item.id = item.qlkhsdung_id;
                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .post(app.config.host + "/Invoice68/quanlykyhieu68", item, {
                                    error: function (text, data, XmlHttpRequest) {
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        webix.message(text + XmlHttpRequest, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text);
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            $$("kyhieu-win").close();
                                            var table = $$("kyhieu");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    },
                                });
                        } else {
                            if (!isValidKhhdon(item.khhdon)) {
                                webix.message("Ký hiệu đúng dạng: CT + 2 số năm + 2 chữ cái in hoa (vd: CT26AA)", "error");
                            }
                        }
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("kyhieu-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "kyhieu-win",
        position: "center",
        head: "Đăng ký ký hiệu",
        on: {
            onBeforeShow: function () {
                if (editmode == 1) {
                    yearDefault = new Date().getFullYear().toString().slice(-2);
                    $$("khmbl").setValue("03/TNCN");
                    $$("khmbl").define("readonly", true);
                    $$("khmbl").define("css", "mcls_readonly_text");
                    $$("khmbl").refresh();

                    $$("kh_prefix").setValue("CT");
                    $$("kh_year").setValue(yearDefault);
                    $$("kh_suffix").setValue("");
                    $$("kh_year").define("readonly", false);
                    $$("kh_suffix").define("readonly", false);
                    $$("kh_year").refresh();
                    $$("kh_suffix").refresh();
                    syncKhhdon();
                } else if (editmode == 2) {
                    $$("khmbl").define("readonly", true);
                    $$("khmbl").define("css", "mcls_readonly_text");
                    $$("khmbl").refresh();
                }
            },
        },
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "kyhieu-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    view: "text",
                    label: "Ký hiệu mẫu",
                    name: "khmbl",
                    id: "khmbl",
                    labelWidth: 120,
                    required: true,
                    readonly: true,
                    css: "mcls_readonly_text",
                    value: "03/TNCN",
                    invalidMessage: "Không được bỏ trống",
                },
                {
                    cols: [
                        {
                            view: "label",
                            label: "Ký hiệu *",
                            width: 120,
                        },
                        {
                            // Phần 1: CT cố định
                            view: "text",
                            id: "kh_prefix",
                            name: "kh_prefix",
                            width: 45,
                            value: "CT",
                            readonly: true,
                            css: "mcls_readonly_text",
                        },
                        {
                            // Phần 2: năm (2 số), default năm hiện tại
                            view: "text",
                            id: "kh_year",
                            name: "kh_year",
                            width: 50,
                            value: yearDefault,
                            attributes: { maxlength: 2 },
                            invalidMessage: "Năm phải gồm 2 chữ số",
                            validate: function (val) {
                                return /^\d{2}$/.test(val || "");
                            },
                            on: {
                                onChange: function (newv) {
                                    if (newv == null || newv == undefined) return;
                                    var val = String(newv).replace(/[^0-9]/g, "").substring(0, 2);
                                    if (val !== newv) {
                                        this.blockEvent();
                                        this.setValue(val);
                                        this.unblockEvent();
                                    }
                                    syncKhhdon();
                                },
                                onTimedKeyPress: function () {
                                    var newv = this.getValue();
                                    var val = String(newv || "").replace(/[^0-9]/g, "").substring(0, 2);
                                    if (val !== newv) {
                                        this.blockEvent();
                                        this.setValue(val);
                                        this.unblockEvent();
                                    }
                                    syncKhhdon();
                                },
                            },
                        },
                        { width: 12 },
                        {
                            // Phần 3: 2 chữ cái in hoa (A-Z), có gạch chân như phần năm
                            view: "text",
                            id: "kh_suffix",
                            name: "kh_suffix",
                            width: 55,
                            value: "",
                            attributes: { maxlength: 2, style: "text-transform:uppercase" },
                            placeholder: "AA",
                            invalidMessage: "Nhập đúng 2 chữ cái in hoa (A-Z)",
                            validate: function (val) {
                                return /^[A-Z]{2}$/.test((val || "").toUpperCase());
                            },
                            on: {
                                onChange: function (newv) {
                                    if (newv == null || newv == undefined) return;
                                    // Chỉ cho chữ cái, tự chuyển in hoa
                                    var val = String(newv).toUpperCase().replace(/[^A-Z]/g, "").substring(0, 2);
                                    if (val !== newv) {
                                        this.blockEvent();
                                        this.setValue(val);
                                        this.unblockEvent();
                                    }
                                    syncKhhdon();
                                },
                                onTimedKeyPress: function () {
                                    var newv = this.getValue();
                                    var val = String(newv || "").toUpperCase().replace(/[^A-Z]/g, "").substring(0, 2);
                                    if (val !== newv) {
                                        this.blockEvent();
                                        this.setValue(val);
                                        this.unblockEvent();
                                    }
                                    syncKhhdon();
                                },
                                onKeyPress: function (code, e) {
                                    // Chặn số và ký tự đặc biệt ngay khi gõ
                                    var ch = String.fromCharCode(code);
                                    if (e.ctrlKey || e.metaKey || e.altKey) return true;
                                    // Cho phép phím điều khiển (backspace, delete, arrows...)
                                    if (code < 32) return true;
                                    if (!/[A-Za-z]/.test(ch)) {
                                        return false;
                                    }
                                    return true;
                                },
                            },
                        },
                        { width: 10 },
                        {
                            // Giá trị đầy đủ lưu DB: CT + năm + 2 chữ cái (vd: CT26AA)
                            view: "text",
                            name: "khhdon",
                            id: "khhdon",
                            readonly: true,
                            css: "mcls_readonly_text",
                            width: 180,
                            required: true,
                            value: "CT" + yearDefault,
                            invalidMessage: "Định dạng đúng: CT + 2 số năm + 2 chữ cái in hoa (vd: CT26AA)",
                            validate: function (val) {
                                return isValidKhhdon(val);
                            },
                        },
                    ],
                },
                {
                    id: "sdmau",
                    name: "sdmau",
                    label: "Số dòng in mẫu",
                    labelWidth: 120,
                    view: "text",
                    value: 1,
                    hidden: true,
                    validate: function (val) {
                        return !isNaN(val * 1) && val * 1 >= 0;
                    },
                    invalidMessage: "Phải nhập số dương",
                    attributes: { type: "number" },
                },
                {
                    view: "combo",
                    label: "Mẫu thiết kế",
                    name: "qlmtke_id",
                    id: "qlmtke_id",
                    labelWidth: 120,
                    required: true,
                    invalidMessage: "Mẫu không được bỏ trống",
                    options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF02002",
                    on: {
                        onChange: function (newv, oldv) {},
                    },
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {
            $$("kyhieu-form").setValues(item);

            var khhd = (item.khhdon || "").toUpperCase();
            // Hỗ trợ cả CT26AA và dữ liệu cũ 03/TNCNCT26AA
            if (khhd.indexOf("03/TNCN") === 0) {
                khhd = khhd.substring(7);
            }
            if (khhd.indexOf("CT") === 0 && khhd.length >= 4) {
                $$("kh_prefix").setValue("CT");
                $$("kh_year").setValue(khhd.substring(2, 4).replace(/[^0-9]/g, "").substring(0, 2));
                $$("kh_suffix").setValue((khhd.substring(4, 6) || "").replace(/[^A-Z]/g, "").substring(0, 2));
            }
            syncKhhdon();
        },
    };
});

define('views/68_kyhieu_tncn',["app", "locale", "models/user", "views/forms/68_kyhieuForm_tncn"], function (app, _, user, kyhieuForm) {
    

    webix.$$("title").parse({
        title: "Quản lý ký hiệu chứng từ sử dụng",
        details: "Quản lý ký hiệu chứng từ sử dụng",
    });

    var initUI = function () {
        // var windowno = app.path[1].params[0];
        var table = webix.$$("kyhieu");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var tlbparam_s = [];
                var url = app.config.host + "/Invoice68/GetDataquanlykyhieu68";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var tlbParams = $$("paramDonvi");

                if (tlbParams !== undefined) {
                    var childViews = tlbParams.getChildViews();
                    var parameters = [];

                    for (var i = 0; i < childViews.length; i++) {
                        var child = childViews[i];
                        // console.log(child);
                        var id = child.config.id;
                        //var value_field = child.config.value_field;

                        var item = {
                            columnName: "code",
                            value: $$(id).getValue(),
                        };
                        parameters.push(item);
                    }
                    tlbparam_s = parameters;
                    url = url + "&tlbparam=" + JSON.stringify(parameters);
                } else {
                    url = url + "&tlbparam=null";
                }
                webix.ajax(url +"&loaikh=3", callback, view);
            },
        };
        table.define("url", url);
    };

    var submenuChucNang = webix.ui({
        id: "submnchucnang",
        view: "submenu",
        width: 250,
        padding: 0,
        data: [
            {
                id: "UploadTemplate",
                value: "Tải mẫu lên",
            },
            {
                id: "SignTemplate",
                value: "Ký mẫu chứng từ",
            },
            {
                id: "PreviewTemplate",
                value: "Xem mẫu chứng từ (PDF)",
            },
            {
                id: "DownloadTemplate",
                value: "Tải mẫu thiết kế (.repx)",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                this.hide();
                var selectedItem = webix.$$("congvieckinhdoanh").getSelectedItem();
                if (selectedselectedItem == null) {
                    webix.message("Bạn chưa chọn khách hàng !", "error");
                    return;
                }
            },
        },
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);
                    kyhieuForm.setEditMode(1);
                    var params = null;

                    var tlbParams = $$("paramDonvi");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];
                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item[id] = $$(id).getValue();
                        }

                        params = item;
                    }
                    kyhieuForm.initUI(params);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn khách hàng ! ", "error");
                        return;
                    }
                    if (selectedItem.tt_sd > 0) {
                        webix.message("Ký hiệu đã sử dụng không thể sửa ! ", "error");
                        return;
                    }
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);

                    var params = null;

                    var tlbParams = $$("paramDonvi");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];
                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item[id] = $$(id).getValue();
                        }

                        params = item;
                    }
                    kyhieuForm.initUI(params);

                    kyhieuForm.setEditMode(2);
                    kyhieuForm.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn ký hiệu chứng từ cần xóa ! ", "error");
                        return;
                    }
                    if (selectedItem.tt_sd > 0) {
                        webix.message("Ký hiệu đã sử dụng không thể xóa ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/deletequanlykyhieu68", selectedItem, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var res = JSON.parse(text);
                                            if (res.hasOwnProperty("error")) {
                                                webix.message(res.error, "error");
                                            } else {
                                                table.remove(selectedItem.id);
                                                table.enable();
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + " (F7)" + "</span>",
            id: "btnPrint",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in chứng từ ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>chứng từ điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inMauHoadon?id=" + item.id, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     id: "btnChucNang",
        //     view: "button",
        //     type: "icon",
        //     icon: "fa fa-cube",
        //     label: "Chức năng",
        //     width: 100,
        //     css: "button_raised",
        //     click: function () {
        //         submenuChucNang.show(webix.$$("btnChucNang").$view);
        //     },
        // },
        // {
        //     view: "button",
        //     id: "btnRegister",
        //     type: "icon",
        //     icon: "plus",
        //     label: "Đăng ký",
        //     width: 100,
        //     shortcut: "F1",
        //     on: {
        //         onClick: function () {
        //             var detailForm = this.$scope.ui(dangkyform.$ui);
        //             dangkyform.setEditMode(0);
        //             detailForm.show();
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "kyhieu",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.ngayLap) {
                        //     obj.ngayLap = new Date(obj.ngayLap);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "kyhieu_id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "index",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "tmau",
                        header: [
                            "Tên mẫu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "khmbl",
                        header: [
                            "Ký hiệu mẫu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "khhdon",
                        header: [
                            "Ký hiệu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    // {
                    //     id: "trangThai",
                    //     header: [
                    //         "Số dòng in mẫu",
                    //         {
                    //             content: "textFilter",
                    //         },
                    //     ],
                    //     width: 120,
                    //     template: function (obj) {
                    //         return (
                    //             "<span class='tt_kyhieu_status" +
                    //             obj.trangThai +
                    //             "'>" +
                    //             obj.trangThai +
                    //             "</span>"
                    //         );
                    //     }
                    // },
                    {
                        id: "nlap",
                        header: [
                            "Ngày lập",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        columnType: "datetime",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "nglap",
                        header: [
                            "Người lập",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "tt_sdung",
                        header: ["Sử dụng"],
                        editor: "checkbox",
                        width: 90,
                        template: function (obj) {
                            var checked = obj.tt_sd > 0 ? 'checked="true"' : "";
                            return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                        },
                        css: {
                            "text-align": "center",
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                id: "paramDonvi",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    {
                        id: "code",
                        view: "combo",
                        width: 500,
                        label: _("Đơn vị"),
                        options: {
                            body: {
                                //comboId: comp.id,
                                // isDefault: item.has_default,
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195",
                                ready: function () {
                                    // if (this.config.isDefault == "C") {
                                    var count = this.count();

                                    if (count > 0) {
                                        var combo = webix.$$("code");
                                        combo.setValue(this.getFirstId());
                                    }
                                    // }
                                },
                            },
                        },
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                        on: {
                            onChange: function (newv, oldv) {
                                var table = $$("kyhieu");
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                ],
            },
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("kyhieu");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("kyhieu");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangedKyhieu68", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_kyhieuForm',["app", "models/user"], function (app, user) {
    var editmode = 0;
    var param;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var item = $$("kyhieu-form").getValues();
                        var table = $$("kyhieu-form");

                        var khhdon = item.khhdon;

                        if (item.lhdon != khhdon[0] || item.hthuc != khhdon[1] || item.khdon != khhdon[4]) {
                            webix.message("Ký hiệu không hợp lệ", "error");
                            return;
                        }
                        var donginmau = item.sdmau;
                        if (donginmau == undefined || donginmau == "") {
                            webix.message("Dòng in mẫu không được để trống", "error");
                            return;
                        }
                        if (table.validate()) {
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            item.editmode = editmode;
                            item.code = param.code;
                            item.loaikh = 1;
                            item.id = item.qlkhsdung_id;
                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .post(app.config.host + "/Invoice68/quanlykyhieu68", item, {
                                    error: function (text, data, XmlHttpRequest) {
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        // var json = JSON.parse(text);
                                        // webix.message(json.ExceptionMessage, "error");
                                        webix.message(text + XmlHttpRequest, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text);
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            $$("kyhieu-win").close();
                                            var table = $$("kyhieu");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    },
                                });
                        }
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("kyhieu-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "kyhieu-win",
        position: "center",
        head: "Đăng ký ký hiệu hóa đơn",
        on: {
            onBeforeShow: function () {
                var table = webix.$$("kyhieu");
                var selectedItem = table.getSelectedItem();
                if (editmode == 1) {
                    var date = new Date();
                    var year = date.getFullYear();
                    $$("khhdon").setValue("1K" + year.toString().substring(2, 4) + "TYY");
                } else if (editmode == 2) {
                    if (selectedItem.tt_sd > 0) {
                        $$("lhdon").disable();
                        $$("hthuc").disable();
                        $$("khhdon").disable();
                        $$("qlmtke_id").disable();
                        $$("khdon").disable();
                    }
                }
            },
        },
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "kyhieu-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "lhdon",
                    label: "Loại hóa đơn",
                    //labelPosition: "top",
                    id: "lhdon",
                    required: true,
                    labelWidth: 120,
                    value: "1",
                    invalidMessage: "Loại hóa đơn không được bỏ trống !",
                    options: [
                        { id: "1", value: "Hóa đơn GTGT" },
                        { id: "2", value: "Hóa đơn bán hàng" },
                        { id: "3", value: "Hóa đơn điện tử bán tài sản công" },
                        { id: "4", value: "Hóa đơn điện tử bán hàng dự trữ quốc gia" },
                        { id: "5", value: "Hóa đơn khác: tem, vé, thẻ, phiếu..." },
                        { id: "6", value: "Phiếu xuất kho kiêm vận chuyển nội bộ/ hàng gửi bán đại lý" },
                    ],
                    on: {
                        onChange: function (newv, oldv) {
                            var kyhieu = $$("khhdon").getValue();
                            var res = kyhieu.replace(kyhieu.substring(0, 1), newv);
                            $$("khhdon").setValue(res);
                            $$("khhdon").refresh();
                        },
                    },
                },
                {
                    view: "combo",
                    label: "Hình thức",
                    name: "hthuc",
                    id: "hthuc",
                    required: true,
                    invalidMessage: "Hình thức không được bỏ trống",
                    labelWidth: 120,
                    value: "K",
                    options: [
                        { id: "K", value: "Hóa đơn không có mã của CQT" },
                        { id: "C", value: "Hóa đơn có mã của CQT" },
                    ],
                    on: {
                        onChange: function (newv, oldv) {
                            var kyhieu = $$("khhdon").getValue();

                            var res = kyhieu.replace(kyhieu.substring(1, 2), newv);
                            $$("khhdon").setValue(res);
                            $$("khhdon").refresh();
                        },
                    },
                },
                {
                    view: "combo",
                    label: "Kiểu hóa đơn",
                    name: "khdon",
                    id: "khdon",
                    labelWidth: 120,
                    required: true,
                    invalidMessage: "Hình thức không được bỏ trống",
                    value: "T",
                    options: [
                        { id: "T", value: "Tự đăng ký sử dụng" },
                        { id: "D", value: "Hóa đơn đặc thù" },
                        { id: "L", value: "Hóa đơn CQT cấp từng lần" },
                        { id: "M", value: "Hóa đơn khởi tạo từ máy tính tiền" },
                        { id: "N", value: "PXKKVCNB" },
                        { id: "B", value: "PXKGBĐL" },
                        { id: "G", value: "Tem, vé, thẻ điện tử là hóa đơn giá trị gia tăng" },
                        { id: "H", value: "Tem, vé, thẻ điện tử là hóa đơn bán hàng" },
                    ],
                    on: {
                        onChange: function (newv, oldv) {
                            var kyhieu = $$("khhdon").getValue();

                            var res = kyhieu.replace(kyhieu.substring(4, 5), newv);
                            $$("khhdon").setValue(res);
                            $$("khhdon").refresh();

                            if(newv === 'M')
                            {
                                $$("mtttien").show();


                            }
                        },
                    },
                },
                {
                    view: "text",
                    label: "Ký hiệu",
                    name: "khhdon",
                    id: "khhdon",
                    labelWidth: 120,
                    required: true,
                    invalidMessage: "Ký hiệu không được bỏ trống hoặc sai định dạng",
                    attributes: {
                        maxlength: 7,
                    },
                    validate: function(value) {
                        var regex = /^[A-Z1-9]{1,7}$/;
                        return regex.test(value);
                    }
        
                },
                {
                    view: "text",
                    label: "Mã máy tính tiền",
                    name: "mtttien",
                    id: "mtttien",
                    hidden: true,
                    labelWidth: 120,
                    attributes: {
                        maxlength: 5,
                    },
                },
                {
                    id: "sdmau",
                    name: "sdmau",
                    label: "Số dòng in mẫu",
                    labelWidth: 120,
                    view: "text",
                    value: 1,
                    required: true,
                    validate: function (val) {
                        return !isNaN(val * 1) && val * 1 >= 0;
                    },
                    invalidMessage: "Phải nhập số dương",
                    attributes: { type: "number" },
                },
                {
                    view: "combo",
                    label: "Mẫu thiết kế",
                    name: "qlmtke_id",
                    id: "qlmtke_id",
                    labelWidth: 120,
                    required: true,
                    invalidMessage: "Mẫu không được bỏ trống",
                    options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00053",
                    on: {
                        onChange: function (newv, oldv) {},
                    },
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
            if(editmode ==1) {
                webix
                    .ajax()
                    .get(app.config.host + "/Invoice68/GetMaTinhTien", function (text) {
                        var json = JSON.parse(text);
                        $$("mtttien").setValue(json['mccqt']);
                        $$("mtttien").refresh();
                    });
            }
        },
        setValues: function (item) {
            $$("kyhieu-form").setValues(item);


        },
    };
});

define('views/68_kyhieu_transfer',["views/commonHD", "app", "locale", "models/user", "views/forms/68_kyhieuForm"], function (commonHD, app, _, user, kyhieuForm) {
    
    // Năm hiện tại dùng cho chọn năm chuyển ký hiệu
    var currentYear = new Date().getFullYear();
    // Danh sách năm (từ năm hiện tại - 1 đến năm hiện tại + 5)
    var yearOptions = [];
    for (var y = currentYear - 1; y <= currentYear + 5; y++) {
        yearOptions.push({ id: String(y), value: String(y) });
    }

    var initUI = function () {
        var table = webix.$$("kyhieu");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var tlbparam_s = [];
                var url = app.config.host + "/Invoice68/GetListKyHieuTransfer";
                // Lấy năm được chọn và tính currentYearParam = selectedYear - 1
                var selectedYear = null;
                if ($$("selectedYear")) {
                    selectedYear = parseInt($$("selectedYear").getValue(), 10);
                }
                var currentYearParam = currentYear;
                if (!isNaN(selectedYear)) {
                    currentYearParam = selectedYear - 1;
                }

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&currentYear=" + currentYearParam + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&currentYear=" + currentYearParam + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var tlbParams = $$("paramDonvi");

                if (tlbParams !== undefined) {
                    var childViews = tlbParams.getChildViews();
                    var parameters = [];

                    for (var i = 0; i < childViews.length; i++) {
                        var child = childViews[i];
                        var id = child.config.id;
                        var item = {
                            columnName: "code",
                            value: $$(id).getValue(),
                        };
                        parameters.push(item);
                    }
                    tlbparam_s = parameters;
                    url = url + "&tlbparam=" + JSON.stringify(parameters);
                } else {
                    url = url + "&tlbparam=null";
                }
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    commonHD.clear_filter(table);
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 140,
            label: '<i class="fa fa-exchange fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("TRANSFER_SYMBOL") + " (F4)" + "</span>",
            id: "btnTransfer",
            shortcut: "F4",
                on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var selectedYear = null;
                    if ($$("selectedYear")) {
                        selectedYear = $$("selectedYear").getValue();
                    }
                    
                    if (selectedYear == null || selectedYear == undefined || selectedYear == "") {
                        webix.message("Bạn chưa chọn năm cần chuyển ký hiệu !", "error");
                        return;
                    }
                    
                    var dataPost = {
                        selectedYear: selectedYear
                    };

                    // Chuẩn bị nội dung hiển thị trong popup xác nhận
                    var fromYear = parseInt(selectedYear, 10) - 1;
                    var unitName = "";
                    if ($$("code")) {
                        var comboUnit = $$("code");
                        if (comboUnit.getText) {
                            unitName = comboUnit.getText();
                        } else {
                            unitName = comboUnit.getValue();
                        }
                    }
                    var unitNameSafe = webix.template.escape(unitName || "");

                    var messageHtml =
                        "<div>Bạn đang thực hiện chuyển toàn bộ dải hóa đơn từ năm <b>" +
                        fromYear +
                        "</b> sang năm <b>" +
                        selectedYear +
                        "</b> cho đơn vị: <b>" +
                        unitNameSafe +
                        "</b></div>" +
                        "<div style='margin-top: 12px; padding: 12px 16px; background-color: #fff7e6; border-radius: 4px; border-left: 4px solid #ffa940; display:flex; align-items:flex-start; gap:10px;'>" +
                        "<div><i class='fa fa-info-circle' style='color:#FFD43B; font-size:18px; margin-top:3px;'></i></div>" +
                        "<div>" +
                        "<div><b>Lưu ý:</b></div>" +
                        "<div style='margin-top: 8px;'>" +
                        "<div>- Thao tác này không thể hoàn tác.</div>" +
                        "<div>- Dải hóa đơn sẽ được áp dụng theo thời điểm tạo hóa đơn.</div>" +
                        "<div>- Hóa đơn tạo trong năm cũ vẫn sử dụng dải năm cũ.</div>" +
                        "<div>- Hóa đơn tạo từ năm mới sẽ sử dụng dải năm mới.</div>" +
                        "<div>- Việc chuyển dải không làm ảnh hưởng hóa đơn đã phát hành.</div>" +
                        "</div>" +
                        "</div>" +
                        "</div>";

                    var confirmWindow = {
                        view: "window",
                        modal: true,
                        id: "confirmTransferWindow",
                        position: "center",
                        width: 450,
                        height: 280,
                        head: "Chuyển dải hoá đơn",
                        body: {
                            paddingY: 10,
                            paddingX: 10,
                            rows: [
                                {
                                    view: "template",
                                    template: messageHtml,
                                    css: "quenmktemplate",
                                    borderless: true,
                                },
                                {
                                    margin: 10,
                                    height: 40,
                                    cols: [
                                        {
                                            shortcut: "F10",
                                            view: "button",
                                            label: "LƯU (F10)",
                                            type: "form",
                                            align: "center",
                                            width: 110,
                                            click: function () {
                                                webix.$$("confirmTransferWindow").close();
                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/TransferInvoiceSymbol", dataPost, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            table.enable();
                                                            table.hideProgress();
                                                            var json = JSON.parse(text);
                                                            webix.message("Chuyển dải ký hiệu hoá đơn không thành công", "error");
                                                            console.error(json.error);
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var res = JSON.parse(text);
                                                            if (res.hasOwnProperty("error")) {
                                                                webix.message(res.error, "error");
                                                                table.enable();
                                                                table.hideProgress();
                                                            } else {
                                                                webix.message("Chuyển dải ký hiệu hoá đơn thành công", "success");
                                                                table.clearAll();
                                                                table.load(table.config.url);
                                                                table.enable();
                                                                table.hideProgress();
                                                            }
                                                        },
                                                    });
                                            },
                                        },
                                        {
                                            view: "button",
                                            shortcut: "esc",
                                            label: "HỦY (ESC)",
                                            type: "danger",
                                            align: "center",
                                            width: 110,
                                            click: function () {
                                                webix.$$("confirmTransferWindow").close();
                                            },
                                        },
                                        {},
                                    ],
                                },
                            ],
                        },
                    };

                    if (!webix.$$("confirmTransferWindow")) {
                        webix.ui(confirmWindow);
                    }
                    webix.$$("confirmTransferWindow").show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {},
        {},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "kyhieu",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "kyhieu_id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "index",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "tmau",
                        header: [
                            "Tên mẫu",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 250,
                    },
                    {
                        id: "lhdon",
                        header: [
                            "Loại hóa đơn",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "hthuc",
                        header: [
                            "Hình thức",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "khdon",
                        header: [
                            "Kiểu hóa đơn",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "khhdon",
                        header: [
                            "Ký hiệu",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "status",
                        header: [
                            "Trạng thái",
                        ],
                        width: 120,
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                id: "paramDonvi",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    {
                        id: "code",
                        view: "combo",
                        width: 800,
                        label: _("Đơn vị"),
                        options: {
                            body: {
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195",
                                ready: function () {
                                    var count = this.count();

                                    if (count > 0) {
                                        var combo = webix.$$("code");
                                        combo.setValue(this.getFirstId());
                                    }
                                },
                            },
                        },
                        on: {
                            onChange: function (newv, oldv) {
                                var table = $$("kyhieu");
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                ],
            },
            {
                id: "paramSelectedYear",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    {
                        id: "selectedYear",
                        view: "combo",
                        width: 200,
                        label: _("Năm"),
                        options: yearOptions,
                        value: String(currentYear),
                        on: {
                            onChange: function (newv, oldv) {
                                var table = $$("kyhieu");
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                ],
            },
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("kyhieu");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("kyhieu");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangedKyhieu68", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
            if (webix.$$("head-title") != null) {
                webix.$$("head-title").show()
            }
           
            webix.$$("title").parse({
                title: "Quản lý ký hiệu hóa đơn sử dụng",
                details: "Quản lý ký hiệu hóa đơn sử dụng",
            });
        },
    };
});

define('views/68_kyhieu',["views/commonHD", "app", "locale", "models/user", "views/forms/68_kyhieuForm"], function (commonHD, app, _, user, kyhieuForm) {
    
    var initUI = function () {
        var table = webix.$$("kyhieu");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var tlbparam_s = [];
                var url = app.config.host + "/Invoice68/GetDataquanlykyhieu68";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var tlbParams = $$("paramDonvi");

                if (tlbParams !== undefined) {
                    var childViews = tlbParams.getChildViews();
                    var parameters = [];

                    for (var i = 0; i < childViews.length; i++) {
                        var child = childViews[i];
                        var id = child.config.id;
                        var item = {
                            columnName: "code",
                            value: $$(id).getValue(),
                        };
                        parameters.push(item);
                    }
                    tlbparam_s = parameters;
                    url = url + "&tlbparam=" + JSON.stringify(parameters);
                } else {
                    url = url + "&tlbparam=null";
                }
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var submenuChucNang = webix.ui({
        id: "submnchucnang",
        view: "submenu",
        width: 250,
        padding: 0,
        data: [
            {
                id: "UploadTemplate",
                value: "Tải mẫu lên",
            },
            {
                id: "SignTemplate",
                value: "Ký mẫu hóa đơn",
            },
            {
                id: "PreviewTemplate",
                value: "Xem mẫu hóa đơn (PDF)",
            },
            {
                id: "DownloadTemplate",
                value: "Tải mẫu thiết kế (.repx)",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                this.hide();
                var selectedItem = webix.$$("congvieckinhdoanh").getSelectedItem();
                if (selectedselectedItem == null) {
                    webix.message("Bạn chưa chọn khách hàng !", "error");
                    return;
                }
            },
        },
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    commonHD.clear_filter(table);
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);
                    kyhieuForm.setEditMode(1);
                    var params = null;

                    var tlbParams = $$("paramDonvi");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];
                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item[id] = $$(id).getValue();
                        }

                        params = item;
                    }
                    kyhieuForm.initUI(params);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn khách hàng ! ", "error");
                        return;
                    }
                    // if (selectedItem.tt_sd > 0) {
                    //     webix.message("Ký hiệu đã sử dụng không thể sửa ! ", "error");
                    //     return;
                    // }
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);

                    var params = null;

                    var tlbParams = $$("paramDonvi");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];
                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item[id] = $$(id).getValue();
                        }

                        params = item;
                    }
                    kyhieuForm.initUI(params);

                    kyhieuForm.setEditMode(2);
                    kyhieuForm.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn ký hiệu hóa đơn cần xóa ! ", "error");
                        return;
                    }
                    if (selectedItem.tt_sd > 0) {
                        webix.message("Ký hiệu đã sử dụng không thể xóa ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    var dataPost = {
                        id: selectedItem.qlkhsdung_id,
                        editmode: 3
                    }
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/deletequanlykyhieu68", dataPost, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message("Xóa ký hiệu " + selectedItem.khhdon + " không thành công", "error");
                                            console.error(json.error);
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var res = JSON.parse(text);
                                            if (res.hasOwnProperty("error")) {
                                                webix.message(res.error, "error");
                                            } else {
                                                webix.message("Xóa ký hiệu " + selectedItem.khhdon + " thành công", "success");
                                                table.remove(selectedItem.id);
                                                table.enable();
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + " (F7)" + "</span>",
            id: "btnPrint",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inMauHoadon?id=" + item.qlkhsdung_id, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "kyhieu",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.ngayLap) {
                        //     obj.ngayLap = new Date(obj.ngayLap);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "kyhieu_id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "index",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "tmau",
                        header: [
                            "Tên mẫu",
                            {
                                content: "serverFilter",
                                /* Code tối ưu ui 
                                content: "serverSelectFilter",
                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00053",
                                */
                            },
                        ],
                        width: 250,
                    },
                    {
                        id: "lhdon",
                        header: [
                            "Loại hóa đơn",
                            {
                                content: "serverFilter",
                                /* Code tối ưu ui 
                                content: "serverSelectFilter",
                                options: [
                                    { id: "1", value: "Hóa đơn GTGT (1)" },
                                    { id: "2", value: "Hóa đơn bán hàng (2)" },
                                    { id: "3", value: "Hóa đơn điện tử bán tài sản công (3)" },
                                    { id: "4", value: "Hóa đơn điện tử bán hàng dự trữ quốc gia (4)" },
                                    { id: "5", value: "Hóa đơn khác: tem, vé, thẻ, phiếu... (5)" },
                                    { id: "6", value: "Phiếu xuất kho kiêm vận chuyển nội bộ/ hàng gửi bán đại lý (6)" },
                                ],
                                */
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                        /* Code tối ưu ui 
                        template: function (obj) {
                            switch (obj.lhdon) {
                                case 1:
                                    return "Hóa đơn GTGT (1)";
                                case 2:
                                    return "Hóa đơn bán hàng (2)";
                                case 3:
                                    return "Hóa đơn điện tử bán tài sản công (3)";
                                case 4:
                                    return "Hóa đơn điện tử bán hàng dự trữ quốc gia (4)";
                                case 5:
                                    return "Hóa đơn khác: tem, vé, thẻ, phiếu... (5)";
                                case 6:
                                    return "Phiếu xuất kho kiêm vận chuyển nội bộ/ hàng gửi bán đại lý (6)";
                                default:
                                    return obj.lhdon;
                            }
                        },
                        */
                    },
                    {
                        id: "hthuc",
                        header: [
                            "Hình thức",
                            {
                                content: "serverFilter",
                                /* Code tối ưu ui 
                                content: "serverSelectFilter",
                                options: [
                                    { id: "K", value: "Hóa đơn không có mã của CQT (K)" },
                                    { id: "C", value: "Hóa đơn có mã của CQT (C)" },
                                ],
                                */
                            },
                        ],
                        width: 120,
                        css: {
                            "text-align": "center",
                        },
                        /* Code tối ưu ui 
                        template: function (obj) {
                            switch (obj.hthuc) {
                                case "K":
                                    return "Hóa đơn không có mã của CQT (K)";
                                case "C":
                                    return "Hóa đơn có mã của CQT (C)";
                                default:
                                    return null; // Handle default case if needed
                            }
                        }
                        */
                    },
                    {
                        id: "khdon",
                        header: [
                            "Kiểu hóa đơn",
                            {
                                content: "serverFilter",
                                /* Code tối ưu ui 
                                content: "serverSelectFilter",
                                options: [
                                    { id: "T", value: "Tự đăng ký sử dụng (T)" },
                                    { id: "D", value: "Hóa đơn đặc thù (D)" },
                                    { id: "L", value: "Hóa đơn CQT cấp từng lần (L)" },
                                    { id: "M", value: "Hóa đơn khởi tạo từ máy tính tiền (M)" },
                                    { id: "N", value: "PXKKVCNB (N)" },
                                    { id: "B", value: "PXKGBĐL (B)" },
                                    { id: "G", value: "Tem, vé, thẻ điện tử là hóa đơn giá trị gia tăng (G)" },
                                    { id: "H", value: "Tem, vé, thẻ điện tử là hóa đơn bán hàng (H)" },
                                ],
                                */
                            },
                        ],
                        width: 120,
                        css: {
                            "text-align": "center",
                        },
                        /* Code tối ưu ui 
                        template: function (obj) {
                            switch (obj.khdon) {
                                case "T":
                                    return "Tự đăng ký sử dụng (T)";
                                case "D":
                                    return "Hóa đơn đặc thù (D)";
                                case "L":
                                    return "Hóa đơn CQT cấp từng lần (L)";
                                case "M":
                                    return "Hóa đơn khởi tạo từ máy tính tiền (M)";
                                case "N":
                                    return "PXKKVCNB (N)";
                                case "B":
                                    return "PXKGBĐL (B)";
                                case "G":
                                    return "Tem, vé, thẻ điện tử là hóa đơn giá trị gia tăng (G)";
                                case "H":
                                    return "Tem, vé, thẻ điện tử là hóa đơn bán hàng (H)";
                                default:
                                    return null; // Handle default case if needed
                            }
                        }
                        */
                    },
                    {
                        id: "khhdon",
                        header: [
                            "Ký hiệu",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "sdmau",
                        header: [
                            "Số dòng in mẫu",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "nlap",
                        header: [
                            "Ngày lập",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 160,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        columnType: "datetime",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "nglap",
                        header: [
                            "Người lập",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 150,
                    },
                    {
                        id: "tt_sd",
                        header: [
                            "Sử dụng",
                        ],
                        editor: "checkbox",
                        width: 90,
                        template: function (obj) {
                            var checked = obj.tt_sd > 0 ? 'checked="true"' : "";
                            return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                        },
                        css: {
                            "text-align": "center",
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                id: "paramDonvi",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    {
                        id: "code",
                        view: "combo",
                        width: 800,
                        label: _("Đơn vị"),
                        options: {
                            body: {
                                //comboId: comp.id,
                                // isDefault: item.has_default,
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195",
                                ready: function () {
                                    // if (this.config.isDefault == "C") {
                                    var count = this.count();

                                    if (count > 0) {
                                        var combo = webix.$$("code");
                                        combo.setValue(this.getFirstId());
                                    }
                                    // }
                                },
                            },
                        },
                        // value_field: item.value_field,
                        // isDefault: item.has_default,
                        on: {
                            onChange: function (newv, oldv) {
                                var table = $$("kyhieu");
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                ],
            },
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("kyhieu");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("kyhieu");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangedKyhieu68", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
            if (webix.$$("head-title") != null) {
                webix.$$("head-title").show()
            }
           
            webix.$$("title").parse({
                title: "Quản lý ký hiệu hóa đơn sử dụng",
                details: "Quản lý ký hiệu hóa đơn sử dụng",
            });
        },
    };
});

define('views/forms/68_huyhoadon_bienlai',["app", "locale", "models/user", "views/forms/68_invoiceForms"], function (app, _, user, invoiceForms) {
    

    var editmode = 0;

    function listToTreeCustomize(json) {
        return json.map(function(item) {
            return {
                id: item.code,
                name: item.name != null ? item.name.toString() : "",
                code: item.code
            };
        });
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>BIÊN BẢN HỦY BIÊN LAI<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_dksdForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "huyhoadonForms",
            resize: true,
            width: 1100,
            height: 600,
            // fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {},
            },
            body: {
                view: "form",
                id: "huyhoadon",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        // id: "header",
                        template: "<center><b><span style='font-size:17px;'>BIÊN BẢN HỦY BIÊN LAI</b></center>",
                        borderless: true,
                        height: 40,
                    },
                    {
                        paddingX: 30,
                        rows: [
                            {
                                cols: [
                                    {},
                                    {
                                        view: "text",
                                        id: "tcqt_hidden",
                                        name: "tcqt",
                                        hidden: true
                                    },
                                    {
                                        label: "Kính gửi: ",
                                        id: "tcqt",
                                        view: "combo",
                                        labelWidth: 100,
                                        valueField: "name", // Chỉ định rõ ràng rằng combo sẽ lấy giá trị từ trường name                                        width: 300,
                                        width: 300,
                                        options: {
                                            view: "gridsuggest",
                                            columnName: "name",
                                            url: {
                                                $proxy: true,
                                                load: function (view, callback, params) {
                                                    var url = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00251";
                                                    webix.ajax(url, function (text) {
                                                        var json = JSON.parse(text);
                                                        var data = listToTreeCustomize(json);
                                                        view.parse(data, "json");
                                                    });
                                                },
                                            },
                                            body: {
                                                columns: [ { id: "name", width: 225, header: "Tên" }, { id: "code", width: 100, header: "Mã" }],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    $$("tcqt_hidden").setValue(obj["name"]); // Lưu item.name vào trường ẩn
                                                    $$("tcqt_hidden").refresh();

                                                    $$("mcqt").setValue(obj["code"]);
                                                    $$("mcqt").refresh();
                                                },
                                            },
                                        },
                                        required: true,
                                        invalidMessage: "Kính gửi không được để trống !",
                                    },
                                    {},
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Mã số thuế",
                                        id: "mst",
                                        name: "mst",
                                        required: true,
                                        invalidMessage: "Tên người nộp thuế không được để trống !",
                                    },
                                    {
                                        view: "text",
                                        label: "Mã đơn vị quan hệ ngân sách",
                                        id: "mdvqhnsach",
                                        name: "mdvqhnsach",
                                        labelWidth: 200,
                                        //required: true,
                                        //invalidMessage: "Tên người nộp thuế không được để trống !",
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Tên người nộp thuế",
                                        labelWidth: 150,
                                        required: true,
                                        invalidMessage: "Tên người nộp thuế không được để trống !",
                                        id: "tnnt",
                                        name: "tnnt",
                                    },
                                    {
                                        id: "loaihd",
                                        name: "loaihd",
                                        width: 150,
                                        value: 1,
                                        hidden: true,
                                        editor: "text",
                                    },
                                    {
                                        id: "mcqt",
                                        name: "mcqt",
                                        label: "Mã cơ quan thuế",
                                        labelWidth: 150,
                                        required: true,
                                        invalidMessage: "Mã cơ quan thuế quản lý không được để trống !",
                                        view: "text",
                                        attributes: { maxlength: 5 },
                                        readonly: true,
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Địa danh",
                                        labelWidth: 150,
                                        id: "ddanh",
                                        name: "ddanh",
                                        required: true,
                                        invalidMessage: "Địa danh không được để trống !",
                                    },
                                ],
                            },
                        ],
                    },
                    { height: 3 },
                    { height: 3 },
                    {
                        rows: [
                            {
                                id: "btnHuyhoadon",
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " (F9)",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_hoadonhuy");
                                                var item = { id: webix.uid() };
                                                table.add(item);
                                                table.select(item.id, "khieu", false);
                                                table.edit({ row: item.id, column: "khieu" });
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " (F8)",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_hoadonhuy");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {},
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_hoadonhuy",
                                // height: 250,
                                name: "danhsach_hoadonhuy",
                                // select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                select: "cell",
                                scheme: {
                                    $init: function (obj) {},
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                    onBeforeEditStart: function (id) {
                                        if (id.column == "stt") {
                                            // block editors in 'year' column
                                            return false;
                                        } else if (id.column == "shdon") {
                                            return false;
                                        }
                                        // else if (id.column == "ladhddt") {
                                        //     return false;
                                        // }
                                        else if (id.column == "ngay") {
                                            return false;
                                        } else if (id.column == "huygiaitrinh") {
                                            return false;
                                        }
                                    },
                                },
                                columns: [
                                    { editor: "text", id: "hdon_id", name: "hdon_id", hidden: true },
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                    },
                                    {
                                        id: "khieu",
                                        header: _("Ký hiệu"),
                                        editor: "text",
                                        width: 250,
                                        editable: true,
                                        suggest: {
                                            view: "gridsuggest",
                                            // value_suggest: field.value_suggest,
                                            // fieldExpression: field.field_expression,
                                            // displayField: field.display_field,
                                            // tableId: "edit_inv_InvoiceDetail",
                                            columnName: "ky_hieu",
                                            body: {
                                                columns: [
                                                    { id: "id", hidden: true, header: "id" },
                                                    { id: _("khieu"), width: 120, header: "khieu" },
                                                    { id: _("shdon"), width: 350, header: "shdon" },
                                                ],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                                dataFeed: function (filtervalue, filter) {
                                                    if (filtervalue.length < 1) return;

                                                    var refid = this.config.refid;
                                                    var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF02010";
                                                    var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                    this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                },
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    var table = $$("danhsach_hoadonhuy");
                                                    var selectedItem = table.getSelectedItem();
                                                    selectedItem["shdon"] = obj["shdon"];
                                                    selectedItem["ngay"] = obj["nlap"];
                                                    selectedItem["huygiaitrinh"] = 1;
                                                    selectedItem["hdon_id"] = obj["id"];
                                                    selectedItem["ladhddt"] = 1;
                                                    selectedItem["tctbao"] = 1;
                                                    table.updateItem(selectedItem.id, selectedItem);
                                                },
                                            },
                                        },
                                    },
                                    {
                                        id: "shdon",
                                        name: "shdon",
                                        header: "Số biên lai",
                                        width: 200,
                                        editor: "text",
                                    },
                                    {
                                        id: "ngay",
                                        name: "ngay",
                                        header: "Ngày lập",
                                        width: 200,
                                        editor: "text",
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "tctbao",
                                        name: "tctbao",
                                        header: "Loại",
                                        editable: true,
                                        width: 200,
                                        editor: "combo",
                                        readonly: true,
                                        value: 1,
                                        options: [{ id: 1, value: "Hủy" }],
                                    },
                                    {
                                        id: "ldo",
                                        name: "ldo",
                                        header: "Lý do",
                                        editable: true,
                                        editor: "text",
                                        width: 300,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                shortcut: "F9",
                                view: "button",
                                id: "btnLuuTamHDDT",
                                label: "Lưu tạm(F9)",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            item.loaihd = 2;
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin biên lai cần hủy !", "error");
                                                    return;
                                                }
                                                var details = [];
                                                details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                                item["details"] = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                var tableDK = $$("huyhoadon");
                                                webix.extend(table, webix.ProgressBar);
                                                tableDK.disable();
                                                tableDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/huyhoadonSaveSignBienLai", data_post, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            // var json = JSON.parse(text);
                                                            // webix.message(json.ExceptionMessage, "error");
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Lưu thành công, trạng thái biên lai chỉ thay đổi khi ký biên bản !", "success");
                                                                if ($$("mau04_68")) {
                                                                    var table = $$("mau04_68");
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                }
                                                                $$("huyhoadonForms").close();
                                                                app.callEvent("dataChangedInvoie68", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                shortcut: "F10",
                                view: "button",
                                id: "btnGhiSignHuyHDDT",
                                label: "Ký(F10)",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            item.loaihd = 2;
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin biên lai cần hủy !", "error");
                                                    return;
                                                }
                                                var details = [];
                                                details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                                item["details"] = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                var tableDK = $$("huyhoadon");

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = "";
                                                        for (var i = 0; i < result.length; i++) {
                                                            var item = result[i];
                                                            kytaptrung = item.value;
                                                        }

                                                        webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                            var listcerts = JSON.parse(text);
                                                            if (listcerts.length > 0) {
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();

                                                                                var cert = null;

                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }

                                                                                var now = new Date();
                                                                                var begin = new Date(cert.begin_date);
                                                                                var end = new Date(cert.end_date);
                                                                                if (now < begin || now > end) {
                                                                                    webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                    return;
                                                                                }
                                                                                
                                                                                var postData = {
                                                                                    branch_code: user.getDvcsID(),
                                                                                    username: user.getCurrentUser(),
                                                                                    cer_serial: cert.cer_serial,
                                                                                };
                                                                                data_post.sign = postData;
                                                                                data_post.signMode = 1;

                                                                                webix.extend(tableDK, webix.ProgressBar);
                                                                                tableDK.disable();
                                                                                tableDK.showProgress();
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({ "Content-type": "application/json" })
                                                                                    .post(app.config.host + "/Invoice68/huyhoadonSaveSignBienLai", data_post, {
                                                                                        error: function (text, data, XmlHttpRequest) {
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            // var json = JSON.parse(text);
                                                                                            // webix.message(json.ExceptionMessage, "error");
                                                                                            webix.message(text + XmlHttpRequest, "error");
                                                                                        },
                                                                                        success: function (text, data, XmlHttpRequest) {
                                                                                            var json = JSON.parse(text);
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            if (!json.hasOwnProperty("error")) {
                                                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                                                if ($$("mau04_68")) {
                                                                                                    var table = $$("mau04_68");
                                                                                                    table.clearAll();
                                                                                                    table.load(table.config.url);
                                                                                                }
                                                                                                $$("huyhoadonForms").close();
                                                                                                app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                            } else {
                                                                                                webix.message(json.error, "error");
                                                                                            }
                                                                                        },
                                                                                    });

                                                                            // return;
                                                                        }
                                                                    },
                                                                });

                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}",
                                                                        },
                                                                        {
                                                                            id: "cert_type",
                                                                            header: _("Loại"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "cer_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 150,
                                                                        },
                                                                        {
                                                                            id: "subject_name",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "begin_date",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "end_date",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "issuer",
                                                                            header: _("DONVI"),
                                                                            width: 450,
                                                                        },
                                                                    ],
                                                                    url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                });
                                                            } else {
                                                                var table = $$("huyhoadon");
                                                                webix.extend(table, webix.ProgressBar);
                                                                table.disable();
                                                                table.showProgress();

                                                                // xem user có tích checkbox ký HSM không?
                                                                var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                                                webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                                                    if (resultscheckSigHSM[0].json() == "C") {
                                                                        var postData = {
                                                                            branch_code: user.getDvcsID(),
                                                                            username: user.getCurrentUser(),
                                                                            check_HSM: "1",
                                                                        };
                                                                        data_post.sign = postData;

                                                                        webix.extend(tableDK, webix.ProgressBar);
                                                                        tableDK.disable();
                                                                        tableDK.showProgress();
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/huyhoadonSaveSign", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    tableDK.enable();
                                                                                    tableDK.hideProgress();
                                                                                    // var json = JSON.parse(text);
                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);
                                                                                    tableDK.enable();
                                                                                    tableDK.hideProgress();
                                                                                    if (!json.hasOwnProperty("error")) {
                                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                                        if ($$("mau04_68")) {
                                                                                            var table = $$("mau04_68");
                                                                                            table.clearAll();
                                                                                            table.load(table.config.url);
                                                                                        }
                                                                                        $$("huyhoadonForms").close();
                                                                                        app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                    } else {
                                                                                        webix.message(json.error, "error");
                                                                                    }
                                                                                },
                                                                            });
                                                                    } else {
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/huyhoadonSave", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    table.enable();
                                                                                    table.hideProgress();
                                                                                    // var json = JSON.parse(text);
                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);

                                                                                    if (json.hasOwnProperty("error")) {
                                                                                        webix.message(json.error, "error");
                                                                                    } else {
                                                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlMau0405?id=" + json.id);
                                                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                                                        webix.promise.all([a, b, json]).then(function (results) {
                                                                                            // webix.extend(tblInvoice, webix.ProgressBar);
                                                                                            // tblInvoice.disable();
                                                                                            // tblInvoice.showProgress();
                                                                                            var json = results[0].json();

                                                                                            if (json.hasOwnProperty("error")) {
                                                                                                webix.message({ type: "error", text: json.error });
                                                                                            }

                                                                                            var listcerts = results[1].json();
                                                                                            var item = results[2];

                                                                                            if (listcerts.length == 0) {
                                                                                                table.enable();
                                                                                                table.hideProgress();
                                                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                                                return;
                                                                                            }

                                                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                                                var hub = plugin.hub();
                                                                                                var hubconnect = plugin.conn();
                                                                                                if (hubconnect.state != 1) {
                                                                                                    table.enable();
                                                                                                    table.hideProgress();
                                                                                                    webix.message(
                                                                                                        "Quý khách hàng chưa cài Plugin ký biên lai hoặc Plugin ký biên lai chưa được bật !",
                                                                                                        "error"
                                                                                                    );
                                                                                                    return;
                                                                                                }
                                                                                                hub.off("resCommand");
                                                                                                hub.on("resCommand", function (result) {
                                                                                                    var json = JSON.parse(result);

                                                                                                    if (json.hasOwnProperty("error")) {
                                                                                                        webix.message({ type: "error", text: json.error });
                                                                                                    } else {
                                                                                                        var parameters = {
                                                                                                            xml: json.xml,
                                                                                                            id: item.id,
                                                                                                            tthdon: 3,
                                                                                                        };

                                                                                                        webix
                                                                                                            .ajax()
                                                                                                            .headers({ "Content-Type": "application/json" })
                                                                                                            .post(app.config.host + "/Invoice68/SaveXmlMau0405", parameters, function (text) {
                                                                                                                var result = JSON.parse(text);
                                                                                                                if (result.hasOwnProperty("error")) {
                                                                                                                    webix.message(result.error, "error");
                                                                                                                } else {
                                                                                                                    app.callEvent("dataChangedInvoie68", [editmode, null]);

                                                                                                                    webix.message("Thành công !", "success");
                                                                                                                    if ($$("mau04_68")) {
                                                                                                                        var table = $$("mau04_68");
                                                                                                                        table.clearAll();
                                                                                                                        table.load(table.config.url);
                                                                                                                    }
                                                                                                                    webix.$$("huyhoadonForms").close();
                                                                                                                }
                                                                                                            });
                                                                                                    }
                                                                                                    table.enable();
                                                                                                    table.hideProgress();
                                                                                                });

                                                                                                var _listcerts = [];

                                                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                                                    var _cert = listcerts[i];

                                                                                                    _listcerts.push({
                                                                                                        so_serial: _cert.cer_serial,
                                                                                                        ngaybatdau: _cert.begin_date,
                                                                                                        ngayketthuc: _cert.end_date,
                                                                                                        issuer: _cert.issuer,
                                                                                                        subjectname: _cert.subject_name,
                                                                                                    });
                                                                                                }

                                                                                                var arg = {
                                                                                                    idData: "#data",
                                                                                                    xml: json["xml"],
                                                                                                    shdon: "",
                                                                                                    idSigner: "seller",
                                                                                                    tagSign: "NNT",
                                                                                                    dvky: json["dvky"],
                                                                                                    dateKy: json["dateKy"],
                                                                                                    listcerts: _listcerts,
                                                                                                };

                                                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                                                    .done(function () {
                                                                                                        console.log("Success !");
                                                                                                    })
                                                                                                    .fail(function (error) {
                                                                                                        webix.message(error, "error");
                                                                                                    });
                                                                                            });
                                                                                        });
                                                                                        // app.callEvent("dataChangedInvoie68", [editmode, null]);

                                                                                        // webix.message("Thành công !", "success");
                                                                                        // webix.$$("huyhoadonForms").close();
                                                                                    }
                                                                                },
                                                                            });
                                                                    }
                                                                });
                                                            }
                                                        });
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    app.callEvent("dataChangedInvoie68", [1, null]);
                                    webix.$$("huyhoadonForms").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix
                    .ajax()
                    .sync()
                    .get(app.config.host + "/System/GetDmDvcsByUser");
                var json = JSON.parse(result.response);

                // $$("dclhe").setValue(json[0].address);
                $$("tnnt").setValue(json[0].name);
                $$("mst").setValue(json[0].tax_code);
                $$("ddanh").setValue(json[0].city);
                //$$("tcqt").setValue(json[0].cqt);
                // $$("dctdtu").setValue(json[0].email);
                // $$("nlhe").setValue(json[0].manage);

                $$("tcqt").setValue(json[0].code2);
                $$("mcqt").setValue(json[0].code2);
                $$("tcqt_hidden").setValue(json[0].name2);
            } else {
                if (editmode == 2) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
        setValues: function (item, winconfig, params) {
            $$("danhsach_hoadonhuy").parse(item);
        },
        setValuesTongQuat: function (item, winconfig, params) {
            var data = $$("huyhoadon").getValues();
            data.so = item.so;
            data.ntbccqt = item.ntbccqt;
            data.loai = item.loai;
            $$("huyhoadon").parse(data);
        },
        setValuesEdit: function (item, winconfig, params) {
            $$("huyhoadon").parse(item);
        },
    };
});

define('views/68_mau0405_bienlai',["app", "locale", "models/user", "views/forms/68_huyhoadon_bienlai"], function (app, _, user, form_0405) {
    
    var param;
    webix.$$("title").parse({
        title: "Thông báo hủy và rà soát biên lai",
        details: "Bảng tổng hợp biên lai",
    });

    var initUI = function () {
        //var windowno = app.path[1].params[0];
        var table = webix.$$("mau04_68");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/getDatamau04";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                                filterType: column.header[1].content,
                            };
                            if (item.value != null && item.value != "") {
                                array.push(item);
                            }
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + encodeURIComponent(JSON.stringify(array)) ;
                    }
                }
                webix.ajax(url+"&loaihd=2", callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Thêm mới " + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(form_0405.$ui);
                    form_0405.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    var selectedItem = table.getSelectedItem();

                    var detailForm = this.$scope.ui(form_0405.$ui);

                    form_0405.setEditMode(2);
                    form_0405.setValuesEdit(selectedItem);
                    if (selectedItem.trang_thai == 1) {
                        var form = $$("huyhoadon").elements;
                        for (var key in form) {
                            var $el = form[key];
                            $el.define("readonly", "true");
                            $el.define("css", "mcls_readonly_text");
                            $el.refresh();
                        }

                        $$("danhsach_hoadonhuy").define("editable","false");
                        $$("danhsach_hoadonhuy").refresh();
                        $$("btnLuuTamHDDT").destructor();
                        $$("btnGhiSignHuyHDDT").destructor();
                    }
                    var tableDetail = webix.$$("danhsach_hoadonhuy");
                    var url = app.config.host + "/Invoice68/GetDataMau0405Detail?id=" + selectedItem.id;
                    tableDetail.clearAll();
                    tableDetail.load(url);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn khách hàng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã ký và gửi CQT bạn không thể xóa! ", "error");
                        return;
                    }
                    if (selectedItem.loai_tbao == "5") {
                        webix.message("Mẫu 05 nhận từ CQT bạn không thể xóa! ", "error");
                        return;
                    }

                    webix.confirm({
                        text: "Bạn có muốn xóa biên lai",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/deleteMau04", selectedItem, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            table.remove(selectedItem.id);
                                            table.enable();
                                            table.hideProgress();
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký") + "</span>",
            id: "btnSign",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("mau04_68");
                    var selectedItem = tableDK.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã ký, bạn không thể ký lại! ", "error");
                        return;
                    }

                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                            var result = JSON.parse(text);
                            var kytaptrung = "";
                            for (var i = 0; i < result.length; i++) {
                                var item = result[i];
                                kytaptrung = item.value;
                            }

                            webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                var listcerts = JSON.parse(text);
                                if (listcerts.length > 0) {
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();

                                                    var cert = null;

                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }

                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                        return;
                                                    }

                                                    var now = new Date();
                                                    var begin = new Date(cert.begin_date);
                                                    var end = new Date(cert.end_date);
                                                    if (now < begin || now > end) {
                                                        webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                        return;
                                                    }

                                                    var postData = {
                                                        branch_code: user.getDvcsID(),
                                                        username: user.getCurrentUser(),
                                                        cer_serial: cert.cer_serial,
                                                        id: selectedItem.id,
                                                    };

                                                    webix.extend(tableDK, webix.ProgressBar);
                                                    tableDK.disable();
                                                    tableDK.showProgress();
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(app.config.host + "/Invoice68/huyhoadonSign", postData, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                tableDK.enable();
                                                                tableDK.hideProgress();
                                                                // var json = JSON.parse(text);
                                                                // webix.message(json.ExceptionMessage, "error");
                                                                webix.message(text + XmlHttpRequest, "error");
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(text);
                                                                tableDK.enable();
                                                                tableDK.hideProgress();
                                                                if (!json.hasOwnProperty("error")) {
                                                                    webix.message("Ký thành công !", "success");
                                                                    // $$("huyhoadonForms").close();
                                                                    app.callEvent("dataChangedMau0405", [1, null]);
                                                                } else {
                                                                    webix.message(json.error, "error");
                                                                }
                                                            },
                                                        });

                                                // return;
                                            }
                                        },
                                    });

                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon",
                                                header: _("CHON"),
                                                width: 65,
                                                checkValue: true,
                                                uncheckValue: false,
                                                template: "{common.checkbox()}",
                                            },
                                            {
                                                id: "cert_type",
                                                header: _("Loại"),
                                                width: 450,
                                            },
                                            {
                                                id: "cer_serial",
                                                header: _("SO_SERIAL"),
                                                width: 150,
                                            },
                                            {
                                                id: "subject_name",
                                                header: _("SUBJECTNAME"),
                                                width: 450,
                                            },
                                            {
                                                id: "begin_date",
                                                header: _("NGAY_BAT_DAU"),
                                                width: 200,
                                            },
                                            {
                                                id: "end_date",
                                                header: _("NGAY_KET_THUC"),
                                                width: 200,
                                            },
                                            {
                                                id: "issuer",
                                                header: _("DONVI"),
                                                width: 450,
                                            },
                                        ],
                                        url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                    });
                                } else {
                                    var table = $$("mau04_68");
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    // xem user có tích checkbox ký HSM không?
                                    var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                    webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                        if (resultscheckSigHSM[0].json() == "C") {
                                            var postData = {
                                                branch_code: user.getDvcsID(),
                                                username: user.getCurrentUser(),
                                                id: selectedItem.id,
                                                check_HSM: "1",
                                            };

                                            webix.extend(tableDK, webix.ProgressBar);
                                            tableDK.disable();
                                            tableDK.showProgress();
                                            webix
                                                .ajax()
                                                .headers({ "Content-type": "application/json" })
                                                .post(app.config.host + "/Invoice68/huyhoadonSign", postData, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        tableDK.enable();
                                                        tableDK.hideProgress();
                                                        // var json = JSON.parse(text);
                                                        // webix.message(json.ExceptionMessage, "error");
                                                        webix.message(text + XmlHttpRequest, "error");
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text);
                                                        tableDK.enable();
                                                        tableDK.hideProgress();
                                                        if (!json.hasOwnProperty("error")) {
                                                            webix.message("Ký thành công !", "success");
                                                            // $$("huyhoadonForms").close();
                                                            app.callEvent("dataChangedMau0405", [1, null]);
                                                        } else {
                                                            webix.message(json.error, "error");
                                                        }
                                                    },
                                                });
                                        } else {
                                            var a = webix.ajax(app.config.host + "/Invoice68/XmlMau0405?id=" + selectedItem.id);
                                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                            webix.promise.all([a, b, selectedItem]).then(function (results) {
                                                // webix.extend(tblInvoice, webix.ProgressBar);
                                                // tblInvoice.disable();
                                                // tblInvoice.showProgress();
                                                var json = results[0].json();

                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                }

                                                var listcerts = results[1].json();
                                                var item = results[2];

                                                if (listcerts.length == 0) {
                                                    table.enable();
                                                    table.hideProgress();
                                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                    return;
                                                }

                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();
                                                    if (hubconnect.state != 1) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký biên lai hoặc Plugin ký biên lai chưa được bật !", "error");
                                                        return;
                                                    }
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (result) {
                                                        var json = JSON.parse(result);

                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: "error", text: json.error });
                                                        } else {
                                                            var parameters = {
                                                                xml: json.xml,
                                                                id: selectedItem.id,
                                                                tthdon: 3,
                                                            };

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlMau0405", parameters, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        webix.message("Ký thành công !", "success");
                                                                        // $$("huyhoadonForms").close();
                                                                        app.callEvent("dataChangedMau0405", [1, null]);
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    });

                                                    var _listcerts = [];

                                                    for (var i = 0; i < listcerts.length; i++) {
                                                        var _cert = listcerts[i];

                                                        _listcerts.push({
                                                            so_serial: _cert.cer_serial,
                                                            ngaybatdau: _cert.begin_date,
                                                            ngayketthuc: _cert.end_date,
                                                            issuer: _cert.issuer,
                                                            subjectname: _cert.subject_name,
                                                        });
                                                    }

                                                    var arg = {
                                                        idData: "#data",
                                                        xml: json["xml"],
                                                        shdon: "",
                                                        idSigner: "seller",
                                                        tagSign: "NNT",
                                                        dvky: json["dvky"],
                                                        dateKy: json["dateKy"],
                                                        listcerts: _listcerts,
                                                    };

                                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success !");
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                        });
                                                });
                                            });
                                            // app.callEvent("dataChangedInvoie68", [editmode, null]);

                                            // webix.message("Thành công !", "success");
                                            // webix.$$("huyhoadonForms").close();
                                        }
                                    });
                                }
                            });
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "mau04_68",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    scrollX: true,
                    cells: [
                        {
                            header: "Chi tiết biên lai",
                            body: {
                                view: "datatable",
                                height: 200,
                                resizeColumn: true,
                                // scroll: true,
                                id: "mau04_68_chitiet",
                                headerRowHeight: 50,
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.index = i + 1;
                                        });
                                    },
                                },
                                columns: [
                                    {
                                        view: "text",
                                        id: "mau04_id",
                                        name: "mau04_id",
                                        hidden: true,
                                    },
                                    {
                                        view: "text",
                                        id: "mau04_chitiet_id",
                                        name: "mau04_chitiet_id",
                                        hidden: true,
                                    },
                                    {
                                        view: "text",
                                        header: "STT",
                                        id: "index",
                                        name: "index",
                                        width: 80,
                                    },
                                    {
                                        header: "Mẫu số",
                                        id: "mau_so",
                                        width: 120,
                                        // template: function (obj) {
                                        //     return obj.khieu.toString().substring(0, 1);
                                        // },
                                    },

                                    {
                                        id: "khieu",
                                        name: "khieu",
                                        header: "Ký hiệu",
                                        width: 150,
                                    },
                                    {
                                        id: "shdon",
                                        name: "shdon",
                                        header: "Số biên lai",
                                        width: 120,
                                    },
                                    {
                                        id: "ngay",
                                        name: "ngay",
                                        header: "Ngày lập",
                                        width: 120,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "tctbao",
                                        name: "tctbao",
                                        header: "Hủy/Điều chỉnh/Thay thế/Giải trình",
                                        editable: true,
                                        width: 200,
                                        template: function (obj) {
                                            switch (obj.tctbao) {
                                                case 1:
                                                    return "Hủy";
                                                case 3:
                                                    return "Thay thế";
                                                case 4:
                                                    return "Giải trình";
                                                case 5:
                                                    return "Điều chỉnh tăng";
                                                case 6:
                                                    return "Điều chỉnh giảm";
                                                case 7:
                                                    return "Điều chỉnh khác";
                                                default:
                                                    break;
                                            }
                                        },
                                    },
                                    {
                                        id: "ldo",
                                        name: "ldo",
                                        header: "Lý do",
                                        width: 250,
                                    },
                                ],
                                data: [
                                    {
                                        index: 1,
                                        khieu: "1KT20YY",
                                        shdon: "0000001",
                                        ngay: new Date(),
                                        ladhddt: "1",
                                        ldo: "Sai thông tin",
                                    },
                                    {
                                        index: 2,
                                        khieu: "1KT20YY",
                                        shdon: "0000002",
                                        ngay: new Date(),
                                        ladhddt: "1",
                                        ldo: "Sai tiền",
                                    },
                                ],
                                // scrollX: false,
                                // autoheight: true,
                            },
                        },
                    ],
                },
                scheme: {
                    $init: function () {
                        // this.data.each(function (obj, i) {
                        //     obj.index = i + 1;
                        // });
                    },
                },
                onClick: {
                    // ShowHistory: function (event, cell, target){
                    //     debugger
                    //     var table = webix.$$("mau04_68");
                    //     var win = table.$scope.ui(hoadonHistory.$ui);
                    //     var hdon_id = cell.row;
                    //     hoadonHistory.setEditMode(hdon_id);
                    //     win.show();
                    // },
                    Dowload0405: function (event, cell, target) {
                        var win = webix.$$("mau04_68");
                        var record = win.getItem(cell.row);

                        if (record.loai_tbao != "5") {
                            if (record.trang_thai != 1) {
                                webix.message("Mẫu chưa được ký không thể tải !", "error");
                                return;
                            }
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = record.loai_tbao == "5" ? "Mau05.xml" : "Mau04.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLMau04?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        return false; // here it blocks the default behavior
                    },
                    Dowload0405Rep: function (event, cell, target) {
                        var win = webix.$$("mau04_68");
                        var record = win.getItem(cell.row);

                        if (record.loai_tbao != "5") {
                            if (record.trang_thai != 1) {
                                webix.message("Mẫu chưa được ký không thể tải !", "error");
                                return;
                            }
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = record.loai_tbao == "5" ? "Mau05Rep.xml" : "Mau04Rep.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLMau04Rep?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        return false; // here it blocks the default behavior
                    },
                    InMau0405: function (event, cell, target) {
                        var table = webix.$$("mau04_68");
                        var item = table.getItem(cell.row);

                        //webix.message("Chưa có mẫu in ...", "error");
                        // var rpParameter = null;
                        var box = webix.modalbox({
                            title: "Đang in biên lai ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>biên lai điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau04?id=" + item.id + "&type=PDF&loai=" + item.loai_tbao, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    InMau0405Rep: function (event, cell, target) {
                        var table = webix.$$("mau04_68");
                        var item = table.getItem(cell.row);

                        //webix.message("Chưa có mẫu in ...", "error");
                        // var rpParameter = null;
                        // var box = webix.modalbox({
                        //     title: "Đang in biên lai ....",
                        //     text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        //     width: 350,
                        //     height: 200,
                        // });

                        //  var newWin = window.open();
                        // var html =
                        //     "<html><head><title>biên lai điện tử MobiFone Invoice</title>" +
                        //     '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        //     '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        //     '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        // newWin.document.write(html);

                        webix
                            .ajax()
                            .sync()
                            .get(app.config.host + "/Invoice68/inMau04SS?id=" + item.id, function (text) {
                                var result = text.replace(new RegExp("\\" + "\\", "gi"), "");
                                var newWin = window.open();
                                var html =
                                    "<html><head><title>biên lai điện tử MobiFone Invoice</title>" +
                                    '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                                    '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                                    "</head><body>" +
                                    '<center><div id="divprint">' +
                                    result +
                                    "</div></center>" +
                                    "</body></html>";
                                newWin.document.write(html);
                            });
                    },
                },
                on: {
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("mau04_68_chitiet");
                            var url = app.config.host + "/Invoice68/GetDataMau0405Detail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {},
                },
                columns: [
                    {
                        id: "mau04_id",
                        header: "mau04_id",
                        hidden: true,
                    },
                    {
                        template: "{common.subrow()}",
                        width: 50,
                    },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "shdon",
                        header: [
                            "Số biên lai",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 200,
                    },
                    {
                        id: "khieu",
                        header: [
                            "Ký hiệu",
                            {
                                content: "selectFilter",
                            },
                        ],

                        width: 200,
                    },
                    {
                        id: "loai_tbao",
                        header: [
                            "Loại thông báo",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 200,
                        template: function (obj) {
                            return obj.loai_tbao == "5" ? "biên lai cần rà soát" : "Thông báo biên lai sai sót";
                        },
                    },
                    {
                        id: "trang_thai",
                        header: [
                            "Trạng thái",
                            {
                                content: "serverSelectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "0", value: "Chưa ký" },
                                    { id: "1", value: "Đã ký" },
                                ],
                            },
                        ],
                        width: 150,
                        template: function (obj) {

                            return obj.trang_thai == 1
                                ? "<span style='color: #00b300'><i class='fas fa-check'></i></span> Đã ký"
                                : "<span style='color: red'><i class='fas fa-times'></i></span> Chưa ký";
                        },
                    },
                    {
                        id: "ntbao",
                        header: [
                            "Ngày tạo",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 120,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: { "text-align": "center" },
                        columnType: "datetime",
                    },
                    {
                        id: "Dowload0405",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        width: 120,
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='Dowload0405' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='Dowload0405' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                    },
                    {
                        id: "btnInMau0405",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='InMau0405' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau0405' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 120,
                    },
                ],
                // data: [
                //     {
                //         stt: 1,
                //         loai_tb: "4",
                //         trang_thai: "Chờ duyệt",
                //         mso: "001",
                //         ntbao: new Date(),
                //         nguoi_gui: "ADMINNISTRATOR"
                //     },
                //     {
                //         stt: 2,
                //         loai_tb: "5",
                //         trang_thai: "Chờ duyệt",
                //         mso: "002",
                //         ntbao: new Date(),
                //         nguoi_gui: "ADMINNISTRATOR"
                //     }
                // ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("mau04_68");

            $scope.on(app, "dataChangedMau0405", function (mode, item) {
                // if (mode == 1) {
                //     table.add(item);
                // }
                // if (mode == 5) {
                table.clearAll();
                table.load(table.config.url);
                // }
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_huyhoadon_tncn',["app", "locale", "models/user", "views/forms/68_invoiceForms"], function (app, _, user, invoiceForms) {
    

    var editmode = 0;

    function listToTreeCustomize(json) {
        return json.map(function(item) {
            return {
                id: item.code,
                name: item.name != null ? item.name.toString() : "",
                code: item.code
            };
        });
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>THÔNG BÁO CHỨNG TỪ ĐIỆN TỬ ĐÃ LẬP SAI<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_dksdForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "huyhoadonForms",
            resize: true,
            width: 1100,
            height: 600,
            // fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {},
            },
            body: {
                view: "form",
                id: "huyhoadon",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        // id: "header",
                        template: "<center><b><span style='font-size:17px;'>THÔNG BÁO CHỨNG TỪ ĐIỆN TỬ ĐÃ LẬP SAI</b></center>",
                        borderless: true,
                        height: 40,
                    },
                    {
                        paddingX: 30,
                        rows: [
                            {
                                cols: [
                                    {},
                                    {
                                        view: "text",
                                        id: "tcqt_hidden",
                                        name: "tcqt",
                                        hidden: true
                                    },
                                    {
                                        label: "Kính gửi: ",
                                        id: "tcqt",
                                        view: "combo",
                                        valueField: "name", // Chỉ định rõ ràng rằng combo sẽ lấy giá trị từ trường name                                        width: 300,
                                        labelWidth: 100,
                                        width: 300,
                                        options: {
                                            view: "gridsuggest",
                                            columnName: "name",
                                            url: {
                                                $proxy: true,
                                                load: function (view, callback, params) {
                                                    var url = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00251";
                                                    webix.ajax(url, function (text) {
                                                        var json = JSON.parse(text);
                                                        var data = listToTreeCustomize(json);
                                                        view.parse(data, "json");
                                                    });
                                                },
                                            },
                                            body: {
                                                columns: [ { id: "name", width: 225, header: "Tên" }, { id: "code", width: 100, header: "Mã" }],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    $$("tcqt_hidden").setValue(obj["name"]); // Lưu item.name vào trường ẩn
                                                    $$("tcqt_hidden").refresh();

                                                    $$("mcqt").setValue(obj["code"]);
                                                    $$("mcqt").refresh();
                                                },
                                            },
                                        },
                                        required: true,
                                        invalidMessage: "Kính gửi không được để trống !",
                                    },
                                    {},
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Mã số thuế",
                                        id: "mst",
                                        name: "mst",
                                        required: true,
                                        invalidMessage: "Mã số thuế không được để trống !",
                                    },
                                    {
                                        view: "text",
                                        label: "Mã đơn vị quan hệ ngân sách",
                                        id: "mdvqhnsach",
                                        name: "mdvqhnsach",
                                        labelWidth: 200,
                                        //required: true,
                                        //invalidMessage: "Tên người nộp thuế không được để trống !",
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Tên người nộp thuế",
                                        labelWidth: 150,
                                        required: true,
                                        invalidMessage: "Tên người nộp thuế không được để trống !",
                                        id: "tnnt",
                                        name: "tnnt",
                                    },
                                    {
                                        id: "loaihd",
                                        name: "loaihd",
                                        width: 150,
                                        value: 3,
                                        hidden: true,
                                        editor: "text",
                                    },
                                    {
                                        id: "mcqt",
                                        name: "mcqt",
                                        label: "Mã cơ quan thuế",
                                        labelWidth: 150,
                                        required: true,
                                        invalidMessage: "Mã cơ quan thuế quản lý không được để trống !",
                                        view: "text",
                                        attributes: { maxlength: 5 },
                                        readonly: true,
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Địa danh",
                                        labelWidth: 150,
                                        id: "ddanh",
                                        name: "ddanh",
                                        required: true,
                                        invalidMessage: "Địa danh không được để trống !",
                                    },
                                ],
                            },
                        ],
                    },
                    { height: 3 },
                    { height: 3 },
                    {
                        rows: [
                            {
                                id: "btnHuyhoadon",
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " (F9)",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_hoadonhuy");
                                                var item = { id: webix.uid() };
                                                table.add(item);
                                                table.select(item.id, "khieu", false);
                                                table.edit({ row: item.id, column: "khieu" });
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true,
                                        label: " (F8)",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_hoadonhuy");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {},
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_hoadonhuy",
                                // height: 250,
                                name: "danhsach_hoadonhuy",
                                // select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                select: "cell",
                                scheme: {
                                    $init: function (obj) {},
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                    onBeforeEditStart: function (id) {
                                        if (id.column == "stt") {
                                            // block editors in 'year' column
                                            return false;
                                        } else if (id.column == "shdon") {
                                            return false;
                                        }
                                        // else if (id.column == "ladhddt") {
                                        //     return false;
                                        // }
                                        else if (id.column == "khmbl") {
                                            return false;
                                        }
                                        else if (id.column == "ngay") {
                                            return false;
                                        } else if (id.column == "huygiaitrinh") {
                                            return false;
                                        }
                                    },
                                },
                                columns: [
                                    { editor: "text", id: "hdon_id", name: "hdon_id", hidden: true },
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                    },
                                    {
                                        id: "khieu",
                                        header: _("Ký hiệu"),
                                        editor: "text",
                                        width: 250,
                                        editable: true,
                                        suggest: {
                                            view: "gridsuggest",
                                            // value_suggest: field.value_suggest,
                                            // fieldExpression: field.field_expression,
                                            // displayField: field.display_field,
                                            // tableId: "edit_inv_InvoiceDetail",
                                            columnName: "ky_hieu",
                                            body: {
                                                columns: [
                                                    { id: "id", hidden: true, header: "id" },
                                                    { id: _("khieu"), width: 120, header: "khieu" },
                                                    { id: _("shdon"), width: 120, header: "shdon" },
                                                    { id: _("khmbl"), width: 120, header: "khmbl" },
                                                ],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                                dataFeed: function (filtervalue, filter) {
                                                    if (filtervalue.length < 1) return;

                                                    var refid = this.config.refid;
                                                    var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00213";
                                                    var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                    this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                },
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    var table = $$("danhsach_hoadonhuy");
                                                    var selectedItem = table.getSelectedItem();
                                                    selectedItem["shdon"] = obj["shdon"];
                                                    selectedItem["khmbl"] = obj["khmbl"];
                                                    selectedItem["ngay"] = obj["nlap"];
                                                    selectedItem["huygiaitrinh"] = 1;
                                                    selectedItem["hdon_id"] = obj["id"];
                                                    selectedItem["ladhddt"] = 1;
                                                    selectedItem["tctbao"] = 0;
                                                    table.updateItem(selectedItem.id, selectedItem);
                                                },
                                            },
                                        },
                                    },
                                    {
                                        id: "khmbl",
                                        name: "khmbl",
                                        header: "Ký hiệu mẫu chứng từ",
                                        width: 200,
                                        editor: "text",
                                    },
                                    {
                                        id: "shdon",
                                        name: "shdon",
                                        header: "Số chứng từ",
                                        width: 200,
                                        editor: "text",
                                    },
                                    {
                                        id: "ngay",
                                        name: "ngay",
                                        header: "Ngày lập",
                                        width: 200,
                                        editor: "text",
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "tctbao",
                                        name: "tctbao",
                                        header: "Loại",
                                        editable: true,
                                        width: 200,
                                        editor: "combo",
                                        readonly: true,
                                        value: 0,
                                        hidden: true,
                                        options: [{ id: 1, value: "Hủy" }],
                                    },
                                    {
                                        id: "ladhddt",
                                        name: "ladhddt",
                                        header: "Loại chứng từ điện tử",
                                        editable: false,
                                        width: 400,
                                        editor: "combo",
                                        require: true,
                                        options: [
                                            { id: 1, value: "Chứng từ điện tử khấu trừ thuế TNCN theo Nghị định 70" },
                                            { id: 2, value: "Chứng từ điện tử khấu trừ thuế đối với hoạt động kinh doanh trên nền tảng thương mại điện tử, nền tảng số" },
                                            { id: 7, value: "Chứng từ khấu trừ thuế TNCN theo Nghị định số 123/2020/NĐ-CP" }
                                        ],
                                    },
                                    {
                                        id: "ldo",
                                        name: "ldo",
                                        header: "Lý do",
                                        editable: true,
                                        editor: "text",
                                        width: 300,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                shortcut: "F9",
                                view: "button",
                                id: "btnLuuTamHDDT",
                                label: "Lưu tạm(F9)",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            item.loaihd = 3;
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin chứng từ cần hủy !", "error");
                                                    return;
                                                }
                                                var details = [];
                                                details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                                item["details"] = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                var tableDK = $$("huyhoadon");
                                                webix.extend(table, webix.ProgressBar);
                                                tableDK.disable();
                                                tableDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/huyhoadonSaveSignTncn", data_post, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            // var json = JSON.parse(text);
                                                            // webix.message(json.ExceptionMessage, "error");
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Lưu thành công, trạng thái chứng từ chỉ thay đổi khi ký biên bản !", "success");
                                                                if ($$("mau04_68")) {
                                                                    var table = $$("mau04_68");
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                }
                                                                $$("huyhoadonForms").close();
                                                                app.callEvent("dataChangedInvoie68", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                shortcut: "F10",
                                view: "button",
                                id: "btnGhiSignHuyHDDT",
                                label: "Ký gửi CQT(F10)",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            item.loaihd = 3;
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin chứng từ cần hủy !", "error");
                                                    return;
                                                }
                                                var details = [];
                                                details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                                item["details"] = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                var tableDK = $$("huyhoadon");

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = "";
                                                        for (var i = 0; i < result.length; i++) {
                                                            var item = result[i];
                                                            kytaptrung = item.value;
                                                        }

                                                        webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                            var listcerts = JSON.parse(text);
                                                            if (listcerts.length > 0) {
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();

                                                                                var cert = null;

                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }

                                                                                var now = new Date();
                                                                                var begin = new Date(cert.begin_date);
                                                                                var end = new Date(cert.end_date);
                                                                                if (now < begin || now > end) {
                                                                                    webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                    return;
                                                                                }
                                                                                
                                                                                var postData = {
                                                                                    branch_code: user.getDvcsID(),
                                                                                    username: user.getCurrentUser(),
                                                                                    cer_serial: cert.cer_serial,
                                                                                };
                                                                                data_post.sign = postData;
                                                                                data_post.signMode = 1;

                                                                                webix.extend(tableDK, webix.ProgressBar);
                                                                                tableDK.disable();
                                                                                tableDK.showProgress();
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({ "Content-type": "application/json" })
                                                                                    .post(app.config.host + "/Invoice68/huyhoadonSaveSignTncn", data_post, {
                                                                                        error: function (text, data, XmlHttpRequest) {
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            // var json = JSON.parse(text);
                                                                                            // webix.message(json.ExceptionMessage, "error");
                                                                                            webix.message(text + XmlHttpRequest, "error");
                                                                                        },
                                                                                        success: function (text, data, XmlHttpRequest) {
                                                                                            var json = JSON.parse(text);
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            if (!json.hasOwnProperty("error")) {
                                                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                                                if ($$("mau04_68")) {
                                                                                                    var table = $$("mau04_68");
                                                                                                    table.clearAll();
                                                                                                    table.load(table.config.url);
                                                                                                }
                                                                                                $$("huyhoadonForms").close();
                                                                                                app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                            } else {
                                                                                                webix.message(json.error, "error");
                                                                                            }
                                                                                        },
                                                                                    });

                                                                            // return;
                                                                        }
                                                                    },
                                                                });

                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}",
                                                                        },
                                                                        {
                                                                            id: "cert_type",
                                                                            header: _("Loại"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "cer_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 150,
                                                                        },
                                                                        {
                                                                            id: "subject_name",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "begin_date",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "end_date",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "issuer",
                                                                            header: _("DONVI"),
                                                                            width: 450,
                                                                        },
                                                                    ],
                                                                    url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                });
                                                            } else {
                                                                var table = $$("huyhoadon");
                                                                webix.extend(table, webix.ProgressBar);
                                                                table.disable();
                                                                table.showProgress();

                                                                // xem user có tích checkbox ký HSM không?
                                                                var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                                                webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                                                    if (resultscheckSigHSM[0].json() == "C") {
                                                                        var postData = {
                                                                            branch_code: user.getDvcsID(),
                                                                            username: user.getCurrentUser(),
                                                                            check_HSM: "1",
                                                                        };
                                                                        data_post.sign = postData;

                                                                        webix.extend(tableDK, webix.ProgressBar);
                                                                        tableDK.disable();
                                                                        tableDK.showProgress();
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/huyhoadonSaveSign", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    tableDK.enable();
                                                                                    tableDK.hideProgress();
                                                                                    // var json = JSON.parse(text);
                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);
                                                                                    tableDK.enable();
                                                                                    tableDK.hideProgress();
                                                                                    if (!json.hasOwnProperty("error")) {
                                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                                        if ($$("mau04_68")) {
                                                                                            var table = $$("mau04_68");
                                                                                            table.clearAll();
                                                                                            table.load(table.config.url);
                                                                                        }
                                                                                        $$("huyhoadonForms").close();
                                                                                        app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                    } else {
                                                                                        webix.message(json.error, "error");
                                                                                    }
                                                                                },
                                                                            });
                                                                    } else {
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/huyhoadonSave", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    table.enable();
                                                                                    table.hideProgress();
                                                                                    // var json = JSON.parse(text);
                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);

                                                                                    if (json.hasOwnProperty("error")) {
                                                                                        webix.message(json.error, "error");
                                                                                    } else {
                                                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlMau0405?id=" + json.id);
                                                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                                                        webix.promise.all([a, b, json]).then(function (results) {
                                                                                            // webix.extend(tblInvoice, webix.ProgressBar);
                                                                                            // tblInvoice.disable();
                                                                                            // tblInvoice.showProgress();
                                                                                            var json = results[0].json();

                                                                                            if (json.hasOwnProperty("error")) {
                                                                                                webix.message({ type: "error", text: json.error });
                                                                                            }

                                                                                            var listcerts = results[1].json();
                                                                                            var item = results[2];

                                                                                            if (listcerts.length == 0) {
                                                                                                table.enable();
                                                                                                table.hideProgress();
                                                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                                                return;
                                                                                            }

                                                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                                                var hub = plugin.hub();
                                                                                                var hubconnect = plugin.conn();
                                                                                                if (hubconnect.state != 1) {
                                                                                                    table.enable();
                                                                                                    table.hideProgress();
                                                                                                    webix.message(
                                                                                                        "Quý khách hàng chưa cài Plugin ký chứng từ hoặc Plugin ký chứng từ chưa được bật !",
                                                                                                        "error"
                                                                                                    );
                                                                                                    return;
                                                                                                }
                                                                                                hub.off("resCommand");
                                                                                                hub.on("resCommand", function (result) {
                                                                                                    var json = JSON.parse(result);

                                                                                                    if (json.hasOwnProperty("error")) {
                                                                                                        webix.message({ type: "error", text: json.error });
                                                                                                    } else {
                                                                                                        var parameters = {
                                                                                                            xml: json.xml,
                                                                                                            id: item.id,
                                                                                                            tthdon: 3,
                                                                                                        };

                                                                                                        webix
                                                                                                            .ajax()
                                                                                                            .headers({ "Content-Type": "application/json" })
                                                                                                            .post(app.config.host + "/Invoice68/SaveXmlMau0405", parameters, function (text) {
                                                                                                                var result = JSON.parse(text);
                                                                                                                if (result.hasOwnProperty("error")) {
                                                                                                                    webix.message(result.error, "error");
                                                                                                                } else {
                                                                                                                    app.callEvent("dataChangedInvoie68", [editmode, null]);

                                                                                                                    webix.message("Thành công !", "success");
                                                                                                                    if ($$("mau04_68")) {
                                                                                                                        var table = $$("mau04_68");
                                                                                                                        table.clearAll();
                                                                                                                        table.load(table.config.url);
                                                                                                                    }
                                                                                                                    webix.$$("huyhoadonForms").close();
                                                                                                                }
                                                                                                            });
                                                                                                    }
                                                                                                    table.enable();
                                                                                                    table.hideProgress();
                                                                                                });

                                                                                                var _listcerts = [];

                                                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                                                    var _cert = listcerts[i];

                                                                                                    _listcerts.push({
                                                                                                        so_serial: _cert.cer_serial,
                                                                                                        ngaybatdau: _cert.begin_date,
                                                                                                        ngayketthuc: _cert.end_date,
                                                                                                        issuer: _cert.issuer,
                                                                                                        subjectname: _cert.subject_name,
                                                                                                    });
                                                                                                }

                                                                                                var arg = {
                                                                                                    idData: "#data",
                                                                                                    xml: json["xml"],
                                                                                                    shdon: "",
                                                                                                    idSigner: "seller",
                                                                                                    tagSign: "NNT",
                                                                                                    dvky: json["dvky"],
                                                                                                    dateKy: json["dateKy"],
                                                                                                    listcerts: _listcerts,
                                                                                                };

                                                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                                                    .done(function () {
                                                                                                        console.log("Success !");
                                                                                                    })
                                                                                                    .fail(function (error) {
                                                                                                        webix.message(error, "error");
                                                                                                    });
                                                                                            });
                                                                                        });
                                                                                        // app.callEvent("dataChangedInvoie68", [editmode, null]);

                                                                                        // webix.message("Thành công !", "success");
                                                                                        // webix.$$("huyhoadonForms").close();
                                                                                    }
                                                                                },
                                                                            });
                                                                    }
                                                                });
                                                            }
                                                        });
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    app.callEvent("dataChangedInvoie68", [1, null]);
                                    webix.$$("huyhoadonForms").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix
                    .ajax()
                    .sync()
                    .get(app.config.host + "/System/GetDmDvcsByUser");
                var json = JSON.parse(result.response);

                // $$("dclhe").setValue(json[0].address);
                $$("tnnt").setValue(json[0].name);
                $$("mst").setValue(json[0].tax_code);
                $$("ddanh").setValue(json[0].city);
                //$$("tcqt").setValue(json[0].cqt);
                // $$("dctdtu").setValue(json[0].email);
                // $$("nlhe").setValue(json[0].manage);

                $$("tcqt").setValue(json[0].code2);
                $$("mcqt").setValue(json[0].code2);
                $$("tcqt_hidden").setValue(json[0].name2);
            } else {
                if (editmode == 2) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
          setValues: function (item, winconfig, params) {
            if(item.detail == null){
                $$("danhsach_hoadonhuy").parse(item);
            }
            else
            {
                $$("danhsach_hoadonhuy").parse(item.detail);
                $$("huyhoadon").parse(item);
            }
            
            //$$("huyhoadon").parse(item);
            //var ladhddt = item.detail[0].ladhddt;
            // if (ladhddt === 3) {
            //     $$("lhdon").define("value", "1");
            //     $$("lhdon").disable();
            // } else {
            //     $$("lhdon").define("value", "2");
            //     $$("lhdon").disable();
            //     $$("danhsach_hoadonhuy").hideColumn("mau_so");
            //     $$("danhsach_hoadonhuy").showColumn("mcqtcap");
            // }
        },
        setValuesTongQuat: function (item, winconfig, params) {
            var data = $$("huyhoadon").getValues();
            data.so = item.so;
            data.ntbccqt = item.ntbccqt;
            data.loai = item.loai;
            $$("huyhoadon").parse(data);
        },
        setValuesEdit: function (item, winconfig, params) {
            $$("huyhoadon").parse(item);
        },
    };
});

define('views/68_mau0405_tncn',["app", "locale", "models/user", "views/commonHD", "views/forms/68_huyhoadon_tncn"], function (app, _, user, commonHD, form_0405) {
    
    var param;
    webix.$$("title").parse({
        title: "Thông báo hủy và rà soát chứng từ",
        details: "Bảng tổng hợp chứng từ",
    });

    var initUI = function () {
        var table = webix.$$("mau04_68");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/getDatamau04";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                                filterType: column.header[1].content,
                            };

                            if (item.value != null && item.value != "") {
                                array.push(item);
                            }
                        }

                        url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                    }
                }
                webix.ajax(url+"&loaihd=3", callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 200,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Thêm mới" + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(form_0405.$ui);
                    form_0405.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn chứng từ ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã ký và gửi CQT bạn không thể sửa! ", "error");
                        return;
                    }

                    if (selectedItem.loai_tbao == "5") {
                        webix.message("Mẫu 05 nhận từ CQT bạn không thể sửa! ", "error");
                        return;
                    }
                    // if (selectedItem.is_hdon78 == 1) {
                    //     webix.message("Mẫu được này không được chỉnh sửa");
                    //     return;
                    // }

                    var detailForm = this.$scope.ui(form_0405.$ui);
                    form_0405.setEditMode(2);
                    var item = table.getSelectedItem();
                    var url = app.config.host + "/Invoice68/GetDataMau0405Detail?id=" + item.id;
                    var result = webix.ajax().sync().get(url);
                    var json = JSON.parse(result.response);
                    item.detail = json;
                    form_0405.setValues(item);
                    var tableDetail = webix.$$("danhsach_hoadonhuy");
                    var url = app.config.host + "/Invoice68/GetDataMau0405Detail?id=" + item.id;
                    tableDetail.clearAll();
                    tableDetail.load(url);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    var lstDataChoose = commonHD.GetHoaDonChonOfTableId({ id: "mau04_68" });

                    if (lstDataChoose == null) {
                        webix.message("Bạn chưa chọn thông báo ! ", "error");
                        return;
                    }

                    for (var index = 0; index < lstDataChoose.length; index++) {
                        var selectedItem = lstDataChoose[index];

                        if (selectedItem.trang_thai == 1) {
                            webix.message("TBSS số " + selectedItem.shdon + ", kí hiệu " + selectedItem.khieu + ": Mẫu đã ký và gửi CQT bạn không thể xóa! ", "error");
                            lstDataChoose.splice(index, 1);
                            index--;
                        } else if (selectedItem.loai_tbao == "5") {
                            webix.message("TBSS số " + selectedItem.shdon + ", kí hiệu " + selectedItem.khieu + ": Mẫu 05 nhận từ CQT bạn không thể xóa! ", "error");
                            lstDataChoose.splice(index, 1);
                            index--;
                        }
                    }

                    if (lstDataChoose.length > 0) {
                        var text = "Bạn có muốn xóa:";
                        lstDataChoose.forEach(function (selectedItem) {
                            text += '<span style="color:red">' + " TBSS số " + selectedItem.shdon + " kí hiệu " + selectedItem.khieu + '</span>' + ", "
                        })
                        text += "?";
                        webix.confirm({
                            text: text,
                            ok: "Có",
                            cancel: "Không",
                            callback: function (choose) {
                                if (choose) {
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();
                                    var arrid = [];
                                    lstDataChoose.forEach(function (item) {
                                        arrid.push(item.id);
                                    })
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Invoice68/deleteMau04", { arrid: arrid }, {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();

                                                webix.message(XmlHttpRequest.statusText, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var json = JSON.parse(text);
                                                if (json.ok) {
                                                    webix.message('Xóa thành công', "success");
                                                }
                                                else {
                                                    var errarr = json.error;
                                                    for (var erri = 0; erri < errarr.length; erri++) {
                                                        webix.message(errarr[erri].error, "error");
                                                    }
                                                }
                                                table.clearAll();
                                                table.load(table.config.url);
                                                table.enable();
                                                table.hideProgress();
                                            },
                                        });
                                }
                            },
                        });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký gửi CQT") + "</span>",
            id: "btnSign",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("mau04_68");
                    var lstDataChoose = commonHD.GetHoaDonChonOfTableId({ id: "mau04_68" });

                    if (lstDataChoose == null) {
                        webix.message("Bạn chưa chọn thông báo ! ", "error");
                        return;
                    }

                    for (var index = 0; index < lstDataChoose.length; index++) {
                        var selectedItem = lstDataChoose[index];
                        if (selectedItem.trang_thai == 1) {
                            webix.message("TBSS số " + selectedItem.shdon + ", kí hiệu " + selectedItem.khieu + ": Mẫu đã ký và gửi CQT bạn không thể ký lại!  ", "error");
                            lstDataChoose.splice(index, 1);
                            return;
                        }
                    }
                    var arrid = [];
                    lstDataChoose.forEach(function (item) {
                        arrid.push(item.id);
                    })
                    if (lstDataChoose.length > 0) {
                        webix
                            .ajax()
                            .headers({ "Content-Type": "application/json" })
                            .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                var result = JSON.parse(text);
                                var kytaptrung = "";
                                for (var i = 0; i < result.length; i++) {
                                    var item = result[i];
                                    kytaptrung = item.value;
                                }

                                webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                    var listcerts = JSON.parse(text);
                                    if (listcerts.length > 0) {
                                        var box = webix.modalbox({
                                            title: "Chọn chứng thư số",
                                            buttons: ["Nhận", "Hủy bỏ"],
                                            text: "<div id='ctnCerts'></div>",
                                            top: 100,
                                            width: 750,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "1":
                                                        webix.modalbox.hide();
                                                        break;
                                                    case "0":
                                                        var table = $$("tblCerts");
                                                        var data = table.serialize();

                                                        var cert = null;

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i].chon == true) {
                                                                cert = data[i];
                                                                break;
                                                            }
                                                        }

                                                        if (cert == null) {
                                                            webix.message("Bạn chưa chọn chứng thư số");
                                                            return;
                                                        }

                                                        var now = new Date();
                                                        var begin = new Date(cert.begin_date);
                                                        var end = new Date(cert.end_date);
                                                        if (now < begin || now > end) {
                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                            return;
                                                        }

                                                        var postData = {
                                                            branch_code: user.getDvcsID(),
                                                            username: user.getCurrentUser(),
                                                            cer_serial: cert.cer_serial,
                                                            ids: arrid,
                                                        };
                                                        webix.extend(tableDK, webix.ProgressBar);
                                                        tableDK.disable();
                                                        tableDK.showProgress();

                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/huyhoadonSign", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text).res;
                                                                    var hasError = false;
                                                                    for (var i = 0; i < json.length; i++) {
                                                                        var item = json[i];
                                                                        if (item.hasOwnProperty("error")) {
                                                                            webix.message(item.error, "error");
                                                                            hasError = true;
                                                                        }
                                                                    }
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    if (!hasError) {
                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                        // $$("huyhoadonForms").close();
                                                                    }
                                                                    app.callEvent("dataChangedMau0405", [1, null]);
                                                                },
                                                            });

                                                    // return;
                                                }
                                            },
                                        });

                                        var tblMatHang = webix.ui({
                                            container: "ctnCerts",
                                            id: "tblCerts",
                                            view: "datatable",
                                            borderless: true,
                                            resizeColumn: true,
                                            height: 350,
                                            columns: [
                                                {
                                                    id: "chon",
                                                    header: _("CHON"),
                                                    width: 65,
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    template: "{common.checkbox()}",
                                                },
                                                {
                                                    id: "cer_serial",
                                                    header: _("SO_SERIAL"),
                                                    width: 150,
                                                },
                                                {
                                                    id: "subject_name",
                                                    header: _("SUBJECTNAME"),
                                                    width: 450,
                                                },
                                                {
                                                    id: "begin_date",
                                                    header: _("NGAY_BAT_DAU"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "end_date",
                                                    header: _("NGAY_KET_THUC"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "issuer",
                                                    header: _("DONVI"),
                                                    width: 450,
                                                },
                                            ],
                                            url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                        });
                                    } else {
                                        var table = $$("mau04_68");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        // xem user có tích checkbox ký HSM không?
                                        var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                        webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                            if (resultscheckSigHSM[0].json() == "C") {
                                                var postData = {
                                                    branch_code: user.getDvcsID(),
                                                    username: user.getCurrentUser(),
                                                    ids: arrid,
                                                    check_HSM: "1",
                                                };

                                                webix.extend(tableDK, webix.ProgressBar);
                                                tableDK.disable();
                                                tableDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/huyhoadonSign", postData, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                app.callEvent("dataChangedMau0405", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                            } else {
                                                var a = webix.ajax(app.config.host + "/Invoice68/XmlMau0405?id=" + selectedItem.id);
                                                var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                webix.promise.all([a, b, selectedItem]).then(function (results) {
                                                    var json = results[0].json();

                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: json.error });
                                                    }

                                                    var listcerts = results[1].json();
                                                    var item = results[2];

                                                    if (listcerts.length == 0) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                        return;
                                                    }

                                                    require(["views/modules/minvoiceplugin"], function (plugin) {
                                                        var hub = plugin.hub();
                                                        var hubconnect = plugin.conn();
                                                        if (hubconnect.state != 1) {
                                                            table.enable();
                                                            table.hideProgress();
                                                            webix.message("Quý khách hàng chưa cài Plugin ký chứng từ hoặc Plugin ký chứng từ chưa được bật !", "error");
                                                            return;
                                                        }
                                                        hub.off("resCommand");
                                                        hub.on("resCommand", function (result) {
                                                            var json = JSON.parse(result);

                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message({ type: "error", text: json.error });
                                                            } else {
                                                                var parameters = {
                                                                    xml: json.xml,
                                                                    id: selectedItem.id,
                                                                    tthdon: 3,
                                                                };

                                                                webix
                                                                    .ajax()
                                                                    .headers({ "Content-Type": "application/json" })
                                                                    .post(app.config.host + "/Invoice68/SaveXmlMau0405", parameters, function (text) {
                                                                        var result = JSON.parse(text);
                                                                        if (result.hasOwnProperty("error")) {
                                                                            webix.message(result.error, "error");
                                                                        } else {
                                                                            webix.message("Gửi thành công đến CQT !", "success");
                                                                            app.callEvent("dataChangedMau0405", [1, null]);
                                                                        }
                                                                    });
                                                            }
                                                            table.enable();
                                                            table.hideProgress();
                                                        });

                                                        var _listcerts = [];

                                                        for (var i = 0; i < listcerts.length; i++) {
                                                            var _cert = listcerts[i];

                                                            _listcerts.push({
                                                                so_serial: _cert.cer_serial,
                                                                ngaybatdau: _cert.begin_date,
                                                                ngayketthuc: _cert.end_date,
                                                                issuer: _cert.issuer,
                                                                subjectname: _cert.subject_name,
                                                            });
                                                        }

                                                        var arg = {
                                                            idData: "#data",
                                                            xml: json["xml"],
                                                            shdon: "",
                                                            idSigner: "seller",
                                                            tagSign: "NNT",
                                                            dvky: json["dvky"],
                                                            dateKy: json["dateKy"],
                                                            listcerts: _listcerts,
                                                        };

                                                        hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                            .done(function () {
                                                                console.log("Success !");
                                                            })
                                                            .fail(function (error) {
                                                                webix.message(error, "error");
                                                            });
                                                    });
                                                });
                                            }
                                        });
                                    }
                                });
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "mau04_68",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    scrollX: true,
                    cells: [
                        {
                            header: "Chi tiết chứng từ",
                            body: {
                                view: "datatable",
                                height: 200,
                                resizeColumn: true,
                                id: "mau04_68_chitiet",
                                headerRowHeight: 50,
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.index = i + 1;
                                        });
                                    },
                                },
                                columns: [
                                    {
                                        view: "text",
                                        id: "mau04_id",
                                        name: "mau04_id",
                                        hidden: true,
                                    },
                                    {
                                        view: "text",
                                        id: "mau04_chitiet_id",
                                        name: "mau04_chitiet_id",
                                        hidden: true,
                                    },
                                    {
                                        view: "text",
                                        header: "STT",
                                        id: "index",
                                        name: "index",
                                        width: 80,
                                    },
                                    {
                                        header: "Mẫu số",
                                        id: "mau_so",
                                        width: 120,
                                    },

                                    {
                                        id: "khieu",
                                        name: "khieu",
                                        header: "Ký hiệu chứng từ điện tử",
                                        width: 150,
                                    },
                                    {
                                        id: "shdon",
                                        name: "shdon",
                                        header: "Số chứng từ điện tử",
                                        width: 120,
                                    },
                                    {
                                        id: "ngay",
                                        name: "ngay",
                                        header: "Ngày lập chứng từ",
                                        width: 120,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },

                                    {
                                        id: "ladhddt",
                                        name: "ladhddt",
                                        header: "Loại áp dụng chứng từ điện tử",
                                        template: function (obj) {
                                            switch (obj.ladhddt) {
                                                case 1:
                                                    return "<span>HĐĐT Nghị đinh số 123/2020/NĐ-CP</span> ";
                                                case 2:
                                                    return "<span>HĐĐT có mã của cơ quan thu</span> ";
                                                case 3:
                                                    return "<span>Các loại chứng từ theo Nghị đinh 51/2010</span> ";
                                                case 4:
                                                    return "<span>Chứng từ đặt in theo Nghị định số 123/2020/NĐ-C</span> ";
                                                default:
                                                    break;
                                            }
                                        },
                                        width: 150,
                                    },
                                    {
                                        id: "tctbao",
                                        name: "tctbao",
                                        header: "Điều chỉnh/Thay thế/Giải trình",
                                        editable: true,
                                        width: 200,
                                        template: function (obj) {
                                            switch (obj.tctbao) {                                        
                                                case 3:
                                                    return "Thay thế";
                                                case 4:
                                                    return "Giải trình";
                                                case 5:
                                                    return "Điều chỉnh tăng";
                                                case 6:
                                                    return "Điều chỉnh giảm";
                                                case 7:
                                                    return "Điều chỉnh khác";
                                                default:
                                                    break;
                                            }
                                        },
                                    },
                                    {
                                        id: "ldo",
                                        name: "ldo",
                                        header: "Lý do",
                                        width: 250,
                                    },
                                    {
                                        id: "tttnhan",
                                        name: "tttnhan",
                                        header: "Trạng thái tiếp nhận",
                                        template: function (obj) {
                                            if (obj.tttnhan == 1) {
                                                return "<span style='color: #00b300'>Chấp thuận</span> ";
                                            } else {
                                                if (obj.tttnhan == 2) {
                                                    return "<span style='color: #e83717'>Không chấp thuận</span> ";
                                                } else {
                                                    return "<span>Chờ phản hồi</span>";
                                                }
                                            }
                                        },
                                        width: 200,
                                    },
                                    {
                                        id: "ly_do",
                                        name: "ldly_doo",
                                        header: "Lý do không tiếp nhận",
                                        width: 250,
                                    },
                                ],
                                data: [
                                    {
                                        index: 1,
                                        khieu: "1KT20YY",
                                        shdon: "0000001",
                                        ngay: new Date(),
                                        ladhddt: "1",
                                        ldo: "Sai thông tin",
                                    },
                                    {
                                        index: 2,
                                        khieu: "1KT20YY",
                                        shdon: "0000002",
                                        ngay: new Date(),
                                        ladhddt: "1",
                                        ldo: "Sai tiền",
                                    },
                                ],
                            },
                        },
                    ],
                },
                scheme: {
                    $init: function () {
                    },
                },
                onClick: {
                    Dowload0405: function (event, cell, target) {
                        var win = webix.$$("mau04_68");
                        var record = win.getItem(cell.row);

                        if (record.loai_tbao != "5") {
                            if (record.trang_thai != 1) {
                                webix.message("Mẫu chưa được ký không thể tải !", "error");
                                return;
                            }
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = record.loai_tbao == "5" ? "Mau05.xml" : "Mau04.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLMau04?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                            });
                        return false; // here it blocks the default behavior
                    },
                    Dowload0405Rep: function (event, cell, target) {
                        var win = webix.$$("mau04_68");
                        var record = win.getItem(cell.row);

                        if (record.loai_tbao != "5") {
                            if (record.trang_thai != 1) {
                                webix.message("Mẫu chưa được ký không thể tải !", "error");
                                return;
                            }
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = record.loai_tbao == "5" ? "Mau05Rep.xml" : "Mau04Rep.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLMau04Rep?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                            });
                        return false; // here it blocks the default behavior
                    },
                    InMau0405: function (event, cell, target) {
                        var table = webix.$$("mau04_68");
                        var item = table.getItem(cell.row);

                        var box = webix.modalbox({
                            title: "Đang in chứng từ ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Chứng từ điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau04?id=" + item.id + "&type=PDF&loai=" + item.loai_tbao, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    InMau0405Rep: function (event, cell, target) {
                        var table = webix.$$("mau04_68");
                        var item = table.getItem(cell.row);

                        var box = webix.modalbox({
                            title: "Đang in chứng từ ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Chứng từ điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau04Rep?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                },
                on: {
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("mau04_68_chitiet");
                            var url = app.config.host + "/Invoice68/GetDataMau0405Detail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () { },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                        resize: false,
                    },
                    {
                        id: "mau04_id",
                        header: "mau04_id",
                        hidden: true,
                    },
                    {
                        template: "{common.subrow()}",
                        width: 50,
                    },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "shdon",
                        header: [
                            "Số chứng từ",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 200,
                    },
                    {
                        id: "khieu",
                        header: [
                            "Ký hiệu",
                            {
                                content: "selectFilter",
                            },
                        ],

                        width: 200,
                    },
                    {
                        id: "loai_tbao",
                        header: [
                            "Loại thông báo",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 200,
                        template: function (obj) {
                            return obj.loai_tbao == "5" ? "Chứng từ cần rà soát" : "Thông báo chứng từ sai sót";
                        },
                    },
                    {
                        id: "trang_thai",
                        header: [
                            "Trạng thái",
                            {
                                content: "serverSelectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "0", value: "Chưa gửi CQT" },
                                    { id: "1", value: "Đã gửi CQT" },
                                ],
                            },
                        ],
                        width: 150,
                        template: function (obj) {
                            if (obj.loai_tbao == "5") {
                                return "";
                            } else {
                                return obj.trang_thai == 1
                                    ? "<span style='color: #00b300'><i class='fas fa-check'></i></span> Đã gửi CQT"
                                    : "<span style='color: red'><i class='fas fa-times'></i></span> Chưa gửi CQT";
                            }
                        },
                    },
                    {
                        id: "cqtphoi",
                        header: [
                            "<center>Trạng thái tiếp nhận CQT</center>",
                            {
                                content: "serverSelectFilter",
                                value: "",
                                options: [
                                    { id: "", value: "" },
                                    { id: "1", value: "Đã nhận phản hồi" },
                                    { id: "0", value: "Chưa nhận phản hồi" },
                                ],
                            },
                        ],
                        // sort: "int",
                        width: 150,

                        template: function (obj) {
                            return obj.cqtphoi == "1" ? "Đã nhận phản hồi" : "Chưa nhận phản hồi";
                        },
                    },

                    {
                        id: "mtdiep_gui",
                        header: ["Mã thông điệp gửi"],

                        width: 350,
                    },
                    {
                        id: "ntbao",
                        header: [
                            "Ngày tạo",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 120,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: { "text-align": "center" },
                        columnType: "datetime",
                    },
                    {
                        id: "ngay_gui",
                        header: [
                            "Ngày gửi",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 120,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: { "text-align": "center" },
                        columnType: "datetime",
                    },
                    {
                        id: "Dowload0405",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        width: 120,
                        template: function (obj) {
                            if (obj.loai_tbao == "5") {
                                return "<span class='Dowload0405' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else {
                                if (obj.trang_thai == 1) {
                                    return "<span class='Dowload0405' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                                } else return "<span class='Dowload0405' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                            }
                        },
                    },
                    {
                        id: "btnInMau0405",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.loai_tbao == "5") {
                                return "<span class='InMau0405' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else {
                                if (obj.trang_thai == 1) {
                                    return "<span class='InMau0405' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                                } else return "<span class='InMau0405' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                            }
                        },
                        width: 120,
                    },
                    {
                        id: "nguoi_gui",
                        header: [
                            "Người gửi",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 150,
                    },
                    {
                        id: "Dowload0405Rep",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.xml_nhan != null && obj.xml_nhan != "") {
                                return "<span class='Dowload0405Rep' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='Dowload0405Rep' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "btnInMau0405Rep",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.xml_nhan != null && obj.xml_nhan != "") {
                                return "<span class='InMau0405Rep' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau0405Rep' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "mtdiepcqt",
                        header: ["", "Mã thông điệp CQT"],
                        width: 250,
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("mau04_68");

            $scope.on(app, "dataChangedMau0405", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_huyhoadon_32-78',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/68_mau0405"], function (app, _, user, invoiceForms, mau0405) {
    

    var editmode = 0;

    function listToTreeCustomize(json) {
        return json.map(function(item) {
            return {
                id: item.code,
                name: item.name != null ? item.name.toString() : "",
                code: item.code
            };
        });
    }
    
    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Thông báo hóa đơn điện tử đã lập sai<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_dksdForms",
                        tooltip: _("HELPER"),
                        click: function () {
                        },
                    },
                ],
            },
            id: "huyhoadonForms",
            resize: true,
            width: 1100,
            height: 600,
            move: true,
            body: {
                view: "form",
                id: "huyhoadon",
                position: "center",
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        template: "<center><b><span style='font-size:17px;'>THÔNG BÁO HÓA ĐƠN ĐIỆN TỬ ĐÃ LẬP SAI</b></center>",
                        borderless: true,
                        height: 40,
                    },
                    {
                        paddingX: 30,
                        rows: [
                            {
                                cols: [
                                    {},
                                    {
                                        view: "text",
                                        id: "tcqt_hidden",
                                        name: "tcqt",
                                        hidden: true
                                    },
                                    {
                                        label: "Kính gửi: ",
                                        id: "tcqt",
                                        view: "combo",
                                        labelWidth: 100,
                                        width: 300,
                                        options: {
                                            view: "gridsuggest",
                                            columnName: "name",
                                            url: {
                                                $proxy: true,
                                                load: function (view, callback, params) {
                                                    var url = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00251";
                                                    webix.ajax(url, function (text) {
                                                        var json = JSON.parse(text);
                                                        var data = listToTreeCustomize(json);
                                                        view.parse(data, "json");
                                                    });
                                                },
                                            },
                                            body: {
                                                columns: [ { id: "name", width: 225, header: "Tên" }, { id: "code", width: 100, header: "Mã" }],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    $$("tcqt_hidden").setValue(obj["name"]); // Lưu item.name vào trường ẩn
                                                    $$("tcqt_hidden").refresh();

                                                    $$("mcqt").setValue(obj["code"]);
                                                    $$("mcqt").refresh();
                                                },
                                            },
                                        },
                                        required: true,
                                        invalidMessage: "Kính gửi không được để trống !",
                                    },
                                    {},
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Mã số thuế",
                                        id: "mst",
                                        name: "mst",
                                        required: true,
                                        invalidMessage: "Tên người nộp thuế không được để trống !",
                                    }, 
                                    
                                    // {
                                    //     view: "text",
                                    //     label: "Mã đơn vị quan hệ ngân sách",
                                    //     id: "mdvqhnsach",
                                    //     name: "mdvqhnsach",
                                    //     labelWidth: 200,
                                    // },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Tên người nộp thuế",
                                        labelWidth: 150,
                                        required: true,
                                        invalidMessage: "Tên người nộp thuế không được để trống !",
                                        id: "tnnt",
                                        name: "tnnt",
                                    },
                                    {
                                        id: "mcqt",
                                        name: "mcqt",
                                        label: "Mã cơ quan thuế",
                                        labelWidth: 150,
                                        required: true,
                                        invalidMessage: "Mã cơ quan thuế quản lý không được để trống !",
                                        view: "text",
                                        attributes: { maxlength: 5 },
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Địa danh",
                                        labelWidth: 150,
                                        id: "ddanh",
                                        name: "ddanh",
                                        required: true,
                                        invalidMessage: "Địa danh không được để trống !",
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "radio",
                                        label: "Loại hóa đơn",
                                        labelWidth: 150,
                                        id: "lhdon",
                                        name: "lhdon",
                                        value: "1",
                                        options: [
                                            { id: "1", value: "Hóa đơn TT32" }, // the initially selected item
                                            { id: "2", value: "Hóa đơn TT78 nhà cung cấp khác" },
                                        ],
                                        on: {
                                            onChange: function (newv, oldv) {
                                                if (newv !== undefined && newv !== null) {
                                                    if (newv === "2") {
                                                        $$("danhsach_hoadonhuy").editStop();
                                                        $$("danhsach_hoadonhuy").clearAll();
                                                        $$("danhsach_hoadonhuy").hideColumn("mau_so");
                                                        $$("danhsach_hoadonhuy").showColumn("mcqtcap");
                                                    } else {
                                                        $$("danhsach_hoadonhuy").editStop();
                                                        $$("danhsach_hoadonhuy").clearAll();
                                                        $$("danhsach_hoadonhuy").showColumn("mau_so");
                                                        $$("danhsach_hoadonhuy").hideColumn("mcqtcap");
                                                    }
                                                }
                                            },
                                        },
                                    },
                                ],
                            },     
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Lý do",
                                        labelWidth: 150,
                                        id: "ldo_all",
                                        name: "ldo_all",
                                        on: {
                                            onblur: function () {
                                                var datatable = $$("danhsach_hoadonhuy");
                                                var items = datatable.serialize(); 
                                                if(items.length < 1){
                                                    return;
                                                }
                                                for (var i = 0; i < items.length; i++) {
                                                    datatable.updateItem(items[i].id, { ldo: this.getValue()}); 
                                                }
                
                                            }
                                        }
                                    },
                                ],
                            },                                     
                        ],
                    },
                    { height: 3 },
                    {
                        template: "<b><span >Người nộp thuế thông báo về việc hóa đơn điện tử đã lập sai như sau:</b>",
                        borderless: true,
                        height: 40,
                    },
                    { height: 3 },
                    {
                        rows: [
                            {
                                id: "btnHuyhoadon",
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        label: " (F9)",
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_hoadonhuy");
                                                var checkHD78 = $$("lhdon").getValue();
                                                var ladhddt = checkHD78 === "1" ? 3 : 1;
                                                var item = { id: webix.uid(), ngay: new Date(), ladhddt: ladhddt, tctbao: "1" };
                                                table.add(item);
                                                table.select(item.id, "khieu", false);
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        autowidth: true,
                                        label: " (F8)",
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_hoadonhuy");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {},
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_hoadonhuy",
                                name: "danhsach_hoadonhuy",
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                select: "cell",
                                scheme: {
                                    $init: function (obj) {},
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                    onBeforeEditStart: function (id) {
                                    },
                                },
                                columns: [
                                    { editor: "text", id: "hdon_id", name: "hdon_id", hidden: true },
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                    },
                                    {
                                        view: "text",
                                        id: "mcqtcap",
                                        name: "mcatcap",
                                        header: "Mã cơ quan thuế cấp",
                                        width: 100,
                                        editor: "text",
                                        hidden: true,
                                    },
                                    {
                                        view: "text",
                                        id: "mau_so",
                                        name: "mau_so",
                                        header: _("Mẫu số HĐ"),
                                        editor: "text",
                                        width: 120,
                                        require: true,
                                    },
                                    {
                                        view: "text",
                                        id: "khieu",
                                        header: _("Ký hiệu HĐ"),
                                        editor: "text",
                                        width: 120,
                                        require: true,
                                    },
                                    {
                                        view: "text",
                                        id: "shdon",
                                        name: "shdon",
                                        header: "Số hóa đơn",
                                        width: 120,
                                        editor: "text",
                                        require: true,
                                    },
                                    {
                                        id: "ngay",
                                        name: "ngay",
                                        header: "Ngày lập hóa đơn",
                                        width: 150,
                                        editor: "date",
                                        require: true,
                                        format: webix.Date.dateToStr("%d/%m/%Y"),
                                    },
                                    {
                                        id: "ladhddt",
                                        name: "ladhddt",
                                        header: "Loại áp dụng hóa đơn điện tử",
                                        editable: false,
                                        width: 400,
                                        editor: "combo",
                                        require: true,
                                        options: [
                                            { id: 1, value: "Hóa đơn điện tử theo Nghị định 123/2020/NĐ-CP, Nghị định 70/2025/NĐ-CP" },
                                            { id: 2, value: "Hóa đơn điện tử có mã xác thực của cơ quan thuế theo Quyết định số 1209/QĐ-BTCHóa đơn điện tử có mã xác thực của cơ quan thuế theo Quyết định số 1209/QĐ-BTC ngày 23 tháng 6 năm 2015 và Quyết định số 2660/QĐ-BTC ngày 14 tháng 12 năm 2016 của Bộ Tài chính (Hóa đơn có mã xác thực của CQT theo Nghị định số 51/2010/NĐ-CP và Nghị định số 04/2014/NĐ-CP)" },
                                            { id: 3, value: "Các loại hóa đơn theo Nghị định số 51/2010/NĐ-CP và Nghị định số 04/2014/NĐ-CP (Trừ hóa đơn điện tử có mã xác thực của cơ quan thuế theo Quyết định số 1209/QĐ-BTC và Quyết định số 2660/QĐ-BTC)" },
                                            { id: 4, value: "Hóa đơn đặt in theo Nghị định 123/2020/NĐ-CP" },
                                        ],
                                    },
                                    {
                                        id: "ldo",
                                        name: "ldo",
                                        header: "Lý do",
                                        editable: true,
                                        editor: "text",
                                        width: 300,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                view: "button",
                                id: "btnStep299",
                                label: "Lưu, chuyển sang bước tiếp theo",
                                type: "form",
                                hidden: true,
                                align: "center",
                                click: function () {
                                    var self = this;
                                    setTimeout(function () {
                                        var item = $$("huyhoadon").getValues();
                                        var details = [];
                                        details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                        item["details"] = details;

                                        var item1 = [];
                                        item1.push(item);
                                        var data_post = { editmode: editmode, data: item1 };

                                        var detailForm = self.$scope.ui(invoiceForms.$ui);

                                        var cctbao_id = webix.$$("kyhieu_id").getValue();
                                        invoiceForms.initUINew(cctbao_id);
                                        invoiceForms.setEditMode(1);
                                        invoiceForms.setValues(null, data_post, null);
                                        detailForm.show();
                                    }, 100);
                                },
                            },
                            {
                                shortcut: "F10",
                                view: "button",
                                id: "btnGhiHuyhoadon",
                                label: "Ghi (F10)",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin hóa đơn cần hủy !", "error");
                                                    return;
                                                }
                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();

                                                var details = [];
                                                details.push({ data: cks });
                                                item.details = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/huyhoadonSave", data_post, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            table.enable();
                                                            table.hideProgress();
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);

                                                            table.enable();
                                                            table.hideProgress();
                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message(json.error, "error");
                                                            } else {
                                                                app.callEvent("dataChangedMau0405", [null, null]);
                                                                webix.message("Thành công !", "success");
                                                                webix.$$("huyhoadonForms").close();
                                                                var table1 = webix.$$("mau04_68");
                                                                table1.clearAll();
                                                                table1.load(table1.config.url);
                                                                table1.show();
                                                            }
                                                        },
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                shortcut: "F4",
                                view: "button",
                                id: "btnGhiSignHuyHDDT",
                                label: "Ký và gửi CQT (F14)",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                       
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                self.disable();
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin hóa đơn cần hủy !", "error");
                                                    self.enable();
                                                    return;
                                                }
                                                var details = [];
                                                details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                                item["details"] = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                var tableDK = $$("huyhoadon");

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = "";
                                                        for (var i = 0; i < result.length; i++) {
                                                            var item = result[i];
                                                            kytaptrung = item.value;
                                                        }

                                                        webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                            var listcerts = JSON.parse(text);
                                                            if (listcerts.length > 0) {
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();

                                                                                var cert = null;

                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }

                                                                                var now = new Date();
                                                                                var begin = new Date(cert.begin_date);
                                                                                var end = new Date(cert.end_date);
                                                                                if (now < begin || now > end) {
                                                                                    webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                    return;
                                                                                }

                                                                                var postData = {
                                                                                    branch_code: user.getDvcsID(),
                                                                                    username: user.getCurrentUser(),
                                                                                    cer_serial: cert.cer_serial,
                                                                                };
                                                                                data_post.sign = postData;

                                                                                webix.extend(tableDK, webix.ProgressBar);
                                                                                tableDK.disable();
                                                                                tableDK.showProgress();
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({ "Content-type": "application/json" })
                                                                                    .post(app.config.host + "/Invoice68/huyhoadonSaveSign", data_post, {
                                                                                        error: function (text, data, XmlHttpRequest) {
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            webix.message(text + XmlHttpRequest, "error");
                                                                                        },
                                                                                        success: function (text, data, XmlHttpRequest) {
                                                                                            var json = JSON.parse(text);
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            if (!json.hasOwnProperty("error")) {
                                                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                                                $$("huyhoadonForms").close();
                                                                                                app.callEvent("dataChangedMau0405", [null, null]);
                                                                                            } else {
                                                                                                if (json.hasOwnProperty("id")) { 
                                                                                                    $$("huyhoadonForms").close();   
                                                                                                    webix.message("Tạo thông báo sai sót thành công !", "success");
                                                                                                }
                                                                                                webix.message(json.error, "error");
                                                                                            }
                                                                                        },
                                                                                    });
                                                                        }
                                                                    },
                                                                });
                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}",
                                                                        },
                                                                        {
                                                                            id: "cert_type",
                                                                            header: _("Loại"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "cer_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 150,
                                                                        },
                                                                        {
                                                                            id: "subject_name",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "begin_date",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "end_date",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "issuer",
                                                                            header: _("DONVI"),
                                                                            width: 450,
                                                                        },
                                                                    ],
                                                                    url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                });
                                                            } else {
                                                                var table = $$("huyhoadon");
                                                                webix.extend(table, webix.ProgressBar);
                                                                table.disable();
                                                                table.showProgress();

                                                                // xem user có tích checkbox ký HSM không?
                                                                var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                                                webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                                                    if (resultscheckSigHSM[0].json() == "C") {
                                                                        var postData = {
                                                                            branch_code: user.getDvcsID(),
                                                                            username: user.getCurrentUser(),
                                                                            check_HSM: "1",
                                                                        };
                                                                        data_post.sign = postData;

                                                                        webix.extend(tableDK, webix.ProgressBar);
                                                                        tableDK.disable();
                                                                        tableDK.showProgress();
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/huyhoadonSaveSign", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    tableDK.enable();
                                                                                    tableDK.hideProgress();
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);
                                                                                    tableDK.enable();
                                                                                    tableDK.hideProgress();
                                                                                    if (!json.hasOwnProperty("error")) {
                                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                                        $$("huyhoadonForms").close();
                                                                                        app.callEvent("dataChangedMau0405", [null, null]);
                                                                                    } else {
                                                                                        if (json.hasOwnProperty("id")) { 
                                                                                            $$("huyhoadonForms").close();   
                                                                                            webix.message("Tạo thông báo sai sót thành công !", "success");
                                                                                        }
                                                                                        webix.message(json.error, "error");
                                                                                    }
                                                                                },
                                                                            });
                                                                    } else {
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/huyhoadonSave", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    table.enable();
                                                                                    table.hideProgress();
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);

                                                                                    if (json.hasOwnProperty("error")) {
                                                                                        webix.message(json.error, "error");
                                                                                    } else {
                                                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlMau0405?id=" + json.id);
                                                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                                                        webix.promise.all([a, b, json]).then(function (results) {
                                                                                            var json = results[0].json();

                                                                                            if (json.hasOwnProperty("error")) {
                                                                                                $$("huyhoadonForms").close();   
                                                                                                webix.message("Tạo thông báo sai sót thành công !", "success");
                                                                                                webix.message({ type: "error", text: json.error });
                                                                                            }

                                                                                            var listcerts = results[1].json();
                                                                                            var item = results[2];

                                                                                            if (listcerts.length == 0) {
                                                                                                table.enable();
                                                                                                table.hideProgress();
                                                                                                $$("huyhoadonForms").close();   
                                                                                                webix.message("Tạo thông báo sai sót thành công !", "success");
                                                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                                                return;
                                                                                            }

                                                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                                                var hub = plugin.hub();
                                                                                                var hubconnect = plugin.conn();
                                                                                                if (hubconnect.state != 1) {
                                                                                                    table.enable();
                                                                                                    table.hideProgress();
                                                                                                    $$("huyhoadonForms").close();   
                                                                                                    webix.message("Tạo thông báo sai sót thành công !", "success");
                                                                                                    webix.message(
                                                                                                        "Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !",
                                                                                                        "error"
                                                                                                    );
                                                                                                    return;
                                                                                                }
                                                                                                hub.off("resCommand");
                                                                                                hub.on("resCommand", function (result) {
                                                                                                    var json = JSON.parse(result);

                                                                                                    if (json.hasOwnProperty("error")) {
                                                                                                        $$("huyhoadonForms").close();   
                                                                                                        webix.message("Tạo thông báo sai sót thành công !", "success");
                                                                                                        webix.message({ type: "error", text: json.error });
                                                                                                    } else {
                                                                                                        var parameters = {
                                                                                                            xml: json.xml,
                                                                                                            id: item.id,
                                                                                                            tthdon: 3,
                                                                                                        };

                                                                                                        webix
                                                                                                            .ajax()
                                                                                                            .headers({ "Content-Type": "application/json" })
                                                                                                            .post(app.config.host + "/Invoice68/SaveXmlMau0405", parameters, function (text) {
                                                                                                                var result = JSON.parse(text);
                                                                                                                if (result.hasOwnProperty("error")) {
                                                                                                                    webix.message("Tạo thông báo sai sót thành công !", "success");
                                                                                                                    webix.message({ type: "error", text: json.error });
                                                                                                                    webix.message(result.error, "error");
                                                                                                                } else {
                                                                                                                    app.callEvent("dataChangedMau0405", [null, null]);
                                                                                                                    webix.message("Thành công !", "success");
                                                                                                                    webix.$$("huyhoadonForms").close();
                                                                                                                }
                                                                                                            });
                                                                                                    }
                                                                                                    table.enable();
                                                                                                    table.hideProgress();
                                                                                                });

                                                                                                var _listcerts = [];

                                                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                                                    var _cert = listcerts[i];

                                                                                                    _listcerts.push({
                                                                                                        so_serial: _cert.cer_serial,
                                                                                                        ngaybatdau: _cert.begin_date,
                                                                                                        ngayketthuc: _cert.end_date,
                                                                                                        issuer: _cert.issuer,
                                                                                                        subjectname: _cert.subject_name,
                                                                                                    });
                                                                                                }

                                                                                                var arg = {
                                                                                                    idData: "#data",
                                                                                                    xml: json["xml"],
                                                                                                    shdon: "",
                                                                                                    idSigner: "seller",
                                                                                                    tagSign: "NNT",
                                                                                                    dvky: json["dvky"],
                                                                                                    dateKy: json["dateKy"],
                                                                                                    listcerts: _listcerts,
                                                                                                };

                                                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                                                    .done(function () {
                                                                                                        console.log("Success !");
                                                                                                    })
                                                                                                    .fail(function (error) {
                                                                                                        webix.message(error, "error");
                                                                                                    });
                                                                                            });
                                                                                        });
                                                                                    }
                                                                                },
                                                                            });
                                                                    }
                                                                });
                                                            }
                                                        });
                                                        self.enable();
                                                    });
                                            }
                                        }, 100);
                                        self.enable();
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                shortcut: "F4",
                                view: "button",
                                id: "btnSaveSignGiaiTrinh",
                                label: "Ký và gửi CQT",
                                width: 150,
                                hidden: true,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin hóa đơn cần hủy !", "error");
                                                    return;
                                                }
                                                var details = [];
                                                details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                                item["details"] = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                var tableDK = $$("huyhoadon");
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = "";
                                                        for (var i = 0; i < result.length; i++) {
                                                            var item = result[i];
                                                            kytaptrung = item.value;
                                                        }

                                                        webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                            var listcerts = JSON.parse(text);
                                                            if (listcerts.length > 0) {
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();

                                                                                var cert = null;

                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }

                                                                                var now = new Date();
                                                                                var begin = new Date(cert.begin_date);
                                                                                var end = new Date(cert.end_date);
                                                                                if (now < begin || now > end) {
                                                                                    webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                    return;
                                                                                }

                                                                                var postData = {
                                                                                    branch_code: user.getDvcsID(),
                                                                                    username: user.getCurrentUser(),
                                                                                    cer_serial: cert.cer_serial,
                                                                                };
                                                                                data_post.sign = postData;

                                                                                webix.extend(tableDK, webix.ProgressBar);
                                                                                tableDK.disable();
                                                                                tableDK.showProgress();
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({ "Content-type": "application/json" })
                                                                                    .post(app.config.host + "/Invoice68/giaitrinhSaveSign", data_post, {
                                                                                        error: function (text, data, XmlHttpRequest) {
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            webix.message(text + XmlHttpRequest, "error");
                                                                                        },
                                                                                        success: function (text, data, XmlHttpRequest) {
                                                                                            var json = JSON.parse(text);
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            if (!json.hasOwnProperty("error")) {
                                                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                                                $$("huyhoadonForms").close();
                                                                                                app.callEvent("dataChangedMau0405", [null, null]);
                                                                                            } else {
                                                                                                webix.message(json.error, "error");
                                                                                            }
                                                                                        },
                                                                                    });
                                                                        }
                                                                    },
                                                                });

                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}",
                                                                        },
                                                                        {
                                                                            id: "cert_type",
                                                                            header: _("Loại"),
                                                                            width: 100,
                                                                        },
                                                                        {
                                                                            id: "cer_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 150,
                                                                        },
                                                                        {
                                                                            id: "subject_name",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "begin_date",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "end_date",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "issuer",
                                                                            header: _("DONVI"),
                                                                            width: 450,
                                                                        },
                                                                    ],
                                                                    url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                });
                                                            } else {
                                                                var table = $$("huyhoadon");
                                                                webix.extend(table, webix.ProgressBar);
                                                                table.disable();
                                                                table.showProgress();

                                                                webix
                                                                    .ajax()
                                                                    .headers({ "Content-type": "application/json" })
                                                                    .post(app.config.host + "/Invoice68/huyhoadonSave", data_post, {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            table.enable();
                                                                            table.hideProgress();
                                                                            webix.message(text + XmlHttpRequest, "error");
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var json = JSON.parse(text);

                                                                            if (json.hasOwnProperty("error")) {
                                                                                webix.message(json.error, "error");
                                                                            } else {
                                                                                var a = webix.ajax(app.config.host + "/Invoice68/XmlMau0405?id=" + json.id);
                                                                                var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                                                webix.promise.all([a, b, json]).then(function (results) {
                                                                                    var json = results[0].json();

                                                                                    if (json.hasOwnProperty("error")) {
                                                                                        webix.message({ type: "error", text: json.error });
                                                                                    }

                                                                                    var listcerts = results[1].json();
                                                                                    var item = results[2];

                                                                                    if (listcerts.length == 0) {
                                                                                        table.enable();
                                                                                        table.hideProgress();
                                                                                        webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                                        return;
                                                                                    }

                                                                                    require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                                        var hub = plugin.hub();
                                                                                        var hubconnect = plugin.conn();
                                                                                        if (hubconnect.state != 1) {
                                                                                            table.enable();
                                                                                            table.hideProgress();
                                                                                            webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                                            return;
                                                                                        }
                                                                                        hub.off("resCommand");
                                                                                        hub.on("resCommand", function (result) {
                                                                                            var json = JSON.parse(result);

                                                                                            if (json.hasOwnProperty("error")) {
                                                                                                webix.message({ type: "error", text: json.error });
                                                                                            } else {
                                                                                                var parameters = {
                                                                                                    xml: json.xml,
                                                                                                    id: item.id,
                                                                                                    tthdon: 1,
                                                                                                };

                                                                                                webix
                                                                                                    .ajax()
                                                                                                    .headers({ "Content-Type": "application/json" })
                                                                                                    .post(app.config.host + "/Invoice68/SaveXmlMau0405", parameters, function (text) {
                                                                                                        var result = JSON.parse(text);
                                                                                                        if (result.hasOwnProperty("error")) {
                                                                                                            webix.message(result.error, "error");
                                                                                                        } else {
                                                                                                            app.callEvent("dataChangedMau0405", [null, null]);
                                                                                                            webix.message("Thành công !", "success");
                                                                                                            webix.$$("huyhoadonForms").close();
                                                                                                        }
                                                                                                    });
                                                                                            }
                                                                                            table.enable();
                                                                                            table.hideProgress();
                                                                                        });

                                                                                        var _listcerts = [];

                                                                                        for (var i = 0; i < listcerts.length; i++) {
                                                                                            var _cert = listcerts[i];

                                                                                            _listcerts.push({
                                                                                                so_serial: _cert.cer_serial,
                                                                                                ngaybatdau: _cert.begin_date,
                                                                                                ngayketthuc: _cert.end_date,
                                                                                                issuer: _cert.issuer,
                                                                                                subjectname: _cert.subject_name,
                                                                                            });
                                                                                        }

                                                                                        var arg = {
                                                                                            idData: "#data",
                                                                                            xml: json["xml"],
                                                                                            shdon: "",
                                                                                            idSigner: "seller",
                                                                                            tagSign: "NNT",
                                                                                            dvky: json["dvky"],
                                                                                            dateKy: json["dateKy"],
                                                                                            listcerts: _listcerts,
                                                                                        };

                                                                                        hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                                            .done(function () {
                                                                                                console.log("Success !");
                                                                                            })
                                                                                            .fail(function (error) {
                                                                                                webix.message(error, "error");
                                                                                            });
                                                                                    });
                                                                                });
                                                                            }
                                                                        },
                                                                    });
                                                            }
                                                        });
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    webix.$$("huyhoadonForms").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix
                    .ajax()
                    .sync()
                    .get(app.config.host + "/System/GetDmDvcsByUser");
                var json = JSON.parse(result.response);

                $$("tnnt").setValue(json[0].name);
                $$("mst").setValue(json[0].tax_code);
                //$$("tcqt").setValue(json[0].cqt_ql);
                $$("ddanh").setValue(json[0].city);
                //$$("mcqt").setValue(json[0].manage_tax_authorities);

                $$("tcqt").setValue(json[0].code2);
                $$("mcqt").setValue(json[0].code2);
                $$("tcqt_hidden").setValue(json[0].name2);
            } else {
                if (editmode == 2) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }
            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
        setValues: function (item, winconfig, params) {
            $$("danhsach_hoadonhuy").parse(item.detail);
            $$("huyhoadon").parse(item);
            var ladhddt = item.detail[0].ladhddt;
            if (ladhddt === 3) {
                $$("lhdon").define("value", "1");
                $$("lhdon").disable();
            } else {
                $$("lhdon").define("value", "2");
                $$("lhdon").disable();
                $$("danhsach_hoadonhuy").hideColumn("mau_so");
                $$("danhsach_hoadonhuy").showColumn("mcqtcap");
            }
        },
        setValuesTongQuat: function (item, winconfig, params) {
            var data = $$("huyhoadon").getValues();
            data.so = item.so;
            data.ntbccqt = item.ntbccqt;
            data.loai = item.loai;
            $$("huyhoadon").parse(data);
        },
    };
});

define('views/68_mau0405',["app", "locale", "models/user", "views/commonHD", "views/forms/68_huyhoadon_32-78"], function (app, _, user, commonHD, form_0405) {
    
    var param;
    webix.$$("title").parse({
        title: "Thông báo hủy và rà soát hóa đơn",
        details: "Bảng tổng hợp hóa đơn",
    });

    var initUI = function () {
        var table = webix.$$("mau04_68");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/getDatamau04";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                                filterType: column.header[1].content,
                            };

                            if (item.value != null && item.value != "") {
                                array.push(item);
                            }
                        }

                        url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                    }
                }
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 200,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Sai sót TT32/NCC khác " + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(form_0405.$ui);
                    form_0405.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn hóa đơn ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã ký và gửi CQT bạn không thể sửa! ", "error");
                        return;
                    }

                    if (selectedItem.loai_tbao == "5") {
                        webix.message("Mẫu 05 nhận từ CQT bạn không thể sửa! ", "error");
                        return;
                    }
                    if (selectedItem.is_hdon78 == 1) {
                        webix.message("Mẫu được này không được chỉnh sửa");
                        return;
                    }

                    var detailForm = this.$scope.ui(form_0405.$ui);
                    form_0405.setEditMode(2);
                    var item = table.getSelectedItem();
                    var url = app.config.host + "/Invoice68/GetDataMau0405Detail?id=" + item.id;
                    var result = webix.ajax().sync().get(url);
                    var json = JSON.parse(result.response);
                    item.detail = json;
                    form_0405.setValues(item);
                    var tableDetail = webix.$$("danhsach_hoadonhuy");
                    var url = app.config.host + "/Invoice68/GetDataMau0405Detail?id=" + item.id;
                    tableDetail.clearAll();
                    tableDetail.load(url);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    var lstDataChoose = commonHD.GetHoaDonChonOfTableId({ id: "mau04_68" });

                    if (lstDataChoose == null) {
                        webix.message("Bạn chưa chọn thông báo ! ", "error");
                        return;
                    }

                    for (var index = 0; index < lstDataChoose.length; index++) {
                        var selectedItem = lstDataChoose[index];

                        if (selectedItem.trang_thai == 1) {
                            webix.message("TBSS số " + selectedItem.shdon + ", kí hiệu " + selectedItem.khieu + ": Mẫu đã ký và gửi CQT bạn không thể xóa! ", "error");
                            lstDataChoose.splice(index, 1);
                            index--;
                        } else if (selectedItem.loai_tbao == "5") {
                            webix.message("TBSS số " + selectedItem.shdon + ", kí hiệu " + selectedItem.khieu + ": Mẫu 05 nhận từ CQT bạn không thể xóa! ", "error");
                            lstDataChoose.splice(index, 1);
                            index--;
                        }
                    }

                    if (lstDataChoose.length > 0) {
                        var text = "Bạn có muốn xóa:";
                        lstDataChoose.forEach(function (selectedItem) {
                            text += '<span style="color:red">' + " TBSS số " + selectedItem.shdon + " kí hiệu " + selectedItem.khieu + '</span>' + ", "
                        })
                        text += "?";
                        webix.confirm({
                            text: text,
                            ok: "Có",
                            cancel: "Không",
                            callback: function (choose) {
                                if (choose) {
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();
                                    var arrid = [];
                                    lstDataChoose.forEach(function (item) {
                                        arrid.push(item.id);
                                    })
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Invoice68/deleteMau04", { arrid: arrid }, {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();

                                                webix.message(XmlHttpRequest.statusText, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var json = JSON.parse(text);
                                                if (json.ok) {
                                                    webix.message('Xóa thành công', "success");
                                                }
                                                else {
                                                    var errarr = json.error;
                                                    for (var erri = 0; erri < errarr.length; erri++) {
                                                        webix.message(errarr[erri].error, "error");
                                                    }
                                                }
                                                table.clearAll();
                                                table.load(table.config.url);
                                                table.enable();
                                                table.hideProgress();
                                            },
                                        });
                                }
                            },
                        });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký gửi CQT") + "</span>",
            id: "btnSign",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("mau04_68");
                    var lstDataChoose = commonHD.GetHoaDonChonOfTableId({ id: "mau04_68" });

                    if (lstDataChoose == null) {
                        webix.message("Bạn chưa chọn thông báo ! ", "error");
                        return;
                    }

                    for (var index = 0; index < lstDataChoose.length; index++) {
                        var selectedItem = lstDataChoose[index];
                        if (selectedItem.trang_thai == 1) {
                            webix.message("TBSS số " + selectedItem.shdon + ", kí hiệu " + selectedItem.khieu + ": Mẫu đã ký và gửi CQT bạn không thể ký lại!  ", "error");
                            lstDataChoose.splice(index, 1);
                            return;
                        }
                    }
                    var arrid = [];
                    lstDataChoose.forEach(function (item) {
                        arrid.push(item.id);
                    })
                    if (lstDataChoose.length > 0) {
                        webix
                            .ajax()
                            .headers({ "Content-Type": "application/json" })
                            .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                var result = JSON.parse(text);
                                var kytaptrung = "";
                                for (var i = 0; i < result.length; i++) {
                                    var item = result[i];
                                    kytaptrung = item.value;
                                }

                                webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                    var listcerts = JSON.parse(text);
                                    if (listcerts.length > 0) {
                                        var box = webix.modalbox({
                                            title: "Chọn chứng thư số",
                                            buttons: ["Nhận", "Hủy bỏ"],
                                            text: "<div id='ctnCerts'></div>",
                                            top: 100,
                                            width: 750,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "1":
                                                        webix.modalbox.hide();
                                                        break;
                                                    case "0":
                                                        var table = $$("tblCerts");
                                                        var data = table.serialize();

                                                        var cert = null;

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i].chon == true) {
                                                                cert = data[i];
                                                                break;
                                                            }
                                                        }

                                                        if (cert == null) {
                                                            webix.message("Bạn chưa chọn chứng thư số");
                                                            return;
                                                        }

                                                        var now = new Date();
                                                        var begin = new Date(cert.begin_date);
                                                        var end = new Date(cert.end_date);
                                                        if (now < begin || now > end) {
                                                            webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                            return;
                                                        }

                                                        var postData = {
                                                            branch_code: user.getDvcsID(),
                                                            username: user.getCurrentUser(),
                                                            cer_serial: cert.cer_serial,
                                                            ids: arrid,
                                                        };
                                                        webix.extend(tableDK, webix.ProgressBar);
                                                        tableDK.disable();
                                                        tableDK.showProgress();

                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Invoice68/huyhoadonSign", postData, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text).res;
                                                                    var hasError = false;
                                                                    for (var i = 0; i < json.length; i++) {
                                                                        var item = json[i];
                                                                        if (item.hasOwnProperty("error")) {
                                                                            webix.message(item.error, "error");
                                                                            hasError = true;
                                                                        }
                                                                    }
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    if (!hasError) {
                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                        // $$("huyhoadonForms").close();
                                                                    }
                                                                    app.callEvent("dataChangedMau0405", [1, null]);
                                                                },
                                                            });

                                                    // return;
                                                }
                                            },
                                        });

                                        var tblMatHang = webix.ui({
                                            container: "ctnCerts",
                                            id: "tblCerts",
                                            view: "datatable",
                                            borderless: true,
                                            resizeColumn: true,
                                            height: 350,
                                            columns: [
                                                {
                                                    id: "chon",
                                                    header: _("CHON"),
                                                    width: 65,
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    template: "{common.checkbox()}",
                                                },
                                                {
                                                    id: "cer_serial",
                                                    header: _("SO_SERIAL"),
                                                    width: 150,
                                                },
                                                {
                                                    id: "subject_name",
                                                    header: _("SUBJECTNAME"),
                                                    width: 450,
                                                },
                                                {
                                                    id: "begin_date",
                                                    header: _("NGAY_BAT_DAU"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "end_date",
                                                    header: _("NGAY_KET_THUC"),
                                                    width: 200,
                                                },
                                                {
                                                    id: "issuer",
                                                    header: _("DONVI"),
                                                    width: 450,
                                                },
                                            ],
                                            url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                        });
                                    } else {
                                        var table = $$("mau04_68");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        // xem user có tích checkbox ký HSM không?
                                        var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                        webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                            if (resultscheckSigHSM[0].json() == "C") {
                                                var postData = {
                                                    branch_code: user.getDvcsID(),
                                                    username: user.getCurrentUser(),
                                                    ids: arrid,
                                                    check_HSM: "1",
                                                };

                                                webix.extend(tableDK, webix.ProgressBar);
                                                tableDK.disable();
                                                tableDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/huyhoadonSign", postData, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                app.callEvent("dataChangedMau0405", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                            } else {
                                                var a = webix.ajax(app.config.host + "/Invoice68/XmlMau0405?id=" + selectedItem.id);
                                                var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                webix.promise.all([a, b, selectedItem]).then(function (results) {
                                                    var json = results[0].json();

                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message({ type: "error", text: json.error });
                                                    }

                                                    var listcerts = results[1].json();
                                                    var item = results[2];

                                                    if (listcerts.length == 0) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                        return;
                                                    }

                                                    require(["views/modules/minvoiceplugin"], function (plugin) {
                                                        var hub = plugin.hub();
                                                        var hubconnect = plugin.conn();
                                                        if (hubconnect.state != 1) {
                                                            table.enable();
                                                            table.hideProgress();
                                                            webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                            return;
                                                        }
                                                        hub.off("resCommand");
                                                        hub.on("resCommand", function (result) {
                                                            var json = JSON.parse(result);

                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message({ type: "error", text: json.error });
                                                            } else {
                                                                var parameters = {
                                                                    xml: json.xml,
                                                                    id: selectedItem.id,
                                                                    tthdon: 3,
                                                                };

                                                                webix
                                                                    .ajax()
                                                                    .headers({ "Content-Type": "application/json" })
                                                                    .post(app.config.host + "/Invoice68/SaveXmlMau0405", parameters, function (text) {
                                                                        var result = JSON.parse(text);
                                                                        if (result.hasOwnProperty("error")) {
                                                                            webix.message(result.error, "error");
                                                                        } else {
                                                                            webix.message("Gửi thành công đến CQT !", "success");
                                                                            app.callEvent("dataChangedMau0405", [1, null]);
                                                                        }
                                                                    });
                                                            }
                                                            table.enable();
                                                            table.hideProgress();
                                                        });

                                                        var _listcerts = [];

                                                        for (var i = 0; i < listcerts.length; i++) {
                                                            var _cert = listcerts[i];

                                                            _listcerts.push({
                                                                so_serial: _cert.cer_serial,
                                                                ngaybatdau: _cert.begin_date,
                                                                ngayketthuc: _cert.end_date,
                                                                issuer: _cert.issuer,
                                                                subjectname: _cert.subject_name,
                                                            });
                                                        }

                                                        var arg = {
                                                            idData: "#data",
                                                            xml: json["xml"],
                                                            shdon: "",
                                                            idSigner: "seller",
                                                            tagSign: "NNT",
                                                            dvky: json["dvky"],
                                                            dateKy: json["dateKy"],
                                                            listcerts: _listcerts,
                                                        };

                                                        hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                            .done(function () {
                                                                console.log("Success !");
                                                            })
                                                            .fail(function (error) {
                                                                webix.message(error, "error");
                                                            });
                                                    });
                                                });
                                            }
                                        });
                                    }
                                });
                            });
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "mau04_68",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    scrollX: true,
                    cells: [
                        {
                            header: "Chi tiết hóa đơn",
                            body: {
                                view: "datatable",
                                height: 200,
                                resizeColumn: true,
                                id: "mau04_68_chitiet",
                                headerRowHeight: 50,
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.index = i + 1;
                                        });
                                    },
                                },
                                columns: [
                                    {
                                        view: "text",
                                        id: "mau04_id",
                                        name: "mau04_id",
                                        hidden: true,
                                    },
                                    {
                                        view: "text",
                                        id: "mau04_chitiet_id",
                                        name: "mau04_chitiet_id",
                                        hidden: true,
                                    },
                                    {
                                        view: "text",
                                        header: "STT",
                                        id: "index",
                                        name: "index",
                                        width: 80,
                                    },
                                    {
                                        header: "Mẫu số",
                                        id: "mau_so",
                                        width: 120,
                                    },

                                    {
                                        id: "khieu",
                                        name: "khieu",
                                        header: "Ký hiệu hóa đơn điện tử",
                                        width: 150,
                                    },
                                    {
                                        id: "shdon",
                                        name: "shdon",
                                        header: "Số hóa đơn điện tử",
                                        width: 120,
                                    },
                                    {
                                        id: "ngay",
                                        name: "ngay",
                                        header: "Ngày lập hóa đơn",
                                        width: 120,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },

                                    {
                                        id: "ladhddt",
                                        name: "ladhddt",
                                        header: "Loại áp dụng hóa đơn điện tử",
                                        template: function (obj) {
                                            switch (obj.ladhddt) {
                                                case 1:
                                                    return "<span>HĐĐT Nghị đinh số 123/2020/NĐ-CP</span> ";
                                                case 2:
                                                    return "<span>HĐĐT có mã của cơ quan thu</span> ";
                                                case 3:
                                                    return "<span>Các loại hóa đơn theo Nghị đinh 51/2010</span> ";
                                                case 4:
                                                    return "<span>Hóa đơn đặt in theo Nghị định số 123/2020/NĐ-C</span> ";
                                                default:
                                                    break;
                                            }
                                        },
                                        width: 150,
                                    },
                                    {
                                        id: "tctbao",
                                        name: "tctbao",
                                        header: "Điều chỉnh/Thay thế/Giải trình",
                                        editable: true,
                                        width: 200,
                                        template: function (obj) {
                                            switch (obj.tctbao) {                                        
                                                case 3:
                                                    return "Thay thế";
                                                case 4:
                                                    return "Giải trình";
                                                case 5:
                                                    return "Điều chỉnh tăng";
                                                case 6:
                                                    return "Điều chỉnh giảm";
                                                case 7:
                                                    return "Điều chỉnh khác";
                                                default:
                                                    break;
                                            }
                                        },
                                    },
                                    {
                                        id: "ldo",
                                        name: "ldo",
                                        header: "Lý do",
                                        width: 250,
                                    },
                                    {
                                        id: "tttnhan",
                                        name: "tttnhan",
                                        header: "Trạng thái tiếp nhận",
                                        template: function (obj) {
                                            if (obj.tttnhan == 1) {
                                                return "<span style='color: #00b300'>Chấp thuận</span> ";
                                            } else {
                                                if (obj.tttnhan == 2) {
                                                    return "<span style='color: #e83717'>Không chấp thuận</span> ";
                                                } else {
                                                    return "<span>Chờ phản hồi</span>";
                                                }
                                            }
                                        },
                                        width: 200,
                                    },
                                    {
                                        id: "ly_do",
                                        name: "ldly_doo",
                                        header: "Lý do không tiếp nhận",
                                        width: 250,
                                    },
                                ],
                                data: [
                                    {
                                        index: 1,
                                        khieu: "1KT20YY",
                                        shdon: "0000001",
                                        ngay: new Date(),
                                        ladhddt: "1",
                                        ldo: "Sai thông tin",
                                    },
                                    {
                                        index: 2,
                                        khieu: "1KT20YY",
                                        shdon: "0000002",
                                        ngay: new Date(),
                                        ladhddt: "1",
                                        ldo: "Sai tiền",
                                    },
                                ],
                            },
                        },
                    ],
                },
                scheme: {
                    $init: function () {
                    },
                },
                onClick: {
                    Dowload0405: function (event, cell, target) {
                        var win = webix.$$("mau04_68");
                        var record = win.getItem(cell.row);

                        if (record.loai_tbao != "5") {
                            if (record.trang_thai != 1) {
                                webix.message("Mẫu chưa được ký không thể tải !", "error");
                                return;
                            }
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = record.loai_tbao == "5" ? "Mau05.xml" : "Mau04.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLMau04?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                            });
                        return false; // here it blocks the default behavior
                    },
                    Dowload0405Rep: function (event, cell, target) {
                        var win = webix.$$("mau04_68");
                        var record = win.getItem(cell.row);

                        if (record.loai_tbao != "5") {
                            if (record.trang_thai != 1) {
                                webix.message("Mẫu chưa được ký không thể tải !", "error");
                                return;
                            }
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = record.loai_tbao == "5" ? "Mau05Rep.xml" : "Mau04Rep.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLMau04Rep?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                            });
                        return false; // here it blocks the default behavior
                    },
                    InMau0405: function (event, cell, target) {
                        var table = webix.$$("mau04_68");
                        var item = table.getItem(cell.row);

                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau04?id=" + item.id + "&type=PDF&loai=" + item.loai_tbao, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    InMau0405Rep: function (event, cell, target) {
                        var table = webix.$$("mau04_68");
                        var item = table.getItem(cell.row);

                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMau04Rep?id=" + item.id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                },
                on: {
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("mau04_68_chitiet");
                            var url = app.config.host + "/Invoice68/GetDataMau0405Detail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () { },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                        resize: false,
                    },
                    {
                        id: "mau04_id",
                        header: "mau04_id",
                        hidden: true,
                    },
                    {
                        template: "{common.subrow()}",
                        width: 50,
                    },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "shdon",
                        header: [
                            "Số hóa đơn",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 200,
                    },
                    {
                        id: "khieu",
                        header: [
                            "Ký hiệu",
                            {
                                content: "selectFilter",
                            },
                        ],

                        width: 200,
                    },
                    {
                        id: "loai_tbao",
                        header: [
                            "Loại thông báo",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 200,
                        template: function (obj) {
                            return obj.loai_tbao == "5" ? "Hóa đơn cần rà soát" : "Thông báo hóa đơn sai sót";
                        },
                    },
                    {
                        id: "trang_thai",
                        header: [
                            "Trạng thái",
                            {
                                content: "serverSelectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "0", value: "Chưa gửi CQT" },
                                    { id: "1", value: "Đã gửi CQT" },
                                ],
                            },
                        ],
                        width: 150,
                        template: function (obj) {
                            if (obj.loai_tbao == "5") {
                                return "";
                            } else {
                                return obj.trang_thai == 1
                                    ? "<span style='color: #00b300'><i class='fas fa-check'></i></span> Đã gửi CQT"
                                    : "<span style='color: red'><i class='fas fa-times'></i></span> Chưa gửi CQT";
                            }
                        },
                    },
                    {
                        id: "cqtphoi",
                        header: [
                            "<center>Trạng thái tiếp nhận CQT</center>",
                            {
                                content: "serverSelectFilter",
                                value: "",
                                options: [
                                    { id: "", value: "" },
                                    { id: "1", value: "Đã nhận phản hồi" },
                                    { id: "0", value: "Chưa nhận phản hồi" },
                                ],
                            },
                        ],
                        // sort: "int",
                        width: 150,

                        template: function (obj) {
                            return obj.cqtphoi == "1" ? "Đã nhận phản hồi" : "Chưa nhận phản hồi";
                        },
                    },

                    {
                        id: "mtdiep_gui",
                        header: ["Mã thông điệp gửi"],

                        width: 350,
                    },
                    {
                        id: "ntbao",
                        header: [
                            "Ngày tạo",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 120,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: { "text-align": "center" },
                        columnType: "datetime",
                    },
                    {
                        id: "ngay_gui",
                        header: [
                            "Ngày gửi",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 120,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        css: { "text-align": "center" },
                        columnType: "datetime",
                    },
                    {
                        id: "Dowload0405",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        width: 120,
                        template: function (obj) {
                            if (obj.loai_tbao == "5") {
                                return "<span class='Dowload0405' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else {
                                if (obj.trang_thai == 1) {
                                    return "<span class='Dowload0405' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                                } else return "<span class='Dowload0405' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                            }
                        },
                    },
                    {
                        id: "btnInMau0405",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.loai_tbao == "5") {
                                return "<span class='InMau0405' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else {
                                if (obj.trang_thai == 1) {
                                    return "<span class='InMau0405' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                                } else return "<span class='InMau0405' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                            }
                        },
                        width: 120,
                    },
                    {
                        id: "nguoi_gui",
                        header: [
                            "Người gửi",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 150,
                    },
                    {
                        id: "Dowload0405Rep",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.xml_nhan != null && obj.xml_nhan != "") {
                                return "<span class='Dowload0405Rep' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='Dowload0405Rep' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "btnInMau0405Rep",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.xml_nhan != null && obj.xml_nhan != "") {
                                return "<span class='InMau0405Rep' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau0405Rep' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "mtdiepcqt",
                        header: ["", "Mã thông điệp CQT"],
                        width: 250,
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("mau04_68");

            $scope.on(app, "dataChangedMau0405", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_mauthietkeform',["app", "models/user"], function (app, user) {
    var editmode = 0;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var table = $$("mauthietke-form");
                        var item = table.getValues();
                        if (table.validate()) {
                            item.editmode = editmode;
                            $$("uploader68").define("upload", app.config.host + "/Invoice68/quanlymau68");
                            $$("uploader68").define("formData", item);
                            $$("uploader68").send(function (res) {
                                if (res != undefined) {
                                    if (res.hasOwnProperty("error")) {
                                        webix.message({ type: "error", text: res.error });
                                    } else {
                                        webix.message("Tạo mẫu thành công", "success");

                                        var win = $$("uploader68").getTopParentView();
                                        win.close();

                                        var table = $$("mauthietke");
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                } else {
                                    webix.message("Bạn chưa chọn mẫu ", "error");
                                }
                            });
                        }
                    }, 100);

                    // $$("uploader68").refresh();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            click: function () {
                webix.$$("mauthietke-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "mauthietke-win",
        position: "center",
        head: "Mẫu hóa đơn",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "mauthietke-form",
            complexData: true,
            margin: 0,
            elementsConfig: {
                labelPosition: "top",
            },
            elements: [
                // {
                //     view: "text",
                //     label: "mauthietke_id",
                //     id: "mauthietke_id",
                //     name: "mauthietke_id",
                //     hidden: true
                // },
                {
                    view: "text",
                    label: "Mã mẫu",
                    name: "mmau",
                    id: "mmau",
                    readonly: true,
                    css: "mcls_readonly_text",
                    labelWidth: 120,
                },
                {
                    view: "text",
                    label: "Tên mẫu",
                    name: "tmau",
                    id: "tmau",
                    labelWidth: 120,
                    required: true,
                    invalidMessage: "Tên mẫu không được bỏ trống hoặc không đúng định dạng",
                },
                {
                    view: "select",
                    label: "Phân cách hàng nghìn",
                    name: "thousand_point",
                    id: "thousand_point",
                    labelWidth: 200,
                    options: [
                        { id: ".", value: "Dấu chấm" },
                        { id: ",", value: "Dấu phẩy" },
                    ],
                    on: {
                        onChange: function (newv, oldv) {
                            if (newv == ",") {
                                $$("decimal_point").setValue(".");
                            } else {
                                $$("decimal_point").setValue(",");
                            }
                        },
                    },
                },
                {
                    view: "select",
                    label: "Phân cách hàng thập phân",
                    name: "decimal_point",
                    id: "decimal_point",
                    options: [
                        { id: ",", value: "Dấu phẩy" },
                        { id: ".", value: "Dấu chấm" },
                    ],
                    labelWidth: 120,
                    on: {
                        onChange: function (newv, oldv) {
                            if (newv == ",") {
                                $$("thousand_point").setValue(".");
                            } else {
                                $$("thousand_point").setValue(",");
                            }
                        },
                    },
                },

                {
                    view: "uploader",
                    value: "Upload file",
                    label: "Mẫu thiết kế",
                    id: "uploader68",
                    name: "uploader68",
                    link: "mylist",
                    accept: "repx",
                    autosend: false,
                    multiple: false,
                    // upload: app.config.host + "",
                    on: {
                        onUploadComplete: function (response) {},
                        onFileUploadError: function (file, response) {},
                        onAfterDelete: function (id) {},
                    },
                },
                {
                    view: "list",
                    id: "mylist",
                    type: "uploader",
                    autoheight: true,
                    borderless: true,
                },
                {
                    height: 20,
                },
                {
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (item) {
            var form = $$("mauthietke-form");
            form.setValues(item);
        },
    };
});

define('views/68_mauthietke_bienlai',["app", "locale", "models/user", "views/forms/68_mauthietkeform"], function (app, _, user, mauthietkeform) {
    

    webix.$$("title").parse({
        title: "Quản lý mẫu thiết kế biên lai",
        details: "Quản lý mẫu thiết kế biên lai",
    });

    var loaimau =2;
    var subBangKe = webix.ui({
        view: "submenu",
        width: 150,
        padding: 0,
        data: [
            {
                id: "addMauBangKe",
                value: "Thêm mẫu bảng kê",
            },
            {
                id: "taiMauBangKe",
                value: "Tải mẫu bảng kê",
            },
            {
                id: "inMauBangKe",
                value: "In mẫu bảng kê",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                var table = webix.$$("mauthietke");
                var selectedItem = table.getSelectedItem();

                if (record.id == "addMauBangKe") {
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu biên lai cần thêm mẫu bảng kê ! ", "error");
                        return;
                    }
                    require(["views/forms/uploadfile"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);

                        win.getHead().setHTML("Tải file mẫu bảng kê");
                        win.show();

                        webix.$$("uploader").define("upload", app.config.host + "/Invoice68/UploadBangKeTemplate");
                        webix.$$("uploader").define("formData", { dmmauhoadon_id: selectedItem.id });
                        webix.$$("uploader").refresh();
                    });
                }

                if (record.id == "taiMauBangKe") {
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu biên lai cần tải bảng kê! ", "error");
                        return;
                    }
                    if (selectedItem.checkmaubangke == 0) {
                        webix.message("Chưa có mẫu bảng kê để tải ! ", "error");
                        return;
                    }
                    var url = app.config.host + "/Invoice68/DowloadRepxBangKe?id=" + selectedItem.id;
                    var box = webix.modalbox({
                        title: "Đang tải mẫu bảng kê (repx) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: "application/octet-stream" });
                            webix.html.download(file, "BangKeTemplate.repx");
                            webix.modalbox.hide(box);
                        });
                }

                if (record.id == "inMauBangKe") {
                    if (selectedItem == null || selectedItem == undefined) {
                        webix.message("Bạn chưa chọn mẫu biên lai cần in bảng kê!", "error");
                        return;
                    }

                    if (selectedItem.checkmaubangke == 0) {
                        webix.message("Mẫu bảng kê của hoá đơn chưa có để in ! ", "error");
                        return;
                    }

                    var box = webix.modalbox({
                        title: "Đang in mẫu bảng kê của biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inMauHoadon_QuanLyMau?id=" + selectedItem.id + "&checkLoaiMau=1", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                }
            },
        },
    });

    var initUI = function () {
        //var windowno = app.path[1].params[0];
        var table = webix.$$("mauthietke");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetDataQlymau";
                var donVi = user.getDvcsID();
                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var tlbParam = [
                    {
                        columnName: "code",
                        value: donVi,
                    },
                ];
                // tlbParam = [];
                url = url + "&tlbParam=" + JSON.stringify(tlbParam) +"&loaimau="+loaimau;
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(mauthietkeform.$ui);
                    var selectedItem ={loaimau:2}
                    mauthietkeform.setEditMode(1);
                    mauthietkeform.setValues(selectedItem);
                    $$("mauthietke-win").getHead().setHTML("Mẫu biên lai");
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu biên lai cần sửa ! ", "error");
                        return;
                    }

                    // if (selectedItem.tt_sd > 0) {
                    //     webix.message("Mẫu thiết kế đã sử dụng không thể sửa ! ", "error");
                    //     return;
                    // }
                    var detailForm = this.$scope.ui(mauthietkeform.$ui);

                    mauthietkeform.setEditMode(2);
                    mauthietkeform.setValues(selectedItem);
                    $$("mauthietke-win").getHead().setHTML("Mẫu biên lai");
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu thiết kế ! ", "error");
                        return;
                    }
                    if (selectedItem.tt_sd > 0) {
                        webix.message("Mẫu thiết kế đã sử dụng không thể xóa ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/deleteMau68", selectedItem, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var json = JSON.parse(text);
                                            if (json.error !== undefined) webix.message(json.error, "error");
                                            table.clearAll();
                                            table.load(table.config.url);
                                            table.enable();
                                            table.hideProgress();
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải") + "</span>",
            id: "btnDownload",
            // view: "button",
            // id: "btnDownload",
            // type: "icon",
            // icon: "download",
            // label: "Tải (F8)",
            // width: 100,
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu biên lai cần tải ! ", "error");
                        return;
                    }
                    var url = app.config.host + "/Invoice68/DowloadRepx?id=" + selectedItem.id;
                    var box = webix.modalbox({
                        title: "Đang tải mẫu biên lai (repx) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: "application/octet-stream" });
                            webix.html.download(file, "InvoiceTemplate.repx");
                            // var fileURL = URL.createObjectURL(file);
                            //console.log(fileURL);
                            webix.modalbox.hide(box);
                            //window.open(fileURL, '_blank');
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnIn",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn mẫu biên lai cần in !", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang in mẫu biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Biên lai điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inMauHoadon_QuanLyMau?id=" + item.id, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "mauthietke",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.date_new) {
                        //     obj.date_new = new Date(obj.date_new);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "qlkhsdung_id",
                        header: "qlkhsdung_id",
                        hidden: true,
                    },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "ntao",
                        header: [
                            "Ngày tạo",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        columnType: "datetime",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "mmau",
                        header: [
                            "Mã mẫu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "tmau",
                        header: [
                            "Tên mẫu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },

                    {
                        id: "ngtao",
                        header: [
                            "Người tạo",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "tt_sdung",
                        header: ["Sử dụng"],
                        css: {
                            "text-align": "center",
                        },
                        editor: "checkbox",
                        width: 90,
                        template: function (obj) {
                            var checked = obj.tt_sd > 0 ? 'checked="true"' : "";
                            return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("mauthietke");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("mauthietke");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChanged", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
            webix.$$("title").parse({
                title: "Quản lý mẫu thiết kế biên lai",
                details: "Quản lý mẫu thiết kế biên lai",
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/68_mauthietke_tncn',["app", "locale", "models/user", "views/forms/68_mauthietkeform"], function (app, _, user, mauthietkeform) {
    

    webix.$$("title").parse({
        title: "Quản lý mẫu thiết kế Chứng từ thuế thu nhập cá nhân",
        details: "Quản lý mẫu thiết kế Chứng từ thuế thu nhập cá nhân",
    });

    var loaimau =3;
    var subBangKe = webix.ui({
        view: "submenu",
        width: 150,
        padding: 0,
        data: [
            {
                id: "addMauBangKe",
                value: "Thêm mẫu bảng kê",
            },
            {
                id: "taiMauBangKe",
                value: "Tải mẫu bảng kê",
            },
            {
                id: "inMauBangKe",
                value: "In mẫu bảng kê",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                var table = webix.$$("mauthietke");
                var selectedItem = table.getSelectedItem();

                if (record.id == "addMauBangKe") {
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu Chứng từ cần thêm mẫu bảng kê ! ", "error");
                        return;
                    }
                    require(["views/forms/uploadfile"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);

                        win.getHead().setHTML("Tải file mẫu bảng kê");
                        win.show();

                        webix.$$("uploader").define("upload", app.config.host + "/Invoice68/UploadBangKeTemplate");
                        webix.$$("uploader").define("formData", { dmmauhoadon_id: selectedItem.id });
                        webix.$$("uploader").refresh();
                    });
                }

                if (record.id == "taiMauBangKe") {
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu Chứng từ cần tải bảng kê! ", "error");
                        return;
                    }
                    if (selectedItem.checkmaubangke == 0) {
                        webix.message("Chưa có mẫu bảng kê để tải ! ", "error");
                        return;
                    }
                    var url = app.config.host + "/Invoice68/DowloadRepxBangKe?id=" + selectedItem.id;
                    var box = webix.modalbox({
                        title: "Đang tải mẫu bảng kê (repx) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: "application/octet-stream" });
                            webix.html.download(file, "BangKeTemplate.repx");
                            webix.modalbox.hide(box);
                        });
                }

                if (record.id == "inMauBangKe") {
                    if (selectedItem == null || selectedItem == undefined) {
                        webix.message("Bạn chưa chọn mẫu chứng từ cần in bảng kê!", "error");
                        return;
                    }

                    if (selectedItem.checkmaubangke == 0) {
                        webix.message("Mẫu bảng kê của hoá đơn chưa có để in ! ", "error");
                        return;
                    }

                    var box = webix.modalbox({
                        title: "Đang in mẫu bảng kê của chứng từ ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>chứng từ điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inMauHoadon_QuanLyMau?id=" + selectedItem.id + "&checkLoaiMau=1", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                }
            },
        },
    });

    var initUI = function () {
        //var windowno = app.path[1].params[0];
        var table = webix.$$("mauthietke");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetDataQlymau";
                var donVi = user.getDvcsID();
                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var tlbParam = [
                    {
                        columnName: "code",
                        value: donVi,
                    },
                ];
                // tlbParam = [];
                url = url + "&tlbParam=" + JSON.stringify(tlbParam) +"&loaimau="+loaimau;
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(mauthietkeform.$ui);
                    var selectedItem ={loaimau:3}
                    mauthietkeform.setEditMode(1);
                    mauthietkeform.setValues(selectedItem);
                    $$("mauthietke-win").getHead().setHTML("Mẫu chứng từ");
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu chứng từ cần sửa ! ", "error");
                        return;
                    }

                    // if (selectedItem.tt_sd > 0) {
                    //     webix.message("Mẫu thiết kế đã sử dụng không thể sửa ! ", "error");
                    //     return;
                    // }
                    var detailForm = this.$scope.ui(mauthietkeform.$ui);

                    mauthietkeform.setEditMode(2);
                    mauthietkeform.setValues(selectedItem);
                    $$("mauthietke-win").getHead().setHTML("Mẫu chứng từ");
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu thiết kế ! ", "error");
                        return;
                    }
                    if (selectedItem.tt_sd > 0) {
                        webix.message("Mẫu thiết kế đã sử dụng không thể xóa ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/deleteMau68", selectedItem, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var json = JSON.parse(text);
                                            if (json.error !== undefined) webix.message(json.error, "error");
                                            table.clearAll();
                                            table.load(table.config.url);
                                            table.enable();
                                            table.hideProgress();
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải") + "</span>",
            id: "btnDownload",
            // view: "button",
            // id: "btnDownload",
            // type: "icon",
            // icon: "download",
            // label: "Tải (F8)",
            // width: 100,
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu chứng từ cần tải ! ", "error");
                        return;
                    }
                    var url = app.config.host + "/Invoice68/DowloadRepx?id=" + selectedItem.id;
                    var box = webix.modalbox({
                        title: "Đang tải mẫu chứng từ (repx) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: "application/octet-stream" });
                            webix.html.download(file, "InvoiceTemplate.repx");
                            // var fileURL = URL.createObjectURL(file);
                            //console.log(fileURL);
                            webix.modalbox.hide(box);
                            //window.open(fileURL, '_blank');
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnIn",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn mẫu chứng từ cần in !", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang in mẫu chứng từ ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>chứng từ điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inMauHoadon_QuanLyMau?id=" + item.id, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "mauthietke",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.date_new) {
                        //     obj.date_new = new Date(obj.date_new);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "qlkhsdung_id",
                        header: "qlkhsdung_id",
                        hidden: true,
                    },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "ntao",
                        header: [
                            "Ngày tạo",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        columnType: "datetime",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "mmau",
                        header: [
                            "Mã mẫu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "tmau",
                        header: [
                            "Tên mẫu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },

                    {
                        id: "ngtao",
                        header: [
                            "Người tạo",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "tt_sdung",
                        header: ["Sử dụng"],
                        css: {
                            "text-align": "center",
                        },
                        editor: "checkbox",
                        width: 90,
                        template: function (obj) {
                            var checked = obj.tt_sd > 0 ? 'checked="true"' : "";
                            return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("mauthietke");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("mauthietke");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChanged", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/68_mauthietke',["views/commonHD", "app", "locale", "models/user", "views/forms/68_mauthietkeform"], function (commonHD, app, _, user, mauthietkeform) {
    
    var subBangKe = webix.ui({
        view: "submenu",
        width: 150,
        padding: 0,
        data: [
            {
                id: "addMauBangKe",
                value: "Thêm mẫu bảng kê",
            },
            {
                id: "taiMauBangKe",
                value: "Tải mẫu bảng kê",
            },
            {
                id: "inMauBangKe",
                value: "In mẫu bảng kê",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                var table = webix.$$("mauthietke");
                var selectedItem = table.getSelectedItem();

                if (record.id == "addMauBangKe") {
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn cần thêm mẫu bảng kê ! ", "error");
                        return;
                    }
                    require(["views/forms/uploadfile"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);

                        win.getHead().setHTML("Tải file mẫu bảng kê");
                        win.show();

                        webix.$$("uploader").define("upload", app.config.host + "/Invoice68/UploadBangKeTemplate");
                        webix.$$("uploader").define("formData", { dmmauhoadon_id: selectedItem.id });
                        webix.$$("uploader").refresh();
                    });
                }

                if (record.id == "taiMauBangKe") {
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn cần tải bảng kê! ", "error");
                        return;
                    }
                    if (selectedItem.checkmaubangke == 0) {
                        webix.message("Chưa có mẫu bảng kê để tải ! ", "error");
                        return;
                    }
                    var url = app.config.host + "/Invoice68/DowloadRepxBangKe?id=" + selectedItem.id;
                    var box = webix.modalbox({
                        title: "Đang tải mẫu bảng kê (repx) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: "application/octet-stream" });
                            webix.html.download(file, "BangKeTemplate.repx");
                            webix.modalbox.hide(box);
                        });
                }

                if (record.id == "inMauBangKe") {
                    if (selectedItem == null || selectedItem == undefined) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn cần in bảng kê!", "error");
                        return;
                    }

                    if (selectedItem.checkmaubangke == 0) {
                        webix.message("Mẫu bảng kê của hoá đơn chưa có để in ! ", "error");
                        return;
                    }

                    var box = webix.modalbox({
                        title: "Đang in mẫu bảng kê của hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inMauHoadon_QuanLyMau?id=" + selectedItem.id + "&checkLoaiMau=1", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                }
            },
        },
    });

    var subPhieuThu = webix.ui({
        view: "submenu",
        width: 150,
        padding: 0,
        data: [
            {
                id: "addMauPhieuThu",
                value: "Thêm mẫu phiếu thu",
            },
            {
                id: "taiMauPhieuThu",
                value: "Tải mẫu phiếu thu",
            },
            {
                id: "inMauPhieuThu",
                value: "In mẫu phiếu thu",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                var table = webix.$$("mauthietke");
                var selectedItem = table.getSelectedItem();

                if (record.id == "addMauPhieuThu") {
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn cần thêm mẫu phiếu thu ! ", "error");
                        return;
                    }
                    require(["views/forms/uploadfile"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);

                        win.getHead().setHTML("Tải file mẫu phiếu thu");
                        win.show();

                        webix.$$("uploader").define("upload", app.config.host + "/Invoice68/UploadPhieuThuTemplate");
                        webix.$$("uploader").define("formData", { dmmauhoadon_id: selectedItem.id });
                        webix.$$("uploader").refresh();
                    });
                }

                if (record.id == "taiMauPhieuThu") {
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn cần tải phiếu thu! ", "error");
                        return;
                    }
                    if (selectedItem.checkmauphieuthu == 0) {
                        webix.message("Chưa tồn tại mẫu phiếu thu! ", "error");
                        return;
                    }
                    var url = app.config.host + "/Invoice68/DowloadRepxPhieuThu?id=" + selectedItem.id;
                    var box = webix.modalbox({
                        title: "Đang tải mẫu phiếu thu (repx) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: "application/octet-stream" });
                            webix.html.download(file, "PhieuThuTemplate.repx");
                            webix.modalbox.hide(box);
                        });
                }

                if (record.id == "inMauPhieuThu") {
                    if (selectedItem == null || selectedItem == undefined) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn cần in phiếu thu!", "error");
                        return;
                    }

                    if (selectedItem.checkmauphieuthu == 0) {
                        webix.message("Chưa tồn tại mẫu phiếu thu ! ", "error");
                        return;
                    }

                    var box = webix.modalbox({
                        title: "Đang in mẫu phiếu thu của hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inMauHoadon_QuanLyMau?id=" + selectedItem.id + "&checkLoaiMau=2", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                }
            },
        },
    });

    var initUI = function () {
        //var windowno = app.path[1].params[0];
        var table = webix.$$("mauthietke");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetDataQlymau";
                var donVi = user.getDvcsID();
                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var tlbParam = [
                    {
                        columnName: "code",
                        value: donVi,
                    },
                ];
                // tlbParam = [];
                url = url + "&tlbParam=" + JSON.stringify(tlbParam);
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    commonHD.clear_filter(table);
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(mauthietkeform.$ui);
                    mauthietkeform.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn cần sửa ! ", "error");
                        return;
                    }

                    // if (selectedItem.tt_sd > 0) {
                    //     webix.message("Mẫu thiết kế đã sử dụng không thể sửa ! ", "error");
                    //     return;
                    // }
                    var detailForm = this.$scope.ui(mauthietkeform.$ui);

                    mauthietkeform.setEditMode(2);
                    mauthietkeform.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu thiết kế ! ", "error");
                        return;
                    }
                    if (selectedItem.tt_sd > 0) {
                        webix.message("Mẫu thiết kế đã sử dụng không thể xóa ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/deleteMau68", selectedItem, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var json = JSON.parse(text);
                                            if (json.error !== undefined) webix.message(json.error, "error");
                                            table.clearAll();
                                            table.load(table.config.url);
                                            table.enable();
                                            table.hideProgress();
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Tải") + "</span>",
            id: "btnDownload",
            // view: "button",
            // id: "btnDownload",
            // type: "icon",
            // icon: "download",
            // label: "Tải (F8)",
            // width: 100,
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn cần tải ! ", "error");
                        return;
                    }
                    var url = app.config.host + "/Invoice68/DowloadRepx?id=" + selectedItem.id;
                    var box = webix.modalbox({
                        title: "Đang tải mẫu hóa đơn (repx) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: "application/octet-stream" });
                            webix.html.download(file, "InvoiceTemplate.repx");
                            // var fileURL = URL.createObjectURL(file);
                            //console.log(fileURL);
                            webix.modalbox.hide(box);
                            //window.open(fileURL, '_blank');
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnIn",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn cần in !", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang in mẫu hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inMauHoadon_QuanLyMau?id=" + item.id, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Bảng kê") + "</span>",
            id: "btnBangKeMauIn",
            click: function () {
                subBangKe.show(webix.$$("btnBangKeMauIn").$view);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Phiếu thu") + "</span>",
            id: "btnPhieuThuMauIn",
            click: function () {
                subPhieuThu.show(webix.$$("btnPhieuThuMauIn").$view);
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "mauthietke",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.date_new) {
                        //     obj.date_new = new Date(obj.date_new);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "qlkhsdung_id",
                        header: "qlkhsdung_id",
                        hidden: true,
                    },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "ntao",
                        header: [
                            "Ngày tạo",
                            {
                                content: "serverDateRangeFilter",
                            },
                        ],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        columnType: "datetime",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "mmau",
                        header: [
                            "Mã mẫu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "tmau",
                        header: [
                            "Tên mẫu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },

                    {
                        id: "ngtao",
                        header: [
                            "Người tạo",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                    },
                    {
                        id: "decimal_point",
                        header: ["Phân cách hàng thập phân"],
                        width: 200,
                        css: {
                            "text-align": "center",
                        },
                        template: function (obj) {
                            console.log("thập phân " + obj.decimal_point);
                            var check = obj.decimal_point == "," ? "Dấu phẩy" : "Dấu chấm";
                            return check;
                        },
                    },
                    {
                        id: "thousand_point",
                        header: ["Phân cách hàng nghìn"],
                        width: 200,
                        css: {
                            "text-align": "center",
                        },
                        template: function (obj) {
                            console.log("hàng nghìn " + obj.thousand_point);
                            var check = obj.thousand_point == "." ? "Dấu chấm" : "Dấu phẩy";
                            return check;
                        },
                    },
                    {
                        id: "tt_sdung",
                        header: ["Sử dụng"],
                        css: {
                            "text-align": "center",
                        },
                        editor: "checkbox",
                        width: 90,
                        template: function (obj) {
                            var checked = obj.tt_sd > 0 ? 'checked="true"' : "";
                            return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                        },
                    },
                    {
                        id: "tt_sdung",
                        header: ["Mẫu phiếu thu"],
                        css: {
                            "text-align": "center",
                        },
                        editor: "checkbox",
                        width: 110,
                        template: function (obj) {
                            var checked = obj.checkmauphieuthu == 1 ? 'checked="true"' : "";
                            return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("mauthietke");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("mauthietke");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChanged", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
            if (webix.$$("head-title") != null) {
                webix.$$("head-title").show()
            }
           
            webix.$$("title").parse({
                title: "Quản lý mẫu thiết kế hóa đơn",
                details: "Quản lý mẫu thiết kế hóa đơn",
            });
        },
    };
});

define('views/forms/68_kyhieu_hoadon_bienlai',["app", "locale", "models/user"], function (app, _, user) {
    var editmode = 0;
    var param;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var item = $$("kyhieu-form").getValues();
                        var table = $$("kyhieu-form");
                        item.editmode = editmode;
                        if (table.validate()) {
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();
                            item.id = item.phanhoadon_78_id
                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .post(app.config.host + "/Invoice68/hoadonkihieu68", item, {
                                    error: function (text, data, XmlHttpRequest) {
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        // var json = JSON.parse(text);
                                        // webix.message(json.ExceptionMessage, "error");
                                        webix.message(text + XmlHttpRequest, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text);
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            $$("kyhieu-win").close();
                                            var table = $$("kyhieu_hoadon");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    },
                                });
                        }
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("kyhieu-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "kyhieu-win",
        position: "center",
        head: "Đăng ký ký hiệu ",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "kyhieu-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "kyhieu_id",
                    label: "Ký hiệu ",
                    //labelPosition: "top",
                    id: "kyhieu_id",
                    required: true,
                    labelWidth: 120,
                    invalidMessage: "Ký hiệu  không được bỏ trống",
                    options: {
                    body: {
                        url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF02003",
                        template: function (obj) {

                            if(obj.khmbl != null && obj.khmbl != ""){
                                return obj.value + " - " + obj.khmbl;
                            }
                                 return obj.value;
                            
                        }
                    }
                },
                    
                    on: {
                        onChange: function (newv, oldv) {
                            var test = newv;
                        },
                    },
                },
                {
                    view: "text",
                    name: "tongso",
                    label: _("Số lượng"),
                    editor: "autonumeric",
                    labelWidth: 120,
                    required: true,
                    css: { "text-align": "right" },
                    validate: function (val) {
                        if (val === undefined || val === null || val === "") return false;
                        return !isNaN(val) && val >= 0 && val < 100000000;
                    },
                    attributes: { type: "number" },
                    invalidMessage: "Phải nhập số dương và nhỏ hơn 100000000",
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {
            $$("kyhieu-form").setValues(item);
            if (editmode == 2) {
                $$("kyhieu_id").define("readonly", true);
            }
        },
    };
});

define('views/68_quanlihoadon_kihieu_bienlai',["app", "locale", "models/user", "views/forms/68_kyhieu_hoadon_bienlai"], function (app, _, user, kyhieuForm) {
    
    var isActiveDbClick = true;
    var initUI = function () {
        // var windowno = app.path[1].params[0];
        var table = webix.$$("kyhieu_hoadon");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetHoaDonkyhieu68";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                    var array =[];
                    if (params.filter != null) {
                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                    }
                    url = url + "&filter=" + JSON.stringify(array);
                }
                var arrayParam = [];
                var branchcode = {
                    columnName: "branch_code",
                    value: user.getDvcsID(),
                };
                arrayParam.push(branchcode);
                url = url + "&tlbparam=" + JSON.stringify(arrayParam) +"&loaikh=2";
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);
                    kyhieuForm.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn! ", "error");
                        return;
                    }
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);

                    kyhieuForm.setEditMode(2);
                    kyhieuForm.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn ký hiệu hóa đơn cần xóa ! ", "error");
                        return;
                    }
                    if (selectedItem.sosudung > 0) {
                        webix.message("Ký hiệu đã sử dụng không thể xóa ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/hoadonkihieu68", selectedItem, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var res = JSON.parse(text);
                                            if (res.hasOwnProperty("error")) {
                                                webix.message(res.error, "error");
                                            } else {
                                                table.remove(selectedItem.id);
                                                table.enable();
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "kyhieu_hoadon",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.ngayLap) {
                        //     obj.ngayLap = new Date(obj.ngayLap);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        if(isActiveDbClick) {
                            var btnEdit = $$("btnEdit");
                            btnEdit.callEvent("onClick");
                        }
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "kyhieu_id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "khhdon",
                        header: [
                            "Kí hiệu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 240,
                    },
                    {
                        id: "khmbl",
                        header: [
                            "Kí hiệu mẫu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 240,
                    },

                    {
                        id: "tongso",
                        header: [
                            "Tổng số",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                    },
                    {
                        id: "sosudung",
                        header: [
                            "Số sử dụng",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "soconlai",
                        header: [
                            "Số còn lại",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ngaybatdau",
                        format: function (text) {
                            var test = new Date(text);
                            if (test !== null && test !== "null") {
                                var format = webix.Date.dateToStr("%d-%m-%Y %H:%i:%s");
                                text = removeTimeZoneT(test);
                                return format(text);
                            }
                            return "";
                        },
                        width: 240,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "branch_code",
                        header: [
                            "Đơn vị tạo",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("kyhieu");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangedKyhieu68", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
            if (webix.$$("head-title") != null) {
                webix.$$("head-title").show();

                // Vẽ thêm thoong tin
                webix.ajax().get(app.config.host + "/Invoice68/GetConfigInvSymbol", function (text) {
                    var json = JSON.parse(text);
                    var config = json['data']
                    if(config == "K") {
                        isActiveDbClick = false;
                        webix.$$("btnPlus").hide();
                        webix.$$("btnEdit").hide();
                        webix.$$("btnDelete").hide();
                    } else {
                        isActiveDbClick = true;
                    }
                });
                
                webix
                    .ajax()
                    .headers({ "Content-Type": "application/json" })
                    .get(app.config.host + "/Invoice68/DashboardTiles_License", function (res) {
                        var data = JSON.parse(res);
                        console.log(data);

                        if(data && data["items"]) {
                            var items = data["items"];
                            var total = items.find(function(e) {
                                return e.css == "orders";
                            })
                            var used = items.find(function(e) {
                                return e.css == "number-orders";
                            })
                            var available = items.find(function(e) {
                                return e.css == "users";
                            })

                            $$("head-title").removeView("head-title-subui");
                            $$("head-title").addView(
                                {
                                    id: "head-title-subui",
                                    rows: [
                                        {
                                            cols: [
                                                { view: "label", label: "<b>Tổng số hóa đơn đã đăng ký:</b>", align: "right", width: 200 },
                                                { view: "label", label: total.tien.toLocaleString('vi-VN'), align: "left", width: 100 },
                                                { view: "label", label: "<b>Số sử dụng:</b>", align: "right", width: 200 },
                                                { view: "label", label: used.tien.toLocaleString('vi-VN'), align: "left", width: 100 },
                                                { view: "label", label: "<b>Số hết hạn sử dụng:</b>", align: "right", width: 200 },
                                                { view: "label", label: "0", align: "left", width: 100 },
                                                { view: "label", label: "<b>Số còn lại:</b>", align: "right", width: 200 },
                                                { view: "label", label: available.tien.toLocaleString('vi-VN'), align: "left", width: 100 },
                                            ]
                                        }
                                    ]
                                }
                            );
                        }
                    });
            }

            webix.$$("title").parse({
                title: "Quản lý số lượng HĐ cho từng ký hiệu biên lai",
                details: "Quản lý số lượng HĐ cho từng ký hiệu biên lai",
            });
        },
    };
});

define('views/forms/68_kyhieu_hoadon_tncn',["app", "locale", "models/user"], function (app, _, user) {
    var editmode = 0;
    var param;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var item = $$("kyhieu-form").getValues();
                        var table = $$("kyhieu-form");
                        item.editmode = editmode;
                        if (table.validate()) {
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();
                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .post(app.config.host + "/Invoice68/hoadonkihieu68", item, {
                                    error: function (text, data, XmlHttpRequest) {
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        // var json = JSON.parse(text);
                                        // webix.message(json.ExceptionMessage, "error");
                                        webix.message(text + XmlHttpRequest, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text);
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            $$("kyhieu-win").close();
                                            var table = $$("kyhieu_hoadon");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    },
                                });
                        }
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("kyhieu-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "kyhieu-win",
        position: "center",
        head: "Đăng ký ký hiệu ",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "kyhieu-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "kyhieu_id",
                    label: "Ký hiệu ",
                    //labelPosition: "top",
                    id: "kyhieu_id",
                    required: true,
                    labelWidth: 120,
                    invalidMessage: "Ký hiệu  không được bỏ trống",
                    options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF02000",
                    on: {
                        onChange: function (newv, oldv) {
                            var test = newv;
                        },
                    },
                },
                {
                    view: "text",
                    name: "tongso",
                    label: _("Số lượng"),
                    editor: "autonumeric",
                    labelWidth: 120,
                    required: true,
                    css: { "text-align": "right" },
                    validate: function (val) {
                        if (val === undefined || val === null || val === "") return false;
                        return !isNaN(val) && val >= 0 && val < 100000000;
                    },
                    attributes: { type: "number" },
                    invalidMessage: "Phải nhập số dương và nhỏ hơn 100000000",
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {
            $$("kyhieu-form").setValues(item);
            if (editmode == 2) {
                $$("kyhieu_id").define("readonly", true);
            }
        },
    };
});

define('views/68_quanlihoadon_kihieu_tncn',["app", "locale", "models/user", "views/forms/68_kyhieu_hoadon_tncn"], function (app, _, user, kyhieuForm) {
    

    webix.$$("title").parse({
        title: "Quản lý số lượng chứng từ cho từng ký hiệu chứng từ",
        details: "Quản lý số lượng chứng từ cho từng ký hiệu chứng từ",
    });

    var initUI = function () {
        // var windowno = app.path[1].params[0];
        var table = webix.$$("kyhieu_hoadon");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetHoaDonkyhieu68";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                    var array =[];
                    if (params.filter != null) {
                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                    }
                    url = url + "&filter=" + JSON.stringify(array);
                }
                var arrayParam = [];
                var branchcode = {
                    columnName: "branch_code",
                    value: user.getDvcsID(),
                };
                arrayParam.push(branchcode);
                url = url + "&tlbparam=" + JSON.stringify(arrayParam) +"&loaikh=3";
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);
                    kyhieuForm.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn! ", "error");
                        return;
                    }
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);

                    kyhieuForm.setEditMode(2);
                    kyhieuForm.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn ký hiệu chứng từ cần xóa ! ", "error");
                        return;
                    }
                    if (selectedItem.sosudung > 0) {
                        webix.message("Ký hiệu đã sử dụng không thể xóa ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/hoadonkihieu68", selectedItem, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var res = JSON.parse(text);
                                            if (res.hasOwnProperty("error")) {
                                                webix.message(res.error, "error");
                                            } else {
                                                table.remove(selectedItem.id);
                                                table.enable();
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "kyhieu_hoadon",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.ngayLap) {
                        //     obj.ngayLap = new Date(obj.ngayLap);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "kyhieu_id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "khhdon",
                        header: [
                            "Ký hiệu",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 240,
                    },
                    {
                        id: "tongso",
                        header: [
                            "Tổng số",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                    },
                    {
                        id: "sosudung",
                        header: [
                            "Số sử dụng",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "soconlai",
                        header: [
                            "Số còn lại",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ngaybatdau",
                        header: "Ngày bắt đầu",
                        format: function (text) {
                            var test = new Date(text);
                            if (test !== null && test !== "null") {
                                var format = webix.Date.dateToStr("%d-%m-%Y %H:%i:%s");
                                text = removeTimeZoneT(test);
                                return format(text);
                            }
                            return "";
                        },
                        width: 240,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "branch_code",
                        header: [
                            "Đơn vị tạo",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("kyhieu");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangedKyhieu68", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/68_kyhieu_hoadon',["app", "locale", "models/user"], function (app, _, user) {
    var editmode = 0;
    var param;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var item = $$("kyhieu-form").getValues();
                        var table = $$("kyhieu-form");
                        item.editmode = editmode;
                        item.id = item.phanhoadon_78_id;
                        if (table.validate()) {
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();
                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .post(app.config.host + "/Invoice68/hoadonkihieu68", item, {
                                    error: function (text, data, XmlHttpRequest) {
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        // var json = JSON.parse(text);
                                        // webix.message(json.ExceptionMessage, "error");
                                        webix.message(text + XmlHttpRequest, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text);
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            $$("kyhieu-win").close();
                                            var table = $$("kyhieu_hoadon");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    },
                                });
                        }
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("kyhieu-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "kyhieu-win",
        position: "center",
        head: "Đăng ký ký hiệu ",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "kyhieu-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    view: "combo",
                    name: "kyhieu_id",
                    label: "Ký hiệu ",
                    id: "kyhieu_id",
                    required: true,
                    labelWidth: 120,
                    invalidMessage: "Ký hiệu  không được bỏ trống",
                    css: "mcls_uppercase",
                    options: {
                        url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00120",
                    },
                    on: {
                        onChange: function (newv, oldv) {
                            var test = newv;
                        },
                    },
                },
                {
                    view: "text",
                    name: "tongso",
                    label: _("Số lượng"),
                    editor: "autonumeric",
                    labelWidth: 120,
                    required: true,
                    css: { "text-align": "right" },
                    validate: function (val) {
                        if (val === undefined || val === null || val === "") return false;
                        return !isNaN(val) && val >= 0 && val < 100000000;
                    },
                    attributes: { type: "number" },
                    invalidMessage: "Phải nhập số dương và nhỏ hơn 100000000",
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {
            $$("kyhieu-form").setValues(item);
            if (editmode == 2) {
                $$("kyhieu_id").define("readonly", true);
            }
        },
    };
});

define('views/68_quanlihoadon_kihieu',["views/commonHD", "app", "locale", "models/user", "views/forms/68_kyhieu_hoadon"], function (commonHD, app, _, user, kyhieuForm) {
    
    var isActiveDbClick = true;
    var initUI = function () {
        // var windowno = app.path[1].params[0];
        var table = webix.$$("kyhieu_hoadon");

        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetHoaDonkyhieu68";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                    var array = [];
                    if (params.filter != null) {
                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                    }
                    url = url + "&filter=" + JSON.stringify(array);
                }
                var arrayParam = [];
                var branchcode = {
                    columnName: "branch_code",
                    value: user.getDvcsID(),
                };
                arrayParam.push(branchcode);
                url = url + "&tlbparam=" + JSON.stringify(arrayParam);
                view.config.params = params
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    commonHD.clear_filter(table);
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);
                    kyhieuForm.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn! ", "error");
                        return;
                    }
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);

                    kyhieuForm.setEditMode(2);
                    kyhieuForm.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu_hoadon");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn ký hiệu hóa đơn cần xóa ! ", "error");
                        return;
                    }
                    if (selectedItem.sosudung > 0) {
                        webix.message("Ký hiệu đã sử dụng không thể xóa ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    var dataPost = {
                        editmode: 3,
                        id: selectedItem.phanhoadon_78_id,
                        kyhieu_id: selectedItem.kyhieu_id
                    }
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Invoice68/hoadonkihieu68", dataPost, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.error, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var res = JSON.parse(text);
                                            if (res.hasOwnProperty("error")) {
                                                webix.message(res.error, "error");
                                            } else {
                                                table.remove(selectedItem.id);
                                                table.enable();
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Kết xuất màn hình")  + "</span>",
            id: "btnXuatExel",
            click: function () {
                webix.confirm({
                    text: "Kết xuất màn hình toàn bộ hóa đơn theo filter?",
                    ok: "Có",
                    cancel: "Không",
                    width: 300,
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var table = $$("kyhieu_hoadon");
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            var datafetch = table.config.datafetch;
                            table.config.datafetch = table.data.count();
                            var params = table.config.params;
                            if (params != null && params != undefined) {
                                params.count = table.data.count();
                            }
                            var columnlst = table.config.columns;
                            var arrcolumn = [];

                            for (var i = 0; i < columnlst.length; i++) {
                                var exporttype = "";
                                if (columnlst[i].columnType == "character varying" || columnlst[i].columnType == "nvarchar") {
                                    exporttype = "string";
                                } else {
                                    exporttype = columnlst[i].columnType;
                                }
        
                                if (columnlst[i].id == "chinhphu") {
                                    exporttype = "string";
                                }
        
                                var item = {
                                    id: columnlst[i].id,
                                    header: columnlst[i].header[0]["text"],
                                    exportType: exporttype
                                };
        
                                arrcolumn.push(item);
                            }  

                            table.load(
                                table.config.url,
                                function () {
                                debugger

                                webix.toExcel($$("kyhieu_hoadon"), {
                                    columns: arrcolumn,
                                        rawValues: false,
                                    filename: "SoLuongHoaDonChoTungKyHieu",
                                });
                                    debugger;
                                table.config.datafetch = datafetch;
                                table.enable();
                                table.hideProgress();
                                },
                                params
                            );
                        }
                    },
                });
            },
        },
        {},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "kyhieu_hoadon",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                        // if (obj.ngayLap) {
                        //     obj.ngayLap = new Date(obj.ngayLap);
                        // }
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        if(isActiveDbClick) {
                            var btnEdit = $$("btnEdit");
                            btnEdit.callEvent("onClick");
                        }
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    },
                },
                columns: [
                    {
                        id: "id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "kyhieu_id",
                        header: "kyhieu_id",
                        hidden: true,
                    },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric",
                    },
                    {
                        id: "khhdon",
                        header: [
                            "Ký hiệu",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 240,
                    },
                    {
                        id: "tongso",
                        header: [
                            "Tổng số",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                    },
                    {
                        id: "sosudung",
                        header: [
                            "Số sử dụng",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    }, {
                        id: "soconlai",
                        header: [
                            "Số còn lại",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ngaybatdau",
                        format: function (text) {
                            var test = new Date(text);
                            if (test !== null && test !== "null") {
                                var format = webix.Date.dateToStr("%d-%m-%Y %H:%i:%s");
                                text = removeTimeZoneT(test);
                                return format(text);
                            }
                            return "";
                        },
                        width: 240,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "branch_code",
                        header: [
                            "Đơn vị tạo",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 120,
                        columnType: "numeric",
                        css: {
                            "text-align": "center",
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("kyhieu");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangedKyhieu68", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
            if (webix.$$("head-title") != null) {
                webix.$$("head-title").show();

                // Vẽ thêm thoong tin
                webix.ajax().get(app.config.host + "/Invoice68/GetConfigInvSymbol", function (text) {
                    var json = JSON.parse(text);
                    var config = json['data']
                    if(config == "K") {
                        isActiveDbClick = false;
                        webix.$$("btnPlus").hide();
                        webix.$$("btnEdit").hide();
                        webix.$$("btnDelete").hide();
                    } else {
                        isActiveDbClick = true;
                    }
                });

                webix
                    .ajax()
                    .headers({ "Content-Type": "application/json" })
                    .get(app.config.host + "/Invoice68/DashboardTiles_License", function (res) {
                        var data = JSON.parse(res);

                        if(data && data["items"]) {
                            var items = data["items"];
                            var total = items.find(function(e) {
                                return e.css == "orders";
                            })
                            var used = items.find(function(e) {
                                return e.css == "number-orders";
                            })
                            var available = items.find(function(e) {
                                return e.css == "users";
                            })

                            $$("head-title").removeView("head-title-subui");
                            $$("head-title").addView(
                                {
                                    id: "head-title-subui",
                                    rows: [
                                        {
                                            cols: [
                                                { view: "label", label: "<b>Tổng số hóa đơn đã đăng ký:</b>", align: "right", width: 200 },
                                                { view: "label", label: total.tien.toLocaleString('vi-VN'), align: "left", width: 100 },
                                                { view: "label", label: "<b>Số sử dụng:</b>", align: "right", width: 200 },
                                                { view: "label", label: used.tien.toLocaleString('vi-VN'), align: "left", width: 100 },
                                                { view: "label", label: "<b>Số hết hạn sử dụng:</b>", align: "right", width: 200 },
                                                { view: "label", label: "0", align: "left", width: 100 },
                                                { view: "label", label: "<b>Số còn lại:</b>", align: "right", width: 200 },
                                                { view: "label", label: available.tien.toLocaleString('vi-VN'), align: "left", width: 100 },
                                            ]
                                        }
                                    ]
                                }
                            );
                        }
                    });
            }

            webix.$$("title").parse({
                title: "Quản lý số lượng HĐ cho từng ký hiệu HĐ",
                details: "Quản lý số lượng HĐ cho từng ký hiệu HĐ",
            });
        },
    };
});

define('views/68_quanlylog',["app", "locale", "models/user"], function (app, _, user ) {
    

    var layout = {
        rows: [
            // 1. Tiêu đề "Log hệ thống"
            {
                type: "header",
                template: "Log hệ thống"
            },

            // 2. Form/Toolbar lọc theo thời gian
            {
                view: "toolbar",
                id: "myToolbar",
                cols: [
                    {
                        view: "label",
                        label: "Thời gian",
                        width: 80
                    },
                    {
                        view: "datepicker",
                        name: "startDate",
                        value: new Date(),
                        label: "Từ ngày",
                        timepicker: true
                    },
                    {
                        view: "label",
                        label: "-",
                        width: 20,
                        align: "center"
                    },
                    {
                        view: "datepicker",
                        name: "endDate",
                        value: new Date(),
                        label: "Đến ngày",
                        timepicker: true
                    },
                    {
                        view: "button",
                        value: "Tải dữ liệu",
                        css: "webix_primary",
                        width: 110,
                        click: function () {
                        
                            var values = $$("myToolbar").getValues();

                            var start = values.startDate;
                            var end = values.endDate;

                            if (start && end) {
                                var url = app.config.host + "/Invoice68/SearchLogs";
                                var params = {
                                    dateFrom: start,
                                    dateTo: end
                                };

                                webix.ajax().response("blob").get(url, params, {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message("Đã xảy ra lỗi khi tải file: " + XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        try {
                                            var filename = "";
                                            var disposition = XmlHttpRequest.getResponseHeader("Content-Disposition");
                                            if (disposition && disposition.indexOf("attachment") !== -1) {
                                                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                                                var matches = filenameRegex.exec(disposition);
                                                if (matches != null && matches[1]) {
                                                    filename = matches[1].replace(/['"]/g, "");
                                                }
                                            }
                                            var date = new Date(); 

                                            var formatter = webix.Date.dateToStr("%Y%m%d_%H%i%s");
                                            var timestamp = formatter(date); // 3. Định dạng ngày giờ

                                            // 4. Logic của bạn
                                            if (!filename) {
                                                filename = "Log.txt";
                                            }

                                            // 5. Tách và gắn tên file
                                            var dotIndex = filename.lastIndexOf('.');
                                            var baseName = filename.substring(0, dotIndex);
                                            var extension = filename.substring(dotIndex);

                                            filename = baseName + "_" + timestamp + extension;
                                            // --- 2. Tạo link ẩn để tải file ---
                                            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                                // Xử lý cho trình duyệt IE / Edge cũ
                                                window.navigator.msSaveOrOpenBlob(data, filename);
                                            } else {
                                                var fileUrl = window.URL.createObjectURL(data);
                                                var link = document.createElement("a");
                                                link.href = fileUrl;
                                                link.setAttribute("download", filename);
                                                document.body.appendChild(link);
                                                link.click(); // Tự động click vào link để tải

                                                // Dọn dẹp
                                                document.body.removeChild(link);
                                                window.URL.revokeObjectURL(fileUrl);
                                            }

                                            webix.message("Tải file thành công!");

                                        } catch (e) {
                                            webix.message("Lỗi xử lý file tải về: " + e.message, "error");
                                        }
                                    }
                                });

                            } else {
                                webix.message("Vui lòng chọn cả ngày bắt đầu và kết thúc");
                            }
                        }
                    },
                    {}
                ]
            },

            {
                view: "pager",
                id: "pager",
                // Template tùy chỉnh để khớp với văn bản trong ảnh
                template: "{common.first()} {common.prev()} &nbsp; Trang: {common.page()}/{common.pagecount()} &nbsp; {common.next()} {common.last()} &nbsp;&nbsp; Số bản ghi: {common.data_count()}"
            }
        ]
    };

    // Module trả về đối tượng UI để framework (như Webix Jet) render
    return {
        $ui: layout
    };
});
define('views/68_thongdiepthuetrave',["app", "locale", "models/user"], function (app, _, user) {
    

    webix.$$("title").parse({
        title: "Quản lý mã thông điệp CQT",
        // details: "Bảng tổng hợp hóa đơn",
    });

    var initUI = function () {
        var table = webix.$$("mau04_68");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/GetThongDiepThueTraVe";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };

                            array.push(item);
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            // view: "button",
            // type: "htmlbutton",
            // width: 100,
            // label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            // id: "btnRefresh",
            // on: {
            //     onClick: function () {
            //         var table = webix.$$("mau04_68");
            //         table.clearAll();
            //         table.load(table.config.url);
            //     },
            // },
            // click: function () {
            //     this.callEvent("onClick");
            // },
        },
        {
            // view: "button",
            // type: "htmlbutton",
            // width: 100,
            // label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            // id: "btnPlus",
            // shortcut: "F4",
            // on: {
            //     onClick: function () {
            //         // var detailForm = this.$scope.ui(form_0405.$ui);
            //         // form_0405.setEditMode(0);
            //         // detailForm.show();
            //     },
            // },
            // click: function () {
            //     this.callEvent("onClick");
            // },
        },
        {
            // view: "button",
            // type: "htmlbutton",
            // width: 100,
            // label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            // id: "btnEdit",
            // shortcut: "F3",
            // on: {
            //     onClick: function () {
            //         var table = webix.$$("mau04_68");
            //         var selectedItem = table.getSelectedItem();
            //         if (selectedItem == null) {
            //             webix.message("Bạn chưa chọn hóa đơn ! ", "error");
            //             return;
            //         }
            //         if (selectedItem.trang_thai == 1) {
            //             webix.message("Mẫu đã ký và gửi CQT bạn không thể sửa! ", "error");
            //             return;
            //         }
            //         if (selectedItem.loai_tbao == "5") {
            //             webix.message("Mẫu 05 nhận từ CQT bạn không thể sửa! ", "error");
            //             return;
            //         }
            //         // var detailForm = this.$scope.ui(form_0405.$ui);
            //         // form_0405.setEditMode(0);
            //         // detailForm.show();
            //     },
            // },
            // click: function () {
            //     this.callEvent("onClick");
            // },
        },
        {
            // view: "button",
            // type: "htmlbutton",
            // width: 100,
            // label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            // id: "btnDelete",
            // shortcut: "F8",
            // on: {
            //     onClick: function () {
            //         var table = webix.$$("mau04_68");
            //         var selectedItem = table.getSelectedItem();
            //         if (selectedItem == null) {
            //             webix.message("Bạn chưa chọn khách hàng ! ", "error");
            //             return;
            //         }
            //         if (selectedItem.trang_thai == 1) {
            //             webix.message("Mẫu đã ký và gửi CQT bạn không thể xóa! ", "error");
            //             return;
            //         }
            //         if (selectedItem.loai_tbao == "5") {
            //             webix.message("Mẫu 05 nhận từ CQT bạn không thể xóa! ", "error");
            //             return;
            //         }
            //         webix.confirm({
            //             text: "Bạn có muốn xóa hóa đơn",
            //             ok: "Có",
            //             cancel: "Không",
            //             callback: function (choose) {
            //                 if (choose) {
            //                     webix.extend(table, webix.ProgressBar);
            //                     table.disable();
            //                     table.showProgress();
            //                     webix
            //                         .ajax()
            //                         .headers({ "Content-type": "application/json" })
            //                         .post(app.config.host + "/Invoice68/deleteMau04", selectedItem, {
            //                             error: function (text, data, XmlHttpRequest) {
            //                                 table.enable();
            //                                 table.hideProgress();
            //                                 var json = JSON.parse(text);
            //                                 webix.message(json.error, "error");
            //                                 //webix.message(XmlHttpRequest.statusText, "error");
            //                             },
            //                             success: function (text, data, XmlHttpRequest) {
            //                                 table.remove(selectedItem.id);
            //                                 table.enable();
            //                                 table.hideProgress();
            //                             },
            //                         });
            //                 }
            //             },
            //         });
            //     },
            // },
            // click: function () {
            //     this.callEvent("onClick");
            // },
        },
        // {
        //     view: "button",
        //     type: "htmlbutton",
        //     width: 100,
        //     label: '<i class="fa fa-eye fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Xem in") + " (F7)" + "</span>",
        //     id: "btnPreview",
        //     shortcut: "F7",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("mau04_68");
        //             var selectedItem = table.getSelectedItem();
        //             if (selectedItem == null) {
        //                 webix.message("Bạn chưa chọn dòng in ! ", "error");
        //                 return;
        //             }
        //             var box = webix.modalbox({
        //                 title: "Đang in hóa đơn ....",
        //                 text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        //                 width: 350,
        //                 height: 200,
        //             });

        //             var newWin = window.open();
        //             var html =
        //                 "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
        //                 '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
        //                 '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
        //                 '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
        //             newWin.document.write(html);

        //             webix
        //                 .ajax()
        //                 .response("arraybuffer")
        //                 .headers({ "Content-type": "application/json" })
        //                 .get(app.config.host + "/Invoice68/inMau04?id=" + selectedItem.id + "&type=PDF&loai=" + selectedItem.loai_tbao, {
        //                     error: function (text, data, XmlHttpRequest) {
        //                         webix.modalbox.hide(box);
        //                         webix.message(XmlHttpRequest.statusText, "error");
        //                     },
        //                     success: function (text, data, XmlHttpRequest) {
        //                         var file = new Blob([data], { type: "application/pdf" });
        //                         var fileURL = URL.createObjectURL(file);
        //                         //window.open(fileURL, '_blank');
        //                         webix.modalbox.hide(box);
        //                         newWin.location = fileURL;
        //                     },
        //                 });
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        {},
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "mau04_68",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function () {
                        // this.data.each(function (obj, i) {
                        //     obj.index = i + 1;
                        // });
                    },
                },
                onClick: {
                    Dowload0405: function (event, cell, target) {
                        var win = webix.$$("mau04_68");
                        var record = win.getItem(cell.row);

                        // if (record.loai_tbao != "5") {
                        //     if (record.trang_thai != 1) {
                        //         webix.message("Mẫu chưa được ký không thể tải !", "error");
                        //         return;
                        //     }
                        // }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename =
                            record.mltdiep == "202"
                                ? "202.xml"
                                : record.mltdiep == "204"
                                ? "204.xml"
                                : record.mltdiep == "301"
                                ? "301.xml"
                                : record.mltdiep == "302"
                                ? "302.xml"
                                : record.mltdiep == "102"
                                ? "102.xml"
                                : record.mltdiep == "103"
                                ? "103.xml"
                                : "104.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLThongDiepCQT?id=" + record.id;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        return false; // here it blocks the default behavior
                    },

                    InMau0405: function (event, cell, target) {
                        var table = webix.$$("mau04_68");
                        var item = table.getItem(cell.row);

                        //webix.message("Chưa có mẫu in ...", "error");
                        // var rpParameter = null;
                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inMaThongDiepCQT?id=" + item.id + "&mltdiep=" + item.mltdiep, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                },
                on: {
                    // onSubViewCreate: function (view, item) {
                    //     var subView = view;

                    //     if (subView != null) {
                    //         var tableDetail = webix.$$("mau04_68_chitiet");
                    //         var url = app.config.host + "/Invoice68/GetDataMau0405Detail?id=" + item.id;
                    //         tableDetail.clearAll();
                    //         tableDetail.load(url);
                    //     }
                    // },
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {},
                },
                columns: [
                    // {
                    //     id: "id",
                    //     header: "id",
                    //     hidden: true,
                    // },
                    // {
                    //     template: "{common.subrow()}",
                    //     width: 50,
                    // },
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "mltdiep",
                        header: [
                            "Mã loại thông điệp",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 200,
                    },
                    {
                        id: "mltdiep",
                        header: [
                            "Tên loại thông điệp",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 200,
                        template: function (obj) {
                            return obj.mltdiep == "202"
                                ? "Cấp mã hóa đơn"
                                : obj.mltdiep == "204"
                                ? "Kiểm tra dữ liệu hóa đơn"
                                : obj.mltdiep == "301"
                                ? "Xử lý hóa đơn sai sót"
                                : obj.mltdiep == "302"
                                ? "Rà soát hóa đơn"
                                : obj.mltdiep == "102"
                                ? "Tiếp nhận tờ khai ĐK/SD HDDT"
                                : obj.mltdiep == "103"
                                ? "Chấp nhận tờ khai ĐK/SD HDDT"
                                : "Chấp nhận tờ khai ĐK/SD HDDT khi ủy nhiệm/nhận ủy nhiệm";
                        },
                    },
                    {
                        id: "mtdiep_cqt",
                        //header: ["", "Mã thông điệp CQT"],
                        header: [
                            "Mã thông điệp CQT",
                            {
                                content: "serverFilter",
                            },
                        ],
                        width: 450,
                    },
                    {
                        id: "Dowload0405",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        width: 120,
                        template: function (obj) {
                            return "<span class='Dowload0405' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            // if (obj.loai_tbao == "5") {
                            //     return "<span class='Dowload0405' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            // } else {
                            //     if (obj.trang_thai == 1) {
                            //         return "<span class='Dowload0405' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            //     } else return "<span class='Dowload0405' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                            // }
                        },
                    },
                    {
                        id: "InMau0405",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.mltdiep != "204" && obj.mltdiep != "202") {
                                return "<span class='InMau0405' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else {
                                return "<span style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                            }
                        },
                        width: 120,
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("mau04_68");

            // $scope.on(app, "dataChangedMau0405", function (mode, item) {
            //     // if (mode == 1) {
            //     //     table.add(item);
            //     // }
            //     // if (mode == 5) {
            //     table.clearAll();
            //     table.load(table.config.url);
            //     // }
            // });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/78_duyethoadon_bienlai',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_huyhoadon", "views/forms/68_huyhoadon_1", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    invoiceForms,
    huyhoadon,
    huyhoadon_1,
    hoadonHistory,
    commonHD
) {
    
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: 0,
        });
        return k(number);
    };
    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            // {
            //     id: "huyhoadon",
            //     value: "Hủy biên lai",
            // },
            // {
            //     id: "huyhoadon2",
            //     value: "Hủy biên lai có tạo mới",
            // },
            // {
            //     id: "giaitrinh",
            //     value: "Giải trình",
            // },
            {
                id: "notifyErrorInvoice",
                value: "Thông báo HĐĐT có sai sót",
            },
            {
                id: "replace_invoice",
                value: "Thay thế",
            },
            {
                id: "increase_change_invoice",
                value: "Điều chỉnh tăng",
            },
            {
                id: "reduce_change_invoice",
                value: "Điều chỉnh giảm",
            },
            {
                id: "info_change",
                value: "Điều chỉnh thông tin",
            },
            {
                id: "dowloadXml",
                value: "Tải XML",
            },
            {
                id: "dowloadXmlMessageHD",
                value: "Tải XML thông điệp gửi HĐ",
            },
            // {
            //     id: "nhanExcel",
            //     value: "Nhận Excel hàng loạt",
            // },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                if (record.id == "nhanExcel") {
                    var table = $$("invoiceViews");

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", { excel_id: "EX00011", filename: "Nhan hang loat hoa don 68 (GTGT).xlsx" });
                        webix.$$("uploader").hide();
                    });
                }
                // console.log(record);
                if (record.id == "huyhoadon") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("biên lai đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("biên lai đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);

                    webix.$$("btnHuyhoadon").destructor();
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "huyhoadon2") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("biên lai đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("biên lai đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnStep299").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    // webix.$$("btnStep299").define("hidden", false);
                    // webix.$$("btnStep2").show();
                    // webix.$$("btnStep299").hide();
                    // $$("btnHuyHDDT").addView({ view:"button",label: "Bước 2" }, 1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "dowloadXml") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("biên lai đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlInvoice.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "dowloadXmlMessageHD") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("biên lai chưa được gửi tới CQT, không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLThongDiepHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlThongDiepHoaDon.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "giaitrinh") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthdon != "4" && item.tthdon != "0") {
                        webix.message("biên lai không ở trạng thái rà soát không thể lập giải trình !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnSaveSignGiaiTrinh").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    // webix.$$("tctbao").setValue(2);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    this.hide();
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 2,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();

                    // var fn = Function("_", "user", item.on_click);
                    // fn(_, user);
                }
                if (record.id == "notifyErrorInvoice") {
                    var table = webix.$$("invoiceViews");
                    var datafrm = table.serialize();
                    var data = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i]);
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        var cungshd = true;
                        for (var k = 1; k <= data.length - 1; k++) {
                            if (data[k]["stbao"] !== data[0]["stbao"]) {
                                cungshd = false;
                                break;
                            }
                        }
                        if (cungshd === true) {
                            var loai = 1;
                            if (data[0]["stbao"] !== null) loai = 2;
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký" || data[i].tthai == "Đã ký") {
                                    webix.message("biên lai chưa gửi không thể thông báo sai sót", "error");
                                    return;
                                }
                                if (data[i].ladhddt == undefined) {
                                    data[i].ladhddt = "1";
                                }
                                if (data[i].tctbao == undefined) {
                                    data[i].tctbao = "1";
                                }
                            }

                            var win = table.$scope.ui(huyhoadon.$ui);
                            huyhoadon.setEditMode(1);
                            webix.$$("btnHuyhoadon").destructor();
                            var tongquat = {
                                so: data[0].stbao,
                                ntbccqt: data[0].ntbao,
                                loai: loai,
                            };
                            huyhoadon.setValuesTongQuat(tongquat, null, null);
                            data.forEach(function (item) {
                                var put = {
                                    khieu: item.khieu,
                                    shdon: item.shdon,
                                    ngay: item.nlap,
                                    ladhddt: item.ladhddt,
                                    tctbao: item.tctbao,
                                    hdon_id: item.id,
                                };
                                huyhoadon.setValues(put, null, null);
                                //this.hide();
                                win.show();
                            });
                        } else {
                            webix.message("Các biên lai chọn phải có số thông báo giống nhau", "error");
                        }
                    } else {
                        var item = table.getSelectedItem();

                        var loai = 1;
                        if (item["stbao"] !== null) loai = 2;

                        if (item == null) {
                            webix.message("Bạn chưa chọn biên lai", "error");
                            return;
                        }

                        if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                            webix.message("biên lai chưa gửi không thể thông báo sai sót", "error");
                            return;
                        }

                        if (item.ladhddt == undefined) {
                            item["ladhddt"] = "1";
                        }
                        if (item.tctbao == undefined) {
                            item["tctbao"] = "1";
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();

                        var tongquat = {
                            so: item.stbao,
                            ntbccqt: item.ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);

                        var put = {
                            khieu: item.khieu,
                            shdon: item.shdon,
                            ngay: item.nlap,
                            ladhddt: item.ladhddt,
                            tctbao: item.tctbao,
                            hdon_id: item.id,
                        };
                        huyhoadon.setValues(put, null, null);

                        //this.hide();
                        win.show();
                    }

                    // var win = table.$scope.ui(huyhoadon.$ui);
                    // huyhoadon.setEditMode(1);
                    // webix.$$("btnHuyhoadon").destructor();

                    // webix.$$("btnSaveSignGiaiTrinh").show();
                    // webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("btnGhiHuyhoadon").destructor();
                    // webix.$$("btnGhiSignHuyHDDT").destructor();
                    // this.hide();
                    // win.show();
                }
                if (record.id == "replace_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 2;
                    item.tthdon_original = 2;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var tableDetail = webix.$$("hoadon68_chitiet");

                    tableDetail.clearAll();
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "increase_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 19;
                    item.tthdon_original = 19;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    // var tableDetail = webix.$$("hoadon68_chitiet");
                    // tableDetail.clearAll();
                    // tableDetail.refresh();

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "biên lai điều chỉnh cho biên lai số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    /*tableDetail.getColumnConfig("sluong").editor = null;
                    tableDetail.getColumnConfig("thtien").editor = null;
                    tableDetail.getColumnConfig("tsuat").editor = null;
                    tableDetail.getColumnConfig("tgtien").editor = null;
                    tableDetail.getColumnConfig("tthue").editor = null;*/
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();

                    //detailForm.show();
                }
                if (record.id == "reduce_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 21;
                    item.tthdon_original = 21;
                    item.nky = "";
                    item.hdon_id = "";
                    item.note = "reduce_change_invoice";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);
                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "biên lai điều chỉnh cho biên lai số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "info_change") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 23;
                    item.tthdon_original = 23;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";

                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "biên lai điều chỉnh cho biên lai số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    // tableDetail.getColumnConfig("sluong").editor = null;
                    // tableDetail.getColumnConfig("thtien").editor = null;
                    // tableDetail.getColumnConfig("tsuat").editor = null;
                    // tableDetail.getColumnConfig("tgtien").editor = null;
                    // tableDetail.getColumnConfig("tthue").editor = null;
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();
                }
            },
        },
    });

    webix.$$("title").parse({ title: "Danh sách biên lai chờ ký", details: "Danh sách biên lai chờ ký" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in biên lai",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại biên lai gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function (e) {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>biên lai điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                    e.preventDefault();
                    e.stopPropagation();
                },
            },
            click: function () {
                console.log("click");
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("In chuyển đổi") + "</span>",
            id: "btnPrintConvert",
            hidden: true,
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>biên lai điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký biên lai") + "</span>",
            id: "btnKyCXL",
            click: function () {
                webix.confirm({
                    text: "Bạn chắc chắn muốn ký biên lai ?",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var dsHoaDon = commonHD.validate_BL_ReturnListHdonKhongMaVaCoMaId();
                            var lsCoMa = dsHoaDon[0];
                            var lsKhongMa = dsHoaDon[1];

                            // console.log(lsCoMa);
                            // console.log(lsKhongMa);
                            if (lsCoMa.length > 0 || lsKhongMa.length > 0) {
                                var lsHodonId = [];
                                lsHodonId.push(lsCoMa);
                                lsHodonId.push(lsKhongMa);
                                commonHD.ExcuteHoaDonForHasCodeAndNotHaveAnyCode(lsHodonId, false, true, "TCTPhi");
                            }
                        }
                    },
                });
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Kết xuất màn hình") + "</span>",
            id: "btnXuatExel",
            click: function () {
                webix.confirm({
                    text: "Kết xuất màn hình toàn bộ biên lai theo filter?",
                    ok: "Có",
                    cancel: "Không",
                    width: 300,
                    callback: function (res) {
                        if (res) {
                            var table = $$("invoiceViews");

                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            var datafetch = table.config.datafetch;
                            table.config.datafetch = table.data.count();
                            var params = table.config.params;
                            if (params != null && params != undefined) {
                                params.count = table.data.count();
                            }
                            var columnlst = table.config.columns;
                            var arrcolumn = [];

                            for (var i = 2; i < columnlst.length; i++) {
                                var exporttype = "";
                                if (columnlst[i].columnType == "character varying" || columnlst[i].columnType == "nvarchar") {
                                    exporttype = "string";
                                } else {
                                    exporttype = columnlst[i].columnType;
                                }
                                var item = {
                                    id: columnlst[i].id,
                                    header: columnlst[i].header[0]["text"],

                                    exportType: exporttype,
                                };
                                arrcolumn.push(item);
                            }

                            table.load(
                                table.config.url,
                                function () {
                                    webix.toExcel($$("invoiceViews"), {
                                        columns: arrcolumn,
                                        rawValues: true,
                                        filename: "DanhSachHoaDonFull",
                                    });
                                    table.config.datafetch = datafetch;
                                    table.enable();
                                    table.hideProgress();
                                },
                                params
                            );
                        }
                    },
                });
            },
        },
        // Khong duoc xoa cai ngoac nhon nay
        {},
    ];
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0,
    });
    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var daiKyHieu = "";
                        //get count list combo ký hiệu
                        //var countkyHieu = $$("kyhieu_id") != undefined ? $$("kyhieu_id").getPopup().getList().serialize().length : 0;
                        var url = app.config.host + "/Invoice68/GetDataInvoiceDanhSachChoKy";

                        var table = $$("invoiceViews");
                        if (params == null) {
                            commonHD.clear_filter(view);
                            table.config.params = null;
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            webix.storage.local.put("currentFilter", params.filter);
                            table.define("params", params);
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property],
                                        filterType: column.header[1].content,
                                    };

                                    if (item.value != null && item.value != "") {
                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                            }
                            url = url + "&filter=null";
                        }
                        url = url + "&tlbparam=null&tthai=Chờ ký&loaihd=2";
                        webix.ajax(url, callback, view);
                    },
                },
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    // onItemDblClick: function (id, e, node) {
                    //     var btnEdit = $$("btnEdit");
                    //     btnEdit.callEvent("onClick");
                    // },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "stt",
                        header: ["STT"],
                        //header: "",
                        sort: "int",
                        width: 40,
                        columnType: "nvarchar",
                        //css: { "line-height": "20px !important", "height": "63px !important"}
                    },
                    {
                        id: "ttthdon",
                        width: 200,
                        header: [
                            "Trạng thái",
                            {
                                content: "serverMultiSelectFilter",
                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00502",
                            },
                        ],
                        template: function (obj, common) {
                            console.log(obj.tthdon);
                            return "<span class='mcls_status" + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        },
                    },
                    {
                        id: "tthai",
                        header: ["Trạng thái biên lai", { content: "serverMultiSelectFilter", options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00504" }],
                        width: 200,
                    },
                    //
                    // {
                    //     id: "btnMessagetn",
                    //     header: ["<center>Lịch sử xử lý</center>"],
                    //     css: { "text-align": "center" },
                    //     template: function (obj) {
                    //         return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                    //     },
                    //     width: 180,
                    // },
                    // {
                    //     id: "issendmail",
                    //     header: ["<center>Gửi Email</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     checkValue: true, uncheckValue: false,
                    //     template: "{common.rcheckbox()}"
                    // },
                    // {
                    //     id: "error_status",
                    //     header: ["<center>Có lỗi/Không có lỗi</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     template: function (obj) {
                    //         if (obj.error_status == "1") {
                    //             return "<span style='color: #e83717'>Có lỗi</span> ";
                    //         } else {
                    //             return "";
                    //         }
                    //     }
                    // },
                    {
                        id: "nlap",
                        header: ["Ngày biên lai", { content: "serverDateRangeFilter" }],
                        width: 120,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        // template: function (obj, common) {
                        //     if(obj.tthai!="Chờ ký"){
                        //         return obj.nlap="";
                        //     }
                        //     else{
                        //         var format = webix.Date.dateToStr("%d/%m/%Y");
                        //         var text = removeTimeZoneT(obj.nlap);
                        //         return format(text);
                        //     }
                        // },
                        columnType: "datetime",
                    },
                    // {
                    //     id: "nky",
                    //     header: ["<center>Ngày ký</center>", { content: "serverDateRangeFilter" }],
                    //     width: 150,
                    //     css: { "text-align": "center" },
                    //     //format:webix.i18n.dateFormatStr
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    //     columnType: "datetime",
                    // },
                    {
                        id: "khieu",
                        header: ["Ký hiệu", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        columnType: "nvarchar",
                    },
                    { id: "shdon", header: ["Số biên lai", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },

                    { id: "mst", header: ["Mã số thuế", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    { id: "mdvi", header: ["Đơn vị quản lý", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    { id: "ten_str", header: ["Tên đơn vị/ Tên người mua", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    {
                        id: "tgtttbso_last",
                        header: ["Số thuế thu nhập", { content: "textFilter" }],
                        width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tgtttbso_last == null ? 0 : fm(obj.tgtttbso_last);
                        },
                        columnType: "numeric",
                    },
                    {
                        id: "nglap",
                        header: ["Người lập", { content: "textFilter" }],
                        width: 200,
                        columnType: "nvarchar",
                    },
                    // { id: "ten_loai", header: ["<center>Tên loại HĐ</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                webix.message("change page size to " + newv);
                                $$("pagerA").config.size = newv * 1;
                                var table = $$("invoiceViews");
                                table.define("datafetch", newv);
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({ title: "Danh sách chờ ký", details: "Danh sách chờ ký" });
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
            // var table = $$("invoiceViews");
            // var url = {
            //     $proxy: true,
            //     load: function (view, callback, params) {
            //         console.log(view.config);
            //         console.log(callback);
            //         console.log(params);
            //         /*var windowno = app.path[1].params[0];
            //         var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

            //         if (params == null) {
            //             url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            //         }
            //         else {
            //             url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

            //             if (params.filter != null) {
            //                 var array = [];

            //                 for (var property in params.filter) {

            //                     var column = view.getColumnConfig(property);

            //                     if (column !== undefined) {
            //                         var item = {
            //                             columnName: property,
            //                             columnType: column.columnType,
            //                             value: params.filter[property]
            //                         };

            //                         array.push(item);
            //                     }
            //                 }

            //                 //console.log(JSON.stringify(array));
            //                 if (array.length > 0) {
            //                     url = url + "&filter=" + JSON.stringify(array);
            //                 }
            //                 else {
            //                     url = url + "&filter=null";
            //                 }

            //             }
            //             else {
            //                 url = url + "&filter=null";
            //             }
            //         }

            //         if (view.config.infoparam != null) {
            //             url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
            //         }
            //         else {
            //             url = url + "&infoparam=null";
            //         }

            //         var tlbParams = $$("tlbParams");

            //         if (tlbParams !== undefined) {
            //             var childViews = tlbParams.getChildViews();

            //             var parameters = [];

            //             for (var i = 0; i < childViews.length; i++) {
            //                 var child = childViews[i];

            //                 var id = child.config.id;
            //                 var value_field = child.config.value_field;

            //                 var item = {
            //                     columnName: value_field,
            //                     value: $$(id).getValue()
            //                 };

            //                 parameters.push(item);
            //             }

            //             url = url + "&tlbparam=" + JSON.stringify(parameters);

            //         }
            //         else {
            //             url = url + "&tlbparam=null";
            //         }*/

            //         //console.log(url);

            //         /* webix.ajax().bind(view)
            //             .get(url,function(text){
            //                 var json =JSON.parse(text);

            //                 this.clearAll();

            //                 if (!json.hasOwnProperty("error")){
            //                     this.parse(json.data,"json");
            //                 }
            //         }); */

            //         //webix.ajax(url, callback, view);

            //     }
            // };

            // table.define("url", url);
        },
    };
});

define('views/78_duyethoadon_choduyet_bienlai',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_huyhoadon", "views/forms/68_huyhoadon_1", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    invoiceForms,
    huyhoadon,
    huyhoadon_1,
    hoadonHistory,
    commonHD
) {
    
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: 0,
        });
        return k(number);
    };
    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            // {
            //     id: "huyhoadon",
            //     value: "Hủy biên lai",
            // },
            // {
            //     id: "huyhoadon2",
            //     value: "Hủy biên lai có tạo mới",
            // },
            // {
            //     id: "giaitrinh",
            //     value: "Giải trình",
            // },
            {
                id: "notifyErrorInvoice",
                value: "Thông báo HĐĐT có sai sót",
            },
            {
                id: "replace_invoice",
                value: "Thay thế",
            },
            {
                id: "increase_change_invoice",
                value: "Điều chỉnh tăng",
            },
            {
                id: "reduce_change_invoice",
                value: "Điều chỉnh giảm",
            },
            {
                id: "info_change",
                value: "Điều chỉnh thông tin",
            },
            {
                id: "dowloadXml",
                value: "Tải XML",
            },
            {
                id: "dowloadXmlMessageHD",
                value: "Tải XML thông điệp gửi HĐ",
            },
            // {
            //     id: "nhanExcel",
            //     value: "Nhận Excel hàng loạt",
            // },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                if (record.id == "nhanExcel") {
                    var table = $$("invoiceViews");

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", { excel_id: "EX00011", filename: "Nhan hang loat hoa don 68 (GTGT).xlsx" });
                        webix.$$("uploader").hide();
                    });
                }
                // console.log(record);
                if (record.id == "huyhoadon") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("biên lai đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("biên lai đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);

                    webix.$$("btnHuyhoadon").destructor();
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "huyhoadon2") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("biên lai đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("biên lai đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnStep299").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    // webix.$$("btnStep299").define("hidden", false);
                    // webix.$$("btnStep2").show();
                    // webix.$$("btnStep299").hide();
                    // $$("btnHuyHDDT").addView({ view:"button",label: "Bước 2" }, 1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "dowloadXml") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("biên lai đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlInvoice.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "dowloadXmlMessageHD") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("biên lai chưa được gửi tới CQT, không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLThongDiepHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlThongDiepHoaDon.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "giaitrinh") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthdon != "4" && item.tthdon != "0") {
                        webix.message("biên lai không ở trạng thái rà soát không thể lập giải trình !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnSaveSignGiaiTrinh").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    // webix.$$("tctbao").setValue(2);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    this.hide();
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 2,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();

                    // var fn = Function("_", "user", item.on_click);
                    // fn(_, user);
                }
                if (record.id == "notifyErrorInvoice") {
                    var table = webix.$$("invoiceViews");
                    var datafrm = table.serialize();
                    var data = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i]);
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        var cungshd = true;
                        for (var k = 1; k <= data.length - 1; k++) {
                            if (data[k]["stbao"] !== data[0]["stbao"]) {
                                cungshd = false;
                                break;
                            }
                        }
                        if (cungshd === true) {
                            var loai = 1;
                            if (data[0]["stbao"] !== null) loai = 2;
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký" || data[i].tthai == "Đã ký") {
                                    webix.message("biên lai chưa gửi không thể thông báo sai sót", "error");
                                    return;
                                }
                                if (data[i].ladhddt == undefined) {
                                    data[i].ladhddt = "1";
                                }
                                if (data[i].tctbao == undefined) {
                                    data[i].tctbao = "1";
                                }
                            }

                            var win = table.$scope.ui(huyhoadon.$ui);
                            huyhoadon.setEditMode(1);
                            webix.$$("btnHuyhoadon").destructor();
                            var tongquat = {
                                so: data[0].stbao,
                                ntbccqt: data[0].ntbao,
                                loai: loai,
                            };
                            huyhoadon.setValuesTongQuat(tongquat, null, null);
                            data.forEach(function (item) {
                                var put = {
                                    khieu: item.khieu,
                                    shdon: item.shdon,
                                    ngay: item.nlap,
                                    ladhddt: item.ladhddt,
                                    tctbao: item.tctbao,
                                    hdon_id: item.id,
                                };
                                huyhoadon.setValues(put, null, null);
                                //this.hide();
                                win.show();
                            });
                        } else {
                            webix.message("Các biên lai chọn phải có số thông báo giống nhau", "error");
                        }
                    } else {
                        var item = table.getSelectedItem();

                        var loai = 1;
                        if (item["stbao"] !== null) loai = 2;

                        if (item == null) {
                            webix.message("Bạn chưa chọn biên lai", "error");
                            return;
                        }

                        if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                            webix.message("biên lai chưa gửi không thể thông báo sai sót", "error");
                            return;
                        }

                        if (item.ladhddt == undefined) {
                            item["ladhddt"] = "1";
                        }
                        if (item.tctbao == undefined) {
                            item["tctbao"] = "1";
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();

                        var tongquat = {
                            so: item.stbao,
                            ntbccqt: item.ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);

                        var put = {
                            khieu: item.khieu,
                            shdon: item.shdon,
                            ngay: item.nlap,
                            ladhddt: item.ladhddt,
                            tctbao: item.tctbao,
                            hdon_id: item.id,
                        };
                        huyhoadon.setValues(put, null, null);

                        //this.hide();
                        win.show();
                    }

                    // var win = table.$scope.ui(huyhoadon.$ui);
                    // huyhoadon.setEditMode(1);
                    // webix.$$("btnHuyhoadon").destructor();

                    // webix.$$("btnSaveSignGiaiTrinh").show();
                    // webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("btnGhiHuyhoadon").destructor();
                    // webix.$$("btnGhiSignHuyHDDT").destructor();
                    // this.hide();
                    // win.show();
                }
                if (record.id == "replace_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 2;
                    item.tthdon_original = 2;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var tableDetail = webix.$$("hoadon68_chitiet");

                    tableDetail.clearAll();
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "increase_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 19;
                    item.tthdon_original = 19;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    // var tableDetail = webix.$$("hoadon68_chitiet");
                    // tableDetail.clearAll();
                    // tableDetail.refresh();

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "biên lai điều chỉnh cho biên lai số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    /*tableDetail.getColumnConfig("sluong").editor = null;
                    tableDetail.getColumnConfig("thtien").editor = null;
                    tableDetail.getColumnConfig("tsuat").editor = null;
                    tableDetail.getColumnConfig("tgtien").editor = null;
                    tableDetail.getColumnConfig("tthue").editor = null;*/
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();

                    //detailForm.show();
                }
                if (record.id == "reduce_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 21;
                    item.tthdon_original = 21;
                    item.nky = "";
                    item.hdon_id = "";
                    item.note = "reduce_change_invoice";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);
                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "biên lai điều chỉnh cho biên lai số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "info_change") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 23;
                    item.tthdon_original = 23;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";

                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "biên lai điều chỉnh cho biên lai số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    // tableDetail.getColumnConfig("sluong").editor = null;
                    // tableDetail.getColumnConfig("thtien").editor = null;
                    // tableDetail.getColumnConfig("tsuat").editor = null;
                    // tableDetail.getColumnConfig("tgtien").editor = null;
                    // tableDetail.getColumnConfig("tthue").editor = null;
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();
                }
            },
        },
    });

    webix.$$("title").parse({ title: "Danh sách chờ ký", details: "Danh sách biên lai chờ ký" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in biên lai",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại biên lai gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>biên lai điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Duyệt") + "</span>",
            id: "btnKyCXL",
            click: function () {
                webix.confirm({
                    text: "Bạn chắc chắn muốn duyệt biên lai ?",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var dsHoaDon = commonHD.GetBienLaiChon();
                            var lsHodonId = [];

                            dsHoaDon.forEach(function (p) {
                                lsHodonId.push(p.hdon_id);
                            });

                            commonHD.DuyetHoaDon(lsHodonId, "Chờ duyệt");
                        }
                    },
                });
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Kết xuất màn hình") + "</span>",
            id: "btnXuatExel",
            click: function () {
                webix.confirm({
                    text: "Kết xuất màn hình toàn bộ biên lai theo filter?",
                    ok: "Có",
                    cancel: "Không",
                    width: 300,
                    callback: function (res) {
                        if (res) {
                            var table = $$("invoiceViews");

                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            var datafetch = table.config.datafetch;
                            table.config.datafetch = table.data.count();
                            var params = table.config.params;
                            if (params != null && params != undefined) {
                                params.count = table.data.count();
                            }
                            var columnlst = table.config.columns;
                            var arrcolumn = [];

                            for (var i = 2; i < columnlst.length; i++) {
                                var exporttype = "";
                                if (columnlst[i].columnType == "character varying" || columnlst[i].columnType == "nvarchar") {
                                    exporttype = "string";
                                } else {
                                    exporttype = columnlst[i].columnType;
                                }
                                var item = {
                                    id: columnlst[i].id,
                                    header: columnlst[i].header[0]["text"],

                                    exportType: exporttype,
                                };
                                arrcolumn.push(item);
                            }

                            table.load(
                                table.config.url,
                                function () {
                                    webix.toExcel($$("invoiceViews"), {
                                        columns: arrcolumn,
                                        rawValues: true,
                                        filename: "DanhSachHoaDonFull",
                                    });
                                    table.config.datafetch = datafetch;
                                    table.enable();
                                    table.hideProgress();
                                },
                                params
                            );
                        }
                    },
                });
            },
        },
        // Khong duoc xoa cai ngoac nhon nay
        {},
        {},
        {},
        {},
    ];
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0,
    });
    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var daiKyHieu = "";
                        //get count list combo ký hiệu
                        //var countkyHieu = $$("kyhieu_id") != undefined ? $$("kyhieu_id").getPopup().getList().serialize().length : 0;
                        var url = app.config.host + "/Invoice68/GetDataInvoiceDanhSachChoKy";
                        var table = $$("invoiceViews");
                        if (params == null) {
                            commonHD.clear_filter(view);
                            table.config.params = null;
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            webix.storage.local.put("currentFilter", params.filter);
                            table.define("params", params);
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property],
                                        filterType: column.header[1].content,
                                    };

                                    if (item.value != null && item.value != "") {
                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                            }
                            url = url + "&filter=null";
                        }
                        url = url + "&tlbparam=null&tthai=Chờ duyệt&loaihd=2";
                        webix.ajax(url, callback, view);
                    },
                },
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    // onItemDblClick: function (id, e, node) {
                    //     var btnEdit = $$("btnEdit");
                    //     btnEdit.callEvent("onClick");
                    // },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "stt",
                        header: ["STT"],
                        //header: "",
                        sort: "int",
                        width: 40,
                        columnType: "nvarchar",
                        //css: { "line-height": "20px !important", "height": "63px !important"}
                    },
                    {
                        id: "ttthdon",
                        width: 200,
                        header: [
                            "Trạng thái",
                            {
                                content: "serverMultiSelectFilter",
                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00502",
                            },
                        ],
                        template: function (obj, common) {
                            console.log(obj.tthdon);
                            return "<span class='mcls_status" + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        },
                    },
                    {
                        id: "tthai",
                        header: ["Trạng thái biên lai", { content: "serverMultiSelectFilter", options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00504" }],
                        width: 200,
                    },
                    //
                    // {
                    //     id: "btnMessagetn",
                    //     header: ["<center>Lịch sử xử lý</center>"],
                    //     css: { "text-align": "center" },
                    //     template: function (obj) {
                    //         return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                    //     },
                    //     width: 180,
                    // },
                    // {
                    //     id: "issendmail",
                    //     header: ["<center>Gửi Email</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     checkValue: true, uncheckValue: false,
                    //     template: "{common.rcheckbox()}"
                    // },
                    // {
                    //     id: "error_status",
                    //     header: ["<center>Có lỗi/Không có lỗi</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     template: function (obj) {
                    //         if (obj.error_status == "1") {
                    //             return "<span style='color: #e83717'>Có lỗi</span> ";
                    //         } else {
                    //             return "";
                    //         }
                    //     }
                    // },
                    {
                        id: "nlap",
                        header: ["Ngày biên lai", { content: "serverDateRangeFilter" }],
                        width: 120,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        // template: function (obj, common) {
                        //     if(obj.tthai!="Chờ ký"){
                        //         return obj.nlap="";
                        //     }
                        //     else{
                        //         var format = webix.Date.dateToStr("%d/%m/%Y");
                        //         var text = removeTimeZoneT(obj.nlap);
                        //         return format(text);
                        //     }
                        // },
                        columnType: "datetime",
                    },
                    // {
                    //     id: "nky",
                    //     header: ["<center>Ngày ký</center>", { content: "serverDateRangeFilter" }],
                    //     width: 150,
                    //     css: { "text-align": "center" },
                    //     //format:webix.i18n.dateFormatStr
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    //     columnType: "datetime",
                    // },
                    {
                        id: "khieu",
                        header: ["Ký hiệu", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        columnType: "nvarchar",
                    },
                    { id: "shdon", header: ["Số biên lai", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },

                    { id: "mst", header: ["Mã số thuế", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    { id: "mdvi", header: ["Đơn vị quản lý", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    { id: "ten_str", header: ["Tên đơn vị/ Tên người mua", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    {
                        id: "tgtttbso_last",
                        header: ["Số thuế thu nhập", { content: "textFilter" }],
                        width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tgtttbso_last == null ? 0 : fm(obj.tgtttbso_last);
                        },
                        columnType: "numeric",
                    },
                    {
                        id: "nglap",
                        header: ["Người lập", { content: "textFilter" }],
                        width: 200,
                        columnType: "nvarchar",
                    },
                    // { id: "ten_loai", header: ["<center>Tên loại HĐ</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv * 1 != $$("pagerA").config.size) {
                                    webix.message("change page size to " + newv);
                                    $$("pagerA").config.size = newv * 1;
                                    var table = $$("invoiceViews");
                                    table.define("datafetch", newv);
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({ title: "Danh sách chờ duyệt", details: "Danh sách chờ duyệt" });
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },
    };
});

define('views/78_duyethoadon_choduyet_tncn',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_huyhoadon", "views/forms/68_huyhoadon_1", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    invoiceForms,
    huyhoadon,
    huyhoadon_1,
    hoadonHistory,
    commonHD
) {
    

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            // {
            //     id: "huyhoadon",
            //     value: "Hủy chứng từ",
            // },
            // {
            //     id: "huyhoadon2",
            //     value: "Hủy chứng từ có tạo mới",
            // },
            // {
            //     id: "giaitrinh",
            //     value: "Giải trình",
            // },
            {
                id: "notifyErrorInvoice",
                value: "Thông báo HĐĐT có sai sót",
            },
            {
                id: "replace_invoice",
                value: "Thay thế",
            },
            {
                id: "increase_change_invoice",
                value: "Điều chỉnh tăng",
            },
            {
                id: "reduce_change_invoice",
                value: "Điều chỉnh giảm",
            },
            {
                id: "info_change",
                value: "Điều chỉnh thông tin",
            },
            {
                id: "dowloadXml",
                value: "Tải XML",
            },
            {
                id: "dowloadXmlMessageHD",
                value: "Tải XML thông điệp gửi HĐ",
            },
            // {
            //     id: "nhanExcel",
            //     value: "Nhận Excel hàng loạt",
            // },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                if (record.id == "nhanExcel") {
                    var table = $$("invoiceViews");

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", { excel_id: "EX00011", filename: "Nhan hang loat hoa don 68 (GTGT).xlsx" });
                        webix.$$("uploader").hide();
                    });
                }
                // console.log(record);
                if (record.id == "huyhoadon") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("chứng từ đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("chứng từ đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);

                    webix.$$("btnHuyhoadon").destructor();
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "huyhoadon2") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("chứng từ đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("chứng từ đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnStep299").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    // webix.$$("btnStep299").define("hidden", false);
                    // webix.$$("btnStep2").show();
                    // webix.$$("btnStep299").hide();
                    // $$("btnHuyHDDT").addView({ view:"button",label: "Bước 2" }, 1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "dowloadXml") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("chứng từ đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlInvoice.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "dowloadXmlMessageHD") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("chứng từ chưa được gửi tới CQT, không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLThongDiepHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlThongDiepHoaDon.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "giaitrinh") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ", "error");
                        return;
                    }
                    if (item.tthdon != "4" && item.tthdon != "0") {
                        webix.message("chứng từ không ở trạng thái rà soát không thể lập giải trình !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnSaveSignGiaiTrinh").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    // webix.$$("tctbao").setValue(2);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    this.hide();
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 2,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();

                    // var fn = Function("_", "user", item.on_click);
                    // fn(_, user);
                }
                if (record.id == "notifyErrorInvoice") {
                    var table = webix.$$("invoiceViews");
                    var datafrm = table.serialize();
                    var data = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i]);
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        var cungshd = true;
                        for (var k = 1; k <= data.length - 1; k++) {
                            if (data[k]["stbao"] !== data[0]["stbao"]) {
                                cungshd = false;
                                break;
                            }
                        }
                        if (cungshd === true) {
                            var loai = 1;
                            if (data[0]["stbao"] !== null) loai = 2;
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký" || data[i].tthai == "Đã ký") {
                                    webix.message("chứng từ chưa gửi không thể thông báo sai sót", "error");
                                    return;
                                }
                                if (data[i].ladhddt == undefined) {
                                    data[i].ladhddt = "1";
                                }
                                if (data[i].tctbao == undefined) {
                                    data[i].tctbao = "1";
                                }
                            }

                            var win = table.$scope.ui(huyhoadon.$ui);
                            huyhoadon.setEditMode(1);
                            webix.$$("btnHuyhoadon").destructor();
                            var tongquat = {
                                so: data[0].stbao,
                                ntbccqt: data[0].ntbao,
                                loai: loai,
                            };
                            huyhoadon.setValuesTongQuat(tongquat, null, null);
                            data.forEach(function (item) {
                                var put = {
                                    khieu: item.khieu,
                                    shdon: item.shdon,
                                    ngay: item.nlap,
                                    ladhddt: item.ladhddt,
                                    tctbao: item.tctbao,
                                    hdon_id: item.id,
                                };
                                huyhoadon.setValues(put, null, null);
                                //this.hide();
                                win.show();
                            });
                        } else {
                            webix.message("Các chứng từ chọn phải có số thông báo giống nhau", "error");
                        }
                    } else {
                        var item = table.getSelectedItem();

                        var loai = 1;
                        if (item["stbao"] !== null) loai = 2;

                        if (item == null) {
                            webix.message("Bạn chưa chọn chứng từ", "error");
                            return;
                        }

                        if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                            webix.message("chứng từ chưa gửi không thể thông báo sai sót", "error");
                            return;
                        }

                        if (item.ladhddt == undefined) {
                            item["ladhddt"] = "1";
                        }
                        if (item.tctbao == undefined) {
                            item["tctbao"] = "1";
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();

                        var tongquat = {
                            so: item.stbao,
                            ntbccqt: item.ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);

                        var put = {
                            khieu: item.khieu,
                            shdon: item.shdon,
                            ngay: item.nlap,
                            ladhddt: item.ladhddt,
                            tctbao: item.tctbao,
                            hdon_id: item.id,
                        };
                        huyhoadon.setValues(put, null, null);

                        //this.hide();
                        win.show();
                    }

                    // var win = table.$scope.ui(huyhoadon.$ui);
                    // huyhoadon.setEditMode(1);
                    // webix.$$("btnHuyhoadon").destructor();

                    // webix.$$("btnSaveSignGiaiTrinh").show();
                    // webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("btnGhiHuyhoadon").destructor();
                    // webix.$$("btnGhiSignHuyHDDT").destructor();
                    // this.hide();
                    // win.show();
                }
                if (record.id == "replace_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 2;
                    item.tthdon_original = 2;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var tableDetail = webix.$$("hoadon68_chitiet");

                    tableDetail.clearAll();
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "increase_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 19;
                    item.tthdon_original = 19;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    // var tableDetail = webix.$$("hoadon68_chitiet");
                    // tableDetail.clearAll();
                    // tableDetail.refresh();

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "chứng từ điều chỉnh cho chứng từ số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    /*tableDetail.getColumnConfig("sluong").editor = null;
                    tableDetail.getColumnConfig("thtien").editor = null;
                    tableDetail.getColumnConfig("tsuat").editor = null;
                    tableDetail.getColumnConfig("tgtien").editor = null;
                    tableDetail.getColumnConfig("tthue").editor = null;*/
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();

                    //detailForm.show();
                }
                if (record.id == "reduce_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 21;
                    item.tthdon_original = 21;
                    item.nky = "";
                    item.hdon_id = "";
                    item.note = "reduce_change_invoice";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);
                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "chứng từ điều chỉnh cho chứng từ số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "info_change") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 23;
                    item.tthdon_original = 23;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";

                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "chứng từ điều chỉnh cho chứng từ số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    // tableDetail.getColumnConfig("sluong").editor = null;
                    // tableDetail.getColumnConfig("thtien").editor = null;
                    // tableDetail.getColumnConfig("tsuat").editor = null;
                    // tableDetail.getColumnConfig("tgtien").editor = null;
                    // tableDetail.getColumnConfig("tthue").editor = null;
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();
                }
            },
        },
    });

    webix.$$("title").parse({ title: "Danh sách chờ ký", details: "Danh sách chứng từ chờ ký" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in chứng từ",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại chứng từ gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in chứng từ ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>chứng từ điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Duyệt") + "</span>",
            id: "btnKyCXL",
            click: function () {
                webix.confirm({
                    text: "Bạn chắc chắn muốn duyệt chứng từ ?",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var dsHoaDon = commonHD.GetHoaDonChon();
                            var lsHodonId = [];

                            dsHoaDon.forEach(function (p) {
                                lsHodonId.push(p.hdon_id);
                            });

                            commonHD.DuyetHoaDon(lsHodonId, "Chờ duyệt");
                        }
                    },
                });
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Kết xuất màn hình") + "</span>",
            id: "btnXuatExel",
            click: function () {
                webix.confirm({
                    text: "Kết xuất màn hình toàn bộ chứng từ theo filter?",
                    ok: "Có",
                    cancel: "Không",
                    width: 300,
                    callback: function (res) {
                        if (res) {
                            var table = $$("invoiceViews");

                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            var datafetch = table.config.datafetch;
                            table.config.datafetch = table.data.count();
                            var params = table.config.params;
                            if (params != null && params != undefined) {
                                params.count = table.data.count();
                            }
                            var columnlst = table.config.columns;
                            var arrcolumn = [];

                            for (var i = 2; i < columnlst.length; i++) {
                                var exporttype = "";
                                if (columnlst[i].columnType == "character varying" || columnlst[i].columnType == "nvarchar") {
                                    exporttype = "string";
                                } else {
                                    exporttype = columnlst[i].columnType;
                                }
                                var item = {
                                    id: columnlst[i].id,
                                    header: columnlst[i].header[0]["text"],

                                    exportType: exporttype,
                                };
                                arrcolumn.push(item);
                            }

                            table.load(
                                table.config.url,
                                function () {
                                    webix.toExcel($$("invoiceViews"), {
                                        columns: arrcolumn,
                                        rawValues: true,
                                        filename: "DanhSachHoaDonFull",
                                    });
                                    table.config.datafetch = datafetch;
                                    table.enable();
                                    table.hideProgress();
                                },
                                params
                            );
                        }
                    },
                });
            },
        },
        // Khong duoc xoa cai ngoac nhon nay
        {},
        {},
        {},
        {},
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var daiKyHieu = "";
                        //get count list combo ký hiệu
                        //var countkyHieu = $$("kyhieu_id") != undefined ? $$("kyhieu_id").getPopup().getList().serialize().length : 0;
                        var url = app.config.host + "/Invoice68/GetDataInvoiceDanhSachChoKy";
                        var table = $$("invoiceViews");
                        if (params == null) {
                            commonHD.clear_filter(view);
                            table.config.params = null;
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            webix.storage.local.put("currentFilter", params.filter);
                            table.define("params", params);
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property],
                                        filterType: column.header[1].content,
                                    };

                                    if (item.value != null && item.value != "") {
                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                            }
                            url = url + "&filter=null";
                        }
                        url = url + "&tlbparam=null&tthai=Chờ duyệt&loaihd=3";
                        webix.ajax(url, callback, view);
                    },
                },
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    // onItemDblClick: function (id, e, node) {
                    //     var btnEdit = $$("btnEdit");
                    //     btnEdit.callEvent("onClick");
                    // },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "stt",
                        header: ["STT"],
                        //header: "",
                        sort: "int",
                        width: 40,
                        columnType: "nvarchar",
                        //css: { "line-height": "20px !important", "height": "63px !important"}
                    },
                    {
                        id: "ttthdon",
                        width: 200,
                        header: [
                            "Trạng thái",
                            {
                                content: "serverMultiSelectFilter",
                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00502",
                            },
                        ],
                        template: function (obj, common) {
                            console.log(obj.tthdon);
                            return "<span class='mcls_status" + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        },
                    },
                    {
                        id: "tthai",
                        header: ["Trạng thái chứng từ", { content: "serverMultiSelectFilter", options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00504" }],
                        width: 200,
                    },
                    //
                    // {
                    //     id: "btnMessagetn",
                    //     header: ["<center>Lịch sử xử lý</center>"],
                    //     css: { "text-align": "center" },
                    //     template: function (obj) {
                    //         return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                    //     },
                    //     width: 180,
                    // },
                    // {
                    //     id: "issendmail",
                    //     header: ["<center>Gửi Email</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     checkValue: true, uncheckValue: false,
                    //     template: "{common.rcheckbox()}"
                    // },
                    // {
                    //     id: "error_status",
                    //     header: ["<center>Có lỗi/Không có lỗi</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     template: function (obj) {
                    //         if (obj.error_status == "1") {
                    //             return "<span style='color: #e83717'>Có lỗi</span> ";
                    //         } else {
                    //             return "";
                    //         }
                    //     }
                    // },
                    {
                        id: "nlap",
                        header: ["Ngày chứng từ", { content: "serverDateRangeFilter" }],
                        width: 120,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        // template: function (obj, common) {
                        //     if(obj.tthai!="Chờ ký"){
                        //         return obj.nlap="";
                        //     }
                        //     else{
                        //         var format = webix.Date.dateToStr("%d/%m/%Y");
                        //         var text = removeTimeZoneT(obj.nlap);
                        //         return format(text);
                        //     }
                        // },
                        columnType: "datetime",
                    },
                    // {
                    //     id: "nky",
                    //     header: ["<center>Ngày ký</center>", { content: "serverDateRangeFilter" }],
                    //     width: 150,
                    //     css: { "text-align": "center" },
                    //     //format:webix.i18n.dateFormatStr
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    //     columnType: "datetime",
                    // },
                    {
                        id: "khieu",
                        header: ["Ký hiệu", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        columnType: "nvarchar",
                    },
                    { id: "shdon", header: ["Số chứng từ", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },

                    { id: "mst", header: ["Mã số thuế", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    { id: "mdvi", header: ["Đơn vị quản lý", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    { id: "ten_str", header: ["Tên đơn vị/ Tên người mua", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    {
                        id: "tgtttbso_last",
                        header: ["Số thuế thu nhập", { content: "textFilter" }],
                        width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tgtttbso_last == null ? 0 : fm(obj.tgtttbso_last);
                        },
                        columnType: "numeric",
                    },
                    {
                        id: "nglap",
                        header: ["Người lập", { content: "textFilter" }],
                        width: 200,
                        columnType: "nvarchar",
                    },
                    // { id: "ten_loai", header: ["<center>Tên loại HĐ</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv * 1 != $$("pagerA").config.size) {
                                    webix.message("change page size to " + newv);
                                    $$("pagerA").config.size = newv * 1;
                                    var table = $$("invoiceViews");
                                    table.define("datafetch", newv);
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({ title: "Danh sách chờ duyệt", details: "Danh sách chờ duyệt" });
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },
    };
});

define('views/78_duyethoadon_choduyet',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_huyhoadon", "views/forms/68_huyhoadon_1", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    invoiceForms,
    huyhoadon,
    huyhoadon_1,
    hoadonHistory,
    commonHD
) {
    

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            // {
            //     id: "huyhoadon",
            //     value: "Hủy hóa đơn",
            // },
            // {
            //     id: "huyhoadon2",
            //     value: "Hủy hóa đơn có tạo mới",
            // },
            // {
            //     id: "giaitrinh",
            //     value: "Giải trình",
            // },
            {
                id: "notifyErrorInvoice",
                value: "Thông báo HĐĐT có sai sót",
            },
            {
                id: "replace_invoice",
                value: "Thay thế",
            },
            {
                id: "increase_change_invoice",
                value: "Điều chỉnh tăng",
            },
            {
                id: "reduce_change_invoice",
                value: "Điều chỉnh giảm",
            },
            {
                id: "info_change",
                value: "Điều chỉnh thông tin",
            },
            {
                id: "dowloadXml",
                value: "Tải XML",
            },
            {
                id: "dowloadXmlMessageHD",
                value: "Tải XML thông điệp gửi HĐ",
            },
            // {
            //     id: "nhanExcel",
            //     value: "Nhận Excel hàng loạt",
            // },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                if (record.id == "nhanExcel") {
                    var table = $$("invoiceViews");

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", {
                            excel_id: "EX00011",
                            filename: "Nhan hang loat hoa don 68 (GTGT).xlsx",
                        });
                        webix.$$("uploader").hide();
                    });
                }
                // console.log(record);
                if (record.id == "huyhoadon") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Hóa đơn đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);

                    webix.$$("btnHuyhoadon").destructor();
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "huyhoadon2") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Hóa đơn đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnStep299").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    // webix.$$("btnStep299").define("hidden", false);
                    // webix.$$("btnStep2").show();
                    // webix.$$("btnStep299").hide();
                    // $$("btnHuyHDDT").addView({ view:"button",label: "Bước 2" }, 1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "dowloadXml") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlInvoice.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "dowloadXmlMessageHD") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Hóa đơn chưa được gửi tới CQT, không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLThongDiepHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlThongDiepHoaDon.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "giaitrinh") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon != "4" && item.tthdon != "0") {
                        webix.message("Hóa đơn không ở trạng thái rà soát không thể lập giải trình !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnSaveSignGiaiTrinh").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    // webix.$$("tctbao").setValue(2);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    this.hide();
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 2,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();

                    // var fn = Function("_", "user", item.on_click);
                    // fn(_, user);
                }
                if (record.id == "notifyErrorInvoice") {
                    var table = webix.$$("invoiceViews");
                    var datafrm = table.serialize();
                    var data = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i]);
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        var cungshd = true;
                        for (var k = 1; k <= data.length - 1; k++) {
                            if (data[k]["stbao"] !== data[0]["stbao"]) {
                                cungshd = false;
                                break;
                            }
                        }
                        if (cungshd === true) {
                            var loai = 1;
                            if (data[0]["stbao"] !== null) loai = 2;
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký" || data[i].tthai == "Đã ký") {
                                    webix.message("Hóa đơn chưa gửi không thể thông báo sai sót", "error");
                                    return;
                                }
                                if (data[i].ladhddt == undefined) {
                                    data[i].ladhddt = "1";
                                }
                                if (data[i].tctbao == undefined) {
                                    data[i].tctbao = "1";
                                }
                            }

                            var win = table.$scope.ui(huyhoadon.$ui);
                            huyhoadon.setEditMode(1);
                            webix.$$("btnHuyhoadon").destructor();
                            var tongquat = {
                                so: data[0].stbao,
                                ntbccqt: data[0].ntbao,
                                loai: loai,
                            };
                            huyhoadon.setValuesTongQuat(tongquat, null, null);
                            data.forEach(function (item) {
                                var put = {
                                    khieu: item.khieu,
                                    shdon: item.shdon,
                                    ngay: item.nlap,
                                    ladhddt: item.ladhddt,
                                    tctbao: item.tctbao,
                                    hdon_id: item.id,
                                };
                                huyhoadon.setValues(put, null, null);
                                //this.hide();
                                win.show();
                            });
                        } else {
                            webix.message("Các hóa đơn chọn phải có số thông báo giống nhau", "error");
                        }
                    } else {
                        var item = table.getSelectedItem();

                        var loai = 1;
                        if (item["stbao"] !== null) loai = 2;

                        if (item == null) {
                            webix.message("Bạn chưa chọn hóa đơn", "error");
                            return;
                        }

                        if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                            webix.message("Hóa đơn chưa gửi không thể thông báo sai sót", "error");
                            return;
                        }

                        if (item.ladhddt == undefined) {
                            item["ladhddt"] = "1";
                        }
                        if (item.tctbao == undefined) {
                            item["tctbao"] = "1";
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();

                        var tongquat = {
                            so: item.stbao,
                            ntbccqt: item.ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);

                        var put = {
                            khieu: item.khieu,
                            shdon: item.shdon,
                            ngay: item.nlap,
                            ladhddt: item.ladhddt,
                            tctbao: item.tctbao,
                            hdon_id: item.id,
                        };
                        huyhoadon.setValues(put, null, null);

                        //this.hide();
                        win.show();
                    }

                    // var win = table.$scope.ui(huyhoadon.$ui);
                    // huyhoadon.setEditMode(1);
                    // webix.$$("btnHuyhoadon").destructor();

                    // webix.$$("btnSaveSignGiaiTrinh").show();
                    // webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("btnGhiHuyhoadon").destructor();
                    // webix.$$("btnGhiSignHuyHDDT").destructor();
                    // this.hide();
                    // win.show();
                }
                if (record.id == "replace_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 2;
                    item.tthdon_original = 2;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var tableDetail = webix.$$("hoadon68_chitiet");

                    tableDetail.clearAll();
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "increase_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 19;
                    item.tthdon_original = 19;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    // var tableDetail = webix.$$("hoadon68_chitiet");
                    // tableDetail.clearAll();
                    // tableDetail.refresh();

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    /*tableDetail.getColumnConfig("sluong").editor = null;
                    tableDetail.getColumnConfig("thtien").editor = null;
                    tableDetail.getColumnConfig("tsuat").editor = null;
                    tableDetail.getColumnConfig("tgtien").editor = null;
                    tableDetail.getColumnConfig("tthue").editor = null;*/
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();

                    //detailForm.show();
                }
                if (record.id == "reduce_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 21;
                    item.tthdon_original = 21;
                    item.nky = "";
                    item.hdon_id = "";
                    item.note = "reduce_change_invoice";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);
                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "info_change") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 23;
                    item.tthdon_original = 23;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";

                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    // tableDetail.getColumnConfig("sluong").editor = null;
                    // tableDetail.getColumnConfig("thtien").editor = null;
                    // tableDetail.getColumnConfig("tsuat").editor = null;
                    // tableDetail.getColumnConfig("tgtien").editor = null;
                    // tableDetail.getColumnConfig("tthue").editor = null;
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();
                }
            },
        },
    });

    webix.$$("title").parse({ title: "Danh sách chờ ký", details: "Danh sách hóa đơn chờ ký" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in chứng từ",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại hóa đơn gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Duyệt") + "</span>",
            id: "btnKyCXL",
            click: function () {
                webix.confirm({
                    text: "Bạn chắc chắn muốn duyệt hóa đơn ?",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var dsHoaDon = commonHD.GetHoaDonChon();
                            var lsHodonId = [];

                            dsHoaDon.forEach(function (p) {
                                lsHodonId.push(p.hdon_id);
                            });

                            commonHD.DuyetHoaDon(lsHodonId, "Chờ duyệt");
                        }
                    },
                });
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Kết xuất màn hình") + "</span>",
            id: "btnXuatExel",
            click: function () {
                webix.confirm({
                    text: "Kết xuất màn hình toàn bộ hóa đơn theo filter?",
                    ok: "Có",
                    cancel: "Không",
                    width: 300,
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var table = $$("invoiceViews");
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            var datafetch = table.config.datafetch;
                            table.config.datafetch = table.data.count();
                            var params = table.config.params;
                            if (params != null && params != undefined) {
                                params.count = table.data.count();
                            }
                            var columnlst = table.config.columns;
                            var arrcolumn = [];

                            for (var i = 2; i < columnlst.length; i++) {
                                var exporttype = "";
                                if (columnlst[i].columnType == "character varying" || columnlst[i].columnType == "nvarchar") {
                                    exporttype = "string";
                                } else {
                                    exporttype = columnlst[i].columnType;
                                }
                                var item = {
                                    id: columnlst[i].id,
                                    header: columnlst[i].header[0]["text"],

                                    exportType: exporttype,
                                };
                                arrcolumn.push(item);
                            }
                            table.load(
                                table.config.url,
                                function () {
                                    webix.toExcel($$("invoiceViews"), {
                                        columns: arrcolumn,
                                        rawValues: true,
                                        filename: "DanhSachHoaDonFull",
                                    });
                                    table.config.datafetch = datafetch;
                                    table.enable();
                                    table.hideProgress();
                                },
                                params
                            );
                        }
                    },
                });
            },
        },
        // Khong duoc xoa cai ngoac nhon nay
        {},
        {},
        {},
        {},
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var daiKyHieu = "";
                        //get count list combo ký hiệu
                        //var countkyHieu = $$("kyhieu_id") != undefined ? $$("kyhieu_id").getPopup().getList().serialize().length : 0;
                        var url = app.config.host + "/Invoice68/GetDataInvoiceDanhSachChoKy";
                        var table = $$("invoiceViews");
                        if (params == null) {
                            commonHD.clear_filter(view);
                            table.config.params = null;
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            webix.storage.local.put("currentFilter", params.filter);
                            table.define("params", params);
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property],
                                        filterType: column.header[1].content,
                                    };

                                    if (item.filterType == "serverDateRangeFilter") {
                                        var startDate = item.value.start;
                                        if (startDate !== null && startDate !== undefined) {
                                            var hoursDiff = startDate.getHours() - startDate.getTimezoneOffset() / 60;
                                            var minutesDiff = (startDate.getHours() - startDate.getTimezoneOffset()) % 60;
                                            startDate.setHours(hoursDiff);
                                            startDate.setMinutes(minutesDiff);
                                            item.value.start = startDate;
                                        }

                                        var endDate = item.value.end;
                                        if (endDate !== null && endDate !== undefined) {
                                            var hoursDiff = endDate.getHours() - endDate.getTimezoneOffset() / 60;
                                            var minutesDiff = (endDate.getHours() - endDate.getTimezoneOffset()) % 60;
                                            endDate.setHours(hoursDiff);
                                            endDate.setMinutes(minutesDiff);
                                            item.value.end = endDate;
                                        }
                                    }

                                    if (item.value != "" && item.value != null) {
                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                            }
                            url = url + "&filter=null";
                        }
                        url = url + "&tlbparam=null&tthai=Chờ duyệt";
                        webix.ajax(url, callback, view);
                    },
                },
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    // onItemDblClick: function (id, e, node) {
                    //     var btnEdit = $$("btnEdit");
                    //     btnEdit.callEvent("onClick");
                    // },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    css: "subInvoice",
                    scrollX: true,
                    // tabbar: {
                    //     width: 200
                    // },
                    multiview: {
                        fitBiggest: true,
                    },
                    cells: [
                        {
                            header: "Chi tiết hóa đơn",
                            select: "cell",
                            body: {
                                view: "datatable",
                                resizeColumn: true,
                                margin: 10,
                                id: "hoadon68_chitiet_view",
                                height: 200,
                                columns: [
                                    { id: "stt", header: "", width: 30 },
                                    {
                                        id: "ma",
                                        header: _("Mã hàng hóa"),
                                        editor: "text",
                                        width: 100,
                                        editable: true,
                                    },
                                    {
                                        id: "ten",
                                        header: _("Tên hàng hóa"),
                                        editor: "text",
                                        width: 350,
                                        editable: true,
                                    },
                                    {
                                        id: "mdvtinh",
                                        header: _("ĐVT"),
                                        editor: "text",
                                        width: 80,
                                        editable: true,
                                    },
                                    {
                                        id: "sluong",
                                        header: _("Số lương"),
                                        editor: "autonumeric",
                                        width: 100,
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "dgia",
                                        header: _("Đơn giá"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "thtien",
                                        header: _("Tiền trước thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "tlckhau",
                                        header: _("% CK"),
                                        width: 80,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "stckhau",
                                        header: _("Tiền CK"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tsuat",
                                        header: _("Thuế suất"),
                                        width: 100,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tthue",
                                        header: _("Tiền thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tgtien",
                                        header: _("Tiền sau thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "khuyen_mai",
                                        header: _("Khuyến mại"),
                                        width: 100,
                                        editor: "checkbox",
                                        editable: true,
                                        template: "{common.checkbox()}",
                                        checkValue: true,
                                        uncheckValue: false,
                                    },
                                ],
                                on: {
                                    onBeforeLoad: function () {
                                        this.showOverlay(_("LOADING") + "...");
                                    },
                                    onAfterLoad: function () {
                                        this.hideOverlay();
                                    },
                                },
                            },
                        },
                    ],
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "stt",
                        header: ["STT"],
                        //header: "",
                        sort: "int",
                        width: 40,
                        columnType: "nvarchar",
                        //css: { "line-height": "20px !important", "height": "63px !important"}
                    },
                    {
                        id: "ttthdon",
                        width: 200,
                        header: [
                            "Trạng thái",
                            {
                                content: "serverMultiSelectFilter",
                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00502",
                            },
                        ],
                        template: function (obj, common) {
                            console.log(obj.tthdon);
                            return "<span class='mcls_status" + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        },
                    },
                    {
                        id: "tthai",
                        header: ["Trạng thái gửi CQT", { content: "serverMultiSelectFilter", options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00504" }],
                        width: 200,
                    },
                    {
                        id: "nlap",
                        header: ["Ngày hóa đơn", { content: "serverDateRangeFilter" }],
                        width: 120,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        // template: function (obj, common) {
                        //     if(obj.tthai!="Chờ ký"){
                        //         return obj.nlap="";
                        //     }
                        //     else{
                        //         var format = webix.Date.dateToStr("%d/%m/%Y");
                        //         var text = removeTimeZoneT(obj.nlap);
                        //         return format(text);
                        //     }
                        // },
                        columnType: "datetime",
                    },
                    // {
                    //     id: "nky",
                    //     header: ["Ngày ký", { content: "serverDateRangeFilter" }],
                    //     width: 150,
                    //     css: { "text-align": "center" },
                    //     //format:webix.i18n.dateFormatStr
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    //     columnType: "datetime",
                    // },
                    {
                        id: "khieu",
                        header: ["Ký hiệu", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        columnType: "nvarchar",
                    },
                    {
                        id: "is_hdcma_str",
                        header: ["Tình trạng mã", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        /*columnType: "integer",
                        template: function (obj) {
                            return obj.is_hdcma === 0 ? "Không mã" : obj.is_hdcma === 1 ? "Có mã" : "Không rõ tình trạng mã";
                        },*/
                    },
                    // {
                    //     id: "khieu", header: ["Ký hiệu", { content: "textFilter" }],
                    //     template: function (obj, common) {
                    //         return "<span class='mcls_status " + obj.className + "'>" + obj.ten_trang_thai + "</span>";
                    //     }, width: 100, columnType: "nvarchar"
                    // },
                    { id: "shdon", header: ["Số hóa đơn", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },

                    { id: "mst", header: ["Mã số thuế", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    // { id: "mtdiep_gui", header: ["<center>Mã thông điệp gửi đi</center>", { content: "textFilter" }], width: 350, columnType: "nvarchar" },
                    // { id: "mtdiep_cqt", header: ["<center>Mã thông điệp cơ quan thuế</center>", { content: "textFilter" }], width: 300, columnType: "nvarchar" },
                    { id: "mdvi", header: ["Đơn vị quản lý", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    { id: "ten_str", header: ["Tên đơn vị/ Tên người mua", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    {
                        id: "tgtttbso_last",
                        header: ["Thành tiền sau thuế", { content: "textFilter" }],
                        width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tgtttbso_last == null ? 0 : fm(obj.tgtttbso_last);
                        },
                        columnType: "numeric",
                    },
                    { id: "htttoan", header: ["Hình thức TT", { content: "textFilter" }], width: 200, columnType: "nvarchar", css: { "text-align": "center" } },
                    // {
                    //     id: "tdlap",
                    //     header: ["Thời điểm lập", { content: "textFilter" }],
                    //     width: 200,
                    //     columnType: "nvarchar",
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    // },
                    {
                        id: "nglap",
                        header: ["Người lập", { content: "textFilter" }],
                        width: 200,
                        columnType: "nvarchar",
                    },
                    // { id: "ten_loai", header: ["Tên loại HĐ", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv * 1 != $$("pagerA").config.size) {
                                    webix.message("change page size to " + newv);
                                    $$("pagerA").config.size = newv * 1;
                                    var table = $$("invoiceViews");
                                    table.define("datafetch", newv);
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({
                title: "Danh sách chờ duyệt",
                details: "Danh sách chờ duyệt",
            });
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },
    };
});

define('views/78_duyethoadon_chosinhso_bienlai',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_huyhoadon", "views/forms/68_huyhoadon_1", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    invoiceForms,
    huyhoadon,
    huyhoadon_1,
    hoadonHistory,
    commonHD
) {
    
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: 0,
        });
        return k(number);
    };
    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            // {
            //     id: "huyhoadon",
            //     value: "Hủy biên lai",
            // },
            // {
            //     id: "huyhoadon2",
            //     value: "Hủy biên lai có tạo mới",
            // },
            // {
            //     id: "giaitrinh",
            //     value: "Giải trình",
            // },
            {
                id: "notifyErrorInvoice",
                value: "Thông báo HĐĐT có sai sót",
            },
            {
                id: "replace_invoice",
                value: "Thay thế",
            },
            {
                id: "increase_change_invoice",
                value: "Điều chỉnh tăng",
            },
            {
                id: "reduce_change_invoice",
                value: "Điều chỉnh giảm",
            },
            {
                id: "info_change",
                value: "Điều chỉnh thông tin",
            },
            {
                id: "dowloadXml",
                value: "Tải XML",
            },
            {
                id: "dowloadXmlMessageHD",
                value: "Tải XML thông điệp gửi HĐ",
            },
            // {
            //     id: "nhanExcel",
            //     value: "Nhận Excel hàng loạt",
            // },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                if (record.id == "nhanExcel") {
                    var table = $$("invoiceViews");

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", { excel_id: "EX00011", filename: "Nhan hang loat hoa don 68 (GTGT).xlsx" });
                        webix.$$("uploader").hide();
                    });
                }
                // console.log(record);
                if (record.id == "huyhoadon") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("biên lai đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("biên lai đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);

                    webix.$$("btnHuyhoadon").destructor();
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "huyhoadon2") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("biên lai đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("biên lai đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnStep299").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    // webix.$$("btnStep299").define("hidden", false);
                    // webix.$$("btnStep2").show();
                    // webix.$$("btnStep299").hide();
                    // $$("btnHuyHDDT").addView({ view:"button",label: "Bước 2" }, 1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "dowloadXml") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("biên lai đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlInvoice.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "dowloadXmlMessageHD") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("biên lai chưa được gửi tới CQT, không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLThongDiepHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlThongDiepHoaDon.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "giaitrinh") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai", "error");
                        return;
                    }
                    if (item.tthdon != "4" && item.tthdon != "0") {
                        webix.message("biên lai không ở trạng thái rà soát không thể lập giải trình !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnSaveSignGiaiTrinh").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    // webix.$$("tctbao").setValue(2);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    this.hide();
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 2,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();

                    // var fn = Function("_", "user", item.on_click);
                    // fn(_, user);
                }
                if (record.id == "notifyErrorInvoice") {
                    var table = webix.$$("invoiceViews");
                    var datafrm = table.serialize();
                    var data = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i]);
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        var cungshd = true;
                        for (var k = 1; k <= data.length - 1; k++) {
                            if (data[k]["stbao"] !== data[0]["stbao"]) {
                                cungshd = false;
                                break;
                            }
                        }
                        if (cungshd === true) {
                            var loai = 1;
                            if (data[0]["stbao"] !== null) loai = 2;
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký" || data[i].tthai == "Đã ký") {
                                    webix.message("biên lai chưa gửi không thể thông báo sai sót", "error");
                                    return;
                                }
                                if (data[i].ladhddt == undefined) {
                                    data[i].ladhddt = "1";
                                }
                                if (data[i].tctbao == undefined) {
                                    data[i].tctbao = "1";
                                }
                            }

                            var win = table.$scope.ui(huyhoadon.$ui);
                            huyhoadon.setEditMode(1);
                            webix.$$("btnHuyhoadon").destructor();
                            var tongquat = {
                                so: data[0].stbao,
                                ntbccqt: data[0].ntbao,
                                loai: loai,
                            };
                            huyhoadon.setValuesTongQuat(tongquat, null, null);
                            data.forEach(function (item) {
                                var put = {
                                    khieu: item.khieu,
                                    shdon: item.shdon,
                                    ngay: item.nlap,
                                    ladhddt: item.ladhddt,
                                    tctbao: item.tctbao,
                                    hdon_id: item.id,
                                };
                                huyhoadon.setValues(put, null, null);
                                //this.hide();
                                win.show();
                            });
                        } else {
                            webix.message("Các biên lai chọn phải có số thông báo giống nhau", "error");
                        }
                    } else {
                        var item = table.getSelectedItem();

                        var loai = 1;
                        if (item["stbao"] !== null) loai = 2;

                        if (item == null) {
                            webix.message("Bạn chưa chọn biên lai", "error");
                            return;
                        }

                        if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                            webix.message("biên lai chưa gửi không thể thông báo sai sót", "error");
                            return;
                        }

                        if (item.ladhddt == undefined) {
                            item["ladhddt"] = "1";
                        }
                        if (item.tctbao == undefined) {
                            item["tctbao"] = "1";
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();

                        var tongquat = {
                            so: item.stbao,
                            ntbccqt: item.ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);

                        var put = {
                            khieu: item.khieu,
                            shdon: item.shdon,
                            ngay: item.nlap,
                            ladhddt: item.ladhddt,
                            tctbao: item.tctbao,
                            hdon_id: item.id,
                        };
                        huyhoadon.setValues(put, null, null);

                        //this.hide();
                        win.show();
                    }

                    // var win = table.$scope.ui(huyhoadon.$ui);
                    // huyhoadon.setEditMode(1);
                    // webix.$$("btnHuyhoadon").destructor();

                    // webix.$$("btnSaveSignGiaiTrinh").show();
                    // webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("btnGhiHuyhoadon").destructor();
                    // webix.$$("btnGhiSignHuyHDDT").destructor();
                    // this.hide();
                    // win.show();
                }
                if (record.id == "replace_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 2;
                    item.tthdon_original = 2;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var tableDetail = webix.$$("hoadon68_chitiet");

                    tableDetail.clearAll();
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "increase_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 19;
                    item.tthdon_original = 19;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    // var tableDetail = webix.$$("hoadon68_chitiet");
                    // tableDetail.clearAll();
                    // tableDetail.refresh();

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "biên lai điều chỉnh cho biên lai số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    /*tableDetail.getColumnConfig("sluong").editor = null;
                    tableDetail.getColumnConfig("thtien").editor = null;
                    tableDetail.getColumnConfig("tsuat").editor = null;
                    tableDetail.getColumnConfig("tgtien").editor = null;
                    tableDetail.getColumnConfig("tthue").editor = null;*/
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();

                    //detailForm.show();
                }
                if (record.id == "reduce_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 21;
                    item.tthdon_original = 21;
                    item.nky = "";
                    item.hdon_id = "";
                    item.note = "reduce_change_invoice";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);
                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "biên lai điều chỉnh cho biên lai số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "info_change") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("biên lai chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 23;
                    item.tthdon_original = 23;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";

                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "biên lai điều chỉnh cho biên lai số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    // tableDetail.getColumnConfig("sluong").editor = null;
                    // tableDetail.getColumnConfig("thtien").editor = null;
                    // tableDetail.getColumnConfig("tsuat").editor = null;
                    // tableDetail.getColumnConfig("tgtien").editor = null;
                    // tableDetail.getColumnConfig("tthue").editor = null;
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();
                }
            },
        },
    });

    webix.$$("title").parse({ title: "Danh sách chờ ký", details: "Danh sách biên lai chờ ký" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn biên lai !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in biên lai",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại biên lai gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>biên lai điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sinh số") + "</span>",
            id: "btnKyCXL",
            click: function () {
                webix.confirm({
                    text: "Bạn chắc chắn muốn duyệt biên lai ?",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var dsHoaDon = commonHD.GetHoaDonChon();
                            var lsHodonId = [];

                            dsHoaDon.forEach(function (p) {
                                lsHodonId.push(p.hdon_id);
                            });

                            commonHD.DuyetHoaDon(lsHodonId, "Chờ sinh số");
                        }
                    },
                });
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Kết xuất màn hình") + "</span>",
            id: "btnXuatExel",
            click: function () {
                webix.confirm({
                    text: "Kết xuất màn hình toàn bộ biên lai theo filter?",
                    ok: "Có",
                    cancel: "Không",
                    width: 300,
                    callback: function (res) {
                        if (res) {
                            var table = $$("invoiceViews");

                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            var datafetch = table.config.datafetch;
                            table.config.datafetch = table.data.count();
                            var params = table.config.params;
                            if (params != null && params != undefined) {
                                params.count = table.data.count();
                            }
                            var columnlst = table.config.columns;
                            var arrcolumn = [];

                            for (var i = 2; i < columnlst.length; i++) {
                                var exporttype = "";
                                if (columnlst[i].columnType == "character varying" || columnlst[i].columnType == "nvarchar") {
                                    exporttype = "string";
                                } else {
                                    exporttype = columnlst[i].columnType;
                                }
                                var item = {
                                    id: columnlst[i].id,
                                    header: columnlst[i].header[0]["text"],

                                    exportType: exporttype,
                                };
                                arrcolumn.push(item);
                            }

                            table.load(
                                table.config.url,
                                function () {
                                    webix.toExcel($$("invoiceViews"), {
                                        columns: arrcolumn,
                                        rawValues: true,
                                        filename: "DanhSachHoaDonFull",
                                    });
                                    table.config.datafetch = datafetch;
                                    table.enable();
                                    table.hideProgress();
                                },
                                params
                            );
                        }
                    },
                });
            },
        },
        // Khong duoc xoa cai ngoac nhon nay
        {},
        {},
        {},
        {},
    ];
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0,
    });
    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var daiKyHieu = "";
                        //get count list combo ký hiệu
                        //var countkyHieu = $$("kyhieu_id") != undefined ? $$("kyhieu_id").getPopup().getList().serialize().length : 0;
                        var url = app.config.host + "/Invoice68/GetDataInvoiceDanhSachChoKy";
                        var table = $$("invoiceViews");
                        if (params == null) {
                            commonHD.clear_filter(view);
                            table.config.params = null;
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            webix.storage.local.put("currentFilter", params.filter);
                            table.define("params", params);
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property],
                                        filterType: column.header[1].content,
                                    };

                                    if (item.value != null && item.value != "") {
                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                            }
                            url = url + "&filter=null";
                        }
                        url = url + "&tlbparam=null&tthai=Chờ sinh số&loaihd=2";
                        webix.ajax(url, callback, view);
                    },
                },
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    // onItemDblClick: function (id, e, node) {
                    //     var btnEdit = $$("btnEdit");
                    //     btnEdit.callEvent("onClick");
                    // },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "stt",
                        header: ["STT"],
                        //header: "",
                        sort: "int",
                        width: 40,
                        columnType: "nvarchar",
                        //css: { "line-height": "20px !important", "height": "63px !important"}
                    },
                    {
                        id: "ttthdon",
                        width: 200,
                        header: [
                            "Trạng thái",
                            {
                                content: "serverMultiSelectFilter",
                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00502",
                            },
                        ],
                        template: function (obj, common) {
                            console.log(obj.tthdon);
                            return "<span class='mcls_status" + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        },
                    },
                    {
                        id: "tthai",
                        header: ["Trạng thái biên lai", { content: "serverMultiSelectFilter", options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00504" }],
                        width: 200,
                    },
                    //
                    // {
                    //     id: "btnMessagetn",
                    //     header: ["<center>Lịch sử xử lý</center>"],
                    //     css: { "text-align": "center" },
                    //     template: function (obj) {
                    //         return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                    //     },
                    //     width: 180,
                    // },
                    // {
                    //     id: "issendmail",
                    //     header: ["<center>Gửi Email</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     checkValue: true, uncheckValue: false,
                    //     template: "{common.rcheckbox()}"
                    // },
                    // {
                    //     id: "error_status",
                    //     header: ["<center>Có lỗi/Không có lỗi</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     template: function (obj) {
                    //         if (obj.error_status == "1") {
                    //             return "<span style='color: #e83717'>Có lỗi</span> ";
                    //         } else {
                    //             return "";
                    //         }
                    //     }
                    // },
                    {
                        id: "nlap",
                        header: ["Ngày biên lai", { content: "serverDateRangeFilter" }],
                        width: 120,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        // template: function (obj, common) {
                        //     if(obj.tthai!="Chờ ký"){
                        //         return obj.nlap="";
                        //     }
                        //     else{
                        //         var format = webix.Date.dateToStr("%d/%m/%Y");
                        //         var text = removeTimeZoneT(obj.nlap);
                        //         return format(text);
                        //     }
                        // },
                        columnType: "datetime",
                    },
                    // {
                    //     id: "nky",
                    //     header: ["<center>Ngày ký</center>", { content: "serverDateRangeFilter" }],
                    //     width: 150,
                    //     css: { "text-align": "center" },
                    //     //format:webix.i18n.dateFormatStr
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    //     columnType: "datetime",
                    // },
                    {
                        id: "khieu",
                        header: ["Ký hiệu", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        columnType: "nvarchar",
                    },
                    { id: "shdon", header: ["Số biên lai", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },

                    { id: "mst", header: ["Mã số thuế", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    { id: "mdvi", header: ["Đơn vị quản lý", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    { id: "ten_str", header: ["Tên đơn vị/ Tên người mua", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    {
                        id: "tgtttbso_last",
                        header: ["Số thuế thu nhập", { content: "textFilter" }],
                        width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tgtttbso_last == null ? 0 : fm(obj.tgtttbso_last);
                        },
                        columnType: "numeric",
                    },
                    {
                        id: "nglap",
                        header: ["Người lập", { content: "textFilter" }],
                        width: 200,
                        columnType: "nvarchar",
                    },
                    // { id: "ten_loai", header: ["<center>Tên loại HĐ</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv * 1 != $$("pagerA").config.size) {
                                    webix.message("change page size to " + newv);
                                    $$("pagerA").config.size = newv * 1;
                                    var table = $$("invoiceViews");
                                    table.define("datafetch", newv);
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({ title: "Danh sách chờ sinh số", details: "Danh sách chờ sinh số" });
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },
    };
});

define('views/78_duyethoadon_chosinhso_tncn',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_huyhoadon", "views/forms/68_huyhoadon_1", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    invoiceForms,
    huyhoadon,
    huyhoadon_1,
    hoadonHistory,
    commonHD
) {
    

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            // {
            //     id: "huyhoadon",
            //     value: "Hủy hóa đơn",
            // },
            // {
            //     id: "huyhoadon2",
            //     value: "Hủy Chứng từ có tạo mới",
            // },
            // {
            //     id: "giaitrinh",
            //     value: "Giải trình",
            // },
            {
                id: "notifyErrorInvoice",
                value: "Thông báo HĐĐT có sai sót",
            },
            {
                id: "replace_invoice",
                value: "Thay thế",
            },
            {
                id: "increase_change_invoice",
                value: "Điều chỉnh tăng",
            },
            {
                id: "reduce_change_invoice",
                value: "Điều chỉnh giảm",
            },
            {
                id: "info_change",
                value: "Điều chỉnh thông tin",
            },
            {
                id: "dowloadXml",
                value: "Tải XML",
            },
            {
                id: "dowloadXmlMessageHD",
                value: "Tải XML thông điệp gửi HĐ",
            },
            // {
            //     id: "nhanExcel",
            //     value: "Nhận Excel hàng loạt",
            // },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                if (record.id == "nhanExcel") {
                    var table = $$("invoiceViews");

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", { excel_id: "EX00011", filename: "Nhan hang loat hoa don 68 (GTGT).xlsx" });
                        webix.$$("uploader").hide();
                    });
                }
                // console.log(record);
                if (record.id == "huyhoadon") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Chứng từ đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Chứng từ đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);

                    webix.$$("btnHuyhoadon").destructor();
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "huyhoadon2") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Chứng từ đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Chứng từ đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnStep299").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    // webix.$$("btnStep299").define("hidden", false);
                    // webix.$$("btnStep2").show();
                    // webix.$$("btnStep299").hide();
                    // $$("btnHuyHDDT").addView({ view:"button",label: "Bước 2" }, 1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "dowloadXml") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Chứng từ đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlInvoice.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "dowloadXmlMessageHD") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Chứng từ chưa được gửi tới CQT, không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLThongDiepHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlThongDiepHoaDon.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "giaitrinh") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon != "4" && item.tthdon != "0") {
                        webix.message("Chứng từ không ở trạng thái rà soát không thể lập giải trình !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnSaveSignGiaiTrinh").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    // webix.$$("tctbao").setValue(2);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    this.hide();
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 2,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();

                    // var fn = Function("_", "user", item.on_click);
                    // fn(_, user);
                }
                if (record.id == "notifyErrorInvoice") {
                    var table = webix.$$("invoiceViews");
                    var datafrm = table.serialize();
                    var data = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i]);
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        var cungshd = true;
                        for (var k = 1; k <= data.length - 1; k++) {
                            if (data[k]["stbao"] !== data[0]["stbao"]) {
                                cungshd = false;
                                break;
                            }
                        }
                        if (cungshd === true) {
                            var loai = 1;
                            if (data[0]["stbao"] !== null) loai = 2;
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký" || data[i].tthai == "Đã ký") {
                                    webix.message("Chứng từ chưa gửi không thể thông báo sai sót", "error");
                                    return;
                                }
                                if (data[i].ladhddt == undefined) {
                                    data[i].ladhddt = "1";
                                }
                                if (data[i].tctbao == undefined) {
                                    data[i].tctbao = "1";
                                }
                            }

                            var win = table.$scope.ui(huyhoadon.$ui);
                            huyhoadon.setEditMode(1);
                            webix.$$("btnHuyhoadon").destructor();
                            var tongquat = {
                                so: data[0].stbao,
                                ntbccqt: data[0].ntbao,
                                loai: loai,
                            };
                            huyhoadon.setValuesTongQuat(tongquat, null, null);
                            data.forEach(function (item) {
                                var put = {
                                    khieu: item.khieu,
                                    shdon: item.shdon,
                                    ngay: item.nlap,
                                    ladhddt: item.ladhddt,
                                    tctbao: item.tctbao,
                                    hdon_id: item.id,
                                };
                                huyhoadon.setValues(put, null, null);
                                //this.hide();
                                win.show();
                            });
                        } else {
                            webix.message("Các Chứng từ chọn phải có số thông báo giống nhau", "error");
                        }
                    } else {
                        var item = table.getSelectedItem();

                        var loai = 1;
                        if (item["stbao"] !== null) loai = 2;

                        if (item == null) {
                            webix.message("Bạn chưa chọn hóa đơn", "error");
                            return;
                        }

                        if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                            webix.message("Chứng từ chưa gửi không thể thông báo sai sót", "error");
                            return;
                        }

                        if (item.ladhddt == undefined) {
                            item["ladhddt"] = "1";
                        }
                        if (item.tctbao == undefined) {
                            item["tctbao"] = "1";
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();

                        var tongquat = {
                            so: item.stbao,
                            ntbccqt: item.ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);

                        var put = {
                            khieu: item.khieu,
                            shdon: item.shdon,
                            ngay: item.nlap,
                            ladhddt: item.ladhddt,
                            tctbao: item.tctbao,
                            hdon_id: item.id,
                        };
                        huyhoadon.setValues(put, null, null);

                        //this.hide();
                        win.show();
                    }

                    // var win = table.$scope.ui(huyhoadon.$ui);
                    // huyhoadon.setEditMode(1);
                    // webix.$$("btnHuyhoadon").destructor();

                    // webix.$$("btnSaveSignGiaiTrinh").show();
                    // webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("btnGhiHuyhoadon").destructor();
                    // webix.$$("btnGhiSignHuyHDDT").destructor();
                    // this.hide();
                    // win.show();
                }
                if (record.id == "replace_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn Chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 2;
                    item.tthdon_original = 2;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var tableDetail = webix.$$("hoadon68_chitiet");

                    tableDetail.clearAll();
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "increase_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn Chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 19;
                    item.tthdon_original = 19;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    // var tableDetail = webix.$$("hoadon68_chitiet");
                    // tableDetail.clearAll();
                    // tableDetail.refresh();

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Chứng từ điều chỉnh cho Chứng từ số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    /*tableDetail.getColumnConfig("sluong").editor = null;
                    tableDetail.getColumnConfig("thtien").editor = null;
                    tableDetail.getColumnConfig("tsuat").editor = null;
                    tableDetail.getColumnConfig("tgtien").editor = null;
                    tableDetail.getColumnConfig("tthue").editor = null;*/
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();

                    //detailForm.show();
                }
                if (record.id == "reduce_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn Chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 21;
                    item.tthdon_original = 21;
                    item.nky = "";
                    item.hdon_id = "";
                    item.note = "reduce_change_invoice";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);
                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Chứng từ điều chỉnh cho Chứng từ số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "info_change") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn Chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 23;
                    item.tthdon_original = 23;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";

                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Chứng từ điều chỉnh cho Chứng từ số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    // tableDetail.getColumnConfig("sluong").editor = null;
                    // tableDetail.getColumnConfig("thtien").editor = null;
                    // tableDetail.getColumnConfig("tsuat").editor = null;
                    // tableDetail.getColumnConfig("tgtien").editor = null;
                    // tableDetail.getColumnConfig("tthue").editor = null;
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();
                }
            },
        },
    });

    webix.$$("title").parse({ title: "Danh sách chờ ký", details: "Danh sách Chứng từ chờ ký" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn Chứng từ !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in Chứng từ ",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại Chứng từ gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn Chứng từ cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in Chứng từ ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Chứng từ điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sinh số") + "</span>",
            id: "btnKyCXL",
            click: function () {
                webix.confirm({
                    text: "Bạn chắc chắn muốn sinh số Chứng từ ?",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var dsHoaDon = commonHD.GetHoaDonChon();
                            var lsHodonId = [];

                            dsHoaDon.forEach(function (p) {
                                lsHodonId.push(p.hdon_id);
                            });

                            commonHD.DuyetHoaDon(lsHodonId, "Chờ sinh số");
                        }
                    },
                });
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Kết xuất màn hình") + "</span>",
            id: "btnXuatExel",
            click: function () {
                webix.confirm({
                    text: "Kết xuất màn hình toàn bộ Chứng từ theo filter?",
                    ok: "Có",
                    cancel: "Không",
                    width: 300,
                    callback: function (res) {
                        if (res) {
                            var table = $$("invoiceViews");

                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            var datafetch = table.config.datafetch;
                            table.config.datafetch = table.data.count();
                            var params = table.config.params;
                            if (params != null && params != undefined) {
                                params.count = table.data.count();
                            }
                            var columnlst = table.config.columns;
                            var arrcolumn = [];

                            for (var i = 2; i < columnlst.length; i++) {
                                var exporttype = "";
                                if (columnlst[i].columnType == "character varying" || columnlst[i].columnType == "nvarchar") {
                                    exporttype = "string";
                                } else {
                                    exporttype = columnlst[i].columnType;
                                }
                                var item = {
                                    id: columnlst[i].id,
                                    header: columnlst[i].header[0]["text"],

                                    exportType: exporttype,
                                };
                                arrcolumn.push(item);
                            }

                            table.load(
                                table.config.url,
                                function () {
                                    webix.toExcel($$("invoiceViews"), {
                                        columns: arrcolumn,
                                        rawValues: true,
                                        filename: "DanhSachHoaDonFull",
                                    });
                                    table.config.datafetch = datafetch;
                                    table.enable();
                                    table.hideProgress();
                                },
                                params
                            );
                        }
                    },
                });
            },
        },
        // Khong duoc xoa cai ngoac nhon nay
        {},
        {},
        {},
        {},
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var daiKyHieu = "";
                        //get count list combo ký hiệu
                        //var countkyHieu = $$("kyhieu_id") != undefined ? $$("kyhieu_id").getPopup().getList().serialize().length : 0;
                        var url = app.config.host + "/Invoice68/GetDataInvoiceDanhSachChoKy";
                        var table = $$("invoiceViews");
                        if (params == null) {
                            commonHD.clear_filter(view);
                            table.config.params = null;
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            webix.storage.local.put("currentFilter", params.filter);
                            table.define("params", params);
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property],
                                        filterType: column.header[1].content,
                                    };
                                    if (item.value != null && item.value != "") {
                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                            }
                            url = url + "&filter=null";
                        }
                        url = url + "&tlbparam=null&tthai=Chờ sinh số&loaihd=3";
                        webix.ajax(url, callback, view);
                    },
                },
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    // onItemDblClick: function (id, e, node) {
                    //     var btnEdit = $$("btnEdit");
                    //     btnEdit.callEvent("onClick");
                    // },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "stt",
                        header: ["STT"],
                        //header: "",
                        sort: "int",
                        width: 40,
                        columnType: "nvarchar",
                        //css: { "line-height": "20px !important", "height": "63px !important"}
                    },
                    {
                        id: "ttthdon",
                        width: 200,
                        header: [
                            "Trạng thái",
                            {
                                content: "serverMultiSelectFilter",
                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00502",
                            },
                        ],
                        template: function (obj, common) {
                            console.log(obj.tthdon);
                            return "<span class='mcls_status" + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        },
                    },
                    {
                        id: "tthai",
                        header: ["Trạng thái chứng từ", { content: "serverMultiSelectFilter", options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00504" }],
                        width: 200,
                    },
                    //
                    // {
                    //     id: "btnMessagetn",
                    //     header: ["<center>Lịch sử xử lý</center>"],
                    //     css: { "text-align": "center" },
                    //     template: function (obj) {
                    //         return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                    //     },
                    //     width: 180,
                    // },
                    // {
                    //     id: "issendmail",
                    //     header: ["<center>Gửi Email</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     checkValue: true, uncheckValue: false,
                    //     template: "{common.rcheckbox()}"
                    // },
                    // {
                    //     id: "error_status",
                    //     header: ["<center>Có lỗi/Không có lỗi</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     template: function (obj) {
                    //         if (obj.error_status == "1") {
                    //             return "<span style='color: #e83717'>Có lỗi</span> ";
                    //         } else {
                    //             return "";
                    //         }
                    //     }
                    // },
                    {
                        id: "nlap",
                        header: ["Ngày Chứng từ ", { content: "serverDateRangeFilter" }],
                        width: 120,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        // template: function (obj, common) {
                        //     if(obj.tthai!="Chờ ký"){
                        //         return obj.nlap="";
                        //     }
                        //     else{
                        //         var format = webix.Date.dateToStr("%d/%m/%Y");
                        //         var text = removeTimeZoneT(obj.nlap);
                        //         return format(text);
                        //     }
                        // },
                        columnType: "datetime",
                    },
                    // {
                    //     id: "nky",
                    //     header: ["<center>Ngày ký</center>", { content: "serverDateRangeFilter" }],
                    //     width: 150,
                    //     css: { "text-align": "center" },
                    //     //format:webix.i18n.dateFormatStr
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    //     columnType: "datetime",
                    // },
                    {
                        id: "khieu",
                        header: ["Ký hiệu", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        columnType: "nvarchar",
                    },
                    { id: "shdon", header: ["Số Chứng từ ", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },

                    { id: "mst", header: ["Mã số thuế", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    { id: "mdvi", header: ["Đơn vị quản lý", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    { id: "ten_str", header: ["Tên đơn vị/ Tên người mua", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    {
                        id: "tgtttbso_last",
                        header: ["Số thuế thu nhập", { content: "textFilter" }],
                        width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tgtttbso_last == null ? 0 : fm(obj.tgtttbso_last);
                        },
                        columnType: "numeric",
                    },
                    {
                        id: "nglap",
                        header: ["Người lập", { content: "textFilter" }],
                        width: 200,
                        columnType: "nvarchar",
                    },
                    // { id: "ten_loai", header: ["<center>Tên loại HĐ</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv * 1 != $$("pagerA").config.size) {
                                    webix.message("change page size to " + newv);
                                    $$("pagerA").config.size = newv * 1;
                                    var table = $$("invoiceViews");
                                    table.define("datafetch", newv);
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({ title: "Danh sách chờ sinh số", details: "Danh sách chờ sinh số" });
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },
    };
});

define('views/78_duyethoadon_chosinhso',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_huyhoadon", "views/forms/68_huyhoadon_1", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    invoiceForms,
    huyhoadon,
    huyhoadon_1,
    hoadonHistory,
    commonHD
) {
    

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            // {
            //     id: "huyhoadon",
            //     value: "Hủy hóa đơn",
            // },
            // {
            //     id: "huyhoadon2",
            //     value: "Hủy hóa đơn có tạo mới",
            // },
            // {
            //     id: "giaitrinh",
            //     value: "Giải trình",
            // },
            {
                id: "notifyErrorInvoice",
                value: "Thông báo HĐĐT có sai sót",
            },
            {
                id: "replace_invoice",
                value: "Thay thế",
            },
            {
                id: "increase_change_invoice",
                value: "Điều chỉnh tăng",
            },
            {
                id: "reduce_change_invoice",
                value: "Điều chỉnh giảm",
            },
            {
                id: "info_change",
                value: "Điều chỉnh thông tin",
            },
            {
                id: "dowloadXml",
                value: "Tải XML",
            },
            {
                id: "dowloadXmlMessageHD",
                value: "Tải XML thông điệp gửi HĐ",
            },
            // {
            //     id: "nhanExcel",
            //     value: "Nhận Excel hàng loạt",
            // },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                if (record.id == "nhanExcel") {
                    var table = $$("invoiceViews");

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", {
                            excel_id: "EX00011",
                            filename: "Nhan hang loat hoa don 68 (GTGT).xlsx",
                        });
                        webix.$$("uploader").hide();
                    });
                }
                // console.log(record);
                if (record.id == "huyhoadon") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Hóa đơn đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);

                    webix.$$("btnHuyhoadon").destructor();
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "huyhoadon2") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Hóa đơn đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnStep299").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    // webix.$$("btnStep299").define("hidden", false);
                    // webix.$$("btnStep2").show();
                    // webix.$$("btnStep299").hide();
                    // $$("btnHuyHDDT").addView({ view:"button",label: "Bước 2" }, 1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "dowloadXml") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlInvoice.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "dowloadXmlMessageHD") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Hóa đơn chưa được gửi tới CQT, không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLThongDiepHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlThongDiepHoaDon.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "giaitrinh") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon != "4" && item.tthdon != "0") {
                        webix.message("Hóa đơn không ở trạng thái rà soát không thể lập giải trình !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnSaveSignGiaiTrinh").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    // webix.$$("tctbao").setValue(2);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    this.hide();
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 2,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();

                    // var fn = Function("_", "user", item.on_click);
                    // fn(_, user);
                }
                if (record.id == "notifyErrorInvoice") {
                    var table = webix.$$("invoiceViews");
                    var datafrm = table.serialize();
                    var data = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i]);
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        var cungshd = true;
                        for (var k = 1; k <= data.length - 1; k++) {
                            if (data[k]["stbao"] !== data[0]["stbao"]) {
                                cungshd = false;
                                break;
                            }
                        }
                        if (cungshd === true) {
                            var loai = 1;
                            if (data[0]["stbao"] !== null) loai = 2;
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký" || data[i].tthai == "Đã ký") {
                                    webix.message("Hóa đơn chưa gửi không thể thông báo sai sót", "error");
                                    return;
                                }
                                if (data[i].ladhddt == undefined) {
                                    data[i].ladhddt = "1";
                                }
                                if (data[i].tctbao == undefined) {
                                    data[i].tctbao = "1";
                                }
                            }

                            var win = table.$scope.ui(huyhoadon.$ui);
                            huyhoadon.setEditMode(1);
                            webix.$$("btnHuyhoadon").destructor();
                            var tongquat = {
                                so: data[0].stbao,
                                ntbccqt: data[0].ntbao,
                                loai: loai,
                            };
                            huyhoadon.setValuesTongQuat(tongquat, null, null);
                            data.forEach(function (item) {
                                var put = {
                                    khieu: item.khieu,
                                    shdon: item.shdon,
                                    ngay: item.nlap,
                                    ladhddt: item.ladhddt,
                                    tctbao: item.tctbao,
                                    hdon_id: item.id,
                                };
                                huyhoadon.setValues(put, null, null);
                                //this.hide();
                                win.show();
                            });
                        } else {
                            webix.message("Các hóa đơn chọn phải có số thông báo giống nhau", "error");
                        }
                    } else {
                        var item = table.getSelectedItem();

                        var loai = 1;
                        if (item["stbao"] !== null) loai = 2;

                        if (item == null) {
                            webix.message("Bạn chưa chọn hóa đơn", "error");
                            return;
                        }

                        if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                            webix.message("Hóa đơn chưa gửi không thể thông báo sai sót", "error");
                            return;
                        }

                        if (item.ladhddt == undefined) {
                            item["ladhddt"] = "1";
                        }
                        if (item.tctbao == undefined) {
                            item["tctbao"] = "1";
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();

                        var tongquat = {
                            so: item.stbao,
                            ntbccqt: item.ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);

                        var put = {
                            khieu: item.khieu,
                            shdon: item.shdon,
                            ngay: item.nlap,
                            ladhddt: item.ladhddt,
                            tctbao: item.tctbao,
                            hdon_id: item.id,
                        };
                        huyhoadon.setValues(put, null, null);

                        //this.hide();
                        win.show();
                    }

                    // var win = table.$scope.ui(huyhoadon.$ui);
                    // huyhoadon.setEditMode(1);
                    // webix.$$("btnHuyhoadon").destructor();

                    // webix.$$("btnSaveSignGiaiTrinh").show();
                    // webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("btnGhiHuyhoadon").destructor();
                    // webix.$$("btnGhiSignHuyHDDT").destructor();
                    // this.hide();
                    // win.show();
                }
                if (record.id == "replace_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 2;
                    item.tthdon_original = 2;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var tableDetail = webix.$$("hoadon68_chitiet");

                    tableDetail.clearAll();
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "increase_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 19;
                    item.tthdon_original = 19;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    // var tableDetail = webix.$$("hoadon68_chitiet");
                    // tableDetail.clearAll();
                    // tableDetail.refresh();

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    /*tableDetail.getColumnConfig("sluong").editor = null;
                    tableDetail.getColumnConfig("thtien").editor = null;
                    tableDetail.getColumnConfig("tsuat").editor = null;
                    tableDetail.getColumnConfig("tgtien").editor = null;
                    tableDetail.getColumnConfig("tthue").editor = null;*/
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();

                    //detailForm.show();
                }
                if (record.id == "reduce_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 21;
                    item.tthdon_original = 21;
                    item.nky = "";
                    item.hdon_id = "";
                    item.note = "reduce_change_invoice";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);
                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "info_change") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 23;
                    item.tthdon_original = 23;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";

                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    // tableDetail.getColumnConfig("sluong").editor = null;
                    // tableDetail.getColumnConfig("thtien").editor = null;
                    // tableDetail.getColumnConfig("tsuat").editor = null;
                    // tableDetail.getColumnConfig("tgtien").editor = null;
                    // tableDetail.getColumnConfig("tthue").editor = null;
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();
                }
            },
        },
    });

    webix.$$("title").parse({ title: "Danh sách chờ ký", details: "Danh sách hóa đơn chờ ký" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in chứng từ",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại hóa đơn gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sinh số") + "</span>",
            id: "btnKyCXL",
            click: function () {
                webix.confirm({
                    text: "Bạn chắc chắn muốn sinh số hóa đơn ?",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var dsHoaDon = commonHD.GetHoaDonChon();
                            var lsHodonId = [];

                            dsHoaDon.forEach(function (p) {
                                lsHodonId.push(p.hdon_id);
                            });

                            commonHD.DuyetHoaDon(lsHodonId, "Chờ sinh số");
                        }
                    },
                });
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Kết xuất màn hình") + "</span>",
            id: "btnXuatExel",
            click: function () {
                webix.confirm({
                    text: "Kết xuất màn hình toàn bộ hóa đơn theo filter?",
                    ok: "Có",
                    cancel: "Không",
                    width: 300,
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var table = $$("invoiceViews");
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            var datafetch = table.config.datafetch;
                            table.config.datafetch = table.data.count();
                            var params = table.config.params;
                            if (params != null && params != undefined) {
                                params.count = table.data.count();
                            }
                            var columnlst = table.config.columns;
                            var arrcolumn = [];

                            for (var i = 2; i < columnlst.length; i++) {
                                var exporttype = "";
                                if (columnlst[i].columnType == "character varying" || columnlst[i].columnType == "nvarchar") {
                                    exporttype = "string";
                                } else {
                                    exporttype = columnlst[i].columnType;
                                }
                                var item = {
                                    id: columnlst[i].id,
                                    header: columnlst[i].header[0]["text"],

                                    exportType: exporttype,
                                };
                                arrcolumn.push(item);
                            }
                            table.load(
                                table.config.url,
                                function () {
                                    webix.toExcel($$("invoiceViews"), {
                                        columns: arrcolumn,
                                        rawValues: true,
                                        filename: "DanhSachHoaDonFull",
                                    });
                                    table.config.datafetch = datafetch;
                                    table.enable();
                                    table.hideProgress();
                                },
                                params
                            );
                        }
                    },
                });
            },
        },
        // Khong duoc xoa cai ngoac nhon nay
        {},
        {},
        {},
        {},
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var daiKyHieu = "";
                        //get count list combo ký hiệu
                        //var countkyHieu = $$("kyhieu_id") != undefined ? $$("kyhieu_id").getPopup().getList().serialize().length : 0;
                        var url = app.config.host + "/Invoice68/GetDataInvoiceDanhSachChoKy";
                        var table = $$("invoiceViews");
                        if (params == null) {
                            commonHD.clear_filter(view);
                            table.config.params = null;
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            webix.storage.local.put("currentFilter", params.filter);
                            table.define("params", params);
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property],
                                        filterType: column.header[1].content,
                                    };

                                    if (item.filterType == "serverDateRangeFilter") {
                                        var startDate = item.value.start;
                                        if (startDate !== null && startDate !== undefined) {
                                            var hoursDiff = startDate.getHours() - startDate.getTimezoneOffset() / 60;
                                            var minutesDiff = (startDate.getHours() - startDate.getTimezoneOffset()) % 60;
                                            startDate.setHours(hoursDiff);
                                            startDate.setMinutes(minutesDiff);
                                            item.value.start = startDate;
                                        }

                                        var endDate = item.value.end;
                                        if (endDate !== null && endDate !== undefined) {
                                            var hoursDiff = endDate.getHours() - endDate.getTimezoneOffset() / 60;
                                            var minutesDiff = (endDate.getHours() - endDate.getTimezoneOffset()) % 60;
                                            endDate.setHours(hoursDiff);
                                            endDate.setMinutes(minutesDiff);
                                            item.value.end = endDate;
                                        }
                                    }

                                    if (item.value != "" && item.value != null) {
                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                            }
                            url = url + "&filter=null";
                        }
                        url = url + "&tlbparam=null&tthai=Chờ sinh số";
                        webix.ajax(url, callback, view);
                    },
                },
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    // onItemDblClick: function (id, e, node) {
                    //     var btnEdit = $$("btnEdit");
                    //     btnEdit.callEvent("onClick");
                    // },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    css: "subInvoice",
                    scrollX: true,
                    // tabbar: {
                    //     width: 200
                    // },
                    multiview: {
                        fitBiggest: true,
                    },
                    cells: [
                        {
                            header: "Chi tiết hóa đơn",
                            select: "cell",
                            body: {
                                view: "datatable",
                                resizeColumn: true,
                                margin: 10,
                                id: "hoadon68_chitiet_view",
                                height: 200,
                                columns: [
                                    { id: "stt", header: "", width: 30 },
                                    {
                                        id: "ma",
                                        header: _("Mã hàng hóa"),
                                        editor: "text",
                                        width: 100,
                                        editable: true,
                                    },
                                    {
                                        id: "ten",
                                        header: _("Tên hàng hóa"),
                                        editor: "text",
                                        width: 350,
                                        editable: true,
                                    },
                                    {
                                        id: "mdvtinh",
                                        header: _("ĐVT"),
                                        editor: "text",
                                        width: 80,
                                        editable: true,
                                    },
                                    {
                                        id: "sluong",
                                        header: _("Số lương"),
                                        editor: "autonumeric",
                                        width: 100,
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "dgia",
                                        header: _("Đơn giá"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "thtien",
                                        header: _("Tiền trước thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "tlckhau",
                                        header: _("% CK"),
                                        width: 80,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "stckhau",
                                        header: _("Tiền CK"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tsuat",
                                        header: _("Thuế suất"),
                                        width: 100,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tthue",
                                        header: _("Tiền thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tgtien",
                                        header: _("Tiền sau thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "khuyen_mai",
                                        header: _("Khuyến mại"),
                                        width: 100,
                                        editor: "checkbox",
                                        editable: true,
                                        template: "{common.checkbox()}",
                                        checkValue: true,
                                        uncheckValue: false,
                                    },
                                ],
                                on: {
                                    onBeforeLoad: function () {
                                        this.showOverlay(_("LOADING") + "...");
                                    },
                                    onAfterLoad: function () {
                                        this.hideOverlay();
                                    },
                                },
                            },
                        },
                    ],
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "stt",
                        header: ["STT"],
                        //header: "",
                        sort: "int",
                        width: 40,
                        columnType: "nvarchar",
                        //css: { "line-height": "20px !important", "height": "63px !important"}
                    },
                    {
                        id: "ttthdon",

                        header: [
                            "Trạng thái",
                            {
                                content: "serverMultiSelectFilter",
                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00502",
                            },
                        ],
                        // template: function (obj, common) {
                        //     console.log(obj);
                        // },

                        template: function (obj, common) {
                            console.log(obj.tthdon);
                            return "<span class='mcls_status" + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        },
                        width: 200,
                    },
                    {
                        id: "tthai",
                        header: ["Trạng thái gửi CQT", { content: "serverMultiSelectFilter", options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00504" }],
                        width: 200,
                    },
                    //
                    // {
                    //     id: "btnMessagetn",
                    //     header: ["Lịch sử xử lý"],
                    //     css: { "text-align": "center" },
                    //     template: function (obj) {
                    //         return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                    //     },
                    //     width: 180,
                    // },
                    // {
                    //     id: "issendmail",
                    //     header: ["Gửi Email"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     checkValue: true, uncheckValue: false,
                    //     template: "{common.rcheckbox()}"
                    // },
                    // {
                    //     id: "error_status",
                    //     header: ["Có lỗi/Không có lỗi"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     template: function (obj) {
                    //         if (obj.error_status == "1") {
                    //             return "<span style='color: #e83717'>Có lỗi</span> ";
                    //         } else {
                    //             return "";
                    //         }
                    //     }
                    // },
                    {
                        id: "nlap",
                        header: ["Ngày hóa đơn", { content: "serverDateRangeFilter" }],
                        width: 120,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        // template: function (obj, common) {
                        //     if(obj.tthai!="Chờ ký"){
                        //         return obj.nlap="";
                        //     }
                        //     else{
                        //         var format = webix.Date.dateToStr("%d/%m/%Y");
                        //         var text = removeTimeZoneT(obj.nlap);
                        //         return format(text);
                        //     }
                        // },
                        columnType: "datetime",
                    },
                    // {
                    //     id: "nky",
                    //     header: ["Ngày ký", { content: "serverDateRangeFilter" }],
                    //     width: 150,
                    //     css: { "text-align": "center" },
                    //     //format:webix.i18n.dateFormatStr
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    //     columnType: "datetime",
                    // },
                    {
                        id: "khieu",
                        header: ["Ký hiệu", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        columnType: "nvarchar",
                    },
                    {
                        id: "is_hdcma_str",
                        header: ["Tình trạng mã", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        /*columnType: "integer",
                        template: function (obj) {
                            return obj.is_hdcma === 0 ? "Không mã" : obj.is_hdcma === 1 ? "Có mã" : "Không rõ tình trạng mã";
                        },*/
                    },
                    // {
                    //     id: "khieu", header: ["Ký hiệu", { content: "textFilter" }],
                    //     template: function (obj, common) {
                    //         return "<span class='mcls_status " + obj.className + "'>" + obj.ten_trang_thai + "</span>";
                    //     }, width: 100, columnType: "nvarchar"
                    // },
                    { id: "shdon", header: ["Số hóa đơn", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },

                    { id: "mst", header: ["Mã số thuế", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    // { id: "mtdiep_gui", header: ["<center>Mã thông điệp gửi đi</center>", { content: "textFilter" }], width: 350, columnType: "nvarchar" },
                    // { id: "mtdiep_cqt", header: ["<center>Mã thông điệp cơ quan thuế</center>", { content: "textFilter" }], width: 300, columnType: "nvarchar" },
                    { id: "mdvi", header: ["Đơn vị quản lý", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    { id: "ten_str", header: ["Tên đơn vị/ Tên người mua", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    {
                        id: "tgtttbso_last",
                        header: ["Thành tiền sau thuế", { content: "textFilter" }],
                        width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tgtttbso_last == null ? 0 : fm(obj.tgtttbso_last);
                        },
                        columnType: "numeric",
                    },
                    { id: "htttoan", header: ["Hình thức TT", { content: "textFilter" }], width: 200, columnType: "nvarchar", css: { "text-align": "center" } },
                    // {
                    //     id: "tdlap",
                    //     header: ["Thời điểm lập", { content: "textFilter" }],
                    //     width: 200,
                    //     columnType: "nvarchar",
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    // },
                    {
                        id: "nglap",
                        header: ["Người lập", { content: "textFilter" }],
                        width: 200,
                        columnType: "nvarchar",
                    },
                    // { id: "ten_loai", header: ["Tên loại HĐ", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv * 1 != $$("pagerA").config.size) {
                                    webix.message("change page size to " + newv);
                                    $$("pagerA").config.size = newv * 1;
                                    var table = $$("invoiceViews");
                                    table.define("datafetch", newv);
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({
                title: "Danh sách chờ sinh số",
                details: "Danh sách chờ sinh số",
            });
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
        },
    };
});

define('views/78_duyethoadon_tncn',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_huyhoadon", "views/forms/68_huyhoadon_1", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    invoiceForms,
    huyhoadon,
    huyhoadon_1,
    hoadonHistory,
    commonHD
) {
    

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            // {
            //     id: "huyhoadon",
            //     value: "Hủy chứng từ",
            // },
            // {
            //     id: "huyhoadon2",
            //     value: "Hủy chứng từ có tạo mới",
            // },
            // {
            //     id: "giaitrinh",
            //     value: "Giải trình",
            // },
            {
                id: "notifyErrorInvoice",
                value: "Thông báo HĐĐT có sai sót",
            },
            {
                id: "replace_invoice",
                value: "Thay thế",
            },
            {
                id: "increase_change_invoice",
                value: "Điều chỉnh tăng",
            },
            {
                id: "reduce_change_invoice",
                value: "Điều chỉnh giảm",
            },
            {
                id: "info_change",
                value: "Điều chỉnh thông tin",
            },
            {
                id: "dowloadXml",
                value: "Tải XML",
            },
            {
                id: "dowloadXmlMessageHD",
                value: "Tải XML thông điệp gửi HĐ",
            },
            // {
            //     id: "nhanExcel",
            //     value: "Nhận Excel hàng loạt",
            // },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                if (record.id == "nhanExcel") {
                    var table = $$("invoiceViews");

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", { excel_id: "EX00011", filename: "Nhan hang loat hoa don 68 (GTGT).xlsx" });
                        webix.$$("uploader").hide();
                    });
                }
                // console.log(record);
                if (record.id == "huyhoadon") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("chứng từ đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("chứng từ đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);

                    webix.$$("btnHuyhoadon").destructor();
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "huyhoadon2") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("chứng từ đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("chứng từ đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnStep299").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    // webix.$$("btnStep299").define("hidden", false);
                    // webix.$$("btnStep2").show();
                    // webix.$$("btnStep299").hide();
                    // $$("btnHuyHDDT").addView({ view:"button",label: "Bước 2" }, 1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "dowloadXml") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("chứng từ đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlInvoice.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "dowloadXmlMessageHD") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("chứng từ chưa được gửi tới CQT, không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLThongDiepHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlThongDiepHoaDon.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "giaitrinh") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ", "error");
                        return;
                    }
                    if (item.tthdon != "4" && item.tthdon != "0") {
                        webix.message("chứng từ không ở trạng thái rà soát không thể lập giải trình !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnSaveSignGiaiTrinh").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    // webix.$$("tctbao").setValue(2);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    this.hide();
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 2,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();

                    // var fn = Function("_", "user", item.on_click);
                    // fn(_, user);
                }
                if (record.id == "notifyErrorInvoice") {
                    var table = webix.$$("invoiceViews");
                    var datafrm = table.serialize();
                    var data = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i]);
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        var cungshd = true;
                        for (var k = 1; k <= data.length - 1; k++) {
                            if (data[k]["stbao"] !== data[0]["stbao"]) {
                                cungshd = false;
                                break;
                            }
                        }
                        if (cungshd === true) {
                            var loai = 1;
                            if (data[0]["stbao"] !== null) loai = 2;
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký" || data[i].tthai == "Đã ký") {
                                    webix.message("chứng từ chưa gửi không thể thông báo sai sót", "error");
                                    return;
                                }
                                if (data[i].ladhddt == undefined) {
                                    data[i].ladhddt = "1";
                                }
                                if (data[i].tctbao == undefined) {
                                    data[i].tctbao = "1";
                                }
                            }

                            var win = table.$scope.ui(huyhoadon.$ui);
                            huyhoadon.setEditMode(1);
                            webix.$$("btnHuyhoadon").destructor();
                            var tongquat = {
                                so: data[0].stbao,
                                ntbccqt: data[0].ntbao,
                                loai: loai,
                            };
                            huyhoadon.setValuesTongQuat(tongquat, null, null);
                            data.forEach(function (item) {
                                var put = {
                                    khieu: item.khieu,
                                    shdon: item.shdon,
                                    ngay: item.nlap,
                                    ladhddt: item.ladhddt,
                                    tctbao: item.tctbao,
                                    hdon_id: item.id,
                                };
                                huyhoadon.setValues(put, null, null);
                                //this.hide();
                                win.show();
                            });
                        } else {
                            webix.message("Các chứng từ chọn phải có số thông báo giống nhau", "error");
                        }
                    } else {
                        var item = table.getSelectedItem();

                        var loai = 1;
                        if (item["stbao"] !== null) loai = 2;

                        if (item == null) {
                            webix.message("Bạn chưa chọn chứng từ", "error");
                            return;
                        }

                        if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                            webix.message("chứng từ chưa gửi không thể thông báo sai sót", "error");
                            return;
                        }

                        if (item.ladhddt == undefined) {
                            item["ladhddt"] = "1";
                        }
                        if (item.tctbao == undefined) {
                            item["tctbao"] = "1";
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();

                        var tongquat = {
                            so: item.stbao,
                            ntbccqt: item.ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);

                        var put = {
                            khieu: item.khieu,
                            shdon: item.shdon,
                            ngay: item.nlap,
                            ladhddt: item.ladhddt,
                            tctbao: item.tctbao,
                            hdon_id: item.id,
                        };
                        huyhoadon.setValues(put, null, null);

                        //this.hide();
                        win.show();
                    }

                    // var win = table.$scope.ui(huyhoadon.$ui);
                    // huyhoadon.setEditMode(1);
                    // webix.$$("btnHuyhoadon").destructor();

                    // webix.$$("btnSaveSignGiaiTrinh").show();
                    // webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("btnGhiHuyhoadon").destructor();
                    // webix.$$("btnGhiSignHuyHDDT").destructor();
                    // this.hide();
                    // win.show();
                }
                if (record.id == "replace_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 2;
                    item.tthdon_original = 2;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var tableDetail = webix.$$("hoadon68_chitiet");

                    tableDetail.clearAll();
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "increase_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 19;
                    item.tthdon_original = 19;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    // var tableDetail = webix.$$("hoadon68_chitiet");
                    // tableDetail.clearAll();
                    // tableDetail.refresh();

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "chứng từ điều chỉnh cho chứng từ số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    /*tableDetail.getColumnConfig("sluong").editor = null;
                    tableDetail.getColumnConfig("thtien").editor = null;
                    tableDetail.getColumnConfig("tsuat").editor = null;
                    tableDetail.getColumnConfig("tgtien").editor = null;
                    tableDetail.getColumnConfig("tthue").editor = null;*/
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();

                    //detailForm.show();
                }
                if (record.id == "reduce_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 21;
                    item.tthdon_original = 21;
                    item.nky = "";
                    item.hdon_id = "";
                    item.note = "reduce_change_invoice";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);
                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "chứng từ điều chỉnh cho chứng từ số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "info_change") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("chứng từ chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 23;
                    item.tthdon_original = 23;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";

                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "chứng từ điều chỉnh cho chứng từ số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    // tableDetail.getColumnConfig("sluong").editor = null;
                    // tableDetail.getColumnConfig("thtien").editor = null;
                    // tableDetail.getColumnConfig("tsuat").editor = null;
                    // tableDetail.getColumnConfig("tgtien").editor = null;
                    // tableDetail.getColumnConfig("tthue").editor = null;
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();
                }
            },
        },
    });

    webix.$$("title").parse({ title: "Danh sách chờ ký", details: "Danh sách chứng từ chờ ký" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn chứng từ !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in chứng từ",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại chứng từ gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in chứng từ ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>chứng từ điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("In chuyển đổi") + "</span>",
            id: "btnPrintConvert",
            hidden: true,
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in chứng từ ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>chứng từ điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký chờ xử lý") + "</span>",
            id: "btnKyCXL",
            click: function () {
                webix.confirm({
                    text: "Bạn chắc chắn muốn ký chứng từ ?",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var dsHoaDon = commonHD.validate_HD_ReturnListHdonKhongMaVaCoMaId();
                            var lsCoMa = dsHoaDon[0];
                            var lsKhongMa = dsHoaDon[1];

                            // console.log(lsCoMa);
                            // console.log(lsKhongMa);
                            if (lsCoMa.length > 0 || lsKhongMa.length > 0) {
                                var lsHodonId = [];
                                lsHodonId.push(lsCoMa);
                                lsHodonId.push(lsKhongMa);
                                commonHD.ExcuteHoaDonForHasCodeAndNotHaveAnyCode(lsHodonId, false, true, "TCTTNhap");
                            }
                        }
                    },
                });
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Kết xuất màn hình") + "</span>",
            id: "btnXuatExel",
            click: function () {
                webix.confirm({
                    text: "Kết xuất màn hình toàn bộ chứng từ theo filter?",
                    ok: "Có",
                    cancel: "Không",
                    width: 300,
                    callback: function (res) {
                        if (res) {
                            var table = $$("invoiceViews");

                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            var datafetch = table.config.datafetch;
                            table.config.datafetch = table.data.count();
                            var params = table.config.params;
                            if (params != null && params != undefined) {
                                params.count = table.data.count();
                            }
                            var columnlst = table.config.columns;
                            var arrcolumn = [];

                            for (var i = 2; i < columnlst.length; i++) {
                                var exporttype = "";
                                if (columnlst[i].columnType == "character varying" || columnlst[i].columnType == "nvarchar") {
                                    exporttype = "string";
                                } else {
                                    exporttype = columnlst[i].columnType;
                                }
                                var item = {
                                    id: columnlst[i].id,
                                    header: columnlst[i].header[0]["text"],

                                    exportType: exporttype,
                                };
                                arrcolumn.push(item);
                            }

                            table.load(
                                table.config.url,
                                function () {
                                    webix.toExcel($$("invoiceViews"), {
                                        columns: arrcolumn,
                                        rawValues: true,
                                        filename: "DanhSachHoaDonFull",
                                    });
                                    table.config.datafetch = datafetch;
                                    table.enable();
                                    table.hideProgress();
                                },
                                params
                            );
                        }
                    },
                });
            },
        },
        // Khong duoc xoa cai ngoac nhon nay
        {},
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var daiKyHieu = "";
                        //get count list combo ký hiệu
                        //var countkyHieu = $$("kyhieu_id") != undefined ? $$("kyhieu_id").getPopup().getList().serialize().length : 0;
                        var url = app.config.host + "/Invoice68/GetDataInvoiceDanhSachChoKy";

                        var table = $$("invoiceViews");
                        if (params == null) {
                            commonHD.clear_filter(view);
                            table.config.params = null;
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            webix.storage.local.put("currentFilter", params.filter);
                            table.define("params", params);
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property],
                                        filterType: column.header[1].content,
                                    };

                                    if (item.value != null && item.value != "") {
                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                            }
                            url = url + "&filter=null";
                        }
                        url = url + "&tlbparam=null&tthai=Chờ ký&loaihd=3";
                        webix.ajax(url, callback, view);
                    },
                },
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    // onItemDblClick: function (id, e, node) {
                    //     var btnEdit = $$("btnEdit");
                    //     btnEdit.callEvent("onClick");
                    // },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "stt",
                        header: ["STT"],
                        //header: "",
                        sort: "int",
                        width: 40,
                        columnType: "nvarchar",
                        //css: { "line-height": "20px !important", "height": "63px !important"}
                    },
                    {
                        id: "ttthdon",
                        width: 200,
                        header: [
                            "Trạng thái",
                            {
                                content: "serverMultiSelectFilter",
                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00502",
                            },
                        ],
                        template: function (obj, common) {
                            console.log(obj.tthdon);
                            return "<span class='mcls_status" + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        },
                    },
                    {
                        id: "tthai",
                        header: ["Trạng thái chứng từ", { content: "serverMultiSelectFilter", options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00504" }],
                        width: 200,
                    },
                    //
                    // {
                    //     id: "btnMessagetn",
                    //     header: ["<center>Lịch sử xử lý</center>"],
                    //     css: { "text-align": "center" },
                    //     template: function (obj) {
                    //         return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                    //     },
                    //     width: 180,
                    // },
                    // {
                    //     id: "issendmail",
                    //     header: ["<center>Gửi Email</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     checkValue: true, uncheckValue: false,
                    //     template: "{common.rcheckbox()}"
                    // },
                    // {
                    //     id: "error_status",
                    //     header: ["<center>Có lỗi/Không có lỗi</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     template: function (obj) {
                    //         if (obj.error_status == "1") {
                    //             return "<span style='color: #e83717'>Có lỗi</span> ";
                    //         } else {
                    //             return "";
                    //         }
                    //     }
                    // },
                    {
                        id: "nlap",
                        header: ["Ngày chứng từ", { content: "serverDateRangeFilter" }],
                        width: 120,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        // template: function (obj, common) {
                        //     if(obj.tthai!="Chờ ký"){
                        //         return obj.nlap="";
                        //     }
                        //     else{
                        //         var format = webix.Date.dateToStr("%d/%m/%Y");
                        //         var text = removeTimeZoneT(obj.nlap);
                        //         return format(text);
                        //     }
                        // },
                        columnType: "datetime",
                    },
                    // {
                    //     id: "nky",
                    //     header: ["<center>Ngày ký</center>", { content: "serverDateRangeFilter" }],
                    //     width: 150,
                    //     css: { "text-align": "center" },
                    //     //format:webix.i18n.dateFormatStr
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    //     columnType: "datetime",
                    // },
                    {
                        id: "khieu",
                        header: ["Ký hiệu", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        columnType: "nvarchar",
                    },
                    { id: "shdon", header: ["Số chứng từ", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },

                    { id: "mst", header: ["Mã số thuế", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    { id: "mdvi", header: ["Đơn vị quản lý", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    { id: "ten_str", header: ["Tên đơn vị/ Tên người mua", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    {
                        id: "tgtttbso_last",
                        header: ["Số thuế thu nhập", { content: "textFilter" }],
                        width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tgtttbso_last == null ? 0 : fm(obj.tgtttbso_last);
                        },
                        columnType: "numeric",
                    },
                    {
                        id: "nglap",
                        header: ["Người lập", { content: "textFilter" }],
                        width: 200,
                        columnType: "nvarchar",
                    },
                    // { id: "ten_loai", header: ["<center>Tên loại HĐ</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                webix.message("change page size to " + newv);
                                $$("pagerA").config.size = newv * 1;
                                var table = $$("invoiceViews");
                                table.define("datafetch", newv);
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({ title: "Danh sách chờ ký", details: "Danh sách chờ ký" });
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
            // var table = $$("invoiceViews");
            // var url = {
            //     $proxy: true,
            //     load: function (view, callback, params) {
            //         console.log(view.config);
            //         console.log(callback);
            //         console.log(params);
            //         /*var windowno = app.path[1].params[0];
            //         var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

            //         if (params == null) {
            //             url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            //         }
            //         else {
            //             url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

            //             if (params.filter != null) {
            //                 var array = [];

            //                 for (var property in params.filter) {

            //                     var column = view.getColumnConfig(property);

            //                     if (column !== undefined) {
            //                         var item = {
            //                             columnName: property,
            //                             columnType: column.columnType,
            //                             value: params.filter[property]
            //                         };

            //                         array.push(item);
            //                     }
            //                 }

            //                 //console.log(JSON.stringify(array));
            //                 if (array.length > 0) {
            //                     url = url + "&filter=" + JSON.stringify(array);
            //                 }
            //                 else {
            //                     url = url + "&filter=null";
            //                 }

            //             }
            //             else {
            //                 url = url + "&filter=null";
            //             }
            //         }

            //         if (view.config.infoparam != null) {
            //             url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
            //         }
            //         else {
            //             url = url + "&infoparam=null";
            //         }

            //         var tlbParams = $$("tlbParams");

            //         if (tlbParams !== undefined) {
            //             var childViews = tlbParams.getChildViews();

            //             var parameters = [];

            //             for (var i = 0; i < childViews.length; i++) {
            //                 var child = childViews[i];

            //                 var id = child.config.id;
            //                 var value_field = child.config.value_field;

            //                 var item = {
            //                     columnName: value_field,
            //                     value: $$(id).getValue()
            //                 };

            //                 parameters.push(item);
            //             }

            //             url = url + "&tlbparam=" + JSON.stringify(parameters);

            //         }
            //         else {
            //             url = url + "&tlbparam=null";
            //         }*/

            //         //console.log(url);

            //         /* webix.ajax().bind(view)
            //             .get(url,function(text){
            //                 var json =JSON.parse(text);

            //                 this.clearAll();

            //                 if (!json.hasOwnProperty("error")){
            //                     this.parse(json.data,"json");
            //                 }
            //         }); */

            //         //webix.ajax(url, callback, view);

            //     }
            // };

            // table.define("url", url);
        },
    };
});

define('views/78_duyethoadon',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_huyhoadon", "views/forms/68_huyhoadon_1", "views/forms/68_hoadon_history", "views/commonHD"], function (
    app,
    _,
    user,
    invoiceForms,
    huyhoadon,
    huyhoadon_1,
    hoadonHistory,
    commonHD
) {
    

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var dataCount;

    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            // {
            //     id: "huyhoadon",
            //     value: "Hủy hóa đơn",
            // },
            // {
            //     id: "huyhoadon2",
            //     value: "Hủy hóa đơn có tạo mới",
            // },
            // {
            //     id: "giaitrinh",
            //     value: "Giải trình",
            // },
            {
                id: "notifyErrorInvoice",
                value: "Thông báo HĐĐT có sai sót",
            },
            {
                id: "replace_invoice",
                value: "Thay thế",
            },
            {
                id: "increase_change_invoice",
                value: "Điều chỉnh tăng",
            },
            {
                id: "reduce_change_invoice",
                value: "Điều chỉnh giảm",
            },
            {
                id: "info_change",
                value: "Điều chỉnh thông tin",
            },
            {
                id: "dowloadXml",
                value: "Tải XML",
            },
            {
                id: "dowloadXmlMessageHD",
                value: "Tải XML thông điệp gửi HĐ",
            },
            // {
            //     id: "nhanExcel",
            //     value: "Nhận Excel hàng loạt",
            // },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                if (record.id == "nhanExcel") {
                    var table = $$("invoiceViews");

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", { excel_id: "EX00011", filename: "Nhan hang loat hoa don 68 (GTGT).xlsx" });
                        webix.$$("uploader").hide();
                    });
                }
                // console.log(record);
                if (record.id == "huyhoadon") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Hóa đơn đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);

                    webix.$$("btnHuyhoadon").destructor();
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "huyhoadon2") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon == 3) {
                        webix.message("Hóa đơn đã Hủy bạn không thể hủy thêm !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký, không thể hủy !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnStep299").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    // webix.$$("btnStep299").define("hidden", false);
                    // webix.$$("btnStep2").show();
                    // webix.$$("btnStep299").hide();
                    // $$("btnHuyHDDT").addView({ view:"button",label: "Bước 2" }, 1);
                    // console.log(item);
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 1,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();
                }
                if (record.id == "dowloadXml") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Hóa đơn đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlInvoice.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "dowloadXmlMessageHD") {
                    //    var btnEdit = $$("btnPlus");
                    //     btnEdit.callEvent("onClick");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthai == "Chờ ký" || item.tthai == "Chờ gửi") {
                        webix.message("Hóa đơn chưa được gửi tới CQT, không thể tải XML !", "error");
                        return;
                    }

                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLThongDiepHoadon?id=" + item.id;
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "XmlThongDiepHoaDon.xml");
                            // var fileURL = URL.createObjectURL(file);
                            // window.open(fileURL, "_blank");
                        });
                }
                if (record.id == "giaitrinh") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    if (item.tthdon != "4" && item.tthdon != "0") {
                        webix.message("Hóa đơn không ở trạng thái rà soát không thể lập giải trình !", "error");
                        return;
                    }

                    var win = table.$scope.ui(huyhoadon.$ui);
                    huyhoadon.setEditMode(1);
                    webix.$$("btnSaveSignGiaiTrinh").show();
                    webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("danhsach_hoadonhuy").define("editable", false);
                    // webix.$$("tctbao").setValue(2);
                    webix.$$("btnGhiHuyhoadon").destructor();
                    webix.$$("btnGhiSignHuyHDDT").destructor();
                    this.hide();
                    var put = {
                        khieu: item.khieu,
                        shdon: item.shdon,
                        ngay: item.nlap,
                        ladhddt: 1,
                        tctbao: 2,
                        hdon_id: item.id,
                    };
                    huyhoadon.setValues(put, null, null);
                    win.show();

                    // var fn = Function("_", "user", item.on_click);
                    // fn(_, user);
                }
                if (record.id == "notifyErrorInvoice") {
                    var table = webix.$$("invoiceViews");
                    var datafrm = table.serialize();
                    var data = [];

                    if (datafrm.length > 0) {
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i] != undefined) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i]);
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        var cungshd = true;
                        for (var k = 1; k <= data.length - 1; k++) {
                            if (data[k]["stbao"] !== data[0]["stbao"]) {
                                cungshd = false;
                                break;
                            }
                        }
                        if (cungshd === true) {
                            var loai = 1;
                            if (data[0]["stbao"] !== null) loai = 2;
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].tthai == "Chờ gửi" || data[i].tthai == "Chờ ký" || data[i].tthai == "Đã ký") {
                                    webix.message("Hóa đơn chưa gửi không thể thông báo sai sót", "error");
                                    return;
                                }
                                if (data[i].ladhddt == undefined) {
                                    data[i].ladhddt = "1";
                                }
                                if (data[i].tctbao == undefined) {
                                    data[i].tctbao = "1";
                                }
                            }

                            var win = table.$scope.ui(huyhoadon.$ui);
                            huyhoadon.setEditMode(1);
                            webix.$$("btnHuyhoadon").destructor();
                            var tongquat = {
                                so: data[0].stbao,
                                ntbccqt: data[0].ntbao,
                                loai: loai,
                            };
                            huyhoadon.setValuesTongQuat(tongquat, null, null);
                            data.forEach(function (item) {
                                var put = {
                                    khieu: item.khieu,
                                    shdon: item.shdon,
                                    ngay: item.nlap,
                                    ladhddt: item.ladhddt,
                                    tctbao: item.tctbao,
                                    hdon_id: item.id,
                                };
                                huyhoadon.setValues(put, null, null);
                                //this.hide();
                                win.show();
                            });
                        } else {
                            webix.message("Các hóa đơn chọn phải có số thông báo giống nhau", "error");
                        }
                    } else {
                        var item = table.getSelectedItem();

                        var loai = 1;
                        if (item["stbao"] !== null) loai = 2;

                        if (item == null) {
                            webix.message("Bạn chưa chọn hóa đơn", "error");
                            return;
                        }

                        if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký" || item.tthai == "Đã ký") {
                            webix.message("Hóa đơn chưa gửi không thể thông báo sai sót", "error");
                            return;
                        }

                        if (item.ladhddt == undefined) {
                            item["ladhddt"] = "1";
                        }
                        if (item.tctbao == undefined) {
                            item["tctbao"] = "1";
                        }

                        var win = table.$scope.ui(huyhoadon.$ui);
                        huyhoadon.setEditMode(1);
                        webix.$$("btnHuyhoadon").destructor();

                        var tongquat = {
                            so: item.stbao,
                            ntbccqt: item.ntbao,
                            loai: loai,
                        };
                        huyhoadon.setValuesTongQuat(tongquat, null, null);

                        var put = {
                            khieu: item.khieu,
                            shdon: item.shdon,
                            ngay: item.nlap,
                            ladhddt: item.ladhddt,
                            tctbao: item.tctbao,
                            hdon_id: item.id,
                        };
                        huyhoadon.setValues(put, null, null);

                        //this.hide();
                        win.show();
                    }

                    // var win = table.$scope.ui(huyhoadon.$ui);
                    // huyhoadon.setEditMode(1);
                    // webix.$$("btnHuyhoadon").destructor();

                    // webix.$$("btnSaveSignGiaiTrinh").show();
                    // webix.$$("btnHuyhoadon").destructor();
                    // webix.$$("btnGhiHuyhoadon").destructor();
                    // webix.$$("btnGhiSignHuyHDDT").destructor();
                    // this.hide();
                    // win.show();
                }
                if (record.id == "replace_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 2;
                    item.tthdon_original = 2;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var tableDetail = webix.$$("hoadon68_chitiet");

                    tableDetail.clearAll();
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "increase_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 19;
                    item.tthdon_original = 19;
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    // var tableDetail = webix.$$("hoadon68_chitiet");
                    // tableDetail.clearAll();
                    // tableDetail.refresh();

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    /*tableDetail.getColumnConfig("sluong").editor = null;
                    tableDetail.getColumnConfig("thtien").editor = null;
                    tableDetail.getColumnConfig("tsuat").editor = null;
                    tableDetail.getColumnConfig("tgtien").editor = null;
                    tableDetail.getColumnConfig("tthue").editor = null;*/
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();

                    //detailForm.show();
                }
                if (record.id == "reduce_change_invoice") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 21;
                    item.tthdon_original = 21;
                    item.nky = "";
                    item.hdon_id = "";
                    item.note = "reduce_change_invoice";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";
                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);
                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    tableDetail.refresh();

                    detailForm.show();
                }
                if (record.id == "info_change") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    if (item.tthai == "Chờ gửi" || item.tthai == "Chờ ký") {
                        webix.message("Hóa đơn chưa ký không thể thực hiện", "error");
                        return;
                    }
                    var btnPlus = $$("btnPlus");
                    btnPlus.callEvent("onClick");
                    var detailForm = $$("invoiceForms");

                    var ngay_hoa_don = item.nlap;

                    item.nlap = null;
                    item.hdon_id_old = item.hdon_id;
                    item.tthdon_old = item.tthdon;
                    item.tthdon = 23;
                    item.tthdon_original = 23;
                    item.shdon_temp = item.shdon;
                    item.shdon = "";
                    item.nky = "";
                    item.hdon_id = "";

                    for (var i = 0; i < arrayString.length; i++) {
                        item[arrayString[i]] = 0;
                    }
                    item["tgtttbchu"] = "";

                    invoiceForms.setEditMode(1);
                    invoiceForms.setValues(item, null);

                    var obj_detail = {
                        id: webix.uid(),
                        kmai: "4",
                        ten: "Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon_temp + " ngày " + moment(ngay_hoa_don).format("DD/MM/YYYY") + " ký hiệu " + item.khieu,
                    };
                    var tableDetail = webix.$$("hoadon68_chitiet");
                    tableDetail.clearAll();
                    tableDetail.add(obj_detail);
                    var columns = tableDetail.config.columns;
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        //column.editor = null;
                    }
                    // tableDetail.getColumnConfig("sluong").editor = null;
                    // tableDetail.getColumnConfig("thtien").editor = null;
                    // tableDetail.getColumnConfig("tsuat").editor = null;
                    // tableDetail.getColumnConfig("tgtien").editor = null;
                    // tableDetail.getColumnConfig("tthue").editor = null;
                    tableDetail.refreshColumns();
                    tableDetail.refresh();

                    detailForm.show();
                }
            },
        },
    });

    webix.$$("title").parse({ title: "Danh sách chờ ký", details: "Danh sách hóa đơn chờ ký" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in chứng từ",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại hóa đơn gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("In chuyển đổi") + "</span>",
            id: "btnPrintConvert",
            hidden: true,
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                self.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký chờ xử lý") + "</span>",
            id: "btnKyCXL",
            click: function () {
                var table = webix.$$("invoiceViews");
                if ($$("chonAll").getValue() == 0) {
                    webix.confirm({
                        text: "Bạn chắc chắn muốn ký hóa đơn ?",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                //check validate và return ra list hoadon_id
                                var dsHoaDon = commonHD.validate_HD_ReturnListHdonKhongMaVaCoMaId();
                                var lsCoMa = dsHoaDon[0];
                                var lsKhongMa = dsHoaDon[1];
    
                                // console.log(lsCoMa);
                                // console.log(lsKhongMa);
                                
                                if (lsCoMa.length > 0 || lsKhongMa.length > 0) {
                                    var lsHodonId = [];
                                    lsHodonId.push(lsCoMa);
                                    lsHodonId.push(lsKhongMa);
                                    commonHD.ExcuteHoaDonForHasCodeAndNotHaveAnyCode(lsHodonId, false, true);
                                }
                            }
                        },
                    });
                } else {
                    webix.confirm({
                        text: "Bạn chắc chắn muốn ký toàn bộ hóa đơn ?",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.message("Hệ thống đang xử lý, vui lòng chờ trong giây lát!");
                                var table = $$("invoiceViews");
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();
                                //Lấy tất cả và validate hóa đơn
                                var dsHoaDon = commonHD.getAllHD_ValidateHD();
                                var lsCoMa = dsHoaDon[0];
                                var lsKhongMa = dsHoaDon[1];
        
                                // console.log(lsCoMa);
                                // console.log(lsKhongMa);

                                if (lsCoMa.length > 0 || lsKhongMa.length > 0) {
                                    var lsHodonId = [];
                                    lsHodonId.push(lsCoMa);
                                    lsHodonId.push(lsKhongMa);
                                    commonHD.ExcuteHoaDonForHasCodeAndNotHaveAnyCode(lsHodonId, false, true, 2);
                                }

                                var params = table.config.params;
                                var datafetch = table.config.datafetch;
                                table.load(
                                    table.config.url,
                                    function () {
                                        table.config.datafetch = datafetch;
                                        table.enable();
                                        table.hideProgress();
                                    },
                                    params
                                );
                            }
                        },
                    });
                }
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký và gửi CQT") + "</span>",
            id: "btnKyGuiCQT",
            click: function () {
                webix.confirm({
                    text: "Bạn chắc chắn muốn ký và gửi hóa đơn ?",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            //check validate và return ra list hoadon_id
                            var dsHoaDon = commonHD.validate_HD_ReturnListHdonKhongMaVaCoMaVaMTTId();
                            var lsCoMa = dsHoaDon[0];
                            var lsKhongMa = dsHoaDon[1];
                            var lstDataChooseMTT = dsHoaDon[2];

                            // console.log(lsCoMa);
                            // console.log(lsKhongMa);

                            if (lsCoMa.length > 0 || lsKhongMa.length > 0) {
                                var lsHodonId = [];
                                lsHodonId.push(lsCoMa);
                                lsHodonId.push(lsKhongMa);
                                commonHD.ExcuteHoaDonForHasCodeAndNotHaveAnyCode(lsHodonId, true, true);
                            }
                            if (lstDataChooseMTT.length > 0) {
                                var lsHodonId = $.map(lstDataChooseMTT, function (item) {
                                    return item.hdon_id;
                                });;
                                commonHD.ExcuteHoaDonMTT(lsHodonId);
                            }
                        }
                    },
                });
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Kết xuất màn hình") + "</span>",
            id: "btnXuatExel",
            click: function () {
                webix.confirm({
                    text: "Kết xuất màn hình toàn bộ hóa đơn theo filter?",
                    ok: "Có",
                    cancel: "Không",
                    width: 300,
                    callback: function (res) {
                        if (res) {
                            var table = $$("invoiceViews");
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();

                            var datafetch = table.config.datafetch;
                            table.config.datafetch = table.data.count();
                            var params = table.config.params;
                            if (params != null && params != undefined) {
                                params.count = table.data.count();
                            }
                            var columnlst = table.config.columns;
                            var arrcolumn = [];

                            for (var i = 2; i < columnlst.length; i++) {
                                var exporttype = "";
                                if (columnlst[i].columnType == "character varying" || columnlst[i].columnType == "nvarchar") {
                                    exporttype = "string";
                                } else {
                                    exporttype = columnlst[i].columnType;
                                }
                                var item = {
                                    id: columnlst[i].id,
                                    header: columnlst[i].header[0]["text"],

                                    exportType: exporttype,
                                };
                                arrcolumn.push(item);
                            }
                            table.load(
                                table.config.url,
                                function () {
                                    webix.toExcel($$("invoiceViews"), {
                                        columns: arrcolumn,
                                        rawValues: true,
                                        filename: "DanhSachHoaDonFull",
                                    });
                                    table.config.datafetch = datafetch;
                                    table.enable();
                                    table.hideProgress();
                                },
                                params
                            );
                        }
                    },
                });
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Chọn toàn bộ") + "</span>",
            id: "btnChonToanBo",
            click: function (callback, params) {
                $$("chonAll").getValue() ? $$("chonAll").setValue(0) : $$("chonAll").setValue(1);
            }
        },
        {
            view:"checkbox", 
            id:"chonAll", 
            label:"Chọn toàn bộ", 
            labelWidth: 90,
            value:false,
            readonly: true
        },
        // Khong duoc xoa cai ngoac nhon nay
        // ok a
        {},
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var daiKyHieu = "";
                        //get count list combo ký hiệu
                        //var countkyHieu = $$("kyhieu_id") != undefined ? $$("kyhieu_id").getPopup().getList().serialize().length : 0;
                        var url = app.config.host + "/Invoice68/GetDataInvoiceDanhSachChoKy";
                        var table = $$("invoiceViews");

                        if (params == null) {
                            commonHD.clear_filter(view);
                            table.config.params = null;
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            webix.storage.local.put("currentFilter", params.filter);
                            table.define("params", params);
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property],
                                        filterType: column.header[1].content,
                                    };

                                    if (item.filterType == "serverDateRangeFilter") {
                                        var startDate = item.value.start;
                                        if (startDate !== null && startDate !== undefined) {
                                            var hoursDiff = startDate.getHours() - startDate.getTimezoneOffset() / 60;
                                            var minutesDiff = (startDate.getHours() - startDate.getTimezoneOffset()) % 60;
                                            startDate.setHours(hoursDiff);
                                            startDate.setMinutes(minutesDiff);
                                            item.value.start = startDate;
                                        }

                                        var endDate = item.value.end;
                                        if (endDate !== null && endDate !== undefined) {
                                            var hoursDiff = endDate.getHours() - endDate.getTimezoneOffset() / 60;
                                            var minutesDiff = (endDate.getHours() - endDate.getTimezoneOffset()) % 60;
                                            endDate.setHours(hoursDiff);
                                            endDate.setMinutes(minutesDiff);
                                            item.value.end = endDate;
                                        }
                                    }

                                    if (item.value != null && item.value != "") {
                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                            }
                            url = url + "&filter=null";
                        }
                        url = url + "&tlbparam=null&tthai=Chờ ký";
                        
                        webix.ajax(url, callback, view);
                    },
                },
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    // onItemDblClick: function (id, e, node) {
                    //     var btnEdit = $$("btnEdit");
                    //     btnEdit.callEvent("onClick");
                    // },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    css: "subInvoice",
                    scrollX: true,
                    // tabbar: {
                    //     width: 200
                    // },
                    multiview: {
                        fitBiggest: true,
                    },
                    cells: [
                        {
                            header: "Chi tiết hóa đơn",
                            select: "cell",
                            body: {
                                view: "datatable",
                                resizeColumn: true,
                                margin: 10,
                                id: "hoadon68_chitiet_view",
                                height: 200,
                                columns: [
                                    { id: "stt", header: "", width: 30 },
                                    {
                                        id: "ma",
                                        header: _("Mã hàng hóa"),
                                        editor: "text",
                                        width: 100,
                                        editable: true,
                                    },
                                    {
                                        id: "ten",
                                        header: _("Tên hàng hóa"),
                                        editor: "text",
                                        width: 350,
                                        editable: true,
                                    },
                                    {
                                        id: "mdvtinh",
                                        header: _("ĐVT"),
                                        editor: "text",
                                        width: 80,
                                        editable: true,
                                    },
                                    {
                                        id: "sluong",
                                        header: _("Số lương"),
                                        editor: "autonumeric",
                                        width: 100,
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "dgia",
                                        header: _("Đơn giá"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "thtien",
                                        header: _("Tiền trước thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "tlckhau",
                                        header: _("% CK"),
                                        width: 80,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "stckhau",
                                        header: _("Tiền CK"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tsuat",
                                        header: _("Thuế suất"),
                                        width: 100,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tthue",
                                        header: _("Tiền thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "tgtien",
                                        header: _("Tiền sau thuế"),
                                        width: 150,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        id: "khuyen_mai",
                                        header: _("Khuyến mại"),
                                        width: 100,
                                        editor: "checkbox",
                                        editable: true,
                                        template: "{common.checkbox()}",
                                        checkValue: true,
                                        uncheckValue: false,
                                    },
                                ],
                                on: {
                                    onBeforeLoad: function () {
                                        this.showOverlay(_("LOADING") + "...");
                                    },
                                    onAfterLoad: function () {
                                        this.hideOverlay();
                                    },
                                },
                            },
                        },
                    ],
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "stt",
                        header: ["STT"],
                        //header: "",
                        sort: "int",
                        width: 40,
                        columnType: "nvarchar",
                        //css: { "line-height": "20px !important", "height": "63px !important"}
                    },
                    {
                        id: "ttthdon",

                        header: [
                            "Trạng thái",
                            {
                                content: "serverMultiSelectFilter",
                                options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00502",
                            },
                        ],
                        // template: function (obj, common) {
                        //     console.log(obj);
                        // },

                        // template: "<span class='mcls_status#tthdon#'>#ttthdon#</span>",

                        template: function (obj, common) {
                            console.log(obj.tthdon);
                            return "<span class='mcls_status" + obj.tthdon + "'>" + obj.ttthdon + "</span>";
                        },
                        width: 200,
                    },
                    {
                        id: "tthai",
                        header: ["Trạng thái gửi CQT", { content: "serverMultiSelectFilter", options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00504" }],
                        width: 200,
                    },
                    //
                    // {
                    //     id: "btnMessagetn",
                    //     header: ["<center>Lịch sử xử lý</center>"],
                    //     css: { "text-align": "center" },
                    //     template: function (obj) {
                    //         return "<span class='ShowHistory' style='color: #00b300'><i class='fa fa-eye'></i></span> ";
                    //     },
                    //     width: 180,
                    // },
                    // {
                    //     id: "issendmail",
                    //     header: ["<center>Gửi Email</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     checkValue: true, uncheckValue: false,
                    //     template: "{common.rcheckbox()}"
                    // },
                    // {
                    //     id: "error_status",
                    //     header: ["<center>Có lỗi/Không có lỗi</center>"],
                    //     css: { "text-align": "center" },
                    //     width: 120,
                    //     columnType: "nvarchar",
                    //     template: function (obj) {
                    //         if (obj.error_status == "1") {
                    //             return "<span style='color: #e83717'>Có lỗi</span> ";
                    //         } else {
                    //             return "";
                    //         }
                    //     }
                    // },
                    {
                        id: "nlap",
                        header: ["Ngày hóa đơn", { content: "serverDateRangeFilter" }],
                        width: 120,
                        css: { "text-align": "center" },
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        // template: function (obj, common) {
                        //     if(obj.tthai!="Chờ ký"){
                        //         return obj.nlap="";
                        //     }
                        //     else{
                        //         var format = webix.Date.dateToStr("%d/%m/%Y");
                        //         var text = removeTimeZoneT(obj.nlap);
                        //         return format(text);
                        //     }
                        // },
                        columnType: "datetime",
                    },
                    // {
                    //     id: "nky",
                    //     header: ["<center>Ngày ký</center>", { content: "serverDateRangeFilter" }],
                    //     width: 150,
                    //     css: { "text-align": "center" },
                    //     //format:webix.i18n.dateFormatStr
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    //     columnType: "datetime",
                    // },
                    {
                        id: "khieu",
                        header: ["Ký hiệu", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        columnType: "nvarchar",
                    },
                    {
                        id: "is_hdcma_str",
                        header: ["Tình trạng mã", { content: "textFilter" }],
                        width: 100,
                        css: { "text-align": "center" },
                        /*columnType: "integer",
                        template: function (obj) {
                            return obj.is_hdcma === 0 ? "Không mã" : obj.is_hdcma === 1 ? "Có mã" : "Không rõ tình trạng mã";
                        },*/
                    },
                    // {
                    //     id: "khieu", header: ["<center>Ký hiệu</center>", { content: "textFilter" }],
                    //     template: function (obj, common) {
                    //         return "<span class='mcls_status " + obj.className + "'>" + obj.ten_trang_thai + "</span>";
                    //     }, width: 100, columnType: "nvarchar"
                    // },
                    { id: "shdon", header: ["Số hóa đơn", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },

                    { id: "mst", header: ["Mã số thuế", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    // { id: "mtdiep_gui", header: ["<center>Mã thông điệp gửi đi</center>", { content: "textFilter" }], width: 350, columnType: "nvarchar" },
                    // { id: "mtdiep_cqt", header: ["<center>Mã thông điệp cơ quan thuế</center>", { content: "textFilter" }], width: 300, columnType: "nvarchar" },
                    { id: "mdvi", header: ["Đơn vị quản lý", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    { id: "ten_str", header: ["Tên đơn vị/ Tên người mua", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                    {
                        id: "tgtttbso_last",
                        header: ["Thành tiền sau thuế", { content: "textFilter" }],
                        width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tgtttbso_last == null ? 0 : fm(obj.tgtttbso_last);
                        },
                        columnType: "numeric",
                    },
                    { id: "htttoan", header: ["Hình thức TT", { content: "textFilter" }], width: 200, columnType: "nvarchar", css: { "text-align": "center" } },
                    // {
                    //     id: "tdlap",
                    //     header: ["<center>Thời điểm lập</center>", { content: "textFilter" }],
                    //     width: 200,
                    //     columnType: "nvarchar",
                    //     format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     },
                    // },
                    {
                        id: "nglap",
                        header: ["Người lập", { content: "textFilter" }],
                        width: 200,
                        columnType: "nvarchar",
                    },
                    // { id: "ten_loai", header: ["<center>Tên loại HĐ</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            dataCount = data.count;
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                webix.message("change page size to " + newv);
                                $$("pagerA").config.size = newv * 1;
                                var table = $$("invoiceViews");
                                table.define("datafetch", newv);
                                table.clearAll();
                                table.load(table.config.url);
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.$$("title").parse({ title: "Danh sách chờ ký", details: "Danh sách chờ ký" });
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
            // var table = $$("invoiceViews");
            // var url = {
            //     $proxy: true,
            //     load: function (view, callback, params) {
            //         console.log(view.config);
            //         console.log(callback);
            //         console.log(params);
            //         /*var windowno = app.path[1].params[0];
            //         var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

            //         if (params == null) {
            //             url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            //         }
            //         else {
            //             url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

            //             if (params.filter != null) {
            //                 var array = [];

            //                 for (var property in params.filter) {

            //                     var column = view.getColumnConfig(property);

            //                     if (column !== undefined) {
            //                         var item = {
            //                             columnName: property,
            //                             columnType: column.columnType,
            //                             value: params.filter[property]
            //                         };

            //                         array.push(item);
            //                     }
            //                 }

            //                 //console.log(JSON.stringify(array));
            //                 if (array.length > 0) {
            //                     url = url + "&filter=" + JSON.stringify(array);
            //                 }
            //                 else {
            //                     url = url + "&filter=null";
            //                 }

            //             }
            //             else {
            //                 url = url + "&filter=null";
            //             }
            //         }

            //         if (view.config.infoparam != null) {
            //             url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
            //         }
            //         else {
            //             url = url + "&infoparam=null";
            //         }

            //         var tlbParams = $$("tlbParams");

            //         if (tlbParams !== undefined) {
            //             var childViews = tlbParams.getChildViews();

            //             var parameters = [];

            //             for (var i = 0; i < childViews.length; i++) {
            //                 var child = childViews[i];

            //                 var id = child.config.id;
            //                 var value_field = child.config.value_field;

            //                 var item = {
            //                     columnName: value_field,
            //                     value: $$(id).getValue()
            //                 };

            //                 parameters.push(item);
            //             }

            //             url = url + "&tlbparam=" + JSON.stringify(parameters);

            //         }
            //         else {
            //             url = url + "&tlbparam=null";
            //         }*/

            //         //console.log(url);

            //         /* webix.ajax().bind(view)
            //             .get(url,function(text){
            //                 var json =JSON.parse(text);

            //                 this.clearAll();

            //                 if (!json.hasOwnProperty("error")){
            //                     this.parse(json.data,"json");
            //                 }
            //         }); */

            //         //webix.ajax(url, callback, view);

            //     }
            // };

            // table.define("url", url);
        },
    };
});

// var form = $$("window-form");
// var values = form.getValues();
// var currency = values["inv_currencyCode"];
// var table = $$(tableId);
// var selectedItem = table.getItem(rowId)
// //var selectedItem = table.getSelectedItem();
// var loai_dc = selectedItem.ma1 == null ? 0 : selectedItem.ma1;

// // Lấy phần thập phân ở danh mục ngoại tệ
// var table_decimalPlaces = {
//     inv_quantity: 0,
//     inv_TotalAmountWithoutVat: 0,
//     inv_vatAmount: 0,
//     inv_TotalAmount: 0
// }

// table.eachColumn(function (columnId) {
//     var a = columnId.toString();
//     if (a == "inv_quantity" || a == "inv_TotalAmountWithoutVat" || a == "inv_vatAmount" || a == "inv_TotalAmount") {
//         var b = table.getColumnConfig(a).numericConfig.decimalPlaces;
//         if (b != null) {
//             table_decimalPlaces[a] = b;
//         }

//     }
// });
// //End call dmnt

// if (loai_dc == 0) {

//     var inv_quantity = webix.rules.isNumber(selectedItem.inv_quantity) ? selectedItem.inv_quantity : 0;
//     var inv_unitPrice = webix.rules.isNumber(selectedItem.inv_unitPrice) ? selectedItem.inv_unitPrice : 0;
//     var inv_TotalAmountWithoutVat = webix.rules.isNumber(selectedItem.inv_TotalAmountWithoutVat) ? selectedItem.inv_TotalAmountWithoutVat : 0;
//     var inv_discountPercentage = webix.rules.isNumber(selectedItem.inv_discountPercentage) ? selectedItem.inv_discountPercentage : 0;
//     var inv_discountAmount = webix.rules.isNumber(selectedItem.inv_discountAmount) ? selectedItem.inv_discountAmount : 0;
//     var ma_thue = webix.rules.isNumber(selectedItem.ma_thue) ? selectedItem.ma_thue : 0;
//     if (ma_thue == -1) { ma_thue = 0; }
//     var inv_vatAmount = webix.rules.isNumber(selectedItem.inv_vatAmount) ? selectedItem.inv_vatAmount : 0;
//     var inv_TotalAmount = webix.rules.isNumber(selectedItem.inv_TotalAmount) ? selectedItem.inv_TotalAmount : 0;
//     var inv_exchangeRate = webix.rules.isNumber($$("inv_exchangeRate_inv_InvoiceAuth").getValue()) ? $$("inv_exchangeRate_inv_InvoiceAuth").getValue() : 0;

//     if (inv_quantity < 0) { inv_quantity = 0; }
//     if (inv_unitPrice < 0) { inv_unitPrice = 0; }
//     if (inv_TotalAmountWithoutVat < 0) { inv_TotalAmountWithoutVat = 0; }

//     if (columnId == "inv_quantity" || columnId == "inv_unitPrice" || columnId == "inv_TotalAmountWithoutVat" || columnId == "inv_TotalAmount" || columnId == "inv_discountPercentage" || columnId == "inv_discountAmount") {

//         if (inv_unitPrice > 0) {
//             inv_TotalAmountWithoutVat = (inv_quantity * inv_unitPrice).toFixed(table_decimalPlaces.inv_TotalAmountWithoutVat);//Update dòng 1
//         } else {
//             if (inv_TotalAmountWithoutVat > 0) {
//                 if (inv_quantity > 0) {
//                     inv_unitPrice = inv_TotalAmountWithoutVat / inv_quantity;
//                 }
//             } else {
//                 if (inv_TotalAmount > 0) {
//                     if (inv_TotalAmountWithoutVat <= 0) {
//                         inv_TotalAmountWithoutVat = (inv_TotalAmount / (1 + ma_thue / 100)).toFixed(table_decimalPlaces.inv_TotalAmountWithoutVat);// Update dòng 2
//                     }

//                     if (inv_quantity > 0) {
//                         inv_unitPrice = inv_TotalAmountWithoutVat / inv_quantity;
//                     }
//                 }
//             }
//         }

//         if (inv_discountPercentage < 0) { inv_discountPercentage = 0; }
//         if (inv_discountPercentage > 100) { inv_discountPercentage = 0; }

//         inv_discountAmount = inv_TotalAmountWithoutVat * inv_discountPercentage / 100;
//         if ((inv_discountAmount - inv_TotalAmountWithoutVat) > 0) {
//             inv_discountAmount = 0;
//         }
//         inv_vatAmount = ((inv_TotalAmountWithoutVat - inv_discountAmount) * ma_thue / 100).toFixed(table_decimalPlaces.inv_vatAmount);  // Update dòng 3
//         //if(inv_TotalAmount <= 0){
//         inv_TotalAmount = currency == "VND" ? Math.round(inv_TotalAmountWithoutVat - inv_discountAmount + parseFloat(inv_vatAmount)) : (inv_TotalAmountWithoutVat - inv_discountAmount + parseFloat(inv_vatAmount));
//         //}

//         selectedItem.inv_quantity = inv_quantity;
//         selectedItem.inv_unitPrice = inv_unitPrice;
//         selectedItem.inv_TotalAmountWithoutVat = inv_TotalAmountWithoutVat;
//         selectedItem.inv_discountPercentage = inv_discountPercentage;
//         selectedItem.inv_discountAmount = inv_discountAmount;
//         selectedItem.inv_vatAmount = inv_vatAmount;
//         selectedItem.inv_TotalAmount = inv_TotalAmount;
//         table.updateItem(selectedItem.id, selectedItem);
//     }


//     if (columnId == "inv_quantity" || columnId == "inv_unitPrice" || columnId == "inv_TotalAmountWithoutVat"
//         || columnId == "inv_discountPercentage" || columnId == "inv_discountAmount"
//         || columnId == "ma_thue" || columnId == "inv_vatAmount" || columnId == "inv_promotion"
//         || columnId == "inv_TotalAmount" || columnId == "check_giam_tru") {

//         var inv_TotalAmountWithoutVat = 0;
//         var inv_discountAmount = 0;
//         var inv_vatAmount = 0;
//         var inv_TotalAmount = 0;
//         var count = table.count();

//         for (var i = 0; i < count; i++) {
//             var rowIndex = table.getIdByIndex(i);
//             var record = table.getItem(rowIndex);

//             var check_giam_tru = record.hasOwnProperty("check_giam_tru") ? record.check_giam_tru : false;

//             if (record.hasOwnProperty("inv_TotalAmountWithoutVat")) {
//                 var value = record.inv_TotalAmountWithoutVat == null ? 0 : Number(record.inv_TotalAmountWithoutVat);
//                 value = check_giam_tru === true ? -1 * value : value;
//                 inv_TotalAmountWithoutVat = currency == "VND" ? Math.round(inv_TotalAmountWithoutVat + value) : inv_TotalAmountWithoutVat + value;
//             }

//             if (record.hasOwnProperty("inv_discountAmount")) {
//                 var value = record.inv_discountAmount == null ? 0 : Number(record.inv_discountAmount);
//                 inv_discountAmount = currency == "VND" ? Math.round(inv_discountAmount + value) : inv_discountAmount + value;
//             }

//             if (record.hasOwnProperty("inv_vatAmount")) {
//                 var value = record.inv_vatAmount == null ? 0 : Number(record.inv_vatAmount);
//                 value = check_giam_tru === true ? -1 * value : value;
//                 inv_vatAmount = currency == "VND" ? Math.round(inv_vatAmount + value) : inv_vatAmount + value;
//             }
//             if (record.hasOwnProperty("inv_TotalAmount")) {
//                 var value = record.inv_TotalAmount == null ? 0 : Number(record.inv_TotalAmount);
//                 value = check_giam_tru === true ? -1 * value : value;
//                 inv_TotalAmount = currency == "VND" ? Math.round(inv_TotalAmount + value) : inv_TotalAmount + value;
//             }
//         }


//         $$("inv_TotalAmountWithoutVat_inv_InvoiceAuth").setValue(inv_TotalAmountWithoutVat);
//         $$("inv_discountAmount_inv_InvoiceAuth").setValue(inv_discountAmount);
//         $$("inv_vatAmount_inv_InvoiceAuth").setValue(inv_vatAmount);
//         //$$("inv_TotalAmount_inv_InvoiceAuth").setValue(inv_TotalAmountWithoutVat - inv_discountAmount + inv_vatAmount);
//         $$("inv_TotalAmount_inv_InvoiceAuth").setValue(inv_TotalAmount);


//     }
// }
// else {
//     if (columnId == "inv_quantity" || columnId == "inv_unitPrice" || columnId == "inv_TotalAmountWithoutVat" || columnId == "inv_TotalAmount" || columnId == "inv_vatAmount" || columnId == "ma1" || columnId == "tieu_thuc") {

//         var inv_quantity = webix.rules.isNumber(selectedItem.inv_quantity) ? selectedItem.inv_quantity : 0;
//         var inv_unitPrice = webix.rules.isNumber(selectedItem.inv_unitPrice) ? selectedItem.inv_unitPrice : 0;
//         var inv_TotalAmountWithoutVat = webix.rules.isNumber(selectedItem.inv_TotalAmountWithoutVat) ? selectedItem.inv_TotalAmountWithoutVat : 0;
//         var inv_discountPercentage = webix.rules.isNumber(selectedItem.inv_discountPercentage) ? selectedItem.inv_discountPercentage : 0;
//         var inv_discountAmount = webix.rules.isNumber(selectedItem.inv_discountAmount) ? selectedItem.inv_discountAmount : 0;
//         var ma_thue = webix.rules.isNumber(selectedItem.ma_thue) ? selectedItem.ma_thue : 0;
//         if (ma_thue == -1) { ma_thue = 0; }
//         var inv_vatAmount = webix.rules.isNumber(selectedItem.inv_vatAmount) ? selectedItem.inv_vatAmount : 0;
//         var inv_TotalAmount = webix.rules.isNumber(selectedItem.inv_TotalAmount) ? selectedItem.inv_TotalAmount : 0;
//         var inv_itemName = selectedItem.inv_itemName;
//         var tieu_thuc = selectedItem.tieu_thuc == null ? "" : selectedItem.tieu_thuc;
//         if (inv_unitPrice > 0) {
//             inv_TotalAmountWithoutVat = inv_quantity * inv_unitPrice;
//         } else {
//             if (inv_TotalAmountWithoutVat > 0) {
//                 if (inv_quantity > 0) {
//                     inv_unitPrice = inv_TotalAmountWithoutVat / inv_quantity;
//                 }
//             } else {
//                 if (inv_TotalAmount > 0) {
//                     inv_TotalAmountWithoutVat = inv_TotalAmount / (1 + ma_thue / 100);
//                     if (inv_quantity > 0) {
//                         inv_unitPrice = inv_TotalAmountWithoutVat / inv_quantity;
//                     }
//                 }
//             }
//         }

//         inv_discountAmount = inv_TotalAmountWithoutVat * inv_discountPercentage / 100;
//         inv_vatAmount = (inv_TotalAmountWithoutVat - inv_discountAmount) * ma_thue / 100;
//         inv_TotalAmount = inv_TotalAmountWithoutVat - inv_discountAmount + inv_vatAmount;
//         if (loai_dc == -1) {
//             //selectedItem.inv_itemName =  "Điều chỉnh giảm " + tieu_thuc + " " + selectedItem.inv_itemName;
//             selectedItem.inv_TotalAmountWithoutVat = inv_TotalAmountWithoutVat * loai_dc;
//             selectedItem.inv_discountAmount = inv_discountAmount * loai_dc;
//             selectedItem.inv_vatAmount = inv_vatAmount * loai_dc;
//             selectedItem.inv_TotalAmount = inv_TotalAmount * loai_dc;
//             selectedItem.inv_unitPrice = inv_unitPrice;
//             selectedItem.inv_quantity = inv_quantity;
//         }
//         if (loai_dc == 1) {
//             //selectedItem.inv_itemName = "Điều chỉnh tăng " + tieu_thuc + " " + selectedItem.inv_itemName;
//             selectedItem.inv_TotalAmountWithoutVat = inv_TotalAmountWithoutVat < 0 ? inv_TotalAmountWithoutVat * -1 : inv_TotalAmountWithoutVat;
//             selectedItem.inv_discountAmount = inv_discountAmount < 0 ? inv_discountAmount * -1 : inv_discountAmount;
//             selectedItem.inv_vatAmount = inv_vatAmount < 0 ? inv_vatAmount * -1 : inv_vatAmount;
//             selectedItem.inv_TotalAmount = inv_TotalAmount < 0 ? inv_TotalAmount * -1 : inv_TotalAmount;
//             selectedItem.inv_unitPrice = inv_unitPrice < 0 ? inv_unitPrice * -1 : inv_unitPrice;
//             selectedItem.inv_quantity = inv_quantity < 0 ? inv_quantity * -1 : inv_quantity;
//         }
//         table.updateItem(selectedItem.id, selectedItem);
//     }


//     if (columnId == "inv_quantity" || columnId == "inv_unitPrice" || columnId == "inv_TotalAmountWithoutVat"
//         || columnId == "inv_discountPercentage" || columnId == "inv_discountAmount"
//         || columnId == "ma_thue" || columnId == "inv_vatAmount" || columnId == "inv_promotion" || columnId == "ma1" || columnId == "inv_TotalAmount") {

//         var inv_TotalAmountWithoutVat = 0;
//         var inv_discountAmount = 0;
//         var inv_vatAmount = 0;

//         var count = table.count();
//         for (var i = 0; i < count; i++) {
//             var rowIndex = table.getIdByIndex(i);
//             var record = table.getItem(rowIndex);

//             if (record.hasOwnProperty("inv_TotalAmountWithoutVat")) {
//                 var value = record.inv_TotalAmountWithoutVat == null ? 0 : Number(record.inv_TotalAmountWithoutVat);
//                 inv_TotalAmountWithoutVat = inv_TotalAmountWithoutVat + value;
//             }

//             if (record.hasOwnProperty("inv_discountAmount")) {
//                 var value = record.inv_discountAmount == null ? 0 : Number(record.inv_discountAmount);
//                 inv_discountAmount = inv_discountAmount + value;
//             }

//             if (record.hasOwnProperty("inv_vatAmount")) {
//                 var value = record.inv_vatAmount == null ? 0 : Number(record.inv_vatAmount);
//                 inv_vatAmount = inv_vatAmount + value;
//             }
//         }

//         if (loai_dc == -1) {
//             $$("inv_TotalAmountWithoutVat_inv_InvoiceAuth").setValue(inv_TotalAmountWithoutVat * loai_dc);
//             $$("inv_discountAmount_inv_InvoiceAuth").setValue(inv_discountAmount * loai_dc);
//             $$("inv_vatAmount_inv_InvoiceAuth").setValue(inv_vatAmount * loai_dc);
//             $$("inv_TotalAmount_inv_InvoiceAuth").setValue((inv_TotalAmountWithoutVat - inv_discountAmount + inv_vatAmount) * loai_dc);
//         }
//         if (loai_dc == 1) {
//             $$("inv_TotalAmountWithoutVat_inv_InvoiceAuth").setValue(inv_TotalAmountWithoutVat < 0 ? inv_TotalAmountWithoutVat * -1 : inv_TotalAmountWithoutVat);
//             $$("inv_discountAmount_inv_InvoiceAuth").setValue(inv_discountAmount < 0 ? inv_discountAmount * -1 : inv_discountAmount);
//             $$("inv_vatAmount_inv_InvoiceAuth").setValue(inv_vatAmount < 0 ? inv_vatAmount * -1 : inv_vatAmount);
//             var tongtien = inv_TotalAmountWithoutVat - inv_discountAmount + inv_vatAmount;
//             $$("inv_TotalAmount_inv_InvoiceAuth").setValue(tongtien < 0 ? tongtien * -1 : tongtien);
//         }
//     }

// }

// var data = table.serialize();
// var tien_tt_all = 0;
// var tien_thue_all = 0
// var tien_ck_all = 0;
// var tong_tien_all = 0

// var tien_tt_10 = 0;
// var tien_thue_10 = 0;
// var tien_ck_10 = 0;
// var tong_tien_10 = 0;

// var tien_tt_5 = 0;
// var tien_thue_5 = 0;
// var tien_ck_5 = 0;
// var tong_tien_5 = 0;

// var tien_tt_0 = 0;
// var tien_thue_0 = 0;
// var tien_ck_0 = 0;
// var tong_tien_0 = 0;

// var tien_tt_kct = 0;
// var tien_thue_kct = 0;
// var tien_ck_kct = 0;
// var tong_tien_kct = 0;

// var tien_tt_kkk = 0;
// var tien_thue_kkk = 0;
// var tien_ck_kkk = 0;
// var tong_tien_kkk = 0;

// data.forEach(function (entry) {
//     tien_tt_all += entry["inv_TotalAmountWithoutVat"] == null ? 0 : entry["inv_TotalAmountWithoutVat"];
//     tien_thue_all += entry["inv_vatAmount"] == null ? 0 : entry["inv_vatAmount"];
//     tien_ck_all += entry["inv_discountAmount"] == null ? 0 : entry["inv_discountAmount"];
//     tong_tien_all += entry["inv_TotalAmount"] == null ? 0 : entry["inv_TotalAmount"];

//     if (entry["ma_thue"] == 10) {
//         tien_tt_10 += entry["inv_TotalAmountWithoutVat"] == null ? 0 : entry["inv_TotalAmountWithoutVat"];
//         tien_thue_10 += entry["inv_vatAmount"] == null ? 0 : entry["inv_vatAmount"];
//         tien_ck_10 += entry["inv_discountAmount"] == null ? 0 : entry["inv_discountAmount"];
//         tong_tien_10 += entry["inv_TotalAmount"] == null ? 0 : entry["inv_TotalAmount"];
//     }
//     if (entry["ma_thue"] == 5) {
//         tien_tt_5 += entry["inv_TotalAmountWithoutVat"] == null ? 0 : entry["inv_TotalAmountWithoutVat"];
//         tien_thue_5 += entry["inv_vatAmount"] == null ? 0 : entry["inv_vatAmount"];
//         tien_ck_5 += entry["inv_discountAmount"] == null ? 0 : entry["inv_discountAmount"];
//         tong_tien_5 += entry["inv_TotalAmount"] == null ? 0 : entry["inv_TotalAmount"];
//     }
//     if (entry["ma_thue"] == 0) {
//         tien_tt_0 += entry["inv_TotalAmountWithoutVat"] == null ? 0 : entry["inv_TotalAmountWithoutVat"];
//         tien_thue_0 += entry["inv_vatAmount"] == null ? 0 : entry["inv_vatAmount"];
//         tien_ck_0 += entry["inv_discountAmount"] == null ? 0 : entry["inv_discountAmount"];
//         tong_tien_0 += entry["inv_TotalAmount"] == null ? 0 : entry["inv_TotalAmount"];
//     }
//     if (entry["ma_thue"] == -1) {
//         tien_tt_kct += entry["inv_TotalAmountWithoutVat"] == null ? 0 : entry["inv_TotalAmountWithoutVat"];
//         tien_thue_kct += entry["inv_vatAmount"] == null ? 0 : entry["inv_vatAmount"];
//         tien_ck_kct += entry["inv_discountAmount"] == null ? 0 : entry["inv_discountAmount"];
//         tong_tien_kct += entry["inv_TotalAmount"] == null ? 0 : entry["inv_TotalAmount"];
//     }
//     if (entry["ma_thue"] == -2) {
//         tien_tt_kkk += entry["inv_TotalAmountWithoutVat"] == null ? 0 : entry["inv_TotalAmountWithoutVat"];
//         tien_thue_kkk += entry["inv_vatAmount"] == null ? 0 : entry["inv_vatAmount"];
//         tien_ck_kkk += entry["inv_discountAmount"] == null ? 0 : entry["inv_discountAmount"];
//         tong_tien_kkk += entry["inv_TotalAmount"] == null ? 0 : entry["inv_TotalAmount"];
//     }

// });

// // $$("tgtcthue").setValue(tien_tt_all);
// $$("tgtcthue10_inv_InvoiceAuth").setValue(tien_tt_10);
// $$("tgtcthue5_inv_InvoiceAuth").setValue(tien_tt_5);
// $$("tgtcthue0_inv_InvoiceAuth").setValue(tien_tt_0);
// $$("tgtcthuekct_inv_InvoiceAuth").setValue(tien_tt_kct);
// $$("tgtcthuekkk_inv_InvoiceAuth").setValue(tien_tt_kkk);

// // $$("ttcktmai").setValue(tien_ck_all);
// $$("ttcktmai10_inv_InvoiceAuth").setValue(tien_ck_10);
// $$("ttcktmai5_inv_InvoiceAuth").setValue(tien_ck_5);
// $$("ttcktmai0_inv_InvoiceAuth").setValue(tien_ck_0);
// $$("ttcktmaikct_inv_InvoiceAuth").setValue(tien_ck_kct);
// $$("ttcktmaikkk_inv_InvoiceAuth").setValue(tien_ck_kkk);

// // $$("tgtthue").setValue(tien_thue_all);
// $$("tgtthue10_inv_InvoiceAuth").setValue(tien_thue_10);
// $$("tgtthue5_inv_InvoiceAuth").setValue(tien_thue_5);
// $$("tgtthue0_inv_InvoiceAuth").setValue(tien_thue_0);
// $$("tgtthuekct_inv_InvoiceAuth").setValue(tien_thue_kct);
// $$("tgtthuekkk_inv_InvoiceAuth").setValue(tien_thue_kkk);

// // $$("tgtttbso").setValue(tong_tien_all);
// $$("tgtttbso10_inv_InvoiceAuth").setValue(tong_tien_10);
// $$("tgtttbso5_inv_InvoiceAuth").setValue(tong_tien_5);
// $$("tgtttbso0_inv_InvoiceAuth").setValue(tong_tien_0);
// $$("tgtttbsokct_inv_InvoiceAuth").setValue(tong_tien_kct);
// $$("tgtttbsokkk_inv_InvoiceAuth").setValue(tong_tien_kkk);
define("views/aa1", function(){});

define('views/forms/account',["app", "locale"], function (app, _) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win", position: "center",
			head: "Người sử dụng",
			width: 550,
			height: 600,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 60 },
				view: "form",
				id: "dmtab-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						view: "text",
						name: "username",
						labelPosition: "top",
						disabled: true,
						required: false,
						label: "Tên truy cập",
						id: "dmtab-username",
						invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
						validate: webix.rules.isSpecialCharacter,
						css: "mcls_uppercase",
						on: {
							onChange: function (newv, oldv) {
								if (newv != undefined) {
									if (oldv != undefined) {
										if (newv.toUpperCase() != oldv.toUpperCase()) {
											webix.$$(this.config.id).setValue(newv.toUpperCase());
										}
									}
									else {
										webix.$$(this.config.id).setValue(newv.toUpperCase());
									}

								}

							}
						}
					},
					{
						view: "combo",
						name: "wb_role_id",
						label: "Nhóm quyền",
						options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00007",
						id: "dmtab-nhomquyen",
						labelPosition: "top",
						required: true,
						invalidMessage: "Bạn chưa chọn nhóm quyền"
					},
					/*{
						view: "combo",
						name: "store_code",
						label: "Cửa hàng",						
						options: {
							view: "gridsuggest",
							textValue: "value",
							body: {
								url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00052",
								textValue: "value",
								columns: [
									{
										id: "id",
										width: 120,
										header: _("MA")
									},
									{
										id: "value",
										width: 350,
										header: _("TEN")
									}
								]								
							}
						},
						id: "dmtab-store",
						labelPosition: "top",						
						invalidMessage: "Bạn chưa chọn cửa hàng"
					},*/
					{
						id: "cbBranchCode",
						view: "combo",
						name: "branch_code",
						label: "Đơn vị",
						options: {
							view: "treesuggest",
							textValue: "value",
							url: {
								$proxy: true,
								load: function (view, callback, params) {
									var url = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195";

									webix.ajax(url, function (text) {
										var json = JSON.parse(text);
										var data = listToTree(json);
										view.parse(data, "json");

										var branchCombo = $$("cbBranchCode");
										if (branchCombo) {
											var currentValue = branchCombo.getValue();
											if (currentValue) {
												var branchItem = view.getItem(currentValue);
												var show = branchItem && branchItem.is_multi_business_location === true;
												var ddkd = $$("dmtab-ddkd");
												if (ddkd) {
													show ? ddkd.show() : ddkd.hide();
												}
											}
										}
									});

								}
							},
							body: {
								textValue: "value",
								columns: [
									{
										id: "wb_branch_id",
										width: 120,
										header: _("MA"),
										hidden: true
									},
									{
										id: "name",
										width: 650,
										header: _("TEN"),
										template: "{common.space()}{common.icon()}#name#"
									}
								],
								filterMode: {
									level: false,
									showSubItems: false
								}
							}
						},
						//id: "dmtab-store",
						labelPosition: "top",
						required: true,
						invalidMessage: "Bạn chưa chọn đơn vị",
						on: {
							onChange: function (newv, oldv) {
								var show = false;
								if (newv) {
									var list = this.getList();
									if (list) {
										var item = list.getItem(newv);
										show = item && item.is_multi_business_location === true;
									}
								}
								var ddkd = $$("dmtab-ddkd");
								if (show) {
									ddkd.setValue("");
									ddkd.show();
								} else {
									ddkd.setValue("");
									ddkd.hide();
								}
							}
						}
					},
					{
						view: "combo",
						name: "pl_business_location_id",
						label: "Địa điểm kinh doanh (mặc định)",
						id: "dmtab-ddkd",
						labelPosition: "top",
						hidden: true,
						// required: true,
						//invalidMessage: "Bạn chưa chọn địa điểm kinh doanh"
						options: {
							view: "treesuggest",
							textValue: "value",
							body: {
								url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00099",
								columns: [
									{
										id: "code",
										width: 100,
										header: _("MA"),
									},
									{
										id: "name",
										width: 200,
										header: _("TEN"),
										template: "{common.space()}{common.icon()}#name#"
									},
									{
										id: "address",
										width: 250,
										header: _("DIA_CHI"),
									},
								],
								filterMode: {
									level: false,
									showSubItems: false
								}
							},
							on: {
								onBeforeShow: function () {
									var branchCode = $$("cbBranchCode") ? $$("cbBranchCode").getValue() : "";
									if (branchCode) {
										var url = app.config.host + "/System/GetDataReferencesByRefIdAndBranchCode?refId=RF00099&branchCode=" + encodeURIComponent(branchCode);
										var list = this.getList();
										list.clearAll();
										list.load(url);
									}
								}
							}
						}
					},
					{
						view: "radio",
						label: "",
						labelWidth: 150,
						id: "dmtab-register-type",
						name: "register_type",
						value: "0",
						options: [
							{ id: "0", value: "Đăng nhập bằng email" }, // the initially selected item
							{ id: "2", value: "Đăng nhập bằng email/SĐT" },
							{ id: "1", value: "Đăng nhập bằng SĐT" }
						],
						on: {
							onChange: function (newv, oldv) {
								if (newv !== undefined && newv !== null) {
									
									if (newv === "1") {
										$$("dmtab-phone-number").define("required", true); 
										
										var oldv = $$("dmtab-email").getValue();	
										var newv = "abc@abc.abc"       //hashcode  

										$$("dmtab-email").setValue(newv);
										$$("dmtab-email").validate();
										$$("dmtab-email").setValue(oldv);

										$$("dmtab-email").define("required", false); 
										$$("dmtab-email").define("validate", false); 

										$$("dmtab-phone-number").refresh();
										$$("dmtab-email").refresh();

										//Set dmtab-username
										if(editmode != "2")
										{
											webix.$$("dmtab-username").setValue($$("dmtab-phone-number").getValue().toUpperCase());
											$$("dmtab-username").refresh();
										}
									}
									else if (newv === "2") {
										$$("dmtab-phone-number").define("required", true);
										//$$("dmtab-phone-number").define("validate", webix.rules.isNumber); 
										$$("dmtab-email").define("required", true); 
										$$("dmtab-email").define("validate", webix.rules.isEmail); 

										$$("dmtab-phone-number").refresh();
										$$("dmtab-email").refresh();

										//Set dmtab-username
										if(editmode != "2")
										{
											webix.$$("dmtab-username").setValue($$("dmtab-email").getValue().toUpperCase());
											$$("dmtab-username").refresh();
										}										
									}
									else {
										$$("dmtab-email").define("required", true); 
										$$("dmtab-email").define("validate", webix.rules.isEmail); 

										var oldv = $$("dmtab-phone-number").getValue();	
										var newv = "123456"       //hashcode  

										$$("dmtab-phone-number").setValue(newv);
										$$("dmtab-phone-number").validate();
										$$("dmtab-phone-number").setValue(oldv);

										$$("dmtab-phone-number").define("required", false); 
										$$("dmtab-phone-number").define("validate", false); 

										$$("dmtab-phone-number").refresh();
										$$("dmtab-email").refresh();

										//Set dmtab-username
										if(editmode != "2")
										{
											webix.$$("dmtab-username").setValue($$("dmtab-email").getValue().toUpperCase());
											$$("dmtab-username").refresh();
										}
									}
								}
							},
						},
					},
					{
						view: "text",
						name: "email",
						required: true,
						labelPosition: "top",
						label: "Email",
						id: "dmtab-email",
						validate: webix.rules.isEmail,
						invalidMessage: "Email không được để trống hoặc không đúng định dạng",
						on: {
							onChange: function (newv, oldv) {
								if (editmode != "2" && webix.$$("dmtab-register-type").getValue() != 1) {
									if (newv != undefined) {
										if (oldv != undefined) {
											if (newv.toUpperCase() != oldv.toUpperCase()) {
												webix.$$("dmtab-username").setValue(newv.toUpperCase());
											}
										}
										else {
											webix.$$("dmtab-username").setValue(newv.toUpperCase());
										}

									}
								}

							}
						}
					},
					{
						view: "text",
						name: "phone_number",
						required: false,
						labelPosition: "top",
						label: "Số điện thoại",
						id: "dmtab-phone-number",
						invalidMessage: "Số điện thoại không được để trống",
						on: {
							onChange: function (newv, oldv) {
								if (editmode != "2" && webix.$$("dmtab-register-type").getValue() == 1) {
									if (newv != undefined) {
										if (oldv != undefined) {
											if (newv.toUpperCase() != oldv.toUpperCase()) {
												webix.$$("dmtab-username").setValue(newv.toUpperCase());
											}
										}
										else {
											webix.$$("dmtab-username").setValue(newv.toUpperCase());
										}

									}
								}

							}
						}
					},
					{
						view: "text",
						name: "fullname",
						required: true,
						labelPosition: "top",
						label: "Tên người sử dụng",
						id: "dmtab-fullname",
						//validate: webix.rules.isEmail,
						invalidMessage: "Tên người sử dụng không được để trống"
					},
					/* {
								view:"checkbox",
								id:"dmtab-issigninvoice",
								name:"issigninvoice",
								label:"Ký hóa đơn",
								checkValue:"C",
								uncheckValue:"K" ,
								labelWidth:85
					},
					{
						view:"fieldset",
						label:"Quyền truy cập",
						body:{
							cols:[
								{
									view:"checkbox",
									id:"dmtab-isviewuser",
									name:"isviewuser",
									label:"Xem",
									checkValue:"C",
									uncheckValue:"K" 
								},
								{
								view:"checkbox",
								id:"dmtab-isedituser",
								name:"isedituser",
								label:"Sửa",
								checkValue:"C",
								uncheckValue:"K" 
								},
								{
									view:"checkbox",
									id:"dmtab-isdeluser",
									name:"isdeluser",
									label:"Xóa",
									checkValue:"C",
									uncheckValue:"K" 
								}
							]
						}
					}, */
					{ view: "textarea", name: "dien_giai", labelPosition: "top", label: "Diễn giải", id: "dmtab-diengiai" },

					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Lưu (F10)", type: "form", align: "center",
								on: {
									onClick: function () {
										var form = webix.$$("dmtab-form");

										if (form.validate() == false) {
											return;
										}
										var item = form.getValues();
										item.window_type = "account";
										item.email_sso = item.email;
										var url = app.config.host + "/Account/Update";
										webix.extend(form, webix.ProgressBar);
										form.disable();
										form.showProgress();
										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(url, item, function (text) {
												var data = JSON.parse(text);

												form.enable();
												form.hideProgress();
												if (!data.hasOwnProperty("error")) {
													item.id = data.id;
													webix.$$("dmtab-win").close();
													app.callEvent("dataChanged", [editmode, data.item]);
												}
												else {
													webix.message({ type: "error", text: data.error });
												}
											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center",
								click: function () {
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		},
		applyBranchVisibility: function (item) {
			if (!item) {
				$$("dmtab-ddkd").hide();
				return;
			}
			var show = item.is_multi_business_location === true;
			show ? $$("dmtab-ddkd").show() : $$("dmtab-ddkd").hide();
		}
	};

});
﻿define('views/forms/account_hsm',["app", "locale"], function (app, _) {
    var editmode = 0;

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "accountHSM-win",
            position: "center",
            head: "Người sử dụng",
            width: 500,
            height: 480,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 60 },
                view: "form",
                id: "accountHSM-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        id: "user_hsm_id",
                        view: "text",
                        label: "Mã UUID",
                        labelPosition: "top",
                        required: true,
                        name: "user_hsm_id",
                        css:"mcls_uppercase",
                        invalidMessage: "Mã UUID không được để trống",
                    },
                    {
                        view: "text",
                        type: "password",
                        name: "password_level2",
                        required: true,
                        labelPosition: "top",
                        label: "Mật khẩu",
                        id: "accountHSM-password_level2",
                        //validate: webix.rules.isEmail,
                        invalidMessage: "Mật khẩu không được để trống",
                    },

                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Lưu (F10)",
                                type: "form",
                                align: "center",
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("accountHSM-form");
                                        var table = webix.$$("dmwindowData");
                                        var itemData = table.getSelectedItem();
                                        if (form.validate() == false) {
                                            return;
                                        }

                                        var item = form.getValues();
                                        item.wb_user_id = itemData.wb_user_id;
                                        item.window_type = "account";

                                        var url = app.config.host + "/Account/Update_HSM";
                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();
                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(url, item, function (text) {
                                                var data = JSON.parse(text);

                                                form.enable();
                                                form.hideProgress();
                                                if (!data.hasOwnProperty("error")) {
                                                    item.id = data.id;
                                                    webix.$$("accountHSM-win").close();
                                                    webix.message("Lưu thành công", "success");
                                                    // app.callEvent("dataChanged", [editmode, data.item]);
                                                } else {
                                                    webix.message({ type: "error", text: data.error });
                                                }
                                            });
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },

                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy (ESC)",
                                type: "danger",
                                align: "center",
                                click: function () {
                                    webix.$$("accountHSM-win").close();
                                },
                            },
                            {
                                id: "huyUserHSM",
                                shortcut: "F8",
                                view: "button",
                                label: "Xóa (F8)",
                                type: "delete",
                                align: "center",
                                hidden: true,
                                on: {
                                    onClick: function () {
                                        webix.confirm({
                                            text: "Bạn chắc chắn muốn xóa tài khoản HSM?",
                                            ok: "Có",
                                            cancel: "Không",
                                            callback: function (res) {
                                                if (res) {
                                                    var form = webix.$$("accountHSM-form");
                                                    var table = webix.$$("dmwindowData");
                                                    var itemData = table.getSelectedItem();

                                                    var item = { wb_user_id: itemData.wb_user_id };

                                                    var url = app.config.host + "/Account/Delete_HSM";
                                                    webix.extend(form, webix.ProgressBar);
                                                    form.disable();
                                                    form.showProgress();
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(url, item, function (text) {
                                                            var data = JSON.parse(text);

                                                            form.enable();
                                                            form.hideProgress();
                                                            if (!data.hasOwnProperty("error")) {
                                                                item.id = data.id;
                                                                webix.$$("accountHSM-win").close();
                                                                webix.message("Xóa thành công", "success");
                                                                // app.callEvent("dataChanged", [editmode, data.item]);
                                                            } else {
                                                                webix.message({ type: "error", text: data.error });
                                                            }
                                                        });
                                                }
                                            },
                                        });
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        // setEditMode: function (mode) {
        // 	editmode = mode;
        // }
    };
});

define('views/forms/accountpermission',["app", "locale"], function (app, _) {
    function initUI(item) {
        var url = app.config.host + "/System/ExecuteCommand";

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00005",
                    parameter: {
                        wb_user_id: item.id,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);

                    var dtChuKySo = $$("dtChuKySo");

                    dtChuKySo.parse(json, "json");
                }
            );

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00006",
                    parameter: {
                        wb_user_id: item.id,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);
                    var dtMauHoaDon = $$("dtMauHoaDon");

                    dtMauHoaDon.parse(json, "json");

                    /* for(var i=0;i<json.length;i++){
                    var item = json[i];
	
                    if (item.VC_NHOMQUYEN_id!=null){
                        trtBaoCao.checkItem(item.id);
                    }
                } */
                }
            );

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM000100",
                    parameter: {
                        wb_user_id: item.id,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);
                    var dtMauHoaDon = $$("dtMauHoaDon68");

                    dtMauHoaDon.parse(json, "json");

                    /* for(var i=0;i<json.length;i++){
                    var item = json[i];
	
                    if (item.VC_NHOMQUYEN_id!=null){
                        trtBaoCao.checkItem(item.id);
                    }
                } */
                }
            );

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00008",
                    parameter: {
                        wb_user_id: item.id,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);
                    var dtDonvi = $$("dtDonvi");

                    dtDonvi.parse(json, "json");
                }
            );
        var is_new_user = item.is_new_user == null ? "C" : item.is_new_user;

        $$("chkIssigninvoice").setValue(item.is_sign_invoice);
        $$("chkIssigninvoicehsm").setValue(item.is_sign_invoice_hsm);
        $$("chkIsviewuser").setValue(item.is_view_user);
        $$("chkIsedituser").setValue(item.is_edit_user);
        $$("chkIsdeluser").setValue(item.is_del_user);
        $$("chkIsnewuser").setValue(is_new_user);
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "phanquyen-win",
            position: "center",
            head: "Thông tin Tab",
            fullscreen: true,
            body: {
                rows: [
                    {
                        borderless: true,
                        view: "tabview",
                        scrollX: true,
                        multiview: {
                            fitBiggest: true,
                        },
                        cells: [
                            {
                                header: _("CHU_KY_SO"),
                                body: {
                                    id: "dtChuKySo",
                                    view: "datatable",
                                    resizeRow: true,
                                    fixedRowHeight: false,
                                    rowLineHeight: 25,
                                    rowHeight: 70,
                                    //threeState: true,
                                    columns: [
                                        {
                                            id: "chon1",
                                            header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
                                            width: 55,
                                            checkValue: "C",
                                            uncheckValue: "K",
                                            template: "{common.checkbox()}",
                                        },
                                        {
                                            id: "cer_serial",
                                            header: _("SO_SERIAL"),
                                            width: 280,
                                        },
                                        {
                                            id: "subject_name",
                                            header: "Chủ thể",
                                            width: 500,
                                        },
                                        {
                                            id: "begin_date",
                                            header: "Ngày bắt đầu",
                                            width: 150,
                                        },
                                        {
                                            id: "end_date",
                                            header: "Ngày kết thúc",
                                            width: 150,
                                        },
                                        {
                                            id: "cert_type",
                                            header: "Loại chữ ký",
                                            width: 150,
                                        },
                                    ],
                                },
                            },
                            {
                                header: _("MAU_HDON"),
                                body: {
                                    id: "dtMauHoaDon",
                                    view: "datatable",
                                    scheme: {
                                        $init: function (obj) {
                                            //creating fake dates for the sample
                                            obj.date = new Date(obj.ngay_bd_sd);
                                        },
                                    },
                                    columns: [
                                        {
                                            id: "chon1",
                                            header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
                                            width: 55,
                                            checkValue: "C",
                                            uncheckValue: "K",
                                            template: "{common.checkbox()}",
                                        },
                                        {
                                            id: "ma_loai",
                                            header: [_("MA_LOAI"), { content: "textFilter" }],
                                            width: 100,
                                        },
                                        {
                                            id: "ten_loai",
                                            header: [_("TEN_LOAI"), { content: "textFilter" }],
                                            width: 250,
                                        },
                                        {
                                            id: "mau_so",
                                            header: [_("MAU_SO"), { content: "textFilter" }],
                                            width: 100,
                                        },
                                        {
                                            id: "ky_hieu",
                                            header: [_("KY_HIEU"), { content: "textFilter" }],
                                            width: 100,
                                        },
                                        {
                                            id: "tu_so",
                                            header: [_("TU_SO"), { content: "textFilter" }],
                                            width: 100,
                                        },
                                        {
                                            id: "den_so",
                                            header: [_("DEN_SO"), { content: "textFilter" }],
                                            width: 100,
                                        },
                                        {
                                            id: "date",
                                            header: [_("NGAY_BD_SD"), { content: "dateRangeFilter" }],
                                            width: 150,
                                            format: function (text) {
                                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                                text = removeTimeZoneT(text);
                                                return format(text);
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                header: _("Mẫu hóa đơn NĐ123"),
                                body: {
                                    id: "dtMauHoaDon68",
                                    view: "datatable",
                                    scheme: {
                                        $init: function (obj) {
                                            //creating fake dates for the sample
                                            //obj.date = new Date(obj.ngay_bd_sd);
                                        },
                                    },
                                    columns: [
                                        {
                                            id: "chon1",
                                            header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
                                            width: 55,
                                            checkValue: "C",
                                            uncheckValue: "K",
                                            template: "{common.checkbox()}",
                                        },
                                        {
                                            id: "lhdon",
                                            header: [_("Loại hóa đơn"), { content: "textFilter" }],
                                            width: 140,
                                        },
                                        {
                                            id: "hthuc",
                                            header: [_("Hình thức"), { content: "textFilter" }],
                                            width: 250,
                                        },
                                        {
                                            id: "khdon",
                                            header: [_("Kiểu hóa đơn"), { content: "textFilter" }],
                                            width: 140,
                                        },
                                        {
                                            id: "khhdon",
                                            header: [_("KY_HIEU"), { content: "textFilter" }],
                                            width: 100,
                                        },
                                    ],
                                },
                            },
                            {
                                header: _("DONVI"),
                                hidden: true,
                                body: {
                                    id: "dtDonvi",
                                    view: "datatable",
                                    columns: [
                                        {
                                            id: "chon1",
                                            header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
                                            width: 55,
                                            checkValue: "C",
                                            uncheckValue: "K",
                                            template: "{common.checkbox()}",
                                        },
                                        {
                                            id: "ma_dvcs",
                                            header: _("MA"),
                                            width: 100,
                                        },
                                        {
                                            id: "ten_dvcs",
                                            header: _("TEN"),
                                            width: 450,
                                        },
                                    ],
                                },
                            },
                            {
                                header: _("QUYEN_TRUY_CAP_HD"),
                                body: {
                                    paddingY: 10,
                                    paddingX: 10,
                                    rows: [
                                        {
                                            id: "chkIssigninvoice",
                                            view: "checkbox",
                                            name: "issigninvoice",
                                            labelRight: _("KY_HOA_DON"),
                                            checkValue: "C",
                                            uncheckValue: "K",
                                            labelWidth: 0,
                                        },
                                        {
                                            id: "chkIssigninvoicehsm",
                                            view: "checkbox",
                                            name: "issigninvoicehsm",
                                            labelRight: _("KY_HOA_DON_HSM"),
                                            checkValue: "C",
                                            uncheckValue: "K",
                                            labelWidth: 0
                                        },
                                        {
                                            id: "chkIsviewuser",
                                            view: "checkbox",
                                            name: "isviewuser",
                                            labelRight: _("IS_VIEW_USER"),
                                            checkValue: "C",
                                            uncheckValue: "K",
                                            labelAlign: "right",
                                            labelWidth: 0,
                                        },
                                        {
                                            id: "chkIsnewuser",
                                            view: "checkbox",
                                            name: "isnewuser",
                                            labelRight: _("IS_NEW_USER"),
                                            checkValue: "C",
                                            uncheckValue: "K",
                                            labelWidth: 0,
                                        },
                                        {
                                            id: "chkIsedituser",
                                            view: "checkbox",
                                            name: "isedituser",
                                            labelRight: _("IS_EDIT_USER"),
                                            checkValue: "C",
                                            uncheckValue: "K",
                                            labelWidth: 0,
                                        },
                                        {
                                            id: "chkIsdeluser",
                                            view: "checkbox",
                                            name: "isdeluser",
                                            labelRight: _("IS_DEL_USER"),
                                            checkValue: "C",
                                            uncheckValue: "K",
                                            labelWidth: 0,
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Lưu (F10)",
                                type: "form",
                                align: "center",
                                width: 100,
                                on: {
                                    onClick: function () {
                                        var dtChuKySo = $$("dtChuKySo");
                                        var dtMauHoaDon = $$("dtMauHoaDon");
                                        var dtMauHoaDon68 = $$("dtMauHoaDon68");
                                        var dtDonvi = $$("dtDonvi");

                                        var win = this.getTopParentView();
                                        webix.extend(win, webix.ProgressBar);
                                        win.disable();
                                        win.showProgress();
                                        var data = {
                                            wb_user_id: win.config.wb_user_id,
                                            ckspermission: dtChuKySo.serialize(),
                                            invtemppermission: dtMauHoaDon.serialize(),
                                            dtMauHoaDon68: dtMauHoaDon68.serialize(),
                                            //dvpermission: dtDonvi.serialize(),
                                            invoicepermission: {
                                                issigninvoice: $$("chkIssigninvoice").getValue(),
                                                issigninvoicehsm: $$("chkIssigninvoicehsm").getValue(),
                                                isviewuser: $$("chkIsviewuser").getValue(),
                                                isedituser: $$("chkIsedituser").getValue(),
                                                isdeluser: $$("chkIsdeluser").getValue(),
                                                isnewuser: $$("chkIsnewuser").getValue(),
                                            },
                                        };

                                        var url = app.config.host + "/Account/Phanquyen";

                                        webix
                                            .ajax()
                                            .bind(data)
                                            .headers({ "Content-type": "application/json" })
                                            .post(url, data, function (text) {
                                                var result = JSON.parse(text);

                                                if (!result.hasOwnProperty("error")) {
                                                    var table = webix.$$("dmwindowData");
                                                    var item = table.getSelectedItem();

                                                    item.is_sign_invoice = this.invoicepermission.issigninvoice;
                                                    item.is_sign_invoice_hsm = this.invoicepermission.issigninvoicehsm;
                                                    item.is_view_user = this.invoicepermission.isviewuser;
                                                    item.is_edit_user = this.invoicepermission.isedituser;
                                                    item.is_del_user = this.invoicepermission.isdeluser;
                                                    item.is_new_user = this.invoicepermission.isnewuser;

                                                    table.updateItem(item.id, item);
                                                    win.enable();
                                                    win.hideProgress();
                                                    webix.$$("phanquyen-win").close();
                                                } else {
                                                    webix.message({ type: "error", text: result.error });
                                                    win.enable();
                                                    win.hideProgress();
                                                }
                                            });
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                shortcut: "esc",
                                type: "danger",
                                label: "Hủy bỏ (ESC)",
                                align: "center",
                                width: 100,
                                on: {
                                    onClick: function () {
                                        this.getTopParentView().close();
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {},
                        ],
                    },
                    {
                        height: 5,
                    },
                ],
            },
        },
        initUI: initUI,
    };
});

define('views/account',["app", "views/forms/account", "views/forms/account_hsm", "locale", "views/forms/accountpermission", "models/user"], function (app, dmwindowform, account_hsm, _, accountpermission, user) {
    

    var op = [];

    webix.$$("title").parse({ title: "Người sử dụng", details: "Danh mục người sử dụng" });

    var controls = [
        {
            id: "btnPlus",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: _("THEM") + " (F4)",
            width: 100,
            css: "webix_secondary",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmwindowform.$ui);
                    dmwindowform.setEditMode(1);
                    $$("dmtab-email").enable();
                    $$("dmtab-register-type").enable();
                    $$("dmtab-phone-number").enable();
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
            label: _("SUA") + " (F3)",
            width: 90,
            css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    dmwindowform.setEditMode(2);
                    var form = webix.$$("dmtab-form");
                    var currentUser = user.getCurrentUser();
                    if (currentUser && currentUser.toUpperCase() === "ADMINISTRATOR") {
                        $$("dmtab-email").enable();
                    } else {
                        $$("dmtab-email").disable();
                    }
                    $$("dmtab-register-type").disable();
                    $$("dmtab-phone-number").disable();
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item.username == "ADMINISTRATOR") {
                        webix.message("Bạn không được phép sửa tài khoản này !", "error");
                        return;
                    }

                    form.setValues(item);

                    
                    detailForm.show();

                    var cb = $$("cbBranchCode");
                    cb.define("readonly", true);
                    cb.refresh();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "icon",
            icon: "fas fa-trash-o",
            label: _("XOA") + " (F8)",
            width: 90,
            css: "webix_secondary",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item.username == "ADMINISTRATOR") {
                        webix.message("Bạn không được phép xóa tài khoản này !", "error");
                        return;
                    }

                    item.window_type = "account";

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.username,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Account/Delete", item, function (text, xml, xhr) {
                                        var json = JSON.parse(text);
                                        if (json.hasOwnProperty("error")) {
                                            webix.message(json.error, "debug");
                                            return;
                                        }
                                        table.remove(item.id);
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnPhanQuyen",
            view: "button",
            type: "icon",
            icon: "fas fa-lock",
            label: _("PHAN_QUYEN"),
            width: 100,
            css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn người sử dụng", "error");
                        return;
                    }

                    var win = this.$scope.ui(accountpermission.$ui);
                    win.config.wb_user_id = item.id;
                    accountpermission.initUI(item);
                    win.getHead().setHTML("Người sử dụng: " + item.username);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnCreateUserHSM",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: "Thêm/Sửa User HSM",
            width: 150,
            css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn người sử dụng", "error");
                        return;
                    }
                    var win = this.$scope.ui(account_hsm.$ui);

                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Account/GetUserHsmById?wb_user_id=" + item.wb_user_id, function (res) {
                            var json = JSON.parse(res);
                            if (json.length > 0) {
                                var form = webix.$$("accountHSM-form");
                                form.setValues(json[0]);
                                $$("huyUserHSM").show();
                            } else {
                                var form = webix.$$("accountHSM-form");
                            }
                        });

                    // var form = webix.$$("accountHSM-form");
                    // form.setValues(item);

                    // dmwindowform.setEditMode(1);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                url: app.config.host + "/Account/AllUsersByBranch",
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                },
                columns: [
                    {
                        id: "username",
                        header: ["Tên truy cập", { content: "textFilter" }],
                        width: 150,
                    },
                    {
                        id: "wb_role_id",
                        view: "combo",
                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00007",
                        header: ["Nhóm quyền", { content: "selectFilter" }],
                        width: 250,
                    },
                    {
                        id: "email",
                        header: ["Email", { content: "textFilter" }],
                        width: 200,
                    },
                    {
                        id: "fullname",
                        header: ["Tên người sử dụng", { content: "textFilter" }],
                        width: 200,
                    },
                    {
                        id: "is_sign_invoice",
                        header: [
                            "Ký hóa đơn",
                            {
                                content: "selectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "C", value: "C" },
                                    { id: "K", value: "K" },
                                ],
                            },
                        ],
                        width: 100,
                    },
                    {
                        id: "is_sign_invoice_hsm",
                        header: [
                            "Ký hóa đơn HSM",
                            {
                                content: "selectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "C", value: "C" },
                                    { id: "K", value: "K" },
                                ],
                            },
                        ],
                        width: 140,
                    },
                    {
                        id: "is_view_user",
                        header: [
                            "Xem",
                            {
                                content: "selectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "C", value: "C" },
                                    { id: "K", value: "K" },
                                ],
                            },
                        ],
                        width: 60,
                    },
                    {
                        id: "is_new_user",
                        header: [
                            "Mới",
                            {
                                content: "selectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "C", value: "C" },
                                    { id: "K", value: "K" },
                                ],
                            },
                        ],
                        width: 60,
                    },
                    {
                        id: "is_edit_user",
                        header: [
                            "Sửa",
                            {
                                content: "selectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "C", value: "C" },
                                    { id: "K", value: "K" },
                                ],
                            },
                        ],
                        width: 60,
                    },
                    {
                        id: "is_del_user",
                        header: [
                            "Xóa",
                            {
                                content: "selectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "C", value: "C" },
                                    { id: "K", value: "K" },
                                ],
                            },
                        ],
                        width: 60,
                    },
                    {
                        id: "explanation",
                        header: ["Diễn giải", { content: "textFilter" }],
                        width: 350,
                        hidden: true,
                    },
                    {
                        id: "store_code",
                        header: ["Mã cửa hàng", { content: "textFilter" }],
                        width: 150,
                        hidden: true,
                    },
                    {
                        id: "branch_code",
                        header: ["Chi nhánh", { content: "textFilter" }],
                        width: 150,
                    },
                    {
                        id: "is_sso",
                        header: ["Đang liên kết SSO", {
                            content: "selectFilter",
                            options: [
                                { id: "", value: "" },
                                { id: 1, value: "Có" },
                                { id: 0, value: "Không" },
                            ],
                        },],
                        width: 150,
                        template: function (obj) {
                            return obj.is_sso == 1 ? "Có" : "Không"
                        }
                    },
                    {
                        id: "email_sso",
                        header: ["Email liên kết SSO", { content: "textFilter" }],
                        width: 200,
                    },
                    {
                        id: "phone_number",
                        header: ["Số điện thoại", { content: "textFilter" }],
                        width: 200,
                    }
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                view: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    debugger;
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
                table.refresh();
            });
        },
    };
});

define('views/forms/accountbranch',["app","locale"], function (app,_) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win", position: "center",
			head: "Người sử dụng",
			width: 500,
			height: 480,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 60 },
				view: "form",
				id: "dmtab-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						view: "text",
						name: "username",
						labelPosition: "top",
						required: true,
						label: "Tên truy cập",
						id: "dmtab-username",
						invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
						validate: webix.rules.isSpecialCharacter,
						css: "mcls_uppercase",
						on: {
							onChange: function (newv, oldv) {
								if (newv != undefined) {
									if (oldv != undefined) {
										if (newv.toUpperCase() != oldv.toUpperCase()) {
											webix.$$(this.config.id).setValue(newv.toUpperCase());
										}
									}
									else {
										webix.$$(this.config.id).setValue(newv.toUpperCase());
									}

								}

							}
						}
					},
					{
						view: "combo",
						name: "wb_role_id",
						label: "Nhóm quyền",
						options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00190",
						id: "dmtab-nhomquyen",
						labelPosition: "top",
						required: true,
						invalidMessage: "Bạn chưa chọn nhóm quyền"
					},
					{
						view: "combo",
						name: "store_code",
						label: "Cửa hàng",						
						options: {
							view: "gridsuggest",
							textValue: "value",
							body: {
								url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00052",
								textValue: "value",
								columns: [
									{
										id: "id",
										width: 120,
										header: _("MA")
									},
									{
										id: "value",
										width: 350,
										header: _("TEN")
									}
								]								
							}
						},							
						id: "dmtab-store",
						labelPosition: "top",						
						invalidMessage: "Bạn chưa chọn cửa hàng"
					},
					{
						view: "text",
						name: "email",
						required: true,
						labelPosition: "top",
						label: "Email",
						id: "dmtab-email",
						validate: webix.rules.isEmail,
						invalidMessage: "Email không được để trống hoặc không đúng định dạng"
					},
					{
						view: "text",
						name: "fullname",
						required: true,
						labelPosition: "top",
						label: "Tên người sử dụng",
						id: "dmtab-fullname",
						//validate: webix.rules.isEmail,
						invalidMessage: "Tên người sử dụng không được để trống"
					},
					/* {
								view:"checkbox",
								id:"dmtab-issigninvoice",
								name:"issigninvoice",
								label:"Ký hóa đơn",
								checkValue:"C",
								uncheckValue:"K" ,
								labelWidth:85
					},
					{
						view:"fieldset",
						label:"Quyền truy cập",
						body:{
							cols:[
								{
									view:"checkbox",
									id:"dmtab-isviewuser",
									name:"isviewuser",
									label:"Xem",
									checkValue:"C",
									uncheckValue:"K" 
								},
								{
								view:"checkbox",
								id:"dmtab-isedituser",
								name:"isedituser",
								label:"Sửa",
								checkValue:"C",
								uncheckValue:"K" 
								},
								{
									view:"checkbox",
									id:"dmtab-isdeluser",
									name:"isdeluser",
									label:"Xóa",
									checkValue:"C",
									uncheckValue:"K" 
								}
							]
						}
					}, */
					{ view: "textarea", name: "dien_giai", labelPosition: "top", label: "Diễn giải", id: "dmtab-diengiai" },

					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Lưu (F10)", type: "form", align: "center",
								on: {
									onClick: function () {
										var form = webix.$$("dmtab-form");

										if (form.validate() == false) {
											return;
										}

										var item = form.getValues();
										item.window_type = "accountbranch";

										var url = app.config.host + "/Account/Update";
										webix.extend(form, webix.ProgressBar);
										form.disable();
										form.showProgress();
										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(url, item, function (text) {
												var data = JSON.parse(text);
												form.enable();
												form.hideProgress();
												if (!data.hasOwnProperty("error")) {
													item.id = data.id;
													webix.$$("dmtab-win").close();
													app.callEvent("dataChanged", [editmode, item]);
												}
												else {
													webix.message({ type: "error", text: data.error });
												}
											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center",
								click: function () {
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/forms/branchpermission',["app", "locale"], function (app, _) {

	function initUI(item) {

		var url = app.config.host + "/System/ExecuteCommand";

		webix.ajax()
			.headers({ 'Content-type': 'application/json' })
			.post(url,
			{
				command: "CM00095",
				parameter: {
					wb_user_id: item.id
				}
			}
			, function (text) {

				var json = JSON.parse(text);

				var dtChuKySo = $$("dtChuKySo");

				dtChuKySo.parse(json, "json");



			});

		webix.ajax()
			.headers({ 'Content-type': 'application/json' })
			.post(url,
			{
				command: "CM00096",
				parameter: {
					wb_user_id: item.id
				}
			},
			function (text) {

				var json = JSON.parse(text);
				var dtMauHoaDon = $$("dtMauHoaDon");

				dtMauHoaDon.parse(json, "json");
				

			});

		

		$$("chkIssigninvoice").setValue(item.is_sign_invoice);
		$$("chkIsviewuser").setValue(item.is_view_user);
		$$("chkIsedituser").setValue(item.is_edit_user);
		$$("chkIsdeluser").setValue(item.is_del_user);

	}

	return {
		$ui: {
			view: "window", modal: true, id: "phanquyen-win", position: "center",
			head: "Thông tin Tab",
			fullscreen: true,
			body: {
				rows: [
					{
						borderless: true,
						view: "tabview",
						scrollX: true,
						multiview: {
							fitBiggest: true
						},
						cells: [
							{
								header: _("CHU_KY_SO"),
								body: {
									id: "dtChuKySo",
									view: "datatable",
									resizeRow: true,
									fixedRowHeight: false,
									rowLineHeight: 25,
									rowHeight: 70,
									//threeState: true,
									columns: [
										{
											id: "chon1",
											header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
											width: 55,
											checkValue: 'C',
											uncheckValue: 'K',
											template: "{common.checkbox()}"
										},
										{
											id: "cer_serial",
											header: _("SO_SERIAL"),
											width: 280
										},
										{
											id: "subject_name",
											header: "Chủ thể",
											width: 500
										},
										{
											id: "begin_date",
											header: "Ngày bắt đầu",
											width: 150
										},
										{
											id: "end_date",
											header: "Ngày kết thúc",
											width: 150
										},
									]

								}
							},
							{
								header: _("MAU_HDON"),
								body: {
									id: "dtMauHoaDon",
									view: "datatable",
									columns: [
										{
											id: "chon1",
											header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
											width: 55,
											checkValue: 'C',
											uncheckValue: 'K',
											template: "{common.checkbox()}"
										},
										{
											id: "ma_loai",
											header: _("MA_LOAI"),
											width: 100
										},
										{
											id: "mau_so",
											header: _("MAU_SO"),
											width: 100
										},
										{
											id: "ky_hieu",
											header: _("KY_HIEU"),
											width: 100
										},
										{
											id: "tu_so",
											header: _("TU_SO"),
											width: 100
										},
										{
											id: "den_so",
											header: _("DEN_SO"),
											width: 100
										},
										{
											id: "ngay_bd_sd",
											header: _("NGAY_BD_SD"),
											width: 150,
											format: function (text) {
												var format = webix.Date.dateToStr("%d/%m/%Y");
												text = removeTimeZoneT(text);
												return format(text);
											}
										}
									]
								}
							},							
							{
								header: _("QUYEN_TRUY_CAP_HD"),
								body: {
									paddingY: 10,
									paddingX: 10,
									rows: [
										{
											id: "chkIssigninvoice",
											view: "checkbox",
											name: "issigninvoice",
											labelRight: _("KY_HOA_DON"),
											checkValue: "C",
											uncheckValue: "K",
											labelWidth: 0
										},
										{
											id: "chkIsviewuser",
											view: "checkbox",
											name: "isviewuser",
											labelRight: _("IS_VIEW_USER"),
											checkValue: "C",
											uncheckValue: "K",
											labelAlign: "right",
											labelWidth: 0
										},
										{
											id: "chkIsedituser",
											view: "checkbox",
											name: "isedituser",
											labelRight: _("IS_EDIT_USER"),
											checkValue: "C",
											uncheckValue: "K",
											labelWidth: 0
										},
										{
											id: "chkIsdeluser",
											view: "checkbox",
											name: "isdeluser",
											labelRight: _("IS_DEL_USER"),
											checkValue: "C",
											uncheckValue: "K",
											labelWidth: 0
										}
									]
								}
							}
						]
					},
					{
						cols: [
							{},
							{
								shortcut: "F10",
								view: "button", label: "Nhận (F10)", type: "form", align: "center",
								width: 100,
								on: {
									onClick: function () {
										var dtChuKySo = $$("dtChuKySo");
										var dtMauHoaDon = $$("dtMauHoaDon");										

										var win = this.getTopParentView();

										var data = {
											wb_user_id: win.config.wb_user_id,
											ckspermission: dtChuKySo.serialize(),
											invtemppermission: dtMauHoaDon.serialize(),											
											invoicepermission: {
												issigninvoice: $$("chkIssigninvoice").getValue(),
												isviewuser: $$("chkIsviewuser").getValue(),
												isedituser: $$("chkIsedituser").getValue(),
												isdeluser: $$("chkIsdeluser").getValue()
											}
										};

										var url = app.config.host + "/Account/Phanquyen";

										webix.ajax()
											.bind(data)
											.headers({ 'Content-type': 'application/json' })
											.post(url, data, function (text) {
												var result = JSON.parse(text);

												if (!result.hasOwnProperty("error")) {
													var table = webix.$$("dmwindowData");
													var item = table.getSelectedItem();

													item.is_sign_invoice = this.invoicepermission.issigninvoice;
													item.is_view_user = this.invoicepermission.isviewuser;
													item.is_edit_user = this.invoicepermission.isedituser;
													item.is_del_user = this.invoicepermission.isdeluser;

													table.updateItem(item.id, item);
													webix.$$("phanquyen-win").close();
												}
												else {
													webix.message({ type: "error", text: result.error });
												}
											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								},
							},
							{
								view: "button", shortcut: "esc", type: "danger", label: "Hủy bỏ (ESC)", align: "center",
								width: 100,
								on: {
									onClick: function () {
										this.getTopParentView().close();
									}
								},
								click: function () {
									this.callEvent("onClick");
								}
							},
							{}

						]
					},
					{
						height: 5
					}
				]
			}

		},
		initUI: initUI
	};

});
define('views/accountbranch',["app", "views/forms/accountbranch", "locale", "views/forms/branchpermission"], function (app, dmwindowform, _, accountpermission) {
    

    var op = [];

    webix.$$("title").parse({ title: "Người sử dụng", details: "Danh mục người sử dụng" });

    var controls = [
        {
            id: "btnPlus",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: _("THEM") + " (F4)",
            width: 100,
            css: "webix_secondary",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmwindowform.$ui);
                    dmwindowform.setEditMode(1);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
            label: _("SUA") + " (F3)",
            width: 90,
            css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("dmtab-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item.username == "ADMINISTRATOR") {
                        webix.message("Bạn không được phép sửa tài khoản này !", "error");
                        return;
                    }

                    form.setValues(item);

                    dmwindowform.setEditMode(2);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "icon",
            icon: "fas fa-trash-o",
            label: _("XOA") + " (F8)",
            width: 90,
            css: "webix_secondary",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item.username == "ADMINISTRATOR") {
                        webix.message("Bạn không được phép xóa tài khoản này !", "error");
                        return;
                    }

                    item.window_type = "accountbranch";

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.username,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Account/Delete", item, function (text, xml, xhr) {
                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }

                                        table.remove(item.id);
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnPhanQuyen",
            view: "button",
            type: "icon",
            icon: "fas fa-lock",
            label: _("PHAN_QUYEN"),
            width: 100,
            css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn người sử dụng", "error");
                        return;
                    }

                    var win = this.$scope.ui(accountpermission.$ui);
                    win.config.wb_user_id = item.id;
                    accountpermission.initUI(item);
                    win.getHead().setHTML("Người sử dụng: " + item.username);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                url: app.config.host + "/Account/AllUsersByBranch",
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                },
                columns: [
                    {
                        id: "username",
                        header: ["Tên truy cập", { content: "textFilter" }],
                        width: 150,
                    },
                    {
                        id: "wb_role_id",
                        view: "combo",
                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00007",
                        header: ["Nhóm quyền", { content: "selectFilter" }],
                        width: 250,
                    },
                    {
                        id: "email",
                        header: ["Email", { content: "textFilter" }],
                        width: 200,
                    },
                    {
                        id: "fullname",
                        header: ["Tên người sử dụng", { content: "textFilter" }],
                        width: 200,
                    },
                    {
                        id: "is_sign_invoice",
                        header: [
                            "Ký hóa đơn",
                            {
                                content: "selectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "C", value: "C" },
                                    { id: "K", value: "K" },
                                ],
                            },
                        ],
                        width: 150,
                    },
                    {
                        id: "is_view_user",
                        header: [
                            "Xem",
                            {
                                content: "selectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "C", value: "C" },
                                    { id: "K", value: "K" },
                                ],
                            },
                        ],
                        width: 60,
                    },
                    {
                        id: "is_edit_user",
                        header: [
                            "Sửa",
                            {
                                content: "selectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "C", value: "C" },
                                    { id: "K", value: "K" },
                                ],
                            },
                        ],
                        width: 60,
                    },
                    {
                        id: "is_del_user",
                        header: [
                            "Xóa",
                            {
                                content: "selectFilter",
                                options: [
                                    { id: "", value: "" },
                                    { id: "C", value: "C" },
                                    { id: "K", value: "K" },
                                ],
                            },
                        ],
                        width: 60,
                    },
                    {
                        id: "explanation",
                        header: ["Diễn giải", { content: "textFilter" }],
                        width: 350,
                    },
                    {
                        id: "store_code",
                        header: ["Mã cửa hàng", { content: "textFilter" }],
                        width: 150,
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                view: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});

define('views/forms/accountstore',["app","locale"], function (app,_) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win", position: "center",
			head: "Người sử dụng",
			width: 500,
			height: 480,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 60 },
				view: "form",
				id: "dmtab-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						view: "text",
						name: "username",
						labelPosition: "top",
						required: true,
						label: "Tên truy cập",
						id: "dmtab-username",
						invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
						validate: webix.rules.isSpecialCharacter,
						css: "mcls_uppercase",
						on: {
							onChange: function (newv, oldv) {
								if (newv != undefined) {
									if (oldv != undefined) {
										if (newv.toUpperCase() != oldv.toUpperCase()) {
											webix.$$(this.config.id).setValue(newv.toUpperCase());
										}
									}
									else {
										webix.$$(this.config.id).setValue(newv.toUpperCase());
									}

								}

							}
						}
					},
					{
						view: "combo",
						name: "wb_role_id",
						label: "Nhóm quyền",
						options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00191",
						id: "dmtab-nhomquyen",
						labelPosition: "top",
						required: true,
						invalidMessage: "Bạn chưa chọn nhóm quyền"
					},					
					{
						view: "text",
						name: "email",
						required: true,
						labelPosition: "top",
						label: "Email",
						id: "dmtab-email",
						validate: webix.rules.isEmail,
						invalidMessage: "Email không được để trống hoặc không đúng định dạng"
					},
					{
						view: "text",
						name: "fullname",
						required: true,
						labelPosition: "top",
						label: "Tên người sử dụng",
						id: "dmtab-fullname",
						//validate: webix.rules.isEmail,
						invalidMessage: "Tên người sử dụng không được để trống"
					},
					/* {
								view:"checkbox",
								id:"dmtab-issigninvoice",
								name:"issigninvoice",
								label:"Ký hóa đơn",
								checkValue:"C",
								uncheckValue:"K" ,
								labelWidth:85
					},
					{
						view:"fieldset",
						label:"Quyền truy cập",
						body:{
							cols:[
								{
									view:"checkbox",
									id:"dmtab-isviewuser",
									name:"isviewuser",
									label:"Xem",
									checkValue:"C",
									uncheckValue:"K" 
								},
								{
								view:"checkbox",
								id:"dmtab-isedituser",
								name:"isedituser",
								label:"Sửa",
								checkValue:"C",
								uncheckValue:"K" 
								},
								{
									view:"checkbox",
									id:"dmtab-isdeluser",
									name:"isdeluser",
									label:"Xóa",
									checkValue:"C",
									uncheckValue:"K" 
								}
							]
						}
					}, */
					{ view: "textarea", name: "dien_giai", labelPosition: "top", label: "Diễn giải", id: "dmtab-diengiai" },

					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Lưu (F10)", type: "form", align: "center",
								on: {
									onClick: function () {
										var form = webix.$$("dmtab-form");

										if (form.validate() == false) {
											return;
										}

										var item = form.getValues();
										item.window_type = "accountstore";

										var url = app.config.host + "/Account/Update";
										webix.extend(form, webix.ProgressBar);
										form.disable();
										form.showProgress();
										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(url, item, function (text) {
												var data = JSON.parse(text);
												form.enable();
												form.hideProgress();
												if (!data.hasOwnProperty("error")) {
													item.id = data.id;
													webix.$$("dmtab-win").close();
													app.callEvent("dataChanged", [editmode, item]);
												}
												else {
													webix.message({ type: "error", text: data.error });
												}
											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center",
								click: function () {
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/forms/storepermission',["app", "locale"], function (app, _) {

	function initUI(item) {

		var url = app.config.host + "/System/ExecuteCommand";

		webix.ajax()
			.headers({ 'Content-type': 'application/json' })
			.post(url,
			{
				command: "CM00095",
				parameter: {
					wb_user_id: item.id
				}
			}
			, function (text) {

				var json = JSON.parse(text);

				var dtChuKySo = $$("dtChuKySo");

				dtChuKySo.parse(json, "json");



			});

		webix.ajax()
			.headers({ 'Content-type': 'application/json' })
			.post(url,
			{
				command: "USER_TEMP",
				parameter: {
					wb_user_id: item.id,
					store_code: item.store_code
				}
			},
			function (text) {

				var json = JSON.parse(text);
				var dtMauHoaDon = $$("dtMauHoaDon");

				dtMauHoaDon.parse(json, "json");				

			});
		

		$$("chkIssigninvoice").setValue(item.is_sign_invoice);
		$$("chkIsviewuser").setValue(item.is_view_user);
		$$("chkIsedituser").setValue(item.is_edit_user);
		$$("chkIsdeluser").setValue(item.is_del_user);

	}

	return {
		$ui: {
			view: "window", modal: true, id: "phanquyen-win", position: "center",
			head: "Thông tin Tab",
			fullscreen: true,
			body: {
				rows: [
					{
						borderless: true,
						view: "tabview",
						scrollX: true,
						multiview: {
							fitBiggest: true
						},
						cells: [
							{
								header: _("CHU_KY_SO"),
								body: {
									id: "dtChuKySo",
									view: "datatable",
									resizeRow: true,
									fixedRowHeight: false,
									rowLineHeight: 25,
									rowHeight: 70,
									//threeState: true,
									columns: [
										{
											id: "chon1",
											header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
											width: 55,
											checkValue: 'C',
											uncheckValue: 'K',
											template: "{common.checkbox()}"
										},
										{
											id: "cer_serial",
											header: _("SO_SERIAL"),
											width: 280
										},
										{
											id: "subject_name",
											header: "Chủ thể",
											width: 500
										},
										{
											id: "begin_date",
											header: "Ngày bắt đầu",
											width: 150
										},
										{
											id: "end_date",
											header: "Ngày kết thúc",
											width: 150
										},
									]

								}
							},
							{
								header: _("MAU_HDON"),
								body: {
									id: "dtMauHoaDon",
									view: "datatable",
									columns: [
										{
											id: "chon1",
											header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
											width: 55,
											checkValue: 'C',
											uncheckValue: 'K',
											template: "{common.checkbox()}"
										},
										{
											id: "ma_loai",
											header: _("MA_LOAI"),
											width: 100
										},
										{
											id: "mau_so",
											header: _("MAU_SO"),
											width: 100
										},
										{
											id: "ky_hieu",
											header: _("KY_HIEU"),
											width: 100
										},
										{
											id: "tu_so",
											header: _("TU_SO"),
											width: 100
										},
										{
											id: "den_so",
											header: _("DEN_SO"),
											width: 100
										},
										{
											id: "ngay_bd_sd",
											header: _("NGAY_BD_SD"),
											width: 150,
											format: function (text) {
												var format = webix.Date.dateToStr("%d/%m/%Y");
												text = removeTimeZoneT(text);
												return format(text);
											}
										}
									]
								}
							},							
							{
								header: _("QUYEN_TRUY_CAP_HD"),
								body: {
									paddingY: 10,
									paddingX: 10,
									rows: [
										{
											id: "chkIssigninvoice",
											view: "checkbox",
											name: "issigninvoice",
											labelRight: _("KY_HOA_DON"),
											checkValue: "C",
											uncheckValue: "K",
											labelWidth: 0
										},
										{
											id: "chkIsviewuser",
											view: "checkbox",
											name: "isviewuser",
											labelRight: _("IS_VIEW_USER"),
											checkValue: "C",
											uncheckValue: "K",
											labelAlign: "right",
											labelWidth: 0
										},
										{
											id: "chkIsedituser",
											view: "checkbox",
											name: "isedituser",
											labelRight: _("IS_EDIT_USER"),
											checkValue: "C",
											uncheckValue: "K",
											labelWidth: 0
										},
										{
											id: "chkIsdeluser",
											view: "checkbox",
											name: "isdeluser",
											labelRight: _("IS_DEL_USER"),
											checkValue: "C",
											uncheckValue: "K",
											labelWidth: 0
										}
									]
								}
							}
						]
					},
					{
						cols: [
							{},
							{
								shortcut: "F10",
								view: "button", label: "Nhận (F10)", type: "form", align: "center",
								width: 100,
								on: {
									onClick: function () {
										var dtChuKySo = $$("dtChuKySo");
										var dtMauHoaDon = $$("dtMauHoaDon");
										//var dtDonvi = $$("dtDonvi");

										var win = this.getTopParentView();

										var data = {
											wb_user_id: win.config.wb_user_id,
											ckspermission: dtChuKySo.serialize(),
											invtemppermission: dtMauHoaDon.serialize(),
											//dvpermission: dtDonvi.serialize(),
											invoicepermission: {
												issigninvoice: $$("chkIssigninvoice").getValue(),
												isviewuser: $$("chkIsviewuser").getValue(),
												isedituser: $$("chkIsedituser").getValue(),
												isdeluser: $$("chkIsdeluser").getValue()
											}
										};

										var url = app.config.host + "/Account/Phanquyen";

										webix.ajax()
											.bind(data)
											.headers({ 'Content-type': 'application/json' })
											.post(url, data, function (text) {
												var result = JSON.parse(text);

												if (!result.hasOwnProperty("error")) {
													var table = webix.$$("dmwindowData");
													var item = table.getSelectedItem();

													item.is_sign_invoice = this.invoicepermission.issigninvoice;
													item.is_view_user = this.invoicepermission.isviewuser;
													item.is_edit_user = this.invoicepermission.isedituser;
													item.is_del_user = this.invoicepermission.isdeluser;

													table.updateItem(item.id, item);
													webix.$$("phanquyen-win").close();
												}
												else {
													webix.message({ type: "error", text: result.error });
												}
											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								},
							},
							{
								view: "button", shortcut: "esc", type: "danger", label: "Hủy bỏ (ESC)", align: "center",
								width: 100,
								on: {
									onClick: function () {
										this.getTopParentView().close();
									}
								},
								click: function () {
									this.callEvent("onClick");
								}
							},
							{}

						]
					},
					{
						height: 5
					}
				]
			}

		},
		initUI: initUI
	};

});
define('views/accountstore',["app", "views/forms/accountstore", "locale", "views/forms/storepermission"], function (app, dmwindowform, _, accountpermission) {
    

    var op = [];

    webix.$$("title").parse({ title: "Người sử dụng", details: "Danh mục người sử dụng" });

    var controls = [
        {
            id: "btnPlus",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: _("THEM") + " (F4)",
            width: 100,
            css: "webix_secondary",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmwindowform.$ui);
                    dmwindowform.setEditMode(1);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
            label: _("SUA") + " (F3)",
            width: 90,
            css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("dmtab-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item.username == "ADMINISTRATOR") {
                        webix.message("Bạn không được phép sửa tài khoản này !", "error");
                        return;
                    }

                    form.setValues(item);

                    dmwindowform.setEditMode(2);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "icon",
            icon: "fas fa-trash-o",
            label: _("XOA") + " (F8)",
            width: 90,
            css: "webix_secondary",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item.username == "ADMINISTRATOR") {
                        webix.message("Bạn không được phép xóa tài khoản này !", "error");
                        return;
                    }

                    item.window_type = "accountstore";

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.username,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/Account/Delete", item, function (text, xml, xhr) {
                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }

                                        table.remove(item.id);
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnPhanQuyen",
            view: "button",
            type: "icon",
            icon: "fas fa-lock",
            label: _("PHAN_QUYEN"),
            width: 100,
            css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn người sử dụng", "error");
                        return;
                    }

                    var win = this.$scope.ui(accountpermission.$ui);
                    win.config.wb_user_id = item.id;
                    accountpermission.initUI(item);
                    win.getHead().setHTML("Người sử dụng: " + item.username);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                url: app.config.host + "/Account/AllUsersByStore",
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                },
                columns: [
                    {
                        id: "username",
                        header: ["Tên truy cập", { content: "textFilter" }],
                        width: 150,
                    },
                    {
                        id: "wb_role_id",
                        view: "combo",
                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00007",
                        header: ["Nhóm quyền", { content: "selectFilter" }],
                        width: 250,
                    },
                    {
                        id: "email",
                        header: ["Email", { content: "textFilter" }],
                        width: 200,
                    },
                    {
                        id: "fullname",
                        header: ["Tên người sử dụng", { content: "textFilter" }],
                        width: 200,
                    },
                    {
                        id: "is_sign_invoice",
                        header: "Ký hóa đơn",
                        width: 150,
                    },
                    {
                        id: "is_view_user",
                        header: "Xem",
                        width: 60,
                    },
                    {
                        id: "is_edit_user",
                        header: "Sửa",
                        width: 60,
                    },
                    {
                        id: "is_del_user",
                        header: "Xóa",
                        width: 60,
                    },
                    {
                        id: "explanation",
                        header: "Diễn giải",
                        width: 350,
                    },
                    {
                        id: "store_code",
                        header: ["Mã cửa hàng", { content: "textFilter" }],
                        width: 150,
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                view: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});

define('views/menus/search',[],function(){

return {
	$ui:{
		view: "popup",
		id: "searchPopup",

		width: 300,
		body:{
			rows:[
				{
					view: "search"
				},
				{
					borderless:true, css: "extended_search", template: "<span>Extended search</span>", height: 40
				}
			]

		}
	}
};

});
define('views/forms/changepass',["app"], function (app) {

	return {
		$ui: {
			view: "window", modal: true, id: "listuser-win", position: "center", css: "custom-window",
			head: "Đổi mật khẩu",
			body: {
				css: "custom-body",
				paddingY: 10,
				paddingX: 10,
				//elementsConfig:{labelWidth: 120}, 
				view: "form",
				id: "listuser-form",
				complexData: true,
				elements: [
					{ view: "text", id:"oldpass", name: "oldpass", required: true, invalidMessage: "Mật khẩu cũ không được bỏ trống", type: "password", label: "Mật khẩu cũ", labelPosition: "top", css:"custom-input", icon: "fa fa-eye", 
						on: {
							onItemClick: function (id, e) {
								// Kiểm tra xem người dùng có click vào biểu tượng không
								if (e.target && e.target.classList.contains("webix_input_icon")) {
									var inputNode = $$("oldpass").getInputNode();  // Lấy node input
									var inputType = inputNode.type;  // Kiểm tra loại của input (password hoặc text)
									
									// Thay đổi loại input và biểu tượng tương ứng
									if (inputType === "password") {
										inputNode.type = "text"; // Hiển thị mật khẩu
										webix.html.removeCss(e.target, "fa-eye");
										webix.html.addCss(e.target, "fa-eye-slash"); // Thêm biểu tượng mắt đóng
									} else {
										inputNode.type = "password"; // Ẩn mật khẩu
										webix.html.removeCss(e.target, "fa-eye-slash");
										webix.html.addCss(e.target, "fa-eye"); // Thêm biểu tượng mắt mở
									}
								}
							},
							// onBlur: function() {
							// 	var password = this.getValue();
								
							// 	// Password regex: at least 8 characters, including uppercase, lowercase, number, and special character
							// 	var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
					
							// 	let errorLabel = this.$view.querySelector(".custom-error-label");
							// 	if (!errorLabel) {
							// 		errorLabel = document.createElement("div");
							// 		errorLabel.className = "custom-error-label";
							// 		errorLabel.style.color = "red";
							// 		errorLabel.style.marginTop = "10px";
							// 		this.$view.appendChild(errorLabel);
							// 	}

							// 	// Show or hide the error message based on password validity
							// 	if (passwordRegex.test(password)) {
							// 		errorLabel.innerText = "";  // Clear error if valid
							// 	} else {
							// 		errorLabel.innerText = "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt.";
							// 	}
							// }
						}
					 },
					{ view: "text", id:"newpass", name: "newpass", required: true, invalidMessage: "Mật khẩu mới không được bỏ trống", type: "password", label: "Mật khẩu mới", labelPosition: "top" , css:"custom-input", icon: "fa fa-eye", 
						on: {
							onItemClick: function (id, e) {
								// Kiểm tra xem người dùng có click vào biểu tượng không
								if (e.target && e.target.classList.contains("webix_input_icon")) {
									var inputNode = $$("newpass").getInputNode();  // Lấy node input
									var inputType = inputNode.type;  // Kiểm tra loại của input (password hoặc text)
									
									// Thay đổi loại input và biểu tượng tương ứng
									if (inputType === "password") {
										inputNode.type = "text"; // Hiển thị mật khẩu
										webix.html.removeCss(e.target, "fa-eye");
										webix.html.addCss(e.target, "fa-eye-slash"); // Thêm biểu tượng mắt đóng
									} else {
										inputNode.type = "password"; // Ẩn mật khẩu
										webix.html.removeCss(e.target, "fa-eye-slash");
										webix.html.addCss(e.target, "fa-eye"); // Thêm biểu tượng mắt mở
									}
								}
							},
							onBlur: function() {
								var password = this.getValue();
								
								// Password regex: at least 8 characters, including uppercase, lowercase, number, and special character
								var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/;
					
								var errorLabel = this.$view.querySelector(".custom-error-label");
								if (!errorLabel) {
									errorLabel = document.createElement("div");
									errorLabel.className = "custom-error-label";
									errorLabel.style.color = "red";
									errorLabel.style.marginTop = "10px";
									this.$view.appendChild(errorLabel);
								}

								// Show or hide the error message based on password validity
								if (passwordRegex.test(password)) {
									errorLabel.innerText = "";  // Clear error if valid
								} else {
									errorLabel.innerText = "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt.";
								}
							}
						}
					},
					{ view: "text", id:"confirmpass", name: "confirmpass", required: true, invalidMessage: "Xác nhận mật khẩu không được bỏ trống", type: "password", label: "Xác nhận mật khẩu", labelPosition: "top", css:"custom-input", icon: "fa fa-eye", 
						on: {
							onItemClick: function (id, e) {
								// Kiểm tra xem người dùng có click vào biểu tượng không
								if (e.target && e.target.classList.contains("webix_input_icon")) {
									var inputNode = $$("confirmpass").getInputNode();  // Lấy node input
									var inputType = inputNode.type;  // Kiểm tra loại của input (password hoặc text)
									
									// Thay đổi loại input và biểu tượng tương ứng
									if (inputType === "password") {
										inputNode.type = "text"; // Hiển thị mật khẩu
										webix.html.removeCss(e.target, "fa-eye");
										webix.html.addCss(e.target, "fa-eye-slash"); // Thêm biểu tượng mắt đóng
									} else {
										inputNode.type = "password"; // Ẩn mật khẩu
										webix.html.removeCss(e.target, "fa-eye-slash");
										webix.html.addCss(e.target, "fa-eye"); // Thêm biểu tượng mắt mở
									}
								}
							},
							onBlur: function() {
								var password = this.getValue();
								var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/;
								var errorLabel = this.$view.querySelector(".custom-error-label");
								if (!errorLabel) {
									errorLabel = document.createElement("div");
									errorLabel.className = "custom-error-label";
									errorLabel.style.color = "red";
									errorLabel.style.marginTop = "10px";
									this.$view.appendChild(errorLabel);
								}

								if (passwordRegex.test(password)) {
									errorLabel.innerText = "";  // Clear error if valid
								} else {
									errorLabel.innerText = "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt.";
								}
							}
						}
					 },
					{ view: "template",  template: "<span style='display:block;color: red;width: 450px !important; '>Chú ý: Mật khẩu phải lớn hơn 8 ký tự, có chứa chữ hoa, chữ thường, số và ký tự đặc biệt.</span>", css: "warning-text"},
					{
						css: "custom-button",
						margin: 30,
						cols: [	
							{},
							{
								view: "button", label: "Lưu (F10)", hotkey: "F10", type: "form", align: "center", width: 120, click: function () {
									debugger;
									var form = webix.$$("listuser-form");
									debugger;
									if (form.validate() == false) {
										return;
									}

									var item = form.getValues();
									var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/;

									if (!passwordRegex.test(item.newpass) || !passwordRegex.test(item.confirmpass)) {
										webix.message("Mật khẩu phải lớn hơn 8 ký tự, có chứa chữ hoa, chữ thường, số và ký tự đặc biệt!", "error");
										return;
									}

									if (item.newpass != item.confirmpass) {
										webix.message("Mật khẩu mới không giống nhau", "error");
										return;
									}
									
									webix.ajax()
										.post(app.config.host + "/Account/ChangePass", item, function (text) {
											var data = JSON.parse(text);

											if (!data.hasOwnProperty("error")) {
												webix.$$("listuser-win").close();
												webix.message("Đổi mật khẩu thành công !", "success");
												var baseUrl = document.location.href;
												if (baseUrl.startsWith("file")) {
													webix.storage.local.remove("appCookie");
												} else {
													Cookies.remove("appCookie");
												}
												setTimeout(function() {
													document.location.reload();
												}, 500);
											}
											else {
												webix.message(data.error, "error");
											}
										});
								}
							},
							{
								view: "button", label: "Hủy bỏ (ESC)", hotkey: "esc", type: "danger", align: "center", width: 120, click: function () {
									webix.$$("listuser-win").close();
								}
							}
						]
					}

				]
			}
		}
	};

});
define('views/modules/chatplugin',[
    'app',
    'models/user'
], function (app, user) {
    
    var hub = null;
    // var ChatUrl = "http://localhost:52527/signalr";
    // //This will hold the connection to the signalr hub   
    // var SignalrConnection = $.hubConnection(ChatUrl, {
    //     useDefaultPath: false
    // });
    // var hub = SignalrConnection.createHubProxy('chatHub');
    // //connecting the client to the signalr hub   
    // hub.on("addNewMessageToPage", function (name, message) {
    //     console.log(name + message);
    // });

    // SignalrConnection.disconnected(function () {
    //     console.log('Connection disconnected');
    // });
    // SignalrConnection.start().done(function () {
    //     console.log("Connected to Signalr Server");
    // })
    //     .fail(function () {
    //         console.log("failed in connecting to the signalr server");
    //     });


    return {
        hub: function () {
            return hub;
        }
    }
});
define('views/forms/chat',["app", "models/user", "views/modules/chatplugin"], function (app, user, proxy) {
    // var hub = proxy.hub();
    // hub.on("addNewMessageToPage", function (name, message) {
    //     addChatMessage(name, message);
    // });

    // function change_weather(i) {
    //     var jj = proxy.hub();
    //     jj.invoke('change_weather', i);
    // }

    function addChatMessage(name, message) {
        var chat = $$("chat");

        chat.add({
            user: name,
            value: message,
        });

        var lastId = chat.getLastId();
        chat.scrollTo(0, lastId);

        $$("message").setValue("");
        $$("message").focus();
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "chat-win",
            position: "center",
            head: "MobiFone Invoice Chat",
            // head: {
            //     view: "toolbar",
            //     height: 25,
            //     cols: [
            //         { view: "label", label: "MobiFone Invoice Chat" },
            //         {
            //             view: "icon", icon: "times", hotkey: "esc", click: function () {
            //                 $$("chat-win").close();
            //             }
            //         }
            //     ]
            // },
            width: 700,
            height: 500,
            body: {
                paddingY: 10,
                paddingX: 10,
                //elementsConfig:{labelWidth: 120},
                view: "form",
                id: "chat-form",
                complexData: true,
                elements: [
                    //rows: [
                    //  { template: "Webix Based Chat", type: "header" },
                    // {
                    //     view: "list", id: "chat", gravity: 3,
                    //     // url: "faye->/data", save: "faye->/data",
                    //     // type: { height: "auto" },
                    //     // template: chat_template
                    // },
                    {
                        view: "list",
                        id: "chat",
                        gravity: 3,
                        type: { height: "auto" },
                        template: function (obj) {
                            return "<span " + (obj.user == user.getCurrentUser() ? "class='rowBold'" : "class='rowBoldGreen'") + ">" + obj.user + "</span> " + obj.value;
                        },
                    },
                    {
                        cols: [
                            { view: "textarea", id: "message", placeholder: "Type message here", gravity: 3 },
                            {
                                rows: [
                                    {
                                        view: "button",
                                        value: "Send",
                                        type: "form",
                                        // width: 100,
                                        click: function () {
                                            //change_weather(124124);
                                            var text = $$("message").getValue();
                                            var ds = user.getCurrentUser();
                                            //webix.message("Hệ thống đang bảo trì !", "error");
                                            //send(ds, text);
                                            var hub = proxy.hub();
                                            hub.invoke("Send", user.getCurrentUser(), text)
                                                .done(function () {
                                                    console.log("send ok !");
                                                    //addChatMessage(ds, text);
                                                })
                                                .fail(function (error) {
                                                    console.log(error);
                                                });
                                        },
                                        // click: function () {
                                        //     webix.message("Hệ thống đang bảo trì !", "error");
                                        // }
                                    },
                                    {
                                        view: "button",
                                        value: "Hủy bỏ (ESC)",
                                        type: "danger",
                                        hotkey: "esc",
                                        align: "center",
                                        // width: 100,
                                        click: function () {
                                            webix.$$("chat-win").close();
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            //], type: "space", margin: 2
        },
    };
});

define('views/hotroform',["app", "locale"], function (app, _) {
    //var json = version.getInfocompany();
    //$$("hotro-form").setValues(json);

    var layout = {
        view: "window",
        modal: true,
        id: "hotro-win",
        position: "center",
        head: "Gửi yêu cầu hỗ trợ đến MobiFone Invoice",
        width: 500,
        // height: 700,
        body: {
            paddingY: 10,
            paddingX: 10,
            //elementsConfig:{labelWidth: 120},
            view: "form",
            id: "hotro-form",
            complexData: true,
            elements: [
                {
                    view: "text",
                    name: "ms_thue",
                    id: "ms_thue",
                    label: _("MS_THUE"),
                    css: "mcls_readonly_text",
                    readonly: true,
                    labelPosition: "top",
                },
                {
                    view: "text",
                    name: "ten_dvcs",
                    id: "ten_dvcs",
                    label: _("DONVI"),
                    css: "mcls_readonly_text",
                    readonly: true,
                    labelPosition: "top",
                },
                {
                    view: "text",
                    name: "dia_chi",
                    label: _("DIA_CHI"),
                    css: "mcls_readonly_text",
                    readonly: true,
                    labelPosition: "top",
                },
                {
                    cols: [
                        {
                            view: "text",
                            name: "nguoi_dai_dien",
                            label: _("NGUOI_DAI_DIEN_PL"),
                            css: "mcls_readonly_text",
                            readonly: true,
                            labelPosition: "top",
                        },
                        {
                            view: "text",
                            name: "email",
                            label: "Email",
                            css: "mcls_readonly_text",
                            readonly: true,
                            labelPosition: "top",
                        },
                    ],
                },
                {
                    cols: [
                        {
                            view: "text",
                            name: "nguoi_lien_he",
                            id: "nguoi_lien_he",
                            label: _("Người liên hệ"),
                            labelPosition: "top",
                            required: true,
                            invalidMessage: "Bạn phải nhập người liên hệ",
                        },

                        {
                            view: "text",
                            name: "sdt",
                            id: "sdt",
                            label: "Số điện thoại",
                            labelPosition: "top",
                            required: true,
                            //webix.ru
                            invalidMessage: "Bạn phải nhập số điện thoại",
                        },
                    ],
                },
                {
                    cols: [
                        {
                            view: "text",
                            name: "teamview",
                            id: "teamview",
                            label: _("Teamview (UltraViewer)"),
                            labelPosition: "top",
                        },

                        {
                            view: "text",
                            name: "pass",
                            id: "pass",
                            label: "Password",
                            labelPosition: "top",
                        },
                    ],
                },
                {
                    id: "noi_dung",
                    view: "textarea",
                    name: "noi_dung",
                    label: "Yêu cầu hỗ trợ",
                    height: 120,
                    labelPosition: "top",
                },

                {
                    margin: 10,
                    cols: [
                        {},
                        {
                            shortcut: "F10",
                            view: "button",
                            label: "Gửi (F10)",
                            align: "center",
                            width: 120,
                            type: "form",
                            on: {
                                onClick: function () {
                                    var form = webix.$$("hotro-form");

                                    var item = form.getValues();
                                    var format = webix.Date.dateToStr("%d/%m/%Y - %H:%i");
                                    var string = format(new Date());

                                    var descrip =
                                        "Ngày :" +
                                        string +
                                        "</br>" +
                                        "Công ty :" +
                                        item.ten_dvcs +
                                        "</br>" +
                                        "Mã số thuế :" +
                                        item.ms_thue +
                                        "</br>" +
                                        "Người liên hệ: " +
                                        item.nguoi_lien_he +
                                        "</br>" +
                                        "Số điện thoại: " +
                                        item.sdt +
                                        "</br>" +
                                        "Teamview (UltraViewer): " +
                                        item.teamview +
                                        "</br>" +
                                        "Pass: " +
                                        item.pass +
                                        "</br>" +
                                        "Nội dung cần hỗ trợ: " +
                                        item.noi_dung +
                                        "</br>";

                                    if ($$("hotro-form").validate()) {
                                        var box = webix.modalbox({
                                            title: "Đang gửi yêu cầu hỗ trợ đến MobiFone Invoice",
                                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                            width: 350,
                                            height: 200,
                                        });

                                        var data = {
                                            mst: item.ms_thue,
                                            noidung: item.noi_dung,
                                            nguoi_lien_he: item.nguoi_lien_he,
                                            sdt_nguoi_lien_he: item.sdt,
                                            ultra_teamview: item.teamview,
                                            pass: item.pass,
                                        };
                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/System/SendSupport", data, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.modalbox.hide(box);
                                                    alert(text);
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var json = JSON.parse(text);
                                                    if (!json.hasOwnProperty("error")) {
                                                        $$("nguoi_lien_he").setValue(null);
                                                        $$("sdt").setValue(null);
                                                        $$("teamview").setValue(null);
                                                        $$("pass").setValue(null);
                                                        $$("noi_dung").setValue(null);
                                                        webix.message("Gửi yêu cầu hỗ trợ thành công !", "debug");
                                                    } else {
                                                        webix.message(json.error, "error");
                                                    }
                                                    webix.modalbox.hide(box);
                                                },
                                            });
                                    }
                                },
                            },
                            click: function () {
                                this.callEvent("onClick");
                            },
                        },
                        {
                            shortcut: "F10",
                            view: "button",
                            label: "Nhập lại (F9)",
                            align: "center",
                            width: 120,
                            type: "form",
                            on: {
                                onClick: function () {
                                    $$("nguoi_lien_he").setValue(null);
                                    $$("sdt").setValue(null);
                                    $$("teamview").setValue(null);
                                    $$("pass").setValue(null);
                                    $$("noi_dung").setValue(null);
                                },
                            },

                            click: function () {
                                this.callEvent("onClick");
                            },
                        },
                        {
                            view: "button",
                            hotkey: "esc",
                            label: "Hủy bỏ (ESC)",
                            align: "center",
                            width: 120,
                            type: "danger",
                            click: function () {
                                webix.$$("hotro-win").close();
                            },
                        },
                        {},
                    ],
                },
            ],
        },
    };
    return {
        $ui: layout,
        initUI: function (json) {
            $$("hotro-form").setValues(json);
        },
    };
});

define('views/menus/version',["app"], function (app) {

    // var user = null,
    //     credentials = {},
    //     oauthUrl = ''
    //     ;

    // var host = "";
    // var start = "";

    // require(["app"], function (app) {
    //     host = app.config.host;
    //     start = app.config.start;
    // });

    // credentials = Cookies.getJSON("appCookie") || {};

    // function saveSetting(key, value, reload) {
    //     if (current_user) {
    //         var id = current_user.id,
    //             settings = current_user.settings;

    //         if (!settings[key] || value != settings[key]) {
    //             if (reload)
    //                 document.location.reload();
    //         }
    //     }
    // }

    return {
        //saveSetting: saveSetting,
        // getVersion: function () {
        //     var result = webix.ajax().sync().get(app.config.host + "/System/GetVersion");
        //     var json = JSON.parse(result.response);
        //     //console.log(json);
        //     return json;
        // },

        getWarning: function () {
            // var item = {
            //     command: "NOTYFI_INV_TEMP",
            //     parameter: {

            //     }
            // }
            // webix.ajax()
            //     .headers({ "Content-Type": "application/json" })
            //     .post(app.config.host + "/System/ExecuteCommand", item, function (text) {
            //         var res = JSON.parse(text);

            //         if (res.hasOwnProperty("error")) {
            //             webix.message({ type: "error", text: res.error });
            //         }
            //         else {
            //             webix.message("Đã thực hiện xong");
            //         }
            //     });
            // webix.ajax().post(app.config.host + "/System/ExecuteCommand", item, function () {

            // });
            // var json = JSON.parse(result.response);
            // //console.log(json);
            // return json;
        },
        getInfocompany: function () {
            var result = webix.ajax().sync().get(app.config.host + "/System/GetInfoCompany");
            var json = JSON.parse(result.response);
            //console.log(json);
            return json;
        },
        getMST: function () {
            var result = webix.ajax().sync().get(app.config.host + "/System/GetMST");
            var json = result.response.substring(1, result.response.length - 1);
            return json;
        },
        GetSchema: function () {
            var result = webix.ajax().sync().get(app.config.host + "/Invoice/GetSchema");
            var json = result.response.substring(1, result.response.length - 1);
            return json;
        }

    };

});
define('views/forms/link_sso',["app", "models/user"], function (app, user) {

	return {
		$ui: {
			view: "window", modal: true, id: "listuser-win", position: "center",
			head: "Liên kết tài khoản SSO",
			body: {
				paddingY: 10,
				paddingX: 10,
				//elementsConfig:{labelWidth: 120}, 
				view: "form",
				id: "listuser-form",
				complexData: true,
				elements: [
					{ view: "text", id: "email_sso", name: "email_sso", placeholder: "Nhập địa chỉ Email SSO", label: "Email", required: true, invalidMessage: "Email để trống hoặc nhập không đúng định dạng!",validate: webix.rules.isEmail, labelPosition: "top" },
					{ view: "text", id: "otp",name: "otp", disabled:true, label: "Mã OTP", labelPosition: "top" },
					{
						margin: 10,
						cols: [
							{},
							{
								view: "button", id: "btn-sendOtp", label: "Gửi OTP", type: "form", align: "center", width: 120, click: function () {

									var form = webix.$$("listuser-form");

									if (form.validate() == false) {
										return;
									}

									var item = form.getValues();	
									webix.ajax()
										.post(app.config.host + "/Account/GenerateOtpSSO", item, function (text) {
											var data = JSON.parse(text);
											if (!data.hasOwnProperty("error")) {
												
											    $$("confirm-link-btn").enable();
												$$("otp").enable();
												$$("email_sso").disable();
												$$("btn-sendOtp").setValue("Gửi lại OTP");
												webix.message("Gửi yêu cầu thành công!", "success");
											}
											else {
												webix.message(data.error, "error");
											}
										} 
										);
								}
							},
							{
								view: "button", id: "confirm-link-btn", label: "Xác nhận liên kết", type: "success", align: "center", disabled: true, width: 120, click: function () {

									var form = webix.$$("listuser-form");

									if (form.validate() == false) {
										return;
									}

									var item = form.getValues();

									if (item.otp == null||item.otp == "") {
										webix.message("Mã OTP không được để trống!", "error");
										return;
									}
									webix.extend(form, webix.ProgressBar);
									form.disable();
									form.showProgress();
									webix.ajax()
										.post(app.config.host + "/Account/VerifyOtpSSO", item, function (text) {
											
											
											var data = JSON.parse(text);
											if (!data.hasOwnProperty("error")) {
												webix.$$("listuser-win").close();
												//webix.message("Liên kết thành công!", "success");
												var baseUrl = document.location.href;
												if (baseUrl.startsWith("file")) {
													webix.storage.local.remove("appCookie");
												} else {
													Cookies.remove("appCookie");
												}
												webix.modalbox({
													title: "LIÊN KẾT THÀNH CÔNG!",
													text: "Quý khách vui lòng đăng nhập bằng tài khoản SSO để tiếp tục sử dụng dịch vụ.",
													buttons: ["OK"],
													callback: function() {
														document.location.reload();
													}
												});
											}
											else {
												webix.message(data.error, "error");
											}
											form.enable();
											form.hideProgress();
										} 
									);
								}
							},
							{
								view: "button", label: "Hủy bỏ (ESC)", hotkey: "esc", type: "danger", align: "center", width: 120, click: function () {
									webix.$$("listuser-win").close();
								}
							}
						]
					}

				]
			}
		},
		$oninit: function () {
            // Load data from API and fill the form
			var apiUrl = app.config.sso + "/partner/getInfo";
			webix.ajax().get(apiUrl, function (text) {
				var userData = JSON.parse(text);
				var userInfo = userData.result.userInfo;
				var form = $$("listuser-form");
				form.setValues(userInfo);
            });
        }
	};

});
define('views/menus/profile',["models/user", "views/forms/changepass", "locale", "helpers/uiVariant", "views/forms/chat", "views/hotroform", "views/menus/version", "views/forms/link_sso"], function (user, changepass, _, uiVariant, chat, hotroform, version, link_sso) {
    var data = [
        { id: "1", icon: "mdi mdi-key", value: "USER" },
        { id: "changepasssso", icon: "mdi mdi-key", value: _("CHANGE_PASS_SSO") },
        { id: "changepass", icon: "mdi mdi-key", value: _("CHANGE_PASS") },
        { id: "link_sso", icon: "mdi mdi-link", value: _("LINK_SSO") },
        { id: "delcache", icon: "mdi mdi-settings", value: _("DEL_CACHE") },
        { id: "signOut", icon: "mdi mdi-logout", value: _("LOGOUT") },
    ];

    if (uiVariant.isSwitchAvailable()) {
        data.splice(data.length - 1, 0, {
            id: "switchUI",
            icon: "mdi mdi-swap-horizontal",
            value: uiVariant.getSwitchLabel(),
        });
    }

    var cookie = user.getAppCookie();
    var id_token = "";
    // Ktra xem có hiển thị link SSO không
    if ((cookie.id_token != null && cookie.id_token != "") || (cookie != null && cookie.is_link_sso == true)) {
        id_token = cookie.id_token;
        data = data.filter(function(item) {
            return item.id !== "link_sso";
        });
    }
    else{
        data = data.filter(function(item) {
            return item.id !== "changepasssso";
        });
    }
    return {
        $ui: {
            view: "popup",
            id: "profilePopup",
            css: "profilePopup",
            resize: true,
            autofit: true,
            minHeight: 300,
            minWidth: 300,
            body: {
                view: "list",
                select: true,
                datatype: "json",
                css: "profile",
                data: data,
                template: function (obj) {
                    if (obj.value == "USER") {
                        var k =
                            "<div item_id='id' class='custom_profile'>" +
                            "<p><i class='fas fa-user-circle fa-lg'></i><span style='margin-left:8px;'> " +
                            user.getCurrentUser() +
                            "</span></p><br>" +
                            // + "<p><b>Tên công ty: </b>1</p></br>"
                            // + "<p><b>Mã số thuế: </b>2</p></br>"
                            "<p>Phiên bản: 1.0.0.0</p></br>" +
                            "<p>Copyrights © 2021 Phần mềm Hóa đơn điện tử MobiFone Invoice</p></br>" +
                            "<a style ='float:right;text-decoration: none;color:blue;' onclick=\"var menu=$$('app:menu'); menu.$scope.show('./infocompany');\" >Xem thêm</a>" +
                            "</div>" +
                            "</div>";
                        return k;
                    } else {
                        return "<span style ='color: #475466' class='webix_icon alerts " + obj.icon + "' ></span><span> " + obj.value + "</span>";
                    }
                },
                type: {
                    height: "auto",
                },
                // view: "submenu",
                // id: "profilePopup",
                // width: 200,
                // padding: 0,
                // data: [
                // 	/* {id: 1, icon: "user", value: "Thông tin cá nhân"},
                // 	{id: 2, icon: "cog", value: "Thông tin tài khoản"},
                // 	{id: 3, icon: "calendar", value: "Lịch làm việc"},
                // 	{id: 5, icon: "tasks", value: "Nhiệm vụ"},
                // 	{ $template:"Separator" }, */
                // 	{ id: "changepass", icon: "mdi mdi-key", value: _("CHANGE_PASS") },
                // 	{ id: "delcache", icon: "mdi mdi-settings", value: _("DEL_CACHE") },
                // 	{ $template: "Separator" },
                // 	// { id: "hotro", icon: "mdi mdi-ambulance", value: _("MobiFone Invoice Hỗ trợ") },
                // 	// { id: "chat", icon: "mdi mdi-comment-account-outline", value: _("MobiFone Invoice Chat") },
                // 	// { $template: "Separator" },
                // 	{ id: "signOut", icon: "mdi mdi-logout", value: _("LOGOUT") }

                // ],
                // type: {
                // 	template: function (obj) {
                // 		if (obj.type)
                // 			return "<div class='separator'></div>";
                // 		return "<span style ='color: #475466' class='webix_icon alerts " + obj.icon + "' ></span><span> " + obj.value + "</span>";
                // 	}
                // },
                on: {
                    onItemClick: function (id, e, node) {
                        this.hide();

                        if (id == "signOut") {
                            user.logout();
                            // document.location.reload();

                            /* require(["app"], function(app){
								app.router(app.config.start);
							}); */
                        }

                        if (id == "changepasssso") {
                            window.open("https://auth-sso.mobifone.vn/vn/profile-information", "_blank");
                        }

                        if (id == "changepass") {
                            var win = this.$scope.ui(changepass.$ui);
                            win.show();
                        }

                        if (id == "link_sso") {
                            var win = this.$scope.ui(link_sso.$ui);
                            win.show();
                        }

                        if (id == "hotro") {
                            var json = version.getInfocompany();

                            var win = this.$scope.ui(hotroform.$ui);
                            hotroform.initUI(json);
                            win.show();
                        }

                        if (id == "chat") {
                            var win = this.$scope.ui(chat.$ui);
                            win.show();
                        }

                        if (id == "delcache") {
                            webix.storage.local.remove("APP_CACHE");
                            webix.storage.local.put("APP_CACHE", {});

                            webix.message("Đã xóa cache dữ liệu", "debug");
                        }

                        if (id == "switchUI") {
                            uiVariant.switchVariant();
                        }
                    },
                },
            },
        },
    };
});

// JavaScript source code
define('views/menus/notify',["app", "models/user"], function (app, user) {
    var checkDataEmpty = 0;
    var dataList = new webix.DataCollection({
        data: [],
    });

    return {
        $ui: {
            view: "popup",
            id: "notifyPopup",
            css: "notifyPopup",
            resize: true,
            autofit: true,
            minHeight: 250,
            minWidth: 300,
            body: {
                view: "list",
                select: true,
                datatype: "json",
                css: "profile",
                // url: {
                //     $proxy: true,
                //     load: function (view, callback, params) {
                //         var url = app.config.host + "/Invoice68/GetInvoiceNotify";

                //         return webix.ajax(url, callback, view);

                //         //webix.ajax().get(app.config.host + "/Invoice68/GetInvoiceNotify", function (text) {
                //         //    var listcerts = JSON.parse(text);
                //         //    if (listcerts.length > 0) {
                //         //        return listcerts;
                //         //    }
                //         //    else {
                //         //        var itemEmpty = {
                //         //            tgian_gui: null,
                //         //            contentnotify: "Không có dữ liệu để hiển thị."
                //         //        };
                //         //        listcerts.push(itemEmpty);
                //         //        return listcerts;
                //         //    }
                //         //    //return webix.ajax(url, callback, view);
                //         //});
                //     }
                // },
                template: function (obj) {
                    if (obj.tgian_gui != null) {
                        return "<div><p style='margin-bottom: 0px !important; margin: 0 0 10px; font-size: 14px;'><b>" + obj.contentnotify + "</b></p></div>" + "<div><p style='margin-bottom: 0px !important; margin: 0 0 10px'>" + obj.tgian_gui + "</p></div>";
                    }
                    else {
                        document.getElementsByClassName("notifyPopup")[0].style.height = "80px";
                        return "<div><p style='margin-bottom: 0px !important; margin: 0 0 10px; font-size: 14px;'><b>" + obj.contentnotify + "</b></p></div>";
                    }
                },
                type: {
                    height: "auto",
                },
                on: {
                    onAfterLoad: function () {
                        document.getElementsByClassName("notifyPopup")[0].style.borderRadius = "8px";
                    },
                },
                data: dataList
            },
        },
        showNotify: function() {
            if(dataList && dataList.count() == 0) {
                webix.ajax().get(app.config.host + "/Invoice68/GetInvoiceNotify", function (text) {
                    var listcerts = JSON.parse(text);
                    if (listcerts.length > 0) {
                        dataList.parse(listcerts);
                        document.getElementsByClassName("notifyPopup")[0].style.borderRadius = "8px";
                    }
                });
            } 
        }
    };
});

define('views/menus/menubar',["app"], function (app) {
	webix.Touch.enable();
	return {
		$ui: {
			view: "menu",
			id: "app:menu",
			url: app.config.host + "/System/GetMenuBar",
			autowidth: true,
			css: { "background": "#005EB2", "padding-top": "0px" },
			openAction:"click",
			template: function (obj) {
				var html = '<div class="menubar">'
					+ '<div class="menubarimg">'
					+ ' ' + obj.icon
					+ '</div>'
					+ '<div>' + obj.value + '</div>'
					+ '</div>'
				return html;
			},
			width:1200,
			on: {
				onMenuItemClick: function (id) {
					var item = this.getMenuItem(id);

					if (item.url != "") {
						var win = window.open(item.url, '_blank');
						win.focus();
						return;
					}

					if (item.code == "") return;
					if (item.code == "dashboard") {
						$$("head-title").define("hidden", true);
					}
					else {
						$$("head-title").show();
					}

					var start = item.window_id != "" ? item.code + ":" + item.window_id : item.code;
					this.$scope.show("./" + start);

					var _URL = window.location.href;
					if (!_URL.includes(item.window_id)) {
						$$("head-title").removeView("tlbParams");
						webix.$$("title").parse({ title: item.value, details: item.details });
					}
					if (item.code == "tinhhinhsudung" || item.code == "bangkebanra") {
						$$("head-title").removeView("tlbParams");
						webix.$$("title").parse({ title: item.value, details: item.details });
					}
				}
			},
			type: {
				subsign: true
			}
		},
		getApiHost: function () {
			return app.config.host;
		}
	};

});
// icon button with count marker
webix.protoUI({
	name:"icon",
	$skin:function(){
		this.defaults.height = webix.skin.$active.inputHeight;
	},
	defaults:{
		template:function(obj){
			var html = "<button style='height:100%;width:100%;line-height:"+obj.aheight+"px' class='webix_icon_button'>";
			html += "<span class='webix_icon fa-"+obj.icon+"'></span>";
			if(obj.value)
				html += "<span class='webix_icon_count'>"+obj.value+"</span>";
			html += "</button>";
			return html;
		},
		width:33
	},
	_set_inner_size:function(){

	}
}, webix.ui.button);
define("views/webix/icon", function(){});

// Type for left menu
webix.type(webix.ui.tree, {
	name:"menuTree",
	height: 40,
	icon:function(obj, common){
		var html = "";
		/*var open = "";
		for (var i=1; i<=obj.$level; i++){
			if (i==obj.$level && obj.$count){
				var dir = obj.open?"down":"right";
				html+="<span class='"+open+" webix_icon fa-angle-"+dir+"'></span>";
			}
		}*/
		return html;
	},
	folder:function(obj, common){
		if(obj.icon)
			return "<span class='webix_icon icon fa-"+obj.icon+"'></span>";
		return "";
	}
});
webix.type(webix.ui.tree, {
	name:"menuTree2",
	height: 40,

	icon:function(obj, common){
		var html = "";
		var open = "";
		for (var i=1; i<=obj.$level; i++){
			if (i==obj.$level && obj.$count){
				var dir = obj.open?"down":"right";
				html+="<span class='"+open+" webix_icon fa-angle-"+dir+"'></span>";
		    }
		}
		return html;
	},
	folder:function(obj, common){
		if(obj.icon)
			return "<span class='webix_icon icon fa-"+obj.icon+"'></span>";
		return "";
	}
});
define("views/webix/menutree", function(){});

define('views/app',[
    "views/modules/minvoiceplugin",
    "views/menus/search",
    "views/menus/profile",
    "views/menus/notify",
    //"views/menus/sidebar",
    "views/menus/menubar",
    "models/user",
    "views/menus/version",
    // "views/menus/notification",
    "views/webix/icon",
    "views/webix/menutree",
], function (plugin, search, profile, notify, menuBar, user, version) {
    var apiHost = menuBar.getApiHost();

    webix.attachEvent("onBeforeAjax", function (mode, url, data, request, headers, files, promise) {
        var token = user.getAccessToken();

        if (token == null) {
            webix.message("Authorization has been denied for this request.", "error");
            user.logout();
            document.location.reload();
        }

        var dvcs = user.getDvcsID();

        var language = user.getLanguage();

        var bear = token + ";" + dvcs + ";" + language;

        headers["Authorization"] = "Bear " + bear;
    });

    webix.attachEvent("onLoadError", function (text, xml, ajax, owner) {
        console.log(text);
        console.log(xml);
        console.log(ajax);
        console.log(owner);

        if (text != undefined) {
            //console.log(text);
            var json = JSON.parse(text);

            if (json.Message == "Authorization has been denied for this request.") {
                webix.message(json.Message, "Hết hạn phiên đăng nhập!");
                user.logout();
                var baseUrl = document.location.href;
                if (baseUrl.startsWith("file")) {
                    webix.storage.local.remove("appCookie");
                } else {
                    Cookies.remove("appCookie");
                }
                document.location.reload();
            }
        }
    });

    //Top toolbar
    var mainToolbar = {
        css: { "background-color": "#005EB2 !important" },
        view: "toolbar",
        elements: [
            {
                height: 40,
                id: "person_template",
                css: "header_person",
                view: "template",
                borderless: true,
                width: 250,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var url = apiHost + "/System/ExecuteCommand";

                        var parameters = {};

                        parameters.command = "CM00010";
                        parameters.parameter = {
                            code: user.getDvcsID(),
                        };

                        webix.ajax().bind(view).headers({ "Content-type": "application/json" }).post(url, parameters, callback);
                    },
                },

                template: function (obj) {
                    var html = "<a class='bell-notify' style='float: left;padding: 0px 16px;' onclick='webix.$$(\"notifyPopup\").show(this)'><i class='fas fa-bell size-bell-notify' style='font-size: 24px;'></i></div></a>";
                    html += "<div style='height:100%;float:left;' onclick='webix.$$(\"profilePopup\").show(this)'>";
                    html += "<span data-toggle='tooltip' data-placement='top' title='" + user.getCurrentUser() + "'><i class='fas fa-user-circle fa-3x'></i></span>";
                    html += "</div>";
                    html += "<div class='mainToolbar' ><b>" + obj.name + "</b><br /><i>MST: " + obj.tax_code + "</i></div>";
                    return html;
                },
            },
        ],
    };

    var body = {
        rows: [
            { height: 2 },
            {
                id: "head-title",
                css: { "background-color": "#f5f5f5 !important" },
                hidden: true,
                cols: [
                    {
                        height: 30,
                        id: "title",
                        css: "title",
                        width: 360,
                        view: "template",
                        template: "<span><div class='header'>#title#</div><div class='details'></div></span>",
                        data: { text: "", title: "Trang chủ", details: "Phân tích và thống kê" },
                    },
                ],
            },
            {
                view: "scrollview",
                css: "bodycolor",
                body: {
                    cols: [{ $subview: true }],
                },
            },
        ],
    };
    var logoName = "LogoAppMinvoice.jpg";

    webix.ajax().sync().get(apiHost + "/System/GetLogo", function (text) {
        try {
            logoName = JSON.parse(text);
            if (logoName === "" || logoName === null || logoName === undefined) {
                logoName = "LogoAppMinvoice.jpg";
            }
        } catch (e) {
            logoName = "LogoAppMinvoice.jpg";
        }
    });

    var layout = {
        rows: [
            {
                cols: [
                    {
                        view: "label",
                        css: { background: "#005EB2" },
                        label: "<a href='https://mobifone.vn/' target='_blank'><img class='photo' src='assets/imgs/" + logoName + "' /></a>",
                        width: 150,
                    },
                    {
                        css: { background: "#005EB2" },
                        view: "scrollview",
                        scroll: "x",
                        body: menuBar,
                    },
                    mainToolbar,
                ],
            },
            body,
        ],
    };

    return {
        $ui: layout,
        $menu: "app:menu",
        $oninit: function (view, scope) {
            scope.ui(search.$ui);
            scope.ui(profile.$ui);
            scope.ui(notify.$ui);
            // scope.ui(notification.$ui);

            var js = version.getInfocompany();
            document.title = js.tax_code + " - " + js.name;

            if(webix.$$("notifyPopup")) {
                var popup = webix.$$("notifyPopup");
                popup._originalShow = popup.show;

                // Ghi đè hàm show
                popup.show = function() {
                    this._originalShow.apply(this, arguments);
                    notify.showNotify();
                };
            }
        },
    };
});

define('views/forms/bangkebanra',[
    "app",
    "locale",
    "models/user"
], function (app, _, user) {
    var editmode = 0;

    var date = new Date();
    var _month = date.getMonth() + 1;
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    function subviewT() {
        $$('cbQuy').define('label', "Tháng");
        $$('cbQuy').refresh();
        $$('cbQuy').define('options', ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
        //webix.extend(config, $$('cbQuy').config);
        //webix.ui(config, $$('cbThang'));
        //$$('cbThang').destructor();
    }

    function subviewQ() {

        $$('cbQuy').define('label', "Quý");
        $$('cbQuy').refresh();
        $$('cbQuy').define('options', ["1", "2", "3", "4"]);
        // webix.extend($$('cbQuy').config, config, true);
        //webix.ui(config, $$('cbQuy'));
        //$$('cbQuy').destructor();
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Bảng kê bán ra",
            width: 550,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 60 },
                view: "form",
                id: "bangkebr",
                complexData: true,
                margin: 0,
                elements: [
					{
                        view: "multicombo",
                        label: _("DONVI"),
                        name: "lst_branch_code",
                        labelWidth: 80,
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00198"                                
                            }
                        }                        
                    },
                    {
                        cols: [
                            {
                                view: "radio",
                                id: "head_extension",
                                value: 1,
                                options: [
                                    { "id": 1, "value": "Tháng" }, // the initially selected item
                                    { "id": 2, "value": "Quý" }
                                ],
                                on: {
                                    onChange: function (newv, oldv) {
                                        var d = new Date();
                                        var quarter = Math.floor((d.getMonth() / 3));
                                        var quarter1 = quarter + 1;
                                        if (newv == 2) {
                                            subviewQ();
                                            $$("cbQuy").setValue(quarter1);
                                        }
                                        if (newv == 1) {
                                            subviewT();
                                            $$("cbQuy").setValue(d.getMonth() + 1);
                                        }
                                    }
                                }
                            },
                            {
                                id: "cbQuy",
                                name: "quy",
                                view: "combo",
                                label: "Tháng",
                                value: _month,
                                options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
                                on: {
                                    onChange: function () {
                                        var d = new Date();
                                        var quarter = Math.floor((d.getMonth() / 3));
                                        var quarter1 = quarter + 1;

                                        var option = $$('head_extension').getValue();
                                        if (option == 2) {
                                            var nam = d.getFullYear();
                                            var thang;
                                            var quy = $$("cbQuy").getValue();
                                            if (quy == 1) {
                                                thang = 0;
                                            }
                                            if (quy == 2) {
                                                thang = 3;
                                            }
                                            if (quy == 3) {
                                                thang = 6
                                            }
                                            if (quy == 4) {
                                                thang = 9
                                            }
                                            var firstDate = new Date(nam, thang, 1);
                                            var lastDate = new Date(nam, thang + 3, 0);

                                            $$("tu_ngay").setValue(firstDate);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDate);
                                            $$("den_ngay").refresh();
                                        }
                                        if (option == 1) {
                                            var year = d.getFullYear();
                                            var month = $$("cbQuy").getValue();
                                            var date1 = month + "/01" + "/" + year;

                                            var date = new Date(date1);
                                            var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                                            var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                                            $$("tu_ngay").setValue(firstDay1);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDay1);
                                            $$("den_ngay").refresh();
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    {
                        view: "datepicker", label: _("TU_NGAY"), name: "tu_ngay", id: "tu_ngay", value: firstDay, labelWidth: 80
                    },
                    {
                        view: "datepicker", label: _("DEN_NGAY"), name: "den_ngay", id: "den_ngay", value: lastDay, labelWidth: 80
                    },
                    {
                        view: "multicombo",
                        label: _("KY_HIEU"),
                        name: "ky_hieu",
                        labelWidth: 80,
                        // required: true,
                        // invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
                        // validate: webix.rules.isNotEmpty,
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00050",
                                //template: webix.template("#value#")
                            }
                        }
                        //value: "2"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", width: 100, type: "form", align: "center",
                                on: {
                                    onClick: function () {
                                        var form = this.getParentView().getParentView();
                                        var win = this.getTopParentView();

                                        var item = form.getValues();
                                        var load_event = "loadBangkebanra";

                                        app.callEvent(load_event, [item]);

                                        win.close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", width: 100, align: "center", type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }

        },

        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            form.setValues(item);
        }
    };

});

define('views/bangkebanra',["app", "locale", "models/user", "views/forms/bangkebanra"], function (app, _, user, bangkebanra) {
    

    var op = [];

    webix.$$("title").parse({ title: "Bảng kê bán ra", details: "Báo cáo bảng kê bán ra hóa đơn" });

    var controls = [
        {
            id: "btnReload",
            view: "button",
            type: "icon",
            icon: "fas fa-refresh",
            css: "webix_secondary",
            label: _("REFRESH"),
            width: 95,
            on: {
                onClick: function () {
                    var wininfoparam = this.$scope.ui(bangkebanra.$ui);
                    wininfoparam.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnPrint",
            view: "button",
            type: "icon",
            icon: "fas fa-print",
            css: "webix_secondary",
            label: _("PRINT") + " PDF",
            width: 70,
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;

                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";
                    //console.log(rpParameter);
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(
                                app.config.host + "/Bcthsd/PrintPDFBangKeBanRa",
                                rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/pdf" });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.open(fileURL, "_blank");
                                    },
                                }
                                // function (text, data) {
                                //     var file = new Blob([data], { type: 'application/pdf' });
                                //     var fileURL = URL.createObjectURL(file);
                                //     webix.modalbox.hide(box);
                                //     window.open(fileURL, '_blank');
                                // }
                            );
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnExport",
            view: "button",
            type: "icon",
            css: "webix_secondary",
            icon: "fas fa-file",
            label: _("EXPORT_EXCEL"),
            width: 120,
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(
                                app.config.host + "/Bcthsd/PrintPDFBangKeBanRa",
                                rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                        //var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        //window.location.href = fileURL;
                                        webix.html.download(file, "BangKeBanRa.xlsx");
                                    },
                                }
                                // function (text, data) {

                                //     var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                //     var fileURL = URL.createObjectURL(file);

                                //     window.location.href = fileURL;
                                // }
                            );
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var grid = {
        rows: [
            {
                container: "testA",
                view: "treetable",
                id: "bangkebanra",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                fixedRowHeight: false,
                rowLineHeight: 25,
                rowHeight: 25,
                // on: {
                //     onResize: function () {
                //         this.adjustRowHeight("ghi_chu", true);
                //         this.render();
                //     }
                // },
                columns: [
                    {
                        id: "stt",
                        header: "<center>STT</center>",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "so_hd",
                        header: [{ text: "<center>Hóa đơn chứng từ bán</center>", colspan: 2 }, { text: "<center>Số hóa đơn</center>" }],
                        width: 500,
                        template: function (obj, common) {
                            if (obj.$level == 1) return common.treetable(obj, common) + "<span style='color:blue;'>" + obj.value + " ( " + obj.$count + " )" + "</span>";
                            return obj.so_hd;
                        },
                    },
                    {
                        id: "ngay_hd",
                        header: [null, { text: "<center>Ngày hóa đơn</center>" }],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    { id: "inv_buyerlegalname", header: "<center>Tên người mua</center>", width: 300 },
                    // {
                    //     header: "<center>Trạng thái</center>", width: 150, template: function (obj) {
                    //         if (obj.$group == true) return "";
                    //         return "<span class='hotro_status" + obj.trang_thai + "'>" + obj.trang_thai + "</span>"
                    //     }
                    // },
                    { id: "ms_thue", header: "<center>Mã số thuế</center>", width: 150 },
                    {
                        id: "tien_tt0",
                        header: "<center>Doanh thu chưa có thuế GTGT</center>",
                        width: 200,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                    },
                    {
                        id: "tien",
                        header: "<center>Thuế GTGT</center>",
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                    },
                    { id: "ghi_chu", header: "<center>Ghi chú</center>", width: 150 },
                    // {
                    //     id: "nhom", header: "Nhóm", width: 500
                    // }
                    // {
                    //     id: "ngay_thuchien", header: "Ngày thực hiện", width: 150, format: function (text) {
                    //         var format = webix.Date.dateToStr("%d/%m/%Y");
                    //         text = removeTimeZoneT(text);
                    //         return format(text);
                    //     }
                    // }
                ],
                pager: "pagerA",
                scheme: {
                    $group: {
                        by: "nhom",
                        //,css:{ "text-align": "right" }
                        // map:{
                        // 	nguoi_lien_he:["nguoi_lien_he", "count"]
                        // }
                    },
                    //$sort: { by: "stt", dir: "asc" }
                },
                ready: function () {
                    //this.open(this.getFirstId());
                    //this.sort({ by: "stt", dir: "asc" });
                    this.openAll();
                    this.adjustRowHeight("ghi_chu", true);
                    this.refresh();
                },
                //url: app.config.host + "/System/ExecuteQuery?sql=" + sql
                //autoheight: true,
                //autowidth:true,
                //data: big_film_set
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "loadBangkebanra", function (item) {
                var table = $$("bangkebanra");
                // webix.extend(table, webix.OverlayBox);
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();

                table.config.rpParameter = item;

                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .post(app.config.host + "/Bcthsd/bangkebanra", item, {
                        error: function (text, data, XmlHttpRequest) {
                            table.enable();
                            table.hideProgress();
                            alert(text);
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var json = JSON.parse(text);
                            if (!json.hasOwnProperty("error")) {
                                //console.log(json);
                                $$("bangkebanra").clearAll();
                                $$("bangkebanra").parse(json);
                                $$("bangkebanra").refresh();
                            } else {
                                webix.message(json.error, "error");
                            }
                            table.enable();
                            table.hideProgress();
                        },
                    });
            });
        },
    };
});

define('views/forms/infowindow',[
	"app",
	"locale",
	"models/user"
], function (app, _, user) {
	var editmode = 0;

	var _date = new Date();
	var _month = _date.getMonth() + 1;
	function subviewT() {
		$$('cbQuy').define('label', "Tháng");
		$$('cbQuy').refresh();
		$$('cbQuy').define('options', ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
		//webix.extend(config, $$('cbQuy').config);
		//webix.ui(config, $$('cbThang'));
		//$$('cbThang').destructor();
	}

	function subviewQ() {

		$$('cbQuy').define('label', "Quý");
		$$('cbQuy').refresh();
		$$('cbQuy').define('options', ["1", "2", "3", "4"]);
		// webix.extend($$('cbQuy').config, config, true);
		//webix.ui(config, $$('cbQuy'));
		//$$('cbQuy').destructor();
	}

	return {
		$ui: {
			view: "window",
			modal: true,
			position: "center",
			head: "Thông tin Tab",
			resize: true,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 60 },
				view: "form",
				complexData: true,
				margin: 0,
				elements: []
			}

		},
		initUI: function (infoWindowId) {

			debugger
			var url = app.config.host + "/System/ExecuteCommand";

			var parameters = {
				command: "CM00013",
				parameter: {
					wb_infowindow_id: infoWindowId
				}
			};

			webix.ajax().headers({ "Content-Type": "application/json" })
				.post(url, parameters, function (response) {
					var result = JSON.parse(response);

					var win = webix.$$(infoWindowId);

					win.define("width", result[0].window_width);
					win.define("height", result[0].window_height);

					var form = win.getChildViews()[1];
					form.clear();

					var view_extension = {
						cols: [
							{
								view: "radio",
								id: "head_extension",
								value: 1,
								options: [
									{ "id": 1, "value": "Tháng" }, // the initially selected item
									{ "id": 2, "value": "Quý" }
								],
								on: {
									onChange: function (newv, oldv) {
										var d = new Date();
										var quarter = Math.floor((d.getMonth() / 3));
										var quarter1 = quarter + 1;
										if (newv == 2) {
											subviewQ();
											$$("cbQuy").setValue(quarter1);
										}
										if (newv == 1) {
											subviewT();
											$$("cbQuy").setValue(d.getMonth() + 1);
										}
									}
								}
							},
							{
								id: "cbQuy",
								name: "quy",
								view: "combo",
								label: "Tháng",
								//height: 30,
								value: _month,
								options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
								on: {
									onChange: function () {
										var d = new Date();
										var quarter = Math.floor((d.getMonth() / 3));
										var quarter1 = quarter + 1;

										var option = $$('head_extension').getValue();
										if (option == 2) {
											var nam = d.getFullYear();
											var thang;
											var quy = $$("cbQuy").getValue();
											if (quy == 1) {
												thang = 0;
											}
											if (quy == 2) {
												thang = 3;
											}
											if (quy == 3) {
												thang = 6
											}
											if (quy == 4) {
												thang = 9
											}
											var firstDate = new Date(nam, thang, 1);
											var lastDate = new Date(nam, thang + 3, 0);

											$$(win.config.id + "_tu_ngay").setValue(firstDate);
											$$(win.config.id + "_tu_ngay").refresh();
											$$(win.config.id + "_den_ngay").setValue(lastDate);
											$$(win.config.id + "_den_ngay").refresh();
										}
										if (option == 1) {
											var year = d.getFullYear();
											var month = $$("cbQuy").getValue();
											var date1 = month + "/01" + "/" + year;

											var date = new Date(date1);
											var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

											var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
											$$(win.config.id + "_tu_ngay").setValue(firstDay1);
											$$(win.config.id + "_tu_ngay").refresh();
											$$(win.config.id + "_den_ngay").setValue(lastDay1);
											$$(win.config.id + "_den_ngay").refresh();
										}
									}
								}
							}
						]
					};

					var formValues = {};

					var rows_max = result[0].rows_max;

					var el = [];

					for (var i = 1; i <= rows_max; i++) {
						el.push({ cols: [] });
					}

					for (var i = 0; i < result.length; i++) {

						var field = result[i];

						var row = field.row;

						var item = {
							view: field.type_editor,
							name: field.name,
							label: _(field.caption),
							width: field.width,
							labelPosition: field.label_position,
							labelWidth: field.label_width,
							format: field.format,
							hidden: field.hidden == "C" ? true : false,
							id: win.config.id + "_" + field.name
						};

						if (field.name === "lst_branch_code") {   
							item.on = {
								onChange: function (newValue, oldValue) {
									var urlLoad = app.config.host +
										"/System/GetDataReferencesByRefIdAndBranchs?refId=RF0001111&branchs=" +
										newValue;

									var form = this.getFormView(); 
									var target = form.queryView({ name: "lst_user" }); 
									
									if (target) {
										var comp = target.getPopup().getList();
										comp.clearAll();
										comp.load(urlLoad);
									}
								}
							};
						}

						if (field.default_value != null) {
							var defaultValue = field.default_value;

							var date = new Date();
							var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
							var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

							if (defaultValue.startsWith("@Default=")) {
								defaultValue = defaultValue.replace("@Default=", "");
								if (defaultValue == "MA_DVCS" || defaultValue == "BRANCH_CODE") {
									item.value = user.getDvcsID();
								}
								else if (defaultValue == "USER") {
									item.value = user.getCurrentUser();
								}
								else if (defaultValue == "MA_CT") {
									item.value = "MA_CT";
								}
								else if (defaultValue == "FIRST_DATE") {
									item.value = firstDay;
								}
								else if (defaultValue == "LAST_DATE") {
									item.value = lastDay;
								}
								else {
									item.value = defaultValue;
								}
							}
						}

						if (item.hidden == true) {
							formValues[item.name] = item.value;
							continue;
						}

						if (item.view == "combo" || item.view == "multiselect") {
							item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.wb_references_id;
						}

						if (item.view == "multicombo"){
							item.suggest= {
								selectAll: true,
								body: {
									url: app.config.host + "/System/GetDataByReferencesId?id=" + field.wb_references_id                                
								}
							};
						}

						if (item.view == "radio") {
							var ajax = webix.ajax();
							ajax.master = {
								radio_id: item.id,
								win_id: win.config.id
							};

							ajax.get(app.config.host + "/System/GetDataByReferencesId?id=" + field.wb_references_id, function (text) {
								var json = JSON.parse(text);
								var radio = $$(this.radio_id);
								radio.define("options", json);
								radio.refresh();

								$$(this.win_id).resize();
							});
						}

						if (item.view == "treesuggest") {

							//item.REF_ID = field.REF_ID.toString();
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							item.view = "combo";
							item.options = {
								view: "treesuggest",
								url: {
									$proxy: true,
									load: function (view, callback, params) {
										var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

										webix.ajax(url, function (text) {
											var json = JSON.parse(text);
											var data = listToTree(json);
											view.parse(data, "json");
										});

									}
								},
								body: {
									columns: listColumns,
									refid: field.wb_references_id,
									filterMode: {
										level: false,
										showSubItems: false
									}
								}
							};
						}

						if (item.view == "gridcombo") {

							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							item.view = "combo";
							item.options = {
								view: "gridsuggest",
								url: app.config.host + "/api/System/GetDataByReferencesId?id=" + field.wb_references_id,
								body: {
									columns: listColumns,
									refid: field.wb_references_id
								}
							};
						}

						if (item.view == "gridsuggest") {
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							item.view = "text";
							item.suggest = {
								view: "gridsuggest",
								value_suggest: field.value_suggest,
								body: {
									columns: listColumns,
									refid: field.wb_references_id,
									datatype: "json",
									dataFeed: function (filtervalue, filter) {
										if (filtervalue.length < 3) return;

										var refid = this.config.refid;
										var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
										var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

										this.load(pathUrl + "&" + urldata, this.config.datatype);
									},

								},
								on: {
									onValueSuggest: function (obj) {
										if (this.config.value_suggest != null) {
											var fn = Function("obj", "id", this.config.value_suggest);
											fn(obj, this.config.id);
										}
									}
								}
							};
						}

						if (item.name == "tu_ngay") {
							item.value = firstDay;
						}

						if (item.name == "den_ngay") {
							item.value = lastDay;
						}

						formValues[item.name] = item.value;
						el[row - 1].cols.push(item);
					}

					form.setValues(formValues);

					var buttons = {
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Lưu (F10)",
								width: 120,
								type: "form", align: "center",
								on: {
									onClick: function () {
										var form = this.getParentView().getParentView();
										var win = this.getTopParentView();

										var item = form.getValues();
										// xóa header ngày tháng trong sproc ko cần
										delete item.quy;
										var load_event = win.config.load_event == null ? "loadReport" : win.config.load_event;

										app.callEvent(load_event, [win.config.report_id, win.config.id, item, win.config.menuitem]);

										win.close();
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)",
								width: 120,
								align: "center", type: "danger",
								click: function () {
									this.getTopParentView().close();
								}
							},
							{}
						]
					};

					el.push(buttons);

					webix.ui(el, form);
					if ($$(win.config.id + "_tu_ngay") != undefined && $$(win.config.id + "_den_ngay") != undefined) {
						form.addView(view_extension, 0);
					}
					win.getHead().setHTML(result[0]["window_name"]);

					//win.config.height= result[0]["WINDOW_HEIGHT"];
					//win.config.width= result[0]["WINDOW_WIDTH"];

					if (win.config.editmode != null) {
						if (win.config.editmode == 1) {
							form.setValues(win.config.formvalues);
						}
					}

					//win.resize();

				});
		},
		setEditMode: function (mode) {
			editmode = mode;
		},
		setValues: function (item) {
			var win = $$(this.$ui.id);
			var form = win.getChildViews()[1];

			form.setValues(item);
		}
	};

});

define('views/forms/editwindow',[
	"app",
	"locale",
	"models/user"
],function(app,_,user){
	var editmode = 0;	
    var tables = [];

	var windowno = app.path[1].params[0];
    var col=[];
	var rw =[];					
	var el = [];
	var head_name=[];
	var head;
	var url = app.config.host + "/System/GetAllByWindowNo?window_id=" + windowno;

	function setParentValue(windowId){

		var win = $$(windowId);
		var form = win.getChildViews()[1];							
		var item = form.getValues();
		var valueField = win.config.valueField;

		if (win.config.editorId == null){
			var table = $$(win.config.tableId);
			var selectedItem = table.getSelectedItem();

			selectedItem[win.config.columnName] = item[valueField];			

			if (win.config.fieldExpression!=null){
				var fields = win.config.fieldExpression.split(';');

				for(var i=0;i<fields.length;i++){
					var field = fields[i].replace("{","").replace("}","");
					var array = field.split(":");

					selectedItem[array[1]] = item[array[0]];
				}
			}

			table.updateItem(selectedItem.id,selectedItem);

		}
		else {
			var editor = $$(win.config.editorId);
						

			editor.setValue(item[valueField]);

			if (win.config.fieldExpression!=null){
				var formParent = $$(win.config.formId);
				var parentItem = formParent.getValues(); 

				var fields = win.config.fieldExpression.split(';');

				for(var i=0;i<fields.length;i++){
					var field = fields[i].replace("{","").replace("}","");
					var array = field.split(":");

					parentItem[array[1]] = item[array[0]];
				}

				formParent.setValues(parentItem);
			}
		}
		

	}
		    
	return {		
		$ui:{
			view:"window", modal:true, id:"editwindow-win", position:"center",
			//width:800,
			head:"Thông tin khách hàng",
			//fullscreen:true,			
			body:{
                paddingY:10, 
                paddingX:10, 
                view:"form", 
				id:"editwindow-form", 
				complexData:true,
				margin:0,
                elements:el				
			}			
		},	
		initUI: function(windowconfig) {
			
			var rp = windowconfig;
			var max_row = rp['data'][0]['max_row'];
			var vc_window = rp["data"][0];
			var tabs = vc_window.Tabs;

			var win = $$(vc_window.code);

			if (typeof win.showProgress === "undefined")
				webix.extend(win, webix.ProgressBar);
			
			el = [];
			col = [] ;			

			if (vc_window.width==null && vc_window.height==null){
				win.config.fullscreen = true;				
			}

			if (vc_window.after_save!=null){
				win.config.after_save = vc_window.after_save;
			}

			for(var i=1;i<=max_row;i++){
				el.push({ cols:[]});
			}

			var fields = rp['data'][0]['Tabs'][0]['Fields'];

			for(var i=0;i<fields.length;i++){
				
				var field = fields[i];				
				
				if (field.hidden == true){
					continue;
				}

				var row = field.row;

				var item = {
					view: field.type_editor, 
					name: field.column_name,
					label: _(field.column_name), 
					id: field.column_name+"_"+rp['data'][0]['Tabs'][0]["tab_table"],
					width: field.width,
					labelPosition: field.label_position,
					labelWidth: field.label_width,
					format: field.format,
					css:field.css,
					value_change: field.value_change,
					on:{
						
					}
				};

				if (field.caption!=null){
					item.label = _(field.caption);
				}

				if (field.readonly == "C"){
					item.readonly = true;
				}
				
				if (item.view == "combo"){
					item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id
				}						

				if (item.view == "checkbox"){
					if (field.label_position == "right"){
						item.labelRight = _(field.column_name) ;
						item.label = "";							
					}

					if (field.column_type == "char" || field.column_type == "nvarchar" || field.column_type == "nchar" ){
						item.checkValue = "C";
						item.uncheckValue = "K";
					}

					if (field.COLUMN_TYPE == "int"){
						item.checkValue = "1";
						item.uncheckValue = "0";
					}

					if (field.COLUMN_TYPE == "bit"){
						item.checkValue = true;
						item.uncheckValue = false;
					}
				}
				
				if (item.view == "autonumeric"){
					item.inputAlign ="right";
				}

				if (item.view == "treesuggest"){
					
					var listColumns = JSON.parse(field.list_column);

					for(var v=0;v<listColumns.length;v++){
						listColumns[v].header =_(listColumns[v].id);
					}
					
					item.view = "combo";
					item.options = {
						view: "treesuggest",
						url: {
							$proxy:true,
							load:function(view, callback, params){
									var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

									webix.ajax(url, function(text){
										var json = JSON.parse(text);
										var data = listToTree(json);
										view.parse(data,"json");
									});
									
							}
						},
						body: {
							columns: listColumns,
							refid: field.ref_id,
							filterMode:{
								level:false,
								showSubItems:false
							}						
						}
					};

					item.on.onKeyPress = function(code, e){
						if (e.code == "F4"){
							alert("Moi");
						}
					};
				}

				if (item.view == "gridcombo"){
					
					var listColumns = JSON.parse(field.list_column);

					for(var v=0;v<listColumns.length;v++){
						listColumns[v].header =_(listColumns[v].id);
					}
					
					item.view = "combo";
					item.options = {
						view: "gridsuggest",
						url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
						body: {
							columns: listColumns,
							refid: field.ref_id												
						}
					};

					item.on.onKeyPress = function(code, e){
						if (e.code == "F4"){
							alert("Moi");
						}
					};
				}

				if (item.view == "gridsuggest"){
					var listColumns = JSON.parse(field.list_column);

					for(var v=0;v<listColumns.length;v++){
						listColumns[v].header =_(listColumns[v].id);
					}

					item.view = "text";
					item.suggest = {
						view: "gridsuggest",
						value_suggest: field.value_suggest,
						body:{
							columns:listColumns,
							refid: field.ref_id,
							datatype:"json",
							dataFeed: function(filtervalue, filter){
								if(filtervalue.length<3) return;

								var refid = this.config.refid;
								var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
								var urldata = "filtervalue="+encodeURIComponent(filtervalue);
								
								this.load(pathUrl+"&"+urldata, this.config.datatype);
							},
							
						},
						on: {
							onValueSuggest: function(obj){
								if (this.config.value_suggest!=null){								
									var fn = Function("obj","id",this.config.value_suggest);
									fn(obj,this.config.id);
								}
							}							
						}
					};

					item.on.onKeyPress = function(code, e){
						
					};
				}

				if (field.valid_rule!=null){
					var rule = field.valid_rule;

					if (rule == "isNotEmpty"){
						item.required = true;
						item.invalidMessage = item.label + " không được bỏ trống";
						item.validate = webix.rules.isNotEmpty;
					}

					if (rule == "isSpecialCharacter"){
						item.required = true;
						item.invalidMessage = item.label + " không được bỏ trống (a-z,A-Z,0-9)";
						item.validate = webix.rules.isSpecialCharacter;
					}

					if (rule == "isEmail"){
						item.invalidMessage = item.label + " không hợp lệ";
						item.validate = webix.rules.isEmail;
					}

					if (rule == "isTaxCode"){
						item.invalidMessage = item.label + " không hợp lệ";
						item.validate = webix.rules.isTaxCode;
					}
				}

				if (item.value_change!=null || item.css!=null || item.validate!=null){
					item.on.onChange = function(newv,oldv){

							if (this.config.validate!=null && editmode!=0 && oldv!=undefined && newv!= undefined){
								this.validate();
						    }

						   if (this.config.css!=null){
							   if (this.config.css == "mcls_uppercase" && newv !== undefined && oldv!== undefined ){
								   if (newv.toUpperCase()!=oldv.toUpperCase()){
									 webix.$$(this.config.id).setValue(newv.toUpperCase());
								   }
									
							   }
						   }

							if (this.config.value_change!=null){
								
								var fn = Function("newv","oldv","id",this.config.value_change);
								fn(newv,oldv,this.config.id);
							}
						}
				}
				

				el[row-1].cols.push(item);
								
			}
			
			if (vc_window.window_type == "MasterDetail"){

				var cells = [];

                for(var i=0;i<tabs.length;i++){
                    var tab = tabs[i];

                    if (tab.tab_type == "Master"){
                        continue;
                    }

                    var subCols = [];

                    for(var j=0;j<tab.Fields.length;j++){
                        var field = tab.Fields[j];

                        var subCol = {
                            id: field.column_name, 
							header: field.caption!=null ? _(field.caption) : _(field.column_name),
							editor: field.type_editor,
							hidden: field.hidden,
							value_change: field.value_change
						};
						

                        if (field.column_type == "date" || field.column_type == "datetime" ){
                            subCol.format = function(text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);                            
                                return format(text);
                            };
						}

						if (field.column_type == "decimal"){
							subCol.css = { "text-align": "right" };
							subCol.format = webix.Number.numToStr({
												groupDelimiter:",",
												groupSize:3,
												decimalDelimiter:".",
												decimalSize:0
											});
						}
						
						
                        
                        if (field.column_width == null){
                            subCol.fillspace = true;
                        }
                        else {
                            subCol.width = field.column_width;
						}

						if (field.type_editor == "combo"){
							subCol.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id
						}

						if (field.type_editor == "datepicker"){
							subCol.editor = "date";
						}
						
						if (field.type_editor == "treesuggest"){
							var listColumns = JSON.parse(field.list_column);

							for(var v=0;v<listColumns.length;v++){
								listColumns[v].header =_(listColumns[v].id);
							}
							
							var popup = webix.ui({
								view:"treesuggest",								
								body:{
									columns: listColumns,
									refid: field.ref_id,
									url: {
										$proxy:true,
										load:function(view, callback, params){
												var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

												webix.ajax(url, function(text){
													var json = JSON.parse(text);
													var data = listToTree(json);
													view.parse(data,"json");
												});
												
										}
									},
									filterMode:{
										level:false,
										showSubItems:false
									}	
								}
							});											

							subCol.popup = popup;
							subCol.editor = "combo";
							
						}

						if (field.type_editor == "gridcombo"){
							var listColumns = JSON.parse(field.list_column);

							for(var v=0;v<listColumns.length;v++){
								listColumns[v].header =_(listColumns[v].id);
							}
							
							var popup = webix.ui({
								view:"gridsuggest",								
								body:{
									columns: listColumns,
									refid: field.ref_id,
									url: app.config.host + "/System/GetDataByReferencesId?id=" + field.REF_ID								
								}
							});											

							subCol.popup = popup;
							subCol.editor = "combo";
							
						}

						if (field.type_editor == "gridsuggest"){
							var listColumns = JSON.parse(field.list_column);

							for(var v=0;v<listColumns.length;v++){
								listColumns[v].header =_(listColumns[v].id);
							}

							subCol.editor = "text";
							subCol.suggest = {
								view: "gridsuggest",
								value_suggest: field.value_suggest,
								body:{
									columns:listColumns,
									refid: field.ref_id,									
									datatype:"json",
									dataFeed: function(filtervalue, filter){
										if(filtervalue.length<3) return;

										var refid = this.config.refid;
										var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
										var urldata = "filtervalue="+encodeURIComponent(filtervalue);
										
										this.load(pathUrl+"&"+urldata, this.config.datatype);
									}
								},
								on: {
									onValueSuggest: function(obj){
										if (this.config.value_suggest!=null){								
											var fn = Function("obj","id",this.config.value_suggest);
											fn(obj,this.config.id);
										}
									}
									
								}
							}

							
						}
                        
                        subCols.push(subCol);
                    }

                    if (tab.tab_type=="Detail"){
                        var item = {
                            header: tab.name,
                            select: "cell",
                            body: {
								rows:[
									{
										view:"toolbar",
										height:25,
										cols:[
											{
												view:"icon",
												icon:"plus",
												on: {
													onItemClick: function(id,e){
														var parentView = this.getParentView().getParentView();
														var childViews = parentView.getChildViews();

														for(var i=0;i<childViews.length;i++){
															var childview = childViews[i];

															if (childview.config.view=="datatable"){
																var table = childview;

																var item = {
																	id: webix.uid()
																};

																var vc_window = windowconfig['data'][0];																
																var tabs = vc_window.Tabs;															

																for(var i=0;i<tabs.length;i++){
																	var tab = tabs[i];
																	if (tab.tab_type == "Detail"){
																		var fields=tab.Fields;

																		for(var j=0;j<fields.length;j++){
																			var field = fields[j];

																			if (field.column_name == "ma_dvcs"){
																				item[field.column_name] = user.getDvcsID();
																			}

																			
																			
																			if (field.default_value!=null){
																				var defaultValue = field.DEFAULT_VALUE.toString();

																				if (defaultValue.startsWith("@Default=")){
																					item[field.column_name] = defaultValue.replace("@Default=","");
																				}
																				
																				if (defaultValue.startsWith("@JS=")){
																					var fn = Function(defaultValue.replace("@JS=",""));
																					item[field.column_name] = fn();
																				}
																			}
																		}
																	}
																}								
																

																table.add(item);

																break;
															}
														}
														
													}
												}
											},
											{
												view:"icon",
												icon:"minus",
												on: {
													onItemClick: function(id,e){
														var parentView = this.getParentView().getParentView();
														var childViews = parentView.getChildViews();

														for(var i=0;i<childViews.length;i++){
															var childview = childViews[i];

															if (childview.config.view=="datatable"){
																var table = childview;

																table.editStop();

																var item = table.getSelectedItem();
												
																if (!webix.isUndefined(item)){
																	table.remove(item.id);
																	table.clearSelection();
																	return;
																}

																var editor = table.getEditState();

																if (!webix.isUndefined(editor)){
																	table.remove(editor.row);
																	table.clearSelection();
																	return;
																}

																break;
															}
														}
														
													}
												}
											}
										]
									},
									{
										view: "datatable",
										id:"edit_"+tab.table_name,
										tab_table: tab.table_name,
										tab_id: tab.code,
										editable:true,
										select: "cell",
										select_change: tab.select_change,
										columns: subCols,
										on:{
											onAfterEditStop:function(state, editor, ignore){												
												if (editor.config.value_change!=null){
													var selectedItem = null;

													if (typeof editor.getPopup === "function") { 
														var popup = editor.getPopup();
													
														if (popup!=null){
															var list = popup.getList();

															if (list!=null){
																selectedItem = list.getSelectedItem();
															}
														}
													}
													
													var fn = Function("newv","oldv","id","selectedItem",editor.config.value_change);
													fn(state.value,state.old,editor.config.id,selectedItem);
												}

											},
											onKeyPress: function(code,e){
												var table = this;

												if (e.key == "F4"){
													var editor = table.getEditState();

													if (!webix.isUndefined(editor)){
														alert("test")
														return;
													}
												}
											},
											onSelectChange:function(){
												var selectedItem = this.getSelectedId();
												
												if (this.config.select_change!=null){
													var fn = Function("selectedItem",this.config.select_change);
													fn(selectedItem);
												}
											}
										}
									}
								]
                                
                            }
                        };

                        cells.push(item);
                    }
				}
				
                var subview = {
                    borderless:true,
                    view:"tabview",
                    scrollX:true,
					cells: cells,
					tabbar:{
						width:200
					}					
				};

				if (vc_window.width!=null || vc_window.height!=null){
					subview.height = 250;
				}

				//el.push(subview);
				
				if (vc_window.tab_row!=null){
					el[vc_window.tab_row-1]=subview;
				}
				else {
					el.push(subview);
				}
				
            }
			
			var cols = [
				{},
				{ 
					shortcut:"F10",  
					view:"button", label:"Nhận (F10)", type:"form", align:"center", 
					width:100,
					on: {
						onClick: function() {
							var parent = this.getTopParentView();
							var form = parent.getChildViews()[1];

							if (form.validate()==false){
								return;
							}
							
							var item = form.getValues();
							
							var khData={};

							khData.windowid=String(rp['data'][0]['code']);
							khData.editmode=editmode;
							khData.data=[];

							var vc_window = rp['data'][0];

							if (vc_window.window_type == "MasterDetail"){
								
								var tabs = vc_window.Tabs;
								var details = [];

								for(var i=0;i<tabs.length;i++){
									var tab = tabs[i];

									if (tab.tab_type == "Detail"){
										var table = webix.$$("edit_"+tab.table_name);
										
										details.push({
											tab_id: tab.code,
											tab_table: tab.table_name,
											data: table.serialize()
										});
									}
								}

								item["details"] = details;
							}							
							
							khData.data.push(item);
							
							this.getTopParentView().disable();
							this.getTopParentView().showProgress();
							
							webix.ajax()
								.headers({'Content-type':'application/json'})
								.post( app.config.host + "/System/Save", khData, function(text){									
							
									var json = JSON.parse(text);

									$$(json.windowid).enable();
									$$(json.windowid).hideProgress();
												
									if (!json.hasOwnProperty("error")){
										var after_save = $$(json.windowid).config.after_save;

										if (after_save!=null){
											var fn = Function("editmode","data",after_save);
											fn(editmode,json.data);
										}
										
										setParentValue(json.windowid)

										$$(json.windowid).close();										
									}
									else {
										webix.message(json.error);
									}
									
									
								});	
							
						}
					},
					click:function(){								
						this.callEvent("onClick");							
											
					},
				},
				{ 
					view:"button", shortcut:"esc", label:"Hủy bỏ (ESC)", type:"danger", align:"center",
					width:100,
					on:{
						onClick: function(){
							this.getTopParentView().close();
						}
					},
					click:function(){
						this.callEvent("onClick");
					}
				},
				{}
			];			
			
			el.push({
				margin:10,
				cols:cols
			});
			
			webix.ui(el, $$("editwindow-form"));
			
			win.getHead().setHTML(windowconfig.data[0].name);
		},		
		setEditMode: function(mode) {
			editmode = mode;
		},		
		setValues: function(item,winconfig){

			var form = webix.$$("editwindow-form");
			var vc_window = winconfig['data'][0];

			if (item == null){
				var tabs = vc_window.Tabs;
				
				item = {};

                for(var i=0;i<tabs.length;i++){
                    var tab = tabs[i];
                    if (tab.tab_type == "Normal" || tab.tab_type == "Master"){
                        var fields=tab.Fields;

                        for(var j=0;j<fields.length;j++){
							var field = fields[j];
							
							if (field.column_name == "ma_dvcs"){
								item[field.column_name] = user.getDvcsID();
							}

							                            
                            if (field.default_value!=null){
                                var defaultValue = field.default_value.toString();

                                if (defaultValue.startsWith("@Default=")){
                                    item[field.column_name] = defaultValue.replace("@Default=","");
								}
								
								if (defaultValue.startsWith("@JS=")){
									var fn = Function(defaultValue.replace("@JS=",""));
									item[field.column_name] = fn();
								}
                            }
                        }
                    }
				}
				
				form.setValues(item);
			}
			else {

				form.setValues(item);				

				if (vc_window.window_type == "MasterDetail"){
					var tabs = vc_window.Tabs;

					for(var i=0;i<tabs.length;i++){
						var tab = tabs[i];

						if (tab.tab_type == "Master")
						{
							continue;
						}

						var table = webix.$$("edit_"+tab.tab_table);

						var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id="+ vc_window.window_id
										+"&id="+item.id + "&tab_table="+tab.tab_table;
						table.clearAll();
						table.load(url);
						
					}
				}
			}
		}		
	};

});
define('views/forms/selectwindow',[
	"app",
	"locale"
],function(app,_){

	return {		
		$ui:{   
			view:"window", modal:true, id:"select-win", position:"center",
			head:"Thông tin Tab",
			fullscreen:true,
			body:{
                rows:[
					{
						height:35,
						type: "toolbar",
						cols:[
							{
								view: "button", 
								type: "icon", 
								icon:"check-square", 
								label: "Chọn" ,
								width:65,								
								on: {
									onClick: function(){
										var win = this.getTopParentView();

										var valueField = win.config.valueField;
										var displayField = win.config.displayField;
										var fieldExpression = win.config.fieldExpression;
										var table= win.getChildViews()[1].getChildViews()[1];

										if (win.config.editorId!=null){

											if (valueField!=null){									
												var selectedItem = table.getSelectedItem();
												var editor = $$(win.config.editorId);
												editor.setValue(selectedItem[valueField]);
											}

											if (displayField !== undefined){
												if (displayField!=null){
													var selectedItem = table.getSelectedItem();
													var editor = $$(win.config.editorId);
													editor.setValue(selectedItem[displayField]);
												}
											}

											if (fieldExpression!=null){
												var formParent = $$(win.config.formId);
												var parentItem = formParent.getValues(); 
												var selectedItem = table.getSelectedItem();
												var fields = fieldExpression.split(';');

												for(var i=0;i<fields.length;i++){
													var field = fields[i].replace("{","").replace("}","");
													var array = field.split(":");

													parentItem[array[1]] = selectedItem[array[0]];
												}

												formParent.setValues(parentItem);
												$$(win.config.editorId).focus();
											}
										}
										else {
											var tableParent = $$(win.config.tableId);
											var columnName = win.config.columnName;
											var item = tableParent.getSelectedItem();

											if (valueField!=null){									
												var selectedItem = table.getSelectedItem();
												item[columnName] = selectedItem[valueField];												
											}

											if (displayField !== undefined){
												if (displayField!=null){
													var selectedItem = table.getSelectedItem();
													item[columnName] = selectedItem[displayField];
												}
											}

											if (fieldExpression!=null){												
												var selectedItem = table.getSelectedItem();
												var fields = fieldExpression.split(';');

												for(var i=0;i<fields.length;i++){
													var field = fields[i].replace("{","").replace("}","");
													var array = field.split(":");

													item[array[1]] = selectedItem[array[0]];
												}												
											}

											tableParent.updateItem(item);
											//webix.UIManager.setFocus(tableParent.config.id);
											//tableParent.edit({row: item.id, column: columnName});	
										}										

										this.getTopParentView().close();
										if (win.config.tableId!=null){
											webix.UIManager.setFocus(win.config.tableId);
										}
										
									}
								},
								click: function(){                
									this.callEvent("onClick");
								}
							},
							{
								view: "button", 
								type: "icon", 
								icon:"close", 
								label: "Thoát" ,
								width:65,								
								on: {
									onClick: function(){
										this.getTopParentView().close();										
									}
								},
								click: function(){                
									this.callEvent("onClick");
								}
							}

						]
					},
					{
						view: "datatable",
						select: "row",
						datafetch: 50,
						on:{
							onKeyPress: function(code,e){
								var table = this;

								if (e.key == "Enter"){
									var win = this.getTopParentView();
									var toolbar= win.getChildViews()[1].getChildViews()[0];

									var btnChon = toolbar.getChildViews()[0];
									btnChon.callEvent("onClick");
								}
							}
						},
						pager : "selectPagerA"
					},
					{
						id: "selectPagerA",
						view:"pager",
						size: 50,
						group: 5,
						template:"{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
					}
				]
			}				
			
		},
		initUI: function(windowconfig){
			var win=$$("select-win");

			var table= win.getChildViews()[1].getChildViews()[1];
			table.clearAll();

			var vc_window = windowconfig["data"][0];
			var tabs = vc_window.Tabs;

			var masterTab = tabs[0];

			var fields = windowconfig['data'][0]['Tabs'][0]['Fields'];
			var cols = [];

			for(var i=0;i<masterTab.Fields.length;i++){
				var field = masterTab.Fields[i];

				if(field.hide_in_grid==true){
					continue;
				}			
					
				var item = {
					id: field.column_name, 
					header: _(field.caption),
					columnType: field.column_type 					
				};

				if (field.type_filter!=null){
                    if (field.type_filter!=""){
                        item.header = [_(item.header), { content: field.type_filter}]
                    }
                }

				if (field.column_width == null){
					item.fillspace = true;
				}
				else {
					item.width = field.column_width;
				}

				if (field.type_editor == "combo"){
					item.editor = field.type_editor;
					item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                }

				cols.push(item);
			}

			table.config.columns = cols;			
			table.refreshColumns();
			
			table.config.windowno = vc_window.window_id;

			var url = {
                    $proxy:true,
                    load:function(view, callback, params){                        
                        var windowno = view.config.windowno;
						var url = app.config.host + "/System/GetDataByWindowNo";
						
						var parameters = {
							window_id: windowno
						};

                        if (params==null){
														
							parameters["start"] = 0;
							parameters["count"] = view.config.datafetch;
							parameters["continue"] = null;
							parameters["filter"] = [];
							parameters["infoparam"] = null;
							parameters["tlbparam"] = [];

                        }
                        else {
                            							
							parameters["start"] = params.start;
							parameters["count"] = params.count;
							parameters["continue"] = params.continue;
							parameters["filter"] = [];
							parameters["infoparam"] = null;
							parameters["tlbparam"] = [];

                            if (params.filter!=null){
                                var array=[];

                                for(var property in params.filter){

                                    var column = view.getColumnConfig(property);

                                    if (column !== undefined){
                                         var item = {
                                            columnName : property,
                                            columnType : column.columnType,
                                            value: params.filter[property]
                                        };

                                        array.push(item);
                                    }
                                    
                                   
								}
								
								parameters["filter"] = array;                            
                                
                            }
                                                       
                        }

                        if (view.config.infoparam!=null){
							parameters["infoparam"] = view.config.infoparam;
                        }
						
						webix.ajax().bind(view)
							.headers({"Content-Type": "application/json"})
							.post(url, parameters, callback);
                        
                    }
            };
				
			table.define("url",url );
		}		
	};

});
define('models/findjson',[

], function () {


    return {
        // findAndReplace: function findAndReplace(object, value, replacevalue) {
        //     for (var x in object) {
        //         if (object.hasOwnProperty(x)) {
        //             if (typeof object[x] == 'object') {
        //                 findAndReplace(object[x], value, replacevalue);
        //             }
        //             if (object[x] == value) {
        //                 object["name"] = replacevalue;
        //                 // break; // uncomment to stop after first replacement
        //             }
        //         }
        //     }
        // },
        getObjects: function getObjects(obj, key, val) {
            var objects = [];
            for (var i in obj) {
                // console.log(obj);
                if (!obj.hasOwnProperty(i)) continue;
                if (typeof obj[i] == 'object') {
                    objects = objects.concat(getObjects(obj[i], key, val));
                } else
                    //if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
                    if (i == key && obj[i] == val || i == key && val == '') { //
                        objects.push(obj);
                    } else if (obj[i] == val && key == '') {
                        //only add if the object is not already in the array
                        if (objects.lastIndexOf(obj) == -1) {
                            objects.push(obj);
                        }
                    }
            }
            return objects;
        },
        findAndReplace: function findAndReplace(object, value, item) {

            for (var x in object) {

                if (typeof object[x] == typeof {}) {
                    findAndReplace(object[x], value, item);
                }
                //nếu tìm thấy name bằng với name của item truyền vào trong object thì thay thế object[name] bằng item
                if (object[x] == value) {
                    //console.log(object);
                    webix.extend(object, item, true);
                    //object["name"] = value[i];
                    // object[element] = replacevalue;
                    //object["name"] = replacevalue;
                    // break; // uncomment to stop after first replacement
                }
            }
            return object;
        },
        //return an array of values that match on a certain key
        getValues: function getValues(obj, key) {
            var objects = [];
            for (var i in obj) {
                if (!obj.hasOwnProperty(i)) continue;
                if (typeof obj[i] == 'object') {
                    objects = objects.concat(getValues(obj[i], key));
                } else if (i == key) {
                    objects.push(obj[i]);
                }
            }
            return objects;
        },

        //return an array of keys that match on a certain value
        getKeys: function getKeys(obj, val) {
            var objects = [];
            for (var i in obj) {
                if (!obj.hasOwnProperty(i)) continue;
                if (typeof obj[i] == 'object') {
                    objects = objects.concat(getKeys(obj[i], val));
                } else if (obj[i] == val) {
                    objects.push(i);
                }
            }
            return objects;
        }

    };

});
define('views/forms/window',["app", "locale", "models/user", "views/forms/editwindow", "views/forms/selectwindow", "models/findjson"], function (app, _, user, editwindow, selectwindow, findJson) {
    var editmode = 0;
    var tables = [];

    var windowno = app.path[1].params[0];
    var col = [];
    var rw = [];
    var el = [];
    var head_name = [];
    var head;
    var url = app.config.host + "/System/GetAllByWindowNo?window_id=" + windowno;
    var parentCodeParam = null;

    function calculateColumn(tableId, columnId, type, fieldId) {
        var table = $$(tableId);
        var result = 0;

        table.eachRow(function (row) {
            var value = Number(row[columnId]);

            if (type == "SUM") {
                result = result + value;
            }
        });

        $$(fieldId).setValue(result);
    }

    var setdsFieldFormat = function () {
        var url = app.config.host + "/Invoice68/GetDecimalPlaceAll";
        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .get(url, function (text) {
                var arr = JSON.parse(text);
                webix.storage.local.put("dsFieldFormatAll", arr);
            });
    }


    function showEditWindow(component, editmode) {
        var self = component;
        var suggest = $$(self.config.suggest);
        var refid = suggest.config.body.refid;
        var sql = {
            command: "SYS001",
            parameter: {
                REFID: refid,
            },
        };

        var url = app.config.host + "/System/ExecuteCommand";

        var win = self.getTopParentView();
        var form = win.getChildViews()[1];

        var editorId = self.config.id;
        var formId = form.config.id;

        var ajax = webix.ajax();

        ajax.master = {
            editorId: editorId,
            formId: formId,
            fieldExpression: self.config.fieldExpression,
            editmode: editmode,
            editorvalue: self.getValue(),
            suggest: self.config.suggest,
        };

        ajax.post(url, sql, function (text) {
            var json = JSON.parse(text);

            if (json.length > 0) {
                json[0].editorId = this.editorId;
                json[0].formId = this.formId;
                json[0].fieldExpression = this.fieldExpression;
                json[0].editmode = this.editmode;
                json[0].editorvalue = this.editorvalue;
                json[0].suggest = this.suggest;

                var windowno = json[0].windowno;

                var url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;
                var a = webix.ajax(url);
                url = app.config.host + "/System/GetRecordByReferencesId?id=" + json[0].wb_references_id + "&value=" + this.editorvalue;
                var b = webix.ajax(url);
                var c = this.editmode;
                var d = json[0];

                webix.promise.all([a, b, c, d]).then(function (results) {
                    var windowconfig = results[0].json();
                    var res_b = results[1].json();
                    var mode = results[2];
                    var master = results[3];

                    var vc_window = windowconfig["data"][0];

                    if (mode == 1) {
                        editwindow.$ui.id = vc_window.code;
                        editwindow.$ui.editorId = master.editorId;
                        editwindow.$ui.valueField = master.value_field;
                        editwindow.$ui.fieldExpression = master.fieldExpression;
                        editwindow.$ui.formId = master.formId;

                        var win = webix.ui(editwindow.$ui);

                        editwindow.initUI(windowconfig);
                        editwindow.setEditMode(mode);
                        editwindow.setValues(null, windowconfig);

                        $$(master.suggest).hide();
                        win.show();
                    } else {
                        if (res_b.length == 0) {
                            webix.alert({
                                title: "Thông báo",
                                text: "Không tìm thấy dữ liệu",
                            });

                            return;
                        }

                        var ajax = webix.ajax();

                        ajax.master = {
                            master: master,
                            vc_window: vc_window,
                        };

                        var url = app.config.host + "/System/GetDataById?window_id=" + vc_window.code + "&id=" + res_b[0].doc_id;

                        ajax.get(url, function (text) {
                            var json = JSON.parse(text);
                            var data = json;

                            var vc_window = this.vc_window;
                            var master = this.master;

                            editwindow.$ui.id = vc_window.code;
                            editwindow.$ui.editorId = master.editorId;
                            editwindow.$ui.valueField = master.value_field;
                            editwindow.$ui.fieldExpression = master.fieldExpression;
                            editwindow.$ui.formId = master.formId;

                            var win = webix.ui(editwindow.$ui);

                            editwindow.initUI(windowconfig);
                            editwindow.setEditMode(2);
                            editwindow.setValues(data, windowconfig);

                            $$(master.suggest).hide();
                            win.show();
                        });
                    }
                });
            }
        });
    }

    function tableShowEditWindow(table, editmode) {
        var editor = table.getEditState();

        if (!webix.isUndefined(editor)) {
            var suggest = $$(editor.config.suggest);
            var refid = suggest.config.body.refid;
            var sql = {
                command: "SYS003",
                parameter: {
                    refid: refid,
                },
            };
            //var sql = "SELECT a.*,b.code as WINDOWNO FROM #SCHEMA_NAME#.wb_references a INNER JOIN #SCHEMA_NAME#.wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='" + refid + "'";
            // var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;
            //var url = app.config.host + "/System/Query";
            var url = app.config.host + "/System/ExecuteCommand";
            var model = sql;
            var tableId = table.config.id;
            //console.log(tableId);
            var columnName = editor.config.id;

            var ajax = webix.ajax();

            ajax.master = {
                editorId: null,
                tableId: tableId,
                fieldExpression: suggest.config.fieldExpression,
                columnName: columnName,
                editmode: editmode,
                editorvalue: editor.getValue(),
                suggest: editor.config.suggest,
            };

            ajax.post(url, model, function (text) {
                var json = JSON.parse(text);

                if (json.length > 0) {
                    json[0].editorId = this.editorId;
                    json[0].tableId = this.tableId;
                    json[0].fieldExpression = this.fieldExpression;
                    json[0].columnName = this.columnName;
                    json[0].editmode = this.editmode;
                    json[0].editorvalue = this.editorvalue;
                    json[0].suggest = this.suggest;

                    var windowno = json[0].windowno;

                    var url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;
                    var a = webix.ajax(url);
                    url = app.config.host + "/System/GetRecordByReferencesId?id=" + json[0].wb_references_id + "&value=" + this.editorvalue;
                    var b = webix.ajax(url);
                    var c = this.editmode;
                    var d = json[0];

                    webix.promise.all([a, b, c, d]).then(function (results) {
                        var windowconfig = results[0].json();
                        var res_b = results[1].json();
                        var mode = results[2];
                        var master = results[3];

                        var vc_window = windowconfig["data"][0];

                        if (mode == 1) {
                            editwindow.$ui.id = vc_window.code;
                            editwindow.$ui.editorId = master.editorId;
                            editwindow.$ui.valueField = master.value_field;
                            editwindow.$ui.fieldExpression = master.fieldExpression;
                            editwindow.$ui.formId = master.formId;
                            editwindow.$ui.tableId = master.tableId;
                            editwindow.$ui.columnName = master.columnName;

                            var win = webix.ui(editwindow.$ui);

                            editwindow.initUI(windowconfig);
                            editwindow.setValues(null, windowconfig);
                            editwindow.setEditMode(mode);

                            $$(master.suggest).hide();
                            win.show();
                        } else {
                            if (res_b.length == 0) {
                                webix.alert({
                                    title: "Thông báo",
                                    text: "Không tìm thấy dữ liệu",
                                });

                                return;
                            }
                            var ajax = webix.ajax();

                            ajax.master = {
                                master: master,
                                vc_window: vc_window,
                            };

                            var url = app.config.host + "/System/GetDataById?window_id=" + vc_window.code + "&id=" + res_b[0].doc_id;

                            ajax.get(url, function (text) {
                                var json = JSON.parse(text);
                                var data = json;

                                var vc_window = this.vc_window;
                                var master = this.master;

                                editwindow.$ui.id = vc_window.code;
                                editwindow.$ui.editorId = master.editorId;
                                editwindow.$ui.valueField = master.value_field;
                                editwindow.$ui.fieldExpression = master.fieldExpression;
                                editwindow.$ui.formId = master.formId;
                                editwindow.$ui.tableId = master.tableId;
                                editwindow.$ui.columnName = master.columnName;

                                var win = webix.ui(editwindow.$ui);

                                editwindow.initUI(windowconfig);
                                editwindow.setValues(data, windowconfig);
                                editwindow.setEditMode(2);

                                $$(master.suggest).hide();
                                win.show();
                            });
                        }
                    });
                }
            });
        }
    }

    function generateGUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    var wb_excel_id = generateGUID();

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "window-win",
            position: "center",
            //width:800,
            head: "Thông tin khách hàng",
            //fullscreen:true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "window-form",
                complexData: true,
                keepViews: true,
                multiview: { keepViews: true },
                margin: 0,
                elements: el,
            },
        },
        initUI: function (windowconfig) {

            var rp = windowconfig;
            var max_row = rp["data"][0]["max_row"];
            var vc_window = rp["data"][0];
            var tabs = vc_window.Tabs;

            var win = $$(vc_window.code);

            if (typeof win.showProgress === "undefined") webix.extend(win, webix.ProgressBar);

            el = [];
            col = [];

            if (vc_window.width == null && vc_window.height == null) {
                win.config.fullscreen = true;
            }

            if (vc_window.after_save != null) {
                win.config.after_save = vc_window.after_save;
            }
            // nếu có layout_detail thì bindding layout vào el

            if (vc_window.detail_layout != null && vc_window.detail_layout != "") {
                var layoutdetail = JSON.parse(vc_window.detail_layout);

                var layout_element = JSON.stringify(layoutdetail.elements);
                var json_layout = JSON.parse(layout_element);
                //console.log(json_layout);
                for (var i = 0; i < json_layout.length; i++) {
                    el.push(json_layout[i]);
                }

                var jsonElement = findJson.getObjects(JSON.parse(JSON.stringify(el)), "id", "");

                for (var i = 0; i < jsonElement.length; i++) {
                    //var item = jsonElement[i];
                    var fields = rp["data"][0]["Tabs"][0]["Fields"];

                    for (var j = 0; j < fields.length; j++) {
                        var field = fields[j];

                        if (jsonElement[i].name == field.column_name) {
                            // if (field.hidden == true) {
                            //     continue;
                            // }

                            var item = {
                                view: field.type_editor,
                                resizeColumn: true,
                                //keepViews: true,
                                multiview: { keepViews: true },
                                name: field.column_name,
                                label: _(field.column_name),
                                id: field.column_name + "_" + rp["data"][0]["Tabs"][0]["table_name"],
                                width: field.width,
                                labelPosition: field.label_position,
                                labelWidth: field.label_width,
                                format: field.format,
                                value_change: field.value_change,
                                fieldExpression: field.field_expression,
                                data_width: field.data_width,
                                column_type: field.column_type,
                                css: field.css,
                                attributes: {},
                                on: {},
                                hidden: field.hidden,
                            };
                            if (field.type_editor == "password") {
                                item.view = "text";
                                item.type = "password";
                            }

                            if (item.data_width != null) {
                                if (item.data_width != 0) {
                                    item.attributes.maxlength = item.data_width;
                                    //style: "text-transform: uppercase;"
                                }
                            }

                            if (field.styleinput != null && field.styleinput != "") {
                                item.attributes.style = field.styleinput;
                            }

                            if (field.height != null) {
                                if (field.height != 0) {
                                    item.height = field.height;
                                }
                            }

                            if (field.caption != null) {
                                item.label = _(field.caption);
                            }

                            if (field.read_only == "C") {
                                item.readonly = true;
                            }

                            if (item.view == "combo") {
                                item.suggest = {
                                    body: {
                                        url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
                                    },
                                };
                                //item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                            }

                            if (item.view == "select") {
                                item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                            }
                            if (item.view == "checkbox") {
                                if (field.label_position == "right") {
                                    item.labelRight = _(field.column_name);
                                    item.label = "";
                                }

                                if (field.column_type == "char") {
                                    item.checkValue = "C";
                                    item.uncheckValue = "K";
                                }

                                if (field.column_type == "tinyint") {
                                    item.checkValue = "1";
                                    item.uncheckValue = "0";
                                }

                                if (field.column_type == "bit") {
                                    item.checkValue = true;
                                    item.uncheckValue = false;
                                }

                                 if (field.column_type == "boolean") {
                                    item.checkValue = 1;
                                    item.uncheckValue = 0;
                                }
                            }

                            if (item.view == "autonumeric" || field.column_type == "numeric") {
                                item.inputAlign = "left";
                                item.decimalPlaces = field.data_decimal;
                            }

                            if (field.valid_rule != null) {
                                var rule = field.valid_rule;

                                if (rule == "isNotEmpty") {
                                    item.required = true;
                                    item.invalidMessage = item.label + " không được bỏ trống";
                                    item.validate = webix.rules.isNotEmpty;
                                }

                                if (rule == "isSpecialCharacter") {
                                    item.required = true;
                                    item.invalidMessage = "Không bỏ trống hoặc ký tự không hợp lệ (a-z,A-Z,0-9)";
                                    item.validate = webix.rules.isSpecialCharacter;
                                }

                                if (rule == "isEmail") {
                                    item.invalidMessage = item.label + " không hợp lệ";
                                    item.validate = webix.rules.isEmail;
                                }

                                if (rule == "isTaxCode") {
                                    item.invalidMessage = item.label + " không hợp lệ";
                                    item.validate = webix.rules.isTaxCode;
                                }

                                if (rule == "isPositiveNumbers") {
                                    item.invalidMessage = item.label + " không hợp lệ";
                                    item.validate = webix.rules.isPositiveNumbers;
                                }
                            }

                            if (item.view == "treesuggest") {
                                //item.REF_ID = field.REF_ID.toString();
                                var listColumns = JSON.parse(field.list_column);

                                for (var v = 0; v < listColumns.length; v++) {
                                    listColumns[v].header = _(listColumns[v].id);
                                }

                                item.view = "combo";
                                item.options = {
                                    view: "treesuggest",
                                    textValue: field.display_field,
                                    url: {
                                        $proxy: true,
                                        load: function (view, callback, params) {
                                            var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

                                            webix.ajax(url, function (text) {
                                                var json = JSON.parse(text);
                                                var data = listToTree(json);
                                                view.parse(data, "json");
                                            });
                                        },
                                    },
                                    body: {
                                        columns: listColumns,
                                        refid: field.ref_id,
                                        filterMode: {
                                            level: false,
                                            showSubItems: false,
                                        },
                                    },
                                };

                                item.on.onKeyPress = function (code, e) {
                                    if (e.code == "F4") {
                                        alert("Moi");
                                    }
                                };
                            }

                            if (item.view == "gridcombo") {
                                var listColumns = JSON.parse(field.list_column);

                                for (var v = 0; v < listColumns.length; v++) {
                                    listColumns[v].header = _(listColumns[v].id);
                                }

                                item.view = "combo";
                                item.options = {
                                    view: "gridsuggest",
                                    url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
                                    body: {
                                        columns: listColumns,
                                        refid: field.REF_ID,
                                        textValue: field.display_field,
                                    },
                                };

                                item.on.onKeyPress = function (code, e) {
                                    if (e.code == "F4") {
                                        alert("Moi");
                                    }
                                };
                            }
                            // if (item.view == "search") {
                            // 	var express = item.fieldExpression;

                            // 	item.on.onSearchIconClick = function (e) {
                            // 		var form = $$(this.getFormView());

                            // 		//get value của form hiện tại để đổi giá trị
                            // 		var parentItem = form.getValues();

                            // 		var field_express = this.config.fieldExpression;
                            // 		var text = this.getValue();
                            // 		var datapost = { "masothue": text };
                            // 		var form = $$("window-form");
                            // 		webix.extend(form, webix.ProgressBar);
                            // 		form.disable();
                            // 		form.showProgress();
                            // 		webix.ajax()
                            // 			.headers({ 'Content-type': 'application/json' })
                            // 			.post(app.config.host + "/System/GetInfoMST", datapost, function (text) {

                            // 				var json = JSON.parse(text);

                            // 				if (!json.hasOwnProperty("error")) {
                            // 					if (field_express != null) {

                            // 						var fields = field_express.split(';');
                            // 						// tách json thành array
                            // 						for (var i = 0; i < fields.length; i++) {
                            // 							var field = fields[i].replace("{", "").replace("}", "");
                            // 							var array = field.split(":");

                            // 							parentItem[array[1]] = json[array[0]];

                            // 						}
                            // 						form.setValues(parentItem);
                            // 					}
                            // 					else {
                            // 						webix.message("FIELD_EXPRESSION IS NULL IN FIELD !", "error", 2000);
                            // 					}
                            // 				}
                            // 				else {
                            // 					// nếu không tồn tại mã số thuế phải xóa địa chỉ + tên cty ở đây
                            // 					webix.message(json.error, "error", 2000);
                            // 				}
                            // 				form.enable();
                            // 				form.hideProgress();
                            // 			});

                            // 	}
                            // }

                            if (item.view == "search") {
                                item.on.onSearchIconClick = function (e) {
                                    var form = $$(this.getFormView());

                                    //get value của form hiện tại để đổi giá trị
                                    var mst = this.getValue();
                                    // window.location.href = "http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst;
                                    window.open("http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst);
                                };
                            }

                            if (item.view == "gridsuggest") {
                                var listColumns = JSON.parse(field.list_column);

                                for (var v = 0; v < listColumns.length; v++) {
                                    listColumns[v].header = _(listColumns[v].id);
                                }

                                item.view = "search";
                                item.icon = "mdi mdi-plus";
                                item.on.onSearchIconClick = function (e) {
                                    showEditWindow(this, 1);
                                };
                                item.suggest = {
                                    view: "gridsuggest",
                                    autoheight: false,
                                    value_suggest: field.value_suggest,
                                    textValue: field.display_field,
                                    body: {
                                        columns: listColumns,
                                        refid: field.ref_id,
                                        scroll: true,
                                        autoheight: false,
                                        datatype: "json",
                                        textValue: field.display_field,
                                        dataFeed: function (filtervalue, filter) {
                                            if (filtervalue.length < 1) return;

                                            var refid = this.config.refid;
                                            var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                        },
                                    },
                                    on: {
                                        onValueSuggest: function (obj) {
                                            //console.log(obj);
                                            var master = $$(this.config.master);
                                            if (master.config.fieldExpression != null) {
                                                var win = master.getTopParentView();
                                                var form = win.getChildViews()[1];
                                                //console.log(form);
                                                var parentItem = form.getValues();
                                                //console.log(parentItem);
                                                var fields = master.config.fieldExpression.split(";");

                                                for (var i = 0; i < fields.length; i++) {
                                                    var field = fields[i].replace("{", "").replace("}", "");
                                                    var array = field.split(":");
                                                    //console.log(array);
                                                    parentItem[array[1]] = obj[array[0]];
                                                }

                                                form.setValues(parentItem);
                                            }

                                            if (this.config.value_suggest != null) {
                                                var fn = Function("obj", "id", this.config.value_suggest);
                                                fn(obj, this.config.id);
                                            }
                                        },
                                    },
                                };

                                item.on.onKeyPress = function (code, e) {
                                    if (e.code == "F2") {
                                        var suggest = $$(this.config.suggest);
                                        var refid = suggest.config.body.refid;

                                        suggest.hide();
                                        var sql = {
                                            command: "SYS004",
                                            parameter: {
                                                refid: refid,
                                            },
                                        };
                                        //var sql = "SELECT a.*,b.window_id as WINDOWNO FROM #SCHEMA_NAME#.wb_references a INNER JOIN #SCHEMA_NAME#.wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='" + refid + "'";
                                        //var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;
                                        var url = app.config.host + "/System/ExecuteCommand";

                                        var win = this.getTopParentView();
                                        var form = win.getChildViews()[1];

                                        var editorId = this.config.id;
                                        var formId = form.config.id;

                                        var a = webix.ajax().post(url, sql);
                                        var b = this.config.suggest;
                                        var c = this.config.id;
                                        var d = this.config.fieldExpression;
                                        var e = editorId;
                                        var f = formId;

                                        webix.promise.all([a, b, c, d, e, f]).then(function (results) {
                                            var res_a = results[0].json();

                                            var suggest = $$(results[1]);

                                            suggest.hide();

                                            var url = app.config.host + "/System/GetConfigWinByNo?id=" + res_a[0]["windowno"];

                                            var ajax = webix.ajax();
                                            ajax.master = {
                                                searchId: results[2],
                                                fieldExpression: d,
                                                valueField: res_a[0]["value_field"],
                                                formId: f,
                                                editorId: e,
                                            };

                                            ajax.get(url, function (text) {
                                                var windowconfig = JSON.parse(text);
                                                var txtSearch = $$(this.searchId);

                                                var win = txtSearch.$scope.ui(selectwindow.$ui);

                                                win.config.valueField = this.valueField;
                                                win.config.fieldExpression = this.fieldExpression;
                                                win.config.formId = this.formId;
                                                win.config.editorId = this.editorId;

                                                selectwindow.initUI(windowconfig);

                                                win.getHead().setHTML(windowconfig.data[0].name);
                                                win.show();
                                            });
                                        });

                                        var win = this.$scope.ui(selectwindow.$ui);
                                        win.show();
                                    }

                                    if (e.code == "F4" || e.code == "F3") {
                                        var editmode = e.code == "F3" ? 2 : 1;
                                        showEditWindow(this, editmode);
                                    }
                                };
                            }

                            if (item.value_change != null || item.css != null || item.validate != null) {
                                item.on.onChange = function (newv, oldv) {
                                    if (this.config.validate != null && editmode != 0) {
                                        this.validate();
                                    }

                                    if (this.config.css != null) {
                                        if (this.config.css == "mcls_uppercase" && newv !== undefined && oldv !== undefined) {
                                            if (newv.toUpperCase() != oldv.toUpperCase()) {
                                                webix.$$(this.config.id).setValue(newv.toUpperCase());
                                            }
                                        }
                                    }

                                    if (this.config.value_change != null) {
                                        var topParentView = this.getTopParentView();

                                        if (topParentView.config.editmode == 0) return;

                                        var fn = Function("newv", "oldv", "id", this.config.value_change);
                                        fn(newv, oldv, this.config.id);
                                    }
                                };
                            }

                            jsonElement[i] = item;
                            var finish_replace = findJson.findAndReplace(el, jsonElement[i].name, item);
                            // console.log(finish_replace);
                            //webix.extend(el,jsonElement[i],  true);
                        }
                    }
                }
                //console.log(jsonElement);
            } // nếu không có thì push vào el theo field
            else {
                // insert số dòng max của form

                // if (vc_window.code == "WIN00107") {
                //     el.push({
                //         view: "label",
                //         height: 80,
                //         template: "<div style='display:block; color: red; width: 480px !important; font-size: 16px; font-weight: bold; text-align: center; text-decoration: none; border: none;'>Chú ý: Khi thêm cấu hình, toàn bộ hóa đơn đã ký sẽ tự động gửi trực tiếp tới Cơ quan thuế, không gửi Bảng tổng hợp dữ liệu</div>"
                //     });
                // }
                for (var i = 1; i <= max_row; i++) {
                    el.push({ cols: [] });
                }

                var fields = rp["data"][0]["Tabs"][0]["Fields"];
                // field của tab master (đầu phiếu )

                for (var i = 0; i < fields.length; i++) {
                    var field = fields[i];

                    if (field.hidden == true) {
                        continue;
                    }

                    var row = field.row;

                    var item = {
                        view: field.type_editor,
                        resizeColumn: true,
                        multiview: { keepViews: true },
                        keepViews: true,
                        name: field.column_name,
                        label: _(field.column_name),
                        id: field.column_name + "_" + rp["data"][0]["Tabs"][0]["table_name"],
                        width: field.width,
                        labelPosition: field.label_position,
                        labelWidth: field.label_width,
                        format: field.format,
                        value_change: field.value_change,
                        fieldExpression: field.field_expression,
                        data_width: field.data_width,
                        column_type: field.column_type,
                        css: field.css,
                        detail_tab_id: vc_window.code + "_dtab",
                        attributes: {},
                        on: {},
                    };

                    if (field.type_editor == "password") {
                        item.view = "text";
                        item.type = "password";
                    }
                    webix.editors.$popup = {
                        date: {
                            view: "popup",
                            body: { view: "calendar", timepicker: true, icons: true },
                        },
                    };

                    if (field.type_editor == "datepicker" && field.column_type != "time") {
                        item.editor = "date";
                        item.format = function (text) {
                            if (text != null && text != undefined) {
                                var format = webix.Date.dateToStr("%d/%m/%Y %H:%i");
                                text = removeTimeZoneT(text);
                                return format(text);
                            }
                        };
                        item.timepicker = true;
                    }

                    if (field.type_editor == "datepicker" && field.column_type == "time") {
                        item.editor = "date";
                        item.type = "time";
                        item.format = "%H:%i";
                        item.timepicker = true;
                    }

                    if (item.data_width != null) {
                        if (item.data_width != 0) {
                            item.attributes.maxlength = item.data_width;
                            //style: "text-transform: uppercase;"
                        }
                    }

                    if (field.styleinput != null && field.styleinput != "") {
                        item.attributes.style = field.styleinput;
                    }

                    if (field.height != null) {
                        if (field.height != 0) {
                            item.height = field.height;
                        }
                    }

                    if (field.caption != null) {
                        item.label = _(field.caption);
                    }

                    if (field.read_only == "C") {
                        item.readonly = true;
                    }

                    if (item.view == "combo") {
                        item.suggest = {
                            body: {
                                url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
                            },
                        };
                        //item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                    }
                    if (item.view == "select") {
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                    }
                    if (item.view == "checkbox") {
                        if (field.label_position == "right") {
                            item.labelRight = _(field.column_name);
                            item.label = "";
                        }

                        if (field.column_type == "char") {
                            item.checkValue = "C";
                            item.uncheckValue = "K";
                        }

                        if (field.column_type == "tinyint") {
                            item.checkValue = "1";
                            item.uncheckValue = "0";
                        }

                        if (field.column_type == "bit") {
                            item.checkValue = true;
                            item.uncheckValue = false;
                        }

                        if (field.column_type == "boolean") {
                            item.checkValue = 1;
                            item.uncheckValue = 0;
                        }
                    }

                    if (item.view == "autonumeric" || field.column_type == "numeric") {
                        item.inputAlign = "left";
                        item.decimalPlaces = field.data_decimal;
                    }

                    if (field.valid_rule != null) {
                        var rule = field.valid_rule;

                        if (rule == "isNotEmpty") {
                            item.required = true;
                            item.invalidMessage = item.label + " không được bỏ trống";
                            item.validate = webix.rules.isNotEmpty;
                        }

                        if (rule == "isSpecialCharacter") {
                            item.required = true;
                            item.invalidMessage = "Không bỏ trống hoặc ký tự không hợp lệ (a-z,A-Z,0-9)";
                            item.validate = webix.rules.isSpecialCharacter;
                        }

                        if (rule == "isEmail") {
                            item.invalidMessage = item.label + " không hợp lệ";
                            item.validate = webix.rules.isEmail;
                        }

                        if (rule == "isTaxCode") {
                            item.invalidMessage = item.label + " không hợp lệ";
                            item.validate = webix.rules.isTaxCode;
                        }

                        if (rule == "isPositiveNumbers") {
                            item.invalidMessage = item.label + " không hợp lệ";
                            item.validate = webix.rules.isPositiveNumbers;
                        }
                    }

                    if (item.view == "treesuggest") {
                        //item.REF_ID = field.REF_ID.toString();
                        var listColumns = JSON.parse(field.list_column);

                        for (var v = 0; v < listColumns.length; v++) {
                            listColumns[v].header = _(listColumns[v].id);
                        }

                        item.view = "combo";
                        item.options = {
                            view: "treesuggest",
                            textValue: field.display_field,
                            url: {
                                $proxy: true,
                                load: function (view, callback, params) {
                                    var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

                                    webix.ajax(url, function (text) {
                                        var json = JSON.parse(text);
                                        var data = listToTree(json);
                                        view.parse(data, "json");
                                    });
                                },
                            },
                            body: {
                                columns: listColumns,
                                refid: field.ref_id,
                                filterMode: {
                                    level: false,
                                    showSubItems: false,
                                },
                            },
                        };

                        item.on.onKeyPress = function (code, e) {
                            if (e.code == "F4") {
                                alert("Moi");
                            }
                        };
                    }

                    if (item.view == "gridcombo") {
                        var listColumns = JSON.parse(field.list_column);

                        for (var v = 0; v < listColumns.length; v++) {
                            listColumns[v].header = _(listColumns[v].id);
                        }

                        item.view = "combo";
                        item.options = {
                            view: "gridsuggest",
                            url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
                            body: {
                                columns: listColumns,
                                refid: field.REF_ID,
                                textValue: field.display_field,
                            },
                            on: {
                                onValueSuggest: function (obj) {
                                    //console.log(obj);
                                    var master = $$(this.config.master);
                                    if (master.config.fieldExpression != null) {
                                        var win = master.getTopParentView();
                                        var form = win.getChildViews()[1];
                                        //console.log(form);
                                        var parentItem = form.getValues();
                                        //console.log(parentItem);
                                        var fields = master.config.fieldExpression.split(";");

                                        for (var i = 0; i < fields.length; i++) {
                                            var field = fields[i].replace("{", "").replace("}", "");
                                            var array = field.split(":");
                                            //console.log(array);
                                            parentItem[array[1]] = obj[array[0]];
                                        }

                                        form.setValues(parentItem);
                                    }

                                    if (this.config.value_suggest != null) {
                                        var fn = Function("obj", "id", this.config.value_suggest);
                                        fn(obj, this.config.id);
                                    }
                                },
                            },
                        };

                        item.on.onKeyPress = function (code, e) {
                            if (e.code == "F4") {
                                alert("Moi");
                            }
                        };
                    }
                    if (item.view == "search") {
                        var express = item.fieldExpression;

                        item.on.onSearchIconClick = function (e) {
                            var form = $$(this.getFormView());
                            //get value của form hiện tại để đổi giá trị
                            var mst = this.getValue();
                            // window.location.href = "http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst;
                            window.open("http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst);
                        };
                    }

                    if (item.view == "gridsuggest") {
                        var listColumns = JSON.parse(field.list_column);

                        for (var v = 0; v < listColumns.length; v++) {
                            listColumns[v].header = _(listColumns[v].id);
                        }

                        item.view = "search";
                        item.icon = "mdi mdi-plus";
                        item.on.onSearchIconClick = function (e) {
                            showEditWindow(this, 1);
                        };
                        item.suggest = {
                            view: "gridsuggest",
                            autoheight: false,
                            value_suggest: field.value_suggest,
                            textValue: field.display_field,
                            body: {
                                columns: listColumns,
                                refid: field.ref_id,
                                scroll: true,
                                autoheight: false,
                                datatype: "json",
                                textValue: field.display_field,
                                dataFeed: function (filtervalue, filter) {
                                    if (filtervalue.length < 1) return;

                                    var refid = this.config.refid;
                                    var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
                                    var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                    this.load(pathUrl + "&" + urldata, this.config.datatype);
                                },
                            },
                            on: {
                                onValueSuggest: function (obj) {
                                    //console.log(obj);
                                    var master = $$(this.config.master);
                                    if (master.config.fieldExpression != null) {
                                        var win = master.getTopParentView();
                                        var form = win.getChildViews()[1];
                                        //console.log(form);
                                        var parentItem = form.getValues();
                                        //console.log(parentItem);
                                        var fields = master.config.fieldExpression.split(";");

                                        for (var i = 0; i < fields.length; i++) {
                                            var field = fields[i].replace("{", "").replace("}", "");
                                            var array = field.split(":");
                                            //console.log(array);
                                            parentItem[array[1]] = obj[array[0]];
                                        }

                                        form.setValues(parentItem);
                                    }

                                    if (this.config.value_suggest != null) {
                                        var fn = Function("obj", "id", this.config.value_suggest);
                                        fn(obj, this.config.id);
                                    }
                                },
                            },
                        };

                        item.on.onKeyPress = function (code, e) {
                            if (e.code == "F2") {
                                var suggest = $$(this.config.suggest);
                                var refid = suggest.config.body.refid;

                                suggest.hide();
                                var sql = {
                                    command: "SYS004",
                                    parameter: {
                                        refid: refid,
                                    },
                                };
                                //var sql = "SELECT a.*,b.window_id as WINDOWNO FROM #SCHEMA_NAME#.wb_references a INNER JOIN #SCHEMA_NAME#.wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='" + refid + "'";
                                //var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;
                                var url = app.config.host + "/System/ExecuteCommand";

                                var win = this.getTopParentView();
                                var form = win.getChildViews()[1];

                                var editorId = this.config.id;
                                var formId = form.config.id;

                                var a = webix.ajax().post(url, sql);
                                var b = this.config.suggest;
                                var c = this.config.id;
                                var d = this.config.fieldExpression;
                                var e = editorId;
                                var f = formId;

                                webix.promise.all([a, b, c, d, e, f]).then(function (results) {
                                    var res_a = results[0].json();
                                    var suggest = $$(results[1]);

                                    suggest.hide();

                                    var url = app.config.host + "/System/GetConfigWinByNo?id=" + res_a[0]["windowno"];

                                    var ajax = webix.ajax();
                                    ajax.master = {
                                        searchId: results[2],
                                        fieldExpression: d,
                                        valueField: res_a[0]["value_field"],
                                        formId: f,
                                        editorId: e,
                                    };

                                    ajax.get(url, function (text) {
                                        var windowconfig = JSON.parse(text);
                                        var txtSearch = $$(this.searchId);

                                        var win = txtSearch.$scope.ui(selectwindow.$ui);

                                        win.config.valueField = this.valueField;
                                        win.config.fieldExpression = this.fieldExpression;
                                        win.config.formId = this.formId;
                                        win.config.editorId = this.editorId;

                                        selectwindow.initUI(windowconfig);

                                        win.getHead().setHTML(windowconfig.data[0].name);
                                        win.show();
                                    });
                                });

                                var win = this.$scope.ui(selectwindow.$ui);
                                win.show();
                            }

                            if (e.code == "F4" || e.code == "F3") {
                                var editmode = e.code == "F3" ? 2 : 1;
                                showEditWindow(this, editmode);
                            }
                        };
                    }

                    if (item.value_change != null || item.css != null || item.validate != null) {
                        item.on.onChange = function (newv, oldv) {
                            if (this.config.validate != null && editmode != 0) {
                                this.validate();
                            }

                            if (this.config.css != null) {
                                if (this.config.css == "mcls_uppercase" && newv !== undefined && oldv !== undefined) {
                                    if (newv.toUpperCase() != oldv.toUpperCase()) {
                                        webix.$$(this.config.id).setValue(newv.toUpperCase());
                                    }
                                }
                            }

                            if (this.config.value_change != null) {
                                if (this.config.value_change === "@toggleDetailTab") {
                                    var dtab = $$(this.config.detail_tab_id);
                                    if (dtab) {
                                        var cv = this.config.checkValue;
                                        var show = (newv === cv || newv === true || newv === "C" || newv === "1" || newv === 1);
                                        show ? dtab.show() : dtab.hide();
                                    }
                                    return;
                                }

                                var topParentView = this.getTopParentView();

                                if (topParentView.config.editmode == 0) return;

                                var fn = Function("newv", "oldv", "id", this.config.value_change);
                                fn(newv, oldv, this.config.id);
                            }
                        };
                    }

                    el[row - 1].cols.push(item);
                    //console.log(el);
                }
            }
            if (vc_window.window_type == "MasterDetail") {
                var cells = [];

                for (var i = 0; i < tabs.length; i++) {
                    var tab = tabs[i];

                    if (tab.tab_type == "Master") {
                        continue;
                    }

                    var subCols = [];

                    for (var j = 0; j < tab.Fields.length; j++) {
                        var field = tab.Fields[j];

                        var subCol = {
                            id: field.column_name,
                            header: field.caption != null ? _(field.caption) : _(field.column_name),
                            editor: field.type_editor,
                            hidden: field.hidden,
                            value_change: field.value_change,
                        };

                        if (field.read_only == "C" || field.type_editor == "checkbox") {
                            delete subCol.editor;
                        }

                        if (field.type_editor == "checkbox") {
                            subCol.template = "{common.checkbox()}";
                            subCol.checkValue = true;
                            subCol.uncheckValue = false;
                        }

                        if (field.column_type == "date" || field.column_type == "datetime") {
                            subCol.format = function (text) {
                                if (text != null && text != undefined) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                }
                            };
                        }

                        if (field.column_type == "numeric") {
                            subCol.format = webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: field.data_decimal,
                            });
                        }
                        if (field.column_type == "autonumeric") {
                            subCol.css = { "text-align": "left" };
                        }
                        if (field.column_width == null) {
                            subCol.fillspace = true;
                        } else {
                            subCol.width = field.column_width;
                        }

                        if (field.type_editor == "combo" || field.type_editor == "multiselect") {
                            subCol.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                            subCol.optionslist = true;
                        }
                        webix.editors.$popup = {
                            date: {
                                view: "popup",
                                body: { view: "calendar", timepicker: true, icons: true },
                            },
                        };
                        if (field.type_editor == "datepicker") {
                            subCol.editor = "date";
                            subCol.format = function (text) {
                                if (text != null && text != undefined) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                }
                            };
                        }

                        if (field.type_editor == "treesuggest") {
                            var listColumns = JSON.parse(field.list_column);

                            for (var v = 0; v < listColumns.length; v++) {
                                listColumns[v].header = _(listColumns[v].id);
                            }

                            var popup = webix.ui({
                                view: "treesuggest",
                                body: {
                                    columns: listColumns,
                                    refid: field.ref_id,
                                    url: {
                                        $proxy: true,
                                        load: function (view, callback, params) {
                                            var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

                                            webix.ajax(url, function (text) {
                                                var json = JSON.parse(text);
                                                var data = listToTree(json);
                                                view.parse(data, "json");
                                            });
                                        },
                                    },
                                    filterMode: {
                                        level: false,
                                        showSubItems: false,
                                    },
                                },
                            });

                            subCol.popup = popup;
                            subCol.editor = "combo";
                        }

                        if (field.type_editor == "gridcombo") {
                            var listColumns = JSON.parse(field.list_column);

                            for (var v = 0; v < listColumns.length; v++) {
                                listColumns[v].header = _(listColumns[v].id);
                            }

                            var popup = webix.ui({
                                view: "gridsuggest",
                                textValue: field.display_field,
                                body: {
                                    columns: listColumns,
                                    refid: field.ref_id,
                                    textValue: field.display_field,
                                    tableId: "edit_" + tab.table_name,
                                    url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
                                },
                            });

                            subCol.popup = popup;
                            subCol.editor = "combo";
                        }
                        if (field.type_editor == "search") {
                            subCol.on.onSearchIconClick = function (e) {
                                var form = $$(this.getFormView());
                                //get value của form hiện tại để đổi giá trị
                                var mst = this.getValue();
                                // window.location.href = "http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst;
                                window.open("http://tracuunnt.gdt.gov.vn/tcnnt/mstdn.jsp?mst=" + mst);
                            };
                        }
                        if (field.type_editor == "gridsuggest") {
                            var listColumns = JSON.parse(field.list_column);

                            for (var v = 0; v < listColumns.length; v++) {
                                listColumns[v].header = _(listColumns[v].id.toUpperCase());
                            }

                            subCol.editor = "textsearch";
                            subCol.tableId = "edit_" + tab.table_name;
                            subCol.onIconButtonClick = function (e) {
                                var tableId = this.getAttribute("tableId");
                                var table = $$(tableId);
                                tableShowEditWindow(table, 1);
                            };

                            subCol.suggest = {
                                view: "gridsuggest",
                                value_suggest: field.value_suggest,
                                fieldExpression: field.field_expression,
                                displayField: field.display_field,
                                tableId: "edit_" + tab.table_name,
                                columnName: field.column_name,
                                body: {
                                    columns: listColumns,
                                    refid: field.ref_id,
                                    scroll: true,
                                    autoheight: false,
                                    datatype: "json",
                                    dataFeed: function (filtervalue, filter) {
                                        if (filtervalue.length < 1) return;

                                        var refid = this.config.refid;
                                        var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
                                        var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                        this.load(pathUrl + "&" + urldata, this.config.datatype);
                                    },
                                },
                                on: {
                                    onValueSuggest: function (obj) {
                                        if (this.config.fieldExpression != null) {
                                            var table = $$(this.config.tableId);
                                            var selectedItem = table.getSelectedItem();

                                            var fields = this.config.fieldExpression.split(";");

                                            for (var i = 0; i < fields.length; i++) {
                                                var field = fields[i].replace("{", "").replace("}", "");
                                                var array = field.split(":");

                                                selectedItem[array[1]] = obj[array[0]];
                                            }

                                            table.updateItem(selectedItem.id, selectedItem);
                                        }

                                        if (this.config.value_suggest != null) {
                                            var fn = Function("obj", "id", this.config.value_suggest);
                                            fn(obj, this.config.id);
                                        }
                                    },
                                },
                            };
                        }

                        subCols.push(subCol);
                    }

                    if (tab.tab_type == "Detail") {
                        var item = {
                            header: tab.name,
                            select: "cell",
                            body: {
                                rows: [
                                    {
                                        view: "toolbar",
                                        height: 28,
                                        cols: [
                                            {
                                                view: "button",
                                                type: "icon",
                                                //view: "icon",
                                                label: " (F9)",
                                                width: 60,
                                                icon: "fas fa-plus",
                                                css: { "font-size": "15px" },
                                                on: {
                                                    onItemClick: function (id, e) {
                                                        var parentView = this.getParentView().getParentView();
                                                        var childViews = parentView.getChildViews();

                                                        for (var i = 0; i < childViews.length; i++) {
                                                            var childview = childViews[i];

                                                            if (childview.config.view == "datatable") {
                                                                var table = childview;

                                                                var item = {
                                                                    id: webix.uid(),
                                                                };
                                                                webix.editors.$popup = {
                                                                    date: {
                                                                        view: "popup",
                                                                        body: { view: "calendar", timepicker: true, icons: true },
                                                                    },
                                                                };
                                                                var vc_window = windowconfig["data"][0];
                                                                var tabs = vc_window.Tabs;
                                                                for (var i = 0; i < tabs.length; i++) {
                                                                    var tab = tabs[i];
                                                                    if (tab.tab_type == "Detail") {
                                                                        var fields = tab.Fields;

                                                                        for (var j = 0; j < fields.length; j++) {
                                                                            var field = fields[j];

                                                                            if (field.column_name == "branch_code") {
                                                                                item[field.column_name] = user.getDvcsID();
                                                                            }

                                                                            if (field.default_value != null) {
                                                                                var defaultValue = field.default_value.toString();

                                                                                if (defaultValue.startsWith("@Default=")) {
                                                                                    item[field.column_name] = defaultValue.replace("@Default=", "");
                                                                                }

                                                                                if (defaultValue.startsWith("@JS=")) {
                                                                                    var fn = Function(defaultValue.replace("@JS=", ""));
                                                                                    item[field.column_name] = fn();
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }

                                                                //console.log(item);
                                                                table.add(item);

                                                                table.select(item.id, table.config.columns[0].id, false);
                                                                table.edit({ row: item.id, column: table.config.columns[0].id });

                                                                break;
                                                            }
                                                        }
                                                    },
                                                },
                                            },
                                            {
                                                view: "button",
                                                type: "icon",
                                                //view: "icon",
                                                label: " (F8)",
                                                width: 60,
                                                icon: "fas fa-minus",
                                                on: {
                                                    onItemClick: function (id, e) {
                                                        var parentView = this.getParentView().getParentView();
                                                        var childViews = parentView.getChildViews();

                                                        for (var i = 0; i < childViews.length; i++) {
                                                            var childview = childViews[i];

                                                            if (childview.config.view == "datatable") {
                                                                var table = childview;

                                                                table.editStop();

                                                                var item = table.getSelectedItem();

                                                                if (!webix.isUndefined(item)) {
                                                                    table.remove(item.id);
                                                                    table.clearSelection();
                                                                    return;
                                                                }

                                                                var editor = table.getEditState();

                                                                if (!webix.isUndefined(editor)) {
                                                                    table.remove(editor.row);
                                                                    table.clearSelection();
                                                                    return;
                                                                }

                                                                break;
                                                            }
                                                        }
                                                    },
                                                },
                                            },
                                            {
                                                view: "button",
                                                type: "icon",
                                                //view: "icon",
                                                label: " (F7)",
                                                width: 45,
                                                icon: "fas fa-copy",
                                                on: {
                                                    onItemClick: function (id, e) {
                                                        var parentView = this.getParentView().getParentView();
                                                        var childViews = parentView.getChildViews();

                                                        for (var i = 0; i < childViews.length; i++) {
                                                            var childview = childViews[i];

                                                            if (childview.config.view == "datatable") {
                                                                var table = childview;

                                                                table.editStop();

                                                                var item = table.getSelectedItem();
                                                                if (item == null || item == undefined) {
                                                                    webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                    return;
                                                                }
                                                                //item.id = webix.uid();
                                                                var copy = webix.copy(item);
                                                                copy.id = webix.uid();
                                                                copy[tab.table_name + "_id"] = null;

                                                                table.add(copy);
                                                                table.unselect(item.id);
                                                                table.select(copy.id, table.config.columns[0].id, false);
                                                                table.edit({ row: copy.id, column: table.config.columns[0].id });

                                                                break;
                                                            }
                                                        }
                                                    },
                                                },
                                            },
                                            {
                                                hidden: vc_window.code !== "WIN00023" ? true : false,
                                                view: "button",
                                                type: "icon",
                                                icon: "fas fa-folder-open",
                                                label: "Import file excel mẫu",
                                                width: 150,
                                                on: {
                                                    onClick: function () {
                                                        var table = $$("edit_" + tab.table_name);
                                                        require(["views/forms/uploadexceltemplate"], function (uploadForm) {
                                                            uploadForm.$ui.tableId = table.config.id;
                                                            var win = table.$scope.ui(uploadForm.$ui);
                                                            var form = webix.$$("window-form");
                                                            var data = form.getValues();
                                                            win.show();

                                                            var formData;
                                                            if (data.id) {
                                                                formData = { wb_excel_id: data.id, excel_id: data.code, filename: data.name };
                                                            } else {
                                                                formData = { wb_excel_id: wb_excel_id, excel_id: data.code, filename: data.name };
                                                            }

                                                            if (parentCodeParam) {
                                                                formData['parent_code'] = $$(parentCodeParam.id).getValue();
                                                            }

                                                            webix.$$("uploader").define("formData", formData);
                                                            webix.$$("uploader").hide();
                                                        });
                                                    },
                                                },
                                                click: function () {
                                                    this.callEvent("onClick");
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        view: "datatable",
                                        resizeColumn: true,
                                        id: "edit_" + tab.table_name,
                                        tab_table: tab.table_name,
                                        tab_id: tab.tab_id,
                                        editable: true,
                                        select: "cell",
                                        select_change: tab.select_change,
                                        cell_editstop: tab.cell_editstop,
                                        after_addrow: tab.after_addrow,
                                        after_delrow: tab.after_delrow,
                                        oncheck: tab.oncheck,
                                        columns: subCols,
                                        on: {
                                            onCheck: function (row, column, state) {
                                                var table = this;

                                                if (this.config.oncheck != null) {
                                                    var fn = Function("row", "column", "state", "tableId", this.config.oncheck);
                                                    fn(row, column, state, this.config.id);
                                                }
                                            },
                                            onAfterAdd: function (id, index) {
                                                if (this.config.after_addrow != null) {
                                                    var fn = Function("id", "index", "tableId", this.config.after_addrow);
                                                    fn(id, index, this.config.id);
                                                }
                                            },

                                            onAfterDelete: function (id) {
                                                if (this.config.after_delrow != null) {
                                                    var fn = Function("id", "tableId", this.config.after_delrow);
                                                    fn(id, this.config.id);
                                                }
                                            },
                                            onAfterEditStop: function (state, editor, ignore) {
                                                if (state.value === state.old) return;

                                                if (editor.config.value_change != null && editor.config.value_change != "") {
                                                    var selectedItem = null;

                                                    if (typeof editor.getPopup === "function") {
                                                        var popup = editor.getPopup();

                                                        if (popup != null) {
                                                            var list = popup.getList();

                                                            if (list != null) {
                                                                selectedItem = list.getSelectedItem();
                                                            }
                                                        }
                                                    }

                                                    var fn = Function("newv", "oldv", "id", "selectedItem", editor.config.value_change);
                                                    fn(state.value, state.old, editor.config.id, selectedItem);
                                                }

                                                if (this.config.cell_editstop != null) {
                                                    var fn = Function("columnId", "tableId", "rowId", this.config.cell_editstop);
                                                    fn(editor.config.id, this.config.id, editor.row);
                                                }
                                            },
                                            // onKeyDown: function(code, e)
                                            // {
                                            // 		if (e.key == 40) {
                                            // 		var toolbar = this.getParentView().getChildViews()[0];
                                            // 		var btnPlus = toolbar.getChildViews()[0];
                                            // 		console.log(btnPlus);
                                            // 		btnPlus.callEvent("onItemClick");
                                            // 	}
                                            // },
                                            onKeyPress: function (code, e) {
                                                var table = this;

                                                if (e.key == "F8") {
                                                    var toolbar = this.getParentView().getChildViews()[0];
                                                    var btnMinus = toolbar.getChildViews()[1];

                                                    btnMinus.callEvent("onItemClick");
                                                }
                                                if (e.key == "F9") {
                                                    var toolbar = this.getParentView().getChildViews()[0];
                                                    var btnPlus = toolbar.getChildViews()[0];

                                                    btnPlus.callEvent("onItemClick");
                                                }
                                                if (e.key == "F7") {
                                                    var toolbar = this.getParentView().getChildViews()[0];
                                                    var btnCopy = toolbar.getChildViews()[2];

                                                    btnCopy.callEvent("onItemClick");
                                                }

                                                if (e.key == "F2") {
                                                    var editor = table.getEditState();

                                                    if (editor === false) return;

                                                    var suggest = $$(editor.config.suggest);
                                                    var refid = suggest.config.body.refid;
                                                    var sql = {
                                                        command: "SYS004",
                                                        parameter: {
                                                            refid: refid,
                                                        },
                                                    };
                                                    //	var sql = "SELECT a.*,b.window_id as WINDOWNO FROM #SCHEMA_NAME#.wb_references a INNER JOIN #SCHEMA_NAME#.wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='" + refid + "'";
                                                    // var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;
                                                    var url = app.config.host + "/System/ExecuteCommand";

                                                    var a = webix.ajax().post(url, sql);
                                                    var b = editor.config.suggest;
                                                    var c = table.config.id;
                                                    var d = suggest.config.fieldExpression;
                                                    var e = editor.config.id;
                                                    var f = suggest.config.displayField;
                                                    //console.log(f);

                                                    webix.promise.all([a, b, c, d, e, f]).then(function (results) {
                                                        var res_a = results[0].json();
                                                        //	console.log(res_a);
                                                        var suggest = $$(results[1]);

                                                        suggest.hide();

                                                        var url = app.config.host + "/System/GetConfigWinByNo?id=" + res_a[0]["windowno"];

                                                        var ajax = webix.ajax();
                                                        ajax.master = {
                                                            tableId: results[2],
                                                            fieldExpression: d,
                                                            valueField: res_a[0]["value_field"],
                                                            editorId: null,
                                                            columnName: e,
                                                            displayField: f,
                                                        };

                                                        ajax.get(url, function (text) {
                                                            var windowconfig = JSON.parse(text);
                                                            var table = $$(this.tableId);
                                                            //console.log(windowconfig);
                                                            var win = table.$scope.ui(selectwindow.$ui);

                                                            win.config.valueField = this.valueField;
                                                            win.config.fieldExpression = this.fieldExpression;
                                                            win.config.tableId = this.tableId;
                                                            win.config.editorId = null;
                                                            win.config.columnName = this.columnName;
                                                            win.config.displayField = this.displayField;

                                                            selectwindow.initUI(windowconfig);

                                                            win.getHead().setHTML(windowconfig.data[0].name);
                                                            win.show();
                                                        });
                                                    });

                                                    var win = this.$scope.ui(selectwindow.$ui);
                                                    win.show();
                                                }

                                                if (e.key == "F4" || e.key == "F3") {
                                                    var editor = table.getEditState();

                                                    if (editor === false) {
                                                        var toolbar = this.getParentView().getChildViews()[0];
                                                        //console.log(toolbar);
                                                        var btnPlus = toolbar.getChildViews()[0];
                                                        //console.log(btnPlus);
                                                        btnPlus.callEvent("onItemClick");
                                                        return;
                                                    }
                                                    var editmode = e.key == "F3" ? 2 : 1;
                                                    tableShowEditWindow(table, editmode);
                                                }
                                            },
                                            onSelectChange: function () {
                                                var selectedItem = this.getSelectedId();

                                                if (this.config.select_change != null) {
                                                    var fn = Function("selectedItem", this.config.select_change);
                                                    fn(selectedItem);
                                                }
                                            },
                                        },
                                    },
                                ],
                            },
                        };

                        cells.push(item);
                    }
                }

                var subview = {
                    id: vc_window.code + "_dtab",
                    borderless: true,
                    view: "tabview",
                    scrollX: true,
                    cells: cells,
                    tabbar: {
                        width: 200,
                    },
                };

                if (vc_window.width != null || vc_window.height != null) {
                    subview.height = 250;
                }

                //el.push(subview);

                var myJsonString = JSON.stringify(el);
                var x = findJson.getObjects(JSON.parse(myJsonString), "id", "tab_replace");
                //replace tab chi tiết
                if (x.length > 0) {
                    var Y = x[0];
                    //webix.extend(Y, subview, true);
                    // cần cập nhật lại x[0] cho el

                    for (var i = 0; i < el.length; i++) {
                        if (el[i].id == "tab_replace") {
                            //console.log(el[i]);
                            el[i] = subview;
                        }
                    }
                } else {
                    if (vc_window.tab_row != null) {
                        el[vc_window.tab_row - 1] = subview;
                    } else {
                        el.push(subview);
                    }
                }
            }

            var cols = [
                // {},
                {
                    // 		      view: "button", type: "htmlbutton", width: 100,
                    // label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                    // '<span class="text">LƯU (F10)</span>',
                    shortcut: "F10",
                    view: "button",
                    label: "LƯU (F10)",
                    type: "form",
                    align: "center",
                    width: 110,
                    before_save: vc_window.before_save,
                    on: {
                        onClick: function () {
                            var self = this;
                            setTimeout(function () {
                                var form = webix.$$("window-form");

                                if (form.validate() == false) {
                                    return;
                                }

                                if (self.config.before_save != null) {
                                    var fn = Function(self.config.before_save);
                                    var result = fn();

                                    if (result == false) return;
                                }

                                var item = form.getValues();

                                var khData = {};

                                khData.windowid = String(rp["data"][0]["code"]);
                                khData.editmode = editmode;
                                khData.data = [];

                                var vc_window = rp["data"][0];
                                if (vc_window.code === "WIN00023" && editmode == 1) {
                                    item["wb_excel_id"] = wb_excel_id;
                                }

                                if (vc_window.window_type == "MasterDetail") {
                                    var tabs = vc_window.Tabs;
                                    var details = [];

                                    for (var i = 0; i < tabs.length; i++) {
                                        var tab = tabs[i];

                                        if (tab.tab_type == "Detail") {
                                            var table = webix.$$("edit_" + tab.table_name);
                                            details.push({
                                                tab_id: tab.code,
                                                tab_table: tab.table_name,
                                                data: table.serialize(),
                                            });
                                        }
                                    }

                                    item["details"] = details;
                                }

                                khData.data.push(item);

                                self.getTopParentView().disable();
                                self.getTopParentView().showProgress();

                                var box = null
                                if (khData.windowid == "WIN00026" && item.code == "CHECK_QUANTITY_KH") {
                                    box = webix.modalbox({
                                        title: "Hệ thống đang cập nhật cấu hình. Vui lòng không phát hành hóa đơn!",
                                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                        width: 450,
                                        height: 200,
                                    });
                                }

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/System/Save", khData, function (text) {
                                        if (box) {
                                            webix.modalbox.hide(box)
                                        }

                                        var json = JSON.parse(text);

                                        $$(json.windowid).enable();
                                        $$(json.windowid).hideProgress();

                                        if (!json.hasOwnProperty("error")) {
                                            if (khData.windowid == "WIN00017") {
                                                setdsFieldFormat();
                                            }

                                            var after_save = $$(json.windowid).config.after_save;

                                            if (after_save != null) {
                                                //Function
                                                var fn = Function("editmode", "data", after_save);
                                                fn(editmode, json.data);
                                                //console.log(editmode);
                                            }

                                            $$(json.windowid).close();
                                            app.callEvent("dataChanged", [editmode, json.data]);

                                            webix.message("Cập nhật cấu hình thành công", "success", 2000);
                                        } else {
                                            webix.message(json.error, "error", 2000);
                                        }
                                    });
                            }, 100);
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    view: "button",
                    shortcut: "esc",
                    label: "HỦY (ESC)",
                    type: "danger",
                    align: "center",
                    width: 110,
                    on: {
                        onClick: function () {
                            this.getTopParentView().close();
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {},
            ];

            el.push({
                // paddingY:10,
                margin: 10,
                height: 40,
                cols: cols,
            });

            webix.ui(el, $$("window-form"));
            //console.log(el);

            win.getHead().setHTML(windowconfig.data[0].name);
        },
        focusFirstElement: function () {
            var form = $$("window-form");
            form.focus(form.elements[0]);
        },
        setEditMode: function (mode) {
            editmode = mode;

            var form = webix.$$("window-form");
            var topParentView = form.getTopParentView();
            topParentView.config.editmode = mode;
        },
        setValues: function (item, winconfig, params) {
            var form = webix.$$("window-form");
            var vc_window = winconfig["data"][0];
            webix.editors.$popup = {
                date: {
                    view: "popup",
                    body: { view: "calendar", timepicker: true, icons: true },
                },
            };
            if (item == null) {
                var tabs = vc_window.Tabs;

                item = {};

                if (params != null) {
                    item = params;
                }

                for (var i = 0; i < tabs.length; i++) {
                    var tab = tabs[i];
                    if (tab.tab_type == "Normal" || tab.tab_type == "Master") {
                        var fields = tab.Fields;

                        for (var j = 0; j < fields.length; j++) {
                            var field = fields[j];

                            if (field.column_name == "branch_code") {
                                item[field.column_name] = user.getDvcsID();
                            }

                            if (field.default_value != null) {
                                var defaultValue = field.default_value.toString();

                                if (defaultValue.startsWith("@Default=")) {
                                    item[field.column_name] = defaultValue.replace("@Default=", "");
                                }

                                if (defaultValue.startsWith("@JS=")) {
                                    var fn = Function(defaultValue.replace("@JS=", ""));
                                    item[field.column_name] = fn();
                                }
                            }
                        }
                    }
                }

                form.setValues(item);
            } else {
                var tabs = vc_window.Tabs;

                for (var pi = 0; pi < tabs.length; pi++) {
                    if (tabs[pi].tab_type != "Detail") {
                        var pfields = tabs[pi].Fields;
                        for (var pj = 0; pj < pfields.length; pj++) {
                            var pfield = pfields[pj];
                            if (pfield.type_editor == "checkbox" && item[pfield.column_name] != null && item[pfield.column_name] != undefined) {
                                if (pfield.column_type == "tinyint") {
                                    item[pfield.column_name] = String(item[pfield.column_name]);
                                } else if (pfield.column_type == "bit" || pfield.column_type == "boolean") {
                                    var pv = item[pfield.column_name];
                                    item[pfield.column_name] = (pv === true || pv === 1 || pv === "1" || pv === "true") ? 1 : 0;
                                }
                            }
                        }
                        break;
                    }
                }

                form.setValues(item);

                for (var i = 0; i < tabs.length; i++) {
                    var tab = tabs[i];

                    if (tab.tab_type != "Detail") {
                        var fields = tab.Fields;

                        for (var j = 0; j < fields.length; j++) {
                            var field = fields[j];
                            //if (field.hidden != true) {
                            if (field.column_type == "date" || field.column_type == "datetime") {
                                if (item[field.column_name] != null && item[field.column_name] != undefined) {
                                    item[field.column_name] = removeTimeZoneT(item[field.column_name]);
                                    form.setValues(item);
                                }
                            }

                            if (field.column_type == "time") {

                                if (item[field.column_name] != null && item[field.column_name] != undefined) {
                                    item[field.column_name] = new Date(item[field.column_name]);
                                    form.setValues(item);
                                }
                            }


                        }

                        break;
                    }
                }

                if (vc_window.window_type == "MasterDetail") {
                    // Áp dụng trạng thái ban đầu cho checkbox @toggleDetailTab
                    for (var i = 0; i < tabs.length; i++) {
                        if (tabs[i].tab_type === "Master") {
                            var masterFields = tabs[i].Fields;
                            for (var j = 0; j < masterFields.length; j++) {
                                var tf = masterFields[j];
                                if (tf.value_change === "@toggleDetailTab") {
                                    var dtab = $$(vc_window.code + "_dtab");
                                    if (dtab) {
                                        var val = item[tf.column_name];
                                        var show = (val === true || val === "C" || val === "1" || val === 1);
                                        show ? dtab.show() : dtab.hide();
                                    }
                                }
                            }
                            break;
                        }
                    }

                    if(winconfig["data_params"] && winconfig["data_params"].length > 0) {
                        parentCodeParam = winconfig["data_params"].find(function(e) {
                            return e.value_field == 'parent_code';
                        })
                    }
                    for (var i = 0; i < tabs.length; i++) {
                        var tab = tabs[i];

                        if (tab.tab_type == "Master") {
                            continue;
                        }

                        var table = webix.$$("edit_" + tab.table_name);
                        var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + vc_window.code + "&id=" + item.id + "&tab_table=" + tab.table_name;
                        if (parentCodeParam) {
                            url = url + "&parent_code=" + $$(parentCodeParam.id).getValue();
                        }
                        table.clearAll();
                        // if(editmode == 4) continue;
                        table.load(url);
                    }
                }
            }
        },
        copyValues: function (item, winconfig) {
            var form = webix.$$("window-form");
            var vc_window = winconfig["data"][0];

            var dataParam = null;
            if (winconfig["data_params"] && winconfig["data_params"].length > 0) {
                dataParam = winconfig["data_params"].find(function (e) {
                    return e.value_field == 'parent_code';
                })
            }
            if (vc_window.window_type == "MasterDetail") {
                var tabs = vc_window.Tabs;

                for (var i = 0; i < tabs.length; i++) {
                    var tab = tabs[i];

                    if (tab.tab_type == "Master") {
                        continue;
                    }

                    var table = webix.$$("edit_" + tab.table_name);

                    var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + vc_window.code + "&id=" + item.id + "&tab_table=" + tab.table_name;
                    if (dataParam) {
                        url = url + "&parent_code=" + $$(dataParam.id).getValue();
                    }

                    table.clearAll();

                    if (vc_window.code == "WIN00008") {
                        continue;
                    }

                    table.load(url);
                }
            }

            var tabs = vc_window.Tabs;

            for (var i = 0; i < tabs.length; i++) {
                var tab = tabs[i];

                if (tab.tab_type == "Normal" || tab.tab_type == "Master") {
                    var fields = tab.Fields;

                    for (var j = 0; j < fields.length; j++) {
                        var field = fields[j];

                        if (field.column_name == tab.table_name + "_id") {
                            item[field.column_name] = null;
                        }

                        if (field.column_name == "branch_code") {
                            item[field.column_name] = user.getDvcsID();
                        }

                        if (field.default_value != null) {
                            var defaultValue = field.default_value.toString();

                            if (defaultValue.startsWith("@Default=")) {
                                item[field.column_name] = defaultValue.replace("@Default=", "");
                            }

                            if (defaultValue.startsWith("@JS=")) {
                                var fn = Function(defaultValue.replace("@JS=", ""));
                                item[field.column_name] = fn();
                            }
                        }
                    }
                }
            }

            form.setValues(item);
        },
    };
});

define('views/forms/detailreport',[
	"app",
	"locale",
	"views/forms/infowindow",
	"views/forms/window"
],function(app,_,infowindow,windowform){
	var editmode = 0;
	var tableId = 0;

	var contextmenu = webix.ui({
            view:"contextmenu",
            id:"ctxMenuDetail",
            on:{
                onMenuItemClick:function(id){
                    var item = this.getItem(id);

                    if (id=="SUACTGOCDETAIL"){
                        var table =this.getContext().obj;
                        var row = table.getSelectedItem();                        

                        var sql = "SELECT TOP 1 a.* FROM VC_WINDOW a WHERE a.ma_ct='"+row.MA_CT+"'";
                        var url = app.config.host + "/api/System/ExecuteQuery?sql=" + sql;

						var ajax = webix.ajax();
						ajax.master = table;

                        ajax.get(url,function(text){
                            var json = JSON.parse(text);
                            var data = json[0];
                            
                            var table = this;
                            var row = table.getSelectedItem();

                            var a = webix.ajax(app.config.host + "/api/System/GetDataById?window_id="+data.WINDOW_ID + "&id="+row.DOC_ID);
                            var b = webix.ajax(app.config.host + "/api/System/GetAllByWindowNo?window_id="+ data.WINDOW_ID);
							var c = table.config.id;

                            webix.promise.all([a,b,c]).then(function(results){
                                var a_result = results[0].json();
                                var windowconfig = results[1].json();

                                var vc_window = windowconfig["data"][0];
                                windowform.$ui.id = vc_window.WINDOW_ID;

                                var table = $$(c);
                                var detailForm = table.$scope.ui(windowform.$ui);
                            
                                var item = a_result.data[0];              
                                
                                windowform.initUI(windowconfig);
                                windowform.setEditMode(2);
                                windowform.setValues(item,windowconfig);
                                
                                detailForm.show();
                            });
                            
                        });
                    }
                    else {
                        var ctx =this.getContext();

                        detailreport.$ui.id = "dtrp_"+ item.MENU_ID;
                        detailreport.$ui.parentParameter = ctx.obj.config.rpParameter.parameters;
                        detailreport.$ui.parentRow = ctx.obj.getSelectedItem();

                        this.hide();

                        var win = ctx.obj.$scope.ui(detailreport.$ui);
                        detailreport.initUI(item);
                        win.show();
                    }
                    

                    
                }
            }
    });


	function initData(windowId,tableId,infoWindowId,report_id){

		var win = $$(windowId);
		var table = win.getChildViews()[1].getChildViews()[1];

		var menuitem = win.config.menuitem;

		var parentParamter = win.config.parentParameter;
		var parentRow = win.config.parentRow;

		infowindow.$ui.id = infoWindowId;
		infowindow.$ui.report_id = report_id;
		infowindow.$ui.editmode = 1;
		infowindow.$ui.load_event = "loadDetailReport";
		infowindow.$ui.menuitem = menuitem;

		var parameters = menuitem.PARAMETERS								
								.split(';');

		var item = {};

		for(var i=0;i<parameters.length;i++){
			var array = parameters[i]
								.replace("{","")
								.replace("}","")
								.split(':');

			if (array[0].toString()=="1"){
				item[array[2]] = parentParamter[array[1]];
			}

			if (array[0].toString()=="2"){
				item[array[2]] = parentRow[array[1]];
			}
		}

		table.config.rpParameter = {
			parameters : item
		};

		infowindow.$ui.formvalues = item;

		var wininfo = win.$scope.ui(infowindow.$ui);
		
		infowindow.initUI(infoWindowId);
		
		app.callEvent("loadDetailReport",[report_id,infoWindowId,item,menuitem]);
	}

	return {		
		$ui:{   
			view:"window", modal:true, 
			position:"center",
			head:"Thông tin Tab",
			fullscreen:true,
			body:{
				rows:[
					{
						view:"toolbar",
						height:35,
						cols:[
							{
								view:"button",
								type:"icon",
								icon:"refresh",
								label: _("REFRESH"),
								width:90,
								on: {
									onClick: function(){ 
										var win = this.getTopParentView();										
										var table = win.getChildViews()[1].getChildViews()[1];

										infowindow.$ui.id = table.config.infowindow_id;
										infowindow.$ui.report_id = table.config.report_id;
										infowindow.$ui.load_event = "loadDetailReport";
										infowindow.$ui.menuitem = win.config.menuitem;

										if (table.config.rpParameter!=null){									
											infowindow.$ui.editmode = 1;
											infowindow.$ui.formvalues = table.config.rpParameter.parameters;
										}
										else {
											infowindow.$ui.editmode = 0;
											infowindow.$ui.formvalues = null;
										}              

										var wininfoparam = this.$scope.ui(infowindow.$ui);

										infowindow.initUI(table.config.infowindow_id);              
										wininfoparam.show();                    
									}
								},
								click: function(){
									this.callEvent("onClick");
								}
							},
							{
								view:"button",
								type:"icon",
								icon:"print",
								label: _("PRINT"),
								width:40,
								click: function(){
									this.callEvent("onClick");
								},
								on: {
									onClick: function(){
										var win = this.getTopParentView();										
										var table = win.getChildViews()[1].getChildViews()[1];

										var rpParameter = table.config.rpParameter;
										
										rpParameter.type = "pdf";

										if (rpParameter!=null){
											webix.ajax()
												.response("arraybuffer")
												.headers({'Content-type':'application/json'})
												.post(app.config.host + "/api/System/CreateReport", rpParameter, function(text, data){
												var file = new Blob([data], {type: 'application/pdf'});
												var fileURL = URL.createObjectURL(file);
												window.open(fileURL,'_blank');
											});
										}
									}
								}
							},
							{
								view:"button",
								type:"icon",
								icon:"file",
								label: _("EXPORT"),
								width:80,
								click: function(){
									this.callEvent("onClick");
								},
								on: {
									onClick: function(){
										var win = this.getTopParentView();										
										var table = win.getChildViews()[1].getChildViews()[1];
										
										var rpParameter = table.config.rpParameter;
										rpParameter.type = "excel";

										if (rpParameter!=null){
											webix.ajax()
												.response("arraybuffer")
												.headers({'Content-type':'application/json'})
												.post(app.config.host + "/api/System/CreateReport", rpParameter, function(text, data){
												
												var file = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
												var fileURL = URL.createObjectURL(file);                        
																			
												window.location.href = fileURL;
											});
										}
									}
								}
							},
							{
								view:"button",
								type:"icon",
								icon:"close",
								label: _("EXIT"),
								width:80,
								click: function(){
									this.getTopParentView().close();
								}
							}
						]
					},
					{
						view:"datatable",
						scheme:{
							$change:function(item){
								if (item.BOLD == "C")
									item.$css = "rowBold";
							}
						},
						select: "row",
						on:{
							onBeforeContextMenu:function(id){
								var item = this.getItem(id);
								var mn = $$("ctxMenuDetail");

								if (item.DOC_ID!=null && item.MA_CT!=null){									
									var menuitem = mn.getItem("SUACTGOCDETAIL");
									if (menuitem==null){
										mn.add({id:"SUACTGOCDETAIL",value:"Sửa chứng từ"});
									}
								}
								else {
									mn.clearAll();
								}

								webix.delay(function(){
									this.clearSelection();
									this.select(id.row, id.column);
								},this);
							} 
						}
					}
				]
                
			}			
			
		},		
		setEditMode: function(mode) {
			editmode = mode;
		},
		setTableId: function(id){
			tableId = id;
		}, 
		initUI: function(item){
			var report_id = item.REPORT_ID;

			webix.$$("dtrp_" + item.MENU_ID).config.menuitem = item;			

			var sql = "SELECT a.*,b.INFOWINDOW_ID,'"+item.MENU_ID+"' as MENU_ID FROM VC_REPORTCOLUMN a "
					+" INNER JOIN VC_REPORT b ON b.id=a.VC_REPORT_id "
					+" WHERE a.VC_REPORT_id='"+report_id+"' ORDER BY a.SEQ_NO";

			var url=app.config.host + "/api/System/ExecuteQuery?sql=" + sql;
			
			webix.ajax(url,function(text){
				var json = JSON.parse(text);

				var win = webix.$$("dtrp_" + json[0]["MENU_ID"]);
				win.getHead().setHTML(win.config.menuitem.CAPTION);

				var table = win.getChildViews()[1].getChildViews()[1];
				table.config.rpParameter = null;
				table.clearAll();

				$$("ctxMenuDetail").attachTo(table);

				var cols=[];

				for(var i=0;i<json.length;i++){
					var col=json[i];

					var item = {
						id: col.REPORTCOLUMN_FIELD,
						header:"<center>" + _(col.REPORTCOLUMN_NAME) +"</center>",
						width: col.REPORTCOLUMN_WIDTH,
						hidden: col.HIDDEN == "C" ? true : false
					};

					if (col.HEADER!=null){
						if (col.HEADER!=""){
							var headers = JSON.parse(col.HEADER);

							for(var j=0;j<headers.length;j++){
								var hd = headers[j];
								if (hd!=null){
									hd.text = "<center>" + _(hd.text) +"</center>";
								}
							}

							item.header = headers;
						}
						
					}

					if (col.COLUMN_TYPE == "VC_DATE"){
						item.format = function(text) {
							var format = webix.Date.dateToStr("%d/%m/%Y");
							text = removeTimeZoneT(text);                            
							return format(text);
						};
					}

					if (col.COLUMN_TYPE == "VC_TYGIA" || col.COLUMN_TYPE == "VC_TIEN"){
						item.css = { "text-align" : "right" };
						item.format = webix.Number.numToStr({
								groupDelimiter:",",
								groupSize:3,
								decimalDelimiter:".",
								decimalSize:0
							});
					}

					cols.push(item);
				}

			
				table.config.columns = cols;
				table.config.report_id = json[0]["VC_REPORT_id"];
				table.config.infowindow_id = json[0]["INFOWINDOW_ID"];

				table.refreshColumns();	
				
				initData(win.config.id,table.config.id,json[0]["INFOWINDOW_ID"],json[0]["VC_REPORT_id"]);

			});
		},
		$oninit: function(view,$scope) {
			
			 $scope.on(app, "loadDetailReport", function(report_id,infoWindowId,item,menuitem){
				
                var win = $$(infoWindowId);
				var table = win.getChildViews()[1].getChildViews()[1];

                if (table.config.report_id == report_id){

                    var rpParameter={
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id
                    };

                    table.config.rpParameter = rpParameter;

                    webix.ajax()
                        .headers({'Content-type':'application/json'})
                        .post( app.config.host + "/api/System/CreateReport", rpParameter, function(text){
                            var data = JSON.parse(text);

                            var table = $$("tblReport");
                            table.clearAll();
                            table.parse(data,"json");
                        });
                }

                
            });
        }
	};

});
define('views/baocao_bangkebienlai',["app", "locale", "views/forms/infowindow", "views/forms/detailreport", "views/forms/window", "models/user"], function (app, _, infowindow, detailreport, windowform, user) {
    

    var windowno = app.path[1].params[0];

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-refresh",
            // css: "webix_secondary",
            // label: _("REFRESH"),
            // width: 95,
            on: {
                onClick: function () {
                    //console.log($$("cbReport").getValue());
                    
                    if ($$("cbReport").getValue() == null || $$("cbReport").getValue() == "") {
                        webix.message("Bạn chưa chọn báo cáo !", "error");
                        return;
                    }
                    var cbReport = webix.$$("cbReport");
                    var list = cbReport.getList();

                    var item = list.getItem(cbReport.getValue());

                    infowindow.$ui.id = item.wb_infowindow_id;
                    infowindow.$ui.report_id = cbReport.getValue();
                    infowindow.$ui.load_event = "loadReport";

                    if ($$("tblReportBangKe").config.rpParameter != null) {
                        infowindow.$ui.editmode = 1;
                        infowindow.$ui.formvalues = $$("tblReportBangKe").config.rpParameter.parameters;
                    } else {
                        infowindow.$ui.editmode = 0;
                        infowindow.$ui.formvalues = null;
                    }

                    var wininfoparam = this.$scope.ui(infowindow.$ui);

                    infowindow.initUI(item.wb_infowindow_id);
                    wininfoparam.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + " (PDF)" + "</span>",
            id: "btnPrint",
            // view: "button",
            // type: "icon",
            // css: "webix_secondary",
            // icon: "fas fa-print",
            // label: _("PRINT") + " PDF",
            // width: 70,
            on: {
                onClick: function () {
                    var table = $$("tblReportBangKe");

                    var rpParameter = table.config.rpParameter;

                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(
                                app.config.host + "/System/CreateReport",
                                rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/pdf" });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.open(fileURL, "_blank");
                                    },
                                }
                                // function (text, data) {
                                //     var file = new Blob([data], { type: 'application/pdf' });
                                //     var fileURL = URL.createObjectURL(file);
                                //     webix.modalbox.hide(box);
                                //     window.open(fileURL, '_blank');
                                // }
                            );
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-file fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("EXPORT_EXCEL") + "</span>",
            id: "btnExport",
            // view: "button",
            // type: "icon",
            // css: "webix_secondary",
            // icon: "fas fa-file",
            // label: _("EXPORT_EXCEL"),
            // width: 120,
            on: {
                onClick: function () {
                    var table = $$("tblReportBangKe");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(
                                app.config.host + "/System/CreateReport",
                                rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                        //var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        var reportItem = $$("cbReport").getList().getSelectedItem();

                                        if (reportItem != null) {
                                            var export_name = reportItem.export_name;
                                            webix.html.download(file, export_name + ".xlsx");
                                        }
                                    },
                                }
                            );
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {
            id: "cbReport",
            view: "combo",
            width: 450,
            label: "Chọn báo cáo",
            labelWidth: 90,
            suggest: {
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/ExecuteCommand";

                        var parameters = {
                            command: "CM00097",
                            parameter: {
                                window_id: windowno,
                                username: user.getCurrentUser(),
                            },
                        };

                        webix.ajax().bind(view).headers({ "Content-Type": "application/json" }).post(url, parameters, callback);
                    },
                },
                template: "#name#",
                body: {
                    template: "#name#",
                },
            },
            on: {
                onChange: function () {
                    var report_id = this.getValue();

                    if (report_id == "") {
                        return;
                    }
                    var name = $$("cbReport").getText();

                    webix.$$("title").parse({ title: name, details: name });
                    initTable(report_id);
                },
            },
        },
    ];

    var grid = {
        rows: [
            {
                id: "tblReportBangKe",
                view: "treetable",
                resizeColumn: true,
                select: true,
                css: "report",
                columns: [],
                headermenu: {
                    width: 200,
                    autoheight: false,
                    scroll: true,
                },
                scheme: {
                    $change: function (item) {
                        if (item.BOLD == "C") item.$css = "rowBold";
                    },
                    $group: {
                        by: "nhom"
                    },
                },
                pager: "pagerA",
                on: {
                    onBeforeContextMenu: function (id) {
                        var item = this.getItem(id);

                        if (item.DOC_ID != null && item.MA_CT != null) {
                            var mn = $$("ctxMenu");
                            var menuitem = mn.getItem("SUACTGOC");
                            if (menuitem == null) {
                                mn.add({ id: "SUACTGOC", value: "Sửa chứng từ" });
                            }
                        }

                        webix.delay(function () {
                            this.clearSelection();
                            this.select(id.row, id.column);
                        }, this);
                    },
                },
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var contextmenu = webix.ui({
        view: "contextmenu",
        id: "ctxMenu",
        on: {
            onMenuItemClick: function (id) {
                var item = this.getItem(id);

                if (id == "SUACTGOC") {
                    var table = $$("tblReportBangKe");
                    var row = table.getSelectedItem();

                    var sql = "SELECT TOP 1 a.* FROM VC_WINDOW a WHERE a.ma_ct='" + row.MA_CT + "'";
                    var url = app.config.host + "/api/System/ExecuteQuery?sql=" + sql;

                    webix.ajax(url, function (text) {
                        var json = JSON.parse(text);
                        var data = json[0];

                        var table = $$("tblReportBangKe");
                        var row = table.getSelectedItem();

                        var a = webix.ajax(app.config.host + "/api/System/GetDataById?window_id=" + data.WINDOW_ID + "&id=" + row.DOC_ID);
                        var b = webix.ajax(app.config.host + "/api/System/GetAllByWindowNo?window_id=" + data.WINDOW_ID);

                        webix.promise.all([a, b]).then(function (results) {
                            var a_result = results[0].json();
                            var windowconfig = results[1].json();

                            var vc_window = windowconfig["data"][0];
                            windowform.$ui.id = vc_window.WINDOW_ID;

                            var table = $$("tblReportBangKe");
                            var detailForm = table.$scope.ui(windowform.$ui);

                            var item = a_result.data[0];

                            windowform.initUI(windowconfig);
                            windowform.setEditMode(2);
                            windowform.setValues(item, windowconfig);

                            detailForm.show();
                        });
                    });
                } else {
                    var ctx = this.getContext();

                    detailreport.$ui.id = "dtrp_" + item.MENU_ID;
                    detailreport.$ui.parentParameter = ctx.obj.config.rpParameter.parameters;
                    detailreport.$ui.parentRow = ctx.obj.getSelectedItem();

                    this.hide();

                    var win = ctx.obj.$scope.ui(detailreport.$ui);
                    detailreport.initUI(item);
                    win.show();
                }
            },
        },
    });

    var layout = {
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    function initTable(report_id) {
        var url = app.config.host + "/System/ExecuteCommand";

        var parameters = {
            command: "CM00012",
            parameter: {
                wb_report_id: report_id,
            },
        };

        webix
            .ajax()
            .headers({ "Content-Type": "application/json" })
            .post(url, parameters, function (text) {
                var json = JSON.parse(text);
                var table = webix.$$("tblReportBangKe");

                table.clearAll();
                table.config.rpParameter = null;

                var cols = [];
                var isFooter = false;

                for (var i = 0; i < json.length; i++) {
                    var col = json[i];
                    //console.log(col);

                    var item = {
                        id: col.value_field,
                        header: "<center>" + _(col.header_title) + "</center>",
                        width: col.width,
                        hidden: col.hidden == "C" ? true : false,
                    };

                    // cột tổng dưới footer
                    if (col.footer === "" || col.footer === null) {
                    } else {
                        var temp = JSON.parse(col.footer);
                        item.footer = temp;

                        isFooter = true;
                    }

                    //console.log(col.sum);
                    if (col.header != null) {
                        if (col.header != "") {
                            var headers = JSON.parse(col.header);

                            for (var j = 0; j < headers.length; j++) {
                                var hd = headers[j];
                                if (hd != null) {
                                    hd.text = "<center>" + _(hd.text) + "</center>";
                                }
                            }

                            item.header = headers;
                        }
                    }

                    if (col.data_type == "datetime" || col.data_type == "date") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (col.data_type == "decimal" || col.data_type == "int" || col.data_type == "integer" || col.data_type == "numeric") {
                        item.css = { "text-align": "right" };
                        item.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        });
                    }

                    if (col.data_type == "boolean") {
                        item.template = function (obj, common, value) {
                            if (value) return "<div class='webix_icon fa-check-square-o'></div>";
                            else return "<div class='webix_icon fa-square-o'></div>";
                        };
                    }

                    if (col.value_field == "nlap" && col.wb_report_id == "7fdfab2b-9508-4471-98e0-96d36443ab08") {
                        item.template = function (obj, common) {
                            if (obj.$level == 1) return common.treetable(obj, common) + "<span style='color:blue;'>" + obj.value + " ( " + obj.$count + " )" + "</span>";
                            return obj.nlap;
                        };
                    }

                    if (col.value_field == "ord") {
                        item.sort = "int";
                    }

                    cols.push(item);
                }

                table.define("footer", isFooter);

                table.config.columns = cols;
                table.config.report_id = json[0]["wb_report_id"];
                table.refreshColumns();
            });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var windowno = app.path[1].params[0];
            var query = "SELECT * FROM #SCHEMA_NAME#.wb_menu WHERE window_code='" + windowno + "' LIMIT 1";

            var url = app.config.host + "/System/ExecuteQuery?sql=" + encodeURIComponent(query);

            webix.ajax(url, function (text) {
                var json = JSON.parse(text);

                if (json.length > 0) {
                    var title = $$("title");

                    if (title != undefined && title != null) {
                        title.parse({ title: json[0]["name"], details: json[0]["details"] });
                    }
                }
            });

            if (app.path[1].params[1] != null) {
                var id = app.path[1].params[1];
                $$("cbReport").setValue(id);

                var load_event = "loadReport";
                var report_id = "d13001df-01fe-4d4f-ab65-cc98e7b41661";
                var id = "5accccd3-51bd-4370-b130-b01ab35d6c86";

                var now = new Date();
                now.setHours(0, 0, 0, 0);

                var item = {
                    ma_dvcs: user.getDvcsID(),
                    tu_ngay: null,
                    den_ngay: now,
                };

                var table = $$("tblReportBangKe");
                table.report_id = report_id;

                var rpParameter = {
                    parameters: item,
                    infowindow_id: id,
                    type: "json",
                    report_id: report_id,
                };

                table.config.rpParameter = rpParameter;

                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .post(app.config.host + "/System/CreateReport", rpParameter, function (text) {
                        var data = JSON.parse(text);

                        var table = $$("tblReportBangKe");
                        table.clearAll();
                        table.parse(data, "json");
                    });
            }

            $scope.on(app, "loadReport", function (report_id, infoWindowId, item) {
                var table = $$("tblReportBangKe");
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();
                if (table.config.report_id == report_id) {
                    var rpParameter = {
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id,
                    };

                    table.config.rpParameter = rpParameter;

                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .post(app.config.host + "/System/CreateReport", rpParameter, function (text) {
                            webix.delay(
                                function () {
                                    var data = JSON.parse(text);

                                    var table = $$("tblReportBangKe");
                                    table.clearAll();
                                    table.parse(data, "json");
                                },
                                null,
                                null,
                                1000
                            );

                            table.enable();
                            table.hideProgress();
                            // var data = JSON.parse(text);

                            // var table = $$("tblReportBangKe");
                            // table.clearAll();
                            // table.parse(data, "json");
                        });
                }
            });

            $scope.on(app, "loadDetailReport", function (report_id, infoWindowId, item, menuitem) {
                var win = $$("dtrp_" + menuitem.MENU_ID);
                var table = win.getChildViews()[1].getChildViews()[1];

                if (table.config.report_id == report_id) {
                    var rpParameter = {
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id,
                    };

                    table.config.rpParameter = rpParameter;

                    var ajax = webix.ajax();
                    ajax.master = menuitem;

                    ajax.headers({ "Content-type": "application/json" }).post(app.config.host + "/api/System/CreateReport", rpParameter, function (text) {
                        var win = $$("dtrp_" + this.MENU_ID);
                        var table = win.getChildViews()[1].getChildViews()[1];
                        
                        table.clearAll();
                        var data = JSON.parse(text);
                        table.parse(data, "json");
                        table.refresh();
                        table.enable();
                        table.hideProgress();
                    });
                }
            });
        },
        initUI: function () {},
    };
});

define('views/forms/chukyso',["app", "locale"], function (app, _) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "chukyso-win", position: "center",
			head: "Thông tin chứng thư số",
			// height: 490,
			body: {
				paddingY: 10,
				paddingX: 10,
				view: "form",
				id: "chukyso-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						view: "text",
						name: "cer_serial",
						labelPosition: "top",
						label: _("SO_SERIAL"),
						readonly: true,
						css: "mcls_readonly_text",
						width: 550
					},
					{
						view: "textarea",
						name: "subject_name",
						labelPosition: "top",
						label: _("SUBJECTNAME"),
						readonly: true,
						css: "mcls_readonly_text",
						height: 100
					},
					{
						view: "textarea",
						name: "issuer",
						labelPosition: "top",
						label: _("DONVI"),
						css: "mcls_readonly_text",
						readonly: true,
						height: 80
					},
					{
						cols: [
							{
								view: "datepicker",
								label: _("NGAY_BAT_DAU"),
								labelPosition: "top",
								name: "begin_date",
								timepicker: true,
								format: "%d/%m/%Y %H:%i:%s",
								css: "mcls_readonly_text",
								readonly: true
							},
							{
								view: "datepicker",
								label: _("NGAY_KET_THUC"),
								labelPosition: "top",
								name: "end_date",
								format: "%d/%m/%Y %H:%i:%s",
								timepicker: true,
								css: "mcls_readonly_text",
								readonly: true
							}
						]
					},
					{
						view: "text",
						name: "token_serial",
						label: _("TOKEN_SERIAL"),
						labelPosition: "top",
						css: "mcls_readonly_text",
						readonly: true
					},
					{
						view: "text",
						name: "signer",
						label: _("NGUOI_KY"),
						labelPosition: "top",
					},

					/* {
						view: "checkbox",
						name: "chon",
						label: _("CHON"),
						checkValue: true,
						uncheckValue: false,
					}, */
					{},
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Lưu (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("chukyso-form");

										var item = form.getValues();

										var khData = {};

										khData.windowid = app.path[1].params[0];
										khData.editmode = editmode;
										khData.data = [];

										khData.data.push(item);

										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(app.config.host + "/System/Save", khData, function (text) {

												var json = JSON.parse(text);

												if (!json.hasOwnProperty("error")) {
													$$("chukyso-win").close();
													app.callEvent("dataChanged", [editmode, json.data]);
												}
												else {
													webix.message(json.error);
												}


											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
								click: function () {
									webix.$$("chukyso-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/chukyso',["app", "views/forms/chukyso", "locale", "views/modules/minvoiceplugin"], function (app, dmwindowform, _, plugin) {
    

    var op = [];

    webix.$$("title").parse({ title: "Đăng ký chứng thư số", details: "Danh sách chứng thư số" });

    var controls = [
        {
            id: "btnPlus",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: _("THEM") + " (F4)",
            width: 85,
            css: "webix_secondary",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var url = app.config.host + "/System/ExecuteCommand";

                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(
                            url,
                            {
                                command: "CM00019",
                                parameter: {
                                    ma_dvcs: "",
                                },
                            },
                            function (text) {
                                var array = JSON.parse(text);

                                var kytaptrung = "";
                                var server_cert = "";

                                for (var i = 0; i < array.length; i++) {
                                    var item = array[i];

                                    if (item.code == "KYTAPTRUNG") {
                                        kytaptrung = item.value;
                                    }

                                    if (item.code == "FILE") {
                                        kytaptrung = item.value;
                                    }

                                    if (item.code == "SERVER_CERT") {
                                        server_cert = item.value;
                                    }
                                }

                                if (kytaptrung == "C") {
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");

                                                    var item = {
                                                        certs: table.serialize(),
                                                    };

                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(app.config.host + "/Token/SaveCerts", item, function (text) {
                                                            var json = JSON.parse(text);

                                                            if (!json.hasOwnProperty("error")) {
                                                                var table = $$("dmwindowData");
                                                                table.clearAll();
                                                                table.load(table.config.url);

                                                                webix.modalbox.hide();
                                                            } else {
                                                                webix.message(json.error);
                                                            }
                                                        });
                                                    break;
                                            }
                                        },
                                    });

                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                    popupText.style.paddingTop = 0;

                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon",
                                                header: _("CHON"),
                                                width: 65,
                                                checkValue: true,
                                                uncheckValue: false,
                                                template: "{common.checkbox()}",
                                            },
                                            {
                                                id: "cert_type",
                                                header: _("Loại"),
                                                width: 100,
                                            },
                                            {
                                                id: "so_serial",
                                                header: _("SO_SERIAL"),
                                                width: 150,
                                            },
                                            {
                                                id: "subjectname",
                                                header: _("SUBJECTNAME"),
                                                width: 450,
                                            },
                                            {
                                                id: "ngaybatdau",
                                                header: _("NGAY_BAT_DAU"),
                                                width: 200,
                                            },
                                            {
                                                id: "ngayketthuc",
                                                header: _("NGAY_HET_HAN"),
                                                width: 200,
                                            },
                                            {
                                                id: "tokenSerial",
                                                header: _("TOKEN_SERIAL"),
                                                width: 150,
                                            },
                                            {
                                                id: "issuer",
                                                header: _("DONVI"),
                                                width: 450,
                                            },
                                        ],
                                        url: server_cert + "/Token/AllCertificates",
                                    });
                                } else {
                                    if (kytaptrung == "FILE") {
                                        var box = webix.modalbox({
                                            title: "Chọn chứng thư số",
                                            buttons: ["Nhận", "Hủy bỏ"],
                                            text: "<div id='ctnCerts'></div>",
                                            top: 100,
                                            width: 750,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "1":
                                                        webix.modalbox.hide();
                                                        break;
                                                    case "0":
                                                        var table = $$("tblCerts");

                                                        var item = {
                                                            certs: table.serialize(),
                                                        };

                                                        webix
                                                            .ajax()
                                                            .headers({ "Content-type": "application/json" })
                                                            .post(app.config.host + "/Token/SaveChukysoFile", item, function (text) {
                                                                var json = JSON.parse(text);

                                                                if (!json.hasOwnProperty("error")) {
                                                                    var table = $$("dmwindowData");
                                                                    table.clearAll();
                                                                    table.load(table.config.url);

                                                                    webix.modalbox.hide();
                                                                } else {
                                                                    webix.message(json.error);
                                                                }
                                                            });
                                                        break;
                                                }
                                            },
                                        });

                                        var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                        popupText.style.paddingTop = 0;

                                        var tblMatHang = webix.ui({
                                            container: "ctnCerts",
                                            id: "tblCerts",
                                            view: "datatable",
                                            borderless: true,
                                            height: 350,
                                            columns: [
                                                {
                                                    id: "chon",
                                                    header: _("CHON"),
                                                    width: 65,
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    template: "{common.checkbox()}",
                                                },
                                                {
                                                    id: "serial_number",
                                                    header: _("SO_SERIAL"),
                                                    width: 250,
                                                },
                                                {
                                                    id: "file_path",
                                                    header: _("Đường dẫn"),
                                                    width: 250,
                                                },
                                                // {
                                                //     id: "pass",
                                                //     header: _("Mật khẩu"),
                                                //     type:"password",
                                                //     editor:"password",
                                                //     width: 200
                                                // }
                                            ],
                                            url: app.config.host + "/Token/AllCertificatesFile",
                                        });
                                    } else {
                                        var hub = plugin.hub();

                                        hub.off("resCommand");
                                        hub.on("resCommand", function (result) {
                                            var json = JSON.parse(result);

                                            if (json.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: json.error });
                                            } else {
                                                var callback = json.callback;

                                                if (callback == "RegisterCert") {
                                                    var item = {
                                                        chon: true,
                                                        so_serial: json.data.so_serial,
                                                        subjectname: json.data.subjectname,
                                                        issuer: json.data.issuer,
                                                        ngaybatdau: json.data.ngaybatdau,
                                                        ngayketthuc: json.data.ngayketthuc,
                                                        tokenSerial: "",
                                                    };

                                                    var certs = [];
                                                    certs.push(item);

                                                    var parameter = {
                                                        certs: certs,
                                                    };

                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(app.config.host + "/Token/SaveCerts", parameter, function (text) {
                                                            var json = JSON.parse(text);

                                                            if (!json.hasOwnProperty("error")) {
                                                                var table = $$("dmwindowData");
                                                                table.clearAll();
                                                                table.load(table.config.url);
                                                            } else {
                                                                webix.message(json.error);
                                                            }
                                                        });
                                                }
                                            }
                                        });

                                        var arg = {
                                            callback: "RegisterCert",
                                        };

                                        hub.invoke("execCommand", arg.callback, JSON.stringify(arg));
                                    }
                                }
                            }
                        );
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
            label: _("SUA") + " (F3)",
            width: 80,
            css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("chukyso-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    //var chon = item.chon;

                    //item.chon = chon == true ? "true" : "false";

                    var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");

                    item.begin_date = removeTimeZoneT(item.begin_date);
                    item.end_date = removeTimeZoneT(item.end_date);

                    form.setValues(item);

                    dmwindowform.setEditMode(2);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "icon",
            icon: "fas fa-trash-o",
            css: "webix_secondary",
            label: _("XOA") + " (F8)",
            width: 80,
            //css:"button_raised",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    var khData = {};
                    khData.windowid = app.path[1].params[0];
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.cer_serial,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/System/Save", khData, function (text) {
                                        var json = JSON.parse(text);

                                        if (json.hasOwnProperty("error")) {
                                            webix.message(json.error);
                                            return;
                                        }

                                        table.remove(item.id);
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "icon",
            icon: "fas fa-file-text-o",
            css: "webix_secondary",
            label: "Tải file",
            width: "90",
            on: {
                onClick: function () {
                    var form = {
                        view: "form",
                        elements: [
                            {
                                id: "txtPass",
                                view: "text",
                                label: "Mật khẩu",
                                labelPosition: "top",
                                required: true,
                                type: "password",
                            },
                            {
                                view: "uploader",
                                id: "upl1",
                                autosend: false,
                                value: "Chọn file",
                                link: "mylist",
                                upload: app.config.host + "/Token/UploadCertFile",
                            },
                            {
                                view: "list",
                                id: "mylist",
                                type: "uploader",
                                autoheight: true,
                                borderless: true,
                            },
                            {
                                view: "button",
                                label: "Lưu file",
                                type: "form",
                                click: function () {
                                    var formData = {
                                        pass: $$("txtPass").getValue(),
                                    };

                                    $$("upl1").define("formData", formData);

                                    $$("upl1").send(function (res) {
                                        if (res.hasOwnProperty("error")) {
                                            webix.message({ type: "error", text: res.error });
                                        } else {
                                            webix.message("Đã tải thành công");

                                            var win = $$("upl1").getTopParentView();
                                            win.close();

                                            var table = $$("dmwindowData");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    });
                                },
                            },
                            {
                                view: "button",
                                label: "Hủy bỏ",
                                type: "danger",
                                shortcut: "esc",
                                click: function () {
                                    var win = this.getTopParentView();
                                    win.close();
                                },
                            },
                        ],
                    };

                    var comp = {
                        view: "window",
                        position: "center",
                        modal: true,
                        head: "Đăng ký File chứng thư số",
                        body: form,
                    };

                    var win = this.$scope.ui(comp);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "icon",
            icon: "mdi mdi-sim",
            css: "webix_secondary",
            label: "Thêm Sim PKI",
            width: "120",
            on: {
                onClick: function () {
                    var form = {
                        id: "formSimPKI",
                        view: "form",
                        elements: [
                            {
                                id: "txtPhone",
                                view: "text",
                                label: "Số điện thoại",
                                labelPosition: "top",
                                required: true,
                                name: "txtPhone",
                                validate: function (value) {
                                    return /([0-9]{9,13})/.test(value);
                                },
                                invalidMessage: "Định dạng điện thoại không đúng, ví dụ: 0862262040",
                            },
                            {
                                view: "button",
                                label: "Lưu",
                                type: "form",
                                click: function () {
                                    var form = this.getParentView();
                                    if (form.validate() == false) {
                                        return;
                                    }
                                    var formData = {
                                        phone: $$("txtPhone").getValue(),
                                    };
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Token/SaveSimPKI", formData, function (text) {
                                            var json = JSON.parse(text);

                                            if (!json.hasOwnProperty("error")) {
                                                var table = $$("dmwindowData");
                                                table.clearAll();
                                                table.load(table.config.url);
                                                var win = $$("modalSimPKI");
                                                win.close();
                                            } else {
                                                webix.message(json.error);
                                            }
                                        });
                                },
                            },
                            {
                                view: "button",
                                label: "Hủy bỏ",
                                type: "danger",
                                shortcut: "esc",
                                click: function () {
                                    var win = this.getTopParentView();
                                    win.close();
                                },
                            },
                        ],
                    };
                    var comp = {
                        id: "modalSimPKI",
                        view: "window",
                        position: "center",
                        modal: true,
                        head: "Thêm số sim PKI",
                        body: form,
                    };

                    var win = this.$scope.ui(comp);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     view: "button",
        //     type: "icon",
        //     icon: "mdi mdi-certificate",
        //     css: "webix_secondary",
        //     label: "Thêm HSM NCCA",
        //     width: "130",
        //     on: {
        //         onClick: function () {
        //             var form = {
        //                 id: "formHSM",
        //                 view: "form",
        //                 elements: [
        //                     {
        //                         id: "token_serial",
        //                         view: "text",
        //                         label: "Mã UUID",
        //                         labelPosition: "top",
        //                         required: true,
        //                         name: "token_serial",
        //                         css:"mcls_uppercase",
        //                         // validate: function (value) {
        //                         //     return /([0-9]{9,13})/.test(value);
        //                         // },
        //                         // invalidMessage: "Định dạng điện thoại không đúng, ví dụ: 0862262040",
        //                     },
        //                     {
        //                         id: "pass",
        //                         view: "text",
        //                         label: "Pass code",
        //                         labelPosition: "top",
        //                         required: true,
        //                         name: "pass",
        //                         css:"mcls_uppercase",
        //                         // validate: function (value) {
        //                         //     return /([0-9]{9,13})/.test(value);
        //                         // },
        //                         // invalidMessage: "Định dạng điện thoại không đúng, ví dụ: 0862262040",
        //                     },
        //                     {
        //                         view: "button",
        //                         label: "Lưu",
        //                         type: "form",
        //                         click: function () {
        //                             var form = this.getParentView();
        //                             if (form.validate() == false) {
        //                                 return;
        //                             }
        //                             var formData = $$("formHSM").getValues();
        //                             webix
        //                                 .ajax()
        //                                 .headers({ "Content-type": "application/json" })
        //                                 .post(app.config.host + "/Token/SaveHSM_NCCA", formData, function (text) {
        //                                     var json = JSON.parse(text);

        //                                     if (!json.hasOwnProperty("error")) {
        //                                         var table = $$("dmwindowData");
        //                                         table.clearAll();
        //                                         table.load(table.config.url);
        //                                         var win = $$("modelHSM");
        //                                         win.close();
        //                                     } else {
        //                                         webix.message(json.error, "error");
        //                                     }
        //                                 });
        //                         },
        //                     },
        //                     {
        //                         view: "button",
        //                         label: "Hủy bỏ",
        //                         type: "danger",
        //                         shortcut: "esc",
        //                         click: function () {
        //                             var win = this.getTopParentView();
        //                             win.close();
        //                         },
        //                     },
        //                 ],
        //             };
        //             var comp = {
        //                 id: "modelHSM",
        //                 view: "window",
        //                 position: "center",
        //                 modal: true,
        //                 head: "Thêm HSM NCCA",
        //                 body: form,
        //             };

        //             var win = this.$scope.ui(comp);
        //             win.show();
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        {
            view: "button",
            type: "icon",
            icon: "mdi mdi-certificate",
            css: "webix_secondary",
            label: "Thêm HSM Khác",
            width: "150",
            on: {
                onClick: function () {
                    var form = {
                        id: "formHSM",
                        view: "form",
                        elements: [
                            {
                                id: "token_serial",
                                view: "text",
                                label: "Mã UUID",
                                labelPosition: "top",
                                required: true,
                                name: "token_serial",
                                css:"mcls_uppercase",
                                // validate: function (value) {
                                //     return /([0-9]{9,13})/.test(value);
                                // },
                                // invalidMessage: "Định dạng điện thoại không đúng, ví dụ: 0862262040",
                            },
                            {
                                id: "pass",
                                view: "text",
                                label: "Pass code",
                                labelPosition: "top",
                                required: true,
                                name: "pass",
                                css:"mcls_uppercase",
                                // validate: function (value) {
                                //     return /([0-9]{9,13})/.test(value);
                                // },
                                // invalidMessage: "Định dạng điện thoại không đúng, ví dụ: 0862262040",
                            },
                            {
                                id: "loai",
                                view: "combo",
                                label: "Loại",
                                labelPosition: "top",
                                required: true,
                                name: "loai",
                                css:"mcls_uppercase",
                                options:["NCCA", "ICORP"]
                                // validate: function (value) {
                                //     return /([0-9]{9,13})/.test(value);
                                // },
                                // invalidMessage: "Định dạng điện thoại không đúng, ví dụ: 0862262040",
                            },
                            {
                                view: "button",
                                label: "Lưu",
                                type: "form",
                                click: function () {
                                    var form = this.getParentView();
                                    if (form.validate() == false) {
                                        return;
                                    }
                                    var formData = $$("formHSM").getValues();

                                    var url = "";

                                    switch(formData.loai) {
                                        case "NCCA":
                                            url = "/Token/SaveHSM_NCCA";
                                        break;
                                        case "ICORP":
                                            url = "/Token/SaveHSM_ICORP";
                                        break;
                                    }

                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + url, formData, function (text) {
                                            var json = JSON.parse(text);

                                            if (!json.hasOwnProperty("error")) {
                                                var table = $$("dmwindowData");
                                                table.clearAll();
                                                table.load(table.config.url);
                                                var win = $$("modelHSM");
                                                win.close();
                                            } else {
                                                webix.message(json.error, "error");
                                            }
                                        });
                                },
                            },
                            {
                                view: "button",
                                label: "Hủy bỏ",
                                type: "danger",
                                shortcut: "esc",
                                click: function () {
                                    var win = this.getTopParentView();
                                    win.close();
                                },
                            },
                        ],
                    };
                    var comp = {
                        id: "modelHSM",
                        view: "window",
                        position: "center",
                        modal: true,
                        head: "Thêm HSM Khác",
                        body: form,
                    };

                    var win = this.$scope.ui(comp);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "icon",
            icon: "mdi mdi-certificate",
            css: "webix_secondary",
            label: "Thêm Remote Signing",
            width: "150",
            on: {
                onClick: function () {
                    var form = {
                        id: "formCKSRS",
                        view: "form",
                        elements: [
                            {
                                id: "private_number",
                                view: "text",
                                label: "CCCD/CMND/Hộ chiếu/Mã số thuế/Số điện thoại",
                                labelPosition: "top",
                                required: true,
                                name: "private_number",
                                css:"mcls_uppercase label_CKS",
                                width: 300
         
                            },
                            {
                                id: "loaiRS",
                                view: "combo",
                                label: "Loại",
                                labelPosition: "top",
                                required: true,
                                name: "loai",
                                css: "mcls_uppercase label_type_CKS",
                                options: [
                                    { id: "RS_MOBIFONECA", value: "MBF" },
                                    { id: "RS_MOBIFONE", value: "MOBIFONECA" },
                                    { id: "RS_NCM", value: "NCM" }
                                ],
                                value: "RS_MOBIFONE" 
                            },
                            {
                                view: "button",
                                label: "Lưu",
                                type: "form",
                                click: function () {
                                    var pathAPI;
                                    if ($$("loaiRS").getValue() == "RS_NCM") {
                                        pathAPI = "RSNacencom";
                                    } else if ($$("loaiRS").getValue() == "RS_MOBIFONE") {
                                        pathAPI = "RSCMC";
                                    } else {
                                        pathAPI = "RSMobifoneCA";
                                    }
                                    var formData = {
                                        user_id: $$("private_number").getValue(),
                                        type: $$("loaiRS").getValue(),
                                    };
                                    if($$("private_number").getValue().trim() == ""){
                                        webix.message("Số CCCD/CMND/Hộ chiếu/Mã số thuế/Số điện thoại không được để trống", "error");
                                        return;
                                    }
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Token/Save" + pathAPI, formData, function (text) {
                                            var json = JSON.parse(text);

                                            if (!json.hasOwnProperty("error") || (json.hasOwnProperty("error") && Object.keys(json).length > 1)) {    
                                                var table = $$("dmwindowData");
                                                table.clearAll();
                                                table.load(table.config.url);
                                                var win = $$("modelCKSRS");
                                                win.close();
                                                debugger
                                                if((json.hasOwnProperty("error") && Object.keys(json).length > 1))
                                                {
                                                    var lstError= json.error.split(";");
                                                    lstError.pop();
                                                    for (var i = 0 ; i< lstError.length; i++) {
                                                        webix.message(lstError[i], "error");
                                                    }
                                                }
                                            } else {
                                                webix.message(json.error, "error");
                                            }
                                        });
                                },
                            },
                            {
                                view: "button",
                                label: "Hủy bỏ",
                                type: "danger",
                                shortcut: "esc",
                                click: function () {
                                    var win = this.getTopParentView();
                                    win.close();
                                },
                            },
                        ],
                    };
                    var comp = {
                        id: "modelCKSRS",
                        view: "window",
                        position: "center",
                        modal: true,
                        head: "Thêm CKS Remote Signing",
                        body: form,
                    };

                    var win = this.$scope.ui(comp);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                //loadahead: 15,
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                },
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

                        if (params == null) {
                            url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);

                                    if (column !== undefined) {
                                        var item = {
                                            columnName: property,
                                            columnType: column.columnType,
                                            value: params.filter[property],
                                        };

                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                if (array.length > 0) {
                                    url = url + "&filter=" + JSON.stringify(array);
                                } else {
                                    url = url + "&filter=null";
                                }
                            } else {
                                url = url + "&filter=null";
                            }
                        }

                        if (view.config.infoparam != null) {
                            url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                        } else {
                            url = url + "&infoparam=null";
                        }

                        var tlbParams = $$("tlbParams");

                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();

                            var parameters = [];

                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];

                                var id = child.config.id;
                                var value_field = child.config.value_field;

                                var item = {
                                    columnName: value_field,
                                    value: $$(id).getValue(),
                                };

                                parameters.push(item);
                            }

                            url = url + "&tlbparam=" + JSON.stringify(parameters);
                        } else {
                            url = url + "&tlbparam=null";
                        }

                        //console.log(url);

                        webix.ajax(url, callback, view);
                    },
                },
                columns: [
                    { id: "cer_serial", header: _("SO_SERIAL"), width: 250 },
                    { id: "subject_name", header: _("SUBJECTNAME"), width: 550 },
                    { id: "signer", header: _("NGUOI_KY"), width: 150 },
                    { id: "cert_type", header: "Loại", width: 130 },
                    /* {
                        id: "chon",
                        checkValue: "true",
                        uncheckValue: "false",
                        template: function (obj, common, value) {
                            if (value)
                                return "<div class='webix_icon fa-check-square-o'></div>";
                            else
                                return "<div class='webix_icon fa-square-o'></div>";
                        },
                        header: _("CHON"),
                        width: 100
                    }, */
                    {
                        id: "begin_date",
                        header: _("NGAY_BAT_DAU"),
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    {
                        id: "end_date",
                        header: _("NGAY_HET_HAN"),
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    { id: "issuer", header: _("DONVI"), width: 550 },
                    {
                        id: "file_name",
                        header: "Tên File",
                        width: 120,
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                view: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});

define('views/modules/dashline_license',["app"], function (app) {
    return {
        $ui: {
            height: 136,
            CSS: "titles",
            borderless: true,
            template: function (data) {
                var t = null;

                if (data.items == undefined) return "";
                var items = data.items;
                
                var html = "<h2 style= ' margin: inherit '>Thông tin gói hóa đơn</h2>";
                html += "<div class='f-grid'>";

                for (var i = 0; i < items.length; i++) {
                    t = items[i];

                    var tien = webix.Number.format(t.tien, {
                        groupDelimiter: ",",
                        groupSize: 3,
                        decimalDelimiter: ".",
                        decimalSize: 0,
                    });

                    var code = "duyethoadon";
                    var params = "0" + t.p_id;

                    if (t.p_id == "04") {
                        code = "reportwindow";
                        params = "WIN00022:d13001df-01fe-4d4f-ab65-cc98e7b41661";
                    }
                    html += "<div class='f-grid-col'>";
                    html +=
                        "<i class='fad fa-boxes fa-4x' style=' padding-top: 25px;margin-right: 20px;--fa-primary-color: #b5b8ba; --fa-secondary-color: #dadee0;' fa-swap-opacity fa-5x></i><div><p style='font-size:18px;'>" +
                        t.dien_giai +
                        "</p>";
                    html +=
                        "<p if(" +
                        t.quyen +
                        " ==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} menu.$scope.show('./" +
                        code +
                        ":" +
                        params +
                        "');\" style='color:#005EB2;font-weight:bold;font-size:20px;text-decoration: none;'>" +
                        tien +
                        "</p></div>";
                    html += "</div>";
                }
                html += "</div>";
                return html;
            },
            url: app.config.host + "/Invoice68/DashboardTiles_License",
        },
    };
});

define('views/modules/dashline78_new',["app"], function (app) {
    return {
        $ui: {
            id: 'dashline78_new',
            height: 136,
            CSS: "titles",
            borderless: true,
            template: function (data) {
                var t = null;
          
                if (data.items == undefined) return "";
                
                var items = data.items;

                var html = "<h2 style= 'margin: inherit '>Hóa đơn 78</h2>";
                html += "<div class='f-grid'>";

                for (var i = 0; i < items.length; i++) {
                    t = items[i];

                    var tien = webix.Number.format(t.tien, {
                        groupDelimiter: ",",
                        groupSize: 3,
                        decimalDelimiter: ".",
                        decimalSize: 0,
                    });

                    var code = "duyethoadon";
                    var params = "0" + t.p_id;

                    if (t.p_id == "04") {
                        code = "reportwindow";
                        params = "WIN00022:d13001df-01fe-4d4f-ab65-cc98e7b41661";
                    }
                    html += "<div class='f-grid-col'>";
                    html +=
                        "<i class='fad fa-boxes fa-4x' style=' padding-top: 25px;margin-right: 20px;--fa-primary-color: #b5b8ba; --fa-secondary-color: #dadee0;' fa-swap-opacity fa-5x></i><div><p style='font-size:18px;'>" +
                        t.dien_giai +
                        "</p>";
                    html +=
                        "<p if(" +
                        t.quyen +
                        " ==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} menu.$scope.show('./" +
                        code +
                        ":" +
                        params +
                        "');\" style='color:#005EB2;font-weight:bold;font-size:20px;text-decoration: none;'>" +
                        tien +
                        "</p></div>";
                    html += "</div>";
                }
                html += "</div>";
                return html;
            },
            //url: app.config.host + "/Invoice68/DashboardTiles78New",
        },
    };
});

define('views/modules/dashline_bienlai',["app"], function (app) {
    return {
        $ui: {
            height: 136,
            id: 'dashline_bienlai',
            CSS: "titles",
            borderless: true,
            template: function (data) {
                var t = null;

                if (data.items == undefined) return "";
                var items = data.items;

                var html = "<h2 style= 'margin: inherit '>Biên lai</h2>";
                html += "<div class='f-grid'>";
                

                for (var i = 0; i < items.length; i++) {
                    t = items[i];

                    var tien = webix.Number.format(t.tien, {
                        groupDelimiter: ",",
                        groupSize: 3,
                        decimalDelimiter: ".",
                        decimalSize: 0,
                    });

                    var code = "duyethoadon";
                    var params = "0" + t.p_id;

                    if (t.p_id == "04") {
                        code = "reportwindow";
                        params = "WIN00022:d13001df-01fe-4d4f-ab65-cc98e7b41661";
                    }
                    html += "<div class='f-grid-col'>";
                    html +=
                        "<i class='fad fa-boxes fa-4x' style=' padding-top: 25px;margin-right: 20px;--fa-primary-color: #b5b8ba; --fa-secondary-color: #dadee0;' fa-swap-opacity fa-5x></i><div><p style='font-size:18px;'>" +
                        t.dien_giai +
                        "</p>";
                    html +=
                        "<p if(" +
                        t.quyen +
                        " ==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} menu.$scope.show('./" +
                        code +
                        ":" +
                        params +
                        "');\" style='color:#005EB2;font-weight:bold;font-size:20px;text-decoration: none;'>" +
                        tien +
                        "</p></div>";
                    html += "</div>";
                }
                html += "</div>";
                return html;
            },
            //url: app.config.host + "/Invoice68/DashboardTiles_BienLai",
        },
    };
});

define('views/modules/dashline_chungtu',["app"], function (app) {
    return {
        $ui: {
            height: 136,
            id: 'dashline_chungtu',
            CSS: "titles",
            borderless: true,
            template: function (data) {
                var t = null;

                if (data.items == undefined) return "";
                var items = data.items;

                var  html = "<h2 style= ' margin: inherit '>Chứng từ</h2>";
                html += "<div class='f-grid'>";

                for (var i = 0; i < items.length; i++) {
                    t = items[i];

                    var tien = webix.Number.format(t.tien, {
                        groupDelimiter: ",",
                        groupSize: 3,
                        decimalDelimiter: ".",
                        decimalSize: 0,
                    });

                    var code = "duyethoadon";
                    var params = "0" + t.p_id;

                    if (t.p_id == "04") {
                        code = "reportwindow";
                        params = "WIN00022:d13001df-01fe-4d4f-ab65-cc98e7b41661";
                    }
                    html += "<div class='f-grid-col'>";
                    html +=
                        "<i class='fad fa-boxes fa-4x' style=' padding-top: 25px;margin-right: 20px;--fa-primary-color: #b5b8ba; --fa-secondary-color: #dadee0;' fa-swap-opacity fa-5x></i><div><p style='font-size:18px;'>" +
                        t.dien_giai +
                        "</p>";
                    html +=
                        "<p if(" +
                        t.quyen +
                        " ==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} menu.$scope.show('./" +
                        code +
                        ":" +
                        params +
                        "');\" style='color:#005EB2;font-weight:bold;font-size:20px;text-decoration: none;'>" +
                        tien +
                        "</p></div>";
                    html += "</div>";
                }
                html += "</div>";
                return html;
            },
            //url: app.config.host + "/Invoice68/DashboardTiles_Chungtu",
        },
    };
});

define('views/modules/chart',["app"], function (app) {

    return {
        $ui: {
            "type": "clean",
            "cols": [
                {
                    rows: [
                        {
                            "template": "<span class='webix_icon fa-chart-bar' style='color:#FF892A;'></span><b style='color:blue'> Doanh thu ( triệu đồng )</b>",
                            "css": "sub_title",
                            "height": 30,
                            borderless: true
                            // "paddingX": 10,
                            // "paddingY": 10,
                            // "margin-left": 10
                        },
                        {
                            view: "chart",
                            type: "line",
                            barWidth: 165,
                            radius: 0,
                            resize: true,
                            gradient: "falling",
                            // value: "#hd01#",a
                            // label: "#hd01#",
                            preset: "column",
                            //border:false,
                            borderless: true,
                            xAxis: {
                                title: "Tháng",
                                lines: false,
                                template: "<span style = 'font-size:11px'> #thang#</span>"
                            },
                            yAxis: {
                                //  title: "Years",
                                //  lines: true,
                                start: 0,
                                step: 500,
                                end: 5000,
                                template: function (obj) {
                                    return (obj % 500 ? "" : obj)
                                }
                            },
                            legend: {
                                values: [{ text: "01GTKT", color: "#4bbaa4" }, { text: "02GTTT", color: "#ee9e36" }, { text: "03XKNB", color: "#36abee" }, { text: "07KPTQ", color: "#ee3639" }, { text: "01BLP", color: "#914ad8" }],
                                valign: "middle",
                                align: "right",
                                width: 90,
                                layout: "y",
                                marker: {
                                    type: "round",
                                    // width:15,
                                    radius: 3
                                }
                            },
                            eventRadius: 5,
                            series: [
                                {
                                    preset: "column",
                                    barWidth: 65,
                                    alpha: 1,
                                    value: "#hd01#",
                                    color: "#4bbaa4",
                                    item: {
                                        // radius: 3,
                                        // type: "s",
                                        borderColor: "#1777ef",
                                        color: "#ffffff"
                                    },
                                    line: {
                                        color: "#4bbaa4",
                                        width: 2
                                    },
                                    tooltip: {
                                        template: "Type: 01GTKT<br/>Value: #hd01#"
                                    }
                                },
                                {
                                    alpha: 0.5,
                                    value: "#hd02#",
                                    color: "#ee9e36",
                                    item: {
                                        borderColor: "#1777ef",
                                        color: "#ffffff"
                                    },
                                    line: {
                                        color: "#ee9e36",
                                        width: 2
                                    },
                                    tooltip: {
                                        template: "Type: 02GTTT<br/>Value: #hd02#"
                                    }
                                },
                                {
                                    alpha: 0.5,
                                    value: "#hd03#",
                                    color: "#36abee",
                                    item: {
                                        borderColor: "#1777ef",
                                        color: "#ffffff"
                                    },
                                    line: {
                                        color: "#36abee",
                                        width: 2
                                    },
                                    tooltip: {
                                        template: "Type: 03XKNB<br/>Value: #hd03#"
                                    }
                                },
                                {
                                    alpha: 0.5,
                                    value: "#hd07#",
                                    color: "#ee3639",
                                    item: {
                                        borderColor: "#1777ef",
                                        color: "#ffffff"
                                    },
                                    line: {
                                        color: "#ee3639",
                                        width: 2
                                    },
                                    tooltip: {
                                        template: "Type: 07KPTQ<br/>Value: #hd07#"
                                    }
                                },
                                {
                                    alpha: 0.5,
                                    value: "#bienlai#",
                                    color: "#914ad8",
                                    item: {
                                        borderColor: "#1777ef",
                                        color: "#ffffff"
                                    },
                                    line: {
                                        color: "#914ad8",
                                        width: 2
                                    },
                                    tooltip: {
                                        template: "Type: 01BLP<br/>Value: #bienlai#"
                                    }
                                }
                            ],
                            url: app.config.host + "/Invoice/bar_chart"
                        }
                        // {
                        //     view: "chart",
                        //     type: "bar",
                        //     barWidth: 60,
                        //    // preset:"column",
                        //     radius: 2,
                        //     gradient: "rising",
                        //     xAxis: {
                        //         template: "'#thang#"
                        //     },
                        //     yAxis: {
                        //         start: 0,
                        //         step: 100,
                        //         end: 1000
                        //     },
                        //     legend: {
                        //         values: [{ text: "01GTKT", color: "#58dccd" }, { text: "02GTTT", color: "#a7ee70" }, { text: "03XKNB", color: "#36abee" }, { text: "07KPTQ", color: "red" }, { text: "01BLP", color: "blue" }],
                        //         valign: "middle",
                        //         align: "right",
                        //         width: 90,
                        //         layout: "y"
                        //     },
                        //     series: [
                        //         {
                        //             value: "#hd01#",
                        //             color: "#58dccd",
                        //             tooltip: {
                        //                 template: "#hd01#"
                        //             }
                        //         },
                        //         {
                        //             value: "#hd02#",
                        //             color: "#a7ee70",
                        //             tooltip: {
                        //                 template: "#hd02#"
                        //             }
                        //         },
                        //         {
                        //             value: "#hd03#",
                        //             color: "#36abee",
                        //             tooltip: {
                        //                 template: "#hd03#"
                        //             }
                        //         },
                        //         {
                        //             value: "#hd07#",
                        //             color: "#36abee",
                        //             tooltip: {
                        //                 template: "#hd07#"
                        //             }
                        //         },
                        //         {
                        //             value: "#bienlai#",
                        //             color: "#36abee",
                        //             tooltip: {
                        //                 template: "#bienlai#"
                        //             }
                        //         }
                        //     ],
                        //     url: app.config.host + "/Invoice/bar_chart",
                        //     // data: multiple_dataset
                        // },
                    ]
                }
                // {
                //     rows:
                //     [
                //         {
                //             "template": "<span class='webix_icon fa-line-chart' style='color:#FF892A;margin-left:20px'></span><b style='color:#669FC7'> Biểu đồ loại hóa đơn</b>",
                //             "css": "sub_title",
                //             "height": 30,
                //             "paddingX": 0,
                //             "paddingY": 10,
                //             "margin": 0
                //         },
                //         {
                //             view: "chart",
                //             type: "pie",
                //             value: "#soluong#",
                //             color: "#color#",
                //             //label: "#loai#",
                //             borderless: true,
                //             pieInnerText: "#soluong#",
                //             shadow: 0,
                //             //data: month_dataset,
                //             url: app.config.host + "/Invoice/bar_chart2",
                //             legend: {
                //                 // width: 75,
                //                 align: "right",
                //                 valign: "middle",
                //                 template: "#loai#"
                //             }
                //         }
                //     ]

                // }

            ]
        }
    };

});
define('views/modules/dynamic_noti',["app"], function (app) {
    return {
        $ui: {
            height: 30,
            id: 'dynamic_noti',
            //CSS: "titles",
            borderless: true,
            template: function (data) {
                if (!data.items) return "";
            
                var html = "";
                var items = data.items;
            
                for (var i = 0; i < items.length; i++) {
                    var t = items[i];
                    html += "[THÔNG BÁO] " + webix.template.escape(t.message);
                    if (i < items.length - 1) {
                        html += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"; 
                    }
                }
            
                return "<marquee style='margin-top:2px' behavior='scroll' direction='left' scrollamount='5'>" +
                       "<span style='color: red; font-size: 14px; font-family: Arial, sans-serif'>" +
                       html +
                       "</span></marquee>";
            },
            url: app.config.host + "/Invoice68/GetDynamicNoti",
        },
    };
});

define('views/thongbaosso',["app", "locale", "views/forms/link_sso"], function (app, _, linkSSO) {
	var layout = {
		view: "window",
		modal: true,
		id: "notisso",
		position: "center",
		head: "Thông báo",
		width: 800,
		height: 400,
		body: {
			view: "form",
			id: "notissobody",
			elements: [
				{
					type: "clean",
					rows: [
						{
							view: "template",
							template: "<div style='text-align: left; padding: 0 30px 0 30px; font-size: 14px;'>" +
								"   <h3>Kính gửi Quý khách hàng</h3>" +
								"   <div>Nhằm nâng cao chất lượng dịch vụ, MobiFone tiến hành nâng cấp hệ thống Quản lý tài khoản tập trung (SSO) cho các khách hàng sử dụng hệ sinh thái giải pháp số của MobiFone.</div>" +
								"   <br/>" +
								"   <div>Sau khi hoàn thành liên kết, Quý khách có thể đăng nhập toàn bộ các hệ thống thuộc hệ sinh thái giải pháp của MobiFone bằng một tài khoản duy nhất. </div>" +
								"   <br/>" +
								"   <div>Thời gian liên kết: Từ ngày 01/04/2024 đến 30/04/2024</div>" +
								"   </div>" +
								"   <br/>" +
								"</div>",
							borderless: false,
							height: 200
						},
						{
							view: "button",
							template: "<div style='display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: center;align-items: center;'><svg xmlns='http://www.w3.org/2000/svg' width='48' height='48'><path fill='none' d='M0 0h48v48H0z'></path><path d='M7.8 24c0-3.42 2.78-6.2 6.2-6.2h8V14h-8C8.48 14 4 18.48 4 24s4.48 10 10 10h8v-3.8h-8c-3.42 0-6.2-2.78-6.2-6.2zm8.2 2h16v-4H16v4zm18-12h-8v3.8h8c3.42 0 6.2 2.78 6.2 6.2s-2.78 6.2-6.2 6.2h-8V34h8c5.52 0 10-4.48 10-10s-4.48-10-10-10z' fill='#6692d7' class='fill-000000'></path></svg> <span style='font-size: 18px; text-decoration:none; color: #7a8cd3;'><i>Liên kết ngay tại đây</i></span></div>",
							on: {
								onClick: function () {
									var win = this.$scope.ui(linkSSO.$ui);
									win.show();
								},
							},
							click: function () {
								this.callEvent("onClick");
							},
							height: 50
						},
						{
							type: "clean",
							cols: [
								{
									view: "template",
									template: "<a href='https://drive.google.com/drive/folders/1gyqEnQlTJw_o9UIhSEtJSGll9PF9qbHO' target='_blank' style='margin-left: 30px; display: flex; font-size: 16px;'><i>Xem chi tiết hướng dẫn tại đây</i></a>",
								},
								{
									view: "button",
									value: "Đóng",
									width: 100,
									on: {
										onClick: function () {
											$$("notisso").hide();
										},
									},
									click: function () {
										this.callEvent("onClick");
									},
								}
							]
						}
					]
				}
			]
		}
	};
	return {
		$ui: layout,
		initUI: function (json) {
			return
		},
	};
});
define('views/forms/changeweakpass',["app"], function (app) {

	return {
		$ui: {
			view: "window", modal: true, id: "listuser-win", position: "center", css: "custom-window",
			head: "Thiết lập mật khẩu",
			body: {
				css: "custom-body",
				paddingY: 10,
				paddingX: 10,
				//elementsConfig:{labelWidth: 120}, 
				view: "form",
				id: "listuser-form",
				complexData: true,
				elements: [
					{ view: "template",  template: "<span style='display:block;color: #0099bb;width: 450px !important; '>Để tăng cường bảo mật cho hệ thống, quý khách vui lòng đặt mật khẩu mới.</span>", css: "notify-text"},
					{ view: "template",  template: "<span style='display:block;color: red;width: 450px !important; '>Chú ý: Mật khẩu phải lớn hơn 8 ký tự, có chứa chữ hoa, chữ thường, số và ký tự đặc biệt.</span>", css: "notify-text"},
					{ view: "text", id:"newpass", name: "newpass", required: true, invalidMessage: "Mật khẩu mới không được bỏ trống", type: "password", label: "Mật khẩu mới", labelPosition: "top" , css:"custom-input", icon: "fa fa-eye", 
						on: {
							onItemClick: function (id, e) {
								// Kiểm tra xem người dùng có click vào biểu tượng không
								if (e.target && e.target.classList.contains("webix_input_icon")) {
									var inputNode = $$("newpass").getInputNode();  // Lấy node input
									var inputType = inputNode.type;  // Kiểm tra loại của input (password hoặc text)
									
									// Thay đổi loại input và biểu tượng tương ứng
									if (inputType === "password") {
										inputNode.type = "text"; // Hiển thị mật khẩu
										webix.html.removeCss(e.target, "fa-eye");
										webix.html.addCss(e.target, "fa-eye-slash"); // Thêm biểu tượng mắt đóng
									} else {
										inputNode.type = "password"; // Ẩn mật khẩu
										webix.html.removeCss(e.target, "fa-eye-slash");
										webix.html.addCss(e.target, "fa-eye"); // Thêm biểu tượng mắt mở
									}
								}
							},
							onBlur: function() {
								var password = this.getValue();
								
								// Password regex: at least 8 characters, including uppercase, lowercase, number, and special character
								var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/;
					
								var errorLabel = this.$view.querySelector(".custom-error-label");
								if (!errorLabel) {
									errorLabel = document.createElement("div");
									errorLabel.className = "custom-error-label";
									errorLabel.style.color = "red";
									errorLabel.style.marginTop = "10px";
									this.$view.appendChild(errorLabel);
								}

								// Show or hide the error message based on password validity
								if (passwordRegex.test(password)) {
									errorLabel.innerText = "";  // Clear error if valid
								} else {
									errorLabel.innerText = "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt.";
								}
							}
						}
					},
					{ view: "text", id:"confirmpass", name: "confirmpass", required: true, invalidMessage: "Xác nhận mật khẩu không được bỏ trống", type: "password", label: "Xác nhận mật khẩu", labelPosition: "top", css:"custom-input", icon: "fa fa-eye", 
						on: {
							onItemClick: function (id, e) {
								// Kiểm tra xem người dùng có click vào biểu tượng không
								if (e.target && e.target.classList.contains("webix_input_icon")) {
									var inputNode = $$("confirmpass").getInputNode();  // Lấy node input
									var inputType = inputNode.type;  // Kiểm tra loại của input (password hoặc text)
									
									// Thay đổi loại input và biểu tượng tương ứng
									if (inputType === "password") {
										inputNode.type = "text"; // Hiển thị mật khẩu
										webix.html.removeCss(e.target, "fa-eye");
										webix.html.addCss(e.target, "fa-eye-slash"); // Thêm biểu tượng mắt đóng
									} else {
										inputNode.type = "password"; // Ẩn mật khẩu
										webix.html.removeCss(e.target, "fa-eye-slash");
										webix.html.addCss(e.target, "fa-eye"); // Thêm biểu tượng mắt mở
									}
								}
							},
							onBlur: function() {
								var password = this.getValue();
								var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/;
								var errorLabel = this.$view.querySelector(".custom-error-label");
								if (!errorLabel) {
									errorLabel = document.createElement("div");
									errorLabel.className = "custom-error-label";
									errorLabel.style.color = "red";
									errorLabel.style.marginTop = "10px";
									this.$view.appendChild(errorLabel);
								}

								if (passwordRegex.test(password)) {
									errorLabel.innerText = "";  // Clear error if valid
								} else {
									errorLabel.innerText = "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt.";
								}
							}
						}
					 },
					{
						css: "custom-button",
						margin: 30,
						cols: [	
							{},
							{
								view: "button", label: "Lưu (F10)", hotkey: "F10", type: "form", align: "center", width: 120, click: function () {

									var form = webix.$$("listuser-form");
									debugger;
									if (form.validate() == false) {
										return;
									}

									var item = form.getValues();
									var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/;

									if (!passwordRegex.test(item.newpass) || !passwordRegex.test(item.confirmpass)) {
										webix.message("Mật khẩu phải lớn hơn 8 ký tự, có chứa chữ hoa, chữ thường, số và ký tự đặc biệt!", "error");
										return;
									}

									if (item.newpass != item.confirmpass) {
										webix.message("Mật khẩu mới không giống nhau", "error");
										return;
									}
									
									webix.ajax()
										.post(app.config.host + "/Account/ChangeWeakPass", item, function (text) {
											var data = JSON.parse(text);

											if (!data.hasOwnProperty("error")) {
												webix.$$("listuser-win").close();
												webix.message("Đổi mật khẩu thành công !", "success");
												var baseUrl = document.location.href;
												if (baseUrl.startsWith("file")) {
													webix.storage.local.remove("appCookie");
												} else {
													Cookies.remove("appCookie");
												}
												setTimeout(function() {
													document.location.reload();
												}, 500);
											}
											else {
												webix.message(data.error, "error");
											}
										});
								}
							},
							{
								view: "button", label: "Hủy bỏ (ESC)", hotkey: "esc", type: "danger", align: "center", width: 120, click: function () {
									webix.$$("listuser-win").close();
								}
							}
						]
					}

				]
			}
		}
	};

});
define('views/thaydoidiachi',["app", "locale", "views/forms/link_sso", "models/user"], function (app, _, linkSSO, user) {
	var layout = {
		view: "window",
		modal: true,
		id: "thaydoidiachi",
		position: "center",
		head: "Thông báo",
		width: 800,
		height: 520,
		body: {
			view: "form",
			id: "thaydoidiachibody",
			padding: 5,
			elements: [
				{
					type: "clean",
					rows: [
						{
							view: "template",
							template: "<div style='text-align: left; font-size: 13px;'>" +
								"   <h3>V/v Cập nhật thông tin địa chỉ theo thay đổi địa giới hành chính</h3>" +
								"   <br/>" +
								"   <div>Kính gửi Quý khách hàng, Cảm ơn quý khách hàng đã sử dụng dịch vụ Hóa đơn điện tử MobiFone Invoice </div>" +
								"   <br/>" +
								"   <div>Cảm ơn quý khách hàng đã sử dụng dịch vụ Hóa đơn điện tử MobiFone Invoice </div>" +
								"   <br/>" +
								"   <div>Theo Nghị quyết số 60-NQ/TW, việc tổ chức chính quyền địa phương theo mô hình hai cấp (Tỉnh/Thành phố và Xã/Phường) </div>" +
								"   <br/>" +
								"	<div>" +
								"	Sẽ được áp dụng từ ngày <b>01/07/2025</b>. Nếu địa chỉ đơn vị đã được cập nhật trên " +
								"	<a href='https://hoadondientu.gdt.gov.vn' target='_blank' style='color: blue; text-decoration: underline;'>trang Web của Cục Thuế</a>, Quý khách cần:" +
								"	</div><br/>" +
								"   <div>  - Sửa địa chỉ trên thông tin doanh nghiệp theo địa chỉ mới (không phải lập Tờ khai đăng ký/thay đổi thông tin sử dụng HĐĐT)</div>" +
								"   <br/>" +
								"   <div>  - Lập hóa đơn theo địa chỉ mới (kiểm tra địa chỉ trên hóa đơn trước khi ký gửi CQT) </div>" +
								"   <br/>" +
								"</div>",
							borderless: false,
							height: 240
						},
						{
							view: "form",
							id: "formUpdateAddress",
							elements: [
								{
									view: "text",
									label: "Địa chỉ hiện tại:",
									id: "address",
									name: "address",
									readonly: true,
									labelPosition: "top",
								},
								{
									view: "text",
									label: "Địa chỉ mới:",
									id: "new_address",
									name: "new_address",
									required: true,
									labelPosition: "top",
								}
							]
						},
						{
							view: "template",
							template: "<div> Lưu ý: Địa chỉ mới lấy theo nguồn dữ liệu của MobiFone. Quý khách nên kiểm tra thêm thông tin trên " +
								"<a href='https://hoadondientu.gdt.gov.vn' target='_blank' style='color: blue; text-decoration: underline;'> trang Web của Cục Thuế </a> để đảm bảo tính đúng đắn.</div>",
						},
						{
							type: "clean",
							cols: [
								{},
								{
									view: "button", id: "confirm-btn", label: "Cập nhật địa chỉ mới", type: "form", align: "center", width: 150,
									click: function () {

										var form = webix.$$("formUpdateAddress");

										if (form.validate() == false) {
											return;
										}

										var item = form.getValues();

										if (item.new_address == null || item.new_address == "") {
											webix.message("Mã OTP không được để trống!", "error");
											return;
										}
										webix.extend(form, webix.ProgressBar);
										form.disable();
										form.showProgress();
										user.UpdateBranchAddressInfo(item.new_address, function () {
										});
										form.enable();
										form.hideProgress();
										$$("thaydoidiachi").hide();
									}
								},
								{
									view: "button",
									value: "Bỏ qua",
									width: 100,
									type: "danger",
									on: {
										onClick: function () {
											debugger
											var dontShowAgain = $$("dontShowAgain").getValue();
											if (dontShowAgain)
												user.UpdateBranchAddressInfo("", false, function () {
												});
											$$("thaydoidiachi").hide();
										},
									},
									click: function () {
										this.callEvent("onClick");
									},
								},
								{ view: "checkbox", id: "dontShowAgain", labelRight: "Không hiển thị lại thông báo này", name: "dontShowAgain", width: 300 }
							]
						}
					]
				}
			]
		}
	};
	return {
		$ui: layout,
		initUI: function (json) {
			return
		},
		setValues: function (item) {
			var form = $$("formUpdateAddress");
			form.setValues(item);
		}
	};
});
define('views/dashboard',[
    //"views/modules/dashline",
    // "views/modules/dashline78",
    "views/modules/dashline_license",
    "views/modules/dashline78_new",
    "views/modules/dashline_bienlai",
    "views/modules/dashline_chungtu",
    // "views/modules/data_invoice",
    // "views/menus/version",
    "views/modules/chart",
    "views/modules/dynamic_noti",
    "views/thongbaosso",
    "views/forms/changeweakpass",
    "app",
    "models/user",
    "views/thaydoidiachi",
], function (dashline_license, dashline78new, dashline_bienlai, dashline_chungtu, chart, dynamic_noti, thongbaosso, changeweakpass, app, user, thaydoidiachi) {
    var cookie = user.getAppCookie();
    var noti = false;
    var notes = false;
    var notify = false;
    if (cookie.noti_sso == "1") {
        noti = true;
    }
    if (cookie.notes_sso == "1") {
        notes = true;
    }
    if (cookie.notify == "1") {
        notify = true;
    }
    // if(cookie.is_weak_pass){
    //     var win = webix.ui(changeweakpass.$ui);
    //     win.show();
    //     cookie.is_weak_pass = false;
    //     Cookies.set("appCookie", cookie);
    // }
    webix.$$("title").parse({ title: "Trang chủ", details: "Phân tích và thống kê" });
    //var soluong = version.getWarning();
    var layout = {
        type: "clean",
        borderless: true,
        paddingX: 20,
        rows: [
            //dashline,
            { height: 15 },
            {
                view: "template",
                height: 40,
                css: { "background-color": "#f5f5f5 !important" },
                template:
                    "<div id=\"filter_dulieu\"> </div>\n",
            },
            { height: 8 },
            {
                css: "dash_invoice",
                type: "clean",
                hidden: !notes,
                rows: [
                    {
                        template: "<marquee style = 'margin-top:2px' behavior='scroll' direction='left' scrollamount='5'><span style='color: red; font-size: 14px; font-family: Arial, sans-serif'>[THÔNG BÁO] Nhằm nâng cao chất lượng dịch vụ, MobiFone tiến hành nâng cấp hệ thống Quản lý tài khoản tập trung (SSO) cho các khách hàng sử dụng hệ sinh thái giải pháp số của MobiFone. Quý khách sẽ thực hiện liên kết tài khoản sử dụng với hệ thống Quản lý tài khoản tập trung SSO khi truy cập vào hệ thống từ ngày 22/04/2024</span></marquee>",
                        height: 30,
                    }
                ],
            },
            { height: 8 },
            {
                css: "dash_invoice",
                type: "clean",
                hidden: !notify,
                rows: [dynamic_noti],
            },
            { height: 8 },
            {
                css: "dash_invoice",
                type: "space",
                rows: [dashline_license],
            },
            { height: 8 },
            {
                css: "dash_invoice",
                type: "space",
                rows: [dashline78new],
            },
            { height: 8 },
            {
                css: "dash_invoice",
                type: "space",
                rows: [dashline_bienlai],
            },
            { height: 8 },
            {
                css: "dash_invoice",
                type: "space",
                rows: [dashline_chungtu],
            },
            // {
            // 	cols: [
            // 		{
            // 			// paddingX: 18,
            // 			css: "dash_invoice",
            // 			type: "space",
            // 			rows: [chart]
            // 		},
            // 		{ width: 10 },
            // 		{
            // 			// paddingX: 30,
            // 			css: "dash_invoice",
            // 			type: "space",
            // 			rows: []
            // 		}
            // 	]
            // }
            // chart,
            // {
            // 	type: "space",
            // 	rows: [
            // 		{
            // 			type: "wide",
            // 			cols: [
            // 				invoice,
            // 				//orders
            // 			]
            // 		},
            // 		/* {
            // 			type: "wide",
            // 			cols: [
            // 				messages,
            // 				revenue
            // 			]
            // 		},
            // 		{
            // 			type: "wide",
            // 			cols: [
            // 				tasks,
            // 				map
            // 			]
            // 		} */
            // 	]
            // }
        ],
    };

    var form_filter = {
        rows: [
            {
                cols: [
                    {
                        id: "lkdlieu",
                        name: "lkdlieu",
                        view: "combo",
                        css: { "border-radius": "20px" },
                        width: 100,
                        height: 30,
                        value: "T",
                        options: [
                            { id: "T", value: "Tháng" },
                            { id: "N", value: "Năm" },
                        ],
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv === "T") {
                                    $$("thoigian_thang").show();
                                    $$("thoigian_thang").setValue(new Date());
                                    $$("thoigian_nam").hide();
                                }
                                else {
                                    $$("thoigian_thang").hide();
                                    $$("thoigian_nam").show();
                                    $$("thoigian_nam").setValue(new Date());
                                }
                            },
                        },
                    },
                    {
                        view: "datepicker", css: { "border-radius": "20px" }, id: "thoigian_thang", format: "%m-%Y", width: 100, height: 30, type: "month", on: {
                            onChange: function (newv, oldv) {
                                var date = new Date(newv.getFullYear(), newv.getMonth(), 1);
                                const lastday = new Date(new Date(newv.getFullYear(), newv.getMonth() + 1, 1) - 1);
                                var format = webix.Date.dateToStr("%Y.%m.%d");

                                $$("thoigian_thang").disable();
                                $$("thoigian_nam").disable();

                                var loadUrl_HD = app.config.host + "/Invoice68/DashboardTiles78New?from=" + format(date) + "&to=" + format(lastday);
                                $$("dashline78_new").load(loadUrl_HD).then(function (data) {
                                    $$("thoigian_thang").enable();
                                    $$("thoigian_nam").enable();
                                });;

                                var loadUrl_BL = app.config.host + "/Invoice68/DashboardTiles_BienLai?from=" + format(date) + "&to=" + format(lastday);
                                $$("dashline_bienlai").load(loadUrl_BL);

                                var loadUrl_CT = app.config.host + "/Invoice68/DashboardTiles_ChungTu?from=" + format(date) + "&to=" + format(lastday);
                                $$("dashline_chungtu").load(loadUrl_CT);
                            },
                        },
                    },
                    {
                        view: "datepicker", id: "thoigian_nam", hidden: true, format: "%Y", width: 100, height: 30, type: "year", on: {
                            onChange: function (newv, oldv) {
                                var date = new Date(newv.getFullYear(), 0, 1);;
                                const lastday = new Date(new Date(newv.getFullYear() + 1, 0, 1) - 1);
                                var format = webix.Date.dateToStr("%Y.%m.%d");

                                $$("thoigian_thang").disable();
                                $$("thoigian_nam").disable();

                                var loadUrl_HD = app.config.host + "/Invoice68/DashboardTiles78New?from=" + format(date) + "&to=" + format(lastday);
                                $$("dashline78_new").load(loadUrl_HD).then(function (data) {
                                    $$("thoigian_thang").enable();
                                    $$("thoigian_nam").enable();
                                });

                                var loadUrl_BL = app.config.host + "/Invoice68/DashboardTiles_BienLai?from=" + format(date) + "&to=" + format(lastday);
                                $$("dashline_bienlai").load(loadUrl_BL);

                                var loadUrl_CT = app.config.host + "/Invoice68/DashboardTiles_ChungTu?from=" + format(date) + "&to=" + format(lastday);
                                $$("dashline_chungtu").load(loadUrl_CT);
                            },
                        }
                    }
                ]
            }
        ]
    };

    var setdsFieldFormat = function() {
        var url = app.config.host + "/Invoice68/GetDecimalPlaceAll";
        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .get(url, function (text) {
                var arr = JSON.parse(text);
                webix.storage.local.put("dsFieldFormatAll", arr);
            });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var item = {
                command: "NOTYFI_INV_TEMP",
                parameter: {
                    username: user.getCurrentUser(),
                },
            };

            if (cookie.is_weak_pass) {
                var win = webix.ui(changeweakpass.$ui);
                win.show();
                cookie.is_weak_pass = false;
                Cookies.set("appCookie", cookie);
            }

            if (noti) {
                var winthongbaosso = $scope.ui(thongbaosso.$ui);
                winthongbaosso.show();
            }

            user.getBranchAddressInfo(function (branch_info) {
                if (branch_info.update_address == false) {
                    if (branch_info.address != branch_info.new_address) {
                        var winthaydoidiachi = $scope.ui(thaydoidiachi.$ui);
                        thaydoidiachi.setValues(branch_info);
                        winthaydoidiachi.show();
                    }
                    else {
                        user.UpdateBranchAddressInfo("", function () {
                        });
                    }
                }
            });

            webix.ui({
                container: "filter_dulieu",
                view: "layout",
                rows: [
                    form_filter
                ]
            });

            $$("thoigian_thang").setValue(new Date());

            setdsFieldFormat();

            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .post(app.config.host + "/System/ExecuteCommand", item, function (text) {
                    var res = JSON.parse(text);
                    if (res.length > 0 && res != null) {
                        var mess = "Thông báo sắp hết hóa đơn :";
                        for (var i = 0; i < res.length; i++) {
                            mess = mess + "mẫu số: " + res[i].template_code + " ký hiệu: " + res[i].invoice_series;
                            // + res[i].quantity;
                        }
                        webix.message(mess, "debug", 5000);
                    }
                });

            var item1 = {
                command: "NOTYFI_INV_TEMP_78",
                parameter: {
                    username: user.getCurrentUser(),
                },
            };

            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .post(app.config.host + "/System/ExecuteCommand", item1, function (text) {
                    var res = JSON.parse(text);
                    if (res.length > 0 && res != null) {
                        var mess = "Thông báo sắp hết hóa đơn 78: </br>";
                        for (var i = 0; i < res.length; i++) {
                            mess = mess + " ký hiệu: " + res[i].ky_hieu + "</br>";
                            // + res[i].quantity;
                        }
                        webix.message(mess, "debug", 5000);
                    }
                });

            var item3 = {
                command: "NOTYFI_LICENSE_EXPIRE",
                parameter: {
                    username: user.getCurrentUser(),
                },
            };

            webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .post(app.config.host + "/System/ExecuteCommand", item3, function (text) {
                    var res = JSON.parse(text);
                    if (res.length > 0 && res != null) {
                        var mess = "Thông báo sắp hết license: Số lượng license còn lại là: " + res[0].remaining;
                        webix.message(mess, "debug", 5000);
                    }
                });

            webix.ajax().get(app.config.host + "/Invoice68/getHansudungcert?username=" + user.getCurrentUser(), function (text) {
                var res = JSON.parse(text);
                var checked = false;

                if (res.length > 0 && res != null) {
                    var message = "Thông báo sắp hết hạn CKS: </br>";

                    for (var i = 0; i < res.length; i++) {
                        var datecert = new Date(res[i].end_date);
                        var convertcert = datecert.getFullYear() + "-" + (datecert.getMonth() + 1) + "-" + datecert.getDate();
                        var checkdatecert = new Date(convertcert);
                        var datenow = new Date();
                        var convernow = datenow.getFullYear() + "-" + (datenow.getMonth() + 1) + "-" + datenow.getDate();
                        var checkdatenow = new Date(convernow);
                        var ngayhethan = parseInt((checkdatecert.getTime() - checkdatenow.getTime()) / (24 * 3600 * 1000));

                        if (ngayhethan < 31 && ngayhethan >= 0) {
                            message += "Serial: " + res[i].cer_serial + " sắp hết hạn </br>";
                            checked = true;
                        }
                    }
                    if (checked) {
                        webix.message(message, "debug", 5000);
                    }
                }
            });

            webix.ajax().get(app.config.host + "/Invoice68/CheckHSDChungTu", function (text) {
                var res = JSON.parse(text);
                var message;
                if (res.length > 0 && res.length != null) {
                    var checkdate = new Date(res[0].lisence_to);
                    var datenow = new Date();
                    var convernow = datenow.getFullYear() + "-" + (datenow.getMonth() + 1) + "-" + datenow.getDate();
                    var checkdatenow = new Date(convernow);
                    var ngayhethan = parseInt((checkdate.getTime() - checkdatenow.getTime()) / (24 * 3600 * 1000));
                    if (ngayhethan < 61 && ngayhethan > 0) {
                        message = "Thông báo sắp hết hạn sử dụng gói chứng từ TNCN: </br>";
                        webix.message(message, "debug", 5000);
                    } else if (ngayhethan < 0) {
                        message = "Thông báo đã hết hạn sử dụng gói chứng từ TNCN";
                        webix.message(message, "debug", 5000);
                    }
                }
            });
            webix.ajax().get(app.config.host + "/Invoice68/getPromotionNews", function (text) {
                var res = JSON.parse(text);

                if (res.length > 0 && res != null) {
                    for (var i = 0; i < res.length; i++) {
                        var message = res[i].content;
                        webix.message(message, "success", 10000);
                    }
                }
            });

            webix.ajax().get(app.config.host + "/Invoice68/CheckGoiDemo", function (text) {
                var res = JSON.parse(text);

                var now = new Date();
                var date = new Date('2024-02-16');

                if (res && now < date) {
                    message = "Gói cước của Quý khách sẽ hết hạn vào ngày 15/02/2024, vui lòng liên hệ AM hoặc tổng đài 093.611.0116 để được hỗ trợ. </br>";
                    webix.message(message, "debug", 5000);
                }

            });


            //console.log(soluong);
            // if (soluong.length > 0 && soluong != null) {
            // 	var mess = "Thông báo :"
            // 	for (var i = 0; i < soluong.length; i++) {
            // 		mess = mess + soluong[i].thongbao;
            // 	}
            // 	webix.message(mess, "debug", 5000);
            // }
        },
    };
});

define('views/DataStorage/DataHoaDon78',["app"], function (app) {

    var data = {
    };
    
    return {
        SetData: function(key, value) {
            data[key] = value; 
        },
        GetData: function(key) {
            return data[key];
        },
        ClearData: function(keys) {
            if(keys) {
                var listKey = keys.split(";");
                if(listKey && listKey.length > 0) {
                    listKey.forEach(function(element) {
                        data[element] = null;
                    });
                }
            }
        }
    }
});

define('views/forms/dmfield',["app"], function (app) {
    var editmode = 0;

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "dmfield-win",
            position: "center",
            head: "Thông tin Field",
            fullscreen: true,
            body: {
                view: "scrollview",
                scroll: "native-y",
                body: {
                    paddingY: 10,
                    paddingX: 10,
                    elementsConfig: { labelWidth: 150 },
                    view: "form",
                    id: "dmfield-form",
                    complexData: true,
                    margin: 0,
                    elements: [
                        {
                            cols: [
                                { view: "text", name: "ord", label: "STT", id: "dmfield-id" },
                                { view: "text", name: "column_name", label: "Column Name", id: "dmfield-name" },
                            ],
                        },
                        {
                            cols: [
                                { view: "text", name: "row", label: "Row", id: "dmfield-row" },
                                { view: "text", name: "col", label: "Col", id: "dmfield-col" },
                            ],
                        },
                        {
                            cols: [
                                { view: "text", name: "width", label: "Width", id: "dmfield-width" },
                                { view: "text", name: "height", label: "Height", id: "dmfield-height" },
                            ],
                        },
                        {
                            cols: [
                                { view: "text", name: "column_width", label: "Column Width", id: "dmfield-columnwidth" },
                                { view: "text", name: "column_alias", label: "Column alias" },
                            ],
                        },
                        { view: "text", name: "default_value", label: "DEFAULT VALUE" },
                        {
                            cols: [
                                {
                                    view: "combo",
                                    name: "column_type",
                                    label: "Column Type",
                                    id: "dmfield-columntype",
                                    suggest: {
                                        body: {
                                            url: app.config.host + "/System/GetTypeSQL",
                                        },
                                    },
                                    //options: app.config.host + "/System/GetTypeSQL"
                                },
                                {
                                    view: "combo",
                                    name: "type_editor",
                                    label: "TYPE EDITOR",
                                    id: "dmfield-typeeditor",
                                    suggest: {
                                        body: {
                                            data: [
                                                "text",
                                                "combo",
                                                "checkbox",
                                                "datepicker",
                                                "autonumeric",
                                                "treesuggest",
                                                "gridsuggest",
                                                "gridcombo",
                                                "textarea",
                                                "multiselect",
                                                "select",
                                                "ckeditor",
                                                "password",
                                                "search",
                                                "popup",
                                            ],
                                        },
                                    },
                                    //options: ["text", "combo", "checkbox", "datepicker", "autonumeric", "treesuggest", "gridsuggest", "gridcombo", "textarea", "multiselect", "ckeditor", "password","search"]
                                },
                            ],
                        },
                        {
                            cols: [
                                {
                                    view: "text",
                                    name: "data_width",
                                    label: "Data Width",
                                },
                                {
                                    view: "text",
                                    name: "data_decimal",
                                    label: "Data decimal",
                                },
                            ],
                        },
                        {
                            cols: [
                                { view: "text", name: "label_width", label: "Label Width", id: "dmfield-labelwidth" },
                                { view: "combo", name: "label_position", options: ["left", "top", "right", "bottom"], label: "Label Position", id: "dmfield-labelposition" },
                            ],
                        },
                        {
                            view: "combo",
                            name: "ref_id",
                            label: "REF ID",
                            id: "dmfield-refid",
                            suggest: {
                                body: {
                                    url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00004",
                                },
                            },
                            //options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00004"
                        },
                        { view: "text", name: "list_column", label: "LIST COLUMN" },
                        { view: "text", name: "display_field", label: "DISPLAY_FIELD" },
                        { view: "text", name: "format", label: "FORMAT" },
                        { view: "text", name: "field_expression", label: "FIELD_EXPRESSION" },
                        { view: "text", name: "css", label: "Css" },
                        { view: "text", name: "template", label: "Template" },
                        { view: "text", name: "styleinput", label: "Style Input" },
                        {
                            view: "combo",
                            name: "space",
                            options: [
                                { id: "BEFORE", value: "Trước" },
                                { id: "AFTER", value: "Sau" },
                            ],
                            label: "SPACE",
                        },
                        { view: "text", name: "caption", label: "CAPTION" },
                        { view: "text", name: "read_only", label: "READONLY" },
                        {
                            view: "combo",
                            name: "type_filter",
                            options: ["textFilter", "serverFilter", "numberFilter", "datepickerFilter", "serverDateRangeFilter", "serverSelectFilter", "serverMultiSelectFilter"],
                            label: "Type Filter",
                            id: "dmfield-typefilter",
                        },
                        {
                            view: "combo",
                            name: "value_filter",
                            label: "VALUE FILTER",
                            id: "dmfield-value_filter",
                            suggest: {
                                body: {
                                    url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00004",
                                },
                            },
                            //options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00004"
                        },
                        { view: "combo", name: "valid_rule", options: ["isNotEmpty", "isEmail", "isSpecialCharacter", "isTaxCode"], label: "Valid Rule", id: "dmfield-validrule" },
                        { view: "text", name: "total_column", label: "Total Column", id: "dmfield-totalcolumn" },
                        { view: "textarea", height: 160, name: "value_change", label: "VALUE_CHANGE" },
                        { view: "textarea", height: 160, name: "value_suggest", label: "VALUE_SUGGEST" },
                        {
                            cols: [
                                { view: "checkbox", name: "hide_in_grid", label: "HIDE_IN_GRID", checkValue: "true", uncheckValue: "false", id: "dmfield-hiddeningrid" },
                                { view: "checkbox", name: "hidden", label: "Hidden", checkValue: "true", uncheckValue: "false", id: "dmfield-hidden" },
                            ],
                        },
                        {
                            margin: 10,
                            cols: [
                                {},
                                {
                                    shortcut: "F10",
                                    view: "button",
                                    label: "Nhận (F10)",
                                    type: "form",
                                    align: "center",
                                    width: 120,
                                    on: {
                                        onClick: function () {
                                            var form = webix.$$("dmfield-form");
                                            var item = form.getValues();
                                            var branch_code = $$("branch_code_field").getValue();
                                            if(item != null) {
                                                item["branch_code"] = branch_code;
                                            }
                                            
                                            var url = "/WbField/Update";

                                            webix.ajax().post(app.config.host + url, item, function (text) {
                                                var data = JSON.parse(text);

                                                if (!data.hasOwnProperty("error")) {
                                                    item.id = data.id;
                                                    webix.$$("dmfield-win").close();
                                                    app.callEvent("dataChanged", [editmode, item]);
                                                } else {
                                                    webix.message(data.error);
                                                }
                                            });
                                        },
                                    },
                                    click: function () {
                                        this.callEvent("onClick");
                                    },
                                },
                                {
                                    view: "button",
                                    hotkey: "esc",
                                    label: "Hủy bỏ (ESC)",
                                    type: "danger",
                                    align: "center",
                                    width: 140,
                                    click: function () {
                                        webix.$$("dmfield-win").close();
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
    };
});

define('views/dmfield',[
	"app",
	"views/forms/dmfield",
	"locale"
], function (app, dmfieldform, _) {
	

	//var windowno = app.path[1].params[0];
	webix.$$("title").parse({ title: "Điều khiển > Danh mục field", details: "Danh mục field system" });
	var submenu = webix.ui({
		view: "submenu",
		width: 300,
		padding: 0,
		data: [
			{ id: "importcolumns", icon: "fas fa-angle-right", value: "Tải cột" },
			{ id: "createtable", icon: "fas fa-angle-right", value: "Tạo bảng dữ liệu" },
			{ id: "createproccrud", icon: "fas fa-angle-right", value: "Tạo thủ tục (Thêm - Sửa - Xóa)" },
			{ id: "processstt", icon: "fas fa-angle-right", value: "Đánh lại số thứ tự" }
		],
		on: {
			onItemClick: function (id, e, node) {
				if (id == "importcolumns") {

					var url = app.config.host + "/System/InsertFieldsByTabId";
					var tabId = webix.$$("txtTabId").getValue();

					webix.ajax()
						.headers({ 'Content-type': 'application/json' })
						.post(url, { id: tabId }, function (text) {
							var json = JSON.parse(text);

							if (!json.hasOwnProperty("error")) {
								loadData();
							}
							else {
								webix.message(json.error);
							}

						});
				}

				if (id == "createtable") {

					var url = app.config.host + "/System/AutoCreateTable";
					var tabId = webix.$$("txtTabId").getValue();

					webix.ajax()
						.headers({ 'Content-type': 'application/x-www-form-urlencoded' })
						.post(url, "id=" + tabId, function (text) {
							var json = JSON.parse(text);

							if (!json.hasOwnProperty("error")) {
								loadData();
							}
							else {
								webix.message(json.error);
							}

						});
				}

				if (id == "createproccrud") {

					var url = app.config.host + "/System/AutoCreateCmd";
					var tabId = webix.$$("txtTabId").getValue();

					webix.ajax()
						//.headers({'Content-type':'application/x-www-form-urlencoded'})
						.post(url, "id=" + tabId, function (text) {
							var json = JSON.parse(text);

							if (!json.hasOwnProperty("error")) {
								loadData();
								webix.message("Đã thực hiện xong");
							}
							else {
								webix.message(json.error);
							}

						});
				}

				if (id == "processstt") {
					var table = webix.$$("dmfieldData");
					var numberRow = table.count();

					var url = "/WbField/Update";

					for (var i = 0; i < numberRow; i++) {
						var id = table.getIdByIndex(i);
						var item = table.getItem(id);

						item.stt = i + 1;

						webix.ajax().post(app.config.host + url, item, function (text) {
							var data = JSON.parse(text);

							if (!data.hasOwnProperty("error")) {
								webix.$$("dmfieldData").updateItem(item.id, item);

							}

						});
					}



				}
			}
		}
	});

	var controls = [
		{
			view: "button", type: "htmlbutton", width: 100,
			label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
			'<span class="text">' + "Thêm (F4)" + '</span>',
			id: "btnPlus",
			// view: "button",
			// type: "icon",
			// icon: "fas fa-plus",
			// label: "Thêm (F4)",
			// css: "webix_secondary",
			// width: 90,
			shortcut: "F4",
			on: {
				onClick: function () {
					var win = this.$scope.ui(dmfieldform.$ui);
					var form = webix.$$("dmfield-form");

					if (webix.$$("txtTabId").getValue() == "") {
						webix.message("Bạn chưa chọn Tab Id")
						return;
					}

					var item = {
						wb_tab_id: $$("txtTabId").getValue()
					};

					form.setValues(item);

					dmfieldform.setEditMode(1);
					win.show();
				}
			},
			click: function () {
				this.callEvent("onClick");
			}
		},
		{
			view: "button", type: "htmlbutton", width: 100,
			label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
			'<span class="text">' + "Sửa (F3)" + '</span>',
			id: "btnEdit",
			// view: "button",
			// type: "icon",
			// icon: "fas fa-edit",
			// label: "Sửa (F3)",
			// css: "webix_secondary",
			// width: 60,
			shortcut: "F3",
			on: {
				onClick: function () {
					var detailForm = this.$scope.ui(dmfieldform.$ui);
					var form = webix.$$("dmfield-form");

					var table = webix.$$("dmfieldData");
					var item = table.getSelectedItem();

					form.setValues(item);

					dmfieldform.setEditMode(2);
					detailForm.show();
				}
			},
			click: function () {
				this.callEvent("onClick");
			}
		},
		{
			view: "button", type: "htmlbutton", width: 100,
			label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
			'<span class="text">' + "Xóa (F8)" + '</span>',
			id: "btnDelete",
			// view: "button",
			// type: "icon",
			// icon: "fas fa-trash-o",
			// label: "Xóa (F8)",
			// css: "webix_secondary",
			// width: 80,
			shortcut: "F8",
			on: {
				onClick: function () {
					var table = webix.$$("dmfieldData");
					var item = table.getSelectedItem();
					var branch_code = $$("branch_code_field").getValue();
					if(item != null) {
						item["branch_code"] = branch_code;
					}
					webix.confirm({
						text: "Bạn có muốn xóa " + item.column_name, ok: "Có", cancel: "Không",
						callback: function (res) {
							if (res) {
								webix.ajax().post(app.config.host + "/WbField/Delete", item, function (text, xml, xhr) {
									if (text.hasOwnProperty("error")) {
										webix.message(text.error);
										return;
									}

									table.remove(item.id);

								});

							}
						}
					});
				}
			},
			click: function () {
				this.callEvent("onClick");
			}

		},
		{
			view: "button", type: "htmlbutton", width: 100,
			label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' +
			'<span class="text">' + "Sao chép" + '</span>',
			id: "btnCopy",
			// view: "button",
			// type: "icon",
			// icon: "fas fa-files-o",
			// label: "Sao chép",
			// css: "webix_secondary",
			// width: 85,
			on: {
				onClick: function () {
					var detailForm = this.$scope.ui(dmfieldform.$ui);
					var form = webix.$$("dmfield-form");

					var table = webix.$$("dmfieldData");
					var item = table.getSelectedItem();

					if (item == null) {
						webix.message({ type: "error", text: "Bạn chưa chọn mục field" });
						return;
					}

					item.id = null;
					form.setValues(item);

					dmfieldform.setEditMode(1);
					detailForm.show();
				}
			},
			click: function () {
				this.callEvent("onClick");
			}
		},
		{
			view: "button", type: "htmlbutton", width: 110,
			label: '<i class="fa fa-angle-down fa-lg" aria-hidden="true"></i> ' +
			'<span class="text">' + "Chức năng" + '</span>',
			id: "btnChucNang",
			// view: "button",
			// type: "icon",
			// icon: "fas fa-angle-down",
			// label: "Chức năng",
			// css: "webix_secondary",
			// width: 100,
			click: function () {
				submenu.show(webix.$$("btnChucNang").$view);
			}
		},
		{},
		{
			id: "paramDonvi",
			view: "toolbar",
			css: { "background-color": "#f5f5f5 !important" },
			borderless: true,
			height: 35,
			cols: [
				{
					id: "branch_code_field",
					view: "combo",
					width: 600,
					label: _("Đơn vị"),
					options: {
						body: {
							url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195A",
							ready: function () {
								var count = this.count();

								if (count > 0) {
									var combo = webix.$$("branch_code_field");
									var first = this.getFirstId();
									combo.setValue(first);
									var tab = webix.$$("txtTabId").getPopup().getList();
									if(tab) {
										tab.clearAll(); 
										tab.load(app.config.host + "/WbTab/All?branch_code=" + first);
									}
								}
								// }
							},
						},
					},
					on: {
						onChange: function (newv, oldv) {
							var tabCombo = webix.$$("txtTabId");
							var tab = tabCombo.getPopup().getList();
							if(tab && newv != null && newv != '') {
								tab.clearAll(); 
								tabCombo.setValue(null);
								tab.load(app.config.host + "/WbTab/All?branch_code=" + newv, function() {
                                    var table = webix.$$("dmfieldData");
                                    table.clearAll();
                                });
							}
						},
					},
				},
			],
		},
		{},
		{
			view: "combo",
			width: 400,
			label: "Tab ID",
			id: "txtTabId",
			options: {
				view: "gridsuggest",
				id: "grid_tab",
				template: "#name#",
				width: 550,
				body: {
					scroll: true,
					autoheight: false,
					columns: [
						{ id: "code", header: "Window Id", editor: "text", width: 100 },
						{ id: "name", header: "Window Name", editor: "text", width: 400 }
					],
					// url: app.config.host + "/WbTab/All"
				}
			},
			on: {
				onChange: function () {
					loadData();
				}
			}
		}
	];

	var grid = {
		rows: [
			{
				id: "dmfieldData",
				view: "datatable",
				select: true,
				resizeColumn: true,
				datafetch: 2,
				loadahead: 15,
				drag: true,
				on: {
					onItemDblClick: function (id, e, node) {
						var btnEdit = $$("btnEdit");
						btnEdit.callEvent("onClick");
					}
				},
				columns: [
					{ id: "wb_tab_id", header: "Tab Id", width: 100, hidden: true },
					{ id: "ord", header: "STT", width: 75 },
					{ id: "column_name", header: "Column Name", width: 150 },
					{ id: "row", header: "Row", width: 60 },
					{ id: "col", header: "Col", width: 60 },
					{ id: "width", header: "Width", width: 80 },
					{ id: "column_width", header: "Column Width", width: 150 },
					{ id: "column_type", header: "Column Type", width: 150 },
					{ id: "label_width", header: "Label Width", width: 150 },
					{ id: "label_position", header: "Label Position", width: 150 },
					{ id: "space", header: "SPACE", width: 150 },
					{ id: "type_editor", header: "TYPE EDITOR", width: 150 },
					{ id: "ref_id", header: "REF ID", hidden: true, width: 150 },
					{ id: "default_value", header: "Default Value", width: 250 },
					{ id: "hide_in_grid", header: "HIDE_IN_GRID", width: 120, checkValue: true, uncheckValue: false, template: "{common.rcheckbox()}" },
					{ id: "hidden", header: "Hidden", width: 80, checkValue: true, uncheckValue: false, template: "{common.rcheckbox()}" }
				],
				//columns: columns
				pager: "pagerA",
				type: {
					rcheckbox: function (obj, common, value, config) {
						var checked = (value == config.checkValue) ? 'checked="true"' : '';
						return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
					}
				}

			},
			{
				id: "pagerA",
				view: "pager",
				size: 50,
				group: 5,
				// animate: { direction:"top" },
				template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
			}
		]
	}

	var layout = {
		css: "frmView",
		rows: [
			{
				height: 39,
				css: { "background-color": "#f5f5f5 !important" },
				type: "toolbar",
				margin: 0,
				borderless: true,
				cols: controls
			},
			{
				rows: [
					grid
				]
			}



		]

	};

	function loadData() {
		var tabId = webix.$$("txtTabId").getValue();
		if(tabId != null && tabId != "") {
			var branch_code = $$("branch_code_field").getValue(); 
			var url = app.config.host + "/WbField/GetFieldsByTabId?id=" + tabId + "&branch_code="  + branch_code;
	
			webix.ajax().get(url, function (text) {
				var json = JSON.parse(text);
	
				var table = webix.$$("dmfieldData");
				table.clearAll();
	
				for (var i = 0; i < json.length; i++) {
					var item = json[i];
	
					/* if (item.hidden!=null){
						item.hidden = item.toString();
					} */
				}
	
				table.parse(json);
	
			});
		}
	}



	return {
		$ui: layout,
		$oninit: function (view, $scope) {
			$scope.on(app, "dataChanged", function (mode, item) {

				var table = webix.$$("dmfieldData");

				if (mode == 1) {
					table.add(item);
					//table.select(item.iddmfield,false);
				}

				if (mode == 2) {
					var selectedItem = table.getSelectedItem();
					table.updateItem(selectedItem.id, item);
				}

			});
		}
	};
});
define('views/dmhv',["app", "views/forms/window"], function (app, dmhvform) {
    

    //var hvno = app.path[1].params[0];
    var col = [];
    var url = app.config.host + "/api/System/GetAllByWindowId?id=09a8b24b-52b5-46a6-931d-d6f005da0dd7";
    webix.ajax(url, function (text, xml, xhr) {
        var rp = JSON.parse(text);
        //console.log(Object.keys(rp).length);

        for (var j = 0; j < Object.keys(rp["data"][0]["Tabs"][0]["Fields"]).length; j++) {
            col.push({ header: "" + String(rp["data"][0]["Tabs"][0]["Fields"][j]["COLUMN_NAME"]) + "", fillspace: true });
        }
        $$("windowData").define("columns", col);
        $$("windowData").refresh();

        //   console.log(col);
        //   console.log(Object.keys(rp.data).length);
    });

    var controls = [
        {
            id: "btnPlus",
            view: "button",
            type: "iconButton",
            icon: "plus",
            label: "Thêm",
            width: 110,
            css: "button_raised",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmhvform.$ui);
                    dmhvform.setEditMode(1);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "iconButton",
            icon: "edit",
            label: "Sửa",
            width: 100,
            css: "button_raised",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmhvform.$ui);
                    var form = webix.$$("window-form");

                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    form.setValues(item);

                    dmhvform.setEditMode(2);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "iconButton",
            icon: "trash-o",
            label: "Xóa",
            width: 100,
            css: "button_raised",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.ten_hv,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax().post(app.config.host + "/api/Dmhv/Delete", item, function (text, xml, xhr) {
                                    if (text.hasOwnProperty("error")) {
                                        webix.message(text.error);
                                        return;
                                    }

                                    table.remove(item.id);
                                });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var grid = {
        margin: 10,
        rows: [
            {
                id: "dmhvData",
                view: "datatable",
                select: true,
                datafetch: 2,
                loadahead: 15,
                // url: {
                //     $proxy:true,
                //     load:function(view, callback, params){
                //             var url = app.config.host+ "/api/dmhv/All";

                //             webix.ajax(url, callback, view);
                //     }
                // },
                columns: col,
                //  {id: "ma_hv", header: "Mã hàng" , width: 100 },
                //  {id: "ten_hv", header: "Tên hàng" , fillspace: true },
                // {id: "dvt", header: "Đơn vị tính" , fillspace: true }
                // {id: "quai", header: "Quai", width:80},
                // {id: "mau", header: "Màu sắc", width:80},
                // {id: "doday", header: "Độ dày", width:80},
                // {
                //     id: "gia_ban", header: "Giá bán", width:80 ,
                //     format:webix.Number.numToStr({
                //             groupDelimiter:",",
                //             groupSize:3,
                //             decimalDelimiter:".",
                //             decimalSize:0
                //         }),
                //     css:{'text-align':'right'}
                // }
                //  ],
                //columns: columns
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        type: "space",
        rows: [
            {
                height: 40,
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmhvData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmhv,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});

define('views/forms/dmlanguage',["app"], function (app) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win", position: "center",
			head: "Thông tin ngôn ngữ",
			width: 400,
			height: 250,
			body: {
				paddingY: 20,
				paddingX: 30,
				elementsConfig: { labelWidth: 60 },
				view: "form",
				id: "dmtab-form",
				complexData: true,
				margin: 0,
				elements: [
					{ view: "text", name: "wb_lang_id", label: "wb_lang_id", id: "wb_lang_id", hidden: true },
					{ view: "text", name: "key_lang", label: "Key", id: "dmtab-name" },
					{ view: "textarea", name: "value_lang", label: "Value", id: "dmtab-table" },
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("dmtab-form");
										var item = form.getValues();
										//console.log(item);
										var url = editmode == 1 ? app.config.host + "/System/InsertLanguages" : app.config.host + "/System/UpdateLanguages"

										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(url, item, function (text) {
												var data = JSON.parse(text);

												if (!data.hasOwnProperty("error")) {
													item.id = data.id;
													$$("dmtab-win").close();
													app.callEvent("dataChanged", [editmode, item]);
												}
												else {
													webix.message(data.error, "error");
												}
											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", type: "danger", width: 120,
								click: function () {
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/dmlanguage',["app", "views/forms/dmlanguage", "locale"], function (app, dmtabform, _) {
    

    //var windowno = app.path[1].params[0];

    var controls = [
        // {
        //     id: "btnRefresh",
        //     view: "button",
        //     type: "icon",
        //     icon: "refresh",
        //     label: _("REFRESH"),
        //     width: 90,
        //     // shortcut: "F4",
        //     //css:"button_raised",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("dmtabData");
        //             table.clearAll();

        //             table.load(loadData());
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            id: "btnPlus",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: _("THEM") + " (F4)",
            width: 90,
            css: "webix_secondary",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmtabform.$ui);
                    var form = webix.$$("dmtab-form");

                    if (webix.$$("txtWindowId").getValue() == "") {
                        webix.message("Bạn chưa chọn loại ngôn ngữ !", "error");
                        return;
                    }

                    var item = {
                        language_code: $$("txtWindowId").getValue(),
                    };

                    form.setValues(item);

                    dmtabform.setEditMode(1);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
            label: "Sửa (F3)",
            width: 80,
            css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmtabform.$ui);
                    var form = webix.$$("dmtab-form");

                    var table = webix.$$("dmtabData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa ! ", "error");
                        return;
                    }
                    form.setValues(item);

                    dmtabform.setEditMode(2);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "icon",
            icon: "fas fa-trash-o",
            label: "Xóa (F8)",
            width: 80,
            css: "webix_secondary",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmtabData");
                    var item = table.getSelectedItem();

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.key_lang,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax().post(app.config.host + "/System/DeleteLanguages", item, function (text, xml, xhr) {
                                    if (text.hasOwnProperty("error")) {
                                        webix.message(text.error);
                                        return;
                                    }

                                    table.remove(item.id);
                                });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {
            view: "combo",
            width: 300,
            label: "Ngôn ngữ",
            id: "txtWindowId",
            // options: ["en", "vi"],
            suggest: {
                // body: {
                //     url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00012"
                // }
                data: [
                    { id: "vi", value: "Việt Nam" },
                    { id: "en", value: "English" },
                    { id: "ko", value: "Korea" },
                ],
            },
            on: {
                onChange: function () {
                    loadData();
                },
            },
        },
    ];

    var grid = {
        rows: [
            {
                id: "dmtabData",
                view: "datatable",
                select: true,
                datafetch: 50,
                loadahead: 15,
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                },
                columns: [
                    { id: "wb_lang_id", header: "wb_lang_id", hidden: true },
                    { id: "language_code", header: "LANGUAGES", hidden: true },
                    { id: "key_lang", header: ["Key", { content: "textFilter" }], width: 200 },
                    { id: "value_lang", header: ["Value", { content: "textFilter" }], fillspace: true },
                ],
                //columns: columns
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    function loadData() {
        var windowId = webix.$$("txtWindowId").getValue();
        var url = app.config.host + "/System/GetLanguagesByMa?lang=" + windowId;

        webix.ajax().get(url, function (text) {
            var json = JSON.parse(text);

            var table = webix.$$("dmtabData");
            table.clearAll();
            table.parse(json);
        });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmtabData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmtab,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});

define('views/forms/dmreferences',["app"],function(app){
	var editmode = 0;	

	return {		
		$ui:{   
			view:"window", modal:true, id:"dmwindow-win", position:"center",
			head:"Thông tin Window",
			fullscreen:true,
			body:{
                paddingY:20, 
                paddingX:30, 
                elementsConfig:{labelWidth: 100}, 
                view:"form", 
				id:"dmwindow-form", 
				complexData:true,
				margin:0,
                elements:[
					{ view:"text", name:"REFERENCES_ID", label:"RF ID",  id:"dmwindow-rfid"},
                    { view:"text", name:"NAME", label:"Name",  id:"dmwindow-name"},
					{
						cols:[
							{ view:"text", name:"VALUE_FIELD", label:"Value Field",  id:"dmwindow-valuefield"},
							{ view:"text", name:"DISPLAY_FIELD", label:"Display Field",  id:"dmwindow-displayfield"},
						]
					},
					{ view:"combo", name:"TYPE", label:"TYPE", options:[ "List", "SQL" ], id:"dmwindow-type"},
					{ view:"text", name:"SQL", label:"SQL",  id:"dmwindow-sql"},
					{ view:"text", name:"LIST_VALUE", label:"LIST VALUE",  id:"dmwindow-listvalue"},
					{ view:"text", name:"LIST_COLUMN", label:"LIST COLUMN",  id:"dmwindow-listcolumn"},
					{ view:"text", name:"FILTER_VALUE", label:"FILTER VALUE",  id:"dmwindow-filtervalue"},
					{ view:"text", name:"ORDER_BY", label:"ORDER BY",  id:"dmwindow-orderby"},
					{ view:"text", name:"GHICHU", label:"Ghi chú",  id:"dmwindow-ghichu"},
					{ 
						view:"combo", 
						name:"WINDOW_ID", 
						label:"WINDOW ID",  
						id:"dmwindow-windowid",
						options: app.config.host + "/api/System/GetDataByReferencesId?id=76DCF72E-7631-458A-986F-5B6D9BE9B203"
					},
					{
						margin:10,
						cols:[
							{},
							{ 
								shortcut:"F10",  view:"button", label:"Nhận", type:"form", align:"center", width:120, 
								on: {
									onClick: function() {
										var form = webix.$$("dmwindow-form");
										var item = form.getValues();
										console.log(item);
										if(editmode==1){
											webix.ajax().post( app.config.host + "/api/System/InsertReferences", item, function(text){
												var data = JSON.parse(text);
												//console.log(data);
												if (!data.hasOwnProperty("error")){
													item.id = data.id;
													webix.$$("dmwindow-win").close();
													app.callEvent("dataChanged",[editmode,item]);
												}
												else {
													webix.message(data.error);
												}
											});
										}
										if(editmode==2){
											webix.ajax().post( app.config.host + "/api/System/UpdateReferences", item, function(text){
												var data = JSON.parse(text);
												//console.log(data);
												if (!data.hasOwnProperty("error")){
													item.id = data.id;
													webix.$$("dmwindow-win").close();
													app.callEvent("dataChanged",[editmode,item]);
												}
												else {
													webix.message(data.error);
												}
											});
										}
										
									}
								},
								click:function(){								
									this.callEvent("onClick");							
									
								}
							},
							{ view:"button", hotkey:"esc", label:"Hủy bỏ",align:"center", width:120, 
								click:function(){
									webix.$$("dmwindow-win").close();
								}
							}
						]
					}

				]
			}			
			
		},		
		setEditMode: function(mode) {
			editmode = mode;
		}
	};

});
define('views/dmreferences',["app", "views/forms/dmreferences"], function (app, dmwindowform) {
    

    var op = [];
    var url = app.config.host + "/api/System/getAllWindows";
    webix.ajax(url, function (text, xml, xhr) {
        var rp = JSON.parse(text);
        //console.log(Object.keys(rp).length);

        for (var i = 0; i < Object.keys(rp["data"]).length; i++) {
            op.push({ ID: String(rp["data"][i]["ID"]), WINDOW_NAME: String(rp["data"][i]["WINDOW_NAME"]) });
        }
        console.log(op[0]["WINDOW_NAME"]);
    });

    var controls = [
        {
            id: "btnPlus",
            view: "button",
            type: "iconButton",
            icon: "plus",
            label: "Thêm",
            width: 110,
            css: "button_raised",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmwindowform.$ui);
                    dmwindowform.setEditMode(1);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "iconButton",
            icon: "edit",
            label: "Sửa",
            width: 100,
            css: "button_raised",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("dmwindow-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    console.log(item);
                    form.setValues(item);

                    dmwindowform.setEditMode(2);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "iconButton",
            icon: "trash-o",
            label: "Xóa",
            width: 100,
            css: "button_raised",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.WINDOW_NAME,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax().post(app.config.host + "/api/System/DeleteReferences?id=" + item.id, function (text, xml, xhr) {
                                    if (text.hasOwnProperty("error")) {
                                        webix.message(text.error);
                                        return;
                                    }

                                    table.remove(item.id);
                                });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 2,
                loadahead: 15,
                resizeColumn: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var url = app.config.host + "/api/System/GetAllReferences";
                        webix.ajax(url, callback, view);
                    },
                },
                columns: [
                    { id: "REFERENCES_ID", header: "RF ID", width: 100 },
                    { id: "NAME", header: "Title", width: 250 },
                    { id: "VALUE_FIELD", header: "Value Field", width: 150 },
                    { id: "DISPLAY_FIELD", header: "Display Field", width: 150 },
                    { id: "TYPE", header: "Type", width: 100 },
                    { id: "SQL", header: "SQL", width: 250 },
                    { id: "ORDER_BY", header: "ORDER BY", width: 150 },
                    { id: "LIST_VALUE", header: "LIST VALUE", width: 250 },
                    { id: "GHICHU", header: "GHI CHU", width: 250 },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 45,
                view: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});

define('views/forms/dmtab',["app"], function (app) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win", position: "center",
			head: "Thông tin Tab",
			fullscreen: true,
			body: {
				view: "scrollview",
				scroll: "native-y",
				body: {
					paddingY: 10,
					paddingX: 10,
					elementsConfig: { labelWidth: 100 },
					view: "form",
					id: "dmtab-form",
					complexData: true,
					margin: 0,
					elements: [
						{
							cols: [
								{ view: "text", name: "code", label: "TAB ID", id: "dmtab-id" },
								{ view: "text", name: "ord", label: "STT", id: "dmtab-stt" },
							]
						},
						{ view: "text", name: "name", label: "Tab Name", id: "dmtab-name" },
						{ view: "text", name: "table_name", label: "Tab Table", id: "dmtab-table" },
						{
							cols: [
								{
									view: "combo",
									name: "tab_type",
									label: "TAB TYPE",
									options: ["Normal", "Detail", "Master"],
									id: "dmtab-type"
								},
								{
									view: "combo",
									name: "tab_view",
									label: "TAB VIEW",
									options: ["Grid", "Tree"],
									id: "dmtab-view"
								}
							]
						},
						{ view: "text", name: "foreign_key", label: "FOREIGN KEY", id: "dmtab-FOREIGN-KEY" },
						{ view: "text", name: "insert_cmd", label: "INSERT CMD", id: "dmtab-insert-cmd" },
						{ view: "text", name: "update_cmd", label: "UPDATE CMD", id: "dmtab-update-cmd" },
						{ view: "text", name: "delete_cmd", label: "DELETE CMD", id: "dmtab-delete-cmd" },
						{ view: "textarea", name: "select_cmd", label: "SELECT CMD", height: 60, id: "dmtab-select-cmd" },
						{ view: "textarea", name: "select_change", label: "SELECT CHANGE", height: 150, id: "dmtab-select-change" },
						{ view: "textarea", name: "cell_editstop", label: "CELL EDITSTOP", height: 150, id: "dmtab-cell-editstop" },
						{ view: "textarea", name: "after_addrow", label: "AFTER ADDROW", height: 150, id: "dmtab-afteraddrow" },
						{ view: "textarea", name: "after_delrow", label: "AFTER DELROW", height: 150, id: "dmtab-afterdelrow" },
						{ view: "textarea", name: "oncheck", label: "ON CHECK", height: 150, id: "dmtab-oncheck" },
						{ view: "text", name: "prefix", label: "PREFIX", id: "dmtab-prefix" },
						{ view: "text", name: "order_by", label: "ORDER BY", id: "dmtab-orderby" },
						{
							margin: 10,
							cols: [
								{},
								{
									shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 140,
									on: {
										onClick: function () {
											var form = webix.$$("dmtab-form");
											var item = form.getValues();
											var branch_code = $$("branch_code_tab").getValue();
                                            if(item != null) {
                                                item["branch_code"] = branch_code;
                                            }

											var url = app.config.host + "/WbTab/Update";

											webix.ajax()
												.headers({ 'Content-type': 'application/json' })
												.post(url, item, function (text) {
													var data = JSON.parse(text);

													if (!data.hasOwnProperty("error")) {
														item.id = data.id;
														webix.$$("dmtab-win").close();
														app.callEvent("dataChanged", [editmode, item]);
													}
													else {
														webix.message(data.error);
													}
												});
										}
									},
									click: function () {
										this.callEvent("onClick");
									}
								},
								{
									view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 140,
									click: function () {
										webix.$$("dmtab-win").close();
									}
								}
							]
						}

					]
				}

			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/dmtab',["app", "views/forms/dmtab"], function (app, dmtabform) {
    

    //var windowno = app.path[1].params[0];
    // webix.$$("title").parse({ title: "Danh mục Tab", details: "Danh mục Tab system" });
    webix.$$("title").parse({ title: "Điều khiển > Danh mục Tab", details: "Danh mục Tab system" });

    var controls = [
        {
            id: "btnPlus",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: "Thêm (F4)",
            css: "webix_secondary",
            width: 95,
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmtabform.$ui);
                    var form = webix.$$("dmtab-form");

                    if (webix.$$("txtWindowId").getValue() == "") {
                        webix.message("Bạn chưa chọn Window Id");
                        return;
                    }

                    var item = {
                        wb_window_id: $$("txtWindowId").getValue(),
                    };

                    form.setValues(item);

                    dmtabform.setEditMode(1);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
            label: "Sửa (F3)",
            width: 85,
            css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmtabform.$ui);
                    var form = webix.$$("dmtab-form");

                    var table = webix.$$("dmtabData");
                    var item = table.getSelectedItem();

                    form.setValues(item);

                    dmtabform.setEditMode(2);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "icon",
            icon: "fas fa-trash-o",
            label: "Xóa (F8)",
            css: "webix_secondary",
            width: 85,
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmtabData");
                    var item = table.getSelectedItem();
                    var branch_code = $$("branch_code_tab").getValue();
					if(item != null) {
						item["branch_code"] = branch_code;
					}
                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.tab_name,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax().post(app.config.host + "/WbTab/Delete", item, function (text, xml, xhr) {
                                    if (text.hasOwnProperty("error")) {
                                        webix.message(text.error);
                                        return;
                                    }

                                    table.remove(item.id);
                                });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnCopy",
            view: "button",
            type: "icon",
            icon: "fas fa-files-o",
            label: "Sao chép",
            css: "webix_secondary",
            width: 85,
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmtabform.$ui);
                    var form = webix.$$("dmtab-form");

                    var table = webix.$$("dmtabData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message({ type: "error", text: "Bạn chưa chọn mục tab" });
                        return;
                    }

                    item.id = null;
                    form.setValues(item);

                    dmtabform.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {
			id: "paramDonvi",
			view: "toolbar",
			css: { "background-color": "#f5f5f5 !important" },
			borderless: true,
			height: 35,
			cols: [
				{
					id: "branch_code_tab",
					view: "combo",
					width: 600,
					label: "Đơn vị",
					options: {
						body: {
							url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195A",
							ready: function () {
								var count = this.count();

								if (count > 0) {
									var combo = webix.$$("branch_code_tab");
									var first = this.getFirstId();
									combo.setValue(first);
									var tab = webix.$$("txtWindowId").getPopup().getList();
									if(tab) {
										tab.clearAll(); 
										tab.load(app.config.host + "/WbWindow/All?branch_code=" + first);
									}
								}
								// }
							},
						},
					},
					on: {
						onChange: function (newv, oldv) {
                            var tabCombo = webix.$$("txtWindowId");
							var tab = tabCombo.getPopup().getList();
							if(tab && newv != null && newv != '') {
								tab.clearAll(); 
                                tabCombo.setValue(null);
								tab.load(app.config.host + "/WbWindow/All?branch_code=" + newv, function() {
                                    var table = webix.$$("dmtabData");
                                    table.clearAll();
                                });
							}
						},
					},
				},
			],
		},
        {},
        {
            view: "combo",
            width: 450,
            label: "Window ID",
            id: "txtWindowId",
            options: {
                view: "gridsuggest",
                id: "grid_window",
                // filter: function (obj, value) {
                //     var string = "";
                //     if (obj) {
                //         string += obj.id + " ";
                //         string += obj.window_name + " ";

                //     }
                //     return string.toLowerCase().indexOf(value.toLowerCase()) >= 0;
                // },
                // template: function (item) {
                //     return item.name + " ";
                //},
                template: "#name#",
                width: 550,
                body: {
                    scroll: true,
                    autoheight: false,
                    columns: [
                        { id: "code", header: "Window Id", editor: "text", width: 100 },
                        { id: "name", header: "Window Name", editor: "text", width: 400 },
                    ],
                    // url: app.config.host + "/WbWindow/All",
                },
            },
            // suggest: {
            // 	url: app.config.host + "/WbWindow/All",
            // 	template: "#window_name#",
            // 	body: {
            // 		template: "#window_name#"
            // 	}
            // },
            on: {
                onChange: function () {
                    loadData();
                },
            },
        },
    ];

    var grid = {
        rows: [
            {
                id: "dmtabData",
                view: "datatable",
                select: true,
                resizeColumn: true,
                datafetch: 2,
                loadahead: 15,
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                },
                columns: [
                    { id: "ord", header: "STT", width: 80 },
                    { id: "code", header: "Tab Id", width: 80 },
                    { id: "wb_window_id", header: "Window Id", hidden: true },
                    { id: "name", header: "Tab Name", width: 250 },
                    { id: "table_name", header: "Tab Table", width: 150 },
                    { id: "tab_type", header: "Tab Type", width: 100 },
                    { id: "tab_view", header: "Tab View", width: 100 },
                    { id: "foreign_key", header: "FOREIGN KEY", width: 150 },
                    { id: "insert_cmd", header: "INSERT CMD", width: 150 },
                    { id: "update_cmd", header: "UPDATE CMD", width: 150 },
                    { id: "delete_cmd", header: "DELETE CMD", width: 150 },
                    { id: "select_cmd", header: "SELECT CMD", width: 150 },
                ],
                //columns: columns
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: { "background-color": "#f5f5f5 !important" },
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    function loadData() {
        var windowId = webix.$$("txtWindowId").getValue();
        if(windowId != null && windowId != "") {
            var branch_code = $$("branch_code_tab").getValue(); 
            var url = app.config.host + "/WbTab/GetTabsByWindowId?id=" + windowId + "&branch_code=" + branch_code;
    
            webix.ajax().get(url, function (text) {
                var json = JSON.parse(text);
    
                var table = webix.$$("dmtabData");
                table.clearAll();
                table.parse(json);
            });
        }
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmtabData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmtab,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});

define('views/forms/dmwindow',["app"], function (app) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmwindow-win", position: "center",
			head: "Thông tin Window",
			fullscreen: true,
			body: {
				view: "scrollview",
				scroll: "native-y",
				body: {
					paddingY: 10,
					paddingX: 10,
					elementsConfig: { labelWidth: 120 },
					view: "form",
					id: "dmwindow-form",
					complexData: true,
					margin: 0,
					elements: [
						{ view: "text", name: "code", label: "WINDOW ID", id: "dmwindow-id" },
						{ view: "text", name: "name", label: "Tittle", id: "dmwindow-name" },
						{
							view: "combo",
							name: "window_type",
							label: 'Window Type',
							value: "Grid",
							options: ["Grid", "Detail", "MasterDetail", "Report"],
							id: "dmwindow-type"
						},
						{
							cols: [
								{ view: "text", name: "width", label: "Width", id: "dmwindow-width" },
								{ view: "text", name: "height", label: "Height", id: "dmwindow-height" },
							]
						},
						{
							cols: [
								{ view: "text", name: "fix_left", label: "fix_left", id: "dmwindow-fix_left", tooltip: "Số dòng cố định bên trái" },
								{ view: "text", name: "fix_right", label: "fix_right", id: "dmwindow-fix_right", tooltip: "Số dòng cố định bên phải" },
							]
						},
						{ view: "text", name: "max_row", label: "Rows max", id: "dmwindow-rowsmax", tooltip: "Số dòng lớn nhất của form" },
						{ view: "text", name: "tab_row", label: "Row tab", id: "dmwindow-rowtab", tooltip: "Dòng bắt đầu của form chi tiết nếu có" },
						{ view: "text", name: "voucher_code", label: "MA_CT", id: "dmwindow-mact" },
						{ view: "text", name: "sql_code", label: "SQL_CODE", id: "dmwindow-sqlcode" },
						{
							view: "combo",
							name: "wb_infowindow_id",
							label: "INFO WINDOW",
							id: "dmwindow-vcinfowindowid",
							options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00028"
						},
						{ view: "textarea", height: 160, name: "after_new", label: "AFTER_NEW", tooltip: "Trước khi UI forms được tạo" },
						{ view: "textarea", height: 160, name: "before_save", label: "BEFORE_SAVE", tooltip: "Trước khi lưu dữ kiệu TO DO CODE" },
						{ view: "textarea", height: 160, name: "after_save", label: "AFTER_SAVE" },
						{ view: "textarea", height: 160, name: "detail_layout", label: "Layout Detail", tooltip: "Nếu triển khai UI ở đây thì không Auto UI" },
						{ view: "textarea", height: 160, name: "after_edit", label: "AFTER_EDIT" },
						{
							margin: 10,
							cols: [
								{},
								{
									shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 140,
									on: {
										onClick: function () {
											var form = webix.$$("dmwindow-form");
											var item = form.getValues();
											var branch_code = $$("branch_code_window").getValue();
                                            if(item != null) {
                                                item["branch_code"] = branch_code;
                                            }
											webix.ajax()
												.headers({ 'Content-type': 'application/json' })
												.post(app.config.host + "/WbWindow/Update", item, function (text) {
													var data = JSON.parse(text);
													//console.log(data);
													if (!data.hasOwnProperty("error")) {
														item.id = data.id;
														webix.$$("dmwindow-win").close();
														app.callEvent("dataChanged", [editmode, item]);
													}
													else {
														webix.message(data.error);
													}
												});
										}
									},
									click: function () {
										this.callEvent("onClick");
									}
								},
								{
									view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 140,
									click: function () {
										webix.$$("dmwindow-win").close();
									}
								}
							]
						}

					]
				}

			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/dmwindow',["app", "views/forms/dmwindow", "locale"], function (app, dmwindowform, _) {
    

    var op = [];
    //webix.$$("title").parse({ title: "Danh mục window", details: "Danh mục window system" });
    var controls = [
        {
            height: 38,
            id: "title",
            css: "title",
            width: 150,
            borderless: true,
            //css: { "box-shadow": "0 -2px #3498db inset !important" , "background":"#ffffff !important"},
            template: "<div class='header'>#title#</div>",
            data: { text: "", title: "Danh mục window", details: "Danh mục window" },
        },
        {
            id: "btnPlus",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: _("THEM") + " (F4)",
            width: 95,
            css: "webix_secondary",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmwindowform.$ui);
                    dmwindowform.setEditMode(1);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
            label: _("SUA") + " (F3)",
            width: 85,
            css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("dmwindow-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    //console.log(item);
                    form.setValues(item);

                    dmwindowform.setEditMode(2);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "icon",
            icon: "fas fa-trash-o",
            label: _("XOA") + " (F8)",
            width: 85,
            css: "webix_secondary",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    var branch_code = $$("branch_code_window").getValue();
					if(item != null) {
						item["branch_code"] = branch_code;
					}
                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.name,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/WbWindow/Delete", item, function (text, xml, xhr) {
                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }

                                        table.remove(item.id);
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnCopy",
            view: "button",
            type: "icon",
            icon: "fas fa-files-o",
            label: _("COPY"),
            width: 85,
            css: "webix_secondary",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dữ liệu");
                        return;
                    }

                    webix.confirm({
                        text: "Bạn có muốn sao chép " + item.WINDOW_NAME,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                var query = "EXECUTE sproc_copy_vcwindow'" + item.id + "',null";

                                var url = app.config.host + "/api/System/ExecuteQuery?sql=" + query;

                                webix.ajax(url, function (text) {
                                    var json = JSON.parse(text);

                                    if (json.length > 0) {
                                        webix.message(json[0]["ERROR"]);
                                    } else {
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {
			id: "paramDonvi",
			view: "toolbar",
			css: { "background-color": "#f5f5f5 !important" },
			borderless: true,
			height: 35,
			cols: [
				{
					id: "branch_code_window",
					view: "combo",
					width: 600,
					label: _("Đơn vị"),
					options: {
						body: {
							url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195A",
							ready: function () {
								var count = this.count();

								if (count > 0) {
									var combo = webix.$$("branch_code_window");
									var first = this.getFirstId();
									combo.setValue(first);
                                    loadDmWindowData(first);
								}
							},
						},
					},
					on: {
						onChange: function (newv, oldv) {
                            loadDmWindowData(newv)
						},
					},
				},
			],
		}        
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                resizeColumn: true,
                //loadahead: 15,
                // url: {
                //     $proxy: true,
                //     load: function (view, callback, params) {
                //         debugger;
                //         var url = app.config.host + "/WbWindow/GetWindows";

                //         if (params == null) {
                //             url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                //         } else {
                //             url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                //             if (params.filter != null) {
                //                 var array = [];

                //                 for (var property in params.filter) {
                //                     var column = view.getColumnConfig(property);

                //                     var item = {
                //                         columnName: property,
                //                         columnType: column.columnType,
                //                         value: params.filter[property],
                //                     };

                //                     array.push(item);
                //                 }

                //                 //console.log(JSON.stringify(array));
                //                 url = url + "&filter=" + JSON.stringify(array);
                //             }
                //         }

                //         webix.ajax(url, callback, view);
                //     },
                // },
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                },
                columns: [
                    { id: "code", header: ["No", { content: "textFilter" }], width: 100 },
                    { id: "name", header: ["Title", { content: "textFilter" }], width: 400 },
                    { id: "window_type", header: "Window Type", fillspace: true },
                    { id: "width", header: "Width", fillspace: true },
                    { id: "height", header: "Height", fillspace: true },
                    { id: "max_row", columnType: "VC_TIEN", header: ["Rows max", { content: "textFilter" }], fillspace: true },
                    { id: "tab_row", header: "Row tab", fillspace: true },
                    { id: "voucher_code", header: "MA_CT", fillspace: true },
                    { id: "sql_code", header: "SQL_CODE", fillspace: true },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    function loadDmWindowData(branch_code) {
        var dataTable = $$("dmwindowData");
        
        // Chỉ gán URL khi cần tải
        dataTable.clearAll(); // Xóa dữ liệu cũ nếu cần
        dataTable.define("url", {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/WbWindow/GetWindows";
                
                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                    
                    if (params.filter != null) {
                        var array = [];
    
                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);
    
                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                            };
    
                            array.push(item);
                        }
    
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                url = url + "&branch_code=" + branch_code;
                webix.ajax(url, callback, view);
            }
        });
    }

    function loadData() {
        var schoolyearcode = webix.$$("dmwindow").getValue();

        var url = app.config.host + "/api/System/GetWindowById?ID=" + schoolyearcode;

        webix.ajax().get(url, function (text) {
            var data = JSON.parse(text);

            var table = webix.$$("dmwindowData");
            table.clearAll();
            table.parse(data);
        });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});

define('views/forms/duyethoadon',["app"], function (app) {
    
    var editmode = 0;

    return {
        $ui: {
            view: "window", modal: true, id: "duyethoadon-win", position: "center",
            head: "Chi tiết hóa đơn",
            height: 800,
            width: 5000,
            autoheight: false,
            body: {
                paddingY: 20,
                paddingX: 20,
                //elementsConfig:{labelWidth: 120}, 
                view: "form",
                id: "duyethoadon-form",
                complexData: true,
                elements: [
                    {
                        view: "fieldset",
                        label: "Thông tin hóa đơn",
                        body: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: "datepicker",
                                            label: "Ngày hóa đơn",
                                            name: "invoice_issued_date",
                                            // name: "date",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                            format: webix.Date.dateToStr("%d/%m/%Y")
                                        },
                                        {
                                            view: "text",
                                            label: "Mã mẫu hóa đơn",
                                            name: "template_code",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                        },
                                        {
                                            view: "text",
                                            label: "Ký hiệu",
                                            name: "invoice_series",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                        },
                                        {
                                            view: "text",
                                            label: "Số hóa đơn",
                                            name: "invoice_number",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                          
                                        },
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            label: "Trạng thái",
                                            name: "status",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                        },
                                        {
                                            view: "text",
                                            label: "Hình thức thanh toán",
                                            name: "payment_method_name",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                        },
                                        {
                                            view: "text",
                                            label: "Mã tiền tệ",
                                            name: "currency_code",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                        },
                                        {
                                            view: "text",
                                            label: "Tỷ giá",
                                            name: "exchange_rate",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                        },
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            label: "NH bên mua",
                                            name: "buyer_bank_account",
                                            readonly: true,
                                            width: 600,
                                            labelWidth: 150,
                                        },
                                        {
                                            view: "text",
                                            label: "TK bên mua",
                                            name: "buyer_bank_account",
                                            readonly: true,
                                            width: 600,
                                            labelWidth: 150,
                                        },
                                    ]
                                }
                            ]
                        }
                    },

                    {
                        view: "fieldset",
                        label: "Thông tin khách hàng",
                        body: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            label: "Mã khách hàng",
                                            name: "customer_code",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                        },
                                        {
                                            view: "text",
                                            label: "Mã số thuế",
                                            name: "buyer_taxcode",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                        },
                                        {
                                            view: "text",
                                            label: "Email",
                                            name: "buyer_email",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                        },
                                        {
                                            view: "text",
                                            label: "Điện thoại",
                                            name: "buyer_tel",
                                            readonly: true,
                                            width: 300,
                                            labelWidth: 150,
                                        },
                                        
                                    ]
                                },
                                {
                                    cols: [{
                                        view: "text",
                                        label: "Tên người mua",
                                        name: "buyer_display_name",
                                        readonly: true,
                                        width: 1200,
                                        labelWidth: 150,
                                    }]
                                },
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            label: "Địa chỉ",
                                            name: "buyer_address_line",
                                            readonly: true,
                                            width: 1200,
                                            labelWidth: 150,
                                        },
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            label: "Tên đơn vị",
                                            name: "buyer_legal_name",
                                            readonly: true,
                                            width: 1200,
                                            labelWidth: 150,
                                        },
                                    ]
                                }
                            ]
                        }
                    },

                    // {
                    //     view: "fieldset",
                    //     label: "Chi tiết hóa đơn",
                        
                    // },

                    {  
                        borderless:true,
                        scrollX:true,
                        tabbar:{  
                           "width":200
                        },
                        view:"datatable",
                        id:"detail",
                        on: {
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                });
                            }
                        },
                        columns:[
                            {
                                id: "stt",
                                header: "STT",
                                width: 40,
                            },
                            {
                                id: "item_code",
                                name: "item_code",
                                header: "Mã hàng",
                                width: 150,
                                editor: "combo",
                            },
                            {
                                id: "item_name",
                                name: "item_name",
                                header: "Tên hàng hóa",
                                width: 250,
                                editor: "text"
                            },
                            {
                                id: "unit_code",
                                name: "unit_code",
                                header: "ĐVT",
                                width: 150,
                                editor: "combo",
                            },
                            {
                                id: "quantity",
                                name: "quantity",
                                header: "Số lượng",
                                width: 120,
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 0,
                                }),
                                css: {
                                    "text-align": "right",
                                },
                                editor: "autonumeric",
                            },
                            {
                                id: "unit_price",
                                name: "unit_price",
                                header: "Đơn giá",
                                width: 120,
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 0,
                                }),
                                css: {
                                    "text-align": "right",
                                },
                                editor: "autonumeric",
                            },

                            {
                                id: "total_amount_without_vat",
                                name: "total_amount_without_vat",
                                header: "Tiền trước thuế",
                                width: 150,
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 0,
                                }),
                                css: {
                                    "text-align": "right",
                                },
                                editor: "autonumeric",
                            },

                            {
                                id: "discount_percentage",
                                name: "discount_percentage",
                                header: "% CK",
                                width: 150,
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 0,
                                }),
                                css: {
                                    "text-align": "right",
                                },
                                editor: "autonumeric",
                            },

                            {
                                id: "discount_amount",
                                name: "discount_amount",
                                header: "Tiền CK",
                                width: 150,
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 0,
                                }),
                                css: {
                                    "text-align": "right",
                                },
                                editor: "autonumeric",
                            },

                            {
                                id: "tax_type",
                                name: "tax_type",
                                header: "% Thuế",
                                width: 150,
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 0,
                                }),
                                css: {
                                    "text-align": "right",
                                },
                                editor: "combo",
                                options: null
                            },

                            {
                                id: "vat_amount",
                                name: "vat_amount",
                                header: "Tiền thuế",
                                width: 150,
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 0,
                                }),
                                css: {
                                    "text-align": "right",
                                },
                                editor: "autonumeric",
                            },

                            {
                                id: "total_amount",
                                name: "total_amount",
                                header: "Tổng tiền",
                                width: 150,
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 0,
                                }),
                                css: {
                                    "text-align": "right",
                                },
                                editor: "autonumeric",
                            },
                        ],
                        data: [
                           
                        ],

                        // load:function(view, params){
                        //     var data = webix.ajax().get(app.config.host + "System/GetInvoiceDetail?id=" + "inv_invoiceauth_id");
                        // }
                     },

                    {
                        cols: [
                            {
                                view: "text",
                                label: "Tổng tiền trước thuế",
                                name: "total_amount_without_vat",
                                readonly: true,
                                width: 300,
                                labelWidth: 150,
                                format: "1.111",
                            },
                            {
                                view: "text",
                                label: "Tổng tiền CK",
                                name: "discount_percentage",
                                readonly: true,
                                width: 300,
                                labelWidth: 150,
                                format: "1.111",
                            },
                            {
                                view: "text",
                                label: "Tiền thuế",
                                name: "vat_amount",
                                readonly: true,
                                width: 300,
                                labelWidth: 150,
                                format: "1.111",
                            },
                            {
                                view: "text",
                                label: "Thành tiền",
                                name: "total_amount",
                                readonly: true,
                                width: 300,
                                labelWidth: 150,
                                format: "1.111",
                            },
                        ]
                    },

                    {},
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button", hotkey: "esc", label: "Đóng (ESC)", type: "danger", align: "center", width: 120,
                                click: function () {
                                    webix.$$("duyethoadon-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }

        },
        setEditMode: function (mode) {
            editmode = mode;
        }

    };

});
define('views/duyethoadon',["app", "views/forms/duyethoadon", "locale", "views/modules/minvoiceplugin", "models/user"], function (app, dmwindowform, _, plugin, user) {
    
    var windowno = app.path[1].params[0];
    var query = {
        command: "SYS002",
        parameter: {
            windowno: windowno,
        },
    };
    var url = app.config.host + "/System/ExecuteCommand";

    webix
        .ajax()
        .headers({ "Content-Type": "application/json" })
        .post(url, query, function (text) {
            var json = JSON.parse(text);
            if (json.length > 0) {
                if (webix.$$("title") != undefined) {
                    webix.$$("title").parse({ title: json[0]["name"], details: json[0]["details"] });
                    $$("head-title").show();
                }
            }
        });

    function signOnServerFile(data, cert, server_cert) {
        var parameters = {
            xml: data["InvoiceXmlData"],
            refUri: "#data",
            certSerial: cert.so_serial,
            tokenSerial: cert.tokenSerial,
            signId: "seller",
            signTag: "Signatures",
            pass: cert.pass,
            path: cert.path,
            inv_InvoiceAuth_id: data["inv_InvoiceAuth_id"],
        };

        webix
            .ajax()
            .headers({ "Content-Type": "application/json" })
            .post(server_cert + "/Token/SignXmlByFile", parameters, function (text) {
                var json = JSON.parse(text);

                if (json.hasOwnProperty("error")) {
                    webix.message(json["error"], "error");
                } else {
                    var parameters = {
                        InvoiceXmlData: json.xml,
                        inv_InvoiceAuth_id: json.inv_InvoiceAuth_id,
                    };
                    //console.log(parameters);

                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice/SaveXml", parameters, function (text) {
                            var result = JSON.parse(text);

                            if (result.trang_thai == "Đã ký") {
                                var table = webix.$$("dmwindowData");
                                table.clearAll();
                                table.load(table.config.url);

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(
                                        app.config.host + "/System/ExecuteCommand",
                                        {
                                            command: "CM00025",
                                            parameter: {},
                                        },
                                        function (text) {
                                            var json = JSON.parse(text);
                                            // auto send SMS
                                            if (json[1].gia_tri == "C") {
                                                var data = { id: item.inv_InvoiceAuth_id };

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
                                                        var data = JSON.parse(text);

                                                        if (!data.hasOwnProperty("error")) {
                                                        } else {
                                                            webix.message(data.error, "error");
                                                        }
                                                    });
                                            }
                                            // send email ma = 'AUTO_SEND_EMAIL'
                                            // if (json[0].gia_tri == "C") {
                                            //     var data = { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id, nguoinhan: item.inv_buyerEmail, tieude: "Thông báo xuất hóa đơn điện tử" };

                                            //     webix.ajax()
                                            //         .headers({ 'Content-type': 'application/json' })
                                            //         .post(app.config.host + "/Invoice/AutoSendInvoiceByEmail", data, function (text) {
                                            //             var data = JSON.parse(text);

                                            //             if (!data.hasOwnProperty("error")) {

                                            //             }
                                            //             else {
                                            //                 webix.message(data.error, "error");
                                            //             }
                                            //         });
                                            // }
                                        }
                                    );
                                // webix.modalbox.hide();
                                // webix.message("Ký hóa đơn thành công !", "debug");
                            }
                        });
                }
            });
    }

    function signOnServer(data, cert, server_cert) {
        var parameters = {
            xml: data["InvoiceXmlData"],
            refUri: "#data",
            certSerial: cert.so_serial,
            tokenSerial: cert.tokenSerial,
            signId: "seller",
            signTag: "Signatures",
            pass: cert.pass,
            inv_InvoiceAuth_id: data["inv_InvoiceAuth_id"],
        };

        webix
            .ajax()
            .headers({ "Content-Type": "application/json" })
            .post(server_cert + "/Token/SignXml", parameters, function (text) {
                var json = JSON.parse(text);

                if (json.hasOwnProperty("error")) {
                    webix.message(json["error"]);
                } else {
                    var parameters = {
                        InvoiceXmlData: json.xml,
                        inv_InvoiceAuth_id: json.inv_InvoiceAuth_id,
                    };
                    //console.log(parameters);

                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice/SaveXml", parameters, function (text) {
                            var result = JSON.parse(text);

                            if (result.trang_thai == "Đã ký") {
                                var table = webix.$$("dmwindowData");
                                table.clearAll();
                                table.load(table.config.url);

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(
                                        app.config.host + "/System/ExecuteCommand",
                                        {
                                            command: "CM00025",
                                            parameter: {},
                                        },
                                        function (text) {
                                            var json = JSON.parse(text);
                                            // auto send SMS
                                            if (json[1].gia_tri == "C") {
                                                var data = { id: item.inv_InvoiceAuth_id };

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
                                                        var data = JSON.parse(text);

                                                        if (!data.hasOwnProperty("error")) {
                                                        } else {
                                                            webix.message(data.error, "error");
                                                        }
                                                    });
                                            }
                                            // send email ma = 'AUTO_SEND_EMAIL'
                                            // if(json[0].gia_tri == "C")
                                            // {
                                            // 	var data = { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id, nguoinhan: item.inv_buyerEmail, tieude: "Thông báo xuất hóa đơn điện tử" };

                                            // 	webix.ajax()
                                            // 		.headers({ 'Content-type': 'application/json' })
                                            // 		.post(app.config.host + "/Invoice/AutoSendInvoiceByEmail", data, function (text) {
                                            // 			var data = JSON.parse(text);

                                            // 			if (!data.hasOwnProperty("error")) {

                                            // 			}
                                            // 			else {
                                            // 				webix.message(data.error, "error");
                                            // 			}
                                            // 		});
                                            // }
                                        }
                                    );

                                // webix.modalbox.hide();
                                // webix.message("Ký hóa đơn thành công !", "debug");
                            }
                        });
                }
            });
    }

    var op = [];

    // webix.$$("title").parse({ title: "Duyệt hóa đơn", details: "Danh sách hóa đơn chờ duyệt" });

    var controls = [
        {
            id: "showPop",
            view: "button",
            type: "icon",
            icon: "fa fa-eye",
            css: "webix_secondary",
            label: "Chi tiết",
            width: 100,

            //QuyenNH
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("duyethoadon-form");
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    dmwindowform.setEditMode(2);

                    item.invoice_issued_date = new Date(item.invoice_issued_date);

                    // item.total_amount_without_vat = item.total_amount_without_vat ? item.total_amount_without_vat : 0;
                    // item.total_amount_without_vat = webix.Number.format(item.total_amount_without_vat,{
                    //     groupDelimiter:",",
                    //     groupSize:3,
                    // });

                    // item.discount_percentage = item.discount_percentage ? item.discount_percentage : 0;
                    // item.discount_percentage = webix.Number.format(item.discount_percentage,{
                    //     groupDelimiter:",",
                    //     groupSize:3,
                    // });

                    // item.vat_amount = item.vat_amount ? item.vat_amount : 0;
                    // item.vat_amount = webix.Number.format(item.vat_amount,{
                    //     groupDelimiter:",",
                    //     groupSize:3,
                    // });

                    // item.total_amount = item.total_amount ? item.total_amount : 0;
                    // item.total_amount = webix.Number.format(item.total_amount,{
                    //     groupDelimiter:",",
                    //     groupSize:3,
                    // });

                    form.setValues(item);
                    detailForm.show();

                    // QuyenNH: đẩy dữ liệu lên modal detail
                    var tableDetail = $$("detail");
                    tableDetail.clearAll();
                    tableDetail.load(app.config.host + "/System/GetInvoiceDetail?id=" + item.inv_invoiceauth_id);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
            css: "webix_secondary",
            label: _("DUYET") + " (F10)",
            width: 100,
            //css:"button_raised",
            shortcut: "F10",
            on: {
                onClick: function () {
                    var type = "01";

                    if (app.path.length > 0) {
                        if (typeof app.path[1].params[0] == "undefined") {
                            type = "01";
                        } else {
                            type = app.path[1].params[0];
                        }
                    }
                    if (type == "01") {
                        webix.confirm({
                            text: "Bạn có muốn duyệt hóa đơn không?",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (res) {
                                if (res) {
                                    DuyetHoaDon();
                                }
                            },
                        });
                    } else if (type == "02") {
                        webix.confirm({
                            text: "Bạn có muốn sinh số hóa đơn không?",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (res) {
                                if (res) {
                                    laySoHoaDon();
                                }
                            },
                        });
                    } else if (type == "03") {
                        var form = webix.$$("dmwindowData");
                        var datafrm = form.serialize();

                        var data = [];
                        for (var i = 0; i < datafrm.length; i++) {
                            if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                data.push(datafrm[i].inv_invoiceauth_id);
                            }
                        }
                        if (data.length > 0) {
                            webix.confirm({
                                text: "Bạn có muốn ký hóa đơn không?",
                                ok: "Có",
                                cancel: "Không",
                                callback: function (res) {
                                    if (res) {
                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/System/CheckInvoiceCancel", JSON.stringify(data), function (text) {
                                                var res = JSON.parse(text);
                                                if (res.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: res.error });
                                                } else {
                                                    KyHoaDon();
                                                }
                                            });
                                    }
                                },
                            });
                        } else webix.message("Bạn chưa chọn hóa đơn để ký !");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnReject",
            view: "button",
            type: "icon",
            icon: "fas fa-ban",
            css: "webix_secondary",
            label: _("TUCHOI") + " (F11)",
            width: 100,
            //css:"button_raised",
            shortcut: "F11",
            on: {
                onClick: function () {
                    webix.confirm({
                        text: "Bạn có chắc chắn từ chối hóa đơn không?",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                TuChoiHoaDon();
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnPrint",
            view: "button",
            type: "icon",
            icon: "fas fa-print",
            label: _("PRINT") + " (F7)",
            width: 80,
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn");
                        return;
                    }

                    var url = app.config.host + "/Invoice/Preview?id=" + item.inv_invoiceauth_id;

                    var box = webix.modalbox({
                        title: "Đang in hóa đơn",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                alert(text);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);

                                webix.modalbox.hide(box);
                                window.open(fileURL, "_blank");
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnExportExcel",
            view: "button",
            type: "icon",
            icon: "fas fa-file-excel-o",
            css: "webix_secondary",
            label: "Kết xuất Excel",
            width: 100,
            on: {
                onClick: function () {
                    exportExcel();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                resizeColumn: true,
                datafetch: 100,
                url: app.config.host + "/Invoice/GetHoaDonChoDuyet",
                scheme: {
                    $init: function (obj) {
                        //creating fake dates for the sample
                        obj.date = new Date(obj.ngay_hd);
                    },
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 65,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "date",
                        header: [_("NGAY_HDON"), { content: "dateRangeFilter" }],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    { id: "template_code", header: [_("MAU_HD"), { content: "textFilter" }], width: 150 },
                    { id: "invoice_series", header: [_("KY_HIEU"), { content: "textFilter" }], width: 120 },
                    { id: "invoice_number", header: [_("SO_HDON"), { content: "textFilter" }], width: 120 },
                    { id: "ten_dt", header: [_("TEN_DON_VI"), { content: "textFilter" }], width: 350 },
                    {
                        id: "total_amount_without_vat",
                        header: [_("TIEN_TRUOC_THUE"), { content: "numberFilter" }],
                        width: 170,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                        css: { "text-align": "right" },
                    },
                    {
                        id: "discount_percentage",
                        header: [_("TIEN_CK"), { content: "numberFilter" }],
                        width: 150,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                        css: { "text-align": "right" },
                    },
                    {
                        id: "vat_amount",
                        header: [_("TIEN_THUE"), { content: "numberFilter" }],
                        width: 150,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                        css: { "text-align": "right" },
                    },
                    {
                        id: "total_amount",
                        header: [_("THANH_TIEN"), { content: "numberFilter" }],
                        width: 150,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                        css: { "text-align": "right" },
                    },
                ],
                on: {
                    onItemDblClick: function (id, e, node) {
                        var showPopup = $$("showPop");
                        showPopup.callEvent("onClick");

                        // var table =  webix.$$("dmwindowData");
                        // var item = table.getSelectedItem();
                        // var template_code = item.template_code;
                    },
                    onItemClick: function (id, e, node) {
                        var table1 = webix.$$("dmwindowData");
                        var record = table1.getItem(id.row);
                        record["chon"] = !record["chon"];
                        table1.refresh(id.row);
                    },
                },
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                view: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    function exportExcel() {
        webix.toExcel($$("dmwindowData"), {
            rawValues: true,
            columns: [
                {
                    id: "date",
                    exportType: "date",
                    header: _("NGAY_HDON"),
                    width: 120,
                    exportFormat: "dd/MM/yyyy",
                },
                { id: "template_code", header: _("MAU_HD"), width: 150 },
                { id: "invoice_series", header: _("KY_HIEU"), width: 120 },
                {
                    id: "invoice_number",
                    header: _("SO_HDON"),
                    width: 120,
                },
                { id: "ten_dt", header: _("TEN_DON_VI"), width: 350 },
                {
                    id: "total_amount_without_vat",
                    header: _("TIEN_TRUOC_THUE"),
                    width: 120,
                    exportType: "number",
                    exportFormat: "#,##0",
                },
                {
                    id: "vat_amount",
                    header: _("TIEN_THUE"),
                    width: 120,
                    exportType: "number",
                    exportFormat: "#,##0",
                },
                {
                    id: "total_amount",
                    header: _("THANH_TIEN"),
                    width: 120,
                    exportType: "number",
                    exportFormat: "#,##0",
                },
            ],
        });
    }

    function KyHoaDon() {
        var table = webix.$$("dmwindowData");
        var kytaptrung = table.config.kytaptrung;
        var server_cert = table.config.server_cert;

        if (kytaptrung == "FILE") {
            var box = webix.modalbox({
                title: "Chọn chứng thư số",
                buttons: ["Nhận", "Hủy bỏ"],
                text: "<div id='ctnCerts'></div>",
                top: 100,
                width: 750,
                callback: function (result) {
                    switch (result) {
                        case "1":
                            // var form = webix.$$("dmwindowData");
                            // form.enable();
                            // form.hideProgress();

                            webix.modalbox.hide();
                            break;
                        case "0":
                            var table = $$("tblCerts");
                            var data = table.serialize();

                            var cert = null;

                            for (var i = 0; i < data.length; i++) {
                                if (data[i].chon == true) {
                                    cert = data[i];
                                    break;
                                }
                            }

                            if (cert == null) {
                                webix.message("Bạn chưa chọn chứng thư số");
                                return;
                            }

                            webix.modalbox.hide();

                            var wintable = webix.$$("dmwindowData");
                            var data = wintable.serialize();

                            webix.extend(wintable, webix.ProgressBar);
                            wintable.disable();
                            wintable.showProgress();

                            for (var i = 0; i < data.length; i++) {
                                var item = data[i];
                                if (item.chon != undefined) {
                                    if (item.chon == true) {
                                        var a = webix.ajax(app.config.host + "/Invoice/ExportXml?id=" + item.inv_InvoiceAuth_id);

                                        webix.promise
                                            .all([a])
                                            .then(function (results) {
                                                var a_result = results[0].json();
                                                signOnServerFile(a_result, cert, server_cert);
                                            })
                                            .fail(function (err) {
                                                var form = webix.$$("dmwindowData");
                                                form.enable();
                                                form.hideProgress();

                                                webix.alert({
                                                    title: "Lỗi !",
                                                    text: err,
                                                    type: "alert-error",
                                                });
                                            });
                                    }
                                }
                            }

                            var form = webix.$$("dmwindowData");
                            form.enable();
                            form.hideProgress();

                            break;
                    }
                },
            });

            var popupText = document.getElementsByClassName("webix_popup_text")[0];
            popupText.style.paddingTop = 0;

            var tblMatHang = webix.ui({
                container: "ctnCerts",
                id: "tblCerts",
                view: "datatable",
                borderless: true,
                // xmlData: a_result,
                server_cert: server_cert,
                height: 350,
                columns: [
                    {
                        id: "chon",
                        header: _("CHON"),
                        width: 65,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "cert_type",
                        header: _("Loại"),
                        width: 100,
                    },
                    {
                        id: "so_serial",
                        header: _("SO_SERIAL"),
                        width: 150,
                    },
                    {
                        id: "subjectname",
                        header: _("SUBJECTNAME"),
                        width: 450,
                    },
                    {
                        id: "ngaybatdau",
                        header: _("NGAY_BAT_DAU"),
                        width: 200,
                    },
                    {
                        id: "ngayketthuc",
                        header: _("NGAY_KET_THUC"),
                        width: 200,
                    },
                    {
                        id: "issuer",
                        header: _("DONVI"),
                        width: 450,
                    },
                ],
                url: app.config.host + "/Invoice/GetListCertificatesFile",
            });
        } else {
            if (kytaptrung == "C") {
                var box = webix.modalbox({
                    title: "Chọn chứng thư số",
                    buttons: ["Nhận", "Hủy bỏ"],
                    text: "<div id='ctnCerts'></div>",
                    top: 100,
                    width: 750,
                    callback: function (result) {
                        switch (result) {
                            case "1":
                                // var form = webix.$$("dmwindowData");
                                // form.enable();
                                // form.hideProgress();

                                webix.modalbox.hide();
                                break;
                            case "0":
                                var table = $$("tblCerts");
                                var data = table.serialize();

                                var cert = null;

                                for (var i = 0; i < data.length; i++) {
                                    if (data[i].chon == true) {
                                        cert = data[i];
                                        break;
                                    }
                                }

                                if (cert == null) {
                                    webix.message("Bạn chưa chọn chứng thư số");
                                    return;
                                }

                                webix.modalbox.hide();

                                var wintable = webix.$$("dmwindowData");
                                var data = wintable.serialize();

                                webix.extend(wintable, webix.ProgressBar);
                                wintable.disable();
                                wintable.showProgress();

                                for (var i = 0; i < data.length; i++) {
                                    var item = data[i];
                                    if (item.chon != undefined) {
                                        if (item.chon == true) {
                                            var a = webix.ajax(app.config.host + "/Invoice/ExportXml?id=" + item.inv_InvoiceAuth_id);

                                            webix.promise
                                                .all([a])
                                                .then(function (results) {
                                                    var a_result = results[0].json();
                                                    signOnServer(a_result, cert, server_cert);
                                                })
                                                .fail(function (err) {
                                                    var form = webix.$$("dmwindowData");
                                                    form.enable();
                                                    form.hideProgress();

                                                    webix.alert({
                                                        title: "Lỗi !",
                                                        text: err,
                                                        type: "alert-error",
                                                    });
                                                });
                                        }
                                    }
                                }

                                var form = webix.$$("dmwindowData");
                                form.enable();
                                form.hideProgress();

                                break;
                        }
                    },
                });

                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                popupText.style.paddingTop = 0;

                var tblMatHang = webix.ui({
                    container: "ctnCerts",
                    id: "tblCerts",
                    view: "datatable",
                    borderless: true,
                    // xmlData: a_result,
                    server_cert: server_cert,
                    height: 350,
                    columns: [
                        {
                            id: "chon",
                            header: _("CHON"),
                            width: 65,
                            checkValue: true,
                            uncheckValue: false,
                            template: "{common.checkbox()}",
                        },
                        {
                            id: "cert_type",
                            header: _("Loại"),
                            width: 100,
                        },
                        {
                            id: "so_serial",
                            header: _("SO_SERIAL"),
                            width: 150,
                        },
                        {
                            id: "subjectname",
                            header: _("SUBJECTNAME"),
                            width: 450,
                        },
                        {
                            id: "ngaybatdau",
                            header: _("NGAY_BAT_DAU"),
                            width: 200,
                        },
                        {
                            id: "ngayketthuc",
                            header: _("NGAY_KET_THUC"),
                            width: 200,
                        },
                        {
                            id: "issuer",
                            header: _("DONVI"),
                            width: 450,
                        },
                    ],
                    url: app.config.host + "/Invoice/GetListCertificates",
                });
            } else {
                webix.ajax().get(app.config.host + "/Invoice/GetListCertificates", function (text) {
                    var listcerts = JSON.parse(text);

                    if (listcerts.length == 0) {
                        webix.message({ type: "error", text: "Bạn chưa được phân quyền chữ ký số" });
                        return;
                    }

                    // Ký bằng Chữ ký số mềm
                    if (listcerts.length == 1) {
                        var certs = listcerts[0];

                        if (certs.cert_type == "FILE") {
                            console.log("Token File !");
                            var form = webix.$$("dmwindowData");
                            var datafrm = form.serialize();

                            var data = [];
                            for (var i = 0; i < datafrm.length; i++) {
                                if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                                    data.push(datafrm[i].inv_invoiceauth_id);
                                }
                            }

                            var postData = {
                                username: user.getCurrentUser(),
                                invs: data,
                                so_serial: certs.so_serial,
                            };

                            var url = app.config.host + "/Invoice/SignListInvoiceCertFile";

                            webix
                                .ajax()
                                .headers({ "Content-Type": "application/json" })
                                .post(url, postData, function (text) {
                                    var res = JSON.parse(text);

                                    if (res.hasOwnProperty("error")) {
                                        webix.message({ type: "error", text: res.error });
                                    } else {
                                        webix.message("Đã thực hiện xong");
                                        var table = $$("dmwindowData");
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                });
                            return;
                        }
                    }

                    // ký bằng USB TOKEN
                    console.log("USB Token !");
                    var form = webix.$$("dmwindowData");
                    var datafrm = form.serialize();

                    var data = [];
                    for (var i = 0; i < datafrm.length; i++) {
                        if (datafrm[i]["chon"] != null && datafrm[i]["chon"] == true) {
                            data.push(datafrm[i].inv_invoiceauth_id);
                        }
                    }

                    webix.extend(form, webix.ProgressBar);
                    form.disable();
                    form.showProgress();
          
                    //lấy time server
                    var resultTime;
                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .get(app.config.host + "/System/GetDate", function (text) {
                            resultTime = JSON.parse(text);
                        });

                    var hub = plugin.hub();
                    var hubconnect = plugin.conn();
                    if (hubconnect.state != 1) {
                        var form = webix.$$("dmwindowData");
                        form.enable();
                        form.hideProgress();
                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                        return;
                    } else {
                        hub.off("resCommand");
                        hub.on("resCommand", function (result) {
                            var json = JSON.parse(result);
                            //console.log(json);
                            if (json.hasOwnProperty("error")) {
                                webix.message({ type: "error", text: json.error });

                                var form = webix.$$("dmwindowData");
                                form.enable();
                                form.hideProgress();
                            } else {
                                var table = webix.$$("dmwindowData");
                                table.clearAll();
                                table.load(table.config.url);

                                var form = webix.$$("dmwindowData");
                                form.enable();
                                form.hideProgress();

                                // webix.message("Ký thành công !", "success");
                            }
                        });

                        // hub.off('resNotice');
                        // hub.on('resNotice', function (result) {
                        //     webix.message(result, "debug");
                        // });

                        var token = user.getAccessToken();
                        var dvcs = user.getDvcsID();
                        var language = user.getLanguage();

                        var bear = token + ";" + dvcs + ";" + language;

                        var url;
                        if (window.location.protocol == "file:") {
                            url = "http://localhost:18374";
                        } else {
                            url = window.location.origin;
                        }

                        var arg = {
                            idData: "#data",
                            data: data,
                            // mst: "0100686209",
                            mst: "minvoice", // đang fix cứng.sau này có thể fix
                            username: user.getCurrentUser(),
                            idSigner: "seller",
                            tagSign: "Signatures",
                            listcerts: form.config.lstCert,
                            token: bear,
                            dateKy: resultTime.dateKy,
                            url: url,
                        };

                        hub.invoke("execCommand", "SignListInvoiceV2", JSON.stringify(arg))
                            .done(function () {
                                console.log("Success SignListInvoiceV2!");
                            })
                            .fail(function (error) {
                                var form = webix.$$("dmwindowData");
                                form.enable();
                                form.hideProgress();
                                webix.message(error, "error");
                            });
                    }
                });
            }
        }
    }

    function DuyetHoaDon() {
        var table = webix.$$("dmwindowData");
        var data = table.serialize();

        for (var i = 0; i < data.length; i++) {
            var item = data[i];

            if (item.chon != undefined) {
                if (item.chon == true) {
                    webix
                        .ajax()
                        .bind(item)
                        .sync()
                        .headers({ "Content-type": "application/json" })
                        .post(app.config.host + "/Invoice/DuyetHoaDon", { inv_InvoiceAuth_id: item.inv_invoiceauth_id }, function (text) {
                            var res = JSON.parse(text);
                            if (res.hasOwnProperty("error")) {
                                webix.message({ type: "error", text: res.error });
                                return;
                            }

                            $$("dmwindowData").remove(this.id);
                        });
                }
            }
        }

        table.clearAll();
        table.load(table.config.url);
    }

    function laySoHoaDon() {
        var table = webix.$$("dmwindowData");
        var data = table.serialize();
        var lstTemp = [];

        for (var i = 0; i < data.length; i++) {
            var item = data[i];

            if (item.chon != undefined) {
                if (item.chon == true) {
                    var temp = {
                        inv_invoiceauth_id: item.inv_invoiceauth_id,
                    };
                    lstTemp.push(temp);
                }
            }
        }

        if (lstTemp.length == 0) {
            webix.message({ type: "error", text: "Bạn chưa chọn hóa đơn" });
            return;
        }

        var postData = {
            data: lstTemp,
        };

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(app.config.host + "/Invoice/LaySoHoaDon", postData, function (text) {
                var res = JSON.parse(text);

                if (res.hasOwnProperty("error")) {
                    webix.message({ type: "error", text: res.error });
                } else {
                    var table = $$("dmwindowData");
                    table.clearAll();
                    table.load(table.config.url);
                }
            });
    }

    function TuChoiHoaDon() {
        var table = webix.$$("dmwindowData");
        var data = table.serialize();

        for (var i = 0; i < data.length; i++) {
            var item = data[i];

            if (item.chon != undefined) {
                if (item.chon == true) {
                    webix
                        .ajax()
                        .bind(item)
                        .sync()
                        .headers({ "Content-type": "application/json" })
                        .post(app.config.host + "/Invoice/TuChoiHoaDon", { inv_InvoiceAuth_id: item.inv_invoiceauth_id }, function (text) {
                            if (text.hasOwnProperty("error")) {
                                webix.message(text.error);
                                return;
                            }

                            $$("dmwindowData").remove(this.id);
                        });
                }
            }
        }

        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var params = app.path[1].params;
            var table = webix.$$("dmwindowData");
            // Lấy thông tin ký tập trung -----------------------------------------
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .post(
                    app.config.host + "/System/ExecuteCommand",
                    {
                        command: "CM00019",
                        parameter: {
                            ma_dvcs: "",
                        },
                    },
                    {
                        error: function (text, data, XmlHttpRequest) {
                            //webix.modalbox.hide(box);
                            webix.alert({
                                title: "Lỗi !",
                                text: err,
                                type: "alert-error",
                            });
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var c_result = JSON.parse(text);

                            for (var i = 0; i < c_result.length; i++) {
                                var item = c_result[i];

                                if (item.ma == "KYTAPTRUNG") {
                                    table.config.kytaptrung = item.gia_tri;
                                }

                                if (item.ma == "SERVER_CERT") {
                                    table.config.server_cert = item.gia_tri;
                                }
                            }
                        },
                    }
                );

            // lấy danh sách chữ ký số
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(app.config.host + "/Invoice/GetListCertificates", {
                    error: function (text, data, XmlHttpRequest) {
                        //webix.modalbox.hide(box);
                        webix.alert({
                            title: "Lỗi !",
                            text: err,
                            type: "alert-error",
                        });
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var result = JSON.parse(text);
                        table.config.lstCert = result;
                    },
                });

            table.define("url", app.config.host + "/Invoice/GetHoaDonChoDuyet?trangthai=Chờ duyệt");

            /*webix.$$("title").parse({ title: "Duyệt hóa đơn", details: "Danh sách hóa đơn chờ duyệt" });

            var btnEdit = webix.$$("btnEdit");
            btnEdit.define("label", _("DUYET"));

            if (params[0] != undefined) {
                var type = params[0];

                if (type == "02") {
                    webix.$$("title").parse({ title: "Ký hóa đơn", details: "Danh sách hóa đơn chờ ký" });
                    table.define("url", app.config.host + "/Invoice/GetHoaDonChoDuyet?trangthai=Chờ ký");
                    btnEdit.define("label", _("SIGN"));
                }
            }

            table.clearAll();
            table.load(table.config.url);
            btnEdit.refresh();*/

            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            var params = app.path[1].params;

            var table = webix.$$("dmwindowData");

            var btnEdit = webix.$$("btnEdit");
            btnEdit.define("label", _("DUYET"));

            var btnReject = webix.$$("btnReject");
            btnReject.show();
            //btnEdit.define("label", _("DUYET"));

            //webix.$$("title").parse({ title: "Duyệt hóa đơn", details: "Danh sách hóa đơn chờ duyệt" });

            if (params[0] != undefined) {
                var type = params[0];

                if (type == "01") {
                    //webix.$$("title").parse({ title: "Ký hóa đơn", details: "Danh sách hóa đơn chờ ký" });
                    table.define("url", app.config.host + "/Invoice/GetHoaDonChoDuyet?trangthai=Chờ duyệt");
                    btnEdit.define("label", _("DUYET"));
                    btnReject.hide();
                }
                if (type == "02") {
                    //webix.$$("title").parse({ title: "Ký hóa đơn", details: "Danh sách hóa đơn chờ ký" });
                    table.define("url", app.config.host + "/Invoice/GetHoaDonChoDuyet?trangthai=Chờ sinh số");
                    btnEdit.define("label", _("Sinh số"));
                    btnReject.hide();
                }
                if (type == "03") {
                    //webix.$$("title").parse({ title: "Ký hóa đơn", details: "Danh sách hóa đơn chờ ký" });
                    table.define("url", app.config.host + "/Invoice/GetHoaDonChoDuyet?trangthai=Chờ ký");
                    btnEdit.define("label", _("SIGN"));
                    btnReject.hide();
                }
            }

            table.clearAll();
            table.load(table.config.url);
            btnEdit.refresh();
        },
    };
});

define('views/forms/file',["app", "locale"], function (app, _) {
    var editmode = 0;
    // {
    //     "paddingY":3, "paddingX":3, "view":"form", "id":"window-form", "complexData":true, "margin":0, "borderless":true, "elements":
    //     [{
    //         "cols": [
    //             {
    //             "view": "fieldset", "label": "Thông tin chung", "body": {
    //                 "rows": [{
    //                     "cols":
    //                     [{ "id": "MA_DT0_DPKT", "view": "text", "label": "Mã đối tượng", "labelWidth": 100, "width": 200, "name": "MA_DT0" }, { "id": "TEN_DT0_DPKT", "view": "text", "label": "Tên đối tượng", "labelWidth": 110, "name": "TEN_DT0" }]
    //                 }, { "id": "ONG_BA_DPKT", "view": "text", "label": "Ông bà", "labelWidth": 100, "name": "ONG_BA" }, { "id": "CT_GOC_DPKT", "view": "text", "label": "Chứng từ gốc", "labelWidth": 100, "name": "CT_GOC" }, { "id": "DIA_CHI_DPKT", "view": "text", "label": "Địa chỉ", "labelWidth": 100, "name": "DIA_CHI" }, { "id": "DIEN_GIAI_DPKT", "view": "text", "label": "Diễn giải", "labelWidth": 100, "name": "DIEN_GIAI" }]
    //             }
    //         }, 
    //         { "width": 10 },
    //          {
    //             "view": "fieldset", "label": "Chứng từ", "body": {
    //                 "rows":
    //                 [
    //                     { "id": "NGAY_CT_DPKT", "view": "datepicker", "label": "Ngày chứng từ", "labelWidth": 110, "width": 300, "name": "NGAY_CT" }, { "id": "SO_CT_DPKT", "view": "text", "labelWidth": 110, "label": "Số chứng từ", "name": "SO_CT" }, 
    //                     { "cols": [{ "id": "MA_NT_DPKT", "view": "text", "name": "MA_NT", "label": "Mã ngoại tệ", "labelWidth": 110, "width": 170 }, { "id": "TY_GIA_DPKT", "view": "text", "name": "TY_GIA", "label": "Tỷ giá", "labelWidth": 50 }] }, { "id": "MA_HT_DPKT", "view": "text", "labelWidth": 110, "label": "Mã hạch toán", "name": "MA_HT" }, { "id": "MA_BP_DPKT", "view": "text", "labelWidth": 110, "label": "Mã bộ phận", "name": "MA_BP" }]
    //             }
    //         }]
    //     },
    //     {
    //         "view": "tabview", "id": "tab_replace", "cells": [{ "header": "Chi tiết thu" },
    //         { "header": "Chi tiết thuế" }]
    //     }, {
    //         "cols": [{ "id": "T_TIEN_TT_DPKT", "view": "text", "label": "Tổng tiền trước thuế", "labelWidth": 170, "name": "T_TIEN_TT" },
    //         { "id": "T_THUE_DPKT", "view": "text", "label": "Tổng tiền thuế", "labelWidth": 130, "name": "T_THUE" }, { "id": "T_TIEN_DPKT", "view": "text", "label": "Tổng tiền", "labelWidth": 100, "name": "T_TIEN" }]
    //     },
    //     {
    //         "cols": [{ "id": "T_TIEN_TT_NT_DPKT", "view": "text", "label": "Tổng tiền trước thuế NT", "labelWidth": 170, "name": "T_TIEN_TT_NT" },
    //         { "id": "T_THUE_NT_DPKT", "view": "text", "label": "Tổng tiền thuế NT", "labelWidth": 130, "name": "T_THUE_NT" },
    //         { "id": "T_TIEN_NT_DPKT", "view": "text", "label": "Tổng tiền NT", "labelWidth": 100, "name": "T_TIEN_NT" }]
    //     }]
    // }
    return {
        $ui: {
            view: "window", modal: true, id: "window-win", position: "center",
            //width:800,
            head: "Nam đại ka",
            fullscreen: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "window-form",
                complexData: true,
                keepViews: true,
                margin: 0,
                elements: [
                    {
                        cols: [
                            {
                                view: "fieldset",
                                id: "2",
                                label: "Field Set 1",
                                body: {
                                    rows: [
                                        {
                                            column_type: "datetime",
                                            css: null,
                                            data_width: null,
                                            fieldExpression: null,
                                            format: "%d/%m/%Y",
                                            id: "inv_invoiceIssuedDate_inv_InvoiceAuth",
                                            keepViews: true,
                                            label: "Ngày hóa đơn",
                                            labelPosition: "left",
                                            labelWidth: 100,
                                            name: "inv_invoiceIssuedDate",
                                            on: {},
                                            resizeColumn: true,
                                            value_change: null,
                                            view: "datepicker",
                                            width: null
                                        },
                                        {
                                            column_type: "nvarchar",
                                            css: "mcls_readonly_text",
                                            data_width: null,
                                            fieldExpression: null,
                                            format: null,
                                            id: "inv_invoiceNumber_inv_InvoiceAuth",
                                            keepViews: true,
                                            label: "Số hóa đơn",
                                            labelPosition: "left",
                                            labelWidth: 100,
                                            name: "inv_invoiceNumber",
                                            on: {},
                                            readonly: true,
                                            resizeColumn: true,
                                            value_change: null,
                                            view: "text",
                                            width: null
                                        }
                                    ]
                                }
                            },
                            {
                                view: "fieldset",
                                id: "22",
                                label: "Thông tin 2",
                                body: {
                                    rows: [
                                        {
                                            column_type: "datetime",
                                            css: null,
                                            data_width: null,
                                            fieldExpression: null,
                                            format: "%d/%m/%Y",
                                            id: "inv_invoiceIssuedDate_inv_InvoiceAuth1",
                                            keepViews: true,
                                            label: "Ngày hóa đơn",
                                            labelPosition: "left",
                                            labelWidth: 100,
                                            name: "inv_invoiceIssuedDate4",
                                            on: {},
                                            resizeColumn: true,
                                            value_change: null,
                                            view: "datepicker",
                                            width: null
                                        },
                                        {
                                            column_type: "nvarchar",
                                            css: "mcls_readonly_text",
                                            data_width: null,
                                            fieldExpression: null,
                                            format: null,
                                            id: "inv_invoiceNumber_inv_InvoiceAuth1",
                                            keepViews: true,
                                            label: "Số hóa đơn",
                                            labelPosition: "left",
                                            labelWidth: 100,
                                            name: "inv_invoiceNumber5",
                                            on: {},
                                            readonly: true,
                                            resizeColumn: true,
                                            value_change: null,
                                            view: "text",
                                            width: null
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        cols: [
                            { view: "text", label: "Email1" },
                            { view: "text", label: "ahihi", id: "lala" }
                        ]

                    }

                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        }
    };

});
define('views/file',["app", "locale", "views/forms/file"], function (app, _, fileform) {
    

    var op = [];

    webix.$$("title").parse({ title: "Danh sách file báo cáo", details: "Danh sách file báo cáo" });

    var controls = [
        {
            id: "btnRefresh",
            view: "button",
            type: "icon",
            icon: "fas fa-refresh",
            label: _("REFRESH"),
            width: 95,
            // shortcut: "F4",
            css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    table.clearAll();
                    //console.log(table);
                    table.load(table.config.url);
                    //table.refresh();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDowload",
            view: "button",
            type: "icon",
            icon: "fas fa-download",
            label: _("Tải File"),
            width: 90,
            // shortcut: "F4",
            css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn file cần báo cáo !", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang tải xuống",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    webix
                        .ajax()
                        .response("arraybuffer")
                        //.headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + "/Invoice/Floder?filename=" + item.fName, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                alert(text);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "text/csv" });
                                webix.html.download(file, item.fName + ".repx");

                                webix.modalbox.hide(box);
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     id: "btnTest",
        //     view: "button",
        //     type: "icon",
        //     icon: "refresh",
        //     label: _("TEst"),
        //     width: 90,
        //     // shortcut: "F4",
        //     //css:"button_raised",
        //     on: {
        //         onClick: function () {
        //             var detailForm = this.$scope.ui(fileform.$ui);
        //             detailForm.show();

        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {},
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                resizeColumn: true,
                //loadahead: 15,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/Invoice/FloderInfo";

                        webix.ajax(url, callback, view);
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnDowload");
                        btnEdit.callEvent("onClick");
                    },
                },
                columns: [
                    { id: "index", header: "", sort: "int", width: 40 },
                    { id: "fName", header: _("Tên file"), width: 300 },
                    //{ id: "fExtension", header: "Loại", width: 100 },
                    {
                        id: "fTime",
                        header: _("Ngày"),
                        width: 100,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                view: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});

define('views/forms/68_bangdanhsachhanghoagiamtru',["app", "models/user"], function (app, user) {

    var button = [
        {},
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("hanghoa-win").close();
            },
        },
        {},
    ];
    var ui = {
        view: "window",
        modal: true,
        move: true,
        width:1000,
        height:800,
        resize: true,
        id: "hanghoa-win",
        position: "center",
        head: "Danh sách hàng hóa, dịch vụ không giảm trừ",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            id: "hanghoa-form",
            complexData: true,
            margin: 0,
            width:0,
            height:0,
            elements: [
                {
                    view: "datatable",
                    id: "danhsach_hoadonFrm",
                    name: "danhsach_hoadonFrm",
                    select: true,
                    resizeColumn: true,
                    footer: false,
                    editable: false,
                    tooltip: true,
                    width:1000,
                    height:700,
                    scheme: {
                        $init: function (obj) {},
                    },
                    url:{
                        $proxy: true,
                        load: function (view, callback, params) {
                            var url = app.config.host + "/Invoice68/GetDSHHGiamTru";

                            if (params == null) {
                                url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                            } else {
                                url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                                if (params.filter != null) {
                                    var array = [];

                                    for (var property in params.filter) {
                                        var column = view.getColumnConfig(property);

                                        var item = {
                                            columnName: property,
                                            columnType: column.columnType,
                                            value: params.filter[property],
                                            filterType: column.header[1].content,
                                        };


                                        if (item.value != null && item.value != "") {
                                            array.push(item);
                                        }
                                    }

                                    //console.log(JSON.stringify(array));
                                    url = url + "&filter=" + JSON.stringify(array);
                                }
                            }
                            webix.ajax(url, callback, view);
                        },
                    },
                    on: {
                        "data->onStoreUpdated": function () {
                            this.data.each(function (obj, i) {
                                obj.index = i + 1;
                            });
                        },
                    },
                    columns: [
                        {
                            id: "code",
                            name: "code",
                            header: [
                                "Mã",
                                {
                                    content: "serverFilter",
                                },
                            ],
                            width: 120,
                        },
                        {
                            id: "name",
                            name: "name",
                            header: ["Tên", { content: "serverFilter" }],
                            width: 500,
                        },
                        {
                            id: "vat_type",
                            name: "vat_type",
                            header: [" thuế", { content: "serverFilter" }],
                            width: 100,
                        },
                        {
                            id: "unit_code",
                            name: "unit_code",
                            header: [
                                "Đơn vị tính",
                                {
                                    content: "serverFilter",
                                },
                            ],
                            width: 100,
                        },
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
    };
});

define('views/forms/68_chondai',["app", "locale", "models/user", "views/commonHD"], function (app, _, user, commonHD) {
    var editmode = 0;
    var param;
    var branh_code;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var item = $$("chuyendai-form").getValues();
                        
                        if ($$("kyhieuhoadon_78_id").getValue() == null || $$("kyhieuhoadon_78_id").getValue() == "") {
                            webix.message("Bạn chưa chọn ký hiệu", "error");
                            return;
                        }
                        var kyHieuHoaDon = {
                            cctbao_id: $$("kyhieuhoadon_78_id").getValue(),
                        };
                        commonHD.ExcuteChonInvoice(kyHieuHoaDon,2);

                        $$("chuyendai-win").close();
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                var table = $$("invoiceViews").getParentView();
                console.log(table);
                webix.$$("chuyendai-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "chuyendai-win",
        position: "center",
        head: "Chọn ký hiệu hóa đơn",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "chuyendai-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "kyhieuhoadon_78_id",
                    label: "Kí hiệu hóa đơn",
                    //labelPosition: "top",
                    id: "kyhieuhoadon_78_id",
                    required: true,
                    labelWidth: 120,
                    invalidMessage: "Kí hiệu hóa đơn không được bỏ trống",
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
            // $$("kyhieuhoadon_78_id").define("options", app.config.host + "/System/GetDataByReferencesId?id=201a2758-6e97-4296-9beb-b627ff73e1a4");
            var khieu = param["data"][0].WinParams.find(function(item) {
                return item.value_field == "kyhieu_id";
            });

            $$("kyhieuhoadon_78_id").define("options", app.config.host + "/System/GetDataByReferencesId?id=" + khieu.wb_references_id);
            var table = $$("invoiceViews");
            var item = table.getSelectedItem();
            if(item) {
                $$("kyhieuhoadon_78_id").setValue(item.cctbao_id);
                $$("kyhieuhoadon_78_id").refresh();
            }
        },
        setValues: function (item) {
            $$("chuyendai-form").setValues(item);
        },
    };
});

define('views/forms/68_chuyenDaiBienLai',["app", "locale", "models/user", "views/commonHD"], function (app, _, user, commonHD) {
    var editmode = 0;
    var param;
    var branh_code;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        debugger
                        var item = $$("chuyendai-form").getValues();
                        var kyHieuHoaDon = {
                            cctbao_id: $$("kyhieuhoadon_78_id").getValue(),
                            khieu: $$("kyhieuhoadon_78_id").data.text,
                        };

                        switch (item.loaichuyendai_id) {
                            case "1":
                                commonHD.ExcuteReplaceInvoice_KMG(kyHieuHoaDon);
                                break;
                            case "2":
                                commonHD.ExcuteInfoChangeInvoice_BienLai(kyHieuHoaDon);
                                break;
                            default:
                                break;
                        }
                        $$("chuyendai-win").close();
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                var table = $$("invoiceViews").getParentView();
                console.log(table);
                webix.$$("chuyendai-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "chuyendai-win",
        position: "center",
        head: "Chuyển dải biên lai",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "chuyendai-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "kyhieuhoadon_78_id",
                    label: "Ký hiệu hóa đơn",
                    //labelPosition: "top",
                    id: "kyhieuhoadon_78_id",
                    required: true,
                    labelWidth: 120,
                    invalidMessage: "Ký hiệu hóa đơn không được bỏ trống",
                },
                {
                    view: "combo",
                    name: "loaichuyendai_id",
                    label: "Loại chuyển dải",
                    id: "loaichuyendai_id",
                    labelWidth: 120,
                    value: "1",
                    options: [
                        { id: 1, value: "Thay thế" },
                        { id: 2, value: "Điều chỉnh" },
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
            // $$("kyhieuhoadon_78_id").define("options", app.config.host + "/System/GetDataByReferencesId?id=" + param["data"][0].WinParams[0].wb_references_id);
            $$("kyhieuhoadon_78_id").define("options", app.config.host + "/System/GetDataByReferencesId?id=87b61aa2-7864-41f8-a28a-7f52290aa0b7");
            var table = $$("invoiceViews");
            var item = table.getSelectedItem();
            $$("kyhieuhoadon_78_id").setValue(item.cctbao_id);
            $$("kyhieuhoadon_78_id").refresh();
        },
        setValues: function (item) {
            $$("chuyendai-form").setValues(item);
        },
    };
});

define('views/forms/68_chuyenDaiBienLaiCMG',["app", "locale", "models/user", "views/commonHD"], function (app, _, user, commonHD) {
    var editmode = 0;
    var param;
    var branh_code;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var item = $$("chuyendai-form").getValues();
                        var kyHieuHoaDon = {
                            cctbao_id: $$("kyhieuhoadon_78_id").getValue(),
                            khieu: $$("kyhieuhoadon_78_id").data.text,
                        };

                        switch (item.loaichuyendai_id) {
                            case "1":
                                commonHD.ExcuteReplaceInvoice_KMG(kyHieuHoaDon);
                                break;
                            case "2":
                                commonHD.ExcuteInfoChangeInvoice_BienLai(kyHieuHoaDon);
                                break;
                            default:
                                break;
                        }
                        $$("chuyendai-win").close();
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                var table = $$("invoiceViews").getParentView();
                console.log(table);
                webix.$$("chuyendai-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "chuyendai-win",
        position: "center",
        head: "Chuyển dải biên lai",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "chuyendai-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "kyhieuhoadon_78_id",
                    label: "Ký hiệu hóa đơn",
                    //labelPosition: "top",
                    id: "kyhieuhoadon_78_id",
                    required: true,
                    labelWidth: 120,
                    invalidMessage: "Ký hiệu hóa đơn không được bỏ trống",
                },
                {
                    view: "combo",
                    name: "loaichuyendai_id",
                    label: "Loại chuyển dải",
                    id: "loaichuyendai_id",
                    labelWidth: 120,
                    value: "1",
                    options: [
                        { id: 1, value: "Thay thế" },
                        { id: 2, value: "Điều chỉnh" },
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
            // $$("kyhieuhoadon_78_id").define("options", app.config.host + "/System/GetDataByReferencesId?id=" + param["data"][0].WinParams[0].wb_references_id);
            $$("kyhieuhoadon_78_id").define("options", app.config.host + "/System/GetDataByReferencesId?id=d78ba681-3424-4cf3-9835-9074b20fda6e");
            var table = $$("invoiceViews");
            var item = table.getSelectedItem();
            $$("kyhieuhoadon_78_id").setValue(item.cctbao_id);
            $$("kyhieuhoadon_78_id").refresh();
        },
        setValues: function (item) {
            $$("chuyendai-form").setValues(item);
        },
    };
});

define('views/forms/68_chuyenDaiChungTuTncn',["app", "locale", "models/user", "views/commonHD"], function (app, _, user, commonHD) {
    var editmode = 0;
    var param;
    var branh_code;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var item = $$("chuyendai-form").getValues();
                        var kyHieuHoaDon = {
                            cctbao_id: $$("kyhieuhoadon_78_id").getValue(),
                            khieu: $$("kyhieuhoadon_78_id").data.text,
                        };
                        debugger
                        switch (item.loaichuyendai_id) {
                            case "1":
                                commonHD.ExcuteReplaceChungTuTncn(kyHieuHoaDon);
                                break;
                            case "2":
                                commonHD.ExcuteInfoChangeChungTuTncn(kyHieuHoaDon);
                                break;
                            default:
                                break;
                        }                
                        
                        $$("chuyendai-win").close();
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                var table = $$("invoiceViews").getParentView();
                console.log(table);
                webix.$$("chuyendai-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "chuyendai-win",
        position: "center",
        head: "Chuyển dải hoá đơn hóa đơn",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "chuyendai-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "kyhieuhoadon_78_id",
                    label: "Kí hiệu hóa đơn",
                    //labelPosition: "top",
                    id: "kyhieuhoadon_78_id",
                    required: true,
                    labelWidth: 120,
                    invalidMessage: "Kí hiệu hóa đơn không được bỏ trống",
                },
                {
                    view: "combo",
                    name: "loaichuyendai_id",
                    label: "Loại chuyển dải",
                    id: "loaichuyendai_id",
                    labelWidth: 120,
                    value: "1",
                    options: [
                        { id: 1, value: "Thay thế" },
                        { id: 2, value: "Điều chỉnh"}
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
            $$("kyhieuhoadon_78_id").define("options", app.config.host + "/System/GetDataByReferencesId?id=" + param["data"][0].WinParams[0].wb_references_id);
            var table = $$("invoiceViews");
            var item = table.getSelectedItem();
            $$("kyhieuhoadon_78_id").setValue(item.cctbao_id);
            $$("kyhieuhoadon_78_id").refresh();
        },
        setValues: function (item) {
            $$("chuyendai-form").setValues(item);
        },
    };
});

define('views/forms/68_chuyenDaiHoaDon',["app", "locale", "models/user", "views/commonHD"], function (app, _, user, commonHD) {
    var editmode = 0;
    var param;
    var branh_code;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var item = $$("chuyendai-form").getValues();
                        var kyHieuHoaDon = {
                            cctbao_id: $$("kyhieuhoadon_78_id").getValue(),
                            khieu: $$("kyhieuhoadon_78_id").data.text,
                        };

                        switch (item.loaichuyendai_id) {
                            case "1":
                                commonHD.ExcuteReplaceInvoice(kyHieuHoaDon);
                                break;
                            case "2":
                                commonHD.ExcuteIncreaseChangeInvoice(kyHieuHoaDon);
                                break;
                            case "3":
                                commonHD.ExcuteReduceChangeInvoice(kyHieuHoaDon);
                                break;
                            case "4":
                                commonHD.ExcuteInfoChangeInvoice(kyHieuHoaDon);
                                break;
                            default:
                                break;
                        }
                        $$("chuyendai-win").close();
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                var table = $$("invoiceViews").getParentView();
                console.log(table);
                webix.$$("chuyendai-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "chuyendai-win",
        position: "center",
        head: "Chuyển dải hoá đơn hóa đơn",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "chuyendai-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "kyhieuhoadon_78_id",
                    label: "Ký hiệu hóa đơn",
                    //labelPosition: "top",
                    id: "kyhieuhoadon_78_id",
                    required: true,
                    labelWidth: 120,
                    invalidMessage: "Ký hiệu hóa đơn không được bỏ trống",
                },
                {
                    view: "combo",
                    name: "loaichuyendai_id",
                    label: "Loại chuyển dải",
                    id: "loaichuyendai_id",
                    labelWidth: 120,
                    value: "1",
                    options: [
                        { id: 1, value: "Thay thế" },
                        { id: 2, value: "Điều chỉnh tăng" },
                        { id: 3, value: "Điều chỉnh giảm" },
                        { id: 4, value: "Điều chỉnh thông tin" },
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
            // $$("kyhieuhoadon_78_id").define("options", app.config.host + "/System/GetDataByReferencesId?id=" + param["data"][0].WinParams[0].wb_references_id);
            $$("kyhieuhoadon_78_id").define("options", app.config.host + "/System/GetDataByReferencesId?id=8d0468ef-349f-41ce-8d63-499af9073e4a");
            var table = $$("invoiceViews");
            var item = table.getSelectedItem();
            $$("kyhieuhoadon_78_id").setValue(item.cctbao_id);
            $$("kyhieuhoadon_78_id").refresh();
        },
        setValues: function (item) {
            $$("chuyendai-form").setValues(item);
        },
    };
});

define('callApis/hoadon68',["app"], function (app) {
    
    var hoadonSaveChangePath = app.config.host + "/Invoice68/hoadonSaveChange";
    return {
        $oninit: function (app, newconfig) {
        },
        $onurl: function (url) {
        },
        /**
         * Save data invoice
         */
        hoadonSaveChange: function (obj) {
            return webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .post(hoadonSaveChangePath, obj);
        }
    };
});

define('callApis/customer',["app"], function (app) {
    
    var saveCustomerPath = app.config.host + "/Customer/SaveCustomer";
    return {
        $oninit: function (app, newconfig) {
        },
        $onurl: function (url) {
        },
        /**
         * Save data customer
         */
        saveCustomer: function (obj) {
            return webix.ajax().post(saveCustomerPath,obj);
        }
    };
});

define('views/forms/formhoadon78',["app", "locale", "models/user", "models/findjson", "views/commonHD", "callApis/hoadon68", "callApis/customer", "views/DataStorage/DataHoaDon78"], function (app, _, user, findJson, commonHD, hoadon68CallApis, customerCallApis, dataFormHd78) {
    var editmode = 0;
    var modeChangeView = 1; // 1 - Vào form theo dạng thường; 2 - vào form từ chức năng "Sao chép chọn dải"
    var tongtienHDonBke = 0;
    var tongtienthueHDonBke = 0;
    var mau04 = {};
    var formatSoDefault = {
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0,
    };

    var el = [];
    function renderFormat(val) {
        if (val === undefined) val = "VND";
        var url = app.config.host + "/Invoice68/GetDecimalPlace?ma_nt=" + val;
        var table_chitiet = webix.$$("hoadon68_chitiet");

        var table_phi = webix.$$("hoadon68_phi");

        var table = $$("invoiceForms");

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .get(url, function (text) {
                var arr = JSON.parse(text);

                webix.storage.local.put("dsFieldFormat", arr[0]);

                var arrayString_chitiet = ["sluong", "dgia", "thtien", "stckhau", "tthue", "tgtien", "tienphi", "tlckhau"];

                for (var i = 0; i < arrayString_chitiet.length; i++) {
                    var field_name = "";
                    switch (arrayString_chitiet[i]) {
                        case "sluong":
                            field_name = "quantity_decimal";
                            break;
                        case "dgia":
                            field_name = "price_decimal";
                            break;
                        case "thtien":
                            field_name = "amount_without_vat_decimal";
                            break;
                        case "stckhau":
                            field_name = "price_discount";
                            break;
                        case "tthue":
                            field_name = "tax_price";
                            break;
                        case "tgtien":
                            field_name = "total_amount_decimal";
                            break;
                        case "tienphi":
                            field_name = "fee_price";
                            break;
                        case "tlckhau":
                            field_name = "tlckhau";
                            break;
                    }

                    var decimal_place = Array(Number(arr[0][field_name]) + 1).join("9");
                    var decimal_format = Number(arr[0][field_name]);
                    var format_numeric = {
                        //maximumValue: Number("999999999999." + decimal_place),
                        //minValue: Number("-999999999999." + decimal_place),
                        decimalPlaces: Number(decimal_format),
                    };
                    var formatSoDefault = {
                        groupDelimiter: ",",
                        groupSize: 3,
                        decimalDelimiter: ".",
                        decimalSize: decimal_format,
                    };
                    var formatSo = webix.Number.numToStr(formatSoDefault);
                    if (field_name == "fee_price") {
                        var format_config = table_phi.getColumnConfig("tienphi");

                        format_config.format = formatSo;
                        format_config.numericConfig = format_numeric;
                    } else {
                        var format_config = table_chitiet.getColumnConfig(arrayString_chitiet[i]);

                        format_config.format = formatSo;
                        format_config.numericConfig = format_numeric;
                    }
                }

                var arrayString = [
                    "tgtcthue",
                    "tgtcthue10",
                    "tgtcthue5",
                    "tgtcthue0",
                    "tgtcthuek",
                    "tgtcthuekct",
                    "tgtcthuekkk",
                    "ttcktmai",
                    "ttcktmai10",
                    "ttcktmai5",
                    "ttcktmai0",
                    "ttcktmaik",
                    "ttcktmaikct",
                    "ttcktmaikkk",
                    "tgtthue",
                    "tgtthue10",
                    "tgtthue5",
                    "tgtthue0",
                    "tgtthuek",
                    "tgtthuekct",
                    "tgtthuekkk",
                    "tgtttbso",
                    "tgtttbso10",
                    "tgtttbso5",
                    "tgtttbso0",
                    "tgtttbsok",
                    "tgtttbsokct",
                    "tgtttbsokkk",
                    "tkcktmn",
                    "tgtphi",
                    "tgtttbso_last",
                ];

                table_chitiet.refreshColumns();
                table_phi.refreshColumns();

                for (var i = 0; i < arrayString.length; i++) {
                    $$(arrayString[i]).refresh();
                }
            });
    }

    //FormButton
    var cols = [
        {
            margin: 10,
            cols: [
                {},
                {
                    shortcut: "F10",
                    view: "button",
                    id: "btnBangKeSave",
                    label: "Lưu (F10)",
                    type: "form",
                    align: "center",
                    width: 120,
                    hidden: true,
                    on: {
                        onClick: function () {
                            var self = this;
                            setTimeout(function () {
                                var tongtienBangKeCT = webix.$$("tgtttbso").getValue();
                                var tongtienthueBangKeCT = webix.$$("tgtthue").getValue();
                                var item = $$("invoiceForms").getValues();
                                var table = $$("invoiceForms");
                                var record = $$("hoadon68_chitiet").serialize();
                                if (record.length == 0) {
                                    webix.message("Bạn chưa bổ sung chi tiết hàng hóa");
                                    return;
                                }
                                var mauso = $$("khieu").getValue().toString()[0];
                                var tudongtinhtien = item.tudongtinhtien;
                                for (var i = 0; i < record.length; i++) {
                                    var it = record[i];
                                    var isHasDiscount = it["tiletienthuegtgtgiam"] != null && it["tiletienthuegtgtgiam"] != "" && it["tiletienthuegtgtgiam"] != 0 && it["tiletienthuegtgtgiam"] != '0';
                                    if (tudongtinhtien == "0") {
                                        if (mauso === "2" && !isHasDiscount) {
                                            record[i].thtien = record[i].tgtien;
                                        }
                                    }
                                    var it = record[i];

                                    if (it["ten"] == null || it["ten"] == "") {
                                        webix.message("Bạn chưa nhập tên hàng");
                                        return;
                                    }
                                    if (it.kmai != null && (it.kmai.toString() === "1" || it.kmai.toString() === "5")) {
                                        //var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                        //if (!bool) {
                                        //    webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                        //    return;
                                        //}
                                        if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                            webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                            return;
                                        }
                                    }
                                }

                                if (tongtienHDonBke != tongtienBangKeCT) {
                                    webix.message("Tổng tiền chi tiết bảng kê khác tổng tiền của hoá đơn!", "error");
                                    return false;
                                }

                                if (tongtienthueHDonBke != tongtienthueBangKeCT) {
                                    webix.message("Tổng tiền thuế chi tiết bảng kê khác tổng tiền thuế của hoá đơn!", "error");
                                    return false;
                                }

                                if (table.validate()) {
                                    // var fn = Function(check);
                                    // var result = fn();
                                    // console.log(result);
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    var details = [];
                                    details.push({ data: record });
                                    item["details"] = details;
                                    var phi = [];
                                    phi.push({
                                        data: $$("hoadon68_phi").serialize(),
                                    });
                                    item["hoadon68_phi"] = phi;
                                    // hóa đơn không mã
                                    item.is_hdcma = 0;
                                    if (tudongtinhtien == "0") {
                                        if (item.tgtttbso === undefined || item.tgtttbso === "" || item.tgtttbso === null) {
                                            item.tgtttbso = item.tgtttbso_last;
                                        }
                                    }
                                    var item1 = [];
                                    item1.push(item);
                                    var data_post = { editmode: editmode, data: item1 };

                                    var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                    function hoadonSaveChange() {
                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/Invoice68/hoadonSaveChange", data_post, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    table.enable();
                                                    table.hideProgress();
                                                    webix.message(text + XmlHttpRequest, "error");
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var json = JSON.parse(text);
                                                    table.enable();
                                                    table.hideProgress();
                                                    if (!json.hasOwnProperty("error")) {
                                                        webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                                        if (isSaveCustomerInfo)
                                                            if (!json.hasOwnProperty("message_warning")) {
                                                                webix.message("Lưu thông tin khách hàng thành công!", "success");
                                                            }

                                                        var item = $$("invoiceForms").getValues();
                                                        if (item && modeChangeView == 2) {
                                                            dataFormHd78.SetData("KHID", item.cctbao_id);
                                                        }
                                                        webix.$$("invoice68").close();

                                                        if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                            app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                        } else {
                                                            app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                        }
                                                    } else {
                                                        webix.message(json.error, "error");
                                                    }
                                                },
                                            });
                                    }

                                    if ($$('is_save_customer_info') != null && $$('is_save_customer_info').getValue() == 1) {
                                        var mnmuaValue = $$('mnmua').getValue();
                                        var tenValue = $$('ten').getValue();
                                        var mstValue = $$('mst').getValue();
                                        var dchiValue = $$('dchi').getValue();

                                        var checkMessage = [];

                                        if (mnmuaValue == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                        if (tenValue == "") checkMessage.push('"Tên" khách hảng là trường bắt buộc nhập"');
                                        if (dchiValue == "") checkMessage.push('"Địa chỉ" khách hảng là trường bắt buộc nhập"');

                                        var showConfirmUI = function () {
                                            webix.ui({
                                                view: "window",
                                                id: "check-customer-modal",
                                                type: "modal",
                                                modal: true,
                                                position: "center",
                                                head: {
                                                    height: 35,
                                                    cols: [
                                                        {
                                                            id: "head-form-check-customer",
                                                            view: "template",
                                                            css: "headform",
                                                            template: function (obj) {
                                                                return "<div>&nbsp;Tạo mới khách hàng thất bại<div/>";
                                                            },
                                                        }
                                                    ],
                                                },
                                                body: {
                                                    padding: 10,
                                                    rows: [
                                                        {
                                                            rows: checkMessage.map(function (message) {
                                                                return {
                                                                    view: "template",
                                                                    template: "▶ " + message,
                                                                    autoheight: true, width: 350
                                                                }
                                                            }),
                                                        },
                                                        {
                                                            view: "template", template: "<div style='text-align:left;'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        hoadonSaveChange();
                                                                    }
                                                                },
                                                                {
                                                                    view: "button", value: "Hủy", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        table.enable();
                                                                        table.hideProgress();
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            }).show()
                                        }

                                        if (mnmuaValue == "" && mstValue == "") {
                                            showConfirmUI();
                                        } else {
                                            webix
                                                .ajax()
                                                .headers({ "Content-type": "application/json" })
                                                .get(app.config.host + "/Customer/CheckExistedCustomerCodeOrTaxCode?code=" + mnmuaValue + "&taxcode=" + mstValue, null, function (res) {

                                                    res = JSON.parse(res);
                                                    if (res.length > 0) {
                                                        for (var i = 0; i < res.length; i++) {
                                                            if (res[i].code == mnmuaValue) {
                                                                checkMessage.push('"Mã" khách hàng đã tồn tại');
                                                            }
                                                            if (res[i].tax_code == mstValue) {
                                                                checkMessage.push('"Mã" số thuế của khách hàng đã tồn tại');
                                                            }
                                                        }
                                                    }

                                                    if (checkMessage.length > 0) {
                                                        showConfirmUI();
                                                    } else {
                                                        hoadonSaveChange();
                                                    }
                                                });
                                        }
                                    } else
                                        hoadonSaveChange();
                                }
                            }, 100);
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    view: "button",
                    id: "btnBangKeDelete",
                    label: "Xoá",
                    type: "danger",
                    align: "center",
                    width: 80,
                    hidden: true,
                    on: {
                        onClick: function () {
                            var self = this;
                            setTimeout(function () {
                                var item = $$("invoiceForms").getValues();
                                var url = app.config.host + "/Invoice68/DeleteBangKeHoaDon?id=" + item.id;
                                var table = $$("invoiceForms");
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();
                                webix
                                    .ajax()
                                    .headers({ "Content-Type": "application/json" })
                                    .post(url, function (result) {
                                        if (result == "true") {
                                            webix.message("Đã xoá bảng kê !");
                                            table.enable();
                                            table.hideProgress();
                                            webix.$$("invoice68").close();
                                            app.callEvent("dataChangedInvoie68", [editmode, null]);
                                        } else {
                                            webix.message("Xoá không thành công !", "error");
                                        }
                                    });
                            }, 100);
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    shortcut: "F10",
                    view: "button",
                    id: "btnHoadonSave",
                    label: "Lưu tạm (F10)",
                    type: "form",
                    align: "center",
                    width: 120,
                    on: {
                        onClick: function () {
                            var self = this;

                            $$("btnHoadonSave").disable();
                            setTimeout(function () {
                                var item = $$("invoiceForms").getValues();
                                if (item.nlap_temp != null) {
                                    var nlap_temp = new Date(item.nlap_temp);
                                    nlap_temp = new Date(nlap_temp.getFullYear(), nlap_temp.getMonth(), nlap_temp.getDate());
                                    if ($$("nlap").getValue() < nlap_temp) {
                                        webix.message("Ngày hoá đơn thay thế hoặc điều chỉnh không được nhỏ hơn hoá đơn gốc!", "error");
                                        return;
                                    }
                                }
                                var table = $$("invoiceForms");
                                var record = $$("hoadon68_chitiet").serialize();
                                if (record.length == 0) {
                                    webix.message("Bạn chưa bổ sung chi tiết hàng hóa");
                                    $$("btnHoadonSave").enable();
                                    return;
                                }
                                var mauso = $$("khieu").getValue().toString()[0];
                                var tudongtinhtien = item.tudongtinhtien;

                                for (var i = 0; i < record.length; i++) {
                                    var it = record[i];
                                    var isHasDiscount = it["tiletienthuegtgtgiam"] != null && it["tiletienthuegtgtgiam"] != "" && it["tiletienthuegtgtgiam"] != 0 && it["tiletienthuegtgtgiam"] != '0';
                                    if (tudongtinhtien == "0") {
                                        if (mauso === "2" && !isHasDiscount) {
                                            record[i].thtien = record[i].tgtien;
                                        }
                                    }
                                    var it = record[i];
                                    if (it["ten"] == null || it["ten"] == "") {
                                        webix.message("Bạn chưa nhập tên hàng");
                                        return;
                                    }
                                    if (it.kmai != null && (it.kmai.toString() === "1" || it.kmai.toString() === "5")) {
                                        /*var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                    if (!bool) {
                                        webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                        return;
                                    }*/
                                        if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                            webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                            return;
                                        }
                                    }
                                }

                                /*if($$("lblCanhbao").type==1){
                                    webix.message( $$("lblCanhbao").getValue()+". Không thể lưu!", "error");
                                    return;
                                }*/

                                if (table.validate()) {
                                    var TTKhac = [];
                                    Object.keys(item).forEach(function (key) {
                                        if (key.includes("TTKhac_")) {
                                            var test = $$(key);
                                            if (test.config.editor === "nummeric" || test.config.editor === "autonumeric") {
                                                TTKhac.push({
                                                    ttruong: key.replace("TTKhac_", ""),
                                                    kdlieu: "decimal",
                                                    dlieu: item[key],
                                                });
                                            }
                                            else if (test.config.view === "text") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "string", dlieu: item[key] });
                                            else if (test.config.view === "datepicker") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "dateTime", dlieu: item[key] });
                                        }
                                    });
                                    var TTKhacItem = [];
                                    TTKhacItem.push({
                                        data: TTKhac,
                                    });
                                    item["hoadon68_khac"] = TTKhacItem;
                                    // var fn = Function(check);
                                    // var result = fn();
                                    // console.log(result);
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    var details = [];
                                    details.push({ data: record });
                                    item["details"] = details;
                                    var phi = [];
                                    phi.push({
                                        data: $$("hoadon68_phi").serialize(),
                                    });
                                    item["hoadon68_phi"] = phi;
                                    // hóa đơn không mã
                                    item.is_hdcma = 0;
                                    if (tudongtinhtien == "0") {
                                        if (item.tgtttbso === undefined || item.tgtttbso === "" || item.tgtttbso === null) {
                                            item.tgtttbso = item.tgtttbso_last;
                                        }
                                    }
                                    var item1 = [];
                                    item1.push(item);
                                    var data_post = { editmode: editmode, data: item1 };

                                    var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                    function afterSaveInvoiceSuccess(text) {
                                        var json = text.json();
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                            var item = $$("invoiceForms").getValues();
                                            if (item && modeChangeView == 2) {
                                                dataFormHd78.SetData("KHID", item.cctbao_id);
                                            }
                                            webix.$$("invoice68").close();

                                            if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            } else {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            }
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    }

                                    function afterSaveInvoiceError(text) {
                                        table.enable();
                                        table.hideProgress();
                                        webix.message(text.json() + XmlHttpRequest, "error");
                                    }

                                    if (isSaveCustomerInfo) {


                                        var code = $$('mnmua') != null ? $$('mnmua').getValue() : null;
                                        var buyer_name = $$('tnmua') != null ? $$('tnmua').getValue() : null;
                                        var name = $$('ten') != null ? $$('ten').getValue() : null;
                                        var tax_code = $$('mst') != null ? $$('mst').getValue() : null;
                                        var email = $$('email') != null ? $$('email').getValue() : null;
                                        var address = $$('dchi') != null ? $$('dchi').getValue() : null;
                                        var tel = $$('sdtnmua') != null ? $$('sdtnmua').getValue() : null;
                                        var bank_account = $$('stknmua') != null ? $$('stknmua').getValue() : null;
                                        var bank_name = $$('tnhmua') != null ? $$('tnhmua').getValue() : null;
                                        var name_label = $$('ten') != null ? $$('ten').config.label : "Tên";
                                        var address_label = $$('dchi') != null ? $$('dchi').config.label : "Địa chỉ";

                                        var obj = {
                                            code: code,
                                            buyer_name: buyer_name,
                                            name: name,
                                            tax_code: tax_code,
                                            email: email,
                                            address: address,
                                            tel: tel,
                                            bank_account: bank_account,
                                            bank_name: bank_name,
                                        };

                                        var checkMessage = [];

                                        if (obj.code == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                        if (obj.name == "") checkMessage.push('"' + name_label + '" là trường bắt buộc nhập"');
                                        if (obj.address == "") checkMessage.push('"' + address_label + '" khách hảng là trường bắt buộc nhập"');

                                        var showConfirmUI = function () {
                                            webix.ui({
                                                view: "window",
                                                id: "check-customer-modal",
                                                type: "modal",
                                                modal: true,
                                                position: "center",
                                                head: {
                                                    height: 35,
                                                    cols: [
                                                        {
                                                            id: "head-form-check-customer",
                                                            view: "template",
                                                            css: "headform",
                                                            template: function (obj) {
                                                                return "<div style='text-align: center;'>Tạo mới khách hàng thất bại<div/>";
                                                            },
                                                        }
                                                    ],
                                                },
                                                body: {
                                                    padding: 10,
                                                    rows: [
                                                        {
                                                            rows: checkMessage.map(function (message) {
                                                                return {
                                                                    view: "template",
                                                                    template: "▶ " + message,
                                                                    autoheight: true, width: 350
                                                                }
                                                            }),
                                                        },
                                                        {
                                                            view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                        },
                                                        {
                                                            cols: [
                                                                {},
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                                                            .then(afterSaveInvoiceSuccess)
                                                                            .catch(afterSaveInvoiceError);
                                                                    }
                                                                },
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Nhập lại", type: "danger", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        table.enable();
                                                                        table.hideProgress();
                                                                    }
                                                                },
                                                                {}
                                                            ]
                                                        }
                                                    ]
                                                }
                                            }).show()
                                        }

                                        if (checkMessage.length > 0) {
                                            showConfirmUI();
                                        } else {
                                            customerCallApis.saveCustomer(obj).then(function (res) {
                                                res = res.json();

                                                if (!res.status) {
                                                    checkMessage.push(res.message.replace("P0001: ", ""));
                                                    showConfirmUI();
                                                } else {
                                                    webix.message("Lưu thông tin khách hàng thành công", "success"); hoadon68CallApis.hoadonSaveChange(data_post)
                                                        .then(afterSaveInvoiceSuccess)
                                                        .catch(afterSaveInvoiceError);
                                                }
                                            });
                                        }
                                    } else
                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                            .then(afterSaveInvoiceSuccess)
                                            .catch(afterSaveInvoiceError);;

                                }
                                $$("btnHoadonSave").enable();
                            }, 100);
                            $$("btnHoadonSave").enable();
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    shortcut: "F11",
                    view: "button",
                    id: "btnHoadonCQT",
                    label: "Ký và gửi CQT (F11)",
                    type: "form",
                    align: "center",
                    width: 150,
                    on: {
                        onClick: function () {
                            var self = this;
                            setTimeout(function () {
                                var item = $$("invoiceForms").getValues();
                                if (item.nlap_temp != null) {
                                    var nlap_temp = new Date(item.nlap_temp);
                                    nlap_temp = new Date(nlap_temp.getFullYear(), nlap_temp.getMonth(), nlap_temp.getDate());
                                    if ($$("nlap").getValue() < nlap_temp) {
                                        webix.message("Ngày hoá đơn thay thế hoặc điều chỉnh không được nhỏ hơn hoá đơn gốc!", "error");
                                        return;
                                    }
                                }
                                var table = $$("invoiceForms");
                                var record = $$("hoadon68_chitiet").serialize();
                                if (record.length == 0) {
                                    webix.message("Bạn chưa bổ sung chi tiết hàng hóa");
                                    return;
                                }
                                var mauso = $$("khieu").getValue().toString()[0];
                                var tudongtinhtien = item.tudongtinhtien;
                                for (var i = 0; i < record.length; i++) {
                                    var it = record[i];
                                    var isHasDiscount = it["tiletienthuegtgtgiam"] != null && it["tiletienthuegtgtgiam"] != "" && it["tiletienthuegtgtgiam"] != 0 && it["tiletienthuegtgtgiam"] != '0';
                                    if (tudongtinhtien == "0") {
                                        if (mauso === "2" && !isHasDiscount) {
                                            record[i].thtien = record[i].tgtien;
                                        }
                                    }
                                    var it = record[i];
                                    if (it["ten"] == null || it["ten"] == "") {
                                        webix.message("Bạn chưa nhập tên hàng");
                                        return;
                                    }
                                    if (it.kmai != null && (it.kmai.toString() === "1" || it.kmai.toString() === "5")) {
                                        /*var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                    if (!bool) {
                                        webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                        return;
                                    }*/
                                        if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                            webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                            return;
                                        }
                                    }
                                }

                                /*if($$("lblCanhbao").type==1){
                                    webix.message( $$("lblCanhbao").getValue()+". Không thể lưu!", "error");
                                    return;
                                }*/

                                if (table.validate()) {
                                    var TTKhac = [];
                                    Object.keys(item).forEach(function (key) {
                                        if (key.includes("TTKhac_")) {
                                            var test = $$(key);
                                            if (test.config.editor === "nummeric" || test.config.editor === "autonumeric") {
                                                TTKhac.push({
                                                    ttruong: key.replace("TTKhac_", ""),
                                                    kdlieu: "decimal",
                                                    dlieu: item[key],
                                                });
                                            }
                                            else if (test.config.view === "text") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "string", dlieu: item[key] });
                                            else if (test.config.view === "datepicker") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "dateTime", dlieu: item[key] });
                                        }
                                    });
                                    var TTKhacItem = [];
                                    TTKhacItem.push({
                                        data: TTKhac,
                                    });
                                    item["hoadon68_khac"] = TTKhacItem;
                                    // var fn = Function(check);
                                    // var result = fn();
                                    // console.log(result);
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    var details = [];
                                    details.push({ data: $$("hoadon68_chitiet").serialize() });
                                    item["details"] = details;
                                    var phi = [];
                                    phi.push({
                                        data: $$("hoadon68_phi").serialize(),
                                    });
                                    item["hoadon68_phi"] = phi;
                                    // hóa đơn không mã
                                    item.is_hdcma = 0;
                                    if (tudongtinhtien == "0") {
                                        if (item.tgtttbso === undefined || item.tgtttbso === "" || item.tgtttbso === null) {
                                            item.tgtttbso = item.tgtttbso_last;
                                        }
                                    }
                                    var item1 = [];
                                    item1.push(item);
                                    var data_post = { editmode: editmode, data: item1 };

                                    var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                    function afterSaveInvoiceSuccess(text) {
                                        var json = text.json();
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                            var item = $$("invoiceForms").getValues();
                                            if (item && modeChangeView == 2) {
                                                dataFormHd78.SetData("KHID", item.cctbao_id);
                                            }
                                            webix.$$("invoice68").close();

                                            if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            } else {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            }
                                            var lsthdon_id = [];
                                            lsthdon_id.push(json.data.hdon_id);
                                            commonHD.ExcuteHoaDon(lsthdon_id, true, false);

                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    }

                                    function afterSaveInvoiceError(text) {
                                        table.enable();
                                        table.hideProgress();
                                        webix.message(text.json() + XmlHttpRequest, "error");
                                    }

                                    if (isSaveCustomerInfo) {

                                        var code = $$('mnmua') != null ? $$('mnmua').getValue() : null;
                                        var buyer_name = $$('tnmua') != null ? $$('tnmua').getValue() : null;
                                        var name = $$('ten') != null ? $$('ten').getValue() : null;
                                        var tax_code = $$('mst') != null ? $$('mst').getValue() : null;
                                        var email = $$('email') != null ? $$('email').getValue() : null;
                                        var address = $$('dchi') != null ? $$('dchi').getValue() : null;
                                        var tel = $$('sdtnmua') != null ? $$('sdtnmua').getValue() : null;
                                        var bank_account = $$('stknmua') != null ? $$('stknmua').getValue() : null;
                                        var bank_name = $$('tnhmua') != null ? $$('tnhmua').getValue() : null;
                                        var name_label = $$('ten') != null ? $$('ten').config.label : "Tên";
                                        var address_label = $$('dchi') != null ? $$('dchi').config.label : "Địa chỉ";


                                        var obj = {
                                            code: code,
                                            buyer_name: buyer_name,
                                            name: name,
                                            tax_code: tax_code,
                                            email: email,
                                            address: address,
                                            tel: tel,
                                            bank_account: bank_account,
                                            bank_name: bank_name,
                                        };

                                        var checkMessage = [];

                                        if (obj.code == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                        if (obj.name == "") checkMessage.push('"' + name_label + '" là trường bắt buộc nhập"');
                                        if (obj.address == "") checkMessage.push('"' + address_label + '" khách hảng là trường bắt buộc nhập"');

                                        var showConfirmUI = function () {
                                            webix.ui({
                                                view: "window",
                                                id: "check-customer-modal",
                                                type: "modal",
                                                modal: true,
                                                position: "center",
                                                head: {
                                                    height: 35,
                                                    cols: [
                                                        {
                                                            id: "head-form-check-customer",
                                                            view: "template",
                                                            css: "headform",
                                                            template: function (obj) {
                                                                return "<div style='text-align: center;'>Tạo mới khách hàng thất bại<div/>";
                                                            },
                                                        }
                                                    ],
                                                },
                                                body: {
                                                    padding: 10,
                                                    rows: [
                                                        {
                                                            rows: checkMessage.map(function (message) {
                                                                return {
                                                                    view: "template",
                                                                    template: "▶ " + message,
                                                                    autoheight: true, width: 350
                                                                }
                                                            }),
                                                        },
                                                        {
                                                            view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                        },
                                                        {
                                                            cols: [
                                                                {},
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                                                            .then(afterSaveInvoiceSuccess)
                                                                            .catch(afterSaveInvoiceError);
                                                                    }
                                                                },
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Nhập lại", type: "danger", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        table.enable();
                                                                        table.hideProgress();
                                                                    }
                                                                },
                                                                {}
                                                            ]
                                                        }
                                                    ]
                                                }
                                            }).show()
                                        }

                                        if (checkMessage.length > 0) {
                                            showConfirmUI();
                                        } else {
                                            customerCallApis.saveCustomer(obj).then(function (res) {
                                                res = res.json();
                                                if (!res.status) {
                                                    checkMessage.push(res.message.replace("P0001: ", ""));
                                                    showConfirmUI();
                                                } else {

                                                    webix.message("Lưu thông tin khách hàng thành công", "success"); hoadon68CallApis.hoadonSaveChange(data_post)
                                                        .then(afterSaveInvoiceSuccess)
                                                        .catch(afterSaveInvoiceError);
                                                }
                                            });
                                        }
                                    } else
                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                            .then(afterSaveInvoiceSuccess)
                                            .catch(afterSaveInvoiceError);;

                                }
                            }, 100);
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    view: "button",
                    hotkey: "esc",
                    label: "Hủy bỏ (ESC)",
                    align: "center",
                    type: "danger",
                    width: 120,
                    click: function () {
                        this.getTopParentView().close();
                        app.callEvent("dataChangedInvoie68", [editmode, null]);
                    },
                },
                {},
            ],
        },
    ];

    //FormDetail Tạo item trên trang from từ tab và data

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-iconInvoice",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formInvoice",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Test Form<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_InvoiceForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "invoice68",
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () { },
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "invoiceForms",
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {
                    // }
                },
                elements: el,
            },
        },
        setValues: function (item, winconfig, params) {
            commonHD.setdsFieldFormatFromLocal(item.dvtte);
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            if (item != null) {
                this.editgiatri(item);

                if (item.docngoaitetv) {
                    item.docngoaitetv = 1;
                } else {
                    item.docngoaitetv = 0;
                }

                form.setValues(item);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
                var tablePhi = webix.$$("hoadon68_phi");
                var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                tablePhi.clearAll();
                tablePhi.load(urlPhi);
                var urlKhac = app.config.host + "/Invoice68/GetDataInvoiceKhac?id=" + item.id;
                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .get(urlKhac, function (text) {
                        var data = JSON.parse(text);
                        for (var i = 0; i < data.length; i++) {
                            try {
                                if ($$("TTKhac_" + data[i].ttruong) !== undefined && $$("TTKhac_" + data[i].ttruong) !== null) $$("TTKhac_" + data[i].ttruong).setValue(data[i]["dlieu"]);
                            } catch (e) { }
                        }
                    });
            }

            if (editmode == 2) {
            }
            // nếu có mẫu 04 (hóa đơn hủy)
            if (winconfig != null) {
                mau04 = winconfig;
                $$("btnHoadonSaveMau04").show();
                $$("btnHoadonCQT").destructor();
                $$("btnHoadonSave").destructor();
            }
            this.getFormat(item["dvtte"], item);
        },
        setValuesBangKe: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            tongtienHDonBke = item.tgtttbso;
            tongtienthueHDonBke = item.tgtthue;
            var form = win.getChildViews()[1];
            if (item != null) {
                this.editgiatri(item);

                form.setValues(item);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = "";
                if (editmode == 4) {
                    url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                } else {
                    url = app.config.host + "/Invoice68/GetDataInvoiceDetail_BangKe?id=" + item.id;
                }
                tableDetail.clearAll();
                tableDetail.load(url);
            }
            // nếu có mẫu 04 (hóa đơn hủy)
            if (winconfig != null) {
                mau04 = winconfig;
                $$("btnHoadonSaveMau04").show();
                $$("btnHoadonCQT").destructor();
                $$("btnHoadonSave").destructor();
            }
            this.getFormat(item["dvtte"]);
        },
        editgiatri: function (item) {
            if (item["tdlap"] !== undefined) item["tdlap"] = removeTimeZoneT(item["tdlap"]);
            if (item["cqqdbants"] !== undefined) item["cqqdbants"] = removeTimeZoneT(item["cqqdbants"]);
            if (item["tgvchdtu"] !== undefined) item["tgvchdtu"] = removeTimeZoneT(item["tgvchdtu"]);
            if (item["tgvchdden"] !== undefined) item["tgvchdden"] = removeTimeZoneT(item["tgvchdden"]);
            if (item["nqdbants"] !== undefined) item["nqdbants"] = removeTimeZoneT(item["nqdbants"]);
            if (item["nbke"] !== undefined) item["nbke"] = removeTimeZoneT(item["nbke"]);
            if (item["hdktngay"] !== undefined) item["hdktngay"] = removeTimeZoneT(item["hdktngay"]);
            item["giamthuebanhang20"] = item["giamthuebanhang20"] == true ? 1 : 0;
            item["hddckptquan"] = item["hddckptquan"] == true ? 1 : 0;
            if (item["nbke"] !== undefined) item["nbke"] = removeTimeZoneT(item["nbke"]);
            if (item["ngccmnd"] !== undefined) item["ngccmnd"] = removeTimeZoneT(item["ngccmnd"]);
        },
        setEditMode: function (mode) {
            editmode = mode;
            //var form = webix.$$("invoiceForms");
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1 || editmode == 4) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            } else {
                if (editmode == 2 || editmode == 5) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
        },
        setModeChangeView: function (mode) {
            if (mode) {
                modeChangeView = mode;
                console.log("Mode change: " + modeChangeView);
            }
        },
        setNewInvoice: function () {
            var form = webix.$$("invoiceForms");
            form.config.newInvoice = true;
        },
        copyValues: function (item) {
            var form = webix.$$("invoiceForms");
            var tableDetail = webix.$$("hoadon68_chitiet");
            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(url, function (text) {
                    var data = JSON.parse(text);

                    for (var i = 0; i < data.length; i++) {
                        data[i]["cthdon_id"] = null;
                        data[i]["hdon_id"] = null;
                    }

                    tableDetail.clearAll();
                    tableDetail.parse(data);
                });
            var tablePhi = webix.$$("hoadon68_phi");
            var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(urlPhi, function (text) {
                    var data = JSON.parse(text);

                    for (var i = 0; i < data.length; i++) {
                        data[i]["phi_id"] = null;
                        data[i]["hdon_id"] = null;
                    }

                    tablePhi.clearAll();
                    tablePhi.parse(data);
                });
            var urlKhac = app.config.host + "/Invoice68/GetDataInvoiceKhac?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(urlKhac, function (text) {
                    var data = JSON.parse(text);
                    for (var i = 0; i < data.length; i++) {
                        try {
                            if ($$("TTKhac_" + data[i].ttruong) !== undefined && $$("TTKhac_" + data[i].ttruong) !== null) $$("TTKhac_" + data[i].ttruong).setValue(data[i]["dlieu"]);
                        } catch (e) { }
                    }
                });
            // tableDetail.clearAll();
            // tableDetail.load(url);
            item["tthdon"] = 0;
            item["tthdon_original"] = 0;
            item["tthdon_old"] = 0;
            item["hdon_id"] = null;
            item["hdon68_id_lk"] = null;
            item["nky"] = null;
            item["id"] = webix.uid();
            item["giamthuebanhang20"] = item["giamthuebanhang20"] == true ? 1 : 0;
            item["hddckptquan"] = item["hddckptquan"] == true ? 1 : 0;
            item["nbke"] = null;

            this.editgiatri(item);
            form.setValues(item);

            this.getFormat(item["dvtte"]);
        },
        getFormat: function (val, data) {
            commonHD.renderFormat(val, false, data);
        },
        initUINew: function (cctbao_id) {
            $$("cctbao_id").setValue(cctbao_id);
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(app.config.host + "/Invoice68/getKyhieu?cctbao_id=" + cctbao_id, function (text) {
                    var data = JSON.parse(text);

                    if (data.length > 0) {
                        var form = $$("invoiceForms");
                        var values = form.getValues();

                        values["khieu"] = data[0]["khhdon"];
                        values["mcqtcap"] = data[0]["mccqthue"];
                        values["mcqtcap"] = data[0]["mccqthue"];
                        values["msbl_tncn"] = data[0]["khmbl"];
                        values["tudongtinhtien"] = 1;
                        form.setValues(values);
                    }
                });
            this.getFormat();
        },
        initUI: function (windowconfig) {
            var rp = windowconfig;
            var vc_window = rp["data"][0];
            var tabs = vc_window.Tabs;
            $$("head-formInvoice").define("template", "<div>" + vc_window.name + "<div/>");
            el = [];
            var col = [];
            var m = 0;

            if (vc_window.detail_layout != null && vc_window.detail_layout != "") {
                var layoutdetail = JSON.parse(vc_window.detail_layout);

                var layout_element = JSON.stringify(layoutdetail.elements);
                var json_layout = JSON.parse(layout_element);
                //console.log(json_layout);
                for (var i = 0; i < json_layout.length; i++) {
                    el.push(json_layout[i]);
                }

                var jsonElement = findJson.getObjects(JSON.parse(JSON.stringify(el)), "id", "");

                for (var i = 0; i < jsonElement.length; i++) {
                    //var item = jsonElement[i];
                    //var item = jsonElement[i];
                    var fields = rp["data"][0]["Tabs"][0]["Fields"];

                    for (var j = 0; j < fields.length; j++) {
                        var field = fields[j];

                        if (jsonElement[i].name == field.column_name) {
                            item = commonHD.CreatItemMaterFromData(field);
                            jsonElement[i] = item;

                            findJson.findAndReplace(el, jsonElement[i].name, item);
                        }
                    }
                }
                if (vc_window.window_type == "MasterDetail") {
                    for (var i = 0; i < tabs.length; i++) {
                        var tab = tabs[i];

                        if (tab.tab_type == "Master") {
                            continue;
                        }

                        var subCols = [];

                        for (var j = 0; j < tab.Fields.length; j++) {
                            var field = tab.Fields[j];

                            subCols.push(commonHD.CreatItemFromData(field, tab));
                        }

                        if (tab.tab_type == "Detail" && tab.foreign_key === "detail_tab") {
                            var item = {
                                id: "detail_tab",
                                header: "Chi tiết hóa đơn",
                                select: "cell",

                                body: {
                                    rows: [
                                        {
                                            view: "toolbar",
                                            height: 40,
                                            cols: [
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                    id: "addrow",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_chitiet");
                                                            var item = {
                                                                id: webix.uid(),
                                                            };
                                                            table.add(item);
                                                            table.select(item.id, "ma", false);
                                                            table.edit({
                                                                row: item.id,
                                                                column: "ma",
                                                            });
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                    id: "removerow",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_chitiet");

                                                            table.editStop();

                                                            var item = table.getSelectedItem();

                                                            if (!webix.isUndefined(item)) {
                                                                table.remove(item.id);
                                                                table.clearSelection();
                                                                return;
                                                            }

                                                            var editor = table.getEditState();

                                                            if (!webix.isUndefined(editor)) {
                                                                table.remove(editor.row);
                                                                table.clearSelection();
                                                                return;
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                    view: "button",
                                                    id: "copyrow",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_chitiet");

                                                            table.editStop();

                                                            var item = table.getSelectedItem();
                                                            if (item == null || item == undefined) {
                                                                webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                return;
                                                            }

                                                            var copy = webix.copy(item);
                                                            copy.cthdon_id = null;
                                                            copy.id = webix.uid();

                                                            table.add(copy);
                                                            table.unselect(item.id);
                                                            table.select(copy.id, "ma", false);
                                                            table.edit({
                                                                row: copy.id,
                                                                column: "ma",
                                                            });
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 150,
                                                    label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " Nhận excel chi tiết" + "</span>",
                                                    view: "button",
                                                    id: "importRowDetail",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = $$("invoiceViews");
                                                            var item = table.getSelectedItem();

                                                            // if(item == null || item == "")
                                                            // {
                                                            // webix.message("Bạn chưa chọn hóa đơn cần nhận chi tiết !", "error");
                                                            // return;
                                                            // }

                                                            // if (item.tthai != "Chờ ký") {
                                                            //     webix.message("Hóa đơn phải có trạng thái chờ ký, bạn mới có thể nhập excel chi tiết!", "error");
                                                            //     return;
                                                            // }

                                                            require(["views/forms/uploadexcelform"], function (uploadForm) {
                                                                debugger;
                                                                uploadForm.$ui.tableId = table.config.id;
                                                                var win = table.$scope.ui(uploadForm.$ui);
                                                                win.show();
                                                                if (vc_window.code === "WIN00782") {
                                                                    webix.$$("uploader").define("formData", { excel_id: "EX00017", filename: "Mẫu import chi tiết HD bán hàng.xlsx" });
                                                                } else if (vc_window.code === "WIN00785" || vc_window.code === "WIN00786"
                                                                    || vc_window.code === "WIN00783" || vc_window.code === "WIN00784") {
                                                                    webix.$$("uploader").define("formData", { excel_id: "EX00024", filename: "Nhan chi tiet mot HD68.xlsx" });
                                                                } else {
                                                                    webix.$$("uploader").define("formData", { excel_id: "EX00011", filename: "Nhan chi tiet mot HD68.xlsx" });
                                                                }
                                                                webix.$$("uploader").hide();
                                                            });

                                                            // var table = webix.$$("hoadon68_chitiet");

                                                            // table.editStop();

                                                            // var item = table.getSelectedItem();
                                                            // if (item == null || item == undefined) {
                                                            //     webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                            //     return;
                                                            // }

                                                            // var copy = webix.copy(item);
                                                            // copy.cthdon_id = null;
                                                            // copy.id = webix.uid();

                                                            // table.add(copy);
                                                            // table.unselect(item.id);
                                                            // table.select(copy.id, "ma", false);
                                                            // table.edit({
                                                            //     row: copy.id,
                                                            //     column: "ma",
                                                            // });
                                                        },
                                                    },
                                                }
                                            ],
                                        },
                                        {
                                            view: "datatable",
                                            resizeColumn: true,
                                            id: "hoadon68_chitiet",
                                            editable: true,
                                            select: "cell",
                                            drag: true,
                                            scroll: true,
                                            columns: subCols,
                                            select_change: tab.select_change,
                                            cell_editstop: tab.cell_editstop,
                                            after_addrow: tab.after_addrow,
                                            after_delrow: tab.after_delrow,
                                            oncheck: tab.oncheck,
                                            on: {
                                                "data->onStoreUpdated": function () {
                                                    this.data.each(function (obj, i) {
                                                        obj.stt = i + 1;
                                                    });
                                                },
                                                onAfterLoad: function () {
                                                    var table = this;
                                                    var data = table.serialize();
                                                    data.forEach(function (entry) {
                                                        if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                            if (entry["stckhau"] != 0 || entry["tlckhau"] != 0) {
                                                                var ck = $$("check_chietkhau");
                                                                if (ck != undefined) {
                                                                    ck.setValue(1);
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    });

                                                    // Xử lý ẩn hiện trường HHDT
                                                    if (data) {
                                                        var isHHDT = data.find(function (e) {
                                                            if (e.hasOwnProperty('kmai')) {
                                                                return e['kmai'] == '5';
                                                            }
                                                            return false;
                                                        })

                                                        if (isHHDT) {
                                                            $$("hoadon68_chitiet").showColumn("lhhdthu");

                                                            // có hh oto, moto
                                                            var isMoto = data.find(function (e) {
                                                                if (e.hasOwnProperty('lhhdthu')) {
                                                                    return e['lhhdthu'] == '1';
                                                                }
                                                                return false;
                                                            })

                                                            if (isMoto) {
                                                                $$("hoadon68_chitiet").showColumn("skhung");
                                                                $$("hoadon68_chitiet").showColumn("smay");
                                                            }

                                                            // có hh dvvc
                                                            var isDvvc = data.find(function (e) {
                                                                if (e.hasOwnProperty('lhhdthu')) {
                                                                    return e['lhhdthu'] == '2';
                                                                }
                                                                return false;
                                                            })

                                                            if (isDvvc) {
                                                                $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                            }

                                                            // có hh tmdt
                                                            var isTmdt = data.find(function (e) {
                                                                if (e.hasOwnProperty('lhhdthu')) {
                                                                    return e['lhhdthu'] == '3';
                                                                }
                                                                return false;
                                                            })

                                                            if (isTmdt) {
                                                                $$("hoadon68_chitiet").showColumn("tnghang");
                                                                $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                $$("hoadon68_chitiet").showColumn("mddnghang");
                                                            }

                                                            $$("hoadon68_chitiet").refresh();
                                                        }
                                                    }

                                                    commonHD.CanhBaoTinhTien();
                                                },
                                                onCheck: function (row, column, state) {
                                                    var table = this;
                                                    if (column == "khuyen_mai") {
                                                        if (state == true) {
                                                        }
                                                    }
                                                },
                                                onAfterAdd: function (id, index) {
                                                    var item_inf = webix.$$("invoiceForms").getValues();
                                                    var tudongtinhtien = item_inf["tudongtinhtien"];
                                                    if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                        if (this.config.after_addrow != null) {
                                                            var fn = Function("id", "index", "tableId", this.config.after_addrow);
                                                            fn(id, index, this.config.id);
                                                        }
                                                    } else {

                                                        var table_chitiet = webix.$$("hoadon68_chitiet");
                                                        var ishhdt = false;
                                                        var islhhdt_1 = false;
                                                        var islhhdt_2 = false;
                                                        var islhhdt_3 = false;
                                                        var data = $$("hoadon68_chitiet").serialize();
                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["kmai"] && data[i]["kmai"].toString() === "5") {
                                                                ishhdt = true;
                                                                break;
                                                            }
                                                        }

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "1") {
                                                                islhhdt_1 = true;
                                                                break;
                                                            }
                                                        }


                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "2") {
                                                                islhhdt_2 = true;
                                                                break;
                                                            }
                                                        }


                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "3") {
                                                                islhhdt_3 = true;
                                                                break;
                                                            }
                                                        }


                                                        var selectedItemDetail = table_chitiet.getSelectedItem();
                                                        
                                                          if(selectedItemDetail){
                                                            if(selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "3") {
                                                                selectedItemDetail["stckhau"] = 0;
                                                                selectedItemDetail["tlckhau"] = 0;
                                                                table_chitiet.updateItem(selectedItemDetail["id"], selectedItemDetail);
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() != "5"){
                                                            table_chitiet.refresh();
                                                            }else if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "5") {
                                                                $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }else{
                                                            $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }
    
    
                                                            if(ishhdt && islhhdt_1 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "1") {
                                                                $$("hoadon68_chitiet").showColumn("skhung");
                                                                $$("hoadon68_chitiet").showColumn("smay");
                                                                table_chitiet.refresh();
                                                            } else if(ishhdt && islhhdt_1){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_2 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "2") {
                                                                $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_2){
                                                                table_chitiet.refresh();
                                                            }else {
                                                            $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_3 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "3") {
                                                                $$("hoadon68_chitiet").showColumn("tnghang");
                                                                $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_3){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(!ishhdt) {
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
                                                        }else{
                                                               if(ishhdt ) {
                                                                    $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }else{
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }
        
        
                                                                if(ishhdt && islhhdt_1) {
                                                                    $$("hoadon68_chitiet").showColumn("skhung");
                                                                    $$("hoadon68_chitiet").showColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_2) {
                                                                    $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_3) {
                                                                    $$("hoadon68_chitiet").showColumn("tnghang");
                                                                    $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(!ishhdt) {
                                                                    $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
                                                        }
                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                                onAfterDelete: function (id) {
                                                    var item_inf = webix.$$("invoiceForms").getValues();
                                                    var tudongtinhtien = item_inf["tudongtinhtien"];
                                                    if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                        if (this.config.after_delrow != null) {
                                                            var fn = Function("id", "tableId", this.config.after_delrow);
                                                            fn(id, this.config.id);
                                                        }
                                                    } else {

                                                        var table_chitiet = webix.$$("hoadon68_chitiet");
                                                        var ishhdt = false;
                                                        var islhhdt_1 = false;
                                                        var islhhdt_2 = false;
                                                        var islhhdt_3 = false;
                                                        var data = $$("hoadon68_chitiet").serialize();
                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["kmai"] && data[i]["kmai"].toString() === "5") {
                                                                ishhdt = true;
                                                                break;
                                                            }
                                                        }

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "1") {
                                                                islhhdt_1 = true;
                                                                break;
                                                            }
                                                        }


                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "2") {
                                                                islhhdt_2 = true;
                                                                break;
                                                            }
                                                        }


                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "3") {
                                                                islhhdt_3 = true;
                                                                break;
                                                            }
                                                        }


                                                        var selectedItemDetail = table_chitiet.getSelectedItem();
                                                          if(selectedItemDetail){
                                                            if(selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "3") {
                                                                selectedItemDetail["stckhau"] = 0;
                                                                selectedItemDetail["tlckhau"] = 0;
                                                                table_chitiet.updateItem(selectedItemDetail["id"], selectedItemDetail);
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() != "5"){
                                                            table_chitiet.refresh();
                                                            }else if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "5") {
                                                                $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }else{
                                                            $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }
    
    
                                                            if(ishhdt && islhhdt_1 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "1") {
                                                                $$("hoadon68_chitiet").showColumn("skhung");
                                                                $$("hoadon68_chitiet").showColumn("smay");
                                                                table_chitiet.refresh();
                                                            } else if(ishhdt && islhhdt_1){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_2 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "2") {
                                                                $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_2){
                                                                table_chitiet.refresh();
                                                            }else {
                                                            $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_3 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "3") {
                                                                $$("hoadon68_chitiet").showColumn("tnghang");
                                                                $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_3){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(!ishhdt) {
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
                                                        }else{
                                                               if(ishhdt ) {
                                                                    $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }else{
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }
        
        
                                                                if(ishhdt && islhhdt_1) {
                                                                    $$("hoadon68_chitiet").showColumn("skhung");
                                                                    $$("hoadon68_chitiet").showColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_2) {
                                                                    $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_3) {
                                                                    $$("hoadon68_chitiet").showColumn("tnghang");
                                                                    $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(!ishhdt) {
                                                                    $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
                                                        }
                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                                onAfterEditStop: function (state, editor, ignore) {
                                                    if (state.value === state.old) return;
                                                    var item_inf = webix.$$("invoiceForms").getValues();
                                                    var tudongtinhtien = item_inf["tudongtinhtien"];
                                                    var selectedItem = $$("hoadon68_chitiet").getItem(editor.row);
                                                    if (!selectedItem.kmai) selectedItem.kmai = "1";
                                                    if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                        if (this.config.cell_editstop != null) {
                                                            var fn = Function("state", "editor", "ignore", "tableId", this.config.cell_editstop);
                                                            fn(state, editor, ignore, this.config.id);
                                                        }
                                                    } else {

                                                        var table_chitiet = webix.$$("hoadon68_chitiet");
                                                        var ishhdt = false;
                                                        var islhhdt_1 = false;
                                                        var islhhdt_2 = false;
                                                        var islhhdt_3 = false;
                                                        var data = $$("hoadon68_chitiet").serialize();
                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["kmai"] && data[i]["kmai"].toString() === "5") {
                                                                ishhdt = true;
                                                                break;
                                                            }
                                                        }

                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "1") {
                                                                islhhdt_1 = true;
                                                                break;
                                                            }
                                                        }


                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "2") {
                                                                islhhdt_2 = true;
                                                                break;
                                                            }
                                                        }


                                                        for (var i = 0; i < data.length; i++) {
                                                            if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "3") {
                                                                islhhdt_3 = true;
                                                                break;
                                                            }
                                                        }


                                                        var selectedItemDetail = table_chitiet.getSelectedItem();
                                                          if(selectedItemDetail){
                                                            if(selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "3") {
                                                                selectedItemDetail["stckhau"] = 0;
                                                                selectedItemDetail["tlckhau"] = 0;
                                                                table_chitiet.updateItem(selectedItemDetail["id"], selectedItemDetail);
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() != "5"){
                                                            table_chitiet.refresh();
                                                            }else if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "5") {
                                                                $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }else{
                                                            $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }
    
    
                                                            if(ishhdt && islhhdt_1 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "1") {
                                                                $$("hoadon68_chitiet").showColumn("skhung");
                                                                $$("hoadon68_chitiet").showColumn("smay");
                                                                table_chitiet.refresh();
                                                            } else if(ishhdt && islhhdt_1){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_2 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "2") {
                                                                $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_2){
                                                                table_chitiet.refresh();
                                                            }else {
                                                            $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_3 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "3") {
                                                                $$("hoadon68_chitiet").showColumn("tnghang");
                                                                $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_3){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(!ishhdt) {
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
                                                        }else{
                                                               if(ishhdt ) {
                                                                    $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }else{
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }
        
        
                                                                if(ishhdt && islhhdt_1) {
                                                                    $$("hoadon68_chitiet").showColumn("skhung");
                                                                    $$("hoadon68_chitiet").showColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_2) {
                                                                    $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_3) {
                                                                    $$("hoadon68_chitiet").showColumn("tnghang");
                                                                    $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(!ishhdt) {
                                                                    $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
                                                        }
                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                            },
                                        },
                                    ],
                                },
                            };

                            findJson.findAndReplace(el, tab.foreign_key, item);
                            m++;
                            //cells.push(item);
                        }
                        if (tab.tab_type == "Detail" && tab.foreign_key === "phi_tab") {
                            var item = {
                                id: "phi_tab",
                                header: "Tiền phí/lệ phí",
                                select: "cell",
                                hidden: tab.hidden,
                                body: {
                                    rows: [
                                        {
                                            view: "toolbar",
                                            height: 40,
                                            cols: [
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                    id: "addrow2",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_phi");
                                                            var item = {
                                                                id: webix.uid(),
                                                                tienphi: 0,
                                                            };
                                                            table.add(item);
                                                            table.select(item.id);
                                                            table.edit({
                                                                row: item.id,
                                                                column: "tnphi",
                                                            });
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                    id: "removerow2",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_phi");
                                                            table.editStop();
                                                            var item = table.getSelectedItem();
                                                            if (!webix.isUndefined(item)) {
                                                                table.remove(item.id);
                                                                table.clearSelection();
                                                                return;
                                                            }

                                                            var editor = table.getEditState();

                                                            if (!webix.isUndefined(editor)) {
                                                                table.remove(editor.row);
                                                                table.clearSelection();
                                                                return;
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                    view: "button",
                                                    id: "copyrow2",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_phi");

                                                            table.editStop();

                                                            var item = table.getSelectedItem();
                                                            if (item == null || item == undefined) {
                                                                webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                return;
                                                            }
                                                            var copy = webix.copy(item);
                                                            copy.id = webix.uid();

                                                            table.add(copy);
                                                            table.unselect(item.id);
                                                            table.select(copy.id, "tnphi", false);
                                                            table.edit({
                                                                row: copy.id,
                                                                column: "tnphi",
                                                            });
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            view: "datatable",
                                            resizeColumn: true,
                                            id: "hoadon68_phi",
                                            editable: true,
                                            select: "cell",
                                            drag: true,
                                            scroll: true,
                                            columns: subCols,
                                            select_change: tab.select_change,
                                            cell_editstop: tab.cell_editstop,
                                            after_addrow: tab.after_addrow,
                                            after_delrow: tab.after_delrow,
                                            oncheck: tab.oncheck,
                                            on: {
                                                onAfterAdd: function (id, index) {
                                                    var item_inf = webix.$$("invoiceForms").getValues();
                                                    var tudongtinhtien = item_inf["tudongtinhtien"];
                                                    if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                        if (this.config.after_addrow != null) {
                                                            var fn = Function("id", "index", "tableId", this.config.after_addrow);
                                                            fn(id, index, this.config.id);
                                                        }
                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                                onAfterDelete: function (id) {
                                                    var item_inf = webix.$$("invoiceForms").getValues();
                                                    var tudongtinhtien = item_inf["tudongtinhtien"];
                                                    if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                        if (this.config.after_delrow != null) {
                                                            var fn = Function("id", "tableId", this.config.after_delrow);
                                                            fn(id, this.config.id);
                                                        }
                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                                onAfterEditStop: function (state, editor, ignore) {
                                                    if (state.value === state.old) return;
                                                    var item_inf = webix.$$("invoiceForms").getValues();
                                                    var tudongtinhtien = item_inf["tudongtinhtien"];
                                                    if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                        if (this.config.cell_editstop != null) {
                                                            var fn = Function("state", "editor", "ignore", "tableId", this.config.cell_editstop);
                                                            fn(state, editor, ignore, this.config.id);
                                                        }
                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                            },
                                        },
                                    ],
                                },
                            };

                            findJson.findAndReplace(el, "phi_tab", item);
                            m++;
                        }
                    }
                }

                el.push({
                    // paddingY:10,
                    margin: 10,
                    cols: cols,
                });
                webix.ui(el, $$("invoiceForms"));
                //$$("tab_replace").define("tabbar",{width:150 * m});
                //console.log(jsonElement);
                var windowno = vc_window.code;
                if (windowno == "WIN00791" || windowno == "WIN00792") {
                    $$("btnHoadonCQT").hide();
                }

                var result = webix.ajax().sync().get(app.config.host + "/System/GetDataReferencesByRefId?refId=RF00505").response;
                var count = JSON.parse(result)[0].count;
                if (count > 0) {
                    $$("btnHoadonCQT").hide();
                }

                this.SetDefaultValue(windowconfig);
            }
        },
        SetDefaultValue: function (winconfig) {
            var form = webix.$$("invoiceForms");
            var item = form.getValues();
            var vc_window = winconfig["data"][0];

            var tabs = vc_window.Tabs;

            for (var i = 0; i < tabs.length; i++) {
                var tab = tabs[i];

                if (tab.tab_type == "Normal" || tab.tab_type == "Master") {
                    var fields = tab.Fields;

                    for (var j = 0; j < fields.length; j++) {
                        var field = fields[j];

                        if (field.column_name == tab.table_name + "_id") {
                            item[field.column_name] = null;
                        }

                        if (field.column_name == "branch_code") {
                            item[field.column_name] = user.getDvcsID();
                        }

                        if (field.default_value != null) {
                            var defaultValue = field.default_value.toString();

                            if (defaultValue.startsWith("@Default=")) {
                                item[field.column_name] = defaultValue.replace("@Default=", "");
                            }

                            if (defaultValue.startsWith("@JS=")) {
                                var fn = Function(defaultValue.replace("@JS=", ""));
                                item[field.column_name] = fn();
                            }

                            if (defaultValue.startsWith("@API=")) {
                                    var apiUrl = defaultValue.replace("@API=", "").replace(/\{(\w+)\}/g, function (m, key) {
                                        return encodeURIComponent(item[key] || "");
                                    });
                                    try {
                                        var apiRes = webix.ajax().sync().get(app.config.host + apiUrl).response;
                                        var apiData = JSON.parse(apiRes).data;

                                        if (apiData && apiData.length > 0) {
                                            var apiRow = apiData[0];
                                            if (field.field_expression) {
                                                var expressions = field.field_expression.split(";");
                                                for (var ei = 0; ei < expressions.length; ei++) {
                                                    var expr = expressions[ei].replace("{", "").replace("}", "");
                                                    var parts = expr.split(":");
                                                    // parts[0] = tên field API, parts[1] = tên field form
                                                    item[parts[1]] = apiRow[parts[0]];
                                                }
                                            } else {
                                                item[field.column_name] = apiRow[Object.keys(apiRow)[0]];
                                            }
                                        }
                                } catch (e) { }
                            }
                        }
                    }
                }
            }

            form.setValues(item);
        }
    };
});

define('views/forms/lichsuemail',["app", "locale"], function (app, _) {
    function initUI(inv_InvoiceAuth_id) {
        // var model = { inv_InvoiceAuth_id: inv_InvoiceAuth_id };
        // webix.ajax()
        //     .headers({ 'Content-type': 'application/json' })
        //     .post(app.config.host + "/Invoice/history_email", model, function (text) {
        //         var data = JSON.parse(text);
        //         if (!data.hasOwnProperty("error")) {
        //             $$('email-form').setValue(data);
        //         }
        //         else {
        //             webix.message(data.error, "error");
        //         }
        //     });
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "email-win",
            position: "center",
            head: "Lịch sử gửi Email",
            width: 950,
            height: 300,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "email-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "datatable",
                        header: "Lịch sử gửi Email",
                        id: "tbl_email",
                        editable: false,
                        resizeColumn: true,
                        select: true,
                        // fixedRowHeight: true,
                        // rowLineHeight: 25,
                        // rowHeight: 25,
                        //autoheight:true,
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var inv_invoiceauth_id = "";
                                var table = webix.$$("windowData");
                                if (table === undefined || table === null) {
                                    table = webix.$$("invoiceViews");
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.hdon_id;
                                } else {
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.inv_invoiceauth_id;
                                }
                                var url = app.config.host + "/Invoice/InvoiceHistorySendEmail?inv_invoiceauth_id=" + inv_invoiceauth_id;
                                webix.ajax(url, callback, view);
                            },
                        },
                        on: {
                            onresize: webix.once(function () {
                                this.adjustRowHeight("send_type", true);
                            }),
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                });
                            },
                            onItemDblClick: function (id, e, node) {
                                // var btnEdit = $$("btncskh");
                                // btnEdit.callEvent("onClick");
                                //webix.message("Click MobiFone Invoice", "error");
                            },
                            onBeforeRender: function () {
                                //$$("tbl_email").refresh();
                                //$$("tbl_email").define("pager", kk);
                            },
                        },
                        columns: [
                            { id: "stt", header: "STT", width: 40 },
                            { id: "invoice_number", name: "invoice_number", header: "Số hóa đơn", width: 100, editor: "text" },
                            { id: "template_code", name: "template_code", header: "Mẫu hóa đơn", width: 120, editor: "text" },
                            { id: "invoice_series", name: "invoice_series", header: "Ký hiệu", width: 90, editor: "text" },
                            { id: "user_send", name: "user_send", header: "Người gửi", width: 130, editor: "text" },
                            {
                                id: "send_date",
                                name: "send_date",
                                header: "Ngày gửi",
                                width: 110,
                                editor: "date",
                                format: function (text) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                },
                                sort: "date",
                            },
                            { id: "send_to", name: "send_to", header: "Gửi đến", width: 150, editor: "text" },
                            { id: "send_type", name: "send_type", header: "Loại gửi", width: 150, editor: "text" },
                        ],
                        pager: "pagerB",
                        ready: function () {
                            //this.open(this.getFirstId());
                            this.sort({ by: "send_date", dir: "desc" });
                        },
                    },
                    {
                        id: "pagerB",
                        view: "pager",
                        size: 5,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                align: "center",
                                width: 120,
                                type: "danger",
                                click: function () {
                                    webix.$$("email-win").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        initUI: initUI,
    };
});

define('views/Util',["app", "locale", "models/user"], function (app, _, user) {
    return {
        $ui: {
        },
        StringToFunc:function (s){
            var funcReg = /^(function)([ ]*)(\()(\w*)(\))([ ]*)(\{)([^]*)(})$/gm;
            var match = funcReg.exec(s);

            if(match) {
                return new Function(match[4].split(','), match[8]);
            }
            else return null;
        },
        StringToFunc2:function (s){
            return new Function("return " + "s")()
        }
    };
});

define('views/forms/bienbanForm',["app", "locale", "models/user", "models/findjson", "views/commonHD"], function (app, _, user, findJson, commonHD) {
    var editmode = 0;

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Lập biên bản Hủy/Điều chỉnh/Thay thế của hóa đơn",
            width: 600,
            height: 350,
            id: "bienBan",
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 60 },
                id: "bienBanForm",
                view: "form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        id: "svban",
                        view: "text",
                        name: "svban",
                        label: "Số văn bản",
                        labelWidth: 100,
                        required: true,
                        invalidMessage: "Số văn bản không được bỏ trống"
                    },
                    {
                        id: "nvban",
                        view: "datepicker",
                        name: "nvban",
                        label: "Ngày văn bản",
                        labelWidth: 100,
                        required: true,
                        invalidMessage: "Ngày văn bản không được bỏ trống"
                    },
                    {
                        id: "lydo",
                        view: "text",
                        name: "lydo",
                        label: "Lý do",
                        labelWidth: 100
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
                                click: function () {
                                    var table = webix.$$("invoiceViews");
                                    var item = table.getSelectedItem();
                                    var values = $$("bienBanForm").getValues();

                                    if ($$("bienBanForm").validate() == false) {
                                        return;
                                    }

                                    var data_post = {
                                        editmode: editmode,
                                        data: {
                                            hdon_id: item.hdon_id,
                                            cctbao_id: item.cctbao_id,
                                            svban: values.svban,
                                            nvban: values.nvban,
                                            lydo: values.lydo
                                        }
                                    }

                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Invoice68/SaveBienBan", data_post, {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message(text + XmlHttpRequest, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var json = JSON.parse(text);
                                                if (json.hasOwnProperty("error")) {
                                                    webix.message(json.error, "error");
                                                } else {
                                                    webix.message(editmode == 2 ? "Sửa biên bản thành công !" : "Tạo biên bản thành công !", "success");
                                                    var win = $$("bienBanForm").getTopParentView();
                                                    win.close();
                                                }
                                            },
                                        });
                                }
                            },
                            {
                                view: "button", id: "btnBienBanDelete", hotkey: "delete", label: "Xóa (Delete)", align: "center", type: "danger", width: 100,
                                click: function () {
                                    webix.confirm({
                                        text: "Bạn có muốn xóa bản ghi",
                                        ok: "Có",
                                        cancel: "Không",
                                        callback: function (result) {
                                            if (result) {
                                                var values = $$("bienBanForm").getValues();
                                                editmode = 3;

                                                var data_post = {
                                                    editmode: editmode,
                                                    data: {
                                                        hdon_id: values.hdon_id,
                                                        cctbao_id: values.cctbao_id
                                                    }
                                                }

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/SaveBienBan", data_post, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            if (json.hasOwnProperty("error")) {
                                                                webix.message(json.error, "error");
                                                            } else {
                                                                webix.message("Xóa biên bản thành công !", "success");
                                                                var win = $$("bienBanForm").getTopParentView();
                                                                win.close();
                                                            }
                                                        },
                                                    });
                                            }
                                        }
                                    });
                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", type: "danger", width: 120,
                                click: function () {
                                    var win = this.getTopParentView();
                                    win.close();
                                }
                            },
                            {}
                        ]
                    }

                ],
                rules: {
                    "svban": webix.rules.isNotEmpty,
                    "nvban": webix.rules.isNotEmpty
                }
            }
        },
        setValuesBienBan: function (data, winconfig) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            form.setValues(data);
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        setHideBtnDelete: function () {
            $$('btnBienBanDelete').hide();
        }

    };
});
define('views/forms/68_hoadon_history_lienquan',["app", "locale", "models/user", "views/forms/68_invoiceForms", "views/forms/68_bangmotaloiCQT"], function (app, _, user, invoiceForms, bangmotaloiCQT) {
    

    var editmode = 0;
    var hdon_id = "";

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Hóa đơn điều chỉnh, thay thế<div/>";
                        },
                    },
                ],
            },
            id: "responseMessageForms",
            resize: true,
            width: 1000,
            height: 500,
            move: true,
            on: {
                onBeforeShow: function () {},
            },
            body: {
                view: "form",
                id: "message",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        // id: "header",
                        template: "<center><b><span style='font-size:17px;'>Hóa đơn điều chỉnh, thay thế</b></center>",
                        borderless: true,
                        height: 40,
                    },
                    { height: 3 },
                    {
                        rows: [
                            {
                                view: "datatable",
                                id: "danhsach_history",
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                select: "cell",
                                scheme: {
                                    $init: function (obj) {},
                                },
                                onClick: {
                                    btnPrint: function (event, cell, target) {
                                        var win = webix.$$("danhsach_history");
                                        var record = win.getItem(cell.row);
                                        //webix.message("Chưa có mẫu in ...", "error");
                                        // var rpParameter = null;
                                        var box = webix.modalbox({
                                            title: "Đang in hóa đơn ....",
                                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                            width: 350,
                                            height: 200,
                                        });

                                        var newWin = window.open();
                                        var html =
                                            "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                        newWin.document.write(html);
                                        webix
                                            .ajax()
                                            .response("arraybuffer")
                                            .headers({ "Content-type": "application/json" })
                                            .get(app.config.host + "/Invoice68/inHoadon?id=" + record.hdon_id + "&type=PDF&inchuyendoi=false", {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.modalbox.hide(box);
                                                    webix.message(XmlHttpRequest.statusText, "error");
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var file = new Blob([data], { type: "application/pdf" });
                                                    var fileURL = URL.createObjectURL(file);
                                                    //window.open(fileURL, '_blank');
                                                    webix.modalbox.hide(box);
                                                    newWin.location = fileURL;
                                                },
                                            });
                                    },
                                    dowloadXml: function (event, cell, target) {
                                        var win = webix.$$("danhsach_history");
                                        var record = win.getItem(cell.row);
                                        //webix.message("Chưa có mẫu in ...", "error");
                                        // var rpParameter = null;
                                        if (record.tthai == "Chờ sinh số"|| record.tthai == "Chờ duyệt"|| record.tthai == "Chờ ký" || record.tthai == "Chờ gửi") {
                                            webix.message("Hóa đơn đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                                            return;
                                        }
                                        var table = webix.$$("responseMessageForms");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + record.hdon_id;
                                        webix
                                        .ajax()
                                        .response("arraybuffer")
                                        .get(url, function (text, data) {
                                            table.enable();
                                            table.hideProgress();

                                            var file = new Blob([data], {
                                                type: "application/xml"
                                            });
                                            webix.html.download(file, "XmlInvoice.xml");
                                            // var fileURL = URL.createObjectURL(file);
                                            // window.open(fileURL, "_blank");
                                        });
                                    },        
                                },
                                url:{
                                    $proxy: true,
                                    load: function (view, callback, params) {
                                        // var hdon_id = "87de11a4-0b4e-42d4-a86c-45ba10b80337";
                                        if(hdon_id != ""){
                                            var url = app.config.host + "/Invoice68/GetInviceLQ?id=" + hdon_id;
                                            webix.ajax(url, callback, view);
                                        }
                                    }
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                },
                                columns: [

                                    {
                                        id: "stt",
                                        header: ["<center>STT</center>"],
                                        sort: "int",
                                        width: 40,
                                        columnType: "nvarchar",
                                    },
                                    {
                                        id: "hdon_id",
                                        header: ["<center>Mã hóa đơn</center>", { content: "textFilter" }],
                                        width: 100,
                                        columnType: "nvarchar",
                                        hidden: true,
                                    },
                                    {
                                        id: "khieu",
                                        header: ["<center>Ký hiệu</center>", { content: "textFilter" }],
                                        width: 100,
                                        css: { "text-align": "center" },
                                        columnType: "nvarchar",
                                    },
                                    { id: "shdon", header: ["<center>Số hóa đơn</center>", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },
                                    { id: "tthai", header: ["<center>Trạng thái gửi</center>", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                                    { id: "ttthdon", header: ["<center>Trạng thái</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" },
                                    {
                                        id: "nlap",
                                        header: [
                                            "Ngày lập"
                                        ],
                                        width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                        columnType: "datetime",
                                    },
                                    {
                                        id: "nky",
                                        header: [
                                            "Ngày giờ ký"
                                        ],
                                        width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                        columnType: "datetime",
                                    },
                                    {
                                        id: "tgtttbso_last",
                                        header: ["<center>Thành tiền sau thuế</center>", { content: "textFilter" }],
                                        width: 150,
                                        css: { "text-align": "right" },
                                        columnType: "numeric",
                                    },
                                    {
                                        id: "btnPrint",
                                        header: ["", "Xem/In"],
                                        css: { "text-align": "center" },
                                        template: function (obj) {
                                            return "<span class='btnPrint' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                                        },
                                        width: 120,
                                    },
                                    {
                                        id: "dowloadXml",
                                        header: ["", "Tải XML"],
                                        css: { "text-align": "center" },
                                        width: 120,
                                        template: function (obj) {
                                            return "<span class='dowloadXml' style='color: #00b300'><i class='fas fa-download'></i></span> ";

                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    hdon_id = "";
                                    webix.$$("responseMessageForms").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (id) {
            hdon_id = id;
            var table = $$("danhsach_history");
            table.load(table.config.url);
        },
    };
});

define('views/windowhoadon78',[
    "app",
    "locale",
    "models/user",
    "views/forms/formhoadon78",
    "views/forms/68_huyhoadon",
    "views/forms/68_huyhoadon_1",
    "views/forms/68_hoadon_history",
    "views/forms/lichsuemail",
    "views/commonHD",
    "views/Util",
    "views/forms/bienbanForm",
    "views/forms/68_hoadon_history_lienquan",
    "views/DataStorage/DataHoaDon78"
], function (app, _, user, invoiceForms, huyhoadon, huyhoadon_1, hoadonHistory, his_email, commonHD, Util, bienbanForm, hoadonlq, dataFormHd78) {
    
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: 0,
        });
        return k(number);
    };
    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        on: {
            onItemClick: function (id, e, node) {
                var item = this.getItem(id);

                this.hide();

                var fn = Function("_", "user", item.on_click);
                fn(_, user);
            },
        },
    });

    var subBangKe = webix.ui({
        view: "submenu",
        width: 150,
        padding: 0,
        data: [
            {
                id: "addBangKeHoaDon",
                value: "Thêm bảng kê",
            },
            {
                id: "EditBangKeHoaDon",
                value: "Sửa bảng kê",
            },
            {
                id: "InBangKeHoaDon",
                value: "In bảng kê",
            },
            {
                id: "ImportBangKeHoaDon",
                value: "Nhận Excel chi tiết",
            }
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);

                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();

                if (record.id == "addBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký") {
                        webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                        return;
                    }

                    if (item.checksobangke != null) {
                        webix.message("Hoá đơn đã có bảng kê không thể thêm !", "error");
                        return;
                    }

                    var detailForm = table.$scope.ui(invoiceForms.$ui);
                    item.shdon = null;

                    item.nlap = new Date(item.nlap);

                    // ẩn tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = true;
                    }

                    invoiceForms.setEditMode(4); // editmode = 4(add bang ke chi tiet) // edit mode =5 (sửa bảng kê chi tiết)
                    invoiceForms.initUI(windowconfig);
                    //$$("phi_tab").hide();
                    $$("head-formInvoice").define("template", "Bảng kê chi tiết hoá đơn");
                    $$("head-formInvoice").refresh();

                    webix.$$("infohdon").disable();
                    webix.$$("infokhang").disable();

                    webix.$$("shdon").config.label = "Số bảng kê";
                    //webix.$$("infohdon").disable();
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Hóa đơn điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValuesBangKe(item, null);
                    detailForm.show();
                    webix.$$("btnBangKeSave").show();
                    webix.$$("btnHoadonSave").destructor();
                    webix.$$("btnHoadonCQT").destructor();
                }

                if (record.id == "EditBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký") {
                        webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                        return;
                    }

                    if (item.checksobangke == null) {
                        webix.message("Hoá đơn chưa có bảng kê!", "error");
                        return;
                    }

                    // ẩn tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = true;
                    }

                    //set số bảng kê cho form sửa bảng kê
                    item.shdon = item.checksobangke;

                    item.nlap = new Date(item.nlap);
                    var detailForm = table.$scope.ui(invoiceForms.$ui);
                    invoiceForms.setEditMode(5); // editmode = 4(add bang ke chi tiet) // edit mode =5 (sửa bảng kê chi tiết)
                    invoiceForms.initUI(windowconfig);
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Hóa đơn điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    $$("head-formInvoice").define("template", "Bảng kê chi tiết hoá đơn");
                    $$("head-formInvoice").refresh();
                    //set lại title số bảng kê
                    webix.$$("shdon").config.label = "Số bảng kê";

                    webix.$$("infohdon").disable();
                    webix.$$("infokhang").disable();

                    invoiceForms.setValuesBangKe(item, null);
                    detailForm.show();
                    webix.$$("btnBangKeSave").show();
                    webix.$$("btnBangKeDelete").show();
                    webix.$$("btnHoadonSave").destructor();
                    webix.$$("btnHoadonCQT").destructor();
                }

                if (record.id == "InBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.checksobangke == null) {
                        webix.message("Hoá đơn chưa có bảng kê!", "error");
                        return;
                    }

                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false&checkBangKe=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                }

                if (record.id == "ImportBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký" && item.tthai != "Chờ duyệt" && item.tthai != "Chờ sinh số") {
                        webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                        return;
                    }

                    if (item.checksobangke == null) {
                        webix.message("Hoá đơn chưa có bảng kê!", "error");
                        return;
                    }

                    var windowno = app.path[1].params[0];
                    var excel_id_param = "";

                    if (windowno != undefined && windowno == "WIN00781") {
                        excel_id_param = "EX00018";
                    }
                    else if (windowno != undefined && windowno == "WIN00782") {
                        excel_id_param = "EX00019";
                    }
                    else {
                        webix.message("Chức năng nhận Excel chi tiết chưa có mẫu excel phù hợp!", "error");
                        return;
                    }

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", { excel_id: excel_id_param, filename: "MobiFone Invoice_nhan chi tiet mot bang ke.xlsx", hdon_id: item.hdon_id });
                        webix.$$("uploader").hide();
                    });
                }
            },
        },
    });

    var subBienBan = webix.ui({
        view: "submenu",
        width: 150,
        padding: 0,
        data: [
            {
                id: "AddBienBan",
                value: "Thêm biên bản",
            },
            {
                id: "EditBienBan",
                value: "Sửa biên bản",
            },
            {
                id: "InBienBan",
                value: "In biên bản",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();

                if (record.id == "AddBienBan") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthdon != 19 && item.tthdon != 21 && item.tthdon != 23 && item.tthdon != 5 && item.tthdon != 2 && item.tthdon != 3) {
                        webix.message("Vui lòng chọn hóa đơn ở trạng thái điều chỉnh, thay thế, hoặc hủy", "error");
                        return;
                    }

                    // if (item.tthai != "Chờ ký") {
                    //     webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                    //     return;
                    // }        

                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/CheckBienBan?id=" + item.id, {
                            error: function (text) {
                                webix.message(text, "error");
                                return;
                            },
                            success: function (text) {
                                var hasBienBan = JSON.parse(text);
                                if (hasBienBan) {
                                    webix.message("Hoá đơn đã có biên bản không thể thêm mới!", "error");
                                    return;
                                }

                                var component = table.$scope.ui(bienbanForm.$ui);
                                bienbanForm.setEditMode(1);
                                bienbanForm.setHideBtnDelete();
                                component.show();
                            },
                        });
                }

                if (record.id == "EditBienBan") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthdon != 19 && item.tthdon != 21 && item.tthdon != 23 && item.tthdon != 5 && item.tthdon != 2 && item.tthdon != 3) {
                        webix.message("Vui lòng chọn hóa đơn ở trạng thái điều chỉnh, thay thế, hoặc hủy", "error");
                        return;
                    }
                    var url = app.config.host + "/Invoice68/GetDataInvoice_BienBan?id=" + item.id;
                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .get(url, function (text) {
                            var data = (JSON.parse(text))[0];

                            if (!data) {
                                webix.message("Hoá đơn không có biên bản không thể sửa!", "error");
                                return;
                            }

                            data.nvban = removeTimeZoneT(data.nvban);

                            var component = table.$scope.ui(bienbanForm.$ui);
                            bienbanForm.setValuesBienBan(data, null);
                            bienbanForm.setEditMode(2);

                            component.show();

                        });
                }

                if (record.id == "InBienBan") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthdon != 19 && item.tthdon != 21 && item.tthdon != 23 && item.tthdon != 5 && item.tthdon != 2 && item.tthdon != 3) {
                        webix.message("Vui lòng chọn hóa đơn ở trạng thái điều chỉnh, thay thế, hoặc hủy", "error");
                        return;
                    }

                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/CheckBienBan?id=" + item.id, {
                            error: function (text) {
                                webix.message(text, "error");
                                return;
                            },
                            success: function (text) {
                                var hasBienBan = JSON.parse(text);
                                if (!hasBienBan) {
                                    webix.message("Hoá đơn chưa có biên bản không thể in!", "error");
                                    return;
                                }

                                var box = webix.modalbox({
                                    title: "Đang in biên bản ....",
                                    text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                    width: 350,
                                    height: 200,
                                });

                                var newWin = window.open();
                                var html =
                                    "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                                    '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                                    '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                                    '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                newWin.document.write(html);

                                webix
                                    .ajax()
                                    .response("arraybuffer")
                                    .headers({ "Content-type": "application/json" })
                                    .get(app.config.host + "/Invoice68/inBienBan?id=" + item.id + "&type=PDF&inchuyendoi=false&checkBienBan=true", {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.modalbox.hide(box);
                                            webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var file = new Blob([data], { type: "application/pdf" });
                                            var fileURL = URL.createObjectURL(file);
                                            //window.open(fileURL, '_blank');
                                            webix.modalbox.hide(box);
                                            newWin.location = fileURL;
                                        },
                                    });
                            },
                        });
                }
            },
        },
    });

    //webix.$$("title").parse({ title: "Lập hóa đơn -> Hóa đơn giá trị gia tăng", details: "Lập hóa đơn -> Hóa đơn giá trị gia tăng" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu78",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            "Thay thế",
            { $template: "Separator" },
            "Điều chỉnh tăng",
            { $template: "Separator" },
            "Điều chỉnh giảm",
            { $template: "Separator" },
            "Điều chỉnh thông tin",
            { $template: "Separator" },
            // "Hủy",
            // { $template: "Separator" },
            "Lịch sử gửi Email",
        ],
        on: {
            onItemClick: function (id) {
                var self = this;
                setTimeout(function () {
                    var kyHieuHoaDon = {
                        cctbao_id: $$("kyhieu_id").getValue(),
                        khieu: $$("kyhieu_id").data.text,
                    };

                    if (self.getItem(id).value == "Thay thế") {
                        commonHD.ExcuteReplaceInvoice(kyHieuHoaDon);
                    }
                    if (self.getItem(id).value == "Điều chỉnh tăng") {
                        commonHD.ExcuteIncreaseChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Điều chỉnh giảm") {
                        commonHD.ExcuteReduceChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Điều chỉnh thông tin") {
                        commonHD.ExcuteInfoChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Hủy") {
                        commonHD.ExcuteCancellingInvoice();
                    }

                    if (self.getItem(id).value == "Lịch sử gửi Email") {
                        var table = webix.$$("invoiceViews");
                        var selectedItem = table.getSelectedItem();
                        if (selectedItem == null) {
                            webix.message("Bạn chưa chọn hóa đơn", "error");
                            return;
                        }
                        var detailForm = webix.$$("invoiceViews").$scope.ui(his_email.$ui);
                        his_email.initUI(selectedItem.id);
                        detailForm.show();
                    }
                }, 100);
            },
        },
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Thêm (F4)") + "</span>",
            id: "btnPlus",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    var cctbao_id = $$("kyhieu_id").getValue();
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.initUINew(cctbao_id);
                    invoiceForms.setEditMode(1);
                    invoiceForms.setNewInvoice();
                    detailForm.show();
                    if (vc_window.after_new != null) {
                        var fn = Function("app", vc_window.after_new);
                        fn(app);
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    //var detailForm = this.$scope.ui(webix.$$("main"));
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký" && item.tthai != "Chờ duyệt" && item.tthai != "Chờ sinh số") {
                        webix.message("Hóa đơn đã ký hoặc đã gửi lên cơ quan thuế, không thể sửa !", "error");
                        return;
                    }
                    // main.setEditMode(0);
                    // main.initUI(windowconfig);

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    item.nlap = new Date(item.nlap);

                    invoiceForms.initUI(windowconfig);
                    invoiceForms.setEditMode(2);
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Hóa đơn điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValues(item, null);

                    detailForm.show();
                    if (vc_window.after_edit != null) {
                        var fn = Function("app", vc_window.after_edit);
                        fn(app);
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Xóa (F8)") + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var lstDataChoose = commonHD.GetHoaDonChon();
                    var lstDataChooseSort = lstDataChoose.sort(function (a, b) {
                        return Number(a.shdon) - Number(b.shdon);
                    });
                    if (lstDataChooseSort.length === 0) return;
                    var strHoaDonSelect = " ";
                    for (var i = 0; i < lstDataChooseSort.length; i++) {
                        if (
                            commonHD.CheckKhacNull(lstDataChooseSort[i].tthai) &&
                            lstDataChooseSort[i].tthai != "Chờ ký" &&
                            lstDataChooseSort[i].tthai != "Chờ sinh số" &&
                            lstDataChooseSort[i].tthai != "Chờ duyệt"
                        ) {
                            webix.message("Không thể xóa hóa đơn đã ký,đã gửi !", "error");
                            return;
                        }
                        if (i < lstDataChooseSort.length - 1) {
                            if (
                                commonHD.CheckKhacNull(lstDataChooseSort[i].shdon) &&
                                commonHD.CheckKhacNull(lstDataChooseSort[i + 1].shdon) &&
                                Number(lstDataChooseSort[i + 1].shdon) - Number(lstDataChooseSort[i].shdon) >= 2
                            ) {
                                webix.message("Các hóa đơn xóa phải có số hóa đơn liên tiếp nhau", "error");
                                return;
                            } else {
                                strHoaDonSelect += lstDataChooseSort[i].shdon + ",";
                            }
                        } else {
                            strHoaDonSelect += lstDataChooseSort[i].shdon;
                        }
                    }
                    var url = app.config.host + "/Invoice68/hoadonXoaNhieu";
                    var data_post = { data: lstDataChooseSort };
                    webix.confirm({
                        title: "XÓA HÓA ĐƠN",
                        text: "Bạn có muốn xóa hóa đơn số: <span style='color: red'>" + strHoaDonSelect + "</span>",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(url, data_post, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            // var json = JSON.parse(text);
                                            // webix.message(json.ExceptionMessage, "error");
                                            webix.message(text + XmlHttpRequest, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var result = JSON.parse(text);

                                            if (result.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: result.error });
                                                table.enable();
                                                table.hideProgress();
                                                return;
                                            } else {
                                                table.enable();
                                                table.clearAll();
                                                table.load(table.config.url);
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + "</span>",
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "far fa-files-o",
            // label: _("COPY"),
            // width: 85,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }
                    // var vc_window = windowconfig["data"][0];
                    // windowform.$ui.id = vc_window.code;

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    item.shdon = null;
                    invoiceForms.setEditMode(1);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.copyValues(item);
                    detailForm.show();
                    if (vc_window.after_new != null) {
                        var fn = Function(vc_window.after_new);
                        fn();
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Bảng kê") + "</span>",
            id: "btnBangKeOption",
            click: function () {
                subBangKe.show(webix.$$("btnBangKeOption").$view);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("In chuyển đổi") + "</span>",
            id: "btnPrintConvert",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {},
        {},
        {},
        {},
        {},
    ];
    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                scrollX: true,
                //autowidth: true,
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                    ShowHistory2: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonlq.$ui);
                        var hdon_id = cell.row;
                        hoadonlq.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        var table = webix.$$("invoiceViews");
                        var item = table.getSelectedItem();
                        item.chon = !item.chon;
                        table.updateItem(id.row, item);
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                        this.hideOverlay();
                        $$("cmenu78").refresh();
                        $$("cmenu78").sizeToContent();
                        $$("cmenu78").attachTo($$("invoiceViews"));
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;
                        var donvitien = view["dvtte"];
                        var urldecimal = app.config.host + "/Invoice68/GetDecimalPlace?ma_nt=" + donvitien;
                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .sync()
                                .get(url, function (text) {
                                    var arr = JSON.parse(text);
                                    var arrayString_chitiet = ["sluong", "dgia", "thtien", "stckhau", "tthue", "tgtien", "tienphi"];

                                    for (var i = 0; i < arrayString_chitiet.length; i++) {
                                        var field_name = "";
                                        switch (arrayString_chitiet[i]) {
                                            case "sluong":
                                                field_name = "quantity_decimal";
                                                break;
                                            case "dgia":
                                                field_name = "price_decimal";
                                                break;
                                            case "thtien":
                                                field_name = "amount_without_vat_decimal";
                                                break;
                                            case "stckhau":
                                                field_name = "price_discount";
                                                break;
                                            case "tthue":
                                                field_name = "tax_price";
                                                break;
                                            case "tgtien":
                                                field_name = "total_amount_decimal";
                                                break;
                                            case "tienphi":
                                                field_name = "fee_price";
                                                break;
                                        }

                                        var decimal_place = Array(Number(arr[0][field_name]) + 1).join("9");
                                        var decimal_format = Number(arr[0][field_name]);
                                        var format_numeric = {
                                            //maximumValue: Number("999999999999." + decimal_place),
                                            //minValue: Number("-999999999999." + decimal_place),
                                            decimalPlaces: Number(decimal_format),
                                        };
                                        var formatSoDefault = {
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: decimal_format,
                                        };
                                        var formatSo = webix.Number.numToStr(formatSoDefault);

                                        var format_config = tableDetail.getColumnConfig(arrayString_chitiet[i]);

                                        format_config.format = formatSo;
                                        format_config.numericConfig = format_numeric;
                                    }
                                });
                            tableDetail.load(url);
                        }
                    },
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    css: "subInvoice",
                    scrollX: true,
                    // tabbar: {
                    //     width: 200
                    // },
                    multiview: {
                        fitBiggest: true,
                    },
                    cells: [
                        {
                            header: "Chi tiết hóa đơn",
                            select: "cell",
                            body: {
                                view: "datatable",
                                resizeColumn: true,
                                margin: 10,
                                id: "hoadon68_chitiet_view",
                                height: 200,
                                columns: [],
                                on: {
                                    onBeforeLoad: function () {
                                        this.showOverlay(_("LOADING") + "...");
                                    },
                                    onAfterLoad: function () {
                                        this.hideOverlay();
                                    },
                                },
                            },
                        },
                    ],
                },
                columns: col,
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv * 1 != $$("pagerA").config.size) {
                                    webix.message("change page size to " + newv);
                                    $$("pagerA").config.size = newv * 1;
                                    var table = $$("invoiceViews");
                                    table.define("datafetch", newv);
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var mini_dashboard = {
        type: "clean",
        borderless: true,
        cols: [
            {
                id: "khongMa",
                name: "khongMa",
                view: "label",
            },
            {
                id: "khongMaError",
                name: "khongMaError",
                css: "",
                view: "label",
            },
            {
                id: "doanhthunocode",
                name: "doanhthunocode",
                view: "label",
            },
        ],
    };

    var layout = {
        id: "main",
        css: "frmView",
        rows: [
            {
                rows: [mini_dashboard],
            },
            {
                id: "tlbMain",
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    var col = [];
    var sub_col = [];
    var windowconfig = null;
    var kihieuRefId = null;

    var initComponents = function (_windowconfig) {
        //console.log(_windowconfig);
        var k = Object.keys(_windowconfig["data"][0]["Tabs"]).length;
        //console.log(k);
        var vc_window = _windowconfig["data"][0];
        webix.$$("title").parse({
            title: vc_window["name"],
            details: "Lập hóa đơn ->" + vc_window["name"],
            width: 1000,
        });
        var tabs = vc_window.Tabs;

        var windowno = vc_window.window_id;
        kihieuRefId = "RF00054";
        col = [];
        sub_col = [];
        col.push({
            id: "chon",
            header: [{ text: "", content: "masterCheckbox" }],
            width: 30,
            checkValue: true,
            uncheckValue: false,
            template: "{common.checkbox()}",
        });
        col.push({
            id: "subRowMain",
            header: "&nbsp;",
            template: "{common.subrow()}",
            width: 40,
            // height: 25
        });
        for (var i = 0; i < tabs.length; i++) {
            var tab = tabs[i];
            if (tab.tab_type === "Master") {
                var masterTab = tabs[i];
                for (var j = 0; j < tabs[i].Fields.length; j++) {
                    var field = masterTab.Fields[j];

                    if (field.hide_in_grid == true) {
                        continue;
                    }
                    var item = {
                        id: field.column_name,
                        header: _(field.column_name),
                        columnType: field.column_type,
                        columnAlias: field.column_alias,
                        template: field.template,
                        columnFormat: field.format,
                        //adjust: true,
                    };
                    if (item.template !== undefined && item.template !== null && item.template.includes("function")) item.template = Util.StringToFunc(item.template);
                    //if(item.format!== undefined && item.format!== null && item.format.includes("function")) item.template = Util.StringToFunc(item.format);
                    if (field.caption != null) {
                        item.header = _(field.caption);
                    }

                    if (field.column_type == "numeric") {
                        item.css = { "text-align": "right" };
                        item.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: field.data_decimal,
                        });
                    }

                    if (field.type_filter != null) {
                        if (field.type_filter != "") {
                            item.header = [_(item.header), { content: field.type_filter }];
                        }
                    }
                    if (field.type_filter == "serverMultiSelectFilter") {
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.value_filter;
                    }
                    if (field.type_filter == "serverSelectFilter") {
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.value_filter;
                    }
                    if (field.type_editor == "combo") {
                        item.editor = field.type_editor;
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                    }

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr(this.columnFormat);
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.type_editor == "checkbox") {
                        if (field.column_type == "boolean") {
                            item.checkValue = true;
                            item.uncheckValue = false;
                        }

                        item.template = function (obj, common, value) {
                            if (value == true || value == 1) return "<div class='webix_icon fa-check-square-o'></div>";
                            else return "<div class='webix_icon fa-square-o'></div>";
                        };
                    }

                    if (field.column_width == null) {
                        //item.fillspace = true;
                    } else {
                        item.width = field.column_width;
                    }

                    col.push(item);
                }
            }
            if (tab.tab_type == "Detail") {
                for (var j = 0; j < tab.Fields.length; j++) {
                    var field = tab.Fields[j];

                    if (field.hide_in_grid == true) {
                        continue;
                    }

                    var subCol = {
                        id: field.column_name,
                        header: field.caption == null ? _(field.column_name) : _(field.caption),
                        hidden: field.hide_in_grid,
                    };

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        subCol.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.column_type == "numeric") {
                        subCol.css = { "text-align": "right" };
                    }
                    if (field.column_width == null) {
                        subCol.fillspace = true;
                    } else {
                        subCol.width = field.column_width;
                    }

                    sub_col.push(subCol);
                }
            }
        }
        var table = webix.$$("invoiceViews");
        table.clearAll();
        var subview = {
            borderless: true,
            view: "tabview",
            height: 255,
            css: "subInvoice",
            scrollX: true,
            // tabbar: {
            //     width: 200
            // },
            multiview: {
                fitBiggest: true,
            },
            cells: [
                {
                    header: "Chi tiết hóa đơn",
                    select: "cell",
                    body: {
                        view: "datatable",
                        resizeColumn: true,
                        margin: 10,
                        id: "hoadon68_chitiet_view",
                        height: 200,
                        columns: sub_col,
                        on: {
                            onBeforeLoad: function () {
                                this.showOverlay(_("LOADING") + "...");
                            },
                            onAfterLoad: function () {
                                this.hideOverlay();
                            },
                        },
                    },
                },
            ],
        };
        /*var subview = {
            borderless: true,
            view: "tabview",
            height: 200,
            scrollX: true,
            cells: sub_col,
            multiview: {
                fitBiggest: true,
            },
        };*/
        table.define("subview", subview);
        $$("head-title").show();
        $$("head-title").removeView("paramKH");
        $$("head-title").addView(
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [],
            },
            1
        );
        if (vc_window.WinParams != undefined && vc_window.WinParams != null) {
            for (var i = 0; i < vc_window.WinParams.length; i++) {
                var item = vc_window.WinParams[i];
                var comp = {
                    id: item.value_field,
                    view: item.type_editor,
                    width: item.width,
                    label: _(item.caption),
                    value_field: item.value_field,
                    isDefault: item.has_default,
                    on: {},
                };

                if (comp.view == "combo") {
                    comp.options = {
                        body: {
                            comboId: comp.id,
                            isDefault: item.has_default,
                            url: app.config.host + "/System/GetDataByReferencesId?id=" + item.wb_references_id,
                            ready: function () {
                                if (this.config.isDefault == "C") {
                                    var count = this.count();
                                    if (count > 0) {
                                        var combo = webix.$$(this.config.comboId);
                                        // Xử lý xét giá trị ở đây
                                        combo.setValue(this.getFirstId());
                                    }
                                }
                            },
                        },
                    };

                    comp.on.onChange = function (newv, oldv) {
                        var table = $$("invoiceViews");
                        table.clearAll();
                        table.load(table.config.url);
                    };
                }
                
                if (comp.view == 'search') {
                    // Tạm thời fix code cho riêng trường th số hoá đơn này, cơ chế đặt view id này cần xem lại
                    if(item.value_field == 'shdon') {
                        comp.id = 'tlbparams_shdon';
                        comp.placeholder = "VD: 1-10,21-30,41-50";
                    }
                    var validateFunc = function() {
                        var value = $$(comp.id).getValue();
                        if(item.value_field == 'shdon' && value && value != "") {
                            var regex = /^\d+(-\d+)?(,\d+(-\d+)?)*$/;
                            return regex.test(value);
                        }
                        return true;
                    }
                    comp.on.onSearchIconClick = function () {
                        if(validateFunc()) {                           
                            var table = $$("invoiceViews");
                            table.clearAll();
                            table.load(table.config.url);
                        } else {
                            webix.message("Không đúng định dạng: x,x hoặc x-x,x-x (x là số)", "error");
                        }
                    };
                    comp.on.onEnter = function (code, e) {
                        if(validateFunc()) {                           
                            var table = $$("invoiceViews");
                            table.clearAll();
                            table.load(table.config.url);
                        } else {
                            webix.message("Không đúng định dạng: x,x hoặc x-x,x-x (x là số)", "error");
                        }
                    };
                }
                
                $$("paramKH").removeView(item.value_field);
                $$("paramKH").addView(comp);
            }

            // parentToolBar.addView(toolBarParams);
        }

        table.config.columns = col;
        table.refreshColumns();
        table.define("url", loadUrl);
        table.getParentView().getParentView().getParentView().enable();
        table.getParentView().getParentView().getParentView().hideProgress();
    };

    var loadUrl = {
        $proxy: true,
        load: function (view, callback, params) {
            var tlbparam_s = [];
            //get count list combo ký hiệu

            var url = app.config.host + "/Invoice68/GetDataInvoice";

            if (params == null) {
                commonHD.clear_filter(view);
                var table = $$("invoiceViews");
                table.config.params = null;
                url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            } else {
                var table = $$("invoiceViews");
                table.define("params", params);
                webix.storage.local.put("currentFilter", params.filter);
                url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                if (params.filter != null) {
                    var array = [];

                    for (var property in params.filter) {
                        var column = view.getColumnConfig(property);

                        var item = {
                            columnName: property,
                            columnType: column.columnType,
                            value: params.filter[property],
                            filterType: column.header[1].content,
                        };

                        /*if (item.filterType == "serverDateRangeFilter") {

                            var startDate = item.value.start;
                            if (startDate !== null && startDate !== undefined) {
                                var hoursDiff = startDate.getHours() - startDate.getTimezoneOffset() / 60;
                                var minutesDiff = (startDate.getHours() - startDate.getTimezoneOffset()) % 60;
                                startDate.setHours(hoursDiff);
                                startDate.setMinutes(minutesDiff);
                                item.value.start = startDate;
                            }

                            var endDate = item.value.end;
                            if (endDate !== null && endDate !== undefined) {
                                var hoursDiff = endDate.getHours() - endDate.getTimezoneOffset() / 60;
                                var minutesDiff = (endDate.getHours() - endDate.getTimezoneOffset()) % 60;
                                endDate.setHours(hoursDiff);
                                endDate.setMinutes(minutesDiff);
                                item.value.end = endDate;
                            }

                        }*/

                        if (params.filter[property] != null && params.filter[property] != "") {
                            array.push(item);
                        }
                    }

                    //console.log(JSON.stringify(array));
                    url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                }
                url = url + "&filter=null";
            }
            var tlbParams = $$("paramKH");
            if (tlbParams !== undefined) {
                var childViews = tlbParams.getChildViews();

                var parameters = [];

                for (var i = 0; i < childViews.length; i++) {
                    // Xử lý field name 
                    var child = childViews[i];
                    var valueField = child.config.value_field;
                    if(valueField == "kyhieu_id") {
                        valueField = "cctbao_id"

                        if(!child.getValue() || child.getValue() == "") {
                            return;
                        }
                    }

                    var item = {
                        columnName: valueField,
                        value: child.getValue(),
                    };
                    if (item.value !== "") {
                        parameters.push(item);
                    }
                    //parameters.push(item);
                }
                tlbparam_s = parameters;
                url = url + "&tlbparam=" + JSON.stringify(parameters);
            } else {
                url = url + "&tlbparam=null";
            }
            var urlMiniDashBoard = url.replace("GetDataInvoice", "GetDataInvoiceThongTin");

            var urlMiniDashBoard = url.replace("GetDataInvoice", "GetDataInvoiceThongTin");

            webix.ajax().get(urlMiniDashBoard, function (text) {
                var json = JSON.parse(text);
                $$("khongMa").setValue("<span style=' font-weight:bold'>Số hóa đơn đã gửi CQT: </span>" + json["khongma"]);
                $$("khongMaError").setValue("<span style=' font-weight:bold'>Số hóa đơn CQT thông báo lỗi: </span>" + json["khongmaerror"]);
                $$("doanhthunocode").setValue("<span style=' font-weight:bold'>Doanh thu xuất hóa đơn: </span>" + (fm(json["doanhthunocode"]) ? fm(json["doanhthunocode"]) : 0));
            });

            webix.ajax(url, callback, view);
        },
    };
    var buttons = [];
    var initUI = function () {
        var windowno = app.path[1].params[0];
        var url = app.config.host + "/System/ExecuteCommand";
        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00002",
                    parameter: {
                        window_id: windowno,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);

                    if (buttons.length > 0) {
                        for (var i = 0; i < buttons.length; i++) {
                            var item = buttons[i];
                            $$("tlbMain").removeView(item.id);
                        }
                    }

                    buttons = [];
                    var menus = [];

                    var stt = controls.filter(function (x) {
                        return x.id !== undefined;
                    }).length;

                    for (var i = 0; i < json.length; i++) {
                        var item = json[i];

                        if (item.is_group_function == "C") {
                            if (item.hidden != 1) {
                                menus.push({
                                    id: item.name,
                                    value: _(item.caption),
                                    on_click: item.on_click,
                                });
                            }
                        } else {
                            if (item.hidden != 1) {
                                var fn = new Function(item.on_click);

                                var button = {
                                    view: "button",
                                    type: "htmlbutton",
                                    width: item.width,
                                    label: '<i class="fa fa-' + item.icon + ' fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _(item.caption) + "</span>",
                                    id: item.name,
                                    // label: _(item.caption),
                                    // view: "button",
                                    // type: "icon",
                                    // css: "webix_secondary",
                                    // icon: "fas fa-" + item.icon,
                                    // width: item.width,
                                    click: fn,
                                };

                                buttons.push(button);
                                $$("tlbMain").addView(button, stt);

                                stt = stt + 1;
                            }
                        }
                    }
                    $$("tlbMain").removeView("btnChucNang");
                    if (menus.length > 0) {
                        subChucNang.clearAll();
                        subChucNang.parse(menus, "json");
                        var btnChucNang = {
                            view: "button",
                            type: "htmlbutton",
                            width: 120,
                            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("CHUC_NANG") + "</span>",
                            id: "btnChucNang",
                            // label: _("CHUC_NANG"),
                            // view: "button",
                            // type: "icon",
                            // css: "webix_secondary",
                            // icon: "fas fa-tasks",
                            // width: 100,
                            click: function () {
                                subChucNang.show(webix.$$("btnChucNang").$view);
                            },
                        };
                        $$("tlbMain").addView(btnChucNang, stt);
                    }
                }
            );
        col = [];
        sub_col = [];

        var url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;
        webix.$$("invoiceViews").getParentView().getParentView().getParentView().disable();
        webix.$$("invoiceViews").getParentView().getParentView().getParentView().showProgress();

        var app_cache = webix.storage.local.get("APP_CACHE");

        if (app_cache[windowno] != null) {
            windowconfig = app_cache[windowno];
            initComponents(windowconfig);
        } //không có cache
        else {
            webix.ajax(url, function (text, xml, xhr) {
                var rp = JSON.parse(text);
                windowconfig = rp;

                var app_cache = webix.storage.local.get("APP_CACHE");
                app_cache[windowno] = windowconfig;

                webix.storage.local.put("APP_CACHE", app_cache);
                initComponents(windowconfig);
            });
        }
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if(dataFormHd78) {
                    var khID = dataFormHd78.GetData("KHID");
                    if(khID) {
                        webix.$$("kyhieu_id").setValue(khID);
                        dataFormHd78.ClearData("KHID");
                    } 
                }
                table.clearAll();
                table.load(table.config.url);
                //if (editmode == 1) {
                //    table.clearAll();
                //    table.load(table.config.url);
                //}

                //if (editmode == 2) {
                //    table.clearAll();
                //    table.load(table.config.url);
                //}
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
        $onDestruct: function (ui, name, url, scope) {
            $$("tlbParams").Clear();
        },
    };
});

define('views/forms/68_chuyenDaiHoaDon32',["app", "locale", "models/user", "views/commonHD", "views/windowhoadon78"], function (app, _, user, commonHD, windowhoadon78) {
    var editmode = 0;
    var param;
    var branh_code;
    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    setTimeout(function () {
                        if ($$("chuyendai-form").validate()) {
                            var item = $$("chuyendai-form").getValues();

                            var kyHieuHoaDon = {
                                cctbao_id: $$("kyhieuhoadon_78_id").getValue(),
                                khieu: $$("kyhieuhoadon_78_id").data.text,
                                lhdclquan: $$("lhdclquan").getValue(),
                                khmshdclquan: $$("khmshdclquan").getValue(),
                                khhdclquan: $$("khhdclquan").getValue(),
                                shdclquan: $$("shdclquan").getValue(),
                                nlhdclquan: $$("nlhdclquan").getValue(),
                                case: $$("loaichuyendai_id").getValue(),
                                dvtte: "VND",
                                tgia: "1",
                                htttoan: "Tiền mặt/Chuyển khoản",
                            };
                            if (kyHieuHoaDon.case == 1) {
                                kyHieuHoaDon.tthdon = 2;
                                kyHieuHoaDon.tthdon = 2;
                            } else if (kyHieuHoaDon.case == 2) {
                                kyHieuHoaDon.tthdon = 19;
                                kyHieuHoaDon.tthdon = 19;
                            } else if (kyHieuHoaDon.case == 3) {
                                kyHieuHoaDon.tthdon = 21;
                                kyHieuHoaDon.tthdon = 21;
                                kyHieuHoaDon.note = "reduce_change_invoice";
                            } else if (kyHieuHoaDon.case == 4) {
                                kyHieuHoaDon.tthdon = 23;
                                kyHieuHoaDon.tthdon = 23;
                            }
                            switch (item.loaichuyendai_id) {
                                case "1":
                                    commonHD.ExcuteReplaceInvoice_32(kyHieuHoaDon);
                                    break;
                                case "2":
                                    commonHD.ExcuteIncreaseChangeInvoice_32(kyHieuHoaDon);
                                    break;
                                case "3":
                                    commonHD.ExcuteReduceChangeInvoice_32(kyHieuHoaDon);
                                    break;
                                case "4":
                                    commonHD.ExcuteInfoChangeInvoice_32(kyHieuHoaDon);
                                    break;
                                default:
                                    break;
                            }
                            $$("chuyendai-win").close();
                        }
                    }, 100);
                },
            },

            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                var table = $$("invoiceViews").getParentView();
                console.log(table);
                webix.$$("chuyendai-win").close();
            },
        },
        {},
    ];
    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "chuyendai-win",
        position: "center",
        head: "Chuyển dải hoá đơn hóa đơn",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 600,
            id: "chuyendai-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "kyhieuhoadon_78_id",
                    label: "Ký hiệu hóa đơn",
                    //labelPosition: "top",
                    id: "kyhieuhoadon_78_id",
                    required: true,
                    labelWidth: 200,
                    invalidMessage: "Ký hiệu hóa đơn không được bỏ trống",
                },
                {
                    view: "combo",
                    name: "loaichuyendai_id",
                    label: "Loại chuyển dải",
                    id: "loaichuyendai_id",
                    required: true,
                    labelWidth: 200,
                    value: "1",
                    options: [
                        { id: 1, value: "Thay thế" },
                        { id: 2, value: "Điều chỉnh tăng" },
                        { id: 3, value: "Điều chỉnh giảm" },
                        { id: 4, value: "Điều chỉnh thông tin" },
                    ],
                },
                {
                    view: "combo",
                    name: "loaihdlq",
                    label: "Loại HĐLQ",
                    id: "lhdclquan",
                    labelWidth: 200,
                    value: "3",
                    options: [
                        { id: 1, value: "Hóa đơn điện tử theo Nghị định 123/2020/NĐ-CP" },
                        { id: 2, value: "Hóa đơn điện tử có mã xác thực của cơ quan thuế theo Quyết định số 1209/QĐ-BTC" },
                        { id: 3, value: "Các loại hóa đơn theo Nghị định số 51/2010/NĐ-CP và Nghị định số 04/2014/NĐ-CP" },
                        { id: 4, value: "Hóa đơn đặt in theo Nghị định 123/2020/NĐ-CP" },
                    ],
                },
                {
                    view: "text",
                    name: "khmshdclquan",
                    label: "Ký hiệu mẫu số HĐLQ",
                    labelWidth: 200,
                    id: "khmshdclquan",
                    validate: webix.rules.isn,
                    invalidMessage: "Ký hiệu mẫu số hóa đơn liên quan không được bỏ trống",
                    attributes: { maxlength: 11 },
                    required: true,
                },
                {
                    view: "text",
                    name: "khhdclquan",
                    label: "Ký hiệu HĐLQ",
                    labelWidth: 200,
                    id: "khhdclquan",
                    invalidMessage: "Ký hiệu mẫu số hóa đơn liên quan không được bỏ trống",
                    attributes: { maxlength: 8 },
                    required: true,
                },
                {
                    view: "text",
                    name: "shdclquan",
                    label: "Số hóa đơn LQ",
                    labelWidth: 200,
                    id: "shdclquan",
                    invalidMessage: "Số hóa đơn liên quan không được bỏ trống",
                    attributes: { maxlength: 8 },
                    required: true,
                },
                {
                    view: "datepicker",
                    name: "nlhdclquan",
                    label: "Ngày lập hóa đơn liên quan",
                    labelWidth: 200,
                    id: "nlhdclquan",
                    invalidMessage: "Ngày lập hóa đơn không được bỏ trống",
                    required: true,
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
            // $$("kyhieuhoadon_78_id").define("options", app.config.host + "/System/GetDataByReferencesId?id=201a2758-6e97-4296-9beb-b627ff73e1a4");
            var khieu = param["data"][0].WinParams.find(function(item) {
                return item.value_field == "kyhieu_id";
            });

            $$("kyhieuhoadon_78_id").define("options", app.config.host + "/System/GetDataByReferencesId?id=" + khieu.wb_references_id);
            var table = $$("invoiceViews");
            var item = table.getSelectedItem();
            $$("kyhieuhoadon_78_id").setValue($$("kyhieu_id").getValue());
            $$("kyhieuhoadon_78_id").refresh();
        },
        setValues: function (item) {
            $$("chuyendai-form").setValues(item);
        },
    };
});

define('views/forms/68_email_hangloat',["app", "locale", "models/user", "views/commonHD"], function (app, _, user, commonHD) {
    var editmode = 0;
    var hdonids=[];
    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    if(!$$("email-form").validate()) return;
                    
                    var self = this;
                    setTimeout(function () {

                        var table = $$("invoiceViews")
                        var item = $$("email-form").getValues();

                        var data = {
                            nguoinhan:item.nguoinhan,
                            data:hdonids
                        };
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();
                        webix
                            .ajax()
                            .headers({ "Content-type": "application/json" })
                            .post(app.config.host + "/Invoice68/SendMails", data, {
                                error: function (text, data, XmlHttpRequest) {
                                    table.enable();
                                    table.hideProgress();
                                    // var json = JSON.parse(text);
                                    // webix.message(json.ExceptionMessage, "error");
                                    webix.message(text + XmlHttpRequest, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var json = JSON.parse(text);
                                    table.enable();
                                    table.hideProgress();
                                    if (!json.hasOwnProperty("error")) {
                                        $$("email-win").close();
                                        table.clearAll();
                                        table.load(table.config.url);

                                        webix.message("Gửi email thành công", "success");
                                    } else {
                                        $$("email-win").close();
                                        webix.message(json.error, "error");
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                },
                            });
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("email-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "email-win",
        position: "center",
        head: "Gửi nhiều email",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "email-form",
            complexData: true,
            margin: 0,
            rules:{
                "nguoinhan":webix.rules.isEmail,
            },
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "text",
                    label:"Người nhận",
                    name: "nguoinhan",
                    labelWidth: 100,
                    required: true,
                    invalidMessage: "Email người nhận bị bỏ trống hoặc không đúng định dạng",
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (_hdonids) {
            hdonids = _hdonids;
        },
    };
});

define('views/forms/68_email_send_history_result',["app", "locale", "models/user", "views/commonHD"], function (app, _, user, commonHD) {
    var editmode = 0;
    var countObj={};
    var button = [
        {},
        {
            view: "button",
            hotkey: "esc",
            label: "OK (ESC)",
            type: "success",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("result-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "result-win",
        position: "center",
        head: "Kết quả gửi lại mail theo lịch sử",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "result-form",
            complexData: true,
            margin: 0,
            elements: [
               
                {
                    view:"label", 
                    inputWidth: 100, 
                    align:"left",
                    id: "countAll",
                    css:{"color": "blue", "font-weight": "bold"}
                },
                {
                    view:"label", 
                    inputWidth: 100, 
                    align:"left",
                    id: "countSuccess",
                    css:{"color": "green", "font-weight": "bold"}
                },
                {
                    view:"label", 
                    inputWidth: 200, 
                    align:"left",
                    id: "countFailure",
                    css:{"color": "red", "font-weight": "bold"}
                },
                {
                    view:"label", 
                    inputWidth: 100, 
                    align:"left",
                    id: "error",
                    css:{"color": "red", "font-weight": "bold"}
                },
              
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (_countObj) {
            countObj = _countObj;
            
            $$("countAll").setValue("TỔNG SỐ: " + countObj.countAll + " ĐÃ CÓ LỊCH SỬ GỬI MAIL");
            $$("countSuccess").setValue("THÀNH CÔNG: " +  countObj.countSuccess );
          
            if(countObj.hasOwnProperty("error"))
            {
                $$("countFailure").setValue("THẤT BẠI: " + countObj.countFailure);
                $$("error").setValue("SỐ HÓA ĐƠN: " + countObj.error);
            }
        },
    };
});

define('views/forms/68_email_send_history',["app", "locale", "models/user", "views/commonHD"], function (app, _, user, commonHD) {
    var editmode = 0;
    var hdonids=[];
    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    //if(!$$("email-form").validate()) return;
                    
                    //var self = this;
                    setTimeout(function () {

                        var table = $$("invoiceViews")
                        //var item = $$("email-form").getValues();

                        var data = {
                            //nguoinhan:item.nguoinhan,
                            data:hdonids
                        };
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();
                        webix
                            .ajax()
                            .headers({ "Content-type": "application/json" })
                            .post(app.config.host + "/Invoice68/SendMailHistory", data, {
                                error: function (text, data, XmlHttpRequest) {
                                    table.enable();
                                    table.hideProgress();
                                    // var json = JSON.parse(text);
                                    // webix.message(json.ExceptionMessage, "error");
                                    webix.message(text + XmlHttpRequest, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var json = JSON.parse(text);
                                    table.enable();
                                    table.hideProgress();
                                    $$("email-win").close();
                                    table.clearAll();
                                    table.load(table.config.url);

                                    var tableHdon = webix.$$("invoiceViews");
                                    require(["app", "views/forms/68_email_send_history_result"], function (app, winForm) {
                                        var win = tableHdon.$scope.ui(winForm.$ui);
                                        winForm.setValues(json);
                                        win.show();
                                    });
                  
                                },
                            });
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("email-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "email-win",
        position: "center",
        head: "Gửi email theo lịch sử đã gửi",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "email-form",
            complexData: true,
            margin: 0,
            // rules:{
            //     "nguoinhan":webix.rules.isEmail,
            // },
            elements: [
                // {
                //     view: "text",
                //     label:"Người nhận",
                //     name: "nguoinhan",
                //     labelWidth: 100,
                //     required: true,
                //     invalidMessage: "Email người nhận bị bỏ trống hoặc không đúng định dạng",
                // },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (_hdonids) {
            hdonids = _hdonids;
        },
    };
});

define('views/forms/68_kyhieu_donvi_bienlai',["app", "locale", "models/user"], function (app, _, user) {
    var editmode = 0;
    var param;
    var branh_code;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var self = this;
                    setTimeout(function () {
                        var item = $$("kyhieu-form").getValues();
                        var table = $$("kyhieu-form");

                        if (table.validate()) {
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();
                            webix
                                .ajax()
                                .headers({ "Content-type": "application/json" })
                                .post(app.config.host + "/Invoice68/kihieudonvi68", item, {
                                    error: function (text, data, XmlHttpRequest) {
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        // var json = JSON.parse(text);
                                        // webix.message(json.ExceptionMessage, "error");
                                        webix.message(text + XmlHttpRequest, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text);
                                        var table = $$("kyhieu-form");
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            $$("kyhieu-win").close();
                                            var table = $$("kyhieu_hoadon");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    },
                                });
                        }
                    }, 100);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("kyhieu-win").close();
            },
        },
        {},
    ];

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "kyhieu-win",
        position: "center",
        head: "Đăng ký ký hiệu",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "kyhieu-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "phanhoadon_78_id",
                    label: "Ký hiệu",
                    //labelPosition: "top",
                    id: "phanhoadon_78_id",
                    required: true,
                    labelWidth: 120,
                    invalidMessage: "Ký hiệu không được bỏ trống",
                    options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF02004",
                    on: {
                        onChange: function (newv, oldv) {
                            var test = newv;
                        },
                    },
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {
            $$("kyhieu-form").setValues(item);
        },
    };
});

define('views/forms/68_phathanh_bienlai',["app", "locale", "models/user", "views/forms/68_invoiceForms"], function (app, _, user, invoiceForms) {
    

    var editmode = 0;

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>THÔNG BÁO PHÁT HÀNH BIÊN LAI<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_dksdForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "huyhoadonForms",
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {},
            },
            body: {
                view: "form",
                id: "huyhoadon",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        // id: "header",
                        template: "<center><b><span style='font-size:17px;'>THÔNG BÁO PHÁT HÀNH BIÊN LAI</b></center>",
                        borderless: true,
                        height: 40,
                    },
                    {
                        paddingX: 30,
                        rows: [
                            {
                                cols: [
                                    {},
                                    {
                                        label: "Tên CQT tiếp nhận: ",
                                        id: "tcqt",
                                        name: "tcqt",
                                        view: "combo",
                                        labelWidth: 180,
                                        width: 400,
                                        options: {
                                            view: "gridsuggest",
                                            columnName: "name",
                                            url: {
                                                $proxy: true,
                                                load: function (view, callback, params) {
                                                    var url = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00251";
                                                    webix.ajax(url, function (text) {
                                                        var json = JSON.parse(text);
                                                        var data = listToTree(json);
                                                        view.parse(data, "json");
                                                    });
                                                },
                                            },
                                            body: {
                                                columns: [{ id: "name", width: 500, header: "name" }],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    $$("mcqt").setValue(obj["code"]);
                                                    $$("mcqt").refresh();
                                                },
                                            },
                                        },
                                        required: true,
                                        invalidMessage: "Kính gửi không được để trống !",
                                    },
                                    {},
                                ],
                            },
                            {
                                view: "text",
                                label: "Tên đơn vị phát hành biên lai",
                                labelWidth: 200,
                                required: true,
                                invalidMessage: "Tên đơn vị phát hành biên lai không được để trống !",
                                id: "tnnt",
                                name: "tnnt",
                            },
                            {
                                view: "text",
                                label: "Mã số thuế (nếu có):",
                                id: "mst",
                                name: "mst",
                                labelWidth: 200,
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Địa chỉ",
                                        id: "ddanh",
                                        name: "ddanh",
                                        required: true,
                                        invalidMessage: "Địa labchỉ không được để trống !",
                                        labelWidth: 200,
                                        attributes:{ 
                                            maxlength:400 
                                        }
                                    },
                                    {
                                        view: "text",
                                        label: "Thành phố/Tỉnh",
                                        id: "ddtbao",
                                        name: "ddtbao",
                                        labelWidth: 100,
                                        width: 300,
                                    },
                                ],
                            },
                            {
                                view: "text",
                                label: "Số điện thoại",
                                id: "sdthoai",
                                name: "sdthoai",
                                required: true,
                                invalidMessage: "Số điện thoại không được để trống !",
                                labelWidth: 200,
                            },
                            {
                                view: "text",
                                label: "Các loại biên lai đã phát hành",
                                id: "bldaphathanh",
                                name: "bldaphathanh",
                                labelWidth: 200,
                            },
                            /*{
                                view: "datepicker",
                                label: "Ngày thông báo",
                                id: "ntbao",
                                name: "ntbao",
                                labelWidth: 200,
                            },*/
                        ],
                    },
                    { height: 3 },
                    { height: 3 },
                    {
                        rows: [
                            {
                                id: "btnHuyhoadon",
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        label: " (F9)",
                                        // width: 60,
                                        autowidth: true,
                                        icon: "fas fa-plus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_hoadonhuy");
                                                var item = { id: webix.uid() };
                                                table.add(item);
                                                table.select(item.id, "khieu", false);
                                                table.edit({ row: item.id, column: "khieu" });
                                            },
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        //view: "icon",
                                        autowidth: true, label: " (F8)",
                                        // width: 60,
                                        icon: "fas fa-minus",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_hoadonhuy");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {},
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_hoadonhuy",
                                // height: 250,
                                name: "danhsach_hoadonhuy",
                                // select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                select: "cell",
                                scheme: {
                                    $init: function (obj) {},
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                    onBeforeEditStart: function (id) {
                                        if (id.column == "stt") {
                                            return false;
                                        }
                                        if (id.column == "tenlbl") {
                                            return false;
                                        }
                                        if (id.column == "khms") {
                                            return false;
                                        }
                                        if (id.column == "tuso") {
                                            return false;
                                        }
                                        if (id.column == "denso") {
                                            return false;
                                        }
                                        return true;
                                    },
                                    onAfterEditStop: function (state, editor, ignore) {
                                        var columnId = editor.config.id;
                                        if(columnId == "soluong") {
                                            var table = $$(this.config.id);
                                            var selectedItem = table.getSelectedItem();
                                            var maxsoluong = Number(selectedItem["tongso"]) - Number(selectedItem["tuso"]) + 1;
                                            if (Number(selectedItem["soluong"]) > maxsoluong) {
                                                webix.message("Vượt quá số lượng cho phép là: " + maxsoluong);
                                                selectedItem["soluong"] = null;
                                                selectedItem["denso"] = null;
                                                return;
                                            }
                                            selectedItem["denso"] = Number(selectedItem["tuso"]) + Number(selectedItem["soluong"]) - 1;
                                            table.updateItem(selectedItem.id, selectedItem);
                                        }
                                    },
                                },
                                columns: [
                                    { editor: "text", id: "hdon_id", name: "hdon_id", hidden: true },
                                    {
                                        id: "stt",
                                        name: "stt",
                                        header: "STT",
                                        sort: "int",
                                        width: 40,
                                    },
                                    {
                                        id: "khieu",
                                        header: _("Ký hiệu"),
                                        editor: "text",
                                        width: 250,
                                        editable: true,
                                        suggest: {
                                            view: "gridsuggest",
                                            // value_suggest: field.value_suggest,
                                            // fieldExpression: field.field_expression,
                                            // displayField: field.display_field,
                                            // tableId: "edit_inv_InvoiceDetail",
                                            columnName: "ky_hieu",
                                            body: {
                                                columns: [
                                                    { id: "qlkhsdung_id", hidden: true, header: "id" },
                                                    { id: "khhdon", header: "ký hiệu" },
                                                    { id: "tenlbl", header: "Tên loại" },
                                                    { id: "khms", header: "Ký hiệu MS" },
                                                    { id: "tongso", header: "Tổng số" },
                                                    { id: "tuso", header: "Từ số" },
                                                    //{ id: "denso", header: "Đến số" },
                                                ],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                                dataFeed: function (filtervalue, filter) {
                                                    if (filtervalue.length < 1) return;

                                                    var refid = this.config.refid;
                                                    var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF02011";
                                                    var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                    this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                },
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    var table = $$("danhsach_hoadonhuy");
                                                    var items = table.serialize();
                                                    var selectedItem = table.getSelectedItem();
                                                    var newselectedItem = {};
                                                    newselectedItem.id = selectedItem.id
                                                    for(var i =0; i <items.length;i++)
                                                    {
                                                        if(items[i].qlkhsdung_id === obj["qlkhsdung_id"])
                                                        {
                                                            webix.message("Ký hiệu này đã có trong bảng","error");
                                                            return;
                                                        }
                                                    }
                                                    newselectedItem["qlkhsdung_id"] = obj["qlkhsdung_id"];
                                                    newselectedItem["khieu"] = obj["khhdon"];
                                                    newselectedItem["tenlbl"] = obj["tenlbl"];
                                                    newselectedItem["khms"] = obj["khms"];
                                                    newselectedItem["tongso"] = obj["tongso"];
                                                    newselectedItem["tuso"] = obj["tuso"];
                                                    table.updateItem(selectedItem.id, newselectedItem);
                                                },
                                            },
                                        },
                                    },
                                    {
                                        id: "tenlbl",
                                        name: "tenlbl",
                                        header: "Tên loại biên lai",
                                        width: 200,
                                        editor: "text",
                                    },
                                    {
                                        id: "khms",
                                        name: "khms",
                                        header: "Ký hiệu mẫu biên lai",
                                        width: 200,
                                        editor: "text",
                                    },
                                    {
                                        id: "soluong",
                                        name: "soluong",
                                        header: "Số lượng",
                                        width: 200,
                                        editor: "autonumeric",
                                        editable: true,
                                        on: {
                                            onChange: function (newv, oldv) {

                                            },
                                        },
                                    },
                                    {
                                        id: "tuso",
                                        name: "tuso",
                                        header: "Từ số",
                                        width: 200,
                                        editor: "autonumeric",
                                    },
                                    {
                                        id: "denso",
                                        name: "denso",
                                        header: "Đến số",
                                        width: 200,
                                        editor: "autonumeric",
                                    },
                                    {
                                        id: "ngay",
                                        name: "ngay",
                                        header: "Ngày sử dụng",
                                        width: 200,
                                        editor: "date",
                                        format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "hdso",
                                        name: "hdso",
                                        header: "Hợp đồng số",
                                        width: 200,
                                        editor: "text",
                                    },
                                    {
                                        id: "hdngay",
                                        name: "hdngay",
                                        header: "Hợp đồng ngày",
                                        width: 200,
                                        editor: "date",
                                        format: webix.i18n.dateFormatStr,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                shortcut: "F9",
                                view: "button",
                                id: "btnLuuTamHDDT",
                                label: "Lưu tạm(F9)",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            item.loaihd = 2;
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin !", "error");
                                                    return;
                                                }
                                                for(var i =0; i <cks.length;i++)
                                                {
                                                    var obj = cks[i];
                                                    if(obj["qlkhsdung_id"]== undefined || obj["qlkhsdung_id"] == null)
                                                    {
                                                        webix.message("Dòng " +(i+1) +":Ký hiệu không được bỏ trống","error");
                                                        return;
                                                    }
                                                    if(obj["soluong"]== undefined || obj["soluong"] == null)
                                                    {
                                                        webix.message("Dòng " +(i+1) +":Số lượng không được bỏ trống","error");
                                                        return;
                                                    }
                                                    if(obj["tuso"]== undefined || obj["tuso"] == null)
                                                    {
                                                        webix.message("Dòng " +(i+1) +":Từ số không được bỏ trống","error");
                                                        return;
                                                    }
                                                     if(obj["denso"]== undefined || obj["denso"] == null)
                                                    {
                                                        webix.message("Dòng " +(i+1) +":Đến số không được bỏ trống","error");
                                                        return;
                                                    }
                                                    if(obj["ngay"]== undefined || obj["ngay"] == null)
                                                    {
                                                        webix.message("Dòng " +(i+1) +":Ngày sủ dụng không được bỏ trống","error");
                                                        return;
                                                    }

                                                }
                                                var details = [];
                                                details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                                item["details"] = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                var tableDK = $$("huyhoadon");
                                                webix.extend(table, webix.ProgressBar);
                                                tableDK.disable();
                                                tableDK.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice68/SavePhatHanhBienLai", data_post, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            // var json = JSON.parse(text);
                                                            // webix.message(json.ExceptionMessage, "error");
                                                            webix.message(text + XmlHttpRequest, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(text);
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            if (!json.hasOwnProperty("error")) {
                                                                webix.message("Lưu thành công !", "success");
                                                                if ($$("mau04_68")) {
                                                                    var table = $$("mau04_68");
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                }
                                                                $$("huyhoadonForms").close();
                                                                app.callEvent("dataChangedInvoie68", [1, null]);
                                                            } else {
                                                                webix.message(json.error, "error");
                                                            }
                                                        },
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                shortcut: "F10",
                                view: "button",
                                id: "btnGhiSignHuyHDDT",
                                label: "Ký(F10)",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var self = this;
                                        setTimeout(function () {
                                            var item = $$("huyhoadon").getValues();
                                            item.loaihd = 2;
                                            var table = $$("huyhoadon");

                                            if (table.validate()) {
                                                var cks = $$("danhsach_hoadonhuy").serialize();
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin  !", "error");
                                                    return;
                                                }
                                                if (cks.length == 0) {
                                                    webix.message("Bạn chưa nhập thông tin !", "error");
                                                    return;
                                                }
                                                for(var i =0; i <cks.length;i++)
                                                {
                                                    var obj = cks[i];
                                                    if(obj["qlkhsdung_id"]== undefined || obj["qlkhsdung_id"] == null)
                                                    {
                                                        webix.message("Dòng " +(i+1) +":Ký hiệu không được bỏ trống","error");
                                                        return;
                                                    }
                                                    if(obj["soluong"]== undefined || obj["soluong"] == null)
                                                    {
                                                        webix.message("Dòng " +(i+1) +":Số lượng không được bỏ trống","error");
                                                        return;
                                                    }
                                                    if(obj["tuso"]== undefined || obj["tuso"] == null)
                                                    {
                                                        webix.message("Dòng " +(i+1) +":Từ số không được bỏ trống","error");
                                                        return;
                                                    }
                                                    if(obj["denso"]== undefined || obj["denso"] == null)
                                                    {
                                                        webix.message("Dòng " +(i+1) +":Đến số không được bỏ trống","error");
                                                        return;
                                                    }
                                                    if(obj["ngay"]== undefined || obj["ngay"] == null)
                                                    {
                                                        webix.message("Dòng " +(i+1) +":Ngày sủ dụng không được bỏ trống","error");
                                                        return;
                                                    }

                                                }
                                                var details = [];
                                                details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                                item["details"] = details;

                                                var item1 = [];
                                                item1.push(item);
                                                var data_post = { editmode: editmode, data: item1 };

                                                var tableDK = $$("huyhoadon");

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = "";
                                                        for (var i = 0; i < result.length; i++) {
                                                            var item = result[i];
                                                            kytaptrung = item.value;
                                                        }

                                                        webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                                            var listcerts = JSON.parse(text);
                                                            if (listcerts.length > 0) {
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();

                                                                                var cert = null;

                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }

                                                                                var now = new Date();
                                                                                var begin = new Date(cert.begin_date);
                                                                                var end = new Date(cert.end_date);
                                                                                if (now < begin || now > end) {
                                                                                    webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                                                    return;
                                                                                }

                                                                                var postData = {
                                                                                    branch_code: user.getDvcsID(),
                                                                                    username: user.getCurrentUser(),
                                                                                    cer_serial: cert.cer_serial,
                                                                                };
                                                                                data_post.sign = postData;
                                                                                data_post.signMode = 1;

                                                                                webix.extend(tableDK, webix.ProgressBar);
                                                                                tableDK.disable();
                                                                                tableDK.showProgress();
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({ "Content-type": "application/json" })
                                                                                    .post(app.config.host + "/Invoice68/SavePhatHanhBienLai", data_post, {
                                                                                        error: function (text, data, XmlHttpRequest) {
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            // var json = JSON.parse(text);
                                                                                            // webix.message(json.ExceptionMessage, "error");
                                                                                            webix.message(text + XmlHttpRequest, "error");
                                                                                        },
                                                                                        success: function (text, data, XmlHttpRequest) {
                                                                                            var json = JSON.parse(text);
                                                                                            tableDK.enable();
                                                                                            tableDK.hideProgress();
                                                                                            if (!json.hasOwnProperty("error")) {
                                                                                                webix.message("Gửi thành công đến CQT !", "success");
                                                                                                if ($$("mau04_68")) {
                                                                                                    var table = $$("mau04_68");
                                                                                                    table.clearAll();
                                                                                                    table.load(table.config.url);
                                                                                                }
                                                                                                $$("huyhoadonForms").close();
                                                                                                app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                            } else {
                                                                                                webix.message(json.error, "error");
                                                                                            }
                                                                                        },
                                                                                    });

                                                                            // return;
                                                                        }
                                                                    },
                                                                });

                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}",
                                                                        },
                                                                        {
                                                                            id: "cert_type",
                                                                            header: _("Loại"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "cer_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 150,
                                                                        },
                                                                        {
                                                                            id: "subject_name",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 450,
                                                                        },
                                                                        {
                                                                            id: "begin_date",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "end_date",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "issuer",
                                                                            header: _("DONVI"),
                                                                            width: 450,
                                                                        },
                                                                    ],
                                                                    url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                                                });
                                                            } else {
                                                                var table = $$("huyhoadon");
                                                                webix.extend(table, webix.ProgressBar);
                                                                table.disable();
                                                                table.showProgress();

                                                                // xem user có tích checkbox ký HSM không?
                                                                var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                                                webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                                                    if (resultscheckSigHSM[0].json() == "C") {
                                                                        var postData = {
                                                                            branch_code: user.getDvcsID(),
                                                                            username: user.getCurrentUser(),
                                                                            check_HSM: "1",
                                                                        };
                                                                        data_post.sign = postData;

                                                                        webix.extend(tableDK, webix.ProgressBar);
                                                                        tableDK.disable();
                                                                        tableDK.showProgress();
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/SavePhatHanhBienLai", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    tableDK.enable();
                                                                                    tableDK.hideProgress();
                                                                                    // var json = JSON.parse(text);
                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);
                                                                                    tableDK.enable();
                                                                                    tableDK.hideProgress();
                                                                                    if (!json.hasOwnProperty("error")) {
                                                                                        webix.message("Gửi thành công đến CQT !", "success");
                                                                                        if ($$("mau04_68")) {
                                                                                            var table = $$("mau04_68");
                                                                                            table.clearAll();
                                                                                            table.load(table.config.url);
                                                                                        }
                                                                                        $$("huyhoadonForms").close();
                                                                                        app.callEvent("dataChangedInvoie68", [1, null]);
                                                                                    } else {
                                                                                        webix.message(json.error, "error");
                                                                                    }
                                                                                },
                                                                            });
                                                                    } else {
                                                                        webix
                                                                            .ajax()
                                                                            .headers({ "Content-type": "application/json" })
                                                                            .post(app.config.host + "/Invoice68/Savephathanhbl", data_post, {
                                                                                error: function (text, data, XmlHttpRequest) {
                                                                                    table.enable();
                                                                                    table.hideProgress();
                                                                                    // var json = JSON.parse(text);
                                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                                    webix.message(text + XmlHttpRequest, "error");
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                    var json = JSON.parse(text);

                                                                                    if (json.hasOwnProperty("error")) {
                                                                                        webix.message(json.error, "error");
                                                                                    } else {
                                                                                        var a = webix.ajax(app.config.host + "/Invoice68/XmlPhatHanhBL?id=" + json.id);
                                                                                        var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                                                                        webix.promise.all([a, b, json]).then(function (results) {
                                                                                            // webix.extend(tblInvoice, webix.ProgressBar);
                                                                                            // tblInvoice.disable();
                                                                                            // tblInvoice.showProgress();
                                                                                            var json = results[0].json();

                                                                                            if (json.hasOwnProperty("error")) {
                                                                                                webix.message({ type: "error", text: json.error });
                                                                                            }

                                                                                            var listcerts = results[1].json();
                                                                                            var item = results[2];

                                                                                            if (listcerts.length == 0) {
                                                                                                table.enable();
                                                                                                table.hideProgress();
                                                                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                                                                return;
                                                                                            }

                                                                                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                                                var hub = plugin.hub();
                                                                                                var hubconnect = plugin.conn();
                                                                                                if (hubconnect.state != 1) {
                                                                                                    table.enable();
                                                                                                    table.hideProgress();
                                                                                                    webix.message("Quý khách hàng chưa cài Plugin ký hoặc Plugin ký chưa được bật !", "error");
                                                                                                    return;
                                                                                                }
                                                                                                hub.off("resCommand");
                                                                                                hub.on("resCommand", function (result) {
                                                                                                    var json = JSON.parse(result);

                                                                                                    if (json.hasOwnProperty("error")) {
                                                                                                        webix.message({ type: "error", text: json.error });
                                                                                                    } else {
                                                                                                        var parameters = {
                                                                                                            xml: json.xml,
                                                                                                            id: item.id,
                                                                                                            tthdon: 3,
                                                                                                        };

                                                                                                        webix
                                                                                                            .ajax()
                                                                                                            .headers({ "Content-Type": "application/json" })
                                                                                                            .post(app.config.host + "/Invoice68/SaveXmlPhatHanhBienLai", parameters, function (text) {
                                                                                                                var result = JSON.parse(text);
                                                                                                                if (result.hasOwnProperty("error")) {
                                                                                                                    webix.message(result.error, "error");
                                                                                                                } else {
                                                                                                                    app.callEvent("dataChangedInvoie68", [editmode, null]);

                                                                                                                    webix.message("Thành công !", "success");
                                                                                                                    if ($$("mau04_68")) {
                                                                                                                        var table = $$("mau04_68");
                                                                                                                        table.clearAll();
                                                                                                                        table.load(table.config.url);
                                                                                                                    }
                                                                                                                    webix.$$("huyhoadonForms").close();
                                                                                                                }
                                                                                                            });
                                                                                                    }
                                                                                                    table.enable();
                                                                                                    table.hideProgress();
                                                                                                });

                                                                                                var _listcerts = [];

                                                                                                for (var i = 0; i < listcerts.length; i++) {
                                                                                                    var _cert = listcerts[i];

                                                                                                    _listcerts.push({
                                                                                                        so_serial: _cert.cer_serial,
                                                                                                        ngaybatdau: _cert.begin_date,
                                                                                                        ngayketthuc: _cert.end_date,
                                                                                                        issuer: _cert.issuer,
                                                                                                        subjectname: _cert.subject_name,
                                                                                                    });
                                                                                                }

                                                                                                var arg = {
                                                                                                    idData: "#data",
                                                                                                    xml: json["xml"],
                                                                                                    shdon: "",
                                                                                                    idSigner: "seller",
                                                                                                    tagSign: "NNT",
                                                                                                    dvky: json["dvky"],
                                                                                                    dateKy: json["dateKy"],
                                                                                                    listcerts: _listcerts,
                                                                                                };

                                                                                                hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                                                                    .done(function () {
                                                                                                        console.log("Success !");
                                                                                                    })
                                                                                                    .fail(function (error) {
                                                                                                        webix.message(error, "error");
                                                                                                    });
                                                                                            });
                                                                                        });
                                                                                    }
                                                                                },
                                                                            });
                                                                    }
                                                                });
                                                            }
                                                        });
                                                    });
                                            }
                                        }, 100);
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    app.callEvent("dataChangedInvoie68", [1, null]);
                                    webix.$$("huyhoadonForms").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix
                    .ajax()
                    .sync()
                    .get(app.config.host + "/System/GetDmDvcsByUser");
                var json = JSON.parse(result.response);

                $$("tnnt").setValue(json[0].name);
                $$("mst").setValue(json[0].tax_code);
                $$("tcqt").setValue(json[0].cqt);
                $$("ddanh").setValue(json[0].address);
                $$("sdthoai").setValue(json[0].tel);
            } else {
                if (editmode == 2) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
        setValues: function (item, winconfig, params) {
            $$("danhsach_hoadonhuy").parse(item);
        },
        setValuesTongQuat: function (item, winconfig, params) {
            var data = $$("huyhoadon").getValues();
            data.so = item.so;
            data.ntbccqt = item.ntbccqt;
            data.loai = item.loai;
            $$("huyhoadon").parse(data);
        },
        setValuesEdit: function (item, winconfig, params) {
            $$("huyhoadon").parse(item);
            var tableDetail = webix.$$("danhsach_hoadonhuy");
            var url = app.config.host + "/Invoice68/GetDataTBPHDetail?id=" + item.id;
            tableDetail.clearAll();
            tableDetail.load(url);
        },
    };
});

define('views/forms/68_tncn_history_lienquan',["app", "locale"], function (app, _) {
    

    var editmode = 0;
    var hdon_id = "";

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formdksd",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Chứng từ điều chỉnh, thay thế<div/>";
                        },
                    },
                ],
            },
            id: "responseMessageForms",
            resize: true,
            width: 1000,
            height: 500,
            move: true,
            on: {
                onBeforeShow: function () {},
            },
            body: {
                view: "form",
                id: "message",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        // id: "header",
                        template: "<center><b><span style='font-size:17px;'>Chứng từ điều chỉnh, thay thế</b></center>",
                        borderless: true,
                        height: 40,
                    },
                    { height: 3 },
                    {
                        rows: [
                            {
                                view: "datatable",
                                id: "danhsach_history",
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                select: "cell",
                                scheme: {
                                    $init: function (obj) {},
                                },
                                onClick: {
                                    btnPrint: function (event, cell, target) {
                                        var win = webix.$$("danhsach_history");
                                        var record = win.getItem(cell.row);
                                        //webix.message("Chưa có mẫu in ...", "error");
                                        // var rpParameter = null;
                                        var box = webix.modalbox({
                                            title: "Đang in chứng từ ....",
                                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                            width: 350,
                                            height: 200,
                                        });

                                        var newWin = window.open();
                                        var html =
                                            "<html><head><title>Chứng từ điện tử MobiFone Invoice</title>" +
                                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                        newWin.document.write(html);
                                        webix
                                            .ajax()
                                            .response("arraybuffer")
                                            .headers({ "Content-type": "application/json" })
                                            .get(app.config.host + "/Invoice68/inHoadon?id=" + record.hdon_id + "&type=PDF&inchuyendoi=false", {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.modalbox.hide(box);
                                                    webix.message(XmlHttpRequest.statusText, "error");
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var file = new Blob([data], { type: "application/pdf" });
                                                    var fileURL = URL.createObjectURL(file);
                                                    //window.open(fileURL, '_blank');
                                                    webix.modalbox.hide(box);
                                                    newWin.location = fileURL;
                                                },
                                            });
                                    },
                                    dowloadXml: function (event, cell, target) {
                                        var win = webix.$$("danhsach_history");
                                        var record = win.getItem(cell.row);
                                        //webix.message("Chưa có mẫu in ...", "error");
                                        // var rpParameter = null;
                                        if (record.tthai == "Chờ sinh số"|| record.tthai == "Chờ duyệt"|| record.tthai == "Chờ ký" || record.tthai == "Chờ gửi") {
                                            webix.message("Chứng từ đang ở trạng thái chờ ký/chờ gửi không thể tải XML !", "error");
                                            return;
                                        }
                                        var table = webix.$$("responseMessageForms");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        var url = app.config.host + "/Invoice68/ExportXMLHoadon?id=" + record.hdon_id;
                                        webix
                                        .ajax()
                                        .response("arraybuffer")
                                        .get(url, function (text, data) {
                                            table.enable();
                                            table.hideProgress();

                                            var file = new Blob([data], {
                                                type: "application/xml"
                                            });
                                            webix.html.download(file, "XmlChungTu.xml");
                                            // var fileURL = URL.createObjectURL(file);
                                            // window.open(fileURL, "_blank");
                                        });
                                    },        
                                },
                                url:{
                                    $proxy: true,
                                    load: function (view, callback, params) {
                                        // var hdon_id = "87de11a4-0b4e-42d4-a86c-45ba10b80337";
                                        if(hdon_id != ""){
                                            var url = app.config.host + "/Invoice68/GetInviceLQ?id=" + hdon_id;
                                            webix.ajax(url, callback, view);
                                        }
                                    }
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                },
                                columns: [

                                    {
                                        id: "stt",
                                        header: ["<center>STT</center>"],
                                        sort: "int",
                                        width: 40,
                                        columnType: "nvarchar",
                                    },
                                    {
                                        id: "hdon_id",
                                        header: ["<center>Mã chứng từ</center>", { content: "textFilter" }],
                                        width: 100,
                                        columnType: "nvarchar",
                                        hidden: true,
                                    },
                                    {
                                        id: "khieu",
                                        header: ["<center>Ký hiệu</center>", { content: "textFilter" }],
                                        width: 100,
                                        css: { "text-align": "center" },
                                        columnType: "nvarchar",
                                    },
                                    { id: "shdon", header: ["<center>Số chứng từ</center>", { content: "textFilter" }], width: 100, columnType: "numeric", css: { "text-align": "center" } },
                                    { id: "tthai", header: ["<center>Trạng thái gửi</center>", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                                    { id: "ttthdon", header: ["<center>Trạng thái</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" },
                                    {
                                        id: "nlap",
                                        header: [
                                            "Ngày lập"
                                        ],
                                        width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                        columnType: "datetime",
                                    },
                                    {
                                        id: "nky",
                                        header: [
                                            "Ngày giờ ký"
                                        ],
                                        width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                        columnType: "datetime",
                                    },
                                    {
                                        id: "tgtttbso_last",
                                        header: ["<center>Thành tiền sau thuế</center>", { content: "textFilter" }],
                                        width: 150,
                                        css: { "text-align": "right" },
                                        columnType: "numeric",
                                    },
                                    {
                                        id: "btnPrint",
                                        header: ["", "Xem/In"],
                                        css: { "text-align": "center" },
                                        template: function (obj) {
                                            return "<span class='btnPrint' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                                        },
                                        width: 120,
                                    },
                                    {
                                        id: "dowloadXml",
                                        header: ["", "Tải XML"],
                                        css: { "text-align": "center" },
                                        width: 120,
                                        template: function (obj) {
                                            return "<span class='dowloadXml' style='color: #00b300'><i class='fas fa-download'></i></span> ";

                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    hdon_id = "";
                                    webix.$$("responseMessageForms").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (id) {
            hdon_id = id;
            var table = $$("danhsach_history");
            table.load(table.config.url);
        },
    };
});

define('views/forms/createinvoicebangke',["app", "locale"], function (app, _) {

    function initUI(item) {
        $$('sobangke').setValue(item.list_number);
    }

    return {
        $ui: {
            view: "window",
            id: "crinvoice",
            head: "Tạo hóa đơn từ bảng kê",
            modal: true,
            width: 400,
            position: "center",
            // css: { "font-weight": "bold", "text-transform": "uppercase" },
            body: {
                view: "form", id: "crinvoiceform", elements: [

                    { view: "text", label: _("SO_BANG_KE"), id: "sobangke", name: "list_number", readonly: true, labelWidth: 90 },
                    {
                        view: "richselect",
                        id: "inv_InvoiceCode_id",
                        name: "inv_InvoiceCode_id",
                        label: _("MAU_SO"),
                        labelWidth: 90,
                        //options: app.config.host +"/System/GetAllDmDvcs",
                        options: {
                            view: "gridsuggest",
                            textValue: "ky_hieu",
                            body: {
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00027",
                                textValue: "ky_hieu",
                                columns: [
                                    {
                                        id: "mau_so",
                                        width: 100,
                                        header: _("MAU_SO")
                                    },
                                    {
                                        id: "ky_hieu",
                                        width: 100,
                                        header: _("KY_HIEU")
                                    },
                                    {
                                        id: "ma_loai",
                                        width: 100,
                                        header: _("MA_LOAI")
                                    },
                                    {
                                        id: "ngay_bd_sd",
                                        width: 150,
                                        header: _("NGAY_BD_SD"),
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    },
                                    {
                                        id: "tu_so",
                                        width: 100,
                                        header: _("TU_SO")
                                    },
                                    {
                                        id: "den_so",
                                        width: 100,
                                        header: _("DEN_SO")
                                    }
                                ]
                            }
                        }
                    },
                    { view: "datepicker", label: _("NGAY_HDON"), id: "ngayhd", name: "ngay_hd", value: new Date(), labelWidth: 90 },
                    {
                        cols: [

                            {
                                view: "button", value: "Đồng ý", type: "form", click: function () {

                                    var item = $$("crinvoiceform").getValues();
                                    console.log(item);

                                    var url = app.config.host + "/Invoice/CreateInvoiceFromList";
                                    webix.ajax()
                                        .headers({ 'Content-type': 'application/json' })
                                        .post(url, item, function (text) {
                                            var data = JSON.parse(text);

                                            if (!data.hasOwnProperty("error")) {
                                                webix.message("Tạo hóa đơn thành công !");
                                                $$("crinvoice").close();
                                            }
                                            else {
                                                webix.message(data.error, "error");
                                            }
                                        });
                                }
                            },
                            {
                                view: "button", hotkey: "esc", value: "Hủy bỏ", click: function () {
                                    this.getTopParentView().hide();
                                }
                            }
                        ]
                    }
                ]
            }
        },
        initUI: initUI
    };

});
define('views/forms/dmhv',["app"],function(app){
	var editmode = 0;
	var col=[];
					
	var el = [];
	var head_name=[];
	var head;
    var url = app.config.host + "/api/System/GetAllByWindowId?id=09a8b24b-52b5-46a6-931d-d6f005da0dd7";
    webix.ajax(url, function (text, xml, xhr) {

        var rp = JSON.parse(text);
        head_name.push(String(rp['data'][0]['Tabs'][0]['TAB_NAME']));
        for (var i = 0; i < (rp['data'][0]['ROWS_MAX']); i++) {
			var col1=[];
			
			for (var j = 0; j < (Object.keys(rp['data'][0]['Tabs'][0]['Fields']).length); j++) {
				
				if(i==(Number(rp['data'][0]['Tabs'][0]['Fields'][j]['ROW'])-1)){
					var el1=[];
					col1.push({ view:"text", name: '' + String(rp['data'][0]['Tabs'][0]['Fields'][j]['COLUMN_NAME']) + '',label: '' + String(rp['data'][0]['Tabs'][0]['Fields'][j]['COLUMN_NAME']) + '' , 
			  			id: 'dmhv-'+ String(rp['data'][0]['Tabs'][0]['Fields'][j]['COLUMN_NAME']) + '',width:Number(rp['data'][0]['Tabs'][0]['Fields'][j]['WIDTH'])});
					
						  
				}
				
							
			}
			
			if(col1.length>0){
				el.push({
				cols:col1
			});
			}
			
        }
		col.push({});
		col.push({ 
			shortcut:"F10",  view:"button", label:"Nhận", type:"form", align:"center", 
			on: {
				onClick: function() {
					var form = webix.$$("dmhv-form");
						var item = form.getValues();
						var hvData={};
						hvData.windowno=String(rp['data'][0]['ID']);
						hvData.editmode=editmode;
						hvData.data=[];
						hvData.data.push(item);
						console.log(item);
						console.log(hvData);
						webix.ajax().post( app.config.host + "/api/System/Save", hvData, function(text){
						var data = JSON.parse(text);
											
						if (!data.hasOwnProperty("error")){
							item.id = data.id;
							webix.$$("dmhv-win").close();
							app.callEvent("dataChanged",[editmode,item]);
						}
						else {
							webix.message(data.error);
						}
					});
									}
				},
			click:function(){								
				this.callEvent("onClick");							
									
			}
		});	
		col.push({ view:"button", hotkey:"esc", label:"Hủy bỏ",align:"center", 
			click:function(){
				webix.$$("dmhv-win").close();
			}
		});	
		col.push({});	
		el.push({
			margin:10,
			cols:col
		});
        $$("dmhvData").define("elements",el );;
        $$("dmhvData").refresh();
		//console.log(head_name[0]);
    });
	  
	return {		
		$ui:{
			view:"window", modal:true, id:"dmhv-win", position:"center",
			head:'' + head + '',
			//fullscreen:true,
			//width: 350,
			body:{
                paddingY:20, 
                paddingX:30, 
                elementsConfig:{labelWidth: 80}, 
                view:"form", 
				id:"dmhv-form", 
				complexData:true,
                elements:
                    el
					// {
					// 	margin:10,
					// 	cols:[
					// 		{},
					// 		{ 
					// 			shortcut:"F10",  view:"button", label:"Nhận", type:"form", align:"center", width:120, 
					// 			on: {
					// 				onClick: function() {
					// 					var form = webix.$$("dmhv-form");
					// 					var item = form.getValues();

					// 					webix.ajax().post( app.config.host + "/api/Dmhv/Update", item, function(text){
					// 						var data = JSON.parse(text);
											
					// 						if (!data.hasOwnProperty("error")){
					// 							item.id = data.id;
					// 							webix.$$("dmhv-win").close();
					// 							app.callEvent("dataChanged",[editmode,item]);
					// 						}
					// 						else {
					// 							webix.message(data.error);
					// 						}
					// 					});
					// 				}
					// 			},
					// 			click:function(){								
					// 				this.callEvent("onClick");							
									
					// 			}
					// 		},
					// 		{ view:"button", hotkey:"esc", label:"Hủy bỏ",align:"center", width:120, 
					// 			click:function(){
					// 				webix.$$("dmhv-win").close();
					// 			}
					// 		}
					// 	]
					// }

				
			}			
			
		},		
		setEditMode: function(mode) {
			editmode = mode;
		}
	};

});
define('views/forms/formhoadon78bienlai',["app", "locale", "models/user", "models/findjson", "views/commonHD", "callApis/hoadon68", "callApis/customer"], function (app, _, user, findJson, commonHD, hoadon68CallApis, customerCallApis) {
    var editmode = 0;
    var tongtienHDonBke = 0;
    var mau04 = {};
    formatSoDefault = {
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0,
    };

    var el = [];
    function renderFormat(val) {
        if (val === undefined) val = "VND";
        var url = app.config.host + "/Invoice68/GetDecimalPlace?ma_nt=" + val;
        var table_chitiet = webix.$$("hoadon68_chitiet");
        var table_phi = webix.$$("hoadon68_phi");
        var table = $$("invoiceForms");
    }

    //FormButton
    var cols = [
        {
            margin: 10,
            cols: [
                {},
                {
                    shortcut: "F10",
                    view: "button",
                    id: "btnBangKeSave",
                    label: "Lưu (F10)",
                    type: "form",
                    align: "center",
                    width: 120,
                    hidden: true,
                    on: {
                        onClick: function () {
                            var self = this;

                            $$("btnBangKeSave").disable();
                            setTimeout(function () {
                                var tongtienBangKeCT = webix.$$("tgtttbso").getValue();
                                var item = $$("invoiceForms").getValues();
                                var table = $$("invoiceForms");
                                var record = $$("hoadon68_chitiet").serialize();
                                if (record.length == 0 && item.tlkthu == undefined) {
                                    webix.message("Bạn chưa bổ sung chi tiết khoản thu");
                                    return;
                                }
                                var mauso = $$("khieu").getValue().toString()[0];
                                for (var i = 0; i < record.length; i++) {
                                    var it = record[i];

                                    if (it["ten"] == null || it["ten"] == "") {
                                        webix.message("Bạn chưa nhập tên hàng");
                                        return;
                                    }
                                }

                                if (tongtienHDonBke != tongtienBangKeCT) {
                                    webix.message("Tổng tiền chi tiết bảng kê khác tổng tiền của hoá đơn!", "error");
                                    return false;
                                }

                                if (table.validate()) {
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    var details = [];
                                    details.push({ data: record });
                                    item["details"] = details;
                                    var phi = [];
                                    phi.push({
                                        data: $$("hoadon68_phi").serialize(),
                                    });
                                    item["hoadon68_phi"] = phi;
                                    // hóa đơn không mã
                                    item.is_hdcma = 0;
                                    var item1 = [];
                                    item1.push(item);
                                    var data_post = { editmode: editmode, data: item1 };

                                    var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                    function afterSaveInvoiceSuccess(text) {
                                        var json = text.json();
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                            webix.$$("invoice68").close();

                                            if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            } else {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            }
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    }

                                    function afterSaveInvoiceError(text) {
                                        table.enable();
                                        table.hideProgress();
                                        webix.message(text.json() + XmlHttpRequest, "error");
                                    }

                                    if (isSaveCustomerInfo) {

                                        var code = $$('mnmua') != null ? $$('mnmua').getValue() : null;
                                        var buyer_name = $$('tnmua') != null ? $$('tnmua').getValue() : null;
                                        var name = $$('ten') != null ? $$('ten').getValue() : null;
                                        var tax_code = $$('mst') != null ? $$('mst').getValue() : null;
                                        var email = $$('email') != null ? $$('email').getValue() : null;
                                        var address = $$('dchi') != null ? $$('dchi').getValue() : null;
                                        var tel = $$('sdtnmua') != null ? $$('sdtnmua').getValue() : null;
                                        var bank_account = $$('stknmua') != null ? $$('stknmua').getValue() : null;
                                        var bank_name = $$('tnhmua') != null ? $$('tnhmua').getValue() : null;
                                        var name_label = $$('ten') != null ? $$('ten').config.label : "Tên";
                                        var address_label = $$('dchi') != null ? $$('dchi').config.label : "Địa chỉ";

                                        var obj = {
                                            code: code,
                                            buyer_name: buyer_name,
                                            name: name,
                                            tax_code: tax_code,
                                            email: email,
                                            address: address,
                                            tel: tel,
                                            bank_account: bank_account,
                                            bank_name: bank_name,
                                        };

                                        var checkMessage = [];

                                        if (obj.code == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                        if (obj.name == "") checkMessage.push('"' + name_label + '" là trường bắt buộc nhập"');
                                        if (obj.address == "") checkMessage.push('"' + address_label + '" khách hảng là trường bắt buộc nhập"');

                                        var showConfirmUI = function () {
                                            webix.ui({
                                                view: "window",
                                                id: "check-customer-modal",
                                                type: "modal",
                                                modal: true,
                                                position: "center",
                                                head: {
                                                    height: 35,
                                                    cols: [
                                                        {
                                                            id: "head-form-check-customer",
                                                            view: "template",
                                                            css: "headform",
                                                            template: function (obj) {
                                                                return "<div style='text-align: center;'>Tạo mới khách hàng thất bại<div/>";
                                                            },
                                                        }
                                                    ],
                                                },
                                                body: {
                                                    padding: 10,
                                                    rows: [
                                                        {
                                                            rows: checkMessage.map(function (message) {
                                                                return {
                                                                    view: "template",
                                                                    template: "▶ " + message,
                                                                    autoheight: true, width: 350
                                                                }
                                                            }),
                                                        },
                                                        {
                                                            view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                        },
                                                        {
                                                            cols: [
                                                                {},
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                                                            .then(afterSaveInvoiceSuccess)
                                                                            .catch(afterSaveInvoiceError);
                                                                    }
                                                                },
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Nhập lại", type: "danger", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        table.enable();
                                                                        table.hideProgress();
                                                                    }
                                                                },
                                                                {}
                                                            ]
                                                        }
                                                    ]
                                                }
                                            }).show()
                                        }

                                        if (checkMessage.length > 0) {
                                            showConfirmUI();
                                        } else {
                                            customerCallApis.saveCustomer(obj).then(function (res) {
                                                res = res.json();

                                                if (!res.status) {
                                                    checkMessage.push(res.message.replace("P0001: ", ""));
                                                    showConfirmUI();
                                                } else {

                                                    webix.message("Lưu thông tin khách hàng thành công", "success"); hoadon68CallApis.hoadonSaveChange(data_post)
                                                        .then(afterSaveInvoiceSuccess)
                                                        .catch(afterSaveInvoiceError);
                                                }
                                            });
                                        }
                                    } else
                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                            .then(afterSaveInvoiceSuccess)
                                            .catch(afterSaveInvoiceError);;

                                }

                                $$("btnBangKeSave").enable();
                            }, 100);
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    view: "button",
                    id: "btnBangKeDelete",
                    label: "Xoá",
                    type: "danger",
                    align: "center",
                    width: 80,
                    hidden: true,
                    on: {
                        onClick: function () {
                            var self = this;

                            setTimeout(function () {
                                var item = $$("invoiceForms").getValues();
                                var url = app.config.host + "/Invoice68/DeleteBangKeHoaDon?id=" + item.id;
                                var table = $$("invoiceForms");
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();
                                webix
                                    .ajax()
                                    .headers({ "Content-Type": "application/json" })
                                    .post(url, function (result) {
                                        if (result == "true") {
                                            webix.message("Đã xoá bảng kê !");
                                            table.enable();
                                            table.hideProgress();
                                            webix.$$("invoice68").close();
                                            app.callEvent("dataChangedInvoie68", [editmode, null]);
                                        } else {
                                            webix.message("Xoá không thành công !", "error");
                                        }
                                    });
                            }, 100);
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    shortcut: "F10",
                    view: "button",
                    id: "btnHoadonSave",
                    label: "Lưu tạm (F10)",
                    type: "form",
                    align: "center",
                    width: 120,
                    on: {
                        onClick: function () {
                            var self = this;
                            $$("btnHoadonSave").disable();
                            setTimeout(function () {
                                var item = $$("invoiceForms").getValues();
                                if (item.nlap_temp != null) {
                                    var nlap_temp = new Date(item.nlap_temp);
                                    nlap_temp = new Date(nlap_temp.getFullYear(), nlap_temp.getMonth(), nlap_temp.getDate());

                                    if ($$("nlap").getValue() < nlap_temp) {
                                        webix.message("Ngày hoá đơn thay thế hoặc điều chỉnh không được nhỏ hơn hoá đơn gốc!", "error");
                                        return;
                                    }
                                }
                                var table = $$("invoiceForms");
                                var record = $$("hoadon68_chitiet").serialize();
                                if (record.length == 0 && item.tlkthu == undefined) {
                                    webix.message("Bạn chưa bổ sung chi tiết khoản thu");
                                    return;
                                }
                                var mauso = $$("khieu").getValue().toString()[0];
                                for (var i = 0; i < record.length; i++) {
                                    var it = record[i];
                                    if (it["ten"] == null || it["ten"] == "") {
                                        webix.message("Bạn chưa nhập tên hàng");
                                        return;
                                    }
                                }
                                if (table.validate()) {
                                    var TTKhac = [];
                                    Object.keys(item).forEach(function (key) {
                                        if (key.includes("TTKhac_")) {
                                            var test = $$(key);
                                            if (test.config.editor === "nummeric" || test.config.editor === "autonumeric") {
                                                TTKhac.push({
                                                    ttruong: key.replace("TTKhac_", ""),
                                                    kdlieu: "decimal",
                                                    dlieu: item[key],
                                                });
                                            }
                                            else if (test.config.view === "text") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "string", dlieu: item[key] });
                                            else if (test.config.view === "datepicker") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "dateTime", dlieu: item[key] });
                                        }
                                    });
                                    var TTKhacItem = [];
                                    TTKhacItem.push({
                                        data: TTKhac,
                                    });
                                    item["hoadon68_khac"] = TTKhacItem;
                                    // var fn = Function(check);
                                    // var result = fn();
                                    // console.log(result);
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    var details = [];
                                    details.push({ data: record });
                                    item["details"] = details;
                                    var phi = [];
                                    phi.push({
                                        data: $$("hoadon68_phi").serialize(),
                                    });
                                    item["hoadon68_phi"] = phi;
                                    // hóa đơn không mã
                                    item.is_hdcma = 0;
                                    var item1 = [];
                                    item1.push(item);
                                    var data_post = { editmode: editmode, data: item1 };
                                    var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                    function afterSaveInvoiceSuccess(text) {
                                        var json = text.json();
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                            webix.$$("invoice68").close();

                                            if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            } else {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            }

                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    }

                                    function afterSaveInvoiceError(text) {
                                        table.enable();
                                        table.hideProgress();
                                        webix.message(text.json() + XmlHttpRequest, "error");
                                    }

                                    if (isSaveCustomerInfo) {

                                        var code = $$('mnmua') != null ? $$('mnmua').getValue() : null;
                                        var buyer_name = $$('tnmua') != null ? $$('tnmua').getValue() : null;
                                        var name = $$('ten') != null ? $$('ten').getValue() : null;
                                        var tax_code = $$('mst') != null ? $$('mst').getValue() : null;
                                        var email = $$('email') != null ? $$('email').getValue() : null;
                                        var address = $$('dchi') != null ? $$('dchi').getValue() : null;
                                        var tel = $$('sdtnmua') != null ? $$('sdtnmua').getValue() : null;
                                        var bank_account = $$('stknmua') != null ? $$('stknmua').getValue() : null;
                                        var bank_name = $$('tnhmua') != null ? $$('tnhmua').getValue() : null;
                                        var name_label = $$('ten') != null ? $$('ten').config.label : "Tên";
                                        var address_label = $$('dchi') != null ? $$('dchi').config.label : "Địa chỉ";

                                        var obj = {
                                            code: code,
                                            buyer_name: buyer_name,
                                            name: name,
                                            tax_code: tax_code,
                                            email: email,
                                            address: address,
                                            tel: tel,
                                            bank_account: bank_account,
                                            bank_name: bank_name,
                                        };

                                        var checkMessage = [];

                                        if (obj.code == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                        if (obj.name == "") checkMessage.push('"' + name_label + '" là trường bắt buộc nhập"');
                                        if (obj.address == "") checkMessage.push('"' + address_label + '" khách hảng là trường bắt buộc nhập"');

                                        var showConfirmUI = function () {
                                            webix.ui({
                                                view: "window",
                                                id: "check-customer-modal",
                                                type: "modal",
                                                modal: true,
                                                position: "center",
                                                head: {
                                                    height: 35,
                                                    cols: [
                                                        {
                                                            id: "head-form-check-customer",
                                                            view: "template",
                                                            css: "headform",
                                                            template: function (obj) {
                                                                return "<div style='text-align: center;'>Tạo mới khách hàng thất bại<div/>";
                                                            },
                                                        }
                                                    ],
                                                },
                                                body: {
                                                    padding: 10,
                                                    rows: [
                                                        {
                                                            rows: checkMessage.map(function (message) {
                                                                return {
                                                                    view: "template",
                                                                    template: "▶ " + message,
                                                                    autoheight: true, width: 350
                                                                }
                                                            }),
                                                        },
                                                        {
                                                            view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                        },
                                                        {
                                                            cols: [
                                                                {},
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                                                            .then(afterSaveInvoiceSuccess)
                                                                            .catch(afterSaveInvoiceError);
                                                                    }
                                                                },
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Nhập lại", type: "danger", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        table.enable();
                                                                        table.hideProgress();
                                                                    }
                                                                },
                                                                {}
                                                            ]
                                                        }
                                                    ]
                                                }
                                            }).show()
                                        }

                                        if (checkMessage.length > 0) {
                                            showConfirmUI();
                                        } else {
                                            customerCallApis.saveCustomer(obj).then(function (res) {
                                                res = res.json();

                                                if (!res.status) {
                                                    checkMessage.push(res.message.replace("P0001: ", ""));
                                                    showConfirmUI();
                                                } else {

                                                    webix.message("Lưu thông tin khách hàng thành công", "success"); hoadon68CallApis.hoadonSaveChange(data_post)
                                                        .then(afterSaveInvoiceSuccess)
                                                        .catch(afterSaveInvoiceError);
                                                }
                                            });
                                        }
                                    } else
                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                            .then(afterSaveInvoiceSuccess)
                                            .catch(afterSaveInvoiceError);;

                                }
                                $$("btnHoadonSave").enable();
                            }, 100);
                            $$("btnHoadonSave").enable();
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    view: "button",
                    hotkey: "esc",
                    label: "Hủy bỏ (ESC)",
                    align: "center",
                    type: "danger",
                    width: 120,
                    click: function () {
                        this.getTopParentView().close();
                        app.callEvent("dataChangedInvoie68", [editmode, null]);
                    },
                },
                {},
            ],
        },
    ];
    //FormDetail Tạo item trên trang from từ tab và data

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-iconInvoice",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formInvoice",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Test Form<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_InvoiceForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "invoice68",
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () { },
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "invoiceForms",
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {
                    // }
                },
                elements: el,
            },
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            if (item != null) {
                this.editgiatri(item);
                form.setValues(item);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
                var tablePhi = webix.$$("hoadon68_phi");
                var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                tablePhi.clearAll();
                tablePhi.load(urlPhi);
                var urlKhac = app.config.host + "/Invoice68/GetDataInvoiceKhac?id=" + item.id;
                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .get(urlKhac, function (text) {
                        var data = JSON.parse(text);
                        for (var i = 0; i < data.length; i++) {
                            try {
                                if ($$("TTKhac_" + data[i].ttruong) !== undefined && $$("TTKhac_" + data[i].ttruong) !== null) $$("TTKhac_" + data[i].ttruong).setValue(data[i]["dlieu"]);
                            } catch (e) { }
                        }
                    });
            }

            if (editmode == 2) {
            }
            // nếu có mẫu 04 (hóa đơn hủy)
            if (winconfig != null) {
                mau04 = winconfig;
                $$("btnHoadonSaveMau04").show();
                //$$("btnHoadonCQT").destructor();
                $$("btnHoadonSave").destructor();
            }
            this.getFormat(item["dvtte"]);
        },
        setValuesBangKe: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            tongtienHDonBke = item.tgtttbso;
            var form = win.getChildViews()[1];
            if (item != null) {
                this.editgiatri(item);
                form.setValues(item);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = "";
                if (editmode == 4) {
                    url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                } else {
                    url = app.config.host + "/Invoice68/GetDataInvoiceDetail_BangKe?id=" + item.id;
                }
                tableDetail.clearAll();
                tableDetail.load(url);
            }
            // nếu có mẫu 04 (hóa đơn hủy)
            if (winconfig != null) {
                mau04 = winconfig;
                $$("btnHoadonSaveMau04").show();
                //$$("btnHoadonCQT").destructor();
                $$("btnHoadonSave").destructor();
            }
            this.getFormat(item["dvtte"]);
        },
        editgiatri: function (item) {
            if (item["tdlap"] !== undefined) item["tdlap"] = removeTimeZoneT(item["tdlap"]);
            if (item["cqqdbants"] !== undefined) item["cqqdbants"] = removeTimeZoneT(item["cqqdbants"]);
            if (item["tgvchdtu"] !== undefined) item["tgvchdtu"] = removeTimeZoneT(item["tgvchdtu"]);
            if (item["tgvchdden"] !== undefined) item["tgvchdden"] = removeTimeZoneT(item["tgvchdden"]);
            if (item["nqdbants"] !== undefined) item["nqdbants"] = removeTimeZoneT(item["nqdbants"]);
            if (item["nbke"] !== undefined) item["nbke"] = removeTimeZoneT(item["nbke"]);
            if (item["hdktngay"] !== undefined) item["hdktngay"] = removeTimeZoneT(item["hdktngay"]);
            item["giamthuebanhang20"] = item["giamthuebanhang20"] == true ? 1 : 0;
            if (item["nbke"] !== undefined) item["nbke"] = removeTimeZoneT(item["nbke"]);
            if (item["ngccmnd"] !== undefined) item["ngccmnd"] = removeTimeZoneT(item["ngccmnd"]);
        },
        setcompany: function (item) {
            var url = app.config.host + "/System/GetInfoCompany";
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(url, function (text) {
                    var data = JSON.parse(text);
                    $$("ten_tc").setValue(data.name);
                    $$("mst_tc").setValue(data.tax_code);
                    $$("dchi_tc").setValue(data.address);
                    $$("sdtban").setValue(data.tel);
                    $$("tnhban").setValue(data.bank_name);
                    $$("stknban").setValue(data.bank_account);
                    //$$("tel_tc").setValue(data.tel);
                    if ($$("tinh_tc") != undefined) $$("tinh_tc").setValue(data.city);
                });
        },
        setEditMode: function (mode) {
            editmode = mode;
            //var form = webix.$$("invoiceForms");
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1 || editmode == 4) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            } else {
                if (editmode == 2 || editmode == 5) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
            this.setcompany();
        },
        copyValues: function (item) {
            var form = webix.$$("invoiceForms");
            var tableDetail = webix.$$("hoadon68_chitiet");
            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(url, function (text) {
                    var data = JSON.parse(text);

                    for (var i = 0; i < data.length; i++) {
                        data[i]["cthdon_id"] = null;
                        data[i]["hdon_id"] = null;
                    }

                    tableDetail.clearAll();
                    tableDetail.parse(data);
                });
            var tablePhi = webix.$$("hoadon68_phi");
            var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(urlPhi, function (text) {
                    var data = JSON.parse(text);

                    for (var i = 0; i < data.length; i++) {
                        data[i]["phi_id"] = null;
                        data[i]["hdon_id"] = null;
                    }

                    tablePhi.clearAll();
                    tablePhi.parse(data);
                });
            var urlKhac = app.config.host + "/Invoice68/GetDataInvoiceKhac?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(urlKhac, function (text) {
                    var data = JSON.parse(text);
                    for (var i = 0; i < data.length; i++) {
                        try {
                            if ($$("TTKhac_" + data[i].ttruong) !== undefined && $$("TTKhac_" + data[i].ttruong) !== null) $$("TTKhac_" + data[i].ttruong).setValue(data[i]["dlieu"]);
                        } catch (e) { }
                    }
                });
            // tableDetail.clearAll();
            // tableDetail.load(url);
            item["tthdon"] = 0;
            item["tthdon_original"] = 0;
            item["tthdon_old"] = 0;
            item["hdon_id"] = null;
            item["hdon68_id_lk"] = null;
            item["nky"] = null;
            item["id"] = webix.uid();
            item["giamthuebanhang20"] = item["giamthuebanhang20"] == true ? 1 : 0;
            item["nbke"] = null;

            this.editgiatri(item);
            form.setValues(item);

            this.getFormat();
        },
        getFormat: function (val) {
            renderFormat(val);
        },
        initUINew: function (cctbao_id) {
            $$("cctbao_id").setValue(cctbao_id);
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(app.config.host + "/Invoice68/getKyhieu?cctbao_id=" + cctbao_id, function (text) {
                    var data = JSON.parse(text);

                    if (data.length > 0) {
                        var form = $$("invoiceForms");
                        var values = form.getValues();

                        values["khieu"] = data[0]["khhdon"];
                        values["mcqtcap"] = data[0]["mccqthue"];
                        values["mcqtcap"] = data[0]["mccqthue"];
                        values["msbl_tncn"] = data[0]["khmbl"];

                        form.setValues(values);
                    }
                });
            this.getFormat();
        },
        initUI: function (windowconfig) {
            var rp = windowconfig;
            var vc_window = rp["data"][0];
            var tabs = vc_window.Tabs;
            var windowno = vc_window.code;
            $$("head-formInvoice").define("template", "<div>" + vc_window.name + "<div/>");
            el = [];
            col = [];
            var m = 0;

            if (vc_window.detail_layout != null && vc_window.detail_layout != "") {
                var layoutdetail = JSON.parse(vc_window.detail_layout);

                var layout_element = JSON.stringify(layoutdetail.elements);
                var json_layout = JSON.parse(layout_element);
                //console.log(json_layout);
                for (var i = 0; i < json_layout.length; i++) {
                    el.push(json_layout[i]);
                }

                var jsonElement = findJson.getObjects(JSON.parse(JSON.stringify(el)), "id", "");

                for (var i = 0; i < jsonElement.length; i++) {
                    //var item = jsonElement[i];
                    //var item = jsonElement[i];
                    var fields = rp["data"][0]["Tabs"][0]["Fields"];

                    for (var j = 0; j < fields.length; j++) {
                        var field = fields[j];

                        if (jsonElement[i].name == field.column_name) {
                            item = commonHD.CreatItemMaterFromData(field, windowno);
                            jsonElement[i] = item;

                            findJson.findAndReplace(el, jsonElement[i].name, item);
                        }
                    }
                }
                if (vc_window.window_type == "MasterDetail") {
                    for (var i = 0; i < tabs.length; i++) {
                        var tab = tabs[i];

                        if (tab.tab_type == "Master") {
                            continue;
                        }

                        var subCols = [];

                        for (var j = 0; j < tab.Fields.length; j++) {
                            var field = tab.Fields[j];

                            subCols.push(commonHD.CreatItemFromData(field, tab));
                        }

                        if (tab.tab_type == "Detail" && tab.foreign_key === "detail_tab") {
                            var item = {
                                id: "detail_tab",
                                header: "Chi tiết các khoản thu",
                                select: "cell",

                                body: {
                                    rows: [
                                        {
                                            view: "toolbar",
                                            height: 40,
                                            cols: [
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                    id: "addrow",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_chitiet");
                                                            var item = {
                                                                id: webix.uid(),
                                                            };
                                                            table.add(item);
                                                            table.select(item.id, "ma", false);
                                                            table.edit({
                                                                row: item.id,
                                                                column: "ma",
                                                            });
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                    id: "removerow",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_chitiet");

                                                            table.editStop();

                                                            var item = table.getSelectedItem();

                                                            if (!webix.isUndefined(item)) {
                                                                table.remove(item.id);
                                                                table.clearSelection();
                                                                return;
                                                            }

                                                            var editor = table.getEditState();

                                                            if (!webix.isUndefined(editor)) {
                                                                table.remove(editor.row);
                                                                table.clearSelection();
                                                                return;
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                    view: "button",
                                                    id: "copyrow",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_chitiet");

                                                            table.editStop();

                                                            var item = table.getSelectedItem();
                                                            if (item == null || item == undefined) {
                                                                webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                return;
                                                            }

                                                            var copy = webix.copy(item);
                                                            copy.cthdon_id = null;
                                                            copy.id = webix.uid();

                                                            table.add(copy);
                                                            table.unselect(item.id);
                                                            table.select(copy.id, "ma", false);
                                                            table.edit({
                                                                row: copy.id,
                                                                column: "ma",
                                                            });
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            view: "datatable",
                                            resizeColumn: true,
                                            id: "hoadon68_chitiet",
                                            editable: true,
                                            select: "cell",
                                            drag: true,
                                            scroll: true,
                                            columns: subCols,
                                            select_change: tab.select_change,
                                            cell_editstop: tab.cell_editstop,
                                            after_addrow: tab.after_addrow,
                                            after_delrow: tab.after_delrow,
                                            oncheck: tab.oncheck,
                                            on: {
                                                "data->onStoreUpdated": function () {
                                                    this.data.each(function (obj, i) {
                                                        obj.stt = i + 1;
                                                    });
                                                },
                                                onAfterLoad: function () {
                                                    var table = this;
                                                    var data = table.serialize();
                                                    data.forEach(function (entry) {
                                                        if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                            if (entry["stckhau"] != 0 || entry["tlckhau"] != 0) {
                                                                var ck = $$("check_chietkhau");
                                                                if (ck != undefined) {
                                                                    ck.setValue(1);
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    });
                                                },
                                                onCheck: function (row, column, state) {
                                                    var table = this;
                                                    if (column == "khuyen_mai") {
                                                        if (state == true) {
                                                        }
                                                    }
                                                },
                                                onAfterAdd: function (id, index) {
                                                    if (this.config.after_addrow != null) {
                                                        var fn = Function("id", "index", "tableId", this.config.after_addrow);
                                                        fn(id, index, this.config.id);
                                                    }
                                                },
                                                onAfterDelete: function (id) {
                                                    if (this.config.after_delrow != null) {
                                                        var fn = Function("id", "tableId", this.config.after_delrow);
                                                        fn(id, this.config.id);
                                                    }
                                                },
                                                onAfterEditStop: function (state, editor, ignore) {
                                                    if (state.value === state.old) return;

                                                    if (this.config.cell_editstop != null) {
                                                        var fn = Function("state", "editor", "ignore", "tableId", this.config.cell_editstop);
                                                        fn(state, editor, ignore, this.config.id);
                                                    }
                                                },
                                            },
                                        },
                                    ],
                                },
                            };

                            findJson.findAndReplace(el, tab.foreign_key, item);
                            m++;
                            //cells.push(item);
                        }
                        if (tab.tab_type == "Detail" && tab.foreign_key === "phi_tab") {
                            var item = {
                                id: "phi_tab",
                                header: "Tiền phí/lệ phí",
                                select: "cell",
                                hidden: tab.hidden,
                                body: {
                                    rows: [
                                        {
                                            view: "toolbar",
                                            height: 40,
                                            cols: [
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                    id: "addrow2",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_phi");
                                                            var item = {
                                                                id: webix.uid(),
                                                                tienphi: 0,
                                                            };
                                                            table.add(item);
                                                            table.select(item.id);
                                                            table.edit({
                                                                row: item.id,
                                                                column: "tnphi",
                                                            });
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                    id: "removerow2",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_phi");
                                                            table.editStop();
                                                            var item = table.getSelectedItem();
                                                            if (!webix.isUndefined(item)) {
                                                                table.remove(item.id);
                                                                table.clearSelection();
                                                                return;
                                                            }

                                                            var editor = table.getEditState();

                                                            if (!webix.isUndefined(editor)) {
                                                                table.remove(editor.row);
                                                                table.clearSelection();
                                                                return;
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                    view: "button",
                                                    id: "copyrow2",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_phi");

                                                            table.editStop();

                                                            var item = table.getSelectedItem();
                                                            if (item == null || item == undefined) {
                                                                webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                return;
                                                            }
                                                            var copy = webix.copy(item);
                                                            copy.id = webix.uid();

                                                            table.add(copy);
                                                            table.unselect(item.id);
                                                            table.select(copy.id, "tnphi", false);
                                                            table.edit({
                                                                row: copy.id,
                                                                column: "tnphi",
                                                            });
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            view: "datatable",
                                            resizeColumn: true,
                                            id: "hoadon68_phi",
                                            editable: true,
                                            select: "cell",
                                            drag: true,
                                            scroll: true,
                                            columns: subCols,
                                            select_change: tab.select_change,
                                            cell_editstop: tab.cell_editstop,
                                            after_addrow: tab.after_addrow,
                                            after_delrow: tab.after_delrow,
                                            oncheck: tab.oncheck,
                                            on: {
                                                onAfterAdd: function (id, index) {
                                                    if (this.config.after_addrow != null) {
                                                        var fn = Function("id", "index", "tableId", this.config.after_addrow);
                                                        fn(id, index, this.config.id);
                                                    }
                                                },
                                                onAfterDelete: function (id) {
                                                    if (this.config.after_delrow != null) {
                                                        var fn = Function("id", "tableId", this.config.after_delrow);
                                                        fn(id, this.config.id);
                                                    }
                                                },
                                                onAfterEditStop: function (state, editor, ignore) {
                                                    if (state.value === state.old) return;

                                                    if (this.config.cell_editstop != null) {
                                                        var fn = Function("state", "editor", "ignore", "tableId", this.config.cell_editstop);
                                                        fn(state, editor, ignore, this.config.id);
                                                    }
                                                },
                                            },
                                        },
                                    ],
                                },
                            };

                            findJson.findAndReplace(el, "phi_tab", item);
                            m++;
                        }
                    }
                }

                el.push({
                    // paddingY:10,
                    margin: 10,
                    cols: cols,
                });
                webix.ui(el, $$("invoiceForms"));
                //$$("tab_replace").define("tabbar",{width:150 * m});
                //console.log(jsonElement);

                if (windowno == "WIN00791" || windowno == "WIN00792" || windowno == "WIN00793") {
                    //$$("btnHoadonCQT").hide();
                }
                this.SetDefaultValue(windowconfig);
            }
        },
        SetDefaultValue: function (winconfig) {
            var form = webix.$$("invoiceForms");
            var item = form.getValues();
            var vc_window = winconfig["data"][0];

            var tabs = vc_window.Tabs;

            for (var i = 0; i < tabs.length; i++) {
                var tab = tabs[i];

                if (tab.tab_type == "Normal" || tab.tab_type == "Master") {
                    var fields = tab.Fields;

                    for (var j = 0; j < fields.length; j++) {
                        var field = fields[j];

                        if (field.column_name == tab.table_name + "_id") {
                            item[field.column_name] = null;
                        }

                        if (field.column_name == "branch_code") {
                            item[field.column_name] = user.getDvcsID();
                        }

                        if (field.default_value != null) {
                            var defaultValue = field.default_value.toString();

                            if (defaultValue.startsWith("@Default=")) {
                                item[field.column_name] = defaultValue.replace("@Default=", "");
                            }

                            if (defaultValue.startsWith("@JS=")) {
                                var fn = Function(defaultValue.replace("@JS=", ""));
                                item[field.column_name] = fn();
                            }
                        }
                    }
                }
            }

            form.setValues(item);
        },
    };
});

define('views/forms/formhoadon78tncn',["app", "locale", "models/user", "models/findjson", "views/commonHD", "callApis/hoadon68", "callApis/customer"], function (app, _, user, findJson, commonHD, hoadon68CallApis, customerCallApis) {
    var editmode = 0;
    var tongtienHDonBke = 0;
    var mau04 = {};
    formatSoDefault = {
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0,
    };

    var el = [];
    function renderFormat(val) {
        if (val === undefined) val = "VND";
        var url = app.config.host + "/Invoice68/GetDecimalPlace?ma_nt=" + val;
        var table_chitiet = webix.$$("hoadon68_chitiet");
        var table_phi = webix.$$("hoadon68_phi");
        var table = $$("invoiceForms");
    }

    //FormButton
    var cols = [
        {
            margin: 10,
            cols: [
                {},
                {
                    shortcut: "F10",
                    view: "button",
                    id: "btnBangKeSave",
                    label: "Lưu (F10)",
                    type: "form",
                    align: "center",
                    width: 120,
                    hidden: true,
                    on: {
                        onClick: function () {
                            var self = this;
                            setTimeout(function () {
                                var tongtienBangKeCT = webix.$$("tgtttbso").getValue();
                                var item = $$("invoiceForms").getValues();
                                var table = $$("invoiceForms");
                                var record = $$("hoadon68_chitiet").serialize();
                                var mauso = $$("khieu").getValue().toString()[0];
                                for (var i = 0; i < record.length; i++) {
                                    var it = record[i];

                                    if (it["ten"] == null || it["ten"] == "") {
                                        webix.message("Bạn chưa nhập tên hàng");
                                        return;
                                    }
                                    if (it.kmai != null && (it.kmai.toString() === "1" || it.kmai.toString() === "5")) {
                                        //var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                        //if (!bool) {
                                        //    webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                        //    return;
                                        //}
                                        if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                            webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                            return;
                                        }
                                    }
                                }

                                if (tongtienHDonBke != tongtienBangKeCT) {
                                    webix.message("Tổng tiền chi tiết bảng kê khác tổng tiền của hoá đơn!", "error");
                                    return false;
                                }

                                if (table.validate()) {
                                    // var fn = Function(check);
                                    // var result = fn();
                                    // console.log(result);
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    var details = [];
                                    details.push({ data: record });
                                    item["details"] = details;
                                    var phi = [];
                                    phi.push({
                                        data: $$("hoadon68_phi").serialize(),
                                    });
                                    item["hoadon68_phi"] = phi;
                                    // hóa đơn không mã
                                    item.is_hdcma = 0;
                                    var item1 = [];
                                    item1.push(item);
                                    var data_post = { editmode: editmode, data: item1 };

                                    var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                    function hoadonSaveChange() {
                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/Invoice68/hoadonSaveChange", data_post, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    table.enable();
                                                    table.hideProgress();
                                                    webix.message(text + XmlHttpRequest, "error");
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var json = JSON.parse(text);
                                                    table.enable();
                                                    table.hideProgress();
                                                    if (!json.hasOwnProperty("error")) {
                                                        webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                                        if (isSaveCustomerInfo)
                                                            if (!json.hasOwnProperty("message_warning")) {
                                                                webix.message("Lưu thông tin khách hàng thành công!", "success");
                                                            }

                                                        webix.$$("invoice68").close();

                                                        if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                            app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                        } else {
                                                            app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                        }
                                                    } else {
                                                        webix.message(json.error, "error");
                                                    }
                                                },
                                            });
                                    }

                                    if ($$('is_save_customer_info') != null && $$('is_save_customer_info').getValue() == 1) {
                                        var mnmuaValue = $$('mnmua').getValue();
                                        var tenValue = $$('ten').getValue();
                                        var mstValue = $$('mst').getValue();
                                        var dchiValue = $$('dchi').getValue();

                                        var checkMessage = [];

                                        if (mnmuaValue == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                        if (tenValue == "") checkMessage.push('"Tên" khách hảng là trường bắt buộc nhập"');
                                        if (dchiValue == "") checkMessage.push('"Địa chỉ" khách hảng là trường bắt buộc nhập"');

                                        var showConfirmUI = function () {
                                            webix.ui({
                                                view: "window",
                                                id: "check-customer-modal",
                                                type: "modal",
                                                modal: true,
                                                position: "center",
                                                head: {
                                                    height: 35,
                                                    cols: [
                                                        {
                                                            id: "head-form-check-customer",
                                                            view: "template",
                                                            css: "headform",
                                                            template: function (obj) {
                                                                return "<div>&nbsp;Tạo mới khách hàng thất bại<div/>";
                                                            },
                                                        }
                                                    ],
                                                },
                                                body: {
                                                    padding: 10,
                                                    rows: [
                                                        {
                                                            rows: checkMessage.map(function (message) {
                                                                return {
                                                                    view: "template",
                                                                    template: "▶ " + message,
                                                                    autoheight: true, width: 350
                                                                }
                                                            }),
                                                        },
                                                        {
                                                            view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        hoadonSaveChange();
                                                                    }
                                                                },
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Hủy", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        table.enable();
                                                                        table.hideProgress();
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            }).show()
                                        }

                                        if (mnmuaValue == "" && mstValue == "") {
                                            showConfirmUI();
                                        } else {
                                            webix
                                                .ajax()
                                                .headers({ "Content-type": "application/json" })
                                                .get(app.config.host + "/Customer/CheckExistedCustomerCodeOrTaxCode?code=" + mnmuaValue + "&taxcode=" + mstValue, null, function (res) {

                                                    res = JSON.parse(res);
                                                    if (res.length > 0) {
                                                        for (var i = 0; i < res.length; i++) {
                                                            if (res[i].code == mnmuaValue) {
                                                                checkMessage.push('"Mã" khách hàng đã tồn tại');
                                                            }
                                                            if (res[i].tax_code == mstValue) {
                                                                checkMessage.push('"Mã" số thuế của khách hàng đã tồn tại');
                                                            }
                                                        }
                                                    }

                                                    if (checkMessage.length > 0) {
                                                        showConfirmUI();
                                                    } else {
                                                        hoadonSaveChange();
                                                    }
                                                });
                                        }
                                    } else
                                        hoadonSaveChange();
                                }
                            }, 100);
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    view: "button",
                    id: "btnBangKeDelete",
                    label: "Xoá",
                    type: "danger",
                    align: "center",
                    width: 80,
                    hidden: true,
                    on: {
                        onClick: function () {
                            var self = this;
                            setTimeout(function () {
                                var item = $$("invoiceForms").getValues();
                                var url = app.config.host + "/Invoice68/DeleteBangKeHoaDon?id=" + item.id;
                                var table = $$("invoiceForms");
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();
                                webix
                                    .ajax()
                                    .headers({ "Content-Type": "application/json" })
                                    .post(url, function (result) {
                                        if (result == "true") {
                                            webix.message("Đã xoá bảng kê !");
                                            table.enable();
                                            table.hideProgress();
                                            webix.$$("invoice68").close();
                                            app.callEvent("dataChangedInvoie68", [editmode, null]);
                                        } else {
                                            webix.message("Xoá không thành công !", "error");
                                        }
                                    });
                            }, 100);
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    shortcut: "F10",
                    view: "button",
                    id: "btnHoadonSave",
                    label: "Lưu tạm (F10)",
                    type: "form",
                    align: "center",
                    width: 120,
                    on: {
                        onClick: function () {
                            var self = this;
                            $$("btnHoadonSave").disable();
                            setTimeout(function () {
                                var item = $$("invoiceForms").getValues();
                                if (item.nlap_temp != null) {
                                    var nlap_temp = new Date(item.nlap_temp);
                                    nlap_temp = new Date(nlap_temp.getFullYear(), nlap_temp.getMonth(), nlap_temp.getDate());

                                    if ($$("nlap").getValue() < nlap_temp) {
                                        webix.message("Ngày hoá đơn thay thế hoặc điều chỉnh không được nhỏ hơn hoá đơn gốc!", "error");
                                        return;
                                    }
                                }
                                var table = $$("invoiceForms");
                                var record = $$("hoadon68_chitiet").serialize();
                                var mauso = $$("khieu").getValue().toString()[0];
                                for (var i = 0; i < record.length; i++) {
                                    var it = record[i];
                                    if (it["ten"] == null || it["ten"] == "") {
                                        webix.message("Bạn chưa nhập tên hàng");
                                        return;
                                    }
                                    if (it.kmai != null && (it.kmai.toString() === "1" || it.kmai.toString() === "5")) {
                                        /*var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                    if (!bool) {
                                        webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                        return;
                                    }*/
                                        if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                            webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                            return;
                                        }
                                    }
                                }
                                if (table.validate()) {
                                    var TTKhac = [];
                                    Object.keys(item).forEach(function (key) {
                                        if (key.includes("TTKhac_")) {
                                            var test = $$(key);
                                            if (test.config.editor === "nummeric" || test.config.editor === "autonumeric") {
                                                TTKhac.push({
                                                    ttruong: key.replace("TTKhac_", ""),
                                                    kdlieu: "decimal",
                                                    dlieu: item[key],
                                                });
                                            }
                                            else if (test.config.view === "text") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "string", dlieu: item[key] });
                                            else if (test.config.view === "datepicker") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "dateTime", dlieu: item[key] });
                                        }
                                    });
                                    var TTKhacItem = [];
                                    TTKhacItem.push({
                                        data: TTKhac,
                                    });
                                    item["hoadon68_khac"] = TTKhacItem;
                                    // var fn = Function(check);
                                    // var result = fn();
                                    // console.log(result);
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    var details = [];
                                    details.push({ data: record });
                                    item["details"] = details;
                                    var phi = [];
                                    phi.push({
                                        data: $$("hoadon68_phi").serialize(),
                                    });
                                    item["hoadon68_phi"] = phi;
                                    // hóa đơn không mã
                                    item.is_hdcma = 0;
                                    var item1 = [];
                                    item1.push(item);
                                    var data_post = { editmode: editmode, data: item1 };

                                    var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                    function afterSaveInvoiceSuccess(text) {
                                        var json = text.json();
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                            webix.$$("invoice68").close();

                                            if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            } else {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            }
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    }

                                    function afterSaveInvoiceError(text) {
                                        table.enable();
                                        table.hideProgress();
                                        webix.message(text.json() + XmlHttpRequest, "error");
                                    }

                                    if (isSaveCustomerInfo) {


                                        var code = $$('mnmua') != null ? $$('mnmua').getValue() : null;
                                        var buyer_name = $$('tnmua') != null ? $$('tnmua').getValue() : null;
                                        var name = $$('ten') != null ? $$('ten').getValue() : null;
                                        var tax_code = $$('mst') != null ? $$('mst').getValue() : null;
                                        var email = $$('email') != null ? $$('email').getValue() : null;
                                        var address = $$('dchi') != null ? $$('dchi').getValue() : null;
                                        var tel = $$('sdtnmua') != null ? $$('sdtnmua').getValue() : null;
                                        var bank_account = $$('stknmua') != null ? $$('stknmua').getValue() : null;
                                        var bank_name = $$('tnhmua') != null ? $$('tnhmua').getValue() : null;
                                        var name_label = $$('ten') != null ? $$('ten').config.label : "Tên";
                                        var address_label = $$('dchi') != null ? $$('dchi').config.label : "Địa chỉ";

                                        var obj = {
                                            code: code,
                                            buyer_name: buyer_name,
                                            name: name,
                                            tax_code: tax_code,
                                            email: email,
                                            address: address,
                                            tel: tel,
                                            bank_account: bank_account,
                                            bank_name: bank_name,
                                        };

                                        var checkMessage = [];

                                        if (obj.code == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                        if (obj.name == "") checkMessage.push('"' + name_label + '" là trường bắt buộc nhập"');
                                        if (obj.address == "") checkMessage.push('"' + address_label + '" khách hảng là trường bắt buộc nhập"');

                                        var showConfirmUI = function () {
                                            webix.ui({
                                                view: "window",
                                                id: "check-customer-modal",
                                                type: "modal",
                                                modal: true,
                                                position: "center",
                                                head: {
                                                    height: 35,
                                                    cols: [
                                                        {
                                                            id: "head-form-check-customer",
                                                            view: "template",
                                                            css: "headform",
                                                            template: function (obj) {
                                                                return "<div style='text-align: center;'>Tạo mới khách hàng thất bại<div/>";
                                                            },
                                                        }
                                                    ],
                                                },
                                                body: {
                                                    padding: 10,
                                                    rows: [
                                                        {
                                                            rows: checkMessage.map(function (message) {
                                                                return {
                                                                    view: "template",
                                                                    template: "▶ " + message,
                                                                    autoheight: true, width: 350
                                                                }
                                                            }),
                                                        },
                                                        {
                                                            view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                        },
                                                        {
                                                            cols: [
                                                                {},
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                                                            .then(afterSaveInvoiceSuccess)
                                                                            .catch(afterSaveInvoiceError);
                                                                    }
                                                                },
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Nhập lại", type: "danger", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        table.enable();
                                                                        table.hideProgress();
                                                                    }
                                                                },
                                                                {}
                                                            ]
                                                        }
                                                    ]
                                                }
                                            }).show()
                                        }

                                        if (checkMessage.length > 0) {
                                            showConfirmUI();
                                        } else {
                                            customerCallApis.saveCustomer(obj).then(function (res) {
                                                res = res.json();

                                                if (!res.status) {
                                                    checkMessage.push(res.message.replace("P0001: ", ""));
                                                    showConfirmUI();
                                                } else {

                                                    webix.message("Lưu thông tin khách hàng thành công", "success"); hoadon68CallApis.hoadonSaveChange(data_post)
                                                        .then(afterSaveInvoiceSuccess)
                                                        .catch(afterSaveInvoiceError);
                                                }
                                            });
                                        }
                                    } else
                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                            .then(afterSaveInvoiceSuccess)
                                            .catch(afterSaveInvoiceError);;

                                }
                                $$("btnHoadonSave").enable();
                            }, 100);
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    shortcut: "F11",
                    view: "button",
                    id: "btnHoadonCQT",
                    label: "Ký và gửi CQT (F11)",
                    type: "form",
                    align: "center",
                    width: 150,
                    on: {
                        onClick: function () {
                            var self = this;

                            $$("btnHoadonCQT").disable();
                            setTimeout(function () {
                                var item = $$("invoiceForms").getValues();
                                if (item.nlap_temp != null) {
                                    var nlap_temp = new Date(item.nlap_temp);
                                    nlap_temp = new Date(nlap_temp.getFullYear(), nlap_temp.getMonth(), nlap_temp.getDate());

                                    if ($$("nlap").getValue() < nlap_temp) {
                                        webix.message("Ngày hoá đơn thay thế hoặc điều chỉnh không được nhỏ hơn hoá đơn gốc!", "error");
                                        return;
                                    }
                                }
                                var table = $$("invoiceForms");
                                var record = $$("hoadon68_chitiet").serialize();
                                var mauso = $$("khieu").getValue().toString()[0];
                                for (var i = 0; i < record.length; i++) {
                                    var it = record[i];
                                    if (it["ten"] == null || it["ten"] == "") {
                                        webix.message("Bạn chưa nhập tên hàng");
                                        return;
                                    }
                                    if (it.kmai != null && (it.kmai.toString() === "1" || it.kmai.toString() === "5")) {
                                        /*var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                    if (!bool) {
                                        webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                        return;
                                    }*/
                                        if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                            webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                            return;
                                        }
                                    }
                                }
                                if (table.validate()) {
                                    var TTKhac = [];
                                    Object.keys(item).forEach(function (key) {
                                        if (key.includes("TTKhac_")) {
                                            var test = $$(key);
                                            if (test.config.editor === "nummeric" || test.config.editor === "autonumeric") {
                                                TTKhac.push({
                                                    ttruong: key.replace("TTKhac_", ""),
                                                    kdlieu: "decimal",
                                                    dlieu: item[key],
                                                });
                                            }
                                            else if (test.config.view === "text") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "string", dlieu: item[key] });
                                            else if (test.config.view === "datepicker") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "dateTime", dlieu: item[key] });
                                        }
                                    });
                                    var TTKhacItem = [];
                                    TTKhacItem.push({
                                        data: TTKhac,
                                    });
                                    item["hoadon68_khac"] = TTKhacItem;
                                    // var fn = Function(check);
                                    // var result = fn();
                                    // console.log(result);
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    var details = [];
                                    details.push({ data: $$("hoadon68_chitiet").serialize() });
                                    item["details"] = details;
                                    var phi = [];
                                    phi.push({
                                        data: $$("hoadon68_phi").serialize(),
                                    });
                                    item["hoadon68_phi"] = phi;
                                    // hóa đơn không mã
                                    item.is_hdcma = 0;
                                    var item1 = [];
                                    item1.push(item);
                                    var data_post = { editmode: editmode, data: item1 };

                                    var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                    function afterSaveInvoiceSuccess(text) {
                                        var json = text.json();
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                            webix.$$("invoice68").close();

                                            if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            } else {
                                                app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                            }
                                            var lsthdon_id = [];
                                            lsthdon_id.push(json.data.hdon_id);
                                            commonHD.ExcuteHoaDon(lsthdon_id, true, false);
                                        } else {
                                            webix.message(json.error, "error");
                                        }
                                    }

                                    function afterSaveInvoiceError(text) {
                                        table.enable();
                                        table.hideProgress();
                                        webix.message(text.json() + XmlHttpRequest, "error");
                                    }

                                    if (isSaveCustomerInfo) {


                                        var code = $$('mnmua') != null ? $$('mnmua').getValue() : null;
                                        var buyer_name = $$('tnmua') != null ? $$('tnmua').getValue() : null;
                                        var name = $$('ten') != null ? $$('ten').getValue() : null;
                                        var tax_code = $$('mst') != null ? $$('mst').getValue() : null;
                                        var email = $$('email') != null ? $$('email').getValue() : null;
                                        var address = $$('dchi') != null ? $$('dchi').getValue() : null;
                                        var tel = $$('sdtnmua') != null ? $$('sdtnmua').getValue() : null;
                                        var bank_account = $$('stknmua') != null ? $$('stknmua').getValue() : null;
                                        var bank_name = $$('tnhmua') != null ? $$('tnhmua').getValue() : null;
                                        var name_label = $$('ten') != null ? $$('ten').config.label : "Tên";
                                        var address_label = $$('dchi') != null ? $$('dchi').config.label : "Địa chỉ";

                                        var obj = {
                                            code: code,
                                            buyer_name: buyer_name,
                                            name: name,
                                            tax_code: tax_code,
                                            email: email,
                                            address: address,
                                            tel: tel,
                                            bank_account: bank_account,
                                            bank_name: bank_name,
                                        };

                                        var checkMessage = [];

                                        if (obj.code == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                        if (obj.name == "") checkMessage.push('"' + name_label + '" là trường bắt buộc nhập"');
                                        if (obj.address == "") checkMessage.push('"' + address_label + '" khách hảng là trường bắt buộc nhập"');

                                        var showConfirmUI = function () {
                                            webix.ui({
                                                view: "window",
                                                id: "check-customer-modal",
                                                type: "modal",
                                                modal: true,
                                                position: "center",
                                                head: {
                                                    height: 35,
                                                    cols: [
                                                        {
                                                            id: "head-form-check-customer",
                                                            view: "template",
                                                            css: "headform",
                                                            template: function (obj) {
                                                                return "<div style='text-align: center;'>Tạo mới khách hàng thất bại<div/>";
                                                            },
                                                        }
                                                    ],
                                                },
                                                body: {
                                                    padding: 10,
                                                    rows: [
                                                        {
                                                            rows: checkMessage.map(function (message) {
                                                                return {
                                                                    view: "template",
                                                                    template: "▶ " + message,
                                                                    autoheight: true, width: 350
                                                                }
                                                            }),
                                                        },
                                                        {
                                                            view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                        },
                                                        {
                                                            cols: [
                                                                {},
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                                                            .then(afterSaveInvoiceSuccess)
                                                                            .catch(afterSaveInvoiceError);
                                                                    }
                                                                },
                                                                {
                                                                    width: 100,
                                                                    view: "button", value: "Nhập lại", type: "danger", click: function () {
                                                                        $$('check-customer-modal').hide();
                                                                        table.enable();
                                                                        table.hideProgress();
                                                                    }
                                                                },
                                                                {}
                                                            ]
                                                        }
                                                    ]
                                                }
                                            }).show()
                                        }

                                        if (checkMessage.length > 0) {
                                            showConfirmUI();
                                        } else {
                                            customerCallApis.saveCustomer(obj).then(function (res) {
                                                res = res.json();

                                                if (!res.status) {
                                                    checkMessage.push(res.message.replace("P0001: ", ""));
                                                    showConfirmUI();
                                                } else {

                                                    webix.message("Lưu thông tin khách hàng thành công", "success"); hoadon68CallApis.hoadonSaveChange(data_post)
                                                        .then(afterSaveInvoiceSuccess)
                                                        .catch(afterSaveInvoiceError);
                                                }
                                            });
                                        }
                                    } else
                                        hoadon68CallApis.hoadonSaveChange(data_post)
                                            .then(afterSaveInvoiceSuccess)
                                            .catch(afterSaveInvoiceError);;

                                }
                                $$("btnHoadonCQT").enable();
                            }, 100);
                        },
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    view: "button",
                    hotkey: "esc",
                    label: "Hủy bỏ (ESC)",
                    align: "center",
                    type: "danger",
                    width: 120,
                    click: function () {
                        this.getTopParentView().close();
                        app.callEvent("dataChangedInvoie68", [editmode, null]);
                    },
                },
                {},
            ],
        },
    ];
    //FormDetail Tạo item trên trang from từ tab và data

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-iconInvoice",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "",
                    },
                    {
                        id: "head-formInvoice",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Test Form<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_InvoiceForms",
                        tooltip: _("HELPER"),
                        click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        },
                    },
                ],
            },
            id: "invoice68",
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () { },
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "invoiceForms",
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {
                    // }
                },
                elements: el,
            },
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            if (item != null) {
                this.editgiatri(item);
                form.setValues(item);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
                var tablePhi = webix.$$("hoadon68_phi");
                var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                tablePhi.clearAll();
                tablePhi.load(urlPhi);
                var urlKhac = app.config.host + "/Invoice68/GetDataInvoiceKhac?id=" + item.id;
                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .get(urlKhac, function (text) {
                        var data = JSON.parse(text);
                        for (var i = 0; i < data.length; i++) {
                            try {
                                if ($$("TTKhac_" + data[i].ttruong) !== undefined && $$("TTKhac_" + data[i].ttruong) !== null) $$("TTKhac_" + data[i].ttruong).setValue(data[i]["dlieu"]);
                            } catch (e) { }
                        }
                    });
            }

            if (editmode == 2) {
            }
            // nếu có mẫu 04 (hóa đơn hủy)
            if (winconfig != null) {
                mau04 = winconfig;
                $$("btnHoadonSaveMau04").show();
                $$("btnHoadonCQT").destructor();
                $$("btnHoadonSave").destructor();
            }
            //this.getFormat(item["dvtte"]);
        },
        setValuesBangKe: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            tongtienHDonBke = item.tgtttbso;
            var form = win.getChildViews()[1];
            if (item != null) {
                this.editgiatri(item);
                form.setValues(item);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = "";
                if (editmode == 4) {
                    url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                } else {
                    url = app.config.host + "/Invoice68/GetDataInvoiceDetail_BangKe?id=" + item.id;
                }
                tableDetail.clearAll();
                tableDetail.load(url);
            }
            // nếu có mẫu 04 (hóa đơn hủy)
            if (winconfig != null) {
                mau04 = winconfig;
                $$("btnHoadonSaveMau04").show();
                $$("btnHoadonCQT").destructor();
                $$("btnHoadonSave").destructor();
            }
            //this.getFormat(item["dvtte"]);
        },
        editgiatri: function (item) {
            if (item["tdlap"] !== undefined) item["tdlap"] = removeTimeZoneT(item["tdlap"]);
            if (item["cqqdbants"] !== undefined) item["cqqdbants"] = removeTimeZoneT(item["cqqdbants"]);
            if (item["tgvchdtu"] !== undefined) item["tgvchdtu"] = removeTimeZoneT(item["tgvchdtu"]);
            if (item["tgvchdden"] !== undefined) item["tgvchdden"] = removeTimeZoneT(item["tgvchdden"]);
            if (item["nqdbants"] !== undefined) item["nqdbants"] = removeTimeZoneT(item["nqdbants"]);
            if (item["nbke"] !== undefined) item["nbke"] = removeTimeZoneT(item["nbke"]);
            if (item["hdktngay"] !== undefined) item["hdktngay"] = removeTimeZoneT(item["hdktngay"]);
            item["giamthuebanhang20"] = item["giamthuebanhang20"] == true ? 1 : 0;
            if (item["nbke"] !== undefined) item["nbke"] = removeTimeZoneT(item["nbke"]);
            if (item["ngccmnd"] !== undefined) item["ngccmnd"] = removeTimeZoneT(item["ngccmnd"]);
        },
        setcompany: function (item) {
            var url = app.config.host + "/invoice68/GetInfoCompany";
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(url, function (text) {
                    var data = JSON.parse(text);
                    $$("ten_tc").setValue(data.name);
                    $$("mst_tc").setValue(data.tax_code);
                    $$("dchi_tc").setValue(data.address);
                    $$("tel_tc").setValue(data.tel);
                    $$("tinh_tc").setValue(data.city);
                });
        },
        setEditMode: function (mode) {
            editmode = mode;
            //var form = webix.$$("invoiceForms");
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1 || editmode == 4) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            } else {
                if (editmode == 2 || editmode == 5) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
            this.setcompany();
        },
        copyValues: function (item) {
            var form = webix.$$("invoiceForms");
            var tableDetail = webix.$$("hoadon68_chitiet");
            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(url, function (text) {
                    var data = JSON.parse(text);

                    for (var i = 0; i < data.length; i++) {
                        data[i]["cthdon_id"] = null;
                        data[i]["hdon_id"] = null;
                    }

                    tableDetail.clearAll();
                    tableDetail.parse(data);
                });
            var tablePhi = webix.$$("hoadon68_phi");
            var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(urlPhi, function (text) {
                    var data = JSON.parse(text);

                    for (var i = 0; i < data.length; i++) {
                        data[i]["phi_id"] = null;
                        data[i]["hdon_id"] = null;
                    }

                    tablePhi.clearAll();
                    tablePhi.parse(data);
                });
            var urlKhac = app.config.host + "/Invoice68/GetDataInvoiceKhac?id=" + item.id;
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(urlKhac, function (text) {
                    var data = JSON.parse(text);
                    for (var i = 0; i < data.length; i++) {
                        try {
                            if ($$("TTKhac_" + data[i].ttruong) !== undefined && $$("TTKhac_" + data[i].ttruong) !== null) $$("TTKhac_" + data[i].ttruong).setValue(data[i]["dlieu"]);
                        } catch (e) { }
                    }
                });
            // tableDetail.clearAll();
            // tableDetail.load(url);
            item["tthdon"] = 0;
            item["tthdon_original"] = 0;
            item["tthdon_old"] = 0;
            item["hdon_id"] = null;
            item["hdon68_id_lk"] = null;
            item["nky"] = null;
            item["id"] = webix.uid();
            item["giamthuebanhang20"] = item["giamthuebanhang20"] == true ? 1 : 0;
            item["nbke"] = null;

            this.editgiatri(item);
            form.setValues(item);

            this.getFormat();
        },
        getFormat: function (val) {
            //commonHD.renderFormat(val);
        },
        initUINew: function (cctbao_id) {
            $$("cctbao_id").setValue(cctbao_id);
            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(app.config.host + "/Invoice68/getKyhieu?cctbao_id=" + cctbao_id, function (text) {
                    var data = JSON.parse(text);

                    if (data.length > 0) {
                        var form = $$("invoiceForms");
                        var values = form.getValues();

                        values["khieu"] = data[0]["khhdon"];
                        values["mcqtcap"] = data[0]["mccqthue"];
                        values["mcqtcap"] = data[0]["mccqthue"];
                        values["msbl_tncn"] = data[0]["khmbl"];

                        form.setValues(values);
                    }
                });
            this.getFormat();
        },
        initUI: function (windowconfig) {
            var rp = windowconfig;
            var vc_window = rp["data"][0];
            var tabs = vc_window.Tabs;
            var windowno = vc_window.code;
            $$("head-formInvoice").define("template", "<div>" + vc_window.name + "<div/>");
            el = [];
            col = [];
            var m = 0;

            if (vc_window.detail_layout != null && vc_window.detail_layout != "") {
                var layoutdetail = JSON.parse(vc_window.detail_layout);

                var layout_element = JSON.stringify(layoutdetail.elements);
                var json_layout = JSON.parse(layout_element);
                //console.log(json_layout);
                for (var i = 0; i < json_layout.length; i++) {
                    el.push(json_layout[i]);
                }

                var jsonElement = findJson.getObjects(JSON.parse(JSON.stringify(el)), "id", "");

                for (var i = 0; i < jsonElement.length; i++) {
                    //var item = jsonElement[i];
                    //var item = jsonElement[i];
                    var fields = rp["data"][0]["Tabs"][0]["Fields"];

                    for (var j = 0; j < fields.length; j++) {
                        var field = fields[j];

                        if (jsonElement[i].name == field.column_name) {
                            item = commonHD.CreatItemMaterFromData(field, windowno);
                            jsonElement[i] = item;

                            findJson.findAndReplace(el, jsonElement[i].name, item);
                        }
                    }
                }
                if (vc_window.window_type == "MasterDetail") {
                    for (var i = 0; i < tabs.length; i++) {
                        var tab = tabs[i];

                        if (tab.tab_type == "Master") {
                            continue;
                        }

                        var subCols = [];

                        for (var j = 0; j < tab.Fields.length; j++) {
                            var field = tab.Fields[j];

                            subCols.push(commonHD.CreatItemFromData(field, tab));
                        }

                        if (tab.tab_type == "Detail" && tab.foreign_key === "detail_tab") {
                            var item = {
                                id: "detail_tab",
                                header: "Chi tiết hóa đơn",
                                select: "cell",

                                body: {
                                    rows: [
                                        {
                                            view: "toolbar",
                                            height: 40,
                                            cols: [
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                    id: "addrow",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_chitiet");
                                                            var item = {
                                                                id: webix.uid(),
                                                            };
                                                            table.add(item);
                                                            table.select(item.id, "ma", false);
                                                            table.edit({
                                                                row: item.id,
                                                                column: "ma",
                                                            });
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                    id: "removerow",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_chitiet");

                                                            table.editStop();

                                                            var item = table.getSelectedItem();

                                                            if (!webix.isUndefined(item)) {
                                                                table.remove(item.id);
                                                                table.clearSelection();
                                                                return;
                                                            }

                                                            var editor = table.getEditState();

                                                            if (!webix.isUndefined(editor)) {
                                                                table.remove(editor.row);
                                                                table.clearSelection();
                                                                return;
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                    view: "button",
                                                    id: "copyrow",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_chitiet");

                                                            table.editStop();

                                                            var item = table.getSelectedItem();
                                                            if (item == null || item == undefined) {
                                                                webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                return;
                                                            }

                                                            var copy = webix.copy(item);
                                                            copy.cthdon_id = null;
                                                            copy.id = webix.uid();

                                                            table.add(copy);
                                                            table.unselect(item.id);
                                                            table.select(copy.id, "ma", false);
                                                            table.edit({
                                                                row: copy.id,
                                                                column: "ma",
                                                            });
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            view: "datatable",
                                            resizeColumn: true,
                                            id: "hoadon68_chitiet",
                                            editable: true,
                                            select: "cell",
                                            drag: true,
                                            scroll: true,
                                            columns: subCols,
                                            select_change: tab.select_change,
                                            cell_editstop: tab.cell_editstop,
                                            after_addrow: tab.after_addrow,
                                            after_delrow: tab.after_delrow,
                                            oncheck: tab.oncheck,
                                            on: {
                                                "data->onStoreUpdated": function () {
                                                    this.data.each(function (obj, i) {
                                                        obj.stt = i + 1;
                                                    });
                                                },
                                                onAfterLoad: function () {
                                                    var table = this;
                                                    var data = table.serialize();
                                                    data.forEach(function (entry) {
                                                        if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                            if (entry["stckhau"] != 0 || entry["tlckhau"] != 0) {
                                                                var ck = $$("check_chietkhau");
                                                                if (ck != undefined) {
                                                                    ck.setValue(1);
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    });
                                                },
                                                onCheck: function (row, column, state) {
                                                    var table = this;
                                                    if (column == "khuyen_mai") {
                                                        if (state == true) {
                                                        }
                                                    }
                                                },
                                                onAfterAdd: function (id, index) {
                                                    if (this.config.after_addrow != null) {
                                                        var fn = Function("id", "index", "tableId", this.config.after_addrow);
                                                        fn(id, index, this.config.id);
                                                    }
                                                },
                                                onAfterDelete: function (id) {
                                                    if (this.config.after_delrow != null) {
                                                        var fn = Function("id", "tableId", this.config.after_delrow);
                                                        fn(id, this.config.id);
                                                    }
                                                },
                                                onAfterEditStop: function (state, editor, ignore) {
                                                    if (state.value === state.old) return;

                                                    if (this.config.cell_editstop != null) {
                                                        var fn = Function("state", "editor", "ignore", "tableId", this.config.cell_editstop);
                                                        fn(state, editor, ignore, this.config.id);
                                                    }
                                                },
                                            },
                                        },
                                    ],
                                },
                            };

                            findJson.findAndReplace(el, tab.foreign_key, item);
                            m++;
                            //cells.push(item);
                        }
                        if (tab.tab_type == "Detail" && tab.foreign_key === "phi_tab") {
                            var item = {
                                id: "phi_tab",
                                header: "Tiền phí/lệ phí",
                                select: "cell",
                                hidden: tab.hidden,
                                body: {
                                    rows: [
                                        {
                                            view: "toolbar",
                                            height: 40,
                                            cols: [
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                    id: "addrow2",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_phi");
                                                            var item = {
                                                                id: webix.uid(),
                                                                tienphi: 0,
                                                            };
                                                            table.add(item);
                                                            table.select(item.id);
                                                            table.edit({
                                                                row: item.id,
                                                                column: "tnphi",
                                                            });
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                    id: "removerow2",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_phi");
                                                            table.editStop();
                                                            var item = table.getSelectedItem();
                                                            if (!webix.isUndefined(item)) {
                                                                table.remove(item.id);
                                                                table.clearSelection();
                                                                return;
                                                            }

                                                            var editor = table.getEditState();

                                                            if (!webix.isUndefined(editor)) {
                                                                table.remove(editor.row);
                                                                table.clearSelection();
                                                                return;
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    type: "htmlbutton",
                                                    width: 65,
                                                    label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                    view: "button",
                                                    id: "copyrow2",
                                                    css: "btnForm",
                                                    on: {
                                                        onItemClick: function (id, e) {
                                                            var table = webix.$$("hoadon68_phi");

                                                            table.editStop();

                                                            var item = table.getSelectedItem();
                                                            if (item == null || item == undefined) {
                                                                webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                return;
                                                            }
                                                            var copy = webix.copy(item);
                                                            copy.id = webix.uid();

                                                            table.add(copy);
                                                            table.unselect(item.id);
                                                            table.select(copy.id, "tnphi", false);
                                                            table.edit({
                                                                row: copy.id,
                                                                column: "tnphi",
                                                            });
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            view: "datatable",
                                            resizeColumn: true,
                                            id: "hoadon68_phi",
                                            editable: true,
                                            select: "cell",
                                            drag: true,
                                            scroll: true,
                                            columns: subCols,
                                            select_change: tab.select_change,
                                            cell_editstop: tab.cell_editstop,
                                            after_addrow: tab.after_addrow,
                                            after_delrow: tab.after_delrow,
                                            oncheck: tab.oncheck,
                                            on: {
                                                onAfterAdd: function (id, index) {
                                                    if (this.config.after_addrow != null) {
                                                        var fn = Function("id", "index", "tableId", this.config.after_addrow);
                                                        fn(id, index, this.config.id);
                                                    }
                                                },
                                                onAfterDelete: function (id) {
                                                    if (this.config.after_delrow != null) {
                                                        var fn = Function("id", "tableId", this.config.after_delrow);
                                                        fn(id, this.config.id);
                                                    }
                                                },
                                                onAfterEditStop: function (state, editor, ignore) {
                                                    if (state.value === state.old) return;

                                                    if (this.config.cell_editstop != null) {
                                                        var fn = Function("state", "editor", "ignore", "tableId", this.config.cell_editstop);
                                                        fn(state, editor, ignore, this.config.id);
                                                    }
                                                },
                                            },
                                        },
                                    ],
                                },
                            };

                            findJson.findAndReplace(el, "phi_tab", item);
                            m++;
                        }
                    }
                }

                el.push({
                    // paddingY:10,
                    margin: 10,
                    cols: cols,
                });
                webix.ui(el, $$("invoiceForms"));
                //$$("tab_replace").define("tabbar",{width:150 * m});
                //console.log(jsonElement);

                if (windowno == "WIN00791" || windowno == "WIN00792") {
                    $$("btnHoadonCQT").hide();
                }
                this.SetDefaultValue(windowconfig);
            }
        },
        SetDefaultValue: function (winconfig) {
            var form = webix.$$("invoiceForms");
            var item = form.getValues();
            var vc_window = winconfig["data"][0];

            var tabs = vc_window.Tabs;

            for (var i = 0; i < tabs.length; i++) {
                var tab = tabs[i];

                if (tab.tab_type == "Normal" || tab.tab_type == "Master") {
                    var fields = tab.Fields;

                    for (var j = 0; j < fields.length; j++) {
                        var field = fields[j];

                        if (field.column_name == tab.table_name + "_id") {
                            item[field.column_name] = null;
                        }

                        if (field.column_name == "branch_code") {
                            item[field.column_name] = user.getDvcsID();
                        }

                        if (field.default_value != null) {
                            var defaultValue = field.default_value.toString();

                            if (defaultValue.startsWith("@Default=")) {
                                item[field.column_name] = defaultValue.replace("@Default=", "");
                            }

                            if (defaultValue.startsWith("@JS=")) {
                                var fn = Function(defaultValue.replace("@JS=", ""));
                                item[field.column_name] = fn();
                            }
                        }
                    }
                }
            }

            form.setValues(item);
        },
    };
});

define('views/forms/formhoadoncode78_mtt',[
    "app",
    "locale",
    "models/user",
    "models/findjson",
    "views/commonHD",
    "callApis/hoadon68",
    "callApis/customer",
    "views/DataStorage/DataHoaDon78"], function (app, _, user, findJson, commonHD, hoadon68CallApis, customerCallApis, dataFormHd78) {
        var editmode = 0;
        var tongtienHDonBke = 0;
        var mau04 = {};
        var modeChangeView = 1; // 1 - Vào form theo dạng thường; 2 - vào form từ chức năng "Sao chép chọn dải"

        var el = [];
        function renderFormat(val) {
            if (typeof val == "undefined" || val == null || val == "" || val == 0) val = "VND";
            var url = app.config.host + "/Invoice68/GetDecimalPlace?ma_nt=" + val;
            var table_chitiet = webix.$$("hoadon68_chitiet");
            var table_phi = webix.$$("hoadon68_phi");
            var table = $$("invoiceForms");

            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(url, function (text) {
                    var arr = JSON.parse(text);

                    webix.storage.local.put("dsFieldFormat", arr[0]);

                    var arrayString_chitiet = ["sluong", "dgia", "thtien", "stckhau", "tthue", "tgtien", "tienphi", "tlckhau"];

                    for (var i = 0; i < arrayString_chitiet.length; i++) {
                        var field_name = "";
                        switch (arrayString_chitiet[i]) {
                            case "sluong":
                                field_name = "quantity_decimal";
                                break;
                            case "dgia":
                                field_name = "price_decimal";
                                break;
                            case "thtien":
                                field_name = "amount_without_vat_decimal";
                                break;
                            case "stckhau":
                                field_name = "price_discount";
                                break;
                            case "tthue":
                                field_name = "tax_price";
                                break;
                            case "tgtien":
                                field_name = "total_amount_decimal";
                                break;
                            case "tienphi":
                                field_name = "fee_price";
                                break;
                            case "tlckhau":
                                field_name = "tlckhau";
                                break;
                        }

                        var decimal_place = Array(Number(arr[0][field_name]) + 1).join("9");
                        var decimal_format = Number(arr[0][field_name]);
                        var format_numeric = {
                            maximumValue: Number("999999999999." + decimal_place),
                            minValue: Number("-999999999999." + decimal_place),
                            decimalPlaces: Number(decimal_format),
                        };
                        var formatSoDefault = {
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: decimal_format,
                        };
                        var formatSo = webix.Number.numToStr(formatSoDefault);
                        if (field_name == "fee_price") {
                            var format_config = table_phi.getColumnConfig("tienphi");

                            format_config.format = formatSo;
                            format_config.numericConfig = format_numeric;
                        } else {
                            var format_config = table_chitiet.getColumnConfig(arrayString_chitiet[i]);

                            format_config.format = formatSo;
                            format_config.numericConfig = format_numeric;
                        }
                    }

                    var arrayString = [
                        "tgtcthue",
                        "tgtcthue10",
                        "tgtcthue5",
                        "tgtcthue0",
                        "tgtcthuek",
                        "tgtcthuekct",
                        "tgtcthuekkk",
                        "ttcktmai",
                        "ttcktmai10",
                        "ttcktmai5",
                        "ttcktmai0",
                        "ttcktmaik",
                        "ttcktmaikct",
                        "ttcktmaikkk",
                        "tgtthue",
                        "tgtthue10",
                        "tgtthue5",
                        "tgtthue0",
                        "tgtthuek",
                        "tgtthuekct",
                        "tgtthuekkk",
                        "tgtttbso",
                        "tgtttbso10",
                        "tgtttbso5",
                        "tgtttbso0",
                        "tgtttbsok",
                        "tgtttbsokct",
                        "tgtttbsokkk",
                        "tkcktmn",
                        "tgtphi",
                        "tgtttbso_last",
                    ];

                    table_chitiet.refreshColumns();
                    table_phi.refreshColumns();

                    for (var i = 0; i < arrayString.length; i++) {
                        $$(arrayString[i]).refresh();
                    }
                });
        }

        //FormButton
        var cols = [
            {
                margin: 10,
                cols: [
                    {},
                    {
                        shortcut: "F10",
                        view: "button",
                        id: "btnBangKeSave",
                        label: "Lưu (F10)",
                        type: "form",
                        align: "center",
                        width: 120,
                        hidden: true,
                        on: {
                            onClick: function () {
                                var self = this;
                                setTimeout(function () {
                                    var tongtienBangKeCT = webix.$$("tgtttbso").getValue();
                                    var item = $$("invoiceForms").getValues();
                                    var table = $$("invoiceForms");
                                    var record = $$("hoadon68_chitiet").serialize();
                                    if (record.length == 0) {
                                        webix.message("Bạn chưa bổ sung chi tiết hàng hóa");
                                        return;
                                    }
                                    var mauso = $$("khieu").getValue().toString()[0];
                                    var tudongtinhtien = item.tudongtinhtien;
                                    var app_cache = webix.storage.local.get("APP_CACHE");
                                    var windowno;
                                    if (app_cache[windowno] != null) {
                                        windowno = app_cache["data"][0].code;
                                    }
                                    for (var i = 0; i < record.length; i++) {
                                        var it = record[i];
                                        var isHasDiscount = it["tiletienthuegtgtgiam"] != null && it["tiletienthuegtgtgiam"] != "" && it["tiletienthuegtgtgiam"] != 0 && it["tiletienthuegtgtgiam"] != '0';
                                        if (tudongtinhtien == "0") {
                                            if (mauso === "2" && !isHasDiscount) {
                                                record[i].thtien = record[i].tgtien;
                                            }
                                        }
                                        var it = record[i];

                                        if (it["ten"] == null || it["ten"] == "") {
                                            webix.message("Bạn chưa nhập tên hàng");
                                            return;
                                        }
                                        if (windowno == "WIN00788C") {
                                            it.phanloaihd = 1;
                                        }
                                        if (it.kmai.toString() === "1" || it.kmai.toString() === "5") {
                                            var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                            if (!bool) {
                                                webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                                return;
                                            }
                                            if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                                webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                return;
                                            }
                                        }
                                    }

                                    if (tongtienHDonBke != tongtienBangKeCT) {
                                        webix.message("Tổng tiền chi tiết bảng kê khác tổng tiền của hoá đơn!", "error");
                                        return false;
                                    }

                                    var record_phi = $$("hoadon68_phi").serialize();
                                    for (var i = 0; i < record_phi.length; i++) {
                                        var it = record_phi[i];

                                        if (it["tnphi"] == null || it["tnphi"] == "") {
                                            webix.message("Chưa nhập tên phí/lệ phí");
                                            return;
                                        }
                                    }

                                    if (table.validate()) {
                                        // var fn = Function(check);
                                        // var result = fn();
                                        // console.log(result);
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        var details = [];
                                        details.push({ data: record });
                                        item["details"] = details;
                                        var phi = [];
                                        phi.push({
                                            data: record_phi,
                                        });
                                        item["hoadon68_phi"] = phi;
                                        // hóa đơn không mã
                                        item.is_hdcma = 1;
                                        if (tudongtinhtien == "0") {
                                            if (item.tgtttbso === undefined || item.tgtttbso === "" || item.tgtttbso === null) {
                                                item.tgtttbso = item.tgtttbso_last;
                                            }
                                        }
                                        var item1 = [];
                                        item1.push(item);
                                        var data_post = { editmode: editmode, data: item1 };

                                        var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                        function afterSaveInvoiceSuccess(text) {
                                            var json = text.json();
                                            table.enable();
                                            table.hideProgress();
                                            if (!json.hasOwnProperty("error")) {
                                                webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                                var item = $$("invoiceForms").getValues();
                                                if (item && modeChangeView == 2) {
                                                    dataFormHd78.SetData("KHID", item.cctbao_id);
                                                }
                                                webix.$$("invoice68").close();

                                                if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                } else {
                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                }
                                            } else {
                                                webix.message(json.error, "error");
                                            }
                                        }

                                        function afterSaveInvoiceError(text) {
                                            table.enable();
                                            table.hideProgress();
                                            webix.message(text.json() + XmlHttpRequest, "error");
                                        }

                                        if (isSaveCustomerInfo) {


                                            var code = $$('mnmua') != null ? $$('mnmua').getValue() : null;
                                            var buyer_name = $$('tnmua') != null ? $$('tnmua').getValue() : null;
                                            var name = $$('ten') != null ? $$('ten').getValue() : null;
                                            var tax_code = $$('mst') != null ? $$('mst').getValue() : null;
                                            var email = $$('email') != null ? $$('email').getValue() : null;
                                            var address = $$('dchi') != null ? $$('dchi').getValue() : null;
                                            var tel = $$('sdtnmua') != null ? $$('sdtnmua').getValue() : null;
                                            var bank_account = $$('stknmua') != null ? $$('stknmua').getValue() : null;
                                            var bank_name = $$('tnhmua') != null ? $$('tnhmua').getValue() : null;
                                            var name_label = $$('ten') != null ? $$('ten').config.label : "Tên";
                                            var address_label = $$('dchi') != null ? $$('dchi').config.label : "Địa chỉ";

                                            var obj = {
                                                code: code,
                                                buyer_name: buyer_name,
                                                name: name,
                                                tax_code: tax_code,
                                                email: email,
                                                address: address,
                                                tel: tel,
                                                bank_account: bank_account,
                                                bank_name: bank_name,
                                            };

                                            var checkMessage = [];

                                            if (obj.code == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                            if (obj.name == "") checkMessage.push('"' + name_label + '" là trường bắt buộc nhập"');
                                            if (obj.address == "") checkMessage.push('"' + address_label + '" khách hảng là trường bắt buộc nhập"');

                                            var showConfirmUI = function () {
                                                webix.ui({
                                                    view: "window",
                                                    id: "check-customer-modal",
                                                    type: "modal",
                                                    modal: true,
                                                    position: "center",
                                                    head: {
                                                        height: 35,
                                                        cols: [
                                                            {
                                                                id: "head-form-check-customer",
                                                                view: "template",
                                                                css: "headform",
                                                                template: function (obj) {
                                                                    return "<div style='text-align: center;'>Tạo mới khách hàng thất bại<div/>";
                                                                },
                                                            }
                                                        ],
                                                    },
                                                    body: {
                                                        padding: 10,
                                                        rows: [
                                                            {
                                                                rows: checkMessage.map(function (message) {
                                                                    return {
                                                                        view: "template",
                                                                        template: "▶ " + message,
                                                                        autoheight: true, width: 350
                                                                    }
                                                                }),
                                                            },
                                                            {
                                                                view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                            },
                                                            {
                                                                cols: [
                                                                    {},
                                                                    {
                                                                        width: 100,
                                                                        view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                            $$('check-customer-modal').hide();
                                                                            hoadon68CallApis.hoadonSaveChange(data_post)
                                                                                .then(afterSaveInvoiceSuccess)
                                                                                .catch(afterSaveInvoiceError);
                                                                        }
                                                                    },
                                                                    {
                                                                        width: 100,
                                                                        view: "button", value: "Nhập lại", type: "danger", click: function () {
                                                                            $$('check-customer-modal').hide();
                                                                            table.enable();
                                                                            table.hideProgress();
                                                                        }
                                                                    },
                                                                    {}
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                }).show()
                                            }

                                            if (checkMessage.length > 0) {
                                                showConfirmUI();
                                            } else {
                                                customerCallApis.saveCustomer(obj).then(function (res) {
                                                    res = res.json();

                                                    if (!res.status) {
                                                        checkMessage.push(res.message.replace("P0001: ", ""));
                                                        showConfirmUI();
                                                    } else {

                                                        webix.message("Lưu thông tin khách hàng thành công", "success"); hoadon68CallApis.hoadonSaveChange(data_post)
                                                            .then(afterSaveInvoiceSuccess)
                                                            .catch(afterSaveInvoiceError);
                                                    }
                                                });
                                            }
                                        } else
                                            hoadon68CallApis.hoadonSaveChange(data_post)
                                                .then(afterSaveInvoiceSuccess)
                                                .catch(afterSaveInvoiceError);;

                                    }
                                }, 100);
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                    {
                        view: "button",
                        id: "btnBangKeDelete",
                        label: "Xoá",
                        type: "danger",
                        align: "center",
                        width: 80,
                        hidden: true,
                        on: {
                            onClick: function () {
                                var self = this;
                                setTimeout(function () {
                                    var item = $$("invoiceForms").getValues();
                                    var url = app.config.host + "/Invoice68/DeleteBangKeHoaDon?id=" + item.id;
                                    var table = $$("invoiceForms");
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();
                                    webix
                                        .ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(url, function (result) {
                                            if (result == "true") {
                                                webix.message("Đã xoá bảng kê !");
                                                table.enable();
                                                table.hideProgress();
                                                webix.$$("invoice68").close();
                                                app.callEvent("dataChangedInvoie68", [editmode, null]);
                                            } else {
                                                webix.message("Xoá không thành công !", "error");
                                            }
                                        });
                                }, 100);
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                    {
                        shortcut: "F10",
                        view: "button",
                        id: "btnHoadonSave",
                        label: "Lưu tạm (F10)",
                        type: "form",
                        align: "center",
                        width: 120,
                        on: {
                            onClick: function () {
                                var self = this;
                                setTimeout(function () {
                                    var item = $$("invoiceForms").getValues();
                                    if (item.nlap_temp != null) {
                                        var nlap_temp = new Date(item.nlap_temp);
                                        nlap_temp = new Date(nlap_temp.getFullYear(), nlap_temp.getMonth(), nlap_temp.getDate());

                                        if ($$("nlap").getValue() < nlap_temp) {
                                            webix.message("Ngày hoá đơn thay thế hoặc điều chỉnh không được nhỏ hơn hoá đơn gốc!", "error");
                                            return;
                                        }
                                    }

                                    var table = $$("invoiceForms");
                                    var record = $$("hoadon68_chitiet").serialize();

                                    if (record.length == 0) {
                                        webix.message("Bạn chưa bổ sung chi tiết hàng hóa");
                                        return;
                                    }
                                    var mauso = $$("khieu").getValue().toString()[0];
                                    var tudongtinhtien = item.tudongtinhtien;

                                    var windowno = app.path[1].params[0];

                                    for (var i = 0; i < record.length; i++) {
                                        var it = record[i];
                                        var isHasDiscount = it["tiletienthuegtgtgiam"] != null && it["tiletienthuegtgtgiam"] != "" && it["tiletienthuegtgtgiam"] != 0 && it["tiletienthuegtgtgiam"] != '0';
                                        if (tudongtinhtien == "0") {
                                            if (mauso === "2" && !isHasDiscount) {
                                                record[i].thtien = record[i].tgtien;
                                            }
                                        }
                                        var it = record[i];
                                        if (windowno == "WIN00788C") {
                                            it.phanloaihd = 1;
                                        }
                                        if (it["ten"] == null || it["ten"] == "") {
                                            webix.message("Bạn chưa nhập tên hàng");
                                            return;
                                        }
                                        if (it.kmai.toString() === "1" || it.kmai.toString() === "5") {
                                            /*var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                        if (!bool) {
                                            webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                            return;
                                        }*/
                                            if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                                webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                return;
                                            }
                                        }
                                    }

                                    var record_phi = $$("hoadon68_phi").serialize();
                                    for (var i = 0; i < record_phi.length; i++) {
                                        var it = record_phi[i];

                                        if (it["tnphi"] == null || it["tnphi"] == "") {
                                            webix.message("Chưa nhập tên phí/lệ phí");
                                            return;
                                        }
                                    }

                                    /*if($$("tnmua").getValue() !="" && $$("ten").getValue() !=""){
                                        item["TTKhac_tendonvi"] = $$("tnmua").getValue();
                                    }
                                    else{
                                        delete item["TTKhac_tendonvi"];
                                    }
                                    
                                    if($$("dchi").getValue() !=""){
                                        item["TTKhac_dchi"] = $$("dchi").getValue();
                                    }else{
                                        delete item["TTKhac_dchi"];
                                    }*/
                                    delete item["TTKhac_tendonvi"];
                                    delete item["TTKhac_dchi"];
                                    /*if($$("lblCanhbao").type==1){
                                        webix.message( $$("lblCanhbao").getValue()+". Không thể lưu!", "error");
                                        return;
                                    }*/
                                    if (table.validate()) {
                                        var TTKhac = [];
                                        Object.keys(item).forEach(function (key) {
                                            if (key.includes("TTKhac_")) {
                                                var test = $$(key);
                                                if (test.config.editor === "nummeric" || test.config.editor === "autonumeric") {
                                                    TTKhac.push({
                                                        ttruong: key.replace("TTKhac_", ""),
                                                        kdlieu: "decimal",
                                                        dlieu: item[key],
                                                    });
                                                }
                                                else if (test.config.view === "text") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "string", dlieu: item[key] });
                                                else if (test.config.view === "datepicker") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "dateTime", dlieu: item[key] });
                                            }
                                        });
                                        var TTKhacItem = [];
                                        TTKhacItem.push({
                                            data: TTKhac,
                                        });
                                        item["hoadon68_khac"] = TTKhacItem;
                                        // var fn = Function(check);
                                        // var result = fn();
                                        // console.log(result);
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        var details = [];
                                        details.push({ data: record });

                                        item["details"] = details;
                                        var phi = [];
                                        phi.push({
                                            data: record_phi,
                                        });
                                        item["hoadon68_phi"] = phi;
                                        // hóa đơn không mã
                                        item.is_hdcma = 1;
                                        if (tudongtinhtien == "0") {
                                            if (item.tgtttbso === undefined || item.tgtttbso === "" || item.tgtttbso === null) {
                                                item.tgtttbso = item.tgtttbso_last;
                                            }
                                        }
                                        var item1 = [];
                                        item1.push(item);

                                        var data_post = { editmode: editmode, data: item1 };
                                        var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                        function afterSaveInvoiceSuccess(text) {
                                            var json = text.json();
                                            table.enable();
                                            table.hideProgress();
                                            if (!json.hasOwnProperty("error")) {
                                                webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                                var item = $$("invoiceForms").getValues();
                                                if (item && modeChangeView == 2) {
                                                    dataFormHd78.SetData("KHID", item.cctbao_id);
                                                }
                                                webix.$$("invoice68").close();

                                                if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                } else {
                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                }
                                            } else {
                                                webix.message(json.error, "error");
                                            }
                                        }

                                        function afterSaveInvoiceError(text) {
                                            table.enable();
                                            table.hideProgress();
                                            webix.message(text.json() + XmlHttpRequest, "error");
                                        }

                                        if (isSaveCustomerInfo) {


                                            var code = $$('mnmua') != null ? $$('mnmua').getValue() : null;
                                            var buyer_name = $$('tnmua') != null ? $$('tnmua').getValue() : null;
                                            var name = $$('ten') != null ? $$('ten').getValue() : null;
                                            var tax_code = $$('mst') != null ? $$('mst').getValue() : null;
                                            var email = $$('email') != null ? $$('email').getValue() : null;
                                            var address = $$('dchi') != null ? $$('dchi').getValue() : null;
                                            var tel = $$('sdtnmua') != null ? $$('sdtnmua').getValue() : null;
                                            var bank_account = $$('stknmua') != null ? $$('stknmua').getValue() : null;
                                            var bank_name = $$('tnhmua') != null ? $$('tnhmua').getValue() : null;
                                            var name_label = $$('ten') != null ? $$('ten').config.label : "Tên";
                                            var address_label = $$('dchi') != null ? $$('dchi').config.label : "Địa chỉ";

                                            var obj = {
                                                code: code,
                                                buyer_name: buyer_name,
                                                name: name,
                                                tax_code: tax_code,
                                                email: email,
                                                address: address,
                                                tel: tel,
                                                bank_account: bank_account,
                                                bank_name: bank_name,
                                            };

                                            var checkMessage = [];

                                            if (obj.code == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                            if (obj.name == "") checkMessage.push('"' + name_label + '" là trường bắt buộc nhập"');
                                            if (obj.address == "") checkMessage.push('"' + address_label + '" khách hảng là trường bắt buộc nhập"');

                                            var showConfirmUI = function () {
                                                webix.ui({
                                                    view: "window",
                                                    id: "check-customer-modal",
                                                    type: "modal",
                                                    modal: true,
                                                    position: "center",
                                                    head: {
                                                        height: 35,
                                                        cols: [
                                                            {
                                                                id: "head-form-check-customer",
                                                                view: "template",
                                                                css: "headform",
                                                                template: function (obj) {
                                                                    return "<div style='text-align: center;'>Tạo mới khách hàng thất bại<div/>";
                                                                },
                                                            }
                                                        ],
                                                    },
                                                    body: {
                                                        padding: 10,
                                                        rows: [
                                                            {
                                                                rows: checkMessage.map(function (message) {
                                                                    return {
                                                                        view: "template",
                                                                        template: "▶ " + message,
                                                                        autoheight: true, width: 350
                                                                    }
                                                                }),
                                                            },
                                                            {
                                                                view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                            },
                                                            {
                                                                cols: [
                                                                    {},
                                                                    {
                                                                        width: 100,
                                                                        view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                            $$('check-customer-modal').hide();
                                                                            hoadon68CallApis.hoadonSaveChange(data_post)
                                                                                .then(afterSaveInvoiceSuccess)
                                                                                .catch(afterSaveInvoiceError);
                                                                        }
                                                                    },
                                                                    {
                                                                        width: 100,
                                                                        view: "button", value: "Nhập lại", type: "danger", click: function () {
                                                                            $$('check-customer-modal').hide();
                                                                            table.enable();
                                                                            table.hideProgress();
                                                                        }
                                                                    },
                                                                    {}
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                }).show()
                                            }

                                            if (checkMessage.length > 0) {
                                                showConfirmUI();
                                            } else {
                                                customerCallApis.saveCustomer(obj).then(function (res) {
                                                    res = res.json();

                                                    if (!res.status) {
                                                        checkMessage.push(res.message.replace("P0001: ", ""));
                                                        showConfirmUI();
                                                    } else {

                                                        webix.message("Lưu thông tin khách hàng thành công", "success"); hoadon68CallApis.hoadonSaveChange(data_post)
                                                            .then(afterSaveInvoiceSuccess)
                                                            .catch(afterSaveInvoiceError);
                                                    }
                                                });
                                            }
                                        } else
                                            hoadon68CallApis.hoadonSaveChange(data_post)
                                                .then(afterSaveInvoiceSuccess)
                                                .catch(afterSaveInvoiceError);;

                                    }
                                }, 100);
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                    {
                        shortcut: "F11",
                        view: "button",
                        id: "btnHoadonCQT",
                        label: "Ký và gửi CQT (F11)",
                        type: "form",
                        align: "center",
                        width: 150,
                        on: {
                            onClick: function () {
                                var self = this;
                                setTimeout(function () {
                                    var item = $$("invoiceForms").getValues();
                                    if (item.nlap_temp != null) {
                                        var nlap_temp = new Date(item.nlap_temp);
                                        nlap_temp = new Date(nlap_temp.getFullYear(), nlap_temp.getMonth(), nlap_temp.getDate());

                                        if ($$("nlap").getValue() < nlap_temp) {
                                            webix.message("Ngày hoá đơn thay thế hoặc điều chỉnh không được nhỏ hơn hoá đơn gốc!", "error");
                                            return;
                                        }
                                    }
                                    var table = $$("invoiceForms");
                                    var record = $$("hoadon68_chitiet").serialize();
                                    if (record.length == 0) {
                                        webix.message("Bạn chưa bổ sung chi tiết hàng hóa");
                                        return;
                                    }
                                    var mauso = $$("khieu").getValue().toString()[0];
                                    var checkmtt = $$("khieu").getValue().substring(4, 5);
                                    var tudongtinhtien = item.tudongtinhtien;
                                    var app_cache = webix.storage.local.get("APP_CACHE");
                                    var windowno;
                                    if (app_cache[windowno] != null) {
                                        windowno = app_cache["data"][0].code;
                                    }
                                    for (var i = 0; i < record.length; i++) {
                                        var it = record[i];
                                        var isHasDiscount = it["tiletienthuegtgtgiam"] != null && it["tiletienthuegtgtgiam"] != "" && it["tiletienthuegtgtgiam"] != 0 && it["tiletienthuegtgtgiam"] != '0';
                                        if (tudongtinhtien == "0") {
                                            if (mauso === "2" && !isHasDiscount) {
                                                record[i].thtien = record[i].tgtien;
                                            }
                                        }
                                        var it = record[i];
                                        if (windowno == "WIN00788C") {
                                            it.phanloaihd = 1;
                                        }
                                        if (it["ten"] == null || it["ten"] == "") {
                                            webix.message("Bạn chưa nhập tên hàng");
                                            return;
                                        }
                                        if (it.kmai.toString() === "1" || it.kmai.toString() === "5") {
                                            /*var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                        if (!bool) {
                                            webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                            return;
                                        }*/
                                            if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                                webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                return;
                                            }
                                        }
                                    }

                                    /*if($$("tnmua").getValue() !="" && $$("ten").getValue() !=""){
                                        item["TTKhac_tendonvi"] = $$("tnmua").getValue();
                                    }
                                    else{
                                        delete item["TTKhac_tendonvi"];
                                    }
                                    
                                    if($$("dchi").getValue() !=""){
                                        item["TTKhac_dchi"] = $$("dchi").getValue();
                                    }else{
                                        delete item["TTKhac_dchi"];
                                    }*/
                                    delete item["TTKhac_tendonvi"];
                                    delete item["TTKhac_dchi"];
                                    /*if($$("lblCanhbao").type==1){
                                        webix.message( $$("lblCanhbao").getValue()+". Không thể lưu!", "error");
                                        return;
                                    }*/
                                    if (table.validate()) {
                                        var TTKhac = [];
                                        Object.keys(item).forEach(function (key) {
                                            if (key.includes("TTKhac_")) {
                                                var test = $$(key);
                                                if (test.config.editor === "nummeric" || test.config.editor === "autonumeric") {
                                                    TTKhac.push({
                                                        ttruong: key.replace("TTKhac_", ""),
                                                        kdlieu: "decimal",
                                                        dlieu: item[key],
                                                    });
                                                }
                                                else if (test.config.view === "text") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "string", dlieu: item[key] });
                                                else if (test.config.view === "datepicker") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "dateTime", dlieu: item[key] });
                                            }
                                        });
                                        var TTKhacItem = [];
                                        TTKhacItem.push({
                                            data: TTKhac,
                                        });
                                        item["hoadon68_khac"] = TTKhacItem;
                                        // var fn = Function(check);
                                        // var result = fn();
                                        // console.log(result);
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        var details = [];
                                        details.push({ data: $$("hoadon68_chitiet").serialize() });
                                        item["details"] = details;
                                        var phi = [];
                                        phi.push({
                                            data: $$("hoadon68_phi").serialize(),
                                        });
                                        item["hoadon68_phi"] = phi;
                                        // hóa đơn không mã
                                        item.is_hdcma = 1;
                                        if (tudongtinhtien == "0") {
                                            if (item.tgtttbso === undefined || item.tgtttbso === "" || item.tgtttbso === null) {
                                                item.tgtttbso = item.tgtttbso_last;
                                            }
                                        }
                                        var item1 = [];
                                        item1.push(item);
                                        var data_post = { editmode: editmode, data: item1 };

                                        var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                        function afterSaveInvoiceSuccess(text) {
                                            var json = text.json();
                                            table.enable();
                                            table.hideProgress();
                                            if (!json.hasOwnProperty("error")) {
                                                webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                                var item = $$("invoiceForms").getValues();
                                                if (item && modeChangeView == 2) {
                                                    dataFormHd78.SetData("KHID", item.cctbao_id);
                                                }

                                                webix.$$("invoice68").close();

                                                if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                } else {
                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                }
                                                var lsthdon_id = [];
                                                lsthdon_id.push(json.data.hdon_id);
                                                if (checkmtt === "M") {
                                                    commonHD.ExcuteHoaDonMTT(lsthdon_id);
                                                }
                                                else {
                                                    commonHD.ExcuteHoaDon(lsthdon_id, true, true);
                                                }

                                            } else {
                                                webix.message(json.error, "error");
                                            }
                                        }

                                        function afterSaveInvoiceError(text) {
                                            table.enable();
                                            table.hideProgress();
                                            webix.message(text.json() + XmlHttpRequest, "error");
                                        }

                                        if (isSaveCustomerInfo) {


                                            var code = $$('mnmua') != null ? $$('mnmua').getValue() : null;
                                            var buyer_name = $$('tnmua') != null ? $$('tnmua').getValue() : null;
                                            var name = $$('ten') != null ? $$('ten').getValue() : null;
                                            var tax_code = $$('mst') != null ? $$('mst').getValue() : null;
                                            var email = $$('email') != null ? $$('email').getValue() : null;
                                            var address = $$('dchi') != null ? $$('dchi').getValue() : null;
                                            var tel = $$('sdtnmua') != null ? $$('sdtnmua').getValue() : null;
                                            var bank_account = $$('stknmua') != null ? $$('stknmua').getValue() : null;
                                            var bank_name = $$('tnhmua') != null ? $$('tnhmua').getValue() : null;
                                            var name_label = $$('ten') != null ? $$('ten').config.label : "Tên";
                                            var address_label = $$('dchi') != null ? $$('dchi').config.label : "Địa chỉ";

                                            var obj = {
                                                code: code,
                                                buyer_name: buyer_name,
                                                name: name,
                                                tax_code: tax_code,
                                                email: email,
                                                address: address,
                                                tel: tel,
                                                bank_account: bank_account,
                                                bank_name: bank_name,
                                            };
                                            var checkMessage = [];

                                            if (obj.code == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                            if (obj.name == "") checkMessage.push('"' + name_label + '" là trường bắt buộc nhập"');
                                            if (obj.address == "") checkMessage.push('"' + address_label + '" khách hảng là trường bắt buộc nhập"');

                                            var showConfirmUI = function () {
                                                webix.ui({
                                                    view: "window",
                                                    id: "check-customer-modal",
                                                    type: "modal",
                                                    modal: true,
                                                    position: "center",
                                                    head: {
                                                        height: 35,
                                                        cols: [
                                                            {
                                                                id: "head-form-check-customer",
                                                                view: "template",
                                                                css: "headform",
                                                                template: function (obj) {
                                                                    return "<div style='text-align: center;'>Tạo mới khách hàng thất bại<div/>";
                                                                },
                                                            }
                                                        ],
                                                    },
                                                    body: {
                                                        padding: 10,
                                                        rows: [
                                                            {
                                                                rows: checkMessage.map(function (message) {
                                                                    return {
                                                                        view: "template",
                                                                        template: "▶ " + message,
                                                                        autoheight: true, width: 350
                                                                    }
                                                                }),
                                                            },
                                                            {
                                                                view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                            },
                                                            {
                                                                cols: [
                                                                    {},
                                                                    {
                                                                        width: 100,
                                                                        view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                            $$('check-customer-modal').hide();
                                                                            hoadon68CallApis.hoadonSaveChange(data_post)
                                                                                .then(afterSaveInvoiceSuccess)
                                                                                .catch(afterSaveInvoiceError);
                                                                        }
                                                                    },
                                                                    {
                                                                        width: 100,
                                                                        view: "button", value: "Nhập lại", type: "danger", click: function () {
                                                                            $$('check-customer-modal').hide();
                                                                            table.enable();
                                                                            table.hideProgress();
                                                                        }
                                                                    },
                                                                    {}
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                }).show()
                                            }

                                            if (checkMessage.length > 0) {
                                                showConfirmUI();
                                            } else {
                                                customerCallApis.saveCustomer(obj).then(function (res) {
                                                    res = res.json();

                                                    if (!res.status) {
                                                        checkMessage.push(res.message.replace("P0001: ", ""));
                                                        showConfirmUI();
                                                    } else {

                                                        webix.message("Lưu thông tin khách hàng thành công", "success"); hoadon68CallApis.hoadonSaveChange(data_post)
                                                            .then(afterSaveInvoiceSuccess)
                                                            .catch(afterSaveInvoiceError);
                                                    }
                                                });
                                            }
                                        } else
                                            hoadon68CallApis.hoadonSaveChange(data_post)
                                                .then(afterSaveInvoiceSuccess)
                                                .catch(afterSaveInvoiceError);;

                                    }
                                }, 100);
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                    {
                        view: "button",
                        hotkey: "esc",
                        label: "Hủy bỏ (ESC)",
                        align: "center",
                        type: "danger",
                        width: 120,
                        click: function () {
                            this.getTopParentView().close();
                            app.callEvent("dataChangedInvoie68", [editmode, null]);
                        },
                    },
                    {},
                ],
            },
        ];
        //FormDetail Tạo item trên trang from từ tab và data

        return {
            $ui: {
                view: "window",
                modal: true,
                position: "center",
                css: "headformchil",
                head: {
                    //view: "toolbar",
                    // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                    //css: { "background": "#e6f2ff !important" },
                    height: 35,
                    cols: [
                        {
                            id: "head-iconInvoice",
                            view: "template",
                            css: "headform",
                            width: 35,
                            template: "",
                        },
                        {
                            id: "head-formInvoice",
                            view: "template",
                            css: "headform",
                            template: function (obj) {
                                return "<div>Test Form<div/>";
                            },
                        },
                        {
                            view: "icon",
                            icon: "fas fa-question-circle",
                            id: "help_InvoiceForms",
                            tooltip: _("HELPER"),
                            click: function () {
                                // var form = webix.$$("window-form");
                                // hint_form(form.config.hint);
                            },
                        },
                    ],
                },
                id: "invoice68",
                resize: true,
                fullscreen: true,
                move: true,
                on: {
                    onBeforeShow: function () { },
                },
                body: {
                    paddingY: 10,
                    paddingX: 10,
                    elementsConfig: { labelWidth: 100 },
                    view: "form",
                    id: "invoiceForms",
                    width: 800,
                    height: 500,
                    complexData: true,
                    margin: 0,
                    on: {
                        // onViewShow: function () {
                        // }
                    },
                    elements: el,
                },
            },
            setValues: function (item, winconfig, params) {
                commonHD.setdsFieldFormatFromLocal(item.dvtte);
                var win = $$(this.$ui.id);
                var form = win.getChildViews()[1];
                if (item != null) {
                    this.editgiatri(item);

                    if (item.docngoaitetv) {
                        item.docngoaitetv = 1;
                    } else {
                        item.docngoaitetv = 0;
                    }

                    form.setValues(item);

                    var tableDetail = webix.$$("hoadon68_chitiet");
                    var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                    tableDetail.clearAll();
                    tableDetail.load(url);
                    var tablePhi = webix.$$("hoadon68_phi");
                    var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                    tablePhi.clearAll();
                    tablePhi.load(urlPhi);
                    var urlKhac = app.config.host + "/Invoice68/GetDataInvoiceKhac?id=" + item.id;
                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .get(urlKhac, function (text) {
                            var data = JSON.parse(text);
                            for (var i = 0; i < data.length; i++) {
                                try {
                                    if ($$("TTKhac_" + data[i].ttruong) !== undefined && $$("TTKhac_" + data[i].ttruong) !== null) $$("TTKhac_" + data[i].ttruong).setValue(data[i]["dlieu"]);
                                } catch (e) { }
                            }
                        });
                }

                if (editmode == 2) {
                }
                // nếu có mẫu 04 (hóa đơn hủy)
                if (winconfig != null) {
                    mau04 = winconfig;
                    $$("btnHoadonSaveMau04").show();
                    $$("btnHoadonCQT").destructor();
                    $$("btnHoadonSave").destructor();
                }
                this.getFormat(item["dvtte"], item);
            },
            setValuesBangKe: function (item, winconfig, params) {
                var win = $$(this.$ui.id);
                tongtienHDonBke = item.tgtttbso;
                var form = win.getChildViews()[1];
                if (item != null) {
                    this.editgiatri(item);

                    form.setValues(item);

                    var tableDetail = webix.$$("hoadon68_chitiet");
                    var url = "";
                    if (editmode == 4) {
                        url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                    } else {
                        url = app.config.host + "/Invoice68/GetDataInvoiceDetail_BangKe?id=" + item.id;
                    }
                    tableDetail.clearAll();
                    tableDetail.load(url);
                }
                // nếu có mẫu 04 (hóa đơn hủy)
                if (winconfig != null) {
                    mau04 = winconfig;
                    $$("btnHoadonSaveMau04").show();
                    $$("btnHoadonCQT").destructor();
                    $$("btnHoadonSave").destructor();
                }
                this.getFormat(item["dvtte"]);
            },
            editgiatri: function (item) {
                if (item["tdlap"] !== undefined) item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                if (item["cqqdbants"] !== undefined) item["cqqdbants"] = removeTimeZoneT(item["cqqdbants"]);
                if (item["tgvchdtu"] !== undefined) item["tgvchdtu"] = removeTimeZoneT(item["tgvchdtu"]);
                if (item["tgvchdden"] !== undefined) item["tgvchdden"] = removeTimeZoneT(item["tgvchdden"]);
                if (item["nqdbants"] !== undefined) item["nqdbants"] = removeTimeZoneT(item["nqdbants"]);
                if (item["nbke"] !== undefined) item["nbke"] = removeTimeZoneT(item["nbke"]);
                if (item["hdktngay"] !== undefined) item["hdktngay"] = removeTimeZoneT(item["hdktngay"]);
                item["giamthuebanhang20"] = item["giamthuebanhang20"] == true ? 1 : 0;
                if (item["nbke"] !== undefined) item["nbke"] = removeTimeZoneT(item["nbke"]);
            },
            setEditMode: function (mode) {
                editmode = mode;
                //var form = webix.$$("invoiceForms");
                var form = $$(this.$ui.id);
                //var topParentView = form.getTopParentView();
                form.config.editmode = mode;
                var icon = "";
                if (editmode == 1 || editmode == 4) {
                    icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                } else {
                    if (editmode == 2 || editmode == 5) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                }

                webix.$$("head-iconInvoice").setHTML(icon);
                webix.$$("head-iconInvoice").refresh();
            },
            setModeChangeView: function (mode) {
                if (mode) {
                    modeChangeView = mode;
                }
            },
            setNewInvoice: function () {
                var form = webix.$$("invoiceForms");
                form.config.newInvoice = true;
            },
            copyValues: function (item) {
                var form = webix.$$("invoiceForms");

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .get(url, function (text) {
                        var data = JSON.parse(text);

                        for (var i = 0; i < data.length; i++) {
                            data[i]["cthdon_id"] = null;
                            data[i]["hdon_id"] = null;
                        }

                        tableDetail.clearAll();
                        tableDetail.parse(data);
                    });
                var tablePhi = webix.$$("hoadon68_phi");
                var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .get(urlPhi, function (text) {
                        var data = JSON.parse(text);

                        for (var i = 0; i < data.length; i++) {
                            data[i]["phi_id"] = null;
                            data[i]["hdon_id"] = null;
                        }

                        tablePhi.clearAll();
                        tablePhi.parse(data);
                    });
                var urlKhac = app.config.host + "/Invoice68/GetDataInvoiceKhac?id=" + item.id;
                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .get(urlKhac, function (text) {
                        var data = JSON.parse(text);
                        for (var i = 0; i < data.length; i++) {
                            try {
                                if ($$("TTKhac_" + data[i].ttruong) !== undefined && $$("TTKhac_" + data[i].ttruong) !== null) $$("TTKhac_" + data[i].ttruong).setValue(data[i]["dlieu"]);
                            } catch (e) { }
                        }
                    });
                // tableDetail.clearAll();
                // tableDetail.load(url);
                item["tthdon"] = 0;
                item["tthdon_original"] = 0;
                item["tthdon_old"] = 0;
                item["hdon_id"] = null;
                item["hdon68_id_lk"] = null;
                item["nky"] = null;
                item["id"] = webix.uid();
                item["giamthuebanhang20"] = item["giamthuebanhang20"] == true ? 1 : 0;
                item["nbke"] = null;
                this.editgiatri(item);
                form.setValues(item);
                this.getFormat(item["dvtte"]);
            },
            getFormat: function (val, data) {
                commonHD.renderFormat(val, false, data);
            },
            initUINew: function (cctbao_id) {
                $$("cctbao_id").setValue(cctbao_id);
                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .get(app.config.host + "/Invoice68/getKyhieu?cctbao_id=" + cctbao_id, function (text) {
                        var data = JSON.parse(text);

                        if (data.length > 0) {
                            var form = $$("invoiceForms");
                            var values = form.getValues();
                            values["khieu"] = data[0]["khhdon"];
                            values["mcqtcap"] = data[0]["mccqthue"];
                            values["tudongtinhtien"] = 1;
                            form.setValues(values);
                        }
                    });
                this.getFormat();
            },
            initUI: function (windowconfig) {
                var rp = windowconfig;
                var vc_window = rp["data"][0];
                var tabs = vc_window.Tabs;
                $$("head-formInvoice").define("template", "<div>" + vc_window.name + "<div/>");
                el = [];
                var col = [];
                var m = 0;

                if (vc_window.detail_layout != null && vc_window.detail_layout != "") {
                    var layoutdetail = JSON.parse(vc_window.detail_layout);

                    var layout_element = JSON.stringify(layoutdetail.elements);
                    var json_layout = JSON.parse(layout_element);
                    //console.log(json_layout);
                    for (var i = 0; i < json_layout.length; i++) {
                        el.push(json_layout[i]);
                    }

                    var jsonElement = findJson.getObjects(JSON.parse(JSON.stringify(el)), "id", "");

                    for (var i = 0; i < jsonElement.length; i++) {
                        //var item = jsonElement[i];
                        //var item = jsonElement[i];
                        var fields = rp["data"][0]["Tabs"][0]["Fields"];

                        for (var j = 0; j < fields.length; j++) {
                            var field = fields[j];

                            if (jsonElement[i].name == field.column_name) {
                                item = commonHD.CreatItemMaterFromData(field);
                                jsonElement[i] = item;

                                findJson.findAndReplace(el, jsonElement[i].name, item);
                            }
                        }
                    }
                    if (vc_window.window_type == "MasterDetail") {
                        for (var i = 0; i < tabs.length; i++) {
                            var tab = tabs[i];

                            if (tab.tab_type == "Master") {
                                continue;
                            }

                            var subCols = [];

                            for (var j = 0; j < tab.Fields.length; j++) {
                                var field = tab.Fields[j];

                                subCols.push(commonHD.CreatItemFromData(field, tab));
                            }

                            if (tab.tab_type == "Detail" && tab.foreign_key === "detail_tab") {
                                var item = {
                                    id: "detail_tab",
                                    header: "Chi tiết hóa đơn",
                                    select: "cell",

                                    body: {
                                        rows: [
                                            {
                                                view: "toolbar",
                                                height: 40,
                                                cols: [
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                        id: "addrow",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_chitiet");
                                                                var item = {
                                                                    id: webix.uid(),
                                                                };
                                                                table.add(item);
                                                                table.select(item.id, "ma", false);
                                                                table.edit({
                                                                    row: item.id,
                                                                    column: "ma",
                                                                });
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                        id: "removerow",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_chitiet");

                                                                table.editStop();

                                                                var item = table.getSelectedItem();

                                                                if (!webix.isUndefined(item)) {
                                                                    table.remove(item.id);
                                                                    table.clearSelection();
                                                                    return;
                                                                }

                                                                var editor = table.getEditState();

                                                                if (!webix.isUndefined(editor)) {
                                                                    table.remove(editor.row);
                                                                    table.clearSelection();
                                                                    return;
                                                                }
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                        view: "button",
                                                        id: "copyrow",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_chitiet");

                                                                table.editStop();

                                                                var item = table.getSelectedItem();
                                                                if (item == null || item == undefined) {
                                                                    webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                    return;
                                                                }
                                                                var copy = webix.copy(item);
                                                                copy.cthdon_id = null;
                                                                copy.id = webix.uid();

                                                                table.add(copy);
                                                                table.unselect(item.id);
                                                                table.select(copy.id, "ma", false);
                                                                table.edit({
                                                                    row: copy.id,
                                                                    column: "ma",
                                                                });
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 150,
                                                        label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " Nhận excel chi tiết" + "</span>",
                                                        view: "button",
                                                        id: "importRowDetail",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = $$("invoiceViews");
                                                                var item = table.getSelectedItem();

                                                                // if(item == null || item == "")
                                                                // {
                                                                // webix.message("Bạn chưa chọn hóa đơn cần nhận chi tiết !", "error");
                                                                // return;
                                                                // }

                                                                // if (item.tthai != "Chờ ký") {
                                                                //     webix.message("Hóa đơn phải có trạng thái chờ ký, bạn mới có thể nhập excel chi tiết!", "error");
                                                                //     return;
                                                                // }

                                                                require(["views/forms/uploadexcelform"], function (uploadForm) {
                                                                    uploadForm.$ui.tableId = table.config.id;
                                                                    var win = table.$scope.ui(uploadForm.$ui);
                                                                    win.show();
                                                                    if (vc_window.code === "WIN00782CM") {
                                                                        webix.$$("uploader").define("formData", { excel_id: "EX00017", filename: "Mẫu import chi tiết HD bán hàng.xlsx" });
                                                                    } else {
                                                                        webix.$$("uploader").define("formData", { excel_id: "EX00011", filename: "Nhan chi tiet mot HD68.xlsx" });
                                                                    }
                                                                    webix.$$("uploader").hide();
                                                                });

                                                                // var table = webix.$$("hoadon68_chitiet");

                                                                // table.editStop();

                                                                // var item = table.getSelectedItem();
                                                                // if (item == null || item == undefined) {
                                                                //     webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                //     return;
                                                                // }

                                                                // var copy = webix.copy(item);
                                                                // copy.cthdon_id = null;
                                                                // copy.id = webix.uid();

                                                                // table.add(copy);
                                                                // table.unselect(item.id);
                                                                // table.select(copy.id, "ma", false);
                                                                // table.edit({
                                                                //     row: copy.id,
                                                                //     column: "ma",
                                                                // });
                                                            },
                                                        },
                                                    }
                                                ],
                                            },
                                            {
                                                view: "datatable",
                                                resizeColumn: true,
                                                id: "hoadon68_chitiet",
                                                editable: true,
                                                select: "cell",
                                                drag: true,
                                                scroll: true,
                                                columns: subCols,
                                                select_change: tab.select_change,
                                                cell_editstop: tab.cell_editstop,
                                                after_addrow: tab.after_addrow,
                                                after_delrow: tab.after_delrow,
                                                oncheck: tab.oncheck,
                                                on: {
                                                    "data->onStoreUpdated": function () {
                                                        this.data.each(function (obj, i) {
                                                            obj.stt = i + 1;
                                                        });
                                                    },
                                                    onAfterLoad: function () {
                                                        var table = this;
                                                        var data = table.serialize();
                                                        data.forEach(function (entry) {
                                                            if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                if (entry["stckhau"] != 0 || entry["tlckhau"] != 0) {
                                                                    var ck = $$("check_chietkhau");

                                                                    if (ck != undefined) {
                                                                        ck.setValue(1);
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            if (entry["loaive"] == "Vé trẻ em") {
                                                                entry["loaive"] = "1";
                                                            } else {
                                                                entry["loaive"] = "2";
                                                            }
                                                        });

                                                        // Xử lý ẩn hiện trường HHDT
                                                        if (data) {
                                                            var isHHDT = data.find(function (e) {
                                                                if (e.hasOwnProperty('kmai')) {
                                                                    return e['kmai'] == '5';
                                                                }
                                                                return false;
                                                            })

                                                            if (isHHDT) {
                                                                $$("hoadon68_chitiet").showColumn("lhhdthu");

                                                                // có hh oto, moto
                                                                var isMoto = data.find(function (e) {
                                                                    if (e.hasOwnProperty('lhhdthu')) {
                                                                        return e['lhhdthu'] == '1';
                                                                    }
                                                                    return false;
                                                                })

                                                                if (isMoto) {
                                                                    $$("hoadon68_chitiet").showColumn("skhung");
                                                                    $$("hoadon68_chitiet").showColumn("smay");
                                                                }

                                                                // có hh dvvc
                                                                var isDvvc = data.find(function (e) {
                                                                    if (e.hasOwnProperty('lhhdthu')) {
                                                                        return e['lhhdthu'] == '2';
                                                                    }
                                                                    return false;
                                                                })

                                                                if (isDvvc) {
                                                                    $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                }

                                                                // có hh tmdt
                                                                var isTmdt = data.find(function (e) {
                                                                    if (e.hasOwnProperty('lhhdthu')) {
                                                                        return e['lhhdthu'] == '3';
                                                                    }
                                                                    return false;
                                                                })

                                                                if (isTmdt) {
                                                                    $$("hoadon68_chitiet").showColumn("tnghang");
                                                                    $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                }

                                                                $$("hoadon68_chitiet").refresh();
                                                            }
                                                        }

                                                        commonHD.CanhBaoTinhTien();
                                                    },
                                                    onCheck: function (row, column, state) {
                                                        var table = this;
                                                        if (column == "khuyen_mai") {
                                                            if (state == true) {
                                                            }
                                                        }
                                                    },
                                                    onAfterAdd: function (id, index) {
                                                        var item_inf = webix.$$("invoiceForms").getValues();
                                                        var tudongtinhtien = item_inf["tudongtinhtien"];
                                                        if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                            if (this.config.after_addrow != null) {
                                                                var fn = Function("id", "index", "tableId", this.config.after_addrow);
                                                                fn(id, index, this.config.id);
                                                            }
                                                        } else {

                                                            var table_chitiet = webix.$$("hoadon68_chitiet");
                                                            var ishhdt = false;
                                                            var islhhdt_1 = false;
                                                            var islhhdt_2 = false;
                                                            var islhhdt_3 = false;
                                                            var data = $$("hoadon68_chitiet").serialize();
                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["kmai"] && data[i]["kmai"].toString() === "5") {
                                                                    ishhdt = true;
                                                                    break;
                                                                }
                                                            }

                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "1") {
                                                                    islhhdt_1 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "2") {
                                                                    islhhdt_2 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "3") {
                                                                    islhhdt_3 = true;
                                                                    break;
                                                                }
                                                            }


                                                        var selectedItemDetail = table_chitiet.getSelectedItem();
                                                        if(selectedItemDetail){
                                                            if(selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "3") {
                                                                selectedItemDetail["stckhau"] = 0;
                                                                selectedItemDetail["tlckhau"] = 0;
                                                                table_chitiet.updateItem(selectedItemDetail["id"], selectedItemDetail);
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() != "5"){
                                                            table_chitiet.refresh();
                                                            }else if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "5") {
                                                                $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }else{
                                                            $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }
    
    
                                                            if(ishhdt && islhhdt_1 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "1") {
                                                                $$("hoadon68_chitiet").showColumn("skhung");
                                                                $$("hoadon68_chitiet").showColumn("smay");
                                                                table_chitiet.refresh();
                                                            } else if(ishhdt && islhhdt_1){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_2 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "2") {
                                                                $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_2){
                                                                table_chitiet.refresh();
                                                            }else {
                                                            $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_3 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "3") {
                                                                $$("hoadon68_chitiet").showColumn("tnghang");
                                                                $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_3){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(!ishhdt) {
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
                                                        }else{
                                                               if(ishhdt ) {
                                                                    $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }else{
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }
        
        
                                                                if(ishhdt && islhhdt_1) {
                                                                    $$("hoadon68_chitiet").showColumn("skhung");
                                                                    $$("hoadon68_chitiet").showColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_2) {
                                                                    $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_3) {
                                                                    $$("hoadon68_chitiet").showColumn("tnghang");
                                                                    $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(!ishhdt) {
                                                                    $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
                                                        }
                                                        
                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                                onAfterDelete: function (id) {
                                                    var item_inf = webix.$$("invoiceForms").getValues();
                                                    var tudongtinhtien = item_inf["tudongtinhtien"];
                                                    if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                        if (this.config.after_delrow != null) {
                                                            var fn = Function("id", "tableId", this.config.after_delrow);
                                                            fn(id, this.config.id);
                                                        }
                                                    }else{

                                                            var table_chitiet = webix.$$("hoadon68_chitiet");
                                                            var ishhdt = false;
                                                            var islhhdt_1 = false;
                                                            var islhhdt_2 = false;
                                                            var islhhdt_3 = false;
                                                            var data = $$("hoadon68_chitiet").serialize();
                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["kmai"] && data[i]["kmai"].toString() === "5") {
                                                                    ishhdt = true;
                                                                    break;
                                                                }
                                                            }

                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "1") {
                                                                    islhhdt_1 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "2") {
                                                                    islhhdt_2 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "3") {
                                                                    islhhdt_3 = true;
                                                                    break;
                                                                }
                                                            }


                                                        var selectedItemDetail = table_chitiet.getSelectedItem();
                                                        if(selectedItemDetail){
                                                            if(selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "3") {
                                                                selectedItemDetail["stckhau"] = 0;
                                                                selectedItemDetail["tlckhau"] = 0;
                                                                table_chitiet.updateItem(selectedItemDetail["id"], selectedItemDetail);
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() != "5"){
                                                            table_chitiet.refresh();
                                                            }else if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "5") {
                                                                $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }else{
                                                            $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }
    
    
                                                            if(ishhdt && islhhdt_1 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "1") {
                                                                $$("hoadon68_chitiet").showColumn("skhung");
                                                                $$("hoadon68_chitiet").showColumn("smay");
                                                                table_chitiet.refresh();
                                                            } else if(ishhdt && islhhdt_1){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_2 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "2") {
                                                                $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_2){
                                                                table_chitiet.refresh();
                                                            }else {
                                                            $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_3 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "3") {
                                                                $$("hoadon68_chitiet").showColumn("tnghang");
                                                                $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_3){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(!ishhdt) {
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
                                                        }else{
                                                               if(ishhdt ) {
                                                                    $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }else{
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }
        
        
                                                                if(ishhdt && islhhdt_1) {
                                                                    $$("hoadon68_chitiet").showColumn("skhung");
                                                                    $$("hoadon68_chitiet").showColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_2) {
                                                                    $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_3) {
                                                                    $$("hoadon68_chitiet").showColumn("tnghang");
                                                                    $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(!ishhdt) {
                                                                    $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
                                                        }
                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                                onAfterEditStop: function (state, editor, ignore) {
                                                    if (state.value === state.old) return;
                                                    var item_inf = webix.$$("invoiceForms").getValues();
                                                    var tudongtinhtien = item_inf["tudongtinhtien"];
                                                    var selectedItem = $$("hoadon68_chitiet").getItem(editor.row);
                                                    if (!selectedItem.kmai) selectedItem.kmai = "1";
                                                    if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                        if (this.config.cell_editstop != null) {
                                                            var fn = Function("state", "editor", "ignore", "tableId", this.config.cell_editstop);
                                                            fn(state, editor, ignore, this.config.id);
                                                        }
                                                    }else{

                                                            var table_chitiet = webix.$$("hoadon68_chitiet");
                                                            var ishhdt = false;
                                                            var islhhdt_1 = false;
                                                            var islhhdt_2 = false;
                                                            var islhhdt_3 = false;
                                                            var data = $$("hoadon68_chitiet").serialize();
                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["kmai"] && data[i]["kmai"].toString() === "5") {
                                                                    ishhdt = true;
                                                                    break;
                                                                }
                                                            }

                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "1") {
                                                                    islhhdt_1 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "2") {
                                                                    islhhdt_2 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "3") {
                                                                    islhhdt_3 = true;
                                                                    break;
                                                                }
                                                            }


                                                        var selectedItemDetail = table_chitiet.getSelectedItem();
                                                        if(selectedItemDetail){
                                                            if(selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "3") {
                                                                selectedItemDetail["stckhau"] = 0;
                                                                selectedItemDetail["tlckhau"] = 0;
                                                                table_chitiet.updateItem(selectedItemDetail["id"], selectedItemDetail);
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() != "5"){
                                                            table_chitiet.refresh();
                                                            }else if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "5") {
                                                                $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }else{
                                                            $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }
    
    
                                                            if(ishhdt && islhhdt_1 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "1") {
                                                                $$("hoadon68_chitiet").showColumn("skhung");
                                                                $$("hoadon68_chitiet").showColumn("smay");
                                                                table_chitiet.refresh();
                                                            } else if(ishhdt && islhhdt_1){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_2 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "2") {
                                                                $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_2){
                                                                table_chitiet.refresh();
                                                            }else {
                                                            $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_3 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "3") {
                                                                $$("hoadon68_chitiet").showColumn("tnghang");
                                                                $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_3){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(!ishhdt) {
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
                                                        }else{
                                                               if(ishhdt ) {
                                                                    $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }else{
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }
        
        
                                                                if(ishhdt && islhhdt_1) {
                                                                    $$("hoadon68_chitiet").showColumn("skhung");
                                                                    $$("hoadon68_chitiet").showColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_2) {
                                                                    $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_3) {
                                                                    $$("hoadon68_chitiet").showColumn("tnghang");
                                                                    $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(!ishhdt) {
                                                                    $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
                                                        }
                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                            },
                                        },
                                    ],
                                },
                            };

                                findJson.findAndReplace(el, tab.foreign_key, item);
                                m++;
                                //cells.push(item);
                            }
                            if (tab.tab_type == "Detail" && tab.foreign_key === "phi_tab") {
                                var item = {
                                    id: "phi_tab",
                                    header: "Tiền phí/lệ phí",
                                    select: "cell",
                                    hidden: tab.hidden,
                                    body: {
                                        rows: [
                                            {
                                                view: "toolbar",
                                                height: 40,
                                                cols: [
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                        id: "addrow2",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_phi");
                                                                var item = {
                                                                    id: webix.uid(),
                                                                    tienphi: 0,
                                                                };
                                                                table.add(item);
                                                                table.select(item.id);
                                                                table.edit({
                                                                    row: item.id,
                                                                    column: "tnphi",
                                                                });
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                        id: "removerow2",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_phi");
                                                                table.editStop();
                                                                var item = table.getSelectedItem();
                                                                if (!webix.isUndefined(item)) {
                                                                    table.remove(item.id);
                                                                    table.clearSelection();
                                                                    return;
                                                                }

                                                                var editor = table.getEditState();

                                                                if (!webix.isUndefined(editor)) {
                                                                    table.remove(editor.row);
                                                                    table.clearSelection();
                                                                    return;
                                                                }
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                        view: "button",
                                                        id: "copyrow2",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_phi");

                                                                table.editStop();

                                                                var item = table.getSelectedItem();
                                                                if (item == null || item == undefined) {
                                                                    webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                    return;
                                                                }
                                                                var copy = webix.copy(item);
                                                                copy.id = webix.uid();

                                                                table.add(copy);
                                                                table.unselect(item.id);
                                                                table.select(copy.id, "tnphi", false);
                                                                table.edit({
                                                                    row: copy.id,
                                                                    column: "tnphi",
                                                                });
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                view: "datatable",
                                                resizeColumn: true,
                                                id: "hoadon68_phi",
                                                editable: true,
                                                select: "cell",
                                                drag: true,
                                                scroll: true,
                                                columns: subCols,
                                                select_change: tab.select_change,
                                                cell_editstop: tab.cell_editstop,
                                                after_addrow: tab.after_addrow,
                                                after_delrow: tab.after_delrow,
                                                oncheck: tab.oncheck,
                                                on: {
                                                    onAfterAdd: function (id, index) {
                                                        var item_inf = webix.$$("invoiceForms").getValues();
                                                        var tudongtinhtien = item_inf["tudongtinhtien"];
                                                        if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                            if (this.config.after_addrow != null) {
                                                                var fn = Function("id", "index", "tableId", this.config.after_addrow);
                                                                fn(id, index, this.config.id);
                                                            }
                                                        }
                                                        commonHD.CanhBaoTinhTien();
                                                    },
                                                    onAfterDelete: function (id) {
                                                        var item_inf = webix.$$("invoiceForms").getValues();
                                                        var tudongtinhtien = item_inf["tudongtinhtien"];
                                                        if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                            if (this.config.after_delrow != null) {
                                                                var fn = Function("id", "tableId", this.config.after_delrow);
                                                                fn(id, this.config.id);
                                                            }
                                                        }
                                                        commonHD.CanhBaoTinhTien();
                                                    },
                                                    onAfterEditStop: function (state, editor, ignore) {
                                                        if (state.value === state.old) return;
                                                        var item_inf = webix.$$("invoiceForms").getValues();
                                                        var tudongtinhtien = item_inf["tudongtinhtien"];
                                                        if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                            if (this.config.cell_editstop != null) {
                                                                var fn = Function("state", "editor", "ignore", "tableId", this.config.cell_editstop);
                                                                fn(state, editor, ignore, this.config.id);
                                                            }
                                                        }
                                                        commonHD.CanhBaoTinhTien();
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                };

                                findJson.findAndReplace(el, "phi_tab", item);
                                m++;
                            }
                        }
                    }

                    el.push({
                        // paddingY:10,
                        margin: 10,
                        cols: cols,
                    });
                    webix.ui(el, $$("invoiceForms"));
                    //$$("tab_replace").define("tabbar",{width:150 * m});
                    //console.log(jsonElement);

                    var result = webix
                        .ajax()
                        .sync()
                        .get(app.config.host + "/System/GetDataReferencesByRefId?refId=RF00505").response;
                    var count = JSON.parse(result)[0].count;
                    if (count > 0) {
                        $$("btnHoadonCQT").hide();
                    }

                    this.SetDefaultValue(windowconfig);
                }
            },
            SetDefaultValue: function (winconfig) {
                var form = webix.$$("invoiceForms");
                var item = form.getValues();
                var vc_window = winconfig["data"][0];

                var tabs = vc_window.Tabs;

                for (var i = 0; i < tabs.length; i++) {
                    var tab = tabs[i];

                    if (tab.tab_type == "Normal" || tab.tab_type == "Master") {
                        var fields = tab.Fields;

                        for (var j = 0; j < fields.length; j++) {
                            var field = fields[j];

                            if (field.column_name == tab.table_name + "_id") {
                                item[field.column_name] = null;
                            }

                            if (field.column_name == "branch_code") {
                                item[field.column_name] = user.getDvcsID();
                            }

                            if (field.default_value != null) {
                                var defaultValue = field.default_value.toString();

                                if (defaultValue.startsWith("@Default=")) {
                                    item[field.column_name] = defaultValue.replace("@Default=", "");
                                }

                                if (defaultValue.startsWith("@JS=")) {
                                    var fn = Function(defaultValue.replace("@JS=", ""));
                                    item[field.column_name] = fn();
                                }

                                if (defaultValue.startsWith("@API=")) {
                                    var apiUrl = defaultValue.replace("@API=", "").replace(/\{(\w+)\}/g, function (m, key) {
                                        return encodeURIComponent(item[key] || "");
                                    });
                                    try {
                                        var apiRes = webix.ajax().sync().get(app.config.host + apiUrl).response;
                                        var apiData = JSON.parse(apiRes).data;

                                        if (apiData && apiData.length > 0) {
                                            var apiRow = apiData[0];
                                            if (field.field_expression) {
                                                var expressions = field.field_expression.split(";");
                                                for (var ei = 0; ei < expressions.length; ei++) {
                                                    var expr = expressions[ei].replace("{", "").replace("}", "");
                                                    var parts = expr.split(":");
                                                    // parts[0] = tên field API, parts[1] = tên field form
                                                    item[parts[1]] = apiRow[parts[0]];
                                                }
                                            } else {
                                                item[field.column_name] = apiRow[Object.keys(apiRow)[0]];
                                            }
                                        }
                                    } catch (e) { }
                                }
                            }
                        }
                    }
                }

                form.setValues(item);
            },
        };
    });

define('views/forms/formhoadoncode78',[
    "app",
    "locale",
    "models/user",
    "models/findjson",
    "views/commonHD",
    "callApis/hoadon68",
    "callApis/customer",
    "views/DataStorage/DataHoaDon78"], function (app, _, user, findJson, commonHD, hoadon68CallApis, customerCallApis, dataFormHd78) {
        var editmode = 0;
        var tongtienHDonBke = 0;
        var mau04 = {};
        var modeChangeView = 1; // 1 - Vào form theo dạng thường; 2 - vào form từ chức năng "Sao chép chọn dải"
        var el = [];

        function renderFormat(val) {
            if (typeof val == "undefined" || val == null || val == "" || val == 0) val = "VND";
            var url = app.config.host + "/Invoice68/GetDecimalPlace?ma_nt=" + val;
            var table_chitiet = webix.$$("hoadon68_chitiet");
            var table_phi = webix.$$("hoadon68_phi");
            var table = $$("invoiceForms");

            webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .get(url, function (text) {
                    var arr = JSON.parse(text);

                    webix.storage.local.put("dsFieldFormat", arr[0]);

                    var arrayString_chitiet = ["sluong", "dgia", "thtien", "stckhau", "tthue", "tgtien", "tienphi", "tlckhau"];

                    for (var i = 0; i < arrayString_chitiet.length; i++) {
                        var field_name = "";
                        switch (arrayString_chitiet[i]) {
                            case "sluong":
                                field_name = "quantity_decimal";
                                break;
                            case "dgia":
                                field_name = "price_decimal";
                                break;
                            case "thtien":
                                field_name = "amount_without_vat_decimal";
                                break;
                            case "stckhau":
                                field_name = "price_discount";
                                break;
                            case "tthue":
                                field_name = "tax_price";
                                break;
                            case "tgtien":
                                field_name = "total_amount_decimal";
                                break;
                            case "tienphi":
                                field_name = "fee_price";
                                break;
                            case "tlckhau":
                                field_name = "tlckhau";
                                break;
                        }

                        var decimal_place = Array(Number(arr[0][field_name]) + 1).join("9");
                        var decimal_format = Number(arr[0][field_name]);
                        var format_numeric = {
                            //maximumValue: Number("999999999999." + decimal_place),
                            //minValue: Number("-999999999999." + decimal_place),
                            decimalPlaces: Number(decimal_format),
                        };
                        var formatSoDefault = {
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: decimal_format,
                        };
                        var formatSo = webix.Number.numToStr(formatSoDefault);
                        if (field_name == "fee_price") {
                            var format_config = table_phi.getColumnConfig("tienphi");

                            format_config.format = formatSo;
                            format_config.numericConfig = format_numeric;
                        } else {
                            var format_config = table_chitiet.getColumnConfig(arrayString_chitiet[i]);

                            format_config.format = formatSo;
                            format_config.numericConfig = format_numeric;
                        }
                    }

                    var arrayString = [
                        "tgtcthue",
                        "tgtcthue10",
                        "tgtcthue5",
                        "tgtcthue0",
                        "tgtcthuek",
                        "tgtcthuekct",
                        "tgtcthuekkk",
                        "ttcktmai",
                        "ttcktmai10",
                        "ttcktmai5",
                        "ttcktmai0",
                        "ttcktmaik",
                        "ttcktmaikct",
                        "ttcktmaikkk",
                        "tgtthue",
                        "tgtthue10",
                        "tgtthue5",
                        "tgtthue0",
                        "tgtthuek",
                        "tgtthuekct",
                        "tgtthuekkk",
                        "tgtttbso",
                        "tgtttbso10",
                        "tgtttbso5",
                        "tgtttbso0",
                        "tgtttbsok",
                        "tgtttbsokct",
                        "tgtttbsokkk",
                        "tkcktmn",
                        "tgtphi",
                        "tgtttbso_last",
                    ];

                    table_chitiet.refreshColumns();
                    table_phi.refreshColumns();

                    for (var i = 0; i < arrayString.length; i++) {
                        $$(arrayString[i]).refresh();
                    }
                });
        }

        //FormButton
        var cols = [
            {
                margin: 10,
                cols: [
                    {},
                    {
                        shortcut: "F10",
                        view: "button",
                        id: "btnBangKeSave",
                        label: "Lưu (F10)",
                        type: "form",
                        align: "center",
                        width: 120,
                        hidden: true,
                        on: {
                            onClick: function () {
                                var self = this;
                                setTimeout(function () {
                                    var tongtienBangKeCT = webix.$$("tgtttbso").getValue();
                                    var item = $$("invoiceForms").getValues();
                                    var table = $$("invoiceForms");
                                    var record = $$("hoadon68_chitiet").serialize();
                                    if (record.length == 0) {
                                        webix.message("Bạn chưa bổ sung chi tiết hàng hóa");
                                        return;
                                    }
                                    var mauso = $$("khieu").getValue().toString()[0];
                                    var tudongtinhtien = item.tudongtinhtien;
                                    var app_cache = webix.storage.local.get("APP_CACHE");
                                    var windowno;
                                    if (app_cache[windowno] != null) {
                                        windowno = app_cache["data"][0].code;
                                    }

                                    for (var i = 0; i < record.length; i++) {
                                        var it = record[i];

                                        var isHasDiscount = it["tiletienthuegtgtgiam"] != null && it["tiletienthuegtgtgiam"] != "" && it["tiletienthuegtgtgiam"] != 0 && it["tiletienthuegtgtgiam"] != '0';
                                        if (tudongtinhtien == "0") {
                                            if (mauso === "2" && !isHasDiscount) {
                                                record[i].thtien = record[i].tgtien;
                                            }
                                        }
                                        var it = record[i];

                                        if (it["ten"] == null || it["ten"] == "") {
                                            webix.message("Bạn chưa nhập tên hàng");
                                            return;
                                        }
                                        if (windowno == "WIN00788C") {
                                            it.phanloaihd = 1;
                                        }
                                        if (it.kmai.toString() === "1" || it.kmai.toString() === "5") {
                                            var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                            if (!bool) {
                                                webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                                return;
                                            }
                                            if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                                webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                return;
                                            }
                                        }
                                    }

                                    if (tongtienHDonBke != tongtienBangKeCT) {
                                        webix.message("Tổng tiền chi tiết bảng kê khác tổng tiền của hoá đơn!", "error");
                                        return false;
                                    }

                                    var record_phi = $$("hoadon68_phi").serialize();
                                    for (var i = 0; i < record_phi.length; i++) {
                                        var it = record_phi[i];

                                        if (it["tnphi"] == null || it["tnphi"] == "") {
                                            webix.message("Chưa nhập tên phí/lệ phí");
                                            return;
                                        }
                                    }

                                    if (table.validate()) {
                                        // var fn = Function(check);
                                        // var result = fn();
                                        // console.log(result);
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        var details = [];
                                        details.push({ data: record });
                                        item["details"] = details;
                                        var phi = [];
                                        phi.push({
                                            data: record_phi,
                                        });
                                        item["hoadon68_phi"] = phi;
                                        // hóa đơn không mã
                                        item.is_hdcma = 1;
                                        if (tudongtinhtien == "0") {
                                            if (item.tgtttbso === undefined || item.tgtttbso === "" || item.tgtttbso === null) {
                                                item.tgtttbso = item.tgtttbso_last;
                                            }
                                        }
                                        var item1 = [];
                                        item1.push(item);
                                        var data_post = { editmode: editmode, data: item1 };

                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/Invoice68/hoadonSaveChange", data_post, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    table.enable();
                                                    table.hideProgress();
                                                    // var json = JSON.parse(text);
                                                    // webix.message(json.ExceptionMessage, "error");
                                                    webix.message(text + XmlHttpRequest, "error");
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var json = JSON.parse(text);
                                                    table.enable();
                                                    table.hideProgress();
                                                    if (!json.hasOwnProperty("error")) {
                                                        commonHD.showWarningMessage(json);
                                                        webix.message("Thêm bảng kê thành công !", "success");
                                                        var item = $$("invoiceForms").getValues();
                                                        if (item && modeChangeView == 2) {
                                                            dataFormHd78.SetData("KHID", item.cctbao_id);
                                                        }
                                                        webix.$$("invoice68").close();
                                                        app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                    } else {
                                                        webix.message(json.error, "error");
                                                    }
                                                },
                                            });
                                    }
                                }, 100);
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                    {
                        view: "button",
                        id: "btnBangKeDelete",
                        label: "Xoá",
                        type: "danger",
                        align: "center",
                        width: 80,
                        hidden: true,
                        on: {
                            onClick: function () {
                                var self = this;
                                setTimeout(function () {
                                    var item = $$("invoiceForms").getValues();
                                    var url = app.config.host + "/Invoice68/DeleteBangKeHoaDon?id=" + item.id;
                                    var table = $$("invoiceForms");
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();
                                    webix
                                        .ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(url, function (result) {
                                            if (result == "true") {
                                                webix.message("Đã xoá bảng kê !");
                                                table.enable();
                                                table.hideProgress();
                                                webix.$$("invoice68").close();
                                                app.callEvent("dataChangedInvoie68", [editmode, null]);
                                            } else {
                                                webix.message("Xoá không thành công !", "error");
                                            }
                                        });
                                }, 100);
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                    {
                        shortcut: "F10",
                        view: "button",
                        id: "btnHoadonSave",
                        label: "Lưu tạm (F10)",
                        type: "form",
                        align: "center",
                        width: 120,
                        on: {
                            onClick: function () {
                                var self = this;
                                $$("btnHoadonSave").disable();
                                setTimeout(function () {

                                    var item = $$("invoiceForms").getValues();
                                    if (item.nlap_temp != null) {
                                        var nlap_temp = new Date(item.nlap_temp);
                                        nlap_temp = new Date(nlap_temp.getFullYear(), nlap_temp.getMonth(), nlap_temp.getDate());

                                        if ($$("nlap").getValue() < nlap_temp) {
                                            webix.message("Ngày hoá đơn thay thế hoặc điều chỉnh không được nhỏ hơn hoá đơn gốc!", "error");
                                            return;
                                        }
                                    }

                                    var table = $$("invoiceForms");
                                    var record = $$("hoadon68_chitiet").serialize();

                                    if (record.length == 0) {
                                        webix.message("Bạn chưa bổ sung chi tiết hàng hóa");
                                        $$("btnHoadonSave").enable();
                                        return;
                                    }
                                    var mauso = $$("khieu").getValue().toString()[0];
                                    var tudongtinhtien = item.tudongtinhtien;

                                    var windowno = app.path[1].params[0];

                                    for (var i = 0; i < record.length; i++) {
                                        var it = record[i];
                                        var isHasDiscount = it["tiletienthuegtgtgiam"] != null && it["tiletienthuegtgtgiam"] != "" && it["tiletienthuegtgtgiam"] != 0 && it["tiletienthuegtgtgiam"] != '0';
                                        if (tudongtinhtien == "0") {
                                            if (mauso === "2" && !isHasDiscount) {
                                                record[i].thtien = record[i].tgtien;
                                            }
                                        }
                                        var it = record[i];
                                        if (windowno == "WIN00788C") {
                                            it.phanloaihd = 1;
                                        }
                                        if (it["ten"] == null || it["ten"] == "") {
                                            webix.message("Bạn chưa nhập tên hàng");
                                            return;
                                        }
                                        if (it.kmai != null && (it.kmai.toString() === "1" || it.kmai.toString() === "5")) { // Kiểm tra it.kmai != null
                                            if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                                webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                return;
                                            }
                                        }
                                    }

                                    var record_phi = $$("hoadon68_phi").serialize();
                                    for (var i = 0; i < record_phi.length; i++) {
                                        var it = record_phi[i];

                                        if (it["tnphi"] == null || it["tnphi"] == "") {
                                            webix.message("Chưa nhập tên phí/lệ phí");
                                            return;
                                        }
                                    }
                                    /*if($$("lblCanhbao").type==1){
                                        webix.message( $$("lblCanhbao").getValue()+". Không thể lưu!", "error");
                                        return;
                                    }*/

                                    if (table.validate()) {
                                        var TTKhac = [];
                                        Object.keys(item).forEach(function (key) {
                                            if (key.includes("TTKhac_")) {
                                                var test = $$(key);
                                                if (test.config.editor === "nummeric" || test.config.editor === "autonumeric") {
                                                    TTKhac.push({
                                                        ttruong: key.replace("TTKhac_", ""),
                                                        kdlieu: "decimal",
                                                        dlieu: item[key],
                                                    });
                                                }
                                                else if (test.config.view === "text") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "string", dlieu: item[key] });
                                                else if (test.config.view === "datepicker") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "dateTime", dlieu: item[key] });
                                            }
                                        });
                                        var TTKhacItem = [];
                                        TTKhacItem.push({
                                            data: TTKhac,
                                        });
                                        item["hoadon68_khac"] = TTKhacItem;

                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        var details = [];
                                        details.push({ data: record });

                                        item["details"] = details;
                                        var phi = [];
                                        phi.push({
                                            data: record_phi,
                                        });
                                        item["hoadon68_phi"] = phi;
                                        // hóa đơn không mã
                                        item.is_hdcma = 1;
                                        if (tudongtinhtien == "0") {
                                            if (item.tgtttbso === undefined || item.tgtttbso === "" || item.tgtttbso === null) {
                                                item.tgtttbso = item.tgtttbso_last;
                                            }
                                        }
                                        var item1 = [];
                                        item1.push(item);

                                        var data_post = { editmode: editmode, data: item1 };

                                        var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                        function afterSaveInvoiceSuccess(text) {
                                            var json = text.json();
                                            table.enable();
                                            table.hideProgress();
                                            if (!json.hasOwnProperty("error")) {
                                                webix.message("Lưu thông tin hóa đơn thành công!", "success");
                                                var item = $$("invoiceForms").getValues();
                                                if (item && modeChangeView == 2) {
                                                    dataFormHd78.SetData("KHID", item.cctbao_id);
                                                }
                                                webix.$$("invoice68").close();

                                                if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                } else {
                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                }
                                            } else {
                                                webix.message(json.error, "error");
                                            }
                                        }

                                        function afterSaveInvoiceError(text) {
                                            table.enable();
                                            table.hideProgress();
                                            webix.message(text.json() + XmlHttpRequest, "error");
                                        }

                                        if (isSaveCustomerInfo) {


                                            var code = $$('mnmua') != null ? $$('mnmua').getValue() : null;
                                            var buyer_name = $$('tnmua') != null ? $$('tnmua').getValue() : null;
                                            var name = $$('ten') != null ? $$('ten').getValue() : null;
                                            var tax_code = $$('mst') != null ? $$('mst').getValue() : null;
                                            var email = $$('email') != null ? $$('email').getValue() : null;
                                            var address = $$('dchi') != null ? $$('dchi').getValue() : null;
                                            var tel = $$('sdtnmua') != null ? $$('sdtnmua').getValue() : null;
                                            var bank_account = $$('stknmua') != null ? $$('stknmua').getValue() : null;
                                            var bank_name = $$('tnhmua') != null ? $$('tnhmua').getValue() : null;
                                            var name_label = $$('ten') != null ? $$('ten').config.label : "Tên";
                                            var address_label = $$('dchi') != null ? $$('dchi').config.label : "Địa chỉ";

                                            var obj = {
                                                code: code,
                                                buyer_name: buyer_name,
                                                name: name,
                                                tax_code: tax_code,
                                                email: email,
                                                address: address,
                                                tel: tel,
                                                bank_account: bank_account,
                                                bank_name: bank_name,
                                            };
                                            var checkMessage = [];

                                            if (obj.code == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                            if (obj.name == "") checkMessage.push('"' + name_label + '" là trường bắt buộc nhập"');
                                            if (obj.address == "") checkMessage.push('"' + address_label + '" khách hảng là trường bắt buộc nhập"');

                                            var showConfirmUI = function () {
                                                webix.ui({
                                                    view: "window",
                                                    id: "check-customer-modal",
                                                    type: "modal",
                                                    modal: true,
                                                    position: "center",
                                                    head: {
                                                        height: 35,
                                                        cols: [
                                                            {
                                                                id: "head-form-check-customer",
                                                                view: "template",
                                                                css: "headform",
                                                                template: function (obj) {
                                                                    return "<div style='text-align: center;'>Tạo mới khách hàng thất bại<div/>";
                                                                },
                                                            }
                                                        ],
                                                    },
                                                    body: {
                                                        padding: 10,
                                                        rows: [
                                                            {
                                                                rows: checkMessage.map(function (message) {
                                                                    return {
                                                                        view: "template",
                                                                        template: "▶ " + message,
                                                                        autoheight: true, width: 350
                                                                    }
                                                                }),
                                                            },
                                                            {
                                                                view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                            },
                                                            {
                                                                cols: [
                                                                    {},
                                                                    {
                                                                        width: 100,
                                                                        view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                            $$('check-customer-modal').hide();
                                                                            hoadon68CallApis.hoadonSaveChange(data_post)
                                                                                .then(afterSaveInvoiceSuccess)
                                                                                .catch(afterSaveInvoiceError);
                                                                        }
                                                                    },
                                                                    {
                                                                        width: 100,
                                                                        view: "button", value: "Nhập lại", type: "danger", click: function () {
                                                                            $$('check-customer-modal').hide();
                                                                            table.enable();
                                                                            table.hideProgress();
                                                                        }
                                                                    },
                                                                    {}
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                }).show()
                                            }

                                            if (checkMessage.length > 0) {
                                                showConfirmUI();
                                            } else {
                                                customerCallApis.saveCustomer(obj).then(function (res) {
                                                    res = res.json();

                                                    if (!res.status) {
                                                        checkMessage.push(res.message.replace("P0001: ", ""));
                                                        showConfirmUI();
                                                    } else {

                                                        webix.message("Lưu thông tin khách hàng thành công", "success"); hoadon68CallApis.hoadonSaveChange(data_post)
                                                            .then(afterSaveInvoiceSuccess)
                                                            .catch(afterSaveInvoiceError);
                                                    }
                                                });
                                            }
                                        } else
                                            hoadon68CallApis.hoadonSaveChange(data_post)
                                                .then(afterSaveInvoiceSuccess)
                                                .catch(afterSaveInvoiceError);;

                                    }
                                }, 100);
                                $$("btnHoadonSave").enable();
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                    {
                        shortcut: "F11",
                        view: "button",
                        id: "btnHoadonCQT",
                        label: "Ký và gửi CQT (F11)",
                        type: "form",
                        align: "center",
                        width: 150,
                        on: {
                            onClick: function () {
                                var self = this;
                                $$("btnHoadonCQT").disable();
                                setTimeout(function () {
                                    var item = $$("invoiceForms").getValues();
                                    if (item.nlap_temp != null) {
                                        var nlap_temp = new Date(item.nlap_temp);
                                        nlap_temp = new Date(nlap_temp.getFullYear(), nlap_temp.getMonth(), nlap_temp.getDate());

                                        if ($$("nlap").getValue() < nlap_temp) {
                                            webix.message("Ngày hoá đơn thay thế hoặc điều chỉnh không được nhỏ hơn hoá đơn gốc!", "error");
                                            return;
                                        }
                                    }
                                    var table = $$("invoiceForms");
                                    var record = $$("hoadon68_chitiet").serialize();
                                    if (record.length == 0) {
                                        webix.message("Bạn chưa bổ sung chi tiết hàng hóa");
                                        return;
                                    }
                                    var mauso = $$("khieu").getValue().toString()[0];
                                    var tudongtinhtien = item.tudongtinhtien;
                                    var app_cache = webix.storage.local.get("APP_CACHE");
                                    var windowno;
                                    if (app_cache[windowno] != null) {
                                        windowno = app_cache["data"][0].code;
                                    }

                                    for (var i = 0; i < record.length; i++) {
                                        var it = record[i];
                                        var isHasDiscount = it["tiletienthuegtgtgiam"] != null && it["tiletienthuegtgtgiam"] != "" && it["tiletienthuegtgtgiam"] != 0 && it["tiletienthuegtgtgiam"] != '0';
                                        if (tudongtinhtien == "0") {
                                            if (mauso === "2" && !isHasDiscount) {
                                                record[i].thtien = record[i].tgtien;
                                            }
                                        }
                                        var it = record[i];
                                        if (windowno == "WIN00788C") {
                                            it.phanloaihd = 1;
                                        }
                                        if (it["ten"] == null || it["ten"] == "") {
                                            webix.message("Bạn chưa nhập tên hàng");
                                            $$("btnHoadonCQT").enable();
                                            return;
                                        }
                                        if (it.kmai.toString() === "1" || it.kmai.toString() === "5") {
                                            /*var bool = Number(it.tgtien) == Number(it.thtien) + Number(it.tthue);
                                        if (!bool) {
                                            webix.message("Tiền trước thuế + Tiền thuế != tiền sau thuế");
                                            return;
                                        }*/
                                            if ((it["tsuat"] == null || it["tsuat"] == "") && (mauso === "1" || mauso === "5")) {
                                                webix.message("Bạn chưa nhập thuế suất hàng hóa " + it["ten"]);
                                                return;
                                            }
                                        }
                                    }
                                    /*if($$("lblCanhbao").type==1){
                                        webix.message( $$("lblCanhbao").getValue()+". Không thể lưu!", "error");
                                        return;
                                    }*/

                                    if (table.validate()) {
                                        var TTKhac = [];
                                        Object.keys(item).forEach(function (key) {
                                            if (key.includes("TTKhac_")) {
                                                var test = $$(key);
                                                if (test.config.editor === "nummeric" || test.config.editor === "autonumeric") {
                                                    TTKhac.push({
                                                        ttruong: key.replace("TTKhac_", ""),
                                                        kdlieu: "decimal",
                                                        dlieu: item[key],
                                                    });
                                                }
                                                else if (test.config.view === "text") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "string", dlieu: item[key] });
                                                else if (test.config.view === "datepicker") TTKhac.push({ ttruong: key.replace("TTKhac_", ""), kdlieu: "dateTime", dlieu: item[key] });
                                            }
                                        });
                                        var TTKhacItem = [];
                                        TTKhacItem.push({
                                            data: TTKhac,
                                        });
                                        item["hoadon68_khac"] = TTKhacItem;
                                        // var fn = Function(check);
                                        // var result = fn();
                                        // console.log(result);
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();

                                        var details = [];
                                        details.push({ data: $$("hoadon68_chitiet").serialize() });
                                        item["details"] = details;
                                        var phi = [];
                                        phi.push({
                                            data: $$("hoadon68_phi").serialize(),
                                        });
                                        item["hoadon68_phi"] = phi;
                                        // hóa đơn không mã
                                        item.is_hdcma = 1;
                                        if (tudongtinhtien == "0") {
                                            if (item.tgtttbso === undefined || item.tgtttbso === "" || item.tgtttbso === null) {
                                                item.tgtttbso = item.tgtttbso_last;
                                            }
                                        }
                                        var item1 = [];
                                        item1.push(item);
                                        var data_post = { editmode: editmode, data: item1 };

                                        var isSaveCustomerInfo = $$('is_save_customer_info') != null && $$('is_save_customer_info').getValue();

                                        function afterSaveInvoiceSuccess(text) {
                                            var json = text.json();
                                            table.enable();
                                            table.hideProgress();
                                            if (!json.hasOwnProperty("error")) {
                                                webix.message("Lưu thông tin hóa đơn thành công!", "success");

                                                var item = $$("invoiceForms").getValues();
                                                if (item && modeChangeView == 2) {
                                                    dataFormHd78.SetData("KHID", item.cctbao_id);
                                                }
                                                webix.$$("invoice68").close();

                                                if (item.hdon_id_old !== null && item.hdon_id === "" && item.tthai_old != "Đã ký") {
                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                } else {
                                                    app.callEvent("dataChangedInvoie68", [editmode, json.data]);
                                                }

                                                var lsthdon_id = [];
                                                lsthdon_id.push(json.data.hdon_id);
                                                commonHD.ExcuteHoaDon(lsthdon_id, true, true);

                                            } else {
                                                webix.message(json.error, "error");
                                            }
                                        }

                                        function afterSaveInvoiceError(text) {
                                            table.enable();
                                            table.hideProgress();
                                            webix.message(text.json() + XmlHttpRequest, "error");
                                        }

                                        if (isSaveCustomerInfo) {


                                            var code = $$('mnmua') != null ? $$('mnmua').getValue() : null;
                                            var buyer_name = $$('tnmua') != null ? $$('tnmua').getValue() : null;
                                            var name = $$('ten') != null ? $$('ten').getValue() : null;
                                            var tax_code = $$('mst') != null ? $$('mst').getValue() : null;
                                            var email = $$('email') != null ? $$('email').getValue() : null;
                                            var address = $$('dchi') != null ? $$('dchi').getValue() : null;
                                            var tel = $$('sdtnmua') != null ? $$('sdtnmua').getValue() : null;
                                            var bank_account = $$('stknmua') != null ? $$('stknmua').getValue() : null;
                                            var bank_name = $$('tnhmua') != null ? $$('tnhmua').getValue() : null;
                                            var name_label = $$('ten') != null ? $$('ten').config.label : "Tên";
                                            var address_label = $$('dchi') != null ? $$('dchi').config.label : "Địa chỉ";

                                            var obj = {
                                                code: code,
                                                buyer_name: buyer_name,
                                                name: name,
                                                tax_code: tax_code,
                                                email: email,
                                                address: address,
                                                tel: tel,
                                                bank_account: bank_account,
                                                bank_name: bank_name,
                                            };

                                            var checkMessage = [];

                                            if (obj.code == "") checkMessage.push('"Mã" khách hảng là trường bắt buộc nhập"');
                                            if (obj.name == "") checkMessage.push('"' + name_label + '" là trường bắt buộc nhập"');
                                            if (obj.address == "") checkMessage.push('"' + address_label + '" khách hảng là trường bắt buộc nhập"');

                                            var showConfirmUI = function () {
                                                webix.ui({
                                                    view: "window",
                                                    id: "check-customer-modal",
                                                    type: "modal",
                                                    modal: true,
                                                    position: "center",
                                                    head: {
                                                        height: 35,
                                                        cols: [
                                                            {
                                                                id: "head-form-check-customer",
                                                                view: "template",
                                                                css: "headform",
                                                                template: function (obj) {
                                                                    return "<div style='text-align: center;'>Tạo mới khách hàng thất bại<div/>";
                                                                },
                                                            }
                                                        ],
                                                    },
                                                    body: {
                                                        padding: 10,
                                                        rows: [
                                                            {
                                                                rows: checkMessage.map(function (message) {
                                                                    return {
                                                                        view: "template",
                                                                        template: "▶ " + message,
                                                                        autoheight: true, width: 350
                                                                    }
                                                                }),
                                                            },
                                                            {
                                                                view: "template", autoheight: true, template: "<div style='text-align:center; padding:10px 20px'><i>Chọn \"Tạo hóa đơn\" để tạo hóa đơn và không tạo mới khách hàng</i></div>"
                                                            },
                                                            {
                                                                cols: [
                                                                    {},
                                                                    {
                                                                        width: 100,
                                                                        view: "button", value: "Tạo hóa đơn", type: "form", click: function () {
                                                                            $$('check-customer-modal').hide();
                                                                            hoadon68CallApis.hoadonSaveChange(data_post)
                                                                                .then(afterSaveInvoiceSuccess)
                                                                                .catch(afterSaveInvoiceError);
                                                                        }
                                                                    },
                                                                    {
                                                                        width: 100,
                                                                        view: "button", value: "Nhập lại", type: "danger", click: function () {
                                                                            $$('check-customer-modal').hide();
                                                                            table.enable();
                                                                            table.hideProgress();
                                                                        }
                                                                    },
                                                                    {}
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                }).show()
                                            }

                                            if (checkMessage.length > 0) {
                                                showConfirmUI();
                                            } else {
                                                customerCallApis.saveCustomer(obj).then(function (res) {
                                                    res = res.json();

                                                    if (!res.status) {
                                                        checkMessage.push(res.message.replace("P0001: ", ""));
                                                        showConfirmUI();
                                                    } else {

                                                        webix.message("Lưu thông tin khách hàng thành công", "success"); hoadon68CallApis.hoadonSaveChange(data_post)
                                                            .then(afterSaveInvoiceSuccess)
                                                            .catch(afterSaveInvoiceError);
                                                    }
                                                });
                                            }
                                        } else
                                            hoadon68CallApis.hoadonSaveChange(data_post)
                                                .then(afterSaveInvoiceSuccess)
                                                .catch(afterSaveInvoiceError);;

                                    }
                                    $$("btnHoadonCQT").enable();
                                }, 100);
                                $$("btnHoadonCQT").enable();
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                    {
                        view: "button",
                        hotkey: "esc",
                        label: "Hủy bỏ (ESC)",
                        align: "center",
                        type: "danger",
                        width: 120,
                        click: function () {
                            this.getTopParentView().close();
                            app.callEvent("dataChangedInvoie68", [editmode, null]);
                        },
                    },
                    {},
                ],
            },
        ];
        //FormDetail Tạo item trên trang from từ tab và data

        return {
            $ui: {
                view: "window",
                modal: true,
                position: "center",
                css: "headformchil",
                head: {
                    //view: "toolbar",
                    // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                    //css: { "background": "#e6f2ff !important" },
                    height: 35,
                    cols: [
                        {
                            id: "head-iconInvoice",
                            view: "template",
                            css: "headform",
                            width: 35,
                            template: "",
                        },
                        {
                            id: "head-formInvoice",
                            view: "template",
                            css: "headform",
                            template: function (obj) {
                                return "<div>Test Form<div/>";
                            },
                        },
                        {
                            view: "icon",
                            icon: "fas fa-question-circle",
                            id: "help_InvoiceForms",
                            tooltip: _("HELPER"),
                            click: function () {
                                // var form = webix.$$("window-form");
                                // hint_form(form.config.hint);
                            },
                        },
                    ],
                },
                id: "invoice68",
                resize: true,
                fullscreen: true,
                move: true,
                on: {
                    onBeforeShow: function () { },
                },
                body: {
                    paddingY: 10,
                    paddingX: 10,
                    elementsConfig: { labelWidth: 100 },
                    view: "form",
                    id: "invoiceForms",
                    width: 800,
                    height: 500,
                    complexData: true,
                    margin: 0,
                    on: {
                        // onViewShow: function () {
                        // }
                    },
                    elements: el,
                },
            },
            setValues: function (item, winconfig, params) {
                commonHD.setdsFieldFormatFromLocal(item.dvtte);
                var win = $$(this.$ui.id);
                var form = win.getChildViews()[1];
                if (item != null) {
                    this.editgiatri(item);

                    if (item.docngoaitetv) {
                        item.docngoaitetv = 1;
                    } else {
                        item.docngoaitetv = 0;
                    }

                    form.setValues(item);

                    var tableDetail = webix.$$("hoadon68_chitiet");
                    var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                    tableDetail.clearAll();
                    tableDetail.load(url);
                    var tablePhi = webix.$$("hoadon68_phi");
                    var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                    tablePhi.clearAll();
                    tablePhi.load(urlPhi);
                    var urlKhac = app.config.host + "/Invoice68/GetDataInvoiceKhac?id=" + item.id;
                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .get(urlKhac, function (text) {
                            var data = JSON.parse(text);
                            for (var i = 0; i < data.length; i++) {
                                try {
                                    if ($$("TTKhac_" + data[i].ttruong) !== undefined && $$("TTKhac_" + data[i].ttruong) !== null) $$("TTKhac_" + data[i].ttruong).setValue(data[i]["dlieu"]);
                                } catch (e) { }
                            }
                        });
                }

                if (editmode == 2) {
                }
                // nếu có mẫu 04 (hóa đơn hủy)
                if (winconfig != null) {
                    mau04 = winconfig;
                    $$("btnHoadonSaveMau04").show();
                    $$("btnHoadonCQT").destructor();
                    $$("btnHoadonSave").destructor();
                }
                this.getFormat(item["dvtte"], item);
            },
            setValuesBangKe: function (item, winconfig, params) {
                var win = $$(this.$ui.id);
                tongtienHDonBke = item.tgtttbso;
                var form = win.getChildViews()[1];
                if (item != null) {
                    this.editgiatri(item);

                    form.setValues(item);

                    var tableDetail = webix.$$("hoadon68_chitiet");
                    var url = "";
                    if (editmode == 4) {
                        url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                    } else {
                        url = app.config.host + "/Invoice68/GetDataInvoiceDetail_BangKe?id=" + item.id;
                    }
                    tableDetail.clearAll();
                    tableDetail.load(url);
                }
                // nếu có mẫu 04 (hóa đơn hủy)
                if (winconfig != null) {
                    mau04 = winconfig;
                    $$("btnHoadonSaveMau04").show();
                    $$("btnHoadonCQT").destructor();
                    $$("btnHoadonSave").destructor();
                }
                this.getFormat(item["dvtte"]);
            },
            editgiatri: function (item) {
                if (item["tdlap"] !== undefined) item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                if (item["cqqdbants"] !== undefined) item["cqqdbants"] = removeTimeZoneT(item["cqqdbants"]);
                if (item["tgvchdtu"] !== undefined) item["tgvchdtu"] = removeTimeZoneT(item["tgvchdtu"]);
                if (item["tgvchdden"] !== undefined) item["tgvchdden"] = removeTimeZoneT(item["tgvchdden"]);
                if (item["nqdbants"] !== undefined) item["nqdbants"] = removeTimeZoneT(item["nqdbants"]);
                if (item["nbke"] !== undefined) item["nbke"] = removeTimeZoneT(item["nbke"]);
                if (item["hdktngay"] !== undefined) item["hdktngay"] = removeTimeZoneT(item["hdktngay"]);
                item["hddckptquan"] = item["hddckptquan"] == true ? 1 : 0;
                item["giamthuebanhang20"] = item["giamthuebanhang20"] == true ? 1 : 0;
                if (item["nbke"] !== undefined) item["nbke"] = removeTimeZoneT(item["nbke"]);
            },
            setEditMode: function (mode) {
                editmode = mode;
                //var form = webix.$$("invoiceForms");
                var form = $$(this.$ui.id);
                //var topParentView = form.getTopParentView();
                form.config.editmode = mode;
                var icon = "";
                if (editmode == 1 || editmode == 4) {
                    icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                } else {
                    if (editmode == 2 || editmode == 5) icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                }

                webix.$$("head-iconInvoice").setHTML(icon);
                webix.$$("head-iconInvoice").refresh();
            },
            setModeChangeView: function (mode) {
                if (mode) {
                    modeChangeView = mode;
                }
            },
            setNewInvoice: function () {
                var form = webix.$$("invoiceForms");
                form.config.newInvoice = true;
            },
            copyValues: function (item) {
                var form = webix.$$("invoiceForms");

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .get(url, function (text) {
                        var data = JSON.parse(text);

                        for (var i = 0; i < data.length; i++) {
                            data[i]["cthdon_id"] = null;
                            data[i]["hdon_id"] = null;
                        }

                        tableDetail.clearAll();
                        tableDetail.parse(data);
                    });
                var tablePhi = webix.$$("hoadon68_phi");
                var urlPhi = app.config.host + "/Invoice68/GetDataInvoicePhi?id=" + item.id;
                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .get(urlPhi, function (text) {
                        var data = JSON.parse(text);

                        for (var i = 0; i < data.length; i++) {
                            data[i]["phi_id"] = null;
                            data[i]["hdon_id"] = null;
                        }

                        tablePhi.clearAll();
                        tablePhi.parse(data);
                    });
                var urlKhac = app.config.host + "/Invoice68/GetDataInvoiceKhac?id=" + item.id;
                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .get(urlKhac, function (text) {
                        var data = JSON.parse(text);
                        for (var i = 0; i < data.length; i++) {
                            try {
                                if ($$("TTKhac_" + data[i].ttruong) !== undefined && $$("TTKhac_" + data[i].ttruong) !== null) $$("TTKhac_" + data[i].ttruong).setValue(data[i]["dlieu"]);
                            } catch (e) { }
                        }
                    });
                // tableDetail.clearAll();
                // tableDetail.load(url);
                item["tthdon"] = 0;
                item["tthdon_original"] = 0;
                item["tthdon_old"] = 0;
                item["hdon_id"] = null;
                item["hdon68_id_lk"] = null;
                item["nky"] = null;
                item["id"] = webix.uid();
                item["giamthuebanhang20"] = item["giamthuebanhang20"] == true ? 1 : 0;
                item["hddckptquan"] = item["hddckptquan"] == true ? 1 : 0;
                item["nbke"] = null;
                this.editgiatri(item);
                form.setValues(item);
                this.getFormat(item["dvtte"]);
            },
            getFormat: function (val, data) {
                commonHD.renderFormat(val, false, data);
            },
            initUINew: function (cctbao_id) {
                $$("cctbao_id").setValue(cctbao_id);
                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .get(app.config.host + "/Invoice68/getKyhieu?cctbao_id=" + cctbao_id, function (text) {
                        var data = JSON.parse(text);

                        if (data.length > 0) {
                            var form = $$("invoiceForms");
                            var values = form.getValues();
                            values["khieu"] = data[0]["khhdon"];
                            values["mcqtcap"] = data[0]["mccqthue"];
                            values["tudongtinhtien"] = 1;
                            form.setValues(values);
                        }
                    });
                this.getFormat();
            },
            initUI: function (windowconfig) {
                var rp = windowconfig;
                var vc_window = rp["data"][0];
                var tabs = vc_window.Tabs;
                $$("head-formInvoice").define("template", "<div>" + vc_window.name + "<div/>");
                el = [];
                var col = [];
                var m = 0;
                debugger
                if (vc_window.detail_layout != null && vc_window.detail_layout != "") {
                    var layoutdetail = JSON.parse(vc_window.detail_layout);

                    var layout_element = JSON.stringify(layoutdetail.elements);
                    var json_layout = JSON.parse(layout_element);
                    //console.log(json_layout);
                    for (var i = 0; i < json_layout.length; i++) {
                        el.push(json_layout[i]);
                    }

                    var jsonElement = findJson.getObjects(JSON.parse(JSON.stringify(el)), "id", "");

                    for (var i = 0; i < jsonElement.length; i++) {
                        //var item = jsonElement[i];
                        //var item = jsonElement[i];
                        var fields = rp["data"][0]["Tabs"][0]["Fields"];

                        for (var j = 0; j < fields.length; j++) {
                            var field = fields[j];

                            if (jsonElement[i].name == field.column_name) {
                                item = commonHD.CreatItemMaterFromData(field);
                                jsonElement[i] = item;

                                findJson.findAndReplace(el, jsonElement[i].name, item);
                            }
                        }
                    }
                    if (vc_window.window_type == "MasterDetail") {
                        for (var i = 0; i < tabs.length; i++) {
                            var tab = tabs[i];

                            if (tab.tab_type == "Master") {
                                continue;
                            }

                            var subCols = [];

                            for (var j = 0; j < tab.Fields.length; j++) {
                                var field = tab.Fields[j];

                                subCols.push(commonHD.CreatItemFromData(field, tab));
                            }

                            if (tab.tab_type == "Detail" && tab.foreign_key === "detail_tab") {
                                var item = {
                                    id: "detail_tab",
                                    header: "Chi tiết hóa đơn",
                                    select: "cell",

                                    body: {
                                        rows: [
                                            {
                                                view: "toolbar",
                                                height: 40,
                                                cols: [
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                        id: "addrow",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_chitiet");
                                                                var item = {
                                                                    id: webix.uid(),
                                                                };
                                                                table.add(item);
                                                                table.select(item.id, "ma", false);
                                                                table.edit({
                                                                    row: item.id,
                                                                    column: "ma",
                                                                });
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                        id: "removerow",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_chitiet");

                                                                table.editStop();

                                                                var item = table.getSelectedItem();

                                                                if (!webix.isUndefined(item)) {
                                                                    table.remove(item.id);
                                                                    table.clearSelection();
                                                                    return;
                                                                }

                                                                var editor = table.getEditState();

                                                                if (!webix.isUndefined(editor)) {
                                                                    table.remove(editor.row);
                                                                    table.clearSelection();
                                                                    return;
                                                                }
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                        view: "button",
                                                        id: "copyrow",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_chitiet");

                                                                table.editStop();

                                                                var item = table.getSelectedItem();
                                                                if (item == null || item == undefined) {
                                                                    webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                    return;
                                                                }
                                                                var copy = webix.copy(item);
                                                                copy.cthdon_id = null;
                                                                copy.id = webix.uid();

                                                                table.add(copy);
                                                                table.unselect(item.id);
                                                                table.select(copy.id, "ma", false);
                                                                table.edit({
                                                                    row: copy.id,
                                                                    column: "ma",
                                                                });
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 150,
                                                        label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " Nhận excel chi tiết" + "</span>",
                                                        view: "button",
                                                        id: "importRowDetail",
                                                        css: "btnForm",
                                                        hidden: vc_window.code === "WIN00788C",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = $$("invoiceViews");
                                                                var item = table.getSelectedItem();
                                                                // if(item == null || item == "")
                                                                // {
                                                                // webix.message("Bạn chưa chọn hóa đơn cần nhận chi tiết !", "error");
                                                                // return;
                                                                // }

                                                                // if (item.tthai != "Chờ ký") {
                                                                //     webix.message("Hóa đơn phải có trạng thái chờ ký, bạn mới có thể nhập excel chi tiết!", "error");
                                                                //     return;
                                                                // }

                                                                require(["views/forms/uploadexcelform"], function (uploadForm) {
                                                                    uploadForm.$ui.tableId = table.config.id;
                                                                    var win = table.$scope.ui(uploadForm.$ui);
                                                                    win.show();
                                                                    debugger
                                                                    if (vc_window.code === "WIN00782C") {
                                                                        webix.$$("uploader").define("formData", { excel_id: "EX00017", filename: "Mẫu import chi tiết HD bán hàng.xlsx" });
                                                                    } else if (vc_window.code === "WIN00785C" || vc_window.code === "WIN00786C"
                                                                        || vc_window.code === "WIN00783C" || vc_window.code === "WIN00784C"
                                                                    ) {
                                                                        webix.$$("uploader").define("formData", { excel_id: "EX00024", filename: "Nhan chi tiet mot HD68.xlsx" });
                                                                    }
                                                                    else {
                                                                        webix.$$("uploader").define("formData", { excel_id: "EX00011", filename: "Nhan chi tiet mot HD68.xlsx" });

                                                                    }
                                                                    webix.$$("uploader").hide();
                                                                });

                                                                // var table = webix.$$("hoadon68_chitiet");

                                                                // table.editStop();

                                                                // var item = table.getSelectedItem();
                                                                // if (item == null || item == undefined) {
                                                                //     webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                //     return;
                                                                // }

                                                                // var copy = webix.copy(item);
                                                                // copy.cthdon_id = null;
                                                                // copy.id = webix.uid();

                                                                // table.add(copy);
                                                                // table.unselect(item.id);
                                                                // table.select(copy.id, "ma", false);
                                                                // table.edit({
                                                                //     row: copy.id,
                                                                //     column: "ma",
                                                                // });
                                                            },
                                                        },
                                                    }
                                                ],
                                            },
                                            {
                                                view: "datatable",
                                                resizeColumn: true,
                                                id: "hoadon68_chitiet",
                                                editable: true,
                                                select: "cell",
                                                drag: true,
                                                scroll: true,
                                                columns: subCols,
                                                select_change: tab.select_change,
                                                cell_editstop: tab.cell_editstop,
                                                after_addrow: tab.after_addrow,
                                                after_delrow: tab.after_delrow,
                                                oncheck: tab.oncheck,
                                                on: {
                                                    "data->onStoreUpdated": function () {
                                                        this.data.each(function (obj, i) {
                                                            obj.stt = i + 1;
                                                        });
                                                    },
                                                    onAfterLoad: function () {
                                                        var table = this;
                                                        var data = table.serialize();
                                                        data.forEach(function (entry) {
                                                            if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                if (entry["stckhau"] != 0 || entry["tlckhau"] != 0) {
                                                                    var ck = $$("check_chietkhau");

                                                                    if (ck != undefined) {
                                                                        ck.setValue(1);
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                        });
                                                        debugger
                                                        // Xử lý ẩn hiện trường HHDT
                                                        if (data) {
                                                            var isHHDT = data.find(function (e) {
                                                                if (e.hasOwnProperty('kmai')) {
                                                                    return e['kmai'] == '5';
                                                                }
                                                                return false;
                                                            })

                                                            if (isHHDT) {
                                                                $$("hoadon68_chitiet").showColumn("lhhdthu");

                                                                // có hh oto, moto
                                                                var isMoto = data.find(function (e) {
                                                                    if (e.hasOwnProperty('lhhdthu')) {
                                                                        return e['lhhdthu'] == '1';
                                                                    }
                                                                    return false;
                                                                })

                                                                if (isMoto) {
                                                                    $$("hoadon68_chitiet").showColumn("skhung");
                                                                    $$("hoadon68_chitiet").showColumn("smay");
                                                                }

                                                                // có hh dvvc
                                                                var isDvvc = data.find(function (e) {
                                                                    if (e.hasOwnProperty('lhhdthu')) {
                                                                        return e['lhhdthu'] == '2';
                                                                    }
                                                                    return false;
                                                                })

                                                                if (isDvvc) {
                                                                    $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                }

                                                                // có hh tmdt
                                                                var isTmdt = data.find(function (e) {
                                                                    if (e.hasOwnProperty('lhhdthu')) {
                                                                        return e['lhhdthu'] == '3';
                                                                    }
                                                                    return false;
                                                                })

                                                                if (isTmdt) {
                                                                    $$("hoadon68_chitiet").showColumn("tnghang");
                                                                    $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                }

                                                                $$("hoadon68_chitiet").refresh();
                                                            }
                                                        }
                                                        commonHD.CanhBaoTinhTien();
                                                    },
                                                    onCheck: function (row, column, state) {
                                                        var table = this;
                                                        if (column == "khuyen_mai") {
                                                            if (state == true) {
                                                            }
                                                        }
                                                    },
                                                    onAfterAdd: function (id, index) {
                                                        var item_inf = webix.$$("invoiceForms").getValues();
                                                        var tudongtinhtien = item_inf["tudongtinhtien"];
                                                        if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                            if (this.config.after_addrow != null) {
                                                                var fn = Function("id", "index", "tableId", this.config.after_addrow);
                                                                fn(id, index, this.config.id);
                                                            }
                                                        }
                                                        else {

                                                            var table_chitiet = webix.$$("hoadon68_chitiet");
                                                            var ishhdt = false;
                                                            var islhhdt_1 = false;
                                                            var islhhdt_2 = false;
                                                            var islhhdt_3 = false;
                                                            var data = $$("hoadon68_chitiet").serialize();
                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["kmai"] && data[i]["kmai"].toString() === "5") {
                                                                    ishhdt = true;
                                                                    break;
                                                                }
                                                            }

                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "1") {
                                                                    islhhdt_1 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "2") {
                                                                    islhhdt_2 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "3") {
                                                                    islhhdt_3 = true;
                                                                    break;
                                                                }
                                                            }


                                                        var selectedItemDetail = table_chitiet.getSelectedItem();
                                                        if(selectedItemDetail){
                                                            if(selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "3") {
                                                                selectedItemDetail["stckhau"] = 0;
                                                                selectedItemDetail["tlckhau"] = 0;
                                                                table_chitiet.updateItem(selectedItemDetail["id"], selectedItemDetail);
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() != "5"){
                                                            table_chitiet.refresh();
                                                            }else if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "5") {
                                                                $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }else{
                                                            $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }
    
    
                                                            if(ishhdt && islhhdt_1 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "1") {
                                                                $$("hoadon68_chitiet").showColumn("skhung");
                                                                $$("hoadon68_chitiet").showColumn("smay");
                                                                table_chitiet.refresh();
                                                            } else if(ishhdt && islhhdt_1){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_2 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "2") {
                                                                $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_2){
                                                                table_chitiet.refresh();
                                                            }else {
                                                            $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_3 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "3") {
                                                                $$("hoadon68_chitiet").showColumn("tnghang");
                                                                $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_3){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(!ishhdt) {
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
                                                        }else{
                                                               if(ishhdt ) {
                                                                    $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }else{
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }
        
        
                                                                if(ishhdt && islhhdt_1) {
                                                                    $$("hoadon68_chitiet").showColumn("skhung");
                                                                    $$("hoadon68_chitiet").showColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_2) {
                                                                    $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_3) {
                                                                    $$("hoadon68_chitiet").showColumn("tnghang");
                                                                    $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(!ishhdt) {
                                                                    $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
                                                        }

                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                                onAfterDelete: function (id) {
                                                    var item_inf = webix.$$("invoiceForms").getValues();
                                                    var tudongtinhtien = item_inf["tudongtinhtien"];
                                                    if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                        if (this.config.after_delrow != null) {
                                                            var fn = Function("id", "tableId", this.config.after_delrow);
                                                            fn(id, this.config.id);
                                                        }
                                                    }else{

                                                            var table_chitiet = webix.$$("hoadon68_chitiet");
                                                            var ishhdt = false;
                                                            var islhhdt_1 = false;
                                                            var islhhdt_2 = false;
                                                            var islhhdt_3 = false;
                                                            var data = $$("hoadon68_chitiet").serialize();
                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["kmai"] && data[i]["kmai"].toString() === "5") {
                                                                    ishhdt = true;
                                                                    break;
                                                                }
                                                            }

                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "1") {
                                                                    islhhdt_1 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "2") {
                                                                    islhhdt_2 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "3") {
                                                                    islhhdt_3 = true;
                                                                    break;
                                                                }
                                                            }


                                                        var selectedItemDetail = table_chitiet.getSelectedItem();
                                                        if(selectedItemDetail){
                                                            if(selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "3") {
                                                                selectedItemDetail["stckhau"] = 0;
                                                                selectedItemDetail["tlckhau"] = 0;
                                                                table_chitiet.updateItem(selectedItemDetail["id"], selectedItemDetail);
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() != "5"){
                                                            table_chitiet.refresh();
                                                            }else if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "5") {
                                                                $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }else{
                                                            $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }
    
    
                                                            if(ishhdt && islhhdt_1 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "1") {
                                                                $$("hoadon68_chitiet").showColumn("skhung");
                                                                $$("hoadon68_chitiet").showColumn("smay");
                                                                table_chitiet.refresh();
                                                            } else if(ishhdt && islhhdt_1){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_2 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "2") {
                                                                $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_2){
                                                                table_chitiet.refresh();
                                                            }else {
                                                            $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_3 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "3") {
                                                                $$("hoadon68_chitiet").showColumn("tnghang");
                                                                $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_3){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(!ishhdt) {
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
                                                        }else{
                                                               if(ishhdt ) {
                                                                    $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }else{
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }
        
        
                                                                if(ishhdt && islhhdt_1) {
                                                                    $$("hoadon68_chitiet").showColumn("skhung");
                                                                    $$("hoadon68_chitiet").showColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_2) {
                                                                    $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_3) {
                                                                    $$("hoadon68_chitiet").showColumn("tnghang");
                                                                    $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(!ishhdt) {
                                                                    $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
                                                        }
                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                                onAfterEditStop: function (state, editor, ignore) {
                                                    if (state.value === state.old) return;
                                                    var item_inf = webix.$$("invoiceForms").getValues();
                                                    var tudongtinhtien = item_inf["tudongtinhtien"];
                                                    var selectedItem = $$("hoadon68_chitiet").getItem(editor.row);
                                                    if (!selectedItem.kmai) selectedItem.kmai = "1";
                                                    if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                        if (this.config.cell_editstop != null) {
                                                            var fn = Function("state", "editor", "ignore", "tableId", this.config.cell_editstop);
                                                            fn(state, editor, ignore, this.config.id);
                                                        }
                                                    }else{

                                                            var table_chitiet = webix.$$("hoadon68_chitiet");
                                                            var ishhdt = false;
                                                            var islhhdt_1 = false;
                                                            var islhhdt_2 = false;
                                                            var islhhdt_3 = false;
                                                            var data = $$("hoadon68_chitiet").serialize();
                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["kmai"] && data[i]["kmai"].toString() === "5") {
                                                                    ishhdt = true;
                                                                    break;
                                                                }
                                                            }

                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "1") {
                                                                    islhhdt_1 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "2") {
                                                                    islhhdt_2 = true;
                                                                    break;
                                                                }
                                                            }


                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i]["lhhdthu"] && data[i]["lhhdthu"].toString() === "3") {
                                                                    islhhdt_3 = true;
                                                                    break;
                                                                }
                                                            }


                                                        var selectedItemDetail = table_chitiet.getSelectedItem();
                                                        if(selectedItemDetail){
                                                            if(selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "3") {
                                                                selectedItemDetail["stckhau"] = 0;
                                                                selectedItemDetail["tlckhau"] = 0;
                                                                table_chitiet.updateItem(selectedItemDetail["id"], selectedItemDetail);
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() != "5"){
                                                            table_chitiet.refresh();
                                                            }else if(ishhdt && selectedItemDetail["kmai"] &&  selectedItemDetail["kmai"].toString() == "5") {
                                                                $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }else{
                                                            $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                table_chitiet.refresh();
                                                            }
    
    
                                                            if(ishhdt && islhhdt_1 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "1") {
                                                                $$("hoadon68_chitiet").showColumn("skhung");
                                                                $$("hoadon68_chitiet").showColumn("smay");
                                                                table_chitiet.refresh();
                                                            } else if(ishhdt && islhhdt_1){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_2 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "2") {
                                                                $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_2){
                                                                table_chitiet.refresh();
                                                            }else {
                                                            $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(ishhdt && islhhdt_3 && selectedItemDetail["lhhdthu"] &&  selectedItemDetail["lhhdthu"].toString() == "3") {
                                                                $$("hoadon68_chitiet").showColumn("tnghang");
                                                                $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }else if(ishhdt && islhhdt_3){
                                                                table_chitiet.refresh();
                                                            }else {
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
    
                                                            if(!ishhdt) {
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                $$("hoadon68_chitiet").hideColumn("skhung");
                                                                $$("hoadon68_chitiet").hideColumn("smay");
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                table_chitiet.refresh();
                                                            }
                                                        }else{
                                                               if(ishhdt ) {
                                                                    $$("hoadon68_chitiet").showColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }else{
                                                                $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    table_chitiet.refresh();
                                                                }
        
        
                                                                if(ishhdt && islhhdt_1) {
                                                                    $$("hoadon68_chitiet").showColumn("skhung");
                                                                    $$("hoadon68_chitiet").showColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_2) {
                                                                    $$("hoadon68_chitiet").showColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(ishhdt && islhhdt_3) {
                                                                    $$("hoadon68_chitiet").showColumn("tnghang");
                                                                    $$("hoadon68_chitiet").showColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").showColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }else {
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
        
                                                                if(!ishhdt) {
                                                                    $$("hoadon68_chitiet").hideColumn("lhhdthu");
                                                                    $$("hoadon68_chitiet").hideColumn("skhung");
                                                                    $$("hoadon68_chitiet").hideColumn("smay");
                                                                    $$("hoadon68_chitiet").hideColumn("bksptvchuyen");
                                                                    $$("hoadon68_chitiet").hideColumn("tnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("dcnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mstnghang");
                                                                    $$("hoadon68_chitiet").hideColumn("mddnghang");
                                                                    table_chitiet.refresh();
                                                                }
                                                        }
                                                    }
                                                    commonHD.CanhBaoTinhTien();
                                                },
                                            },
                                        },
                                    ],
                                },
                            };

                                findJson.findAndReplace(el, tab.foreign_key, item);
                                m++;
                                //cells.push(item);
                            }
                            if (tab.tab_type == "Detail" && tab.foreign_key === "phi_tab") {
                                var item = {
                                    id: "phi_tab",
                                    header: "Tiền phí/lệ phí",
                                    select: "cell",
                                    hidden: tab.hidden,
                                    body: {
                                        rows: [
                                            {
                                                view: "toolbar",
                                                height: 40,
                                                cols: [
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F9)" + "</span>",
                                                        id: "addrow2",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_phi");
                                                                var item = {
                                                                    id: webix.uid(),
                                                                    tienphi: 0,
                                                                };
                                                                table.add(item);
                                                                table.select(item.id);
                                                                table.edit({
                                                                    row: item.id,
                                                                    column: "tnphi",
                                                                });
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F8)" + "</span>",
                                                        id: "removerow2",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_phi");
                                                                table.editStop();
                                                                var item = table.getSelectedItem();
                                                                if (!webix.isUndefined(item)) {
                                                                    table.remove(item.id);
                                                                    table.clearSelection();
                                                                    return;
                                                                }

                                                                var editor = table.getEditState();

                                                                if (!webix.isUndefined(editor)) {
                                                                    table.remove(editor.row);
                                                                    table.clearSelection();
                                                                    return;
                                                                }
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: "button",
                                                        type: "htmlbutton",
                                                        width: 65,
                                                        label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + " (F7)" + "</span>",
                                                        view: "button",
                                                        id: "copyrow2",
                                                        css: "btnForm",
                                                        on: {
                                                            onItemClick: function (id, e) {
                                                                var table = webix.$$("hoadon68_phi");

                                                                table.editStop();

                                                                var item = table.getSelectedItem();
                                                                if (item == null || item == undefined) {
                                                                    webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                    return;
                                                                }
                                                                var copy = webix.copy(item);
                                                                copy.id = webix.uid();

                                                                table.add(copy);
                                                                table.unselect(item.id);
                                                                table.select(copy.id, "tnphi", false);
                                                                table.edit({
                                                                    row: copy.id,
                                                                    column: "tnphi",
                                                                });
                                                            },
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                view: "datatable",
                                                resizeColumn: true,
                                                id: "hoadon68_phi",
                                                editable: true,
                                                select: "cell",
                                                drag: true,
                                                scroll: true,
                                                columns: subCols,
                                                select_change: tab.select_change,
                                                cell_editstop: tab.cell_editstop,
                                                after_addrow: tab.after_addrow,
                                                after_delrow: tab.after_delrow,
                                                oncheck: tab.oncheck,
                                                on: {
                                                    onAfterAdd: function (id, index) {
                                                        var item_inf = webix.$$("invoiceForms").getValues();
                                                        var tudongtinhtien = item_inf["tudongtinhtien"];
                                                        if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                            if (this.config.after_addrow != null) {
                                                                var fn = Function("id", "index", "tableId", this.config.after_addrow);
                                                                fn(id, index, this.config.id);
                                                            }
                                                        }
                                                        commonHD.CanhBaoTinhTien();
                                                    },
                                                    onAfterDelete: function (id) {
                                                        var item_inf = webix.$$("invoiceForms").getValues();
                                                        var tudongtinhtien = item_inf["tudongtinhtien"];
                                                        if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                            if (this.config.after_delrow != null) {
                                                                var fn = Function("id", "tableId", this.config.after_delrow);
                                                                fn(id, this.config.id);
                                                            }
                                                        }
                                                        commonHD.CanhBaoTinhTien();
                                                    },
                                                    onAfterEditStop: function (state, editor, ignore) {
                                                        if (state.value === state.old) return;
                                                        var item_inf = webix.$$("invoiceForms").getValues();
                                                        var tudongtinhtien = item_inf["tudongtinhtien"];
                                                        if (tudongtinhtien == undefined || tudongtinhtien == "1") {
                                                            if (this.config.cell_editstop != null) {
                                                                var fn = Function("state", "editor", "ignore", "tableId", this.config.cell_editstop);
                                                                fn(state, editor, ignore, this.config.id);
                                                            }
                                                        }
                                                        commonHD.CanhBaoTinhTien();
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                };

                                findJson.findAndReplace(el, "phi_tab", item);
                                m++;
                            }
                        }
                    }

                    el.push({
                        // paddingY:10,
                        margin: 10,
                        cols: cols,
                    });
                    webix.ui(el, $$("invoiceForms"));
                    //$$("tab_replace").define("tabbar",{width:150 * m});
                    //console.log(jsonElement);

                    var result = webix
                        .ajax()
                        .sync()
                        .get(app.config.host + "/System/GetDataReferencesByRefId?refId=RF00505").response;
                    var count = JSON.parse(result)[0].count;
                    if (count > 0) {
                        $$("btnHoadonCQT").hide();
                    }

                    this.SetDefaultValue(windowconfig);
                }
            },
            SetDefaultValue: function (winconfig) {

                var form = webix.$$("invoiceForms");
                var item = form.getValues();
                var vc_window = winconfig["data"][0];

                var tabs = vc_window.Tabs;

                for (var i = 0; i < tabs.length; i++) {
                    var tab = tabs[i];

                    if (tab.tab_type == "Normal" || tab.tab_type == "Master") {
                        var fields = tab.Fields;

                        for (var j = 0; j < fields.length; j++) {
                            var field = fields[j];

                            if (field.column_name == tab.table_name + "_id") {
                                item[field.column_name] = null;
                            }

                            if (field.column_name == "branch_code") {
                                item[field.column_name] = user.getDvcsID();
                            }

                            if (field.default_value != null) {
                                var defaultValue = field.default_value.toString();

                                if (defaultValue.startsWith("@Default=")) {
                                    item[field.column_name] = defaultValue.replace("@Default=", "");
                                }

                                if (defaultValue.startsWith("@JS=")) {
                                    var fn = Function(defaultValue.replace("@JS=", ""));
                                    item[field.column_name] = fn();
                                }

                                if (defaultValue.startsWith("@API=")) {
                                    var apiUrl = defaultValue.replace("@API=", "").replace(/\{(\w+)\}/g, function (m, key) {
                                        return encodeURIComponent(item[key] || "");
                                    });
                                    try {
                                        var apiRes = webix.ajax().sync().get(app.config.host + apiUrl).response;
                                        var apiData = JSON.parse(apiRes).data;

                                        if (apiData && apiData.length > 0) {
                                            var apiRow = apiData[0];
                                            if (field.field_expression) {
                                                var expressions = field.field_expression.split(";");
                                                for (var ei = 0; ei < expressions.length; ei++) {
                                                    var expr = expressions[ei].replace("{", "").replace("}", "");
                                                    var parts = expr.split(":");
                                                    // parts[0] = tên field API, parts[1] = tên field form
                                                    item[parts[1]] = apiRow[parts[0]];
                                                }
                                            } else {
                                                item[field.column_name] = apiRow[Object.keys(apiRow)[0]];
                                            }
                                        }
                                    } catch (e) { }
                                }
                            }
                        }
                    }
                }

                form.setValues(item);
            },
        };
    });

define('views/forms/kyhoadon',[
    "app",
    "locale",
    "models/user",
    "views/modules/minvoiceplugin"
], function (app, _, user, plugin) {
    var editmode = 0;

    return {
        $ui: {
            view: "window", modal: true, id: "chukyso-win", position: "center",
            head: "Ký hóa đơn chờ ký",
            //fullscreen: true,
            width: 600,
            height: 600,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "chukyso-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        cols: [
                            {
                                view: "datepicker",
                                name: "tu_ngay",
                                format: "%d/%m/%Y",
                                label: "Từ ngày",
                                width: 290,
                                labelPosition: "top"
                            },
                            {
                                view: "datepicker",
                                name: "den_ngay",
                                format: "%d/%m/%Y",
                                label: "Đến ngày",
                                width: 290,
                                labelPosition: "top"
                            },
                        ]
                    },
                    {
                        view: "combo",
                        name: "inv_InvoiceCode_id",
                        label: "Ký hiệu",
                        width: 600,
                        labelPosition: "top",
                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00029"
                    },
                    {
                        view: "combo",
                        width: 600,
                        name: "cerSerial",
                        label: "Chứng thư số",
                        labelPosition: "top",
                        id: "txtCerSerial",
                        options: {
                            view: "gridsuggest",
                            url: app.config.host + "/Invoice/GetListCertificates",
                            body: {
                                columns: [
                                    {
                                        id: "so_serial",
                                        header: _("SO_SERIAL"),
                                        width: 150
                                    },
                                    {
                                        id: "subjectname",
                                        header: _("SUBJECTNAME"),
                                        width: 550
                                    },
                                    {
                                        id: "ngaybatdau",
                                        header: _("NGAY_BAT_DAU"),
                                        width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    },
                                    {
                                        id: "ngayketthuc",
                                        header: _("NGAY_KET_THUC"),
                                        width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    }
                                ]
                            }

                        }
                    },
                    {
                        view: "template",
                        template: "Danh sách hóa đơn chờ ký",
                        type: "section"
                    },
                    {

                        view: "datatable",
                        select: "row",
                        id: "tblHoadon",
                        resizeColumn: true,
                        datafetch: 50,
                        on: {
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.index = i + 1;
                                })
                            }
                            // onKeyPress: function (code, e) {
                            //     var table = this;

                            //     if (e.key == "Enter") {
                            //         var win = this.getTopParentView();
                            //         var toolbar = win.getChildViews()[1].getChildViews()[0];

                            //         var btnChon = toolbar.getChildViews()[0];
                            //         btnChon.callEvent("onClick");
                            //     }
                            // }
                        },
                        columns: [
                            {
                                id: "chon1",
                                header: [{ text: "", content: "masterCheckbox" }],
                                width: 55,
                                checkValue: 'C',
                                uncheckValue: 'K',
                                template: "{common.checkbox()}"
                            },
                            { id: "index", sort: "int", header: "STT", width: 50 },
                            { id: "inv_InvoiceAuth_id", header: "ID hóa đơn", width: 250, hidden: true },
                            {
                                id: "invoice_issued_date", header: "Ngày hóa đơn", width: 150, format: function (text) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                }
                            },
                            { id: "inv_invoiceNumber", header: "Số hóa đơn" },
                            {
                                id: "total_amount", header: "Tổng tiền", width: 150, format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 0
                                })
                            }
                        ],
                        pager: "selectPagerA"
                    },
                    {
                        id: "selectPagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F9", view: "button", label: "Tải dữ liệu (F9)", type: "form", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("chukyso-form");

                                        var item = form.getValues();

                                        var parameter = {
                                            command: "CM00020",
                                            parameter: {
                                                ma_dvcs: user.getDvcsID(),
                                                tu_ngay: item.tu_ngay,
                                                den_ngay: item.den_ngay,
                                                inv_InvoiceCode_id: item.inv_InvoiceCode_id
                                            }
                                        };

                                        var url = app.config.host + "/System/ExecuteCommand";

                                        webix.extend(form, webix.ProgressBar);
                                        //form.disable();
                                        form.showProgress();

                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(url, parameter, function (text) {

                                                var json = JSON.parse(text);
                                              
                                                if (!json.hasOwnProperty("error")) {

                                                    if (json.length == 0) {
                                                        webix.message("Không có dữ liệu", "error");
                                                        var table = $$("tblHoadon");
                                                        //table.load(table.config.url);
                                                        table.clearAll();
                                                        form.hideProgress();
                                                        return;
                                                    }
                                                    else {
                                                        form.hideProgress();
                                                        $$("btnNhan").enable();
                                                        var table = $$("tblHoadon");
                                                        //table.load(table.config.url);
                                                        table.clearAll();
                                                        var table = $$("tblHoadon");
                                                        table.parse(json);
                                                    }
                                                }
                                            });
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                shortcut: "F10", id: "btnNhan", name: "btnNhan", view: "button", label: "Nhận (F10)", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("chukyso-form");

                                        // var item = form.getValues();

                                        // var parameter = {
                                        //     command: "CM00020",
                                        //     parameter: {
                                        //         ma_dvcs: user.getDvcsID(),
                                        //         tu_ngay: item.tu_ngay,
                                        //         den_ngay: item.den_ngay,
                                        //         inv_InvoiceCode_id: item.inv_InvoiceCode_id
                                        //     }
                                        // };

                                        // var url = app.config.host + "/System/ExecuteCommand";

                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();
                                        var json = $$("tblHoadon").serialize();
                                        if (json.length == 0) {
                                            webix.message("Không có dữ liệu !", "error");
                                            form.enable();
                                            form.hideProgress();
                                            return;
                                        }
                                        //console.log(json);

                                        // webix.ajax()
                                        // .headers({ 'Content-type': 'application/json' })
                                        // .post(url, parameter, function (text) {

                                        //     var json = JSON.parse(text);

                                        //     if (!json.hasOwnProperty("error")) {

                                        //         if (json.length == 0) {
                                        //             webix.message("Không có dữ liệu");
                                        //             return;
                                        //         }

                                        //         console.log(json);
                                        //         console.log(json.data);

                                        // var dshoadon = this.$scope.ui(dshoadon.$ui);
                                        // dshoadon.$ui.show();

                                        var resultTime;
                                        webix
                                            .ajax()
                                            .headers({ "Content-Type": "application/json" })
                                            .get(app.config.host + "/System/GetDate", function (text) {
                                                resultTime = JSON.parse(text);
                                            });
                                            
                                        var win = $$("chukyso-win");
                                        var server_cert = win.config.server_cert;

                                        if (server_cert == null) {
                                            var hub = plugin.hub();
                                            hub.off('resCommand');

                                            hub.on('resCommand', function (result) {
                                                var json = JSON.parse(result);

                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: 'error', text: json.error });

                                                    var form = webix.$$("chukyso-form");
                                                    form.enable();
                                                    form.hideProgress();
                                                }
                                                else {
                                                    var promises = [];

                                                    var array = json.data;

                                                    for (var i = 0; i < array.length; i++) {
                                                        var item = array[i];

                                                        var parameters = {
                                                            InvoiceXmlData: item.InvoiceXmlData,
                                                            inv_InvoiceAuth_id: item.inv_InvoiceAuth_id
                                                        };

                                                        var a = webix.ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(app.config.host + "/Invoice/SaveXml", parameters);

                                                        promises.push(a);
                                                    }

                                                    webix.promise.all(promises).then(function (results) {
                                                        var table = webix.$$("windowData");
                                                        table.clearAll();
                                                        table.load(table.config.url);

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();

                                                        var win = $$("chukyso-win");
                                                        win.close();
                                                    });


                                                }
                                            });

                                            var promises = [];

                                            for (var i = 0; i < json.length; i++) {
                                                if (json[i].chon1 != null && json[i].chon1 != "") {
                                                    if (json[i].chon1 == "C") {
                                                        //console.log(json[i]);
                                                        var a = webix.ajax().get(app.config.host + "/Invoice/ExportXml?id=" + json[i].inv_InvoiceAuth_id);
                                                        promises.push(a);
                                                    }
                                                }

                                            }

                                            webix.promise.all(promises).then(function (results) {
                                                var arrays = [];

                                                for (var i = 0; i < results.length; i++) {
                                                    arrays.push(results[i].json());
                                                }

                                                var form = webix.$$("chukyso-form");
                                                var item = form.getValues();

                                                var arg = {
                                                    idData: "#data",
                                                    data: arrays,
                                                    idSigner: "seller",
                                                    tagSign: "Signatures",
                                                    dateKy: resultTime.dateKy,
                                                    listcerts: [
                                                        {
                                                            so_serial: item.cerSerial
                                                        }
                                                    ]
                                                };

                                                hub.invoke('execCommand', 'SignListInvoices', JSON.stringify(arg));
                                            });
                                        }
                                        else {

                                            var promises = [];

                                            // for (var i = 0; i < json.length; i++) {
                                            //     if (json[i].chon1 != null && json[i].chon1 != "") {
                                            //         if (json[i].chon1 == "C") {

                                            //             var a = webix.ajax().get(app.config.host + "/Invoice/ExportXml?id=" + json[i].inv_InvoiceAuth_id);
                                            //             promises.push(a);
                                            //         }
                                            //     }

                                            // }

                                            for (var i = 0; i < json.length; i++) {
                                                // console.log(json[i]);
                                                if (json[i].chon1 == null && json[i].chon1 == "") {
                                                    continue;
                                                }
                                                else {
                                                    if (json[i].chon1 == "C") {
                                                        //console.log(json[i]);
                                                        var a = webix.ajax().get(app.config.host + "/Invoice/ExportXml?id=" + json[i].inv_InvoiceAuth_id);

                                                        //var text = xhr.responseText;
                                                        // var b = JSON.parse(a.responseText);
                                                        //console.log(a);
                                                        promises.push(a);

                                                    }
                                                }

                                            }

                                            webix.promise.all(promises).then(function (results) {
                                                var promises = [];
                                                console.log(results);
                                                var server_cert = win.config.server_cert;


                                                var txtCer = $$("txtCerSerial");
                                                var cert = txtCer.getList().getSelectedItem();

                                                for (var i = 0; i < results.length; i++) {
                                                    var json = results[i].json();

                                                    var parameters = {
                                                        xml: json["InvoiceXmlData"],
                                                        refUri: "#data",
                                                        certSerial: cert.so_serial,
                                                        tokenSerial: cert.tokenSerial,
                                                        signId: "seller",
                                                        signTag: "Signatures",
                                                        pass: cert.pass,
                                                        inv_InvoiceAuth_id: json["inv_InvoiceAuth_id"]
                                                    };

                                                    var a = webix.ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(server_cert + "/Token/SignXml", parameters, function (text) {
                                                            //console.log(text);
                                                        });

                                                    promises.push(a);
                                                }

                                                webix.promise.all(promises).then(function (results) {
                                                    var promises = [];

                                                    for (var i = 0; i < results.length; i++) {
                                                        var json = results[i].json();

                                                        var parameters = {
                                                            InvoiceXmlData: json.xml,
                                                            inv_InvoiceAuth_id: json.inv_InvoiceAuth_id
                                                        };

                                                        var a = webix.ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(server_cert + "/Invoice/SaveXml", parameters, function (text) {
                                                                //console.log(text);
                                                            });

                                                        promises.push(a);
                                                    }
                                                    webix.promise.all(promises).then(function (results) {
                                                        var table = webix.$$("windowData");
                                                        table.clearAll();
                                                        table.load(table.config.url);

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();

                                                        var win = $$("chukyso-win");
                                                        win.close();
                                                    }).fail(function (err) {
                                                        alert(err);

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();
                                                    });


                                                }).fail(function (err) {
                                                    alert(err);

                                                    var form = webix.$$("chukyso-form");
                                                    form.enable();
                                                    form.hideProgress();
                                                });

                                            }).fail(function (err) {
                                                alert(err);

                                                var form = webix.$$("chukyso-form");
                                                form.enable();
                                                form.hideProgress();
                                            });

                                        }
                                    }
                                    // else {
                                    //     webix.message(json.error);

                                    //     var form = webix.$$("chukyso-form");
                                    //     form.enable();
                                    //     form.hideProgress();

                                    // }

                                    //});
                                    // }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                                click: function () {
                                    webix.$$("chukyso-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }
            // onBeforeShow: function()
            // {
            //     webix.$$("btnNhan").define("disabled", true);
            //     webix.$$('btnNhan').disable();
            // }

        },
        // $oninit: function (view, $scope) {
        //     webix.$$("btnNhan").disable();
        // },
        setEditMode: function (mode) {
            editmode = mode;
        }
    };

});
define('views/forms/kynhieuhoadon',["app", "locale", "models/user", "views/modules/minvoiceplugin"], function (app, _, user, plugin) {
    var editmode = 0;

    function signOnServerFile(data, cert, server_cert) {

        var parameters = {
            xml: data["InvoiceXmlData"],
            refUri: "#data",
            certSerial: cert.so_serial,
            tokenSerial: cert.tokenSerial,
            signId: "seller",
            signTag: "Signatures",
            pass: cert.pass,
            path: cert.path,
            inv_InvoiceAuth_id: data["inv_InvoiceAuth_id"]
        };

        webix.ajax()
            .headers({ "Content-Type": "application/json" })
            .post(server_cert + "/Token/SignXmlByFile", parameters, function (text) {
                var json = JSON.parse(text);

                if (json.hasOwnProperty("error")) {
                    webix.message(json["error"], "error");
                }
                else {
                    var parameters = {
                        InvoiceXmlData: json.xml,
                        inv_InvoiceAuth_id: json.inv_InvoiceAuth_id
                    };
                    //console.log(parameters);

                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice/SaveXml", parameters, function (text) {
                            var result = JSON.parse(text);

                            if (result.trang_thai == "Đã ký") {

                                // var table = webix.$$("dmwindowData");
                                // table.clearAll();
                                // table.load(table.config.url);

                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/ExecuteCommand",
                                    {
                                        command: "CM00025",
                                        parameter: {

                                        }
                                    }, function (text) {
                                        var json = JSON.parse(text);
                                        // auto send SMS 
                                        if (json[1].gia_tri == "C") {
                                            var data = { id: item.inv_InvoiceAuth_id };

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
                                                    var data = JSON.parse(text);

                                                    if (!data.hasOwnProperty("error")) {


                                                    }
                                                    else {
                                                        webix.message(data.error, "error");
                                                    }
                                                });
                                        }
                                        // send email ma = 'AUTO_SEND_EMAIL'
                                        // if (json[0].gia_tri == "C") {
                                        //     var data = { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id, nguoinhan: item.inv_buyerEmail, tieude: "Thông báo xuất hóa đơn điện tử" };

                                        //     webix.ajax()
                                        //         .headers({ 'Content-type': 'application/json' })
                                        //         .post(app.config.host + "/Invoice/AutoSendInvoiceByEmail", data, function (text) {
                                        //             var data = JSON.parse(text);

                                        //             if (!data.hasOwnProperty("error")) {


                                        //             }
                                        //             else {
                                        //                 webix.message(data.error, "error");
                                        //             }
                                        //         });
                                        // }


                                    });
                                // webix.modalbox.hide();
                                // webix.message("Ký hóa đơn thành công !", "debug");
                            }

                        });
                }
            });
    }

    function signCertFile() {
        var json = $$("tblHoadon").serialize();
        var data = [];

        for (var i = 0; i < json.length; i++) {
            var item = json[i];

            if (item.chon1 != null && item.chon1 != undefined) {
                if (item.chon1 == "C") {
                    var inv = {
                        inv_invoiceauth_id: item.inv_InvoiceAuth_id
                    };

                    data.push(inv);
                }
            }
        }

        var txtCer = $$("txtCerSerial");
        var cert = txtCer.getList().getSelectedItem();

        var postData = {
            invs: data,
            so_serial: cert.so_serial
        };

        var url = app.config.host + "/Invoice/SignListInvoiceCertFile";

        webix.ajax()
            .headers({ "Content-Type": "application/json" })
            .post(url, postData, function (text) {
                var res = JSON.parse(text);

                if (res.hasOwnProperty("error")) {
                    webix.message({ type: "error", text: res.error });
                }
                else {
                    webix.message("Đã thực hiện xong");
                }
            });
    }

    var layout = {
        view: "window", modal: true, id: "chukyso-win", position: "center",
        head: "Ký hóa đơn chờ ký",
        width: 600,
        height: 600,
        on: {
            onBeforeShow: function () {
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .post(app.config.host + "/System/ExecuteCommand", {
                        command: "CM00019",
                        parameter: {
                            ma_dvcs: ""
                        }
                    }, {
                        error: function (text, data, XmlHttpRequest) {
                            //webix.modalbox.hide(box);
                            webix.alert({
                                title: "Lỗi !",
                                text: err,
                                type: "alert-error"
                            });
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var c_result = JSON.parse(text);

                            for (var i = 0; i < c_result.length; i++) {
                                var item = c_result[i];

                                if (item.ma == "KYTAPTRUNG") {
                                    $$("chukyso-win").config.kytaptrung = item.gia_tri;
                                }
                                if (item.ma == "SERVER_CERT") {
                                    $$("chukyso-win").config.server_cert = item.gia_tri;
                                }
                            }
                        }
                    });
            }
        },
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            id: "chukyso-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    cols: [
                        {
                            view: "datepicker",
                            name: "tu_ngay",
                            format: "%d/%m/%Y",
                            label: "Từ ngày",
                            labelPosition: "top",
                            value: new Date()
                        },
                        {
                            view: "datepicker",
                            name: "den_ngay",
                            format: "%d/%m/%Y",
                            label: "Đến ngày",
                            labelPosition: "top",
                            value: new Date()
                        },
                    ]
                },
                {
                    view: "combo",
                    name: "inv_InvoiceCode_id",
                    label: "Ký hiệu",
                    labelPosition: "top",
                    options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00029",
                    required: true,
                    invalidMessage: "Ký hiệu hóa đơn không được để trống !"
                    // validate: webix.rules.isEmpty
                },
                {
                    view: "combo",
                    name: "cerSerial",
                    label: "Chứng thư số",
                    labelPosition: "top",
                    id: "txtCerSerial",
                    required: true,
                    invalidMessage: "Chứng thư số không được để trống !",
                    options: {
                        view: "gridsuggest",
                        url: app.config.host + "/Invoice/GetListCertificates",
                        body: {
                            columns: [
                                {
                                    id: "so_serial",
                                    header: _("SO_SERIAL"),
                                    width: 150
                                },
                                {
                                    id: "subject_name",
                                    header: _("SUBJECTNAME"),
                                    width: 550
                                },
                                {
                                    id: "begin_date",
                                    header: _("NGAY_BAT_DAU"),
                                    width: 150,
                                    format: function (text) {
                                        var format = webix.Date.dateToStr("%d/%m/%Y");
                                        text = removeTimeZoneT(text);
                                        return format(text);
                                    }
                                },
                                {
                                    id: "end_date",
                                    header: _("NGAY_KET_THUC"),
                                    width: 150,
                                    format: function (text) {
                                        var format = webix.Date.dateToStr("%d/%m/%Y");
                                        text = removeTimeZoneT(text);
                                        return format(text);
                                    }
                                }
                            ]
                        }

                    }
                },
                {
                    view: "template",
                    template: "Danh sách hóa đơn chờ ký",
                    type: "section"
                },
                {

                    view: "datatable",
                    select: "row",
                    id: "tblHoadon",
                    resizeColumn: true,
                    datafetch: 50,
                    on: {
                        "data->onStoreUpdated": function () {
                            this.data.each(function (obj, i) {
                                obj.index = i + 1;
                            })
                        }
                        // onKeyPress: function (code, e) {
                        //     var table = this;

                        //     if (e.key == "Enter") {
                        //         var win = this.getTopParentView();
                        //         var toolbar = win.getChildViews()[1].getChildViews()[0];

                        //         var btnChon = toolbar.getChildViews()[0];
                        //         btnChon.callEvent("onClick");
                        //     }
                        // }
                    },
                    columns: [
                        {
                            id: "chon1",
                            header: [{ text: "", content: "masterCheckbox" }],
                            width: 55,
                            checkValue: 'C',
                            uncheckValue: 'K',
                            template: "{common.checkbox()}"
                        },
                        { id: "index", sort: "int", header: "STT", width: 50 },
                        { id: "inv_InvoiceAuth_id", header: "ID hóa đơn", width: 250, hidden: true },
                        {
                            id: "invoice_issued_date", header: "Ngày hóa đơn", width: 150, format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            }
                        },
                        { id: "inv_invoiceNumber", header: "Số hóa đơn" },
                        {
                            id: "total_amount", header: "Tổng tiền", width: 150, format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            })
                        }
                    ],
                    pager: "selectPagerA"
                },
                {
                    id: "selectPagerA",
                    view: "pager",
                    size: 50,
                    group: 5,
                    template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                },
                {
                    margin: 10,
                    cols: [
                        {},
                        {
                            shortcut: "F9", view: "button", label: "Tải dữ liệu (F9)", type: "form", align: "center", width: 120,
                            on: {
                                onClick: function () {
                                    var form = webix.$$("chukyso-form");
                                    if (form.validate()) {
                                        var item = form.getValues();

                                        var parameter = {
                                            command: "CM00020",
                                            parameter: {
                                                ma_dvcs: user.getDvcsID(),
                                                tu_ngay: item.tu_ngay,
                                                den_ngay: item.den_ngay,
                                                inv_InvoiceCode_id: item.inv_InvoiceCode_id
                                            }
                                        };

                                        var url = app.config.host + "/System/ExecuteCommand";

                                        webix.extend(form, webix.ProgressBar);
                                        //form.disable();
                                        form.showProgress();

                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(url, parameter, function (text) {

                                                var json = JSON.parse(text);

                                                if (!json.hasOwnProperty("error")) {

                                                    if (json.length == 0) {
                                                        webix.message("Không có dữ liệu", "error");
                                                        var table = $$("tblHoadon");
                                                        //table.load(table.config.url);
                                                        table.clearAll();
                                                        form.hideProgress();
                                                        return;
                                                    }
                                                    else {
                                                        form.hideProgress();
                                                        $$("btnNhan").enable();
                                                        var table = $$("tblHoadon");
                                                        //table.load(table.config.url);
                                                        table.clearAll();
                                                        var table = $$("tblHoadon");
                                                        table.parse(json);
                                                    }
                                                }
                                            });
                                    }
                                }
                            },
                            click: function () {
                                this.callEvent("onClick");
                            }
                        },
                        {
                            shortcut: "F10", view: "button", id: "btnNhan", name: "btnNhan", type: "form", label: "Nhận (F10)", align: "center",
                            on: {
                                onClick: function () {
                                    var form = webix.$$("chukyso-form");

                                    webix.extend(form, webix.ProgressBar);
                                    form.disable();
                                    form.showProgress();
                                    var json = $$("tblHoadon").serialize();

                                    if (json.length == 0) {

                                        webix.message("Không có dữ liệu !", "error");
                                        form.enable();
                                        form.hideProgress();
                                        return;
                                    }
                                    var win = $$("chukyso-win");

                                    var kytaptrung = win.config.kytaptrung;
                                    var server_cert = win.config.server_cert;

                                    if (kytaptrung == "FILE") {
                                        var box = webix.modalbox({
                                            title: "Đang ký hóa đơn .... ",
                                            buttons: ["Hủy bỏ"],
                                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                            width: 350,
                                            height: 200,
                                            callback: function (result) {
                                                switch (result) {
                                                    case "0":
                                                        //clearTimeout(interVal);
                                                        webix.modalbox.hide(box);
                                                        break;
                                                }
                                            }
                                        });
                                        var txtCer = $$("txtCerSerial");
                                        var cert = txtCer.getList().getSelectedItem();
                                        var d = 0;
                                        var d1 = 0;
                                        for (var i = 0; i < json.length; i++) {
                                            var item = json[i];

                                            if (item.chon1 != undefined) {
                                                if (item.chon1 == "C") {
                                                    d1 = d1 + 1;
                                                    console.log(d1);
                                                    var a = webix.ajax(app.config.host + "/Invoice/ExportXml?id=" + item.inv_InvoiceAuth_id);

                                                    webix.promise.all([a]).then(function (results) {
                                                        var a_result = results[0].json();

                                                        signOnServerFile(a_result, cert, server_cert);
                                                        d = d + 1;
                                                        console.log(d);

                                                        if (d == d1) {
                                                            webix.modalbox.hide(box);
                                                        }
                                                        form.enable();
                                                        form.hideProgress();
                                                        //webix.modalbox.hide(box);
                                                        //clearTimeout(interVal);

                                                    }).fail(function (err) {

                                                        form.enable();
                                                        form.hideProgress();

                                                        webix.alert({
                                                            title: "Lỗi !",
                                                            text: err,
                                                            type: "alert-error"
                                                        });
                                                    });
                                                }
                                            }
                                        }
                                        //console.log(d);

                                        // var interVal = setTimeout(function () {

                                        //     var txtCer = $$("txtCerSerial");
                                        //     var cert = txtCer.getList().getSelectedItem();

                                        //         clearTimeout(interVal);
                                        //         webix.modalbox.hide(box);

                                        // }, 500);

                                        var tableHD = webix.$$("tblHoadon");
                                        tableHD.clearAll();
                                        form.enable();
                                        form.hideProgress();

                                        //tableHD.load(tableHD.config.url);

                                        // var table = webix.$$("windowData");
                                        // table.clearAll();
                                        // table.load(table.config.url);
                                    }
                                    else {
                                        if (kytaptrung == "C") {
                                            var promises = [];

                                            for (var i = 0; i < json.length; i++) {

                                                if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
                                                    var a = webix.ajax().get(app.config.host + "/Invoice/ExportXml?id=" + json[i].inv_InvoiceAuth_id);
                                                    promises.push(a);
                                                }
                                            }

                                            webix.promise.all(promises).then(function (results) {
                                                var promises = [];

                                                var server_cert = win.config.server_cert;

                                                var txtCer = $$("txtCerSerial");
                                                var cert = txtCer.getList().getSelectedItem();

                                                for (var i = 0; i < results.length; i++) {
                                                    var json = results[i].json();

                                                    var parameters = {
                                                        xml: json["InvoiceXmlData"],
                                                        refUri: "#data",
                                                        certSerial: cert.so_serial,
                                                        tokenSerial: cert.tokenSerial,
                                                        signId: "seller",
                                                        signTag: "Signatures",
                                                        pass: cert.pass,
                                                        inv_InvoiceAuth_id: json["inv_InvoiceAuth_id"]
                                                    };

                                                    var a = webix.ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(server_cert + "/Token/SignXml", parameters, function (text) {
                                                        });

                                                    promises.push(a);
                                                }

                                                webix.promise.all(promises).then(function (results) {
                                                    var promises = [];

                                                    for (var i = 0; i < results.length; i++) {
                                                        var json = results[i].json();

                                                        var parameters = {
                                                            InvoiceXmlData: json.xml,
                                                            inv_InvoiceAuth_id: json.inv_InvoiceAuth_id
                                                        };

                                                        var a = webix.ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(server_cert + "/Invoice/SaveXml", parameters, function (text) {
                                                            });

                                                        promises.push(a);
                                                    }

                                                    webix.promise.all(promises).then(function (results) {
                                                        var table = webix.$$("windowData");
                                                        table.clearAll();
                                                        table.load(table.config.url);

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();

                                                        var win = $$("chukyso-win");
                                                        win.close();
                                                    }).fail(function (err) {
                                                        alert(err);

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();
                                                    });


                                                }).fail(function (err) {
                                                    alert(err);

                                                    var form = webix.$$("chukyso-form");
                                                    form.enable();
                                                    form.hideProgress();
                                                });

                                            }).fail(function (err) {
                                                alert(err);

                                                var form = webix.$$("chukyso-form");
                                                form.enable();
                                                form.hideProgress();
                                            });
                                        }
                                        else {
                                            var txtCer = $$("txtCerSerial");
                                            var cert = txtCer.getList().getSelectedItem();

                                            if (cert.cert_type == "FILE") {
                                                signCertFile();
                                                return;
                                            }

                                            var data = [];
                                            for (var i = 0; i < json.length; i++) {
                                                if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
                                                    data.push(json[i].inv_InvoiceAuth_id);
                                                }
                                            }
                                            //var url = app.config.host + "/Invoice/GetXmlSignInvoices";
                                            // var url = app.config.host + "/Invoice/GetXmlSignInvoices?inv_InvoiceCode_id=" + item.inv_InvoiceCode_id
                                            //     + "&tu_ngay=" + moment(item.tu_ngay).format("DD/MM/YYYY") + "&den_ngay=" + moment(item.den_ngay).format("DD/MM/YYYY") + "&inv_invoiceAuth_id=" + promises_auth_base;

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            var resultTime;
                                            webix
                                                .ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .get(app.config.host + "/System/GetDate", function (text) {
                                                    resultTime = JSON.parse(text);
                                                });

                                            var hub = plugin.hub();
                                            var hubconnect = plugin.conn();
                                            if (hubconnect.state != 1) {
                                                var form = webix.$$("chukyso-form");
                                                form.enable();
                                                form.hideProgress();
                                                webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                return;
                                            }
                                            else {

                                                hub.off('resCommand');
                                                hub.on('resCommand', function (result) {

                                                    var json = JSON.parse(result);
                                                    //console.log(json);
                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message({ type: 'error', text: json.error });

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();
                                                    }
                                                    else {
                                                        var table = webix.$$("windowData");
                                                        table.clearAll();
                                                        table.load(table.config.url);

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();

                                                        var win = $$("chukyso-win");
                                                        win.close();

                                                        // webix.message("Ký thành công !", "success");
                                                    }
                                                });

                                                // hub.off('resNotice');
                                                // hub.on('resNotice', function (result) {
                                                //     webix.message(result, "debug");
                                                // });

                                                var form = webix.$$("chukyso-form");
                                                var item = form.getValues();

                                                var token = user.getAccessToken();
                                                var dvcs = user.getDvcsID();
                                                var language = user.getLanguage();

                                                var bear = token + ";" + dvcs + ";" + language;
                                                var url;
                                                if (window.location.protocol == "file:") {
                                                    url = "http://localhost:18374";
                                                }
                                                else {
                                                    url = window.location.origin;
                                                }

                                                var arg = {
                                                    idData: "#data",
                                                    data: data,
                                                    // mst: "0100686209",
                                                    mst: "minvoice", // đang fix cứng.sau này có thể fix
                                                    username: user.getCurrentUser(),
                                                    idSigner: "seller",
                                                    tagSign: "Signatures",
                                                    token: bear,
                                                    url: url,
                                                    dateKy: resultTime.dateKy,
                                                    listcerts: [
                                                        {
                                                            so_serial: item.cerSerial
                                                        }
                                                    ]
                                                };

                                                hub.invoke('execCommand', 'SignListInvoiceV2', JSON.stringify(arg))
                                                    .done(function () {
                                                        console.log("Success SignListInvoiceV2!")
                                                    })
                                                    .fail(function (error) {
                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(error, "error");
                                                    });
                                            }


                                        }
                                    }
                                }
                            },
                            click: function () {
                                this.callEvent("onClick");
                            }
                        },
                        {
                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                            click: function () {
                                webix.$$("chukyso-win").close();
                            }
                        },
                        {}
                    ]
                }
            ]
        }
    };
    return {
        $ui: layout,
        setEditMode: function (mode) {
            editmode = mode;
        }
    };

});
define('views/forms/license',["app", "locale"], function (app, _) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win", position: "center",
			head: "Thông tin bản quyền",
			body: {

				paddingY: 10,
				paddingX: 10,
				elementsConfig: {
					labelWidth: 60,
					labelPosition: "top"
				},
				view: "form",
				id: "license-form",
				complexData: true,
				margin: 0,
				borderless: true,
				elements: [
					{
						view: "text",
						name: "ms_thue",
						label: _("MS_THUE"),
						width: 450,
						readonly: true,
						css: "mcls_readonly_text"
					},
					{
						view: "text",
						name: "ten_dvcs",
						label: _("TEN_DON_VI"),
						readonly: true,
						css: "mcls_readonly_text"
					},
					{
						view: "autonumeric",
						name: "sl_hd",
						label: _("SL_HD_DK"),
						readonly: true,
						css: "mcls_readonly_text"
					},
					{
						view: "autonumeric",
						name: "sl_dk_them",
						label: _("SL_HD_THEM"),
						required: true,
						invalidMessage: "Số lượng đăng ký thêm không được bằng 0 !",
						validate: webix.rules.isNotEmpty
					},
					{
						view: "text",
						name: "key_license",
						label: _("KEY_LICENSE"),
						readonly: true,
						inputAlign: "center",
						css: "mcls_license_text"
					},
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", id: "btnSave", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("license-form");
										var item = form.getValues();
										if (item.sl_dk_them == 0 || item.sl_dk_them == "" || item.sl_dk_them == null) {
											webix.message("Số lượng đăng ký thêm không được để trống hoặc bằng 0 !", "error");
											return false;
										}

										var url = app.config.host + "/License/Register";

										webix.extend(form, webix.ProgressBar);
										form.disable();
										form.showProgress();

										webix.ajax()
											.bind(this)
											.headers({ 'Content-type': 'application/json' })
											.post(url, item, function (text) {
												var result = JSON.parse(text);

												if (!result.hasOwnProperty("error")) {
													var interVal = setInterval(function () {

														var url = app.config.host + "/License/CheckLicense?id=" + result.id;

														webix.ajax(url, {
															error: function (text, data, XmlHttpRequest) {
																webix.message(text);

																var form = webix.$$("license-form");
																form.enable();
																form.hideProgress();

																clearInterval(interVal);

															},
															success: function (text, data, XmlHttpRequest) {
																var result = JSON.parse(text);

																if (!result.hasOwnProperty("error")) {

																	var form = webix.$$("license-form");

																	var values = form.getValues();
																	values.key_license = result.key_license;
																	values.sl_dk_them = 0;
																	values.sl_hd = result.sl_hd;

																	form.setValues(values);

																	form.enable();
																	form.hideProgress();

																	clearInterval(interVal);
																}
															}
														});

													}, 3000);
												}
												else {
													webix.message(result.error);

													var form = webix.$$("license-form");
													form.enable();
													form.hideProgress();

												}
											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)",type: "danger", align: "center", width: 120,
								click: function () {
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}

				]
			}
		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/forms/lichsuemail_bienlai',["app", "locale"], function (app, _) {
    function initUI(inv_InvoiceAuth_id) {
        // var model = { inv_InvoiceAuth_id: inv_InvoiceAuth_id };
        // webix.ajax()
        //     .headers({ 'Content-type': 'application/json' })
        //     .post(app.config.host + "/Invoice/history_email", model, function (text) {
        //         var data = JSON.parse(text);
        //         if (!data.hasOwnProperty("error")) {
        //             $$('email-form').setValue(data);
        //         }
        //         else {
        //             webix.message(data.error, "error");
        //         }
        //     });
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "email-win",
            position: "center",
            head: "Lịch sử gửi Email",
            width: 950,
            height: 300,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "email-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "datatable",
                        header: "Lịch sử gửi Email",
                        id: "tbl_email",
                        editable: false,
                        resizeColumn: true,
                        select: true,
                        // fixedRowHeight: true,
                        // rowLineHeight: 25,
                        // rowHeight: 25,
                        //autoheight:true,
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var inv_invoiceauth_id = "";
                                var table = webix.$$("windowData");
                                if (table === undefined || table === null) {
                                    table = webix.$$("invoiceViews");
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.hdon_id;
                                } else {
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.inv_invoiceauth_id;
                                }
                                var url = app.config.host + "/Invoice/InvoiceHistorySendEmail?inv_invoiceauth_id=" + inv_invoiceauth_id;
                                webix.ajax(url, callback, view);
                            },
                        },
                        on: {
                            onresize: webix.once(function () {
                                this.adjustRowHeight("send_type", true);
                            }),
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                });
                            },
                            onItemDblClick: function (id, e, node) {
                                // var btnEdit = $$("btncskh");
                                // btnEdit.callEvent("onClick");
                                //webix.message("Click MobiFone Invoice", "error");
                            },
                            onBeforeRender: function () {
                                //$$("tbl_email").refresh();
                                //$$("tbl_email").define("pager", kk);
                            },
                        },
                        columns: [
                            { id: "stt", header: "STT", width: 40 },
                            { id: "invoice_number", name: "invoice_number", header: "Số biên lai", width: 100, editor: "text" },
                            { id: "series_invoice", header: "Ký hiệu", width: 90, editor: "text" },
                            { id: "user_send", name: "user_send", header: "Người gửi", width: 130, editor: "text" },
                            {
                                id: "send_date",
                                name: "send_date",
                                header: "Ngày gửi",
                                width: 110,
                                editor: "date",
                                format: function (text) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                },
                                sort: "date",
                            },
                            { id: "send_to", name: "send_to", header: "Gửi đến", width: 150, editor: "text" },
                            { id: "send_type", name: "send_type", header: "Loại gửi", width: 150, editor: "text" },
                        ],
                        pager: "pagerB",
                        ready: function () {
                            //this.open(this.getFirstId());
                            this.sort({ by: "stt", dir: "desc" });
                        },
                    },
                    {
                        id: "pagerB",
                        view: "pager",
                        size: 5,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                align: "center",
                                width: 120,
                                type: "danger",
                                click: function () {
                                    webix.$$("email-win").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        initUI: initUI,
    };
});

define('views/forms/lichsuemailbienban',["app", "locale"], function (app, _) {
    function initUI(inv_InvoiceAuth_id) {
        // var model = { inv_InvoiceAuth_id: inv_InvoiceAuth_id };
        // webix.ajax()
        //     .headers({ 'Content-type': 'application/json' })
        //     .post(app.config.host + "/Invoice/history_email", model, function (text) {
        //         var data = JSON.parse(text);
        //         if (!data.hasOwnProperty("error")) {
        //             $$('email-form').setValue(data);
        //         }
        //         else {
        //             webix.message(data.error, "error");
        //         }
        //     });
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "email-win",
            position: "center",
            head: "Lịch sử gửi Email",
            width: 950,
            height: 300,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "email-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "datatable",
                        header: "Lịch sử gửi Email",
                        id: "tbl_email",
                        editable: false,
                        resizeColumn: true,
                        select: true,
                        // fixedRowHeight: true,
                        // rowLineHeight: 25,
                        // rowHeight: 25,
                        //autoheight:true,
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var inv_invoiceauth_id = "";
                                var table = webix.$$("windowData");
                                if (table === undefined || table === null) {
                                    table = webix.$$("bienbanthoathuan");
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.hdon_id;
                                } else {
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.inv_invoiceauth_id;
                                }
                                var url = app.config.host + "/Invoice/InvoiceHistorySendEmail?inv_invoiceauth_id=" + inv_invoiceauth_id;
                                webix.ajax(url, callback, view);
                            },
                        },
                        on: {
                            onresize: webix.once(function () {
                                this.adjustRowHeight("send_type", true);
                            }),
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                });
                            },
                            onItemDblClick: function (id, e, node) {
                                // var btnEdit = $$("btncskh");
                                // btnEdit.callEvent("onClick");
                                //webix.message("Click MobiFone Invoice", "error");
                            },
                            onBeforeRender: function () {
                                //$$("tbl_email").refresh();
                                //$$("tbl_email").define("pager", kk);
                            },
                        },
                        columns: [
                            { id: "stt", header: "STT", width: 40 },
                            { id: "invoice_number", name: "invoice_number", header: "Số hóa đơn", width: 100, editor: "text" },
                            { id: "template_code", name: "template_code", header: "Mẫu hóa đơn", width: 120, editor: "text" },
                            { id: "invoice_series", name: "invoice_series", header: "Ký hiệu", width: 90, editor: "text" },
                            { id: "user_send", name: "user_send", header: "Người gửi", width: 130, editor: "text" },
                            {
                                id: "send_date",
                                name: "send_date",
                                header: "Ngày gửi",
                                width: 110,
                                editor: "date",
                                format: function (text) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                },
                                sort: "date",
                            },
                            { id: "send_to", name: "send_to", header: "Gửi đến", width: 150, editor: "text" },
                            { id: "send_type", name: "send_type", header: "Loại gửi", width: 150, editor: "text" },
                        ],
                        pager: "pagerB",
                        ready: function () {
                            //this.open(this.getFirstId());
                            this.sort({ by: "send_date", dir: "desc" });
                        },
                    },
                    {
                        id: "pagerB",
                        view: "pager",
                        size: 5,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                align: "center",
                                width: 120,
                                type: "danger",
                                click: function () {
                                    webix.$$("email-win").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        initUI: initUI,
    };
});

define('views/forms/lichsuemailtncn',["app", "locale"], function (app, _) {
    function initUI(inv_InvoiceAuth_id) {
        // var model = { inv_InvoiceAuth_id: inv_InvoiceAuth_id };
        // webix.ajax()
        //     .headers({ 'Content-type': 'application/json' })
        //     .post(app.config.host + "/Invoice/history_email", model, function (text) {
        //         var data = JSON.parse(text);
        //         if (!data.hasOwnProperty("error")) {
        //             $$('email-form').setValue(data);
        //         }
        //         else {
        //             webix.message(data.error, "error");
        //         }
        //     });
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "email-win",
            position: "center",
            head: "Lịch sử gửi Email",
            width: 950,
            height: 300,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "email-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "datatable",
                        header: "Lịch sử gửi Email",
                        id: "tbl_email",
                        editable: false,
                        resizeColumn: true,
                        select: true,
                        // fixedRowHeight: true,
                        // rowLineHeight: 25,
                        // rowHeight: 25,
                        //autoheight:true,
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var inv_invoiceauth_id = "";
                                var table = webix.$$("windowData");
                                if (table === undefined || table === null) {
                                    table = webix.$$("invoiceViews");
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.hdon_id;
                                } else {
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.inv_invoiceauth_id;
                                }
                                var url = app.config.host + "/Invoice/InvoiceHistorySendEmail?inv_invoiceauth_id=" + inv_invoiceauth_id;
                                webix.ajax(url, callback, view);
                            },
                        },
                        on: {
                            onresize: webix.once(function () {
                                this.adjustRowHeight("send_type", true);
                            }),
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                });
                            },
                            onItemDblClick: function (id, e, node) {
                                // var btnEdit = $$("btncskh");
                                // btnEdit.callEvent("onClick");
                                //webix.message("Click MobiFone Invoice", "error");
                            },
                            onBeforeRender: function () {
                                //$$("tbl_email").refresh();
                                //$$("tbl_email").define("pager", kk);
                            },
                        },
                        columns: [
                            { id: "stt", header: "STT", width: 40 },
                            { id: "invoice_number", name: "invoice_number", header: "Số chứng từ", width: 100, editor: "text" },
                            { id: "series_invoice", header: "Ký hiệu", width: 90, editor: "text" },
                            { id: "user_send", name: "user_send", header: "Người gửi", width: 130, editor: "text" },
                            {
                                id: "send_date",
                                name: "send_date",
                                header: "Ngày gửi",
                                width: 110,
                                editor: "date",
                                format: function (text) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                },
                                sort: "date",
                            },
                            { id: "send_to", name: "send_to", header: "Gửi đến", width: 150, editor: "text" },
                            { id: "send_type", name: "send_type", header: "Loại gửi", width: 150, editor: "text" },
                        ],
                        pager: "pagerB",
                        ready: function () {
                            //this.open(this.getFirstId());
                            this.sort({ by: "stt", dir: "desc" });
                        },
                    },
                    {
                        id: "pagerB",
                        view: "pager",
                        size: 5,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                align: "center",
                                width: 120,
                                type: "danger",
                                click: function () {
                                    webix.$$("email-win").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        initUI: initUI,
    };
});

define('views/forms/link_sso_nologin',["app"], function (app) {

	return {
		$ui: {
			view: "window", modal: true, id: "listuser-win", position: "center",
			head: "Liên kết tài khoản SSO",
			body: {
				paddingY: 10,
				paddingX: 10,
				//elementsConfig:{labelWidth: 120}, 
				view: "form",
				id: "listuser-form",
				complexData: true,
				elements: [
					{ view: "text", id: "username1", name: "username", label: "Tên truy cập", required: true, css: "mcls_uppercase", invalidMessage: "Tên truy cập để trống!", labelPosition: "top" },
					{ view: "text", id: "password1", name: "password", type: "password", label: "Mật khẩu", invalidMessage: "Mật khẩu không được để trống", required: true, labelPosition: "top" },
					{ view: "text", id: "email_sso", name: "email_sso", placeholder: "Nhập địa chỉ Email SSO", label: "Email", required: true, invalidMessage: "Email để trống hoặc nhập không đúng định dạng!", validate: webix.rules.isEmail, labelPosition: "top" },
					{ view: "text", id: "otp", disabled: true, name: "otp", label: "Mã OTP", labelPosition: "top" },
					{
						margin: 10,
						cols: [
							{},
							{
								view: "button", id: "btn-sendOtp", label: "Gửi OTP", type: "form", align: "center", width: 120, click: function () {

									var form = webix.$$("listuser-form");

									if (form.validate() == false) {
										return;
									}
									var item = form.getValues();
									if ($$("password").isVisible()) {
										webix
											.ajax()
											.post(
												app.config.host + "/Account/VerifyPasswordAndGenOTPSSO", item,
												function (text, data) {
													var result = JSON.parse(text);
													
													if (result.error != null) {
														webix.message(result.error, "error");
														return;
													}
													$$("confirm-link-btn").enable();
													$$("otp").enable();
													$$("email_sso").disable();
													$$("btn-sendOtp").setValue("Gửi lại OTP");

													$$("email_sso").define("readonly", "true");
													$$("email_sso").define("css", "mcls_readonly_text");
													$$("email_sso").refresh();

													$$("username1").define("readonly", "true");
													$$("username1").define("css", "mcls_readonly_text");
													$$("username1").refresh();

													$$("password1").define("readonly", "true");
													$$("password1").define("css", "mcls_readonly_text");
													$$("password1").refresh();

													webix.message("Gửi yêu cầu thành công!", "success");

												});
									}
								}
							},
							{
								view: "button", id: "confirm-link-btn", label: "Xác nhận liên kết", type: "success", align: "center", disabled: true, width: 120, click: function () {

									var form = webix.$$("listuser-form");

									if (form.validate() == false) {
										return;
									}

									var item = form.getValues();

									if (item.otp == null||item.otp == "") {
										webix.message("Mã OTP không được để trống!", "error");
										return;
									}
									webix.extend(form, webix.ProgressBar);
									form.disable();
									form.showProgress();
									webix.ajax()
										.post(app.config.host + "/Account/VerifyOtpSsoNoLogin", item, function (text) {
											var data = JSON.parse(text);
											if (!data.hasOwnProperty("error")) {
												webix.$$("listuser-win").close();
												webix.$$("notisso").hide();
												webix.message("Liên kết thành công!", "success");
												webix.modalbox({
													title: "LIÊN KẾT THÀNH CÔNG!",
													text: "Quý khách vui lòng đăng nhập bằng tài khoản SSO để tiếp tục sử dụng dịch vụ.",
													buttons: ["OK"],
													callback: function() {
														document.location.reload();
													}
												});
											}
											else {
												webix.message(data.error, "error");
											}
											form.enable();
											form.hideProgress();
										} 
									);
								}
							},
							{
								view: "button", label: "Hủy bỏ (ESC)", hotkey: "esc", type: "danger", align: "center", width: 120, click: function () {
									webix.$$("listuser-win").close();
								}
							}
						]
					}

				]
			}
		},
		$oninit: function () {
            // Load data from API and fill the form
			
			var apiUrl = app.config.sso + "/partner/getInfo";
			webix.ajax().get(apiUrl, function (text) {
				var userData = JSON.parse(text);
				var userInfo = userData.result.userInfo;
				var form = $$("listuser-form");
				form.setValues(userInfo);
            });
        }
	};

});
define('views/forms/loadDataReport',[
	"app",
	"locale",
	"models/user"
], function (app, _, user) {
	var editmode = 0;
	var _date = new Date();
	var _month = _date.getMonth() + 1;
	function subviewT() {
		$$('cbQuy').define('label', "Tháng");
		$$('cbQuy').refresh();
		$$('cbQuy').define('options', ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
	}

	function subviewQ() {

		$$('cbQuy').define('label', "Quý");
		$$('cbQuy').refresh();
		$$('cbQuy').define('options', ["1", "2", "3", "4"]);
	}

	function checkHasComp(el, comp) {
		var rs = false;
		if(comp == null) {
			return rs;
		}

		for(var i = 0; i < el.length; i++) {
			var element = el[i];
			if(element != null && element.cols != null) {
				for(var j = 0; j < element.cols.length; j++) {
					if(element.cols[j] != null && element.cols[j].id == comp.id) {
						rs = true;
					}

				}
			}
		}
		return rs;
	}

	return {
		$ui: {
			id: "loadDataReportWin",
			view: "window",
			modal: true,
			position: "center",
			head: "Thông tin Tab",
			resize: true,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 60 },
				view: "form",
				id: "loadDataReportForm",
				complexData: true,
				margin: 0,
				scroll: "y", // Add vertical scroll
				elements: []
			},
			width: 600, // Set a fixed width
			height: 500 // Set a maximum height
		},
		initUI: function (infoWindowId) {
			var url = app.config.host + "/System/ExecuteCommand";

			var parameters = {
				command: "CM00013",
				parameter: {
					wb_infowindow_id: infoWindowId
				}
			};

			return webix.ajax().headers({ "Content-Type": "application/json" })
				.post(url, parameters, function (response) {
					var result = JSON.parse(response);

					var win = webix.$$(infoWindowId);

					win.define("width", result[0].window_width || 600);
					win.define("height", result[0].window_height || 500);

					var form = win.getChildViews()[1];
					form.clear();

					var view_extension = {
						cols: [
							{
								view: "radio",
								id: "head_extension",
								value: 1,
								options: [
									{ "id": 1, "value": "Tháng" }, // the initially selected item
									{ "id": 2, "value": "Quý" }
								],
								on: {
									onChange: function (newv, oldv) {
										var d = new Date();
										var quarter = Math.floor((d.getMonth() / 3));
										var quarter1 = quarter + 1;
										if (newv == 2) {
											subviewQ();
											$$("cbQuy").setValue(quarter1);
										}
										if (newv == 1) {
											subviewT();
											$$("cbQuy").setValue(d.getMonth() + 1);
										}
									}
								}
							},
							{
								id: "cbQuy",
								name: "quy",
								view: "combo",
								label: "Tháng",
								//height: 30,
								value: _month,
								options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
								on: {
									onChange: function () {
										var d = new Date();
										var quarter = Math.floor((d.getMonth() / 3));
										var quarter1 = quarter + 1;

										var option = $$('head_extension').getValue();
										if (option == 2) {
											var nam = d.getFullYear();
											var thang;
											var quy = $$("cbQuy").getValue();
											if (quy == 1) {
												thang = 0;
											}
											if (quy == 2) {
												thang = 3;
											}
											if (quy == 3) {
												thang = 6
											}
											if (quy == 4) {
												thang = 9
											}
											var firstDate = new Date(nam, thang, 1);
											var lastDate = new Date(nam, thang + 3, 0);

											$$(win.config.id + "_tu_ngay").setValue(firstDate);
											$$(win.config.id + "_tu_ngay").refresh();
											$$(win.config.id + "_den_ngay").setValue(lastDate);
											$$(win.config.id + "_den_ngay").refresh();
										}
										if (option == 1) {
											var year = d.getFullYear();
											var month = $$("cbQuy").getValue();
											var date1 = month + "/01" + "/" + year;

											var date = new Date(date1);
											var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

											var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
											$$(win.config.id + "_tu_ngay").setValue(firstDay1);
											$$(win.config.id + "_tu_ngay").refresh();
											$$(win.config.id + "_den_ngay").setValue(lastDay1);
											$$(win.config.id + "_den_ngay").refresh();
										}
									}
								}
							}
						]
					};

					var multiComboBranch = null;
					var multiComboKH = null;

					var formValues = {};

					var rows_max = result[0].rows_max;

					var el = [];

					for (var i = 1; i <= rows_max; i++) {
						el.push({ cols: [] });
					}

					for (var i = 0; i < result.length; i++) {

						var field = result[i];

						var row = field.row;

						var item = {
							view: field.type_editor,
							name: field.name,
							label: _(field.caption),
							width: field.width,
							labelPosition: field.label_position,
							labelWidth: field.label_width,
							format: field.format,
							hidden: field.hidden == "C" ? true : false,
							id: win.config.id + "_" + field.name,
							required: field.required,
							invalidMessage: field.required ? _(field.caption) + " không được bỏ trống" : null,
							validate: field.required ? webix.rules.isNotEmpty : null
						};

						if (field.default_value != null) {
							var defaultValue = field.default_value;

							var date = new Date();
							var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
							var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

							if (defaultValue.startsWith("@Default=")) {
								defaultValue = defaultValue.replace("@Default=", "");
								if (defaultValue == "MA_DVCS" || defaultValue == "BRANCH_CODE") {
									item.value = user.getDvcsID();
								}
								else if (defaultValue == "USER") {
									item.value = user.getCurrentUser();
								}
								else if (defaultValue == "MA_CT") {
									item.value = "MA_CT";
								}
								else if (defaultValue == "FIRST_DATE") {
									item.value = firstDay;
								}
								else if (defaultValue == "LAST_DATE") {
									item.value = lastDay;
								}
								else {
									item.value = defaultValue;
								}
							}
						}

						if (item.hidden == true) {
							formValues[item.name] = item.value;
							continue;
						}

						if (item.view == "combo" || item.view == "multiselect") {
							item.options = {
								filter: function (item, value) {
									return item.value.toLowerCase().includes(value)
								},
								body: {
									view: "list",
									data: [],
								}
							}
							webix.ajax().get(app.config.host + "/System/GetDataByReferencesId?id=" + field.wb_references_id).then(function (data) {
								$$(item.id).getList().parse(data.json());
							});
						}

						// Vẽ multi combo
						if (item.view == "multicombo") {
							item.suggest = {
								selectAll: true,
								body: {
									url: app.config.host + "/System/GetDataByReferencesId?id=" + field.wb_references_id
								}
							};

							if(item.name == "lst_branch_code") {
								multiComboBranch = item;
							}

							if(item.name == "invoice_series") {
								multiComboKH = item;
							}
						}

						if (item.view == "radio") {
							var ajax = webix.ajax();
							ajax.master = {
								radio_id: item.id,
								win_id: win.config.id
							};

							ajax.get(app.config.host + "/System/GetDataByReferencesId?id=" + field.wb_references_id, function (text) {
								var json = JSON.parse(text);
								var radio = $$(this.radio_id);
								radio.define("options", json);
								radio.refresh();

								$$(this.win_id).resize();
							});
						}

						if (item.view == "treesuggest") {

							//item.REF_ID = field.REF_ID.toString();
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							item.view = "combo";
							item.options = {
								view: "treesuggest",
								url: {
									$proxy: true,
									load: function (view, callback, params) {
										var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

										webix.ajax(url, function (text) {
											var json = JSON.parse(text);
											var data = listToTree(json);
											view.parse(data, "json");
										});

									}
								},
								body: {
									columns: listColumns,
									refid: field.wb_references_id,
									filterMode: {
										level: false,
										showSubItems: false
									}
								}
							};
						}

						if (item.view == "gridcombo") {

							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							item.view = "combo";
							item.options = {
								view: "gridsuggest",
								url: app.config.host + "/api/System/GetDataByReferencesId?id=" + field.wb_references_id,
								body: {
									columns: listColumns,
									refid: field.wb_references_id
								}
							};
						}

						if (item.view == "gridsuggest") {
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							item.view = "text";
							item.suggest = {
								view: "gridsuggest",
								value_suggest: field.value_suggest,
								body: {
									columns: listColumns,
									refid: field.wb_references_id,
									datatype: "json",
									dataFeed: function (filtervalue, filter) {
										if (filtervalue.length < 3) return;

										var refid = this.config.refid;
										var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
										var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

										this.load(pathUrl + "&" + urldata, this.config.datatype);
									},

								},
								on: {
									onValueSuggest: function (obj) {
										if (this.config.value_suggest != null) {
											var fn = Function("obj", "id", this.config.value_suggest);
											fn(obj, this.config.id);
										}
									}
								}
							};
						}

						if (item.name == "tu_ngay") {
							item.value = firstDay;
						}

						if (item.name == "den_ngay") {
							item.value = lastDay;
						}

						formValues[item.name] = item.value;
						el[row - 1].cols.push(item);
					}

					if(el != null && checkHasComp(el, multiComboBranch) && checkHasComp(el, multiComboKH)) {
						for(var i = 0; i < el.length; i++) {
							var element = el[i];
							if(element != null && element.cols != null) {
								for(var j = 0; j < element.cols.length; j++) {
									if(element.cols[j] != null && element.cols[j].id == multiComboBranch.id) {
										element.cols[i].on = {
											onChange: function(newValue, oldValue) {
												var urlLoad = app.config.host + "/System/GetDataReferencesByRefIdAndBranchs?refId=RF003001&branchs=" + newValue;
                                
												var comp = $$(multiComboKH.id).getPopup().getList();
												if(comp != null) {
													comp.clearAll();
													comp.load(urlLoad);
												}
											}
										}
									}

									if(element.cols[j] != null && element.cols[j].id == multiComboKH.id) {
										element.cols[j].suggest.body = {};
									}
								}
							}
						}
					}

					form.setValues(formValues);

					var buttons = {
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Tải (F10)",
								width: 120,
								type: "form", align: "center",
								on: {
									onClick: function () {
										var form = this.getParentView().getParentView();
										var win = this.getTopParentView();
										if (form.validate() == false) {
											webix.message("Chưa nhập đủ thông tin!", "error");
											return;
										}
										var item = form.getValues();
										// xóa header ngày tháng trong sproc ko cần
										delete item.quy;
										var load_event = win.config.load_event == null ? "loadReport" : win.config.load_event;

										app.callEvent(load_event, [win.config.report_id, win.config.id, item, win.config.menuitem]);

										win.close();
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)",
								width: 120,
								align: "center", type: "danger",
								click: function () {
									this.getTopParentView().close();
								}
							},
							{}
						]
					};

					el.push(buttons);

					webix.ui(el, form);
					if ($$(win.config.id + "_tu_ngay") != undefined && $$(win.config.id + "_den_ngay") != undefined) {
						form.addView(view_extension, 0);
					}
					win.getHead().setHTML(result[0]["window_name"]);
					
					// Tạm thời cmt lại đoạn xet dữ liệu popup
					// if (win.config.editmode != null) {
					// 	if (win.config.editmode == 1) {
					// 		form.setValues(win.config.formvalues);
					// 	}
					// }

					//win.resize();

				});
		},
		setEditMode: function (mode) {
			editmode = mode;
		},
		setValues: function (item) {
			var win = $$(this.$ui.id);
			var form = win.getChildViews()[1];

			form.setValues(item);
		}
	};

});

define('views/forms/main',[
    "app",
    "locale",
    "models/user"
], function (app, _, user) {
    var editmode = 0;

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Thêm mới hóa đơn đầu vào",
            id: "main",
            resize: true,
            move: true,
            on: {
                onBeforeShow: function () {
                    $$("uploader").files.attachEvent("onAfterDelete", function () {
                        $$("inv_Invoice_fileName").setValue(null);
                        $$("inv_Invoice_fileData").setValue(null);
                        $$("inv_Invoice_fileType").setValue(null);
                        $$("inv_Invoice_fileSize").setValue(null);
                    });
                }
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "main-form",
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {

                    // }
                },
                elements: [
                    {
                        view: "combo",
                        name: "inv_ncc_id",
                        label: "Nhà cung cấp",
                        //labelPosition: "top",
                        id: "inv_Invoice_inv_ncc_id",
                        required: true,
                        invalidMessage: "Nhà cung cấp không thể bỏ trống !",
                        options: {
                            view: "gridsuggest",
                            template: "#ten_ncc#",
                            url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00300",
                            body: {
                                columns: [
                                    { id: "mst", header: _("MS_THUE"), width: 150 },
                                    { id: "ten_ncc", header: _("Tên nhà cung cấp"), width: 550 }
                                ]
                            }

                        }
                    },
                    {
                        cols: [
                            {
                                view: "button", type: "icon", icon: "fas fa-folder-open", label: "Chọn file", width: 110,css: "webix_secondary",
                                on: {
                                    onClick: function () {
                                        webix.$$("uploader").fileDialog();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                rows: [
                                    // {view:"text",id:"df",label:"errr"},
                                    {
                                        id: "uploader",
                                        view: "uploader",
                                        value: 'Chọn file',
                                        hide: true,
                                        name: "uploader",
                                        accept: "image/png, image/jpeg, application/vnd.ms-excel,text/XML,text/plain,application/octet-stream,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                        //accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                        link: "mylist",
                                        autosend: false,
                                        //borderless: true,
                                        multiple: false,
                                        //upload: app.config.host + "/Invoice/SaveInv",
                                        on: {
                                            onBeforeFileAdd: function (file) {

                                                var size = file.size;
                                                if (size > 1024000) {
                                                    webix.message("Bạn chỉ được đính kèm File <= 1 Mb", "error");
                                                    return false;
                                                }
                                                var typeList = ["txt", "xml", "xls", "docx", "xlsx", "repx", "png", "pdf", "jpg"];
                                                if (typeList.indexOf(file.type) < 0) {
                                                    webix.message('Định dạng: txt, xml, xls, docx, xlsx, repx, png, pdf, jpg !', "error");
                                                    return false;
                                                }
                                            },
                                            onAfterRender: function () {
                                                //console.log('called once after first rendering:');
                                                this.hide();
                                            },
                                            onAfterFileAdd: function (upload) {
                                                var file = new Blob([upload.file]);

                                                var reader = new FileReader();
                                                var type = upload.type;
                                                if (type == "txt") { type = "text/plain"; }
                                                if (type == "xml") { type = "text/XML"; }
                                                if (type == "xls") { type = "application/vnd.ms-excel"; }
                                                if (type == "docx") { type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; }
                                                if (type == "xlsx") { type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; }
                                                if (type == "repx" || type == "rar") { type = "application/octet-stream"; }
                                                if (type == "jpg") { type = "image/jpeg"; }
                                                if (type == "png") { type = "image/png"; }
                                                if (type == "pdf") { type = "application/pdf"; }

                                                reader.onload = function () {

                                                    var arrayBuffer = this.result,
                                                        array = new Uint8Array(arrayBuffer);

                                                    var array1 = Array.from(array)
                                                    // console.log(array1);
                                                    //var data_btoa = btoa(array1);
                                                    var data = {
                                                        ten_file: upload.name,
                                                        file_data: array1,
                                                        loai_file: type
                                                    }

                                                    $$("inv_Invoice_fileName").setValue(upload.name);
                                                    $$("inv_Invoice_fileData").setValue(array1);
                                                    $$("inv_Invoice_fileType").setValue(type);
                                                    $$("inv_Invoice_fileSize").setValue(upload.size / 1024);
                                                }
                                                reader.readAsArrayBuffer(upload.file);

                                            },
                                            onUploadComplete: function (response) {
                                                // var topParentView = this.getTopParentView();

                                                // if (topParentView.config.tableId !== undefined) {
                                                // 	var table = $$(topParentView.config.tableId);

                                                // 	if (table != null) {
                                                // 		table.clearAll();
                                                // 		table.load(table.config.url);
                                                // 	}
                                                // }
                                                // webix.message("Upload File thành công !", "debug");
                                                // webix.$$("uploadfile-win").close();
                                            },
                                            onFileUploadError: function (file, response) {
                                                $$("mylist").clearAll();
                                                $$("mylist").refresh();
                                                //console.log(file);
                                                //console.log(response);
                                                var table = $$("main-form");
                                                table.enable();
                                                table.hideProgress();
                                                webix.message(response.error, "error");
                                            }
                                        },
                                        apiOnly: true,
                                    },
                                    {
                                        view: "list",
                                        id: "mylist",
                                        type: "uploader",
                                        //css:{"border-bottom": "none !important", "border-color":"white !important"},
                                        //height: 100,
                                        //autoheight: true
                                        borderless: true,
                                        on: {
                                            onAfterDelete: function (id) {
                                                webix.message("aaaaaaaaaaa");
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        view: "combo",
                        name: "dmloaihd_id",
                        label: "Loại hóa đơn",
                        //labelPosition: "top",
                        id: "inv_Invoice_dmloaihd_id",
                        required: true,
                        invalidMessage: "Loại hóa đơn không thể bỏ trống !",
                        options: {
                            view: "gridsuggest",
                            template: "#ten_loai#",
                            url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00301",
                            body: {
                                columns: [
                                    { id: "ma_loai", header: _("Mã loại"), width: 80 },
                                    { id: "ten_loai", header: _("Tên loại hóa đơn"), width: 700 }
                                ]
                            }
                        }
                    },
                    {
                        cols: [
                            { view: "text", label: _("Số hóa đơn"), name: "invoiceNumber", id: "inv_Invoice_invoiceNumber", attributes: { maxlength: 7 } },
                            { view: "datepicker", label: _("Ngày hóa đơn"), name: "invoiceDate", value: new Date(), id: "inv_Invoice_invoiceDate" }
                        ]

                    },
                    {
                        cols: [
                            {
                                view: "text",
                                label: "Mẫu số",
                                name: "mauhd",
                                id: "inv_Invoice_mauhd",
                                //labelWidth: 90,
                                required: true,
                                invalidMessage: "Mẫu số không được bỏ trống",
                                attributes: {
                                    maxlength: 11
                                },
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == undefined) return;
                                        if (newv == "") return;

                                        if (newv.length != 11) {
                                            webix.message({ type: "error", text: "Độ dài mẫu số phải là 11 ký tự" });
                                            this.focus();
                                            return;
                                        }

                                        var txtHinhThuc = "E";
                                        // var txtLoaihd = $$("dmloaihd_id_dmmauhoadon");

                                        if (txtHinhThuc == "") {
                                            webix.message({ type: "error", text: "Bạn chưa chọn hình thức hóa đơn" });
                                            return;
                                        }

                                        // if (txtLoaihd.getValue() == "") {
                                        //     webix.message({ type: "error", text: "Bạn chưa chọn loại hóa đơn" });
                                        //     return;
                                        // }

                                        // var hinhthuc = "E";
                                        // var list = txtLoaihd.getList();

                                        // var selectedItem = list.getItem(txtLoaihd.getValue());

                                        // if (selectedItem == undefined) return;

                                        // var ma_loai = selectedItem.ma_loai;

                                        // var so_lien = hinhthuc == "E" ? 0 : "";
                                        // var mau_so = ma_loai + so_lien + "/";

                                        // if (newv.startsWith(mau_so) == false) {
                                        //     webix.message({ type: "error", text: "Mẫu số không đúng" });
                                        //     this.focus();
                                        //     return;
                                        // }

                                        var sttMau = newv.substring(newv.length - 3, newv.length);
                                        var patt = /^[0-9][0-9][0-9]$/;

                                        if (patt.test(sttMau) == false) {
                                            webix.message({ type: "error", text: "3 ký tự cuối phải là số" });
                                            this.focus();
                                        }
                                    }
                                }
                            },
                            {
                                view: "text",
                                label: "Ký hiệu",
                                name: "invoiceSeries",
                                id: "inv_Invoice_invoiceSeries",
                                // labelWidth: 110,
                                required: true,
                                invalidMessage: "Ký hiệu không được bỏ trống",
                                attributes: { maxlength: 6 },
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == undefined) return;
                                        if (newv == "") return;

                                        if (newv.length != 6) {
                                            webix.message({ type: "error", text: "Độ dài ký hiệu phải là 6 ký tự" });
                                            this.focus();
                                            return;
                                        }

                                        var patt = /^[A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][/]$/;

                                        if (patt.test(newv.substring(0, 3)) == false) {
                                            webix.message({ type: "error", text: "3 ký tự đầu của ký hiệu không đúng" });
                                            this.focus();
                                            return;
                                        }

                                        patt = /^[1-9][1-9]$/;

                                        var nam = newv.substring(3, 5);

                                        if (patt.test(nam) == false) {
                                            webix.message({ type: "error", text: "2 ký tự năm của ký hiệu không đúng" });
                                            this.focus();
                                            return;
                                        }

                                        var now = new Date();
                                        var year = now.getFullYear();

                                        nam = Number("20" + nam);

                                        if (nam < (year - 1) || nam > year) {
                                            webix.message({ type: "error", text: "Năm ký hiệu không đúng" });
                                            this.focus();
                                            return;
                                        }

                                        if (newv.substring(5, 6) != "E") {
                                            webix.message({ type: "error", text: "Ký tự cuối phải là E" });
                                            this.focus();
                                            return;
                                        }

                                    }
                                }
                            },
                        ]
                    },
                    {
                        id: "inv_Invoice_sellerTaxCode",
                        name: "sellerTaxCode",
                        view: "search",
                        label: "MST người bán",
                        //align: "center",
                        placeholder: _("SEARCH") + "...",
                        // width: 300,
                        on: {
                            onTimedKeyPress: function () {
                                // var table = $$("tblSearch");

                                // table.clearAll();
                                // table.load(table.config.url);
                            },
                            onSearchIconClick: function (e) {
                                var text = this.getValue();
                                var datapost = { "masothue": text };
                                var table = $$("main-form");
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/GetInfoByMST", datapost, function (text) {

                                        var json = JSON.parse(text);
                                        table.enable();
                                        table.hideProgress();
                                        if (!json.hasOwnProperty("error")) {
                                            $$("inv_Invoice_sellerName").setValue(json.ten_cty);
                                            $$("inv_Invoice_sellerAdress").setValue(json.dia_chi);
                                        }
                                        else {
                                            // nếu không tồn tại mã số thuế phải xóa địa chỉ + tên cty ở đây 
                                            webix.message(json.error, "error", 1500);
                                        }

                                    });
                            }
                        }
                    },
                    { view: "text", label: _("Tên người bán"), name: "sellerName", id: "inv_Invoice_sellerName" },
                    { view: "text", label: _("Địa chỉ"), name: "sellerAdress", id: "inv_Invoice_sellerAdress" },
                    { view: "text", label: _("Tên mặt hàng tiêu biểu"), name: "itemName", id: "inv_Invoice_itemName" },
                    { view: "text", label: _("Tiền trước thuế"), name: "totalAmountWithoutVat", id: "inv_Invoice_totalAmountWithoutVat", inputAlign: "right", type: "number" },
                    { view: "text", label: _("Tiền thuế"), name: "vatAmount", id: "inv_Invoice_vatAmount", inputAlign: "right", type: "number" },
                    { view: "textarea", label: _("GHI_CHU"), name: "ghi_chu", id: "inv_Invoice_ghi_chu" },
                    { view: "text", label: _("Tên File"), name: "fileName", id: "inv_Invoice_fileName", hidden: true },
                    { view: "text", label: _("File Data"), name: "fileData", id: "inv_Invoice_fileData", hidden: true },
                    { view: "text", label: _("Mime Type"), name: "fileType", id: "inv_Invoice_fileType", hidden: true },
                    { view: "text", label: _("File Size"), name: "fileSize", id: "inv_Invoice_fileSize", hidden: true },
                    { view: "text", label: _("File Url"), name: "fileUrl", id: "inv_Invoice_fileUrl", hidden: true },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center",
                                on: {
                                    onClick: function () {
                                        var item = $$("main-form").getValues();
                                        var table = $$("main-form");

                                        if (table.validate()) {
                                            // var fn = Function(check);
                                            // var result = fn();
                                            // console.log(result);
                                            webix.extend(table, webix.ProgressBar);
                                            table.disable();
                                            table.showProgress();
                                            var file = $$("uploader").files.getFirstId();
                                            // if (file == undefined || file == null) {
                                            //     webix.message("Bạn chưa chọn File hóa đơn đính kèm !", "error");
                                            //     table.enable();
                                            //     table.hideProgress();
                                            //     return;
                                            // }
                                            var item1 = [];
                                            item1.push(item);
                                            var data_post = { editmode: editmode, data: item1 };

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/ManageInvoice/SaveInv", data_post, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        // var json = JSON.parse(text);
                                                        // webix.message(json.ExceptionMessage, "error");
                                                        webix.message(text + XmlHttpRequest, "error");

                                                    }, success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text);
                                                        table.enable();
                                                        table.hideProgress();
                                                        if (!json.hasOwnProperty("error")) {
                                                            webix.$$("main").close();
                                                            app.callEvent("dataChangedMain", [editmode, json.data]);
                                                        }
                                                        else {
                                                            webix.message(json.error, "error");
                                                        }
                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", type: "danger",
                                click: function () {
                                    $$("mylist").clearAll();
                                    $$("mylist").unbind();
                                    var id = $$("uploader").files.getFirstId();
                                    if (id != undefined) {
                                        $$("uploader").stopUpload(id);
                                    }
                                    this.getTopParentView().close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);

            var form = win.getChildViews()[1];

            item["invoiceDate"] = removeTimeZoneT(item["invoiceDate"]);
            form.setValues(item);

            if (editmode == 2) {
                $$("uploader").files.parse([
                    { name: item.fileName == null ? "" : item.fileName, sizetext: item.fileSize == null ? "" : item.fileSize, status: "server" }
                ]);
            }
        },
        setEditMode: function (mode) {
            editmode = mode;

            //var form = webix.$$("main-form");
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
        }
    };

});

define('views/forms/mauhoadon',["app"], function (app) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "mauhoadon-win", position: "center",
			head: "Mẫu hóa đơn",
			height: 250,
			body: {
				paddingY: 10,
				paddingX: 10,
				//elementsConfig:{labelWidth: 120}, 
				view: "form",
				id: "mauhoadon-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						view: "text",
						label: "Tên mẫu",
						name: "name",
						required: true,
						invalidMessage: "Tên mẫu không được bỏ trống",
						width: 600,
						labelWidth: 90
					},
					{
						view: "combo",
						label: "Hình thức",
						name: "invoice_type",
						id: "hinhthuc_dmmauhoadon",
						required: true,
						invalidMessage: "Hình thức không được bỏ trống",
						labelWidth: 90,
						options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00009",
						on: {
							onChange: function (newv, oldv) {
								var txtSolien = $$("so_lien_dmmauhoadon");

								if (newv == "E") {
									txtSolien.setValue(0);
									txtSolien.define("readonly", true);
								}
								else {
									txtSolien.define("readonly", false);
								}

								txtSolien.refresh();


							}
						}
					},
					{
						view: "combo",
						label: "Loại hóa đơn",
						name: "sl_invoice_type_id",
						id: "dmloaihd_id_dmmauhoadon",
						required: true,
						invalidMessage: "Loại hóa đơn không được bỏ trống",
						labelWidth: 90,
						//options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00008",
						options: {
							body: {
								url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00008",
								ready: function () {
									var form = $$("mauhoadon-form");
									var values = form.getValues();

									if (values.sl_invoice_type_id == null || values.sl_invoice_type_id == undefined || values.sl_invoice_type_id == "") {

										var data = this.serialize();

										for (var i = 0; i < data.length; i++) {
											var item = data[i];

											if (item.code == "01GTKT") {
												$$("dmloaihd_id_dmmauhoadon").setValue(item.id);
												break;
											}
										}
									}

								}
							}
						},
						on: {
							onChange: function (newv, oldv) {
								var list = this.getPopup().getList();
								var item = list.getItem(newv);

								if (item === undefined) {
									return;
								}

								var txtMauso = $$("mau_so_dmmauhoadon");

								var txtSolien = $$("so_lien_dmmauhoadon");
								var so_lien = txtSolien.getValue();
								var mau_so = item.code + so_lien + "/001";

								txtMauso.setValue(mau_so);
							}
						}
					},
					{
						cols: [
							{
								view: "text",
								label: "Mẫu số",
								name: "template_code",
								id: "mau_so_dmmauhoadon",
								labelWidth: 90,
								required: true,
								invalidMessage: "Mẫu số không được bỏ trống",
								attributes: {
									maxlength: 11
								},
								on: {
									onChange: function (newv, oldv) {
										if (newv == undefined) return;
										if (newv == "") return;

										if (newv.length != 11) {
											webix.message({ type: "error", text: "Độ dài mẫu số phải là 11 ký tự" });
											this.focus();
											return;
										}

										var txtHinhThuc = $$("hinhthuc_dmmauhoadon");
										var txtLoaihd = $$("dmloaihd_id_dmmauhoadon");

										if (txtHinhThuc.getValue() == "") {
											webix.message({ type: "error", text: "Bạn chưa chọn hình thức hóa đơn" });
											return;
										}

										if (txtLoaihd.getValue() == "") {
											webix.message({ type: "error", text: "Bạn chưa chọn loại hóa đơn" });
											return;
										}

										var hinhthuc = txtHinhThuc.getValue();
										var list = txtLoaihd.getList();

										var selectedItem = list.getItem(txtLoaihd.getValue());

										if (selectedItem == undefined) return;

										var ma_loai = selectedItem.code;

										var so_lien = hinhthuc == "E" ? 0 : "";
										var mau_so = ma_loai + so_lien + "/";

										if (newv.startsWith(mau_so) == false) {
											webix.message({ type: "error", text: "Mẫu số không đúng" });
											this.focus();
											return;
										}

										var sttMau = newv.substring(newv.length - 3, newv.length);
										var patt = /^[0-9][0-9][0-9]$/;

										if (patt.test(sttMau) == false) {
											webix.message({ type: "error", text: "3 ký tự cuối phải là số" });
											this.focus();
										}
									}
								}
							},
							{
								view: "text",
								label: "Ký hiệu",
								name: "invoice_series",
								labelWidth: 110,
								required: true,
								invalidMessage: "Ký hiệu không được bỏ trống",
								attributes: {
									maxlength: 6
								},
								on: {
									onChange: function (newv, oldv) {
										if (newv == undefined) return;
										if (newv == "") return;

										if (newv.length != 6) {
											webix.message({ type: "error", text: "Độ dài ký hiệu phải là 6 ký tự" });
											this.focus();
											return;
										}

										var patt = /^[A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][/]$/;

										if (patt.test(newv.substring(0, 3)) == false) {
											webix.message({ type: "error", text: "3 ký tự đầu không đúng" });
											this.focus();
											return;
										}

										patt = /^[0-9][0-9]$/;

										var nam = newv.substring(3, 5);

										if (patt.test(nam) == false) {
											webix.message({ type: "error", text: "2 ký tự năm không đúng" });
											this.focus();
											return;
										}

										var now = new Date();
										var year = now.getFullYear();

										nam = Number("20" + nam);

										if (nam < (year - 1) || nam > year) {
											webix.message({ type: "error", text: "Năm ký hiệu không đúng" });
											this.focus();
											return;
										}

										if (newv.substring(5, 6) != "E") {
											webix.message({ type: "error", text: "Ký tự cuối phải là E" });
											this.focus();
											return;
										}

									}
								}
							},
						]
					},
					{
						cols: [
							{
								view: "text",
								label: "Số liên",
								name: "copy_number",
								id: "so_lien_dmmauhoadon",
								labelWidth: 90,
								hidden: true,
								value: 0
							},
							{
								view: "text",
								label: "Số dòng in mẫu",
								name: "row_print_template",
								labelWidth: 110,
								hidden: true,
								value: 10
							},
						]
					},

					/* {
						borderless: true,
						view: "tabview",
						scrollX: true,
						cells: [
							{
								header: "Thông tin mẫu hóa đơn",
								select: "cell",
								body: {
									rows: [
										
									]
								}
							},
							{
								header: "Tiêu đề liên",
								select: "cell",
								body: {
									rows: [
										{
											cols: [
												{
													view: "text", label: "Liên 1", name: "copy1", width: 300
												},
												{
													view: "text", label: "Liên 2", name: "copy2", width: 300
												},
											]

										},
										{
											cols: [
												{
													view: "text", label: "Liên 3", name: "copy3"
												},
												{
													view: "text", label: "Liên 4", name: "copy4"
												},
											]

										},
										{
											cols: [
												{
													view: "text", label: "Liên 5", name: "copy5"
												},
												{
													view: "text", label: "Liên 6", name: "copy6"
												},
											]

										},
										{
											cols: [
												{
													view: "text", label: "Liên 7", name: "copy7"
												},
												{
													view: "text", label: "Liên 8", name: "copy8"
												},
											]

										},
										{
											cols: [
												{
													view: "text", label: "Liên 9", name: "copy9"
												},
												{}
											]
										}
									]
								}
							}
						]						
					}, */
					{},
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Lưu (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("mauhoadon-form");

										if (form.validate() == false) return;

										var item = form.getValues();

										var khData = {};

										khData.windowid = app.path[1].params[0];
										khData.editmode = editmode;
										khData.data = [];

										khData.data.push(item);

										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(app.config.host + "/System/Save", khData, function (text) {
												var json = JSON.parse(text);

												if (!json.hasOwnProperty("error")) {
													$$("mauhoadon-win").close();
													app.callEvent("dataChanged", [editmode, json.data]);
													if(json.hasOwnProperty("ok") && editmode == 1 && json.ok == "true")
													{
														webix.message("Thêm mới mẫu hóa đơn thành công!", "success");
													}
												}
												else {
													webix.message(json.error);
												}

											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
								click: function () {
									webix.$$("mauhoadon-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/forms/phanquyen',["app","locale"],function(app,_){
	
	function initUI(item){
		
		var url = app.config.host + "/System/ExecuteCommand";

		webix.ajax()
			.headers({'Content-type':'application/json'})
			.post(url,
				{
					command:"CM00003",
					parameter:{
						wb_nhomquyen_id: item.id
					}
				}
				,function(text){
            var json = JSON.parse(text);
			var data = listToTree(json, { idKey: "id", parentId: "parent_id" });
			
			var trtChucNang = $$("trtChucNang");

			trtChucNang.parse(data,"json");
			trtChucNang.openAll();

			for(var i=0;i<json.length;i++){
				var item = json[i];

				if (item.wb_role_id!=null){
					trtChucNang.checkItem(item.id);
				}				
			}
			
		});
		

		webix.ajax().headers({"Content-Type":"application/json"})
			.post(url,
				{
					command:"CM00015",
					parameter:{
						wb_nhomquyen_id: item.id
					}
				},function(text){
            var json = JSON.parse(text);
			var data = listToTree(json, { idKey: "id", parentId: "parent_id" });
			
			var trtBaoCao=$$("trtBaoCao");

			trtBaoCao.parse(data,"json");
			trtBaoCao.openAll();

			for(var i=0;i<json.length;i++){
				var item = json[i];

				if (item.wb_role_id!=null){
					trtBaoCao.checkItem(item.id);
				}
			}
			
		});

	}

	return {		
		$ui:{   
			view:"window", modal:true, id:"phanquyen-win", position:"center",
			head:"Thông tin Tab",
			fullscreen:true,
			body:{
				rows:[
					{
						borderless:true,
						view:"tabview",
						scrollX:true,
						multiview: {
							fitBiggest:true
						},
						cells:[
							{
								header: _("CHUC_NANG"),
								body:{
									id:"trtChucNang",
									view:"treetable",
									threeState: true,
									columns:[
										{
											id:"name",
											header:"<input id='chkBox' class='chkBox' type='checkbox' />" + _("TEN_CHUC_NANG"),
											template : "{common.space()} {common.icon()} {common.treecheckbox()} #name#",
											fillspace:true																				
										},
										{
											id:"them",
											header: [ {text:"", content:"masterCheckbox" }, _("THEM")],
											width:55,
											checkValue:'C', 
											uncheckValue:'K', 
											template: function(obj,common,value, config) {
												
												if (obj.$count>0){
													return "";
												}

												return common.checkbox(obj, common,value, config);
											}
										},
										{
											id:"sua",
											header: [ {text:"", content:"masterCheckbox" }, _("SUA")],
											width:55,
											checkValue:'C', 
											uncheckValue:'K', 
											template: function(obj,common,value, config) {
												
												if (obj.$count>0){
													return "";
												}

												return common.checkbox(obj, common,value, config);
											}
										},
										{
											id:"xoa",
											header: [ {text:"", content:"masterCheckbox" }, _("XOA")],
											width:55,
											checkValue:'C', 
											uncheckValue:'K', 
											template: function(obj,common,value, config) {
												
												if (obj.$count>0){
													return "";
												}

												return common.checkbox(obj, common,value, config);
											}
										}
									],
									on:{
										onHeaderClick:function(id, e, node){
											if (e.target.className == "chkBox"){
												var chk=document.getElementById("chkBox").checked;

												var trtChucNang = $$("trtChucNang");			
												trtChucNang.openAll();

												var json = trtChucNang.serialize();

												for(var i=0;i<json.length;i++){
													var item = json[i];

													if (chk == true){
														trtChucNang.checkItem(item.id);
													}
													else {
														trtChucNang.uncheckItem(item.id);
													}
																													
												}
											}											
										}
									} 
								}
							},
							{
								header: _("BAO_CAO"),
								body:{
									id:"trtBaoCao",
									view:"treetable",
									threeState: true,
									columns:[
										{
											id:"name",
											header:"<input id='chkBox' class='chkBox' type='checkbox' />" +_("CHON_BOCHON"),
											template : "{common.space()} {common.icon()} {common.treecheckbox()} #name#",
											fillspace:true																				
										}										
									],
									on:{
										onHeaderClick:function(id, e, node){
											if (e.target.className == "chkBox"){
												var chk=document.getElementById("chkBox").checked;

												var trtBaoCao = $$("trtBaoCao");			
												trtBaoCao.openAll();

												var json = trtBaoCao.serialize();

												for(var i=0;i<json.length;i++){
													var item = json[i];

													if (chk == true){
														trtBaoCao.checkItem(item.id);
													}
													else {
														trtBaoCao.uncheckItem(item.id);
													}
																													
												}
											}											
										}
									}
								}
							} 
						]						
					},
					{
						cols:[
							{},
							{ 
								shortcut:"F10",  
								view:"button", label:"Nhận (F10)", type:"form", align:"center", 
								width:100,
								on: {
									onClick: function() {										
										var tblChucnang = $$("trtChucNang");
										var tblBaoCao = $$("trtBaoCao");

										var win = this.getTopParentView();

										var checkedItems = tblChucnang.getChecked();

										var data = {
											wb_role_id: win.config.wb_role_id,
											wb_ctquyen: [],
											wb_ctquyenrp: []
										};

										for(var i=0;i<checkedItems.length;i++){
											var checked = tblChucnang.getItem(checkedItems[i]);
											
											if (checked.$count==0){
												var item = {
													wb_role_id: win.config.wb_role_id,
													wb_menu_id: checked.id,
													them: checked.them,
													sua: checked.sua,
													xoa: checked.xoa
												};
												
												data.wb_ctquyen.push(item);
											}
										}

										checkedItems = tblBaoCao.getChecked();

										for(var i=0;i<checkedItems.length;i++){
											var checked = tblBaoCao.getItem(checkedItems[i]);
											
											if (checked.$count==0){
												var item = {
													wb_role_id: win.config.wb_role_id,
													wb_report_id: checked.id													
												};
												
												data.wb_ctquyenrp.push(item);
											}
										}

										var url = app.config.host + "/System/Phanquyen";

										webix.ajax()
											.headers({'Content-type':'application/json'})
											.post(url, data, function(text){
											var result = JSON.parse(text);
											
											if (!result.hasOwnProperty("error")){
												webix.$$("phanquyen-win").close();												
											}
											else {
												webix.message(result.error);
											}
										});
									}
								},
								click:function(){								
									this.callEvent("onClick");							
														
								},
							},
							{ 
								view:"button", shortcut:"esc", label:"Hủy bỏ (ESC)",type:"danger",align:"center",
								width:100,
								on:{
									onClick: function(){
										this.getTopParentView().close();
									}
								},
								click:function(){
									this.callEvent("onClick");
								}
							},
							{}

						]
					},
					{
						height:5
					}
				]
			}			
			
		},		
		initUI: initUI
	};

});
define('views/forms/printf',[
    "app",
    "locale"
], function (app, _) {
    

    function initUI(url) {

    };

    return {
        $ui: {
            view: "window",
            move: true,
            position: "center",
            id: "nampv",
            modal: true,
            // borderless: false,
            width: 800,
            height: 700,
            //fullscreen: true,
            css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
            head: {
                //view: "toolbar",
                css: { "box-shadow": "0 -2px #3498db inset !important" },
                //height: 15,
                cols: [
                    { gravity: 1, template: "" },
                    {
                        view: "icon", icon: "times", hotkey: "esc", click: function () {
                            $$("nampv").close();
                        }
                    }
                ]
            },
            body: {
                rows: [
                    {
                        view: "iframe", id: "frame-body",css:{"width":"80%", "height":"80%"},
                        src: "https://minvoice.vn/"
                    },
                    //{ gravity: 0.1, template: "" }
                ]
            },
            on: {
                onBeforeShow: function () {
                    var link = $$("nampv").config.url;
                    //$$("myframe").getIframe();
                    $$("frame-body").define("src", link);

                }
            }
        },
        $oninit: function (view, $scope) {

        },
        initUI: initUI
    }
});
define('views/forms/register_licence_branch',["app","locale"], function (app,_) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "register_licence-win", position: "center",
			head: "Đăng ký licence",
			height: 250,
			body: {
				paddingY: 10,
				paddingX: 10,
				//elementsConfig:{labelWidth: 120}, 
				view: "form",
				id: "register_licence-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						id:"cbBranchCode",
						view: "combo",
						name: "branch_code",
						label: "Đơn vị",
						width: 600,
						labelWidth: 200,	
						//id: "dmtab-store",
						required: true,
						readonly: true,
						invalidMessage: "Bạn chưa chọn đơn vị",
											
						options: {
							view: "treesuggest",
							textValue: "value",
							url: {
								$proxy: true,
								load: function (view, callback, params) {
									var url = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00195";

									webix.ajax(url, function (text) {
										var json = JSON.parse(text);
										var data = listToTree(json);
										view.parse(data, "json");
									});

								}
							},
							body: {								
								textValue: "value",
								columns: [
									{
										id: "wb_branch_id",
										width: 120,
										header: _("MA"),
										hidden: true
									},
									{
										id: "name",
										width: 650,
										header: _("TEN"),
										template:"{common.space()}{common.icon()}#name#"
									}
								],
								filterMode: {
									level: false,
									showSubItems: false
								}								
							}
						},
					},
					{
						view: "text",
						label: "Số lượng",
						name: "quantity",
						required: true,
						invalidMessage: "Số lượng không được bỏ trống",
						width: 600,
						labelWidth: 200
					},
                   
					{},
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Lưu (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {

										var form = webix.$$("register_licence-form");
										if (form.validate() == false) return;
										var item = form.getValues();

										var model = {
											// editmode = editmode,
											branch_code: item.branch_code,
											quantity: item.quantity,
											createdondate: new Date().toUTCString()
										};
										model.editmode = editmode;

										if(editmode == "2"){
											model.pl_licence_branch_id = item.pl_licence_branch_id;
										}

										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(app.config.host + "/System/RegisterLicenceBranch", model, function (text) {
												var json = JSON.parse(text);
												if (!json.hasOwnProperty("error")) {
													app.callEvent("dataChangedLicense", [editmode, json.data]);
													if(json.hasOwnProperty("ok") && editmode == 1 && json.ok == "true")
													{
														webix.message("Thêm mới license thành công!", "success");
													}
													$$("register_licence-win").close();
												}
												else {
													webix.message(json.error, "error");
													app.callEvent("dataChangedLicense", [editmode, json.data]);
												}

											});
									}
								},
								click: function () {
									this.callEvent("onClick");
								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
								click: function () {
									webix.$$("register_licence-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/forms/searchinvoice',["app", "locale"],function(app,_){
	var editmode = 0;	

	return {		
		$ui:{   
			view:"window", modal:true, id:"dmtab-win", position:"center",
			head:"Tìm kiếm chi tiết",
			width:500,
			body:{
                paddingY:10, 
                paddingX:10, 
                view:"form", 
				id:"dmtab-form", 
				complexData:true,
				margin: 0,
                elements:[
					{
						view:"combo", 
						name:"inv_invoiceType", 
						label:_("MA_LOAI"), 
						labelPosition:"top",
						options: {
							body:{
								url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00019"
							},									
							width: 550,
							fitMaster:false
						}
					},
					{
						cols:[							
							{ view:"text", name:"mau_hd", label:_("MAU_HDON"), labelPosition:"top" },
							{ view:"text", name:"inv_invoiceSeries", label:_("SO_SERIAL"), labelPosition:"top" }
						]
					},
					{
						cols:[
							{ view:"text", name:"inv_invoiceNumber", label:_("SO_HDON"), labelPosition:"top" },
							{ 
								view:"combo", 
								name:"user_new", 
								label:_("NGUOI_LAP"), 
								labelPosition:"top",
								options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00020" 
							}
						]
					},
					{
						cols:[
							{ view:"datepicker", name:"tu_ngay", label:_("TU_NGAY"), labelPosition:"top" },
							{ view:"datepicker", name:"den_ngay", label:_("DEN_NGAY"), labelPosition:"top" }
						]
					},
					{
						cols:[
							{ view:"combo", name:"trang_thai", options:["Chờ duyệt","Chờ ký", "Đã ký", "Đã kê khai"], label:_("TRANG_THAI"), labelPosition:"top" },
							{ 
								view:"combo", 
								name:"trang_thai_hd", 
								label:_("TRANG_THAI_HDON"), 
								labelPosition:"top",
								options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00017"
							}
						]
					},								
					{
						margin:10,
						cols:[
							{},
							{ 
								shortcut:"F10",  
								view:"button", 
								label:"Nhận (F10)", 
								type:"form", 
								icon:"",
								align:"center", 
								width:120, 
								on: {
									onClick: function() {
										var form = webix.$$("dmtab-form");
										var item = form.getValues();

										webix.$$("dmtab-win").close();
										app.callEvent("dataChanged",[1,item]);										
										
									}
								},
								click:function(){								
									this.callEvent("onClick");							
									
								}
							},
							{ view:"button", hotkey:"esc", label:"Hủy bỏ (ESC)",type:"danger", align:"center", width:120, 
								click:function(){
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}

				]
			}			
			
		},		
		setEditMode: function(mode) {
			editmode = mode;
		},
		setValues: function(values){
			$$("dmtab-form").setValues(values);
		}
	};

});
define('views/forms/sendemail_bienlai',["app", "locale", "views/forms/lichsuemail_bienlai"], function (app, _, his_email) {
    var editmode = 0;
    var itemdoc;
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "dmtab-win",
            position: "center",
            head: "Gửi biên lai cho khách hàng qua email",
            fullscreen: true,
            //height: 700,
            //width: 1000,
            keepViews: true,
            move: true,
            body: {
                paddingY: 5,
                paddingX: 5,
                view: "form",
                id: "dmtab-form",
                // on: {
                // 	onItemClick: function (id) {
                // 		if (id == "his_email") {
                // 			var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
                // 			detailForm.show();
                // 		}
                // 	}
                // },
                elements: [
                    {
                        view: "fieldset",
                        label: "Thông tin gửi mail",
                        body: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            name: "nguoi_gui",
                                            label: _("NGUOI_GUI"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Người gửi không được để trống !",
                                        },
                                        {
                                            view: "text",
                                            name: "alias",
                                            label: _("Bí Danh"),
                                            labelPosition: "top",
                                            // required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Tên hiển thị không được để trống !",
                                        },
                                        {
                                            view: "text",
                                            name: "mat_khau",
                                            label: _("PASSWORD"),
                                            type: "password",
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Mật khẩu không được để trống !",
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        // {
                                        // 	view: "text",
                                        // 	name: "nguoinhan",
                                        // 	id: "nguoinhan",
                                        // 	label: _("NGUOI_NHAN"),
                                        // 	labelPosition: "top",
                                        // 	required: true,
                                        // 	validate: webix.rules.isNotEmpty,
                                        // 	invalidMessage: "Người nhận không được để trống !"
                                        // },
                                        {
                                            view: "multicombo",
                                            name: "nguoinhan",
                                            id: "nguoinhan",
                                            label: _("NGUOI_NHAN"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Người nhận không được để trống !",
                                            newValues: true,
                                            separator: ";",
                                            suggest: {
                                                selectAll: true,

                                                body: {
                                                    id: "nguoinhan_suggest",
                                                    //data: [{"id":"hungkq@minvoice.vn","value":"hungkq@minvoice.vn"},{"id":"khieuhung.kt@gmail.com","value":"khieuhung.kt@gmail.com"},{"id":"abc@gmail.com","value":"abc@gmail.com"},{"id":"xyz@gmail.com","value":"xyz@gmail.com"}]
                                                    //url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00050",
                                                    //template: webix.template("#value#")
                                                },
                                            },
                                        },
                                        {
                                            view: "text",
                                            name: "bcc",
                                            label: "BCC",
                                            labelPosition: "top",
                                        },
                                    ],
                                },
                                {
                                    view: "text",
                                    name: "tieude",
                                    label: _("TIEU_DE"),
                                    labelPosition: "top",
                                },
                            ],
                        },
                    },
                    {
                        view: "label",
                        name: "his_email",
                        id: "his_email",
                        //label: "Hóa đơn đã được gửi đi 5 lần",
                        template: function (obj) {
                            if (obj.value == 0) return "<span style='color:blue'>Biên lai chưa gửi cho khách hàng !</span>";
                            return (
                                "<span style='color:blue'>Biên lai đã được gửi <big>" +
                                obj.value +
                                "</big> lần !<sub style='color:red'> Lịch sử gửi email <i class='fa fa-hand-o-left' aria-hidden='true'></i></sub></span>"
                            );
                        },
                        on: {
                            onItemClick: function () {
                                var inv_invoiceauth_id = "";
                                var table = webix.$$("windowData");
                                if (table === undefined || table === null) {
                                    table = webix.$$("invoiceViews");
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.hdon_id;
                                } else {
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.inv_invoiceauth_id;
                                }

                                var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
                                his_email.initUI(inv_invoiceauth_id);
                                detailForm.show();
                            },
                        },
                    },
                    {
                        name: "noidung",
                        view: "ckeditor",
                        keepViews: true,
                        label: _("NOI_DUNG"),
                        labelPosition: "top",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Gửi (F10)",
                                type: "form",
                                align: "center",
                                width: 120,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("dmtab-form");
                                        var item = form.getValues();
                                        var url = app.config.host + "/Invoice/SendInvoiceByEmail";
                                        console.log(itemdoc);
                                        if (itemdoc.hdon68 == 1) {
                                            url = app.config.host + "/Invoice68/SendInvoiceByEmail";
                                        }

                                        if ($$("dmtab-form").validate()) {
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            webix
                                                .ajax()
                                                .headers({ "Content-type": "application/json" })
                                                .post(url, item, function (text) {
                                                    var form = webix.$$("dmtab-form");

                                                    form.enable();
                                                    form.hideProgress();

                                                    var data = JSON.parse(text);

                                                    if (!data.hasOwnProperty("error")) {
                                                        webix.message("Gửi Email thành công !", "debug");

                                                        var item = form.getValues();
                                                        var topParentView = form.getTopParentView();

                                                        if (topParentView.config.tableId != undefined) {
                                                            var table = $$(topParentView.config.tableId);

                                                            var item = table.getSelectedItem();
                                                            item.trang_thai = "Chờ người mua ký";
                                                            table.updateItem(item.id, item);
                                                        }

                                                        webix.$$("dmtab-win").close();
                                                    } else {
                                                        webix.message(data.error);
                                                    }
                                                });
                                        } else {
                                            $$("nguoinhan").focus();
                                        }
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                type: "danger",
                                align: "center",
                                width: 120,
                                click: function () {
                                    webix.$$("dmtab-win").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (values) {
            itemdoc = values;
            $$("dmtab-form").setValues(values);
            // var k = [{ "id": "hungkq@minvoice.vn", "value": "hungkq@minvoice.vn" }, { "id": "khieuhung.kt@gmail.com", "value": "khieuhung.kt@gmail.com" }, { "id": "abc@gmail.com", "value": "abc@gmail.com" }, { "id": "xyz@gmail.com", "value": "xyz@gmail.com" }];
            // $$("nguoinhan_suggest").define("data", k);
            if (values.nguoinhan != null && values.nguoinhan != "") {
                var k = [{ id: values.nguoinhan, value: values.nguoinhan }];
                $$("nguoinhan_suggest").define("data", k);
            }
            if (values.hasOwnProperty("lst_email")) {
                $$("nguoinhan_suggest").define("data", values.lst_email);
            }

            // $$("dmtab-form").setValues(values);
        },
    };
});

define('views/forms/sendemail',["app", "locale", "views/forms/lichsuemail"], function (app, _, his_email) {
    var editmode = 0;
    var itemdoc;
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "dmtab-win",
            position: "center",
            head: "Gửi hóa đơn cho khách hàng qua email",
            fullscreen: true,
            //height: 700,
            //width: 1000,
            keepViews: true,
            move: true,
            body: {
                paddingY: 5,
                paddingX: 5,
                view: "form",
                id: "dmtab-form",
                // on: {
                // 	onItemClick: function (id) {
                // 		if (id == "his_email") {
                // 			var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
                // 			detailForm.show();
                // 		}
                // 	}
                // },
                elements: [
                    {
                        view: "fieldset",
                        label: "Thông tin gửi mail",
                        body: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            name: "nguoi_gui",
                                            label: _("NGUOI_GUI"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Người gửi không được để trống !",
                                        },
                                        {
                                            view: "text",
                                            name: "alias",
                                            label: _("Bí Danh"),
                                            labelPosition: "top",
                                            // required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Tên hiển thị không được để trống !",
                                        },
                                        {
                                            view: "text",
                                            name: "mat_khau",
                                            label: _("PASSWORD"),
                                            type: "password",
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Mật khẩu không được để trống !",
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        // {
                                        // 	view: "text",
                                        // 	name: "nguoinhan",
                                        // 	id: "nguoinhan",
                                        // 	label: _("NGUOI_NHAN"),
                                        // 	labelPosition: "top",
                                        // 	required: true,
                                        // 	validate: webix.rules.isNotEmpty,
                                        // 	invalidMessage: "Người nhận không được để trống !"
                                        // },
                                        {
                                            view: "multicombo",
                                            name: "nguoinhan",
                                            id: "nguoinhan",
                                            label: _("NGUOI_NHAN"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Người nhận không được để trống !",
                                            newValues: true,
                                            separator: ";",
                                            suggest: {
                                                selectAll: true,

                                                body: {
                                                    id: "nguoinhan_suggest",
                                                    //data: [{"id":"hungkq@minvoice.vn","value":"hungkq@minvoice.vn"},{"id":"khieuhung.kt@gmail.com","value":"khieuhung.kt@gmail.com"},{"id":"abc@gmail.com","value":"abc@gmail.com"},{"id":"xyz@gmail.com","value":"xyz@gmail.com"}]
                                                    //url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00050",
                                                    //template: webix.template("#value#")
                                                },
                                            },
                                        },
                                        {
                                            view: "text",
                                            name: "bcc",
                                            label: "BCC",
                                            labelPosition: "top",
                                        },
                                    ],
                                },
                                {
                                    view: "text",
                                    name: "tieude",
                                    label: _("TIEU_DE"),
                                    labelPosition: "top",
                                },
                            ],
                        },
                    },
                    {
                        view: "label",
                        name: "his_email",
                        id: "his_email",
                        //label: "Hóa đơn đã được gửi đi 5 lần",
                        template: function (obj) {
                            if (obj.value == 0) return "<span style='color:blue'>Hóa đơn chưa gửi cho khách hàng !</span>";
                            return (
                                "<span style='color:blue'>Hóa đơn đã được gửi <big>" +
                                obj.value +
                                "</big> lần !<sub style='color:red'> Lịch sử gửi email <i class='fa fa-hand-o-left' aria-hidden='true'></i></sub></span>"
                            );
                        },
                        on: {
                            onItemClick: function () {
                                var inv_invoiceauth_id = "";
                                var table = webix.$$("windowData");
                                if (table === undefined || table === null) {
                                    table = webix.$$("invoiceViews");
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.hdon_id;
                                } else {
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.inv_invoiceauth_id;
                                }

                                var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
                                his_email.initUI(inv_invoiceauth_id);
                                detailForm.show();
                            },
                        },
                    },
                    {
                        name: "noidung",
                        view: "ckeditor",
                        keepViews: true,
                        label: _("NOI_DUNG"),
                        labelPosition: "top",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Gửi (F10)",
                                type: "form",
                                align: "center",
                                width: 120,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("dmtab-form");
                                        var item = form.getValues();
                                        var url = app.config.host + "/Invoice/SendInvoiceByEmail";
                                        console.log(itemdoc);
                                        if (itemdoc.hdon68 == 1) {
                                            url = app.config.host + "/Invoice68/SendInvoiceByEmail";
                                        }

                                        if ($$("dmtab-form").validate()) {
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            webix
                                                .ajax()
                                                .headers({ "Content-type": "application/json" })
                                                .post(url, item, function (text) {
                                                    var form = webix.$$("dmtab-form");

                                                    form.enable();
                                                    form.hideProgress();

                                                    var data = JSON.parse(text);

                                                    if (!data.hasOwnProperty("error")) {
                                                        webix.message("Gửi Email thành công !", "debug");

                                                        var item = form.getValues();
                                                        var topParentView = form.getTopParentView();

                                                        if (topParentView.config.tableId != undefined) {
                                                            var table = $$(topParentView.config.tableId);

                                                            var item = table.getSelectedItem();
                                                            item.trang_thai = "Chờ người mua ký";
                                                            table.updateItem(item.id, item);
                                                        }

                                                        webix.$$("dmtab-win").close();
                                                    } else {
                                                        webix.message(data.error);
                                                    }
                                                });
                                        } else {
                                            $$("nguoinhan").focus();
                                        }
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                type: "danger",
                                align: "center",
                                width: 120,
                                click: function () {
                                    webix.$$("dmtab-win").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (values) {
            itemdoc = values;
            $$("dmtab-form").setValues(values);
            // var k = [{ "id": "hungkq@minvoice.vn", "value": "hungkq@minvoice.vn" }, { "id": "khieuhung.kt@gmail.com", "value": "khieuhung.kt@gmail.com" }, { "id": "abc@gmail.com", "value": "abc@gmail.com" }, { "id": "xyz@gmail.com", "value": "xyz@gmail.com" }];
            // $$("nguoinhan_suggest").define("data", k);
            if (values.nguoinhan != null && values.nguoinhan != "") {
                var k = [{ id: values.nguoinhan, value: values.nguoinhan }];
                $$("nguoinhan_suggest").define("data", k);
            }
            if (values.hasOwnProperty("lst_email")) {
                $$("nguoinhan_suggest").define("data", values.lst_email);
            }

            // $$("dmtab-form").setValues(values);
        },
    };
});

define('views/forms/sendemailbienban',["app", "locale", "views/forms/lichsuemailbienban"], function (app, _, his_email) {
    var editmode = 0;
    var itemdoc;
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "dmtab-win",
            position: "center",
            head: "Gửi biên bản cho khách hàng qua email",
            fullscreen: true,
            //height: 700,
            //width: 1000,
            keepViews: true,
            move: true,
            body: {
                paddingY: 5,
                paddingX: 5,
                view: "form",
                id: "dmtab-form",
                // on: {
                // 	onItemClick: function (id) {
                // 		if (id == "his_email") {
                // 			var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
                // 			detailForm.show();
                // 		}
                // 	}
                // },
                elements: [
                    {
                        view: "fieldset",
                        label: "Thông tin gửi mail",
                        body: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            name: "nguoi_gui",
                                            label: _("NGUOI_GUI"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Người gửi không được để trống !",
                                        },
                                        {
                                            view: "text",
                                            name: "alias",
                                            label: _("Bí Danh"),
                                            labelPosition: "top",
                                            // required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Tên hiển thị không được để trống !",
                                        },
                                        {
                                            view: "text",
                                            name: "mat_khau",
                                            label: _("PASSWORD"),
                                            type: "password",
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Mật khẩu không được để trống !",
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        // {
                                        // 	view: "text",
                                        // 	name: "nguoinhan",
                                        // 	id: "nguoinhan",
                                        // 	label: _("NGUOI_NHAN"),
                                        // 	labelPosition: "top",
                                        // 	required: true,
                                        // 	validate: webix.rules.isNotEmpty,
                                        // 	invalidMessage: "Người nhận không được để trống !"
                                        // },
                                        {
                                            view: "multicombo",
                                            name: "nguoinhan",
                                            id: "nguoinhan",
                                            label: _("NGUOI_NHAN"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Người nhận không được để trống !",
                                            newValues: true,
                                            separator: ";",
                                            suggest: {
                                                selectAll: true,

                                                body: {
                                                    id: "nguoinhan_suggest",
                                                    //data: [{"id":"hungkq@minvoice.vn","value":"hungkq@minvoice.vn"},{"id":"khieuhung.kt@gmail.com","value":"khieuhung.kt@gmail.com"},{"id":"abc@gmail.com","value":"abc@gmail.com"},{"id":"xyz@gmail.com","value":"xyz@gmail.com"}]
                                                    //url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00050",
                                                    //template: webix.template("#value#")
                                                },
                                            },
                                        },
                                        {
                                            view: "text",
                                            name: "bcc",
                                            label: "BCC",
                                            labelPosition: "top",
                                        },
                                    ],
                                },
                                {
                                    view: "text",
                                    name: "tieude",
                                    label: _("TIEU_DE"),
                                    labelPosition: "top",
                                },
                            ],
                        },
                    },
                    {
                        view: "label",
                        name: "his_email",
                        id: "his_email",
                        template: function (obj) {
                            if (obj.value == 0) return "<span style='color:blue'>Biên bản chưa gửi cho khách hàng !</span>";
                            return (
                                "<span style='color:blue'>Biên bản đã được gửi <big>" +
                                obj.value +
                                "</big> lần !<sub style='color:red'> Lịch sử gửi email <i class='fa fa-hand-o-left' aria-hidden='true'></i></sub></span>"
                            );
                        },
                        on: {
                            onItemClick: function () {
                                debugger
                                var inv_invoiceauth_id = "";
                                var table = webix.$$("windowData");
                                if (table === undefined || table === null) {
                                    table = webix.$$("bienbanthoathuan");
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.hdon_id;
                                } else {
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.inv_invoiceauth_id;
                                }

                                var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
                                his_email.initUI(inv_invoiceauth_id);
                                detailForm.show();
                            },
                        },
                    },
                    {
                        name: "noidung",
                        view: "ckeditor",
                        keepViews: true,
                        label: _("NOI_DUNG"),
                        labelPosition: "top",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Gửi (F10)",
                                type: "form",
                                align: "center",
                                width: 120,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("dmtab-form");
                                        var item = form.getValues();
                                        var url = app.config.host + "/Invoice68/SendBienBanByEmail";


                                        if ($$("dmtab-form").validate()) {
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            webix
                                                .ajax()
                                                .headers({ "Content-type": "application/json" })
                                                .post(url, item, function (text) {
                                                    var form = webix.$$("dmtab-form");

                                                    form.enable();
                                                    form.hideProgress();

                                                    var data = JSON.parse(text);

                                                    if (!data.hasOwnProperty("error")) {
                                                        webix.message("Gửi Email thành công !", "debug");

                                                        var item = form.getValues();
                                                        var topParentView = form.getTopParentView();

                                                        if (topParentView.config.tableId != undefined) {
                                                            var table = $$(topParentView.config.tableId);

                                                            var item = table.getSelectedItem();
                                                            item.trang_thai = "Chờ người mua ký";
                                                            table.updateItem(item.id, item);
                                                        }

                                                        webix.$$("dmtab-win").close();
                                                    } else {
                                                        webix.message(data.error);
                                                    }
                                                });
                                        } else {
                                            $$("nguoinhan").focus();
                                        }
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                type: "danger",
                                align: "center",
                                width: 120,
                                click: function () {
                                    webix.$$("dmtab-win").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (values) {
            itemdoc = values;
            $$("dmtab-form").setValues(values);
            // var k = [{ "id": "hungkq@minvoice.vn", "value": "hungkq@minvoice.vn" }, { "id": "khieuhung.kt@gmail.com", "value": "khieuhung.kt@gmail.com" }, { "id": "abc@gmail.com", "value": "abc@gmail.com" }, { "id": "xyz@gmail.com", "value": "xyz@gmail.com" }];
            // $$("nguoinhan_suggest").define("data", k);
            if (values.nguoinhan != null && values.nguoinhan != "") {
                var k = [{ id: values.nguoinhan, value: values.nguoinhan }];
                $$("nguoinhan_suggest").define("data", k);
            }
            if (values.hasOwnProperty("lst_email")) {
                $$("nguoinhan_suggest").define("data", values.lst_email);
            }

            // $$("dmtab-form").setValues(values);
        },
    };
});

define('views/forms/sendemailbienlai',["app", "locale", "views/forms/lichsuemail"], function (app, _, his_email) {
    var editmode = 0;
    var itemdoc;
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "dmtab-win",
            position: "center",
            head: "Gửi biên lai cho khách hàng qua email",
            fullscreen: true,
            //height: 700,
            //width: 1000,
            keepViews: true,
            move: true,
            body: {
                paddingY: 5,
                paddingX: 5,
                view: "form",
                id: "dmtab-form",
                // on: {
                // 	onItemClick: function (id) {
                // 		if (id == "his_email") {
                // 			var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
                // 			detailForm.show();
                // 		}
                // 	}
                // },
                elements: [
                    {
                        view: "fieldset",
                        label: "Thông tin gửi mail",
                        body: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            name: "nguoi_gui",
                                            label: _("NGUOI_GUI"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Người gửi không được để trống !",
                                        },
                                        {
                                            view: "text",
                                            name: "alias",
                                            label: _("Bí Danh"),
                                            labelPosition: "top",
                                            // required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Tên hiển thị không được để trống !",
                                        },
                                        {
                                            view: "text",
                                            name: "mat_khau",
                                            label: _("PASSWORD"),
                                            type: "password",
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Mật khẩu không được để trống !",
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        // {
                                        // 	view: "text",
                                        // 	name: "nguoinhan",
                                        // 	id: "nguoinhan",
                                        // 	label: _("NGUOI_NHAN"),
                                        // 	labelPosition: "top",
                                        // 	required: true,
                                        // 	validate: webix.rules.isNotEmpty,
                                        // 	invalidMessage: "Người nhận không được để trống !"
                                        // },
                                        {
                                            view: "multicombo",
                                            name: "nguoinhan",
                                            id: "nguoinhan",
                                            label: _("NGUOI_NHAN"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Người nhận không được để trống !",
                                            newValues: true,
                                            separator: ";",
                                            suggest: {
                                                selectAll: true,

                                                body: {
                                                    id: "nguoinhan_suggest",
                                                    //data: [{"id":"hungkq@minvoice.vn","value":"hungkq@minvoice.vn"},{"id":"khieuhung.kt@gmail.com","value":"khieuhung.kt@gmail.com"},{"id":"abc@gmail.com","value":"abc@gmail.com"},{"id":"xyz@gmail.com","value":"xyz@gmail.com"}]
                                                    //url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00050",
                                                    //template: webix.template("#value#")
                                                },
                                            },
                                        },
                                        {
                                            view: "text",
                                            name: "bcc",
                                            label: "BCC",
                                            labelPosition: "top",
                                        },
                                    ],
                                },
                                {
                                    view: "text",
                                    name: "tieude",
                                    label: _("TIEU_DE"),
                                    labelPosition: "top",
                                },
                            ],
                        },
                    },
                    {
                        view: "label",
                        name: "his_email",
                        id: "his_email",
                        //label: "Hóa đơn đã được gửi đi 5 lần",
                        template: function (obj) {
                            if (obj.value == 0) return "<span style='color:blue'>Biên lai chưa gửi cho khách hàng !</span>";
                            return (
                                "<span style='color:blue'>Biên lai đã được gửi <big>" +
                                obj.value +
                                "</big> lần !<sub style='color:red'> Lịch sử gửi email <i class='fa fa-hand-o-left' aria-hidden='true'></i></sub></span>"
                            );
                        },
                        on: {
                            onItemClick: function () {
                                var inv_invoiceauth_id = "";
                                var table = webix.$$("windowData");
                                if (table === undefined || table === null) {
                                    table = webix.$$("invoiceViews");
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.hdon_id;
                                } else {
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.inv_invoiceauth_id;
                                }

                                var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
                                his_email.initUI(inv_invoiceauth_id);
                                detailForm.show();
                            },
                        },
                    },
                    {
                        name: "noidung",
                        view: "ckeditor",
                        keepViews: true,
                        label: _("NOI_DUNG"),
                        labelPosition: "top",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Gửi (F10)",
                                type: "form",
                                align: "center",
                                width: 120,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("dmtab-form");
                                        var item = form.getValues();
                                        var url = app.config.host + "/Invoice/SendInvoiceByEmail";
                                        console.log(itemdoc);
                                        if (itemdoc.hdon68 == 1) {
                                            url = app.config.host + "/Invoice68/SendInvoiceByEmail";
                                        }

                                        if ($$("dmtab-form").validate()) {
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            webix
                                                .ajax()
                                                .headers({ "Content-type": "application/json" })
                                                .post(url, item, function (text) {
                                                    var form = webix.$$("dmtab-form");

                                                    form.enable();
                                                    form.hideProgress();

                                                    var data = JSON.parse(text);

                                                    if (!data.hasOwnProperty("error")) {
                                                        webix.message("Gửi Email thành công !", "debug");

                                                        var item = form.getValues();
                                                        var topParentView = form.getTopParentView();

                                                        if (topParentView.config.tableId != undefined) {
                                                            var table = $$(topParentView.config.tableId);

                                                            var item = table.getSelectedItem();
                                                            item.trang_thai = "Chờ người mua ký";
                                                            table.updateItem(item.id, item);
                                                        }

                                                        webix.$$("dmtab-win").close();
                                                    } else {
                                                        webix.message(data.error);
                                                    }
                                                });
                                        } else {
                                            $$("nguoinhan").focus();
                                        }
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                type: "danger",
                                align: "center",
                                width: 120,
                                click: function () {
                                    webix.$$("dmtab-win").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (values) {
            itemdoc = values;
            $$("dmtab-form").setValues(values);
            // var k = [{ "id": "hungkq@minvoice.vn", "value": "hungkq@minvoice.vn" }, { "id": "khieuhung.kt@gmail.com", "value": "khieuhung.kt@gmail.com" }, { "id": "abc@gmail.com", "value": "abc@gmail.com" }, { "id": "xyz@gmail.com", "value": "xyz@gmail.com" }];
            // $$("nguoinhan_suggest").define("data", k);
            if (values.nguoinhan != null && values.nguoinhan != "") {
                var k = [{ id: values.nguoinhan, value: values.nguoinhan }];
                $$("nguoinhan_suggest").define("data", k);
            }
            if (values.hasOwnProperty("lst_email")) {
                $$("nguoinhan_suggest").define("data", values.lst_email);
            }

            // $$("dmtab-form").setValues(values);
        },
    };
});

define('views/forms/sendemailtncn',["app", "locale", "views/forms/lichsuemail"], function (app, _, his_email) {
    var editmode = 0;
    var itemdoc;
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "dmtab-win",
            position: "center",
            head: "Gửi chứng từ cho khách hàng qua email",
            fullscreen: true,
            //height: 700,
            //width: 1000,
            keepViews: true,
            move: true,
            body: {
                paddingY: 5,
                paddingX: 5,
                view: "form",
                id: "dmtab-form",
                // on: {
                // 	onItemClick: function (id) {
                // 		if (id == "his_email") {
                // 			var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
                // 			detailForm.show();
                // 		}
                // 	}
                // },
                elements: [
                    {
                        view: "fieldset",
                        label: "Thông tin gửi mail",
                        body: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            name: "nguoi_gui",
                                            label: _("NGUOI_GUI"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Người gửi không được để trống !",
                                        },
                                        {
                                            view: "text",
                                            name: "alias",
                                            label: _("Bí Danh"),
                                            labelPosition: "top",
                                            // required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Tên hiển thị không được để trống !",
                                        },
                                        {
                                            view: "text",
                                            name: "mat_khau",
                                            label: _("PASSWORD"),
                                            type: "password",
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Mật khẩu không được để trống !",
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        // {
                                        // 	view: "text",
                                        // 	name: "nguoinhan",
                                        // 	id: "nguoinhan",
                                        // 	label: _("NGUOI_NHAN"),
                                        // 	labelPosition: "top",
                                        // 	required: true,
                                        // 	validate: webix.rules.isNotEmpty,
                                        // 	invalidMessage: "Người nhận không được để trống !"
                                        // },
                                        {
                                            view: "multicombo",
                                            name: "nguoinhan",
                                            id: "nguoinhan",
                                            label: _("NGUOI_NHAN"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Người nhận không được để trống !",
                                            newValues: true,
                                            separator: ";",
                                            suggest: {
                                                selectAll: true,

                                                body: {
                                                    id: "nguoinhan_suggest",
                                                    //data: [{"id":"hungkq@minvoice.vn","value":"hungkq@minvoice.vn"},{"id":"khieuhung.kt@gmail.com","value":"khieuhung.kt@gmail.com"},{"id":"abc@gmail.com","value":"abc@gmail.com"},{"id":"xyz@gmail.com","value":"xyz@gmail.com"}]
                                                    //url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00050",
                                                    //template: webix.template("#value#")
                                                },
                                            },
                                        },
                                        {
                                            view: "text",
                                            name: "bcc",
                                            label: "BCC",
                                            labelPosition: "top",
                                        },
                                    ],
                                },
                                {
                                    view: "text",
                                    name: "tieude",
                                    label: _("TIEU_DE"),
                                    labelPosition: "top",
                                },
                            ],
                        },
                    },
                    {
                        view: "label",
                        name: "his_email",
                        id: "his_email",
                        //label: "Hóa đơn đã được gửi đi 5 lần",
                        template: function (obj) {
                            if (obj.value == 0) return "<span style='color:blue'>Chứng từ chưa gửi cho khách hàng !</span>";
                            return (
                                "<span style='color:blue'>Chứng từ đã được gửi <big>" +
                                obj.value +
                                "</big> lần !<sub style='color:red'> Lịch sử gửi email <i class='fa fa-hand-o-left' aria-hidden='true'></i></sub></span>"
                            );
                        },
                        on: {
                            onItemClick: function () {
                                var inv_invoiceauth_id = "";
                                var table = webix.$$("windowData");
                                if (table === undefined || table === null) {
                                    table = webix.$$("invoiceViews");
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.hdon_id;
                                } else {
                                    item = table.getSelectedItem();
                                    inv_invoiceauth_id = item.inv_invoiceauth_id;
                                }

                                var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
                                his_email.initUI(inv_invoiceauth_id);
                                detailForm.show();
                            },
                        },
                    },
                    {
                        name: "noidung",
                        view: "ckeditor",
                        keepViews: true,
                        label: _("NOI_DUNG"),
                        labelPosition: "top",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Gửi (F10)",
                                type: "form",
                                align: "center",
                                width: 120,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("dmtab-form");
                                        var item = form.getValues();
                                        var url = app.config.host + "/Invoice/SendInvoiceByEmail";
                                        console.log(itemdoc);
                                        if (itemdoc.hdon68 == 1) {
                                            url = app.config.host + "/Invoice68/SendInvoiceByEmail";
                                        }

                                        if ($$("dmtab-form").validate()) {
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            webix
                                                .ajax()
                                                .headers({ "Content-type": "application/json" })
                                                .post(url, item, function (text) {
                                                    var form = webix.$$("dmtab-form");

                                                    form.enable();
                                                    form.hideProgress();

                                                    var data = JSON.parse(text);

                                                    if (!data.hasOwnProperty("error")) {
                                                        webix.message("Gửi Email thành công !", "debug");

                                                        var item = form.getValues();
                                                        var topParentView = form.getTopParentView();

                                                        if (topParentView.config.tableId != undefined) {
                                                            var table = $$(topParentView.config.tableId);

                                                            var item = table.getSelectedItem();
                                                            item.trang_thai = "Chờ người mua ký";
                                                            table.updateItem(item.id, item);
                                                        }

                                                        webix.$$("dmtab-win").close();
                                                    } else {
                                                        webix.message(data.error);
                                                    }
                                                });
                                        } else {
                                            $$("nguoinhan").focus();
                                        }
                                    },
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                },
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                type: "danger",
                                align: "center",
                                width: 120,
                                click: function () {
                                    webix.$$("dmtab-win").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (values) {
            itemdoc = values;
            $$("dmtab-form").setValues(values);
            // var k = [{ "id": "hungkq@minvoice.vn", "value": "hungkq@minvoice.vn" }, { "id": "khieuhung.kt@gmail.com", "value": "khieuhung.kt@gmail.com" }, { "id": "abc@gmail.com", "value": "abc@gmail.com" }, { "id": "xyz@gmail.com", "value": "xyz@gmail.com" }];
            // $$("nguoinhan_suggest").define("data", k);
            if (values.nguoinhan != null && values.nguoinhan != "") {
                var k = [{ id: values.nguoinhan, value: values.nguoinhan }];
                $$("nguoinhan_suggest").define("data", k);
            }
            if (values.hasOwnProperty("lst_email")) {
                $$("nguoinhan_suggest").define("data", values.lst_email);
            }

            // $$("dmtab-form").setValues(values);
        },
    };
});

define('views/forms/templatewindow',[
	"app",
	"locale",
	"models/user",
	"views/forms/editwindow",
	"views/forms/selectwindow"
],function(app,_,user,editwindow,selectwindow){
	var editmode = 0;	
    var tables = [];

	var windowno = app.path[1].params[0];
    var col=[];
	var rw =[];					
	var el = [];
	var head_name=[];
	var head;
	var url = app.config.host + "/api/System/GetAllByWindowNo?window_id=" + windowno;
		    
	return {		
		$ui:{
			view:"window", modal:true, id:"window-win", position:"center",
			//width:800,
			head:"Thông tin khách hàng",
			//fullscreen:true,			
			body:{
                paddingY:10, 
                paddingX:10, 
                view:"form", 
				id:"window-form", 
				complexData:true,
				margin:0,
				borderless:true,
                elements:el				
			}			
		},	
		initUI: function(windowconfig) {
			
			var rp = windowconfig;
			var rows_max = rp['data'][0]['rows_max'];
			var vc_window = rp["data"][0];
			var tabs = vc_window.Tabs;

			var win = $$(vc_window.window_id);

			if (typeof win.showProgress === "undefined")
				webix.extend(win, webix.ProgressBar);
			
			el = [];
			col = [] ;			

			if (vc_window.width==null && vc_window.height==null){
				win.config.fullscreen = true;				
			}

			if (vc_window.after_save!=null){
				win.config.after_save = vc_window.after_save;
			}

			var layoutdetail = vc_window.layoutdetail;
			webix.ui(JSON.parse(layoutdetail),$$("window-form"));

			var fields = rp['data'][0]['Tabs'][0]['Fields'];

			for(var i=0;i<fields.length;i++){
				
				var field = fields[i];				
				
				if (field.hidden == true){
					continue;
				}

				var row = field.row;

				var item = {
					view: field.type_editor, 
					name: field.column_name,
					label: _(field.column_name), 
					id: field.column_name+"_"+rp['data'][0]['Tabs'][0]["tab_table"],
					width: field.width,
					labelPosition: field.label_position,
					labelWidth: field.label_width,
					format: field.format,
					value_change: field.value_change,
					fieldExpression: field.field_expression,
					data_width: field.data_width,
					column_type: field.column_type,
					on:{
						
					}
				};

				if (field.height!=null){
					if (field.height!=0){
						item.height = field.height;
					}
				}

				if (field.caption!=null){
					item.label = _(field.caption);
				}				

				if (field.read_only == "C"){
					item.readonly = true;
				}
				
				if (item.view == "combo"){
					item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
				}						

				if (item.view == "checkbox"){
					if (field.label_position == "right"){
						item.labelRight = _(field.column_name) ;
						item.label = "";							
					}

					if (field.column_type == "char"){
						item.checkValue = "C";
						item.uncheckValue = "K";
					}

					if (field.column_type == "tinyint"){
						item.checkValue = "1";
						item.uncheckValue = "0";
					}
				}

				if (item.view == "autonumeric"){
					item.inputAlign ="right";
				}

				if (item.view == "treesuggest"){
					
					//item.REF_ID = field.REF_ID.toString();
					var listColumns = JSON.parse(field.list_column);

					for(var v=0;v<listColumns.length;v++){
						listColumns[v].header =_(listColumns[v].id);
					}
					
					item.view = "combo";
					item.options = {
						view: "treesuggest",
						textValue: field.display_field,
						url: {
							$proxy:true,
							load:function(view, callback, params){
									var url = app.config.host + "/api/System/GetDataByReferencesId?id=" + view.config.refid;

									webix.ajax(url, function(text){
										var json = JSON.parse(text);
										var data = listToTree(json);
										view.parse(data,"json");
									});
									
							}
						},
						body: {
							columns: listColumns,
							refid: field.ref_id,
							filterMode:{
								level:false,
								showSubItems:false
							}						
						}
					};

					item.on.onKeyPress = function(code, e){
						if (e.code == "F4"){
							alert("Moi");
						}
					};
				}

				if (item.view == "gridcombo"){
					
					var listColumns = JSON.parse(field.list_column);

					for(var v=0;v<listColumns.length;v++){
						listColumns[v].header =_(listColumns[v].id);
					}
					
					item.view = "combo";
					item.options = {
						view: "gridsuggest",
						url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
						body: {
							columns: listColumns,
							refid: field.REF_ID,
							textValue: field.display_field											
						}
					};

					item.on.onKeyPress = function(code, e){
						if (e.code == "F4"){
							alert("Moi");
						}
					};
				}

				if (item.view == "gridsuggest"){
					var listColumns = JSON.parse(field.list_column);

					for(var v=0;v<listColumns.length;v++){
						listColumns[v].header =_(listColumns[v].id);
					}

					item.view = "text";
					item.suggest = {
						view: "gridsuggest",
						value_suggest: field.value_suggest,
						body:{
							columns:listColumns,
							refid: field.ref_id,
							datatype:"json",
							dataFeed: function(filtervalue, filter){
								if(filtervalue.length<3) return;

								var refid = this.config.refid;
								var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
								var urldata = "filtervalue="+encodeURIComponent(filtervalue);
								
								this.load(pathUrl+"&"+urldata, this.config.datatype);
							},
							
						},
						on: {
							onValueSuggest: function(obj){
								var master = $$(this.config.master);

								if (master.config.fieldExpression!=null){
									
									var win = master.getTopParentView();
									var form = win.getChildViews()[1];
									var parentItem = form.getValues();

									var fields = master.config.fieldExpression.split(';');

									for(var i=0;i<fields.length;i++){
										var field = fields[i].replace("{","").replace("}","");
										var array = field.split(":");

										parentItem[array[1]] = obj[array[0]];
									}

									form.setValues(parentItem);
								}

								if (this.config.value_suggest!=null){								
									var fn = Function("obj","id",this.config.value_suggest);
									fn(obj,this.config.id);
								}
							}							
						}
					};

					item.on.onKeyPress = function(code, e){
						if (e.code == "F2"){
							var suggest = $$(this.config.suggest);
							var refid = suggest.config.body.refid;

							suggest.hide();

							var sql = "SELECT a.*,b.window_id as WINDOWNO FROM wb_references a INNER JOIN wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='"+refid +"'";
							var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;

							var win = this.getTopParentView();
							var form = win.getChildViews()[1];

							var editorId = this.config.id;
							var formId = form.config.id;
							
							var a= webix.ajax(url);
							var b= this.config.suggest;
							var c = this.config.id;
							var d = this.config.fieldExpression;
							var e = editorId;
							var f = formId;
							

							webix.promise.all([a,b,c,d,e,f]).then(function(results){
								var res_a = results[0].json();
								var suggest = $$(results[1]);								

								suggest.hide();

								var url = app.config.host + "/System/GetConfigWinByNo?id="+ res_a[0]["WINDOWNO"] ;

								var ajax = webix.ajax();
								ajax.master = {
									searchId : results[2],
									fieldExpression: d,
									valueField: res_a[0]["value_field"],
									formId: f,
									editorId:e
								};

								ajax.get(url,function(text){
									var windowconfig = JSON.parse(text);
									var txtSearch = $$(this.searchId);

									var win = txtSearch.$scope.ui(selectwindow.$ui);
									
									win.config.valueField = this.valueField;
									win.config.fieldExpression = this.fieldExpression;
									win.config.formId = this.formId;
									win.config.editorId = this.editorId;

									selectwindow.initUI(windowconfig);

									win.getHead().setHTML(windowconfig.data[0].window_name);
									win.show();

								});


							});


							var win = this.$scope.ui(selectwindow.$ui);
							win.show();							
						}

						if (e.code == "F4" || e.code == "F3"){
							var suggest = $$(this.config.suggest);
							var refid = suggest.config.body.refid;

							var sql = "SELECT a.*,b.window_id as WINDOWNO FROM wb_references a INNER JOIN wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='"+refid +"'";
							var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;

							var win = this.getTopParentView();
							var form = win.getChildViews()[1];

							var editorId = this.config.id;
							var formId = form.config.id;

							var ajax = webix.ajax();
							
							ajax.master = {
								editorId: editorId,
								formId: formId,
								fieldExpression: this.config.fieldExpression,
								editmode: e.code == "F3" ? 2 : 1,
								editorvalue: this.getValue(),
								suggest: this.config.suggest
							};							

							ajax.get(url,function(text){
								var json = JSON.parse(text);
								
								if (json.length>0){

									json[0].editorId = this.editorId;
									json[0].formId = this.formId;
									json[0].fieldExpression = this.fieldExpression;
									json[0].editmode = this.editmode;
									json[0].editorvalue = this.editorvalue;
									json[0].suggest = this.suggest;

									var windowno = json[0].WINDOWNO;					

									var url = app.config.host + "/api/System/GetAllByWindowNo?window_id="+windowno ;
									var a = webix.ajax(url);
									url = app.config.host +"/api/System/GetDataByReferences?id="+json[0].id+"&value_field=" + this.editorvalue;
									var b = webix.ajax(url);
									var c= this.editmode;
									var d = json[0];

									webix.promise.all([a,b,c,d]).then(function(results){
										
										var windowconfig = results[0].json();
										var res_b = results[1].json();
										var mode = results[2];
										var master = results[3];

										var vc_window = windowconfig["data"][0];

										if (mode == 1){
											editwindow.$ui.id = vc_window.window_id;
											editwindow.$ui.editorId = master.editorId;
											editwindow.$ui.valueField = master.value_field;
											editwindow.$ui.fieldExpression = master.fieldExpression;
											editwindow.$ui.formId = master.formId;

											var win = webix.ui(editwindow.$ui);            
											
											editwindow.initUI(windowconfig);
											editwindow.setEditMode(mode);
											editwindow.setValues(null,windowconfig);
											
											$$(master.suggest).hide();
											win.show();
										}
										else {

											if (res_b.length == 0){
												webix.alert({
													title: "Thông báo",
													text: "Không tìm thấy dữ liệu"
												});

												return;
											}

											var ajax = webix.ajax();
											
											ajax.master = {
												master: master,
												vc_window: vc_window												
											};

											var url = app.config.host + "/api/System/GetDataById?window_id="+ vc_window.window_id + "&id="+res_b[0].doc_id;

											ajax.get(url,function(text){
												var json = JSON.parse(text);
												var data = json.data[0];

												var vc_window = this.vc_window;
												var master = this.master;

												editwindow.$ui.id = vc_window.window_id;
												editwindow.$ui.editorId = master.editorId;
												editwindow.$ui.valueField = master.value_field;
												editwindow.$ui.fieldExpression = master.fieldExpression;
												editwindow.$ui.formId = master.formId;

												var win = webix.ui(editwindow.$ui);            
												
												editwindow.initUI(windowconfig);
												editwindow.setEditMode(2);
												editwindow.setValues(data,windowconfig);
												
												$$(master.suggest).hide();
												win.show();

											});
										}
									});									
								}
							});

							
						}
					};
				}

				if (item.value_change!=null || field.column_type == "nvarchar" || field.column_type == "varchar" || field.column_type == "char"){
					item.on.onChange = function(newv,oldv){
							var data_width = this.config.data_width;

							if (data_width< newv.length){
								webix.message("Số lượng ký tự tối đa là " + data_width.toString());
								return;
							}

							if (this.config.value_change!=null){
								
								
								var fn = Function("newv","oldv","id",this.config.value_change);
								fn(newv,oldv,this.config.id);
							}
						}
				}
				
				webix.ui(item,$$(item.id));
				//el[row-1].cols.push(item);
								
			}

			if (vc_window.window_type == "MasterDetail"){

				var cells = [];

                for(var i=0;i<tabs.length;i++){
                    var tab = tabs[i];

                    if (tab.TAB_TYPE == "Master"){
                        continue;
                    }

                    var subCols = [];

                    for(var j=0;j<tab.Fields.length;j++){
                        var field = tab.Fields[j];

                        var subCol = {
                            id: field.column_name, 
							header: field.caption!=null ? _(field.caption) : _(field.column_name),
							editor: field.type_editor,
							hidden: field.hidden,
							value_change: field.value_change
						};
						

                        if (field.column_type == "date" || field.column_type == "datetime" ){
                            subCol.format = function(text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);                            
                                return format(text);
                            };
						}

						if (field.column_type == "decimal"){
							subCol.css = { "text-align": "right" };
							subCol.format = webix.Number.numToStr({
												groupDelimiter:",",
												groupSize:3,
												decimalDelimiter:".",
												decimalSize:0
											});
						}
						
						
                        
                        if (field.column_width == null){
                            subCol.fillspace = true;
                        }
                        else {
                            subCol.width = field.column_width;
						}

						if (field.type_editor == "combo"){
							subCol.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id
						}

						if (field.type_editor == "datepicker"){
							subCol.editor = "date";
						}
						
						if (field.type_editor == "treesuggest"){
							var listColumns = JSON.parse(field.list_column);

							for(var v=0;v<listColumns.length;v++){
								listColumns[v].header =_(listColumns[v].id);
							}
							
							var popup = webix.ui({
								view:"treesuggest",								
								body:{
									columns: listColumns,
									refid: field.ref_id,
									url: {
										$proxy:true,
										load:function(view, callback, params){
												var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

												webix.ajax(url, function(text){
													var json = JSON.parse(text);
													var data = listToTree(json);
													view.parse(data,"json");
												});
												
										}
									},
									filterMode:{
										level:false,
										showSubItems:false
									}	
								}
							});											

							subCol.popup = popup;
							subCol.editor = "combo";
							
						}

						if (field.type_editor == "gridcombo"){
							var listColumns = JSON.parse(field.list_column);

							for(var v=0;v<listColumns.length;v++){
								listColumns[v].header =_(listColumns[v].id);
							}
							
							var popup = webix.ui({
								view:"gridsuggest",	
								textValue: field.display_field,
								body:{
									columns: listColumns,
									refid: field.ref_id,
									textValue: field.display_field,
									tableId: "edit_"+tab.tab_table,
									url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id								
								}
							});											

							subCol.popup = popup;
							subCol.editor = "combo";
							
							
						}

						if (field.type_editor == "gridsuggest"){
							var listColumns = JSON.parse(field.list_column);

							for(var v=0;v<listColumns.length;v++){
								listColumns[v].header =_(listColumns[v].id.toUpperCase());
							}

							subCol.editor = "text";
							subCol.suggest = {
								view: "gridsuggest",
								value_suggest: field.value_suggest,
								fieldExpression: field.field_expression,
								displayField: field.display_field,
								tableId: "edit_"+tab.tab_table,
								columnName:field.column_name,
								body:{
									columns:listColumns,
									refid: field.ref_id,									
									datatype:"json",
									dataFeed: function(filtervalue, filter){
										if(filtervalue.length<3) return;

										var refid = this.config.refid;
										var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
										var urldata = "filtervalue="+encodeURIComponent(filtervalue);
										
										this.load(pathUrl+"&"+urldata, this.config.datatype);
									}
								},
								on: {
									onValueSuggest: function(obj){
										
										if (this.config.fieldExpression!=null){
											var table = $$(this.config.tableId);
											var selectedItem = table.getSelectedItem();

											var fields = this.config.fieldExpression.split(';');

											for(var i=0;i<fields.length;i++){
												var field = fields[i].replace("{","").replace("}","");
												var array = field.split(":");

												selectedItem[array[1]] = obj[array[0]];
											}

											table.updateItem(selectedItem.id,selectedItem);
										}

										if (this.config.value_suggest!=null){								
											var fn = Function("obj","id",this.config.value_suggest);
											fn(obj,this.config.id);
										}
									}
									
								}
							}

							
						}
                        
                        subCols.push(subCol);
                    }

                    if (tab.tab_type=="Detail"){
                        var item = {
                            header: tab.tab_name,
                            select: "cell",
                            body: {
								rows:[
									{
										view:"toolbar",
										height:25,
										cols:[
											{
												view:"icon",
												icon:"plus",
												on: {
													onItemClick: function(id,e){
														var parentView = this.getParentView().getParentView();
														var childViews = parentView.getChildViews();

														for(var i=0;i<childViews.length;i++){
															var childview = childViews[i];

															if (childview.config.view=="datatable"){
																var table = childview;

																var item = {
																	id: webix.uid()
																};

																var vc_window = windowconfig['data'][0];																
																var tabs = vc_window.Tabs;															

																for(var i=0;i<tabs.length;i++){
																	var tab = tabs[i];
																	if (tab.tab_type == "Detail"){
																		var fields=tab.Fields;

																		for(var j=0;j<fields.length;j++){
																			var field = fields[j];

																			if (field.column_name == "ma_dvcs"){
																				item[field.column_name] = user.getDvcsID();
																			}																			
																			
																			if (field.default_value!=null){
																				var defaultValue = field.default_value.toString();

																				if (defaultValue.startsWith("@Default=")){
																					item[field.column_name] = defaultValue.replace("@Default=","");
																				}
																				
																				if (defaultValue.startsWith("@JS=")){
																					var fn = Function(defaultValue.replace("@JS=",""));
																					item[field.column_name] = fn();
																				}
																			}
																		}
																	}
																}								
																

																table.add(item);

																table.select(item.id, table.config.columns[0].id, false);
																table.edit({row: item.id, column: table.config.columns[0].id});

																break;
															}
														}
														
													}
												}
											},
											{
												view:"icon",
												icon:"minus",
												on: {
													onItemClick: function(id,e){
														var parentView = this.getParentView().getParentView();
														var childViews = parentView.getChildViews();

														for(var i=0;i<childViews.length;i++){
															var childview = childViews[i];

															if (childview.config.view=="datatable"){
																var table = childview;

																table.editStop();

																var item = table.getSelectedItem();
												
																if (!webix.isUndefined(item)){
																	table.remove(item.id);
																	table.clearSelection();
																	return;
																}

																var editor = table.getEditState();

																if (!webix.isUndefined(editor)){
																	table.remove(editor.row);
																	table.clearSelection();
																	return;
																}

																break;
															}
														}
														
													}
												}
											}
										]
									},
									{
										view: "datatable",
										id:"edit_"+tab.tab_table,
										tab_table: tab.tab_table,
										tab_id: tab.tab_id,
										editable:true,
										select: "cell",
										select_change: tab.select_change,
										cell_editstop: tab.cell_editstop,
										columns: subCols,
										on:{
											onAfterEditStop:function(state, editor, ignore){
												
												if (this.config.cell_editstop!=null){
													var fn = Function("columnId","tableId",this.config.cell_editstop);
													fn(editor.config.id,this.config.id);
												}

												if (editor.config.value_change!=null){
													var selectedItem = null;

													if (typeof editor.getPopup === "function") { 
														var popup = editor.getPopup();
													
														if (popup!=null){
															var list = popup.getList();

															if (list!=null){
																selectedItem = list.getSelectedItem();
															}
														}
													}
													
													var fn = Function("newv","oldv","id","selectedItem",editor.config.value_change);
													fn(state.value,state.old,editor.config.id,selectedItem);
												}

											},
											onKeyPress: function(code,e){
												var table = this;

												if (e.key == "F8"){
													var toolbar = this.getParentView().getChildViews()[0];
													var btnMinus = toolbar.getChildViews()[1];

													btnMinus.callEvent("onItemClick");
												}

												if (e.key == "F2"){

													var editor = table.getEditState();

													if (editor === false) return;

													var suggest = $$(editor.config.suggest);
													var refid = suggest.config.body.refid;

													var sql = "SELECT a.*,b.window_id as WINDOWNO FROM wb_references a INNER JOIN wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='"+refid +"'";
													var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;

													var a= webix.ajax(url);
													var b= editor.config.suggest;
													var c = table.config.id;
													var d = suggest.config.fieldExpression;
													var e = editor.config.id;
													var f = suggest.config.displayField;
													
													webix.promise.all([a,b,c,d,e,f]).then(function(results){
														var res_a = results[0].json();
														var suggest = $$(results[1]);								

														suggest.hide();

														var url = app.config.host + "/System/GetConfigWinByNo?id="+ res_a[0]["WINDOWNO"] ;

														var ajax = webix.ajax();
														ajax.master = {
															tableId : results[2],
															fieldExpression: d,
															valueField: res_a[0]["value_field"],
															editorId:null,
															columnName: e,
															displayField:f
														};

														ajax.get(url,function(text){
															var windowconfig = JSON.parse(text);
															var table = $$(this.tableId);

															var win = table.$scope.ui(selectwindow.$ui);
															
															win.config.valueField = this.valueField;
															win.config.fieldExpression = this.fieldExpression;
															win.config.tableId = this.tableId;
															win.config.editorId = null;
															win.config.columnName = this.columnName;
															win.config.displayField = this.displayField;

															selectwindow.initUI(windowconfig);
															
															win.getHead().setHTML(windowconfig.data[0].window_name);
															win.show();

														});


													});


													var win = this.$scope.ui(selectwindow.$ui);
													win.show();
												}

												if (e.key == "F4" || e.key == "F3"){
													var editor = table.getEditState();

													if (editor === false){
														var toolbar = this.getParentView().getChildViews()[0];
														var btnPlus = toolbar.getChildViews()[0];

														btnPlus.callEvent("onItemClick");

													}

													if (!webix.isUndefined(editor)){
														var suggest = $$(editor.config.suggest);
														var refid = suggest.config.body.refid;

														var sql = "SELECT a.*,b.WINDOW_ID as WINDOWNO FROM VC_REFERENCES a INNER JOIN VC_WINDOW b ON a.WINDOW_ID=b.id  WHERE a.id='"+refid +"'";
														var url = app.config.host + "/api/System/ExecuteQuery?sql=" + sql;

														var tableId = table.config.id;
														var columnName = editor.config.id;

														var ajax = webix.ajax();
														
														ajax.master = {
															editorId: null,
															tableId: tableId,
															fieldExpression: suggest.config.fieldExpression,
															columnName: columnName,
															editmode: e.key == "F3" ? 2 : 1,
															editorvalue: editor.getValue(),
															suggest: editor.config.suggest
														};

														ajax.get(url,function(text){
															var json = JSON.parse(text);
															
															if (json.length>0){

																json[0].editorId = this.editorId;
																json[0].tableId = this.tableId;
																json[0].fieldExpression = this.fieldExpression;
																json[0].columnName = this.columnName;
																json[0].editmode = this.editmode;
																json[0].editorvalue = this.editorvalue;
																json[0].suggest = this.suggest;

																var windowno = json[0].WINDOWNO;															

																var url = app.config.host + "/api/System/GetAllByWindowNo?window_id="+windowno ;
																var a = webix.ajax(url);
																url = app.config.host +"/api/System/GetDataByReferences?id="+json[0].id+"&value_field=" + this.editorvalue;
																var b = webix.ajax(url);
																var c= this.editmode;
																var d = json[0];

																webix.promise.all([a,b,c,d]).then(function(results){
										
																	var windowconfig = results[0].json();
																	var res_b = results[1].json();
																	var mode = results[2];
																	var master = results[3];

																	var vc_window = windowconfig["data"][0];

																	if (mode == 1){
																		editwindow.$ui.id = vc_window.window_id;
																		editwindow.$ui.editorId = master.editorId;
																		editwindow.$ui.valueField = master.value_field;
																		editwindow.$ui.fieldExpression = master.fieldExpression;
																		editwindow.$ui.formId = master.formId;
																		editwindow.$ui.tableId = master.tableId;
																		editwindow.$ui.columnName = master.columnName;

																		var win = webix.ui(editwindow.$ui);            
																		
																		editwindow.initUI(windowconfig);
																		editwindow.setEditMode(mode);
																		editwindow.setValues(null,windowconfig);
																		
																		$$(master.suggest).hide();
																		win.show();
																	}
																	else {
																		if (res_b.length == 0){
																			webix.alert({
																				title: "Thông báo",
																				text: "Không tìm thấy dữ liệu"
																			});

																			return;
																		}
																		var ajax = webix.ajax();
																		
																		ajax.master = {
																			master: master,
																			vc_window: vc_window												
																		};

																		var url = app.config.host + "/api/System/GetDataById?window_id="+ vc_window.window_id + "&id="+res_b[0].doc_id;

																		ajax.get(url,function(text){
																			var json = JSON.parse(text);
																			var data = json.data[0];

																			var vc_window = this.vc_window;
																			var master = this.master;

																			editwindow.$ui.id = vc_window.window_id;
																			editwindow.$ui.editorId = master.editorId;
																			editwindow.$ui.valueField = master.value_field;
																			editwindow.$ui.fieldExpression = master.fieldExpression;
																			editwindow.$ui.formId = master.formId;
																			editwindow.$ui.tableId = master.tableId;
																			editwindow.$ui.columnName = master.columnName;

																			var win = webix.ui(editwindow.$ui);            
																			
																			editwindow.initUI(windowconfig);
																			editwindow.setEditMode(2);
																			editwindow.setValues(data,windowconfig);
																			
																			$$(master.suggest).hide();
																			win.show();

																		});
																	}
																});																
															}
														});

														return;
													}
													
												}
											},
											onSelectChange:function(){
												var selectedItem = this.getSelectedId();
												
												if (this.config.select_change!=null){
													var fn = Function("selectedItem",this.config.select_change);
													fn(selectedItem);
												}
											}
										}
									}
								]
                                
                            }
                        };

                        cells.push(item);
                    }
				}
				
                var subview = {
                    borderless:true,
                    view:"tabview",
                    scrollX:true,
					cells: cells,
					tabbar:{
						width:200
					}					
				};

				if (vc_window.width!=null || vc_window.height!=null){
					subview.height = 250;
				}

				//el.push(subview);
				
				if (vc_window.row_tab!=null){
					el[vc_window.row_tab-1]=subview;
				}
				else {
					el.push(subview);
				}
				
            }
			
			var cols = [
				{},
				{ 
					shortcut:"F10",  
					view:"button", label:"Nhận", type:"form", align:"center", 
					width:100,
					on: {
						onClick: function() {
							var form = webix.$$("window-form");
							
							var item = form.getValues();
							
							var khData={};

							khData.windowid=String(rp['data'][0]['window_id']);
							khData.editmode=editmode;
							khData.data=[];

							var vc_window = rp['data'][0];

							if (vc_window.window_type == "MasterDetail"){
								
								var tabs = vc_window.Tabs;
								var details = [];

								for(var i=0;i<tabs.length;i++){
									var tab = tabs[i];

									if (tab.tab_type == "Detail"){
										var table = webix.$$("edit_"+tab.tab_table);
										
										details.push({
											tab_id: tab.tab_id,
											tab_table: tab.tab_table,
											data: table.serialize()
										});
									}
								}

								item["details"] = details;
							}							
							
							khData.data.push(item);
							
							this.getTopParentView().disable();
							this.getTopParentView().showProgress();
							
							webix.ajax()
								.headers({'Content-type':'application/json'})
								.post( app.config.host + "/System/Save", khData, function(text){									
							
									var json = JSON.parse(text);

									$$(json.windowid).enable();
									$$(json.windowid).hideProgress();
												
									if (!json.hasOwnProperty("error")){
										var after_save = $$(json.windowid).config.after_save;

										if (after_save!=null){
											var fn = Function("editmode","data",after_save);
											fn(editmode,json.data);
										}										

										$$(json.windowid).close();
										app.callEvent("dataChanged",[editmode,json.data]);
									}
									else {
										webix.message(json.error);
									}
									
									
								});	
							
						}
					},
					click:function(){								
						this.callEvent("onClick");							
											
					},
				},
				{ 
					view:"button", shortcut:"esc", label:"Hủy bỏ",align:"center",
					width:100,
					on:{
						onClick: function(){
							this.getTopParentView().close();
						}
					},
					click:function(){
						this.callEvent("onClick");
					}
				},
				{}
			];			
			
			/* el.push({
				margin:10,
				cols:cols
			}); */

			$$("window-form").addView({margin:10,cols:cols},$$("window-form").getChildViews().length);
			$$("window-form").$view.style.borderWidth = 0;
			//webix.ui(el, $$("window-form"));

			win.getHead().setHTML(windowconfig.data[0].window_name);
		},
		focusFirstElement:function(){
			var form = $$("window-form");
			form.focus(form.elements[0]);
		},	
		setEditMode: function(mode) {
			editmode = mode;
		},		
		setValues: function(item,winconfig,params){

			var form = webix.$$("window-form");
			var vc_window = winconfig['data'][0];

			if (item == null){
				var tabs = vc_window.Tabs;
				
				item = {};

				if (params!=null){
					item = params;
				}

                for(var i=0;i<tabs.length;i++){
                    var tab = tabs[i];
                    if (tab.tab_type == "Normal" || tab.tab_type == "Master"){
                        var fields=tab.Fields;

                        for(var j=0;j<fields.length;j++){
							var field = fields[j];
							
							if (field.column_name == "ma_dvcs"){
								item[field.column_name] = user.getDvcsID();
							}

							                            
                            if (field.default_value!=null){
                                var defaultValue = field.default_value.toString();

                                if (defaultValue.startsWith("@Default=")){
                                    item[field.column_name] = defaultValue.replace("@Default=","");
								}
								
								if (defaultValue.startsWith("@JS=")){
									var fn = Function(defaultValue.replace("@JS=",""));
									item[field.column_name] = fn();
								}
                            }
                        }
                    }
				}
				
				form.setValues(item);
			}
			else {

				form.setValues(item);	
				
				var tabs = vc_window.Tabs;

				for(var i=0;i<tabs.length;i++){
					var tab = tabs[i];

					if (tab.tab_type != "Detail")
					{
						var fields=tab.Fields;

						for(var j=0;j<fields.length;j++){
							var field = fields[j];
							
							if (field.column_type == "date" || field.column_type == "datetime"){
								item[field.column_name] = removeTimeZoneT(item[field.column_name])
								form.setValues(item);
							}														
							
						}							

						break;
					}				
					
				}

				if (vc_window.window_type == "MasterDetail"){
					

					for(var i=0;i<tabs.length;i++){
						var tab = tabs[i];

						if (tab.tab_type == "Master")
						{
							continue;
						}

						var table = webix.$$("edit_"+tab.tab_table);

						var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id="+ vc_window.window_id
										+"&id="+item.id + "&tab_table="+tab.tab_table;
						table.clearAll();
						table.load(url);
						
					}
				}
				
			}
		},
		copyValues: function(item,winconfig){

			var form = webix.$$("window-form");
			var vc_window = winconfig['data'][0];
							

			if (vc_window.window_type == "MasterDetail"){
				var tabs = vc_window.Tabs;

				for(var i=0;i<tabs.length;i++){
					var tab = tabs[i];

					if (tab.tab_type == "Master")
					{
						continue;
					}

					var table = webix.$$("edit_"+tab.tab_table);

					var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id="+ vc_window.window_id
									+"&id="+item.id + "&tab_table="+tab.tab_table;
					table.clearAll();
					table.load(url);
					
				}
			}

			var tabs = vc_window.Tabs;

			for(var i=0;i<tabs.length;i++){
				var tab = tabs[i];
				if (tab.tab_type == "Normal" || tab.tab_type == "Master"){
					var fields=tab.Fields;

					for(var j=0;j<fields.length;j++){
						var field = fields[j];

						if (field.column_name == tab.tab_table + "_id"){
							item[field.column_name] = null;
						}
						
						if (field.column_name == "ma_dvcs"){
							item[field.column_name] = user.getDvcsID();
						}

													
						if (field.default_value!=null){
							var defaultValue = field.default_value.toString();

							if (defaultValue.startsWith("@Default=")){
								item[field.column_name] = defaultValue.replace("@Default=","");
							}
							
							if (defaultValue.startsWith("@JS=")){
								var fn = Function(defaultValue.replace("@JS=",""));
								item[field.column_name] = fn();
							}
						}
					}
				}
			}

			form.setValues(item);
			
		}

	};

});
define('views/forms/tinhhinhsudung',["app", "locale", "models/user"], function (app, _, user) {

    function initUI(item) {
        if (item.tokhai_thang == 1) {
            $$('kybc').setValue("Kỳ báo cáo: Tháng " + moment(item.tu_ngay).format("MM") + " năm " + moment(item.den_ngay).format("YYYY"));
        }
        if (item.tokhai_quy == 1) {
            $$('kybc').setValue("Kỳ báo cáo: Quý " + (Math.floor((item.tu_ngay.getMonth() / 3)) + 1) + " năm " + moment(item.den_ngay).format("YYYY"));
        }
        $$('tungay').setValue("( từ " + moment(item.tu_ngay).format("DD/MM/YYYY") + " đến " + moment(item.den_ngay).format("DD/MM/YYYY") + " )");
        $$('zmau312').setValue(item.mau_312);
        $$('zmau310').setValue(item.mau_310);
        $$('dataform').config.item = item;

        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(app.config.host + "/Bcthsd/Check_xulyHD", item, function (text) {
                var data = JSON.parse(text);

                if (!data.hasOwnProperty("error")) {
                    $$('tccanhan').setValue("[02] Tên tổ chức, cá nhân " + data.ten_dvcs);
                    $$('mst').setValue("[03] Mã số thuế " + data.ms_thue);
                }
                else {
                    webix.message(data.error, "error");
                }
            });

        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .get(app.config.host + "/Bcthsd/GetInfoDonvi", function (text) {
                var data = JSON.parse(text);
                //console.log(data);
                if (!data.hasOwnProperty("error")) {
                    $$('nguoi_dai_dien').setValue(data.nguoi_dai_dien);
                    $$('nguoi_lap').setValue(data.nguoi_lap);
                    // $$('mst').setValue("[03] Mã số thuế " + data.MS_THUE);
                }
                else {
                    webix.message(data.error, "error");
                }
            });

        // webix.ajax()
        //     .headers({ 'Content-type': 'application/json' })
        //     .get(app.config.host + "/System/ExecuteQuery?sql=SELECT * FROM dmdvcs", function (text) {
        //         var data = JSON.parse(text);
        //         if (!data.hasOwnProperty("error")) {
        //             $$('nguoi_dai_dien').setValue(data.nguoi_dai_dien);
        //             // $$('mst').setValue("[03] Mã số thuế " + data.MS_THUE);
        //         }
        //         else {
        //             webix.message(data.error, "error");
        //         }
        //     });

        webix.ajax()
            .headers({ "Conten-type": "application/json" })
            .get(app.config.host + "/Bcthsd/GetTenFile", function (text) {
                var data = JSON.parse(text);
                if (item.tokhai_thang == 1) {
                    var filename = data.name + "-T" + item.thang + item.nam + "-L00";
                    $$('tenfile').setValue(filename);
                    return;
                }
                if (item.tokhai_quy == 1) {
                    var filename = data.name + "-Q" + item.quy + item.nam + "-L00";
                    $$('tenfile').setValue(filename);
                    return;
                }

            })
    }

    return {
        $ui: {
            view: "window",
            fullscreen: true,
            modal: true, id: "thsd-win", position: "center",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                // height: 25,
                cols: [
                    { gravity: 1, template: "" },
                    {
                        view: "icon", icon: "times", hotkey: "esc", click: function () {
                            $$("thsd-win").close();
                        }
                    }
                ]
            },
            //height:420,		
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "thsd-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        rows: [
                            {
                                view: "label",
                                id: "dataform",
                                hidden: true
                            },
                            {
                                view: "label",
                                id: "tenfile",
                                hidden: true
                            },
                            {
                                view: "label",
                                label: "BÁO CÁO TÌNH HÌNH SỬ DỤNG HÓA ĐƠN (BC26/AC)",
                                css: { "font-weight": "bold", "font-size": "15px" },
                                inputWidth: 100,
                                align: "center"
                            },
                            {
                                view: "label",
                                id: "kybc",
                                name: "kybc",
                                label: "Kỳ báo cáo: Tháng ",
                                inputWidth: 100,
                                align: "center"

                            },
                            {
                                view: "label",
                                label: "Từ ngày: ",
                                id: "tungay",
                                inputWidth: 100,
                                align: "center"
                            },
                            {
                                view: "label",
                                label: "[02] Tên tổ chức, cá nhân ",
                                id: "tccanhan",
                                inputWidth: 100,
                                align: "left"
                            },
                            {
                                view: "label",
                                label: "[03] Mã số thuế ",
                                id: "mst",
                                inputWidth: 100,
                                align: "left"
                            },
                            {
                                cols: [
                                    {
                                        view: "checkbox",
                                        id: "zmau312",
                                        name: "zmau_312",
                                        label: "Mẫu 3.12 (Kỳ báo cáo cuối cùng)",
                                        labelWidth: 200
                                    },
                                    {
                                        view: "checkbox",
                                        id: "zmau310",
                                        name: "zmau_310",
                                        label: "Mẫu 3.10 (Chuyển địa điểm)",
                                        labelWidth: 200
                                    }
                                ]

                            },
                            {
                                id: "dataBC",
                                view: "datatable",
                                editable: true,
                                editaction: "dblclick",
                                select: true,
                                datafetch: 2,
                                loadahead: 15,
                                drag: true,
                                fixedRowHeight: false, rowLineHeight: 25, rowHeight: 25,
                                on: {
                                    onColumnResize: function () {
                                        this.adjustRowHeight("so1", true);
                                        this.render();
                                    }
                                },
                                columns: [
                                    { id: "stt", header: "<center>STT</center>", width: 50 },
                                    { id: "code", header: "<center>Mã loại hóa đơn</center>", width: 100 },
                                    { id: "name", header: "<center>Tên loại hóa đơn</center>", width: 160 },
                                    { id: "mau_hd", header: "<center>Mẫu hóa đơn</center>", width: 120 },
                                    { id: "ky_hieu", header: "<center>Ký hiệu</center>", width: 100 },
                                    {
                                        id: "ton_dau_ky", name: "namdaika", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "ton_dau",
                                                groupText: "Tổng số tồn đầu kỳ", colspan: 1
                                            },
                                            "Tổng số "], width: 150
                                    },
                                    {
                                        id: "tu_so1", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr1",
                                                groupText: "Số tồn đầu kỳ", colspan: 2
                                            },
                                            "Từ số"]
                                    },
                                    { id: "den_so1", batch: "gr1", header: [null, "Đến số"] },
                                    {
                                        id: "tu_so2", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr2",
                                                groupText: "Số mua/phát hành trong kỳ", colspan: 2
                                            },
                                            "Từ số"]
                                    },
                                    { id: "den_so2", batch: "gr2", header: [null, "Đến số"] },
                                    {
                                        id: "tu_so3", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr3",
                                                groupText: "Tổng số sử dụng, xóa bỏ, mất, hủy", colspan: 3
                                            },
                                            "Từ số"]
                                    },
                                    { id: "den_so3", batch: "gr3", header: [null, "Đến số"] },
                                    { id: "cong", batch: "gr3", header: [null, "Cộng"] },
                                    {
                                        id: "sl_sd", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr4",
                                                groupText: "Đã sử dụng", colspan: 1
                                            },
                                            "Số lượng"], width: 150
                                    },
                                    {
                                        id: "so_luong1", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr5",
                                                groupText: "Xóa bỏ", colspan: 2
                                            },
                                            "Số lượng"], width: 110
                                    },
                                    { id: "so1", batch: "gr5", header: [null, "Số"] },
                                    {
                                        id: "so_luong2", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr6",
                                                groupText: "Mất", colspan: 2
                                            },
                                            "Số lượng"], width: 110
                                    },
                                    { id: "so2", batch: "gr6", header: [null, "Số"] },
                                    {
                                        id: "so_luong3", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr7",
                                                groupText: "Hủy", colspan: 2
                                            },
                                            "Số lượng"], width: 110
                                    },
                                    { id: "so3", batch: "gr7", header: [null, "Số"] },
                                    {
                                        id: "tu_so4", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr8",
                                                groupText: "Tồn cuối kỳ", colspan: 3
                                            },
                                            "Từ số"]
                                    },
                                    { id: "den_so4", batch: "gr8", header: [null, "Đến số"] },
                                    { id: "so_luong4", batch: "gr8", header: [null, "Số lượng"] }

                                ]
                            },
                            {
                                view: "fieldset",
                                label: "Thông tin đơn vị",
                                body: {
                                    rows: [
                                        {
                                            view: "text",
                                            id: "nguoi_dai_dien",
                                            name: "nguoi_dai_dien",
                                            //labelPosition: "top",
                                            label: "Người đại diện",
                                            css: "mcls_readonly_text",
                                            labelWidth: 100,
                                            readonly: true,
                                            width: 500
                                        },
                                        {
                                            cols: [
                                                {
                                                    id: "nguoi_lap",
                                                    view: "text",
                                                    name: "nguoi_lap",
                                                    //labelPosition: "top",
                                                    css: "mcls_readonly_text",
                                                    labelWidth: 100,
                                                    label: "Người lập",
                                                    readonly: true,
                                                    width: 500
                                                },
                                                {
                                                    id: "ngay_lap",
                                                    view: "datepicker",
                                                    name: "ngay_lap",
                                                    css: "mcls_readonly_text",
                                                    value: new Date(),
                                                    label: "Ngày lập",
                                                    readonly: true,
                                                    width: 500
                                                }
                                            ]
                                        }
                                    ]
                                }
                            },
                            {
                                margin: 10,
                                cols: [
                                    {},
                                    {
                                        shortcut: "F11", view: "button", icon: "refresh", type: "form", label: "Tải dữ liệu (F11)", align: "center", width: 120,
                                        on: {
                                            onClick: function () {

                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/Bcthsd/BcTinhhinhsudung", $$('dataform').config.item, function (text) {
                                                        var data = JSON.parse(text);
                                                        //console.log(data);
                                                        var table = webix.$$("dataBC");
                                                        table.clearAll();
                                                        table.parse(data);
                                                    });
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        shortcut: "F10", id: "btnGhi", view: "button", icon: "refresh", label: "Lưu (F10)", type: "danger", align: "center", width: 120,
                                        on: {
                                            onClick: function () {
                                                var ss = $$("dataBC").serialize();

                                                var dataBC = {
                                                    data: ss,
                                                    nguoi_lap: $$('nguoi_lap').getValue(),
                                                    nguoi_dai_dien: $$('nguoi_dai_dien').getValue(),
                                                    ngay_lap: $$('ngay_lap').getValue()
                                                };

                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/Bcthsd/bcthsd_INSERT", dataBC, function (text) {
                                                        var data = JSON.parse(text);
                                                        if (data.hasOwnProperty("error")) {
                                                            webix.message(data.error);
                                                        }
                                                        else {
                                                            webix.message(data.ok, "debug");
                                                        }
                                                    });
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        shortcut: "F9", view: "button", type: "form", icon: "refresh", label: "Export XML (F9)", align: "center", width: 120,
                                        on: {
                                            onClick: function () {

                                                webix.confirm({
                                                    text: "Bạn có muốn ghi báo cáo trước khi kết suất XML không ?", ok: "Có", cancel: "Không",
                                                    callback: function (res) {
                                                        if (res) {
                                                            var ss = $$("dataBC").serialize();

                                                            var dataBC = {
                                                                data: ss,
                                                                nguoi_lap: $$('nguoi_lap').getValue(),
                                                                nguoi_dai_dien: $$('nguoi_dai_dien').getValue(),
                                                                ngay_lap: $$('ngay_lap').getValue()
                                                            };
                                                            var box = webix.modalbox({
                                                                title: "Đang kết suất XML ....",
                                                                text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                                width: 350,
                                                                height: 200
                                                            });
                                                            webix.ajax()
                                                                .headers({ 'Content-type': 'application/json' })
                                                                .post(app.config.host + "/Bcthsd/bcthsd_INSERT", dataBC, function (text) {
                                                                    var data = JSON.parse(text);
                                                                    if (data.hasOwnProperty("error")) {
                                                                        webix.modalbox.hide(box);
                                                                        webix.message(data.error, "error");
                                                                    }
                                                                    else {
                                                                        var item = $$('dataform').config.item;
                                                                        // console.log(item);
                                                                        var input = {
                                                                            ma_dvcs: user.getDvcsID(),
                                                                            tokhai_quy: item.tokhai_quy,
                                                                            tokhai_thang: item.tokhai_thang,
                                                                            nam: item.nam,
                                                                            thang: item.thang,
                                                                            tu_ngay: item.tu_ngay,
                                                                            den_ngay: item.den_ngay
                                                                        }

                                                                        webix.ajax()
                                                                            .response("arraybuffer")
                                                                            .get(app.config.host + "/Bcthsd/ExportFileXML", input, function (text, data) {
                                                                                var file = new Blob([data], { type: 'application/xml' });
                                                                                webix.html.download(file, $$('tenfile').getValue());
                                                                                webix.modalbox.hide(box);
                                                                            });
                                                                    }
                                                                });

                                                        }
                                                        else {
                                                            var item = $$('dataform').config.item;
                                                            // console.log(item);
                                                            var input = {
                                                                ma_dvcs: user.getDvcsID(),
                                                                tokhai_quy: item.tokhai_quy,
                                                                tokhai_thang: item.tokhai_thang,
                                                                nam: item.nam,
                                                                thang: item.thang,
                                                                tu_ngay: item.tu_ngay,
                                                                den_ngay: item.den_ngay
                                                            }
                                                            var box = webix.modalbox({
                                                                title: "Đang kết suất XML ....",
                                                                text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                                width: 350,
                                                                height: 200
                                                            });
                                                            webix.ajax()
                                                                .response("arraybuffer")
                                                                .get(app.config.host + "/Bcthsd/ExportFileXML", input, function (text, data) {
                                                                    var file = new Blob([data], { type: 'application/xml' });
                                                                    webix.html.download(file, $$('tenfile').getValue());
                                                                    webix.modalbox.hide(box);
                                                                });
                                                        }
                                                    }
                                                });
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        shortcut: "F8", view: "button", type: "form", icon: "far fa-refresh", label: "Print (F8)", align: "center", width: 120,
                                        on: {
                                            onClick: function () {
                                                var item = $$('dataform').config.item;
                                                // console.log(item);
                                                var input = {
                                                    ma_dvcs: user.getDvcsID(),
                                                    bc_soluong: item.bc_soluong,
                                                    nam: item.nam,
                                                    thang: item.thang,
                                                    tokhai_quy: item.tokhai_quy,
                                                    tokhai_thang: item.tokhai_thang
                                                }
                                                var box = webix.modalbox({
                                                    title: "Đang in báo cáo ....",
                                                    text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                    width: 350,
                                                    height: 200
                                                });
                                                webix.ajax()
                                                    .response("arraybuffer")
                                                    .get(app.config.host + "/Bcthsd/PrintPDF?ma_dvcs=" + user.getDvcsID() + "&bc_soluong=" + item.bc_soluong + "&nam=" + item.nam + "&thang=" + item.thang + "&tokhai_quy=" + item.tokhai_quy + "&tokhai_thang=" + item.tokhai_thang, function (text, data) {
                                                        var file = new Blob([data], { type: 'application/pdf' });
                                                        var fileURL = URL.createObjectURL(file);
                                                        webix.modalbox.hide(box);
                                                        //  var printWindow = window.open(fileURL, '', 'width=800,height=500');
                                                        //           printWindow.print()
                                                        // var a = document.createElement("a");
                                                        // a.target = '_blank';
                                                        // document.body.appendChild(a);

                                                        // a.href = fileURL;
                                                        // a.download = "fileName.pdf";
                                                        // a.click();
                                                        //$$("frame-body").define("src", fileURL);
                                                        //kk.show();
                                                        window.open(fileURL, '_blank');

                                                        // webix.html.download(file, $$('tenfile').getValue());
                                                    });
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {}
                                    /*{
                                        view: "button", hotkey: "esc", label: "Hủy bỏ", align: "center", width: 120,
                                        click: function () {
                                            $$("tinhhinhsudung").removeView("dataBC");
                                            // webix.$$("tinhhinhsudung").close();
                                        }
                                    }*/
                                ]
                            }
                        ]
                    }
                ]
            }

        },
        initUI: initUI
    };

});
define('views/forms/token',["app", "locale"], function (app, _) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "chukyso-win", position: "center",
			head: "Thông tin Token",
			//height:420,		
			body: {
				paddingY: 10,
				paddingX: 10,
				view: "form",
				id: "chukyso-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						view: "text",
						name: "serial_number",
						labelPosition: "top",
						label: _("SO_SERIAL"),
						readonly: true,
						width: 350
					},
					{
						view: "text",
						name: "token_label",
						labelPosition: "top",
						label: "TOKEN LABEL",
						readonly: true,
					},
					{
						view: "text",
						name: "pass",
						labelPosition: "top",
						label: _("PASSWORD"),
						type: "password"
					},
					{},
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Lưu (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("chukyso-form");

										var item = form.getValues();

										var khData = {};

										khData.windowid = app.path[1].params[0];
										khData.editmode = editmode;
										khData.data = [];

										khData.data.push(item);

										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(app.config.host + "/System/Save", khData, function (text) {

												var json = JSON.parse(text);

												if (!json.hasOwnProperty("error")) {
													$$("chukyso-win").close();
													app.callEvent("dataChanged", [editmode, json.data]);
												}
												else {
													webix.message(json.error, "error");
												}


											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
								click: function () {
									webix.$$("chukyso-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/forms/tokenfile',["app", "locale"], function (app, _) {
    var editmode = 0;

    return {
        $ui: {
            view: "window", modal: true, id: "tokenfile-win", position: "center",
            head: "Thông tin Token File",
            //height:420,		
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "tokenfile-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "textarea",
                        name: "file_path",
                        labelPosition: "top",
                        label: _("PATH"),
                        height: 100,
                        required: true,
                        validate: webix.rules.isNotEmpty,
                        invalidMessage: "Đường dẫn không được để trống !"
                    },
                    {
                        view: "text",
                        name: "pass",
                        labelPosition: "top",
                        label: _("PASSWORD"),
                        type: "password",
                        required: true,
                        invalidMessage: "Password không được để trống !",
                        validate: webix.rules.isNotEmpty
                    },
                    {},
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Lưu (F10)", type: "form", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        if ($$("tokenfile-form").validate()) {
                                            var form = webix.$$("tokenfile-form");

                                            var item = form.getValues();

                                            var khData = {};

                                            khData.windowid = app.path[1].params[0];
                                            khData.editmode = editmode;
                                            khData.data = [];

                                            khData.data.push(item);

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Token/SaveTokenFile", khData, function (text) {

                                                    var json = JSON.parse(text);

                                                    if (!json.hasOwnProperty("error")) {
                                                        $$("tokenfile-win").close();
                                                        app.callEvent("dataChanged", [editmode, json.data]);
                                                    }
                                                    else {
                                                        webix.message(json.error, "error");
                                                    }


                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
                                click: function () {
                                    webix.$$("tokenfile-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }

        },
        setEditMode: function (mode) {
            editmode = mode;
        }
    };

});
define('views/forms/updateToWeb',["require", "locale", "app"], function (require, _, app) {
    

    var layout = {
        view: "window",
        id: "formConfirm",
        head: "Đăng nhập",
        modal: true,
        position: "center",
        // css: { "font-weight": "bold", "text-transform": "uppercase" },
        body: {
            view: "form",
            id: "formConfirmValid",
            // elementsConfig: {
            //     labelPosition: "top",
            //     //validateEvent: "key"
            // },
            elements: [
                {
                    view: "text",
                    label: _("Account"),
                    id: "1",
                    name: "taikhoan",
                    width: 350,
                    invalidMessage: "Tài khoản không được để trống !",
                    required: true,
                    css: "mcls_uppercase",
                },
                {
                    view: "text",
                    label: _("PASSWORD"),
                    id: "pass",
                    name: "matkhau",
                    type: "password",
                    width: 350,
                    invalidMessage: "Mật khẩu không được để trống !",
                    required: true,
                },
                // {
                //     view: "label",
                //     name: "lb1",
                //     id: "lb",
                //     template: "<hr>"
                // },
                {
                    view: "button",
                    css: "mcls_btnRegisterLogin",
                    type: "iconButton",
                    icon: "long-arrow-right",
                    label: _("Phần mềm hóa đơn điện tử MobiFone Invoice"),
                    width: 250,
                    click: function () {
                        window.open("http://minvoice.vn/dang-ky-su-dung/", "_blank");
                    },
                },
                {
                    cols: [
                        {
                            view: "button",
                            value: "Đồng ý",
                            type: "danger",
                            click: function () {
                                var model = {
                                    username: $$("1").getValue(),
                                    password: $$("pass").getValue(),
                                };
                                if ($$("formConfirmValid").validate()) {
                                    var box = webix.modalbox({
                                        title: "Đang cập nhật phần mềm ....",
                                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                        width: 350,
                                        height: 200,
                                    });
                                    var urlCheck = app.config.host + "/System/CheckPassUpdate";

                                    var url = app.config.host + "/System/UpdateToWeb";
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(urlCheck, model, function (text) {
                                            var data = JSON.parse(text);

                                            if (!data.hasOwnProperty("error")) {
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(url, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.modalbox.hide(box);
                                                            webix.message(XmlHttpRequest.statusText, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            //console.log(text);
                                                            var data = JSON.parse(text);

                                                            if (data.error == "" || data.error == null) {
                                                                webix.modalbox.hide(box);
                                                                webix.message(data.ok, "debug");

                                                                webix.$$("formConfirm").close();
                                                            } else {
                                                                webix.$$("formConfirm").close();
                                                                webix.modalbox.hide(box);
                                                                webix.message(data.error, "error");
                                                            }
                                                        },
                                                    });
                                            } else {
                                                webix.modalbox.hide(box);
                                                webix.message(data.error, "error");
                                            }
                                        });
                                    //this.getTopParentView().hide();
                                }
                            },
                        },
                        {
                            view: "button",
                            hotkey: "esc",
                            label: "Hủy bỏ",
                            type: "iconButton",
                            icon: "times",
                            click: function () {
                                //this.getFormView().save();
                                $$("formConfirm").close();
                                //this.getTopParentView().hide();
                            },
                        },
                    ],
                },
            ],
        },
    };

    return {
        $ui: layout,
        $oninit: function () {
            $$("formConfirmValid").focus();
        },
    };
});

define('views/forms/uploadexcel',["app", "locale"], function (app, _) {
    // var dialog = webix.ui({
    // 	id: "uploader",
    // 	view: "uploader",
    // 	value: 'Chọn file',
    // 	name: "uploader",
    // 	accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    // 	link: "mylist",
    // 	autosend: false,
    // 	//borderless: true,
    // 	multiple: false,
    // 	upload: app.config.host + "/System/UploadExcel",
    // 	on: {
    // 		onAfterFileAdd: function (file) {
    // 			//console.log(file);
    // 			// var kk = {
    // 			// 	name: file.name,
    // 			// 	lastModified: file.lastModified,
    // 			// 	lastModifiedDate: file.lastModifiedDate,
    // 			// 	webkitRelativePath: file.webkitRelativePath,
    // 			// 	id: file.id,
    // 			// 	size: file.size,
    // 			// 	sizetext: file.sizetext,
    // 			// 	status: file.status,
    // 			// 	type: file.type
    // 			// };
    // 			// $$("mylist").add(kk);

    // 			// console.log($$("mylist").getIdByIndex(0));
    // 			// var id = $$("mylist").getIdByIndex(0);
    // 			// console.log($$("mylist").getItem(id));
    // 			$$("mylist").refresh();
    // 			//$$("mylist").show();

    // 		},
    // 		onUploadComplete: function (response) {
    // 			// var topParentView = this.getTopParentView();

    // 			// if (topParentView.config.tableId !== undefined) {
    // 			// 	var table = $$(topParentView.config.tableId);

    // 			// 	if (table != null) {
    // 			// 		table.clearAll();
    // 			// 		table.load(table.config.url);
    // 			// 	}
    // 			// }
    // 			// webix.message("Upload File thành công !", "debug");
    // 			// webix.$$("uploadfile-win").close();
    // 		},
    // 		onFileUploadError: function (file, response) {
    // 			console.log(file);
    // 			console.log(response);
    // 		}
    // 	},
    // 	apiOnly: true,
    // });

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "uploadfile-win",
            position: "center",
            head: "Nhận dữ liệu từ file Excel",
            width: 500,
            height: 500,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "uploadfile-form",
                complexData: true,
                elements: [
                    {
                        cols: [
                            {
                                view: "toolbar",
                                css: { background: "#e6f7ff !important" },
                                rows: [
                                    // { gravity: 2 },
                                    {
                                        view: "button",
                                        type: "icon",
                                        icon: "fas fa-folder-open",
                                        label: "Chọn file",
                                        width: 110,
                                        on: {
                                            onClick: function () {
                                                webix.$$("uploader").fileDialog();
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        icon: "fas fa-download",
                                        label: "Tải file mẫu",
                                        width: 110,
                                        on: {
                                            onClick: function () {
                                                var uploader = webix.$$("uploader");
                                                var formData = uploader.config.formData;
                                                var filename = formData["filename"] == null ? "template.xlsx" : formData["filename"];
                                                var table = $$("uploadfile-win");
                                                // webix.extend(table, webix.OverlayBox);
                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                webix
                                                    .ajax()
                                                    .bind({ filename: filename })
                                                    .response("arraybuffer")
                                                    .headers({ "Content-type": "application/json" })
                                                    .get(app.config.host + "/System/DownloadFileExcelTemplate?id=" + formData["excel_id"], function (text, data, XmlHttpRequest) {
                                                        webix.delay(
                                                            function (filename) {
                                                                var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                                                var fileURL = URL.createObjectURL(file);

                                                                var link = document.createElement("a");
                                                                document.body.appendChild(link);
                                                                link.download = filename;
                                                                link.href = fileURL;
                                                                link.click();
                                                                document.body.removeChild(link); // remove the link when done
                                                                //document.location.href = fileURL;
                                                            },
                                                            null,
                                                            [filename],
                                                            500
                                                        );

                                                        table.enable();
                                                        table.hideProgress();
                                                    });
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                    {
                                        shortcut: "F10",
                                        view: "button",
                                        type: "icon",
                                        icon: "fas fa-check",
                                        label: "Nhận file (F10)",
                                        width: 120,
                                        on: {
                                            onClick: function () {
                                                var table = $$("uploadfile-win");
                                                // webix.extend(table, webix.OverlayBox);
                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                var file = $$("uploader").files.getFirstId();
                                                if (file == undefined || file == null) {
                                                    webix.message("Bạn chưa chọn file !", "error");
                                                    $$("uploadfile-win").enable();
                                                    $$("uploadfile-win").hideProgress();
                                                    return;
                                                }
                                                // var kk = $$("uploader").files.data.pull;
                                                // console.log(kk);
                                                $$("uploader").send(function (response) {
                                                    var message = response.message || "Nhận dữ liệu Excel thành công !";
                                                    console.log(response);
                                                    console.log(message);
                                                    if (response != undefined) {
                                                        if (!response.hasOwnProperty("error")) {
                                                            $$("uploadfile-win").enable();
                                                            $$("uploadfile-win").hideProgress();
                                                            //this.callEvent("onUploadComplete");
                                                            // success call event onUploadComplete ở trên
                                                            var topParentView = this.getTopParentView();

                                                            if (topParentView.config.callback) {
                                                                topParentView.config.callback();
                                                                return;
                                                            }

                                                            if (topParentView.config.tableId !== undefined) {
                                                                var table = $$(topParentView.config.tableId);

                                                                if (table != null && table.config.url != undefined) {
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                }
                                                            }

                                                            webix.alert({
                                                                title: "Thành công !",
                                                                text: "<div class='v-message'>" + message + "</div>",
                                                                type: "alert-warning",
                                                                callback: function (result) {
                                                                    webix.$$("uploadfile-win").close();
                                                                },
                                                            });

                                                            //webix.message("Nhận dữ liệu Excel thành công !", "debug");
                                                        } else {
                                                            $$("uploadfile-win").enable();
                                                            $$("uploadfile-win").hideProgress();

                                                            webix.alert({
                                                                title: "Lỗi !",
                                                                text: response.error,
                                                                type: "alert-error",
                                                                callback: function (result) {
                                                                    webix.$$("uploadfile-win").close();
                                                                },
                                                                // callback: function (result) {
                                                                // 	webix.alert({
                                                                // 		title: "Custom title",
                                                                // 		ok: "Custom text",
                                                                // 		text: "Result: " + result
                                                                // 	});
                                                                // }
                                                            });
                                                            //webix.message(response.error, "error");
                                                        }
                                                    } else {
                                                        $$("uploadfile-win").enable();
                                                        $$("uploadfile-win").hideProgress();
                                                    }
                                                });
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                    {
                                        hotkey: "esc",
                                        view: "button",
                                        type: "icon",
                                        icon: "fas fa-times",
                                        label: "Hủy bỏ (ESC)",
                                        width: 110,
                                        on: {
                                            onClick: function () {
                                                $$("mylist").clearAll();
                                                $$("mylist").unbind();
                                                var id = $$("uploader").files.getFirstId();
                                                if (id != undefined) {
                                                    $$("uploader").stopUpload(id);
                                                }
                                                webix.$$("uploadfile-win").close();
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                ],
                            },
                            {
                                rows: [
                                    // {view:"text",id:"df",label:"errr"},
                                    {
                                        id: "uploader",
                                        view: "uploader",
                                        value: "Chọn file",
                                        hide: true,
                                        name: "uploader",
                                        accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                        link: "mylist",
                                        autosend: false,
                                        //borderless: true,
                                        multiple: false,
                                        upload: app.config.host + "/System/UploadExcel",
                                        on: {
                                            onAfterRender: function () {
                                                //console.log('called once after first rendering:');
                                                this.hide();
                                            },
                                            onAfterFileAdd: function (file) {
                                                var fileName = file.name;
                                                if (!fileName.endsWith(".xls") && !fileName.endsWith(".xlsx")) {
                                                    webix.alert({
                                                        title: "Lỗi !",
                                                        text: "File không đúng định dạng Excel!",
                                                        type: "alert-error",
                                                        callback: function () {
                                                            $$("uploader").files.data.clearAll();
                                                        },
                                                    });
                                                }
                                                //console.log(file);
                                                // var kk = {
                                                // 	name: file.name,
                                                // 	lastModified: file.lastModified,
                                                // 	lastModifiedDate: file.lastModifiedDate,
                                                // 	webkitRelativePath: file.webkitRelativePath,
                                                // 	id: file.id,
                                                // 	size: file.size,
                                                // 	sizetext: file.sizetext,
                                                // 	status: file.status,
                                                // 	type: file.type
                                                // };
                                                // $$("mylist").add(kk);

                                                // console.log($$("mylist").getIdByIndex(0));
                                                // var id = $$("mylist").getIdByIndex(0);
                                                // console.log($$("mylist").getItem(id));
                                                $$("mylist").refresh();
                                                //$$("mylist").show();
                                            },
                                            onUploadComplete: function (response) {
                                                // var topParentView = this.getTopParentView();

                                                // if (topParentView.config.tableId !== undefined) {
                                                // 	var table = $$(topParentView.config.tableId);

                                                // 	if (table != null) {
                                                // 		table.clearAll();
                                                // 		table.load(table.config.url);
                                                // 	}
                                                // }
                                                // webix.message("Upload File thành công !", "debug");
                                                // webix.$$("uploadfile-win").close();

                                                if (response === undefined) return;

                                                if (response.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: response.error });
                                                }
                                            },
                                            onFileUploadError: function (file, response) {
                                                console.log(file);
                                                console.log(response);
                                                $$("uploadfile-win").enable();
                                                $$("uploadfile-win").hideProgress();
                                            },
                                        },
                                        apiOnly: true,
                                    },
                                    {
                                        view: "list",
                                        id: "mylist",
                                        type: "uploader",
                                        height: 100,
                                        //autoheight: true
                                        borderless: true,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
    };
});

define('views/forms/uploadexcelform',["app", "locale"], function (app, _) {
    // var dialog = webix.ui({
    // 	id: "uploader",
    // 	view: "uploader",
    // 	value: 'Chọn file',
    // 	name: "uploader",
    // 	accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    // 	link: "mylist",
    // 	autosend: false,
    // 	//borderless: true,
    // 	multiple: false,
    // 	upload: app.config.host + "/System/UploadExcel",
    // 	on: {
    // 		onAfterFileAdd: function (file) {
    // 			//console.log(file);
    // 			// var kk = {
    // 			// 	name: file.name,
    // 			// 	lastModified: file.lastModified,
    // 			// 	lastModifiedDate: file.lastModifiedDate,
    // 			// 	webkitRelativePath: file.webkitRelativePath,
    // 			// 	id: file.id,
    // 			// 	size: file.size,
    // 			// 	sizetext: file.sizetext,
    // 			// 	status: file.status,
    // 			// 	type: file.type
    // 			// };
    // 			// $$("mylist").add(kk);

    // 			// console.log($$("mylist").getIdByIndex(0));
    // 			// var id = $$("mylist").getIdByIndex(0);
    // 			// console.log($$("mylist").getItem(id));
    // 			$$("mylist").refresh();
    // 			//$$("mylist").show();

    // 		},
    // 		onUploadComplete: function (response) {
    // 			// var topParentView = this.getTopParentView();

    // 			// if (topParentView.config.tableId !== undefined) {
    // 			// 	var table = $$(topParentView.config.tableId);

    // 			// 	if (table != null) {
    // 			// 		table.clearAll();
    // 			// 		table.load(table.config.url);
    // 			// 	}
    // 			// }
    // 			// webix.message("Upload File thành công !", "debug");
    // 			// webix.$$("uploadfile-win").close();
    // 		},
    // 		onFileUploadError: function (file, response) {
    // 			console.log(file);
    // 			console.log(response);
    // 		}
    // 	},
    // 	apiOnly: true,
    // });

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "uploadfile-win",
            position: "center",
            head: "Nhận dữ liệu từ file Excel",
            width: 500,
            height: 500,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "uploadfile-form",
                complexData: true,
                elements: [
                    {
                        cols: [
                            {
                                view: "toolbar",
                                css: { background: "#e6f7ff !important" },
                                rows: [
                                    // { gravity: 2 },
                                    {
                                        view: "button",
                                        type: "icon",
                                        icon: "fas fa-folder-open",
                                        label: "Chọn file",
                                        width: 110,
                                        on: {
                                            onClick: function () {
                                                webix.$$("uploader").fileDialog();
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        icon: "fas fa-download",
                                        label: "Tải file mẫu",
                                        width: 110,
                                        on: {
                                            onClick: function () {
                                                debugger
                                                var uploader = webix.$$("uploader");
                                                var formData = uploader.config.formData;
                                                var filename = formData["filename"] == null ? "template.xlsx" : formData["filename"];
                                                var table = $$("uploadfile-win");
                                                // webix.extend(table, webix.OverlayBox);
                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                webix
                                                    .ajax()
                                                    .bind({ filename: filename })
                                                    .response("arraybuffer")
                                                    .headers({ "Content-type": "application/json" })
                                                    .get(app.config.host + "/System/DownloadFileExcelTemplate?id=" + formData["excel_id"], function (text, data, XmlHttpRequest) {
                                                        webix.delay(
                                                            function (filename) {
                                                                var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                                                var fileURL = URL.createObjectURL(file);

                                                                var link = document.createElement("a");
                                                                document.body.appendChild(link);
                                                                link.download = filename;
                                                                link.href = fileURL;
                                                                link.click();
                                                                document.body.removeChild(link); // remove the link when done
                                                                //document.location.href = fileURL;
                                                            },
                                                            null,
                                                            [filename],
                                                            500
                                                        );

                                                        table.enable();
                                                        table.hideProgress();
                                                    });
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                    {
                                        shortcut: "F10",
                                        view: "button",
                                        type: "icon",
                                        icon: "fas fa-check",
                                        label: "Nhận file (F10)",
                                        width: 120,
                                        on: {
                                            onClick: function () {

                                                // Lấy mẫu excel import
                                                var uploader = webix.$$("uploader");
                                                var formData = uploader.config.formData;
                                                var excel_id = formData["excel_id"];
                                              
                                                var table = $$("uploadfile-win");
                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                var file = $$("uploader").files.getFirstId();
                                                if (file == undefined || file == null) {
                                                    webix.message("Bạn chưa chọn file !", "error");
                                                    $$("uploadfile-win").enable();
                                                    $$("uploadfile-win").hideProgress();
                                                    return;
                                                }

                                                // khi import bật lên rồi sau khi import thì tắt
                                                debugger
                                                var checkTien = $$("tudongtinhtien");
                                                    checkTien.setValue(1);

                                                if(excel_id ==="EX00017"){
                                                    var checkbox = $$("giamthuebanhang20");
                                                    if (checkbox) {
                                                        $$("tienthuegtgtgiam").setValue(0);
                                                        $$("tgtttbso_last").setValue(0);
                                                        checkbox.setValue(0);
                                                    }
                                                }

                                                var fileData = $$("uploader").files.getItem(file);
                                                var reader = new FileReader();
                                                reader.readAsArrayBuffer(fileData.file);
                                                reader.onload = function (e) {
                                                    debugger
                                                    var table = webix.$$("hoadon68_chitiet");
                                                    table.clearAll();

                                                    //Đọc file excel
                                                    var data = new Uint8Array(e.target.result);
                                                    var workbook = XLSX.read(data, { type: "array" });
                                                    //Lấy sheet data
                                                    var firstSheetName = workbook.SheetNames[0];
                                                    var firstSheet = workbook.Sheets[firstSheetName];
                                                    var range = XLSX.utils.decode_range(firstSheet["!ref"]);
                                                    // đếm cột có kí tự để so sánh mẫu
                                                    var totalColumns = 0;
                                                    for (var col = range.s.c; col <= range.e.c; col++) {
                                                        for (var row = 0; row <= range.e.r; row++) { 
                                                            var cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                                                            var cell = firstSheet[cellAddress];
                                                      
                                                            if (cell && cell.v && String(cell.v).trim() !== "") {
                                                                totalColumns ++; 
                                                                break; 
                                                            }
                                                        }
                                                    }
                                                    var checkErro = false;
                                                    var isGiamTru = false;
                                                    //Lặp từng dòng trong file import
                                                    for (var row = 5; row <= (range.e.r + 1); row++) {
                                                        var item = {
                                                            id: webix.uid(),
                                                        };
                                                        //Map dữ liệu excel với cột trong bảng table_chitiet
                                                        var columns = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T"];
                                                        var columnIds = ["ma", "ten", "mdvtinh", "sluong", "dgia", "tlckhau", "stckhau", "thtien", "tiletienthuegtgtgiam", "tienthuegtgtgiam", "tgtien", "kmai", "lhhdthu", "skhung", "smay", "bksptvchuyen", "tnghang", "dcnghang", "mstnghang","mddnghang"];
                                                        if(excel_id ==="EX00011"){
                                                            columns = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T"];
                                                            columnIds= ["ma", "ten", "mdvtinh", "sluong", "dgia", "thtien", "tlckhau", "stckhau", "tsuat", "tthue", "tgtien", "kmai", "lhhdthu", "skhung", "smay", "bksptvchuyen", "tnghang", "dcnghang", "mstnghang","mddnghang"]; // Tên cột tương ứng trong Webix
                                                        }else if(excel_id ==="EX00029"){
                                                            columns = ["A", "B", "C", "D", "E", "F", "G"];
                                                            columnIds = ["ma", "ten", "mdvtinh", "sluong", "dgia", "tgtien", "kmai"]; 
                                                        }else if(excel_id ==="EX00024"){
                                                            columns = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O"];
                                                            columnIds = ["ma", "ten", "mdvtinh", "sluong", "dgia", "tgtien", "kmai", "lhhdthu", "skhung", "smay", "bksptvchuyen", "tnghang", "dcnghang", "mstnghang","mddnghang"]; 
                                                        }else{
                                                            columns = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T"];
                                                            columnIds = ["ma", "ten", "mdvtinh", "sluong", "dgia", "tlckhau", "stckhau", "thtien", "tiletienthuegtgtgiam", "tienthuegtgtgiam", "tgtien", "kmai", "lhhdthu", "skhung", "smay", "bksptvchuyen", "tnghang", "dcnghang", "mstnghang","mddnghang"]; 
                                                        }
                                                        if(totalColumns !== columns.length){
                                                            webix.message("File excel là " + totalColumns + " cột khác với file mẫu là  " + columns.length + " cột!" , "error");
                                                            checkErro = true;
                                                            break;
                                                        }
                                                            
                                                        //Lặp columns để set giá trị vào ô trong bảng table_chitiet
                                                        for (var index = 0; index < columns.length; index++) {
                                                            var col = columns[index]; 

                                                            var cellAddress = col + row; 
                                                            var cell = firstSheet[cellAddress];
                                                            var value;
                                                            if (cell) { 
                                                                value = cell.v; 
                                                                if(columnIds[index] === "tsuat"){
                                                                    item[columnIds[index]] = String(value); 
                                                                }else{
                                                                    item[columnIds[index]] = value;
                                                                }
                                                                
                                                            } else {
                                                                // Check các cột bắt buộc nhập trong excel
                                                                if(excel_id ==="EX00011" && (columnIds[index]==="ten" || columnIds[index]==="tsuat" || columnIds[index]==="tthue"|| columnIds[index]==="tgtien")){
                                                                    webix.message("Dòng " + row + " cột " + col+ " không được để trống" , "error");
                                                                    table.clearAll();
                                                                    checkErro = true;
                                                                    break;
                                                                }
    
                                                                if(excel_id ==="EX00024" && (columnIds[index]==="ten" || columnIds[index]==="kmai")){
                                                                    webix.message("Dòng " + row + " cột " + col+ " không được để trống" , "error");
                                                                    table.clearAll();
                                                                    checkErro = true;
                                                                    break;
                                                                }
    
                                                                if(excel_id ==="EX00017" && (columnIds[index]==="ten" || columnIds[index]==="thtien" || columnIds[index]==="tgtien")){
                                                                    webix.message("Dòng " + row + " cột " + col+ " không được để trống" , "error");
                                                                    table.clearAll();
                                                                    checkErro = true;
                                                                    $$("tienthuegtgtgiam").setValue(0);
                                                                    $$("tgtttbso_last").setValue(0);
                                                                    break;
                                                                }
                                                                if(columnIds[index] === "kmai"){
                                                                    webix.message("Dòng " + row + " cột " + col+ " tính chất không được để trống" , "error");
                                                                    table.clearAll();
                                                                    checkErro = true;
                                                                    break;
                                                                }
                                                                
                                                                item[columnIds[index]] = ""; 
                                                            }
                                                        };

                                                        debugger
                                                        if(excel_id ==="EX00017" && (item["sluong"]!=="" && item["stckhau"] !== "" && item["dgia"] !== ""
                                                            && item["tlckhau"] !== "")){
                                                                if(item["dgia"]*item["sluong"]*item["tlckhau"]/100 !== item["stckhau"]){
                                                                     webix.message("Tiền chiết khấu tại dòng " + row + " đang bị tính sai" , "error");
                                                                     table.clearAll();
                                                                     checkErro = true;
                                    
                                                                     break;
                                                                }

                                                                if((item["dgia"]*item["sluong"] - item["stckhau"]) !== item["thtien"]){
                                                                    webix.message("Thành tiền tại dòng " + row + " đang bị tính sai" , "error");
                                                                    table.clearAll();
                                                                    checkErro = true;
                                                      
                                                                    break;
                                                               }

                                                        }
                                                        
                                                        if(item["kmai"] === 5 && excel_id !=="EX00029"){
                                                            if(item["sluong"]==="" || item["sluong"]===0){
                                                                webix.message("Dòng "+ row + " số lượng không được để trống!" , "error");
                                                                webix.alert({
                                                                    title: "Lỗi !",
                                                                    text: "Dòng "+ row + " số lượng không được để trống!",
                                                                    type: "alert-error",
                                                                });
                                                                table.clearAll();
                                                                if ($$("tienthuegtgtgiam")) {
                                                                    $$("tienthuegtgtgiam").setValue(0);
                                                                }
                                                                if ($$("tgtttbso_last")) {
                                                                    $$("tgtttbso_last").setValue(0);
                                                                }     
                                                                if ($$("tgtttbso")) {
                                                                    $$("tgtttbso").setValue(0);
                                                                }    
                                                                if ($$("tgtthue")) {
                                                                    $$("tgtthue").setValue(0);
                                                                }    
                                                                if ($$("tgtcthue")) {
                                                                    $$("tgtcthue").setValue(0);
                                                                } 
                                                                checkErro = true;
                                                                break;
                                                            }

                                                            if(item["lhhdthu"]===""){
                                                                webix.message("Dòng "+ row + " loại hàng hóa đặc thù không được để trống!" , "error");
                                                                webix.alert({
                                                                    title: "Lỗi !",
                                                                    text: "Dòng "+ row + " loại hàng hóa đặc thù không được để trống!",
                                                                    type: "alert-error",
                                                                });
                                                                table.clearAll();
                                                                if ($$("tienthuegtgtgiam")) {
                                                                    $$("tienthuegtgtgiam").setValue(0);
                                                                }
                                                                if ($$("tgtttbso_last")) {
                                                                    $$("tgtttbso_last").setValue(0);
                                                                }     
                                                                if ($$("tgtttbso")) {
                                                                    $$("tgtttbso").setValue(0);
                                                                }    
                                                                if ($$("tgtthue")) {
                                                                    $$("tgtthue").setValue(0);
                                                                }    
                                                                if ($$("tgtcthue")) {
                                                                    $$("tgtcthue").setValue(0);
                                                                } 
                                                                checkErro = true;
                                                                break;
                                                            }  
                                                         
                                                            if(item["lhhdthu"]===1){
                                                                if(item["skhung"]==="" ||item["smay"]===""){
                                                                    webix.message("Dòng "+ row + " số khung, số máy không được để trống với hàng hóa là xe ô tô, xe mô tô!" , "error");
                                                                    webix.alert({
                                                                        title: "Lỗi !",
                                                                        text: "Dòng "+ row + " số khung, số máy không được để trống với hàng hóa là xe ô tô, xe mô tô!",
                                                                        type: "alert-error",
                                                                    });
                                                                    table.clearAll();
                                                                    if ($$("tienthuegtgtgiam")) {
                                                                        $$("tienthuegtgtgiam").setValue(0);
                                                                    }
                                                                    if ($$("tgtttbso_last")) {
                                                                        $$("tgtttbso_last").setValue(0);
                                                                    }     
                                                                    if ($$("tgtttbso")) {
                                                                        $$("tgtttbso").setValue(0);
                                                                    }    
                                                                    if ($$("tgtthue")) {
                                                                        $$("tgtthue").setValue(0);
                                                                    }    
                                                                    if ($$("tgtcthue")) {
                                                                        $$("tgtcthue").setValue(0);
                                                                    } 
                                                                    checkErro = true;
                                                                    break;
                                                                }
                                                                if(item["sluong"]!==1 && item["sluong"] !== -1){
                                                                    webix.message("Dòng "+ row + " số lượng không khớp với số khung!" , "error");
                                                                    webix.alert({
                                                                        title: "Lỗi !",
                                                                        text: "Dòng "+ row + " số lượng không khớp với số khung!",
                                                                        type: "alert-error",
                                                                    });
                                                                    table.clearAll();
                                                                    if ($$("tienthuegtgtgiam")) {
                                                                        $$("tienthuegtgtgiam").setValue(0);
                                                                    }
                                                                    if ($$("tgtttbso_last")) {
                                                                        $$("tgtttbso_last").setValue(0);
                                                                    }     
                                                                    if ($$("tgtttbso")) {
                                                                        $$("tgtttbso").setValue(0);
                                                                    }    
                                                                    if ($$("tgtthue")) {
                                                                        $$("tgtthue").setValue(0);
                                                                    }    
                                                                    if ($$("tgtcthue")) {
                                                                        $$("tgtcthue").setValue(0);
                                                                    } 
                                                                    checkErro = true;
                                                                    break;
                                                                }
                                                            }  

                                                            if(item["lhhdthu"]===2){
                                                                if(item["bksptvchuyen"]===""){
                                                                    debugger
                                                                    webix.message("Dòng "+ row + " biển kiểm soát không được để trống với dịch vụ vận chuyển!" , "error");
                                                                    webix.alert({
                                                                        title: "Lỗi !",
                                                                        text: "Dòng "+ row + " biển kiểm soát không được để trống với dịch vụ vận chuyển!",
                                                                        type: "alert-error",
                                                                    });

                                                                    table.clearAll();
                                                                    if ($$("tienthuegtgtgiam")) {
                                                                        $$("tienthuegtgtgiam").setValue(0);
                                                                    }
                                                                    if ($$("tgtttbso_last")) {
                                                                        $$("tgtttbso_last").setValue(0);
                                                                    }     
                                                                    if ($$("tgtttbso")) {
                                                                        $$("tgtttbso").setValue(0);
                                                                    }    
                                                                    if ($$("tgtthue")) {
                                                                        $$("tgtthue").setValue(0);
                                                                    }    
                                                                    if ($$("tgtcthue")) {
                                                                        $$("tgtcthue").setValue(0);
                                                                    } 
                                                                    checkErro = true;
                                                                    break;
                                                                }
                                                                
                                                            }

                                                            if(item["lhhdthu"]===3){
                                                                if(item["mddnghang"]==="" || item["mstnghang"]==="" || item["dcnghang"]==="" || item["tnghang"]===""){
                                                                    webix.message("Dòng "+ row + " không được để trống với dịch vụ vận chuyển trên nền tảng số, TMĐT!" , "error");
                                                                    webix.alert({
                                                                        title: "Lỗi !",
                                                                        text: "Dòng "+ row + " không được để trống với dịch vụ vận chuyển trên nền tảng số, TMĐT!",
                                                                        type: "alert-error",
                                                                    });
                                                                    table.clearAll();
                
                                                                    checkErro = true;
                                                                    break;
                                                                }
                                                                
                                                            }
                                                        }
                                                        if(excel_id ==="EX00024" && (item["tgtien"]==="" && item["kmai"] !== 4)){
                                                            webix.message("Trường thành tiền bắt buộc nhập với tính chất khác ghi chú!" , "error");
                                                            webix.alert({
                                                                title: "Lỗi !",
                                                                text: "Trường thành tiền bắt buộc nhập với tính chất khác ghi chú!",
                                                                type: "alert-error",
                                                            });
                                                            table.clearAll();                        
                                                            checkErro = true;
                                                            break;
                                                        }

                                                        if(excel_id ==="EX00024" && (item["tgtien"]!=="" && item["kmai"] === 4)){
                                                            webix.message("Trường thành tiền không được nhập với tính chất ghi chú!" , "error");
                                                            webix.alert({
                                                                title: "Lỗi !",
                                                                text: "Trường thành tiền không được nhập với tính chất ghi chú!",
                                                                type: "alert-error",
                                                            });
                                                            table.clearAll();
                                                        
                                                            checkErro = true;
                                                            break;
                                                        }
                                                        if(checkErro)                                                         
                                                        {
                                                            break;   
                                                        }
                                                       
                                                        if(excel_id ==="EX00017" && item["tienthuegtgtgiam"]!==""){
                                                            isGiamTru = true;
                                                        }

                                                        if(excel_id !=="EX00024"){
                                                            if(item["kmai"]==="")
                                                              item["kmai"] = 1; 
                                                        }
                                                        table.add(item);                                           
                                                        table.updateItem(item.id, item);
                                        
                                                    }
                                                        
                                                    table.refreshColumns(); 

                                                    if(!checkErro){
                                                        webix.message("Import dữ liệu thành công!");
                                                    }

                                                    //Tắt tự động tính tiền
                                                    var checkbox = $$("tudongtinhtien");
                                                    if (checkbox) {
                                                        checkbox.setValue(0);
                                                    }
                                                    if(excel_id ==="EX00017"){
                                                        var checkbox = $$("giamthuebanhang20");
                                                        if(isGiamTru){
                                                            checkbox.setValue(1);
                                                        }
                                                    }
                                                };
                                                    
                                                reader.onerror = function () {
                                                        webix.message("Không thể đọc file Excel!", "error");
                                                };

                                                $$("uploadfile-win").enable();
                                                $$("uploadfile-win").hideProgress();
                                                webix.$$("uploadfile-win").close();
                                                return;
                                              
                                                
                                                // var kk = $$("uploader").files.data.pull;
                                                // console.log(kk);

                                                $$("uploader").send(function (response) {
                                                    var message = response.message || "Nhận dữ liệu Excel thành công !";
                                                    console.log(response);
                                                    console.log(message);
                                                    if (response != undefined) {
                                                        if (!response.hasOwnProperty("error")) {
                                                            $$("uploadfile-win").enable();
                                                            $$("uploadfile-win").hideProgress();
                                                            //this.callEvent("onUploadComplete");
                                                            // success call event onUploadComplete ở trên
                                                            var topParentView = this.getTopParentView();

                                                            if (topParentView.config.callback) {
                                                                topParentView.config.callback();
                                                                return;
                                                            }

                                                            if (topParentView.config.tableId !== undefined) {
                                                                var table = $$(topParentView.config.tableId);

                                                                if (table != null && table.config.url != undefined) {
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                }
                                                            }

                                                            webix.alert({
                                                                title: "Thành công !",
                                                                text: "<div class='v-message'>" + message + "</div>",
                                                                type: "alert-warning",
                                                                callback: function (result) {
                                                                    webix.$$("uploadfile-win").close();
                                                                },
                                                            });

                                                            //webix.message("Nhận dữ liệu Excel thành công !", "debug");
                                                        } else {
                                                            $$("uploadfile-win").enable();
                                                            $$("uploadfile-win").hideProgress();

                                                            webix.alert({
                                                                title: "Lỗi !",
                                                                text: response.error,
                                                                type: "alert-error",
                                                                callback: function (result) {
                                                                    webix.$$("uploadfile-win").close();
                                                                },
                                                                // callback: function (result) {
                                                                // 	webix.alert({
                                                                // 		title: "Custom title",
                                                                // 		ok: "Custom text",
                                                                // 		text: "Result: " + result
                                                                // 	});
                                                                // }
                                                            });
                                                            //webix.message(response.error, "error");
                                                        }
                                                    } else {
                                                        $$("uploadfile-win").enable();
                                                        $$("uploadfile-win").hideProgress();
                                                    }
                                                });



                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                    {
                                        hotkey: "esc",
                                        view: "button",
                                        type: "icon",
                                        icon: "fas fa-times",
                                        label: "Hủy bỏ (ESC)",
                                        width: 110,
                                        on: {
                                            onClick: function () {
                                                $$("mylist").clearAll();
                                                $$("mylist").unbind();
                                                var id = $$("uploader").files.getFirstId();
                                                if (id != undefined) {
                                                    $$("uploader").stopUpload(id);
                                                }
                                                webix.$$("uploadfile-win").close();
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                ],
                            },
                            {
                                rows: [
                                    // {view:"text",id:"df",label:"errr"},
                                    {
                                        id: "uploader",
                                        view: "uploader",
                                        value: "Chọn file",
                                        hide: true,
                                        name: "uploader",
                                        accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                        link: "mylist",
                                        autosend: false,
                                        //borderless: true,
                                        multiple: false,
                                        upload: app.config.host + "/System/UploadExcel",
                                        on: {
                                            onAfterRender: function () {
                                                //console.log('called once after first rendering:');
                                                this.hide();
                                            },
                                            onAfterFileAdd: function (file) {
                                                var fileName = file.name;
                                                if (!fileName.endsWith(".xls") && !fileName.endsWith(".xlsx")) {
                                                    webix.alert({
                                                        title: "Lỗi !",
                                                        text: "File không đúng định dạng Excel!",
                                                        type: "alert-error",
                                                        callback: function () {
                                                            $$("uploader").files.data.clearAll();
                                                        },
                                                    });
                                                }
                                                //console.log(file);
                                                // var kk = {
                                                // 	name: file.name,
                                                // 	lastModified: file.lastModified,
                                                // 	lastModifiedDate: file.lastModifiedDate,
                                                // 	webkitRelativePath: file.webkitRelativePath,
                                                // 	id: file.id,
                                                // 	size: file.size,
                                                // 	sizetext: file.sizetext,
                                                // 	status: file.status,
                                                // 	type: file.type
                                                // };
                                                // $$("mylist").add(kk);

                                                // console.log($$("mylist").getIdByIndex(0));
                                                // var id = $$("mylist").getIdByIndex(0);
                                                // console.log($$("mylist").getItem(id));
                                                $$("mylist").refresh();
                                                //$$("mylist").show();
                                            },
                                            onUploadComplete: function (response) {
                                                // var topParentView = this.getTopParentView();

                                                // if (topParentView.config.tableId !== undefined) {
                                                // 	var table = $$(topParentView.config.tableId);

                                                // 	if (table != null) {
                                                // 		table.clearAll();
                                                // 		table.load(table.config.url);
                                                // 	}
                                                // }
                                                // webix.message("Upload File thành công !", "debug");
                                                // webix.$$("uploadfile-win").close();

                                                if (response === undefined) return;

                                                if (response.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: response.error });
                                                }
                                            },
                                            onFileUploadError: function (file, response) {
                                                console.log(file);
                                                console.log(response);
                                                $$("uploadfile-win").enable();
                                                $$("uploadfile-win").hideProgress();
                                            },
                                        },
                                        apiOnly: true,
                                    },
                                    {
                                        view: "list",
                                        id: "mylist",
                                        type: "uploader",
                                        height: 100,
                                        //autoheight: true
                                        borderless: true,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
    };
});

define('views/forms/uploadexceltemplate',["app", "locale"], function (app, _) {

	return {
		$ui: {
			view: "window", modal: true, id: "uploadfile-win", position: "center",
			head: "Nhận dữ liệu từ file Excel",
			width: 500,
			height: 500,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 100 },
				view: "form",
				id: "uploadfile-form",
				complexData: true,
				elements: [
					{
						cols: [
							{
								view: "toolbar",
								css: { "background": "#e6f7ff !important" },
								rows: [
									{
										view: "button", type: "icon", icon: "fas fa-folder-open", label: "Chọn file", width: 110,
										on: {
											onClick: function () {
												webix.$$("uploader").fileDialog();
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										view: "button", type: "icon", icon: "fas fa-download", label: "Tải file mẫu", width: 110,
										on: {
											onClick: function () {
												var uploader = webix.$$("uploader");
												debugger;
												var formData = uploader.config.formData;
												var filename = formData["filename"] == null ? "template.xlsx" : formData["filename"];
												var parent_code = formData["parent_code"];
												var table = $$("uploadfile-win");
												webix.extend(table, webix.ProgressBar);
												table.disable();
												table.showProgress();
												webix.ajax()
													.bind({filename: filename})
													.response("arraybuffer")
													.headers({ 'Content-type': 'application/json' })
													.get(app.config.host + "/System/DownloadFileExcelTemplate?id=" + formData["excel_id"] + "&branch_code=" + parent_code, function (text, data, XmlHttpRequest) {
														webix.delay(function (filename) {
															var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
															var fileURL = URL.createObjectURL(file);

															var link = document.createElement('a');
															document.body.appendChild(link);
															link.download = filename;
															link.href = fileURL;
															link.click();
															document.body.removeChild(link); // remove the link when done
														}, null, [filename], 500);

														table.enable();
														table.hideProgress();
													});
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										shortcut: "F10", view: "button", type: "icon", icon: "fas fa-check", label: "Nhận file (F10)", width: 120, on: {
											onClick: function () {
												var table = $$("uploadfile-win");
												webix.extend(table, webix.ProgressBar);
												table.disable();
												table.showProgress();
												var file = $$("uploader").files.getFirstId();
												if (file == undefined || file == null) {
													webix.message("Bạn chưa chọn file !", "error");
													$$("uploadfile-win").enable();
													$$("uploadfile-win").hideProgress();
													return;
												}
												$$("uploader").send(function (response) {
													var message = response.message || "Nhập file Excel thành công !";
													if (response != undefined) {

														if (!response.hasOwnProperty("error")) {
															$$("uploadfile-win").enable();
															$$("uploadfile-win").hideProgress();
															var topParentView = this.getTopParentView();

															if (topParentView.config.callback){
																topParentView.config.callback();
																return;
															}

															if (topParentView.config.tableId !== undefined) {
																var table = $$(topParentView.config.tableId);

																if (table != null && table.config.url!=undefined) {
																	table.clearAll();
																	table.load(table.config.url);
																}
															}

															webix.alert({
																title: "Thành công !",
																text: "<div class='v-message'>"+message+"</div>",
																type: "alert-warning",
																callback: function (result) {
																	webix.$$("uploadfile-win").close();
																}
															});

														}
														else {
															$$("uploadfile-win").enable();
															$$("uploadfile-win").hideProgress();

															webix.alert({
																title: "Lỗi !",
																text: response.error,
																type: "alert-error",
                                                                callback: function (result) {
																	webix.$$("uploadfile-win").close();
																}
															});
														}
													}
													else {
														$$("uploadfile-win").enable();
														$$("uploadfile-win").hideProgress();
													}
												});
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										hotkey: "esc", view: "button", type: "icon", icon: "fas fa-times", label: "Hủy bỏ (ESC)", width: 110,
										on: {
											onClick: function () {
												$$("mylist").clearAll();
												$$("mylist").unbind();
												var id = $$("uploader").files.getFirstId();
												if (id != undefined) {
													$$("uploader").stopUpload(id);
												}
												webix.$$("uploadfile-win").close();
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									}

								]
							},
							{
								rows: [
									{
										id: "uploader",
										view: "uploader",
										value: 'Chọn file',
										hide: true,
										name: "uploader",
										accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
										link: "mylist",
										autosend: false,
										multiple: false,
										upload: app.config.host + "/System/UploadExcelTemplate",
										on: {
											onAfterRender: function () {
												this.hide();
											},
											onAfterFileAdd: function (file) {
												var fileName = file.name;
												if (!fileName.endsWith(".xls") && !fileName.endsWith(".xlsx")) {
													webix.alert({
														title: "Lỗi !",
														text: "File không đúng định dạng Excel!",
														type: "alert-error",
														callback: function () {
															$$("uploader").files.data.clearAll();
														}
													});
												}
											},
											onUploadComplete: function (response) {
												if (response === undefined) return;

												if (response.hasOwnProperty("error")){
													webix.message({type:"error",text:response.error});
												}
											},
											onFileUploadError: function (file, response) {
												$$("uploadfile-win").enable();
												$$("uploadfile-win").hideProgress();
											}
										},
										apiOnly: true,
									},
									{
										view: "list",
										id: "mylist",
										type: "uploader",
										height: 100,
										borderless: true
									}
								]
							}

						]
					}
				]
			}

		}

	};

});
define('views/forms/uploadexceluser',["app", "locale"], function (app, _) {

	// var dialog = webix.ui({
	// 	id: "uploader",
	// 	view: "uploader",
	// 	value: 'Chọn file',
	// 	name: "uploader",
	// 	accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	// 	link: "mylist",
	// 	autosend: false,
	// 	//borderless: true,
	// 	multiple: false,
	// 	upload: app.config.host + "/System/UploadExcel",
	// 	on: {
	// 		onAfterFileAdd: function (file) {
	// 			//console.log(file);
	// 			// var kk = {
	// 			// 	name: file.name, 
	// 			// 	lastModified: file.lastModified,
	// 			// 	lastModifiedDate: file.lastModifiedDate,
	// 			// 	webkitRelativePath: file.webkitRelativePath,
	// 			// 	id: file.id,
	// 			// 	size: file.size,
	// 			// 	sizetext: file.sizetext,
	// 			// 	status: file.status,
	// 			// 	type: file.type
	// 			// };
	// 			// $$("mylist").add(kk);

	// 			// console.log($$("mylist").getIdByIndex(0));
	// 			// var id = $$("mylist").getIdByIndex(0);
	// 			// console.log($$("mylist").getItem(id));
	// 			$$("mylist").refresh();
	// 			//$$("mylist").show();

	// 		},
	// 		onUploadComplete: function (response) {
	// 			// var topParentView = this.getTopParentView();

	// 			// if (topParentView.config.tableId !== undefined) {
	// 			// 	var table = $$(topParentView.config.tableId);

	// 			// 	if (table != null) {
	// 			// 		table.clearAll();
	// 			// 		table.load(table.config.url);
	// 			// 	}
	// 			// }
	// 			// webix.message("Upload File thành công !", "debug");
	// 			// webix.$$("uploadfile-win").close();
	// 		},
	// 		onFileUploadError: function (file, response) {
	// 			console.log(file);
	// 			console.log(response);
	// 		}
	// 	},
	// 	apiOnly: true,
	// });

	return {
		$ui: {
			view: "window", modal: true, id: "uploadfile-win", position: "center",
			head: "Nhận dữ liệu từ file Excel",
			width: 500,
			height: 500,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 100 },
				view: "form",
				id: "uploadfile-form",
				complexData: true,
				elements: [
					{
						cols: [
							{
								view: "toolbar",
								css: { "background": "#e6f7ff !important" },
								rows: [
									// { gravity: 2 },
									{
										view: "button", type: "icon", icon: "fas fa-folder-open", label: "Chọn file", width: 110,
										on: {
											onClick: function () {
												webix.$$("uploader").fileDialog();
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										view: "button", type: "icon", icon: "fas fa-download", label: "Tải file mẫu", width: 110,
										on: {
											onClick: function () {
												var uploader = webix.$$("uploader");
												var formData = uploader.config.formData;
												var filename = formData["filename"] == null ? "template.xlsx" : formData["filename"];
												var table = $$("uploadfile-win");
												// webix.extend(table, webix.OverlayBox);
												webix.extend(table, webix.ProgressBar);
												table.disable();
												table.showProgress();
												webix.ajax()
													.bind({filename: filename})
													.response("arraybuffer")
													.headers({ 'Content-type': 'application/json' })
													.get(app.config.host + "/System/DownloadFileExcelTemplate?id=" + formData["excel_id"], function (text, data, XmlHttpRequest) {
														webix.delay(function (filename) {
															var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
															var fileURL = URL.createObjectURL(file);

															var link = document.createElement('a');
															document.body.appendChild(link);
															link.download = filename;
															link.href = fileURL;
															link.click();
															document.body.removeChild(link); // remove the link when done
															//document.location.href = fileURL;
														}, null, [filename], 500);

														table.enable();
														table.hideProgress();
													});
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										shortcut: "F10", view: "button", type: "icon", icon: "fas fa-check", label: "Nhận file (F10)", width: 120, on: {
											onClick: function () {
												var table = $$("uploadfile-win");
												// webix.extend(table, webix.OverlayBox);
												webix.extend(table, webix.ProgressBar);
												table.disable();
												table.showProgress();
												var file = $$("uploader").files.getFirstId();
												if (file == undefined || file == null) {
													webix.message("Bạn chưa chọn file !", "error");
													$$("uploadfile-win").enable();
													$$("uploadfile-win").hideProgress();
													return;
												}
												// var kk = $$("uploader").files.data.pull;
												// console.log(kk);
												$$("uploader").send(function (response) {
													var message = response.message || "Nhận dữ liệu Excel thành công !";
													console.log(response);
													console.log(message);
													if (response != undefined) {

														if (!response.hasOwnProperty("error")) {
															$$("uploadfile-win").enable();
															$$("uploadfile-win").hideProgress();
															//this.callEvent("onUploadComplete");
															// success call event onUploadComplete ở trên 
															var topParentView = this.getTopParentView();

															// if (topParentView.config.callback){
															// 	topParentView.config.callback();
															// 	return;
															// }

															if (topParentView.config.tableId !== undefined) {
																var table = $$(topParentView.config.tableId);

																if (table != null && table.config.url!=undefined) {
																	table.clearAll();
																	table.load(table.config.url);
																}
															}

															webix.alert({
																title: "Thành công !",
																text: "<div class='v-message'>"+message+"</div>",
																type: "alert-warning",
																callback: function (result) {
																	webix.$$("uploadfile-win").close();
																}
															});

															//webix.message("Nhận dữ liệu Excel thành công !", "debug");

														}
														else {
															$$("uploadfile-win").enable();
															$$("uploadfile-win").hideProgress();

															webix.alert({
																title: "Lỗi !",
																text: response.error,
																type: "alert-error",
																callback: function (result) {
																	webix.$$("uploadfile-win").close();
																}
																// callback: function (result) {
																// 	webix.alert({
																// 		title: "Custom title",
																// 		ok: "Custom text",
																// 		text: "Result: " + result
																// 	});
																// }
															});
															//webix.message(response.error, "error");
														}
													}
													else {
														$$("uploadfile-win").enable();
														$$("uploadfile-win").hideProgress();
													}
												});
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										hotkey: "esc", view: "button", type: "icon", icon: "fas fa-times", label: "Hủy bỏ (ESC)", width: 110,
										on: {
											onClick: function () {
												$$("mylist").clearAll();
												$$("mylist").unbind();
												var id = $$("uploader").files.getFirstId();
												if (id != undefined) {
													$$("uploader").stopUpload(id);
												}
												webix.$$("uploadfile-win").close();
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									}

								]
							},
							{
								rows: [
									// {view:"text",id:"df",label:"errr"},
									{
										id: "uploader",
										view: "uploader",
										value: 'Chọn file',
										hide: true,
										name: "uploader",
										accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
										link: "mylist",
										autosend: false,
										//borderless: true,
										multiple: false,
										upload: app.config.host + "/System/UploadExcelListUnit",
										on: {
											onAfterRender: function () {
												//console.log('called once after first rendering:');
												this.hide();
											},
											onAfterFileAdd: function (file) {
												//console.log(file);
												// var kk = {
												// 	name: file.name, 
												// 	lastModified: file.lastModified,
												// 	lastModifiedDate: file.lastModifiedDate,
												// 	webkitRelativePath: file.webkitRelativePath,
												// 	id: file.id,
												// 	size: file.size,
												// 	sizetext: file.sizetext,
												// 	status: file.status,
												// 	type: file.type
												// };
												// $$("mylist").add(kk);

												// console.log($$("mylist").getIdByIndex(0));
												// var id = $$("mylist").getIdByIndex(0);
												// console.log($$("mylist").getItem(id));
												$$("mylist").refresh();
												//$$("mylist").show();

											},
											onUploadComplete: function (response) {
												// var topParentView = this.getTopParentView();

												// if (topParentView.config.tableId !== undefined) {
												// 	var table = $$(topParentView.config.tableId);

												// 	if (table != null) {
												// 		table.clearAll();
												// 		table.load(table.config.url);
												// 	}
												// }
												// webix.message("Upload File thành công !", "debug");
												// webix.$$("uploadfile-win").close();

												if (response === undefined) return;

												if (response.hasOwnProperty("error")){
													webix.message({type:"error",text:response.error});
												}
											},
											onFileUploadError: function (file, response) {
												console.log(file);
												console.log(response);
												$$("uploadfile-win").enable();
												$$("uploadfile-win").hideProgress();
											}
										},
										apiOnly: true,
									},
									{
										view: "list",
										id: "mylist",
										type: "uploader",
										height: 100,
										//autoheight: true
										borderless: true
									}
								]
							}

						]
					}
				]
			}

		}

	};

});
define('views/forms/uploadfile',["app"],function(app){
	
	return {		
		$ui:{
			view:"window", modal:true, id:"uploadfile-win", position:"center",
			head:"Tải file",
			body:{
                paddingY:20, 
                paddingX:30, 
                elementsConfig:{labelWidth: 100}, 
                view:"form", 
				id:"uploadfile-form", 
				complexData:true,
                elements:[
					{ 
						id:"uploader",
						view: "uploader", 
						value: 'Upload file', 
						name:"file",
						//accept:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
						link:"mylist",
						//upload: app.config.host + "/System/UploadExcel" ,
						on: {
							onUploadComplete: function(response){
								
								if (response.hasOwnProperty("error")){
									webix.message({ type:"error",text:response["error"]});
									return;
								}

								var topParentView = this.getTopParentView();

								if (topParentView.config.tableId !== undefined){
									var table = $$(topParentView.config.tableId);

									if (table!=null){
										table.clearAll();
										table.load(table.config.url);
									}
								}
								if (response.hasOwnProperty("success")){
									webix.message({ type:"success",text:response["success"]});
								}
								webix.$$("uploadfile-win").close();	
							}
						}
					},
					{
						view:"list",  
						id:"mylist", 
						type:"uploader",
						autoheight:true, borderless:true	
					},
					{
						view: "button",
						label: "Hủy bỏ",
						click: function() {
							webix.$$("uploadfile-win").close();							
						}
					}
				]
			}			
			
		}	
		
	};

});
define('views/forms/usertracuu',["app", "models/user", "views/menus/version"], function (app, user, version) {
    var editmode = 0;
    function initUI(item) {
        var form = $$("usertracuu-win");

        webix.extend(form, webix.ProgressBar);
        form.disable();
        form.showProgress();

        var mst = version.getMST();
        var schema = version.GetSchema();
        //console.log(schema);
        item.mst = mst;
        // item.mst = "0100686209";
        item.schema_name = schema;
        webix
            .ajax()
            .headers({ "content-type": "application/json" })
            .post(app.config.host + "/Invoice/GetUserTracuu", item, function (result) {
                form.enable();
                form.hideProgress();
                var data = JSON.parse(result);
                if (!data.hasOwnProperty("error")) {
                    var btnEdit = webix.$$("btnSavve");
                    btnEdit.define("label", "Sửa");
                    btnEdit.refresh();
                    data.ma_dt = data.code_customer;
                    data.mst = data.tax_code;
                    $$("usertracuu-form").setValues(data);
                } else {
                    webix.message(data.error, "debug");
                    $$("schema_name").setValue(item.schema_name);
                    $$("mst").setValue(item.mst);
                    // $$("mst").setValue("0100686209");
                    $$("email").setValue(item.email);
                    $$("username").setValue(item.code.replace(/[^a-zA-Z0-9 ]/g, ""));
                    $$("ma_dt").setValue(item.code);
                }
            });
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "usertracuu-win",
            position: "center",
            move: true,
            resize: true,
            head: "Thông tin khách hàng hỗ trợ",
            body: {
                paddingY: 10,
                paddingX: 10,
                //elementsConfig: { labelWidth: 100 },
                view: "form",
                width: 500,
                // height: 150,
                id: "usertracuu-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "text",
                        label: "Chema name: ",
                        labelWidth: 80,
                        name: "schema_name",
                        id: "schema_name",
                        readonly: true,
                        hidden: true,
                        css: "mcls_readonly_text",
                    },
                    {
                        view: "text",
                        label: "Mã số thuế: ",
                        labelWidth: 80,
                        name: "mst",
                        id: "mst",
                        readonly: true,
                        css: "mcls_readonly_text",
                        hidden: true,
                    },
                    {
                        view: "text",
                        label: "Mã KH : ",
                        labelWidth: 80,
                        name: "ma_dt",
                        id: "ma_dt",
                        readonly: true,
                        css: "mcls_readonly_text",
                    },
                    {
                        view: "text",
                        label: "Username ",
                        labelWidth: 80,
                        name: "username",
                        id: "username",
                        // readonly: true,
                        readonly: true,
                        css: "mcls_readonly_text",
                        required: true,
                        invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
                        validate: webix.rules.isSpecialCharacter,
                    },
                    {
                        view: "text",
                        label: "Password: ",
                        labelWidth: 80,
                        name: "password",
                        id: "password",
                        //value: "minvoice",
                        required: true,
                        invalidMessage: "Password không được để trống",
                    },
                    {
                        view: "text",
                        label: "Email: ",
                        labelWidth: 80,
                        name: "email",
                        id: "email",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button",
                                id: "btnSavve",
                                type: "image",
                                image: "assets/imgs/save.png",
                                label: "Lưu",
                                width: 60,
                                click: function () {
                                    var form = webix.$$("usertracuu-form");
                                    var item = form.getValues();

                                    if ($$("usertracuu-form").validate()) {
                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();
                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/Invoice/CreateUser_tracuu", item, function (text) {
                                                var data = JSON.parse(text);

                                                if (!data.hasOwnProperty("error")) {
                                                    webix.message(data.ok, "success");
                                                    webix.$$("usertracuu-win").close();
                                                } else {
                                                    webix.message(data.error, "error");
                                                }
                                                form.enable();
                                                form.hideProgress();
                                            });
                                    }
                                },
                            },
                            {
                                view: "button",
                                type: "image",
                                image: "assets/imgs/reset.png",
                                label: "Reset Password",
                                width: 130,
                                click: function () {
                                    var form = webix.$$("usertracuu-form");
                                    var item = form.getValues();

                                    webix.confirm({
                                        text: "Bạn có chắc chắn muốn reset mật khẩu về mật khẩu mặc định ?",
                                        ok: "Có",
                                        cancel: "Không",
                                        callback: function (res) {
                                            if (res) {
                                                webix.extend(form, webix.ProgressBar);
                                                form.disable();
                                                form.showProgress();
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice/ResetPassUserTracuu", item, function (text) {
                                                        var data = JSON.parse(text);

                                                        if (!data.hasOwnProperty("error")) {
                                                            webix.message(data.ok, "success");
                                                            webix.$$("usertracuu-win").close();
                                                        } else {
                                                            webix.message(data.error, "error");
                                                        }
                                                        form.enable();
                                                        form.hideProgress();
                                                    });
                                            }
                                        },
                                    });
                                },
                            },
                            {
                                view: "button",
                                id: "btnXoa",
                                type: "image",
                                image: "assets/imgs/xoa.png",
                                label: "Xóa",
                                width: 60,
                                click: function () {
                                    var form = webix.$$("usertracuu-form");
                                    var item = form.getValues();
                                    webix.confirm({
                                        text: "Bạn có chắc chắn muốn xóa tài khoản ?",
                                        ok: "Có",
                                        cancel: "Không",
                                        callback: function (res) {
                                            if (res) {
                                                webix
                                                    .ajax()
                                                    .headers({ "Content-type": "application/json" })
                                                    .post(app.config.host + "/Invoice/DeleteUserTracuu", item, function (text) {
                                                        var data = JSON.parse(text);

                                                        if (!data.hasOwnProperty("error")) {
                                                            webix.message(data.ok, "success");
                                                            webix.$$("usertracuu-win").close();
                                                        } else {
                                                            webix.message(data.error, "error");
                                                        }
                                                    });
                                            }
                                        },
                                    });
                                },
                            },
                            {
                                view: "button",
                                type: "image",
                                image: "assets/imgs/close.png",
                                label: "Hủy bỏ",
                                hotkey: "esc",
                                width: 80,
                                click: function () {
                                    webix.$$("usertracuu-win").close();
                                },
                            },
                            {},
                        ],
                    },
                ],
            },
        },
        initUI: initUI,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (item) {
            var form = webix.$$("usertracuu-form");
            // var table = webix.$$("discountTable");

            form.setValues(item);
            // table.parse(item.hp_hsgiamtrus, "json");
        },
    };
});

define('views/forms/xoabo',["app", "locale", "models/user", "views/modules/minvoiceplugin"], function (app, _, user, plugin) {
    var editmode = 0;

    function signOnServer(data, cert, server_cert) {

        var parameters = {
            xml: data["InvoiceXmlData"],
            refUri: "#data",
            certSerial: cert.so_serial,
            tokenSerial: cert.tokenSerial,
            signId: "seller",
            signTag: "Signatures",
            pass: cert.pass,
            inv_InvoiceAuth_id: data["inv_InvoiceAuth_id"]
        };

        data.serialNumber = cert.so_serial;

        webix.ajax()
            .bind(data)
            .headers({ "Content-Type": "application/json" })
            .post(server_cert + "/Token/SignXml", parameters, function (text) {
                var json = JSON.parse(text);

                if (json.hasOwnProperty("error")) {
                    webix.message({ type: "error", text: json["error"] });

                    var form = webix.$$("chukyso-form");
                    form.enable();
                    form.hideProgress();
                }
                else {
                    var parameters = this;
                    parameters.InvoiceXmlData = json.xml;

                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice/SaveInvoiceXoaBo", parameters, function (text) {
                            var result = JSON.parse(text);

                            var form = webix.$$("chukyso-form");
                            form.enable();
                            form.hideProgress();

                            if (result.hasOwnProperty("error")) {
                                webix.message({ type: "error", text: result["error"] });
                            }
                            else {
                                var table = webix.$$("windowData");
                                table.clearAll();
                                table.load(table.config.url);

                                $$("chukyso-win").close();
                            }

                        });

                }
            });
    }


    function signOnServerFile(data, cert, server_cert) {

        var parameters = {
            xml: data["InvoiceXmlData"],
            refUri: "#data",
            certSerial: cert.so_serial,
            tokenSerial: cert.tokenSerial,
            signId: "seller",
            signTag: "Signatures",
            pass: cert.pass,
            path: cert.path,
            inv_InvoiceAuth_id: data["inv_InvoiceAuth_id"]
        };

        data.serialNumber = cert.so_serial;

        webix.ajax()
            .bind(data)
            .headers({ "Content-Type": "application/json" })
            .post(server_cert + "/Token/SignXmlByFile", parameters, function (text) {
                var json = JSON.parse(text);

                if (json.hasOwnProperty("error")) {
                    webix.message({ type: "error", text: json["error"] });

                    var form = webix.$$("chukyso-form");
                    form.enable();
                    form.hideProgress();
                }
                else {
                    var parameters = this;
                    parameters.InvoiceXmlData = json.xml;

                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice/SaveInvoiceXoaBo", parameters, function (text) {
                            var result = JSON.parse(text);

                            var form = webix.$$("chukyso-form");
                            form.enable();
                            form.hideProgress();

                            if (result.hasOwnProperty("error")) {
                                webix.message({ type: "error", text: result["error"] });
                            }
                            else {
                                var table = webix.$$("windowData");
                                table.clearAll();
                                table.load(table.config.url);

                                $$("chukyso-win").close();
                            }

                        });

                }
            });
    }

    function signOnCertFile(cert){
        
        var form = webix.$$("chukyso-form");

        var item = form.getValues();
        var table = webix.$$("windowData");
        var selectedItem = table.getSelectedItem();

        var postData={
            username:user.getCurrentUser(),
            branch_code:"",
            template_code:selectedItem.template_code,
            invoice_series:selectedItem.invoice_series,
            invoice_number:selectedItem.invoice_number,
            cer_serial:cert.so_serial,
            ngayvb:moment(item.ngayvb).format("YYYY-MM-DD"),
            sovb:item.sovb,
            ghi_chu:item.ghi_chu
        };

        webix.ajax()
            .headers({'Content-Type':'application/json'})
            .post(app.config.host + "/Invoice/DeleteByCertFile",postData,function(text){
                var res=JSON.parse(text);

                var form = webix.$$("chukyso-form");
                form.enable();
                form.hideProgress();

                if (res.hasOwnProperty("error")){
                    webix.message({type:"error",text:res.error});
                }
                else {
                    var table = webix.$$("windowData");
                    table.clearAll();
                    table.load(table.config.url);

                    $$("chukyso-win").close();
                }
            });
    }

    return {
        $ui: {
            view: "window", modal: true, id: "chukyso-win", position: "center",
            head: "Xoá bỏ hóa đơn",
            width: 400,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "chukyso-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "text",
                        label: _("SOVB"),
                        labelPosition: "top",
                        name: "sovb",
                        required: true,
                        invalidMessage: "Số văn bản không được để trống"
                    },
                    {
                        view: "datepicker",
                        label: _("NGAYVB"),
                        labelPosition: "top",
                        name: "ngayvb",
                        format: "%d/%m/%Y",
                        required: true,
                        invalidMessage: "Ngày văn bản không được để trống"
                    },
                    {
                        view: "textarea",
                        name: "ghi_chu",
                        label: _("GHI_CHU"),
                        labelPosition: "top",
                        height: 150
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Lưu (F10)", type: "form", align: "center", width: 100,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("chukyso-form");

                                        if (form.validate() == false) return;

                                        var item = form.getValues();

                                        var table = webix.$$("windowData");
                                        var selectedItem = table.getSelectedItem();

                                        var a = webix.ajax()
                                            .headers({ "Content-Type": "application/json" })
                                            .post(app.config.host + "/Invoice/GetThongTinXoaBo", {
                                                id: selectedItem.id,
                                                sovb: item.sovb,
                                                ngayvb: item.ngayvb,
                                                ghi_chu: item.ghi_chu
                                            });

                                        var b = webix.ajax(app.config.host + "/Invoice/GetListCertificates");

                                        var c = webix.ajax()
                                            .headers({ "Content-Type": "application/json" })
                                            .post(app.config.host + "/System/ExecuteCommand", {
                                                command: "CM00019",
                                                parameter: {
                                                    ma_dvcs: ""
                                                }
                                            });

                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();

                                        webix.promise.all([a, b, c]).then(function (results) {
                                            var a_result = results[0].json();
                                            var listcerts = results[1].json();
                                            var c_result = results[2].json();

                                            var form = webix.$$("chukyso-form");

                                            if (listcerts.length == 0) {
                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });

                                                form.enable();
                                                form.hideProgress();

                                                return;
                                            }

                                            if (a_result.hasOwnProperty("error")) {
                                                webix.message({ type: 'error', text: a_result.error });

                                                form.enable();
                                                form.hideProgress();

                                                return;

                                            }

                                            var kytaptrung = "";
                                            var server_cert = "";

                                            for (var i = 0; i < c_result.length; i++) {
                                                var item = c_result[i];

                                                if (item.ma == "KYTAPTRUNG") {
                                                    kytaptrung = item.gia_tri;
                                                }

                                                if (item.ma == "SERVER_CERT") {
                                                    server_cert = item.gia_tri;
                                                }
                                            }

                                            //console.log(listcerts.length);

                                            if (kytaptrung == "C") {
                                                if (listcerts.length == 1) {
                                                    signOnServer(a_result, listcerts[0], server_cert);
                                                }
                                                else {
                                                    var box = webix.modalbox({
                                                        title: "Chọn chứng thư số",
                                                        buttons: ["Nhận", "Hủy bỏ"],
                                                        text: "<div id='ctnCerts'></div>",
                                                        top: 100,
                                                        width: 750,
                                                        callback: function (result) {
                                                            switch (result) {
                                                                case "1":
                                                                    var form = webix.$$("chukyso-form");
                                                                    form.enable();
                                                                    form.hideProgress();

                                                                    webix.modalbox.hide();
                                                                    break;
                                                                case "0":
                                                                    var table = $$("tblCerts");
                                                                    var data = table.serialize();

                                                                    var cert = null;

                                                                    for (var i = 0; i < data.length; i++) {
                                                                        if (data[i].chon == true) {
                                                                            cert = data[i];
                                                                            break;
                                                                        }
                                                                    }

                                                                    if (cert == null) {
                                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                                        return;
                                                                    }

                                                                    webix.modalbox.hide();                                                                    
                                                                    signOnServer(table.config.xmlData, cert, table.config.server_cert);

                                                                    break;
                                                            }
                                                        }
                                                    });

                                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                    popupText.style.paddingTop = 0;

                                                    var tblMatHang = webix.ui({
                                                        container: "ctnCerts",
                                                        id: "tblCerts",
                                                        view: "datatable",
                                                        borderless: true,
                                                        xmlData: a_result,
                                                        server_cert: server_cert,
                                                        height: 350,
                                                        columns: [
                                                            {
                                                                id: "chon",
                                                                header: _("CHON"),
                                                                width: 65,
                                                                checkValue: true,
                                                                uncheckValue: false,
                                                                template: "{common.checkbox()}"
                                                            },
                                                            {
                                                                id: "cert_type",
                                                                header: _("Loại"),
                                                                width: 100,
                                                            },
                                                            {
                                                                id: "so_serial",
                                                                header: _("SO_SERIAL"),
                                                                width: 150
                                                            },
                                                            {
                                                                id: "subjectname",
                                                                header: _("SUBJECTNAME"),
                                                                width: 450
                                                            },
                                                            {
                                                                id: "ngaybatdau",
                                                                header: _("NGAY_BAT_DAU"),
                                                                width: 200
                                                            },
                                                            {
                                                                id: "ngayketthuc",
                                                                header: _("NGAY_KET_THUC"),
                                                                width: 200
                                                            },
                                                            {
                                                                id: "issuer",
                                                                header: _("DONVI"),
                                                                width: 450
                                                            },
                                                        ],
                                                        url: app.config.host + "/Invoice/GetListCertificates"
                                                    });
                                                }
                                            }
                                            else {
                                                if (kytaptrung == "FILE") {
                                                    var box = webix.modalbox({
                                                        title: "Chọn chứng thư số",
                                                        buttons: ["Nhận", "Hủy bỏ"],
                                                        text: "<div id='ctnCerts'></div>",
                                                        top: 100,
                                                        width: 750,
                                                        callback: function (result) {
                                                            switch (result) {
                                                                case "1":
                                                                    var form = webix.$$("chukyso-form");
                                                                    form.enable();
                                                                    form.hideProgress();

                                                                    webix.modalbox.hide();
                                                                    break;
                                                                case "0":
                                                                    var table = $$("tblCerts");
                                                                    var data = table.serialize();

                                                                    var cert = null;

                                                                    for (var i = 0; i < data.length; i++) {
                                                                        if (data[i].chon == true) {
                                                                            cert = data[i];
                                                                            break;
                                                                        }
                                                                    }

                                                                    if (cert == null) {
                                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                                        return;
                                                                    }

                                                                    webix.modalbox.hide();
                                                                    signOnServerFile(table.config.xmlData, cert, table.config.server_cert);

                                                                    break;
                                                            }
                                                        }
                                                    });

                                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                    popupText.style.paddingTop = 0;

                                                    var tblMatHang = webix.ui({
                                                        container: "ctnCerts",
                                                        id: "tblCerts",
                                                        view: "datatable",
                                                        borderless: true,
                                                        xmlData: a_result,
                                                        server_cert: server_cert,
                                                        height: 350,
                                                        columns: [
                                                            {
                                                                id: "chon",
                                                                header: _("CHON"),
                                                                width: 65,
                                                                checkValue: true,
                                                                uncheckValue: false,
                                                                template: "{common.checkbox()}"
                                                            },
                                                            {
                                                                id: "cert_type",
                                                                header: _("Loại"),
                                                                width: 100,
                                                            },
                                                            {
                                                                id: "so_serial",
                                                                header: _("SO_SERIAL"),
                                                                width: 150
                                                            },
                                                            {
                                                                id: "subjectname",
                                                                header: _("SUBJECTNAME"),
                                                                width: 450
                                                            },
                                                            {
                                                                id: "ngaybatdau",
                                                                header: _("NGAY_BAT_DAU"),
                                                                width: 200
                                                            },
                                                            {
                                                                id: "ngayketthuc",
                                                                header: _("NGAY_KET_THUC"),
                                                                width: 200
                                                            },
                                                            {
                                                                id: "issuer",
                                                                header: _("DONVI"),
                                                                width: 450
                                                            },
                                                        ],
                                                        url: app.config.host + "/Invoice/GetListCertificatesFile"
                                                    });
                                                }
                                                else {

                                                    if (listcerts.length == 1){
                                                        var cert = listcerts[0];

                                                        if (cert.cert_type == "FILE"){
                                                            signOnCertFile(cert);
                                                            return;
                                                        }
                                                    }
                                                    
                                                    console.log("Signature_Client");
                                                    //console.log(a_result);
                                                    var resultTime;
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .get(app.config.host + "/System/GetDate", function (text) {
                                                            resultTime = JSON.parse(text);
                                                        });
                                                    var hub = plugin.hub();

                                                    hub.off('resCommand');
                                                    hub.on('resCommand', function (result) {
                                                        var json = JSON.parse(result);
                                                        console.log(json);
                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: 'error', text: json.error });

                                                            var form = webix.$$("chukyso-form");
                                                            form.enable();
                                                            form.hideProgress();

                                                        }
                                                        else {

                                                            var callback = json.callback;

                                                            if (callback == "SignCancelInvoice") {
                                                                var parameters = json.data;

                                                                webix.ajax()
                                                                    .headers({ "Content-Type": "application/json" })
                                                                    .post(app.config.host + "/Invoice/SaveInvoiceXoaBo", parameters, function (text) {
                                                                        var result = JSON.parse(text);

                                                                        var form = webix.$$("chukyso-form");
                                                                        form.enable();
                                                                        form.hideProgress();

                                                                        if (result.hasOwnProperty("error")) {
                                                                            webix.message({ type: "error", text: result["error"] });
                                                                        }
                                                                        else {
                                                                            var table = webix.$$("windowData");
                                                                            table.clearAll();
                                                                            table.load(table.config.url);

                                                                            $$("chukyso-win").close();
                                                                        }
                                                                    });
                                                            }
                                                        }
                                                    });

                                                    var arg = {
                                                        callback: "SignCancelInvoice",
                                                        idData: "#data",
                                                        data: a_result,
                                                        idSigner: "seller",
                                                        tagSign: "Signatures",
                                                        dateKy: resultTime.dateKy,
                                                        listcerts: listcerts
                                                    };


                                                    hub.invoke('execCommand', arg.callback, JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success done !");
                                                            //console.log("2");
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                        });
                                                }
                                            }

                                        }).fail(function (err) {
                                            alert(err);

                                            var form = webix.$$("chukyso-form");
                                            form.enable();
                                            form.hideProgress();
                                        });

                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                                click: function () {
                                    webix.$$("chukyso-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }

        },
        setEditMode: function (mode) {
            editmode = mode;
        }
    };

});
define('views/hotro',["app", "locale", "views/forms/license"], function (app, _, licenseForm) {
    

    webix.$$("title").parse({ title: "Gửi yêu cầu hỗ trợ đến MobiFone Invoice", details: "Gửi yêu cầu hỗ trợ đến MobiFone Invoice" });

    var layout = {
        // paddingY: 60,
        // paddingX: 500,
        cols: [
            { gravity: 1, template: "" },
            {
                rows: [
                    { gravity: 1, template: "" },
                    // {
                    //     height: 35,
                    //     type: "toolbar",
                    //     cols: controls
                    // },
                    {
                        // view: "scrollview",
                        // scroll: "y",
                        // body: {
                        view: "form",
                        id: "form_hotro",
                        paddingY: 10,
                        // width: 500,
                        // height: 500,
                        position: "center",
                        paddingX: 10,
                        complexData: true,
                        margin: 0,
                        elements: [
                            {
                                view: "text",
                                name: "ms_thue",
                                id: "ms_thue",
                                label: _("MS_THUE"),
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top",
                            },
                            {
                                view: "text",
                                name: "ten_dvcs",
                                id: "ten_dvcs",
                                label: _("DONVI"),
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top",
                            },
                            {
                                view: "text",
                                name: "dia_chi",
                                label: _("DIA_CHI"),
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top",
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        name: "nguoi_dai_dien",
                                        label: _("NGUOI_DAI_DIEN_PL"),
                                        css: "mcls_readonly_text",
                                        readonly: true,
                                        labelPosition: "top",
                                    },
                                    {
                                        view: "text",
                                        name: "email",
                                        label: "Email",
                                        css: "mcls_readonly_text",
                                        readonly: true,
                                        labelPosition: "top",
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        name: "nguoi_lien_he",
                                        id: "nguoi_lien_he",
                                        label: _("Người liên hệ"),
                                        labelPosition: "top",
                                        required: true,
                                        invalidMessage: "Bạn phải nhập người liên hệ",
                                    },

                                    {
                                        view: "text",
                                        name: "sdt",
                                        id: "sdt",
                                        label: "Số điện thoại",
                                        labelPosition: "top",
                                        required: true,
                                        //webix.ru
                                        invalidMessage: "Bạn phải nhập số điện thoại",
                                    },
                                ],
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        name: "teamview",
                                        id: "teamview",
                                        label: _("Teamview (UltraViewer)"),
                                        labelPosition: "top",
                                    },

                                    {
                                        view: "text",
                                        name: "pass",
                                        id: "pass",
                                        label: "Password",
                                        labelPosition: "top",
                                    },
                                ],
                            },
                            {
                                id: "noi_dung",
                                view: "textarea",
                                name: "noi_dung",
                                label: "Yêu cầu hỗ trợ",
                                height: 160,
                                labelPosition: "top",
                            },

                            {
                                margin: 10,
                                cols: [
                                    {},
                                    {
                                        shortcut: "F10",
                                        view: "button",
                                        label: "Gửi (F10)",
                                        align: "center",
                                        width: 120,
                                        on: {
                                            onClick: function () {
                                                var form = webix.$$("form_hotro");

                                                var item = form.getValues();
                                                var format = webix.Date.dateToStr("%d/%m/%Y - %H:%i");
                                                var string = format(new Date());

                                                var descrip =
                                                    "Ngày :" +
                                                    string +
                                                    "</br>" +
                                                    "Công ty :" +
                                                    item.ten_dvcs +
                                                    "</br>" +
                                                    "Mã số thuế :" +
                                                    item.ms_thue +
                                                    "</br>" +
                                                    "Người liên hệ: " +
                                                    item.nguoi_lien_he +
                                                    "</br>" +
                                                    "Số điện thoại: " +
                                                    item.sdt +
                                                    "</br>" +
                                                    "Teamview (UltraViewer): " +
                                                    item.teamview +
                                                    "</br>" +
                                                    "Pass: " +
                                                    item.pass +
                                                    "</br>" +
                                                    "Nội dung cần hỗ trợ: " +
                                                    item.noi_dung +
                                                    "</br>";

                                                if ($$("form_hotro").validate()) {
                                                    var box = webix.modalbox({
                                                        title: "Đang gửi yêu cầu hỗ trợ đến MobiFone Invoice",
                                                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                        width: 350,
                                                        height: 200,
                                                    });

                                                    var data = {
                                                        mst: item.ms_thue,
                                                        noidung: item.noi_dung,
                                                        nguoi_lien_he: item.nguoi_lien_he,
                                                        sdt_nguoi_lien_he: item.sdt,
                                                        ultra_teamview: item.teamview,
                                                        pass: item.pass,
                                                    };
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(app.config.host + "/System/SendSupport", data, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.modalbox.hide(box);
                                                                alert(text);
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(text);
                                                                if (!json.hasOwnProperty("error")) {
                                                                    $$("nguoi_lien_he").setValue(null);
                                                                    $$("sdt").setValue(null);
                                                                    $$("teamview").setValue(null);
                                                                    $$("pass").setValue(null);
                                                                    $$("noi_dung").setValue(null);
                                                                    webix.message("Gửi yêu cầu hỗ trợ thành công !", "debug");
                                                                } else {
                                                                    webix.message(json.error, "error");
                                                                }
                                                                webix.modalbox.hide(box);
                                                            },
                                                        });
                                                }
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                    {
                                        view: "button",
                                        hotkey: "esc",
                                        label: "Nhập lại (ESC)",
                                        align: "center",
                                        width: 120,
                                        type: "danger",
                                        click: function () {
                                            $$("nguoi_lien_he").setValue(null);
                                            $$("sdt").setValue(null);
                                            $$("teamview").setValue(null);
                                            $$("pass").setValue(null);
                                            $$("noi_dung").setValue(null);
                                            // webix.$$("chukyso-win").close();
                                        },
                                    },
                                    {},
                                ],
                            },
                        ],
                    },
                    { gravity: 1, template: "" },
                ],
            },
            { gravity: 1, template: "" },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var url = app.config.host + "/System/GetInfoCompany";

            webix.ajax(url, function (text) {
                var json = JSON.parse(text);
                $$("form_hotro").setValues(json);
            });
        },
    };
});

define('views/infocompany',[
    "app",
    "locale",
    "views/forms/license",
], function (app, _, licenseForm) {
    

    webix.$$("title").parse({ title: "Thông tin doanh nghiệp", details: "Cập nhật thông tin doanh nghiệp" });

    var controls = [
        {},
        {
            id: "btnSave",
            view: "button",
            type: "danger",
            //css: "mcls_btn_save", 
            icon: "save",
            label: _("Ghi") + " (F10)",
            width: 85,
            shortcut: "F10",
            on: {
                onClick: function () {

                    var form = webix.$$("foInfoCompany");
                    webix.extend(form, webix.ProgressBar);
                    form.disable();
                    form.showProgress();
                    if (form.validate()) {
                        var item = form.getValues();

                        webix.ajax()
                            .bind(form)
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/System/SaveInfoCompany", item, function (text) {
                                var data = JSON.parse(text);

                                this.enable();
                                this.hideProgress();

                                if (!data.hasOwnProperty("error")) {
                                    webix.message({ type: "debug", text: "Đã lưu thành công" });

                                }
                                else {
                                    webix.message({ type: "error", text: data.error });
                                }
                            });
                    }

                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var layout = {
        cols: [
            { gravity: 0.5, template: "" },
            {
                rows: [
                    { height: 20 },
                    {
                        view: "form",
                        id: "foInfoCompany",
                        paddingY: 10,
                        paddingX: 10,
                        complexData: true,
                        margin: 0,
                        elements: [
                            {
                                view: "text",
                                name: "tax_code",
                                label: _("MS_THUE"),
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "text",
                                name: "name",
                                label: _("DONVI"),
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "text",
                                name: "address",
                                label: _("DIA_CHI"),
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        name: "nguoi_dai_dien",
                                        label: _("NGUOI_DAI_DIEN_PL"),
                                        css: "mcls_readonly_text",
                                        readonly: true,
                                        labelPosition: "top"
                                    },
                                    {
                                        view: "text",
                                        name: "email",
                                        label: "Email",
                                        css: "mcls_readonly_text",
                                        readonly: true,
                                        labelPosition: "top"
                                    }
                                ]
                            },
                            {
                                view: "text",
                                name: "begin_date",
                                label: _("NGAY_BD_NAM_TC"),
                                placeholder: "dd/mm",
                                labelPosition: "top",
                                invalidMessage: _("NGAY_BD_NAM_TC") + " không hợp lệ",
                                on: {
                                    onChange: function (newv, oldv) {
                                        this.validate();
                                    }
                                }
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        name: "tel",
                                        label: _("DIEN_THOAI"),
                                        labelPosition: "top",
                                        validate: webix.rules.isPhoneNumber,
                                        invalidMessage: "Định dạng điện thoại nhập không đúng",
                                        on: {
                                            onChange: function (newv, oldv) {
                                                if (newv != "") {
                                                    this.validate();
                                                }
                                            }
                                        }
                                    },

                                    {
                                        view: "text",
                                        name: "fax",
                                        label: "Fax",
                                        labelPosition: "top",
                                        validate: webix.rules.isPhoneNumber,
                                        invalidMessage: "Định dạng fax nhập không đúng",
                                        on: {
                                            onChange: function (newv, oldv) {
                                                if (newv != "") {
                                                    this.validate();
                                                }
                                            }
                                        }
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        name: "city",
                                        label: _("TINH_THANH"),
                                        labelPosition: "top"
                                    },

                                    {
                                        view: "text",
                                        name: "district",
                                        label: "Quận huyện",
                                        labelPosition: "top"
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        name: "bank_account",
                                        label: _("TAI_KHOAN"),
                                        labelPosition: "top",
                                        validate: webix.rules.isPhoneNumber,
                                        invalidMessage: "Định dạng tài khoản nhập không đúng",
                                        on: {
                                            onChange: function (newv, oldv) {
                                                if (newv != "") {
                                                    this.validate();
                                                }
                                            }
                                        }
                                    },
                                    {
                                        view: "text",
                                        name: "bank_name",
                                        label: _("TAI_NH"),
                                        labelPosition: "top"
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        view: "combo",
                                        name: "provincial_tax_authorities",
                                        label: "Cơ quan thuế cấp tỉnh",
                                        labelPosition: "top",
                                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00015",
                                        on: {
                                            onChange: function (newv, oldv) {
                                                webix.ajax()
                                                    .headers({ 'Content-Type': 'application/json' })
                                                    .post(
                                                    app.config.host + "/System/ExecuteCommand",
                                                    {
                                                        command: "CM00007",
                                                        parameter: {
                                                            nhom: newv
                                                        }
                                                    },
                                                    function (text) {
                                                        var result = JSON.parse(text);

                                                        var list = $$("ma_cqthuecapql").getPopup().getList();
                                                        list.clearAll();

                                                        list.parse(result);
                                                    });


                                            }
                                        }
                                    },
                                    {
                                        id: "ma_cqthuecapql",
                                        view: "combo",
                                        name: "manage_tax_authorities",
                                        label: "Cơ quan thuế quản lý",
                                        labelPosition: "top",
                                        options: []
                                    }
                                ]
                            },
                            {
                                view: "fieldset",
                                label: "Thông tin đơn vị chủ quản",
                                body: {
                                    rows: [
                                        {
                                            view: "text",
                                            name: "manage_taxcode",
                                            label: _("MS_THUE"),
                                            validate: webix.rules.isTaxCode,
                                            invalidMessage: "Mã số thuế không hợp lệ",
                                            labelPosition: "top",
                                            on: {
                                                onChange: function (newv, oldv) {
                                                    if (newv != "") {
                                                        this.validate();
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            view: "text",
                                            name: "manage_unit_name",
                                            label: _("DONVI"),
                                            labelPosition: "top"
                                        },
                                        {
                                            view: "text",
                                            name: "manage_email",
                                            validate: webix.rules.isEmail,
                                            invalidMessage: "Email không hợp lệ",
                                            label: _("EMAIL"),
                                            labelPosition: "top",
                                            on: {
                                                onChange: function (newv, oldv) {
                                                    if (newv != "") {
                                                        this.validate();
                                                    }
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                margin: 15,
                                cols: controls
                            }
                        ],
                        rules: {
                            begin_date: function (value) {
                                if (value != "") {

                                    if (value.toString().length != 5)
                                        return false;

                                    var patt = /^[0-1][1-2][/][0-9][0-9]$/;

                                    return patt.test(value);

                                }
                                return true;
                            }
                        }
                    },
                    { height: 10 }
                ]
            },
            { gravity: 0.5, template: "" }

        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var url = app.config.host + "/System/GetInfoCompany";

            webix.ajax(url, function (text) {
                var json = JSON.parse(text);
                $$("foInfoCompany").setValues(json);

            });
        }

    };
});
define('views/license',[
    "app",
    "locale",
    "views/forms/license",
], function (app, _, licenseForm) {
    

    webix.$$("title").parse({ title: "Đăng ký bản quyền", details: "Đăng ký số lượng hóa đơn sử dụng" });

    var controls = [
        {
            id: "btnRegFirst",
            view: "button",
            type: "form",
            icon: "registered",
            label: _("DANG_KY_LAN_DAU"),
            width: 150,
            on: {
                onClick: function () {

                    webix.ajax().bind(this).get(app.config.host + "/License/Info", function (text) {
                        var json = JSON.parse(text);

                        if (json.key_license != undefined) {
                            webix.alert({
                                title: _("THONG_BAO"),
                                ok: "OK",
                                text: "Phần mềm đã được đăng ký lần đầu"
                            });
                        }
                        else {
                            var win = this.$scope.ui(licenseForm.$ui);
                            win.getHead().setHTML(_("DANG_KY_LAN_DAU"));
                            win.show();
                            $$("license-form").setValues(json);
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            id: "btnRegMore",
            view: "button",
            type: "danger",
            icon: "registered",
            label: _("DANG_KY_THEM"),
            width: 150,
            on: {
                onClick: function () {

                    webix.ajax().bind(this).get(app.config.host + "/License/Info", function (text) {
                        var json = JSON.parse(text);

                        if (json.key_license != undefined) {
                            var win = this.$scope.ui(licenseForm.$ui);
                            win.getHead().setHTML(_("DANG_KY_THEM"));
                            win.show();
                            $$("license-form").setValues(json);
                        }
                        else {

                            webix.alert({
                                title: _("THONG_BAO"),
                                ok: "OK",
                                text: "Phần mềm chưa được đăng ký lần đầu"
                            });
                        }
                    });


                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var layout = {
        rows: [
            {
                height: 35,
                type: "toolbar",
                cols: controls
            },
            {
                view: "iframe",
                id: "framePdf",
                toolbar: "toolbar",
                //src: app.config.host + "/License/PrintLicenseInfo"

            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var url = app.config.host + "/License/PrintLicenseInfo";

            var form = view;
            webix.extend(form, webix.ProgressBar);
            form.disable();
            form.showProgress();
            webix.ajax()
                .response("arraybuffer")
                .get(url, {
                    error: function (text, data, XmlHttpRequest) {
                        form.enable();
                        form.hideProgress();
                        alert(text);
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var file = new Blob([data], { type: 'application/pdf' });
                        var fileURL = URL.createObjectURL(file);

                        var framePdf = $$("framePdf");
                        framePdf.load(fileURL);

                        form.enable();
                        form.hideProgress();
                    }
                });
        }

    };
});
define('views/licenseInvoice',[
    "app",
    "locale",
    "models/user",
    "views/menus/version",
], function (app, _, user, version) {
    

    var op = [];
    webix.$$("title").parse({ title: "Thông tin doanh nghiệp", details: "Cập nhật thông tin doanh nghiệp" });

    var controls = [
        {},
        {
            id: "btnSave",
            view: "button",
            type: "danger",
            icon: "save",
            label: "Cấp bản quyền (F10)",
            //width: 135,
            shortcut: "F10",
            on: {
                onClick: function () {
                    var form = webix.$$("foInfoCompany");

                    if (form.validate()) {
                        var item = form.getValues();
                        if (item.floderId == null || item.floderId == "") {
                            var box = webix.modalbox({
                                title: "Đang tạo thư mục  ....",
                                text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                width: 350,
                                height: 200
                            });

                            webix.ajax()
                                .headers({ 'Content-type': 'application/json' })
                                .post(app.config.host + "/License/SaveInfoCompany", item, function (text) {
                                    var data = JSON.parse(text);

                                    if (!data.hasOwnProperty("error")) {
                                        webix.message({ type: "debug", text: "Cấp bản quyền thành công" });
                                        var table = webix.$$("foInfoCompany");
                                        table.refresh();

                                        table.load(table.config.url);
                                        webix.modalbox.hide(box);
                                    }
                                    else {
                                        webix.message({ type: "error", text: data.error });
                                        webix.modalbox.hide(box);
                                    }
                                });
                        }
                        else {
                            webix.message("Khách hàng đã được cấp bản quyền !", "error");
                            return;
                        }
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var layout = {
        // paddingY: 60,
        // paddingX: 500,
        cols: [
            { gravity: 0.5, template: "" },
            {
                rows: [
                    { gravity: 1, template: "" },
                    {
                        view: "form",
                        id: "foInfoCompany",
                        paddingY: 15,
                        // width: 700,
                        // height:300,
                        position: "center",
                        paddingX: 15,
                        complexData: true,
                        margin: 0,
                        elements: [
                            {
                                cols: [
                                    {
                                        view: "text",
                                        name: "ms_thue",
                                        label: _("MS_THUE"),
                                        css: "mcls_license_text",
                                        readonly: true,
                                        labelPosition: "top"
                                    },
                                    {
                                        view: "text",
                                        name: "nguoi_dai_dien",
                                        label: _("NGUOI_DAI_DIEN_PL"),
                                        css: "mcls_readonly_text",
                                        readonly: true,
                                        labelPosition: "top"
                                    }
                                ]

                            },
                            {
                                view: "text",
                                name: "ten_dvcs",
                                label: _("DONVI"),
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "text",
                                name: "dia_chi",
                                label: _("DIA_CHI"),
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "fieldset",
                                label: "Thông tin đơn vị chủ quản",
                                body: {
                                    rows: [
                                        {
                                            view: "text",
                                            name: "mst_dvcq",
                                            label: _("MS_THUE"),
                                            validate: webix.rules.isTaxCode,
                                            invalidMessage: "Mã số thuế không hợp lệ",
                                            labelPosition: "top",
                                            on: {
                                                onChange: function (newv, oldv) {
                                                    if (newv != "") {
                                                        this.validate();
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            view: "text",
                                            name: "ten_dvcq",
                                            label: _("DONVI"),
                                            labelPosition: "top"
                                        },
                                        {
                                            view: "text",
                                            name: "email_dvcq",
                                            validate: webix.rules.isEmail,
                                            invalidMessage: "Email không hợp lệ",
                                            label: _("EMAIL"),
                                            labelPosition: "top",
                                            on: {
                                                onChange: function (newv, oldv) {
                                                    if (newv != "") {
                                                        this.validate();
                                                    }
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                view: "text",
                                name: "floderId",
                                label: _("Key"),
                                css: "mcls_license_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "text",
                                name: "floderTitle",
                                label: _("Title"),
                                validate: webix.rules.isEmpty,
                                invalidMessage: "Bạn phải nhập tiêu đề cho thư mục !",
                                required: true,
                                //css: "mcls_readonly_text",
                                //readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "text",
                                name: "floderDes",
                                label: _("Description"),
                                validate: webix.rules.isEmpty,
                                invalidMessage: "Bạn phải nhập diễn dải cho thư mục !",
                                required: true,
                                //css: "mcls_readonly_text",
                                //readonly: true,
                                labelPosition: "top"
                            },
                            {
                                margin: 15,
                                cols: controls

                            }

                        ]
                    },
                    { gravity: 5, template: "" }
                ]
            },
            { gravity: 0.5, template: "" }
        ]

    };


    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var url = app.config.host + "/System/GetInfoCompany";
            $$("foInfoCompany").config.url = url;
            webix.ajax(url, function (text) {
                var json = JSON.parse(text);
                $$("foInfoCompany").setValues(json);

            });
        }
    };
});
define('views/quenmk',["app", "locale"], function (app, _) {
    //var json = version.getInfocompany();
    //$$("hotro-form").setValues(json);

    var layout = {
        view: "window",
        modal: true,
        id: "retrivepass-win",
        position: "center",
        head: {
            // height: 40,
            rows: [
                {
                    height: 15,
                    borderless: true,
                    cols: [
                        { gravity: 1, template: "" },
                        {
                            view: "icon",
                            icon: "fal fa-times",
                            css: "icquenmk",
                            hotkey: "esc",
                            click: function () {
                                $$("retrivepass-win").close();
                            },
                        },
                    ],
                },
                {
                    id: "head-form",
                    height: 60,
                    view: "template",
                    css: "quenmklock",
                    borderless: true,
                    template: function (obj) {
                        return '<img src="assets/imgs/locker.png" >';
                    },
                },
                {
                    view: "label",
                    label: "Quên mật khẩu tài khoản MobiFone Invoice",
                    css: "quenmk",
                },
            ],
        },
        width: 500,
        //minheight: 240,
        height: 350,
        body: {
            paddingY: 10,
            paddingX: 30,
            //elementsConfig:{labelWidth: 120},
            view: "form",
            id: "retrivepassForm",
            complexData: true,
            elements: [
                {
                    view: "template",
                    css: "forgot-password-link",
                    borderless: true,
                    template: "<a href='http://auth-sso.mobifone.vn/en/dashboard' target='_blank''><i>Quý khách quên mật khẩu tài khoản SSO, vui lòng truy cập tại đây</i></a>",
                },
                {
                    view: "template",
                    borderless: true,
                    template: "<div>Hệ thống của MobiFone Invoice sẽ gửi mật khẩu mới cho Quý khách hàng. " + "Quý khách hàng dùng mật khẩu đó để đăng nhập vào phần mềm</div>",
                    css: "quenmktemplate",
                },
                {
                    view: "text",
                    labelPosition: "top",
                    //id:          "email",
                    name: "email",
                    label: "MỜI NHẬP EMAIL",
                    icon: "email",
                    css: "quenmkemail",
                    required: true,
                    invalidMessage: "Bạn chưa nhập địa chỉ email hoặc email định dạng không đúng",
                    placeholder: "ví dụ lan@gmail.com",
                    validate: webix.rules.isEmail,
                },
                // {
                //     view: "fieldset",
                //     label: "Hướng dẫn",
                //     body: {
                //         rows: [
                //             {
                //                 id: "version",
                //                 //borderless: true,
                //                 css: { "background": "#e6f7ff !important" },
                //                 // width: 200,
                //                 view: "template",
                //                 template: "<div class=''><p><b>Bước 1:</b></p><label> Quý khách hàng vui lòng nhập Email đăng ký tài khoản !</label> <br />"
                //                 + "<p><b>Bước 2:</b></p><label> Đăng nhập tài khoản Email vừa nhập !</label></div>"
                //                 + "<p><b>Bước 3:</b></p><label> Hệ thống của MobiFone Invoice sẽ gửi mật khẩu mới cho Quý khách hàng. Quý khách hàng dùng mật khẩu đó để đăng nhập vào phần mềm !</label></div>"
                //             }
                //         ]
                //     }
                // },

                {
                    margin: 10,
                    cols: [
                        {
                            shortcut: "F10",
                            view: "button",
                            label: "Gửi yêu cầu (F10)",
                            css: "btnlogin",
                            align: "center",
                            height: 43,
                            width: 180,
                            type: "form",
                            on: {
                                onClick: function () {
                                    if ($$("retrivepassForm").validate()) {
                                        var form = $$("retrivepassForm");

                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();

                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/Account/ResetPass", $$("retrivepassForm").getValues(), function (text, xml, xhr) {
                                                var json = JSON.parse(text);

                                                var form = $$("retrivepassForm");
                                                form.enable();
                                                form.hideProgress();
                                                webix.alert({
                                                    title: "Thông báo",
                                                    ok: "OK",
                                                    text: "Đã gửi mật khẩu tới email. Bạn hãy kiểm tra lại.",
                                                });
                                                /*if (json.hasOwnProperty("error")) {
                                                    // webix.alert({
                                                    //     title: "Thông báo",
                                                    //     ok: "OK",
                                                    //     text: json.error,
                                                    //     type: "alert-error"
                                                    // });
                                                    webix.message(json.error, "error");
                                                } else {
                                                    webix.alert({
                                                        title: "Thông báo",
                                                        ok: "OK",
                                                        text: "Đã gửi mật khẩu tới email.Bạn hãy kiểm tra lại.",
                                                    });
                                                }*/
                                            });
                                    } else {
                                        $$("retrivepassForm").focus();
                                    }
                                },
                            },
                            click: function () {
                                this.callEvent("onClick");
                            },
                        },
                        // {
                        //     view: "button", hidden: true, hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
                        //     click: function () {
                        //         webix.$$("retrivepass-win").close();
                        //     }
                        // },
                        {},
                    ],
                },
                { height: 10 },
            ],
        },
    };
    return {
        $ui: layout,
        initUI: function (json) {
            $$("retrivepassForm").setValues(json);
        },
    };
});

define('views/thongbaosso_nologin',["app", "locale", "views/forms/link_sso_nologin"], function (app, _, linkSSO) {
	var layout = {
		view: "window",
		modal: true,
		id: "notisso",
		position: "center",
		head: "Thông báo",
		width: 800,
		height: 400,
		body: {
			view: "form",
			id: "notissobody",
			elements: [
				{
					type: "clean",
					rows: [
						{
							view: "template",
							template: "<div style='text-align: left; padding: 0 30px 0 30px; font-size: 14px;'>" +
								"   <h3>Kính gửi Quý khách hàng</h3>" +
								"   <div>Nhằm nâng cao chất lượng dịch vụ, MobiFone tiến hành nâng cấp hệ thống Quản lý tài khoản tập trung (SSO) cho các khách hàng sử dụng hệ sinh thái giải pháp số của MobiFone.</div>" +
								"   <br/>" +
								"   <div>Sau khi hoàn thành liên kết, Quý khách có thể đăng nhập toàn bộ các hệ thống thuộc hệ sinh thái giải pháp của MobiFone bằng một tài khoản duy nhất. </div>" +
								"   <br/>" +
								"   <div>Thời gian liên kết: Từ ngày 01/04/2024 đến 30/04/2024</div>" +
								"   </div>" +
								"   <br/>" +
								"</div>",
							borderless: false,
							height: 200
						},
						{
							view: "button",
							template: "<div style='display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: center;align-items: center;'><svg xmlns='http://www.w3.org/2000/svg' width='48' height='48'><path fill='none' d='M0 0h48v48H0z'></path><path d='M7.8 24c0-3.42 2.78-6.2 6.2-6.2h8V14h-8C8.48 14 4 18.48 4 24s4.48 10 10 10h8v-3.8h-8c-3.42 0-6.2-2.78-6.2-6.2zm8.2 2h16v-4H16v4zm18-12h-8v3.8h8c3.42 0 6.2 2.78 6.2 6.2s-2.78 6.2-6.2 6.2h-8V34h8c5.52 0 10-4.48 10-10s-4.48-10-10-10z' fill='#6692d7' class='fill-000000'></path></svg> <span style='font-size: 18px; text-decoration:none; color: #7a8cd3;'><i>Liên kết ngay tại đây</i></span></div>",
							on: {
								onClick: function () {
									var win = this.$scope.ui(linkSSO.$ui);
									win.show();
								},
							},
							click: function () {
								this.callEvent("onClick");
							},
							height: 50
						},
						{
							type: "clean",
							cols: [
								{
									view: "template",
									template: "<a href='https://drive.google.com/drive/folders/1gyqEnQlTJw_o9UIhSEtJSGll9PF9qbHO' target='_blank' style='margin-left: 30px; display: flex; font-size: 16px;'><i>Xem chi tiết hướng dẫn tại đây</i></a>",
								},
								{
									view: "button",
									value: "Đóng",
									width: 100,
									on: {
										onClick: function () {
											$$("notisso").hide();
										},
									},
									click: function () {
										this.callEvent("onClick");
									},
								}
							]
						}
					]
				}
			]
		}
	};
	return {
		$ui: layout,
		initUI: function (json) {
			return
		},
	};
});
/**
 * Created by Mads on 03-10-2015.
 */

define('views/login',["models/user", "locale", "app", "helpers/locale", "helpers/uiVariant", "views/menus/version", "views/quenmk", "views/thongbaosso_nologin", "views/forms/link_sso"], function (user, _, app, locale, uiVariant, version, quenmk, thongbaosso, linkSSO) {
    
    webix.ui({
        view: "popup",
        id: "my_pop",
        head: "Submenu",
        width: 250,
        body: {
            view: "list",
            data: [{ id: "1", name: "Cập nhật bản cũ", location: "Mobi-Invoice Desktop" }],
            template: "#name# - #location#",
            autoheight: true,
            select: true,
            on: {
                onItemDblClick: function (id) {
                    if (id == "1") {
                        app.router("/updateToWeb");
                    }
                },
            },
        },
    });
    var values = webix.copy(
        {
            username: "",
            password: "",
            rememberme: false,
            language: "vi",
            ma_dvcs: "",
        },
        Cookies.getJSON("Crm")
    );

    var demo = function () {
        webix.message("ấvasv");
    };

    var action = document.querySelector(".showLogin");
    action.classList.add("inactive");

    var bannerName = "head-banner.png";

    webix.ajax().sync().get(app.config.host + "/System/GetBanner", function (text) {
        try {
            bannerName = JSON.parse(text);
            if (bannerName === "" || bannerName === null || bannerName === undefined) {
                bannerName = "head-banner.png";
            }
        } catch (e) {
            bannerName = "head-banner.png";
        }
    });

    return {
        $ui: {
            css: "bodylogin",
            rows: [
                {
                    //borderless: true,
                    // css: { "box-shadow": "0 15px 10px rgba(0,0,0,0.2)" },
                    height: 80,
                    cols: [
                        { gravity: 1, template: "", width: 150 },
                        {
                            view: "label",
                            template: "<a href='https://mobifone.vn/' target='_blank'><img style='width:200px; height:120px;' src='assets/imgs/" + bannerName + "' /></a>",
                            height: 65,
                            borderless: true,
                            css: { padding: "10px", "padding-top": "1px !important" },
                        },
                        {
                            id: "version",
                            borderless: true,
                            view: "label",
                            template: "<div class='hotline'><b style='font-family:Arial;color=white'>Hotline:</b> <label style='color:white'>18001290</label> <br /></div>",
                            css: { padding: "10px", "padding-top": "20px", color: "white" },
                        },
                        {
                            rows: [
                                { gravity: 1, template: "" },
                                {
                                    cols: [
                                        {
                                            id: "cbLanguage",
                                            view: "combo",
                                            width: 125,
                                            height: 36,
                                            css: "cbSwitchUI",
                                            options: [
                                                { id: "vi", value: "Việt Nam" },
                                                /*  { id: "en", value: "English" },
                                                { id: "ko", value: "Korea" } */
                                            ],
                                            value: locale.getLang(),
                                            on: {
                                                onChange: function (newv, oldv) {
                                                    locale.setLang(newv, null);
                                                },
                                            },
                                        },
                                        { width: 8, template: "" },
                                        uiVariant.buildLoginSwitchCombo(),
                                    ],
                                },
                                { gravity: 1, template: "" },
                            ],
                        },
                        { gravity: 1, template: "", width: 150 },
                    ],
                },
                {
                    cols: [
                        { gravity: 1, template: "" },
                        // { gravity: 1, template: "" },
                        // { gravity: 1, template: "" },
                        // { gravity: 1, template: "" },
                        // { gravity: 1, template: "" },
                        // { gravity: 1, template: "" },
                        {
                            //  css: { "padding-left": "450px" },
                            rows: [
                                { gravity: 0.05, template: "" },
                                {
                                    view: "form",
                                    gravity: 5,
                                    id: "loginForm",
                                    width: 900,
                                    height: 550,
                                    margin: 5,
                                    paddingX: 50,
                                    css: "login",
                                    borderless: false,
                                    elements: [
                                        {
                                            view: "label",
                                            label: "Đăng nhập",
                                            css: "lbldangnhap",
                                        },
                                        {
                                            view: "combo",
                                            id: "ma_dvcs",
                                            name: "ma_dvcs",
                                            label: _("DONVI"),
                                            width: 330,
                                            css: "donvilogin",
                                            //options: app.config.host +"/System/GetAllDmDvcs",
                                            options: {
                                                view: "gridsuggest",
                                                textValue: "name",
                                                body: {
                                                    //url: app.config.host + "/System/GetAllDmDvcs",
                                                    textValue: "name",
                                                    columns: [
                                                        {
                                                            id: "tax_code",
                                                            width: 120,
                                                            header: _("MS_THUE"),
                                                        },
                                                        {
                                                            id: "name",
                                                            width: 450,
                                                            header: _("DONVI"),
                                                        },
                                                    ],
                                                    ready: function () {
                                                        var values = Cookies.getJSON("Crm");

                                                        var obj = $$("ma_dvcs");
                                                        var list = obj.getList();
                    
                                                        if (values === undefined) {
                                                            if (list.count()) {
                                                                var id = list.getIdByIndex(0);
                                                                obj.setValue(id);
                                                            }
                                                        } else {
                                                            var item = list.getItem(values.ma_dvcs);

                                                            if (item != null && item != undefined) {
                                                                obj.setValue(values.ma_dvcs);
                                                            } else {
                                                                if (list.count()) {
                                                                    var id = list.getIdByIndex(0);
                                                                    obj.setValue(id);
                                                                }
                                                            }
                                                        }
                                                    },
                                                },
                                            },
                                            value: values.ma_dvcs,
                                            required: true,
                                            hidden: true,
                                        },
                                        {
                                            view: "text",
                                            id: "username",
                                            name: "username",
                                            label: _("USERNAME"),
                                            icon: "user",
                                            width: 330,
                                            value: values.username,
                                            required: true,
                                            invalidMessage: "Tên truy cập không để trống!",
                                            //validate: webix.rules.isSpecialCharacter,
                                            css: "mcls_uppercase",
                                        },
                                        {
                                            view: "text",
                                            id: "password",
                                            name: "password",
                                            width: 330,
                                            type: "password",
                                            label: _("PASSWORD"),
                                            value: values.password,
                                            invalidMessage: "Mật khẩu không được để trống",
                                            required: true,
                                            css: "passlogin",
                                            icon: "fa fa-eye", 
                                            on: {
                                                onItemClick: function (id, e) {
                                                    // Kiểm tra xem người dùng có click vào biểu tượng không
                                                    if (e.target && e.target.classList.contains("webix_input_icon")) {
                                                        var inputNode = $$("password").getInputNode();  // Lấy node input
                                                        var inputType = inputNode.type;  // Kiểm tra loại của input (password hoặc text)
                                                        
                                                        // Thay đổi loại input và biểu tượng tương ứng
                                                        if (inputType === "password") {
                                                            inputNode.type = "text"; // Hiển thị mật khẩu
                                                            webix.html.removeCss(e.target, "fa-eye");
                                                            webix.html.addCss(e.target, "fa-eye-slash"); // Thêm biểu tượng mắt đóng
                                                        } else {
                                                            inputNode.type = "password"; // Ẩn mật khẩu
                                                            webix.html.removeCss(e.target, "fa-eye-slash");
                                                            webix.html.addCss(e.target, "fa-eye"); // Thêm biểu tượng mắt mở
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            view: "checkbox",
                                            id: "remember",
                                            name: "rememberme",
                                            css: "rememberlogin",
                                            label: _("REMEMBERME") + " ?",
                                            labelPosition: "left",
                                            labelWidth: 130,
                                            checkValue: "true",
                                            uncheckValue: "false",
                                            value: values.rememberme,
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: "button",
                                                    id: "login",
                                                    name: "login",
                                                    label: _("DANGNHAP"),
                                                    css: "btnlogin",
                                                    width: 300,
                                                    height: 43,
                                                    hotkey: "enter",
                                                    type: "form",
                                                    click: function () {
                                                        var username = $$("username").getValue();
                                                        $$("username").setValue(username.toUpperCase());
                    
                                                        if ($$("loginForm").validate()) {
                                                            var values = $$("loginForm").getValues();
                                                            if ("true" === values.rememberme) {
                                                                values.language = $$("cbLanguage").getValue();
                                                                Cookies.set("Crm", values);
                                                            } else {
                                                                // Clear cookie
                                                                Cookies.remove("Crm");
                                                            }
                    
                                                            var _ma_dvcs = values.ma_dvcs;

                                                            if ($$("ma_dvcs").config.hidden) {
                                                                _ma_dvcs = "";
                                                            }
                                                            user.login(values.username, values.password, _ma_dvcs, $$("cbLanguage").getValue(), $$("loginForm"));
                                                        } else {
                                                            $$("username").focus();
                                                            $$("loginForm").focus();
                                                        }
                                                    },
                                                },
                                            ]
                                        },
                                        {
                                            width: 330,
                                            css: "linelogin",
                                            cols: [
                                                {
                                                    view: "button",
                                                    label: _("QUENMK"),
                                                    css: "mcls_btnResetPassLogin",
                                                    type: "iconButton",
                                                    icon: "far fa-key",
                                                    width: 300,
                                                    click: function () {
                                                        var win = this.$scope.ui(quenmk.$ui);
                                                        win.show();
                                                        // app.router("/retrivepass");
                                                    },
                                                },
                                                {
                                                    view: "button",
                                                    css: "mcls_btnRegisterLogin",
                                                    type: "iconButton",
                                                    hidden: true,
                                                    icon: "far fa-long-arrow-right",
                                                    label: _("DANGKY"),
                                                    width: 150,
                                                    click: function () {
                                                        window.open("http://mobifone.vn/", "_blank");
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            height: 25
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: "label",
                                                    template: "<div class='fancy'><span>Hoặc đăng nhập bằng</span></div>",
                                                    width: 300,
                                                    align: "center"
                                                },
                                            ],
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: "button",
                                                    id: "loginsso",
                                                    name: "loginsso",
                                                    template: "<div><div style='display: flex;flex-direction: column;align-items: center;'> " +
                                                        "<svg width='40' height='40' style='margin-bottom:10px'><circle cx='20' cy='20' r='19' fill='transparent' stroke='#a7cde6' stroke-width='2'/>" +
                                                        "<image xlink:href='assets/imgs/icon/login_method_sso.svg' x='10' y='10' width='20' height='20' /></svg><span style='color:#4281b3'>" +
                                                        _("DANGNHAPSSO") + "</span></div></div>",
                                                    align: "center",
                                                    width: 300,
                                                    height: 100,
                                                    type: "iconButton",
                                                    click: function () {
                                                        var host_name = "auth-sso.mobifone.vn:8080";
                                                        var realm_name = "sso-mobifone";
                                                        var client_id = "TTCNTT-MOBIFONEINVOICE";
                                                        var scope = "openid";
                                                        var response_type = "code";
                                                        var redirect_uri = "http:" + window.location.host + "/%23%21/app/loginsso";
                                                        var url = "https://" + host_name +
                                                            "/oauth/realms/" + realm_name +
                                                            "/protocol/openid-connect/auth?client_id=" + client_id +
                                                            "&scope=" + scope +
                                                            "&response_type=" + response_type +
                                                            "&redirect_uri=" + redirect_uri;
                                                        window.location.href = url;
                                                    },
                                                }

                                            ],
                                        },
                                    ],
                                    elementsConfig: {
                                        labelPosition: "top",
                                        //validateEvent: "key"
                                    },
                                },
                                { gravity: 0.1, template: "" },
                            ],
                        },
                        { gravity: 1, template: "" },
                    ],
                },
                {
                    height: 80,
                },
            ],
        },
        $oninit: function (view, $scope) {

            $$("loginForm").focus();
            //var winthongbaosso = $scope.ui(thongbaosso.$ui);
            //winthongbaosso.show();
        },
    };
});

define('views/loginsso',["models/user"], function (user) {
    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    var currentUrl = window.location.href.replace(/#!\//, '');
    var urlParams = new URLSearchParams(currentUrl);
    var sso_code = urlParams.get('code');
    var login_type = getParameterByName('login_type', url);
    login_type = getParameterByName('login_type', url);
    var redirect_uri_api = "http:" + window.location.host + "/#!/app/loginsso";
    var redirect_uri = "http:" + window.location.host + "/%23%21/app/loginsso";
    if(login_type == 'sso'){
        var host_name = "auth-sso.mobifone.vn:8080";
        var realm_name = "sso-mobifone";
        var client_id = "TTCNTT-MOBIFONEINVOICE";
        var scope = "openid";
        var response_type = "code";
        var url = "https://" + host_name +
            "/oauth/realms/" + realm_name +
            "/protocol/openid-connect/auth?client_id=" + client_id +
            "&scope=" + scope +
            "&response_type=" + response_type +
            "&redirect_uri=" + redirect_uri;
        window.location.href = url;
    }
    else{
        if(sso_code != null || sso_code != ""){
            user.loginsso(sso_code, redirect_uri_api, '', 'vi');
        }
        else{
            window.location.href = "/#!" + start;
        }
    }
    return {
        $ui: {},
    }
});

define('views/main',["app", "locale", "models/user", "views/forms/main"], function (app, _, user, main) {
    

    var fm = function (number, decimalSizeDefault) {
        if (decimalSizeDefault === undefined || decimalSizeDefault === null) decimalSizeDefault = 0;
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: decimalSizeDefault,
        });
        return k(number);
    };

    var op = [];

    webix.$$("title").parse({ title: "Quản lý hóa đơn", details: "Quản lý hóa đơn đầu vào" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        //css: { "background": "#ccc !important" },
        data: ["Thêm", { $template: "Separator" }, "Sửa", { $template: "Separator" }, "Xóa", { $template: "Separator" }, "Tải File đính kèm"],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("mainData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in chứng từ",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại hóa đơn gốc !", "error");
                    //     return;
                    // }
                }
            },
        },
    });
    var controls = [
        {
            id: "btnReload",
            view: "button",
            type: "icon",
            icon: "fas fa-refresh",
            label: _("REFRESH"),
            css: "webix_secondary",
            width: 96,
            on: {
                onClick: function () {
                    var table = webix.$$("mainData");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnPlus",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: "Thêm (F4)",
            width: 90,
            shortcut: "F4",
            css: "webix_secondary",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(main.$ui);
                    //main.setValues(null, null, null);
                    main.setEditMode(1);
                    detailForm.show();
                    // if (vc_window.after_new != null) {
                    //     var fn = Function("app", vc_window.after_new);
                    //     fn(app);
                    // }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "far fa-edit",
            label: "Sửa (F3)",
            width: 90,
            shortcut: "F3",
            css: "webix_secondary",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(main.$ui);
                    //var detailForm = this.$scope.ui(webix.$$("main"));
                    var table = webix.$$("mainData");
                    var item = table.getSelectedItem();

                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }

                    if (item.$group) {
                        webix.message("Không thể sửa nhóm !", "error");
                        return;
                    }
                    // main.setEditMode(0);
                    // main.initUI(windowconfig);
                    main.setEditMode(2);
                    main.setValues(item, null);

                    detailForm.show();
                    //main.focusFirstElement();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "icon",
            icon: "fas fa-trash-o",
            label: "Xóa (F8)",
            width: 80,
            shortcut: "F8",
            css: "webix_secondary",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("mainData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần xóa !", "error");
                        return;
                    }
                    if (item.$group) {
                        webix.message("Không thể xóa cột nhóm !", "error");
                        return;
                    }

                    var khData = {};
                    // khData.windowid = windowconfig.data[0].window_id;
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);

                    webix.confirm({
                        title: "XÓA HÓA ĐƠN",
                        text: "Bạn có muốn xóa hóa đơn số: <span style='color: red'>" + item.invoiceNumber + "</span>",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/ManageInvoice/SaveInv", khData, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.ExceptionMessage, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            table.remove(item.id);
                                            table.enable();
                                            table.hideProgress();
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDowload",
            view: "button",
            type: "icon",
            icon: "far fa-download",
            css: "webix_secondary",
            label: _("Tải File"),
            width: 80,
            on: {
                onClick: function () {
                    //webix.confirm();
                    //webix.message("Continue ! ", "debug");
                    var table = webix.$$("mainData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }

                    if (item.fileUrl == null || item.fileUrl == "") {
                        webix.message("Hóa đơn không có file đính kèm !", "error");
                        return;
                    }

                    if (item.$group) {
                        webix.message("Không thể sửa nhóm !", "error");
                        return;
                    }

                    webix.confirm({
                        title: "TẢI HÓA ĐƠN",
                        text: "Bạn có muốn tải file hóa đơn số: <span style='color: red'>" + item.invoiceNumber + "</span>",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();
                                webix
                                    .ajax()
                                    .response("arraybuffer")
                                    .get(app.config.host + "/ManageInvoice/DowloadFile?url=" + item.fileUrl, function (text, data) {
                                        var file = new Blob([data], { type: item.fileType });
                                        webix.html.download(file, item.fileName);
                                        table.enable();
                                        table.hideProgress();
                                    });
                                // webix.ajax()
                                //     .headers({ 'Content-type': 'application/json' })
                                //     .post(app.config.host + "/ManageInvoice/SaveInv", khData,
                                //     {
                                //         error: function (text, data, XmlHttpRequest) {
                                //             table.enable();
                                //             table.hideProgress();
                                //             var json = JSON.parse(text);
                                //             webix.message(json.ExceptionMessage, "error");
                                //             //webix.message(XmlHttpRequest.statusText, "error");
                                //         },
                                //         success: function (text, data, XmlHttpRequest) {
                                //             table.remove(item.id);
                                //             table.enable();
                                //             table.hideProgress();
                                //         }
                                //     });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnPrint",
            view: "button",
            type: "icon",
            icon: "far fa-print",
            label: _("PRINT") + " PDF",
            css: "webix_secondary",
            width: 70,
            on: {
                onClick: function () {
                    var table = $$("mainData");

                    // var rpParameter = table.config.rpParameter;
                    var rpParameter = null;
                    // if (rpParameter == undefined || rpParameter == null) {
                    //     webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                    //     return;
                    // }
                    // rpParameter.type = "PDF";
                    //console.log(rpParameter);
                    // if (rpParameter != null) {
                    var box = webix.modalbox({
                        title: "Đang in báo cáo ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .post(
                            app.config.host + "/Bcthsd/PrintPDFBangKeBanRa",
                            rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    window.open(fileURL, "_blank");
                                    webix.modalbox.hide(box);
                                },
                            }
                            // function (text, data) {
                            //     var file = new Blob([data], { type: 'application/pdf' });
                            //     var fileURL = URL.createObjectURL(file);
                            //     webix.modalbox.hide(box);
                            //     window.open(fileURL, '_blank');
                            // }
                        );
                    // }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnExport",
            view: "button",
            type: "icon",
            icon: "far fa-file",
            label: _("EXPORT_EXCEL"),
            css: "webix_secondary",
            width: 115,
            on: {
                onClick: function () {
                    var box = webix.modalbox({
                        title: "Đang kết suất Excel ... ",
                        buttons: ["Hủy bỏ"],
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                        callback: function (result) {
                            switch (result) {
                                case "0":
                                    clearTimeout(interVal);
                                    webix.modalbox.hide(box);
                                    break;
                            }
                        },
                    });
                    var interVal = setTimeout(function () {
                        var table = $$("mainData");
                        webix.toExcel(table, {
                            rawValues: true,
                        });
                        clearTimeout(interVal);
                        webix.modalbox.hide(box);
                    }, 1500);

                    // var rpParameter = table.config.rpParameter;
                    // if (rpParameter == undefined || rpParameter == null) {
                    //     webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                    //     return;
                    // }
                    // rpParameter.type = "xlsx";

                    // if (rpParameter != null) {
                    //     var box = webix.modalbox({
                    //         title: "Đang kết xuất Excel ....",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .post(app.config.host + "/Bcthsd/PrintPDFBangKeBanRa", rpParameter,
                    //         {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 webix.message(XmlHttpRequest.statusText, "error");
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    //                 var fileURL = URL.createObjectURL(file);
                    //                 webix.modalbox.hide(box);
                    //                 window.location.href = fileURL;
                    //             }
                    //         }
                    //         // function (text, data) {

                    //         //     var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    //         //     var fileURL = URL.createObjectURL(file);

                    //         //     window.location.href = fileURL;
                    //         // }
                    //         );
                    // }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },

        {},
    ];

    var grid = {
        rows: [
            {
                container: "testA",
                view: "treetable",
                id: "mainData",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                rowLineHeight: 25,
                rowHeight: 25,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var url = app.config.host + "/ManageInvoice/GetData";

                        if (params == null) {
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);

                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property],
                                    };

                                    array.push(item);
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + JSON.stringify(array);
                            }
                        }

                        webix.ajax(url, callback, view);
                    },
                },
                on: {
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            webix.message("Continue Dowloading ... !", "debug");
                        }
                    },
                    onClick: function (e) {
                        var view = $$(e);
                        if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate")) webix.confirm("The changes was not saved");
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                        webix.delay(function () {
                            this.adjustRowHeight("ten_loai", true);
                            this.render();
                        }, this);
                        //console.log($$("mainData").serialize());
                        this.openAll();
                        $$("cmenu").attachTo($$("mainData"));
                    },
                    onColumnResize: function () {
                        this.adjustRowHeight("ten_loai", true);
                        this.render();
                    },
                    // "data->onStoreUpdated": function () {
                    //     this.data.each(function (obj, i) {
                    //         console.log(obj);
                    //         console.log(i);
                    //         obj.index = i + 1;
                    //     })
                    // }
                },
                columns: [
                    {
                        id: "stt",
                        header: "<center>STT</center>",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "ten_loai",
                        header: [{ text: "<center>Hóa đơn chứng từ bán</center>", colspan: 2 }, { text: "<center>Số hóa đơn</center>" }],
                        width: 525,
                        // template: function (obj, common) {
                        //     if (obj.$group) return common.treetable(obj, common) + obj.invoiceNumber;
                        //     return obj.invoiceNumber;
                        //}
                        template: function (obj, common) {
                            if (obj.$level == 1) return common.treetable(obj, common) + "<span style='color:red;'>" + obj.value + " ( " + obj.$count + " )" + "</span>";
                            //return obj.invoiceNumber;
                            return "<a href='JavaScript:Void(0);'> " + obj.invoiceNumber + "</a>";
                        },
                    },
                    {
                        id: "invoiceDate",
                        header: [null, { text: "<center>Ngày hóa đơn</center>" }],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                    },
                    { id: "sellerName", header: ["<center>Tên người mua</center>", { content: "textFilter" }], width: 300 },
                    { id: "sellerTaxCode", header: "<center>Mã số thuế</center>", width: 150 },
                    {
                        id: "totalAmountWithoutVat",
                        header: "<center>Doanh thu chưa có thuế GTGT</center>",
                        width: 200,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                        template: function (obj, common) {
                            if (obj.$level == 1) return "<b><span style='color:red;'>" + fm(obj.totalAmountWithoutVat) + "</span></b>";
                            return obj.totalAmountWithoutVat == null ? 0 : fm(obj.totalAmountWithoutVat);
                        },
                    },
                    {
                        id: "vatAmount",
                        header: "<center>Thuế GTGT</center>",
                        width: 100,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0,
                        }),
                        template: function (obj, common) {
                            if (obj.$level == 1) return "<b><span style='color:red;'>" + fm(obj.vatAmount) + "</span></b>";
                            return obj.vatAmount == null ? 0 : fm(obj.vatAmount);
                        },
                    },
                    { id: "ghi_chu", header: "<center>Ghi chú</center>", width: 150 },
                ],
                pager: "pagerA",
                scheme: {
                    $group: {
                        by: "ten_loai",
                        //css:"multiline",
                        map: {
                            vatAmount: ["vatAmount", "sum"],
                            totalAmountWithoutVat: ["totalAmountWithoutVat", "sum"],
                            //title: ["year"]
                        },
                    },
                    //$sort: { by: "stt", dir: "asc" }
                },
                ready: function () {
                    //this.open(this.getFirstId());
                    //this.sort({ by: "stt", dir: "asc" });
                    this.openAll();
                },
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChangedMain", function (editmode, item) {
                var table = webix.$$("mainData");

                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }
            });
            // var table = $$("mainData");
            // var url = {
            //     $proxy: true,
            //     load: function (view, callback, params) {
            //         console.log(view.config);
            //         console.log(callback);
            //         console.log(params);
            //         /*var windowno = app.path[1].params[0];
            //         var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

            //         if (params == null) {
            //             url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            //         }
            //         else {
            //             url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

            //             if (params.filter != null) {
            //                 var array = [];

            //                 for (var property in params.filter) {

            //                     var column = view.getColumnConfig(property);

            //                     if (column !== undefined) {
            //                         var item = {
            //                             columnName: property,
            //                             columnType: column.columnType,
            //                             value: params.filter[property]
            //                         };

            //                         array.push(item);
            //                     }
            //                 }

            //                 //console.log(JSON.stringify(array));
            //                 if (array.length > 0) {
            //                     url = url + "&filter=" + JSON.stringify(array);
            //                 }
            //                 else {
            //                     url = url + "&filter=null";
            //                 }

            //             }
            //             else {
            //                 url = url + "&filter=null";
            //             }
            //         }

            //         if (view.config.infoparam != null) {
            //             url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
            //         }
            //         else {
            //             url = url + "&infoparam=null";
            //         }

            //         var tlbParams = $$("tlbParams");

            //         if (tlbParams !== undefined) {
            //             var childViews = tlbParams.getChildViews();

            //             var parameters = [];

            //             for (var i = 0; i < childViews.length; i++) {
            //                 var child = childViews[i];

            //                 var id = child.config.id;
            //                 var value_field = child.config.value_field;

            //                 var item = {
            //                     columnName: value_field,
            //                     value: $$(id).getValue()
            //                 };

            //                 parameters.push(item);
            //             }

            //             url = url + "&tlbparam=" + JSON.stringify(parameters);

            //         }
            //         else {
            //             url = url + "&tlbparam=null";
            //         }*/

            //         //console.log(url);

            //         /* webix.ajax().bind(view)
            //             .get(url,function(text){
            //                 var json =JSON.parse(text);

            //                 this.clearAll();

            //                 if (!json.hasOwnProperty("error")){
            //                     this.parse(json.data,"json");
            //                 }
            //         }); */

            //         //webix.ajax(url, callback, view);

            //     }
            // };

            // table.define("url", url);
        },
    };
});

define('views/mauhoadon',["app", "views/forms/mauhoadon", "locale", "views/modules/minvoiceplugin"], function (app, dmwindowform, _, plugin) {
    

    var op = [];

    webix.$$("title").parse({ title: "Mẫu hóa đơn", details: "Danh sách mẫu hóa đơn" });

    var submenu = webix.ui({
        view: "submenu",
        width: 200,
        padding: 0,
        data: [
            // { id: "createInvoiceTemplate", value: "Tạo mẫu hóa đơn" },
            { id: "printInvoiceTemplate", value: "Xem mẫu hóa đơn (PDF)" },
            { id: "printTempHtml", value: "Xem mẫu hóa đơn (Html)" },
            { id: "dowload", value: "Tải file .repx" },
            // { id: "signInvoiceTemplate", value: "Ký mẫu hóa đơn" },
            { id: "uploadInvoiceTemplate", value: "Upload mẫu hóa đơn" },
        ],
        on: {
            onItemClick: function (id, e, node) {
                this.hide();

                if (id == "createInvoiceTemplate") {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn", "error");
                        return;
                    }

                    var box = webix.modalbox({
                        title: "Đang tạo mẫu hóa đơn",
                        buttons: ["Hủy bỏ"],
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                        callback: function (result) {
                            switch (result) {
                                case "0":
                                    clearInterval(interVal);
                                    webix.modalbox.hide(box);
                                    break;
                            }
                        },
                    });

                    var interVal = setInterval(function () {
                        var url = app.config.host + "/Invoice/GetInvoiceTemplate?id=" + item.id;

                        webix.ajax(url, {
                            error: function (text, data, XmlHttpRequest) {
                                alert(text);
                                webix.modalbox.hide(box);
                                clearInterval(interVal);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var result = JSON.parse(text);

                                if (result.trang_thai_mau == "Đã tạo mẫu") {
                                    var table = webix.$$("dmwindowData");
                                    var item = table.getSelectedItem();

                                    item.trang_thai_mau = "Đã tạo mẫu";
                                    table.updateItem(item);

                                    webix.modalbox.hide(box);
                                    clearInterval(interVal);
                                }
                            },
                        });
                    }, 3000);

                    window.location.href = app.config.host + "/Content/App/ReportDesign/ReportDesign.application?type=99&id=" + item.id;
                }

                if (id == "printInvoiceTemplate") {
                    var item = $$("dmwindowData").getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn", "error");
                        return;
                    }

                    var url = app.config.host + "/Invoice/PrintInvoiceTemplate?id=" + item.id;
                    var box = webix.modalbox({
                        title: "Đang in mẫu hóa đơn (PDF) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: "application/pdf" });
                            //  webix.html.download(file, "ahihi.pdf");
                            var fileURL = URL.createObjectURL(file);
                            //console.log(fileURL);
                            webix.modalbox.hide(box);
                            window.open(fileURL, "_blank");
                        });
                }
                if (id == "dowload") {
                    var item = $$("dmwindowData").getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn", "error");
                        return;
                    }

                    if (item.template_status != "Đã tạo mẫu") {
                        webix.message("Mẫu hóa đơn chưa được tạo, không thể tải xuống !", "error");
                        return;
                    }

                    var url = app.config.host + "/Invoice/DowloadRepx?id=" + item.id;
                    var box = webix.modalbox({
                        title: "Đang tải mẫu hóa đơn (repx) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: "application/octet-stream" });
                            webix.html.download(file, "InvoiceTemplate.repx");
                            // var fileURL = URL.createObjectURL(file);
                            //console.log(fileURL);
                            webix.modalbox.hide(box);
                            //window.open(fileURL, '_blank');
                        });
                }

                if (id == "printTempHtml") {
                    var item = $$("dmwindowData").getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn");
                        return;
                    }

                    var url = app.config.host + "/Invoice/PrintInvoiceTemplate?id=" + item.id + "&type=Html";
                    var box = webix.modalbox({
                        title: "Đang in mẫu hóa đơn (Html) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });
                    var newwin = window.open();

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: "text/html" });
                            var fileURL = URL.createObjectURL(file);
                            webix.modalbox.hide(box);
                            newwin.location = fileURL;
                        });
                }

                if (id == "signInvoiceTemplate") {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn", "error");
                        return;
                    }

                    var a = webix.ajax(app.config.host + "/Invoice/GetXmlTemplate?id=" + item.id);
                    var b = webix.ajax(app.config.host + "/Invoice/GetListCertificates");
                    var c = webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/System/ExecuteCommand", {
                            command: "CM00019",
                            parameter: {
                                ma_dvcs: "",
                            },
                        });

                    webix.promise.all([a, b, c]).then(function (results) {
                        var xmlData = results[0].json();
                        var listcerts = results[1].json();
                        var c_results = results[2].json();

                        if (listcerts.length == 0) {
                            webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                            return;
                        }

                        var kytaptrung = "";
                        var server_cert = "";

                        for (var i = 0; i < c_results.length; i++) {
                            var item = c_results[i];

                            if (item.code == "KYTAPTRUNG") {
                                kytaptrung = item.value;
                            }

                            if (item.ma == "SERVER_CERT") {
                                server_cert = item.value;
                            }
                        }

                        if (kytaptrung == "K") {
                            var hub = plugin.hub();

                            hub.off("resCommand");
                            hub.on("resCommand", function (result) {
                                var json = JSON.parse(result);

                                if (json.hasOwnProperty("error")) {
                                    webix.message({ type: "error", text: json.error });
                                } else {
                                    var callback = json.callback;

                                    if (callback == "SignInvoice") {
                                        var table = webix.$$("dmwindowData");
                                        var item = table.getSelectedItem();

                                        var parameter = {
                                            id: item.id,
                                            xml: json.xml,
                                        };

                                        webix
                                            .ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/Invoice/SignXmlTemplate", parameter, function (text) {
                                                var json = JSON.parse(text);

                                                if (!json.hasOwnProperty("error")) {
                                                    var table = $$("dmwindowData");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                } else {
                                                    webix.message({ type: "error", text: json.error });
                                                }
                                            });
                                    }
                                }
                            });

                            var _listcerts = [];

                            for (var i = 0; i < listcerts.length; i++) {
                                var item = listcerts[i];

                                _listcerts.push({
                                    so_serial: item.cer_serial,
                                    ngaybatdau: item.begin_date,
                                    ngayketthuc: item.end_date,
                                    issuer: item.issuer,
                                    subjectname: item.subject_name,
                                });
                            }

                            var arg = {
                                callback: "SignInvoice",
                                idData: "#data",
                                xml: xmlData["xml"],
                                idSigner: "seller",
                                tagSign: "Signatures",
                                dateKy: xmlData["dateKy"],
                                listcerts: _listcerts,
                            };

                            hub.invoke("execCommand", arg.callback, JSON.stringify(arg));
                        } else {
                            var box = webix.modalbox({
                                title: "Chọn chứng thư số",
                                buttons: ["Nhận", "Hủy bỏ"],
                                text: "<div id='ctnCerts'></div>",
                                top: 100,
                                width: 750,
                                callback: function (result) {
                                    switch (result) {
                                        case "1":
                                            webix.modalbox.hide();
                                            break;
                                        case "0":
                                            var table = $$("tblCerts");
                                            var data = table.serialize();

                                            var cert = null;

                                            for (var i = 0; i < data.length; i++) {
                                                if (data[i].chon == true) {
                                                    cert = data[i];
                                                    break;
                                                }
                                            }

                                            if (cert == null) {
                                                webix.message("Bạn chưa chọn chứng thư số");
                                                return;
                                            }

                                            var table = webix.$$("dmwindowData");
                                            var item = table.getSelectedItem();

                                            webix.ajax(app.config.host + "/Invoice/GetXmlTemplate?id=" + item.id, function (text, data) {
                                                var xmlData = JSON.parse(text);

                                                var parameters = {
                                                    xml: xmlData["xml"],
                                                    refUri: "#data",
                                                    certSerial: cert.cer_serial,
                                                    tokenSerial: cert.token_serial,
                                                    signId: "seller",
                                                    signTag: "Signatures",
                                                    pass: cert.pass,
                                                    inv_InvoiceAuth_id: xmlData["id"],
                                                };

                                                webix
                                                    .ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .post(server_cert + "/Token/SignXml", parameters, function (text) {
                                                        var json = JSON.parse(text);

                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message(json["error"]);
                                                        } else {
                                                            var parameter = {
                                                                id: item.inv_InvoiceAuth_id,
                                                                xml: json.xml,
                                                            };

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-type": "application/json" })
                                                                .post(app.config.host + "/Invoice/SignXmlTemplate", parameter, function (text) {
                                                                    var json = JSON.parse(text);

                                                                    if (!json.hasOwnProperty("error")) {
                                                                        var table = $$("dmwindowData");
                                                                        table.clearAll();
                                                                        table.load(table.config.url);
                                                                    } else {
                                                                        webix.message({ type: "error", text: json.error });
                                                                    }
                                                                });
                                                        }
                                                    });
                                            });
                                    }
                                },
                            });

                            var popupText = document.getElementsByClassName("webix_popup_text")[0];
                            popupText.style.paddingTop = 0;

                            var tblMatHang = webix.ui({
                                container: "ctnCerts",
                                id: "tblCerts",
                                view: "datatable",
                                borderless: true,
                                height: 350,
                                columns: [
                                    {
                                        id: "chon",
                                        header: _("CHON"),
                                        width: 65,
                                        checkValue: true,
                                        uncheckValue: false,
                                        template: "{common.checkbox()}",
                                    },
                                    {
                                        id: "cert_type",
                                        header: _("Loại"),
                                        width: 100,
                                    },
                                    {
                                        id: "cer_serial",
                                        header: _("SO_SERIAL"),
                                        width: 150,
                                    },
                                    {
                                        id: "subject_name",
                                        header: _("SUBJECTNAME"),
                                        width: 450,
                                    },
                                    {
                                        id: "begin_date",
                                        header: _("NGAY_BAT_DAU"),
                                        width: 200,
                                    },
                                    {
                                        id: "end_date",
                                        header: _("NGAY_KET_THUC"),
                                        width: 200,
                                    },
                                    {
                                        id: "issuer",
                                        header: _("DONVI"),
                                        width: 450,
                                    },
                                ],
                                url: app.config.host + "/Invoice/GetListCertificates",
                            });
                        }
                    });
                }

                if (id == "uploadInvoiceTemplate") {
                    require(["views/forms/uploadfile"], function (uploadForm) {
                        var table = webix.$$("dmwindowData");

                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);

                        win.getHead().setHTML("Tải file mẫu hóa đơn");
                        win.show();

                        var item = table.getSelectedItem();

                        webix.$$("uploader").define("upload", app.config.host + "/Invoice/UploadInvTemplate");
                        webix.$$("uploader").define("formData", { dmmauhoadon_id: item.id });
                        webix.$$("uploader").refresh();
                    });
                }
            },
        },
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-plus",
            // css: "webix_secondary",
            // label: _("THEM") + " (F4)",
            // width: 85,
            //css:"button_raised",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmwindowform.$ui);
                    dmwindowform.setEditMode(1);

                    win.show();

                    var form = $$("mauhoadon-form");
                    var values = form.getValues();

                    values.invoice_type = "E";
                    values.copy_number = 0;
                    values.row_print_template = 10;

                    form.setValues(values);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-edit",
            // css: "webix_secondary",
            // label: _("SUA") + " (F3)",
            // width: 85,
            //css:"button_raised",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("mauhoadon-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    form.setValues(item);

                    dmwindowform.setEditMode(2);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-trash-o",
            // label: _("XOA") + " (F8)",
            // css: "webix_secondary",
            // width: 85,
            //css:"button_raised",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    var khData = {};
                    khData.windowid = app.path[1].params[0];
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.name,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/System/Save", khData, function (text) {
                                        var json = JSON.parse(text);
                                        if (json.hasOwnProperty("error")) {
                                            webix.message({ type: "error", text: json.error });
                                            return;
                                        }

                                        table.remove(item.id);
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + " (F7)</span>",
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-copy",
            // label: _("COPY") + " (F7)",
            // css: "webix_secondary",
            // width: 90,
            //css:"button_raised",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message({ type: "error", text: "Bạn chưa chọn mẫu cần sao chép" });
                        return;
                    }

                    var comp = {
                        view: "window",
                        modal: true,
                        head: "Sao chép mẫu",
                        position: "center",
                        body: {
                            view: "form",
                            paddingY: 10,
                            paddingX: 10,
                            margin: 0,
                            complexData: true,
                            elements: [
                                {
                                    view: "text",
                                    name: "invoice_series",
                                    labelPosition: "top",
                                    width: 300,
                                    value: item.invoice_series,
                                    required: true,
                                    on: {
                                        onChange: function (newv, oldv) {
                                            if (newv == undefined) return;
                                            if (newv == "") return;

                                            if (newv.length != 6) {
                                                webix.message({ type: "error", text: "Độ dài ký hiệu phải là 6 ký tự" });
                                                this.focus();
                                                return;
                                            }

                                            var patt = /^[A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][/]$/;

                                            if (patt.test(newv.substring(0, 3)) == false) {
                                                webix.message({ type: "error", text: "3 ký tự đầu không đúng" });
                                                this.focus();
                                                return;
                                            }

                                            patt = /^[1-9][0-9]$/;

                                            var nam = newv.substring(3, 5);

                                            if (patt.test(nam) == false) {
                                                webix.message({ type: "error", text: "2 ký tự năm không đúng" });
                                                this.focus();
                                                return;
                                            }

                                            var now = new Date();
                                            var year = now.getFullYear();

                                            nam = Number("20" + nam);

                                            if (nam < year - 1 || nam > year) {
                                                webix.message({ type: "error", text: "Năm ký hiệu không đúng" });
                                                this.focus();
                                                return;
                                            }

                                            if (newv.substring(5, 6) != "E") {
                                                webix.message({ type: "error", text: "Ký tự cuối phải là E" });
                                                this.focus();
                                                return;
                                            }
                                        },
                                    },
                                },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        {
                                            shortcut: "F10",
                                            view: "button",
                                            label: "Lưu (F10)",
                                            type: "form",
                                            align: "center",
                                            width: 120,
                                            on: {
                                                onClick: function () {
                                                    var win = this.getTopParentView();
                                                    var form = win.queryView({ view: "form" });

                                                    if (form.validate() == false) {
                                                        return;
                                                    }
                                                    var item = form.getValues();
                                                    var table = webix.$$("dmwindowData");
                                                    var selectedItem = table.getSelectedItem();

                                                    var url = app.config.host + "/Invoice/CopyTemplate";
                                                    item.id = selectedItem.id;

                                                    webix
                                                        .ajax()
                                                        .bind(win)
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(url, item, function (text) {
                                                            var data = JSON.parse(text);

                                                            if (!data.hasOwnProperty("error")) {
                                                                this.close();
                                                                if (data.hasOwnProperty("ok") && data.ok) {
                                                                    webix.message("Thêm mới mẫu hóa đơn thành công!", "success");
                                                                }
                                                                var table = webix.$$("dmwindowData");
                                                                table.clearAll();
                                                                table.load(table.config.url);
                                                            } else {
                                                                webix.message(data.error, "error");
                                                            }
                                                        });
                                                },
                                            },
                                            click: function () {
                                                this.callEvent("onClick");
                                            },
                                        },
                                        {
                                            view: "button",
                                            hotkey: "esc",
                                            label: "Hủy bỏ (ESC)",
                                            align: "center",
                                            type: "danger",
                                            width: 120,
                                            click: function () {
                                                var win = this.getTopParentView();
                                                win.close();
                                            },
                                        },
                                        {},
                                    ],
                                },
                            ],
                            rules: {
                                $obj: function () {
                                    var data = this.getValues();
                                    var newv = data.invoice_series;

                                    if (newv.length != 6) {
                                        webix.message({ type: "error", text: "Độ dài ký hiệu phải là 6 ký tự" });
                                        return false;
                                    }

                                    var patt = /^[A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][/]$/;

                                    if (patt.test(newv.substring(0, 3)) == false) {
                                        webix.message({ type: "error", text: "3 ký tự đầu không đúng" });
                                        return false;
                                    }

                                    patt = /^[1-9][0-9]$/;

                                    var nam = newv.substring(3, 5);

                                    if (patt.test(nam) == false) {
                                        webix.message({ type: "error", text: "2 ký tự năm không đúng" });
                                        return false;
                                    }

                                    var now = new Date();
                                    var year = now.getFullYear();

                                    nam = Number("20" + nam);

                                    if (nam < year - 1 || nam > year) {
                                        webix.message({ type: "error", text: "Năm ký hiệu không đúng" });
                                        return false;
                                    }

                                    if (newv.substring(5, 6) != "E") {
                                        webix.message({ type: "error", text: "Ký tự cuối phải là E" });
                                        return false;
                                    }

                                    return true;
                                },
                            },
                        },
                    };

                    var win = this.$scope.ui(comp);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
            rules: {
                $obj: function () {
                    var data = this.getValues();

                    return true; //success!
                },
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("CHUC_NANG") + "</span>",
            id: "btnChucNang",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-angle-down",
            // label: "Chức năng",
            // width: 120,
            // css: "button_raised",
            click: function () {
                submenu.show(webix.$$("btnChucNang").$view);
            },
        },
        {},
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                //loadahead: 15,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

                        if (params == null) {
                            url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);

                                    if (column !== undefined) {
                                        var item = {
                                            columnName: property,
                                            columnType: column.columnType,
                                            value: params.filter[property],
                                        };

                                        if (column.tableAlias != undefined) {
                                            item.tableAlias = column.tableAlias;
                                        }

                                        if (item.columnType == "bit") {
                                            if (item.value != "") {
                                                item.value = item.value == "true" ? true : item.value == "false" ? false : "";
                                            }
                                        }

                                        if (item.columnType == "int" || item.columnType == "decimal") {
                                            if (item.value != "") {
                                                if (webix.rules.isNumber(item.value)) {
                                                    item.value = Number(item.value);
                                                } else {
                                                    item.value = "";
                                                }
                                            }
                                        }

                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                if (array.length > 0) {
                                    url = url + "&filter=" + JSON.stringify(array);
                                } else {
                                    url = url + "&filter=null";
                                }
                            } else {
                                url = url + "&filter=null";
                            }
                        }

                        if (view.config.infoparam != null) {
                            url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                        } else {
                            url = url + "&infoparam=null";
                        }

                        var tlbParams = $$("tlbParams");

                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();

                            var parameters = [];

                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];

                                var id = child.config.id;
                                var value_field = child.config.value_field;

                                var item = {
                                    columnName: value_field,
                                    value: $$(id).getValue(),
                                };

                                parameters.push(item);
                            }

                            url = url + "&tlbparam=" + JSON.stringify(parameters);
                        } else {
                            url = url + "&tlbparam=null";
                        }

                        //console.log(url);

                        webix.ajax(url, callback, view);
                    },
                },
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                },
                columns: [
                    { id: "name", columnType: "character varying", header: [_("TEN_MAU"), { content: "serverFilter" }], width: 250 },
                    {
                        id: "sl_invoice_type_id",
                        view: "combo",
                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00008",
                        header: [_("LOAI_HOA_DON"), { content: "serverSelectFilter" }],
                        columnType: "uuid",
                        tableAlias: "sl_invoice_template",
                        width: 300,
                    },
                    {
                        id: "invoice_type",
                        view: "combo",
                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00009",
                        header: [_("HINH_THUC"), { content: "serverSelectFilter" }],
                        columnType: "character varying",
                        width: 200,
                    },
                    { id: "template_code", columnType: "character varying", header: [_("MAU_SO"), { content: "serverFilter" }], width: 150 },
                    { id: "invoice_series", columnType: "character varying", header: [_("KY_HIEU"), { content: "serverFilter" }], width: 150 },
                    // { id: "copy_number", columnType: "integer", header: [_("SO_LIEN"), { content: "serverFilter" }], width: 150 },
                    { id: "template_status", columnType: "character varying", header: [_("TRANG_THAI_MAU"), { content: "serverFilter" }], width: 150 },
                    // {
                    //     id: "signed",
                    //     checkValue: true,
                    //     uncheckValue: false,
                    //     template: function (obj, common, value) {
                    //         if (value)
                    //             return "<div class='webix_icon fa-check-square-o'></div>";
                    //         else
                    //             return "<div class='webix_icon fa-square-o'></div>";
                    //     },
                    //     columnType: "boolean",
                    //     header: [_("DA_KY"), { content: "serverFilter" }],
                    //     width: 100
                    // }
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                view: "toolbar",
                cols: controls,
                borderless: true,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});


define('views/menus/notification',["app"
], function (app) {

    function initUI(item) {
        $$("lstUser").select(item.id);
        $$("content").setHTML(item.inv_content);
        $$("notification-win").getHead().setHTML("Thông tin bản cập nhật: " + item.version);
    }

    return {
        $ui: {
            view: "window", modal: true, id: "notification-win", position: "center", resize: true, move: true,
            head: "Thông tin bản cập nhật",
            body: {
                view: "form",
                id: "notification-form",
                height: 500,
                complexData: true,
                elements: [
                    {
                        cols: [
                            {
                                view: "list",
                                id: "lstUser",
                                select: true,
                                on: {
                                    onItemClick: function (id, e, node) {
                                        var item = this.getItem(id);
                                        //webix.message(id, "error");
                                        $$("notification-win").getHead().setHTML("Thông tin bản cập nhật: " + item.version);
                                        $$("content").setHTML(item.inv_content);
                                    }
                                },
                                url: app.config.host + "/System/GetNotification",
                                // data: [
                                //     { id: 1, version: "3.1.0.0", update: "Lorem ipsum dolor sit amet", personId: 1 },
                                //     { id: 2, version: "3.2.0.0", update: "Praesent luctus nulla enim, pellentesque condimentum ", personId: 2 },
                                //     { id: 3, version: "3.3.0.0", update: "Lorem ipsum dolor sit amet", personId: 2 },
                                //     { id: 4, version: "3.4.0.0", update: "Morbi eget facilisis risus", personId: 1 },
                                //     { id: 5, version: "3.5.0.0", update: "Cras lacinia bibendum arcu", personId: 1 }
                                // ],
                                template: "- #version#",
                                //template: "<span class='webix_icon fa-user'></span> <span class='rowBold'>#User# </span>",
                                width: 150
                            },
                            {
                                width: 900,
                                paddingX: 5,
                                paddingX: 5,
                                rows: [
                                    {
                                        view: "template", id: "content", scroll: "xy",
                                        // , gravity: 3
                                        type: { height: "auto" },
                                        // template: function (obj) {
                                        //     return "<span " + (obj.user == user.getCurrentUser() ? "class='rowBold'" : "class='rowBoldGreen'") + ">" + obj.user + "</span> " + obj.value;
                                        // }
                                    },
                                    {
                                        paddingY: 5,
                                        cols: [
                                            {},
                                            // {
                                            //     view: "button", value: "Cập nhật", width: 100, type: "danger",
                                            //     click: function () {

                                            //     }
                                            // },
                                            {
                                                view: "button", type: "danger", label: "Đóng (ESC)", shortcut: "esc", align: "center", width: 100,
                                                on: {
                                                    onClick: function () {
                                                        webix.$$("notification-win").close();
                                                    }
                                                },
                                                click: function () {
                                                    this.callEvent("onClick");
                                                }
                                            },
                                            {}
                                        ]
                                    }
                                ]
                            }
                        ]
                    }

                ]
            }
        },
        initUI: initUI
    };

});
define('views/menus/sidebar',["app"],function(app){
	
	return {
		$ui:{
			width: 220,

			rows:[
				{
					view: "tree",
					//id: "app:menu",
					type: "menuTree2",
					css: "menu",
					activeTitle: true,
					select: true,
					tooltip: {
						template: function(obj){
							return obj.$count?"":obj.details;
						}
					},
					on:{
						onBeforeSelect:function(id){
							if(this.getItem(id).$count){
								return false;
							}
							
						},
						onAfterSelect:function(id){
							
							var item = this.getItem(id);
							
							var start = item.window_id!=null ? item.code + ":" + item.window_id : item.code;
							this.$scope.show("./"+ start);
							
							webix.$$("title").parse({title: item.value, details: item.details});
						}
					},
					url: app.config.host + "/api/System/GetSideBar"
				}
			]
		},
		getApiHost: function(){
			return app.config.host;
		}
	};

});

define('views/modules/aichatbot',[
    'app',
    'models/user'
], function (app, user) {
    

    var shadowRoot = null;
    var threadId = null;
    var isStreaming = false;
    var authWatchTimer = null;

    function generateThreadId() {
        return 'thread_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    }

    function isLoggedIn() {
        return !!user.getAccessToken();
    }

    function getAuthHeader() {
        var token = user.getAccessToken();
        var dvcs = user.getDvcsID();
        var language = user.getLanguage();
        if (!token) return "";
        return "Bear " + token + ";" + dvcs + ";" + language;
    }

    function getStyles() {
        return '\
            :host { all: initial; }\
            * { box-sizing: border-box; }\
            .chat-container {\
                position: fixed;\
                width: 520px;\
                height: 620px;\
                border-radius: 12px;\
                background-color: #fff;\
                box-shadow: 0 5px 40px rgba(0, 0, 0, 0.15);\
                display: flex;\
                flex-direction: column;\
                overflow: hidden;\
                z-index: 1001;\
                opacity: 1;\
                transform: translateY(0);\
                transition: opacity 0.3s ease, transform 0.3s ease;\
                font-family: "Segoe UI", sans-serif;\
            }\
            .chat-container.hidden {\
                opacity: 0;\
                transform: translateY(20px);\
                pointer-events: none;\
            }\
            .chat-header {\
                background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%);\
                color: #fff;\
                padding: 14px 16px;\
                display: flex;\
                justify-content: space-between;\
                align-items: center;\
            }\
            .chat-header-left {\
                display: flex;\
                align-items: center;\
                gap: 10px;\
            }\
            .chat-header-left .header-icon {\
                width: 36px;\
                height: 36px;\
                border-radius: 50%;\
                background: rgba(255,255,255,0.2);\
                display: flex;\
                align-items: center;\
                justify-content: center;\
                font-size: 20px;\
            }\
            .chatbot-name {\
                display: flex;\
                flex-direction: column;\
            }\
            .chatbot-name-text {\
                font-size: 16px;\
                font-weight: 600;\
            }\
            .chatbot-status {\
                font-size: 11px;\
                opacity: 0.85;\
                display: flex;\
                align-items: center;\
                gap: 4px;\
            }\
            .chatbot-status .dot {\
                width: 6px;\
                height: 6px;\
                border-radius: 50%;\
                background: #4caf50;\
            }\
            .close-button {\
                background: none;\
                border: none;\
                color: #fff;\
                cursor: pointer;\
                font-size: 22px;\
                padding: 4px 8px;\
                border-radius: 4px;\
                transition: background 0.2s;\
            }\
            .close-button:hover {\
                background: rgba(255,255,255,0.15);\
            }\
            .chat-body {\
                display: flex;\
                flex-direction: column;\
                flex: 1;\
                overflow: hidden;\
                background: #f8f9fa;\
            }\
            .messages {\
                flex: 1;\
                overflow-y: auto;\
                padding: 16px;\
                display: flex;\
                flex-direction: column;\
                gap: 12px;\
                scroll-behavior: smooth;\
                scrollbar-width: thin;\
                scrollbar-color: #c1c1c1 transparent;\
            }\
            .messages::-webkit-scrollbar { width: 5px; }\
            .messages::-webkit-scrollbar-track { background: transparent; }\
            .messages::-webkit-scrollbar-thumb { background-color: #c1c1c1; border-radius: 10px; }\
            .message-row {\
                display: flex;\
                align-items: flex-start;\
                gap: 8px;\
            }\
            .message-row.user-row {\
                justify-content: flex-end;\
            }\
            .message-row.bot-row {\
                justify-content: flex-start;\
            }\
            .bot-avatar {\
                width: 28px;\
                height: 28px;\
                border-radius: 50%;\
                background: #e3f2fd;\
                display: flex;\
                align-items: center;\
                justify-content: center;\
                font-size: 14px;\
                flex-shrink: 0;\
                margin-top: 2px;\
            }\
            .message-bubble {\
                padding: 10px 14px;\
                border-radius: 12px;\
                max-width: 75%;\
                word-wrap: break-word;\
                line-height: 1.5;\
                font-size: 14px;\
            }\
            .user-bubble {\
                background: #1a73e8;\
                color: #fff;\
                border-bottom-right-radius: 4px;\
            }\
            .bot-bubble {\
                background: #fff;\
                color: #333;\
                border-top-left-radius: 4px;\
                box-shadow: 0 1px 3px rgba(0,0,0,0.08);\
            }\
            .message-time {\
                font-size: 10px;\
                color: #999;\
                margin-top: 4px;\
            }\
            .bot-row .message-time { margin-left: 36px; }\
            .user-row .message-time { text-align: right; }\
            .typing-indicator {\
                display: flex;\
                gap: 4px;\
                padding: 8px 14px;\
            }\
            .typing-indicator span {\
                width: 7px;\
                height: 7px;\
                border-radius: 50%;\
                background: #90a4ae;\
                animation: typing 1.4s infinite;\
            }\
            .typing-indicator span:nth-child(2) { animation-delay: 0.2s; }\
            .typing-indicator span:nth-child(3) { animation-delay: 0.4s; }\
            @keyframes typing {\
                0%, 60%, 100% { transform: translateY(0); }\
                30% { transform: translateY(-4px); }\
            }\
            .input-area {\
                display: flex;\
                align-items: flex-end;\
                gap: 8px;\
                padding: 12px 16px;\
                border-top: 1px solid #eee;\
                background: #fff;\
            }\
            .input-area textarea {\
                flex: 1;\
                min-height: 40px;\
                max-height: 100px;\
                padding: 10px 14px;\
                border: 1px solid #e0e0e0;\
                border-radius: 20px;\
                outline: none;\
                font-size: 14px;\
                font-family: inherit;\
                resize: none;\
                transition: border 0.2s;\
                line-height: 1.4;\
            }\
            .input-area textarea:focus {\
                border-color: #1a73e8;\
            }\
            .input-area textarea::-webkit-scrollbar { display: none; }\
            .input-area textarea { scrollbar-width: none; }\
            .send-btn {\
                width: 38px;\
                height: 38px;\
                border-radius: 50%;\
                border: none;\
                background: #1a73e8;\
                color: #fff;\
                cursor: pointer;\
                display: flex;\
                align-items: center;\
                justify-content: center;\
                transition: background 0.2s, transform 0.1s;\
                flex-shrink: 0;\
            }\
            .send-btn:hover { background: #1557b0; }\
            .send-btn:active { transform: scale(0.95); }\
            .send-btn:disabled {\
                background: #bdbdbd;\
                cursor: not-allowed;\
            }\
            .send-btn svg {\
                width: 18px;\
                height: 18px;\
            }\
            .welcome-msg {\
                text-align: center;\
                padding: 20px;\
                color: #666;\
                font-size: 13px;\
            }\
        ';
    }

    function getIconStyles() {
        return '\
            .chatbot-floating-icon {\
                position: fixed;\
                bottom: 82px;\
                right: 25px;\
                width: 56px;\
                height: 56px;\
                border-radius: 50%;\
                background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%);\
                display: flex;\
                justify-content: center;\
                align-items: center;\
                cursor: grab;\
                box-shadow: 0 4px 15px rgba(26, 115, 232, 0.4);\
                transition: transform 0.3s, box-shadow 0.3s;\
                z-index: 1000;\
                user-select: none;\
                touch-action: none;\
            }\
            .chatbot-floating-icon.dragging {\
                cursor: grabbing;\
                transition: none;\
                transform: scale(1.05);\
            }\
            .chatbot-floating-icon:hover {\
                transform: scale(1.08);\
                box-shadow: 0 6px 20px rgba(26, 115, 232, 0.5);\
            }\
            .chatbot-floating-icon.dragging:hover {\
                transform: scale(1.05);\
            }\
            .chatbot-floating-icon svg {\
                width: 26px;\
                height: 26px;\
                fill: #fff;\
                pointer-events: none;\
            }\
        ';
    }

    function setChatMenuVisible(visible) {
        var chatItem = document.getElementById('action-support-chat');
        if (chatItem) {
            chatItem.style.display = visible ? '' : 'none';
        }
    }

    function positionChatNearIcon(chatIcon, chatContainer) {
        if (!chatIcon || !chatContainer) return;

        var iconRect = chatIcon.getBoundingClientRect();
        var gap = 12;
        var chatW = chatContainer.offsetWidth || 520;
        var chatH = chatContainer.offsetHeight || 620;

        var top = iconRect.top - chatH - gap;
        if (top < 8) {
            top = iconRect.bottom + gap;
        }
        if (top + chatH > window.innerHeight - 8) {
            top = Math.max(8, window.innerHeight - chatH - 8);
        }

        var left = iconRect.right - chatW;
        if (left < 8) left = 8;
        if (left + chatW > window.innerWidth - 8) {
            left = Math.max(8, window.innerWidth - chatW - 8);
        }

        chatContainer.style.left = left + 'px';
        chatContainer.style.top = top + 'px';
        chatContainer.style.right = 'auto';
        chatContainer.style.bottom = 'auto';
        chatContainer.style.transform = 'none';
    }

    function updateChatPosition() {
        if (!shadowRoot) return;
        var chatIcon = document.getElementById('ai-chatbot-icon');
        var container = shadowRoot.getElementById('ai-chat-container');
        if (chatIcon && container) {
            positionChatNearIcon(chatIcon, container);
            return;
        }
        var support = document.getElementById('action-support');
        if (!support || !container) return;

        var rect = support.getBoundingClientRect();
        var chatWidth = 520;
        var chatHeight = 620;
        var gap = 12;
        var left = rect.left + rect.width - chatWidth;
        var top = rect.top - chatHeight - gap;

        if (left < 8) left = 8;
        if (top < 8) top = rect.bottom + gap;
        if (left + chatWidth > window.innerWidth - 8) {
            left = window.innerWidth - chatWidth - 8;
        }

        container.style.left = left + 'px';
        container.style.top = top + 'px';
        container.style.right = 'auto';
        container.style.bottom = 'auto';
    }

    function toggleChat(open) {
        if (!shadowRoot) return;
        var chatContainer = shadowRoot.getElementById('ai-chat-container');
        var messageInput = shadowRoot.getElementById('ai-message-input');
        var chatIcon = document.getElementById('ai-chatbot-icon');
        if (!chatContainer) return;

        var shouldOpen = typeof open === 'boolean'
            ? open
            : chatContainer.classList.contains('hidden');

        if (shouldOpen) {
            chatContainer.classList.remove('hidden');
            if (chatIcon) {
                positionChatNearIcon(chatIcon, chatContainer);
            } else {
                updateChatPosition();
            }
            if (messageInput) messageInput.focus();
        } else {
            chatContainer.classList.add('hidden');
        }
    }

    function enableIconDrag(chatIcon, chatContainer) {
        if (!chatIcon) return;

        var dragging = false;
        var moved = false;
        var startX = 0;
        var startY = 0;
        var startLeft = 0;
        var startTop = 0;
        var DRAG_THRESHOLD = 5;

        function onMouseMove(e) {
            if (!dragging) return;
            e.preventDefault();

            var dx = e.clientX - startX;
            var dy = e.clientY - startY;
            if (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD) {
                moved = true;
                if (chatContainer && !chatContainer.classList.contains('hidden')) {
                    chatContainer.classList.add('hidden');
                }
            }

            var nextLeft = startLeft + dx;
            var nextTop = startTop + dy;
            var maxLeft = window.innerWidth - chatIcon.offsetWidth;
            var maxTop = window.innerHeight - chatIcon.offsetHeight;
            nextLeft = Math.max(0, Math.min(nextLeft, maxLeft));
            nextTop = Math.max(0, Math.min(nextTop, maxTop));

            chatIcon.style.left = nextLeft + 'px';
            chatIcon.style.top = nextTop + 'px';
        }

        function onMouseUp() {
            if (!dragging) return;
            dragging = false;
            chatIcon.classList.remove('dragging');
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }

        chatIcon.addEventListener('mousedown', function (e) {
            if (e.button !== 0) return;
            e.preventDefault();

            dragging = true;
            moved = false;
            chatIcon.classList.add('dragging');

            var rect = chatIcon.getBoundingClientRect();
            chatIcon.style.left = rect.left + 'px';
            chatIcon.style.top = rect.top + 'px';
            chatIcon.style.right = 'auto';
            chatIcon.style.bottom = 'auto';

            startX = e.clientX;
            startY = e.clientY;
            startLeft = rect.left;
            startTop = rect.top;

            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        });

        chatIcon._wasDragged = function () {
            return moved;
        };
    }

    function createUI() {
        if (document.getElementById('ai-chatbot-icon') || document.getElementById('ai-chatbot-host')) return;

        setChatMenuVisible(true);

        if (!document.getElementById('ai-chatbot-icon-style')) {
            var iconStyle = document.createElement('style');
            iconStyle.id = 'ai-chatbot-icon-style';
            iconStyle.textContent = getIconStyles();
            document.head.appendChild(iconStyle);
        }

        var chatIcon = document.createElement('div');
        chatIcon.id = 'ai-chatbot-icon';
        chatIcon.className = 'chatbot-floating-icon';
        chatIcon.title = 'Trợ lý ảo';
        chatIcon.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/><path d="M7 9h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"/></svg>';
        document.body.appendChild(chatIcon);

        var host = document.createElement('div');
        host.id = 'ai-chatbot-host';
        document.body.appendChild(host);
        shadowRoot = host.attachShadow({ mode: 'open' });

        var container = document.createElement('div');
        container.id = 'ai-chat-container';
        container.className = 'chat-container hidden';
        container.innerHTML = '\
            <div class="chat-header">\
                <div class="chat-header-left">\
                    <div class="header-icon">\uD83E\uDD16</div>\
                    <div class="chatbot-name">\
                        <div class="chatbot-name-text">Tr\u1EE3 l\u00FD \u1EA3o</div>\
                        <div class="chatbot-status"><span class="dot"></span> Online</div>\
                    </div>\
                </div>\
                <button id="ai-close-chat" class="close-button">\u00D7</button>\
            </div>\
            <div class="chat-body">\
                <div id="ai-messages" class="messages">\
                    <div class="welcome-msg">Xin ch\u00E0o! T\u00F4i l\u00E0 tr\u1EE3 l\u00FD \u1EA3o MobiFone Invoice.<br>H\u00E3y \u0111\u1EB7t c\u00E2u h\u1ECFi v\u1EC1 h\u00F3a \u0111\u01A1n c\u1EE7a b\u1EA1n.</div>\
                </div>\
                <div class="input-area">\
                    <textarea id="ai-message-input" placeholder="Nh\u1EADp c\u00E2u h\u1ECFi..." rows="1"></textarea>\
                    <button id="ai-send-btn" class="send-btn">\
                        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>\
                    </button>\
                </div>\
            </div>\
        ';

        var style = document.createElement('style');
        style.textContent = getStyles();
        shadowRoot.appendChild(style);
        shadowRoot.appendChild(container);

        initEvents();
        window.addEventListener('support-widget-moved', updateChatPosition);
        window.addEventListener('resize', updateChatPosition);
    }

    function removeUI() {
        window.removeEventListener('support-widget-moved', updateChatPosition);
        window.removeEventListener('resize', updateChatPosition);
        setChatMenuVisible(false);

        var icon = document.getElementById('ai-chatbot-icon');
        if (icon && icon.parentNode) icon.parentNode.removeChild(icon);

        var host = document.getElementById('ai-chatbot-host');
        if (host && host.parentNode) host.parentNode.removeChild(host);

        shadowRoot = null;
        threadId = null;
        isStreaming = false;
    }

    function initEvents() {
        var chatIcon = document.getElementById('ai-chatbot-icon');
        var chatMenuItem = document.getElementById('action-support-chat');
        var chatContainer = shadowRoot.getElementById('ai-chat-container');
        var closeBtn = shadowRoot.getElementById('ai-close-chat');
        var sendBtn = shadowRoot.getElementById('ai-send-btn');
        var messageInput = shadowRoot.getElementById('ai-message-input');

        enableIconDrag(chatIcon, chatContainer);

        if (chatIcon) {
            chatIcon.addEventListener('click', function (e) {
                if (chatIcon._wasDragged && chatIcon._wasDragged()) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                toggleChat();
            });
        }

        if (chatMenuItem) {
            chatMenuItem.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var support = document.getElementById('action-support');
                if (support) support.classList.remove('active');
                toggleChat(true);
            });
        }

        closeBtn.addEventListener('click', function () {
            toggleChat(false);
        });

        sendBtn.addEventListener('click', function () {
            sendMessage();
        });

        messageInput.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                sendMessage();
            }
        });

        messageInput.addEventListener('input', function () {
            this.style.height = 'auto';
            this.style.height = Math.min(this.scrollHeight, 100) + 'px';
        });
    }

    function sendMessage() {
        var messageInput = shadowRoot.getElementById('ai-message-input');
        var message = messageInput.value.trim();
        if (!message || isStreaming) return;

        if (!threadId) {
            threadId = generateThreadId();
        }

        appendUserMessage(message);
        messageInput.value = '';
        messageInput.style.height = 'auto';

        streamBotResponse(message);
    }

    function appendUserMessage(text) {
        var messagesContainer = shadowRoot.getElementById('ai-messages');
        var row = document.createElement('div');
        row.className = 'message-row user-row';

        var bubble = document.createElement('div');
        bubble.className = 'message-bubble user-bubble';
        bubble.textContent = text;
        row.appendChild(bubble);

        messagesContainer.appendChild(row);

        var time = document.createElement('div');
        time.className = 'message-time';
        time.textContent = formatTime(new Date());
        row.appendChild(time);

        scrollToBottom();
    }

    function appendBotMessageStart() {
        var messagesContainer = shadowRoot.getElementById('ai-messages');

        var row = document.createElement('div');
        row.className = 'message-row bot-row';
        row.id = 'ai-current-bot-row';

        var avatar = document.createElement('div');
        avatar.className = 'bot-avatar';
        avatar.textContent = '\uD83E\uDD16';
        row.appendChild(avatar);

        var bubble = document.createElement('div');
        bubble.className = 'message-bubble bot-bubble';
        bubble.id = 'ai-current-bot-bubble';

        var typing = document.createElement('div');
        typing.className = 'typing-indicator';
        typing.id = 'ai-typing-indicator';
        typing.innerHTML = '<span></span><span></span><span></span>';
        bubble.appendChild(typing);

        row.appendChild(bubble);
        messagesContainer.appendChild(row);
        scrollToBottom();

        return bubble;
    }

    function formatTime(date) {
        var h = date.getHours().toString().padStart(2, '0');
        var m = date.getMinutes().toString().padStart(2, '0');
        return h + ':' + m;
    }

    function scrollToBottom() {
        var messagesContainer = shadowRoot.getElementById('ai-messages');
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }

    function setSendButtonState(disabled) {
        var sendBtn = shadowRoot.getElementById('ai-send-btn');
        if (sendBtn) {
            sendBtn.disabled = disabled;
        }
    }

    function parseSSEEvents(text) {
        var events = [];
        var blocks = text.split('\n\n');
        for (var i = 0; i < blocks.length; i++) {
            var block = blocks[i].trim();
            if (!block) continue;

            var lines = block.split('\n');
            var event = { type: 'message', data: '' };
            for (var j = 0; j < lines.length; j++) {
                var line = lines[j];
                if (line.indexOf('event:') === 0) {
                    event.type = line.substring(6).trim();
                } else if (line.indexOf('data:') === 0) {
                    event.data += line.substring(5).trim();
                }
            }
            if (event.data) {
                events.push(event);
            }
        }
        return events;
    }

    var STREAM_TIMEOUT_MS = 65000;

    function readStreamWithTimeout(reader, timeoutMs) {
        return Promise.race([
            reader.read(),
            new Promise(function (_, reject) {
                setTimeout(function () {
                    reject(new Error('H\u1EC7 th\u1ED1ng AI kh\u00F4ng ph\u1EA3n h\u1ED3i trong th\u1EDDi gian cho ph\u00E9p.'));
                }, timeoutMs);
            })
        ]);
    }

    function processStreamEvents(events, bubble, botContentRef, typingRemovedRef) {
        for (var i = 0; i < events.length; i++) {
            var evt = events[i];
            var data;
            try {
                data = JSON.parse(evt.data);
            } catch (e) {
                continue;
            }

            if (evt.type === 'message' && data.type === 'ai' && data.content) {
                if (!typingRemovedRef.value) {
                    var typingEl = shadowRoot.getElementById('ai-typing-indicator');
                    if (typingEl) typingEl.remove();
                    typingRemovedRef.value = true;
                }
                botContentRef.value += data.content;
                bubble.innerHTML = formatBotContent(botContentRef.value);
                scrollToBottom();
            } else if (evt.type === 'tool_call') {
                var clarify = extractAskClarification(data);
                if (clarify) {
                    if (!typingRemovedRef.value) {
                        var typingEl3 = shadowRoot.getElementById('ai-typing-indicator');
                        if (typingEl3) typingEl3.remove();
                        typingRemovedRef.value = true;
                    }
                    botContentRef.value = '__ask_clarification__';
                    bubble.innerHTML = formatAskClarification(clarify);
                    bindClarificationOptionHandlers(bubble, clarify);
                    scrollToBottom();
                }
            } else if (evt.type === 'error') {
                if (!typingRemovedRef.value) {
                    var typingEl2 = shadowRoot.getElementById('ai-typing-indicator');
                    if (typingEl2) typingEl2.remove();
                    typingRemovedRef.value = true;
                }
                botContentRef.value = '__error__';
                bubble.innerHTML = formatBotError(data);
                scrollToBottom();
            }
        }
    }

    function extractAskClarification(toolCallFrame) {
        if (!toolCallFrame || !toolCallFrame.tool_calls || !toolCallFrame.tool_calls.length) return null;
        for (var i = 0; i < toolCallFrame.tool_calls.length; i++) {
            var tc = toolCallFrame.tool_calls[i];
            if (tc && tc.name === 'ask_clarification' && tc.args) return tc.args;
        }
        return null;
    }

    function formatAskClarification(args) {
        var question = (args && args.question) ? String(args.question) : 'Cần bạn xác nhận thêm thông tin.';
        var options = (args && args.options && args.options.length) ? args.options : [];

        var html = '<div style="font-weight:600;margin-bottom:8px;">' + escapeHtml(question) + '</div>';
        if (args && args.context) {
            html += '<div style="color:#666;font-size:12px;margin-bottom:10px;">' + escapeHtml(String(args.context)) + '</div>';
        }
        if (!options.length) {
            html += '<div style="color:#999;">Vui lòng nhập thêm thông tin ở ô bên dưới.</div>';
            return html;
        }

        html += '<div style="display:flex;flex-wrap:wrap;gap:8px;">';
        for (var i = 0; i < options.length; i++) {
            var opt = String(options[i]);
            html += '<button type="button" data-ai-clarify-option="' + escapeHtml(opt) + '"'
                + ' style="border:1px solid #d0d7de;background:#fff;padding:6px 10px;border-radius:8px;cursor:pointer;font-size:13px;">'
                + escapeHtml(opt)
                + '</button>';
        }
        html += '</div>';
        return html;
    }

    function bindClarificationOptionHandlers(bubble, args) {
        if (!bubble) return;
        var buttons = bubble.querySelectorAll('[data-ai-clarify-option]');
        if (!buttons || !buttons.length) return;

        for (var i = 0; i < buttons.length; i++) {
            (function (btn) {
                btn.addEventListener('click', function () {
                    var option = btn.getAttribute('data-ai-clarify-option') || '';
                    option = option.trim();
                    if (!option || isStreaming) return;
                    appendUserMessage(option);
                    streamBotResponse(option);
                });
            })(buttons[i]);
        }
    }

    function readStreamLoop(reader, decoder, buffer, streamStart, bubble, botContentRef, typingRemovedRef) {
        var elapsed = Date.now() - streamStart;
        var remaining = STREAM_TIMEOUT_MS - elapsed;
        if (remaining <= 0) {
            return Promise.reject(new Error('H\u1EC7 th\u1ED1ng AI kh\u00F4ng ph\u1EA3n h\u1ED3i trong th\u1EDDi gian cho ph\u00E9p.'));
        }

        return readStreamWithTimeout(reader, remaining).then(function (result) {
            if (result.done) {
                return;
            }

            buffer.value += decoder.decode(result.value, { stream: true });

            var events = parseSSEEvents(buffer.value);
            var lastDoubleNewline = buffer.value.lastIndexOf('\n\n');
            if (lastDoubleNewline !== -1) {
                buffer.value = buffer.value.substring(lastDoubleNewline + 2);
            }

            processStreamEvents(events, bubble, botContentRef, typingRemovedRef);
            return readStreamLoop(reader, decoder, buffer, streamStart, bubble, botContentRef, typingRemovedRef);
        });
    }

    function streamBotResponse(message) {
        isStreaming = true;
        setSendButtonState(true);

        var bubble = appendBotMessageStart();
        var botContentRef = { value: '' };
        var typingRemovedRef = { value: false };
        var streamStart = Date.now();
        var authHeader = getAuthHeader();

        fetch(app.config.host + '/Chatbot/Stream', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader
            },
            body: JSON.stringify({
                message: message,
                thread_id: threadId
            })
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Server error: ' + response.status);
                }

                var reader = response.body.getReader();
                var decoder = new TextDecoder();
                var buffer = { value: '' };

                return readStreamLoop(reader, decoder, buffer, streamStart, bubble, botContentRef, typingRemovedRef);
            })
            .then(function () {
                if (!typingRemovedRef.value) {
                    var typingEl3 = shadowRoot.getElementById('ai-typing-indicator');
                    if (typingEl3) typingEl3.remove();
                }

                if (!botContentRef.value) {
                    bubble.innerHTML = '<span style="color:#999;">Kh\u00F4ng c\u00F3 ph\u1EA3n h\u1ED3i t\u1EEB h\u1EC7 th\u1ED1ng.</span>';
                }
            })
            .catch(function (error) {
                var typingEl4 = shadowRoot.getElementById('ai-typing-indicator');
                if (typingEl4) typingEl4.remove();
                var errMsg = (error && error.message) ? error.message : 'Kh\u00F4ng th\u1EC3 k\u1EBFt n\u1ED1i t\u1EDBi server.';
                bubble.innerHTML = '<span style="color:#e53935;">\u274C ' + escapeHtml(errMsg) + '</span>';
                console.error('AI Chatbot error:', error);
            })
            .then(function () {
                isStreaming = false;
                setSendButtonState(false);

                var timeDiv = document.createElement('div');
                timeDiv.className = 'message-time';
                timeDiv.textContent = formatTime(new Date());
                var currentRow = shadowRoot.getElementById('ai-current-bot-row');
                if (currentRow) {
                    currentRow.appendChild(timeDiv);
                    currentRow.removeAttribute('id');
                }
                var currentBubble = shadowRoot.getElementById('ai-current-bot-bubble');
                if (currentBubble) {
                    currentBubble.removeAttribute('id');
                }
                scrollToBottom();
            });
    }

    function escapeHtml(text) {
        return String(text)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    function formatBotError(data) {
        var msg = data.error || 'Unknown error';
        var typeLabel = '';
        if (data.error_type === 'TIMEOUT' || data.error_type === 'TIMEOUT_IDLE') {
            typeLabel = ' [Timeout]';
        } else if (data.source === 'BE') {
            typeLabel = ' [BE]';
        }
        return '<span style="color:#e53935;">\u274C ' + escapeHtml(msg) + escapeHtml(typeLabel) + '</span>';
    }

    function formatBotContent(text) {
        var escaped = text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
        escaped = escaped.replace(/\n/g, '<br>');
        escaped = escaped.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        escaped = escaped.replace(/`([^`]+)`/g, '<code style="background:#f0f0f0;padding:1px 4px;border-radius:3px;font-size:13px;">$1</code>');
        return escaped;
    }

    return {
        init: function () {
            if (isLoggedIn()) createUI();

            if (!authWatchTimer) {
                authWatchTimer = setInterval(function () {
                    var loggedIn = isLoggedIn();
                    var hasChat = !!document.getElementById('ai-chatbot-host');
                    if (loggedIn && !hasChat) {
                        createUI();
                    } else if (!loggedIn && hasChat) {
                        removeUI();
                    }
                }, 1500);
            }
        },
        toggleChat: toggleChat,
        newConversation: function () {
            threadId = generateThreadId();
            var messagesContainer = shadowRoot.getElementById('ai-messages');
            if (messagesContainer) {
                messagesContainer.innerHTML = '<div class="welcome-msg">Cu\u1ED9c h\u1ED9i tho\u1EA1i m\u1EDBi \u0111\u00E3 b\u1EAFt \u0111\u1EA7u.</div>';
            }
        }
    };
});

define('views/modules/dashline',["app"], function (app) {

	return {
		$ui: {
			height: 136,
			css: "tiles",
			borderless:true,
			template: function (data) {
				var t = null;

				if (data.items == undefined) return;

				var items = data.items;
				var html = '<div class="f-grid">'
					+ '<div class="f-grid-col">'
					+ 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quae, nulla! Assumenda dignissimos harum, molestias iure repudiandae ratione praesentium. Illo facilis et velit ut quam omnis, porro molestiae magni, laboriosam ipsa.'
					+ '</div>'
					+ '<div class="f-grid-col">'
					+ 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Non, quaerat blanditiis. Eligendi quae tenetur ratione repellendus ut.</div>'
					+ '<div class="f-grid-col">'
					+ 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quae, nulla! Assumenda dignissimos harum, molestias iure repudiandae ratione praesentium. Illo facilis et velit ut quam omnis, porro molestiae magni, laboriosam ipsa.'
					+ '</div>'
					+ '</div>'
				var html = "<div class='f-grid'>";
				html += "<h2 style= ' padding-left: 20px; margin: inherit '>Hóa đơn 32</h2>" ;

				for (var i = 0; i < items.length; i++) {
					t = items[i];

					var tien = webix.Number.format(t.tien, {
						groupDelimiter: ",",
						groupSize: 3,
						decimalDelimiter: ".",
						decimalSize: 0
					});

					var code = "duyethoadon";
					var params = "0" + t.p_id;

					if (t.p_id == "04") {
						code = "reportwindow";
						params = "WIN00022:d13001df-01fe-4d4f-ab65-cc98e7b41661";
					}

					html += "<div class='f-grid-col'>";
					// html += "<img style='padding-top:12px;' src='./assets/imgs/icon/dieukhien.png' height='80' width='80' ><div><p style='font-size:18px;'>"+t.dien_giai+"</p>"
					html += "<i class='fad fa-boxes fa-4x' style=' padding-top: 25px;margin-right: 10px;--fa-primary-color: #b5b8ba; --fa-secondary-color: #dadee0;' fa-swap-opacity fa-5x></i><div><p style='font-size:18px;'>"+t.dien_giai+"</p>"
					html += "<a href='#' onclick=\"var menu=$$('app:menu'); if(" + t.quyen + " ==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} menu.$scope.show('./" + code + ":" + params + "');\" style='color:#005EB2;font-weight:bold;font-size:20px;text-decoration: none;'>"+tien+"</a></div>"
					// html += "<div class='webix_icon icon fa-" + t.icon + "'></div>";
					// html += "<div class='details'><div class='value'>" + tien + "</div><div class='text'>" + t.dien_giai + "</div></div>";
				    // html += "<a href='#' onclick=\"var menu=$$('app:menu'); if(" + t.quyen + " ==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} menu.$scope.show('./" + code + ":" + params + "');\" style='color:white;text-decoration: none;'>"+tien+"</a></div>";
					html += "</div>";
				}
				html += "</div>";
				return html;
			},
			url: app.config.host + "/Invoice/DashboardTiles"
		}

	};

});
define('views/modules/dashline78',["app"], function (app) {
    return {
        $ui: {
            height: 136,
            CSS: "titles",
            borderless: true,
            template: function (data) {
                var t = null;

                if (data.items == undefined) return;
                var items = data.items;
                var html = "<div class='f-grid'>";
                html += "<h2 style= ' padding-left: 20px; margin: inherit '>Hóa đơn 78</h2>";

                for (var i = 0; i < items.length; i++) {
                    t = items[i];

                    var tien = webix.Number.format(t.tien, {
                        groupDelimiter: ",",
                        groupSize: 3,
                        decimalDelimiter: ".",
                        decimalSize: 0,
                    });

                    var code = "duyethoadon";
                    var params = "0" + t.p_id;

                    if (t.p_id == "04") {
                        code = "reportwindow";
                        params = "WIN00022:d13001df-01fe-4d4f-ab65-cc98e7b41661";
                    }
                    html += "<div class='f-grid-col'>";
                    html +=
                        "<i class='fad fa-boxes fa-4x' style=' padding-top: 25px;margin-right: 10px;--fa-primary-color: #b5b8ba; --fa-secondary-color: #dadee0;' fa-swap-opacity fa-5x></i><div><p style='font-size:18px;'>" +
                        t.dien_giai +
                        "</p>";
                    html +=
                        "<p if(" +
                        t.quyen +
                        " ==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} menu.$scope.show('./" +
                        code +
                        ":" +
                        params +
                        "');\" style='color:#005EB2;font-weight:bold;font-size:20px;text-decoration: none;'>" +
                        tien +
                        "</p></div>";
                    html += "</div>";
                }
                html += "</div>";
                return html;
            },
            url: app.config.host + "/Invoice68/DashboardTiles78",
        },
    };
});

define('views/modules/data_invoice',["app"],function(app){

	return {
		$ui:{
			"type": "clean",
			"rows":[
				{
					"template": "<span class='webix_icon fa-star' style='color:#FF892A'></span><b style='color:#669FC7'> Danh sách mẫu hóa đơn sử dụng</b>", "css": "sub_title", "height": 30
				},
				{
                    "view":"datatable",
                    "css" : "mcls_invoiceDashboard",
                    "url": app.config.host + "/Invoice/DashboardInvoices",
                    "columns": [
                        // {
                        //     id: "trang_thai",
                        //     header:"Trạng thái",
                        //     width:120,
                        //     template:"<span class='mcls_status #className#'>#trang_thai#</span>"
                        // },
                        {
                            id: "mau_so",
                            header:"Mẫu hóa đơn",
                            template: "<a href='#' onclick=\"var menu=$$('app:menu');menu.$scope.show('./window:#win#');\" >#mau_so#</a>",
                            fillspace:1
                        },
                        {
                            id: "ky_hieu",
                            header:"Ký hiệu",
                            fillspace:1
                        },
                        {
                            id: "ngay_bd_sd",
                            header:"Ngày sử dụng",
                            fillspace:1,
                            format: function(text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);                            
                                return format(text);
                            }
                        },
                        {
                            id: "so_luong",
                            header:"Số lượng",
                            width:120,
                            css: {"text-align": "right","color":"blue", "font-weight": "bold"},
                            format: webix.Number.numToStr({
                                groupDelimiter:",",
                                groupSize:3,
                                decimalDelimiter:".",
                                decimalSize:0
                            })
                        },
                        {
                            id: "sl_xuat",
                            header:"Đã xuất",
                            width:120,
                            css: {"text-align": "right","color":"red","font-weight": "bold"},
                            format: webix.Number.numToStr({
                                groupDelimiter:",",
                                groupSize:3,
                                decimalDelimiter:".",
                                decimalSize:0
                            })
                        },
                        {
                            id: "con_lai",
                            header:"Còn lại",
                            width:120,
                            css: {"text-align": "right","font-weight": "bold","color":"green"},
                            format: webix.Number.numToStr({
                                groupDelimiter:",",
                                groupSize:3,
                                decimalDelimiter:".",
                                decimalSize:0
                            })
                        },
                        {
                            id: "trung_binh",
                            header:"Trung bình 1 ngày",
                            width:120,
                            css: {"text-align": "right","font-weight": "bold"},
                            format: webix.Number.numToStr({
                                groupDelimiter:",",
                                groupSize:3,
                                decimalDelimiter:".",
                                decimalSize:0
                            })
                        }
                    ]
                }
			]
		}
	};

});
define('views/register_licence_branch',["app",
        "locale",
        "views/forms/register_licence_branch"
    ],function(app,_,dmwindowform){

        var itemValue;
	
        function initUI(){
		
            // call API kiểm tra đơn vị này có được đăng ký không?
            var table = webix.$$("treewindowDataRegister");
            var url = {
                $proxy: true,
                load: function (view, callback, params) {
                    var value = itemValue.code;
                    webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .post(app.config.host + "/System/CheckBrandValidation?value=" + value, function (res) {
                        // res = true;
                        if (res == "false") {
                            webix.message({ type: "error", text: "Đơn vị không thể đăng ký" });
                            webix.$$("dangkylicense-win").close();
                        }
                        else {
                            // call API get danh sách đã đăng ký của đơn vị
                            var url = app.config.host + "/System/ExecuteCommand";
                            webix.ajax()
                                .headers({'Content-type':'application/json'})
                                .post(url,
                                    {
                                        command:"CM00098",
                                        parameter:{
                                            branch_id: itemValue.id
                                        }
                                    }
                                    ,function(text){
                                var json = JSON.parse(text);
                                
                                var data = listToTree(json, { idKey: "id", parentId: "parent_id" });
                                
                                var tblData = $$("treewindowDataRegister");
                    
                                tblData.parse(data,"json");
                                tblData.openAll();
                                
                            });
                        }
                    });
                }
            }
            table.define("url", url);
          
        }

    var controls = [
        // {
        //     id: "btnRefreshRegister",
        //     view: "button",
        //     type: "icon",
        //     icon: "fas fa-refresh",
        //     label: _("REFRESH"),
        //     css: "webix_secondary",
        //     width: 95,
        //     on: {
        //         onClick: function () {
                   
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            id: "btnPlusRegister",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: "Thêm mới",
            css: "webix_secondary",
            width: 100,
            //css:"button_raised",
            shortcut: "F4",
            on: {
                onClick: function (item) {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("register_licence-form");
                   
                    var branchCode = itemValue.code;

                    dmwindowform.setEditMode(1);
                    detailForm.show();

                    var cb=$$("cbBranchCode");
                    cb.define("readonly",true);
                    cb.setValue(branchCode);
                    cb.refresh();
                },
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            id: "btnEditRegister",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
            css: "webix_secondary",
            label: "Cập nhật",
            width: 100,
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("register_licence-form");

                    var table = webix.$$("treewindowDataRegister");
                    var item = table.getSelectedItem();
                    item.createdondate = new Date(item.createdondate);
                    form.setValues(item);        
                    dmwindowform.setEditMode(2);

                    detailForm.show();
                }, 
            },
            click: function () {
                this.callEvent("onClick");
            },
            
        },
       
        {},
    ]

    var grid = {
        rows: [
            {
                id: "treewindowDataRegister",
                view: "treetable",
                select: true,
                resizeColumn: true,
                scheme: {
                    $change: function (item) {
                        if (item.$count > 1980)
                            item.$css = "highlight";
                    },
                    $init: function (obj) {

                    },
                },
                
 
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEditRegister = $$("btnEditRegister");
                        btnEditRegister.callEvent("onClick");
                    },
                },
                //url: app.config.host + "/api/System/GetDataByWindowNo?window_id="+windowno ,
                columns: [
                    {
                        id: "stt",
                        header: "STT",
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "branch_name",
                        header: "Tên khách hàng/ đơn vị",
                        width: 300,
                    },
                    {
                        id: "quantity",
                        header: "Số lượng (hóa đơn)",
                        width: 200,
                    },
                    {
                        id: "createdondate",
                        header: "Ngày đăng ký",
                        width: 200,
                        format: function (text) {
                            var format =  webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                ],
                data: [
                           
                ],
                filterMode:{
                    level:false,
                    showSubItems:false
                }
            }
        ]
    }

	return {	
        // $ui: layout,	
		$ui:{   
			view:"window", modal:true, id:"dangkylicense-win", position:"center",
			head:"Đăng ký licence cho khách hàng",
			fullscreen:true,
			body:{
                rows: [
                    {
                        id: "tlbMain",
                        height: 35,
                        type: "toolbar",
                        cols: controls
                    },
                    {
                        rows: [
                            grid
                        ]
                    },
                    { 
                        view:"button", shortcut:"esc", label:"Hủy bỏ (ESC)",type:"danger",align:"center",
                        width:100,
                        on:{
                            onClick: function(){
                                this.getTopParentView().close();
                            }
                        },
                        click:function(){
                            this.callEvent("onClick");
                        }
                    }
                ]
			}			
			
		},	
        
        setItemValue: function (item) {
			itemValue = item;
            initUI();
		}
        
	};

});
define('views/reportwindow',["app", "locale", "views/forms/loadDataReport", "views/forms/detailreport", "views/forms/window", "models/user"], function (app, _, loadDataReport, detailreport, windowform, user) {
    

    var windowno = app.path[1].params[0];

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    if ($$("cbReport").getValue() == null || $$("cbReport").getValue() == "") {
                        webix.message("Bạn chưa chọn báo cáo !", "error");
                        return;
                    }

                    var cbReport = webix.$$("cbReport");
                    var reportTable = webix.$$("reportTable");

                    webix.extend(reportTable, webix.ProgressBar);
                    reportTable.disable();
                    reportTable.showProgress();

                    var list = cbReport.getList();

                    var item = list.getItem(cbReport.getValue());

                    loadDataReport.$ui.id = item.wb_infowindow_id;
                    loadDataReport.$ui.report_id = cbReport.getValue();
                    loadDataReport.$ui.load_event = "loadReport";

                    if ($$("tblReport").config.rpParameter != null) {
                        loadDataReport.$ui.editmode = 1;
                        loadDataReport.$ui.formvalues = $$("tblReport").config.rpParameter.parameters;
                    } else {
                        loadDataReport.$ui.editmode = 0;
                        loadDataReport.$ui.formvalues = null;
                    }

                    var wininfoparam = this.$scope.ui(loadDataReport.$ui);
                    loadDataReport.initUI(item.wb_infowindow_id).then(function () {
                        wininfoparam.show();
                        reportTable.enable();
                        reportTable.hideProgress();
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 130,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + " (PDF)" + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("tblReport");

                    var rpParameter = table.config.rpParameter;

                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }

                    var datafrmAll = table.serialize();

                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để in!", "error");
                        return;
                    }

                    rpParameter.type = "PDF";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(
                                app.config.host + "/System/CreateReport",
                                rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/pdf" });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.open(fileURL, "_blank");
                                    },
                                }
                            );
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-file fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("EXPORT_EXCEL") + "</span>",
            id: "btnExport",
            on: {
                onClick: function () {
                    var table = $$("tblReport");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }

                    var datafrmAll = table.serialize();

                    if (datafrmAll.length == 0) {
                        webix.message("Không có dữ liệu để xuất!", "error");
                        return;
                    }

                    rpParameter.type = "xlsx";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .post(
                                app.config.host + "/System/CreateReport",
                                rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                        webix.modalbox.hide(box);
                                        var reportItem = $$("cbReport").getList().getSelectedItem();

                                        if (reportItem != null) {
                                            var export_name = reportItem.export_name;
                                            webix.html.download(file, export_name + ".xlsx");
                                        }

                                    },
                                }
                            );
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
        {
            id: "cbReport",
            view: "combo",
            width: 450,
            label: "Chọn báo cáo",
            labelWidth: 90,
            suggest: {
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/ExecuteCommand";

                        var parameters = {
                            command: "CM00016",
                            parameter: {
                                window_id: windowno,
                                username: user.getCurrentUser(),
                            },
                        };

                        webix.ajax().bind(view).headers({ "Content-Type": "application/json" }).post(url, parameters, callback);
                    },
                },
                template: "#name#",
                body: {
                    template: "#name#",
                },
            },
            on: {
                onChange: function () {
                    var report_id = this.getValue();

                    if (report_id == "") {
                        return;
                    }
                    var name = $$("cbReport").getText();
                    webix.$$("title").parse({ title: name, details: name });
                    initTable(report_id);
                },
            },
        },
    ];

    var grid = {
        id: "reportTable",
        rows: [
            {
                id: "tblReport",
                view: "datatable",
                resizeColumn: true,
                select: true,
                css: "report",
                columns: [],
                headermenu: {
                    width: 200,
                    autoheight: false,
                    scroll: true,
                },
                scheme: {
                    $change: function (item) {
                        if (item.BOLD == "C") item.$css = "rowBold";
                    },
                },
                pager: "pagerA",
                on: {
                    onBeforeContextMenu: function (id) {
                        var item = this.getItem(id);

                        if (item.DOC_ID != null && item.MA_CT != null) {
                            var mn = $$("ctxMenu");
                            var menuitem = mn.getItem("SUACTGOC");
                            if (menuitem == null) {
                                mn.add({ id: "SUACTGOC", value: "Sửa chứng từ" });
                            }
                        }

                        webix.delay(function () {
                            this.clearSelection();
                            this.select(id.row, id.column);
                        }, this);
                    },
                },
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var contextmenu = webix.ui({
        view: "contextmenu",
        id: "ctxMenu",
        on: {
            onMenuItemClick: function (id) {
                var item = this.getItem(id);

                if (id == "SUACTGOC") {
                    var table = $$("tblReport");
                    var row = table.getSelectedItem();

                    var sql = "SELECT TOP 1 a.* FROM VC_WINDOW a WHERE a.ma_ct='" + row.MA_CT + "'";
                    var url = app.config.host + "/api/System/ExecuteQuery?sql=" + sql;

                    webix.ajax(url, function (text) {
                        var json = JSON.parse(text);
                        var data = json[0];

                        var table = $$("tblReport");
                        var row = table.getSelectedItem();

                        var a = webix.ajax(app.config.host + "/api/System/GetDataById?window_id=" + data.WINDOW_ID + "&id=" + row.DOC_ID);
                        var b = webix.ajax(app.config.host + "/api/System/GetAllByWindowNo?window_id=" + data.WINDOW_ID);

                        webix.promise.all([a, b]).then(function (results) {
                            var a_result = results[0].json();
                            var windowconfig = results[1].json();

                            var vc_window = windowconfig["data"][0];
                            windowform.$ui.id = vc_window.WINDOW_ID;

                            var table = $$("tblReport");
                            var detailForm = table.$scope.ui(windowform.$ui);

                            var item = a_result.data[0];

                            windowform.initUI(windowconfig);
                            windowform.setEditMode(2);
                            windowform.setValues(item, windowconfig);

                            detailForm.show();
                        });
                    });
                } else {
                    var ctx = this.getContext();

                    detailreport.$ui.id = "dtrp_" + item.MENU_ID;
                    detailreport.$ui.parentParameter = ctx.obj.config.rpParameter.parameters;
                    detailreport.$ui.parentRow = ctx.obj.getSelectedItem();

                    this.hide();

                    var win = ctx.obj.$scope.ui(detailreport.$ui);
                    detailreport.initUI(item);
                    win.show();
                }
            },
        },
    });

    var layout = {
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    function initTable(report_id) {
        var url = app.config.host + "/System/ExecuteCommand";

        var parameters = {
            command: "CM00012",
            parameter: {
                wb_report_id: report_id,
            },
        };

        webix
            .ajax()
            .headers({ "Content-Type": "application/json" })
            .post(url, parameters, function (text) {
                var json = JSON.parse(text);

                var table = webix.$$("tblReport");

                table.clearAll();
                table.config.rpParameter = null;

                var cols = [];
                var isFooter = false;

                for (var i = 0; i < json.length; i++) {
                    var col = json[i];
                    //console.log(col);

                    var item = {
                        id: col.value_field,
                        header: "<center>" + _(col.header_title) + "</center>",
                        width: col.width,
                        hidden: col.hidden == "C" ? true : false,
                    };

                    // cột tổng dưới footer
                    if (col.footer === "" || col.footer === null) {
                    } else {
                        var temp = JSON.parse(col.footer);
                        item.footer = temp;

                        isFooter = true;
                    }

                    //console.log(col.sum);
                    if (col.header != null) {
                        if (col.header != "") {
                            var headers = JSON.parse(col.header);

                            for (var j = 0; j < headers.length; j++) {
                                var hd = headers[j];
                                if (hd != null) {
                                    hd.text = "<center>" + _(hd.text) + "</center>";
                                }
                            }

                            item.header = headers;
                        }
                    }

                    if (col.data_type == "datetime" || col.data_type == "date") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (col.data_type == "decimal" || col.data_type == "int" || col.data_type == "integer" || col.data_type == "numeric") {
                        item.css = { "text-align": "right" };
                        item.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 6,
                            decimalOptional: true
                        });
                    }

                    if (col.data_type == "boolean") {
                        item.template = function (obj, common, value) {
                            if (value) return "<div class='webix_icon fa-check-square-o'></div>";
                            else return "<div class='webix_icon fa-square-o'></div>";
                        };
                    }

                    if (col.value_field == "nlap" && col.wb_report_id == "7fdfab2b-9508-4471-98e0-96d36443ab08") {

                        item.template = function (obj, common) {
                            if (obj.$level == 1) return common.treetable(obj, common) + "<span style='color:blue;'>" + obj.value + " ( " + obj.$count + " )" + "</span>";
                            return obj.nlap;
                        };
                    }

                    if (col.value_field == "ord") {

                        item.sort = "int";
                    }

                    cols.push(item);
                }

                table.define("footer", isFooter);

                table.config.columns = cols;
                table.config.report_id = json[0]["wb_report_id"];
                table.refreshColumns();
            });
    }
    var initComponents = function (_windowconfig) {
        var vc_window = _windowconfig["data"][0];

        webix.$$("title").parse({
            title: vc_window["name"],
            details: vc_window["name"],
            width: 1000,
        });

        $$("head-title").show();
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            var windowno = app.path[1].params[0];
            var app_cache = webix.storage.local.get("APP_CACHE");
            if (app_cache[windowno] != null) {
                var windowconfig = app_cache[windowno];

                initComponents(windowconfig);
            } //không có cache
            else {
                var url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;
                webix.ajax(url, function (text, xml, xhr) {
                    var rp = JSON.parse(text);
                    var windowconfig = rp;

                    var app_cache = webix.storage.local.get("APP_CACHE");
                    app_cache[windowno] = windowconfig;

                    webix.storage.local.put("APP_CACHE", app_cache);

                    initComponents(windowconfig);
                });
            }

            if (app.path[1].params[1] != null) {
                var id = app.path[1].params[1];
                $$("cbReport").setValue(id);

                var load_event = "loadReport";
                var report_id = "d13001df-01fe-4d4f-ab65-cc98e7b41661";
                var id = "5accccd3-51bd-4370-b130-b01ab35d6c86";

                var now = new Date();
                now.setHours(0, 0, 0, 0);

                var item = {
                    ma_dvcs: user.getDvcsID(),
                    tu_ngay: null,
                    den_ngay: now,
                };

                var table = $$("tblReport");
                table.report_id = report_id;

                var rpParameter = {
                    parameters: item,
                    infowindow_id: id,
                    type: "json",
                    report_id: report_id,
                };

                table.config.rpParameter = rpParameter;

                webix
                    .ajax()
                    .headers({ "Content-type": "application/json" })
                    .post(app.config.host + "/System/CreateReport", rpParameter, function (text) {
                        var data = JSON.parse(text);

                        var table = $$("tblReport");
                        table.clearAll();
                        table.parse(data, "json");
                    });
            }

            $scope.on(app, "loadReport", function (report_id, infoWindowId, item) {

                var table = $$("tblReport");
                // webix.extend(table, webix.OverlayBox);
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();
                //table.showOverlay("<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>");
                if (table.config.report_id == report_id) {
                    var rpParameter = {
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id,
                    };

                    table.config.rpParameter = rpParameter;

                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .post(app.config.host + "/System/CreateReport", rpParameter, function (text) {
                            webix.delay(
                                function () {
                                    var data = JSON.parse(text);

                                    var table = $$("tblReport");
                                    table.clearAll();
                                    table.parse(data, "json");
                                },
                                null,
                                null,
                                1000
                            );

                            table.enable();
                            table.hideProgress();
                            // var data = JSON.parse(text);

                            // var table = $$("tblReport");
                            // table.clearAll();
                            // table.parse(data, "json");
                        });
                }
            });

            $scope.on(app, "loadDetailReport", function (report_id, infoWindowId, item, menuitem) {
                var win = $$("dtrp_" + menuitem.MENU_ID);
                var table = win.getChildViews()[1].getChildViews()[1];

                if (table.config.report_id == report_id) {
                    var rpParameter = {
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id,
                    };

                    table.config.rpParameter = rpParameter;

                    var ajax = webix.ajax();
                    ajax.master = menuitem;

                    ajax.headers({ "Content-type": "application/json" }).post(app.config.host + "/api/System/CreateReport", rpParameter, function (text) {

                        var win = $$("dtrp_" + this.MENU_ID);
                        var table = win.getChildViews()[1].getChildViews()[1];

                        table.clearAll();
                        var data = JSON.parse(text);
                        table.parse(data, "json");
                        table.refresh();
                        table.enable();
                        table.hideProgress();
                    });
                }
            });
        },
        initUI: function () {
            $$("head-title").show();
        },
    };
});

/**
 * Created by Mads on 03-10-2015.
 */
define('views/retrivepass',["models/user", "locale", "app", "helpers/locale"], function (user, _, app, locale) {
    

    var values = webix.copy(
        {
            username: "",
            password: "",
            rememberme: false,
            language: "vi",
            ma_dvcs: "VP",
        },
        Cookies.getJSON("Crm")
    );

    return {
        $ui: {
            cols: [
                { gravity: 1, template: "" },
                {
                    rows: [
                        { gravity: 1, template: "" },
                        {
                            css: { "background-color": "#cc0000", color: "white", "border-radius": "15px 15px 0px 0px" },
                            cols: [
                                {
                                    view: "template",
                                    type: "header",
                                    template: "Quên mật khẩu ?",
                                    css: { "background-color": "#cc0000", color: "white", "padding-bottom": "5px" },
                                    borderless: true,
                                    //width:180
                                },
                            ],
                        },
                        {
                            cols: [
                                {
                                    view: "form",
                                    gravity: 1,
                                    id: "loginForm",
                                    width: 360,
                                    elementsConfig: {
                                        labelPosition: "top",
                                    },
                                    elements: [
                                        {
                                            view: "template",
                                            template: "<center><a href='http://minvoice.vn/' target='_blank'><img  src='assets/imgs/LogoMinvoice.png' /></a></center>",
                                            height: 130,
                                            borderless: true,
                                            css: { padding: "0px" },
                                        },
                                        {
                                            height: 15,
                                        },
                                        {
                                            view: "text",
                                            //id:          "email",
                                            name: "email",
                                            label: "Nhập địa chỉ email để gửi mật khẩu mới",
                                            icon: "email",
                                            required: true,
                                            invalidMessage: "Bạn chưa nhập địa chỉ email hoặc email định dạng không đúng",
                                            placeholder: "Email",
                                            validate: webix.rules.isEmail,
                                        },
                                        {
                                            view: "button",
                                            //type:"danger",
                                            id: "login",
                                            name: "login",
                                            label: "Gửi yêu cầu tạo mật khẩu",
                                            //hotkey: "enter",
                                            css: "mcls_btnResetPass",
                                            click: function () {
                                                if ($$("loginForm").validate()) {
                                                    var form = $$("loginForm");

                                                    webix.extend(form, webix.ProgressBar);
                                                    form.disable();
                                                    form.showProgress();

                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(app.config.host + "/Account/ResetPass", $$("loginForm").getValues(), function (text, xml, xhr) {
                                                            var json = JSON.parse(text);

                                                            var form = $$("loginForm");
                                                            form.enable();
                                                            form.hideProgress();

                                                            if (json.hasOwnProperty("error")) {
                                                                webix.alert({
                                                                    title: "Thông báo",
                                                                    ok: "OK",
                                                                    text: json.error,
                                                                    type: "alert-error",
                                                                });
                                                            } else {
                                                                webix.alert({
                                                                    title: "Thông báo",
                                                                    ok: "OK",
                                                                    text: "Đã gửi mật khẩu tới email.Bạn hãy kiểm tra lại.",
                                                                });
                                                            }
                                                        });
                                                } else {
                                                    $$("loginForm").focus();
                                                }
                                            },
                                        },
                                        {
                                            view: "button",
                                            label: "Quay lại đăng nhập",
                                            type: "form",
                                            icon: "repeat",
                                            click: function () {
                                                app.router("/login");
                                            },
                                        },
                                    ],
                                },
                                {
                                    id: "version",
                                    //borderless: true,
                                    css: { background: "#e6f7ff !important" },
                                    width: 200,
                                    view: "template",
                                    template:
                                        "<div class=''><p><b>Bước 1:</b></p><label> Quý khách hàng vui lòng nhập Email đăng ký tài khoản !</label> <br />" +
                                        "<p><b>Bước 2:</b></p><label> Đăng nhập tài khoản Email vừa nhập !</label></div>" +
                                        "<p><b>Bước 3:</b></p><label> Hệ thống của MobiFone Invoice sẽ gửi mật khẩu mới cho Quý khách hàng. Quý khách hàng dùng mật khẩu đó để đăng nhập vào phần mềm !</label></div>",
                                },
                            ],
                        },
                        { gravity: 1, temlate: "" },
                    ],
                },
                { gravity: 1, template: "" },
            ],
        },

        $oninit: function () {
            $$("loginForm").focus();
        },
    };
});

define('views/searchinvoice',["app", "views/forms/searchinvoice", "locale"], function (app, searchForm, _) {
    

    var op = [];

    webix.$$("title").parse({ title: "Tra cứu hóa đơn", details: "Hóa đơn đã lập" });

    var controls = [
        {
            id: "txtSearch",
            view: "search",
            align: "center",
            placeholder: _("SEARCH") + "..",
            width: 300,
            on: {
                onTimedKeyPress: function () {
                    var table = $$("tblSearch");

                    table.clearAll();
                    table.load(table.config.url);
                },
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            css: "webix_secondary",
            icon: " fas fa-edit",
            label: _("TIM_CHI_TIET"),
            width: 100,
            on: {
                onClick: function () {
                    var win = this.$scope.ui(searchForm.$ui);
                    searchForm.setValues($$("tblSearch").config.paramFilter);
                    win.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnPrint",
            view: "button",
            type: "icon",
            icon: "fas fa-print",
            css: "webix_secondary",
            label: _("PRINT"),
            width: 65,
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("tblSearch");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn");
                        return;
                    }

                    var url = app.config.host + "/Invoice/Preview?id=" + item.inv_InvoiceAuth_id;

                    var box = webix.modalbox({
                        title: "Đang in hóa đơn",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .get(url, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                alert(text);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);

                                webix.modalbox.hide(box);
                                window.open(fileURL, "_blank");
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var grid = {
        rows: [
            {
                id: "tblSearch",
                view: "datatable",
                select: true,
                datafetch: 100,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var url = app.config.host + "/Invoice/Search";
                        var item = {};

                        var txtSearch = $$("txtSearch");

                        var filter = {};

                        if (txtSearch !== undefined) {
                            var typingFilter = txtSearch.getValue();

                            if (typingFilter != "") {
                                filter.typingFilter = typingFilter;
                            }
                        }

                        if (view.config.paramFilter != null) {
                            filter.paramFilter = view.config.paramFilter;
                        }

                        if (params == null) {
                            item.start = 0;
                            item.count = view.config.datafetch;
                            item.continue = null;
                            item.filter = filter;
                        } else {
                            item.start = params.start;
                            item.count = params.count;
                            item.continue = params.continue;
                            item.filter = filter;
                        }

                        webix.ajax().bind(view).headers({ "Content-Type": "application/json" }).post(url, item, callback);
                    },
                },
                columns: [
                    { id: "mau_hd", header: _("MAU_HD"), width: 150 },
                    { id: "inv_invoiceSeries", header: _("KY_HIEU"), width: 120 },
                    { id: "inv_invoiceNumber", header: _("SO_HDON"), width: 120 },
                    { id: "inv_invoiceIssuedDate", header: _("NGAY_HDON"), width: 150 },
                    { id: "ma_dt", header: _("MA_DT"), width: 150 },
                    { id: "inv_buyerLegalName", header: _("TEN_DON_VI"), width: 250 },
                    { id: "inv_buyerDisplayName", header: _("TEN_NGUOI_MUA"), width: 250 },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                view: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $$("tblSearch").config.paramFilter = {};

            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("tblSearch");
                table.config.paramFilter = item;

                table.clearAll();
                table.load(table.config.url);
            });
        },
    };
});

/**
 * Created by Mads on 03-10-2015.
 */

define('views/signbienban',["views/commonHD", "app"], function (commonHD, app) {
    var currentUrl = window.location.href;
    var otp = sessionStorage.getItem("otp");
    var urlParams = new URLSearchParams(currentUrl.split('?')[1]);
    var bienban_kemtheo_id = urlParams.get('bienban_kemtheo_id');
    var bienban_kemtheo_id_old = sessionStorage.getItem("bienban_kemtheo_id");
    if (bienban_kemtheo_id) {
        sessionStorage.setItem("bienban_kemtheo_id", bienban_kemtheo_id);
    } else {
        bienban_kemtheo_id = bienban_kemtheo_id_old;
    }
    window.history.replaceState({}, document.title, window.location.origin + '/#!/app/signbienban');


    function showOtpBienban() {
        var postData = {
            otp: otp,
            id: bienban_kemtheo_id,
        };

        webix
            .ajax()
            .headers({ "Content-Type": "application/json" })
            .post(app.config.host + "/BienBan/VerifyOtp", postData, function (text) {
                var result = JSON.parse(text);
                if (result.hasOwnProperty("ok")) {
                }
                else {
                    otpBienban.show();
                }
            });

        var otpBienban = webix.ui({
            view: "window",
            id: "otpBienban",
            width: 200,
            position: "center",
            modal: true,
            head: "Xác nhận OTP",
            body: {
                rows: [
                    { view: "text", label: "OTP", name: "otp", id: "otp" },
                    {
                        cols: [
                            {
                                view: "button", type: "form", value: "Xác nhận", click: function () {
                                    otp = $$("otp").getValue();

                                    var postData = {
                                        otp: otp,
                                        id: bienban_kemtheo_id,
                                    };

                                    webix
                                        .ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(app.config.host + "/BienBan/VerifyOtp", postData, function (text) {
                                            var result = JSON.parse(text);
                                            if (result.hasOwnProperty("error")) {
                                                webix.message(result.error, "error");
                                            } else {
                                                webix.message("Xác nhận OTP thành công!", "success");
                                                sessionStorage.setItem("otp", otp);
                                                otpBienban.hide();
                                            }
                                        });
                                }
                            }
                        ]
                    }
                ]
            }
        });

    }

    return {
        showOtpBienban: showOtpBienban(),
        $ui: {
            css: "bodylogin",
            id: "signbienban",
            rows: [
                {
                    //borderless: true,
                    // css: { "box-shadow": "0 15px 10px rgba(0,0,0,0.2)" },
                    height: 100,
                    cols: [
                        { gravity: 1, template: "", width: 150 },
                        {
                            view: "label",
                            template: "<a href='https://mobifone.vn/' target='_blank'><img style='width:200px; height:120px;' src='assets/imgs/head-banner.png' /></a>",
                            height: 65,
                            borderless: true,
                            css: { padding: "10px", "padding-top": "1px !important" },
                        },
                        { gravity: 1, template: "", width: 150 },
                    ],
                },
                {
                    cols: [
                        {
                            view: "template",
                            template: "<span style='color: #178dc4ff; font-weight: bold;'>Người mua xác nhận biên bản điều chỉnh/thay thế</span>",
                            height: 40,
                            width: 482,
                            css: {
                                "font- family": "Times New Roman",
                                "background": "transparent",
                                "font-size": "18px",
                                "border": "none",
                                "box-shadow": "none",
                                "outline": "none"
                            }
                        },
                        {
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: "button",
                                            type: "form",
                                            width: 200,
                                            label: "Xem/In",
                                            id: "btnPrint",
                                            on: {
                                                onClick: function () {

                                                    if (!bienban_kemtheo_id) {
                                                        webix.message("Không tồn tại biên bản nào!", "error");
                                                        return false;
                                                    }
                                                    var box = webix.modalbox({
                                                        title: "Đang in biên bản ....",
                                                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                        width: 350,
                                                        height: 200,
                                                    });
                                                    var newWin = window.open();
                                                    var html =
                                                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                                                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                                                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                                                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                                    newWin.document.write(html);
                                                    var postData = {
                                                        otp: otp,
                                                        id: bienban_kemtheo_id,
                                                    };
                                                    webix
                                                        .ajax()
                                                        .response("arraybuffer")
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(app.config.host + "/BienBan/inMauBienBan", postData, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.modalbox.hide(box);
                                                                webix.message(XmlHttpRequest.statusText, "error");
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var file = new Blob([data], { type: "application/pdf" });
                                                                var fileURL = URL.createObjectURL(file);
                                                                //window.open(fileURL, '_blank');
                                                                webix.modalbox.hide(box);
                                                                newWin.location = fileURL;
                                                            },
                                                        });

                                                },
                                            },
                                            click: function () {
                                                this.callEvent("onClick");
                                            },
                                        },
                                        {
                                            view: "button",
                                            type: "form",
                                            width: 200,
                                            label: "Ký số biên bản",
                                            id: "btnSign",
                                            on: {
                                                onClick: function () {
                                                    if (bienban_kemtheo_id != null && bienban_kemtheo_id != "") {
                                                        commonHD.KyBienBanThoaThuan_BenMua(bienban_kemtheo_id, otp);
                                                    } else {
                                                        webix.message("Không tồn tại biên bản nào!");
                                                    }
                                                },
                                            },
                                            click: function () {
                                                this.callEvent("onClick");
                                            },
                                        },
                                        {
                                            id: "uploader",
                                            view: "uploader",
                                            type: "form",
                                            label: "Upload biên bản",
                                            name: "uploader",
                                            width: 200,
                                            accept: "application/pdf",
                                            //link: "mylist",
                                            autosend: true,
                                            multiple: false,
                                            upload: app.config.host + "/BienBan/UploadBienBanThoaThuan",
                                            on: {
                                                onBeforeFileAdd: function (file) {
                                                    if (!bienban_kemtheo_id) {
                                                        webix.message("Không tồn tại biên bản nào!", "error");
                                                        return false;
                                                    }
                                                    this.bienban_kemtheo_id = bienban_kemtheo_id;
                                                    this.otp = otp;

                                                    return true;
                                                },
                                                onAfterFileAdd: function (file) {
                                                    var uploader = this;
                                                    var item = uploader.files.getItem(file.id);
                                                    var formData = new FormData();

                                                    formData.append("file", item.file);
                                                    formData.append("bienban_kemtheo_id", uploader.bienban_kemtheo_id);
                                                    formData.append("otp", uploader.otp);

                                                    webix.ajax()
                                                        .post(app.config.host + "/BienBan/UploadBienBanThoaThuan", formData)
                                                        .then(function (res) {
                                                            if (res.hasOwnProperty("error")) {
                                                                webix.message({ type: "error", text: res.error });
                                                                return;
                                                            }
                                                            else { webix.message("Upload file thành công!"); }
                                                        })
                                                        .catch(function (err) {
                                                            webix.message("Upload file lỗi!", "error");
                                                        });

                                                    uploader.files.remove(file.id);

                                                    return false;
                                                },
                                                onUploadComplete: function (response) {
                                                    if (!response) return;
                                                    if (response.error) {
                                                        webix.message({ type: "error", text: response.error });
                                                    } else {
                                                        webix.message("Upload file thành công!");
                                                        // Optional: reload bảng nếu cần
                                                        // $$("bienbanthoathuan").reload();
                                                    }
                                                },
                                                onFileUploadError: function (file, response) {
                                                    webix.message("Tải file thất bại!", "error");
                                                },
                                            },
                                            apiOnly: true,
                                        },

                                    ]
                                },
                            ],
                        },
                    ],
                },
                {
                    height: 800,
                    cols: [
                        {
                            view: "label",
                            template:
                                "<div style='padding:10px; font-size:14px; line-height:1.6;'>" +
                                "<div style='color:blue; font-weight:bold; margin-bottom:6px;'>Cách 1: Khách hàng thực hiện ký số biên bản thỏa thuận.</div>" +
                                "Để ký xác nhận biên bản thỏa thuận, quý khách hàng thực hiện các bước sau:<br>" +
                                "<ul style='margin-top:5px; padding-left:20px;'>" +
                                "<li>Bước 1: <a href='https://drive.google.com/drive/folders/1_nMt7-ECJS0Ut1NkMNCHuinHWlJI53fu' target='_blank'>Tải và Cài đặt Plugin người mua ký</a></li>" +
                                "<li>Bước 2: Mở Plugin, Cắm USB token vào máy tính</li>" +
                                "<li>Bước 3: Ấn nút <b>“Ký số biên bản”</b></li>" +
                                "<li>Bước 4: Thực hiện ký để hoàn tất</li>" +
                                "</ul>" +
                                "<div style='color:blue; font-weight:bold; margin-top:10px;'>Cách 2: Khách hàng upload biên bản ký tươi (không có chữ ký số USB token).</div>" +
                                "<ul style='margin-top:5px; padding-left:20px;'>" +
                                "<li>Bước 1: Ấn nút <b>“Xem/in”</b> và tải về biên bản định dạng PDF</li>" +
                                "<li>Bước 2: Thực hiện in và ký xác nhận</li>" +
                                "<li>Bước 3: Scan file biên bản đã ký để upload lên hệ thống</li>" +
                                "<li>Bước 4: Ấn nút <b>“Upload biên bản”</b> để upload file biên bản vừa scan</li>" +
                                "</ul>" +
                                "</div>",
                            height: 65,
                            borderless: true,
                            css: { padding: "10px", "padding-top": "1px !important" },
                        },
                    ],
                },
            ],
        },
    };
});

define('views/templatewindow',[
    "app",
    "views/forms/templatewindow",
    "views/forms/infowindow",
	"locale"
], function(app,windowform,infowindow,_) {
    
	
	var layoutId = "";
	var col = [];
	var sub_col = [];
    var windowconfig = null;
    var buttons = [];
	//var windowno = "":
	
	var initUI = function(){
		var windowno = app.path[1].params[0];
		
		col = [];		
        sub_col = [];
        
        var query = "SELECT TOP 1 * FROM WB_MENU WHERE WINDOW_ID='"+ windowno +"'";

        var url = app.config.host + "/System/ExecuteQuery?sql=" + query;

        webix.ajax(url,function(text){
            var json = JSON.parse(text);

            if (json.length>0){
                webix.$$("title").parse({title: json[0]["name"], details: json[0]["details"]});
            }
        });

        /* query = "SELECT CODE as id,NAME as value FROM VC_MAUIN WHERE WINDOW_ID='"+ windowno +"'";
        url = app.config.host + "/api/System/ExecuteQuery?sql=" + query;

        webix.ajax(url,function(text){
            var json = JSON.parse(text);

            if (json.length>0){
                $$("cbMauIn").define("options",json);
                $$("cbMauIn").setValue(json[0].id);
                $$("cbMauIn").show();
                $$("btnPrint").show();                
            }
            else {
                 $$("cbMauIn").define("options",[]);
                 $$("cbMauIn").hide();
                 $$("btnPrint").hide();
            }

            $$("cbMauIn").refresh();
        }); */

        url = app.config.host + "/System/ExecuteCommand";

        webix.ajax()
            .headers({'Content-type':'application/json'})
            .post(url,
                    { 
                        command : "CM00002", 
                        parameter: {
                            window_id: windowno
                        }
                    },function(text){
            var json = JSON.parse(text);

            if (buttons.length>0){
                for(var i=0;i<buttons.length;i++){
                    var item = buttons[i];
                    $$("tlbMain").removeView(item.id);
                }                
            }

            buttons = [];

            for(var i=0;i<json.length;i++){
                var item = json[i];

                var fn = new Function(item.on_click);

                var button = {
                    id: item.name,
                    label: _(item.caption),
                    view: "button", 
                    type: "icon", 
                    icon: item.icon, 
                    width: item.width,
                    click: fn                  
                };

                buttons.push(button);
                $$("tlbMain").addView(button,6);

            }

            
        });

		
		url = app.config.host + "/System/GetConfigWinByNo?id="+windowno ;
		
		webix.$$("windowData").getParentView().getParentView().getParentView().disable();
        webix.$$("windowData").getParentView().getParentView().getParentView().showProgress();
		
		webix.ajax(url, function (text, xml, xhr) {

			var rp = JSON.parse(text);
			windowconfig = rp;
			//console.log(Object.keys(rp).length);
            var k= Object.keys(rp['data'][0]['Tabs']).length;
            var vc_window = rp["data"][0];
            var tabs = vc_window.Tabs;

            if (vc_window.window_type == "MasterDetail"){
                col.push({
                    id: "subRow",
                    header: "&nbsp;",
                    template:"{common.subrow()}",
                    width:40
                });
            }

            var masterTab = tabs[0];

			for (var j = 0; j < masterTab.Fields.length; j++) {

                var field = masterTab.Fields[j];

				if(field.hide_in_grid==true){
					continue;
				}			
				
				var item = {
					id: field.column_name, 
                    header: _(field.column_name) ,
                    columnType: field.column_type					
                };
                
                if (field.caption!=null){
                    item.header = _(field.caption);
                }
				
				if (field.column_type == "decimal" ){
					item.css = { "text-align" : "right" };
					item.format = webix.Number.numToStr({
                            groupDelimiter:",",
                            groupSize:3,
                            decimalDelimiter:".",
                            decimalSize:0
                        });
                }
                    
                if (field.type_filter!=null){
                    if (field.type_filter!=""){
                        item.header = [_(field.column_name), { content: field.type_filter}]
                    }
                }
				
				if (field.type_filter == "combo"){
					item.editor = field.type_editor;
					item.options = app.config.host + "/api/System/GetDataByReferencesId?id=" + field.ref_id;
                }
                
                if (field.column_type == "date" || field.column_type == "datetime"){
                    item.format = function(text) {
                        var format = webix.Date.dateToStr("%d/%m/%Y");
                        text = removeTimeZoneT(text);                            
                        return format(text);
                    };
                }
				
				if (field.column_width == null){
					item.fillspace = true;
				}
				else {
					item.width = field.column_width;
				}
				
				col.push(item);
			}
			
			var table = $$("windowData");
			table.clearAll();			
            
            if (vc_window.window_type == "MasterDetail"){               

                var cells = [];

                for(var i=0;i<tabs.length;i++){
                    var tab = tabs[i];

                    if (tab.tab_type == "Master"){
                        continue;
                    }

                    var subCols = [];

                    for(var j=0;j<tab.Fields.length;j++){
                        var field = tab.Fields[j];

                        if (field.hide_in_grid == true){
                            continue;
                        }

                        var subCol = {
                            id: field.column_name, 
                            header: field.caption == null ? _(field.column_name) : _(field.caption),
                            hidden: field.hide_in_grid
                        };

                        if (field.column_type == "date" || field.column_type == "datetime"){
                            subCol.format = function(text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);                            
                                return format(text);
                            };
                        }

                        if (field.column_type == "decimal"){
							subCol.css = { "text-align": "right" };
							subCol.format = webix.Number.numToStr({
												groupDelimiter:",",
												groupSize:3,
												decimalDelimiter:".",
												decimalSize:0
											});
						}
                        
                        if (field.column_width == null){
                            subCol.fillspace = true;
                        }
                        else {
                            subCol.width = field.column_width;
                        }
                        
                        subCols.push(subCol);
                    }

                    if (tab.tab_type=="Detail"){
                        var item = {
                            header: tab.tab_name,
                            select: "cell",
                            body: {
                                view: "datatable",
                                tab_table: tab.tab_table,
                                columns: subCols,
                                on:{
                                    onBeforeLoad:function(){
                                        this.showOverlay(_("LOADING")+"...");
                                    },
                                    onAfterLoad:function(){
                                        this.hideOverlay();
                                    }
                                }
                            }
                        };

                        cells.push(item);
                    }
                }

                var subview = {
                    borderless:true,
                    view:"tabview",
                    height:200,
                    scrollX:true,
                    cells:cells,
                    multiview: {
                        fitBiggest:true
                    }
                };

                table.define("subview",subview);                
            }

            table.define("windowno", windowno);
            
            table.config.infoparam = null ;
            table.config.columns = col;
            table.config.ma_ct = vc_window.ma_ct;

            table.refreshColumns();	

            var parentToolBar = $$("tlbMain").getParentView();
            parentToolBar.removeView("tlbParams");

            if (vc_window.WinParams !== undefined){

                var toolBarParams = {
                    id:"tlbParams",
                    view: "toolbar",
                    height: 35,
                    cols:[]
                }
                
                for(var i=0;i<vc_window.WinParams.length;i++){
                    var item=vc_window.WinParams[i];

                    var comp = {
                        view: item.type_editor,
                        width: item.width,
                        label: _(item.caption),
                        value_field: item.value_field,
                        on:{}
                    };

                    if (comp.view == "combo"){
                        comp.options = app.config.host + "/System/GetDataByReferencesId?id=" + item.ref_id;
                        
					    comp.on.onChange = function(newv,oldv){
							var table = $$("windowData");                            
                            table.clearAll();
                            table.load(table.config.url);
						}
				
                    }

                    toolBarParams.cols.push(comp);

                }

                parentToolBar.addView(toolBarParams);
            }
            
            var url = {
                    $proxy:true,
                    load:function(view, callback, params){                        
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/GetDataByWindowNo?window_id="+windowno;                        

                        if (params==null){
                            url = url + "&start=0&count="+view.config.datafetch + "&continue=null&filter=null" ;                               
                        }
                        else {
                            url = url + "&start="+params.start+"&count="+params.count + "&continue=" + params.continue;
                            
                            if (params.filter!=null){
                                var array=[];

                                for(var property in params.filter){

                                    var column = view.getColumnConfig(property);

                                    if (column !== undefined){
                                         var item = {
                                            columnName : property,
                                            columnType : column.columnType,
                                            value: params.filter[property]
                                        };

                                        array.push(item);
                                    }
                                    
                                   
                                }

                                //console.log(JSON.stringify(array));
                                if (array.length>0){
                                    url = url + "&filter=" +JSON.stringify(array);
                                }
                                else {
                                    url = url + "&filter=null";
                                }
                                
                            }
                            else {
                                 url = url + "&filter=null";
                            }                                
                        }

                        if (view.config.infoparam!=null){
                            url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                        }
                        else {
                            url = url + "&infoparam=null";
                        }

                        var tlbParams = $$("tlbParams");

                        if (tlbParams!== undefined){
                            var childViews = tlbParams.getChildViews();

                            var parameters = [];

                            for(var i=0;i< childViews.length;i++){
                                var child = childViews[i];

                                var id = child.config.id;
                                var value_field = child.config.value_field;

                                var item = {
                                    columnName: value_field,
                                    value: $$(id).getValue()
                                };
                               
                                parameters.push(item);
                            }

                            url = url + "&tlbparam=" + JSON.stringify(parameters);

                        }
                        else {
                            url = url + "&tlbparam=null" ;
                        }
                        
                        console.log(url);

                        webix.ajax(url, callback, view);
                        
                    }
            };
            
            table.define("url", url );

            if (vc_window.vc_infowindow_id!=null){
                if (vc_window.vc_infowindow_id!=""){
                    $$("btnSearch").show();
                    table.config.infowindow_id = vc_window.vc_infowindow_id;
                }
                else {
                    $$("btnSearch").hide();
                    table.config.infowindow_id = null;
                }
            }
            else {
                $$("btnSearch").hide();
                table.config.infowindow_id = null;
            }

            
            

			webix.$$("windowData").getParentView().getParentView().getParentView().enable();
			webix.$$("windowData").getParentView().getParentView().getParentView().hideProgress();

		});
	};
	

    var controls = [
        { 
            id: "btnPlus",
            view: "button", 
            type: "icon", 
            icon:"plus", 
            label: "Thêm" ,
            width:65,
            shortcut: "F4",
            //css:"button_raised",
            on:{
                onClick: function(){
                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.window_id;

                    var detailForm = this.$scope.ui(windowform.$ui);            
                    
                    windowform.initUI(windowconfig);
                    windowform.setEditMode(1);

                    var params = null;

                    var tlbParams = $$("tlbParams");

                    if (tlbParams!== undefined){
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for(var i=0;i< childViews.length;i++){
                            var child = childViews[i];

                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item[value_field] = $$(id).getValue();                            
                           
                        }

                        params = item;

                    }
                    

                    windowform.setValues(null,windowconfig,params);
                    
                    detailForm.show();
                    windowform.focusFirstElement();

                    if (vc_window.after_new!=null){
                        var fn = Function("app",vc_window.after_new);
                        fn(app);
                    }
                }
            },
            click: function(){
                this.callEvent("onClick");                
            }
        },
        { 
            id: "btnEdit",
            view: "button", 
            type: "icon", 
            icon:"edit", 
            label: "Sửa" ,
            width:55,
            shortcut: "F3",
            //css:"button_raised",
            on: {
                onClick: function(){
                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.window_id;

                    var detailForm = this.$scope.ui(windowform.$ui);
                
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();                
                    
                    windowform.initUI(windowconfig);
                    windowform.setEditMode(2);
                    windowform.setValues(item,windowconfig);
                    
                    detailForm.show();
                    windowform.focusFirstElement();
                }
            },
            click: function(){                
                this.callEvent("onClick");
            }
        },
        { 
            id: "btnDelete", 
            view: "button", 
            type: "icon", 
            icon:"trash-o", 
            label: "Xóa" ,
            width:55,
            shortcut: "F8",
            //css:"button_raised",
            on: {
                onClick: function(){
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    var khData={};
                    khData.windowid=windowconfig.data[0].window_id;
                    khData.editmode=3;
                    khData.data=[];
                    khData.data.push(item);
                    
                    webix.confirm({
                        text:"Bạn có muốn xóa ", ok:"Có", cancel:"Không",
                        callback:function(res){
                            if(res){
                                webix.ajax()
                                .headers({'Content-type':'application/json'})
                                .post( app.config.host + "/System/Save", khData , function(text){
                                    if (text.hasOwnProperty("error")){
                                        webix.message(text.error);
                                        return;
                                    }
                                    
                                    table.remove(item.id);

                                });
                                
                            }
                        }
                    });
                }
            },
            click: function(){               
                this.callEvent("onClick");
            }
        },
        { 
            id: "btnCopy", 
            view: "button", 
            type: "icon", 
            icon:"files-o", 
            label: _("COPY") ,
            width:85,
            on: {
                onClick: function(){
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null){
                        webix.message("Bạn chưa chọn dòng dữ liệu");
                        return;
                    }

                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.window_id;

                    var detailForm = this.$scope.ui(windowform.$ui);            
                    
                    windowform.initUI(windowconfig);
                    windowform.setEditMode(1);
                    windowform.copyValues(item,windowconfig);
                    
                    detailForm.show();
                    windowform.focusFirstElement();

                    if (vc_window.after_new!=null){
                        var fn = Function(vc_window.after_new);
                        fn();
                    }

                    
                }
            },
            click: function(){               
                this.callEvent("onClick");
            }
        },
        { 
            id: "btnSearch", 
            view: "button", 
            type: "icon", 
            icon:"search", 
            label: _("SEARCH") ,
            width:85,
            shortcut: "F2",
            on: {
                onClick: function(){
                    var table = webix.$$("windowData");
                    
                    infowindow.$ui.id = table.config.infowindow_id;
                    infowindow.$ui.load_event = "filterTable";                      

                    var wininfoparam = this.$scope.ui(infowindow.$ui);

                    infowindow.initUI(table.config.infowindow_id);              
                    wininfoparam.show();
                }
            },
            click: function(){               
                this.callEvent("onClick");
            }
        },
        { 
            id: "btnPrint", 
            view: "button", 
            type: "icon", 
            icon:"print", 
            label: _("PRINT") ,
            width:40,
            shortcut: "F7",
            on: {
                onClick: function(){
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dữ liệu cần in");
                        return;
                    }

                    var cbMauIn = $$("cbMauIn");

                    var rpParameter = {
                        parameter : item,
                        CODE: cbMauIn.getValue()
                    };

                    var url = app.config.host + "/api/System/InChungTu" ;

                    webix.ajax()
                        .response("arraybuffer")
                        .headers({'Content-type':'application/json'})
                        .post(url, rpParameter, function(text, data){
                        var file = new Blob([data], {type: 'application/pdf'});
                        var fileURL = URL.createObjectURL(file);
                        window.open(fileURL,'_blank');
                    });
                    
                }
            },
            click: function(){               
                this.callEvent("onClick");
            }
        },
        {},
        {
            view:"richselect",
            label:_("MAUIN"),
            width:250,
            labelWidth:50,
            id:"cbMauIn"
        }
    ]    
    
    var grid = {
        rows:[
            {
                id : "windowData",
                view: "datatable", 
                select: true,
                datafetch: 50,
                columns: col ,
                on:{
                    onSubViewCreate:function(view, item){
                        var subView = view;

                        if (subView!=null){
                            var windowno = app.path[1].params[0];

                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id="+ windowno
                                    +"&id="+item.id;
                            
                            var detailTables = subView.getChildViews()[1].getChildViews();

                            for(var i=0;i<detailTables.length;i++){
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table="+dt.config.tab_table);
                            }                         
                        }

                    },
                    onSubViewOpen: function(id){
                        var table = this;
                        var subView = table.getSubView(id);
                        
                        if (subView!=null){
                            var windowno = app.path[1].params[0];

                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id="+ windowno
                                    +"&id="+id.row;
                            
                            var detailTables = subView.getChildViews()[1].getChildViews();

                            for(var i=0;i<detailTables.length;i++){
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table="+dt.config.tab_table);
                            }                         
                        }
                    },
                    onItemDblClick: function(id, e, node){
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                subview: {
                    borderless:true,
                    view:"tabview",
                    height:200,
                    scrollX:true,
                    tabbar:{
						width:200
					},
                    cells:[]
                },
                pager:"pagerA"                                        
            },
            {
                id: "pagerA",
                view:"pager",
                size: 50,
                group: 5,
                template:"{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            }
        ]
    }

    var layout = {		
		rows:[
			{
                rows:[
                    {
                        id:"tlbMain",
                        height:35,
                        type: "toolbar",
                        cols:controls 
                    }                    
                ]                                                          
			},
			{
				rows:[
					grid					
				]
			}



		]

    };
    
    return {
        $ui: layout,
        $oninit: function(view,$scope) {
			
			webix.extend(view, webix.ProgressBar);
			
			
            $scope.on(app, "dataChanged", function(mode,item){
				
                var table = webix.$$("windowData");

                if (mode == 1){
                    table.add(item);
                    //table.select(item.id,false);
                }

                if (mode == 2){
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id,item);

                    webix.UIManager.setFocus($$(table.config.id));
                }
                
            });

            $scope.on(app, "filterTable", function(report_id,infoWindowId,item){				
                var table = $$("windowData");
 
                /* if (item.hasOwnProperty("p_MA_CT")){
                    item["p_MA_CT"] = table.config.ma_ct;
                } */

                var infoparam = {
                    infowindow_id : infoWindowId,
                    parameter : item                    
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);                
            });
        },
		$onurlchange:function(ui, name, url, scope){
			initUI();
		}
	};
});
define('views/thongbaophathanh_bienlai',["app", "locale", "models/user", "views/forms/68_phathanh_bienlai"], function (app, _, user, form_0405) {
    
    var param;

    var initUI = function () {
        //var windowno = app.path[1].params[0];
        var table = webix.$$("mau04_68");
        // table.disable();
        // table.showProgress();
        // table.clearAll();
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Invoice68/getthph_bienlai";

                if (params == null) {
                    url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                } else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property],
                                filterType: column.header[1].content,
                            };
                            if (item.value != null && item.value != "") {
                                array.push(item);
                            }
                        }

                        //console.log(JSON.stringify(array));
                        url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                    }
                }
                webix.ajax(url, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Thêm mới " + " (F4)" + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(form_0405.$ui);
                    form_0405.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem != undefined && selectedItem != null) {
                        var detailForm = this.$scope.ui(form_0405.$ui);
                        form_0405.setEditMode(2);
                        form_0405.setValuesEdit(selectedItem);
                        if (selectedItem.trang_thai == 1) {
                            var form = $$("huyhoadon").elements;
                            for (var key in form) {
                                var $el = form[key];
                                $el.define("readonly", "true");
                                $el.define("css", "mcls_readonly_text");
                                $el.refresh();
                            }

                            $$("danhsach_hoadonhuy").define("editable", "false");
                            $$("danhsach_hoadonhuy").refresh();
                            $$("btnLuuTamHDDT").destructor();
                            $$("btnGhiSignHuyHDDT").destructor();
                        }
                        detailForm.show();
                    } else {
                        webix.message("Chưa chọn thông báo nào!");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("mau04_68");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem != undefined && selectedItem != null) {
                        webix.confirm({
                            text: "Bạn có muốn xóa",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (choose) {
                                if (choose) {
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();
                                    selectedItem.signMode = 0;
                                    var data = [];
                                    data.push(selectedItem);
                                    var postData = {
                                        data: data,
                                        signMode: 0,
                                        editmode: 3,
                                    };
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Invoice68/SavePhatHanhBienLai", postData, {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();
                                                var json = JSON.parse(text);
                                                webix.message(json.error, "error");
                                                //webix.message(XmlHttpRequest.statusText, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var result = JSON.parse(text);

                                                if (result.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: result.error });
                                                    table.enable();
                                                    table.hideProgress();
                                                    return;
                                                } else {
                                                    table.enable();
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    table.hideProgress();
                                                }
                                            },
                                        });
                                }
                            },
                        });
                    } else {
                        webix.message("Chưa chọn thông báo nào!");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-pencil fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Ký") + "</span>",
            id: "btnSign",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("mau04_68");
                    var selectedItem = tableDK.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1) {
                        webix.message("Mẫu đã ký, bạn không thể ký lại! ", "error");
                        return;
                    }

                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .get(app.config.host + "/Invoice68/GetSignType", function (text) {
                            var result = JSON.parse(text);
                            var kytaptrung = "";
                            for (var i = 0; i < result.length; i++) {
                                var item = result[i];
                                kytaptrung = item.value;
                            }

                            webix.ajax().get(app.config.host + "/Invoice68/GetListCertificatesFile68", function (text) {
                                var listcerts = JSON.parse(text);
                                if (listcerts.length > 0) {
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();

                                                    var cert = null;

                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }

                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                        return;
                                                    }

                                                    var now = new Date();
                                                    var begin = new Date(cert.begin_date);
                                                    var end = new Date(cert.end_date);
                                                    if (now < begin || now > end) {
                                                        webix.message("Chứng thư số nằm ngoài thời gian hiệu lực", "error");
                                                        return;
                                                    }

                                                    var postData = {   
                                                        branch_code: user.getDvcsID(),
                                                        username: user.getCurrentUser(),
                                                        cer_serial: cert.cer_serial,
                                                        id: selectedItem.id,
                                                        notEditMode: 1,
                                                        signMode: 1,
                                                    };

                                                    webix.extend(tableDK, webix.ProgressBar);
                                                    tableDK.disable();
                                                    tableDK.showProgress();
                                                    webix
                                                        .ajax()
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(app.config.host + "/Invoice68/SavePhatHanhBienLai", postData, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                tableDK.enable();
                                                                tableDK.hideProgress();
                                                                // var json = JSON.parse(text);
                                                                // webix.message(json.ExceptionMessage, "error");
                                                                webix.message(text + XmlHttpRequest, "error");
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(text);
                                                                tableDK.enable();
                                                                tableDK.hideProgress();
                                                                if (!json.hasOwnProperty("error")) {
                                                                    webix.message("Ký thành công !", "success");
                                                                    // $$("huyhoadonForms").close();
                                                                    app.callEvent("dataChangedMau0405", [1, null]);
                                                                } else {
                                                                    webix.message(json.error, "error");
                                                                }
                                                            },
                                                        });

                                                // return;
                                            }
                                        },
                                    });

                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon",
                                                header: _("CHON"),
                                                width: 65,
                                                checkValue: true,
                                                uncheckValue: false,
                                                template: "{common.checkbox()}",
                                            },
                                            {
                                                id: "cert_type",
                                                header: _("Loại"),
                                                width: 450,
                                            },
                                            {
                                                id: "cer_serial",
                                                header: _("SO_SERIAL"),
                                                width: 150,
                                            },
                                            {
                                                id: "subject_name",
                                                header: _("SUBJECTNAME"),
                                                width: 450,
                                            },
                                            {
                                                id: "begin_date",
                                                header: _("NGAY_BAT_DAU"),
                                                width: 200,
                                            },
                                            {
                                                id: "end_date",
                                                header: _("NGAY_KET_THUC"),
                                                width: 200,
                                            },
                                            {
                                                id: "issuer",
                                                header: _("DONVI"),
                                                width: 450,
                                            },
                                        ],
                                        url: app.config.host + "/Invoice68/GetListCertificatesFile68",
                                    });
                                } else {
                                    var table = $$("mau04_68");
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    // xem user có tích checkbox ký HSM không?
                                    var checkSigHSM = webix.ajax(app.config.host + "/Account/GetInfoUserLogin");
                                    webix.promise.all([checkSigHSM]).then(function (resultscheckSigHSM) {
                                        if (resultscheckSigHSM[0].json() == "C") {
                                            var postData = {
                                                branch_code: user.getDvcsID(),
                                                username: user.getCurrentUser(),
                                                id: selectedItem.id,
                                                notEditMode: 1,
                                                signMode: 1,
                                                check_HSM: "1",
                                            };

                                            webix.extend(tableDK, webix.ProgressBar);
                                            tableDK.disable();
                                            tableDK.showProgress();
                                            webix
                                                .ajax()
                                                .headers({ "Content-type": "application/json" })
                                                .post(app.config.host + "/Invoice68/SavePhatHanhBienLai", postData, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        tableDK.enable();
                                                        tableDK.hideProgress();
                                                        // var json = JSON.parse(text);
                                                        // webix.message(json.ExceptionMessage, "error");
                                                        webix.message(text + XmlHttpRequest, "error");
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text);
                                                        tableDK.enable();
                                                        tableDK.hideProgress();
                                                        if (!json.hasOwnProperty("error")) {
                                                            webix.message("Ký thành công !", "success");
                                                            // $$("huyhoadonForms").close();
                                                            app.callEvent("dataChangedMau0405", [1, null]);
                                                        } else {
                                                            webix.message(json.error, "error");
                                                        }
                                                    },
                                                });
                                        } else {
                                            var a = webix.ajax(app.config.host + "/Invoice68/XmlPhatHanhBL?id=" + selectedItem.id);
                                            var b = webix.ajax(app.config.host + "/Invoice68/GetListCertificates");

                                            webix.promise.all([a, b, selectedItem]).then(function (results) {
                                                // webix.extend(tblInvoice, webix.ProgressBar);
                                                // tblInvoice.disable();
                                                // tblInvoice.showProgress();
                                                var json = results[0].json();

                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: "error", text: json.error });
                                                }

                                                var listcerts = results[1].json();
                                                var item = results[2];

                                                if (listcerts.length == 0) {
                                                    table.enable();
                                                    table.hideProgress();
                                                    webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                                    return;
                                                }

                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();
                                                    if (hubconnect.state != 1) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký biên lai hoặc Plugin ký biên lai chưa được bật !", "error");
                                                        return;
                                                    }
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (result) {
                                                        var json = JSON.parse(result);

                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: "error", text: json.error });
                                                        } else {
                                                            var parameters = {
                                                                xml: json.xml,
                                                                id: selectedItem.id,
                                                                tthdon: 3,
                                                            };

                                                            webix
                                                                .ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice68/SaveXmlPhatHanhBienLai", parameters, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.hasOwnProperty("error")) {
                                                                        webix.message(result.error, "error");
                                                                    } else {
                                                                        webix.message("Ký thành công !", "success");
                                                                        // $$("huyhoadonForms").close();
                                                                        app.callEvent("dataChangedMau0405", [1, null]);
                                                                    }
                                                                });
                                                        }
                                                        table.enable();
                                                        table.hideProgress();
                                                    });

                                                    var _listcerts = [];

                                                    for (var i = 0; i < listcerts.length; i++) {
                                                        var _cert = listcerts[i];

                                                        _listcerts.push({
                                                            so_serial: _cert.cer_serial,
                                                            ngaybatdau: _cert.begin_date,
                                                            ngayketthuc: _cert.end_date,
                                                            issuer: _cert.issuer,
                                                            subjectname: _cert.subject_name,
                                                        });
                                                    }

                                                    var arg = {
                                                        idData: "#data",
                                                        xml: json["xml"],
                                                        shdon: "",
                                                        idSigner: "seller",
                                                        tagSign: "NNT",
                                                        dvky: json["dvky"],
                                                        dateKy: json["dateKy"],
                                                        listcerts: _listcerts,
                                                    };

                                                    hub.invoke("execCommand", "SignInvoice", JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("Success !");
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                        });
                                                });
                                            });
                                            // app.callEvent("dataChangedInvoie68", [editmode, null]);

                                            // webix.message("Thành công !", "success");
                                            // webix.$$("huyhoadonForms").close();
                                        }
                                    });
                                }
                            });
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "mau04_68",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    scrollX: true,
                    cells: [
                        {
                            header: "Chi tiết",
                            body: {
                                view: "datatable",
                                height: 200,
                                resizeColumn: true,
                                // scroll: true,
                                id: "mau04_68_chitiet",
                                headerRowHeight: 50,
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.index = i + 1;
                                        });
                                    },
                                },
                                columns: [
                                    {
                                        view: "text",
                                        id: "tbph_id",
                                        name: "tbph_id",
                                        hidden: true,
                                    },
                                    {
                                        view: "text",
                                        id: "tbph_chitiet_id",
                                        name: "tbph_chitiet_id",
                                        hidden: true,
                                    },
                                    {
                                        view: "text",
                                        header: "STT",
                                        id: "index",
                                        name: "index",
                                        width: 80,
                                    },
                                    {
                                        header: "Tên biên lai",
                                        id: "tenlbl",
                                        width: 120,
                                    },
                                    {
                                        header: "Kí hiệu",
                                        id: "khieu",
                                        width: 120,
                                    },
                                    {
                                        header: "Số lượng",
                                        id: "soluong",
                                        width: 120,
                                        editor: "autonumeric",
                                        editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2,
                                        }),
                                    },
                                    {
                                        header: "Từ số",
                                        id: "tuso",
                                        width: 120,
                                        // template: function (obj) {
                                        //     return obj.khieu.toString().substring(0, 1);
                                        // },
                                    },
                                    {
                                        header: "Đên số",
                                        id: "denso",
                                        width: 120,
                                        // template: function (obj) {
                                        //     return obj.khieu.toString().substring(0, 1);
                                        // },
                                    },
                                    {
                                        header: "Hợp đồng số",
                                        id: "hdso",
                                        width: 120,
                                    },
                                    {
                                        header: "Hợp đồng ngày",
                                        id: "hdngay",
                                        width: 120,
                                        // template: function (obj) {
                                        //     return obj.khieu.toString().substring(0, 1);
                                        // },
                                    },
                                    {
                                        id: "ngay",
                                        name: "ngay",
                                        header: "Ngày lập",
                                        width: 120,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        },
                                    },
                                    {
                                        id: "ldo",
                                        name: "ldo",
                                        header: "Lý do",
                                        width: 250,
                                    },
                                ],
                                data: [
                                    {
                                        index: 1,
                                        khieu: "1KT20YY",
                                        shdon: "0000001",
                                        ngay: new Date(),
                                        ladhddt: "1",
                                        ldo: "Sai thông tin",
                                    },
                                    {
                                        index: 2,
                                        khieu: "1KT20YY",
                                        shdon: "0000002",
                                        ngay: new Date(),
                                        ladhddt: "1",
                                        ldo: "Sai tiền",
                                    },
                                ],
                                // scrollX: false,
                                // autoheight: true,
                            },
                        },
                    ],
                },
                scheme: {
                    $init: function () {
                        // this.data.each(function (obj, i) {
                        //     obj.index = i + 1;
                        // });
                    },
                },
                onClick: {
                    // ShowHistory: function (event, cell, target){
                    //     debugger
                    //     var table = webix.$$("mau04_68");
                    //     var win = table.$scope.ui(hoadonHistory.$ui);
                    //     var hdon_id = cell.row;
                    //     hoadonHistory.setEditMode(hdon_id);
                    //     win.show();
                    // },
                    Dowload0405: function (event, cell, target) {
                        var win = webix.$$("mau04_68");
                        var record = win.getItem(cell.row);

                        if (record.loai_tbao != "5") {
                            if (record.trang_thai != 1) {
                                webix.message("Mẫu chưa được ký không thể tải !", "error");
                                return;
                            }
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = record.loai_tbao == "5" ? "Mau05.xml" : "Mau04.xml";
                        var url = app.config.host + "/Invoice68/ExportTBPHBienLai?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        return false; // here it blocks the default behavior
                    },
                    Dowload0405Rep: function (event, cell, target) {
                        var win = webix.$$("mau04_68");
                        var record = win.getItem(cell.row);

                        if (record.loai_tbao != "5") {
                            if (record.trang_thai != 1) {
                                webix.message("Mẫu chưa được ký không thể tải !", "error");
                                return;
                            }
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = record.loai_tbao == "5" ? "Mau05Rep.xml" : "Mau04Rep.xml";
                        var url = app.config.host + "/Invoice68/ExportXMLMau04Rep?id=" + cell.row;
                        webix
                            .ajax()
                            .response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();

                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);
                                // var fileURL = URL.createObjectURL(file);
                                // window.open(fileURL, "_blank");
                            });
                        // webix.message("Delete row: " + cell.row);
                        return false; // here it blocks the default behavior
                    },
                    InMau0405: function (event, cell, target) {
                        var table = webix.$$("mau04_68");
                        var item = table.getItem(cell.row);

                        //webix.message("Chưa có mẫu in ...", "error");
                        // var rpParameter = null;
                        var box = webix.modalbox({
                            title: "Đang in biên lai ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        var newWin = window.open();
                        var html =
                            "<html><head><title>biên lai điện tử MobiFone Invoice</title>" +
                            '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                            '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                            '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice68/inTbph_bienlai?id=" + item.id + "&type=PDF&loai=" + item.loai_tbao, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                },
                            });
                    },
                    InMau0405Rep: function (event, cell, target) {
                        var table = webix.$$("mau04_68");
                        var item = table.getItem(cell.row);

                        //webix.message("Chưa có mẫu in ...", "error");
                        // var rpParameter = null;
                        // var box = webix.modalbox({
                        //     title: "Đang in biên lai ....",
                        //     text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        //     width: 350,
                        //     height: 200,
                        // });

                        //  var newWin = window.open();
                        // var html =
                        //     "<html><head><title>biên lai điện tử MobiFone Invoice</title>" +
                        //     '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        //     '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        //     '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        // newWin.document.write(html);

                        webix
                            .ajax()
                            .sync()
                            .get(app.config.host + "/Invoice68/inMau04SS?id=" + item.id, function (text) {
                                var result = text.replace(new RegExp("\\" + "\\", "gi"), "");
                                var newWin = window.open();
                                var html =
                                    "<html><head><title>biên lai điện tử MobiFone Invoice</title>" +
                                    '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                                    '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                                    "</head><body>" +
                                    '<center><div id="divprint">' +
                                    result +
                                    "</div></center>" +
                                    "</body></html>";
                                newWin.document.write(html);
                            });
                    },
                },
                on: {
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("mau04_68_chitiet");
                            var url = app.config.host + "/Invoice68/GetDataTBPHDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {},
                },
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 30,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}",
                    },
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        // height: 25
                    },
                    {
                        id: "trang_thai",

                        header: [
                            "Trạng thái gửi",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 150,
                        template: function (obj) {
                            return obj.trang_thai == 1
                                ? "<span style='color: #00b300'><i class='fas fa-check'></i></span> Đã ký"
                                : "<span style='color: red'><i class='fas fa-times'></i></span> Chưa ký";
                        },
                    },
                    {
                        id: "Dowload0405",
                        header: ["", "Tải về"],
                        css: { "text-align": "center" },
                        width: 120,
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='Dowload0405' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                            } else return "<span class='Dowload0405' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                        },
                    },
                    {
                        id: "btnInMau0405",
                        header: ["", "In"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.trang_thai == 1) {
                                return "<span class='InMau0405' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                            } else return "<span class='InMau0405' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                        },
                        width: 120,
                    },
                    {
                        id: "tnnt",
                        header: [
                            "Tên công ty",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 300,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "ddanh",
                        header: [
                            "Địa chỉ",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 500,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "sdthoai",
                        header: [
                            "Số điện thoại",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 150,
                        css: {
                            "text-align": "center",
                        },
                    },
                    {
                        id: "tcqt",
                        header: [
                            "Cơ quan thuế nhận",
                            {
                                content: "textFilter",
                            },
                        ],
                        width: 300,
                    },
                    {
                        id: "ntbao",
                        header: [
                            "Ngày thông báo",
                            {
                                content: "textFilter",
                            },
                        ],
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        width: 200,
                    },
                ],
                // data: [
                //     {
                //         stt: 1,
                //         loai_tb: "4",
                //         trang_thai: "Chờ duyệt",
                //         mso: "001",
                //         ntbao: new Date(),
                //         nguoi_gui: "ADMINNISTRATOR"
                //     },
                //     {
                //         stt: 2,
                //         loai_tb: "5",
                //         trang_thai: "Chờ duyệt",
                //         mso: "002",
                //         ntbao: new Date(),
                //         nguoi_gui: "ADMINNISTRATOR"
                //     }
                // ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("mau04_68");
            webix.$$("title").parse({
                title: "Quản lý thông báo phát hành",
                details: "Quản lý thông báo phát hành",
            });
            $scope.on(app, "dataChangedMau0405", function (mode, item) {
                // if (mode == 1) {
                //     table.add(item);
                // }
                // if (mode == 5) {
                table.clearAll();
                table.load(table.config.url);
                // }
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/tinhhinhsudung',[
    "app",
    "views/forms/dmwindow",
    "locale",
    "models/user",
    "views/forms/tinhhinhsudung"
], function (app, dmwindowform, _, user, tinhhinhsudungform) {
    

    var op = [];
    webix.$$("title").parse({ title: "Tình hình sử dụng hóa đơn", details: "Báo cáo tình hình sử dụng hóa đơn (BC26/AC)" });

    var controls = [
        {},
        {
            id: "btnSave",
            view: "button",
            type: "danger",
            icon: "save",
            label: "Nhận (F10)",
            width: 85,
            shortcut: "F10",
            on: {
                onClick: function () {
                    var form = webix.$$("tinhhinhsudung");
                    var item = form.getValues();
                    var donvi = $$("cbdonvi").getValue();
            
                    if (donvi.length > 0) {
                        webix.$$('btnshow').callEvent("onClick");
                    } else {
                        webix.extend(form, webix.ProgressBar);
                        form.disable();
                        form.showProgress();
                        webix.ajax()
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Bcthsd/Check_xulyHD", item, function (text) {
                                var data = JSON.parse(text);

                                if (!data.hasOwnProperty("error")) {
                                    webix.$$('btnshow').callEvent("onClick");
                                }
                                else {
                                    webix.message(data.error, "error");
                                }
                                form.enable();
                                form.hideProgress();
                            });
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            id: "btnshow",
            view: "button",
            type: "icon",
            icon: "save",
            label: "Nhận",
            hidden: true,
            width: 65,
            shortcut: "F11",
            on: {
                onClick: function () {

                    var form = webix.$$("tinhhinhsudung");
                    var item = form.getValues();
                    var win = this.$scope.ui(tinhhinhsudungform.$ui);

                    tinhhinhsudungform.initUI(item);
                    win.show();
                },
                click: function () {
                    this.callEvent("onClick");
                }
            }
        },
        {}
    ];

    var thang = webix.Date.dateToStr("%n");
    var thangcb = thang(new Date());
    var nam = webix.Date.dateToStr("%Y");
    var cbnam = nam(new Date());

    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    var layout = {
        // paddingY: 60,
        // paddingX: 500,
        cols: [
            { gravity: 0.5, template: "" },
            {
                rows: [
                    { gravity: 1, template: "" },
                    {
                        view: "form",
                        id: "tinhhinhsudung",
                        paddingY: 10,
                        // width: 700,
                        // height:300,
                        position: "center",
                        paddingX: 10,
                        complexData: true,
                        margin: 0,
                        elements: [
                            {
                                view: "multicombo",
                                label: _("DONVI"),
                                name: "lst_branch_code",
                                id: "cbdonvi",
                                labelWidth: 80,
                                suggest: {
                                    selectAll: true,
                                    body: {
                                        url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00198"
                                    }
                                }
                            },
                            {
                                cols: [
                                    {
                                        id: "tkThang",
                                        name: "tokhai_thang",
                                        view: "checkbox",
                                        value: 1,
                                        label: "Tờ khai tháng",
                                        labelWidth: 100
                                    },
                                    {
                                        id: "tkQuy",
                                        name: "tokhai_quy",
                                        view: "checkbox",
                                        label: "Tờ khai quý",
                                        labelWidth: 100
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        id: "cbThang",
                                        name: "thang",
                                        view: "combo",
                                        label: "Tháng",
                                        value: thangcb,
                                        options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
                                    },
                                    {
                                        id: "cbNam",
                                        name: "nam",
                                        view: "text",
                                        value: cbnam,
                                        label: "Năm"
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        id: "cbTungay",
                                        view: "datepicker",
                                        name: "tu_ngay",

                                        label: "Từ ngày"

                                    },
                                    {
                                        id: "cbDenngay",
                                        view: "datepicker",
                                        name: "den_ngay",

                                        label: "Đến ngày"
                                    }
                                ]
                            },
                            {
                                view: "fieldset",
                                label: "Chọn phụ lục kê khai",
                                body: {
                                    rows: [
                                        {
                                            view: "checkbox",
                                            id: "mau312",
                                            name: "mau_312",
                                            label: "Mẫu 3.12(Kỳ báo cáo cuối cùng)",
                                            labelWidth: 200
                                        },
                                        {
                                            view: "checkbox",
                                            id: "mau310",
                                            name: "mau_310",
                                            label: "Mẫu 3.10(Chuyển địa điểm)",
                                            labelWidth: 200
                                        },
                                    ]
                                }
                            },
                            {
                                id: "bcSoluong",
                                name: "bc_soluong",
                                view: "checkbox",
                                label: "Báo cáo theo số lượng hóa đơn",
                                labelWidth: 210
                            },
                            // {
                            //     view: "template",
                            //     template: "<hr class='ahii2'>"
                            //    // type: "section"
                            // },
                            {
                                margin: 10,
                                cols: controls

                            }

                        ]
                    },
                    { gravity: 5, template: "" }
                ]
            },
            { gravity: 0.5, template: "" }
        ]

    };

    function subview(config) {
        webix.ui(config, $$('tinhhinhsudung').getChildViews()[2].getChildViews()[0]);
    }

    var d = new Date();
    var quarter = Math.floor((d.getMonth() / 3));
    var quarter1 = quarter + 1;
    var firstDate = new Date(d.getFullYear(), quarter * 3, 1);
    var lastDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0)

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            var year = $$("cbNam").getValue();
            var month = $$("cbThang").getValue();
            var date1 = month + "/01" + "/" + year;

            var date = new Date(date1);
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            $$("cbTungay").setValue(firstDay);
            $$("cbDenngay").setValue(lastDay);
            var tkQuy = $$("tkQuy").getValue();

            $$("tkThang").attachEvent("onChange", function (newv, oldv) {
                if (newv == 1) {
                    $$("tkQuy").setValue(0);
                    $$("tkThang").setValue(1);

                    subview({
                        id: "cbThang",
                        name: "thang",
                        view: "combo",
                        label: "Tháng",
                        value: thangcb,
                        options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
                    });
                    var ssk = $$('tinhhinhsudung').getChildViews()[2].getChildViews()[0];
                    ssk.define("id", "cbThang");

                    $$("cbThang").attachEvent("onChange", function (newv, oldv) {
                        var year = $$("cbNam").getValue();
                        var month = $$("cbThang").getValue();
                        var date1 = month + "/01" + "/" + year;

                        var date = new Date(date1);
                        var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                        var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                        $$("cbTungay").setValue(firstDay1);
                        $$("cbTungay").refresh();
                        $$("cbDenngay").setValue(lastDay1);
                        $$("cbDenngay").refresh();
                    });
                    $$("cbNam").attachEvent("onChange", function (newv, oldv) {
                        var year2 = $$("cbNam").getValue();
                        var month2 = $$("cbThang").getValue();
                        var date1 = month2 + "/01" + "/" + year2;

                        var date2 = new Date(date1);
                        var firstDay2 = new Date(date2.getFullYear(), date2.getMonth(), 1);

                        var lastDay2 = new Date(date2.getFullYear(), date2.getMonth() + 1, 0);
                        $$("cbTungay").setValue(firstDay2);
                        $$("cbTungay").refresh();
                        $$("cbDenngay").setValue(lastDay2);
                        $$("cbDenngay").refresh();
                    });
                    var year = $$("cbNam").getValue();
                    var month = $$("cbThang").getValue();
                    var date1 = month + "/01" + "/" + year;

                    var date = new Date(date1);
                    var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                    var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    $$("cbTungay").setValue(firstDay1);
                    $$("cbTungay").refresh();
                    $$("cbDenngay").setValue(lastDay1);
                    $$("cbDenngay").refresh();
                }
                // webix.message("value cũ : "+oldv+" Mới: "+newv);
            });

            $$("tkQuy").attachEvent("onChange", function (newv, oldv) {
                if (newv == 1) {
                    $$("tkThang").setValue(0);
                    subview({
                        id: "cbQuy",
                        name: "quy",
                        view: "combo",
                        label: "Quý",
                        value: quarter1,
                        options: ["1", "2", "3", "4"]
                    });
                    var ssk = $$('tinhhinhsudung').getChildViews()[2].getChildViews()[0];
                    ssk.define("id", "cbQuy");

                    $$("cbQuy").attachEvent("onChange", function (newv, oldv) {
                        var quy = $$("cbQuy").getValue();
                        //console.log(quy);
                        var nam = $$("cbNam").getValue();
                        var thang;
                        if (quy == 1) {
                            thang = 0;
                        }
                        if (quy == 2) {
                            thang = 3;
                        }
                        if (quy == 3) {
                            thang = 6
                        }
                        if (quy == 4) {
                            thang = 9
                        }
                        var firstDate = new Date(nam, thang, 1);
                        var lastDate = new Date(nam, thang + 3, 0);

                        $$("cbTungay").setValue(firstDate);
                        $$("cbTungay").refresh();
                        $$("cbDenngay").setValue(lastDate);
                        $$("cbDenngay").refresh();
                    });

                    var quy = $$("cbQuy").getValue();
                    var nam = $$("cbNam").getValue();
                    var thang;
                    if (quy == 1) {
                        thang = 0;
                    }
                    if (quy == 2) {
                        thang = 3;
                    }
                    if (quy == 3) {
                        thang = 6
                    }
                    if (quy == 4) {
                        thang = 9
                    }
                    var firstDate = new Date(nam, thang, 1);
                    var lastDate = new Date(nam, thang + 3, 0);

                    $$("cbTungay").setValue(firstDate);
                    $$("cbTungay").refresh();
                    $$("cbDenngay").setValue(lastDate);
                    $$("cbDenngay").refresh();

                }

            });

            $$("cbThang").attachEvent("onChange", function (newv, oldv) {
                var year = $$("cbNam").getValue();
                var month = $$("cbThang").getValue();
                var date1 = month + "/01" + "/" + year;

                var date = new Date(date1);
                var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                $$("cbTungay").setValue(firstDay1);
                $$("cbTungay").refresh();
                $$("cbDenngay").setValue(lastDay1);
                $$("cbDenngay").refresh();
            });

            $$("cbNam").attachEvent("onChange", function (newv, oldv) {

                if ($$("tkThang").getValue() == 1) {
                    var year2 = $$("cbNam").getValue();
                    var month2 = $$("cbThang").getValue();
                    var date1 = month2 + "/01" + "/" + year2;

                    var date2 = new Date(date1);
                    var firstDay2 = new Date(date2.getFullYear(), date2.getMonth(), 1);

                    var lastDay2 = new Date(date2.getFullYear(), date2.getMonth() + 1, 0);
                    $$("cbTungay").setValue(firstDay2);
                    $$("cbTungay").refresh();
                    $$("cbDenngay").setValue(lastDay2);
                    $$("cbDenngay").refresh();
                }
                if ($$("tkQuy").getValue() == 1) {
                    var quy = $$("cbQuy").getValue();
                    //console.log(quy);
                    var nam = $$("cbNam").getValue();
                    var thang;
                    if (quy == 1) {
                        thang = 0;
                    }
                    if (quy == 2) {
                        thang = 3;
                    }
                    if (quy == 3) {
                        thang = 6
                    }
                    if (quy == 4) {
                        thang = 9
                    }
                    var firstDate = new Date(nam, thang, 1);
                    var lastDate = new Date(nam, thang + 3, 0);

                    $$("cbTungay").setValue(firstDate);
                    $$("cbTungay").refresh();
                    $$("cbDenngay").setValue(lastDate);
                    $$("cbDenngay").refresh();
                }
            });

            $$("mau312").attachEvent("onChange", function (newv, oldv) {
                if (newv == 1) {
                    $$("mau310").setValue(0);
                }

            });

            $$("mau310").attachEvent("onChange", function (newv, oldv) {
                if (newv == 1) {
                    $$("mau312").setValue(0);
                }

            });
        }
    };
});
define('views/token',["app", "views/forms/token", "locale"], function (app, dmwindowform, _) {
    

    var op = [];

    webix.$$("title").parse({ title: "Đăng ký Token", details: "Danh sách Token" });

    var controls = [
        // {
        //     id: "btnRefrescacash",
        //     view: "button",
        //     type: "icon",
        //     icon: "refresh",
        //     label: _("Tải báo cáo"),
        //     width: 90,
        //     // shortcut: "F4",
        //     //css:"button_raised",
        //     on: {
        //         onClick: function () {
        //             var box = webix.modalbox({
        //                 title: "Đang tải xuống",
        //                 text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        //                 width: 350,
        //                 height: 200
        //             });

        //             webix.ajax()
        //                 .response("arraybuffer")
        //                 //.headers({ 'Content-type': 'application/json' })
        //                 .get(app.config.host + "/Invoice/Floder?filename=BC_CHITIET_ACB_201812151033.csv", {
        //                     error: function (text, data, XmlHttpRequest) {
        //                         webix.modalbox.hide(box);
        //                         alert(text);
        //                     },
        //                     success: function (text, data, XmlHttpRequest) {
        //                         var file = new Blob([data], { type: 'text/csv' });
        //                         webix.html.download(file, "baocao.csv");

        //                         webix.modalbox.hide(box);
        //                     }
        //                 });
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            id: "btnRefresh",
            view: "button",
            type: "icon",
            icon: "fas fa-refresh",
            label: _("REFRESH"),
            css: "webix_secondary",
            width: 90,
            // shortcut: "F4",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    table.clearAll();
                    //console.log(table);
                    table.load(table.config.url);
                    //table.refresh();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnPlus",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: _("THEM") + " (F4)",
            css: "webix_secondary",
            width: 85,
            //css:"button_raised",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var box = webix.modalbox({
                        title: "Chọn Token",
                        buttons: ["Nhận", "Hủy bỏ"],
                        text: "<div id='ctnToken'></div>",
                        top: 100,
                        width: 750,
                        callback: function (result) {
                            switch (result) {
                                case "1":
                                    webix.modalbox.hide();
                                    break;
                                case "0":
                                    var table = $$("tblToken");

                                    var item = {
                                        tokens: table.serialize(),
                                    };

                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/Token/SaveTokens", item, function (text) {
                                            var json = JSON.parse(text);

                                            if (!json.hasOwnProperty("error")) {
                                                var table = $$("dmwindowData");
                                                table.clearAll();
                                                table.load(table.config.url);

                                                webix.modalbox.hide();
                                            } else {
                                                webix.message(json.error);
                                            }
                                        });

                                    break;
                            }
                        },
                    });

                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                    popupText.style.paddingTop = 0;

                    var tblMatHang = webix.ui({
                        container: "ctnToken",
                        id: "tblToken",
                        view: "datatable",
                        borderless: true,
                        height: 350,
                        columns: [
                            {
                                id: "chon",
                                header: _("CHON"),
                                width: 65,
                                checkValue: true,
                                uncheckValue: false,
                                template: "{common.checkbox()}",
                            },
                            {
                                id: "serialNumber",
                                header: _("SO_SERIAL"),
                                width: 150,
                            },
                            {
                                id: "tokenLabel",
                                header: _("TOKEN LABEL"),
                                width: 550,
                            },
                        ],
                        //url: app.config.host + "/Token/SelectTokens"
                    });

                    var url = app.config.host + "/System/ExecuteCommand";

                    webix
                        .ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(
                            url,
                            {
                                command: "CM00019",
                                parameter: {
                                    ma_dvcs: "",
                                },
                            },
                            function (text) {
                                var array = JSON.parse(text);

                                var kytaptrung = "";
                                var server_cert = "";

                                for (var i = 0; i < array.length; i++) {
                                    var item = array[i];

                                    if (item.code == "KYTAPTRUNG") {
                                        kytaptrung = item.gia_tri;
                                    }

                                    if (item.code == "SERVER_CERT") {
                                        server_cert = item.gia_tri;
                                    }
                                }

                                webix.ajax(server_cert + "/Token/SelectTokens", function (text) {
                                    $$("tblToken").clearAll();
                                    $$("tblToken").parse(text, "json");
                                });
                            }
                        );
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
            label: _("SUA") + " (F3)",
            css: "webix_secondary",
            width: 75,
            //css:"button_raised",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("chukyso-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }
                    /* var chon = item.chon;

                    item.chon = chon == true ? "true" : "false"; */

                    form.setValues(item);

                    dmwindowform.setEditMode(2);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "icon",
            icon: "fas fa-trash-o",
            css: "webix_secondary",
            label: _("XOA") + " (F8)",
            width: 75,
            //css:"button_raised",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    var khData = {};
                    khData.windowid = app.path[1].params[0];
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.serial_number,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/System/Save", khData, function (text) {
                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }

                                        table.remove(item.id);
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                resizeColumn: true,
                //loadahead: 15,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

                        if (params == null) {
                            url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        } else {
                            url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);

                                    if (column !== undefined) {
                                        var item = {
                                            columnName: property,
                                            columnType: column.columnType,
                                            value: params.filter[property],
                                        };

                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                if (array.length > 0) {
                                    url = url + "&filter=" + JSON.stringify(array);
                                } else {
                                    url = url + "&filter=null";
                                }
                            } else {
                                url = url + "&filter=null";
                            }
                        }

                        if (view.config.infoparam != null) {
                            url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                        } else {
                            url = url + "&infoparam=null";
                        }

                        var tlbParams = $$("tlbParams");

                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();

                            var parameters = [];

                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];

                                var id = child.config.id;
                                var value_field = child.config.value_field;

                                var item = {
                                    columnName: value_field,
                                    value: $$(id).getValue(),
                                };

                                parameters.push(item);
                            }

                            url = url + "&tlbparam=" + JSON.stringify(parameters);
                        } else {
                            url = url + "&tlbparam=null";
                        }
                        //console.log(url);
                        webix.ajax(url, callback, view);
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                },
                columns: [
                    { id: "index", header: "", sort: "int", width: 40 },
                    { id: "serial_number", header: _("SO_SERIAL"), width: 200 },
                    { id: "token_label", header: "TOKEN LABEL", width: 350 },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                view: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});

define('views/tokenfile',["app", "views/forms/tokenfile", "locale"], function (app, dmwindowform, _) {
    

    var op = [];

    webix.$$("title").parse({ title: "Đăng ký Token File mềm", details: "Danh sách Token File mềm" });

    var controls = [
        {
            id: "btnRefresh",
            view: "button",
            type: "icon",
            icon: "fas fa-refresh",
            label: _("REFRESH"),
            width: 90,
            // shortcut: "F4",
            //css:"button_raised",
            css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    table.clearAll();
                    //console.log(table);
                    table.load(table.config.url);
                    //table.refresh();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnPlus",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: _("THEM") + " (F4)",
            width: 85,
            //css:"button_raised",
            css: "webix_secondary",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("tokenfile-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    // var chon = item.chon;

                    // item.chon = chon == true ? "true" : "false";

                    dmwindowform.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
            label: _("SUA") + " (F3)",
            width: 75,
            //css:"button_raised",
            css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("tokenfile-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }
                    // var chon = item.chon;

                    // item.chon = chon == true ? "true" : "false";

                    form.setValues(item);

                    dmwindowform.setEditMode(2);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            id: "btnDelete",
            view: "button",
            type: "icon",
            icon: "fas fa-trash-o",
            css: "webix_secondary",
            label: _("XOA") + " (F8)",
            width: 75,
            //css:"button_raised",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    var khData = {};
                    khData.windowid = app.path[1].params[0];
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.serialNumber,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(app.config.host + "/System/Save", khData, function (text) {
                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }

                                        table.remove(item.id);
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {},
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                resizeColumn: true,
                //loadahead: 15,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/GetDataByWindowNo";

                        var start = null;
                        var count = null;
                        var filter = [];
                        var infoparam = null;
                        var tlbparam_s = [];

                        if (params == null) {
                            url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                            start = 0;
                            count = view.config.datafetch;
                        } else {
                            url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                            start = params.start;
                            count = params.count;
                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);

                                    if (column !== undefined) {
                                        var item = {
                                            columnName: property,
                                            columnType: column.columnType,
                                            value: params.filter[property],
                                        };
                                        array.push(item);
                                    }
                                }

                                if (array.length > 0) {
                                    filter = array;
                                    url = url + "&filter=" + JSON.stringify(array);
                                } else {
                                    url = url + "&filter=null";
                                }
                            } else {
                                url = url + "&filter=null";
                            }
                        }

                        if (view.config.infoparam != null) {
                            infoparam = view.config.infoparam;
                            url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                        } else {
                            url = url + "&infoparam=null";
                        }

                        var tlbParams = $$("tlbParams");

                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();

                            var parameters = [];

                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];

                                var id = child.config.id;
                                var value_field = child.config.value_field;

                                var item = {
                                    columnName: value_field,
                                    value: $$(id).getValue(),
                                };

                                parameters.push(item);
                            }
                            tlbparam_s = parameters;
                            url = url + "&tlbparam=" + JSON.stringify(parameters);
                        } else {
                            url = url + "&tlbparam=null";
                        }

                        var item = {
                            window_id: windowno,
                            start: start,
                            count: count,
                            filter: filter,
                            infoparam: infoparam,
                            tlbparam: tlbparam_s,
                        };
                        var url1 = app.config.host + "/System/GetDataByWindowNo";
                        webix.ajax().headers({ "Content-type": "application/json" }).bind(view).post(url1, item, callback, view);
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                },
                columns: [
                    { id: "index", header: "", sort: "int", width: 40 },
                    { id: "file_path", header: _("PATH"), width: 350 },
                    { id: "serial_number", header: "Số serial", sort: "int", width: 250 },
                    { id: "serial_label", header: "Serial token", sort: "int", width: 250 },
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            },
        ],
    };

    var layout = {
        rows: [
            {
                height: 35,
                view: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        },
    };
});

define('views/treewindow',[
    "app",
    "views/forms/window",
    "locale"
], function (app, windowform, _) {
    

    var layoutId = "";
    var col = [];
    var sub_col = [];
    var windowconfig = null;
    var buttons = [];
    var dataParams = [];
    //var windowno = "":   


    var initUI = function () {
        var windowno = app.path[1].params[0];

        col = [];
        sub_col = [];

        var query = "SELECT * FROM #SCHEMA_NAME#.wb_menu WHERE window_code='" + windowno + "' LIMIT 1 OFFSET 0";
        var url = app.config.host + "/System/Query";

        webix.ajax()
            .headers({"Content-Type":"application/json"})
            .post(url,{sql : query}, function (text) {
            var json = JSON.parse(text);

            if (json.length > 0) {
                webix.$$("title").parse({ title: json[0]["name"], details: json[0]["details"], url_help: json[0]["url_help"] == null || undefined ? "http://huongdansudung.minvoice.com.vn/" : json[0]["url_help"] });
            }
        });

        url = app.config.host + "/System/ExecuteCommand";
        
        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(url,
            {
                command: "CM00002",
                parameter: {
                    window_id: windowno
                }
            }, function (text) {
                var json = JSON.parse(text);

                if (buttons.length > 0) {
                    for (var i = 0; i < buttons.length; i++) {
                        var item = buttons[i];
                        $$("tlbMain").removeView(item.id);
                    }
                }

                buttons = [];
                var menus = [];

                var stt = 5;

                for (var i = 0; i < json.length; i++) {
                    var item = json[i];

                    if (item.is_group_function == "C") {
                        if (item.hidden != 1) {
                            menus.push({
                                id: item.name,
                                value: _(item.caption),
                                on_click: item.on_click
                            });
                        }
                    }
                    else {
                        if (item.hidden != 1) {
                            var fn = new Function(item.on_click);

                            var button = {
                                id: item.name,
                                label: _(item.caption),
                                view: "button",
                                type: "icon",
                                css: "webix_secondary",
                                icon: "fas fa-" + item.icon,
                                width: item.width,
                                click: fn
                            };

                            buttons.push(button);
                            $$("tlbMain").addView(button, stt);

                            stt=stt+1;
                        }
                    }

                }

                if (menus.length > 0) {
                    subChucNang.clearAll();
                    subChucNang.parse(menus, "json");

                    var index = $$("tlbMain").index($$("cbMauIn"));

                    var btnChucNang = {
                        id: "btnChucNang",
                        label: _("CHUC_NANG"),
                        view: "button",
                        type: "icon",
                        css: "webix_secondary",
                        icon: "fas fa-tasks",
                        width: 100,
                        click: function () {
                            subChucNang.show(webix.$$("btnChucNang").$view);
                        }
                    }

                    $$("tlbMain").addView(btnChucNang, index - 1);
                }


            });

        url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;

        webix.$$("treewindowData").getParentView().getParentView().getParentView().disable();
        webix.$$("treewindowData").getParentView().getParentView().getParentView().showProgress();

        webix.ajax(url, function (text, xml, xhr) {

            var rp = JSON.parse(text);
            windowconfig = rp;
            var vc_window = windowconfig.data[0];

            var isPlusIcon = false;

            var tabs = rp['data'][0]['Tabs'];
            var k = tabs.length;

            var masterTab = tabs[0];
            for (var t = 0; t < tabs.length; t++) {
                if (tabs[t].tab_type == "Master") {
                    masterTab = tabs[t];
                    break;
                }
            }

            var hasDetailTabs = false;
            for (var t = 0; t < tabs.length; t++) {
                if (tabs[t].tab_type == "Detail") {
                    hasDetailTabs = true;
                    break;
                }
            }

            if (hasDetailTabs) {
                col.push({
                    id: "subRow",
                    header: "&nbsp;",
                    template: "{common.subrow()}",
                    css: "nampvsub",
                    width: 40,
                });
            }

            for (var j = 0; j < masterTab.Fields.length; j++) {

                var field = masterTab.Fields[j];
                if (field.hide_in_grid == true) {
                    continue;
                }

                var item = {
                    id: field.column_name,
                    header: _(String(field.column_name)),
                    formatColumn: field.format
                };

                if (field.caption != null) {
                    item.header = _(field.caption);
                }

                if (field.type_filter != null) {
                    if (field.type_filter != "") {
                        item.header = [_(item.header), { content: field.type_filter }]
                    }
                }

                if (isPlusIcon == false) {
                    item.template = "{common.space()} {common.icon()} #" + item.id + "#";
                    isPlusIcon = true;
                }

                if (field.FORMAT != null) {
                    if (field.column_type == "decimal") {
                        item.css = { "text-align": "right" };
                        item.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        });
                    }

                    if (field.column_type == "datetime" || field.column_type == "date") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr(this.formatColumn);
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }
                }

                if (field.type_editor == "combo") {
                    item.editor = field.type_editor;
                    item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                }

                if (field.column_width == null) {
                    item.fillspace = true;
                }
                else {
                    item.width = field.column_width;
                }

                col.push(item);
            }

            var table = $$("treewindowData");
            table.clearAll();

            table.config.columns = col;
            table.refreshColumns();

            if (hasDetailTabs) {
                var cells = [];

                for (var i = 0; i < tabs.length; i++) {
                    var tab = tabs[i];

                    if (tab.tab_type != "Detail") {
                        continue;
                    }

                    var subCols = [];

                    for (var j = 0; j < tab.Fields.length; j++) {
                        var field = tab.Fields[j];

                        if (field.hide_in_grid == true) {
                            continue;
                        }

                        var subCol = {
                            id: field.column_name,
                            header: field.caption == null ? _(field.column_name) : _(field.caption),
                            hidden: field.hide_in_grid,
                        };

                        if (field.column_type == "date" || field.column_type == "datetime") {
                            subCol.format = function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            };
                        }

                        if (field.column_type == "numeric") {
                            subCol.css = { "text-align": "right" };
                            subCol.format = webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: field.data_decimal,
                            });
                        }

                        if (field.column_width == null) {
                            subCol.fillspace = true;
                        } else {
                            subCol.width = field.column_width;
                        }

                        subCols.push(subCol);
                    }

                    cells.push({
                        header: tab.name,
                        select: "cell",
                        body: {
                            view: "datatable",
                            tab_table: tab.table_name,
                            columns: subCols,
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(_("LOADING") + "...");
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay();
                                },
                            },
                        },
                    });
                }

                table.define("subview", {
                    borderless: true,
                    view: "tabview",
                    height: 200,
                    scrollX: true,
                    cells: cells,
                    multiview: {
                        fitBiggest: true,
                    },
                });
            }

            //table.define("url",app.config.host + "/api/System/GetDataByWindowNo?window_id="+windowno );

            webix.ajax()
                .headers({ "Content-Type": "application/json" })
                .post(app.config.host + "/System/GetDataByWindowNo",
                {
                    window_id: windowno,
                    start: 0,
                    count: 999999999,
                    continue: null,
                    filter: [],
                    infoparam: null,
                    tlbparam: []
                }, function (text) {
                    var json = JSON.parse(text);
                    //console.log(json);
                    var data = listToTree(json.data, { idKey: "id", parentId: "parent_id" });
                    //console.log(data);
                    $$("treewindowData").parse(data, "json");
                    $$("treewindowData").openAll();
                });

            table.getParentView().getParentView().getParentView().enable();
            table.getParentView().getParentView().getParentView().hideProgress();

            var parentToolBar = $$("tlbMain").getParentView();

            parentToolBar.removeView("tlbParams");
            $$("head-title").show();
            $$("head-title").removeView("tlbParams");
            // toolBar windown parram
            if (vc_window.WinParams != undefined && vc_window.WinParams != null) {
                var toolBarParams = {
                    id: "tlbParams",
                    view: "toolbar",
                    css: { "background-color": "#f5f5f5 !important" },
                    borderless: true,
                    height: 35,
                    cols: [],
                };
    
                for (var i = 0; i < vc_window.WinParams.length; i++) {
                    var item1 = vc_window.WinParams[i];
    
                    var comp = {
                        id: webix.uid(),
                        view: item1.type_editor,
                        width: item1.width,
                        label: _(item1.caption),
                        value_field: item1.value_field,
                        isDefault: item1.has_default,
                        on: {},
                    };
    
                    if (comp.view == "combo") {
                        if(comp.value_field) {
                            dataParams.push({
                                id: comp.id,
                                value_field: comp.value_field
                            })
                        }
                        comp.options = {
                            body: {
                                comboId: comp.id,
                                isDefault: item1.has_default,
                                url: app.config.host + "/System/GetDataByReferencesId?id=" + item1.wb_references_id,
                                ready: function () {
                                    if (this.config.isDefault == "C") {
                                        var count = this.count();
                                        if (count > 0) {
                                            var combo = webix.$$(this.config.comboId);
                                            combo.setValue(this.getFirstId());
                                            loadDataCustom(param);
                                        }
                                    }
                                },
                            },
                        };
    
                        comp.on.onChange = function (newv, oldv) {
                            var param = {};
                            param[comp.value_field] = newv;
                            loadDataCustom(param);
                        };
                    }
    
                    if (comp.view == "treesuggest") {
                        var listColumns = JSON.parse(item1.list_column);
    
                        for (var v = 0; v < listColumns.length; v++) {
                            listColumns[v].header = _(listColumns[v].id);
                        }
    
                        comp.view = "combo";
    
                        comp.options = {
                            view: "treesuggest",
                            textValue: item1.display_field,
                            isDefault: item1.has_default,
                            url: {
                                $proxy: true,
                                load: function (view, callback, params) {
                                    var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;
                                    webix.ajax(url, function (text) {
                                        var json = JSON.parse(text);
                                        var data = listToTree(json);
                                        view.parse(data, "json");
                                    });
                                },
                            },
                            body: {
                                isDefault: item1.has_default,
                                comboId: comp.id,
                                columns: listColumns,
                                refid: item1.wb_references_id,
                                filterMode: {
                                    level: false,
                                    showSubItems: false,
                                },
                                ready: function () {
                                    if (this.config.isDefault == "C") {
                                        var count = this.count();
    
                                        if (count > 0) {
                                            var combo = webix.$$(this.config.comboId);
                                            combo.setValue(this.getFirstId());
                                        }
                                    }
                                },
                            },
                        };
    
                        comp.on.onChange = function (newv, oldv) {
                            var table = $$("windowData");
                            table.clearAll();
                            table.load(table.config.url);
                        };
                    }
                    if (comp.view == "label") {
                        var url = app.config.host + "/System/GetDataByReferencesId?id=" + item1.wb_references_id;
                        var result = JSON.parse(webix.ajax().sync().get(url).response);
                        comp.label = comp.label + ": " + result[0][comp.value_field];
                        // comp.label = webix.ajax(url, function (text) {
                        //     var result = JSON.parse(text);
                        //     var label = $$(id).data.label;
                        //     $$(id).setValue(label + ": " + result[0][comp.value_field]);
                        //     $$(id).refresh();
                        // }));
                    }
    
                    toolBarParams.cols.push(comp);
                }
                $$("head-title").addView(toolBarParams, 1);
            }
        });
    };

    var mini_dashboard = {
        type: "clean",
        borderless: true,
        cols: [
            {
                id: "sohoadonconlai",
                name: "sohoadonconlai",
                view: "label",
            },
        ],
    };

    var controls = [
        {
            id: "btnRefresh",
            view: "button",
            type: "icon",
            icon: "fas fa-refresh",
            label: _("REFRESH"),
            css: "webix_secondary",
            width: 95,
            // shortcut: "F4",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var param = {};
                    if(dataParams.length > 0) {
                        var prCodeComp = dataParams.find(function(e) {
                            return e.value_field == 'parent_code';
                        })
                        dataParams.forEach(function(e) {
                            param[e.value_field] =  $$(e.id).getValue();
                        });
                    }
                    loadDataCustom(param);
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            id: "btnPlus",
            view: "button",
            type: "icon",
            icon: "fas fa-plus",
            label: "Thêm",
             css: "webix_secondary",
            width: 65,
            //css:"button_raised",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.code;

                    var detailForm = this.$scope.ui(windowform.$ui);
                    windowform.setEditMode(0);
                    windowform.initUI(windowconfig);
                    
                    windowform.setValues(null, windowconfig);
                    windowform.setEditMode(1);
                    
                    detailForm.show();

                    if (vc_window.after_new != null) {
                        var fn = Function(vc_window.after_new);
                        fn();
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            id: "btnEdit",
            view: "button",
            type: "icon",
            icon: "fas fa-edit",
             css: "webix_secondary",
            label: "Sửa",
            width: 55,
            shortcut: "F3",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];


                    windowform.$ui.id = vc_window.code;

                    var detailForm = this.$scope.ui(windowform.$ui);

                    var table = webix.$$("treewindowData");
                    var item = table.getSelectedItem();
                    if (item == null || item == "") {
                        webix.message("Bạn chưa chọn dòng cần sửa ! ", "error");
                        return;
                    }
                    windowform.initUI(windowconfig);
                    windowform.setEditMode(2);
                    windowform.setValues(item, windowconfig);

                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            id: "btnDelete",
            view: "button",
            type: "icon",
            icon: "fas fa-trash-o",
             css: "webix_secondary",
            label: "Xóa",
            width: 55,
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("treewindowData");
                    var item = table.getSelectedItem();

                    if (item.$count > 0) {
                        webix.message("Đã có nhóm con. Không thể xóa");
                        return;
                    }

                    var khData = {};
                    khData.windowid = windowconfig.data[0].code;
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);

                    webix.confirm({
                        text: "Bạn có muốn xóa ", ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/Save", khData, function (text) {
                                        var json = JSON.parse(text);
                                        //console.log(json);
                                        if (json.hasOwnProperty("error")) {
                                            webix.message(json.error);
                                            return;
                                        }

                                        table.remove(item.id);

                                    });

                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            id: "btnCopy",
            view: "button",
            type: "icon",
            icon: "fas fa-files-o",
             css: "webix_secondary",
            label: _("COPY"),
            width: 85,
            on: {
                onClick: function () {
                    var table = webix.$$("treewindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu !", "error");
                        return;
                    }

                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.code;

                    var detailForm = this.$scope.ui(windowform.$ui);

                    windowform.initUI(windowconfig);
                    windowform.setEditMode(1);
                    windowform.copyValues(item, windowconfig);

                    detailForm.show();

                    if (vc_window.after_new != null) {
                        var fn = Function(vc_window.after_new);
                        fn();
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var grid = {
        rows: [
            {
                id: "treewindowData",
                view: "treetable",
                select: true,
                resizeColumn: true,
                scheme: {
                    $change: function (item) {
                        if (item.$count > 1980)
                            item.$css = "highlight";
                    }
                },
                on: {
                    onSubViewCreate: function (view, item) {
                        var subView = view;
                        if (subView != null) {
                            var windowno = app.path[1].params[0];
                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + windowno + "&id=" + item.id;
                            var detailTables = subView.getChildViews()[1].getChildViews();
                            for (var i = 0; i < detailTables.length; i++) {
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table=" + dt.config.tab_table);
                            }
                        }
                    },
                    onSubViewOpen: function (id) {
                        var table = this;
                        var subView = table.getSubView(id);
                        if (subView != null) {
                            var windowno = app.path[1].params[0];
                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + windowno + "&id=" + id.row;
                            var detailTables = subView.getChildViews()[1].getChildViews();
                            for (var i = 0; i < detailTables.length; i++) {
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table=" + dt.config.tab_table);
                            }
                        }
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 200,
                    scrollX: true,
                    cells: [],
                },
                //url: app.config.host + "/api/System/GetDataByWindowNo?window_id="+windowno ,
                columns: col,
                filterMode:{
                    level:false,
                    showSubItems:false
                }
            }
        ]
    };

    var layout = {
        rows: [
            {
                id: "tlbMain",
                height: 35,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }



        ]

    };

    function loadData() {
        var windowno = app.path[1].params[0];
        var table = webix.$$("treewindowData");
        table.clearAll();

        webix.ajax()
            .headers({ "Content-Type": "application/json" })
            .post(app.config.host + "/System/GetDataByWindowNo",
            {
                window_id: windowno,
                start: 0,
                count: 999999999,
                continue: null,
                filter: [],
                infoparam: null,
                tlbparam: []
            }, function (text) {
                var json = JSON.parse(text);
                var data = listToTree(json.data, { idKey: "id", parentId: "parent_id" });
                $$("treewindowData").parse(data, "json");
                $$("treewindowData").openAll();
            });
    }

    function loadDataCustom(param) {
        var windowno = app.path[1].params[0];
        var table = webix.$$("treewindowData");
        table.clearAll();
        var defaultBody = {
            window_id: windowno,
            start: 0,
            count: 999999999,
            continue: null,
            filter: [],
            infoparam: null,
            tlbparam: []
        };

        var body = mergeObject(defaultBody, param)

        webix.ajax()
            .headers({ "Content-Type": "application/json" })
            .post(app.config.host + "/System/GetDataByWindowNo",
                body, function (text) {
                var json = JSON.parse(text);
                var data = listToTree(json.data, { idKey: "id", parentId: "parent_id" });
                $$("treewindowData").parse(data, "json");
                $$("treewindowData").openAll();
            });
    }

    function mergeObject(obj1, obj2) {
        var mergedObj = {};

        // Sao chép thuộc tính từ obj1
        for (var key in obj1) {
            if (obj1.hasOwnProperty(key)) {
                mergedObj[key] = obj1[key];
            }
        }
        
        // Sao chép thuộc tính từ obj2, ghi đè thuộc tính trùng lặp
        for (var key in obj2) {
            if (obj2.hasOwnProperty(key)) {
                mergedObj[key] = obj2[key];
            }
        }
        
        return mergedObj;
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            webix.extend(view, webix.ProgressBar);

            var windowno = app.path[1].params[0];

            $scope.on(app, "dataChangedLicense", function (mode, item) {
               
                var table = webix.$$("treewindowDataRegister");

                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }

                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }
            });

            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("treewindowData");
                var url = app.config.host + "/System/GetDataById?window_id=" + windowno + "&id=" + item.id;
                
                if(dataParams.length > 0) {
                    var prCodeComp = dataParams.find(function(e) {
                        return e.value_field == 'parent_code';
                    })

                    if(prCodeComp) {
                        url = url + "&parent_code=" + $$(prCodeComp.id).getValue();
                    }
                }

                webix.ajax(url, function (text) {
                    var json = JSON.parse(text);

                    if (mode == 1) {
                        table.data.add(json, 0, json.parent_id);
                        table.select(json.id);
                    }

                    if (mode == 2) {
                        var selectedItem = table.getSelectedItem();
                        //console.log(json.data[0]);
                        if (selectedItem.parent_id != json.parent_id) {

                            var nodeId = table.getSelectedId();
                            table.remove(nodeId);

                            table.clearSelection();

                            table.data.add(json, 0, json.parent_id);
                            table.select(json.id);
                        }
                        else {
                            table.updateItem(selectedItem.id, json);
                        }


                    }


                });



            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        }
    };
});
define('views/update',[
    "app",
    "locale",
    "views/forms/license",
], function (app, _, licenseForm) {
    

    webix.$$("title").parse({ title: "Cập nhật phần mềm", details: "Cập nhật phần mềm" });

    var controls = [
        {},
        {
            id: "btnUpdate",
            view: "button",
            type: "danger",
            //css: "mcls_btn_save", 
            icon: "save",
            label: _("Cập nhật (F10)"),
            // width: 100,
            shortcut: "F10",
            on: {
                onClick: function () {

                    var form = webix.$$("updateform");

                    if (form.validate()) {
                        webix.confirm({
                            title: "Cập nhật phần mềm",
                            text: "Bạn có muốn cập nhật phần mềm ", ok: "Có", cancel: "Không",
                            callback: function (res) {
                                if (res) {
                                    var box = webix.modalbox({
                                        title: "Đang tải cập nhật",
                                        buttons: ["Hủy bỏ"],
                                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                        width: 350,
                                        height: 200,
                                        callback: function (result) {
                                            switch (result) {
                                                case "0":
                                                    clearTimeout(interVal);
                                                    webix.modalbox.hide(box);
                                                    break;
                                            }
                                        }
                                    });
                                    var interVal = setTimeout(function () {

                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(app.config.host + "/System/UpdateVersion", function (text) {
                                                var data = JSON.parse(text);
                                                if (!data.hasOwnProperty("error")) {
                                                    webix.modalbox.hide(box);
                                                    clearTimeout(interVal);

                                                    webix.message("Cập nhật thành công !", "debug");
                                                }
                                                else {
                                                    webix.modalbox.hide(box);
                                                    clearTimeout(interVal);
                                                    webix.message(data.error, "error");
                                                }
                                            });

                                    }, 3000);
                                }
                            }
                        });
                    }

                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var layout = {
        cols: [
            { gravity: 0.5, template: "" },
            {
                rows: [
                    { gravity: 0.2, template: "" },
                    {
                        view: "template", template: "<div><span style = 'padding-left:15px; margin-top:65px;'><i class='fas fa-star'></i> Thông tin cập nhật</span></div>",
                        css: { "background-color": "white", "color": "red", "border-radius": "15px 15px 0px 0px", "font-size": "15px", "margin-top":"65px" },
                        type: "header"
                    },
                    {
                        view: "form",
                        id: "updateform",
                        paddingY: 10,
                        paddingX: 10,
                        complexData: true,
                        margin: 0,
                        elements: [
                            {
                                view: "text",
                                name: "old_ver",
                                label: "Version hiện tại",
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "text",
                                name: "new_ver",
                                label: "Version mới nhất",
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "fieldset",
                                label: "Thông tin bản cập nhật",
                                height: 200,
                                body: {
                                    rows: [
                                        {
                                            view: "textarea",
                                            name: "info_update",
                                            labelPosition: "top",
                                            css: "mcls_readonly_text",
                                            readonly: true,
                                        }
                                    ]
                                }
                            },
                            {
                                margin: 15,
                                cols: controls
                            }
                        ]

                    },
                    { gravity: 1, template: "" }
                ]
            },
            { gravity: 0.5, template: "" }
        ]
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var url = app.config.host + "/System/GetVersionUpdate";

            webix.ajax(url, function (text) {
                var json = JSON.parse(text);
                $$("updateform").setValues(json);

            });
        }

    };
});
define('views/updateToWeb',[
    "app",
    "locale",
    "views/forms/updateToWeb"
], function (app, _, formUpdate) {
    

    //var windowno = app.path[1].params[0];
    var windowno = null;
    //webix.$$("title").parse({ title: "Nhận dữ liệu từ VACOMS", details: "Nhận dữ liệu từ VACOMS" });
    var header = {
        //borderless: true,
        css: { "box-shadow": "0 2px 10px rgba(0,0,0,0.2)" },
        height: 135,
        cols: [
            // { gravity: 1, template: "", width: 150 },
            {
                view: "label",
                template: "<a href='http://minvoice.vn/' target='_blank'><img  src='assets/imgs/LogoMinvoice.png' /></a>",
                height: 115,
                borderless: true,
                css: { "padding": "10px" }
            },
            {
                id: "version",
                borderless: true,
                view: "label",
                template: "<div class='hotline'><b style='font-family:Arial;'>Hotline:</b> <label style='color:red'>0901 80 16 18</label> <br /><i style='float:right; color:red'>info@minvoice.vn</i></div>",
                css: { "padding": "40px", "padding-top": "50px" }
            },
            {
                rows: [
                    { gravity: 1, template: "" },
                    {
                        id: "cbLanguage",
                        view: "combo",
                        width: 125,
                        options: [
                            { id: "vi", value: "Việt Nam" },
                            { id: "en", value: "English" },
                            { id: "ko", value: "Korea" }
                        ],
                        // inputAlign: "right",
                        //css: "cbLanguage",
                        value: "vi",
                        // on: {
                        //     onChange: function (newv, oldv) {
                        //         locale.setLang(newv, null);
                        //     }
                        // }
                    },
                    { gravity: 1, template: "" }
                ]

            }
            // { gravity: 1, template: "", width: 150 }
        ]
    };
    var controls = [
        {},
        {
            id: "btnSave",
            view: "button",
            type: "danger",
            icon: "save",
            label: "Thực hiện (F10)",
            //  width: 120,
            shortcut: "F10",
            on: {
                onClick: function () {
                    var frm = this.$scope.ui(formUpdate.$ui);
                    frm.show();
                    // $$("formConfirm").show();
                    // $$("formConfirmValid").bind($$("formInfo"));
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button",
            label: "Quay lại đăng nhập",
            type: "form",
            icon: "fas fa-repeat",
            click: function () {
                app.router("/login");
            }
        },
        {}
    ];

    var tabview = {
        id: "my_tabview",
        view: "tabview",
        cells: [
            {
                header: "Bảng dữ liệu",
                body: {
                    id: "tblDM",
                    view: "datatable",
                    select: true,
                    editable: false,
                    disable: true,
                    data: [
                        { chon: true, MA: "SYS", TEN_DM: "Bảng hệ thống" },
                        { chon: true, MA: "BQ", TEN_DM: "Bản Quyền" },
                        { chon: true, MA: "CKS", TEN_DM: "Chữ ký số" },
                        { chon: true, MA: "TBH", TEN_DM: "Thông báo hủy" },
                        { chon: true, MA: "QTC", TEN_DM: "Quyền truy cập" },
                        { chon: true, MA: "LDC", TEN_DM: "Loại điều chỉnh" }
                    ],
                    columns: [
                        {
                            id: "chon",
                            header: { content: "masterCheckbox" },
                            template: "{common.checkbox()}",
                            checkValue: true,
                            uncheckValue: false,
                            value: true,
                            width: 50,
                            css: { 'text-align': 'right' }
                        },
                        {
                            id: "MA",
                            header: _("MA"),
                            width: 80
                        },
                        {
                            id: "TEN_DM",
                            header: _("Tên Bảng"),
                            width: 250
                        }
                    ]
                }
            },
            {
                header: "Stored Procedures",
                body: {
                    id: "tblDMCT",
                    view: "datatable",
                    select: true,
                    editable: true,
                    data: [
                        { chon: true, MA_CT: "MNU", TEN_CT: "Get Menu" },
                        { chon: true, MA_CT: "DHB", TEN_CT: "Dashboard" },
                        { chon: true, MA_CT: "CHA", TEN_CT: "Biểu đồ" },
                        { chon: true, MA_CT: "PRI", TEN_CT: "Print Invoice" },
                        { chon: true, MA_CT: "PRL", TEN_CT: "Print License" },
                        { chon: true, MA_CT: "TEM", TEN_CT: "Temple Email" },
                        { chon: true, MA_CT: "TSM", TEN_CT: "Temple SMS" },
                        { chon: true, MA_CT: "SEI", TEN_CT: "Search Invoice" },
                        { chon: true, MA_CT: "ATC", TEN_CT: "Auto Create CMD" },
                        { chon: true, MA_CT: "ATF", TEN_CT: "Auto Create Field" }
                    ],
                    columns: [
                        {
                            id: "chon",
                            header: { content: "masterCheckbox" },
                            template: "{common.checkbox()}",
                            checkValue: true,
                            uncheckValue: false,
                            value: true,
                            width: 50,
                            css: { 'text-align': 'right' }
                        },
                        {
                            id: "MA_CT",
                            header: _("Mã"),
                            width: 80
                        },
                        {
                            id: "TEN_CT",
                            header: _("Tên Stored Procedures"),
                            width: 250
                        }

                    ]
                }
            }
        ]
    };


    var layout = {
        // paddingY: 60,
        // paddingX: 500,
        cols: [
            { gravity: 0.5, template: "" },
            {
                rows: [
                    header,
                    { gravity: 0.1, template: "" },
                    {
                        gravity: 0.1,
                        template: "<div><center><b style='color:#e60000'><i class='fa fa-globe'></i> CẬP NHẬT PHẦN MỀM LÊN PHIÊN BẢN OLNINE (WEB)</b></center></div>", css: { "padding-top": "15px" }
                    },
                    {
                        view: "form",
                        id: "formInfo",
                        paddingY: 10,
                        // width: 700,
                        // height:300,
                        position: "center",
                        paddingX: 10,
                        complexData: true,
                        margin: 0,
                        //  elementsConfig: {
                        //         labelPosition: "top",
                        //         //validateEvent: "key"
                        //     },
                        url: app.config.host + "/System/GetAllDmDvcs",
                        elements: [
                            {
                                cols: [
                                    {
                                        id: "ten_dvcs",
                                        name: "ten_dvcs",
                                        view: "text",
                                        label: "Tên đơn vị",
                                        readonly: true,
                                        css: "mcls_readonly_text"
                                    },
                                    {
                                        id: "ms_thue",
                                        name: "ms_thue",
                                        view: "text",
                                        label: "Mã số thuế",
                                        readonly: true,
                                        css: "mcls_readonly_text"
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        id: "dia_chi",
                                        view: "text",
                                        name: "dia_chi",
                                        label: "Địa chỉ",
                                        readonly: true,
                                        css: "mcls_readonly_text"
                                    },
                                    {
                                        id: "tk",
                                        name: "gd",
                                        view: "checkbox",
                                        value: 1,
                                        label: "Ghi đè"
                                    }
                                ]
                            },
                            {
                                view: "template",
                                template: "Lựa chọn Bảng/Stored Procedures Update",
                                type: "section"
                            },
                            tabview,
                            {
                                margin: 10,
                                cols: controls
                            }
                        ]
                    },
                    { gravity: 0.5, template: "" }
                ]
            },
            { gravity: 0.5, template: "" }
        ]

    };

    return {
        $ui: layout
    };
});
webix.protoUI({
	name: "ckeditor",
	$init: function (config) {
		this.$view.className += " webix_selectable";
		this._waitEditor = webix.promise.defer();
	},
	defaults: {
		borderless: true,
		language: "vi",
		toolbar: [
			{ name: 'document', items: ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'] },
			{ name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
			{ name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'] },
			{ name: 'forms', items: ['Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField'] },
			'/',
			{ name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
			{ name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language'] },
			{ name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
			{ name: 'insert', items: ['Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'] },
			'/',
			{ name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
			{ name: 'colors', items: ['TextColor', 'BGColor'] },
			{ name: 'tools', items: ['Maximize', 'ShowBlocks'] },
			{ name: 'about', items: ['About'] }
		]
	},
	_init_ckeditor_once: function () {
		var tid = this.config.textAreaID = "t" + webix.uid();
		this.$view.innerHTML = "<textarea id='" + tid + "'>" + this.config.value + "</textarea>";

		this._3rd_editor = CKEDITOR.replace(this.config.textAreaID, {
			toolbar: this.config.toolbar,
			language: this.config.language,
			width: this.$width - 2,
			height: this.$height - 140
		});
		this._waitEditor.resolve(this._3rd_editor);

		this._init_ckeditor_once = function () { };
	},
	_render_ckeditor: function () {
		var initMethod = "replace";
		if (this.config.editorType === "inline") {
			CKEDITOR.disableAutoInline = true;
			initMethod = "inline";
		}

		this._3rd_editor = CKEDITOR[initMethod](this.config.textAreaID, {
			toolbar: this.config.toolbar,
			language: this.config.language,
			width: this.$width - 2,
			height: this.$height - this.config.barHeight


		});
		console.log(this.config.barHeight);
		this._waitEditor.resolve(this._3rd_editor);
	},
	_set_inner_size: function (x, y) {
		//alert(x+"-"+y);
		if (!this._3rd_editor || !this._3rd_editor.container || !this.$width || this.config.editorType === "inline") return;
		this._3rd_editor.resize(x, y);
	},
	$setSize: function (x, y) {
		//alert(x+"-"+y);
		if (webix.ui.view.prototype.$setSize.call(this, x, y)) {
			this._init_ckeditor_once();
			this._set_inner_size(x, y);
		}
	},
	setValue: function (value) {
		this.config.value = value;

		if (this._3rd_editor && this._3rd_editor.status === "ready")
			this._3rd_editor.setData(value);
		else webix.delay(function () {
			this.setValue(value);
		}, this, [], 100);
	},
	getValue: function () {
		return this._3rd_editor ? this._3rd_editor.getData() : this.config.value;
	},
	focus: function () {
		this._focus_await = true;
		if (this._3rd_editor)
			this._3rd_editor.focus();
	},
	getEditor: function (waitEditor) {
		return waitEditor ? this._waitEditor : this._3rd_editor;
	}
}, webix.ui.view);
define("views/webix/ckeditor", function(){});

webix.protoUI({
	name:"edittree"
}, webix.EditAbility, webix.ui.tree);
define("views/webix/editable", function(){});

webix.type(webix.ui.tree, {
	name:"fileTree",
	css: "file",
	height: 40,
	templateCommon:webix.template("{common.icon()} <div class='folder_title'>{common.folder()} #value#</div>"),
	folder:function(obj, common){
		return "<span class='webix_icon icon fa-folder"+(obj.open?"-open":(obj.$level>3?"-o":""))+"'></span>";
	}
});
define("views/webix/filetree", function(){});

webix.type(webix.ui.dataview, {
	name:"fileView",
	css: "files",
	height: 80,
	width: 150,

	template: function(obj){
		var icon = (obj.icon||"folder-o");
		return "<div class='"+(obj.type||"folder")+"'><span class='webix_icon fa-"+icon+"'></span></div>"+obj.value;
	}

});
define("views/webix/fileview", function(){});

webix.protoUI({
	name:"google-map",
	$init:function(config){
		this.$view.innerHTML = "<div class='webix_map_content' style='width:100%;height:100%'></div>";
		this._contentobj = this.$view.firstChild;

		this.map = null;
		this.$ready.push(this.render);
	},
	render:function(){
        if(typeof google=="undefined"||typeof google.maps=="undefined"){
            var name = "webix_callback_"+webix.uid();
            window[name] = webix.bind(function(){
                 this._initMap.call(this,true);
            },this);

            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "//maps.google.com/maps/api/js?sensor=false&callback="+name;
            document.getElementsByTagName("head")[0].appendChild(script);
        }
        else
            this._initMap();
	},
    _initMap:function(define){
        var c = this.config;

        this.map = new google.maps.Map(this._contentobj, {
            zoom: c.zoom,
            center: new google.maps.LatLng(c.center[0], c.center[1]),
            mapTypeId: google.maps.MapTypeId[c.mapType]
        });
        webix._ldGMap = null;
    },
	center_setter:function(config){
		if(this.map)
            this.map.setCenter(new google.maps.LatLng(config[0], config[1]));
        
		return config;
	},
	mapType_setter:function(config){
		/*ROADMAP,SATELLITE,HYBRID,TERRAIN*/
        if(this.map)
        	this.map.setMapTypeId(google.maps.MapTypeId[config]);

		return config;
	},
	zoom_setter:function(config){
		if(this.map)
			 this.map.setZoom(config);

		return config;
	},
	defaults:{
		zoom: 5,
		center:[ 39.5, -98.5 ],
		mapType: "ROADMAP" 
	},
	$setSize:function(){
		webix.ui.view.prototype.$setSize.apply(this, arguments);
		if(this.map)
            google.maps.event.trigger(this.map, "resize");
	}
}, webix.ui.view);

define("views/webix/googlemap", function(){});

define('views/window_custom',["app", "views/forms/window", "views/forms/infowindow", "locale", "models/user", "views/forms/printf", "views/forms/sendemail", "views/forms/lichsuemail", "views/commonHD"], function (
    app,
    windowform,
    infowindow,
    _,
    user,
    printf,
    sendemail,
    his_email,
    commonHD
) {
    

    var layoutId = "";
    var col = [];
    var sub_col = [];
    var windowconfig = null;
    var buttons = [];
    var dataParams = [];
    //var windowno = "":

    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [],
        on: {
            onItemClick: function (id, e, node) {
                var item = this.getItem(id);

                this.hide();

                var fn = Function("_", "user", item.on_click);
                fn(_, user);
            },
        },
    });

    var initUI = function () {
        var windowno = app.path[1].params[0];

        col = [];
        sub_col = [];
        var query = {
            command: "SYS002",
            parameter: {
                windowno: windowno,
            },
        };
        //var query = "SELECT * FROM #SCHEMA_NAME#.wb_menu WHERE window_code='" + windowno + "' LIMIT 1 OFFSET 0";
        // var url = app.config.host + "/System/Query";
        var url = app.config.host + "/System/ExecuteCommand";

        webix
            .ajax()
            .headers({ "Content-Type": "application/json" })
            .post(url, query, function (text) {
                var json = JSON.parse(text);

                if (json.length > 0) {
                    if (webix.$$("title") != undefined) {
                        webix.$$("title").parse({ title: json[0]["name"], details: json[0]["details"] });
                    }
                }
            });

        url = app.config.host + "/System/ExecuteCommand";

        $$("tlbMain").removeView("btnChucNang");

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00004",
                    parameter: {
                        window_id: windowno,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);

                    if (json.length > 0) {
                        $$("cbMauIn").define("options", json);
                        $$("cbMauIn").setValue(json[0].id);
                        $$("cbMauIn").show();
                        $$("cbTypeIn").show();
                        $$("btnPrint").show();
                    } else {
                        $$("cbMauIn").define("options", []);
                        $$("cbMauIn").hide();
                        $$("cbTypeIn").hide();
                        $$("btnPrint").hide();
                    }

                    $$("cbMauIn").refresh();
                }
            );

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00002",
                    parameter: {
                        window_id: windowno,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);

                    if (buttons.length > 0) {
                        for (var i = 0; i < buttons.length; i++) {
                            var item = buttons[i];
                            $$("tlbMain").removeView(item.id);
                        }
                    }

                    buttons = [];
                    var menus = [];

                    var stt = 7;

                    for (var i = 0; i < json.length; i++) {
                        var item = json[i];

                        if (item.is_group_function == "C") {
                            if (item.hidden != 1) {
                                menus.push({
                                    id: item.name,
                                    value: _(item.caption),
                                    on_click: item.on_click,
                                });
                            }
                        } else {
                            if (item.hidden != 1) {
                                var fn = new Function(item.on_click);

                                var button = {
                                    view: "button",
                                    type: "htmlbutton",
                                    width: item.width,
                                    label: '<i class="fa fa-' + item.icon + ' fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _(item.caption) + "</span>",
                                    id: item.name,
                                    // label: _(item.caption),
                                    // view: "button",
                                    // type: "icon",
                                    // css: "webix_secondary",
                                    // icon: "fas fa-" + item.icon,
                                    // width: item.width,
                                    click: fn,
                                };

                                buttons.push(button);
                                $$("tlbMain").addView(button, stt);

                                stt = stt + 1;
                            }
                        }
                    }

                    if (menus.length > 0) {
                        subChucNang.clearAll();
                        subChucNang.parse(menus, "json");

                        var index = $$("tlbMain").index($$("cbMauIn"));

                        var btnChucNang = {
                            view: "button",
                            type: "htmlbutton",
                            width: 120,
                            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("CHUC_NANG") + "</span>",
                            id: "btnChucNang",
                            // label: _("CHUC_NANG"),
                            // view: "button",
                            // type: "icon",
                            // css: "webix_secondary",
                            // icon: "fas fa-tasks",
                            // width: 100,
                            click: function () {
                                subChucNang.show(webix.$$("btnChucNang").$view);
                            },
                        };

                        $$("tlbMain").addView(btnChucNang, index - 1);
                    }
                }
            );

        // lấy thông tin của window
        url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;

        webix.$$("windowData").getParentView().getParentView().getParentView().disable();
        webix.$$("windowData").getParentView().getParentView().getParentView().showProgress();

        var app_cache = webix.storage.local.get("APP_CACHE");
        // console.log(app_cache);
        //nếu có trong cache
        if (app_cache[windowno] != null) {
            windowconfig = app_cache[windowno];
            initComponents(windowconfig);
        } //không có cache
        else {
            webix.ajax(url, function (text, xml, xhr) {
                var rp = JSON.parse(text);
                windowconfig = rp;

                var app_cache = webix.storage.local.get("APP_CACHE");
                app_cache[windowno] = windowconfig;

                webix.storage.local.put("APP_CACHE", app_cache);
                initComponents(windowconfig);
            });
        }
    };

    var initComponents = function (_windowconfig) {
        //console.log(_windowconfig);
        var k = Object.keys(_windowconfig["data"][0]["Tabs"]).length;
        //console.log(k);
        var vc_window = _windowconfig["data"][0];

        var tabs = vc_window.Tabs;

        var windowno = vc_window.window_id;

        var masterTab = tabs[0];
        //console.log(masterTab);

        $$("btnPlus").show();
        $$("btnCopy").show();
        $$("btnEdit").show();
        $$("btnDelete").show();

        for (var j = 0; j < masterTab.Fields.length; j++) {
            var field = masterTab.Fields[j];

            if (field.hide_in_grid == true) {
                continue;
            }

            var item = {
                id: field.column_name,
                header: _(field.column_name),
                columnType: field.column_type,
                columnAlias: field.column_alias,
                template: field.template,
                columnFormat: field.format,
            };

            if (field.caption != null) {
                item.header = _(field.caption);
            }

            if (field.column_type == "numeric") {
                item.css = { "text-align": "right" };
                item.format = webix.Number.numToStr({
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: field.data_decimal,
                });
            }

            if (field.type_filter != null) {
                if (field.type_filter != "") {
                    item.header = [_(item.header), { content: field.type_filter }];
                }
            }

            if (field.type_editor == "combo") {
                item.editor = field.type_editor;
                item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
            }

            if (field.type_editor == "gridcombo") {
                item.editor = field.type_editor;
                item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
            }


            if (field.column_type == "date" || field.column_type == "datetime") {
                item.format = function (text) {
                    var format = webix.Date.dateToStr(this.columnFormat);
                    text = removeTimeZoneT(text);
                    return format(text);
                };
            }

            if (field.column_type == "time") {
                item.format = function (text) {
                    var format = webix.Date.dateToStr("%H:%i");
                    text = removeTimeZoneT(text);
                    return format(text);
                }
            }

            if (field.type_editor == "checkbox") {
                if (field.column_type == "boolean") {
                    item.checkValue = true;
                    item.uncheckValue = false;
                }

                item.template = function (obj, common, value) {
                    if (value == true || value == 1) return "<div class='webix_icon fa-check-square-o'></div>";
                    else return "<div class='webix_icon fa-square-o'></div>";
                };
            }

            if (field.column_width == null) {
                item.fillspace = true;
            } else {
                item.width = field.column_width;
            }

            col.push(item);
        }

        var table = $$("windowData");
        table.clearAll();

        table.define("windowno", windowno);
        table.define("leftSplit", vc_window.fix_left == null ? 0 : vc_window.fix_left);
        table.define("rightSplit", vc_window.fix_right == null ? 0 : vc_window.fix_right);

        table.config.infoparam = null;
        table.config.columns = col;
        table.config.ma_ct = vc_window.ma_ct;

        table.refreshColumns();

        var parentToolBar = $$("tlbMain").getParentView();

        parentToolBar.removeView("tlbParams");
        $$("head-title").show();
        $$("head-title").removeView("tlbParams");
        // toolBar windown parram
        dataParams = [];
        if (vc_window.WinParams != undefined && vc_window.WinParams != null) {
            var toolBarParams = {
                id: "tlbParams",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [],
            };

            for (var i = 0; i < vc_window.WinParams.length; i++) {
                var item = vc_window.WinParams[i];

                var comp = {
                    id: webix.uid(),
                    view: item.type_editor,
                    width: item.width,
                    label: _(item.caption),
                    value_field: item.value_field,
                    isDefault: item.has_default,
                    on: {},
                };

                if (comp.view == "combo") {
                    if(comp.value_field) {
                        dataParams.push({
                            id: comp.id,
                            value_field: comp.value_field
                        })
                    }
                    comp.options = {
                        body: {
                            comboId: comp.id,
                            isDefault: item.has_default,
                            url: app.config.host + "/System/GetDataByReferencesId?id=" + item.wb_references_id,
                            ready: function () {
                                if (this.config.isDefault == "C") {
                                    var count = this.count();
                                    if (count > 0) {
                                        var combo = webix.$$(this.config.comboId);
                                        combo.setValue(this.getFirstId());
                                    }
                                }
                            },
                        },
                    };

                    comp.on.onChange = function (newv, oldv) {
                        var table = $$("windowData");
                        table.clearAll();
                        table.load(table.config.url);
                    };
                }

                toolBarParams.cols.push(comp);
            }
            windowconfig['data_params'] = dataParams;
            $$("head-title").addView(toolBarParams, 1);
            // parentToolBar.addView(toolBarParams);
        }

        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var windowno = app.path[1].params[0];
                var url = app.config.host + "/System/GetDataByWindowNo";
                var start = null;
                var count = null;
                var filter = [];
                var infoparam = null;
                var tlbparam_s = [];

                if (params == null) {
                    url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                    start = 0;
                    count = view.config.datafetch;
                } else {
                    url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                    start = params.start;
                    count = params.count;
                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            if (column !== undefined) {
                                var item = {
                                    columnName: property,
                                    columnType: column.columnType,
                                    columnAlias: column.columnAlias,
                                    value: params.filter[property],
                                };
                                array.push(item);
                            }
                        }

                        if (array.length > 0) {
                            filter = array;
                            url = url + "&filter=" + JSON.stringify(array);
                        } else {
                            url = url + "&filter=null";
                        }
                    } else {
                        url = url + "&filter=null";
                    }
                }

                if (view.config.infoparam != null) {
                    infoparam = view.config.infoparam;
                    url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                } else {
                    url = url + "&infoparam=null";
                }
                var tlbParams = $$("tlbParams");

                var checkValue = true;
                var parameters = [];
                if (tlbParams !== undefined) {
                    var childViews = tlbParams.getChildViews();


                    for (var i = 0; i < childViews.length; i++) {
                        var child = childViews[i];

                        var id = child.config.id;
                        var value_field = child.config.value_field;

                        if ($$(id).getValue() == "") {
                            checkValue = false;
                            break;
                        }

                        var item = {
                            columnName: value_field,
                            value: $$(id).getValue(),
                        };
                        parameters.push(item);
                    }
                } 
                url = url + "&tlbparam=null";

                var item = {
                    window_id: windowno,
                    start: start,
                    count: count,
                    filter: filter,
                    infoparam: infoparam,
                    tlbparam: [],
                };
                if(parameters != null && parameters.length > 0) {
                    parameters.forEach(function(c) {
                        item[c.columnName] = c.value;
                    });
                } 

                var url1 = null;
                if (checkValue == true) {
                    url1 = app.config.host + "/System/GetDataByWindowNo";
                }
                webix.ajax().headers({ "Content-type": "application/json" }).bind(view).post(url1, item, callback, view);
                //}
                //else {
                //    $('.webix_overlay').hide()
                //}
                // webix.ajax().headers({ 'Content-type': 'application/json' })
                //     .bind(view)
                //     .post(url, item, function (text) {
                //         var json = JSON.parse(text);

                //         this.clearAll();

                //         if (!json.hasOwnProperty("error")) {
                //             this.bind(json);
                //             // this.refresh();
                //             // table.parse(json.data, "json");
                //         }
                //     });

                //    webix.ajax(url, callback, view);
            },
        };

        table.define("url", url);

        if (vc_window.wb_infowindow_id != null) {
            if (vc_window.wb_infowindow_id != "") {
                $$("btnSearch").show();
                table.config.infowindow_id = vc_window.wb_infowindow_id;
            } else {
                $$("btnSearch").hide();
                table.config.infowindow_id = null;
            }
        } else {
            $$("btnSearch").hide();
            table.config.infowindow_id = null;
        }

        webix.$$("windowData").getParentView().getParentView().getParentView().enable();
        webix.$$("windowData").getParentView().getParentView().getParentView().hideProgress();
    };

    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            "Thêm",
            { $template: "Separator" },
            "Sửa",
            { $template: "Separator" },
            "Xóa",
            { $template: "Separator" },
            "Xem hóa đơn gốc",
            { $template: "Separator" },
            "Gửi hóa đơn qua email",
            { $template: "Separator" },
            "In hóa đơn",
            { $template: "Separator" },
            "Lịch sử gửi Email",
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xem hóa đơn gốc") {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    //console.log(item);
                    if (item.original_invoice_id != null && item.original_invoice_id != undefined) {
                        var box = webix.modalbox({
                            title: "Đang in chứng từ",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        //var newWin = window.open();

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.original_invoice_id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    alert(text);
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);

                                    webix.modalbox.hide(box);
                                    //newWin.location = fileURL;
                                    window.open(fileURL, "_blank");
                                },
                            });

                        // webix.ajax()
                        // .response("arraybuffer")
                        // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                        //     var file = new Blob([data], { type: 'application/pdf' });
                        //     var fileURL = URL.createObjectURL(file);
                        //     window.open(fileURL, '_blank');
                        //     // webix.html.download(file, $$('tenfile').getValue());
                        // });
                    } else {
                        webix.message("Không tồn tại hóa đơn gốc !", "error");
                        return;
                    }
                }
                if (this.getItem(id).value == "Lịch sử gửi Email") {
                    var table = webix.$$("windowData");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    var detailForm = webix.$$("windowData").$scope.ui(his_email.$ui);
                    his_email.initUI(selectedItem.inv_invoiceauth_id);
                    detailForm.show();
                }
                if (this.getItem(id).value == "Gửi hóa đơn qua email") {
                    var table = webix.$$("windowData");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }

                    if (selectedItem.status == "Chờ ký" || selectedItem.status == "Chờ duyệt") {
                        webix.message("Hóa đơn chưa được ký", "error");
                        return;
                    }

                    var url = "/Invoice/GetEmailTemplate?type=Gửi hóa đơn&id=" + selectedItem.inv_invoiceauth_id;

                    webix.ajax(app.config.host + url, function (text) {
                        var json = JSON.parse(text);

                        var win = webix.$$("windowData").$scope.ui(sendemail.$ui);

                        var item = {
                            nguoi_gui: json.sender,
                            tieude: json.subject,
                            noidung: json.body,
                            mat_khau: json.pass,
                            inv_invoiceauth_id: selectedItem.inv_invoiceauth_id,
                            type: "Gửi hóa đơn",
                            nguoinhan: selectedItem.buyer_email,
                            his_email: json.his_email,
                        };
                        //console.log(sendemail);

                        sendemail.setValues(item);
                        win.show();
                    });
                }
                if (this.getItem(id).value == "In hóa đơn") {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dữ liệu cần in", "error");
                        return;
                    }

                    var cbMauIn = $$("cbMauIn");
                    var cbTypeIn = $$("cbTypeIn");

                    var rpParameter = {
                        parameter: item,
                        wb_mauin_id: cbMauIn.getValue(),
                        type: cbTypeIn.getValue(),
                    };

                    var mimetype = cbTypeIn.getValue() == "PDF" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

                    var url = app.config.host + "/System/InChungTu";

                    var box = webix.modalbox({
                        title: "Đang in chứng từ",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .post(url, rpParameter, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                alert(text);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: mimetype });
                                var fileURL = URL.createObjectURL(file);

                                webix.modalbox.hide(box);

                                // var win = $$("windowData").$scope.ui(printf.$ui);
                                // win.config.url = fileURL;
                                // win.show();

                                newWin.location = fileURL;
                            },
                        });
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            // view: "button",
            // type: "icon",
            // icon: "far fa-refresh",
            // label: _("REFRESH"),
            // width: 95,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("windowData");
                    table.clearAll();

                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            // view: "button",
            // type: "icon",
            // icon: "far fa-plus",
            // label: "Thêm (F4)",
            // css: "webix_secondary",
            // width: 90,
            shortcut: "F4",
            css: "btnThem",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.code;

                    var detailForm = this.$scope.ui(windowform.$ui);

                    windowform.setEditMode(0);
                    windowform.initUI(windowconfig);

                    var params = null;

                    var tlbParams = $$("tlbParams");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];

                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item[value_field] = $$(id).getValue();
                        }

                        params = item;
                    }

                    windowform.setValues(null, windowconfig, params);
                    windowform.setEditMode(1);

                    detailForm.show();
                    windowform.focusFirstElement();

                    if (vc_window.after_new != null) {
                        var fn = Function("app", vc_window.after_new);
                        fn(app);
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            // view: "button",
            // type: "icon",
            // icon: "far fa-edit",
            // label: "Sửa (F3)",
            // width: 90,
            shortcut: "F3",
            // css: "webix_secondary",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    // console.log(vc_window);
                    windowform.$ui.id = vc_window.code;
                    var detailForm = this.$scope.ui(windowform.$ui);

                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }
                    // không cho sửa hóa đơn điều chỉnh, thay thế đang fix cứng

                    if (vc_window.code == "WIN00187" || vc_window.code == "WIN00189" || vc_window.code == "WIN00192" || vc_window.code == "WIN00193") {
                        if (item.trang_thai_hd == 7 || item.trang_thai_hd == 13 || item.trang_thai_hd == 15 || item.trang_thai_hd == 17) {
                            webix.message("Không thể sửa hóa đơn xóa bỏ. Bạn cần phải sử dụng chức năng tương ứng", "error");
                            return;
                        }
                        if (item.trang_thai == "Đã ký") {
                            webix.message("Hóa đơn đã ký, bạn không thể sửa !", "error");
                            return;
                        }
                    }

                    if (item == null) {
                        webix.message({ type: "error", text: "Bạn chưa chọn dòng cần sửa" });
                        return;
                    }

                    windowform.setEditMode(0);
                    windowform.initUI(windowconfig);

                    if (item.dadung == true) {
                        item.dadung = 1;
                    }
                    windowform.setValues(item, windowconfig);

                    windowform.setEditMode(2);

                    detailForm.show();
                    windowform.focusFirstElement();

                    if (vc_window.after_edit != null) {
                        var fn = Function("app", "_", vc_window.after_edit);
                        fn(app, _);
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-trash",
            // label: "Xóa (F8)",
            // width: 80,
            shortcut: "F8",
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("windowData");

                    if (table.getColumnConfig("colMultiChoice") == undefined) {
                        var item = table.getSelectedItem();
                        if (item == null || item == undefined) {
                            webix.message("Bạn chưa chọn dòng cần xóa !", "error");
                            return;
                        }

                        var khData = {};
                        khData.windowid = windowconfig.data[0].code;
                        khData.editmode = 3;
                        khData.data = [];
                        khData.data.push(item);

                        webix.confirm({
                            text: "Bạn có muốn xóa ",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (res) {
                                if (res) {
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/System/Save", khData, function (text) {
                                            var response = JSON.parse(text);

                                            if (response.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: response.error });
                                                return;
                                            }

                                            table.remove(item.id);
                                            var btnRefresh = $$("btnRefresh");
                                            console.log(btnRefresh);
                                            btnRefresh.callEvent("onClick");
                                        });
                                }
                            },
                        });
                    } else {
                        webix.confirm({
                            text: "Bạn có muốn xóa ",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (res) {
                                if (res) {
                                    deleteMultiChoice();
                                }
                            },
                        });
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + "</span>",
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "far fa-files-o",
            // label: _("COPY"),
            // width: 85,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu");
                        return;
                    }

                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.code;

                    var detailForm = this.$scope.ui(windowform.$ui);

                    const cloneItem = JSON.parse(JSON.stringify(item));

                    windowform.setEditMode(0);
                    windowform.initUI(windowconfig);
                    // windowform.setEditMode(4);
                    windowform.copyValues(cloneItem, windowconfig);
                    windowform.setEditMode(1);
                    detailForm.show();
                    windowform.focusFirstElement();

                    if (vc_window.after_new != null) {
                        var fn = Function("app", vc_window.after_new);
                        fn(app);
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 110,
            label: '<i class="fa fa-search fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SEARCH") + " (F2)" + "</span>",
            id: "btnSearch",
            // view: "button",
            // type: "icon",
            // icon: "far fa-search",
            // label: _("SEARCH") + " (F2)",
            // width: 110,
            // css: "webix_secondary",
            shortcut: "F2",
            on: {
                onClick: function () {
                    var table = webix.$$("windowData");

                    infowindow.$ui.id = table.config.infowindow_id;
                    infowindow.$ui.load_event = "filterTable";

                    var wininfoparam = this.$scope.ui(infowindow.$ui);

                    if (table.config.infoparam != undefined) {
                        wininfoparam.config.editmode = 1;
                        wininfoparam.config.formvalues = table.config.infoparam.parameter;
                    } else {
                        wininfoparam.config.editmode = 0;
                        wininfoparam.config.formvalues = null;
                    }

                    infowindow.initUI(table.config.infowindow_id);
                    wininfoparam.show();
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + " (F7)" + "</span>",
            id: "btnPrint",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-print",
            // label: _("PRINT") + " (F7)",
            // width: 70,
            shortcut: "F7",
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dữ liệu cần in", "error");
                        return;
                    }

                    var cbMauIn = $$("cbMauIn");
                    var cbTypeIn = $$("cbTypeIn");

                    var rpParameter = {
                        parameter: item,
                        wb_mauin_id: cbMauIn.getValue(),
                        type: cbTypeIn.getValue(),
                    };

                    var mimetype = cbTypeIn.getValue() == "PDF" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

                    if (cbTypeIn.getValue() == "Rtf") {
                        mimetype = "application/octet-stream";
                    }

                    var url = app.config.host + "/System/InChungTu";

                    var box = webix.modalbox({
                        title: "Đang in chứng từ",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window;

                    if (cbTypeIn.getValue() == "PDF") {
                        newWin = window.open();
                    }

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .post(url, rpParameter, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                alert(text);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: mimetype });
                                webix.modalbox.hide(box);

                                var cbTypeIn = $$("cbTypeIn");

                                if (cbTypeIn.getValue() == "Excel" || cbTypeIn.getValue() == "Rtf") {
                                    var suffix = cbTypeIn.getValue() == "Excel" ? ".xlsx" : ".rtf";

                                    var id = $$("cbMauIn").getValue();
                                    var mauin = $$("cbMauIn").getList().getItem(id);
                                    var export_name = mauin.export_name;

                                    var table = webix.$$("windowData");
                                    var item = table.getSelectedItem();

                                    for (var key in item) {
                                        export_name = export_name.replace(new RegExp("#" + key + "#", "g"), item[key]);
                                    }

                                    export_name = export_name.replace(new RegExp("/", "g"), "");

                                    webix.html.download(file, export_name + suffix);
                                    return;
                                }

                                var fileURL = URL.createObjectURL(file);

                                newWin.location = fileURL;
                            },
                        });
                },

                // onClick: function () {
                //     var table = webix.$$("windowData");
                //     var item = table.getSelectedItem();

                //     if (item == null) {
                //         webix.message("Bạn chưa chọn dữ liệu cần in", "error");
                //         return;
                //     }

                //     var cbMauIn = $$("cbMauIn");
                //     var cbTypeIn = $$("cbTypeIn");

                //     var rpParameter = {
                //         parameter: item,
                //         wb_mauin_id: cbMauIn.getValue(),
                //         type: cbTypeIn.getValue()
                //     };

                //     var mimetype = cbTypeIn.getValue() == "PDF" ? "application/pdf" : (cbTypeIn.getValue() == "Excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/richtext");

                //     var url = app.config.host + "/System/InChungTu";

                //     var box = webix.modalbox({
                //         title: "Đang in chứng từ",
                //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                //         width: 350,
                //         height: 200
                //     });

                //     var newWin = window.open();

                //     webix.ajax()
                //         .response("arraybuffer")
                //         .headers({ 'Content-type': 'application/json' })
                //         .post(url, rpParameter, {
                //             error: function (text, data, XmlHttpRequest) {
                //                 webix.modalbox.hide(box);
                //                 alert(text);
                //             },
                //             success: function (text, data, XmlHttpRequest) {
                //                 var file = new Blob([data], { type: mimetype });

                //                 if (cbTypeIn.getValue() == "Rtf") {
                //                     webix.html.download(file, "invoice.rtf");
                //                     webix.modalbox.hide(box);
                //                     return;
                //                 }
                //                 var fileURL = URL.createObjectURL(file);

                //                 webix.modalbox.hide(box);

                //                 // var win = $$("windowData").$scope.ui(printf.$ui);
                //                 // win.config.url = fileURL;
                //                 // win.show();

                //                 newWin.location = fileURL;

                //             }
                //         });

                // }
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {},
        {
            view: "richselect",
            label: _("MAUIN"),
            width: 250,
            labelWidth: 50,
            id: "cbMauIn",
        },
        {
            view: "richselect",
            //label: _("MAUIN"),
            width: 80,
            labelWidth: 50,
            css: "cbTypePrint",
            id: "cbTypeIn",
            value: "PDF",
            options: [
                { id: "PDF", value: "PDF" },
                // { "id": "Excel", "value": "EXCEL" },
                { id: "Rtf", value: "Rtf" },
            ],
        }
    ];

    var grid = {
        rows: [
            {
                id: "windowData",
                view: "datatable",
                select: true,
                datafetch: 50,
                resizeColumn: true,
                columns: col,
                tooltip: true,
                leftSplit: 0,
                rightSplit: 0,
                headermenu: {
                    //width: 200,
                    autoheight: false,
                    scroll: true,
                    autowidth: true,
                },
                multiview: { keepViews: true },
                keepViews: true,
                //css:"webix_header_border webix_data_border",
                hover: "myhover",
                // tooltip: function (obj, common) {
                //     //obj - row object
                //     console.log(obj);
                //     console.log(common);
                //     //common.column - configuration of related column
                //     //return "<span class='webix_strong'>Rating: </span> " + obj[common.column.id] + "<br/><span class='webix_strong'>Votes: </span>" + obj[(common.column.id + 1)];
                //     return "<span>" + obj + "</span>";
                // },
                on: {
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var windowno = app.path[1].params[0];

                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + windowno + "&id=" + item.id;

                            var detailTables = subView.getChildViews()[1].getChildViews();

                            for (var i = 0; i < detailTables.length; i++) {
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table=" + dt.config.tab_table);
                            }
                        }
                    },
                    onSubViewOpen: function (id) {
                        var table = this;
                        var subView = table.getSubView(id);

                        if (subView != null) {
                            var windowno = app.path[1].params[0];

                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + windowno + "&id=" + id.row;

                            var detailTables = subView.getChildViews()[1].getChildViews();

                            for (var i = 0; i < detailTables.length; i++) {
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table=" + dt.config.tab_table);
                            }
                        }
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                        var windowno = app.path[1].params[0];
                        if (windowno != "WIN00187" && windowno != "WIN00189" && windowno != "WIN00193" && windowno != "WIN00192" && windowno != "WIN00194") {
                            $$("cmenu").refresh();
                            $$("cmenu").sizeToContent();
                            $$("cmenu").hideItem("Xem hóa đơn gốc");
                            $$("cmenu").hideItem("Gửi hóa đơn qua email");
                            $$("cmenu").hideItem("In hóa đơn");
                            $$("cmenu").attachTo($$("windowData"));
                        } else {
                            $$("cmenu").refresh();
                            $$("cmenu").showItem("Xem hóa đơn gốc");
                            $$("cmenu").showItem("Gửi hóa đơn qua email");
                            $$("cmenu").showItem("In hóa đơn");
                            $$("cmenu").attachTo($$("windowData"));
                        }
                    },
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 200,
                    scrollX: true,
                    tabbar: {
                        width: 200,
                    },
                    cells: [],
                },
                pager: "pagerA",
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        template: function (data, common) {
                            var size = 0;
                            var start = data.page * data.size;
                            var end = start + data.size;
                            if (end > data.count) size = data.count - start;
                            else size = data.size;
                            var end = start + data.size;
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Số bản ghi:" + size + "/" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {},
                    {
                        view: "button",
                        type: "icon",
                        icon: "fas fa-th-list",
                        width: 35,
                        on: {
                            onClick: function () {
                                changeMultiChoice();
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                ],
            },
        ],
    };

    var layout = {
        rows: [
            {
                rows: [
                    {
                        id: "tlbMain",
                        height: 39,
                        type: "toolbar",
                        css: { "background-color": "#f5f5f5 !important" },
                        cols: controls,
                        borderless: true,
                    },
                ],
            },
            {
                rows: [grid],
            },
        ],
    };

    function changeMultiChoice() {
        var table = $$("windowData");
        var columns = webix.toArray(table.config.columns);

        if (table.getColumnConfig("colMultiChoice") == undefined) {
            columns.insertAt(
                {
                    id: "colMultiChoice",
                    header: [{ text: "", content: "masterCheckbox" }],
                    width: 50,
                    checkValue: "C",
                    uncheckValue: "K",
                    template: "{common.checkbox()}",
                },
                0
            );
        } else {
            columns.removeAt(0);
        }

        table.refreshColumns();
    }

    function deleteMultiChoice() {
        var table = $$("windowData");
        var array = [];

        table.eachRow(function (row) {
            var record = table.getItem(row);

            if (record != undefined && record != null) {
                if (record.hasOwnProperty("colMultiChoice")) {
                    if (record.colMultiChoice == "C") {
                        array.push(record.id);
                    }
                }
            }
        }, true);

        if (array.length == 0) {
            webix.message({ type: "error", text: "Không có bản ghi nào được chọn" });
            return;
        }

        var khData = {};
        khData.windowid = windowconfig.data[0].code;
        khData.editmode = 3;
        khData.data = array;

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(app.config.host + "/System/DeleteMultiChoice", khData, function (text) {
                var response = JSON.parse(text);

                if (response.hasOwnProperty("error")) {
                    webix.message({ type: "error", text: response.error });
                    return;
                }

                $$("btnRefresh").callEvent("onClick");
            });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("windowData");

                if (mode == 1) {
                    // table.add(item);
                    table.clearAll();
                    table.load(table.config.url);
                }

                if (mode == 2) {
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);
                    table.clearAll();
                    table.load(table.config.url);
                    webix.UIManager.setFocus($$(table.config.id));
                }
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var table = $$("windowData");

                /* if (item.hasOwnProperty("p_MA_CT")){
                    item["p_MA_CT"] = table.config.ma_ct;
                } */

                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/window',["app", "views/forms/window", "views/forms/infowindow", "locale", "models/user", "views/forms/printf", "views/forms/sendemail", "views/forms/lichsuemail", "views/commonHD"], function (
    app,
    windowform,
    infowindow,
    _,
    user,
    printf,
    sendemail,
    his_email,
    commonHD
) {
    

    var layoutId = "";
    var col = [];
    var sub_col = [];
    var windowconfig = null;
    var buttons = [];
    //var windowno = "":

    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [],
        on: {
            onItemClick: function (id, e, node) {
                var item = this.getItem(id);

                this.hide();

                var fn = Function("_", "user", item.on_click);
                fn(_, user);
            },
        },
    });

    var initUI = function () {
        var windowno = app.path[1].params[0];

        col = [];
        sub_col = [];
        var query = {
            command: "SYS002",
            parameter: {
                windowno: windowno,
            },
        };
        //var query = "SELECT * FROM #SCHEMA_NAME#.wb_menu WHERE window_code='" + windowno + "' LIMIT 1 OFFSET 0";
        // var url = app.config.host + "/System/Query";
        var url = app.config.host + "/System/ExecuteCommand";

        webix
            .ajax()
            .headers({ "Content-Type": "application/json" })
            .post(url, query, function (text) {
                var json = JSON.parse(text);

                if (json.length > 0) {
                    if (webix.$$("title") != undefined) {
                        webix.$$("title").parse({ title: json[0]["name"], details: json[0]["details"] });
                    }
                }
            });

        url = app.config.host + "/System/ExecuteCommand";

        $$("tlbMain").removeView("btnChucNang");

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00004",
                    parameter: {
                        window_id: windowno,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);

                    if (json.length > 0) {
                        $$("cbMauIn").define("options", json);
                        $$("cbMauIn").setValue(json[0].id);
                        $$("cbMauIn").show();
                        $$("cbTypeIn").show();
                        $$("btnPrint").show();
                    } else {
                        $$("cbMauIn").define("options", []);
                        $$("cbMauIn").hide();
                        $$("cbTypeIn").hide();
                        $$("btnPrint").hide();
                    }

                    $$("cbMauIn").refresh();
                }
            );

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00002",
                    parameter: {
                        window_id: windowno,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);

                    if (buttons.length > 0) {
                        for (var i = 0; i < buttons.length; i++) {
                            var item = buttons[i];
                            $$("tlbMain").removeView(item.id);
                        }
                    }

                    buttons = [];
                    var menus = [];

                    var stt = 7;

                    for (var i = 0; i < json.length; i++) {
                        var item = json[i];

                        if (item.is_group_function == "C") {
                            if (item.hidden != 1) {
                                menus.push({
                                    id: item.name,
                                    value: _(item.caption),
                                    on_click: item.on_click,
                                });
                            }
                        } else {
                            if (item.hidden != 1) {
                                var fn = new Function(item.on_click);

                                var button = {
                                    view: "button",
                                    type: "htmlbutton",
                                    width: item.width,
                                    label: '<i class="fa fa-' + item.icon + ' fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _(item.caption) + "</span>",
                                    id: item.name,
                                    // label: _(item.caption),
                                    // view: "button",
                                    // type: "icon",
                                    // css: "webix_secondary",
                                    // icon: "fas fa-" + item.icon,
                                    // width: item.width,
                                    click: fn,
                                };

                                buttons.push(button);
                                $$("tlbMain").addView(button, stt);

                                stt = stt + 1;
                            }
                        }
                    }

                    if (menus.length > 0) {
                        subChucNang.clearAll();
                        subChucNang.parse(menus, "json");

                        var index = $$("tlbMain").index($$("cbMauIn"));

                        var btnChucNang = {
                            view: "button",
                            type: "htmlbutton",
                            width: 120,
                            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("CHUC_NANG") + "</span>",
                            id: "btnChucNang",
                            // label: _("CHUC_NANG"),
                            // view: "button",
                            // type: "icon",
                            // css: "webix_secondary",
                            // icon: "fas fa-tasks",
                            // width: 100,
                            click: function () {
                                subChucNang.show(webix.$$("btnChucNang").$view);
                            },
                        };

                        $$("tlbMain").addView(btnChucNang, index - 1);
                    }
                }
            );

        // lấy thông tin của window
        url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;

        webix.$$("windowData").getParentView().getParentView().getParentView().disable();
        webix.$$("windowData").getParentView().getParentView().getParentView().showProgress();

        var app_cache = webix.storage.local.get("APP_CACHE");
        // console.log(app_cache);
        //nếu có trong cache
        if (app_cache[windowno] != null) {
            windowconfig = app_cache[windowno];
            initComponents(windowconfig);
        } //không có cache
        else {
            webix.ajax(url, function (text, xml, xhr) {
                var rp = JSON.parse(text);
                windowconfig = rp;

                var app_cache = webix.storage.local.get("APP_CACHE");
                app_cache[windowno] = windowconfig;

                webix.storage.local.put("APP_CACHE", app_cache);
                initComponents(windowconfig);
            });
        }
    };

    var initComponents = function (_windowconfig) {
        //console.log(_windowconfig);
        var k = Object.keys(_windowconfig["data"][0]["Tabs"]).length;
        //console.log(k);
        var vc_window = _windowconfig["data"][0];

        var tabs = vc_window.Tabs;

        var windowno = vc_window.window_id;
        
        if (vc_window.code == "WIN00103" || vc_window.code == "WIN00077") {
            col.push({
            id: "chon",
            header: [{ text: "", content: "masterCheckbox" }],
            width: 50,
            checkValue: true,
            uncheckValue: false,
            template: "{common.checkbox()}",
        });
        }
        

        if (vc_window.window_type == "MasterDetail") {
            col.push({
                id: "subRow",
                header: "&nbsp;",
                template: "{common.subrow()}",
                css: "nampvsub",
                width: 40,
            });
        }

        var masterTab = tabs[0];
        //console.log(masterTab);

        if (masterTab.insert_cmd == "" || masterTab.insert_cmd == null) {
            $$("btnPlus").hide();
            $$("btnCopy").hide();
        } else {
            $$("btnPlus").show();
            $$("btnCopy").show();
        }

        if (masterTab.update_cmd == "" || masterTab.update_cmd == null) {
            $$("btnEdit").hide();
        } else {
            $$("btnEdit").show();
        }

        if (masterTab.delete_cmd == "" || masterTab.delete_cmd == null) {
            $$("btnDelete").hide();
        } else {
            $$("btnDelete").show();
        }

        for (var j = 0; j < masterTab.Fields.length; j++) {
            var field = masterTab.Fields[j];

            if (field.hide_in_grid == true) {
                continue;
            }

            var item = {
                id: field.column_name,
                header: _(field.column_name),
                columnType: field.column_type,
                columnAlias: field.column_alias,
                template: field.template,
                columnFormat: field.format,
            };

            if (field.caption != null) {
                item.header = _(field.caption);
            }

            if (field.column_type == "numeric") {
                item.css = { "text-align": "right" };
                item.format = webix.Number.numToStr({
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: field.data_decimal,
                });
            }

            if (field.type_filter != null) {
                if (field.type_filter != "") {
                    item.header = [_(item.header), { content: field.type_filter }];
                }
            }

            if (field.type_editor == "combo") {
                item.editor = field.type_editor;
                item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
            }

            if (field.type_editor == "gridcombo") {
                item.editor = field.type_editor;
                item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
            }


            if (field.column_type == "date" || field.column_type == "datetime") {
                item.format = function (text) {
                    var format = webix.Date.dateToStr(this.columnFormat);
                    text = removeTimeZoneT(text);
                    return format(text);
                };
            }

            if (field.column_type == "time") {
                item.format = function (text) {
                    var format = webix.Date.dateToStr("%H:%i");
                    text = removeTimeZoneT(text);
                    return format(text);
                }
            }

            if (field.type_editor == "checkbox") {
                if (field.column_type == "boolean") {
                    item.checkValue = true;
                    item.uncheckValue = false;
                }

                item.template = function (obj, common, value) {
                    if (value == true || value == 1) return "<div class='webix_icon fa-check-square-o'></div>";
                    else return "<div class='webix_icon fa-square-o'></div>";
                };
            }

            if (field.column_width == null) {
                item.fillspace = true;
            } else {
                item.width = field.column_width;
            }

            col.push(item);
        }

        var table = $$("windowData");
        table.clearAll();

        if (vc_window.window_type == "MasterDetail") {
            var cells = [];

            for (var i = 0; i < tabs.length; i++) {
                var tab = tabs[i];

                if (tab.tab_type == "Master") {
                    continue;
                }

                var subCols = [];

                for (var j = 0; j < tab.Fields.length; j++) {
                    var field = tab.Fields[j];

                    if (field.hide_in_grid == true) {
                        continue;
                    }

                    var subCol = {
                        id: field.column_name,
                        header: field.caption == null ? _(field.column_name) : _(field.caption),
                        hidden: field.hide_in_grid,
                    };

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        subCol.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.column_type == "numeric") {
                        subCol.css = { "text-align": "right" };
                        subCol.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: field.data_decimal,
                        });
                    }

                    if (field.column_width == null) {
                        subCol.fillspace = true;
                    } else {
                        subCol.width = field.column_width;
                    }

                    subCols.push(subCol);
                }

                if (tab.tab_type == "Detail") {
                    var item = {
                        header: tab.name,
                        select: "cell",
                        body: {
                            view: "datatable",
                            tab_table: tab.table_name,
                            columns: subCols,
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(_("LOADING") + "...");
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay();
                                },
                            },
                        },
                    };
                    cells.push(item);
                }
            }

            var subview = {
                borderless: true,
                view: "tabview",
                height: 200,
                scrollX: true,
                cells: cells,
                multiview: {
                    fitBiggest: true,
                },
            };

            table.define("subview", subview);
        }

        table.define("windowno", windowno);
        table.define("leftSplit", vc_window.fix_left == null ? 0 : vc_window.fix_left);
        table.define("rightSplit", vc_window.fix_right == null ? 0 : vc_window.fix_right);

        table.config.infoparam = null;
        table.config.columns = col;
        table.config.ma_ct = vc_window.ma_ct;

        table.refreshColumns();

        var parentToolBar = $$("tlbMain").getParentView();

        parentToolBar.removeView("tlbParams");
        $$("head-title").show();
        $$("head-title").removeView("tlbParams");
        // toolBar windown parram
        if (vc_window.WinParams != undefined && vc_window.WinParams != null) {
            var toolBarParams = {
                id: "tlbParams",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [],
            };

            for (var i = 0; i < vc_window.WinParams.length; i++) {
                var item = vc_window.WinParams[i];

                var comp = {
                    id: webix.uid(),
                    view: item.type_editor,
                    width: item.width,
                    label: _(item.caption),
                    value_field: item.value_field,
                    isDefault: item.has_default,
                    on: {},
                };

                if (comp.view == "combo") {
                    comp.options = {
                        body: {
                            comboId: comp.id,
                            isDefault: item.has_default,
                            url: app.config.host + "/System/GetDataByReferencesId?id=" + item.wb_references_id,
                            ready: function () {
                                if (this.config.isDefault == "C") {
                                    var count = this.count();
                                    if (count > 0) {
                                        var combo = webix.$$(this.config.comboId);
                                        combo.setValue(this.getFirstId());
                                    }
                                }
                            },
                        },
                    };

                    comp.on.onChange = function (newv, oldv) {
                        var table = $$("windowData");
                        table.clearAll();
                        table.load(table.config.url);
                    };
                }

                if (comp.view == "treesuggest") {
                    var listColumns = JSON.parse(item.list_column);

                    for (var v = 0; v < listColumns.length; v++) {
                        listColumns[v].header = _(listColumns[v].id);
                    }

                    comp.view = "combo";

                    comp.options = {
                        view: "treesuggest",
                        textValue: item.display_field,
                        isDefault: item.has_default,
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

                                webix.ajax(url, function (text) {
                                    var json = JSON.parse(text);
                                    var data = listToTree(json);
                                    view.parse(data, "json");
                                });
                            },
                        },
                        body: {
                            isDefault: item.has_default,
                            comboId: comp.id,
                            columns: listColumns,
                            refid: item.wb_references_id,
                            filterMode: {
                                level: false,
                                showSubItems: false,
                            },
                            ready: function () {
                                if (this.config.isDefault == "C") {
                                    var count = this.count();

                                    if (count > 0) {
                                        var combo = webix.$$(this.config.comboId);
                                        combo.setValue(this.getFirstId());
                                    }
                                }
                            },
                        },
                    };

                    comp.on.onChange = function (newv, oldv) {
                        var table = $$("windowData");
                        table.clearAll();
                        table.load(table.config.url);
                    };
                }

                toolBarParams.cols.push(comp);
            }
            $$("head-title").addView(toolBarParams, 1);
            // parentToolBar.addView(toolBarParams);
        }

        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var windowno = app.path[1].params[0];
                var url = app.config.host + "/System/GetDataByWindowNo";
                var start = null;
                var count = null;
                var filter = [];
                var infoparam = null;
                var tlbparam_s = [];

                if (params == null) {
                    url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                    start = 0;
                    count = view.config.datafetch;
                } else {
                    url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                    start = params.start;
                    count = params.count;
                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);

                            if (column !== undefined) {
                                var item = {
                                    columnName: property,
                                    columnType: column.columnType,
                                    columnAlias: column.columnAlias,
                                    value: params.filter[property],
                                };
                                array.push(item);
                            }
                        }

                        if (array.length > 0) {
                            filter = array;
                            url = url + "&filter=" + JSON.stringify(array);
                        } else {
                            url = url + "&filter=null";
                        }
                    } else {
                        url = url + "&filter=null";
                    }
                }

                if (view.config.infoparam != null) {
                    infoparam = view.config.infoparam;
                    url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                } else {
                    url = url + "&infoparam=null";
                }
                var tlbParams = $$("tlbParams");

                var checkValue = true;
                if (tlbParams !== undefined) {
                    var childViews = tlbParams.getChildViews();

                    var parameters = [];

                    for (var i = 0; i < childViews.length; i++) {
                        var child = childViews[i];

                        var id = child.config.id;
                        var value_field = child.config.value_field;

                        if ($$(id).getValue() == "") {
                            checkValue = false;
                            break;
                        }

                        var item = {
                            columnName: value_field,
                            value: $$(id).getValue(),
                        };

                        parameters.push(item);
                    }
                    tlbparam_s = parameters;
                    url = url + "&tlbparam=" + JSON.stringify(parameters);
                } else {
                    url = url + "&tlbparam=null";
                }
                //if (checkValue == false) {
                //    $('.webix_overlay').hide();
                //    webix.message("Không tồn tại ký hiệu!", "error");
                //    return false;
                //}
                var item = {
                    window_id: windowno,
                    start: start,
                    count: count,
                    filter: filter,
                    infoparam: infoparam,
                    tlbparam: tlbparam_s,
                };
                var url1 = null;
                if (checkValue == true) {
                    url1 = app.config.host + "/System/GetDataByWindowNo";
                }
                webix.ajax().headers({ "Content-type": "application/json" }).bind(view).post(url1, item, callback, view);
                //}
                //else {
                //    $('.webix_overlay').hide()
                //}
                // webix.ajax().headers({ 'Content-type': 'application/json' })
                //     .bind(view)
                //     .post(url, item, function (text) {
                //         var json = JSON.parse(text);

                //         this.clearAll();

                //         if (!json.hasOwnProperty("error")) {
                //             this.bind(json);
                //             // this.refresh();
                //             // table.parse(json.data, "json");
                //         }
                //     });

                //    webix.ajax(url, callback, view);
            },
        };

        table.define("url", url);

        if (vc_window.wb_infowindow_id != null) {
            if (vc_window.wb_infowindow_id != "") {
                $$("btnSearch").show();
                table.config.infowindow_id = vc_window.wb_infowindow_id;
            } else {
                $$("btnSearch").hide();
                table.config.infowindow_id = null;
            }
        } else {
            $$("btnSearch").hide();
            table.config.infowindow_id = null;
        }

        webix.$$("windowData").getParentView().getParentView().getParentView().enable();
        webix.$$("windowData").getParentView().getParentView().getParentView().hideProgress();
    };

    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            "Thêm",
            { $template: "Separator" },
            "Sửa",
            { $template: "Separator" },
            "Xóa",
            { $template: "Separator" },
            "Xem hóa đơn gốc",
            { $template: "Separator" },
            "Gửi hóa đơn qua email",
            { $template: "Separator" },
            "In hóa đơn",
            { $template: "Separator" },
            "Lịch sử gửi Email",
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Thêm") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xem hóa đơn gốc") {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    //console.log(item);
                    if (item.original_invoice_id != null && item.original_invoice_id != undefined) {
                        var box = webix.modalbox({
                            title: "Đang in chứng từ",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200,
                        });

                        //var newWin = window.open();

                        webix
                            .ajax()
                            .response("arraybuffer")
                            .headers({ "Content-type": "application/json" })
                            .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.original_invoice_id + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    alert(text);
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: "application/pdf" });
                                    var fileURL = URL.createObjectURL(file);

                                    webix.modalbox.hide(box);
                                    //newWin.location = fileURL;
                                    window.open(fileURL, "_blank");
                                },
                            });

                        // webix.ajax()
                        // .response("arraybuffer")
                        // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                        //     var file = new Blob([data], { type: 'application/pdf' });
                        //     var fileURL = URL.createObjectURL(file);
                        //     window.open(fileURL, '_blank');
                        //     // webix.html.download(file, $$('tenfile').getValue());
                        // });
                    } else {
                        webix.message("Không tồn tại hóa đơn gốc !", "error");
                        return;
                    }
                }
                if (this.getItem(id).value == "Lịch sử gửi Email") {
                    var table = webix.$$("windowData");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    var detailForm = webix.$$("windowData").$scope.ui(his_email.$ui);
                    his_email.initUI(selectedItem.inv_invoiceauth_id);
                    detailForm.show();
                }
                if (this.getItem(id).value == "Gửi hóa đơn qua email") {
                    var table = webix.$$("windowData");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }

                    if (selectedItem.status == "Chờ ký" || selectedItem.status == "Chờ duyệt") {
                        webix.message("Hóa đơn chưa được ký", "error");
                        return;
                    }

                    var url = "/Invoice/GetEmailTemplate?type=Gửi hóa đơn&id=" + selectedItem.inv_invoiceauth_id;

                    webix.ajax(app.config.host + url, function (text) {
                        var json = JSON.parse(text);

                        var win = webix.$$("windowData").$scope.ui(sendemail.$ui);

                        var item = {
                            nguoi_gui: json.sender,
                            tieude: json.subject,
                            noidung: json.body,
                            mat_khau: json.pass,
                            inv_invoiceauth_id: selectedItem.inv_invoiceauth_id,
                            type: "Gửi hóa đơn",
                            nguoinhan: selectedItem.buyer_email,
                            his_email: json.his_email,
                        };
                        //console.log(sendemail);

                        sendemail.setValues(item);
                        win.show();
                    });
                }
                if (this.getItem(id).value == "In hóa đơn") {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dữ liệu cần in", "error");
                        return;
                    }

                    var cbMauIn = $$("cbMauIn");
                    var cbTypeIn = $$("cbTypeIn");

                    var rpParameter = {
                        parameter: item,
                        wb_mauin_id: cbMauIn.getValue(),
                        type: cbTypeIn.getValue(),
                    };

                    var mimetype = cbTypeIn.getValue() == "PDF" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

                    var url = app.config.host + "/System/InChungTu";

                    var box = webix.modalbox({
                        title: "Đang in chứng từ",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .post(url, rpParameter, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                alert(text);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: mimetype });
                                var fileURL = URL.createObjectURL(file);

                                webix.modalbox.hide(box);

                                // var win = $$("windowData").$scope.ui(printf.$ui);
                                // win.config.url = fileURL;
                                // win.show();

                                newWin.location = fileURL;
                            },
                        });
                }
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnRefresh",
            // view: "button",
            // type: "icon",
            // icon: "far fa-refresh",
            // label: _("REFRESH"),
            // width: 95,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("windowData");
                    table.clearAll();

                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("THEM") + " (F4)" + "</span>",
            id: "btnPlus",
            // view: "button",
            // type: "icon",
            // icon: "far fa-plus",
            // label: "Thêm (F4)",
            // css: "webix_secondary",
            // width: 90,
            shortcut: "F4",
            css: "btnThem",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.code;

                    var detailForm = this.$scope.ui(windowform.$ui);

                    windowform.setEditMode(0);
                    windowform.initUI(windowconfig);

                    var params = null;

                    var tlbParams = $$("tlbParams");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];

                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item[value_field] = $$(id).getValue();
                        }

                        params = item;
                    }

                    windowform.setValues(null, windowconfig, params);
                    windowform.setEditMode(1);

                    detailForm.show();
                    windowform.focusFirstElement();

                    if (vc_window.after_new != null) {
                        var fn = Function("app", vc_window.after_new);
                        fn(app);
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SUA") + " (F3)" + "</span>",
            id: "btnEdit",
            // view: "button",
            // type: "icon",
            // icon: "far fa-edit",
            // label: "Sửa (F3)",
            // width: 90,
            shortcut: "F3",
            // css: "webix_secondary",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    // console.log(vc_window);
                    windowform.$ui.id = vc_window.code;
                    var detailForm = this.$scope.ui(windowform.$ui);

                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }
                    // không cho sửa hóa đơn điều chỉnh, thay thế đang fix cứng

                    if (vc_window.code == "WIN00187" || vc_window.code == "WIN00189" || vc_window.code == "WIN00192" || vc_window.code == "WIN00193") {
                        if (item.trang_thai_hd == 7 || item.trang_thai_hd == 13 || item.trang_thai_hd == 15 || item.trang_thai_hd == 17) {
                            webix.message("Không thể sửa hóa đơn xóa bỏ. Bạn cần phải sử dụng chức năng tương ứng", "error");
                            return;
                        }
                        if (item.trang_thai == "Đã ký") {
                            webix.message("Hóa đơn đã ký, bạn không thể sửa !", "error");
                            return;
                        }
                    }

                    if (item == null) {
                        webix.message({ type: "error", text: "Bạn chưa chọn dòng cần sửa" });
                        return;
                    }

                    windowform.setEditMode(0);
                    windowform.initUI(windowconfig);

                    if (item.dadung == true) {
                        item.dadung = 1;
                    }
                    windowform.setValues(item, windowconfig);

                    windowform.setEditMode(2);

                    detailForm.show();
                    windowform.focusFirstElement();

                    if (vc_window.after_edit != null) {
                        var fn = Function("app", "_", vc_window.after_edit);
                        fn(app, _);
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("XOA") + " (F8)" + "</span>",
            id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-trash",
            // label: "Xóa (F8)",
            // width: 80,
            shortcut: "F8",
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("windowData");

                    if (table.getColumnConfig("colMultiChoice") == undefined) {
                        var item = table.getSelectedItem();
                        if (item == null || item == undefined) {
                            webix.message("Bạn chưa chọn dòng cần xóa !", "error");
                            return;
                        }

                        var khData = {};
                        khData.windowid = windowconfig.data[0].code;
                        khData.editmode = 3;
                        khData.data = [];
                        khData.data.push(item);

                        webix.confirm({
                            text: "Bạn có muốn xóa ",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (res) {
                                if (res) {
                                    webix
                                        .ajax()
                                        .headers({ "Content-type": "application/json" })
                                        .post(app.config.host + "/System/Save", khData, function (text) {
                                            var response = JSON.parse(text);

                                            if (response.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: response.error });
                                                return;
                                            }

                                            table.remove(item.id);
                                            var btnRefresh = $$("btnRefresh");
                                            console.log(btnRefresh);
                                            btnRefresh.callEvent("onClick");
                                        });
                                }
                            },
                        });
                    } else {
                        webix.confirm({
                            text: "Bạn có muốn xóa ",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (res) {
                                if (res) {
                                    deleteMultiChoice();
                                }
                            },
                        });
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + "</span>",
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "far fa-files-o",
            // label: _("COPY"),
            // width: 85,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu");
                        return;
                    }

                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.code;

                    var detailForm = this.$scope.ui(windowform.$ui);

                    const cloneItem = JSON.parse(JSON.stringify(item));

                    windowform.setEditMode(0);
                    windowform.initUI(windowconfig);
                    // windowform.setEditMode(4);
                    windowform.copyValues(cloneItem, windowconfig);
                    windowform.setEditMode(1);
                    detailForm.show();
                    windowform.focusFirstElement();

                    if (vc_window.after_new != null) {
                        var fn = Function("app", vc_window.after_new);
                        fn(app);
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 110,
            label: '<i class="fa fa-search fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("SEARCH") + " (F2)" + "</span>",
            id: "btnSearch",
            // view: "button",
            // type: "icon",
            // icon: "far fa-search",
            // label: _("SEARCH") + " (F2)",
            // width: 110,
            // css: "webix_secondary",
            shortcut: "F2",
            on: {
                onClick: function () {
                    var table = webix.$$("windowData");

                    infowindow.$ui.id = table.config.infowindow_id;
                    infowindow.$ui.load_event = "filterTable";

                    var wininfoparam = this.$scope.ui(infowindow.$ui);

                    if (table.config.infoparam != undefined) {
                        wininfoparam.config.editmode = 1;
                        wininfoparam.config.formvalues = table.config.infoparam.parameter;
                    } else {
                        wininfoparam.config.editmode = 0;
                        wininfoparam.config.formvalues = null;
                    }

                    infowindow.initUI(table.config.infowindow_id);
                    wininfoparam.show();
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + " (F7)" + "</span>",
            id: "btnPrint",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-print",
            // label: _("PRINT") + " (F7)",
            // width: 70,
            shortcut: "F7",
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dữ liệu cần in", "error");
                        return;
                    }

                    var cbMauIn = $$("cbMauIn");
                    var cbTypeIn = $$("cbTypeIn");

                    var rpParameter = {
                        parameter: item,
                        wb_mauin_id: cbMauIn.getValue(),
                        type: cbTypeIn.getValue(),
                    };

                    var mimetype = cbTypeIn.getValue() == "PDF" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

                    if (cbTypeIn.getValue() == "Rtf") {
                        mimetype = "application/octet-stream";
                    }

                    var url = app.config.host + "/System/InChungTu";

                    var box = webix.modalbox({
                        title: "Đang in chứng từ",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window;

                    if (cbTypeIn.getValue() == "PDF") {
                        newWin = window.open();
                    }

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .post(url, rpParameter, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                alert(text);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: mimetype });
                                webix.modalbox.hide(box);

                                var cbTypeIn = $$("cbTypeIn");

                                if (cbTypeIn.getValue() == "Excel" || cbTypeIn.getValue() == "Rtf") {
                                    var suffix = cbTypeIn.getValue() == "Excel" ? ".xlsx" : ".rtf";

                                    var id = $$("cbMauIn").getValue();
                                    var mauin = $$("cbMauIn").getList().getItem(id);
                                    var export_name = mauin.export_name;

                                    var table = webix.$$("windowData");
                                    var item = table.getSelectedItem();

                                    for (var key in item) {
                                        export_name = export_name.replace(new RegExp("#" + key + "#", "g"), item[key]);
                                    }

                                    export_name = export_name.replace(new RegExp("/", "g"), "");

                                    webix.html.download(file, export_name + suffix);
                                    return;
                                }

                                var fileURL = URL.createObjectURL(file);

                                newWin.location = fileURL;
                            },
                        });
                },

                // onClick: function () {
                //     var table = webix.$$("windowData");
                //     var item = table.getSelectedItem();

                //     if (item == null) {
                //         webix.message("Bạn chưa chọn dữ liệu cần in", "error");
                //         return;
                //     }

                //     var cbMauIn = $$("cbMauIn");
                //     var cbTypeIn = $$("cbTypeIn");

                //     var rpParameter = {
                //         parameter: item,
                //         wb_mauin_id: cbMauIn.getValue(),
                //         type: cbTypeIn.getValue()
                //     };

                //     var mimetype = cbTypeIn.getValue() == "PDF" ? "application/pdf" : (cbTypeIn.getValue() == "Excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/richtext");

                //     var url = app.config.host + "/System/InChungTu";

                //     var box = webix.modalbox({
                //         title: "Đang in chứng từ",
                //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                //         width: 350,
                //         height: 200
                //     });

                //     var newWin = window.open();

                //     webix.ajax()
                //         .response("arraybuffer")
                //         .headers({ 'Content-type': 'application/json' })
                //         .post(url, rpParameter, {
                //             error: function (text, data, XmlHttpRequest) {
                //                 webix.modalbox.hide(box);
                //                 alert(text);
                //             },
                //             success: function (text, data, XmlHttpRequest) {
                //                 var file = new Blob([data], { type: mimetype });

                //                 if (cbTypeIn.getValue() == "Rtf") {
                //                     webix.html.download(file, "invoice.rtf");
                //                     webix.modalbox.hide(box);
                //                     return;
                //                 }
                //                 var fileURL = URL.createObjectURL(file);

                //                 webix.modalbox.hide(box);

                //                 // var win = $$("windowData").$scope.ui(printf.$ui);
                //                 // win.config.url = fileURL;
                //                 // win.show();

                //                 newWin.location = fileURL;

                //             }
                //         });

                // }
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHDTT32(self);
            },
        },
        {},
        {
            view: "richselect",
            label: _("MAUIN"),
            width: 250,
            labelWidth: 50,
            id: "cbMauIn",
        },
        {
            view: "richselect",
            //label: _("MAUIN"),
            width: 80,
            labelWidth: 50,
            css: "cbTypePrint",
            id: "cbTypeIn",
            value: "PDF",
            options: [
                { id: "PDF", value: "PDF" },
                // { "id": "Excel", "value": "EXCEL" },
                { id: "Rtf", value: "Rtf" },
            ],
        },
    ];

    var grid = {
        rows: [
            {
                id: "windowData",
                view: "datatable",
                select: true,
                datafetch: 50,
                resizeColumn: true,
                columns: col,
                tooltip: true,
                leftSplit: 0,
                rightSplit: 0,
                headermenu: {
                    //width: 200,
                    autoheight: false,
                    scroll: true,
                    autowidth: true,
                },
                multiview: { keepViews: true },
                keepViews: true,
                //css:"webix_header_border webix_data_border",
                hover: "myhover",
                // tooltip: function (obj, common) {
                //     //obj - row object
                //     console.log(obj);
                //     console.log(common);
                //     //common.column - configuration of related column
                //     //return "<span class='webix_strong'>Rating: </span> " + obj[common.column.id] + "<br/><span class='webix_strong'>Votes: </span>" + obj[(common.column.id + 1)];
                //     return "<span>" + obj + "</span>";
                // },
                on: {
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var windowno = app.path[1].params[0];

                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + windowno + "&id=" + item.id;

                            var detailTables = subView.getChildViews()[1].getChildViews();

                            for (var i = 0; i < detailTables.length; i++) {
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table=" + dt.config.tab_table);
                            }
                        }
                    },
                    onSubViewOpen: function (id) {
                        var table = this;
                        var subView = table.getSubView(id);

                        if (subView != null) {
                            var windowno = app.path[1].params[0];

                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + windowno + "&id=" + id.row;

                            var detailTables = subView.getChildViews()[1].getChildViews();

                            for (var i = 0; i < detailTables.length; i++) {
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table=" + dt.config.tab_table);
                            }
                        }
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                        var windowno = app.path[1].params[0];
                        if (windowno != "WIN00187" && windowno != "WIN00189" && windowno != "WIN00193" && windowno != "WIN00192" && windowno != "WIN00194") {
                            $$("cmenu").refresh();
                            $$("cmenu").sizeToContent();
                            $$("cmenu").hideItem("Xem hóa đơn gốc");
                            $$("cmenu").hideItem("Gửi hóa đơn qua email");
                            $$("cmenu").hideItem("In hóa đơn");
                            $$("cmenu").attachTo($$("windowData"));
                        } else {
                            $$("cmenu").refresh();
                            $$("cmenu").showItem("Xem hóa đơn gốc");
                            $$("cmenu").showItem("Gửi hóa đơn qua email");
                            $$("cmenu").showItem("In hóa đơn");
                            $$("cmenu").attachTo($$("windowData"));
                        }
                    },
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 200,
                    scrollX: true,
                    tabbar: {
                        width: 200,
                    },
                    cells: [],
                },
                pager: "pagerA",
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        template: function (data, common) {
                            var size = 0;
                            var start = data.page * data.size;
                            var end = start + data.size;
                            if (end > data.count) size = data.count - start;
                            else size = data.size;
                            var end = start + data.size;
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Số bản ghi:" + size + "/" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {},
                    {
                        view: "button",
                        type: "icon",
                        icon: "fas fa-th-list",
                        width: 35,
                        on: {
                            onClick: function () {
                                changeMultiChoice();
                            },
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                ],
            },
        ],
    };

    var layout = {
        rows: [
            {
                rows: [
                    {
                        id: "tlbMain",
                        height: 39,
                        type: "toolbar",
                        css: { "background-color": "#f5f5f5 !important" },
                        cols: controls,
                        borderless: true,
                    },
                ],
            },
            {
                rows: [grid],
            },
        ],
    };

    function changeMultiChoice() {
        var table = $$("windowData");
        var columns = webix.toArray(table.config.columns);

        if (table.getColumnConfig("colMultiChoice") == undefined) {
            columns.insertAt(
                {
                    id: "colMultiChoice",
                    header: [{ text: "", content: "masterCheckbox" }],
                    width: 50,
                    checkValue: "C",
                    uncheckValue: "K",
                    template: "{common.checkbox()}",
                },
                0
            );
        } else {
            columns.removeAt(0);
        }

        table.refreshColumns();
    }

    function deleteMultiChoice() {
        var table = $$("windowData");
        var array = [];

        table.eachRow(function (row) {
            var record = table.getItem(row);

            if (record != undefined && record != null) {
                if (record.hasOwnProperty("colMultiChoice")) {
                    if (record.colMultiChoice == "C") {
                        array.push(record.id);
                    }
                }
            }
        }, true);

        if (array.length == 0) {
            webix.message({ type: "error", text: "Không có bản ghi nào được chọn" });
            return;
        }

        var khData = {};
        khData.windowid = windowconfig.data[0].code;
        khData.editmode = 3;
        khData.data = array;

        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(app.config.host + "/System/DeleteMultiChoice", khData, function (text) {
                var response = JSON.parse(text);

                if (response.hasOwnProperty("error")) {
                    webix.message({ type: "error", text: response.error });
                    return;
                }

                $$("btnRefresh").callEvent("onClick");
            });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("windowData");

                if (mode == 1) {
                    // table.add(item);
                    table.clearAll();
                    table.load(table.config.url);
                }

                if (mode == 2) {
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);
                    table.clearAll();
                    table.load(table.config.url);
                    webix.UIManager.setFocus($$(table.config.id));
                }
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var table = $$("windowData");

                /* if (item.hasOwnProperty("p_MA_CT")){
                    item["p_MA_CT"] = table.config.ma_ct;
                } */

                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/windowhoadon78bienlai',[
    "app",
    "locale",
    "models/user",
    "views/forms/formhoadon78bienlai",
    "views/forms/68_huyhoadon",
    "views/forms/68_huyhoadon_1",
    "views/forms/68_hoadon_history",
    "views/forms/lichsuemail_bienlai",
    "views/commonHD",
    "views/Util",
], function (app, _, user, invoiceForms, huyhoadon, huyhoadon_1, hoadonHistory, his_email, commonHD, Util) {
    
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: 0,
        });
        return k(number);
    };
    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        on: {
            onItemClick: function (id, e, node) {
                var item = this.getItem(id);

                this.hide();

                var fn = Function("_", "user", item.on_click);
                fn(_, user);
            },
        },
    });

    var subBangKe = webix.ui({
        view: "submenu",
        width: 150,
        padding: 0,
        data: [
            {
                id: "addBangKeHoaDon",
                value: "Thêm bảng kê",
            },
            {
                id: "EditBangKeHoaDon",
                value: "Sửa bảng kê",
            },
            {
                id: "InBangKeHoaDon",
                value: "In bảng kê",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);

                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();

                if (record.id == "addBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký") {
                        webix.message("Vui lòng chọn biên lai chờ ký !", "error");
                        return;
                    }

                    if (item.checksobangke != null) {
                        webix.message("Biên lai đã có bảng kê không thể thêm !", "error");
                        return;
                    }

                    var detailForm = table.$scope.ui(invoiceForms.$ui);
                    item.shdon = null;

                    item.nlap = new Date(item.nlap);

                    // ẩn tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = true;
                    }

                    invoiceForms.setEditMode(4); // editmode = 4(add bang ke chi tiet) // edit mode =5 (sửa bảng kê chi tiết)
                    invoiceForms.initUI(windowconfig);
                    //$$("phi_tab").hide();
                    $$("head-formInvoice").define("template", "Bảng kê chi tiết hoá đơn");
                    $$("head-formInvoice").refresh();

                    webix.$$("infohdon").disable();
                    webix.$$("infokhang").disable();

                    webix.$$("shdon").config.label = "Số bảng kê";
                    //webix.$$("infohdon").disable();
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: biên lai điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValuesBangKe(item, null);
                    detailForm.show();
                    webix.$$("btnBangKeSave").show();
                    webix.$$("btnHoadonSave").destructor();
                    webix.$$("btnHoadonCQT").destructor();
                }

                if (record.id == "EditBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký") {
                        webix.message("Vui lòng chọn biên lai chờ ký !", "error");
                        return;
                    }

                    if (item.checksobangke == null) {
                        webix.message("Biên lai chưa có bảng kê!", "error");
                        return;
                    }

                    // ẩn tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = true;
                    }

                    //set số bảng kê cho form sửa bảng kê
                    item.shdon = item.checksobangke;

                    item.nlap = new Date(item.nlap);
                    var detailForm = table.$scope.ui(invoiceForms.$ui);
                    invoiceForms.setEditMode(5); // editmode = 4(add bang ke chi tiet) // edit mode =5 (sửa bảng kê chi tiết)
                    invoiceForms.initUI(windowconfig);
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: biên lai điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    $$("head-formInvoice").define("template", "Bảng kê chi tiết hoá đơn");
                    $$("head-formInvoice").refresh();
                    //set lại title số bảng kê
                    webix.$$("shdon").config.label = "Số bảng kê";

                    webix.$$("infohdon").disable();
                    webix.$$("infokhang").disable();

                    invoiceForms.setValuesBangKe(item, null);
                    detailForm.show();
                    webix.$$("btnBangKeSave").show();
                    webix.$$("btnBangKeDelete").show();
                    webix.$$("btnHoadonSave").destructor();
                    webix.$$("btnHoadonCQT").destructor();
                }

                if (record.id == "InBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.checksobangke == null) {
                        webix.message("Biên lai chưa có bảng kê!", "error");
                        return;
                    }

                    var box = webix.modalbox({
                        title: "Đang in biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Biên lai thuế thu nhập cá nhân MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false&checkBangKe=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                }
            },
        },
    });

    //webix.$$("title").parse({ title: "Lập hóa đơn -> Hóa đơn giá trị gia tăng", details: "Lập hóa đơn -> Hóa đơn giá trị gia tăng" });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Thêm (F4)") + "</span>",
            id: "btnPlus",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    var cctbao_id = $$("kyhieu_id").getValue();
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.initUINew(cctbao_id);
                    invoiceForms.setEditMode(1);
                    detailForm.show();
                    if (vc_window.after_new != null) {
                        var fn = Function("app", vc_window.after_new);
                        fn(app);
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    //var detailForm = this.$scope.ui(webix.$$("main"));
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký" && item.tthai != "Chờ duyệt" && item.tthai != "Chờ sinh số") {
                        webix.message("Biên lai đã ký, không thể sửa !", "error");
                        return;
                    }
                    // main.setEditMode(0);
                    // main.initUI(windowconfig);

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    item.nlap = new Date(item.nlap);

                    invoiceForms.initUI(windowconfig);
                    invoiceForms.setEditMode(2);
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: biên lai điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValues(item, null);

                    detailForm.show();
                    //main.focusFirstElement();
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Xóa (F8)") + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var lstDataChoose = commonHD.GetBienLaiChon();
                    var lstDataChooseSort = lstDataChoose.sort(function (a, b) {
                        return Number(a.shdon) - Number(b.shdon);
                    });
                    if (lstDataChooseSort.length === 0) return;
                    var strHoaDonSelect = " ";
                    for (var i = 0; i < lstDataChooseSort.length; i++) {
                        if (
                            commonHD.CheckKhacNull(lstDataChooseSort[i].tthai) &&
                            lstDataChooseSort[i].tthai != "Chờ ký" &&
                            lstDataChooseSort[i].tthai != "Chờ sinh số" &&
                            lstDataChooseSort[i].tthai != "Chờ duyệt"
                        ) {
                            webix.message("Không thể xóa biên lai đã ký !", "error");
                            return;
                        }
                        if (i < lstDataChooseSort.length - 1) {
                            if (
                                commonHD.CheckKhacNull(lstDataChooseSort[i].shdon) &&
                                commonHD.CheckKhacNull(lstDataChooseSort[i + 1].shdon) &&
                                Number(lstDataChooseSort[i + 1].shdon) - Number(lstDataChooseSort[i].shdon) >= 2
                            ) {
                                webix.message("Các biên lai xóa phải có số biên lai liên tiếp nhau", "error");
                                return;
                            } else {
                                strHoaDonSelect += lstDataChooseSort[i].shdon + ",";
                            }
                        } else {
                            strHoaDonSelect += lstDataChooseSort[i].shdon;
                        }
                    }
                    var url = app.config.host + "/Invoice68/hoadonXoaNhieu";
                    var data_post = { data: lstDataChooseSort };
                    webix.confirm({
                        title: "XÓA biên lai",
                        text: "Bạn có muốn xóa biên lai số: <span style='color: red'>" + strHoaDonSelect + "</span>",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(url, data_post, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            // var json = JSON.parse(text);
                                            // webix.message(json.ExceptionMessage, "error");
                                            webix.message(text + XmlHttpRequest, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var result = JSON.parse(text);

                                            if (result.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: result.error });
                                                table.enable();
                                                table.hideProgress();
                                                return;
                                            } else {
                                                table.enable();
                                                table.clearAll();
                                                table.load(table.config.url);
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + "</span>",
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "far fa-files-o",
            // label: _("COPY"),
            // width: 85,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }
                    // var vc_window = windowconfig["data"][0];
                    // windowform.$ui.id = vc_window.code;

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    item.shdon = null;
                    invoiceForms.setEditMode(1);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.copyValues(item);
                    detailForm.show();
                    if (vc_window.after_new != null) {
                        var fn = Function(vc_window.after_new);
                        fn();
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        /*{
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Bảng kê") + "</span>",
            id: "btnBangKeOption",
            click: function () {
                subBangKe.show(webix.$$("btnBangKeOption").$view);
            },
        },*/
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>biên lai thuế thu nhập cá nhân MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("In chuyển đổi") + "</span>",
            id: "btnPrintCD",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn biên lai cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>biên lai thuế thu nhập cá nhân MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {},
        {},
        {},
        {},
    ];
    webix.ui({
        view: "contextmenu",
        id: "cmenu78",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [ "Lịch sử gửi Email"],
        on: {
            onItemClick: function (id) {
                var self = this;
                setTimeout(function () {
                    var kyHieuHoaDon = {
                        cctbao_id: $$("kyhieu_id").getValue(),
                        khieu: $$("kyhieu_id").data.text,
                    };

                    if (self.getItem(id).value == "Thay thế") {
                        commonHD.ExcuteReplaceInvoice(kyHieuHoaDon);
                    }
                    if (self.getItem(id).value == "Điều chỉnh tăng") {
                        commonHD.ExcuteIncreaseChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Điều chỉnh giảm") {
                        commonHD.ExcuteReduceChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Điều chỉnh thông tin") {
                        commonHD.ExcuteInfoChangeInvoice(kyHieuHoaDon);
                    }
                    if (self.getItem(id).value == "Hủy") {
                        commonHD.ExcuteHUyInvoicebienlai();
                    }
                    if (self.getItem(id).value == "Lập biên bản xóa bỏ") {
                        commonHD.ExcuteCancellingInvoicebienlai();
                    }

                    if (self.getItem(id).value == "Lịch sử gửi Email") {
                        var table = webix.$$("invoiceViews");
                        var selectedItem = table.getSelectedItem();
                        if (selectedItem == null) {
                            webix.message("Bạn chưa chọn biên lai", "error");
                            return;
                        }
                        var detailForm = webix.$$("invoiceViews").$scope.ui(his_email.$ui);
                        his_email.initUI(selectedItem.id);
                        detailForm.show();
                    }
                }, 100);
            },
        },
    });

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                scrollX: true,
                //autowidth: true,
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        var table = webix.$$("invoiceViews");
                        var item = table.getSelectedItem();
                        item.chon = !item.chon;
                        table.updateItem(id.row, item);
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                        this.hideOverlay();
                        $$("cmenu78").refresh();
                        $$("cmenu78").sizeToContent();
                        $$("cmenu78").attachTo($$("invoiceViews"));
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                },
                columns: col,
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv * 1 != $$("pagerA").config.size) {
                                    webix.message("change page size to " + newv);
                                    $$("pagerA").config.size = newv * 1;
                                    var table = $$("invoiceViews");
                                    table.define("datafetch", newv);
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var mini_dashboard = {
        type: "clean",
        borderless: true,
        cols: [
            {
                id: "khongMa",
                name: "khongMa",
                view: "label",
            },
            {
                id: "khongMaError",
                name: "khongMaError",
                css: "",
                view: "label",
            },
            {
                id: "doanhthunocode",
                name: "doanhthunocode",
                view: "label",
            },
        ],
    };

    var layout = {
        id: "main",
        css: "frmView",
        rows: [
            {
                id: "tlbMain",
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    var col = [];
    var sub_col = [];
    var windowconfig = null;
    var kihieuRefId = null;

    var initComponents = function (_windowconfig) {
        //console.log(_windowconfig);
        var k = Object.keys(_windowconfig["data"][0]["Tabs"]).length;
        //console.log(k);
        var vc_window = _windowconfig["data"][0];
        webix.$$("title").parse({ title: vc_window["name"], details: "Lập biên lai ->" + vc_window["name"], width: 1000 });
        var tabs = vc_window.Tabs;

        var windowno = vc_window.window_id;
        kihieuRefId = "RF00054";
        col = [];
        sub_col = [];
        col.push({
            id: "chon",
            header: [{ text: "", content: "masterCheckbox" }],
            width: 30,
            checkValue: true,
            uncheckValue: false,
            template: "{common.checkbox()}",
        });
        col.push({
            id: "subRowMain",
            header: "&nbsp;",
            template: "{common.subrow()}",
            width: 40,
            // height: 25
        });
        for (var i = 0; i < tabs.length; i++) {
            var tab = tabs[i];
            if (tab.tab_type === "Master") {
                var masterTab = tabs[i];
                for (var j = 0; j < tabs[i].Fields.length; j++) {
                    var field = masterTab.Fields[j];
                    if (field.hide_in_grid == true) {
                        continue;
                    }

                    var item = {
                        id: field.column_name,
                        header: _(field.column_name),
                        columnType: field.column_type,
                        columnAlias: field.column_alias,
                        template: field.template,
                        columnFormat: field.format,
                        //adjust: true,
                    };
                    if (item.template !== undefined && item.template !== null && item.template.includes("function")) item.template = Util.StringToFunc(item.template);
                    //if(item.format!== undefined && item.format!== null && item.format.includes("function")) item.template = Util.StringToFunc(item.format);
                    if (field.caption != null) {
                        item.header = _(field.caption).replace(/(\[)([0-9]{2})(])/, "");
                    }
                    if (field.column_type == "character varying") {
                        item.columnType = "nvarchar";
                    }
                    if (field.column_type == "numeric") {
                        item.css = { "text-align": "right" };
                        item.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: field.data_decimal,
                        });
                    }

                    if (field.type_filter != null) {
                        if (field.type_filter != "") {
                            item.header = [_(item.header), { content: field.type_filter }];
                        }
                    }
                    if (field.type_filter == "serverMultiSelectFilter") {
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.value_filter;
                    }
                    if (field.type_filter == "serverSelectFilter") {
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.value_filter;
                    }
                    if (field.type_editor == "combo") {
                        item.editor = field.type_editor;
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                    }

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr(this.columnFormat);
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.type_editor == "checkbox") {
                        if (field.column_type == "boolean") {
                            item.checkValue = true;
                            item.uncheckValue = false;
                        }

                        item.template = function (obj, common, value) {
                            if (value == true || value == 1) return "<div class='webix_icon fa-check-square-o'></div>";
                            else return "<div class='webix_icon fa-square-o'></div>";
                        };
                    }

                    if (field.column_width == null) {
                        //item.fillspace = true;
                    } else {
                        item.width = field.column_width;
                    }

                    col.push(item);
                }
            }
            if (tab.tab_type == "Detail") {
                for (var j = 0; j < tab.Fields.length; j++) {
                    var field = tab.Fields[j];

                    if (field.hide_in_grid == true) {
                        continue;
                    }

                    var subCol = {
                        id: field.column_name,
                        header: field.caption == null ? _(field.column_name) : _(field.caption),
                        hidden: field.hide_in_grid,
                    };

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        subCol.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.column_type == "numeric") {
                        subCol.css = { "text-align": "right" };
                        subCol.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: field.data_decimal,
                        });
                    }

                    if (field.column_width == null) {
                        subCol.fillspace = true;
                    } else {
                        subCol.width = field.column_width;
                    }

                    sub_col.push(subCol);
                }
            }
        }
        var table = webix.$$("invoiceViews");
        table.clearAll();
        var subview = {
            borderless: true,
            view: "tabview",
            height: 255,
            css: "subInvoice",
            scrollX: true,
            // tabbar: {
            //     width: 200
            // },
            multiview: {
                fitBiggest: true,
            },
            cells: [
                {
                    header: "Chi tiết biên lai",
                    select: "cell",
                    body: {
                        view: "datatable",
                        resizeColumn: true,
                        margin: 10,
                        id: "hoadon68_chitiet_view",
                        height: 200,
                        columns: sub_col,
                        on: {
                            onBeforeLoad: function () {
                                this.showOverlay(_("LOADING") + "...");
                            },
                            onAfterLoad: function () {
                                this.hideOverlay();
                            },
                        },
                    },
                },
            ],
        };
        /*var subview = {
            borderless: true,
            view: "tabview",
            height: 200,
            scrollX: true,
            cells: sub_col,
            multiview: {
                fitBiggest: true,
            },
        };*/
        table.define("subview", subview);
        $$("head-title").show();
        $$("head-title").removeView("paramKH");
        $$("head-title").addView(
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [],
            },
            1
        );
        if (vc_window.WinParams != undefined && vc_window.WinParams != null) {
            for (var i = 0; i < vc_window.WinParams.length; i++) {
                var item = vc_window.WinParams[i];
                var comp = {
                    id: item.value_field,
                    view: item.type_editor,
                    width: item.width,
                    label: _(item.caption),
                    value_field: item.value_field,
                    isDefault: item.has_default,
                    on: {},
                };

                if (comp.view == "combo") {
                    comp.options = {
                        body: {
                            comboId: comp.id,
                            isDefault: item.has_default,
                            url: app.config.host + "/System/GetDataByReferencesId?id=" + item.wb_references_id,
                            ready: function () {
                                if (this.config.isDefault == "C") {
                                    var count = this.count();
                                    if (count > 0) {
                                        var combo = webix.$$(this.config.comboId);
                                        combo.setValue(this.getFirstId());
                                    }
                                }
                            },
                        },
                    };

                    comp.on.onChange = function (newv, oldv) {
                        var table = $$("invoiceViews");
                        table.clearAll();
                        table.load(table.config.url);
                    };
                }
                $$("paramKH").removeView(item.value_field);
                $$("paramKH").addView(comp);
            }

            // parentToolBar.addView(toolBarParams);
        }

        table.config.columns = col;
        table.refreshColumns();
        table.define("url", loadUrl);
        table.getParentView().getParentView().getParentView().enable();
        table.getParentView().getParentView().getParentView().hideProgress();
    };

    var loadUrl = {
        $proxy: true,
        load: function (view, callback, params) {
            var tlbparam_s = [];
            //get count list combo ký hiệu
            var url = app.config.host + "/Invoice68/GetDataInvoice";

            if (params == null) {
                commonHD.clear_filter(view);
                var table = $$("invoiceViews");
                table.config.params = null;
                url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            } else {
                var table = $$("invoiceViews");
                table.define("params", params);
                webix.storage.local.put("currentFilter", params.filter);
                url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                if (params.filter != null) {
                    var array = [];

                    for (var property in params.filter) {
                        var column = view.getColumnConfig(property);

                        var item = {
                            columnName: property,
                            columnType: column.columnType,
                            value: params.filter[property],
                            filterType: column.header[1].content,
                        };
                        if (params.filter[property] != null && params.filter[property] != "") {
                            array.push(item);
                        }
                    }

                    //console.log(JSON.stringify(array));
                    url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                }
                url = url + "&filter=null";
            }
            var tlbParams = $$("paramKH");

            if (tlbParams !== undefined) {
                var childViews = tlbParams.getChildViews();

                var parameters = [];

                for (var i = 0; i < childViews.length; i++) {
                    var child = childViews[i];
                    // console.log(child);
                    var id = child.config.id;
                    //var value_field = child.config.value_field;
                    var item = {
                        columnName: "cctbao_id",
                        value: $$(id).getValue(),
                    };
                    if (item.value !== "") {
                        parameters.push(item);
                    } else {
                        return;
                    }
                    //parameters.push(item);
                }
                tlbparam_s = parameters;
                url = url + "&tlbparam=" + JSON.stringify(parameters);
            } else {
                url = url + "&tlbparam=null";
            }
            var urlMiniDashBoard = url.replace("GetDataInvoice", "GetDataInvoiceThongTin");

            var urlMiniDashBoard = url.replace("GetDataInvoice", "GetDataInvoiceThongTin");

            /*webix.ajax().get(urlMiniDashBoard, function (text) {
                var json = JSON.parse(text);
                $$("khongMa").setValue("<span style=' font-weight:bold'>Số hóa đơn đã gửi CQT: </span>" + json["khongma"]);
                $$("khongMaError").setValue("<span style=' font-weight:bold'>Số hóa đơn CQT thông báo lỗi: </span>" + json["khongmaerror"]);
                $$("doanhthunocode").setValue("<span style=' font-weight:bold'>Doanh thu xuất hóa đơn: </span>" + (fm(json["doanhthunocode"]) ? fm(json["doanhthunocode"]) : 0));
            });*/

            webix.ajax(url, callback, view);
        },
    };
    var buttons = [];
    var initUI = function () {
        var windowno = app.path[1].params[0];
        var url = app.config.host + "/System/ExecuteCommand";
        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00002",
                    parameter: {
                        window_id: windowno,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);

                    if (buttons.length > 0) {
                        for (var i = 0; i < buttons.length; i++) {
                            var item = buttons[i];
                            $$("tlbMain").removeView(item.id);
                        }
                    }

                    buttons = [];
                    var menus = [];

                    var stt = controls.filter(function (x) {
                        return x.id !== undefined;
                    }).length;

                    for (var i = 0; i < json.length; i++) {
                        var item = json[i];

                        if (item.is_group_function == "C") {
                            if (item.hidden != 1) {
                                menus.push({
                                    id: item.name,
                                    value: _(item.caption),
                                    on_click: item.on_click,
                                });
                            }
                        } else {
                            if (item.hidden != 1) {
                                var fn = new Function(item.on_click);

                                var button = {
                                    view: "button",
                                    type: "htmlbutton",
                                    width: item.width,
                                    label: '<i class="fa fa-' + item.icon + ' fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _(item.caption) + "</span>",
                                    id: item.name,
                                    // label: _(item.caption),
                                    // view: "button",
                                    // type: "icon",
                                    // css: "webix_secondary",
                                    // icon: "fas fa-" + item.icon,
                                    // width: item.width,
                                    click: fn,
                                };

                                buttons.push(button);
                                $$("tlbMain").addView(button, stt);

                                stt = stt + 1;
                            }
                        }
                    }
                    $$("tlbMain").removeView("btnChucNang");
                    if (menus.length > 0) {
                        subChucNang.clearAll();
                        subChucNang.parse(menus, "json");
                        var btnChucNang = {
                            view: "button",
                            type: "htmlbutton",
                            width: 120,
                            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("CHUC_NANG") + "</span>",
                            id: "btnChucNang",
                            // label: _("CHUC_NANG"),
                            // view: "button",
                            // type: "icon",
                            // css: "webix_secondary",
                            // icon: "fas fa-tasks",
                            // width: 100,
                            click: function () {
                                subChucNang.show(webix.$$("btnChucNang").$view);
                            },
                        };
                        $$("tlbMain").addView(btnChucNang, stt);
                    }
                }
            );
        col = [];
        sub_col = [];

        var url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;
        webix.$$("invoiceViews").getParentView().getParentView().getParentView().disable();
        webix.$$("invoiceViews").getParentView().getParentView().getParentView().showProgress();

        var app_cache = webix.storage.local.get("APP_CACHE");

        if (app_cache[windowno] != null) {
            windowconfig = app_cache[windowno];
            initComponents(windowconfig);
        } //không có cache
        else {
            webix.ajax(url, function (text, xml, xhr) {
                var rp = JSON.parse(text);
                windowconfig = rp;

                var app_cache = webix.storage.local.get("APP_CACHE");
                app_cache[windowno] = windowconfig;

                webix.storage.local.put("APP_CACHE", app_cache);
                initComponents(windowconfig);
            });
        }
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                table.clearAll();
                table.load(table.config.url);
                //if (editmode == 1) {
                //    table.clearAll();
                //    table.load(table.config.url);
                //}

                //if (editmode == 2) {
                //    table.clearAll();
                //    table.load(table.config.url);
                //}
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
        $onDestruct: function (ui, name, url, scope) {
            $$("tlbParams").Clear();
        },
    };
});

define('views/windowhoadon78tncn',[
    "app",
    "locale",
    "models/user",
    "views/forms/formhoadon78tncn",
    "views/forms/68_hoadon_history",
    "views/forms/lichsuemailtncn",
    "views/commonHD",
    "views/Util",
    "views/forms/68_tncn_history_lienquan",
], function (app, _, user, invoiceForms, hoadonHistory, his_email, commonHD, Util, tncnlq) {
    
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: 0,
        });
        return k(number);
    };
    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        on: {
            onItemClick: function (id, e, node) {
                var item = this.getItem(id);

                this.hide();

                var fn = Function("_", "user", item.on_click);
                fn(_, user);
            },
        },
    });

    var subBangKe = webix.ui({
        view: "submenu",
        width: 150,
        padding: 0,
        data: [
            {
                id: "addBangKeHoaDon",
                value: "Thêm bảng kê",
            },
            {
                id: "EditBangKeHoaDon",
                value: "Sửa bảng kê",
            },
            {
                id: "InBangKeHoaDon",
                value: "In bảng kê",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);

                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();

                if (record.id == "addBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký") {
                        webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                        return;
                    }

                    if (item.checksobangke != null) {
                        webix.message("Hoá đơn đã có bảng kê không thể thêm !", "error");
                        return;
                    }

                    var detailForm = table.$scope.ui(invoiceForms.$ui);
                    item.shdon = null;

                    item.nlap = new Date(item.nlap);

                    // ẩn tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = true;
                    }

                    invoiceForms.setEditMode(4); // editmode = 4(add bang ke chi tiet) // edit mode =5 (sửa bảng kê chi tiết)
                    invoiceForms.initUI(windowconfig);
                    //$$("phi_tab").hide();
                    $$("head-formInvoice").define("template", "Bảng kê chi tiết hoá đơn");
                    $$("head-formInvoice").refresh();

                    webix.$$("infohdon").disable();
                    webix.$$("infokhang").disable();

                    webix.$$("shdon").config.label = "Số bảng kê";
                    //webix.$$("infohdon").disable();
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Chứng từ điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValuesBangKe(item, null);
                    detailForm.show();
                    webix.$$("btnBangKeSave").show();
                    webix.$$("btnHoadonSave").destructor();
                    webix.$$("btnHoadonCQT").destructor();
                }

                if (record.id == "EditBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký") {
                        webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                        return;
                    }

                    if (item.checksobangke == null) {
                        webix.message("Hoá đơn chưa có bảng kê!", "error");
                        return;
                    }

                    // ẩn tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = true;
                    }

                    //set số bảng kê cho form sửa bảng kê
                    item.shdon = item.checksobangke;

                    item.nlap = new Date(item.nlap);
                    var detailForm = table.$scope.ui(invoiceForms.$ui);
                    invoiceForms.setEditMode(5); // editmode = 4(add bang ke chi tiet) // edit mode =5 (sửa bảng kê chi tiết)
                    invoiceForms.initUI(windowconfig);
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Chứng từ điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    $$("head-formInvoice").define("template", "Bảng kê chi tiết hoá đơn");
                    $$("head-formInvoice").refresh();
                    //set lại title số bảng kê
                    webix.$$("shdon").config.label = "Số bảng kê";

                    webix.$$("infohdon").disable();
                    webix.$$("infokhang").disable();

                    invoiceForms.setValuesBangKe(item, null);
                    detailForm.show();
                    webix.$$("btnBangKeSave").show();
                    webix.$$("btnBangKeDelete").show();
                    webix.$$("btnHoadonSave").destructor();
                    webix.$$("btnHoadonCQT").destructor();
                }

                if (record.id == "InBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.checksobangke == null) {
                        webix.message("Hoá đơn chưa có bảng kê!", "error");
                        return;
                    }

                    var box = webix.modalbox({
                        title: "Đang in chừng từ ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Chứng từ thuế thu nhập cá nhân MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false&checkBangKe=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                }
            },
        },
    });

    //webix.$$("title").parse({ title: "Lập hóa đơn -> Hóa đơn giá trị gia tăng", details: "Lập hóa đơn -> Hóa đơn giá trị gia tăng" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu78",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: ["Lịch sử gửi Email"],
        on: {
            onItemClick: function (id) {
                var self = this;
                setTimeout(function () {
                    var kyHieuHoaDon = {
                        cctbao_id: $$("kyhieu_id").getValue(),
                        khieu: $$("kyhieu_id").data.text,
                    };

                    if (self.getItem(id).value == "Thay thế") {
                        commonHD.ExcuteReplaceInvoice(kyHieuHoaDon);
                    }
                    if (self.getItem(id).value == "Điều chỉnh tăng") {
                        commonHD.ExcuteIncreaseChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Điều chỉnh giảm") {
                        commonHD.ExcuteReduceChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Điều chỉnh thông tin") {
                        commonHD.ExcuteInfoChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Hủy") {
                        commonHD.ExcuteCancellingInvoicetncn();
                    }

                    if (self.getItem(id).value == "Lịch sử gửi Email") {
                        var table = webix.$$("invoiceViews");
                        var selectedItem = table.getSelectedItem();
                        if (selectedItem == null) {
                            webix.message("Bạn chưa chọn chứng từ", "error");
                            return;
                        }
                        var detailForm = webix.$$("invoiceViews").$scope.ui(his_email.$ui);
                        his_email.initUI(selectedItem.id);
                        detailForm.show();
                    }
                }, 100);
            },
        },
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Thêm (F4)") + "</span>",
            id: "btnPlus",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    var cctbao_id = $$("kyhieu_id").getValue();
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.initUINew(cctbao_id);
                    invoiceForms.setEditMode(1);
                    detailForm.show();
                    if (vc_window.after_new != null) {
                        var fn = Function("app", vc_window.after_new);
                        fn(app);
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    //var detailForm = this.$scope.ui(webix.$$("main"));
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký" && item.tthai != "Chờ duyệt" && item.tthai != "Chờ sinh số") {
                        webix.message("Chứng từ đã ký hoặc đã gửi lên cơ quan thuế, không thể sửa !", "error");
                        return;
                    }
                    // main.setEditMode(0);
                    // main.initUI(windowconfig);

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    item.nlap = new Date(item.nlap);

                    invoiceForms.initUI(windowconfig);
                    invoiceForms.setEditMode(2);
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Chứng từ điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValues(item, null);

                    detailForm.show();
                    //main.focusFirstElement();
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Xóa (F8)") + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var lstDataChoose = commonHD.GetHoaDonChon();
                    var lstDataChooseSort = lstDataChoose.sort(function (a, b) {
                        return Number(a.shdon) - Number(b.shdon);
                    });
                    if (lstDataChooseSort.length === 0) return;
                    var strHoaDonSelect = " ";
                    for (var i = 0; i < lstDataChooseSort.length; i++) {
                        if (
                            commonHD.CheckKhacNull(lstDataChooseSort[i].tthai) &&
                            lstDataChooseSort[i].tthai != "Chờ ký" &&
                            lstDataChooseSort[i].tthai != "Chờ sinh số" &&
                            lstDataChooseSort[i].tthai != "Chờ duyệt"
                        ) {
                            webix.message("Không thể xóa chứng từ đã ký,đã gửi !", "error");
                            return;
                        }
                        if (i < lstDataChooseSort.length - 1) {
                            if (
                                commonHD.CheckKhacNull(lstDataChooseSort[i].shdon) &&
                                commonHD.CheckKhacNull(lstDataChooseSort[i + 1].shdon) &&
                                Number(lstDataChooseSort[i + 1].shdon) - Number(lstDataChooseSort[i].shdon) >= 2
                            ) {
                                webix.message("Các chứng từ xóa phải có số chứng từ liên tiếp nhau", "error");
                                return;
                            } else {
                                strHoaDonSelect += lstDataChooseSort[i].shdon + ",";
                            }
                        } else {
                            strHoaDonSelect += lstDataChooseSort[i].shdon;
                        }
                    }
                    var url = app.config.host + "/Invoice68/hoadonXoaNhieu";
                    var data_post = { data: lstDataChooseSort };
                    webix.confirm({
                        title: "XÓA CHỨNG TỪ",
                        text: "Bạn có muốn xóa chứng từ số: <span style='color: red'>" + strHoaDonSelect + "</span>",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(url, data_post, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            // var json = JSON.parse(text);
                                            // webix.message(json.ExceptionMessage, "error");
                                            webix.message(text + XmlHttpRequest, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var result = JSON.parse(text);

                                            if (result.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: result.error });
                                                table.enable();
                                                table.hideProgress();
                                                return;
                                            } else {
                                                table.enable();
                                                table.clearAll();
                                                table.load(table.config.url);
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + "</span>",
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "far fa-files-o",
            // label: _("COPY"),
            // width: 85,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }
                    // var vc_window = windowconfig["data"][0];
                    // windowform.$ui.id = vc_window.code;

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    item.shdon = null;
                    invoiceForms.setEditMode(1);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.copyValues(item);
                    detailForm.show();
                    if (vc_window.after_new != null) {
                        var fn = Function(vc_window.after_new);
                        fn();
                    }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        /*{
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Bảng kê") + "</span>",
            id: "btnBangKeOption",
            click: function () {
                subBangKe.show(webix.$$("btnBangKeOption").$view);
            },
        },*/
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in chứng từ ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Chứng từ thuế thu nhập cá nhân MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {},
        {},
        {},
        {},
        {},
    ];
    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                scrollX: true,
                //autowidth: true,
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                    ShowHistory2: function (event, cell, target) {
                        debugger;
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(tncnlq.$ui);
                        var hdon_id = cell.row;
                        tncnlq.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        var table = webix.$$("invoiceViews");
                        var item = table.getSelectedItem();
                        item.chon = !item.chon;
                        table.updateItem(id.row, item);
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                        this.hideOverlay();
                        $$("cmenu78").refresh();
                        $$("cmenu78").sizeToContent();
                        $$("cmenu78").attachTo($$("invoiceViews"));
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    /*onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },*/
                },
                columns: col,
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv * 1 != $$("pagerA").config.size) {
                                    webix.message("change page size to " + newv);
                                    $$("pagerA").config.size = newv * 1;
                                    var table = $$("invoiceViews");
                                    table.define("datafetch", newv);
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var mini_dashboard = {
        type: "clean",
        borderless: true,
        cols: [
            {
                id: "khongMa",
                name: "khongMa",
                view: "label",
            },
            {
                id: "khongMaError",
                name: "khongMaError",
                css: "",
                view: "label",
            },
            {
                id: "doanhthunocode",
                name: "doanhthunocode",
                view: "label",
            },
        ],
    };

    var layout = {
        id: "main",
        css: "frmView",
        rows: [
            {
                id: "tlbMain",
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    var col = [];
    var sub_col = [];
    var windowconfig = null;
    var kihieuRefId = null;

    var initComponents = function (_windowconfig) {
        //console.log(_windowconfig);
        var k = Object.keys(_windowconfig["data"][0]["Tabs"]).length;
        //console.log(k);
        var vc_window = _windowconfig["data"][0];
        webix.$$("title").parse({ title: vc_window["name"], details: "Lập Chứng từ ->" + vc_window["name"], width: 1000 });
        var tabs = vc_window.Tabs;

        var windowno = vc_window.window_id;
        kihieuRefId = "RF00054";
        col = [];
        sub_col = [];
        col.push({
            id: "chon",
            header: [{ text: "", content: "masterCheckbox" }],
            width: 30,
            checkValue: true,
            uncheckValue: false,
            template: "{common.checkbox()}",
        });
        col.push({
            id: "subRowMain",
            header: "&nbsp;",
            template: "{common.subrow()}",
            width: 40,
            // height: 25
        });
        for (var i = 0; i < tabs.length; i++) {
            var tab = tabs[i];
            if (tab.tab_type === "Master") {
                var masterTab = tabs[i];
                for (var j = 0; j < tabs[i].Fields.length; j++) {
                    var field = masterTab.Fields[j];
                    if (field.hide_in_grid == true) {
                        continue;
                    }

                    var item = {
                        id: field.column_name,
                        header: _(field.column_name),
                        columnType: field.column_type,
                        columnAlias: field.column_alias,
                        template: field.template,
                        columnFormat: field.format,
                        //adjust: true,
                    };
                    if (item.template !== undefined && item.template !== null && item.template.includes("function")) item.template = Util.StringToFunc(item.template);
                    //if(item.format!== undefined && item.format!== null && item.format.includes("function")) item.template = Util.StringToFunc(item.format);
                    if (field.caption != null) {
                        item.header = _(field.caption).replace(/(\[)([0-9]{2})(])/, "");
                    }
                    if (field.column_type == "character varying") {
                        item.columnType = "nvarchar";
                    }
                    if (field.column_type == "numeric") {
                        item.css = { "text-align": "right" };
                        item.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: field.data_decimal,
                        });
                    }
                    if (field.type_filter == "serverMultiSelectFilter") {
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.value_filter;
                    }
                    if (field.type_filter == "serverSelectFilter") {
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.value_filter;
                    }
                    if (field.type_filter != null) {
                        if (field.type_filter != "") {
                            item.header = [_(item.header), { content: field.type_filter }];
                        }
                    }

                    if (field.type_editor == "combo") {
                        item.editor = field.type_editor;
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                    }

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr(this.columnFormat);
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.type_editor == "checkbox") {
                        if (field.column_type == "boolean") {
                            item.checkValue = true;
                            item.uncheckValue = false;
                        }

                        item.template = function (obj, common, value) {
                            if (value == true || value == 1) return "<div class='webix_icon fa-check-square-o'></div>";
                            else return "<div class='webix_icon fa-square-o'></div>";
                        };
                    }

                    if (field.column_width == null) {
                        //item.fillspace = true;
                    } else {
                        item.width = field.column_width;
                    }

                    col.push(item);
                }
            }
            if (tab.tab_type == "Detail") {
                for (var j = 0; j < tab.Fields.length; j++) {
                    var field = tab.Fields[j];

                    if (field.hide_in_grid == true) {
                        continue;
                    }

                    var subCol = {
                        id: field.column_name,
                        header: field.caption == null ? _(field.column_name) : _(field.caption),
                        hidden: field.hide_in_grid,
                    };

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        subCol.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.column_type == "numeric") {
                        subCol.css = { "text-align": "right" };
                        subCol.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: field.data_decimal,
                        });
                    }

                    if (field.column_width == null) {
                        subCol.fillspace = true;
                    } else {
                        subCol.width = field.column_width;
                    }

                    sub_col.push(subCol);
                }
            }
        }
        var table = webix.$$("invoiceViews");
        table.clearAll();
        var subview = {
            borderless: true,
            view: "tabview",
            height: 255,
            css: "subInvoice",
            scrollX: true,
            // tabbar: {
            //     width: 200
            // },
            multiview: {
                fitBiggest: true,
            },
            cells: [
                {
                    header: "Chi tiết chứng từ",
                    select: "cell",
                    body: {
                        view: "datatable",
                        resizeColumn: true,
                        margin: 10,
                        id: "hoadon68_chitiet_view",
                        height: 200,
                        columns: sub_col,
                        on: {
                            onBeforeLoad: function () {
                                this.showOverlay(_("LOADING") + "...");
                            },
                            onAfterLoad: function () {
                                this.hideOverlay();
                            },
                        },
                    },
                },
            ],
        };
        /*var subview = {
            borderless: true,
            view: "tabview",
            height: 200,
            scrollX: true,
            cells: sub_col,
            multiview: {
                fitBiggest: true,
            },
        };*/
        table.define("subview", subview);
        $$("head-title").show();
        $$("head-title").removeView("paramKH");
        $$("head-title").addView(
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [],
            },
            1
        );
        if (vc_window.WinParams != undefined && vc_window.WinParams != null) {
            for (var i = 0; i < vc_window.WinParams.length; i++) {
                var item = vc_window.WinParams[i];
                var comp = {
                    id: item.value_field,
                    view: item.type_editor,
                    width: item.width,
                    label: _(item.caption),
                    value_field: item.value_field,
                    isDefault: item.has_default,
                    on: {},
                };

                if (comp.view == "combo") {
                    comp.options = {
                        body: {
                            comboId: comp.id,
                            isDefault: item.has_default,
                            url: app.config.host + "/System/GetDataByReferencesId?id=" + item.wb_references_id,
                            ready: function () {
                                if (this.config.isDefault == "C") {
                                    var count = this.count();
                                    if (count > 0) {
                                        var combo = webix.$$(this.config.comboId);
                                        combo.setValue(this.getFirstId());
                                    }
                                }
                            },
                        },
                    };

                    comp.on.onChange = function (newv, oldv) {
                        var table = $$("invoiceViews");
                        table.clearAll();
                        table.load(table.config.url);
                    };
                }
                $$("paramKH").removeView(item.value_field);
                $$("paramKH").addView(comp);
            }

            // parentToolBar.addView(toolBarParams);
        }

        table.config.columns = col;
        table.refreshColumns();
        table.define("url", loadUrl);
        table.getParentView().getParentView().getParentView().enable();
        table.getParentView().getParentView().getParentView().hideProgress();
    };

    var loadUrl = {
        $proxy: true,
        load: function (view, callback, params) {
            var tlbparam_s = [];
            //get count list combo ký hiệu
            var url = app.config.host + "/Invoice68/GetDataInvoice";

            if (params == null) {
                commonHD.clear_filter(view);
                var table = $$("invoiceViews");
                table.config.params = null;
                url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            } else {
                var table = $$("invoiceViews");
                table.define("params", params);
                webix.storage.local.put("currentFilter", params.filter);
                url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                if (params.filter != null) {
                    var array = [];

                    for (var property in params.filter) {
                        var column = view.getColumnConfig(property);

                        var item = {
                            columnName: property,
                            columnType: column.columnType,
                            value: params.filter[property],
                            filterType: column.header[1].content,
                        };
                        if (params.filter[property] != null && params.filter[property] != "") {
                            array.push(item);
                        }
                    }

                    //console.log(JSON.stringify(array));
                    url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                }
                url = url + "&filter=null";
            }
            var tlbParams = $$("paramKH");

            if (tlbParams !== undefined) {
                var childViews = tlbParams.getChildViews();

                var parameters = [];

                for (var i = 0; i < childViews.length; i++) {
                    var child = childViews[i];
                    // console.log(child);
                    var id = child.config.id;
                    //var value_field = child.config.value_field;
                    var item = {
                        columnName: "cctbao_id",
                        value: $$(id).getValue(),
                    };
                    if (item.value !== "") {
                        parameters.push(item);
                    } else {
                        return;
                    }
                    //parameters.push(item);
                }
                tlbparam_s = parameters;
                url = url + "&tlbparam=" + JSON.stringify(parameters);
            } else {
                url = url + "&tlbparam=null";
            }
            var urlMiniDashBoard = url.replace("GetDataInvoice", "GetDataInvoiceThongTin");

            var urlMiniDashBoard = url.replace("GetDataInvoice", "GetDataInvoiceThongTin");

            /*webix.ajax().get(urlMiniDashBoard, function (text) {
                var json = JSON.parse(text);
                $$("khongMa").setValue("<span style=' font-weight:bold'>Số hóa đơn đã gửi CQT: </span>" + json["khongma"]);
                $$("khongMaError").setValue("<span style=' font-weight:bold'>Số hóa đơn CQT thông báo lỗi: </span>" + json["khongmaerror"]);
                $$("doanhthunocode").setValue("<span style=' font-weight:bold'>Doanh thu xuất hóa đơn: </span>" + (fm(json["doanhthunocode"]) ? fm(json["doanhthunocode"]) : 0));
            });*/

            webix.ajax(url, callback, view);
        },
    };
    var buttons = [];
    var initUI = function () {
        var windowno = app.path[1].params[0];
        var url = app.config.host + "/System/ExecuteCommand";
        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00002",
                    parameter: {
                        window_id: windowno,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);

                    if (buttons.length > 0) {
                        for (var i = 0; i < buttons.length; i++) {
                            var item = buttons[i];
                            $$("tlbMain").removeView(item.id);
                        }
                    }

                    buttons = [];
                    var menus = [];

                    var stt = controls.filter(function (x) {
                        return x.id !== undefined;
                    }).length;

                    for (var i = 0; i < json.length; i++) {
                        var item = json[i];

                        if (item.is_group_function == "C") {
                            if (item.hidden != 1) {
                                menus.push({
                                    id: item.name,
                                    value: _(item.caption),
                                    on_click: item.on_click,
                                });
                            }
                        } else {
                            if (item.hidden != 1) {
                                var fn = new Function(item.on_click);

                                var button = {
                                    view: "button",
                                    type: "htmlbutton",
                                    width: item.width,
                                    label: '<i class="fa fa-' + item.icon + ' fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _(item.caption) + "</span>",
                                    id: item.name,
                                    // label: _(item.caption),
                                    // view: "button",
                                    // type: "icon",
                                    // css: "webix_secondary",
                                    // icon: "fas fa-" + item.icon,
                                    // width: item.width,
                                    click: fn,
                                };

                                buttons.push(button);
                                $$("tlbMain").addView(button, stt);

                                stt = stt + 1;
                            }
                        }
                    }
                    $$("tlbMain").removeView("btnChucNang");
                    if (menus.length > 0) {
                        subChucNang.clearAll();
                        subChucNang.parse(menus, "json");
                        var btnChucNang = {
                            view: "button",
                            type: "htmlbutton",
                            width: 120,
                            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("CHUC_NANG") + "</span>",
                            id: "btnChucNang",
                            // label: _("CHUC_NANG"),
                            // view: "button",
                            // type: "icon",
                            // css: "webix_secondary",
                            // icon: "fas fa-tasks",
                            // width: 100,
                            click: function () {
                                subChucNang.show(webix.$$("btnChucNang").$view);
                            },
                        };
                        $$("tlbMain").addView(btnChucNang, stt);
                    }
                }
            );
        col = [];
        sub_col = [];

        var url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;
        webix.$$("invoiceViews").getParentView().getParentView().getParentView().disable();
        webix.$$("invoiceViews").getParentView().getParentView().getParentView().showProgress();

        var app_cache = webix.storage.local.get("APP_CACHE");

        if (app_cache[windowno] != null) {
            windowconfig = app_cache[windowno];
            initComponents(windowconfig);
        } //không có cache
        else {
            webix.ajax(url, function (text, xml, xhr) {
                var rp = JSON.parse(text);
                windowconfig = rp;

                var app_cache = webix.storage.local.get("APP_CACHE");
                app_cache[windowno] = windowconfig;

                webix.storage.local.put("APP_CACHE", app_cache);
                initComponents(windowconfig);
            });
        }
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                table.clearAll();
                table.load(table.config.url);
                //if (editmode == 1) {
                //    table.clearAll();
                //    table.load(table.config.url);
                //}

                //if (editmode == 2) {
                //    table.clearAll();
                //    table.load(table.config.url);
                //}
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
        $onDestruct: function (ui, name, url, scope) {
            $$("tlbParams").Clear();
        },
    };
});

define('views/windowhoadoncode78_mtt',[
    "app",
    "locale",
    "models/user",
    "views/forms/formhoadoncode78_mtt",
    "views/forms/68_huyhoadon",
    "views/forms/68_huyhoadon_1",
    "views/forms/68_hoadon_history",
    "views/forms/lichsuemail",
    "views/commonHD",
    "views/Util",
    "views/forms/bienbanForm",
    "views/forms/68_hoadon_history_lienquan",
    "views/DataStorage/DataHoaDon78"
], function (app, _, user, invoiceForms, huyhoadon, huyhoadon_1, hoadonHistory, his_email, commonHD, Util, bienbanForm, hoadonlq, dataFormHd78) {
    
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: 0,
        });
        return k(number);
    };
    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        on: {
            onItemClick: function (id, e, node) {
                var item = this.getItem(id);

                this.hide();

                var fn = Function("_", "user", item.on_click);
                fn(_, user);
            },
        },
    });

    var subBangKe = webix.ui({
        view: "submenu",
        width: 150,
        padding: 0,
        data: [
            {
                id: "addBangKeHoaDon",
                value: "Thêm bảng kê",
            },
            {
                id: "EditBangKeHoaDon",
                value: "Sửa bảng kê",
            },
            {
                id: "InBangKeHoaDon",
                value: "In bảng kê",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);

                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();

                if (record.id == "addBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký" && item.tthai != "Chờ duyệt" && item.tthai != "Chờ sinh số") {
                        webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                        return;
                    }

                    if (item.checksobangke != null) {
                        webix.message("Hoá đơn đã có bảng kê không thể thêm !", "error");
                        return;
                    }

                    var detailForm = table.$scope.ui(invoiceForms.$ui);
                    item.shdon = null;

                    item.nlap = new Date(item.nlap);

                    // ẩn tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = true;
                    }

                    invoiceForms.setEditMode(4); // editmode = 4(add bang ke chi tiet) // edit mode =5 (sửa bảng kê chi tiết)
                    invoiceForms.initUI(windowconfig);
                    //$$("phi_tab").hide();
                    $$("head-formInvoice").define("template", "Bảng kê chi tiết hoá đơn");
                    $$("head-formInvoice").refresh();

                    webix.$$("infohdon").disable();
                    webix.$$("infokhang").disable();

                    webix.$$("shdon").config.label = "Số bảng kê";
                    //webix.$$("infohdon").disable();
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Hóa đơn điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValuesBangKe(item, null);
                    detailForm.show();
                    webix.$$("btnBangKeSave").show();
                    webix.$$("btnHoadonSave").destructor();
                    webix.$$("btnHoadonCQT").destructor();
                }

                if (record.id == "EditBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.checksobangke == null) {
                        webix.message("Hoá đơn chưa có bảng kê!", "error");
                        return;
                    }

                    // ẩn tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = true;
                    }

                    //set số bảng kê cho form sửa bảng kê
                    item.shdon = item.checksobangke;

                    item.nlap = new Date(item.nlap);
                    var detailForm = table.$scope.ui(invoiceForms.$ui);
                    invoiceForms.setEditMode(5); // editmode = 4(add bang ke chi tiet) // edit mode =5 (sửa bảng kê chi tiết)
                    invoiceForms.initUI(windowconfig);

                    $$("head-formInvoice").define("template", "Bảng kê chi tiết hoá đơn");
                    $$("head-formInvoice").refresh();
                    //set lại title số bảng kê
                    webix.$$("shdon").config.label = "Số bảng kê";

                    webix.$$("infohdon").disable();
                    webix.$$("infokhang").disable();
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Hóa đơn điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValuesBangKe(item, null);
                    detailForm.show();
                    webix.$$("btnBangKeSave").show();
                    webix.$$("btnBangKeDelete").show();
                    webix.$$("btnHoadonSave").destructor();
                    webix.$$("btnHoadonCQT").destructor();
                }

                if (record.id == "InBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    // if (item.tthai != "Chờ ký") {
                    //     webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                    //     return;
                    // }

                    if (item.checksobangke == null) {
                        webix.message("Hoá đơn chưa có bảng kê!", "error");
                        return;
                    }

                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false&checkBangKe=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                }
            },
        },
    });
    webix.ui({
        view: "contextmenu",
        id: "cmenu78",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            "Thay thế",
            { $template: "Separator" },
            "Điều chỉnh tăng",
            { $template: "Separator" },
            "Điều chỉnh giảm",
            { $template: "Separator" },
            "Điều chỉnh thông tin",
            { $template: "Separator" },
            // "Hủy",
            // { $template: "Separator" },
            "Lịch sử gửi Email",
        ],
        on: {
            onItemClick: function (id) {
                var self = this;
                setTimeout(function () {
                    var kyHieuHoaDon = {
                        cctbao_id: $$("kyhieu_id").getValue(),
                        khieu: $$("kyhieu_id").data.text,
                    };

                    if (self.getItem(id).value == "Thay thế") {
                        commonHD.ExcuteReplaceInvoice(kyHieuHoaDon);
                    }
                    if (self.getItem(id).value == "Điều chỉnh tăng") {
                        commonHD.ExcuteIncreaseChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Điều chỉnh giảm") {
                        commonHD.ExcuteReduceChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Điều chỉnh thông tin") {
                        commonHD.ExcuteInfoChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Hủy") {
                        commonHD.ExcuteCancellingInvoice();
                    }

                    if (self.getItem(id).value == "Lịch sử gửi Email") {
                        var table = webix.$$("invoiceViews");
                        var selectedItem = table.getSelectedItem();
                        if (selectedItem == null) {
                            webix.message("Bạn chưa chọn hóa đơn", "error");
                            return;
                        }
                        var detailForm = webix.$$("invoiceViews").$scope.ui(his_email.$ui);
                        his_email.initUI(selectedItem.id);
                        detailForm.show();
                    }
                }, 100);
            },
        },
    });

    var subBienBan = webix.ui({
        view: "submenu",
        width: 150,
        padding: 0,
        data: [
            {
                id: "AddBienBan",
                value: "Thêm biên bản",
            },
            {
                id: "EditBienBan",
                value: "Sửa biên bản",
            },
            {
                id: "InBienBan",
                value: "In biên bản",
            },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();

                if (record.id == "AddBienBan") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthdon != 19 && item.tthdon != 21 && item.tthdon != 23 && item.tthdon != 5 && item.tthdon != 2 && item.tthdon != 3) {
                        webix.message("Vui lòng chọn hóa đơn ở trạng thái điều chỉnh, thay thế, hoặc hủy", "error");
                        return;
                    }

                    // if (item.tthai != "Chờ ký") {
                    //     webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                    //     return;
                    // }        

                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/CheckBienBan?id=" + item.id, {
                            error: function (text) {
                                webix.message(text, "error");
                                return;
                            },
                            success: function (text) {
                                var hasBienBan = JSON.parse(text);
                                if (hasBienBan) {
                                    webix.message("Hoá đơn đã có biên bản không thể thêm mới!", "error");
                                    return;
                                }

                                var component = table.$scope.ui(bienbanForm.$ui);
                                bienbanForm.setEditMode(1);
                                bienbanForm.setHideBtnDelete();
                                component.show();
                            },
                        });
                }

                if (record.id == "EditBienBan") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthdon != 19 && item.tthdon != 21 && item.tthdon != 23 && item.tthdon != 5 && item.tthdon != 2 && item.tthdon != 3) {
                        webix.message("Vui lòng chọn hóa đơn ở trạng thái điều chỉnh, thay thế, hoặc hủy", "error");
                        return;
                    }
                    var url = app.config.host + "/Invoice68/GetDataInvoice_BienBan?id=" + item.id;
                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .get(url, function (text) {
                            var data = (JSON.parse(text))[0];

                            if (!data) {
                                webix.message("Hoá đơn không có biên bản không thể sửa!", "error");
                                return;
                            }

                            data.nvban = removeTimeZoneT(data.nvban);

                            var component = table.$scope.ui(bienbanForm.$ui);
                            bienbanForm.setValuesBienBan(data, null);
                            bienbanForm.setEditMode(2);

                            component.show();

                        });
                }

                if (record.id == "InBienBan") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthdon != 19 && item.tthdon != 21 && item.tthdon != 23 && item.tthdon != 5 && item.tthdon != 2 && item.tthdon != 3) {
                        webix.message("Vui lòng chọn hóa đơn ở trạng thái điều chỉnh, thay thế, hoặc hủy", "error");
                        return;
                    }

                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/CheckBienBan?id=" + item.id, {
                            error: function (text) {
                                webix.message(text, "error");
                                return;
                            },
                            success: function (text) {
                                var hasBienBan = JSON.parse(text);
                                if (!hasBienBan) {
                                    webix.message("Hoá đơn chưa có biên bản không thể in!", "error");
                                    return;
                                }

                                var box = webix.modalbox({
                                    title: "Đang in biên bản ....",
                                    text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                    width: 350,
                                    height: 200,
                                });

                                var newWin = window.open();
                                var html =
                                    "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                                    '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                                    '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                                    '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                newWin.document.write(html);

                                webix
                                    .ajax()
                                    .response("arraybuffer")
                                    .headers({ "Content-type": "application/json" })
                                    .get(app.config.host + "/Invoice68/inBienBan?id=" + item.id + "&type=PDF&inchuyendoi=false&checkBienBan=true", {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.modalbox.hide(box);
                                            webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var file = new Blob([data], { type: "application/pdf" });
                                            var fileURL = URL.createObjectURL(file);
                                            //window.open(fileURL, '_blank');
                                            webix.modalbox.hide(box);
                                            newWin.location = fileURL;
                                        },
                                    });
                            },
                        });
                }
            },
        },
    });

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Thêm (F4)") + "</span>",
            id: "btnPlus",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    var cctbao_id = $$("kyhieu_id").getValue();
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.initUINew(cctbao_id);
                    invoiceForms.setEditMode(1);
                    invoiceForms.setNewInvoice();
                    detailForm.show();
                    // if (vc_window.after_new != null) {
                    //     var fn = Function("app", vc_window.after_new);
                    //     fn(app);
                    // }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    //var detailForm = this.$scope.ui(webix.$$("main"));
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }
                    if (item.mccqthue != undefined && item.mccqthue != null && item.mccqthue != '' && item.tthai != "Chờ ký") {
                        webix.message("Hóa đơn đã có mã, không thể sửa !", "error");
                        return;
                    }
                    if (item.tthai != "Chờ ký" && item.tthai != "Chờ duyệt" && item.tthai != "Chờ sinh số") {
                        webix.message("Hóa đơn đã ký hoặc đã gửi lên cơ quan thuế, không thể sửa !", "error");
                        return;
                    }
                    // main.setEditMode(0);
                    // main.initUI(windowconfig);

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    item.nlap = new Date(item.nlap);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.setEditMode(2);
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Hóa đơn điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValues(item, null);

                    detailForm.show();
                    //main.focusFirstElement();
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Xóa (F8)") + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var lstDataChoose = commonHD.GetHoaDonChon();
                    var lstDataChooseSort = lstDataChoose.sort(function (a, b) {
                        return Number(a.shdon) - Number(b.shdon);
                    });
                    if (lstDataChooseSort.length === 0) return;
                    var strHoaDonSelect = " ";
                    for (var i = 0; i < lstDataChooseSort.length; i++) {
                        if (
                            commonHD.CheckKhacNull(lstDataChooseSort[i].tthai) &&
                            lstDataChooseSort[i].tthai != "Chờ ký" &&
                            lstDataChooseSort[i].tthai != "Chờ sinh số" &&
                            lstDataChooseSort[i].tthai != "Chờ duyệt"
                        ) {
                            webix.message("Không thể xóa hóa đơn đã ký,đã gửi !", "error");
                            return;
                        }
                        if (i < lstDataChooseSort.length - 1) {
                            if (
                                commonHD.CheckKhacNull(lstDataChooseSort[i].shdon) &&
                                commonHD.CheckKhacNull(lstDataChooseSort[i + 1].shdon) &&
                                Number(lstDataChooseSort[i + 1].shdon) - Number(lstDataChooseSort[i].shdon) >= 2
                            ) {
                                webix.message("Các hóa đơn xóa phải có số hóa đơn liên tiếp nhau", "error");
                                return;
                            } else {
                                strHoaDonSelect += lstDataChooseSort[i].shdon + ",";
                            }
                        } else {
                            strHoaDonSelect += lstDataChooseSort[i].shdon;
                        }
                    }
                    var url = app.config.host + "/Invoice68/hoadonXoaNhieu";
                    var data_post = { data: lstDataChooseSort };
                    webix.confirm({
                        title: "XÓA HÓA ĐƠN",
                        text: "Bạn có muốn xóa hóa đơn số: <span style='color: red'>" + strHoaDonSelect + "</span>",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(url, data_post, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            // var json = JSON.parse(text);
                                            // webix.message(json.ExceptionMessage, "error");
                                            webix.message(text + XmlHttpRequest, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var result = JSON.parse(text);

                                            if (result.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: result.error });
                                                table.enable();
                                                table.hideProgress();
                                                return;
                                            } else {
                                                table.enable();
                                                table.clearAll();
                                                table.load(table.config.url);
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + "</span>",
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "far fa-files-o",
            // label: _("COPY"),
            // width: 85,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }
                    // var vc_window = windowconfig["data"][0];
                    // windowform.$ui.id = vc_window.code;

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    item.mccqthue = "";
                    item.shdon = null;
                    invoiceForms.setEditMode(1);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.copyValues(item);
                    detailForm.show();

                    // windowform.focusFirstElement();
                    // if (vc_window.after_new != null) {
                    //     var fn = Function(vc_window.after_new);
                    //     fn();
                    // }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Bảng kê") + "</span>",
            id: "btnBangKeOption",
            click: function () {
                subBangKe.show(webix.$$("btnBangKeOption").$view);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "Sinh MTT" + "</span>",
            id: "btnCreatMa",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần tạo mã !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();
                    webix
                        .ajax()
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/SinhMTT?hdon_id=" + item["hdon_id"], {
                            error: function (text, data, XmlHttpRequest) {

                                table.enable();
                                table.hideProgress();
                                // var json = JSON.parse(text);
                                // webix.message(json.ExceptionMessage, "error");
                                webix.message(text + XmlHttpRequest, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var json = JSON.parse(text);

                                table.enable();
                                table.hideProgress();

                                if (!json.hasOwnProperty("error")) {
                                    table.load(table.config.url);
                                } else {
                                    webix.message(json.error, "error");
                                }
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("In chuyển đổi") + "</span>",
            id: "btnPrintConvert",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {},
        {},
        {},
        {},
        {},
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                scrollX: true,
                scroll: true,
                //autowidth: true,
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                    ShowHistory2: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonlq.$ui);
                        var hdon_id = cell.row;
                        hoadonlq.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        var table = webix.$$("invoiceViews");
                        var item = table.getSelectedItem();
                        item.chon = !item.chon;
                        table.updateItem(id.row, item);
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                        this.hideOverlay();
                        $$("cmenu78").refresh();
                        $$("cmenu78").sizeToContent();
                        $$("cmenu78").attachTo($$("invoiceViews"));
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            var urlget = app.config.host + "/Invoice68/GetDecimalPlace?ma_nt=" + item["dvtte"];
                            webix
                                .ajax()
                                .sync()
                                .headers({ "Content-type": "application/json" })
                                .get(urlget, function (text) {
                                    var arr = JSON.parse(text);
                                    var arrayString_chitiet = ["sluong", "dgia", "thtien", "stckhau", "tthue", "tgtien", "tienphi"];
                                    for (var i = 0; i < arrayString_chitiet.length; i++) {
                                        var field_name = "";
                                        switch (arrayString_chitiet[i]) {
                                            case "sluong":
                                                field_name = "quantity_decimal";
                                                break;
                                            case "dgia":
                                                field_name = "price_decimal";
                                                break;
                                            case "thtien":
                                                field_name = "amount_without_vat_decimal";
                                                break;
                                            case "stckhau":
                                                field_name = "price_discount";
                                                break;
                                            case "tthue":
                                                field_name = "tax_price";
                                                break;
                                            case "tgtien":
                                                field_name = "total_amount_decimal";
                                                break;
                                            case "tienphi":
                                                field_name = "fee_price";
                                                break;
                                        }
                                        var decimal_place = Array(Number(arr[0][field_name]) + 1).join("9");
                                        var decimal_format = Number(arr[0][field_name]);
                                        var format_numeric = {
                                            maximumValue: Number("999999999999." + decimal_place),
                                            minValue: Number("-999999999999." + decimal_place),
                                            decimalPlaces: Number(decimal_format),
                                        };
                                        var formatSoDefault = {
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: decimal_format,
                                        };
                                        var formatSo = webix.Number.numToStr(formatSoDefault);

                                        var format_config = tableDetail.getColumnConfig(arrayString_chitiet[i]);

                                        format_config.format = formatSo;
                                        format_config.numericConfig = format_numeric;
                                    }
                                });

                            tableDetail.load(url);

                            var data = tableDetail.serialize();
                            console.log(data);
                        }
                    },
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    css: "subInvoice",
                    scrollX: true,
                    // tabbar: {
                    //     width: 200
                    // },
                    multiview: {
                        fitBiggest: true,
                    },
                    cells: [
                        {
                            header: "Chi tiết hóa đơn",
                            select: "cell",
                            body: {
                                view: "datatable",
                                resizeColumn: true,
                                margin: 10,
                                id: "hoadon68_chitiet_view",
                                height: 200,
                                columns: [],
                                on: {
                                    onBeforeLoad: function () {
                                        this.showOverlay(_("LOADING") + "...");
                                    },
                                    onAfterLoad: function () {
                                        this.hideOverlay();
                                    },
                                },
                            },
                        },
                    ],
                },
                columns: col,
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                webix.message("change page size to " + newv);
                                $$("pagerA").config.size = newv * 1;
                                var table = $$("invoiceViews");
                                table.define("datafetch", newv);
                                table.clearAll();
                                table.load(table.config.url);
                                table.getColumnConfig;
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var mini_dashboard = {
        type: "clean",
        borderless: true,
        cols: [
            {
                id: "choCapMa",
                name: "choCapMa",
                view: "label",
            },
            {
                id: "choCapMaError",
                name: "choCapMaError",
                view: "label",
            },
            {
                id: "duocCapMa",
                name: "duocCapMa",
                view: "label",
            },
            {
                id: "chuaGui",
                name: "chuaGui",
                view: "label",
            },
            {
                id: "doanhThu",
                name: "doanhThu",
                view: "label",
            },
        ],
    };

    var layout = {
        id: "main",
        css: "frmView",
        rows: [
            {
                rows: [mini_dashboard],
            },
            {
                id: "tlbMain",
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    var col = [];
    var sub_col = [];
    var windowconfig = null;
    var kihieuRefId = null;

    var initComponents = function (_windowconfig) {
        //console.log(_windowconfig);
        var k = Object.keys(_windowconfig["data"][0]["Tabs"]).length;
        //console.log(k);
        var vc_window = _windowconfig["data"][0];
        webix.$$("title").parse({ title: vc_window["name"], details: "Lập hóa đơn ->" + vc_window["name"], width: 500 });
        var tabs = vc_window.Tabs;
        var codewindow = app.path[1].params[0];
        var windowno = vc_window.window_id;
        kihieuRefId = "RF00054";
        col = [];
        sub_col = [];
        col.push({
            id: "chon",
            header: [{ text: "", content: "masterCheckbox" }],
            width: 30,
            checkValue: true,
            uncheckValue: false,
            template: "{common.checkbox()}",
        });
        col.push({
            id: "subRowMain",
            header: "&nbsp;",
            template: "{common.subrow()}",
            width: 40,
            // height: 25
        });
        for (var i = 0; i < tabs.length; i++) {
            var tab = tabs[i];
            if (tab.tab_type === "Master") {
                var masterTab = tabs[i];
                for (var j = 0; j < tabs[i].Fields.length; j++) {
                    var field = masterTab.Fields[j];
                    if (field.hide_in_grid == true) {
                        continue;
                    }
                    var item = {
                        id: field.column_name,
                        header: _(field.column_name),
                        columnType: field.column_type,
                        columnAlias: field.column_alias,
                        template: field.template,
                        columnFormat: field.format,
                        //adjust: true,
                    };
                    if (item.template !== undefined && item.template !== null && item.template.includes("function")) item.template = Util.StringToFunc(item.template);
                    //if(item.format!== undefined && item.format!== null && item.format.includes("function")) item.template = Util.StringToFunc(item.format);
                    if (field.caption != null) {
                        item.header = _(field.caption);
                    }

                    if (field.column_type == "numeric") {
                        item.css = { "text-align": "right" };
                        item.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: field.data_decimal,
                        });
                    }

                    if (field.type_filter != null) {
                        if (field.type_filter != "") {
                            item.header = [_(item.header), { content: field.type_filter }];
                        }
                    }

                    if (field.type_editor == "combo") {
                        item.editor = field.type_editor;
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                    }

                    if (field.type_filter == "serverMultiSelectFilter") {
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.value_filter;
                    }
                    if (field.type_filter == "serverSelectFilter") {
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.value_filter;
                    }

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr(this.columnFormat);
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.type_editor == "checkbox") {
                        if (field.column_type == "boolean") {
                            item.checkValue = true;
                            item.uncheckValue = false;
                        }

                        item.template = function (obj, common, value) {
                            if (value == true || value == 1) return "<div class='webix_icon fa-check-square-o'></div>";
                            else return "<div class='webix_icon fa-square-o'></div>";
                        };
                    }

                    if (field.column_width == null) {
                        //item.fillspace = true;
                    } else {
                        item.width = field.column_width;
                    }

                    col.push(item);
                }
            }
            if (tab.tab_type == "Detail") {
                for (var j = 0; j < tab.Fields.length; j++) {
                    var field = tab.Fields[j];

                    if (field.hide_in_grid == true) {
                        continue;
                    }

                    var subCol = {
                        id: field.column_name,
                        header: field.caption == null ? _(field.column_name) : _(field.caption),
                        hidden: field.hide_in_grid,
                    };

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        subCol.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.column_type == "numeric") {
                        subCol.css = { "text-align": "right" };
                    }

                    if (field.column_width == null) {
                        subCol.fillspace = true;
                    } else {
                        subCol.width = field.column_width;
                    }

                    sub_col.push(subCol);
                }
            }
        }
        var table = webix.$$("invoiceViews");
        table.clearAll();
        var subview = {
            borderless: true,
            view: "tabview",
            height: 255,
            css: "subInvoice",
            scrollX: true,
            // tabbar: {
            //     width: 200
            // },
            multiview: {
                fitBiggest: true,
            },
            cells: [
                {
                    header: "Chi tiết hóa đơn",
                    select: "cell",
                    body: {
                        view: "datatable",
                        resizeColumn: true,
                        margin: 10,
                        id: "hoadon68_chitiet_view",
                        height: 200,
                        columns: sub_col,
                        on: {
                            onBeforeLoad: function () {
                                this.showOverlay(_("LOADING") + "...");
                            },
                            onAfterLoad: function () {
                                this.hideOverlay();
                            },
                        },
                    },
                },
            ],
        };
        /*var subview = {
            borderless: true,
            view: "tabview",
            height: 200,
            scrollX: true,
            cells: sub_col,
            multiview: {
                fitBiggest: true,
            },
        };*/
        table.define("subview", subview);
        $$("head-title").show();
        $$("head-title").removeView("paramKH");
        $$("head-title").addView(
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [],
            },
            1
        );
        if (vc_window.WinParams != undefined && vc_window.WinParams != null) {
            for (var i = 0; i < vc_window.WinParams.length; i++) {
                var item = vc_window.WinParams[i];
                var comp = {
                    id: item.value_field,
                    view: item.type_editor,
                    width: item.width,
                    label: _(item.caption),
                    value_field: item.value_field,
                    isDefault: item.has_default,
                    on: {},
                };

                if (comp.view == "combo") {
                    comp.options = {
                        body: {
                            comboId: comp.id,
                            isDefault: item.has_default,
                            url: app.config.host + "/System/GetDataByReferencesId?id=" + item.wb_references_id,
                            ready: function () {
                                if (this.config.isDefault == "C") {
                                    var count = this.count();
                                    if (count > 0) {
                                        var combo = webix.$$(this.config.comboId);
                                        combo.setValue(this.getFirstId());
                                    }
                                }
                            },
                        },
                    };

                    comp.on.onChange = function (newv, oldv) {
                        var table = $$("invoiceViews");
                        table.clearAll();
                        table.load(table.config.url);
                    };
                }

                if (comp.view == 'search') {
                    // Tạm thời fix code cho riêng trường th số hoá đơn này, cơ chế đặt view id này cần xem lại
                    if(item.value_field == 'shdon') {
                        comp.id = 'tlbparams_shdon';
                        comp.placeholder = "VD: 1-10,21-30,41-50";
                    }
                    var validateFunc = function() {
                        var value = $$(comp.id).getValue();
                        if(item.value_field == 'shdon' && value && value != "") {
                            var regex = /^\d+(-\d+)?(,\d+(-\d+)?)*$/;
                            return regex.test(value);
                        }
                        return true;
                    }
                    comp.on.onSearchIconClick = function () {
                        if(validateFunc()) {                           
                            var table = $$("invoiceViews");
                            table.clearAll();
                            table.load(table.config.url);
                        } else {
                            webix.message("Không đúng định dạng: x,x hoặc x-x,x-x (x là số)", "error");
                        }
                    };
                    comp.on.onEnter = function (code, e) {
                        if(validateFunc()) {                           
                            var table = $$("invoiceViews");
                            table.clearAll();
                            table.load(table.config.url);
                        } else {
                            webix.message("Không đúng định dạng: x,x hoặc x-x,x-x (x là số)", "error");
                        }
                    };
                }

                $$("paramKH").removeView(item.value_field);
                $$("paramKH").addView(comp);
            }

            // parentToolBar.addView(toolBarParams);
        }

        table.config.columns = col;
        table.refreshColumns();
        table.define("url", loadUrl);
        table.getParentView().getParentView().getParentView().enable();
        table.getParentView().getParentView().getParentView().hideProgress();
        if (codewindow == "WIN00788C") {
            $$("btnBangKeOption").hide();
            $$("btnPrintConvert").hide();
            $$("btnPrint").hide();
            $$("btnPrintVe").hide();
        } else {
            $$("btnPrintVe").hide();
        }
    };

    var loadUrl = {
        $proxy: true,
        load: function (view, callback, params) {
            var tlbparam_s = [];
            //get count list combo ký hiệu
            var url = app.config.host + "/Invoice68/GetDataInvoice";
            if (params == null) {
                commonHD.clear_filter(view);
                var table = $$("invoiceViews");
                table.config.params = null;
                url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            } else {
                var table = $$("invoiceViews");
                table.define("params", params);
                webix.storage.local.put("currentFilter", params.filter);
                url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                if (params.filter != null) {
                    var array = [];

                    for (var property in params.filter) {
                        var column = view.getColumnConfig(property);
                        var item = {
                            columnName: property,
                            columnType: column.columnType,
                            value: params.filter[property],
                            filterType: column.header[1].content,
                        };

                        /*if (item.filterType == "serverDateRangeFilter") {
                            var startDate = item.value.start;
                            if (startDate !== null && startDate !== undefined) {
                                var hoursDiff = startDate.getHours() - startDate.getTimezoneOffset() / 60;
                                var minutesDiff = (startDate.getHours() - startDate.getTimezoneOffset()) % 60;
                                startDate.setHours(hoursDiff);
                                startDate.setMinutes(minutesDiff);
                                item.value.start = startDate;
                            }

                            var endDate = item.value.end;
                            if (endDate !== null && endDate !== undefined) {
                                var hoursDiff = endDate.getHours() - endDate.getTimezoneOffset() / 60;
                                var minutesDiff = (endDate.getHours() - endDate.getTimezoneOffset()) % 60;
                                endDate.setHours(hoursDiff);
                                endDate.setMinutes(minutesDiff);
                                item.value.end = endDate;
                            }
                        }*/

                        if (params.filter[property] != null && params.filter[property] != "") {
                            array.push(item);
                        }
                    }

                    //console.log(JSON.stringify(array));
                    url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                }
                url = url + "&filter=null";
            }
            var tlbParams = $$("paramKH");

            if (tlbParams !== undefined) {
                var childViews = tlbParams.getChildViews();

                var parameters = [];

                for (var i = 0; i < childViews.length; i++) {
                    // Xử lý field name 
                    var child = childViews[i];
                    var valueField = child.config.value_field;
                    if(valueField == "kyhieu_id") {
                        valueField = "cctbao_id"

                        if(!child.getValue() || child.getValue() == "") {
                            return;
                        }
                    }

                    var item = {
                        columnName: valueField,
                        value: child.getValue(),
                    };
                    if (item.value !== "") {
                        parameters.push(item);
                    }
                    //parameters.push(item);
                }
                tlbparam_s = parameters;
                url = url + "&tlbparam=" + JSON.stringify(parameters);
            } else {
                url = url + "&tlbparam=null";
            }

            // Lấy giá trị thông tin các trường đã có mã, không có mã, doanh thu
            var urlMiniDashBoard = url.replace("GetDataInvoice", "GetDataInvoiceThongTin");
            webix.ajax().get(urlMiniDashBoard, function (text) {
                var json = JSON.parse(text);
                var windowno = app.path[1].params[0];
                if (windowno != "WIN00788C") {
                    $$("choCapMa").setValue("<span style=' font-weight:bold'>Số hóa đơn chờ cấp mã: </span>" + json["chocapma"]);
                    $$("choCapMaError").setValue("<span style=' font-weight:bold'>Số hóa đơn CQT không cấp mã: </span>" + json["chocapmaerror"]);
                    $$("duocCapMa").setValue("<span style=' font-weight:bold'>Số hóa đơn được cấp mã: </span>" + json["duoccapma"]);
                    $$("chuaGui").setValue("<span style=' font-weight:bold'>Số hóa đơn chưa ký gửi CQT: </span>" + json["chuagui"]);
                    $$("doanhThu").setValue("<span style=' font-weight:bold'>Doanh thu xuất hóa đơn: </span>" + (fm(json["doanhthu"]) ? fm(json["doanhthu"]) : 0));
                }
            });

            webix.ajax(url, callback, view);
        },
    };
    var buttons = [];
    var initUI = function () {
        var windowno = app.path[1].params[0];
        var url = app.config.host + "/System/ExecuteCommand";
        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00002",
                    parameter: {
                        window_id: windowno,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);

                    if (buttons.length > 0) {
                        for (var i = 0; i < buttons.length; i++) {
                            var item = buttons[i];
                            $$("tlbMain").removeView(item.id);
                        }
                    }

                    buttons = [];
                    var menus = [];

                    var stt = controls.filter(function (x) {
                        return x.id !== undefined;
                    }).length;

                    for (var i = 0; i < json.length; i++) {
                        var item = json[i];

                        if (item.is_group_function == "C") {
                            if (item.hidden != 1) {
                                menus.push({
                                    id: item.name,
                                    value: _(item.caption),
                                    on_click: item.on_click,
                                });
                            }
                        } else {
                            if (item.hidden != 1) {
                                var fn = new Function(item.on_click);

                                var button = {
                                    view: "button",
                                    type: "htmlbutton",
                                    width: item.width,
                                    label: '<i class="fa fa-' + item.icon + ' fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _(item.caption) + "</span>",
                                    id: item.name,
                                    // label: _(item.caption),
                                    // view: "button",
                                    // type: "icon",
                                    // css: "webix_secondary",
                                    // icon: "fas fa-" + item.icon,
                                    // width: item.width,
                                    click: fn,
                                };

                                buttons.push(button);
                                $$("tlbMain").addView(button, stt);

                                stt = stt + 1;
                            }
                        }
                    }
                    $$("tlbMain").removeView("btnChucNang");
                    if (menus.length > 0) {
                        subChucNang.clearAll();
                        subChucNang.parse(menus, "json");
                        var btnChucNang = {
                            view: "button",
                            type: "htmlbutton",
                            width: 120,
                            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("CHUC_NANG") + "</span>",
                            id: "btnChucNang",
                            // label: _("CHUC_NANG"),
                            // view: "button",
                            // type: "icon",
                            // css: "webix_secondary",
                            // icon: "fas fa-tasks",
                            // width: 100,
                            click: function () {
                                subChucNang.show(webix.$$("btnChucNang").$view);
                            },
                        };
                        $$("tlbMain").addView(btnChucNang, stt);
                    }
                }
            );
        col = [];
        sub_col = [];

        var url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;
        webix.$$("invoiceViews").getParentView().getParentView().getParentView().disable();
        webix.$$("invoiceViews").getParentView().getParentView().getParentView().showProgress();

        var app_cache = webix.storage.local.get("APP_CACHE");

        if (app_cache[windowno] != null) {
            windowconfig = app_cache[windowno];
            initComponents(windowconfig);
        } //không có cache
        else {
            webix.ajax(url, function (text, xml, xhr) {
                var rp = JSON.parse(text);
                windowconfig = rp;

                var app_cache = webix.storage.local.get("APP_CACHE");
                app_cache[windowno] = windowconfig;

                webix.storage.local.put("APP_CACHE", app_cache);
                initComponents(windowconfig);
            });
        }
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if(dataFormHd78) {
                    var khID = dataFormHd78.GetData("KHID");
                    if(khID) {
                        webix.$$("kyhieu_id").setValue(khID);
                        dataFormHd78.ClearData("KHID");
                    } 
                }

                // load lai table
                table.clearAll();
                table.load(table.config.url);
                //if (editmode == 1) {
                //    table.clearAll();
                //    table.load(table.config.url);
                //}

                //if (editmode == 2) {
                //    table.clearAll();
                //    table.load(table.config.url);
                //}
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/windowhoadoncode78',[
    "app",
    "locale",
    "models/user",
    "views/forms/formhoadoncode78",
    "views/forms/68_huyhoadon",
    "views/forms/68_huyhoadon_1",
    "views/forms/68_hoadon_history",
    "views/forms/lichsuemail",
    "views/commonHD",
    "views/Util",
    "views/forms/bienbanForm",
    "views/forms/68_hoadon_history_lienquan",
    "views/DataStorage/DataHoaDon78"
], function (app, _, user, invoiceForms, huyhoadon, huyhoadon_1, hoadonHistory, his_email, commonHD, Util, bienbanForm, hoadonlq, dataFormHd78) {
    
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: 0,
        });
        return k(number);
    };
    var arrayString = [
        "tgtcthue",
        "tgtcthue10",
        "tgtcthue5",
        "tgtcthue0",
        "tgtcthuek",
        "tgtcthuekct",
        "tgtcthuekkk",
        "ttcktmai",
        "ttcktmai10",
        "ttcktmai5",
        "ttcktmai0",
        "ttcktmaik",
        "ttcktmaikct",
        "ttcktmaikkk",
        "tgtthue",
        "tgtthue10",
        "tgtthue5",
        "tgtthue0",
        "tgtthuek",
        "tgtthuekct",
        "tgtthuekkk",
        "tgtttbso",
        "tgtttbso10",
        "tgtttbso5",
        "tgtttbso0",
        "tgtttbsok",
        "tgtttbsokct",
        "tgtttbsokkk",
        "tkcktmn",
        "tgtphi",
        "tgtttbso_last",
    ];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        on: {
            onItemClick: function (id, e, node) {
                var item = this.getItem(id);

                this.hide();

                var fn = Function("_", "user", item.on_click);
                fn(_, user);
            },
        },
    });

    var subBangKe = webix.ui({
        view: "submenu",
        width: 150,
        padding: 0,
        data: [
            {
                id: "addBangKeHoaDon",
                value: "Thêm bảng kê",
            },
            {
                id: "EditBangKeHoaDon",
                value: "Sửa bảng kê",
            },
            {
                id: "InBangKeHoaDon",
                value: "In bảng kê",
            },
            {
                id: "ImportBangKeHoaDon",
                value: "Nhận Excel chi tiết",
            }
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);

                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();

                if (record.id == "addBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký" && item.tthai != "Chờ duyệt" && item.tthai != "Chờ sinh số") {
                        webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                        return;
                    }

                    if (item.checksobangke != null) {
                        webix.message("Hoá đơn đã có bảng kê không thể thêm !", "error");
                        return;
                    }

                    var detailForm = table.$scope.ui(invoiceForms.$ui);
                    item.shdon = null;

                    item.nlap = new Date(item.nlap);

                    // ẩn tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = true;
                    }

                    invoiceForms.setEditMode(4); // editmode = 4(add bang ke chi tiet) // edit mode =5 (sửa bảng kê chi tiết)
                    invoiceForms.initUI(windowconfig);
                    //$$("phi_tab").hide();
                    $$("head-formInvoice").define("template", "Bảng kê chi tiết hoá đơn");
                    $$("head-formInvoice").refresh();

                    webix.$$("infohdon").disable();
                    webix.$$("infokhang").disable();

                    webix.$$("shdon").config.label = "Số bảng kê";
                    //webix.$$("infohdon").disable();
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Hóa đơn điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValuesBangKe(item, null);
                    detailForm.show();
                    webix.$$("btnBangKeSave").show();
                    webix.$$("btnHoadonSave").destructor();
                    webix.$$("btnHoadonCQT").destructor();
                }

                if (record.id == "EditBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.checksobangke == null) {
                        webix.message("Hoá đơn chưa có bảng kê!", "error");
                        return;
                    }

                    // ẩn tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = true;
                    }

                    //set số bảng kê cho form sửa bảng kê
                    item.shdon = item.checksobangke;

                    item.nlap = new Date(item.nlap);
                    var detailForm = table.$scope.ui(invoiceForms.$ui);
                    invoiceForms.setEditMode(5); // editmode = 4(add bang ke chi tiet) // edit mode =5 (sửa bảng kê chi tiết)
                    invoiceForms.initUI(windowconfig);

                    $$("head-formInvoice").define("template", "Bảng kê chi tiết hoá đơn");
                    $$("head-formInvoice").refresh();
                    //set lại title số bảng kê
                    webix.$$("shdon").config.label = "Số bảng kê";

                    webix.$$("infohdon").disable();
                    webix.$$("infokhang").disable();
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Hóa đơn điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValuesBangKe(item, null);
                    detailForm.show();
                    webix.$$("btnBangKeSave").show();
                    webix.$$("btnBangKeDelete").show();
                    webix.$$("btnHoadonSave").destructor();
                    webix.$$("btnHoadonCQT").destructor();
                }

                if (record.id == "InBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    // if (item.tthai != "Chờ ký") {
                    //     webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                    //     return;
                    // }

                    if (item.checksobangke == null) {
                        webix.message("Hoá đơn chưa có bảng kê!", "error");
                        return;
                    }

                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false&checkBangKe=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                }

                if (record.id == "ImportBangKeHoaDon") {
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký" && item.tthai != "Chờ duyệt" && item.tthai != "Chờ sinh số") {
                        webix.message("Vui lòng chọn hoá đơn chờ ký !", "error");
                        return;
                    }

                    if (item.checksobangke == null) {
                        webix.message("Hoá đơn chưa có bảng kê!", "error");
                        return;
                    }

                    var windowno = app.path[1].params[0];
                    var excel_id_param = "";

                    if (windowno != undefined && windowno == "WIN00781C") {
                        excel_id_param = "EX00018";
                    }
                    else if (windowno != undefined && windowno == "WIN00782C") {
                        excel_id_param = "EX00019";
                    }
                    else {
                        webix.message("Chức năng nhận Excel chi tiết chưa có mẫu excel phù hợp!", "error");
                        return;
                    }

                    require(["views/forms/uploadexcel"], function (uploadForm) {
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.show();
                        webix.$$("uploader").define("formData", { excel_id: excel_id_param, filename: "MobiFone Invoice_nhan chi tiet mot bang ke.xlsx", hdon_id: item.hdon_id });
                        webix.$$("uploader").hide();
                    });
                }
            },
        },
    });

    webix.ui({
        view: "contextmenu",
        id: "cmenu78",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            "Thay thế",
            { $template: "Separator" },
            "Điều chỉnh tăng",
            { $template: "Separator" },
            "Điều chỉnh giảm",
            { $template: "Separator" },
            "Điều chỉnh thông tin",
            { $template: "Separator" },
            // "Hủy",
            // { $template: "Separator" },
            "Lịch sử gửi Email",
        ],
        on: {
            onItemClick: function (id) {
                var self = this;
                setTimeout(function () {
                    var kyHieuHoaDon = {
                        cctbao_id: $$("kyhieu_id").getValue(),
                        khieu: $$("kyhieu_id").data.text,
                    };

                    if (self.getItem(id).value == "Thay thế") {
                        commonHD.ExcuteReplaceInvoice(kyHieuHoaDon);
                    }
                    if (self.getItem(id).value == "Điều chỉnh tăng") {
                        commonHD.ExcuteIncreaseChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Điều chỉnh giảm") {
                        commonHD.ExcuteReduceChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Điều chỉnh thông tin") {
                        commonHD.ExcuteInfoChangeInvoice(kyHieuHoaDon);
                    }

                    if (self.getItem(id).value == "Hủy") {
                        commonHD.ExcuteCancellingInvoice();
                    }

                    if (self.getItem(id).value == "Lịch sử gửi Email") {
                        var table = webix.$$("invoiceViews");
                        var selectedItem = table.getSelectedItem();
                        if (selectedItem == null) {
                            webix.message("Bạn chưa chọn hóa đơn", "error");
                            return;
                        }
                        var detailForm = webix.$$("invoiceViews").$scope.ui(his_email.$ui);
                        his_email.initUI(selectedItem.id);
                        detailForm.show();
                    }
                }, 100);
            },
        },
    });
    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("REFRESH") + "</span>",
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("invoiceViews");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Thêm (F4)") + "</span>",
            id: "btnPlus",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    var cctbao_id = $$("kyhieu_id").getValue();
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.initUINew(cctbao_id);
                    invoiceForms.setEditMode(1);
                    invoiceForms.setNewInvoice();
                    detailForm.show();
                    // if (vc_window.after_new != null) {
                    //     var fn = Function("app", vc_window.after_new);
                    //     fn(app);
                    // }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    //var detailForm = this.$scope.ui(webix.$$("main"));
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }

                    if (item.tthai != "Chờ ký" && item.tthai != "Chờ duyệt" && item.tthai != "Chờ sinh số") {
                        webix.message("Hóa đơn đã ký hoặc đã gửi lên cơ quan thuế, không thể sửa !", "error");
                        return;
                    }
                    // main.setEditMode(0);
                    // main.initUI(windowconfig);

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    item.nlap = new Date(item.nlap);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.setEditMode(2);
                    if (item.tthdon === 21) {
                        var ghichu = webix.$$("textGhiChu");
                        ghichu.setValue("Lưu ý: Hóa đơn điều chỉnh giảm thì GHI DẤU ÂM (-) đối với chỉ tiêu bị điều chỉnh giảm (Ví dụ: số lượng, đơn giá..)");
                        ghichu.show();
                        item.note = "reduce_change_invoice";
                    }
                    invoiceForms.setValues(item, null);

                    detailForm.show();
                    //main.focusFirstElement();
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Xóa (F8)") + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var lstDataChoose = commonHD.GetHoaDonChon();
                    var lstDataChooseSort = lstDataChoose.sort(function (a, b) {
                        return Number(a.shdon) - Number(b.shdon);
                    });
                    if (lstDataChooseSort.length === 0) return;
                    var strHoaDonSelect = " ";
                    for (var i = 0; i < lstDataChooseSort.length; i++) {
                        if (
                            commonHD.CheckKhacNull(lstDataChooseSort[i].tthai) &&
                            lstDataChooseSort[i].tthai != "Chờ ký" &&
                            lstDataChooseSort[i].tthai != "Chờ sinh số" &&
                            lstDataChooseSort[i].tthai != "Chờ duyệt"
                        ) {
                            webix.message("Không thể xóa hóa đơn đã ký,đã gửi !", "error");
                            return;
                        }
                        if (i < lstDataChooseSort.length - 1) {
                            if (
                                commonHD.CheckKhacNull(lstDataChooseSort[i].shdon) &&
                                commonHD.CheckKhacNull(lstDataChooseSort[i + 1].shdon) &&
                                Number(lstDataChooseSort[i + 1].shdon) - Number(lstDataChooseSort[i].shdon) >= 2
                            ) {
                                webix.message("Các hóa đơn xóa phải có số hóa đơn liên tiếp nhau", "error");
                                return;
                            } else {
                                strHoaDonSelect += lstDataChooseSort[i].shdon + ",";
                            }
                        } else {
                            strHoaDonSelect += lstDataChooseSort[i].shdon;
                        }
                    }
                    var url = app.config.host + "/Invoice68/hoadonXoaNhieu";
                    var data_post = { data: lstDataChooseSort };
                    webix.confirm({
                        title: "XÓA HÓA ĐƠN",
                        text: "Bạn có muốn xóa hóa đơn số: <span style='color: red'>" + strHoaDonSelect + "</span>",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .post(url, data_post, {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            // var json = JSON.parse(text);
                                            // webix.message(json.ExceptionMessage, "error");
                                            webix.message(text + XmlHttpRequest, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var result = JSON.parse(text);

                                            if (result.hasOwnProperty("error")) {
                                                webix.message({ type: "error", text: result.error });
                                                table.enable();
                                                table.hideProgress();
                                                return;
                                            } else {
                                                table.enable();
                                                table.clearAll();
                                                table.load(table.config.url);
                                                table.hideProgress();
                                            }
                                        },
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + "</span>",
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "far fa-files-o",
            // label: _("COPY"),
            // width: 85,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "error");
                        return;
                    }
                    // var vc_window = windowconfig["data"][0];
                    // windowform.$ui.id = vc_window.code;

                    // hiện tab_phi
                    if (windowconfig["data"][0].Tabs[2] != undefined) {
                        windowconfig["data"][0].Tabs[2].hidden = false;
                    }

                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                    item.mccqthue = "";
                    item.shdon = null;
                    invoiceForms.setEditMode(1);
                    invoiceForms.initUI(windowconfig);
                    invoiceForms.copyValues(item);
                    detailForm.show();

                    // windowform.focusFirstElement();
                    // if (vc_window.after_new != null) {
                    //     var fn = Function(vc_window.after_new);
                    //     fn();
                    // }
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-tasks fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Bảng kê") + "</span>",
            id: "btnBangKeOption",
            click: function () {
                subBangKe.show(webix.$$("btnBangKeOption").$view);
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);
                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=false", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        /*
                {
                    view: "button",
                    type: "htmlbutton",
                    width: 100,
                    label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + "In vé" + "</span>",
                    id: "btnPrintVe",
                    on: {
                        onClick: function () {
                            var table = webix.$$("invoiceViews");
                            var item = table.getSelectedItem();
                            if (item == null || item == undefined) {
                                webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                                return;
                            }
                            //webix.message("Chưa có mẫu in ...", "error");
                            // var rpParameter = null;
                            var box = webix.modalbox({
                                title: "Đang in hóa đơn ....",
                                text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                width: 350,
                                height: 200,
                            });
        
                            var newWin = window.open();
                            var html =
                                "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                                '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                                '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                                '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                            newWin.document.write(html);
                            webix
                                .ajax()
                                .response("arraybuffer")
                                .headers({ "Content-type": "application/json" })
                                .post(
                                    app.config.host + "/Invoice68/inMauVe",
                                    {
                                        id: item.id,
                                        type: "0",
                                    },
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.modalbox.hide(box);
                                            webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var file = new Blob([data], { type: "image/jpeg" });
                                            var fileURL = URL.createObjectURL(file);
                                            //window.open(fileURL, '_blank');
                                            webix.modalbox.hide(box);
                                            newWin.location = fileURL;
                                        },
                                    }
                                );
                        },
                    },
                    click: function () {
                        var self = this;
                        commonHD.CommonOnclickTaskOfHD(self);
                    },
                },
        */
        {
            view: "button",
            type: "htmlbutton",
            width: 120,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("In chuyển đổi") + "</span>",
            id: "btnPrintConvert",
            on: {
                onClick: function () {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html =
                        "<html><head><title>Hóa đơn điện tử MobiFone Invoice</title>" +
                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + "/Invoice68/inHoadon?id=" + item.id + "&type=PDF&inchuyendoi=true", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                var self = this;
                commonHD.CommonOnclickTaskOfHD(self);
            },
        },
        {},
        {},
        {},
        {},
        {},
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "invoiceViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25,
                rowHeight: 25,
                tooltip: true,
                scrollX: true,
                scroll: true,
                //autowidth: true,
                onClick: {
                    ShowHistory: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonHistory.$ui);
                        var hdon_id = cell.row;
                        hoadonHistory.setEditMode(hdon_id);
                        win.show();
                    },
                    ShowHistory2: function (event, cell, target) {
                        var table = webix.$$("invoiceViews");
                        var win = table.$scope.ui(hoadonlq.$ui);
                        var hdon_id = cell.row;
                        hoadonlq.setEditMode(hdon_id);
                        win.show();
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                        var table = webix.$$("invoiceViews");
                        var item = table.getSelectedItem();
                        item.chon = !item.chon;
                        table.updateItem(id.row, item);
                    },
                    // onClick: function (e) {
                    //     // var view = $$(e);
                    //     // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                    //     //     webix.confirm("The changes was not saved");
                    // },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                        this.hideOverlay();
                        $$("cmenu78").refresh();
                        $$("cmenu78").sizeToContent();
                        $$("cmenu78").attachTo($$("invoiceViews"));
                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("hoadon68_chitiet_view");
                            var url = app.config.host + "/Invoice68/GetDataInvoiceDetail?id=" + item.id;
                            tableDetail.clearAll();
                            var urlget = app.config.host + "/Invoice68/GetDecimalPlace?ma_nt=" + item["dvtte"];
                            webix
                                .ajax()
                                .sync()
                                .headers({ "Content-type": "application/json" })
                                .get(urlget, function (text) {
                                    var arr = JSON.parse(text);
                                    var arrayString_chitiet = ["sluong", "dgia", "thtien", "stckhau", "tthue", "tgtien", "tienphi"];
                                    for (var i = 0; i < arrayString_chitiet.length; i++) {
                                        var field_name = "";
                                        switch (arrayString_chitiet[i]) {
                                            case "sluong":
                                                field_name = "quantity_decimal";
                                                break;
                                            case "dgia":
                                                field_name = "price_decimal";
                                                break;
                                            case "thtien":
                                                field_name = "amount_without_vat_decimal";
                                                break;
                                            case "stckhau":
                                                field_name = "price_discount";
                                                break;
                                            case "tthue":
                                                field_name = "tax_price";
                                                break;
                                            case "tgtien":
                                                field_name = "total_amount_decimal";
                                                break;
                                            case "tienphi":
                                                field_name = "fee_price";
                                                break;
                                        }
                                        var decimal_place = Array(Number(arr[0][field_name]) + 1).join("9");
                                        var decimal_format = Number(arr[0][field_name]);
                                        var format_numeric = {
                                            //maximumValue: Number("999999999999." + decimal_place),
                                            //minValue: Number("-999999999999." + decimal_place),
                                            decimalPlaces: Number(decimal_format),
                                        };
                                        var formatSoDefault = {
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: decimal_format,
                                        };
                                        var formatSo = webix.Number.numToStr(formatSoDefault);

                                        var format_config = tableDetail.getColumnConfig(arrayString_chitiet[i]);

                                        format_config.format = formatSo;
                                        format_config.numericConfig = format_numeric;
                                    }
                                });

                            tableDetail.load(url);

                            var data = tableDetail.serialize();
                            console.log(data);
                        }
                    },
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    css: "subInvoice",
                    scrollX: true,
                    // tabbar: {
                    //     width: 200
                    // },
                    multiview: {
                        fitBiggest: true,
                    },
                    cells: [
                        {
                            header: "Chi tiết hóa đơn",
                            select: "cell",
                            body: {
                                view: "datatable",
                                resizeColumn: true,
                                margin: 10,
                                id: "hoadon68_chitiet_view",
                                height: 200,
                                columns: [],
                                on: {
                                    onBeforeLoad: function () {
                                        this.showOverlay(_("LOADING") + "...");
                                    },
                                    onAfterLoad: function () {
                                        this.hideOverlay();
                                    },
                                },
                            },
                        },
                    ],
                },
                columns: col,
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = value == config.checkValue ? 'checked="true"' : "";
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
            },
            {
                cols: [
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        width: 400,
                        template: function (data, common) {
                            var html = " <span style='text-align:center; line-height:20px; font-size:10pt;'> Trang:" + (data.page + 1) + "/" + data.limit + " </span> ";
                            var htmlSoBanGhi = " <span style='line-height:20px; font-size:10pt;'> Tổng số bản ghi:" + data.count + " </span> ";
                            return common.first() + common.prev() + html + common.next() + common.last() + htmlSoBanGhi;
                        },
                    },
                    {
                        view: "combo",
                        label: "Số lượng item/1 page: ",
                        labelWidth: 150,
                        value: "50",
                        options: ["50", "100", "200", "300", "500", "1000"],
                        width: 400,
                        on: {
                            onChange: function (newv, oldv) {
                                webix.message("change page size to " + newv);
                                $$("pagerA").config.size = newv * 1;
                                var table = $$("invoiceViews");
                                table.define("datafetch", newv);
                                table.clearAll();
                                table.load(table.config.url);
                                table.getColumnConfig;
                            },
                        },
                    },
                    {},
                ],
            },
        ],
    };

    var mini_dashboard = {
        type: "clean",
        borderless: true,
        cols: [
            {
                id: "choCapMa",
                name: "choCapMa",
                view: "label",
            },
            {
                id: "choCapMaError",
                name: "choCapMaError",
                view: "label",
            },
            {
                id: "duocCapMa",
                name: "duocCapMa",
                view: "label",
            },
            {
                id: "chuaGui",
                name: "chuaGui",
                view: "label",
            },
            {
                id: "doanhThu",
                name: "doanhThu",
                view: "label",
            },
        ],
    };

    var layout = {
        id: "main",
        css: "frmView",
        rows: [
            {
                rows: [mini_dashboard],
            },
            {
                id: "tlbMain",
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [grid],
            },
        ],
    };

    var col = [];
    var sub_col = [];
    var windowconfig = null;
    var kihieuRefId = null;

    var initComponents = function (_windowconfig) {
        // console.log('window_config',_windowconfig);
        var k = Object.keys(_windowconfig["data"][0]["Tabs"]).length;
        //console.log(k);
        var vc_window = _windowconfig["data"][0];
        webix.$$("title").parse({ title: vc_window["name"], details: "Lập hóa đơn ->" + vc_window["name"], width: 500 });
        var tabs = vc_window.Tabs;
        var codewindow = app.path[1].params[0];
        var windowno = vc_window.window_id;
        kihieuRefId = "RF00054";
        col = [];
        sub_col = [];
        col.push({
            id: "chon",
            header: [{ text: "", content: "masterCheckbox" }],
            width: 30,
            checkValue: true,
            uncheckValue: false,
            template: "{common.checkbox()}",
        });
        col.push({
            id: "subRowMain",
            header: "&nbsp;",
            template: "{common.subrow()}",
            width: 40,
            // height: 25
        }); for (var i = 0; i < tabs.length; i++) {
            var tab = tabs[i];
            if (tab.tab_type === "Master") {
                var masterTab = tabs[i];
                for (var j = 0; j < tabs[i].Fields.length; j++) {
                    var field = masterTab.Fields[j];
                    if (field.hide_in_grid == true) {
                        continue;
                    }
                    var item = {
                        id: field.column_name,
                        header: _(field.column_name),
                        columnType: field.column_type,
                        columnAlias: field.column_alias,
                        template: field.template,
                        columnFormat: field.format,
                        //adjust: true,
                    };
                    if (item.template !== undefined && item.template !== null && item.template.includes("function")) item.template = Util.StringToFunc(item.template);
                    //if(item.format!== undefined && item.format!== null && item.format.includes("function")) item.template = Util.StringToFunc(item.format);
                    if (field.caption != null) {
                        item.header = _(field.caption);
                    }

                    if (field.column_type == "numeric") {
                        item.css = { "text-align": "right" };
                        item.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: field.data_decimal,
                        });
                    }

                    if (field.type_filter != null) {
                        if (field.type_filter != "") {
                            item.header = [_(item.header), { content: field.type_filter }];
                        }
                    }

                    if (field.type_editor == "combo") {
                        item.editor = field.type_editor;
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                    }

                    if (field.type_filter == "serverMultiSelectFilter") {
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.value_filter;
                    }
                    if (field.type_filter == "serverSelectFilter") {
                        item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.value_filter;
                    }

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr(this.columnFormat);
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.type_editor == "checkbox") {
                        if (field.column_type == "boolean") {
                            item.checkValue = true;
                            item.uncheckValue = false;
                        }

                        item.template = function (obj, common, value) {
                            if (value == true || value == 1) return "<div class='webix_icon fa-check-square-o'></div>";
                            else return "<div class='webix_icon fa-square-o'></div>";
                        };
                    }

                    if (field.column_width == null) {
                        //item.fillspace = true;
                    } else {
                        item.width = field.column_width;
                    }

                    col.push(item);
                }
            }
            if (tab.tab_type == "Detail") {
                for (var j = 0; j < tab.Fields.length; j++) {
                    var field = tab.Fields[j];

                    if (field.hide_in_grid == true) {
                        continue;
                    }

                    var subCol = {
                        id: field.column_name,
                        header: field.caption == null ? _(field.column_name) : _(field.caption),
                        hidden: field.hide_in_grid,
                    };

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        subCol.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.column_type == "numeric") {
                        subCol.css = { "text-align": "right" };
                    }

                    if (field.column_width == null) {
                        subCol.fillspace = true;
                    } else {
                        subCol.width = field.column_width;
                    }

                    sub_col.push(subCol);
                }
            }
        }
        var table = webix.$$("invoiceViews");
        table.clearAll();
        var subview = {
            borderless: true,
            view: "tabview",
            height: 255,
            css: "subInvoice",
            scrollX: true,
            // tabbar: {
            //     width: 200
            // },
            multiview: {
                fitBiggest: true,
            },
            cells: [
                {
                    header: "Chi tiết hóa đơn",
                    select: "cell",
                    body: {
                        view: "datatable",
                        resizeColumn: true,
                        margin: 10,
                        id: "hoadon68_chitiet_view",
                        height: 200,
                        columns: sub_col,
                        on: {
                            onBeforeLoad: function () {
                                this.showOverlay(_("LOADING") + "...");
                            },
                            onAfterLoad: function () {
                                this.hideOverlay();
                            },
                        },
                    },
                },
            ],
        };
        /*var subview = {
            borderless: true,
            view: "tabview",
            height: 200,
            scrollX: true,
            cells: sub_col,
            multiview: {
                fitBiggest: true,
            },
        };*/
        table.define("subview", subview);
        $$("head-title").show();
        $$("head-title").removeView("paramKH");
        $$("head-title").addView(
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [],
            },
            1
        );
        if (vc_window.WinParams != undefined && vc_window.WinParams != null) {
            for (var i = 0; i < vc_window.WinParams.length; i++) {
                var item = vc_window.WinParams[i];
                var comp = {
                    id: item.value_field,
                    view: item.type_editor,
                    width: item.width,
                    label: _(item.caption),
                    value_field: item.value_field,
                    isDefault: item.has_default,
                    on: {
                    },
                };

                if (comp.view == "combo") {
                    comp.options = {
                        body: {
                            comboId: comp.id,
                            isDefault: item.has_default,
                            url: app.config.host + "/System/GetDataByReferencesId?id=" + item.wb_references_id,
                            ready: function () {
                                if (this.config.isDefault == "C") {
                                    var count = this.count();
                                    if (count > 0) {
                                        var combo = webix.$$(this.config.comboId);
                                        combo.setValue(this.getFirstId());
                                    }
                                }
                            },
                        },
                    };

                    comp.on.onChange = function (newv, oldv) {
                        var table = $$("invoiceViews");
                        table.clearAll();
                        table.load(table.config.url);
                    };
                }

                if (comp.view == 'search') {
                    // Tạm thời fix code cho riêng trường th số hoá đơn này, cơ chế đặt view id này cần xem lại
                    if(item.value_field == 'shdon') {
                        comp.id = 'tlbparams_shdon';
                        comp.placeholder = "VD: 1-10,21-30,41-50";
                    }
                    var validateFunc = function() {
                        var value = $$(comp.id).getValue();
                        if(item.value_field == 'shdon' && value && value != "") {
                            var regex = /^\d+(-\d+)?(,\d+(-\d+)?)*$/;
                            return regex.test(value);
                        }
                        return true;
                    }
                    comp.on.onSearchIconClick = function () {
                        if(validateFunc()) {                           
                            var table = $$("invoiceViews");
                            table.clearAll();
                            table.load(table.config.url);
                        } else {
                            webix.message("Không đúng định dạng: x,x hoặc x-x,x-x (x là số)", "error");
                        }
                    };
                    comp.on.onEnter = function (code, e) {
                        if(validateFunc()) {                           
                            var table = $$("invoiceViews");
                            table.clearAll();
                            table.load(table.config.url);
                        } else {
                            webix.message("Không đúng định dạng: x,x hoặc x-x,x-x (x là số)", "error");
                        }
                    };
                }

                $$("paramKH").removeView(comp.id);
                $$("paramKH").addView(comp);
            }


            // parentToolBar.addView(toolBarParams);
        }

        table.config.columns = col;
        table.refreshColumns();
        table.define("url", loadUrl);
        table.getParentView().getParentView().getParentView().enable();
        table.getParentView().getParentView().getParentView().hideProgress();
    };

    var loadUrl = {
        $proxy: true,
        load: function (view, callback, params) {
            var tlbparam_s = [];
            //get count list combo ký hiệu
            var url = app.config.host + "/Invoice68/GetDataInvoice";
            if (params == null) {
                commonHD.clear_filter(view);
                var table = $$("invoiceViews");
                table.config.params = null;
                url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            } else {
                var table = $$("invoiceViews");
                table.define("params", params);
                webix.storage.local.put("currentFilter", params.filter);
                url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                if (params.filter != null) {
                    var array = [];
                    for (var property in params.filter) {
                        var column = view.getColumnConfig(property);
                        var item = {
                            columnName: property,
                            columnType: column.columnType,
                            value: params.filter[property],
                            filterType: column.header[1].content,
                        };

                        /*if (item.filterType == "serverDateRangeFilter") {
                            var startDate = item.value.start;
                            if (startDate !== null && startDate !== undefined) {
                                var hoursDiff = startDate.getHours() - startDate.getTimezoneOffset() / 60;
                                var minutesDiff = (startDate.getHours() - startDate.getTimezoneOffset()) % 60;
                                startDate.setHours(hoursDiff);
                                startDate.setMinutes(minutesDiff);
                                item.value.start = startDate;
                            }

                            var endDate = item.value.end;
                            if (endDate !== null && endDate !== undefined) {
                                var hoursDiff = endDate.getHours() - endDate.getTimezoneOffset() / 60;
                                var minutesDiff = (endDate.getHours() - endDate.getTimezoneOffset()) % 60;
                                endDate.setHours(hoursDiff);
                                endDate.setMinutes(minutesDiff);
                                item.value.end = endDate;
                            }
                        }*/

                        if (params.filter[property] != null && params.filter[property] != "") {
                            array.push(item);
                        }
                    }

                    //console.log(JSON.stringify(array));
                    url = url + "&filter=" + encodeURIComponent(JSON.stringify(array));
                }
                url = url + "&filter=null";
            }
            var tlbParams = $$("paramKH");

            if (tlbParams !== undefined) {
                var childViews = tlbParams.getChildViews();

                var parameters = [];

                for (var i = 0; i < childViews.length; i++) {
                    // Xử lý field name 
                    var child = childViews[i];
                    var valueField = child.config.value_field;
                    if(valueField == "kyhieu_id") {
                        valueField = "cctbao_id"

                        if(!child.getValue() || child.getValue() == "") {
                            return;
                        }
                    }

                    var item = {
                        columnName: valueField,
                        value: child.getValue(),
                    };
                    if (item.value !== "") {
                        parameters.push(item);
                    }
                    //parameters.push(item);
                }
                tlbparam_s = parameters;
                url = url + "&tlbparam=" + JSON.stringify(parameters);
            } else {
                url = url + "&tlbparam=null";
            }

            // Lấy giá trị thông tin các trường đã có mã, không có mã, doanh thu
            var urlMiniDashBoard = url.replace("GetDataInvoice", "GetDataInvoiceThongTin");
            webix.ajax().get(urlMiniDashBoard, function (text) {
                var json = JSON.parse(text);
                var windowno = app.path[1].params[0];
                if (windowno != "WIN00788C") {
                    $$("choCapMa").setValue("<span style=' font-weight:bold'>Số hóa đơn chờ cấp mã: </span>" + json["chocapma"]);
                    $$("choCapMaError").setValue("<span style=' font-weight:bold'>Số hóa đơn CQT không cấp mã: </span>" + json["chocapmaerror"]);
                    $$("duocCapMa").setValue("<span style=' font-weight:bold'>Số hóa đơn được cấp mã: </span>" + json["duoccapma"]);
                    $$("chuaGui").setValue("<span style=' font-weight:bold'>Số hóa đơn chưa ký gửi CQT: </span>" + json["chuagui"]);
                    $$("doanhThu").setValue("<span style=' font-weight:bold'>Doanh thu xuất hóa đơn: </span>" + (fm(json["doanhthu"]) ? fm(json["doanhthu"]) : 0));
                }
            });

            webix.ajax(url, callback, view);
        },
    };
    var buttons = [];
    var initUI = function () {
        var windowno = app.path[1].params[0];
        var url = app.config.host + "/System/ExecuteCommand";
        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(
                url,
                {
                    command: "CM00002",
                    parameter: {
                        window_id: windowno,
                    },
                },
                function (text) {
                    var json = JSON.parse(text);

                    if (buttons.length > 0) {
                        for (var i = 0; i < buttons.length; i++) {
                            var item = buttons[i];
                            $$("tlbMain").removeView(item.id);
                        }
                    }

                    buttons = [];
                    var menus = [];

                    var stt = controls.filter(function (x) {
                        return x.id !== undefined;
                    }).length;

                    for (var i = 0; i < json.length; i++) {
                        var item = json[i];

                        if (item.is_group_function == "C") {
                            if (item.hidden != 1) {
                                menus.push({
                                    id: item.name,
                                    value: _(item.caption),
                                    on_click: item.on_click,
                                });
                            }
                        } else {
                            if (item.hidden != 1) {
                                var fn = new Function(item.on_click);

                                var button = {
                                    view: "button",
                                    type: "htmlbutton",
                                    width: item.width,
                                    label: '<i class="fa fa-' + item.icon + ' fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _(item.caption) + "</span>",
                                    id: item.name,
                                    // label: _(item.caption),
                                    // view: "button",
                                    // type: "icon",
                                    // css: "webix_secondary",
                                    // icon: "fas fa-" + item.icon,
                                    // width: item.width,
                                    click: fn,
                                };

                                buttons.push(button);
                                $$("tlbMain").addView(button, stt);

                                stt = stt + 1;
                            }
                        }
                    }
                    $$("tlbMain").removeView("btnChucNang");
                    if (menus.length > 0) {
                        subChucNang.clearAll();
                        subChucNang.parse(menus, "json");
                        var btnChucNang = {
                            view: "button",
                            type: "htmlbutton",
                            width: 120,
                            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("CHUC_NANG") + "</span>",
                            id: "btnChucNang",
                            // label: _("CHUC_NANG"),
                            // view: "button",
                            // type: "icon",
                            // css: "webix_secondary",
                            // icon: "fas fa-tasks",
                            // width: 100,
                            click: function () {
                                subChucNang.show(webix.$$("btnChucNang").$view);
                            },
                        };
                        $$("tlbMain").addView(btnChucNang, stt);
                    }
                }
            );
        col = [];
        sub_col = [];

        var url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;
        webix.$$("invoiceViews").getParentView().getParentView().getParentView().disable();
        webix.$$("invoiceViews").getParentView().getParentView().getParentView().showProgress();

        var app_cache = webix.storage.local.get("APP_CACHE");

        if (app_cache[windowno] != null) {
            windowconfig = app_cache[windowno];
            initComponents(windowconfig);
        } //không có cache
        else {
            webix.ajax(url, function (text, xml, xhr) {
                var rp = JSON.parse(text);
                windowconfig = rp;

                var app_cache = webix.storage.local.get("APP_CACHE");
                app_cache[windowno] = windowconfig;

                webix.storage.local.put("APP_CACHE", app_cache);
                initComponents(windowconfig);
            });
        }
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if(dataFormHd78) {
                    var khID = dataFormHd78.GetData("KHID");
                    if(khID) {
                        webix.$$("kyhieu_id").setValue(khID);
                        dataFormHd78.ClearData("KHID");
                    } 
                }       

                table.clearAll();
                table.load(table.config.url);
                //if (editmode == 1) {
                //    table.clearAll();
                //    table.load(table.config.url);
                //}

                //if (editmode == 2) {
                //    table.clearAll();
                //    table.load(table.config.url);
                //}
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('locales/en',[], function () {
    return {
        "TUCHOI":"Reject",
        "them": "Add",
        "sua": "Edit",
        "dangnhap": "Login",
        "DONVI": "Company",
        "DANGKY": "Register",
        "QUENMK": "Forgot password",
        "USERNAME": "User name",
        "PASSWORD": "Pass word",
        "REMEMBERME": "Rememberme",
        "DANGNHAP": "Login",
        "DANGNHAPSSO": "SSO"
    };
});
define('locales/ko',[], function () {
    return {
        "DONVI": "회사",
        "DANGKY": "등록",
        "QUENMK": "비밀 번호 잊어 버려",
        "THEM": "더하다",
        "SUA": "편집하다",
        "XOA": "지우다",
        "COPY": "부",
        "USERNAME": "사용자 이름",
        "PASSWORD": "암호",
        "REMEMBERME": "생각해 내다",
        "DANGNHAP": "로그인",
        "DANGNHAPSSO": "SSO",
        "MAU_HD": "Mẫu hóa đơn",
        "KY_HIEU": "Ký hiệu",
        "MAUIN": "Mẫu in",
        "SO_HDON": "Số hóa đơn",
        "NGAY_HDON": "Ngày hóa đơn",
        "TEN_DON_VI": "Tên đơn vị",
        "TEN_NGUOI_MUA": "Tên người mua",
        "SO_DH": "Số đơn hàng",
        "MA_DT": "Mã đối tượng",
        "MS_THUE": "Mã số thuế",
        "DIA_CHI": "Địa chỉ",
        "TK_BEN_MUA": "TK Bên Mua",
        "NGAN_HANG_BEN_MUA": "NH Bên Mua",
        "TK_BEN_BAN": "TK Bên Bán",
        "NGAN_HANG_BEN_BAN": "NH Bên Bán",
        "HT_TT": "HT thanh toán",
        "PRINT": "Xem/In",
        "MA_HV": "Mã hàng",
        "TEN_HV": "Tên hàng",
        "DVT": "ĐVT",
        "SO_LUONG": "Số lượng",
        "GIA": "Giá",
        "TIEN": "Tiền",
        "PT_CK": "% CK",
        "TIEN_CK": "Tiền CK",
        "MA_THUE": "Mã thuế",
        "TIEN_THUE": "Tiền thuế",
        "THANH_TIEN": "Thành tiền",
        "MA": "Mã",
        "TEN": "Tên",
        "DUYET": "Duyệt",
        "PHAN_QUYEN": "Phân quyền",
        "CHUC_NANG": "Chức năng",
        "BAO_CAO": "Báo cáo",
        "TEN_CHUC_NANG": "Tên chức năng",
        "TEN_MAU": "Tên mẫu",
        "LOAI_HOA_DON": "Loại hóa đơn",
        "HINH_THUC": "Hình thức",
        "MAU_SO": "Mẫu số",
        "SO_LIEN": "Số liên",
        "DA_KY": "Đã ký",
        "TRANG_THAI_MAU": "Trạng thái mẫu",
        "NGAY_TB": "Ngày thông báo",
        "NGUOI_DAI_DIEN_PL": "Người đại diện pháp luật",
        "DON_VI_CHU_QUAN": "Đơn vị chủ quản",
        "CO_QUAN_THUE_NHAN_TB": "Cơ quan thuế nhận thông báo",
        "TRANG_THAI": "Trạng thái",
        "MA_LOAI": "Mã loại",
        "TEN_LOAI": "Tên loại",
        "TU_SO": "Từ số",
        "DEN_SO": "Đến số",
        "NGAY_BD_SD": "Ngày bắt đầu sử dụng",
        "DN_IN": "Doanh nghiệp In/Cung cấp phần mềm",
        "MAU_HDON": "Mẫu hóa đơn",
        "TEN_DT": "Tên đối tượng",
        "CHUC_VU": "Chức vụ",
        "DIEN_THOAI": "Điện thoại",
        "DAI_DIEN": "Đại diện",
        "SU_DUNG": "Sử dụng",
        "EXPORT_XML": "Kết xuất XML",
        "NGUOI_KY": "Người ký",
        "SO_SERIAL": "Số serial",
        "MA_DVT": "Mã ĐVT",
        "TEN_DVT": "Tên ĐVT",
        "CHU_KY_SO": "Chữ ký số",
        "CHON": "Chọn",
        "TINH_THANH": "Tỉnh thành",
        "NGAY_BD_NAM_TC": "Ngày bắt đầu năm tài chính",
        "TAI_KHOAN": "Tài khoản",
        "TAI_NH": "Tại ngân hàng",
        "EMAIL": "Email",
        "SUBJECTNAME": "Chủ thể",
        "SIGN": "Ký",
        "KY_HOA_DON": "Ký hóa đơn",
        "DC_DINH_DANH": "Điều chỉnh định danh",
        "SOVB": "Số văn bản",
        "NGAYVB": "Ngày văn bản",
        "DIEN_GIAI": "Diễn giải",
        "SEARCH": "Tìm kiếm",
        "TIM_CHI_TIET": "Tìm chi tiết",
        "NGUOI_LAP": "Người lập",
        "TRANG_THAI_HDON": "Trạng thái hóa đơn",
        "TU_NGAY": "Từ ngày",
        "DEN_NGAY": "Đến ngày",
        "NGUOI_NHAN": "Người nhận",
        "TIEU_DE": "Tiêu đề",
        "NOI_DUNG": "Nội dung",
        "SEND_EMAIL_INVOICE": "Gửi hóa đơn qua email",
        "KHUYEN_MAI": "Khuyến mãi",
        "TIEU_THUC": "Tiêu thức",
        "DC_TANG": "Điều chỉnh tăng",
        "DC_GIAM": "Điều chỉnh giảm",
        "HDON_THAY_THE": "Hóa đơn thay thế",
        "REFRESH": "Tải dữ liệu",
        "EXPORT": "Kết xuất",
        "EXPORT_EXCEL": "Kết xuất Excel",
        "XOA_BO": "Xóa bỏ",
        "MST_BEN_BAN": "MST Bên bán",
        "MST_BEN_MUA": "MST Bên mua",
        "HDON_CT_BRA": "Hóa đơn chứng từ bán ra",
        "TIEN_TRUOC_THUE": "Tiền trước thuế",
        "TIEN_THUE_10": "10%",
        "TIEN_THUE_05": "5%",
        "TIEN_THUE_00": "0%",
        "KHONG_CHIU_THUE": "Không chịu thuế",
        "KHONG_KK": "Không kê khai",
        "GHI_CHU": "Ghi chú",
        "IMPORT_EXCEL": "Nhận Excel",
        "NGUOI_GUI": "Người gửi",
        "KY_HOA_DON_CHO_KY": "Ký hóa đơn chờ ký",
        "SMTP_SERVER": "SMTP Server",
        "SMTP_PORT": "SMTP Port",
        "enableSSL": "Enable SSL",
        "LOAI": "Loại",
        "SEND_EMAIL_CONFIRM": "Email yêu cầu ký xác nhận",
        "NHOM": "Nhóm",
        "GIA_BAN": "Giá bán",
        "DANG_KY": "Đăng ký",
        "SL_HD_DK": "Số lượng hóa đơn đã đăng ký",
        "KEY_LICENSE": "Key bản quyền",
        "SL_HD_THEM": "Số lượng hóa đơn đăng ký thêm",
        "GIA_TRI": "Giá trị",
        "NGAY_BAT_DAU": "Ngày bắt đầu",
        "NGAY_KET_THUC": "Ngày kết thúc",
        "TOKEN_SERIAL": "TOKEN SERIAL",
        "CHUYEN_DOI": "Chuyển đổi",
        "SO_TK": "Số tài khoản",
        "TRANSFER_SYMBOL": "Chuyển dải",
    };
});
define('locales/vi',[], function () {
    return {
        "from_number": "Từ số",
        "to_number": "Đến số",
        "TUCHOI": "Từ chối",
        "amount_to_word": "Thành tiền bằng chữ",
        "INVOICE_STATUS": "Trạng thái hóa đơn",
        "status": "Trạng thái",
        "invoice_issued_date": "Ngày hóa đơn",
        "invoice_number": "Số hóa đơn",
        "buyer_taxcode": "Mã số thuế",
        "buyer_legal_name": "Tên đơn vị",
        "total_amount_without_vat": "Tiền trước thuế",
        "discount_amount": "Tiền chiết khấu",
        "vat_amount": "Tiền thuế",
        "total_amount": "Tổng tiền",
        "template_code": "Mẫu số",
        "invoice_series": "Ký hiệu",
        "buyer_bank_account": "TK Bên mua",
        "buyer_bank_name": "NH Bên mua ",
        "buyer_address_line": "Địa chỉ",
        "customer_code": "Mã khách hàng",
        "item_name": "Tên hàng",
        "item_code": "Mã hàng",
        "unit_code": "ĐVT",
        "quantity": "Số lượng",
        "unit_price": "Đơn giá",
        "discount_percentage": "% Chiết khấu",
        "tax_type": "Mã thuế",
        "promotion": "Khuyến mại",
        "buyer_display_name": "Tên người mua",
        "buyer_email": "Email",
        "payment_method_name": "Hình thức thanh toán",
        "CODE": "Mã",
        "NAME": "Tên",
        "PL_CUSTOMER_GROUP_ID": "Nhóm khách hàng",
        "TAX_CODE": "Mã số thuế",
        "BUYER_NAME": "Tên người mua",
        "TEL": "Số điện thoại",
        "MOBILE": "Di động",
        "ADDRESS": "Địa chỉ",
        "PL_GOODS_GROUP_ID": "Nhóm hàng hóa",
        "UNIT_CODE": "Đơn vị tính",
        "VAT_TYPE": "% Thuế",
        "UNIT_PRICE": "Đơn giá",
        "VAT_PERCENTAGE": "% Thuế",
        "BANK_ACCOUNT": "Tài khoản ngân hàng",
        "BANK_NAME": "Tên ngân hàng",
        "VAT_PERCENTAGE": "% Thuế",
        "COMPANY_NAME": "Tên công ty",
        "NOTIFICATION_DATE": "Ngày thông báo",
        "TAXCODE": "Mã số thuế",
        "INVOICE_TYPE": "Hình thức",
        "QUANTITY": "Số lượng",
        "INVOICE_SERIES": "Ký hiệu",
        "FROM_NUMBER": "Từ số",
        "TO_NUMBER": "Đến số",
        "TEMPLATE_CODE": "Mẫu số",
        "QUANTITY_DECIMAL": "Số chữ số thập phân số lượng",
        "PRICE_DECIMAL": "Số chữ số thập phân đơn giá",

        "BEGIN_DATE": "Ngày bắt đầu",
        "MST": "Mã số thuế",
        "TEN_NCC": "Tên nhà cung cấp",
        "THUONG_HIEU": "Thương hiệu",
        "LINK_TRACUU": "Link Tra cứu",
        "Bạn chưa chọn hóa đơn": "Not select Invoie",
        "IMPORT_EXCEL_CT": "Nhận Excel chi tiết",
        "ma_dt": "Mã đối tượng",
        "ten_dt": "Tên đối tượng",
        "THEM": "Thêm",
        "SUA": "Sửa",
        "XOA": "Xóa",
        "COPY": "Sao chép",
        "USERNAME": "Tên truy cập",
        "PASSWORD": "Mật khẩu",
        "REMEMBERME": "Ghi nhớ tài khoản",
        "DANGNHAP": "Đăng nhập",
        "DANGNHAPSSO": "SSO",
        "DANGKY": "Đăng ký",
        "QUENMK": "Quên mật khẩu",
        "MAU_HD": "Mẫu hóa đơn",
        "KY_HIEU": "Ký hiệu",
        "BRANCH_CODE": "Đơn vị",
        "MAUIN": "Mẫu in",
        "SO_HDON": "Số hóa đơn",
        "NGAY_HDON": "Ngày hóa đơn",
        "TEN_DON_VI": "Tên đơn vị",
        "TEN_NGUOI_MUA": "Tên người mua",
        "SO_DH": "Số đơn hàng",
        "MA_DT": "Mã đối tượng",
        "MS_THUE": "Mã số thuế",
        "DIA_CHI": "Địa chỉ",
        "TK_BEN_MUA": "TK Bên Mua",
        "NGAN_HANG_BEN_MUA": "NH Bên Mua",
        "TK_BEN_BAN": "TK Bên Bán",
        "NGAN_HANG_BEN_BAN": "NH Bên Bán",
        "HT_TT": "HT thanh toán",
        "PRINT": "Xem/In",
        "MA_HV": "Mã hàng",
        "TEN_HV": "Tên hàng",
        "DVT": "ĐVT",
        "SO_LUONG": "Số lượng",
        "GIA": "Giá",
        "TIEN": "Tiền",
        "PT_CK": "% CK",
        "TIEN_CK": "Tiền CK",
        "MA_THUE": "Mã thuế",
        "TIEN_THUE": "Tiền thuế",
        "THANH_TIEN": "Thành tiền",
        "MA": "Mã",
        "TEN": "Tên",
        "DUYET": "Duyệt",
        "PHAN_QUYEN": "Phân quyền",
        "CHUC_NANG": "Chức năng",
        "BAO_CAO": "Báo cáo",
        "TEN_CHUC_NANG": "Tên chức năng",
        "TEN_MAU": "Tên mẫu",
        "LOAI_HOA_DON": "Loại hóa đơn",
        "HINH_THUC": "Hình thức",
        "MAU_SO": "Mẫu số",
        "SO_LIEN": "Số liên",
        "DA_KY": "Đã ký",
        "TRANG_THAI_MAU": "Trạng thái mẫu",
        "NGAY_TB": "Ngày thông báo",
        "NGUOI_DAI_DIEN_PL": "Người đại diện pháp luật",
        "DON_VI_CHU_QUAN": "Đơn vị chủ quản",
        "CO_QUAN_THUE_NHAN_TB": "Cơ quan thuế nhận thông báo",
        "TRANG_THAI": "Trạng thái",
        "MA_LOAI": "Mã loại",
        "TEN_LOAI": "Tên loại",
        "TU_SO": "Từ số",
        "DEN_SO": "Đến số",
        "NGAY_BD_SD": "Ngày bắt đầu sử dụng",
        "DN_IN": "Doanh nghiệp In/Cung cấp phần mềm",
        "MAU_HDON": "Mẫu hóa đơn",
        "TEN_DT": "Tên đối tượng",
        "CHUC_VU": "Chức vụ",
        "DIEN_THOAI": "Điện thoại",
        "DAI_DIEN": "Đại diện",
        "SU_DUNG": "Sử dụng",
        "EXPORT_XML": "Kết xuất XML",
        "NGUOI_KY": "Người ký",
        "SO_SERIAL": "Ký hiệu",
        "MA_DVT": "Mã ĐVT",
        "TEN_DVT": "Tên ĐVT",
        "CHU_KY_SO": "Chữ ký số",
        "CHON": "Chọn",
        "DONVI": "Đơn vị",
        "TINH_THANH": "Tỉnh thành",
        "NGAY_BD_NAM_TC": "Ngày bắt đầu năm tài chính",
        "TAI_KHOAN": "Tài khoản",
        "TAI_NH": "Tại ngân hàng",
        "EMAIL": "Email",
        "SUBJECTNAME": "Chủ thể",
        "SIGN": "Ký hóa đơn",
        "KY_HOA_DON": "Ký hóa đơn",
        "DC_DINH_DANH": "Điều chỉnh định danh",
        "SOVB": "Số văn bản",
        "NGAYVB": "Ngày văn bản",
        "DIEN_GIAI": "Diễn giải",
        "SEARCH": "Tìm kiếm",
        "TIM_CHI_TIET": "Tìm chi tiết",
        "NGUOI_LAP": "Người lập",
        "TRANG_THAI_HDON": "Trạng thái hóa đơn",
        "TU_NGAY": "Từ ngày",
        "DEN_NGAY": "Đến ngày",
        "NGUOI_NHAN": "Người nhận",
        "TIEU_DE": "Tiêu đề",
        "NOI_DUNG": "Nội dung",
        "SEND_EMAIL_INVOICE": "Gửi hóa đơn qua email",
        "KHUYEN_MAI": "Khuyến mãi",
        "TIEU_THUC": "Tiêu thức",
        "DC_TANG": "Điều chỉnh tăng",
        "DC_GIAM": "Điều chỉnh giảm",
        "HDON_THAY_THE": "Hóa đơn thay thế",
        "REFRESH": "Tải dữ liệu",
        "EXPORT": "Kết xuất",
        "EXPORT_EXCEL": "Kết xuất Excel",
        "XOA_BO": "Xóa bỏ",
        "MST_BEN_BAN": "MST Bên bán",
        "MST_BEN_MUA": "MST Bên mua",
        "HDON_CT_BRA": "Hóa đơn chứng từ bán ra",
        "TIEN_TRUOC_THUE": "Tiền trước thuế",
        "TIEN_THUE_10": "10%",
        "TIEN_THUE_05": "5%",
        "TIEN_THUE_00": "0%",
        "KHONG_CHIU_THUE": "Không chịu thuế",
        "KHONG_KK": "Không kê khai",
        "GHI_CHU": "Ghi chú",
        "IMPORT_EXCEL": "Nhận Excel",
        "REGISTER_LICENCE" : "Đăng ký Licence",
        "NGUOI_GUI": "Người gửi",
        "KY_HOA_DON_CHO_KY": "Ký nhiều hóa đơn",
        "SMTP_SERVER": "SMTP Server",
        "SMTP_PORT": "SMTP Port",
        "enableSSL": "Enable SSL",
        "LOAI": "Loại",
        "SEND_EMAIL_CONFIRM": "Email yêu cầu ký xác nhận",
        "NHOM": "Nhóm",
        "GIA_BAN": "Giá bán",
        "DANG_KY": "Đăng ký",
        "SL_HD_DK": "Số lượng hóa đơn đã đăng ký",
        "KEY_LICENSE": "Key bản quyền",
        "SL_HD_THEM": "Số lượng hóa đơn đăng ký thêm",
        "GIA_TRI": "Giá trị",
        "NGAY_BAT_DAU": "Ngày bắt đầu",
        "NGAY_KET_THUC": "Ngày kết thúc",
        "TOKEN_SERIAL": "Token serial",
        "CHUYEN_DOI": "Chuyển đổi",
        "SO_TK": "Số tài khoản",
        "NGAY_HET_HAN": "Ngày hết hạn",
        "CHON_BOCHON": "Chọn/Bỏ chọn",
        "QUYEN_TRUY_CAP_HD": "Quyền truy cập hóa đơn",
        "IS_VIEW_USER": "Xem chứng từ của NSD khác",
        "IS_EDIT_USER": "Sửa chứng từ của NSD khác",
        "IS_DEL_USER": "Xóa chứng từ của NSD khác",
        "IS_NEW_USER": "Thêm chứng từ",
        "KY_HOA_DON": "Ký hóa đơn",
        "KY_HOA_DON_HSM": "Ký hóa đơn HSM",
        "DANG_KY_LAN_DAU": "Đăng ký lần đầu",
        "DANG_KY_THEM": "Đăng ký thêm",
        "THONG_BAO": "Thông báo",
        "TAI_FILE_MAU": "Tải file mẫu",
        "MA_NT": "Mã ngoại tệ",
        "TEN_NT": "Tên ngoại tệ",
        "TY_GIA": "Tỷ giá",
        "TEN_NH": "Tên ngân hàng",
        "IN_CHUYEN_DOI": "In chuyển đổi",
        "NGUOI_IN_CDOI": "Người in chuyển đổi",
        "NGAY_IN_CDOI": "Ngày in chuyển đổi",
        "PHAN_CACH_HANG_NGHIN": "Phân cách hàng nghìn",
        "PHAN_CACH_THAP_PHAN": "Phân cách thập phân",
        "PRINT_INVOICE_HTML": "Xem hóa đơn (Html)",
        "DEL_CACHE": "Xóa cache",
        "LOGOUT": "Đăng xuất",
        "CHANGE_PASS": "Đổi mật khẩu",
        "CHANGE_PASS_SSO": "Đổi mật khẩu SSO",
        "SO_BANG_KE": "Số bảng kê",
        "TAO_HD": "Tạo hóa đơn từ bảng kê",
        "LIST_DATE": "Ngày bảng kê",
        "LIST_NUMBER": "Số bảng kê",
        "MA_CHUNGTU": "Mã chứng từ",
        "NGAY_CHUNGTU": "Ngày chứng từ",
        "SO_CHUNGTU": "Số chứng từ",
        "PT_THUE": "% thuế",
        "TEN_DV": "Tên đơn vị",
        "TONG_TIEN": "Tổng tiền",
        "MA_DVCS": "Mã đơn vị",
        "TEN_NHV": "Tên nhóm",
        "USER_TRACUU": "Tạo user tra cứu",
        "MA_HANG": "Mã hàng hóa",
        "TEN_HANG": "Tên hàng",
        "DON_GIA": "Đơn giá",
        "DOANH_THU": "Doanh thu",
        "THUE_SUAT": "Thuế suất",
        "GIO_TB": "Ngày, giờ thông báo hủy hóa đơn như sau:",
        "NGAY_TB": "Ngày",
        "PHUONG_PHAP_HUY": "Phương pháp hủy hóa đơn:",
        "NGAY_LAP_TB": "Ngày lập thông báo:",
        "NGUOI_LAP_BIEU": "Người lập",
        "PATH": "Đường dẫn file ký",
        "KET_XUAT_EXCEL": "Kết xuất Excel",
        "HIDDEN": "Ẩn/hiện",
        "PARENT_ID": "Nhóm mẹ",
        "name": "Tên",
        "code": "Mã",
        "id": "Mã",
        "CURRENT_NUMBER": "Số hiện tại",
        "is_main": "Chính",
        "LINK_SSO":"Liên kết tài khoản SSO",
        "TRANSFER_SYMBOL": "Chuyển dải",
    };
});
require(["app"]);
